var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { defineComponent, computed, openBlock, createElementBlock, mergeProps, Fragment as Fragment$1, renderList, normalizeProps, guardReactiveProps, resolveComponent, normalizeClass, createBlock, createCommentVNode, renderSlot, createElementVNode, ref, watch, nextTick, createVNode, withCtx, toDisplayString, resolveDirective, withDirectives, onMounted, withKeys, vModelText, createTextVNode, reactive, onBeforeUnmount, Suspense, Transition, resolveDynamicComponent, TransitionGroup, normalizeStyle, vModelSelect, markRaw, Teleport, inject } from "vue";
import draggable from "vuedraggable";
const adjustments = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M12 6V4M12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10M12 6C13.1046 6 14 6.89543 14 8C14 9.10457 13.1046 10 12 10M6 18C7.10457 18 8 17.1046 8 16C8 14.8954 7.10457 14 6 14M6 18C4.89543 18 4 17.1046 4 16C4 14.8954 4.89543 14 6 14M6 18V20M6 14V4M12 10V20M18 18C19.1046 18 20 17.1046 20 16C20 14.8954 19.1046 14 18 14M18 18C16.8954 18 16 17.1046 16 16C16 14.8954 16.8954 14 18 14M18 18V20M18 14V4",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M5 4C5 3.44772 4.55228 3 4 3C3.44772 3 3 3.44772 3 4V11.2676C2.4022 11.6134 2 12.2597 2 13C2 13.7403 2.4022 14.3866 3 14.7324V16C3 16.5523 3.44772 17 4 17C4.55228 17 5 16.5523 5 16V14.7324C5.5978 14.3866 6 13.7403 6 13C6 12.2597 5.5978 11.6134 5 11.2676V4Z",
        fill: "#4A5568"
      },
      {
        d: "M11 4C11 3.44772 10.5523 3 10 3C9.44772 3 9 3.44772 9 4V5.26756C8.4022 5.61337 8 6.25972 8 7C8 7.74028 8.4022 8.38663 9 8.73244V16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16V8.73244C11.5978 8.38663 12 7.74028 12 7C12 6.25972 11.5978 5.61337 11 5.26756V4Z",
        fill: "#4A5568"
      },
      {
        d: "M16 3C16.5523 3 17 3.44772 17 4V11.2676C17.5978 11.6134 18 12.2597 18 13C18 13.7403 17.5978 14.3866 17 14.7324V16C17 16.5523 16.5523 17 16 17C15.4477 17 15 16.5523 15 16V14.7324C14.4022 14.3866 14 13.7403 14 13C14 12.2597 14.4022 11.6134 15 11.2676V4C15 3.44772 15.4477 3 16 3Z",
        fill: "#4A5568"
      }
    ]
  }
};
const annotation = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M7 8H17M7 12H11M12 20L8 16H5C3.89543 16 3 15.1046 3 14V6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V14C21 15.1046 20.1046 16 19 16H16L12 20Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M18 13V5C18 3.89543 17.1046 3 16 3H4C2.89543 3 2 3.89543 2 5V13C2 14.1046 2.89543 15 4 15H7L10 18L13 15H16C17.1046 15 18 14.1046 18 13ZM5 7C5 6.44772 5.44772 6 6 6H14C14.5523 6 15 6.44772 15 7C15 7.55228 14.5523 8 14 8H6C5.44772 8 5 7.55228 5 7ZM6 10C5.44772 10 5 10.4477 5 11C5 11.5523 5.44772 12 6 12H9C9.55229 12 10 11.5523 10 11C10 10.4477 9.55229 10 9 10H6Z",
        fill: "#4A5568"
      }
    ]
  }
};
const archive = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M5 8H19M5 8C3.89543 8 3 7.10457 3 6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6C21 7.10457 20.1046 8 19 8M5 8L5 18C5 19.1046 5.89543 20 7 20H17C18.1046 20 19 19.1046 19 18V8M10 12H14",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M4 3C2.89543 3 2 3.89543 2 5C2 6.10457 2.89543 7 4 7H16C17.1046 7 18 6.10457 18 5C18 3.89543 17.1046 3 16 3H4Z",
        fill: "#4A5568"
      },
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 8H17V15C17 16.1046 16.1046 17 15 17H5C3.89543 17 3 16.1046 3 15V8ZM8 11C8 10.4477 8.44772 10 9 10H11C11.5523 10 12 10.4477 12 11C12 11.5523 11.5523 12 11 12H9C8.44772 12 8 11.5523 8 11Z",
        fill: "#4A5568"
      }
    ]
  }
};
const backspace$1 = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M12 14L14 12M14 12L16 10M14 12L12 10M14 12L16 14M3 12L9.41421 18.4142C9.78929 18.7893 10.298 19 10.8284 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H10.8284C10.298 5 9.78929 5.21071 9.41421 5.58579L3 12Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6.70711 4.87868C7.26972 4.31607 8.03278 4 8.82843 4H15C16.6569 4 18 5.34315 18 7V13C18 14.6569 16.6569 16 15 16H8.82843C8.03278 16 7.26972 15.6839 6.70711 15.1213L2.29289 10.7071C2.10536 10.5196 2 10.2652 2 10C2 9.73478 2.10536 9.48043 2.29289 9.29289L6.70711 4.87868ZM10.7071 7.29289C10.3166 6.90237 9.68342 6.90237 9.29289 7.29289C8.90237 7.68342 8.90237 8.31658 9.29289 8.70711L10.5858 10L9.29289 11.2929C8.90237 11.6834 8.90237 12.3166 9.29289 12.7071C9.68342 13.0976 10.3166 13.0976 10.7071 12.7071L12 11.4142L13.2929 12.7071C13.6834 13.0976 14.3166 13.0976 14.7071 12.7071C15.0976 12.3166 15.0976 11.6834 14.7071 11.2929L13.4142 10L14.7071 8.70711C15.0976 8.31658 15.0976 7.68342 14.7071 7.29289C14.3166 6.90237 13.6834 6.90237 13.2929 7.29289L12 8.58579L10.7071 7.29289Z",
        fill: "#374151"
      }
    ]
  }
};
const ban = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M18.364 18.364C21.8787 14.8492 21.8787 9.15076 18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604M18.364 18.364C14.8492 21.8787 9.15076 21.8787 5.63604 18.364C2.12132 14.8492 2.12132 9.15076 5.63604 5.63604M18.364 18.364L5.63604 5.63604",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M13.4766 14.8907C12.4958 15.5892 11.2959 16 10 16C6.68629 16 4 13.3137 4 10C4 8.70414 4.41081 7.50423 5.1093 6.52339L13.4766 14.8907ZM14.8908 13.4765L6.52354 5.1092C7.50434 4.41077 8.7042 4 10 4C13.3137 4 16 6.68629 16 10C16 11.2958 15.5892 12.4957 14.8908 13.4765ZM18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10Z",
        fill: "#4B5563"
      }
    ]
  }
};
const beaker = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M19.428 15.4282C19.1488 15.149 18.7932 14.9587 18.406 14.8812L16.0185 14.4037C14.7101 14.1421 13.3519 14.324 12.1585 14.9207L11.8411 15.0793C10.6477 15.676 9.28948 15.8579 7.98113 15.5963L6.04938 15.2099C5.39366 15.0788 4.71578 15.284 4.24294 15.7569M7.9998 4H15.9998L14.9998 5V10.1716C14.9998 10.702 15.2105 11.2107 15.5856 11.5858L20.5856 16.5858C21.8455 17.8457 20.9532 20 19.1714 20H4.82823C3.04642 20 2.15409 17.8457 3.41401 16.5858L8.41402 11.5858C8.78909 11.2107 8.9998 10.702 8.9998 10.1716V5L7.9998 4Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6.99985 2C6.59539 2 6.23075 2.24364 6.07597 2.61732C5.92119 2.99099 6.00675 3.42111 6.29275 3.70711L6.99985 4.41421V8.17157C6.99985 8.43679 6.8945 8.69114 6.70696 8.87868L2.70696 12.8787C0.817066 14.7686 2.15556 18 4.82828 18H15.1714C17.8441 18 19.1826 14.7686 17.2927 12.8787L13.2927 8.87868C13.1052 8.69114 12.9999 8.43679 12.9999 8.17157V4.41421L13.707 3.70711C13.993 3.42111 14.0785 2.99099 13.9237 2.61732C13.769 2.24364 13.4043 2 12.9999 2H6.99985ZM8.99985 8.17157V4H10.9999V8.17157C10.9999 8.96722 11.3159 9.73028 11.8785 10.2929L12.9061 11.3204C12.1892 11.1537 11.4377 11.1874 10.7349 11.4217L10.2647 11.5784C9.44364 11.8521 8.55596 11.8521 7.73489 11.5784L7.17244 11.3909C7.13436 11.3782 7.09607 11.3667 7.05762 11.3564L8.12117 10.2929C8.68378 9.73028 8.99985 8.96722 8.99985 8.17157Z",
        fill: "#374151"
      }
    ]
  }
};
const bell = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M15 17H20L18.5951 15.5951C18.2141 15.2141 18 14.6973 18 14.1585V11C18 8.38757 16.3304 6.16509 14 5.34142V5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5V5.34142C7.66962 6.16509 6 8.38757 6 11V14.1585C6 14.6973 5.78595 15.2141 5.40493 15.5951L4 17H9M15 17V18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18V17M15 17H9",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M10 2C6.68632 2 4.00003 4.68629 4.00003 8V11.5858L3.29292 12.2929C3.00692 12.5789 2.92137 13.009 3.07615 13.3827C3.23093 13.7564 3.59557 14 4.00003 14H16C16.4045 14 16.7691 13.7564 16.9239 13.3827C17.0787 13.009 16.9931 12.5789 16.7071 12.2929L16 11.5858V8C16 4.68629 13.3137 2 10 2Z",
        fill: "#4A5568"
      },
      {
        d: "M10 18C8.34315 18 7 16.6569 7 15H13C13 16.6569 11.6569 18 10 18Z",
        fill: "#4A5568"
      }
    ]
  }
};
const bookmark = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M5 5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21L12 17.5L5 21V5Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M5 4C5 2.89543 5.89543 2 7 2H13C14.1046 2 15 2.89543 15 4V18L10 15.5L5 18V4Z",
        fill: "#4A5568"
      }
    ]
  }
};
const briefcase = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M21 13.2554C18.2207 14.3805 15.1827 15 12 15C8.8173 15 5.7793 14.3805 3 13.2554M16 6V4C16 2.89543 15.1046 2 14 2H10C8.89543 2 8 2.89543 8 4V6M12 12H12.01M5 20H19C20.1046 20 21 19.1046 21 18V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V18C3 19.1046 3.89543 20 5 20Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6 6V5C6 3.34315 7.34315 2 9 2H11C12.6569 2 14 3.34315 14 5V6H16C17.1046 6 18 6.89543 18 8V11.5708C15.5096 12.4947 12.8149 12.9999 10 12.9999C7.18514 12.9999 4.49037 12.4947 2 11.5707V8C2 6.89543 2.89543 6 4 6H6ZM8 5C8 4.44772 8.44772 4 9 4H11C11.5523 4 12 4.44772 12 5V6H8V5ZM9 10C9 9.44772 9.44772 9 10 9H10.01C10.5623 9 11.01 9.44772 11.01 10C11.01 10.5523 10.5623 11 10.01 11H10C9.44772 11 9 10.5523 9 10Z",
        fill: "#4A5568"
      },
      {
        d: "M2 13.6923V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V13.6923C15.4872 14.5404 12.7964 14.9999 10 14.9999C7.20363 14.9999 4.51279 14.5404 2 13.6923Z",
        fill: "#4A5568"
      }
    ]
  }
};
const cake = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M21 15.5458C20.4771 15.5458 19.9542 15.6972 19.5 16C18.5917 16.6056 17.4083 16.6056 16.5 16C15.5917 15.3944 14.4083 15.3944 13.5 16C12.5917 16.6056 11.4083 16.6056 10.5 16C9.59167 15.3944 8.40833 15.3944 7.5 16C6.59167 16.6056 5.40833 16.6056 4.5 16C4.04584 15.6972 3.52292 15.5458 3 15.5458M9 6V8M12 6V8M15 6V8M9 3H9.01M12 3H12.01M15 3H15.01M21 21V14C21 12.8954 20.1046 12 19 12H5C3.89543 12 3 12.8954 3 14V21H21ZM18 12V10C18 8.89543 17.1046 8 16 8H8C6.89543 8 6 8.89543 6 10V12H18Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6 3C6 2.44772 6.44772 2 7 2H7.01C7.56228 2 8.01 2.44772 8.01 3C8.01 3.55228 7.56228 4 7.01 4H7C6.44772 4 6 3.55228 6 3ZM8 6C8 5.44772 7.55228 5 7 5C6.44772 5 6 5.44772 6 6V7C4.89543 7 4 7.89543 4 9V10C2.89543 10 2 10.8954 2 12V12.6833C2.36868 12.7866 2.72499 12.9482 3.0547 13.168C3.62713 13.5496 4.37287 13.5496 4.9453 13.168C6.18953 12.3385 7.81047 12.3385 9.0547 13.168C9.62713 13.5496 10.3729 13.5496 10.9453 13.168C12.1895 12.3385 13.8105 12.3385 15.0547 13.168C15.6271 13.5496 16.3729 13.5496 16.9453 13.168C17.275 12.9482 17.6313 12.7866 18 12.6833V12C18 10.8954 17.1046 10 16 10V9C16 7.89543 15.1046 7 14 7V6C14 5.44772 13.5523 5 13 5C12.4477 5 12 5.44772 12 6V7H11V6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6V7H8V6ZM18 14.8679C16.7633 15.6614 15.1714 15.6495 13.9453 14.8321C13.3729 14.4505 12.6271 14.4505 12.0547 14.8321C10.8105 15.6616 9.18953 15.6616 7.9453 14.8321C7.37287 14.4505 6.62713 14.4505 6.0547 14.8321C4.82863 15.6495 3.23675 15.6614 2 14.8679V17C2 17.5523 2.44772 18 3 18H17C17.5523 18 18 17.5523 18 17V14.8679ZM9 3C9 2.44772 9.44772 2 10 2H10.01C10.5623 2 11.01 2.44772 11.01 3C11.01 3.55228 10.5623 4 10.01 4H10C9.44772 4 9 3.55228 9 3ZM12 3C12 2.44772 12.4477 2 13 2H13.01C13.5623 2 14.01 2.44772 14.01 3C14.01 3.55228 13.5623 4 13.01 4H13C12.4477 4 12 3.55228 12 3Z",
        fill: "#374151"
      }
    ]
  }
};
const calculator = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M9 7H15M15 17V14M12 17H12.01M9 17H9.01M9 14H9.01M12 14H12.01M15 11H15.01M12 11H12.01M9 11H9.01M7 21H17C18.1046 21 19 20.1046 19 19V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6 2C4.89543 2 4 2.89543 4 4V16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V4C16 2.89543 15.1046 2 14 2H6ZM7 4C6.44772 4 6 4.44772 6 5C6 5.55228 6.44772 6 7 6H13C13.5523 6 14 5.55228 14 5C14 4.44772 13.5523 4 13 4H7ZM13 11C13.5523 11 14 11.4477 14 12V15C14 15.5523 13.5523 16 13 16C12.4477 16 12 15.5523 12 15V12C12 11.4477 12.4477 11 13 11ZM10 14C9.44772 14 9 14.4477 9 15C9 15.5523 9.44772 16 10 16H10.01C10.5623 16 11.01 15.5523 11.01 15C11.01 14.4477 10.5623 14 10.01 14H10ZM6 15C6 14.4477 6.44772 14 7 14H7.01C7.56228 14 8.01 14.4477 8.01 15C8.01 15.5523 7.56228 16 7.01 16H7C6.44772 16 6 15.5523 6 15ZM7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H7.01C7.56228 13 8.01 12.5523 8.01 12C8.01 11.4477 7.56228 11 7.01 11H7ZM9 12C9 11.4477 9.44772 11 10 11H10.01C10.5623 11 11.01 11.4477 11.01 12C11.01 12.5523 10.5623 13 10.01 13H10C9.44772 13 9 12.5523 9 12ZM13 8C12.4477 8 12 8.44772 12 9C12 9.55228 12.4477 10 13 10H13.01C13.5623 10 14.01 9.55228 14.01 9C14.01 8.44772 13.5623 8 13.01 8H13ZM9 9C9 8.44772 9.44772 8 10 8H10.01C10.5623 8 11.01 8.44772 11.01 9C11.01 9.55228 10.5623 10 10.01 10H10C9.44772 10 9 9.55228 9 9ZM7 8C6.44772 8 6 8.44772 6 9C6 9.55228 6.44772 10 7 10H7.01C7.56228 10 8.01 9.55228 8.01 9C8.01 8.44772 7.56228 8 7.01 8H7Z",
        fill: "#374151"
      }
    ]
  }
};
const calendar$2 = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M8 7V3M16 7V3M7 11H17M5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6 2C5.44772 2 5 2.44772 5 3V4H4C2.89543 4 2 4.89543 2 6V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V6C18 4.89543 17.1046 4 16 4H15V3C15 2.44772 14.5523 2 14 2C13.4477 2 13 2.44772 13 3V4H7V3C7 2.44772 6.55228 2 6 2ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H6Z",
        fill: "#4A5568"
      }
    ]
  }
};
const camera = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M3 9C3 7.89543 3.89543 7 5 7H5.92963C6.59834 7 7.2228 6.6658 7.59373 6.1094L8.40627 4.8906C8.7772 4.3342 9.40166 4 10.0704 4H13.9296C14.5983 4 15.2228 4.3342 15.5937 4.8906L16.4063 6.1094C16.7772 6.6658 17.4017 7 18.0704 7H19C20.1046 7 21 7.89543 21 9V18C21 19.1046 20.1046 20 19 20H5C3.89543 20 3 19.1046 3 18V9Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      },
      {
        d: "M15 13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13C9 11.3431 10.3431 10 12 10C13.6569 10 15 11.3431 15 13Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4 5C2.89543 5 2 5.89543 2 7V15C2 16.1046 2.89543 17 4 17H16C17.1046 17 18 16.1046 18 15V7C18 5.89543 17.1046 5 16 5H14.4142C14.149 5 13.8946 4.89464 13.7071 4.70711L12.5858 3.58579C12.2107 3.21071 11.702 3 11.1716 3H8.82843C8.29799 3 7.78929 3.21071 7.41421 3.58579L6.29289 4.70711C6.10536 4.89464 5.851 5 5.58579 5H4ZM10 14C11.6569 14 13 12.6569 13 11C13 9.34315 11.6569 8 10 8C8.34315 8 7 9.34315 7 11C7 12.6569 8.34315 14 10 14Z",
        fill: "#4A5568"
      }
    ]
  }
};
const cash = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M17 9V7C17 5.89543 16.1046 5 15 5H5C3.89543 5 3 5.89543 3 7V13C3 14.1046 3.89543 15 5 15H7M9 19H19C20.1046 19 21 18.1046 21 17V11C21 9.89543 20.1046 9 19 9H9C7.89543 9 7 9.89543 7 11V17C7 18.1046 7.89543 19 9 19ZM16 14C16 15.1046 15.1046 16 14 16C12.8954 16 12 15.1046 12 14C12 12.8954 12.8954 12 14 12C15.1046 12 16 12.8954 16 14Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4 4C2.89543 4 2 4.89543 2 6V10C2 11.1046 2.89543 12 4 12V6H14C14 4.89543 13.1046 4 12 4H4ZM6 10C6 8.89543 6.89543 8 8 8H16C17.1046 8 18 8.89543 18 10V14C18 15.1046 17.1046 16 16 16H8C6.89543 16 6 15.1046 6 14V10ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
        fill: "#4A5568"
      }
    ]
  }
};
const chat = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M8 12H8.01M12 12H12.01M16 12H16.01M21 12C21 16.4183 16.9706 20 12 20C10.4607 20 9.01172 19.6565 7.74467 19.0511L3 20L4.39499 16.28C3.51156 15.0423 3 13.5743 3 12C3 7.58172 7.02944 4 12 4C16.9706 4 21 7.58172 21 12Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M18 10C18 13.866 14.4183 17 10 17C8.50836 17 7.11208 16.6428 5.91677 16.0208L2 17L3.3383 13.8773C2.4928 12.7673 2 11.434 2 10C2 6.13401 5.58172 3 10 3C14.4183 3 18 6.13401 18 10ZM7 9H5V11H7V9ZM15 9H13V11H15V9ZM9 9H11V11H9V9Z",
        fill: "#4A5568"
      }
    ]
  }
};
const check = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M5 13L9 17L19 7",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M16.7071 5.29289C17.0976 5.68342 17.0976 6.31658 16.7071 6.70711L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071L3.29289 10.7071C2.90237 10.3166 2.90237 9.68342 3.29289 9.29289C3.68342 8.90237 4.31658 8.90237 4.70711 9.29289L8 12.5858L15.2929 5.29289C15.6834 4.90237 16.3166 4.90237 16.7071 5.29289Z",
        fill: "#4A5568"
      }
    ]
  }
};
const chip = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M9 3V5M15 3V5M9 19V21M15 19V21M5 9H3M5 15H3M21 9H19M21 15H19M7 19H17C18.1046 19 19 18.1046 19 17V7C19 5.89543 18.1046 5 17 5H7C5.89543 5 5 5.89543 5 7V17C5 18.1046 5.89543 19 7 19ZM9 9H15V15H9V9Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M13 7H7V13H13V7Z",
        fill: "#374151"
      },
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7 2C7 1.44772 7.44772 1 8 1C8.55228 1 9 1.44772 9 2V3H11V2C11 1.44772 11.4477 1 12 1C12.5523 1 13 1.44772 13 2V3H15C16.1046 3 17 3.89543 17 5V7H18C18.5523 7 19 7.44772 19 8C19 8.55228 18.5523 9 18 9H17V11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H17V15C17 16.1046 16.1046 17 15 17H13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V17H9V18C9 18.5523 8.55228 19 8 19C7.44772 19 7 18.5523 7 18V17H5C3.89543 17 3 16.1046 3 15V13H2C1.44772 13 1 12.5523 1 12C1 11.4477 1.44772 11 2 11H3V9H2C1.44772 9 1 8.55228 1 8C1 7.44772 1.44772 7 2 7H3V5C3 3.89543 3.89543 3 5 3H7V2ZM5 5H15V15H5V5Z",
        fill: "#374151"
      }
    ]
  }
};
const clipboard = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15M9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M8 3C8 2.44772 8.44772 2 9 2H11C11.5523 2 12 2.44772 12 3C12 3.55228 11.5523 4 11 4H9C8.44772 4 8 3.55228 8 3Z",
        fill: "#4A5568"
      },
      {
        d: "M6 3C4.89543 3 4 3.89543 4 5V16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V5C16 3.89543 15.1046 3 14 3C14 4.65685 12.6569 6 11 6H9C7.34315 6 6 4.65685 6 3Z",
        fill: "#4A5568"
      }
    ]
  }
};
const clock = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M12 8V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 6C11 5.44772 10.5523 5 10 5C9.44771 5 9 5.44772 9 6V10C9 10.2652 9.10536 10.5196 9.29289 10.7071L12.1213 13.5355C12.5118 13.9261 13.145 13.9261 13.5355 13.5355C13.9261 13.145 13.9261 12.5118 13.5355 12.1213L11 9.58579V6Z",
        fill: "#4A5568"
      }
    ]
  }
};
const cloud = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M3 15C3 17.2091 4.79086 19 7 19H16C18.7614 19 21 16.7614 21 14C21 11.2386 18.7614 9 16 9C15.9666 9 15.9334 9.00033 15.9002 9.00098C15.4373 6.71825 13.4193 5 11 5C8.23858 5 6 7.23858 6 10C6 10.3768 6.04169 10.7439 6.12071 11.097C4.33457 11.4976 3 13.0929 3 15Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M5.5 16C3.567 16 2 14.433 2 12.5C2 10.6916 3.37146 9.20358 5.13102 9.01922C5.04553 8.69382 5 8.35223 5 8C5 5.79086 6.79086 4 9 4C10.8788 4 12.4551 5.29538 12.8845 7.04175C13.0857 7.01422 13.2912 7 13.5 7C15.9853 7 18 9.01472 18 11.5C18 13.9853 15.9853 16 13.5 16H5.5Z",
        fill: "#374151"
      }
    ]
  }
};
const code$1 = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M10 20L14 4M18 8L22 12L18 16M6 16L2 12L6 8",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.3162 3.05134C12.8402 3.22599 13.1233 3.79231 12.9487 4.31625L8.94868 16.3163C8.77404 16.8402 8.20772 17.1234 7.68377 16.9487C7.15983 16.7741 6.87667 16.2077 7.05132 15.6838L11.0513 3.6838C11.226 3.15986 11.7923 2.8767 12.3162 3.05134ZM5.70711 6.29292C6.09763 6.68344 6.09763 7.31661 5.70711 7.70713L3.41421 10L5.70711 12.2929C6.09763 12.6834 6.09763 13.3166 5.70711 13.7071C5.31658 14.0977 4.68342 14.0977 4.29289 13.7071L1.29289 10.7071C0.902369 10.3166 0.902369 9.68344 1.29289 9.29292L4.29289 6.29292C4.68342 5.9024 5.31658 5.9024 5.70711 6.29292ZM14.2929 6.29292C14.6834 5.9024 15.3166 5.9024 15.7071 6.29292L18.7071 9.29292C19.0976 9.68344 19.0976 10.3166 18.7071 10.7071L15.7071 13.7071C15.3166 14.0977 14.6834 14.0977 14.2929 13.7071C13.9024 13.3166 13.9024 12.6834 14.2929 12.2929L16.5858 10L14.2929 7.70713C13.9024 7.31661 13.9024 6.68344 14.2929 6.29292Z",
        fill: "#4A5568"
      }
    ]
  }
};
const cog = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M10.3246 4.31731C10.751 2.5609 13.249 2.5609 13.6754 4.31731C13.9508 5.45193 15.2507 5.99038 16.2478 5.38285C17.7913 4.44239 19.5576 6.2087 18.6172 7.75218C18.0096 8.74925 18.5481 10.0492 19.6827 10.3246C21.4391 10.751 21.4391 13.249 19.6827 13.6754C18.5481 13.9508 18.0096 15.2507 18.6172 16.2478C19.5576 17.7913 17.7913 19.5576 16.2478 18.6172C15.2507 18.0096 13.9508 18.5481 13.6754 19.6827C13.249 21.4391 10.751 21.4391 10.3246 19.6827C10.0492 18.5481 8.74926 18.0096 7.75219 18.6172C6.2087 19.5576 4.44239 17.7913 5.38285 16.2478C5.99038 15.2507 5.45193 13.9508 4.31731 13.6754C2.5609 13.249 2.5609 10.751 4.31731 10.3246C5.45193 10.0492 5.99037 8.74926 5.38285 7.75218C4.44239 6.2087 6.2087 4.44239 7.75219 5.38285C8.74926 5.99037 10.0492 5.45193 10.3246 4.31731Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      },
      {
        d: "M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.4892 3.17094C11.1102 1.60969 8.8898 1.60969 8.51078 3.17094C8.26594 4.17949 7.11045 4.65811 6.22416 4.11809C4.85218 3.28212 3.28212 4.85218 4.11809 6.22416C4.65811 7.11045 4.17949 8.26593 3.17094 8.51078C1.60969 8.8898 1.60969 11.1102 3.17094 11.4892C4.17949 11.7341 4.65811 12.8896 4.11809 13.7758C3.28212 15.1478 4.85218 16.7179 6.22417 15.8819C7.11045 15.3419 8.26594 15.8205 8.51078 16.8291C8.8898 18.3903 11.1102 18.3903 11.4892 16.8291C11.7341 15.8205 12.8896 15.3419 13.7758 15.8819C15.1478 16.7179 16.7179 15.1478 15.8819 13.7758C15.3419 12.8896 15.8205 11.7341 16.8291 11.4892C18.3903 11.1102 18.3903 8.8898 16.8291 8.51078C15.8205 8.26593 15.3419 7.11045 15.8819 6.22416C16.7179 4.85218 15.1478 3.28212 13.7758 4.11809C12.8896 4.65811 11.7341 4.17949 11.4892 3.17094ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z",
        fill: "#4A5568"
      }
    ]
  }
};
const collection = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M19 11H5M19 11C20.1046 11 21 11.8954 21 13V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V13C3 11.8954 3.89543 11 5 11M19 11V9C19 7.89543 18.1046 7 17 7M5 11V9C5 7.89543 5.89543 7 7 7M7 7V5C7 3.89543 7.89543 3 9 3H15C16.1046 3 17 3.89543 17 5V7M7 7H17",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M7 3C6.44772 3 6 3.44772 6 4C6 4.55228 6.44772 5 7 5H13C13.5523 5 14 4.55228 14 4C14 3.44772 13.5523 3 13 3H7Z",
        fill: "#4A5568"
      },
      {
        d: "M4 7C4 6.44772 4.44772 6 5 6H15C15.5523 6 16 6.44772 16 7C16 7.55228 15.5523 8 15 8H5C4.44772 8 4 7.55228 4 7Z",
        fill: "#4A5568"
      },
      {
        d: "M2 11C2 9.89543 2.89543 9 4 9H16C17.1046 9 18 9.89543 18 11V15C18 16.1046 17.1046 17 16 17H4C2.89543 17 2 16.1046 2 15V11Z",
        fill: "#4A5568"
      }
    ]
  }
};
const cube = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M20 7L12 3L4 7M20 7L12 11M20 7V17L12 21M12 11L4 7M12 11V21M4 7V17L12 21",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M11 17C11 17.3466 11.1795 17.6684 11.4743 17.8507C11.7691 18.0329 12.1372 18.0494 12.4472 17.8944L16.4472 15.8944C16.786 15.725 17 15.3788 17 15V9.23607C17 8.88949 16.8205 8.56762 16.5257 8.38542C16.2309 8.20321 15.8628 8.18665 15.5528 8.34164L11.5528 10.3416C11.214 10.511 11 10.8573 11 11.2361V17Z",
        fill: "#374151"
      },
      {
        d: "M15.2111 6.27639C15.5499 6.107 15.7639 5.76074 15.7639 5.38197C15.7639 5.00319 15.5499 4.65693 15.2111 4.48754L10.4472 2.10557C10.1657 1.96481 9.83431 1.96481 9.55279 2.10557L4.78885 4.48754C4.45007 4.65693 4.23607 5.00319 4.23607 5.38197C4.23607 5.76074 4.45007 6.107 4.78885 6.27639L9.55279 8.65836C9.83431 8.79912 10.1657 8.79912 10.4472 8.65836L15.2111 6.27639Z",
        fill: "#374151"
      },
      {
        d: "M4.44721 8.34164C4.13723 8.18665 3.76909 8.20321 3.47427 8.38542C3.17945 8.56762 3 8.88949 3 9.23607V15C3 15.3788 3.214 15.725 3.55279 15.8944L7.55279 17.8944C7.86277 18.0494 8.23091 18.0329 8.52573 17.8507C8.82055 17.6684 9 17.3466 9 17V11.2361C9 10.8573 8.786 10.511 8.44721 10.3416L4.44721 8.34164Z",
        fill: "#374151"
      }
    ]
  }
};
const database = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M4 7V17C4 19.2091 7.58172 21 12 21C16.4183 21 20 19.2091 20 17V7M4 7C4 9.20914 7.58172 11 12 11C16.4183 11 20 9.20914 20 7M4 7C4 4.79086 7.58172 3 12 3C16.4183 3 20 4.79086 20 7M20 12C20 14.2091 16.4183 16 12 16C7.58172 16 4 14.2091 4 12",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M3 12V15C3 16.6569 6.13401 18 10 18C13.866 18 17 16.6569 17 15V12C17 13.6569 13.866 15 10 15C6.13401 15 3 13.6569 3 12Z",
        fill: "#374151"
      },
      {
        d: "M3 7V10C3 11.6569 6.13401 13 10 13C13.866 13 17 11.6569 17 10V7C17 8.65685 13.866 10 10 10C6.13401 10 3 8.65685 3 7Z",
        fill: "#374151"
      },
      {
        d: "M17 5C17 6.65685 13.866 8 10 8C6.13401 8 3 6.65685 3 5C3 3.34315 6.13401 2 10 2C13.866 2 17 3.34315 17 5Z",
        fill: "#374151"
      }
    ]
  }
};
const document$1 = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M7 21H17C18.1046 21 19 20.1046 19 19V9.41421C19 9.149 18.8946 8.89464 18.7071 8.70711L13.2929 3.29289C13.1054 3.10536 12.851 3 12.5858 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4 4C4 2.89543 4.89543 2 6 2H10.5858C11.1162 2 11.6249 2.21071 12 2.58579L15.4142 6C15.7893 6.37507 16 6.88378 16 7.41421V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V4Z",
        fill: "#4A5568"
      }
    ]
  }
};
const download = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M4 16L4 17C4 18.6569 5.34315 20 7 20L17 20C18.6569 20 20 18.6569 20 17L20 16M16 12L12 16M12 16L8 12M12 16L12 4",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 17C3 16.4477 3.44772 16 4 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H4C3.44772 18 3 17.5523 3 17ZM6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L9 10.5858L9 3C9 2.44772 9.44771 2 10 2C10.5523 2 11 2.44771 11 3L11 10.5858L12.2929 9.29289C12.6834 8.90237 13.3166 8.90237 13.7071 9.29289C14.0976 9.68342 14.0976 10.3166 13.7071 10.7071L10.7071 13.7071C10.5196 13.8946 10.2652 14 10 14C9.73478 14 9.48043 13.8946 9.29289 13.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289Z",
        fill: "#4A5568"
      }
    ]
  }
};
const duplicate = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M8 16H6C4.89543 16 4 15.1046 4 14V6C4 4.89543 4.89543 4 6 4H14C15.1046 4 16 4.89543 16 6V8M10 20H18C19.1046 20 20 19.1046 20 18V10C20 8.89543 19.1046 8 18 8H10C8.89543 8 8 8.89543 8 10V18C8 19.1046 8.89543 20 10 20Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M7 9C7 7.89543 7.89543 7 9 7H15C16.1046 7 17 7.89543 17 9V15C17 16.1046 16.1046 17 15 17H9C7.89543 17 7 16.1046 7 15V9Z",
        fill: "#4A5568"
      },
      {
        d: "M5 3C3.89543 3 3 3.89543 3 5V11C3 12.1046 3.89543 13 5 13L5 5H13C13 3.89543 12.1046 3 11 3H5Z",
        fill: "#4A5568"
      }
    ]
  }
};
const exclamation = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M12 9V11M12 15H12.01M5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0378 2.66667 10.268 4L3.33978 16C2.56998 17.3333 3.53223 19 5.07183 19Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8.25706 3.09882C9.02167 1.73952 10.9788 1.73952 11.7434 3.09882L17.3237 13.0194C18.0736 14.3526 17.1102 15.9999 15.5805 15.9999H4.4199C2.89025 15.9999 1.92682 14.3526 2.67675 13.0194L8.25706 3.09882ZM11.0001 13C11.0001 13.5523 10.5524 14 10.0001 14C9.44784 14 9.00012 13.5523 9.00012 13C9.00012 12.4477 9.44784 12 10.0001 12C10.5524 12 11.0001 12.4477 11.0001 13ZM10.0001 5C9.44784 5 9.00012 5.44772 9.00012 6V9C9.00012 9.55228 9.44784 10 10.0001 10C10.5524 10 11.0001 9.55228 11.0001 9V6C11.0001 5.44772 10.5524 5 10.0001 5Z",
        fill: "#4A5568"
      }
    ]
  }
};
const eye = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M14.9998 12C14.9998 13.6569 13.6566 15 11.9998 15C10.3429 15 8.99976 13.6569 8.99976 12C8.99976 10.3431 10.3429 9 11.9998 9C13.6566 9 14.9998 10.3431 14.9998 12Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      },
      {
        d: "M2.45801 12C3.73228 7.94288 7.52257 5 12.0002 5C16.4778 5 20.2681 7.94291 21.5424 12C20.2681 16.0571 16.4778 19 12.0002 19C7.52256 19 3.73226 16.0571 2.45801 12Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M10 12C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8C8.89544 8 8.00001 8.89543 8.00001 10C8.00001 11.1046 8.89544 12 10 12Z",
        fill: "#4A5568"
      },
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M0.457764 10C1.73202 5.94291 5.52232 3 9.99997 3C14.4776 3 18.2679 5.94288 19.5422 9.99996C18.2679 14.0571 14.4776 17 9.99995 17C5.52232 17 1.73204 14.0571 0.457764 10ZM14 10C14 12.2091 12.2091 14 10 14C7.79087 14 6.00001 12.2091 6.00001 10C6.00001 7.79086 7.79087 6 10 6C12.2091 6 14 7.79086 14 10Z",
        fill: "#4A5568"
      }
    ]
  }
};
const film = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M7 4V20M17 4V20M3 8H7M17 8H21M3 12H21M3 16H7M17 16H21M4 20H20C20.5523 20 21 19.5523 21 19V5C21 4.44772 20.5523 4 20 4H4C3.44772 4 3 4.44772 3 5V19C3 19.5523 3.44772 20 4 20Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4 3C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H16C17.1046 17 18 16.1046 18 15V5C18 3.89543 17.1046 3 16 3H4ZM7 5L13 5V9H7V5ZM15 13V15H16V13H15ZM13 11H7V15H13V11ZM15 11H16V9H15V11ZM16 7V5H15V7H16ZM5 5V7H4V5H5ZM5 9H4V11H5V9ZM4 13H5V15H4V13Z",
        fill: "#374151"
      }
    ]
  }
};
const filter = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V6.58579C21 6.851 20.8946 7.10536 20.7071 7.29289L14.2929 13.7071C14.1054 13.8946 14 14.149 14 14.4142V17L10 21V14.4142C10 14.149 9.89464 13.8946 9.70711 13.7071L3.29289 7.29289C3.10536 7.10536 3 6.851 3 6.58579V4Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 3C3 2.44772 3.44772 2 4 2H16C16.5523 2 17 2.44772 17 3V6C17 6.26522 16.8946 6.51957 16.7071 6.70711L12 11.4142V15C12 15.2652 11.8946 15.5196 11.7071 15.7071L9.70711 17.7071C9.42111 17.9931 8.99099 18.0787 8.61732 17.9239C8.24364 17.7691 8 17.4045 8 17V11.4142L3.29289 6.70711C3.10536 6.51957 3 6.26522 3 6V3Z",
        fill: "#4A5568"
      }
    ]
  }
};
const fire = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M17.6569 18.6568C14.5327 21.781 9.46734 21.781 6.34315 18.6568C4.78105 17.0947 4 15.0474 4 13C4 10.9526 4.78105 8.90523 6.34315 7.34313C6.34315 7.34313 7.00004 8.99995 9.00004 9.99995C9.00004 7.99995 9.50004 4.99996 11.9859 3C14 5 16.0912 5.77745 17.6569 7.34313C19.219 8.90523 20 10.9526 20 13C20 15.0474 19.2189 17.0947 17.6569 18.6568Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      },
      {
        d: "M9.87868 16.1213C11.0503 17.2928 12.9497 17.2928 14.1213 16.1213C14.7071 15.5355 15 14.7677 15 14C15 13.2322 14.7071 12.4644 14.1213 11.8786C13.5392 11.2965 12.7775 11.0037 12.0146 11L10.9999 13.9999L9 14C9.00001 14.7677 9.2929 15.5355 9.87868 16.1213Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.3945 2.55279C12.2662 2.29624 12.034 2.10713 11.7568 2.03351C11.4795 1.95988 11.184 2.00885 10.9454 2.16795C10.5995 2.39858 10.3314 2.72608 10.1229 3.04791C9.90855 3.37854 9.71986 3.76148 9.553 4.16366C9.21939 4.96773 8.93911 5.93195 8.71375 6.89778C8.42752 8.12448 8.21568 9.41687 8.10004 10.4776C7.61585 10.1512 7.33491 9.78527 7.15481 9.41104C6.82729 8.73046 6.75736 7.8772 6.75736 6.75739C6.75736 6.35292 6.51372 5.98829 6.14004 5.83351C5.76637 5.67872 5.33625 5.76428 5.05025 6.05028C3.68361 7.41692 3 9.21013 3 11C3 12.7899 3.68361 14.5831 5.05025 15.9498C7.78392 18.6834 12.2161 18.6834 14.9497 15.9498C16.3164 14.5831 17 12.7899 17 11C17 9.21013 16.3164 7.41692 14.9497 6.05028C14.3584 5.45889 13.9696 5.06453 13.6021 4.5828C13.239 4.10688 12.8781 3.51991 12.3945 2.55279ZM12.1213 15.1213C10.9497 16.2929 9.05025 16.2929 7.87868 15.1213C7.29289 14.5355 7 13.7678 7 13C7 13 7.87868 13.5 9.50005 13.5C9.50005 12.5 10 9.5 10.75 9C11.25 10 11.5355 10.2929 12.1213 10.8787C12.7071 11.4645 13 12.2322 13 13C13 13.7678 12.7071 14.5355 12.1213 15.1213Z",
        fill: "#374151"
      }
    ]
  }
};
const flag = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M3 21V17M3 17V5C3 3.89543 3.89543 3 5 3H11.5L12.5 4H21L18 10L21 16H12.5L11.5 15H5C3.89543 15 3 15.8954 3 17ZM12 3.5V9",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 6C3 4.34315 4.34315 3 6 3H16C16.3788 3 16.725 3.214 16.8944 3.55279C17.0638 3.89157 17.0273 4.29698 16.8 4.6L14.25 8L16.8 11.4C17.0273 11.703 17.0638 12.1084 16.8944 12.4472C16.725 12.786 16.3788 13 16 13H6C5.44772 13 5 13.4477 5 14V17C5 17.5523 4.55228 18 4 18C3.44772 18 3 17.5523 3 17V6Z",
        fill: "#4A5568"
      }
    ]
  }
};
const folder = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M3 7V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V9C21 7.89543 20.1046 7 19 7H13L11 5H5C3.89543 5 3 5.89543 3 7Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M2 6C2 4.89543 2.89543 4 4 4H9L11 6H16C17.1046 6 18 6.89543 18 8V14C18 15.1046 17.1046 16 16 16H4C2.89543 16 2 15.1046 2 14V6Z",
        fill: "#4A5568"
      }
    ]
  }
};
const gift = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M12 8V21M12 8C12 8 12 6.50722 12 6C12 4.89543 12.8954 4 14 4C15.1046 4 16 4.89543 16 6C16 7.10457 15.1046 8 14 8C13.4027 8 12 8 12 8ZM12 8C12 8 12 6.06291 12 5.5C12 4.11929 10.8807 3 9.5 3C8.11929 3 7 4.11929 7 5.5C7 6.88071 8.11929 8 9.5 8C10.3178 8 12 8 12 8ZM5 12H19M5 12C3.89543 12 3 11.1046 3 10C3 8.89543 3.89543 8 5 8H19C20.1046 8 21 8.89543 21 10C21 11.1046 20.1046 12 19 12M5 12L5 19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V12",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M5 5C5 3.34315 6.34315 2 8 2C8.76836 2 9.46924 2.28885 10 2.7639C10.5308 2.28885 11.2316 2 12 2C13.6569 2 15 3.34315 15 5C15 5.35064 14.9398 5.68722 14.8293 6H16C17.1046 6 18 6.89543 18 8C18 9.10457 17.1046 10 16 10H11V9C11 8.44772 10.5523 8 10 8C9.44772 8 9 8.44771 9 9V10H4C2.89543 10 2 9.10457 2 8C2 6.89543 2.89543 6 4 6H5.17071C5.06015 5.68722 5 5.35064 5 5ZM9 6V5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6H9ZM12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5V6H12Z",
        fill: "#374151"
      },
      {
        d: "M9 11H3V16C3 17.1046 3.89543 18 5 18H9V11Z",
        fill: "#374151"
      },
      {
        d: "M11 18H15C16.1046 18 17 17.1046 17 16V11H11V18Z",
        fill: "#374151"
      }
    ]
  }
};
const globe = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M3.05493 11H5C6.10457 11 7 11.8954 7 13V14C7 15.1046 7.89543 16 9 16C10.1046 16 11 16.8954 11 18V20.9451M8 3.93552V5.5C8 6.88071 9.11929 8 10.5 8H11C12.1046 8 13 8.89543 13 10C13 11.1046 13.8954 12 15 12C16.1046 12 17 11.1046 17 10C17 8.89543 17.8954 8 19 8L20.0645 8M15 20.4879V18C15 16.8954 15.8954 16 17 16H20.0645M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM4.33179 8.02741C4.70542 6.95361 5.37558 6.01864 6.24421 5.32056C6.51209 5.72966 6.97449 5.99991 7.50001 5.99991C8.32844 5.99991 9.00001 6.67148 9.00001 7.49991V7.99991C9.00001 9.10448 9.89545 9.99991 11 9.99991C12.1046 9.99991 13 9.10448 13 7.99991C13 7.05979 13.6487 6.27118 14.5228 6.05719C15.4428 7.11161 16 8.49069 16 9.99992C16 10.3407 15.9716 10.6748 15.917 11.0001H15C13.8954 11.0001 13 11.8955 13 13.0001V15.1973C12.1175 15.7078 11.0928 15.9999 9.99992 15.9999V14C9.99992 12.8954 9.10448 12 7.99992 12C6.89535 12 5.99992 11.1046 5.99992 10C5.99992 9.00849 5.27841 8.1855 4.33179 8.02741Z",
        fill: "#4A5568"
      }
    ]
  }
};
const hand = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M7 11.5V14M7 11.5V5.5C7 4.67157 7.67157 4 8.5 4C9.32843 4 10 4.67157 10 5.5M7 11.5C7 10.6716 6.32843 10 5.5 10C4.67157 10 4 10.6716 4 11.5V13.5C4 17.6421 7.35786 21 11.5 21C15.6421 21 19 17.6421 19 13.5V8.5C19 7.67157 18.3284 7 17.5 7C16.6716 7 16 7.67157 16 8.5M10 5.5V11M10 5.5V4.5C10 3.67157 10.6716 3 11.5 3C12.3284 3 13 3.67157 13 4.5V5.5M13 5.5V11M13 5.5C13 4.67157 13.6716 4 14.5 4C15.3284 4 16 4.67157 16 5.5V8.5M16 8.5V11",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9 3C9 2.44772 9.44772 2 10 2C10.5523 2 11 2.44772 11 3V8V8.5C11 8.77614 11.2239 9 11.5 9C11.7761 9 12 8.77614 12 8.5V8V4C12 3.44772 12.4477 3 13 3C13.5523 3 14 3.44772 14 4V8V8.5C14 8.77614 14.2239 9 14.5 9C14.7761 9 15 8.77614 15 8.5V8V6C15 5.44772 15.4477 5 16 5C16.5523 5 17 5.44772 17 6V11C17 14.866 13.866 18 10 18C6.13401 18 3 14.866 3 11V9C3 8.44772 3.44772 8 4 8C4.55228 8 5 8.44772 5 9V11V11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5V11V10V8V4C6 3.44772 6.44772 3 7 3C7.55228 3 8 3.44772 8 4V8V8.5C8 8.77614 8.22386 9 8.5 9C8.77614 9 9 8.77614 9 8.5V8V3Z",
        fill: "#374151"
      }
    ]
  }
};
const hashtag = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M7 20L11 4M13 20L17 4M6 9H20M4 15H18",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9.24254 3.02985C9.77833 3.1638 10.1041 3.70673 9.97014 4.24253L9.53078 5.99999H12.4692L13.0299 3.75746C13.1638 3.22166 13.7067 2.8959 14.2425 3.02985C14.7783 3.1638 15.1041 3.70673 14.9701 4.24253L14.5308 5.99999H17C17.5523 5.99999 18 6.44771 18 6.99999C18 7.55228 17.5523 7.99999 17 7.99999H14.0308L13.0308 12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H12.5308L11.9701 16.2425C11.8362 16.7783 11.2933 17.1041 10.7575 16.9701C10.2217 16.8362 9.89591 16.2933 10.0299 15.7575L10.4692 14H7.53078L6.97014 16.2425C6.83619 16.7783 6.29326 17.1041 5.75746 16.9701C5.22167 16.8362 4.89591 16.2933 5.02986 15.7575L5.46922 14H3C2.44772 14 2 13.5523 2 13C2 12.4477 2.44772 12 3 12H5.96922L6.96922 7.99999H5C4.44772 7.99999 4 7.55228 4 6.99999C4 6.44771 4.44772 5.99999 5 5.99999H7.46922L8.02986 3.75746C8.16381 3.22166 8.70674 2.8959 9.24254 3.02985ZM9.03078 7.99999L8.03078 12H10.9692L11.9692 7.99999H9.03078Z",
        fill: "#4A5568"
      }
    ]
  }
};
const heart = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M4.31802 6.31802C2.56066 8.07538 2.56066 10.9246 4.31802 12.682L12.0001 20.364L19.682 12.682C21.4393 10.9246 21.4393 8.07538 19.682 6.31802C17.9246 4.56066 15.0754 4.56066 13.318 6.31802L12.0001 7.63609L10.682 6.31802C8.92462 4.56066 6.07538 4.56066 4.31802 6.31802Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3.17157 5.17157C4.73367 3.60948 7.26633 3.60948 8.82843 5.17157L10 6.34315L11.1716 5.17157C12.7337 3.60948 15.2663 3.60948 16.8284 5.17157C18.3905 6.73367 18.3905 9.26633 16.8284 10.8284L10 17.6569L3.17157 10.8284C1.60948 9.26633 1.60948 6.73367 3.17157 5.17157Z",
        fill: "#4A5568"
      }
    ]
  }
};
const home = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M3 12L5 10M5 10L12 3L19 10M5 10V20C5 20.5523 5.44772 21 6 21H9M19 10L21 12M19 10V20C19 20.5523 18.5523 21 18 21H15M9 21C9.55228 21 10 20.5523 10 20V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V20C14 20.5523 14.4477 21 15 21M9 21H15",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M10.7071 2.29289C10.3166 1.90237 9.68342 1.90237 9.29289 2.29289L2.29289 9.29289C1.90237 9.68342 1.90237 10.3166 2.29289 10.7071C2.68342 11.0976 3.31658 11.0976 3.70711 10.7071L4 10.4142V17C4 17.5523 4.44772 18 5 18H7C7.55228 18 8 17.5523 8 17V15C8 14.4477 8.44772 14 9 14H11C11.5523 14 12 14.4477 12 15V17C12 17.5523 12.4477 18 13 18H15C15.5523 18 16 17.5523 16 17V10.4142L16.2929 10.7071C16.6834 11.0976 17.3166 11.0976 17.7071 10.7071C18.0976 10.3166 18.0976 9.68342 17.7071 9.29289L10.7071 2.29289Z",
        fill: "#4A5568"
      }
    ]
  }
};
const identification = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M10 6H5C3.89543 6 3 6.89543 3 8V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V8C21 6.89543 20.1046 6 19 6H14M10 6V5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5V6M10 6C10 7.10457 10.8954 8 12 8C13.1046 8 14 7.10457 14 6M9 14C10.1046 14 11 13.1046 11 12C11 10.8954 10.1046 10 9 10C7.89543 10 7 10.8954 7 12C7 13.1046 7.89543 14 9 14ZM9 14C10.3062 14 11.4174 14.8348 11.8292 16M9 14C7.69378 14 6.58249 14.8348 6.17065 16M15 11H18M15 15H17",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10 2C9.44772 2 9 2.44772 9 3V4C9 4.55228 9.44772 5 10 5C10.5523 5 11 4.55228 11 4V3C11 2.44772 10.5523 2 10 2ZM4 4H7C7 5.65685 8.34315 7 10 7C11.6569 7 13 5.65685 13 4H16C17.1046 4 18 4.89543 18 6V15C18 16.1046 17.1046 17 16 17H4C2.89543 17 2 16.1046 2 15V6C2 4.89543 2.89543 4 4 4ZM6.5 11C7.32843 11 8 10.3284 8 9.5C8 8.67157 7.32843 8 6.5 8C5.67157 8 5 8.67157 5 9.5C5 10.3284 5.67157 11 6.5 11ZM8.95048 15C8.98327 14.8384 9.00049 14.6712 9.00049 14.5C9.00049 13.1193 7.8812 12 6.50049 12C5.11978 12 4.00049 13.1193 4.00049 14.5C4.00049 14.6712 4.0177 14.8384 4.0505 15H8.95048ZM12 9C11.4477 9 11 9.44772 11 10C11 10.5523 11.4477 11 12 11H15C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9H12ZM11 13C11 12.4477 11.4477 12 12 12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14H12C11.4477 14 11 13.5523 11 13Z",
        fill: "#374151"
      }
    ]
  }
};
const inbox = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M20 13V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V13M20 13V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V13M20 13H17.4142C17.149 13 16.8946 13.1054 16.7071 13.2929L14.2929 15.7071C14.1054 15.8946 13.851 16 13.5858 16H10.4142C10.149 16 9.89464 15.8946 9.70711 15.7071L7.29289 13.2929C7.10536 13.1054 6.851 13 6.58579 13H4",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M5 3C3.89543 3 3 3.89543 3 5V15C3 16.1046 3.89543 17 5 17H15C16.1046 17 17 16.1046 17 15V5C17 3.89543 16.1046 3 15 3H5ZM5 5L15 5V12H13L12 14H8L7 12H5V5Z",
        fill: "#4A5568"
      }
    ]
  }
};
const key$2 = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M15 7C16.1046 7 17 7.89543 17 9M21 9C21 12.3137 18.3137 15 15 15C14.3938 15 13.8087 14.9101 13.2571 14.7429L11 17H9V19H7V21H4C3.44772 21 3 20.5523 3 20V17.4142C3 17.149 3.10536 16.8946 3.29289 16.7071L9.25707 10.7429C9.08989 10.1914 9 9.60617 9 9C9 5.68629 11.6863 3 15 3C18.3137 3 21 5.68629 21 9Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M18 8C18 11.3137 15.3137 14 12 14C11.3938 14 10.8087 13.9101 10.2571 13.7429L10 14L9 15L8 16H6V18H2V14L6.25707 9.74293C6.08989 9.19135 6 8.60617 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8ZM12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6C13.1046 6 14 6.89543 14 8C14 8.55228 14.4477 9 15 9C15.5523 9 16 8.55228 16 8C16 5.79086 14.2091 4 12 4Z",
        fill: "#4B5563"
      }
    ]
  }
};
const library = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M8 14V17M12 14V17M16 14V17M3 21H21M3 10H21M3 7L12 3L21 7M4 10H20V21H4V10Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10.4963 2.13176C10.1889 1.95608 9.81146 1.95608 9.50403 2.13176L2.50403 6.13176C2.02451 6.40577 1.85792 7.01662 2.13193 7.49614C2.31631 7.81881 2.65322 7.99979 3 8.00017V15C2.44772 15 2 15.4477 2 16C2 16.5523 2.44772 17 3 17H17C17.5523 17 18 16.5523 18 16C18 15.4477 17.5523 15 17 15V8.00017C17.3469 7.99991 17.684 7.81892 17.8684 7.49614C18.1424 7.01662 17.9758 6.40577 17.4963 6.13176L10.4963 2.13176ZM6 9C5.44772 9 5 9.44772 5 10V13C5 13.5523 5.44772 14 6 14C6.55228 14 7 13.5523 7 13V10C7 9.44772 6.55228 9 6 9ZM9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10V13C11 13.5523 10.5523 14 10 14C9.44772 14 9 13.5523 9 13V10ZM14 9C13.4477 9 13 9.44772 13 10V13C13 13.5523 13.4477 14 14 14C14.5523 14 15 13.5523 15 13V10C15 9.44772 14.5523 9 14 9Z",
        fill: "#4B5563"
      }
    ]
  }
};
const link$1 = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M13.8284 10.1716C12.2663 8.60948 9.73367 8.60948 8.17157 10.1716L4.17157 14.1716C2.60948 15.7337 2.60948 18.2663 4.17157 19.8284C5.73367 21.3905 8.26633 21.3905 9.82843 19.8284L10.93 18.7269M10.1716 13.8284C11.7337 15.3905 14.2663 15.3905 15.8284 13.8284L19.8284 9.82843C21.3905 8.26633 21.3905 5.73367 19.8284 4.17157C18.2663 2.60948 15.7337 2.60948 14.1716 4.17157L13.072 5.27118",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.5858 4.58579C13.3668 3.80474 14.6331 3.80474 15.4142 4.58579C16.1952 5.36683 16.1952 6.63316 15.4142 7.41421L12.4142 10.4142C11.6331 11.1953 10.3668 11.1953 9.58577 10.4142C9.19524 10.0237 8.56208 10.0237 8.17156 10.4142C7.78103 10.8047 7.78103 11.4379 8.17156 11.8284C9.73365 13.3905 12.2663 13.3905 13.8284 11.8284L16.8284 8.82843C18.3905 7.26633 18.3905 4.73367 16.8284 3.17157C15.2663 1.60948 12.7337 1.60948 11.1716 3.17157L9.67156 4.67157C9.28103 5.0621 9.28103 5.69526 9.67156 6.08579C10.0621 6.47631 10.6952 6.47631 11.0858 6.08579L12.5858 4.58579ZM7.58579 9.58579C8.36683 8.80474 9.63316 8.80474 10.4142 9.58579C10.8047 9.97631 11.4379 9.97631 11.8284 9.58579C12.219 9.19526 12.219 8.5621 11.8284 8.17157C10.2663 6.60948 7.73367 6.60948 6.17157 8.17157L3.17157 11.1716C1.60948 12.7337 1.60948 15.2663 3.17157 16.8284C4.73367 18.3905 7.26633 18.3905 8.82843 16.8284L10.3284 15.3284C10.719 14.9379 10.719 14.3047 10.3284 13.9142C9.9379 13.5237 9.30474 13.5237 8.91421 13.9142L7.41421 15.4142C6.63316 16.1953 5.36684 16.1953 4.58579 15.4142C3.80474 14.6332 3.80474 13.3668 4.58579 12.5858L7.58579 9.58579Z",
        fill: "#4A5568"
      }
    ]
  }
};
const login = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M11 16L7 12M7 12L11 8M7 12L21 12M16 16V17C16 18.6569 14.6569 20 13 20H6C4.34315 20 3 18.6569 3 17V7C3 5.34315 4.34315 4 6 4H13C14.6569 4 16 5.34315 16 7V8",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 3C3.55229 3 4 3.44771 4 4L4 16C4 16.5523 3.55228 17 3 17C2.44771 17 2 16.5523 2 16L2 4C2 3.44771 2.44772 3 3 3ZM10.7071 6.29289C11.0976 6.68342 11.0976 7.31658 10.7071 7.70711L9.41421 9L17 9C17.5523 9 18 9.44771 18 10C18 10.5523 17.5523 11 17 11L9.41421 11L10.7071 12.2929C11.0976 12.6834 11.0976 13.3166 10.7071 13.7071C10.3166 14.0976 9.68342 14.0976 9.29289 13.7071L6.29289 10.7071C6.10536 10.5196 6 10.2652 6 10C6 9.73478 6.10536 9.48043 6.29289 9.29289L9.29289 6.29289C9.68342 5.90237 10.3166 5.90237 10.7071 6.29289Z",
        fill: "#374151"
      }
    ]
  }
};
const logout = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M17 16L21 12M21 12L17 8M21 12L7 12M13 16V17C13 18.6569 11.6569 20 10 20H6C4.34315 20 3 18.6569 3 17V7C3 5.34315 4.34315 4 6 4H10C11.6569 4 13 5.34315 13 7V8",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 3C2.44772 3 2 3.44772 2 4V16C2 16.5523 2.44772 17 3 17C3.55228 17 4 16.5523 4 16V4C4 3.44772 3.55228 3 3 3ZM13.2929 12.2929C12.9024 12.6834 12.9024 13.3166 13.2929 13.7071C13.6834 14.0976 14.3166 14.0976 14.7071 13.7071L17.7071 10.7071C17.8946 10.5196 18 10.2652 18 10C18 9.73478 17.8946 9.48043 17.7071 9.29289L14.7071 6.29289C14.3166 5.90237 13.6834 5.90237 13.2929 6.29289C12.9024 6.68342 12.9024 7.31658 13.2929 7.70711L14.5858 9L7 9C6.44771 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H14.5858L13.2929 12.2929Z",
        fill: "#374151"
      }
    ]
  }
};
const mail = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M3 8L10.8906 13.2604C11.5624 13.7083 12.4376 13.7083 13.1094 13.2604L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M2.00333 5.88355L9.99995 9.88186L17.9967 5.8835C17.9363 4.83315 17.0655 4 16 4H4C2.93452 4 2.06363 4.83318 2.00333 5.88355Z",
        fill: "#4A5568"
      },
      {
        d: "M18 8.1179L9.99995 12.1179L2 8.11796V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V8.1179Z",
        fill: "#4A5568"
      }
    ]
  }
};
const map$1 = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M9 20L3.55279 17.2764C3.214 17.107 3 16.7607 3 16.382V5.61803C3 4.87465 3.78231 4.39116 4.44721 4.72361L9 7M9 20L15 17M9 20V7M15 17L19.5528 19.2764C20.2177 19.6088 21 19.1253 21 18.382V7.61803C21 7.23926 20.786 6.893 20.4472 6.72361L15 4M15 17V4M15 4L9 7",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 1.58582L8 5.58582V18.4142L12 14.4142V1.58582Z",
        fill: "#374151"
      },
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3.70711 3.29292C3.42111 3.00692 2.99099 2.92137 2.61732 3.07615C2.24364 3.23093 2 3.59557 2 4.00003V14C2 14.2652 2.10536 14.5196 2.29289 14.7071L6 18.4142V5.58582L3.70711 3.29292Z",
        fill: "#374151"
      },
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M17.7071 5.29292L14 1.58582V14.4142L16.2929 16.7071C16.5789 16.9931 17.009 17.0787 17.3827 16.9239C17.7564 16.7691 18 16.4045 18 16V6.00003C18 5.73481 17.8946 5.48046 17.7071 5.29292Z",
        fill: "#374151"
      }
    ]
  }
};
const menu = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M4 6H20M4 12H20M4 18H20",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 5C3 4.44772 3.44772 4 4 4H16C16.5523 4 17 4.44772 17 5C17 5.55228 16.5523 6 16 6H4C3.44772 6 3 5.55228 3 5Z",
        fill: "#4A5568"
      },
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 10C3 9.44772 3.44772 9 4 9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H4C3.44772 11 3 10.5523 3 10Z",
        fill: "#4A5568"
      },
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 15C3 14.4477 3.44772 14 4 14H16C16.5523 14 17 14.4477 17 15C17 15.5523 16.5523 16 16 16H4C3.44772 16 3 15.5523 3 15Z",
        fill: "#4A5568"
      }
    ]
  }
};
const microphone = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M19 11C19 14.866 15.866 18 12 18M12 18C8.13401 18 5 14.866 5 11M12 18V22M12 22H8M12 22H16M12 14C10.3431 14 9 12.6569 9 11V5C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5V11C15 12.6569 13.6569 14 12 14Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7 4C7 2.34315 8.34315 1 10 1C11.6569 1 13 2.34315 13 4V8C13 9.65685 11.6569 11 10 11C8.34315 11 7 9.65685 7 8V4ZM11 14.9291C14.3923 14.4439 17 11.5265 17 8C17 7.44772 16.5523 7 16 7C15.4477 7 15 7.44772 15 8C15 10.7614 12.7614 13 10 13C7.23858 13 5 10.7614 5 8C5 7.44772 4.55228 7 4 7C3.44772 7 3 7.44772 3 8C3 11.5265 5.60771 14.4439 9 14.9291V17H6C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19H14C14.5523 19 15 18.5523 15 18C15 17.4477 14.5523 17 14 17H11V14.9291Z",
        fill: "#4B5563"
      }
    ]
  }
};
const minus = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M20 12H4",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 10C3 9.44772 3.44772 9 4 9L16 9C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11L4 11C3.44772 11 3 10.5523 3 10Z",
        fill: "#374151"
      }
    ]
  }
};
const moon = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M20.3542 15.3542C19.3176 15.7708 18.1856 16.0001 17 16.0001C12.0294 16.0001 8 11.9706 8 7.00006C8 5.81449 8.22924 4.68246 8.64581 3.64587C5.33648 4.9758 3 8.21507 3 12.0001C3 16.9706 7.02944 21.0001 12 21.0001C15.785 21.0001 19.0243 18.6636 20.3542 15.3542Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M17.2929 13.2929C16.2886 13.7471 15.1738 13.9999 14 13.9999C9.58172 13.9999 6 10.4182 6 5.9999C6 4.82593 6.25287 3.71102 6.70712 2.70667C3.93137 3.96191 2 6.75526 2 9.9997C2 14.418 5.58172 17.9997 10 17.9997C13.2443 17.9997 16.0376 16.0685 17.2929 13.2929Z",
        fill: "#4A5568"
      }
    ]
  }
};
const newspaper = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M19 20H5C3.89543 20 3 19.1046 3 18L3 6C3 4.89543 3.89543 4 5 4L15 4C16.1046 4 17 4.89543 17 6V7M19 20C17.8954 20 17 19.1046 17 18L17 7M19 20C20.1046 20 21 19.1046 21 18V9C21 7.89543 20.1046 7 19 7L17 7M13 4L9 4M7 16H13M7 8H13V12H7V8Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M2 5C2 3.89543 2.89543 3 4 3H12C13.1046 3 14 3.89543 14 5V15C14 16.1046 14.8954 17 16 17H4C2.89543 17 2 16.1046 2 15V5ZM5 6H11V10H5V6ZM11 12H5V14H11V12Z",
        fill: "#4B5563"
      },
      {
        d: "M15 7H16C17.1046 7 18 7.89543 18 9V14.5C18 15.3284 17.3284 16 16.5 16C15.6716 16 15 15.3284 15 14.5V7Z",
        fill: "#4B5563"
      }
    ]
  }
};
const pause = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M10 9V15M14 9V15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8V12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12V8ZM12 7C11.4477 7 11 7.44772 11 8V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V8C13 7.44772 12.5523 7 12 7Z",
        fill: "#4B5563"
      }
    ]
  }
};
const pencil = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M15.2322 5.23223L18.7677 8.76777M16.7322 3.73223C17.7085 2.75592 19.2914 2.75592 20.2677 3.73223C21.244 4.70854 21.244 6.29146 20.2677 7.26777L6.5 21.0355H3V17.4644L16.7322 3.73223Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M13.5858 3.58579C14.3668 2.80474 15.6332 2.80474 16.4142 3.58579C17.1953 4.36683 17.1953 5.63316 16.4142 6.41421L15.6213 7.20711L12.7929 4.37868L13.5858 3.58579Z",
        fill: "#4A5568"
      },
      {
        d: "M11.3787 5.79289L3 14.1716V17H5.82842L14.2071 8.62132L11.3787 5.79289Z",
        fill: "#4A5568"
      }
    ]
  }
};
const phone = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M3 5C3 3.89543 3.89543 3 5 3H8.27924C8.70967 3 9.09181 3.27543 9.22792 3.68377L10.7257 8.17721C10.8831 8.64932 10.6694 9.16531 10.2243 9.38787L7.96701 10.5165C9.06925 12.9612 11.0388 14.9308 13.4835 16.033L14.6121 13.7757C14.8347 13.3306 15.3507 13.1169 15.8228 13.2743L20.3162 14.7721C20.7246 14.9082 21 15.2903 21 15.7208V19C21 20.1046 20.1046 21 19 21H18C9.71573 21 3 14.2843 3 6V5Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M2 3C2 2.44772 2.44772 2 3 2H5.15287C5.64171 2 6.0589 2.35341 6.13927 2.8356L6.87858 7.27147C6.95075 7.70451 6.73206 8.13397 6.3394 8.3303L4.79126 9.10437C5.90756 11.8783 8.12168 14.0924 10.8956 15.2087L11.6697 13.6606C11.866 13.2679 12.2955 13.0492 12.7285 13.1214L17.1644 13.8607C17.6466 13.9411 18 14.3583 18 14.8471V17C18 17.5523 17.5523 18 17 18H15C7.8203 18 2 12.1797 2 5V3Z",
        fill: "#4A5568"
      }
    ]
  }
};
const photograph = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M4 16L8.58579 11.4142C9.36683 10.6332 10.6332 10.6332 11.4142 11.4142L16 16M14 14L15.5858 12.4142C16.3668 11.6332 17.6332 11.6332 18.4142 12.4142L20 14M14 8H14.01M6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4 3C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H16C17.1046 17 18 16.1046 18 15V5C18 3.89543 17.1046 3 16 3H4ZM16 15H4L8 7L11 13L13 9L16 15Z",
        fill: "#4A5568"
      }
    ]
  }
};
const play = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M14.7519 11.1679L11.5547 9.03647C10.8901 8.59343 10 9.06982 10 9.86852V14.1315C10 14.9302 10.8901 15.4066 11.5547 14.9635L14.7519 12.8321C15.3457 12.4362 15.3457 11.5638 14.7519 11.1679Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      },
      {
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM9.5547 7.16795C9.24784 6.96338 8.8533 6.94431 8.52814 7.11833C8.20298 7.29235 8 7.63121 8 8V12C8 12.3688 8.20298 12.7077 8.52814 12.8817C8.8533 13.0557 9.24784 13.0366 9.5547 12.8321L12.5547 10.8321C12.8329 10.6466 13 10.3344 13 10C13 9.66565 12.8329 9.35342 12.5547 9.16795L9.5547 7.16795Z",
        fill: "#4B5563"
      }
    ]
  }
};
const plus = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M12 4V20M20 12L4 12",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10 3C10.5523 3 11 3.44772 11 4V9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H11V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V11H4C3.44772 11 3 10.5523 3 10C3 9.44771 3.44772 9 4 9L9 9V4C9 3.44772 9.44772 3 10 3Z",
        fill: "#111827"
      }
    ]
  }
};
const printer = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M17 17H19C20.1046 17 21 16.1046 21 15V11C21 9.89543 20.1046 9 19 9H5C3.89543 9 3 9.89543 3 11V15C3 16.1046 3.89543 17 5 17H7M9 21H15C16.1046 21 17 20.1046 17 19V15C17 13.8954 16.1046 13 15 13H9C7.89543 13 7 13.8954 7 15V19C7 20.1046 7.89543 21 9 21ZM17 9V5C17 3.89543 16.1046 3 15 3H9C7.89543 3 7 3.89543 7 5V9H17Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M5 4V7H4C2.89543 7 2 7.89543 2 9V12C2 13.1046 2.89543 14 4 14H5V16C5 17.1046 5.89543 18 7 18H13C14.1046 18 15 17.1046 15 16V14H16C17.1046 14 18 13.1046 18 12V9C18 7.89543 17.1046 7 16 7H15V4C15 2.89543 14.1046 2 13 2H7C5.89543 2 5 2.89543 5 4ZM13 4H7V7H13V4ZM13 12H7V16H13V12Z",
        fill: "#4A5568"
      }
    ]
  }
};
const puzzle = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M11 4C11 2.89543 11.8954 2 13 2C14.1046 2 15 2.89543 15 4V5C15 5.55228 15.4477 6 16 6H19C19.5523 6 20 6.44772 20 7V10C20 10.5523 19.5523 11 19 11H18C16.8954 11 16 11.8954 16 13C16 14.1046 16.8954 15 18 15H19C19.5523 15 20 15.4477 20 16V19C20 19.5523 19.5523 20 19 20H16C15.4477 20 15 19.5523 15 19V18C15 16.8954 14.1046 16 13 16C11.8954 16 11 16.8954 11 18V19C11 19.5523 10.5523 20 10 20H7C6.44772 20 6 19.5523 6 19V16C6 15.4477 5.55228 15 5 15H4C2.89543 15 2 14.1046 2 13C2 11.8954 2.89543 11 4 11H5C5.55228 11 6 10.5523 6 10V7C6 6.44772 6.44772 6 7 6H10C10.5523 6 11 5.55228 11 5V4Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M10 3.5C10 2.67157 10.6716 2 11.5 2C12.3284 2 13 2.67157 13 3.5V4C13 4.55228 13.4477 5 14 5H17C17.5523 5 18 5.44772 18 6V9C18 9.55228 17.5523 10 17 10H16.5C15.6716 10 15 10.6716 15 11.5C15 12.3284 15.6716 13 16.5 13H17C17.5523 13 18 13.4477 18 14V17C18 17.5523 17.5523 18 17 18H14C13.4477 18 13 17.5523 13 17V16.5C13 15.6716 12.3284 15 11.5 15C10.6716 15 10 15.6716 10 16.5V17C10 17.5523 9.55228 18 9 18H6C5.44772 18 5 17.5523 5 17V14C5 13.4477 4.55228 13 4 13H3.5C2.67157 13 2 12.3284 2 11.5C2 10.6716 2.67157 10 3.5 10H4C4.55228 10 5 9.55228 5 9V6C5 5.44772 5.44772 5 6 5H9C9.55228 5 10 4.55228 10 4V3.5Z",
        fill: "#374151"
      }
    ]
  }
};
const qrcode = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M12 4V5M18 16H20M14 16H12V20M12 9V12M12 12H12.01M12 12H16.01M16 20H20M4 12H8M20 12H20.01M5 8H7C7.55228 8 8 7.55228 8 7V5C8 4.44772 7.55228 4 7 4H5C4.44772 4 4 4.44772 4 5V7C4 7.55228 4.44772 8 5 8ZM17 8H19C19.5523 8 20 7.55228 20 7V5C20 4.44772 19.5523 4 19 4H17C16.4477 4 16 4.44772 16 5V7C16 7.55228 16.4477 8 17 8ZM5 20H7C7.55228 20 8 19.5523 8 19V17C8 16.4477 7.55228 16 7 16H5C4.44772 16 4 16.4477 4 17V19C4 19.5523 4.44772 20 5 20Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 4C3 3.44772 3.44772 3 4 3H7C7.55228 3 8 3.44772 8 4V7C8 7.55228 7.55228 8 7 8H4C3.44772 8 3 7.55228 3 7V4ZM5 6V5H6V6H5Z",
        fill: "#4A5568"
      },
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 13C3 12.4477 3.44772 12 4 12H7C7.55228 12 8 12.4477 8 13V16C8 16.5523 7.55228 17 7 17H4C3.44772 17 3 16.5523 3 16V13ZM5 15V14H6V15H5Z",
        fill: "#4A5568"
      },
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M13 3C12.4477 3 12 3.44772 12 4V7C12 7.55228 12.4477 8 13 8H16C16.5523 8 17 7.55228 17 7V4C17 3.44772 16.5523 3 16 3H13ZM14 5V6H15V5H14Z",
        fill: "#4A5568"
      },
      {
        d: "M11 4C11 3.44772 10.5523 3 10 3C9.44772 3 9 3.44772 9 4V5C9 5.55228 9.44772 6 10 6C10.5523 6 11 5.55228 11 5V4Z",
        fill: "#4A5568"
      },
      {
        d: "M10 7C10.5523 7 11 7.44772 11 8V9H13C13.5523 9 14 9.44772 14 10C14 10.5523 13.5523 11 13 11H10C9.44772 11 9 10.5523 9 10V8C9 7.44772 9.44772 7 10 7Z",
        fill: "#4A5568"
      },
      {
        d: "M16 9C15.4477 9 15 9.44772 15 10C15 10.5523 15.4477 11 16 11C16.5523 11 17 10.5523 17 10C17 9.44772 16.5523 9 16 9Z",
        fill: "#4A5568"
      },
      {
        d: "M9 13C9 12.4477 9.44772 12 10 12H11C11.5523 12 12 12.4477 12 13C12 13.5523 11.5523 14 11 14V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V13Z",
        fill: "#4A5568"
      },
      {
        d: "M7 11C7.55228 11 8 10.5523 8 10C8 9.44772 7.55228 9 7 9H4C3.44772 9 3 9.44771 3 10C3 10.5523 3.44772 11 4 11H7Z",
        fill: "#4A5568"
      },
      {
        d: "M17 13C17 13.5523 16.5523 14 16 14H14C13.4477 14 13 13.5523 13 13C13 12.4477 13.4477 12 14 12H16C16.5523 12 17 12.4477 17 13Z",
        fill: "#4A5568"
      },
      {
        d: "M16 17C16.5523 17 17 16.5523 17 16C17 15.4477 16.5523 15 16 15H13C12.4477 15 12 15.4477 12 16C12 16.5523 12.4477 17 13 17H16Z",
        fill: "#4A5568"
      }
    ]
  }
};
const refresh = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M4 4V9H4.58152M19.9381 11C19.446 7.05369 16.0796 4 12 4C8.64262 4 5.76829 6.06817 4.58152 9M4.58152 9H9M20 20V15H19.4185M19.4185 15C18.2317 17.9318 15.3574 20 12 20C7.92038 20 4.55399 16.9463 4.06189 13M19.4185 15H15",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4 2C4.55228 2 5 2.44772 5 3V5.10125C6.27009 3.80489 8.04052 3 10 3C13.0494 3 15.641 4.94932 16.6014 7.66675C16.7855 8.18747 16.5126 8.75879 15.9918 8.94284C15.4711 9.12689 14.8998 8.85396 14.7157 8.33325C14.0289 6.38991 12.1755 5 10 5C8.36507 5 6.91204 5.78502 5.99935 7H9C9.55228 7 10 7.44772 10 8C10 8.55228 9.55228 9 9 9H4C3.44772 9 3 8.55228 3 8V3C3 2.44772 3.44772 2 4 2ZM4.00817 11.0572C4.52888 10.8731 5.1002 11.146 5.28425 11.6668C5.97112 13.6101 7.82453 15 10 15C11.6349 15 13.088 14.215 14.0006 13L11 13C10.4477 13 10 12.5523 10 12C10 11.4477 10.4477 11 11 11H16C16.2652 11 16.5196 11.1054 16.7071 11.2929C16.8946 11.4804 17 11.7348 17 12V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V14.8987C13.7299 16.1951 11.9595 17 10 17C6.95059 17 4.35905 15.0507 3.39857 12.3332C3.21452 11.8125 3.48745 11.2412 4.00817 11.0572Z",
        fill: "#4A5568"
      }
    ]
  }
};
const reply = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M3 10H13C17.4183 10 21 13.5817 21 18V20M3 10L9 16M3 10L9 4",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.70711 3.29289C8.09763 3.68342 8.09763 4.31658 7.70711 4.70711L5.41421 7H11C14.866 7 18 10.134 18 14V16C18 16.5523 17.5523 17 17 17C16.4477 17 16 16.5523 16 16V14C16 11.2386 13.7614 9 11 9H5.41421L7.70711 11.2929C8.09763 11.6834 8.09763 12.3166 7.70711 12.7071C7.31658 13.0976 6.68342 13.0976 6.29289 12.7071L2.29289 8.70711C1.90237 8.31658 1.90237 7.68342 2.29289 7.29289L6.29289 3.29289C6.68342 2.90237 7.31658 2.90237 7.70711 3.29289Z",
        fill: "#4A5568"
      }
    ]
  }
};
const rewind = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M12.0665 11.2C11.5332 11.6 11.5332 12.4 12.0665 12.8L17.3998 16.8C18.0591 17.2944 18.9998 16.824 18.9998 16V7.99999C18.9998 7.17594 18.0591 6.70556 17.3998 7.19999L12.0665 11.2Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      },
      {
        d: "M4.0665 11.2C3.53317 11.6 3.53317 12.4 4.0665 12.8L9.39984 16.8C10.0591 17.2944 10.9998 16.824 10.9998 16V7.99998C10.9998 7.17594 10.0591 6.70556 9.39984 7.19998L4.0665 11.2Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M8.4453 14.8321C8.75216 15.0366 9.1467 15.0557 9.47186 14.8817C9.79701 14.7077 10 14.3688 10 14L10 11.2019L15.4453 14.8321C15.7522 15.0366 16.1467 15.0557 16.4719 14.8817C16.797 14.7077 17 14.3688 17 14V6C17 5.63121 16.797 5.29235 16.4719 5.11833C16.1467 4.94431 15.7522 4.96338 15.4453 5.16795L10 8.79815V6C10 5.63121 9.79702 5.29235 9.47186 5.11833C9.1467 4.94431 8.75216 4.96338 8.4453 5.16795L2.4453 9.16795C2.1671 9.35342 2 9.66565 2 10C2 10.3344 2.1671 10.6466 2.4453 10.8321L8.4453 14.8321Z",
        fill: "#374151"
      }
    ]
  }
};
const rss = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M6 5C13.1797 5 19 10.8203 19 18M6 11C9.86599 11 13 14.134 13 18M7 18C7 18.5523 6.55228 19 6 19C5.44772 19 5 18.5523 5 18C5 17.4477 5.44772 17 6 17C6.55228 17 7 17.4477 7 18Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M5 3C4.44772 3 4 3.44772 4 4C4 4.55228 4.44772 5 5 5C10.5228 5 15 9.47715 15 15C15 15.5523 15.4477 16 16 16C16.5523 16 17 15.5523 17 15C17 8.37258 11.6274 3 5 3Z",
        fill: "#374151"
      },
      {
        d: "M4 9C4 8.44772 4.44772 8 5 8C8.86599 8 12 11.134 12 15C12 15.5523 11.5523 16 11 16C10.4477 16 10 15.5523 10 15C10 12.2386 7.76142 10 5 10C4.44772 10 4 9.55228 4 9Z",
        fill: "#374151"
      },
      {
        d: "M3 15C3 13.8954 3.89543 13 5 13C6.10457 13 7 13.8954 7 15C7 16.1046 6.10457 17 5 17C3.89543 17 3 16.1046 3 15Z",
        fill: "#374151"
      }
    ]
  }
};
const save$1 = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M8 7H5C3.89543 7 3 7.89543 3 9V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V9C21 7.89543 20.1046 7 19 7H16M15 11L12 14M12 14L9 11M12 14L12 4",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M7.70711 10.2929C7.31658 9.90237 6.68342 9.90237 6.29289 10.2929C5.90237 10.6834 5.90237 11.3166 6.29289 11.7071L9.29289 14.7071C9.68342 15.0976 10.3166 15.0976 10.7071 14.7071L13.7071 11.7071C14.0976 11.3166 14.0976 10.6834 13.7071 10.2929C13.3166 9.90237 12.6834 9.90237 12.2929 10.2929L11 11.5858L11 6H16C17.1046 6 18 6.89543 18 8V15C18 16.1046 17.1046 17 16 17H4C2.89543 17 2 16.1046 2 15V8C2 6.89543 2.89543 6 4 6H9L9 11.5858L7.70711 10.2929Z",
        fill: "#374151"
      },
      {
        d: "M9 4C9 3.44772 9.44772 3 10 3C10.5523 3 11 3.44772 11 4L11 6H9L9 4Z",
        fill: "#374151"
      }
    ]
  }
};
const scale = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M3 6L6 7M6 7L3 16C4.77253 17.3334 7.22866 17.3334 9.00119 16M6 7L9.00006 16M6 7L12 5M18 7L21 6M18 7L15 16C16.7725 17.3334 19.2287 17.3334 21.0012 16M18 7L21.0001 16M18 7L12 5M12 3V5M12 21V5M12 21H9M12 21H15",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9.99998 2C10.5523 2 11 2.44772 11 3V4.32297L14.9544 5.90474L16.5528 5.10557C17.0467 4.85858 17.6474 5.05881 17.8944 5.55279C18.1414 6.04676 17.9412 6.64744 17.4472 6.89443L16.214 7.51101L17.9522 12.9307C18.0727 13.3065 17.961 13.718 17.6669 13.9812C16.9599 14.614 16.0238 15 15 15C13.9761 15 13.0401 14.614 12.3331 13.9812C12.039 13.718 11.9272 13.3065 12.0477 12.9307L13.7631 7.58227L11 6.47703V16H13C13.5523 16 14 16.4477 14 17C14 17.5523 13.5523 18 13 18H6.99997C6.44769 18 5.99997 17.5523 5.99997 17C5.99997 16.4477 6.44769 16 6.99997 16H8.99997V6.47703L6.23689 7.58227L7.9522 12.9307C8.07272 13.3065 7.96096 13.718 7.66689 13.9812C6.95988 14.614 6.02381 15 4.99997 15C3.97614 15 3.04007 14.614 2.33306 13.9812C2.03899 13.718 1.92723 13.3065 2.04775 12.9307L3.78592 7.51101L2.55276 6.89443C2.05878 6.64744 1.85856 6.04676 2.10555 5.55279C2.35254 5.05881 2.95321 4.85858 3.44719 5.10557L5.04553 5.90474L8.99997 4.32297V3C8.99997 2.44772 9.44769 2 9.99998 2ZM4.99997 10.2745L4.18174 12.8258C4.43132 12.9378 4.708 13 4.99997 13C5.29194 13 5.56863 12.9378 5.81821 12.8258L4.99997 10.2745ZM15 10.2745L14.1817 12.8258C14.4313 12.9378 14.708 13 15 13C15.2919 13 15.5686 12.9378 15.8182 12.8258L15 10.2745Z",
        fill: "#4A5568"
      }
    ]
  }
};
const scissors = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M14.1213 14.1213L19 19M12 12L19 5M12 12L9.12132 14.8787M12 12L9.12132 9.12132M9.12132 14.8787C8.57843 14.3358 7.82843 14 7 14C5.34315 14 4 15.3431 4 17C4 18.6569 5.34315 20 7 20C8.65685 20 10 18.6569 10 17C10 16.1716 9.66421 15.4216 9.12132 14.8787ZM9.12132 9.12132C9.66421 8.57843 10 7.82843 10 7C10 5.34315 8.65685 4 7 4C5.34315 4 4 5.34315 4 7C4 8.65685 5.34315 10 7 10C7.82843 10 8.57843 9.66421 9.12132 9.12132Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M5.5 2C3.567 2 2 3.567 2 5.5C2 7.433 3.567 9 5.5 9C6.10276 9 6.66993 8.84763 7.1651 8.57931L8.58582 10L7.16515 11.4207C6.66997 11.1524 6.10278 11 5.5 11C3.567 11 2 12.567 2 14.5C2 16.433 3.567 18 5.5 18C7.433 18 9 16.433 9 14.5C9 13.8973 8.84764 13.3301 8.57934 12.835L16.7072 4.70711C17.0977 4.31658 17.0977 3.68342 16.7072 3.29289C16.3167 2.90237 15.6835 2.90237 15.293 3.29289L10 8.58582L8.57931 7.1651C8.84763 6.66993 9 6.10276 9 5.5C9 3.567 7.433 2 5.5 2ZM4 5.5C4 4.67157 4.67157 4 5.5 4C6.32843 4 7 4.67157 7 5.5C7 6.32843 6.32843 7 5.5 7C4.67157 7 4 6.32843 4 5.5ZM4 14.5C4 13.6716 4.67157 13 5.5 13C6.32843 13 7 13.6716 7 14.5C7 15.3284 6.32843 16 5.5 16C4.67157 16 4 15.3284 4 14.5Z",
        fill: "#374151"
      },
      {
        d: "M12.8284 11.4142C12.4379 11.0237 11.8047 11.0237 11.4142 11.4142C11.0237 11.8047 11.0237 12.4379 11.4142 12.8284L15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071C17.0976 16.3166 17.0976 15.6834 16.7071 15.2929L12.8284 11.4142Z",
        fill: "#374151"
      }
    ]
  }
};
const search = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4ZM2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 9.29583 13.5892 10.4957 12.8907 11.4765L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L11.4765 12.8907C10.4957 13.5892 9.29583 14 8 14C4.68629 14 2 11.3137 2 8Z",
        fill: "#4A5568"
      }
    ]
  }
};
const selector = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M8 9L12 5L16 9M16 15L12 19L8 15",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10 3C10.2652 3 10.5196 3.10536 10.7071 3.29289L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L10 5.41421L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711C5.90237 7.31658 5.90237 6.68342 6.29289 6.29289L9.29289 3.29289C9.48043 3.10536 9.73478 3 10 3ZM6.29289 12.2929C6.68342 11.9024 7.31658 11.9024 7.70711 12.2929L10 14.5858L12.2929 12.2929C12.6834 11.9024 13.3166 11.9024 13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071L10.7071 16.7071C10.3166 17.0976 9.68342 17.0976 9.29289 16.7071L6.29289 13.7071C5.90237 13.3166 5.90237 12.6834 6.29289 12.2929Z",
        fill: "#4A5568"
      }
    ]
  }
};
const server = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M5 12H19M5 12C3.89543 12 3 11.1046 3 10V6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V10C21 11.1046 20.1046 12 19 12M5 12C3.89543 12 3 12.8954 3 14V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V14C21 12.8954 20.1046 12 19 12M17 8H17.01M17 16H17.01",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M2 5C2 3.89543 2.89543 3 4 3H16C17.1046 3 18 3.89543 18 5V7C18 8.10457 17.1046 9 16 9H4C2.89543 9 2 8.10457 2 7V5ZM16 6C16 6.55228 15.5523 7 15 7C14.4477 7 14 6.55228 14 6C14 5.44772 14.4477 5 15 5C15.5523 5 16 5.44772 16 6Z",
        fill: "#374151"
      },
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M2 13C2 11.8954 2.89543 11 4 11H16C17.1046 11 18 11.8954 18 13V15C18 16.1046 17.1046 17 16 17H4C2.89543 17 2 16.1046 2 15V13ZM16 14C16 14.5523 15.5523 15 15 15C14.4477 15 14 14.5523 14 14C14 13.4477 14.4477 13 15 13C15.5523 13 16 13.4477 16 14Z",
        fill: "#374151"
      }
    ]
  }
};
const share = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M8.68387 13.3419C8.88616 12.9381 9 12.4824 9 12C9 11.5176 8.88616 11.0619 8.68387 10.6581M8.68387 13.3419C8.19134 14.3251 7.17449 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.17449 9 8.19134 9.67492 8.68387 10.6581M8.68387 13.3419L15.3161 16.6581M8.68387 10.6581L15.3161 7.34193M15.3161 7.34193C15.8087 8.32508 16.8255 9 18 9C19.6569 9 21 7.65685 21 6C21 4.34315 19.6569 3 18 3C16.3431 3 15 4.34315 15 6C15 6.48237 15.1138 6.93815 15.3161 7.34193ZM15.3161 16.6581C15.1138 17.0619 15 17.5176 15 18C15 19.6569 16.3431 21 18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15C16.8255 15 15.8087 15.6749 15.3161 16.6581Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M15 8C16.6569 8 18 6.65685 18 5C18 3.34315 16.6569 2 15 2C13.3431 2 12 3.34315 12 5C12 5.12548 12.0077 5.24917 12.0227 5.37061L7.08259 7.84064C6.54303 7.32015 5.8089 7 5 7C3.34315 7 2 8.34315 2 10C2 11.6569 3.34315 13 5 13C5.80892 13 6.54306 12.6798 7.08263 12.1593L12.0227 14.6293C12.0077 14.7508 12 14.8745 12 15C12 16.6569 13.3431 18 15 18C16.6569 18 18 16.6569 18 15C18 13.3431 16.6569 12 15 12C14.1911 12 13.457 12.3201 12.9174 12.8406L7.97733 10.3706C7.9923 10.2492 8 10.1255 8 10C8 9.8745 7.99229 9.7508 7.97733 9.62934L12.9174 7.15932C13.4569 7.67984 14.1911 8 15 8Z",
        fill: "#4A5568"
      }
    ]
  }
};
const sparkles = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M5 3V7M3 5H7M6 17V21M4 19H8M13 3L15.2857 9.85714L21 12L15.2857 14.1429L13 21L10.7143 14.1429L5 12L10.7143 9.85714L13 3Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M5 2C5.55228 2 6 2.44772 6 3V4H7C7.55228 4 8 4.44772 8 5C8 5.55228 7.55228 6 7 6H6V7C6 7.55228 5.55228 8 5 8C4.44772 8 4 7.55228 4 7V6H3C2.44772 6 2 5.55228 2 5C2 4.44772 2.44772 4 3 4H4V3C4 2.44772 4.44772 2 5 2ZM5 12C5.55228 12 6 12.4477 6 13V14H7C7.55228 14 8 14.4477 8 15C8 15.5523 7.55228 16 7 16H6V17C6 17.5523 5.55228 18 5 18C4.44772 18 4 17.5523 4 17V16H3C2.44772 16 2 15.5523 2 15C2 14.4477 2.44772 14 3 14H4V13C4 12.4477 4.44772 12 5 12Z",
        fill: "#4A5568"
      },
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.9999 2C12.4537 2 12.8505 2.30548 12.9667 2.74411L14.1459 7.19893L17.4997 9.13381C17.8092 9.31241 17.9999 9.64262 17.9999 10C17.9999 10.3574 17.8092 10.6876 17.4997 10.8662L14.1459 12.8011L12.9667 17.2559C12.8505 17.6945 12.4537 18 11.9999 18C11.5462 18 11.1493 17.6945 11.0332 17.2559L9.85402 12.8011L6.50027 10.8662C6.19072 10.6876 6 10.3574 6 10C6 9.64262 6.19072 9.31241 6.50027 9.13382L9.85402 7.19893L11.0332 2.74411C11.1493 2.30548 11.5462 2 11.9999 2Z",
        fill: "#4A5568"
      }
    ]
  }
};
const speakerphone = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M11 5.88218V19.2402C11 20.2121 10.2121 21 9.24018 21C8.49646 21 7.83302 20.5325 7.58288 19.8321L5.43647 13.6829M18 13C19.6569 13 21 11.6569 21 10C21 8.34315 19.6569 7 18 7M5.43647 13.6829C4.0043 13.0741 3 11.6543 3 10C3 7.79086 4.79086 6 6.99999 6H8.83208C12.9327 6 16.4569 4.7659 18 3L18 17C16.4569 15.2341 12.9327 14 8.83208 14L6.99998 14C6.44518 14 5.91677 13.887 5.43647 13.6829Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M18 3C18 2.65342 17.8205 2.33156 17.5257 2.14935C17.2309 1.96714 16.8628 1.95058 16.5528 2.10557L8.76393 6H5C3.34315 6 2 7.34315 2 9C2 10.6569 3.34315 12 5 12H5.27925L7.05132 17.3162C7.18744 17.7246 7.56958 18 8.00001 18H9.00001C9.55229 18 10 17.5523 10 17V12.618L16.5528 15.8944C16.8628 16.0494 17.2309 16.0329 17.5257 15.8507C17.8205 15.6684 18 15.3466 18 15V3Z",
        fill: "#4B5563"
      }
    ]
  }
};
const star = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M11.0489 2.92707C11.3483 2.00576 12.6517 2.00576 12.9511 2.92707L14.4697 7.60083C14.6035 8.01285 14.9875 8.29181 15.4207 8.29181H20.335C21.3037 8.29181 21.7065 9.53143 20.9228 10.1008L16.947 12.9894C16.5965 13.244 16.4499 13.6954 16.5838 14.1074L18.1024 18.7812C18.4017 19.7025 17.3472 20.4686 16.5635 19.8992L12.5878 17.0107C12.2373 16.756 11.7627 16.756 11.4122 17.0107L7.43647 19.8992C6.65276 20.4686 5.59828 19.7025 5.89763 18.7812L7.41623 14.1074C7.5501 13.6954 7.40344 13.244 7.05296 12.9894L3.07722 10.1008C2.2935 9.53143 2.69628 8.29181 3.665 8.29181H8.57929C9.01251 8.29181 9.39647 8.01285 9.53034 7.60083L11.0489 2.92707Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M9.04893 2.92707C9.34828 2.00576 10.6517 2.00576 10.951 2.92707L12.0206 6.21886C12.1545 6.63089 12.5384 6.90985 12.9717 6.90985H16.4329C17.4016 6.90985 17.8044 8.14946 17.0207 8.71886L14.2205 10.7533C13.87 11.0079 13.7233 11.4593 13.8572 11.8713L14.9268 15.1631C15.2261 16.0844 14.1717 16.8506 13.3879 16.2812L10.5878 14.2467C10.2373 13.9921 9.76269 13.9921 9.4122 14.2467L6.61203 16.2812C5.82832 16.8506 4.77384 16.0844 5.07319 15.1631L6.14276 11.8713C6.27663 11.4593 6.12997 11.0079 5.77949 10.7533L2.97932 8.71886C2.1956 8.14946 2.59838 6.90985 3.5671 6.90985H7.0283C7.46153 6.90985 7.84548 6.63089 7.97936 6.21886L9.04893 2.92707Z",
        fill: "#4B5563"
      }
    ]
  }
};
const stop = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      },
      {
        d: "M9 10C9 9.44772 9.44772 9 10 9H14C14.5523 9 15 9.44772 15 10V14C15 14.5523 14.5523 15 14 15H10C9.44772 15 9 14.5523 9 14V10Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8 7C7.44772 7 7 7.44772 7 8V12C7 12.5523 7.44772 13 8 13H12C12.5523 13 13 12.5523 13 12V8C13 7.44772 12.5523 7 12 7H8Z",
        fill: "#4B5563"
      }
    ]
  }
};
const sun = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M12 3V4M12 20V21M21 12H20M4 12H3M18.364 18.364L17.6569 17.6569M6.34315 6.34315L5.63604 5.63604M18.364 5.63609L17.6569 6.3432M6.3432 17.6569L5.63609 18.364M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10 2C10.5523 2 11 2.44772 11 3V4C11 4.55228 10.5523 5 10 5C9.44772 5 9 4.55228 9 4V3C9 2.44772 9.44772 2 10 2ZM14 10C14 12.2091 12.2091 14 10 14C7.79086 14 6 12.2091 6 10C6 7.79086 7.79086 6 10 6C12.2091 6 14 7.79086 14 10ZM13.5356 14.9497L14.2427 15.6568C14.6332 16.0473 15.2664 16.0473 15.6569 15.6568C16.0474 15.2663 16.0474 14.6331 15.6569 14.2426L14.9498 13.5355C14.5593 13.145 13.9261 13.145 13.5356 13.5355C13.1451 13.926 13.1451 14.5592 13.5356 14.9497ZM15.6568 4.34309C16.0473 4.73362 16.0473 5.36678 15.6568 5.75731L14.9497 6.46441C14.5592 6.85494 13.926 6.85494 13.5355 6.46441C13.145 6.07389 13.145 5.44072 13.5355 5.0502L14.2426 4.34309C14.6331 3.95257 15.2663 3.95257 15.6568 4.34309ZM17 11C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9H16C15.4477 9 15 9.44772 15 10C15 10.5523 15.4477 11 16 11H17ZM10 15C10.5523 15 11 15.4477 11 16V17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17V16C9 15.4477 9.44772 15 10 15ZM5.05031 6.46443C5.44083 6.85496 6.074 6.85496 6.46452 6.46443C6.85505 6.07391 6.85505 5.44074 6.46452 5.05022L5.75742 4.34311C5.36689 3.95259 4.73373 3.95259 4.3432 4.34311C3.95268 4.73363 3.95268 5.3668 4.3432 5.75732L5.05031 6.46443ZM6.46443 14.9497L5.75732 15.6568C5.3668 16.0473 4.73363 16.0473 4.34311 15.6568C3.95259 15.2663 3.95259 14.6331 4.34311 14.2426L5.05022 13.5355C5.44074 13.145 6.07391 13.145 6.46443 13.5355C6.85496 13.926 6.85496 14.5592 6.46443 14.9497ZM4 11C4.55228 11 5 10.5523 5 10C5 9.44772 4.55228 9 4 9H3C2.44772 9 2 9.44772 2 10C2 10.5523 2.44772 11 3 11H4Z",
        fill: "#4A5568"
      }
    ]
  }
};
const support = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M18.364 5.63604L14.8284 9.17157M14.8284 14.8284L18.364 18.364M9.17157 9.17157L5.63604 5.63604M9.17157 14.8284L5.63604 18.364M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM16 10C16 10.9926 15.7589 11.929 15.3322 12.7537L13.8076 11.2291C13.9325 10.8419 14 10.4288 14 10C14 9.6714 13.9604 9.35205 13.8856 9.04648L15.4484 7.48368C15.8025 8.24895 16 9.1014 16 10ZM10.8345 13.9128L12.4156 15.4939C11.6765 15.8193 10.8594 16 10 16C9.1014 16 8.24895 15.8025 7.48368 15.4484L9.04648 13.8856C9.35205 13.9604 9.6714 14 10 14C10.2862 14 10.5653 13.9699 10.8345 13.9128ZM6.1581 11.1172C6.05517 10.7626 6 10.3878 6 10C6 9.66814 6.04041 9.34571 6.11659 9.03738L6.0378 9.11617L4.50608 7.58444C4.18066 8.32349 4 9.14065 4 10C4 10.9539 4.2226 11.8558 4.61868 12.6566L6.1581 11.1172ZM7.24631 4.66782C8.07101 4.24105 9.00735 4 10 4C10.9539 4 11.8558 4.2226 12.6566 4.61868L11.1172 6.1581C10.7626 6.05517 10.3878 6 10 6C9.57119 6 9.15814 6.06748 8.77088 6.19239L7.24631 4.66782ZM12 10C12 11.1046 11.1046 12 10 12C8.89543 12 8 11.1046 8 10C8 8.89543 8.89543 8 10 8C11.1046 8 12 8.89543 12 10Z",
        fill: "#4B5563"
      }
    ]
  }
};
const table = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M3 10H21M3 14H21M12 10V18M5 18H19C20.1046 18 21 17.1046 21 16V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M5 4C3.34315 4 2 5.34315 2 7V13C2 14.6569 3.34315 16 5 16H15C16.6569 16 18 14.6569 18 13V7C18 5.34315 16.6569 4 15 4H5ZM4 13V12H9V14H5C4.44772 14 4 13.5523 4 13ZM11 14H15C15.5523 14 16 13.5523 16 13V12H11V14ZM11 10H16V8H11V10ZM9 8H4V10H9V8Z",
        fill: "#374151"
      }
    ]
  }
};
const tag = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M7 7H7.01M7 3H12C12.5119 2.99999 13.0237 3.19525 13.4142 3.58579L20.4143 10.5858C21.1953 11.3668 21.1953 12.6332 20.4143 13.4142L13.4142 20.4142C12.6332 21.1953 11.3668 21.1953 10.5858 20.4142L3.58579 13.4142C3.19526 13.0237 3 12.5118 3 12V7C3 4.79086 4.79086 3 7 3Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L10.7071 17.7071C10.3166 18.0976 9.68342 18.0976 9.29289 17.7071L2.29289 10.7071C2.0976 10.5118 1.99997 10.2558 2 9.99988V5C2 3.34315 3.34315 2 5 2H10.0003C10.2561 2.00007 10.5119 2.0977 10.7071 2.29289L17.7071 9.29289ZM5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6Z",
        fill: "#4A5568"
      }
    ]
  }
};
const template$1 = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V7C20 7.55228 19.5523 8 19 8H5C4.44772 8 4 7.55228 4 7V5Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      },
      {
        d: "M4 13C4 12.4477 4.44772 12 5 12H11C11.5523 12 12 12.4477 12 13V19C12 19.5523 11.5523 20 11 20H5C4.44772 20 4 19.5523 4 19V13Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      },
      {
        d: "M16 13C16 12.4477 16.4477 12 17 12H19C19.5523 12 20 12.4477 20 13V19C20 19.5523 19.5523 20 19 20H17C16.4477 20 16 19.5523 16 19V13Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z",
        fill: "#4A5568"
      },
      {
        d: "M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z",
        fill: "#4A5568"
      },
      {
        d: "M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z",
        fill: "#4A5568"
      }
    ]
  }
};
const terminal = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M8 9L11 12L8 15M13 15H16M5 20H19C20.1046 20 21 19.1046 21 18V6C21 4.89543 20.1046 4 19 4H5C3.89543 4 3 4.89543 3 6V18C3 19.1046 3.89543 20 5 20Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M2 5C2 3.89543 2.89543 3 4 3H16C17.1046 3 18 3.89543 18 5V15C18 16.1046 17.1046 17 16 17H4C2.89543 17 2 16.1046 2 15V5ZM5.29289 6.29289C5.68342 5.90237 6.31658 5.90237 6.70711 6.29289L9.70711 9.29289C10.0976 9.68342 10.0976 10.3166 9.70711 10.7071L6.70711 13.7071C6.31658 14.0976 5.68342 14.0976 5.29289 13.7071C4.90237 13.3166 4.90237 12.6834 5.29289 12.2929L7.58579 10L5.29289 7.70711C4.90237 7.31658 4.90237 6.68342 5.29289 6.29289ZM11 12C10.4477 12 10 12.4477 10 13C10 13.5523 10.4477 14 11 14H14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12H11Z",
        fill: "#4B5563"
      }
    ]
  }
};
const ticket = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M15 5V7M15 11V13M15 17V19M5 5C3.89543 5 3 5.89543 3 7V10C4.10457 10 5 10.8954 5 12C5 13.1046 4.10457 14 3 14V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V14C19.8954 14 19 13.1046 19 12C19 10.8954 19.8954 10 21 10V7C21 5.89543 20.1046 5 19 5H5Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M2 6C2 4.89543 2.89543 4 4 4H16C17.1046 4 18 4.89543 18 6V8C16.8954 8 16 8.89543 16 10C16 11.1046 16.8954 12 18 12V14C18 15.1046 17.1046 16 16 16H4C2.89543 16 2 15.1046 2 14V12C3.10457 12 4 11.1046 4 10C4 8.89543 3.10457 8 2 8V6Z",
        fill: "#4A5568"
      }
    ]
  }
};
const translate$1 = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M3 5H15M9 3V5M10.0482 14.5C8.52083 12.9178 7.28073 11.0565 6.41187 9M12.5 18H19.5M11 21L16 11L21 21M12.7511 5C11.7831 10.7702 8.06969 15.6095 3 18.129",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.00001 2C7.55229 2 8.00001 2.44772 8.00001 3V4H8.73223C8.744 3.99979 8.75581 3.99979 8.76765 4H11C11.5523 4 12 4.44772 12 5C12 5.55228 11.5523 6 11 6H9.57801C9.21635 7.68748 8.63076 9.29154 7.85405 10.7796C8.14482 11.1338 8.44964 11.476 8.76767 11.8055C9.15124 12.2028 9.14007 12.8359 8.74272 13.2195C8.34537 13.603 7.7123 13.5919 7.32873 13.1945C7.13962 12.9986 6.95468 12.7987 6.77405 12.5948C5.88895 13.9101 4.84387 15.1084 3.66692 16.1618C3.2554 16.5301 2.6232 16.4951 2.25487 16.0836C1.88655 15.672 1.92157 15.0398 2.3331 14.6715C3.54619 13.5858 4.60214 12.3288 5.4631 10.9389C4.90663 10.1499 4.40868 9.31652 3.97558 8.44503C3.7298 7.95045 3.93148 7.35027 4.42606 7.10449C4.92064 6.8587 5.52083 7.06039 5.76661 7.55497C6.00021 8.02502 6.25495 8.48278 6.52961 8.92699C6.947 7.99272 7.28247 7.01402 7.52698 6H3.00001C2.44772 6 2.00001 5.55228 2.00001 5C2.00001 4.44772 2.44772 4 3.00001 4H6.00001V3C6.00001 2.44772 6.44772 2 7.00001 2ZM13 8C13.3788 8 13.725 8.214 13.8944 8.55279L16.8854 14.5348C16.8919 14.5471 16.8982 14.5596 16.9041 14.5722L17.8944 16.5528C18.1414 17.0468 17.9412 17.6474 17.4472 17.8944C16.9532 18.1414 16.3526 17.9412 16.1056 17.4472L15.382 16H10.618L9.89444 17.4472C9.64745 17.9412 9.04677 18.1414 8.5528 17.8944C8.05882 17.6474 7.85859 17.0468 8.10558 16.5528L9.09589 14.5722C9.10187 14.5596 9.1081 14.5471 9.11458 14.5348L12.1056 8.55279C12.275 8.214 12.6212 8 13 8ZM11.618 14H14.382L13 11.2361L11.618 14Z",
        fill: "#4A5568"
      }
    ]
  }
};
const trash = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M19 7L18.1327 19.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224C6.81296 21 5.94208 20.1891 5.86732 19.1425L5 7M10 11V17M14 11V17M15 7V4C15 3.44772 14.5523 3 14 3H10C9.44772 3 9 3.44772 9 4V7M4 7H20",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9 2C8.62123 2 8.27497 2.214 8.10557 2.55279L7.38197 4H4C3.44772 4 3 4.44772 3 5C3 5.55228 3.44772 6 4 6L4 16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V6C16.5523 6 17 5.55228 17 5C17 4.44772 16.5523 4 16 4H12.618L11.8944 2.55279C11.725 2.214 11.3788 2 11 2H9ZM7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14V8ZM12 7C11.4477 7 11 7.44772 11 8V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V8C13 7.44772 12.5523 7 12 7Z",
        fill: "#4A5568"
      }
    ]
  }
};
const truck = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17C5 15.8954 5.89543 15 7 15C8.10457 15 9 15.8954 9 17Z"
      },
      {
        d: "M19 17C19 18.1046 18.1046 19 17 19C15.8954 19 15 18.1046 15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17Z"
      },
      {
        d: "M13 16V6C13 5.44772 12.5523 5 12 5H4C3.44772 5 3 5.44772 3 6V16C3 16.5523 3.44772 17 4 17H5M13 16C13 16.5523 12.5523 17 12 17H9M13 16L13 8C13 7.44772 13.4477 7 14 7H16.5858C16.851 7 17.1054 7.10536 17.2929 7.29289L20.7071 10.7071C20.8946 10.8946 21 11.149 21 11.4142V16C21 16.5523 20.5523 17 20 17H19M13 16C13 16.5523 13.4477 17 14 17H15M5 17C5 18.1046 5.89543 19 7 19C8.10457 19 9 18.1046 9 17M5 17C5 15.8954 5.89543 15 7 15C8.10457 15 9 15.8954 9 17M15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17M15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M8 16.5C8 17.3284 7.32843 18 6.5 18C5.67157 18 5 17.3284 5 16.5C5 15.6716 5.67157 15 6.5 15C7.32843 15 8 15.6716 8 16.5Z",
        fill: "#374151"
      },
      {
        d: "M15 16.5C15 17.3284 14.3284 18 13.5 18C12.6716 18 12 17.3284 12 16.5C12 15.6716 12.6716 15 13.5 15C14.3284 15 15 15.6716 15 16.5Z",
        fill: "#374151"
      },
      {
        d: "M3 4C2.44772 4 2 4.44772 2 5V15C2 15.5523 2.44772 16 3 16H4.05001C4.28164 14.8589 5.29052 14 6.5 14C7.70948 14 8.71836 14.8589 8.94999 16H10C10.5523 16 11 15.5523 11 15V5C11 4.44772 10.5523 4 10 4H3Z",
        fill: "#374151"
      },
      {
        d: "M14 7C13.4477 7 13 7.44772 13 8V14.05C13.1616 14.0172 13.3288 14 13.5 14C14.7095 14 15.7184 14.8589 15.95 16H17C17.5523 16 18 15.5523 18 15V10C18 9.73478 17.8946 9.48043 17.7071 9.29289L15.7071 7.29289C15.5196 7.10536 15.2652 7 15 7H14Z",
        fill: "#374151"
      }
    ]
  }
};
const upload = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M4 16L4 17C4 18.6569 5.34315 20 7 20L17 20C18.6569 20 20 18.6569 20 17L20 16M16 8L12 4M12 4L8 8M12 4L12 16",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 17C3 16.4477 3.44772 16 4 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H4C3.44772 18 3 17.5523 3 17ZM6.29289 6.70711C5.90237 6.31658 5.90237 5.68342 6.29289 5.29289L9.29289 2.29289C9.48043 2.10536 9.73478 2 10 2C10.2652 2 10.5196 2.10536 10.7071 2.29289L13.7071 5.29289C14.0976 5.68342 14.0976 6.31658 13.7071 6.70711C13.3166 7.09763 12.6834 7.09763 12.2929 6.70711L11 5.41421L11 13C11 13.5523 10.5523 14 10 14C9.44771 14 9 13.5523 9 13L9 5.41421L7.70711 6.70711C7.31658 7.09763 6.68342 7.09763 6.29289 6.70711Z",
        fill: "#4A5568"
      }
    ]
  }
};
const user = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      },
      {
        d: "M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10 9C11.6569 9 13 7.65685 13 6C13 4.34315 11.6569 3 10 3C8.34315 3 7 4.34315 7 6C7 7.65685 8.34315 9 10 9ZM3 18C3 14.134 6.13401 11 10 11C13.866 11 17 14.134 17 18H3Z",
        fill: "#4A5568"
      }
    ]
  }
};
const users = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M12 4.35418C12.7329 3.52375 13.8053 3 15 3C17.2091 3 19 4.79086 19 7C19 9.20914 17.2091 11 15 11C13.8053 11 12.7329 10.4762 12 9.64582M15 21H3V20C3 16.6863 5.68629 14 9 14C12.3137 14 15 16.6863 15 20V21ZM15 21H21V20C21 16.6863 18.3137 14 15 14C13.9071 14 12.8825 14.2922 12 14.8027M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z",
        fill: "#4A5568"
      },
      {
        d: "M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z",
        fill: "#4A5568"
      },
      {
        d: "M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z",
        fill: "#4A5568"
      },
      {
        d: "M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z",
        fill: "#4A5568"
      }
    ]
  }
};
const variable = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M4.87104 4C3.67341 6.40992 3 9.12632 3 12C3 14.8737 3.67341 17.5901 4.87104 20M19.0001 20C20.1977 17.5901 20.8711 14.8737 20.8711 12C20.8711 9.12632 20.1977 6.40992 19.0001 4M9 9H10.2457C10.6922 9 11.0846 9.29598 11.2072 9.72528L12.7928 15.2747C12.9154 15.704 13.3078 16 13.7543 16H15M16 9H15.9199C15.336 9 14.7813 9.25513 14.4014 9.69842L9.59864 15.3016C9.21868 15.7449 8.66398 16 8.08013 16H8",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4.6485 3.08366C5.15459 3.30478 5.3856 3.89429 5.16448 4.40038C4.41582 6.11389 4 8.00707 4 10C4 11.9929 4.41582 13.8861 5.16448 15.5996C5.3856 16.1057 5.15459 16.6952 4.6485 16.9164C4.14242 17.1375 3.5529 16.9065 3.33178 16.4004C2.47486 14.4391 2 12.2737 2 10C2 7.72632 2.47486 5.56091 3.33178 3.59964C3.5529 3.09355 4.14242 2.86254 4.6485 3.08366ZM12.9613 7C12.0499 7 11.188 7.41427 10.6186 8.12592L10.2911 8.53528L10.1799 8.25722C9.87619 7.4979 9.14078 7 8.32297 7H8C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9H8.32297L8.8551 10.3303L7.81962 11.6247C7.62985 11.8619 7.34253 12 7.03875 12H7C6.44772 12 6 12.4477 6 13C6 13.5523 6.44772 14 7 14H7.03875C7.9501 14 8.81204 13.5857 9.38136 12.8741L9.70885 12.4647L9.82008 12.7428C10.1238 13.5021 10.8592 14 11.677 14H12C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12H11.677L11.1449 10.6697L12.1804 9.37531C12.3702 9.13809 12.6575 9 12.9613 9H13C13.5523 9 14 8.55228 14 8C14 7.44772 13.5523 7 13 7H12.9613ZM14.8355 4.40038C14.6144 3.89429 14.8454 3.30478 15.3515 3.08366C15.8576 2.86254 16.4471 3.09355 16.6682 3.59964C17.5251 5.56091 18 7.72632 18 10C18 12.2737 17.5251 14.4391 16.6682 16.4004C16.4471 16.9065 15.8576 17.1375 15.3515 16.9164C14.8454 16.6952 14.6144 16.1057 14.8355 15.5996C15.5842 13.8861 16 11.9929 16 10C16 8.00707 15.5842 6.11389 14.8355 4.40038Z",
        fill: "#374151"
      }
    ]
  }
};
const wifi = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M8.11107 16.4039C10.259 14.256 13.7414 14.256 15.8892 16.4039M12.0002 20H12.0102M4.92913 12.9289C8.83437 9.02371 15.166 9.0237 19.0713 12.9289M1.39355 9.3934C7.25142 3.53553 16.7489 3.53553 22.6068 9.3934",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M17.7781 8.22183C13.4823 3.92606 6.51752 3.92606 2.22176 8.22183C1.83123 8.61235 1.19807 8.61235 0.807542 8.22183C0.417017 7.8313 0.417017 7.19814 0.807542 6.80761C5.88436 1.7308 14.1155 1.7308 19.1923 6.80761C19.5828 7.19814 19.5828 7.8313 19.1923 8.22183C18.8018 8.61235 18.1686 8.61235 17.7781 8.22183ZM14.9497 11.0503C12.216 8.31659 7.78385 8.31659 5.05018 11.0503C4.65966 11.4408 4.02649 11.4408 3.63597 11.0503C3.24544 10.6597 3.24544 10.0266 3.63597 9.63605C7.15069 6.12133 12.8492 6.12133 16.3639 9.63605C16.7544 10.0266 16.7544 10.6597 16.3639 11.0503C15.9734 11.4408 15.3402 11.4408 14.9497 11.0503ZM12.1213 13.8787C10.9497 12.7071 9.05018 12.7071 7.87861 13.8787C7.48809 14.2692 6.85492 14.2692 6.4644 13.8787C6.07387 13.4882 6.07387 12.855 6.4644 12.4645C8.41702 10.5119 11.5828 10.5119 13.5355 12.4645C13.926 12.855 13.926 13.4882 13.5355 13.8787C13.1449 14.2692 12.5118 14.2692 12.1213 13.8787ZM8.99993 16C8.99993 15.4477 9.44765 15 9.99993 15H10.0099C10.5622 15 11.0099 15.4477 11.0099 16C11.0099 16.5523 10.5622 17 10.0099 17H9.99993C9.44765 17 8.99993 16.5523 8.99993 16Z",
        fill: "#374151"
      }
    ]
  }
};
const x = {
  normal: {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        d: "M6 18L18 6M6 6L18 18",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    ]
  },
  small: {
    attrs: {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    paths: [
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: "#4A5568"
      }
    ]
  }
};
var icons$1 = {
  "academic-cap": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M12 14L21 9L12 4L3 9L12 14Z"
        },
        {
          d: "M12 14L18.1591 10.5783C18.7017 11.9466 19 13.4384 19 14.9999C19 15.7013 18.9398 16.3885 18.8244 17.0569C16.2143 17.3106 13.849 18.4006 12 20.0555C10.151 18.4006 7.78571 17.3106 5.17562 17.0569C5.06017 16.3885 5 15.7012 5 14.9999C5 13.4384 5.29824 11.9466 5.84088 10.5782L12 14Z"
        },
        {
          d: "M12 14L21 9L12 4L3 9L12 14ZM12 14L18.1591 10.5783C18.7017 11.9466 19 13.4384 19 14.9999C19 15.7013 18.9398 16.3885 18.8244 17.0569C16.2143 17.3106 13.849 18.4006 12 20.0555C10.151 18.4006 7.78571 17.3106 5.17562 17.0569C5.06017 16.3885 5 15.7012 5 14.9999C5 13.4384 5.29824 11.9466 5.84088 10.5782L12 14ZM8 19.9999V12.5L12 10.2778",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M10.3939 2.08085C10.1424 1.97305 9.85763 1.97305 9.60608 2.08085L2.60608 5.08085C2.2384 5.23843 2 5.59997 2 6C2 6.40003 2.2384 6.76157 2.60608 6.91915L5.25037 8.05241C5.34653 7.94347 5.46706 7.85473 5.60608 7.79515L9.60608 6.08087C10.1137 5.86331 10.7016 6.09846 10.9191 6.60609C11.1367 7.11372 10.9015 7.7016 10.3939 7.91916L7.66668 9.08797L9.60608 9.91915C9.85763 10.027 10.1424 10.027 10.3939 9.91915L17.3939 6.91915C17.7616 6.76157 18 6.40003 18 6C18 5.59997 17.7616 5.23843 17.3939 5.08085L10.3939 2.08085Z",
          fill: "#374151"
        },
        {
          d: "M3.31004 9.39673L5 10.121V14.2226C4.65723 14.1449 4.30705 14.0867 3.95071 14.0494C3.48094 14.0001 3.1097 13.6289 3.06044 13.1591C3.02046 12.7778 3 12.391 3 11.9998C3 11.1033 3.10741 10.2315 3.31004 9.39673Z",
          fill: "#374151"
        },
        {
          d: "M9.29996 16.5725C8.62708 15.9129 7.85167 15.3584 7 14.9351V10.9781L8.81824 11.7574C9.57289 12.0808 10.4271 12.0808 11.1818 11.7574L16.69 9.39673C16.8926 10.2315 17 11.1033 17 11.9998C17 12.391 16.9795 12.7778 16.9396 13.1591C16.8903 13.6289 16.5191 14.0001 16.0493 14.0494C13.9765 14.2667 12.1124 15.188 10.7 16.5725C10.3112 16.9537 9.68881 16.9537 9.29996 16.5725Z",
          fill: "#374151"
        },
        {
          d: "M6 18C6.55228 18 7 17.5523 7 17V14.9351C6.37136 14.6227 5.70117 14.3817 5 14.2226V17C5 17.5523 5.44772 18 6 18Z",
          fill: "#374151"
        }
      ]
    }
  },
  adjustments,
  annotation,
  archive,
  "arrow-circle-down": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M15 13L12 16M12 16L9 13M12 16L12 8M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 7C11 6.44772 10.5523 6 10 6C9.44771 6 9 6.44772 9 7L9 10.5858L7.70711 9.29289C7.31658 8.90237 6.68342 8.90237 6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071L9.29289 13.7071C9.68342 14.0976 10.3166 14.0976 10.7071 13.7071L13.7071 10.7071C14.0976 10.3166 14.0976 9.68342 13.7071 9.29289C13.3166 8.90237 12.6834 8.90237 12.2929 9.29289L11 10.5858V7Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "arrow-circle-left": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M11 15L8 12M8 12L11 9M8 12L16 12M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10.7071 7.70711C11.0976 7.31658 11.0976 6.68342 10.7071 6.29289C10.3166 5.90237 9.68342 5.90237 9.29289 6.29289L6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071L9.29289 13.7071C9.68342 14.0976 10.3166 14.0976 10.7071 13.7071C11.0976 13.3166 11.0976 12.6834 10.7071 12.2929L9.41421 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9L9.41421 9L10.7071 7.70711Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "arrow-circle-right": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M13 9L16 12M16 12L13 15M16 12L8 12M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM13.7071 9.29289L10.7071 6.29289C10.3166 5.90237 9.68342 5.90237 9.29289 6.29289C8.90237 6.68342 8.90237 7.31658 9.29289 7.70711L10.5858 9L7 9C6.44772 9 6 9.44771 6 10C6 10.5523 6.44772 11 7 11H10.5858L9.29289 12.2929C8.90237 12.6834 8.90237 13.3166 9.29289 13.7071C9.68342 14.0976 10.3166 14.0976 10.7071 13.7071L13.7071 10.7071C14.0976 10.3166 14.0976 9.68342 13.7071 9.29289Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "arrow-circle-up": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 11L12 8M12 8L15 11M12 8L12 16M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM13.7071 9.29289L10.7071 6.29289C10.3166 5.90237 9.68342 5.90237 9.29289 6.29289L6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071C6.68342 11.0976 7.31658 11.0976 7.70711 10.7071L9 9.41421L9 13C9 13.5523 9.44771 14 10 14C10.5523 14 11 13.5523 11 13V9.41421L12.2929 10.7071C12.6834 11.0976 13.3166 11.0976 13.7071 10.7071C14.0976 10.3166 14.0976 9.68342 13.7071 9.29289Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "arrow-down": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M19 14L12 21M12 21L5 14M12 21L12 3",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M16.7071 10.2929C17.0976 10.6834 17.0976 11.3166 16.7071 11.7071L10.7071 17.7071C10.3166 18.0976 9.68342 18.0976 9.29289 17.7071L3.29289 11.7071C2.90237 11.3166 2.90237 10.6834 3.29289 10.2929C3.68342 9.90237 4.31658 9.90237 4.70711 10.2929L9 14.5858L9 3C9 2.44772 9.44772 2 10 2C10.5523 2 11 2.44772 11 3L11 14.5858L15.2929 10.2929C15.6834 9.90237 16.3166 9.90237 16.7071 10.2929Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "arrow-left": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M10 19L3 12M3 12L10 5M3 12L21 12",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M9.70711 16.7071C9.31658 17.0976 8.68342 17.0976 8.29289 16.7071L2.29289 10.7071C1.90237 10.3166 1.90237 9.68342 2.29289 9.29289L8.29289 3.29289C8.68342 2.90237 9.31658 2.90237 9.70711 3.29289C10.0976 3.68342 10.0976 4.31658 9.70711 4.70711L5.41421 9H17C17.5523 9 18 9.44772 18 10C18 10.5523 17.5523 11 17 11L5.41421 11L9.70711 15.2929C10.0976 15.6834 10.0976 16.3166 9.70711 16.7071Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "arrow-narrow-down": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M16 17L12 21M12 21L8 17M12 21L12 3",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M14.7071 12.2929C15.0976 12.6834 15.0976 13.3166 14.7071 13.7071L10.7071 17.7071C10.3166 18.0976 9.68342 18.0976 9.29289 17.7071L5.29289 13.7071C4.90237 13.3166 4.90237 12.6834 5.29289 12.2929C5.68342 11.9024 6.31658 11.9024 6.70711 12.2929L9 14.5858L9 3C9 2.44772 9.44772 2 10 2C10.5523 2 11 2.44772 11 3L11 14.5858L13.2929 12.2929C13.6834 11.9024 14.3166 11.9024 14.7071 12.2929Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "arrow-narrow-left": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M7 16L3 12M3 12L7 8M3 12L21 12",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M7.70711 14.7071C7.31658 15.0976 6.68342 15.0976 6.29289 14.7071L2.29289 10.7071C1.90237 10.3166 1.90237 9.68342 2.29289 9.29289L6.29289 5.29289C6.68342 4.90237 7.31658 4.90237 7.70711 5.29289C8.09763 5.68342 8.09763 6.31658 7.70711 6.70711L5.41421 9L17 9C17.5523 9 18 9.44771 18 10C18 10.5523 17.5523 11 17 11L5.41421 11L7.70711 13.2929C8.09763 13.6834 8.09763 14.3166 7.70711 14.7071Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "arrow-narrow-right": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M17 8L21 12M21 12L17 16M21 12L3 12",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M12.2929 5.29289C12.6834 4.90237 13.3166 4.90237 13.7071 5.29289L17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L13.7071 14.7071C13.3166 15.0976 12.6834 15.0976 12.2929 14.7071C11.9024 14.3166 11.9024 13.6834 12.2929 13.2929L14.5858 11H3C2.44772 11 2 10.5523 2 10C2 9.44772 2.44772 9 3 9H14.5858L12.2929 6.70711C11.9024 6.31658 11.9024 5.68342 12.2929 5.29289Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "arrow-narrow-up": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M8 7L12 3M12 3L16 7M12 3V21",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5.29289 7.70711C4.90237 7.31658 4.90237 6.68342 5.29289 6.29289L9.29289 2.29289C9.68342 1.90237 10.3166 1.90237 10.7071 2.29289L14.7071 6.29289C15.0976 6.68342 15.0976 7.31658 14.7071 7.70711C14.3166 8.09763 13.6834 8.09763 13.2929 7.70711L11 5.41421L11 17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17L9 5.41421L6.70711 7.70711C6.31658 8.09763 5.68342 8.09763 5.29289 7.70711Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "arrow-right": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M14 5L21 12M21 12L14 19M21 12L3 12",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10.2929 3.29289C10.6834 2.90237 11.3166 2.90237 11.7071 3.29289L17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L11.7071 16.7071C11.3166 17.0976 10.6834 17.0976 10.2929 16.7071C9.90237 16.3166 9.90237 15.6834 10.2929 15.2929L14.5858 11L3 11C2.44772 11 2 10.5523 2 10C2 9.44772 2.44772 9 3 9H14.5858L10.2929 4.70711C9.90237 4.31658 9.90237 3.68342 10.2929 3.29289Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "arrow-sm-down": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M17 13L12 18M12 18L7 13M12 18L12 6",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M14.7071 10.2929C15.0976 10.6834 15.0976 11.3166 14.7071 11.7071L10.7071 15.7071C10.3166 16.0976 9.68342 16.0976 9.29289 15.7071L5.29289 11.7071C4.90237 11.3166 4.90237 10.6834 5.29289 10.2929C5.68342 9.90237 6.31658 9.90237 6.70711 10.2929L9 12.5858V5C9 4.44772 9.44772 4 10 4C10.5523 4 11 4.44772 11 5L11 12.5858L13.2929 10.2929C13.6834 9.90237 14.3166 9.90237 14.7071 10.2929Z",
          fill: "#111827"
        }
      ]
    }
  },
  "arrow-sm-left": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M11 17L6 12M6 12L11 7M6 12L18 12",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M9.70711 14.7071C9.31658 15.0976 8.68342 15.0976 8.29289 14.7071L4.29289 10.7071C3.90237 10.3166 3.90237 9.68342 4.29289 9.29289L8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289C10.0976 5.68342 10.0976 6.31658 9.70711 6.70711L7.41421 9L15 9C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11H7.41421L9.70711 13.2929C10.0976 13.6834 10.0976 14.3166 9.70711 14.7071Z",
          fill: "#111827"
        }
      ]
    }
  },
  "arrow-sm-right": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M13 7L18 12M18 12L13 17M18 12L6 12",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10.2929 5.29289C10.6834 4.90237 11.3166 4.90237 11.7071 5.29289L15.7071 9.29289C16.0976 9.68342 16.0976 10.3166 15.7071 10.7071L11.7071 14.7071C11.3166 15.0976 10.6834 15.0976 10.2929 14.7071C9.90237 14.3166 9.90237 13.6834 10.2929 13.2929L12.5858 11L5 11C4.44772 11 4 10.5523 4 10C4 9.44772 4.44772 9 5 9H12.5858L10.2929 6.70711C9.90237 6.31658 9.90237 5.68342 10.2929 5.29289Z",
          fill: "#111827"
        }
      ]
    }
  },
  "arrow-sm-up": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M7 11L12 6M12 6L17 11M12 6V18",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289L9.29289 4.29289C9.68342 3.90237 10.3166 3.90237 10.7071 4.29289L14.7071 8.29289C15.0976 8.68342 15.0976 9.31658 14.7071 9.70711C14.3166 10.0976 13.6834 10.0976 13.2929 9.70711L11 7.41421L11 15C11 15.5523 10.5523 16 10 16C9.44772 16 9 15.5523 9 15L9 7.41421L6.70711 9.70711C6.31658 10.0976 5.68342 10.0976 5.29289 9.70711Z",
          fill: "#111827"
        }
      ]
    }
  },
  "arrow-up": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M5 10L12 3M12 3L19 10M12 3V21",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3.29289 9.70711C2.90237 9.31658 2.90237 8.68342 3.29289 8.29289L9.29289 2.29289C9.68342 1.90237 10.3166 1.90237 10.7071 2.29289L16.7071 8.29289C17.0976 8.68342 17.0976 9.31658 16.7071 9.70711C16.3166 10.0976 15.6834 10.0976 15.2929 9.70711L11 5.41421L11 17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17L9 5.41421L4.70711 9.70711C4.31658 10.0976 3.68342 10.0976 3.29289 9.70711Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "arrows-expand": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M4 8V4M4 4H8M4 4L9 9M20 8V4M20 4H16M20 4L15 9M4 16V20M4 20H8M4 20L9 15M20 20L15 15M20 20V16M20 20H16",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3 4C3 3.44772 3.44772 3 4 3H8C8.55228 3 9 3.44772 9 4C9 4.55228 8.55228 5 8 5H6.41421L8.70711 7.29289C9.09763 7.68342 9.09763 8.31658 8.70711 8.70711C8.31658 9.09763 7.68342 9.09763 7.29289 8.70711L5 6.41421V8C5 8.55228 4.55228 9 4 9C3.44772 9 3 8.55228 3 8V4ZM12 5C11.4477 5 11 4.55228 11 4C11 3.44772 11.4477 3 12 3H16C16.5523 3 17 3.44772 17 4V8C17 8.55228 16.5523 9 16 9C15.4477 9 15 8.55228 15 8V6.41421L12.7071 8.70711C12.3166 9.09763 11.6834 9.09763 11.2929 8.70711C10.9024 8.31658 10.9024 7.68342 11.2929 7.29289L13.5858 5H12ZM3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12V13.5858L7.29289 11.2929C7.68342 10.9024 8.31658 10.9024 8.70711 11.2929C9.09763 11.6834 9.09763 12.3166 8.70711 12.7071L6.41421 15H8C8.55228 15 9 15.4477 9 16C9 16.5523 8.55228 17 8 17H4C3.44772 17 3 16.5523 3 16V12ZM16 11C16.5523 11 17 11.4477 17 12V16C17 16.5523 16.5523 17 16 17H12C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15H13.5858L11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929L15 13.5858V12C15 11.4477 15.4477 11 16 11Z",
          fill: "#111827"
        }
      ]
    }
  },
  "at-symbol": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12ZM16 12V13.5C16 14.8807 17.1193 16 18.5 16C19.8807 16 21 14.8807 21 13.5V12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21M16.5 19.7942C15.0801 20.614 13.5296 21.0029 12 21.0015",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M14.2426 5.75736C11.8995 3.41421 8.10051 3.41421 5.75736 5.75736C3.41421 8.10051 3.41421 11.8995 5.75736 14.2426C7.79395 16.2792 10.9325 16.5464 13.257 15.0408C13.7205 14.7405 14.3397 14.8729 14.6399 15.3364C14.9402 15.8 14.8078 16.4191 14.3443 16.7194C11.2445 18.7273 7.0606 18.3743 4.34315 15.6569C1.21895 12.5327 1.21895 7.46734 4.34315 4.34315C7.46734 1.21895 12.5327 1.21895 15.6569 4.34315C17.2187 5.90503 18 7.9542 18 10C18 11.6569 16.6569 13 15 13C14.3247 13 13.7015 12.7769 13.2001 12.4003C12.4703 13.3717 11.3085 14 10 14C7.79086 14 6 12.2091 6 10C6 7.79086 7.79086 6 10 6C12.2091 6 14 7.79086 14 10C14 10.5523 14.4477 11 15 11C15.5523 11 16 10.5523 16 10C16 8.46294 15.4144 6.9291 14.2426 5.75736ZM12 10C12 8.89543 11.1046 8 10 8C8.89543 8 8 8.89543 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  backspace: backspace$1,
  "badge-check": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9.00012 12L11.0001 14L15.0001 10M7.83486 4.69705C8.55239 4.63979 9.23358 4.35763 9.78144 3.89075C11.0599 2.80123 12.9403 2.80123 14.2188 3.89075C14.7667 4.35763 15.4478 4.63979 16.1654 4.69705C17.8398 4.83067 19.1695 6.16031 19.3031 7.83474C19.3603 8.55227 19.6425 9.23346 20.1094 9.78132C21.1989 11.0598 21.1989 12.9402 20.1094 14.2187C19.6425 14.7665 19.3603 15.4477 19.3031 16.1653C19.1695 17.8397 17.8398 19.1693 16.1654 19.303C15.4479 19.3602 14.7667 19.6424 14.2188 20.1093C12.9403 21.1988 11.0599 21.1988 9.78144 20.1093C9.23358 19.6424 8.55239 19.3602 7.83486 19.303C6.16043 19.1693 4.83079 17.8397 4.69717 16.1653C4.63991 15.4477 4.35775 14.7665 3.89087 14.2187C2.80135 12.9402 2.80135 11.0598 3.89087 9.78132C4.35775 9.23346 4.63991 8.55227 4.69717 7.83474C4.83079 6.16031 6.16043 4.83067 7.83486 4.69705Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M6.26701 3.45496C6.91008 3.40364 7.52057 3.15077 8.01158 2.73234C9.15738 1.75589 10.8426 1.75589 11.9884 2.73234C12.4794 3.15077 13.0899 3.40364 13.733 3.45496C15.2336 3.57471 16.4253 4.76636 16.545 6.26701C16.5964 6.91008 16.8492 7.52057 17.2677 8.01158C18.2441 9.15738 18.2441 10.8426 17.2677 11.9884C16.8492 12.4794 16.5964 13.0899 16.545 13.733C16.4253 15.2336 15.2336 16.4253 13.733 16.545C13.0899 16.5964 12.4794 16.8492 11.9884 17.2677C10.8426 18.2441 9.15738 18.2441 8.01158 17.2677C7.52057 16.8492 6.91008 16.5964 6.26701 16.545C4.76636 16.4253 3.57471 15.2336 3.45496 13.733C3.40364 13.0899 3.15077 12.4794 2.73234 11.9884C1.75589 10.8426 1.75589 9.15738 2.73234 8.01158C3.15077 7.52057 3.40364 6.91008 3.45496 6.26701C3.57471 4.76636 4.76636 3.57471 6.26701 3.45496ZM13.7071 8.70711C14.0976 8.31658 14.0976 7.68342 13.7071 7.29289C13.3166 6.90237 12.6834 6.90237 12.2929 7.29289L9 10.5858L7.70711 9.29289C7.31658 8.90237 6.68342 8.90237 6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071L8.29289 12.7071C8.68342 13.0976 9.31658 13.0976 9.70711 12.7071L13.7071 8.70711Z",
          fill: "#4B5563"
        }
      ]
    }
  },
  ban,
  beaker,
  bell,
  "book-open": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M12 6.25278V19.2528M12 6.25278C10.8321 5.47686 9.24649 5 7.5 5C5.75351 5 4.16789 5.47686 3 6.25278V19.2528C4.16789 18.4769 5.75351 18 7.5 18C9.24649 18 10.8321 18.4769 12 19.2528M12 6.25278C13.1679 5.47686 14.7535 5 16.5 5C18.2465 5 19.8321 5.47686 21 6.25278V19.2528C19.8321 18.4769 18.2465 18 16.5 18C14.7535 18 13.1679 18.4769 12 19.2528",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 4.80423C7.9428 4.28906 6.75516 4 5.5 4C4.24484 4 3.0572 4.28906 2 4.80423V14.8042C3.0572 14.2891 4.24484 14 5.5 14C7.1686 14 8.71789 14.5108 10 15.3847C11.2821 14.5108 12.8314 14 14.5 14C15.7552 14 16.9428 14.2891 18 14.8042V4.80423C16.9428 4.28906 15.7552 4 14.5 4C13.2448 4 12.0572 4.28906 11 4.80423V12C11 12.5523 10.5523 13 10 13C9.44772 13 9 12.5523 9 12V4.80423Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "bookmark-alt": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M16 4V16L12 14L8 16V4M6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3 5C3 3.89543 3.89543 3 5 3H15C16.1046 3 17 3.89543 17 5V15C17 16.1046 16.1046 17 15 17H5C3.89543 17 3 16.1046 3 15V5ZM14 6H6V14L10 12L14 14V6Z",
          fill: "#4B5563"
        }
      ]
    }
  },
  bookmark,
  briefcase,
  cake,
  calculator,
  calendar: calendar$2,
  camera,
  cash,
  "chart-bar": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 19V13C9 11.8954 8.10457 11 7 11H5C3.89543 11 3 11.8954 3 13V19C3 20.1046 3.89543 21 5 21H7C8.10457 21 9 20.1046 9 19ZM9 19V9C9 7.89543 9.89543 7 11 7H13C14.1046 7 15 7.89543 15 9V19M9 19C9 20.1046 9.89543 21 11 21H13C14.1046 21 15 20.1046 15 19M15 19V5C15 3.89543 15.8954 3 17 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H17C15.8954 21 15 20.1046 15 19Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M2 11C2 10.4477 2.44772 10 3 10H5C5.55228 10 6 10.4477 6 11V16C6 16.5523 5.55228 17 5 17H3C2.44772 17 2 16.5523 2 16V11Z",
          fill: "#4B5563"
        },
        {
          d: "M8 7C8 6.44772 8.44772 6 9 6H11C11.5523 6 12 6.44772 12 7V16C12 16.5523 11.5523 17 11 17H9C8.44772 17 8 16.5523 8 16V7Z",
          fill: "#4B5563"
        },
        {
          d: "M14 4C14 3.44772 14.4477 3 15 3H17C17.5523 3 18 3.44772 18 4V16C18 16.5523 17.5523 17 17 17H15C14.4477 17 14 16.5523 14 16V4Z",
          fill: "#4B5563"
        }
      ]
    }
  },
  "chart-pie": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M11 3.05493C6.50005 3.55238 3 7.36745 3 12C3 16.9706 7.02944 21 12 21C16.6326 21 20.4476 17.5 20.9451 13H11V3.05493Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        },
        {
          d: "M20.4878 9H15V3.5123C17.5572 4.41613 19.5839 6.44285 20.4878 9Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M2 10C2 5.58172 5.58172 2 10 2V10H18C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10Z",
          fill: "#4A5568"
        },
        {
          d: "M12 2.25195C14.8113 2.97552 17.0245 5.18877 17.748 8.00004H12V2.25195Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "chart-square-bar": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M16 8V16M12 11V16M8 14V16M6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5 3C3.89543 3 3 3.89543 3 5V15C3 16.1046 3.89543 17 5 17H15C16.1046 17 17 16.1046 17 15V5C17 3.89543 16.1046 3 15 3H5ZM14 7C14 6.44772 13.5523 6 13 6C12.4477 6 12 6.44772 12 7V13C12 13.5523 12.4477 14 13 14C13.5523 14 14 13.5523 14 13V7ZM11 9C11 8.44772 10.5523 8 10 8C9.44772 8 9 8.44772 9 9V13C9 13.5523 9.44772 14 10 14C10.5523 14 11 13.5523 11 13V9ZM8 12C8 11.4477 7.55228 11 7 11C6.44772 11 6 11.4477 6 12V13C6 13.5523 6.44772 14 7 14C7.55228 14 8 13.5523 8 13V12Z",
          fill: "#4B5563"
        }
      ]
    }
  },
  "chat-alt-2": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M17 8H19C20.1046 8 21 8.89543 21 10V16C21 17.1046 20.1046 18 19 18H17V22L13 18H9C8.44772 18 7.94772 17.7761 7.58579 17.4142M7.58579 17.4142L11 14H15C16.1046 14 17 13.1046 17 12V6C17 4.89543 16.1046 4 15 4H5C3.89543 4 3 4.89543 3 6V12C3 13.1046 3.89543 14 5 14H7V18L7.58579 17.4142Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M2 5C2 3.89543 2.89543 3 4 3H11C12.1046 3 13 3.89543 13 5V9C13 10.1046 12.1046 11 11 11H9L6 14V11H4C2.89543 11 2 10.1046 2 9V5Z",
          fill: "#4B5563"
        },
        {
          d: "M15 7V9C15 11.2091 13.2091 13 11 13H9.82843L8.06173 14.7667C8.34154 14.9156 8.66091 15 9 15H11L14 18V15H16C17.1046 15 18 14.1046 18 13V9C18 7.89543 17.1046 7 16 7H15Z",
          fill: "#4B5563"
        }
      ]
    }
  },
  "chat-alt": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M8 10H8.01M12 10H12.01M16 10H16.01M9 16H5C3.89543 16 3 15.1046 3 14V6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V14C21 15.1046 20.1046 16 19 16H14L9 21V16Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M18 5V13C18 14.1046 17.1046 15 16 15H11L6 19V15H4C2.89543 15 2 14.1046 2 13V5C2 3.89543 2.89543 3 4 3H16C17.1046 3 18 3.89543 18 5ZM7 8H5V10H7V8ZM9 8H11V10H9V8ZM15 8H13V10H15V8Z",
          fill: "#4B5563"
        }
      ]
    }
  },
  chat,
  "check-circle": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM13.7071 8.70711C14.0976 8.31658 14.0976 7.68342 13.7071 7.29289C13.3166 6.90237 12.6834 6.90237 12.2929 7.29289L9 10.5858L7.70711 9.29289C7.31658 8.90237 6.68342 8.90237 6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071L8.29289 12.7071C8.68342 13.0976 9.31658 13.0976 9.70711 12.7071L13.7071 8.70711Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  check,
  "chevron-double-down": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M19 13L12 20L5 13M19 5L12 12L5 5",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L10.7071 10.7071C10.3166 11.0976 9.68342 11.0976 9.29289 10.7071L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289ZM15.7071 10.2929C16.0976 10.6834 16.0976 11.3166 15.7071 11.7071L10.7071 16.7071C10.3166 17.0976 9.68342 17.0976 9.29289 16.7071L4.29289 11.7071C3.90237 11.3166 3.90237 10.6834 4.29289 10.2929C4.68342 9.90237 5.31658 9.90237 5.70711 10.2929L10 14.5858L14.2929 10.2929C14.6834 9.90237 15.3166 9.90237 15.7071 10.2929Z",
          fill: "#374151"
        }
      ]
    }
  },
  "chevron-double-left": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M11 19L4 12L11 5M19 19L12 12L19 5",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L9.29289 10.7071C8.90237 10.3166 8.90237 9.68342 9.29289 9.29289L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071ZM9.70711 15.7071C9.31658 16.0976 8.68342 16.0976 8.29289 15.7071L3.29289 10.7071C2.90237 10.3166 2.90237 9.68342 3.29289 9.29289L8.29289 4.29289C8.68342 3.90237 9.31658 3.90237 9.70711 4.29289C10.0976 4.68342 10.0976 5.31658 9.70711 5.70711L5.41421 10L9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071Z",
          fill: "#374151"
        }
      ]
    }
  },
  "chevron-double-right": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M13 5L20 12L13 19M5 5L12 12L5 19",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10.2929 15.7071C9.90237 15.3166 9.90237 14.6834 10.2929 14.2929L14.5858 10L10.2929 5.70711C9.90237 5.31658 9.90237 4.68342 10.2929 4.29289C10.6834 3.90237 11.3166 3.90237 11.7071 4.29289L16.7071 9.29289C17.0976 9.68342 17.0976 10.3166 16.7071 10.7071L11.7071 15.7071C11.3166 16.0976 10.6834 16.0976 10.2929 15.7071Z",
          fill: "#374151"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10.7071 9.29289C11.0976 9.68342 11.0976 10.3166 10.7071 10.7071L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071Z",
          fill: "#374151"
        }
      ]
    }
  },
  "chevron-double-up": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M5 11L12 4L19 11M5 19L12 12L19 19",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L9.29289 9.29289C9.68342 8.90237 10.3166 8.90237 10.7071 9.29289L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071ZM4.29289 9.70711C3.90237 9.31658 3.90237 8.68342 4.29289 8.29289L9.29289 3.29289C9.68342 2.90237 10.3166 2.90237 10.7071 3.29289L15.7071 8.29289C16.0976 8.68342 16.0976 9.31658 15.7071 9.70711C15.3166 10.0976 14.6834 10.0976 14.2929 9.70711L10 5.41421L5.70711 9.70711C5.31658 10.0976 4.68342 10.0976 4.29289 9.70711Z",
          fill: "#374151"
        }
      ]
    }
  },
  "chevron-down": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M19 9L12 16L5 9",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5.29289 7.29289C5.68342 6.90237 6.31658 6.90237 6.70711 7.29289L10 10.5858L13.2929 7.29289C13.6834 6.90237 14.3166 6.90237 14.7071 7.29289C15.0976 7.68342 15.0976 8.31658 14.7071 8.70711L10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071L5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "chevron-left": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M15 19L8 12L15 5",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M12.7071 5.29289C13.0976 5.68342 13.0976 6.31658 12.7071 6.70711L9.41421 10L12.7071 13.2929C13.0976 13.6834 13.0976 14.3166 12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L7.29289 10.7071C6.90237 10.3166 6.90237 9.68342 7.29289 9.29289L11.2929 5.29289C11.6834 4.90237 12.3166 4.90237 12.7071 5.29289Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "chevron-right": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 5L16 12L9 19",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M7.29289 14.7071C6.90237 14.3166 6.90237 13.6834 7.29289 13.2929L10.5858 10L7.29289 6.70711C6.90237 6.31658 6.90237 5.68342 7.29289 5.29289C7.68342 4.90237 8.31658 4.90237 8.70711 5.29289L12.7071 9.29289C13.0976 9.68342 13.0976 10.3166 12.7071 10.7071L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "chevron-up": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M5 15L12 8L19 15",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M14.7071 12.7071C14.3166 13.0976 13.6834 13.0976 13.2929 12.7071L10 9.41421L6.70711 12.7071C6.31658 13.0976 5.68342 13.0976 5.29289 12.7071C4.90237 12.3166 4.90237 11.6834 5.29289 11.2929L9.29289 7.29289C9.68342 6.90237 10.3166 6.90237 10.7071 7.29289L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  chip,
  "clipboard-check": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15M9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5M9 14L11 16L15 12",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4H11C11.5523 4 12 3.55228 12 3C12 2.44772 11.5523 2 11 2H9Z",
          fill: "#4A5568"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M4 5C4 3.89543 4.89543 3 6 3C6 4.65685 7.34315 6 9 6H11C12.6569 6 14 4.65685 14 3C15.1046 3 16 3.89543 16 5V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V5ZM13.7071 10.7071C14.0976 10.3166 14.0976 9.68342 13.7071 9.29289C13.3166 8.90237 12.6834 8.90237 12.2929 9.29289L9 12.5858L7.70711 11.2929C7.31658 10.9024 6.68342 10.9024 6.29289 11.2929C5.90237 11.6834 5.90237 12.3166 6.29289 12.7071L8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071L13.7071 10.7071Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "clipboard-copy": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M8 5H6C4.89543 5 4 5.89543 4 7V19C4 20.1046 4.89543 21 6 21H16C17.1046 21 18 20.1046 18 19V18M8 5C8 6.10457 8.89543 7 10 7H12C13.1046 7 14 6.10457 14 5M8 5C8 3.89543 8.89543 3 10 3H12C13.1046 3 14 3.89543 14 5M14 5H16C17.1046 5 18 5.89543 18 7V10M20 14H10M10 14L13 11M10 14L13 17",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M8 2C7.44772 2 7 2.44772 7 3C7 3.55228 7.44772 4 8 4H10C10.5523 4 11 3.55228 11 3C11 2.44772 10.5523 2 10 2H8Z",
          fill: "#4A5568"
        },
        {
          d: "M3 5C3 3.89543 3.89543 3 5 3C5 4.65685 6.34315 6 8 6H10C11.6569 6 13 4.65685 13 3C14.1046 3 15 3.89543 15 5V11H10.4142L11.7071 9.70711C12.0976 9.31658 12.0976 8.68342 11.7071 8.29289C11.3166 7.90237 10.6834 7.90237 10.2929 8.29289L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071L10.2929 15.7071C10.6834 16.0976 11.3166 16.0976 11.7071 15.7071C12.0976 15.3166 12.0976 14.6834 11.7071 14.2929L10.4142 13H15V16C15 17.1046 14.1046 18 13 18H5C3.89543 18 3 17.1046 3 16V5Z",
          fill: "#4A5568"
        },
        {
          d: "M15 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H15V11Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "clipboard-list": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15M9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5M12 12H15M12 16H15M9 12H9.01M9 16H9.01",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4H11C11.5523 4 12 3.55228 12 3C12 2.44772 11.5523 2 11 2H9Z",
          fill: "#4A5568"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M4 5C4 3.89543 4.89543 3 6 3C6 4.65685 7.34315 6 9 6H11C12.6569 6 14 4.65685 14 3C15.1046 3 16 3.89543 16 5V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V5ZM7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H7.01C7.56228 11 8.01 10.5523 8.01 10C8.01 9.44772 7.56228 9 7.01 9H7ZM10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H10ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H7.01C7.56228 15 8.01 14.5523 8.01 14C8.01 13.4477 7.56228 13 7.01 13H7ZM10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H10Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  clipboard,
  clock,
  "cloud-download": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M7 16C4.79086 16 3 14.2091 3 12C3 10.0929 4.33457 8.4976 6.12071 8.09695C6.04169 7.74395 6 7.37684 6 7C6 4.23858 8.23858 2 11 2C13.4193 2 15.4373 3.71825 15.9002 6.00098C15.9334 6.00033 15.9666 6 16 6C18.7614 6 21 8.23858 21 11C21 13.419 19.2822 15.4367 17 15.9M9 19L12 22M12 22L15 19M12 22V10",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M2 9.5C2 11.433 3.567 13 5.5 13H9V15.5858L7.70711 14.2929C7.31658 13.9024 6.68342 13.9024 6.29289 14.2929C5.90237 14.6834 5.90237 15.3166 6.29289 15.7071L9.29289 18.7071C9.68342 19.0976 10.3166 19.0976 10.7071 18.7071L13.7071 15.7071C14.0976 15.3166 14.0976 14.6834 13.7071 14.2929C13.3166 13.9024 12.6834 13.9024 12.2929 14.2929L11 15.5858V13H13.5C15.9853 13 18 10.9853 18 8.5C18 6.01472 15.9853 4 13.5 4C13.2912 4 13.0857 4.01422 12.8845 4.04175C12.4551 2.29538 10.8788 1 9 1C6.79086 1 5 2.79086 5 5C5 5.35223 5.04553 5.69382 5.13102 6.01922C3.37146 6.20358 2 7.69163 2 9.5ZM11 13H9V8C9 7.44772 9.44772 7 10 7C10.5523 7 11 7.44772 11 8V13Z",
          fill: "#374151"
        }
      ]
    }
  },
  "cloud-upload": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M7 16C4.79086 16 3 14.2091 3 12C3 10.0929 4.33457 8.4976 6.12071 8.09695C6.04169 7.74395 6 7.37684 6 7C6 4.23858 8.23858 2 11 2C13.4193 2 15.4373 3.71825 15.9002 6.00098C15.9334 6.00033 15.9666 6 16 6C18.7614 6 21 8.23858 21 11C21 13.419 19.2822 15.4367 17 15.9M15 13L12 10M12 10L9 13M12 10L12 22",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M5.5 13C3.567 13 2 11.433 2 9.5C2 7.69163 3.37146 6.20358 5.13102 6.01922C5.04553 5.69382 5 5.35223 5 5C5 2.79086 6.79086 1 9 1C10.8788 1 12.4551 2.29538 12.8845 4.04175C13.0857 4.01422 13.2912 4 13.5 4C15.9853 4 18 6.01472 18 8.5C18 10.9853 15.9853 13 13.5 13H11V9.41421L12.2929 10.7071C12.6834 11.0976 13.3166 11.0976 13.7071 10.7071C14.0976 10.3166 14.0976 9.68342 13.7071 9.29289L10.7071 6.29289C10.3166 5.90237 9.68342 5.90237 9.29289 6.29289L6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071C6.68342 11.0976 7.31658 11.0976 7.70711 10.7071L9 9.41421L9 13H5.5Z",
          fill: "#374151"
        },
        {
          d: "M9 13H11L11 18C11 18.5523 10.5523 19 10 19C9.44772 19 9 18.5523 9 18L9 13Z",
          fill: "#374151"
        }
      ]
    }
  },
  cloud,
  code: code$1,
  cog,
  collection,
  "color-swatch": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M7 21C4.79086 21 3 19.2091 3 17V5C3 3.89543 3.89543 3 5 3H9C10.1046 3 11 3.89543 11 5V17C11 19.2091 9.20914 21 7 21ZM7 21H19C20.1046 21 21 20.1046 21 19V15C21 13.8954 20.1046 13 19 13H16.6569M11 7.34312L12.6569 5.68629C13.4379 4.90524 14.7042 4.90524 15.4853 5.68629L18.3137 8.51472C19.0948 9.29577 19.0948 10.5621 18.3137 11.3431L9.82843 19.8284M7 17H7.01",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M4 2C2.89543 2 2 2.89543 2 4V15C2 16.6569 3.34315 18 5 18C6.65685 18 8 16.6569 8 15V4C8 2.89543 7.10457 2 6 2H4ZM5 16C5.55228 16 6 15.5523 6 15C6 14.4477 5.55228 14 5 14C4.44772 14 4 14.4477 4 15C4 15.5523 4.44772 16 5 16ZM10 14.2426L14.8995 9.34308C15.6805 8.56203 15.6805 7.2957 14.8995 6.51465L13.4853 5.10044C12.7042 4.31939 11.4379 4.31939 10.6568 5.10044L10 5.75728V14.2426ZM16 18H9.07104L15.071 12H16C17.1046 12 18 12.8954 18 14V16C18 17.1046 17.1046 18 16 18Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "credit-card": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M3 10H21M7 15H8M12 15H13M6 19H18C19.6569 19 21 17.6569 21 16V8C21 6.34315 19.6569 5 18 5H6C4.34315 5 3 6.34315 3 8V16C3 17.6569 4.34315 19 6 19Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z",
          fill: "#4A5568"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "cube-transparent": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M14 10L12 11M12 11L10 10M12 11V13.5M20 7L18 8M20 7L18 6M20 7V9.5M14 4L12 3L10 4M4 7L6 6M4 7L6 8M4 7V9.5M12 21L10 20M12 21L14 20M12 21V18.5M6 18L4 17V14.5M18 18L20 17V14.5",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M9.50386 1.13176C9.81129 0.956081 10.1887 0.956081 10.4961 1.13176L12.2461 2.13176C12.7257 2.40577 12.8923 3.01662 12.6182 3.49614C12.3442 3.97566 11.7334 4.14225 11.2539 3.86824L10 3.15175L8.74614 3.86824C8.26662 4.14225 7.65577 3.97566 7.38176 3.49614C7.10775 3.01662 7.27434 2.40577 7.75386 2.13176L9.50386 1.13176ZM5.61824 4.50386C5.89225 4.98338 5.72566 5.59423 5.24614 5.86824L5.01556 6L5.24614 6.13176C5.72566 6.40577 5.89225 7.01662 5.61824 7.49614C5.34423 7.97566 4.73338 8.14225 4.25386 7.86824L4 7.72318V8C4 8.55228 3.55228 9 3 9C2.44772 9 2 8.55228 2 8V6C2 5.75001 2.09173 5.52145 2.24336 5.34614C2.27802 5.30603 2.31598 5.26854 2.35699 5.23411C2.40754 5.19163 2.46236 5.15405 2.52071 5.12213L4.25386 4.13176C4.73338 3.85775 5.34423 4.02434 5.61824 4.50386ZM14.3818 4.50386C14.6558 4.02434 15.2666 3.85775 15.7461 4.13176L17.4793 5.12212C17.5376 5.15405 17.5925 5.19162 17.643 5.23411C17.8613 5.41755 18 5.69258 18 6V8C18 8.55228 17.5523 9 17 9C16.4477 9 16 8.55228 16 8V7.72318L15.7461 7.86824C15.2666 8.14225 14.6558 7.97566 14.3818 7.49614C14.1077 7.01662 14.2743 6.40577 14.7539 6.13176L14.9844 6L14.7539 5.86824C14.2743 5.59423 14.1077 4.98338 14.3818 4.50386ZM7.38176 8.50386C7.65577 8.02434 8.26662 7.85775 8.74614 8.13176L10 8.84825L11.2539 8.13176C11.7334 7.85775 12.3442 8.02434 12.6182 8.50386C12.8923 8.98338 12.7257 9.59423 12.2461 9.86824L11 10.5803V12C11 12.5523 10.5523 13 10 13C9.44772 13 9 12.5523 9 12V10.5803L7.75386 9.86824C7.27434 9.59423 7.10775 8.98338 7.38176 8.50386ZM3 11C3.55228 11 4 11.4477 4 12V13.4197L5.24614 14.1318C5.72566 14.4058 5.89225 15.0166 5.61824 15.4961C5.34423 15.9757 4.73338 16.1423 4.25386 15.8682L2.50386 14.8682C2.19229 14.6902 2 14.3589 2 14V12C2 11.4477 2.44772 11 3 11ZM17 11C17.5523 11 18 11.4477 18 12V14C18 14.3589 17.8077 14.6902 17.4961 14.8682L15.7461 15.8682C15.2666 16.1423 14.6558 15.9757 14.3818 15.4961C14.1077 15.0166 14.2743 14.4058 14.7539 14.1318L16 13.4197V12C16 11.4477 16.4477 11 17 11ZM7.38176 16.5039C7.65577 16.0243 8.26662 15.8577 8.74614 16.1318L9 16.2768V16C9 15.4477 9.44772 15 10 15C10.5523 15 11 15.4477 11 16V16.2768L11.2539 16.1318C11.7334 15.8577 12.3442 16.0243 12.6182 16.5039C12.8923 16.9834 12.7257 17.5942 12.2461 17.8682L10.5113 18.8596C10.3617 18.9488 10.1868 19 10 19C9.81316 19 9.63828 18.9488 9.48866 18.8596L7.75386 17.8682C7.27434 17.5942 7.10775 16.9834 7.38176 16.5039Z",
          fill: "#374151"
        }
      ]
    }
  },
  cube,
  "currency-bangladeshi": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M11 11V9C11 7.89543 10.1046 7 9 7M11 11V15C11 16.1046 11.8954 17 13 17C14.1046 17 15 16.1046 15 15V14M11 11H9M11 11H15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM7 4C6.44772 4 6 4.44772 6 5C6 5.55228 6.44772 6 7 6C7.55228 6 8 6.44772 8 7V8H7C6.44772 8 6 8.44772 6 9C6 9.55228 6.44772 10 7 10H8V13C8 14.6569 9.34315 16 11 16C12.6569 16 14 14.6569 14 13V12C14 11.4477 13.5523 11 13 11C12.4477 11 12 11.4477 12 12V13C12 13.5523 11.5523 14 11 14C10.4477 14 10 13.5523 10 13V10H13C13.5523 10 14 9.55228 14 9C14 8.44772 13.5523 8 13 8H10V7C10 5.34315 8.65685 4 7 4Z",
          fill: "#374151"
        }
      ]
    }
  },
  "currency-dollar": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M12 8C10.3431 8 9 8.89543 9 10C9 11.1046 10.3431 12 12 12C13.6569 12 15 12.8954 15 14C15 15.1046 13.6569 16 12 16M12 8C13.1104 8 14.0799 8.4022 14.5987 9M12 8V7M12 8L12 16M12 16L12 17M12 16C10.8896 16 9.92008 15.5978 9.40137 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M8.43338 7.41784C8.58818 7.31464 8.77939 7.2224 9 7.15101L9.00001 8.84899C8.77939 8.7776 8.58818 8.68536 8.43338 8.58216C8.06927 8.33942 8 8.1139 8 8C8 7.8861 8.06927 7.66058 8.43338 7.41784Z",
          fill: "#4A5568"
        },
        {
          d: "M11 12.849L11 11.151C11.2206 11.2224 11.4118 11.3146 11.5666 11.4178C11.9308 11.6606 12 11.8861 12 12C12 12.1139 11.9308 12.3394 11.5666 12.5822C11.4118 12.6854 11.2206 12.7776 11 12.849Z",
          fill: "#4A5568"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 5C11 4.44772 10.5523 4 10 4C9.44772 4 9 4.44772 9 5V5.09199C8.3784 5.20873 7.80348 5.43407 7.32398 5.75374C6.6023 6.23485 6 7.00933 6 8C6 8.99067 6.6023 9.76515 7.32398 10.2463C7.80348 10.5659 8.37841 10.7913 9.00001 10.908L9.00002 12.8492C8.60902 12.7223 8.31917 12.5319 8.15667 12.3446C7.79471 11.9275 7.16313 11.8827 6.74599 12.2447C6.32885 12.6067 6.28411 13.2382 6.64607 13.6554C7.20855 14.3036 8.05956 14.7308 9 14.9076L9 15C8.99999 15.5523 9.44769 16 9.99998 16C10.5523 16 11 15.5523 11 15L11 14.908C11.6216 14.7913 12.1965 14.5659 12.676 14.2463C13.3977 13.7651 14 12.9907 14 12C14 11.0093 13.3977 10.2348 12.676 9.75373C12.1965 9.43407 11.6216 9.20873 11 9.09199L11 7.15075C11.391 7.27771 11.6808 7.4681 11.8434 7.65538C12.2053 8.07252 12.8369 8.11726 13.254 7.7553C13.6712 7.39335 13.7159 6.76176 13.354 6.34462C12.7915 5.69637 11.9405 5.26915 11 5.09236V5Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "currency-euro": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M14.1213 15.5355C12.9497 17.4882 11.0503 17.4882 9.87868 15.5355C8.70711 13.5829 8.70711 10.4171 9.87868 8.46447C11.0503 6.51184 12.9497 6.51184 14.1213 8.46447M8 10.5H12M8 13.5H12M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.73617 6.97896C9.20793 6.1927 9.69618 6 10 6C10.3038 6 10.7921 6.1927 11.2638 6.97896C11.548 7.45254 12.1622 7.60611 12.6358 7.32196C13.1094 7.03781 13.263 6.42355 12.9788 5.94997C12.279 4.78361 11.2317 4 10 4C8.76829 4 7.721 4.78361 7.02119 5.94997C6.73632 6.42475 6.51422 6.94939 6.35097 7.5H6C5.44772 7.5 5 7.94772 5 8.5C5 9.05228 5.44772 9.5 6 9.5H6.01337C6.00443 9.66702 6 9.83388 6 10C6 10.1661 6.00443 10.333 6.01337 10.5H6C5.44772 10.5 5 10.9477 5 11.5C5 12.0523 5.44772 12.5 6 12.5H6.35097C6.51422 13.0506 6.73632 13.5753 7.02119 14.05C7.721 15.2164 8.76829 16 10 16C11.2317 16 12.279 15.2164 12.9788 14.05C13.263 13.5764 13.1094 12.9622 12.6358 12.678C12.1622 12.3939 11.548 12.5475 11.2638 13.021C10.7921 13.8073 10.3038 14 10 14C9.69618 14 9.20793 13.8073 8.73617 13.021C8.63927 12.8595 8.5511 12.6851 8.47216 12.5H10C10.5523 12.5 11 12.0523 11 11.5C11 10.9477 10.5523 10.5 10 10.5H8.01695C8.00571 10.335 8 10.1681 8 10C8 9.83191 8.00571 9.66498 8.01695 9.5H10C10.5523 9.5 11 9.05228 11 8.5C11 7.94772 10.5523 7.5 10 7.5H8.47216C8.5511 7.31488 8.63927 7.14047 8.73617 6.97896Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "currency-pound": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M15 9C15 7.89543 14.1046 7 13 7C11.8954 7 11 7.89543 11 9V14C11 15.1046 10.1046 16 9 16H15M9 12H13M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 4C9.34315 4 8 5.34315 8 7V9H7C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H8V12C8 12.5523 7.55228 13 7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H9.82929C9.93985 12.6872 10 12.3506 10 12V11H11C11.5523 11 12 10.5523 12 10C12 9.44772 11.5523 9 11 9H10V7C10 6.44772 10.4477 6 11 6C11.5523 6 12 6.44772 12 7C12 7.55228 12.4477 8 13 8C13.5523 8 14 7.55228 14 7C14 5.34315 12.6569 4 11 4Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "currency-rupee": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 8H15M10 8C11.6569 8 13 9.34315 13 11C13 12.6569 11.6569 14 10 14H9L12 17M9 11H15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM7.00003 5C6.44774 5 6.00003 5.44772 6.00003 6C6.00003 6.55228 6.44774 7 7.00003 7H8.00003C8.74031 7 9.38666 7.4022 9.73246 8H7.00003C6.44774 8 6.00003 8.44772 6.00003 9C6.00003 9.55228 6.44774 10 7.00003 10H9.73246C9.38665 10.5978 8.74031 11 8.00003 11H7.00003C6.59557 11 6.23093 11.2436 6.07615 11.6173C5.92137 11.991 6.00692 12.4211 6.29292 12.7071L9.29292 15.7071C9.68345 16.0976 10.3166 16.0976 10.7071 15.7071C11.0977 15.3166 11.0977 14.6834 10.7071 14.2929L9.22363 12.8094C10.5222 12.3926 11.5316 11.3302 11.874 10H13C13.5523 10 14 9.55228 14 9C14 8.44772 13.5523 8 13 8H11.874C11.7827 7.64523 11.6439 7.30951 11.4649 7H13C13.5523 7 14 6.55228 14 6C14 5.44772 13.5523 5 13 5H7.00003Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "currency-yen": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 8L12 13M12 13L15 8M12 13V17M9 12H15M9 15H15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM7.85752 5.48541C7.57337 5.01183 6.95911 4.85827 6.48553 5.14241C6.01195 5.42656 5.85839 6.04082 6.14254 6.5144L7.63384 8.99991H7.00003C6.44774 8.99991 6.00003 9.44762 6.00003 9.99991C6.00003 10.5522 6.44774 10.9999 7.00003 10.9999H8.83384L9.00003 11.2769V11.9999H7.00003C6.44774 11.9999 6.00003 12.4476 6.00003 12.9999C6.00003 13.5522 6.44774 13.9999 7.00003 13.9999H9.00003V14.9999C9.00003 15.5522 9.44774 15.9999 10 15.9999C10.5523 15.9999 11 15.5522 11 14.9999V13.9999H13C13.5523 13.9999 14 13.5522 14 12.9999C14 12.4476 13.5523 11.9999 13 11.9999H11V11.2769L11.1662 10.9999H13C13.5523 10.9999 14 10.5522 14 9.99991C14 9.44762 13.5523 8.99991 13 8.99991H12.3662L13.8575 6.5144C14.1417 6.04082 13.9881 5.42656 13.5145 5.14241C13.0409 4.85827 12.4267 5.01183 12.1425 5.48541L10.0338 8.99991H9.96622L7.85752 5.48541Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "cursor-click": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M14.9998 15L12.9998 20L8.99983 9L19.9998 13L14.9998 15ZM14.9998 15L19.9998 20M7.18806 2.23853L7.96452 5.1363M5.13606 7.96472L2.23828 7.18826M13.9495 4.05029L11.8282 6.17161M6.17146 11.8284L4.05014 13.9497",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M6.67187 1.91147C6.52893 1.37801 5.9806 1.06142 5.44713 1.20437C4.91366 1.34731 4.59708 1.89565 4.74002 2.42911L4.99884 3.39504C5.14178 3.9285 5.69012 4.24509 6.22359 4.10214C6.75705 3.9592 7.07363 3.41086 6.93069 2.8774L6.67187 1.91147ZM2.42923 4.7399C1.89577 4.59696 1.34743 4.91354 1.20449 5.44701C1.06155 5.98047 1.37813 6.52881 1.9116 6.67175L2.87752 6.93057C3.41099 7.07351 3.95932 6.75693 4.10227 6.22346C4.24521 5.69 3.92863 5.14166 3.39516 4.99872L2.42923 4.7399ZM11.2427 4.17149C11.6332 3.78097 11.6332 3.1478 11.2427 2.75728C10.8522 2.36676 10.219 2.36676 9.82847 2.75728L9.12136 3.46439C8.73084 3.85491 8.73084 4.48808 9.12136 4.8786C9.51189 5.26912 10.1451 5.26912 10.5356 4.8786L11.2427 4.17149ZM4.17162 11.2426L4.87872 10.5355C5.26925 10.1449 5.26925 9.51177 4.87872 9.12124C4.4882 8.73072 3.85503 8.73072 3.46451 9.12124L2.7574 9.82835C2.36688 10.2189 2.36688 10.852 2.7574 11.2426C3.14793 11.6331 3.78109 11.6331 4.17162 11.2426ZM7.37154 6.07152C7.00012 5.92295 6.5759 6.01002 6.29304 6.29289C6.01018 6.57575 5.92311 6.99997 6.07167 7.37138L10.0717 17.3714C10.2179 17.737 10.5651 17.9828 10.9586 17.9991C11.352 18.0155 11.7185 17.7994 11.8946 17.4472L13.2741 14.6882L16.293 17.7071C16.6836 18.0976 17.3167 18.0976 17.7073 17.7071C18.0978 17.3166 18.0978 16.6834 17.7073 16.2929L14.6883 13.2739L17.4474 11.8944C17.7996 11.7183 18.0157 11.3519 17.9993 10.9584C17.9829 10.565 17.7372 10.2178 17.3715 10.0715L7.37154 6.07152Z",
          fill: "#4B5563"
        }
      ]
    }
  },
  database,
  "desktop-computer": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9.75 17L9 20L8 21H16L15 20L14.25 17M3 13H21M5 17H19C20.1046 17 21 16.1046 21 15V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V15C3 16.1046 3.89543 17 5 17Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3 5C3 3.89543 3.89543 3 5 3H15C16.1046 3 17 3.89543 17 5V13C17 14.1046 16.1046 15 15 15H12.7808L12.903 15.4887L13.7071 16.2929C13.9931 16.5789 14.0787 17.009 13.9239 17.3827C13.7691 17.7563 13.4045 18 13 18H7.00003C6.59557 18 6.23093 17.7563 6.07615 17.3827C5.92137 17.009 6.00692 16.5789 6.29292 16.2929L7.09706 15.4887L7.21925 15H5C3.89543 15 3 14.1046 3 13V5ZM8.7713 12C8.75657 11.9997 8.74189 11.9997 8.72725 12H5V5H15V12H11.2728C11.2582 11.9997 11.2435 11.9997 11.2288 12H8.7713Z",
          fill: "#4B5563"
        }
      ]
    }
  },
  "device-mobile": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M12 18H12.01M8 21H16C17.1046 21 18 20.1046 18 19V5C18 3.89543 17.1046 3 16 3H8C6.89543 3 6 3.89543 6 5V19C6 20.1046 6.89543 21 8 21Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M7 2C5.89543 2 5 2.89543 5 4V16C5 17.1046 5.89543 18 7 18H13C14.1046 18 15 17.1046 15 16V4C15 2.89543 14.1046 2 13 2H7ZM10 16C10.5523 16 11 15.5523 11 15C11 14.4477 10.5523 14 10 14C9.44772 14 9 14.4477 9 15C9 15.5523 9.44772 16 10 16Z",
          fill: "#374151"
        }
      ]
    }
  },
  "device-tablet": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M12 18H12.01M7 21H17C18.1046 21 19 20.1046 19 19V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M6 2C4.89543 2 4 2.89543 4 4V16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V4C16 2.89543 15.1046 2 14 2H6ZM10 16C10.5523 16 11 15.5523 11 15C11 14.4477 10.5523 14 10 14C9.44772 14 9 14.4477 9 15C9 15.5523 9.44772 16 10 16Z",
          fill: "#374151"
        }
      ]
    }
  },
  "document-add": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 13H15M12 10L12 16M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M6 2C4.89543 2 4 2.89543 4 4V16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V7.41421C16 6.88378 15.7893 6.37507 15.4142 6L12 2.58579C11.6249 2.21071 11.1162 2 10.5858 2H6ZM11 8C11 7.44772 10.5523 7 10 7C9.44772 7 9 7.44772 9 8V10H7C6.44772 10 6 10.4477 6 11C6 11.5523 6.44772 12 7 12H9V14C9 14.5523 9.44771 15 10 15C10.5523 15 11 14.5523 11 14L11 12H13C13.5523 12 14 11.5523 14 11C14 10.4477 13.5523 10 13 10H11V8Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "document-download": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M12 10V16M12 16L9 13M12 16L15 13M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M6 2C4.89543 2 4 2.89543 4 4V16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V7.41421C16 6.88378 15.7893 6.37507 15.4142 6L12 2.58579C11.6249 2.21071 11.1162 2 10.5858 2H6ZM11 8C11 7.44772 10.5523 7 10 7C9.44772 7 9 7.44772 9 8V11.5858L7.70711 10.2929C7.31658 9.90237 6.68342 9.90237 6.29289 10.2929C5.90237 10.6834 5.90237 11.3166 6.29289 11.7071L9.29289 14.7071C9.68342 15.0976 10.3166 15.0976 10.7071 14.7071L13.7071 11.7071C14.0976 11.3166 14.0976 10.6834 13.7071 10.2929C13.3166 9.90237 12.6834 9.90237 12.2929 10.2929L11 11.5858V8Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "document-duplicate": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M8 7V15C8 16.1046 8.89543 17 10 17H16M8 7V5C8 3.89543 8.89543 3 10 3H14.5858C14.851 3 15.1054 3.10536 15.2929 3.29289L19.7071 7.70711C19.8946 7.89464 20 8.149 20 8.41421V15C20 16.1046 19.1046 17 18 17H16M8 7H6C4.89543 7 4 7.89543 4 9V19C4 20.1046 4.89543 21 6 21H14C15.1046 21 16 20.1046 16 19V17",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 2C7.89543 2 7 2.89543 7 4V12C7 13.1046 7.89543 14 9 14H15C16.1046 14 17 13.1046 17 12V6.41421C17 5.88378 16.7893 5.37507 16.4142 5L14 2.58579C13.6249 2.21071 13.1162 2 12.5858 2H9Z",
          fill: "#4A5568"
        },
        {
          d: "M3 8C3 6.89543 3.89543 6 5 6V16H13C13 17.1046 12.1046 18 11 18H5C3.89543 18 3 17.1046 3 16V8Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "document-remove": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 13H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M6 2C4.89543 2 4 2.89543 4 4V16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V7.41421C16 6.88378 15.7893 6.37507 15.4142 6L12 2.58579C11.6249 2.21071 11.1162 2 10.5858 2H6ZM7 10C6.44772 10 6 10.4477 6 11C6 11.5523 6.44772 12 7 12H13C13.5523 12 14 11.5523 14 11C14 10.4477 13.5523 10 13 10H7Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "document-report": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 17V15M12 17V13M15 17V11M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M6 2C4.89543 2 4 2.89543 4 4V16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V7.41421C16 6.88378 15.7893 6.37507 15.4142 6L12 2.58579C11.6249 2.21071 11.1162 2 10.5858 2H6ZM8 12C8 11.4477 7.55228 11 7 11C6.44772 11 6 11.4477 6 12V15C6 15.5523 6.44772 16 7 16C7.55228 16 8 15.5523 8 15V12ZM10 9C10.5523 9 11 9.44772 11 10V15C11 15.5523 10.5523 16 10 16C9.44772 16 9 15.5523 9 15V10C9 9.44772 9.44772 9 10 9ZM14 8C14 7.44772 13.5523 7 13 7C12.4477 7 12 7.44772 12 8V15C12 15.5523 12.4477 16 13 16C13.5523 16 14 15.5523 14 15V8Z",
          fill: "#4B5563"
        }
      ]
    }
  },
  "document-search": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M10 21H17C18.1046 21 19 20.1046 19 19V9.41421C19 9.149 18.8946 8.89464 18.7071 8.70711L13.2929 3.29289C13.1054 3.10536 12.851 3 12.5858 3H7C5.89543 3 5 3.89543 5 5V16M5 21L9.87868 16.1213M9.87868 16.1213C10.4216 16.6642 11.1716 17 12 17C13.6569 17 15 15.6569 15 14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14C9 14.8284 9.33579 15.5784 9.87868 16.1213Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M4 4C4 2.89543 4.89543 2 6 2H10.5858C11.1162 2 11.6249 2.21071 12 2.58579L15.4142 6C15.7893 6.37507 16 6.88378 16 7.41421V16C16 17.1046 15.1046 18 14 18H12.4722C13.4223 16.9385 14 15.5367 14 14C14 10.6863 11.3137 8 8 8C6.46329 8 5.06151 8.57771 4 9.52779V4Z",
          fill: "#374151"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M8 10C5.79086 10 4 11.7909 4 14C4 14.7414 4.20229 15.4364 4.55397 16.0318L3.29289 17.2929C2.90237 17.6834 2.90237 18.3166 3.29289 18.7071C3.68342 19.0976 4.31658 19.0976 4.70711 18.7071L5.96818 17.446C6.56362 17.7977 7.25862 18 8 18C10.2091 18 12 16.2091 12 14C12 11.7909 10.2091 10 8 10ZM6 14C6 12.8954 6.89543 12 8 12C9.10457 12 10 12.8954 10 14C10 15.1046 9.10457 16 8 16C7.44744 16 6.94881 15.7772 6.58579 15.4142C6.22276 15.0512 6 14.5526 6 14Z",
          fill: "#374151"
        }
      ]
    }
  },
  "document-text": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 12H15M9 16H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M4 4C4 2.89543 4.89543 2 6 2H10.5858C11.1162 2 11.6249 2.21071 12 2.58579L15.4142 6C15.7893 6.37507 16 6.88378 16 7.41421V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V4ZM6 10C6 9.44772 6.44772 9 7 9H13C13.5523 9 14 9.44772 14 10C14 10.5523 13.5523 11 13 11H7C6.44772 11 6 10.5523 6 10ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H7Z",
          fill: "#374151"
        }
      ]
    }
  },
  document: document$1,
  "dots-circle-horizontal": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M8 12H8.01M12 12H12.01M16 12H16.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM7 9H5V11H7V9ZM15 9H13V11H15V9ZM9 9H11V11H9V9Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "dots-horizontal": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M5 12H5.01M12 12H12.01M19 12H19.01M6 12C6 12.5523 5.55228 13 5 13C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11C5.55228 11 6 11.4477 6 12ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12ZM20 12C20 12.5523 19.5523 13 19 13C18.4477 13 18 12.5523 18 12C18 11.4477 18.4477 11 19 11C19.5523 11 20 11.4477 20 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M6 10C6 11.1046 5.10457 12 4 12C2.89543 12 2 11.1046 2 10C2 8.89543 2.89543 8 4 8C5.10457 8 6 8.89543 6 10Z",
          fill: "#4A5568"
        },
        {
          d: "M12 10C12 11.1046 11.1046 12 10 12C8.89543 12 8 11.1046 8 10C8 8.89543 8.89543 8 10 8C11.1046 8 12 8.89543 12 10Z",
          fill: "#4A5568"
        },
        {
          d: "M16 12C17.1046 12 18 11.1046 18 10C18 8.89543 17.1046 8 16 8C14.8954 8 14 8.89543 14 10C14 11.1046 14.8954 12 16 12Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "dots-vertical": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M12 5L12 5.01M12 12L12 12.01M12 19L12 19.01M12 6C11.4477 6 11 5.55228 11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5C13 5.55228 12.5523 6 12 6ZM12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13ZM12 20C11.4477 20 11 19.5523 11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19C13 19.5523 12.5523 20 12 20Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M10 6C8.89543 6 8 5.10457 8 4C8 2.89543 8.89543 2 10 2C11.1046 2 12 2.89543 12 4C12 5.10457 11.1046 6 10 6Z",
          fill: "#4A5568"
        },
        {
          d: "M10 12C8.89543 12 8 11.1046 8 10C8 8.89543 8.89543 8 10 8C11.1046 8 12 8.89543 12 10C12 11.1046 11.1046 12 10 12Z",
          fill: "#4A5568"
        },
        {
          d: "M10 18C8.89543 18 8 17.1046 8 16C8 14.8954 8.89543 14 10 14C11.1046 14 12 14.8954 12 16C12 17.1046 11.1046 18 10 18Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  download,
  duplicate,
  "emoji-happy": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M14.8284 14.8284C13.2663 16.3905 10.7337 16.3905 9.17157 14.8284M9 10H9.01M15 10H15.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM7 9C7.55228 9 8 8.55228 8 8C8 7.44772 7.55228 7 7 7C6.44772 7 6 7.44772 6 8C6 8.55228 6.44772 9 7 9ZM14 8C14 8.55228 13.5523 9 13 9C12.4477 9 12 8.55228 12 8C12 7.44772 12.4477 7 13 7C13.5523 7 14 7.44772 14 8ZM13.5355 13.5354C13.9261 13.1449 13.9261 12.5118 13.5355 12.1212C13.145 11.7307 12.5118 11.7307 12.1213 12.1212C10.9497 13.2928 9.05025 13.2928 7.87868 12.1212C7.48816 11.7307 6.85499 11.7307 6.46447 12.1212C6.07394 12.5118 6.07394 13.1449 6.46447 13.5354C8.41709 15.4881 11.5829 15.4881 13.5355 13.5354Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "emoji-sad": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9.17163 16.1716C10.7337 14.6095 13.2664 14.6095 14.8285 16.1716M9 10H9.01M15 10H15.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM7 9C7.55228 9 8 8.55228 8 8C8 7.44772 7.55228 7 7 7C6.44772 7 6 7.44772 6 8C6 8.55228 6.44772 9 7 9ZM14 8C14 8.55228 13.5523 9 13 9C12.4477 9 12 8.55228 12 8C12 7.44772 12.4477 7 13 7C13.5523 7 14 7.44772 14 8ZM6.46447 13.8785C6.85499 14.269 7.48816 14.269 7.87868 13.8785C9.05025 12.7069 10.9497 12.7069 12.1213 13.8785C12.5118 14.269 13.145 14.269 13.5355 13.8785C13.9261 13.4879 13.9261 12.8548 13.5355 12.4642C11.5829 10.5116 8.41709 10.5116 6.46447 12.4642C6.07394 12.8548 6.07394 13.4879 6.46447 13.8785Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "exclamation-circle": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM11 14C11 14.5523 10.5523 15 10 15C9.44772 15 9 14.5523 9 14C9 13.4477 9.44772 13 10 13C10.5523 13 11 13.4477 11 14ZM10 5C9.44772 5 9 5.44772 9 6V10C9 10.5523 9.44772 11 10 11C10.5523 11 11 10.5523 11 10V6C11 5.44772 10.5523 5 10 5Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  exclamation,
  "external-link": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M10 6H6C4.89543 6 4 6.89543 4 8V18C4 19.1046 4.89543 20 6 20H16C17.1046 20 18 19.1046 18 18V14M14 4H20M20 4V10M20 4L10 14",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M11 3C10.4477 3 10 3.44772 10 4C10 4.55228 10.4477 5 11 5H13.5858L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071C7.68342 13.0976 8.31658 13.0976 8.70711 12.7071L15 6.41421V9C15 9.55228 15.4477 10 16 10C16.5523 10 17 9.55228 17 9V4C17 3.44772 16.5523 3 16 3H11Z",
          fill: "#4A5568"
        },
        {
          d: "M5 5C3.89543 5 3 5.89543 3 7V15C3 16.1046 3.89543 17 5 17H13C14.1046 17 15 16.1046 15 15V12C15 11.4477 14.5523 11 14 11C13.4477 11 13 11.4477 13 12V15H5V7L8 7C8.55228 7 9 6.55228 9 6C9 5.44772 8.55228 5 8 5H5Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "eye-off": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M13.8749 18.8246C13.2677 18.9398 12.6411 19 12.0005 19C7.52281 19 3.73251 16.0571 2.45825 12C2.80515 10.8955 3.33851 9.87361 4.02143 8.97118M9.87868 9.87868C10.4216 9.33579 11.1716 9 12 9C13.6569 9 15 10.3431 15 12C15 12.8284 14.6642 13.5784 14.1213 14.1213M9.87868 9.87868L14.1213 14.1213M9.87868 9.87868L6.58916 6.58916M14.1213 14.1213L17.4112 17.4112M3 3L6.58916 6.58916M6.58916 6.58916C8.14898 5.58354 10.0066 5 12.0004 5C16.4781 5 20.2684 7.94291 21.5426 12C20.8357 14.2507 19.3545 16.1585 17.4112 17.4112M17.4112 17.4112L21 21",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3.70711 2.29289C3.31658 1.90237 2.68342 1.90237 2.29289 2.29289C1.90237 2.68342 1.90237 3.31658 2.29289 3.70711L16.2929 17.7071C16.6834 18.0976 17.3166 18.0976 17.7071 17.7071C18.0976 17.3166 18.0976 16.6834 17.7071 16.2929L16.2339 14.8197C17.7715 13.5924 18.939 11.9211 19.5424 9.99996C18.2681 5.94288 14.4778 3 10.0002 3C8.37665 3 6.84344 3.38692 5.48779 4.07358L3.70711 2.29289ZM7.96813 6.55391L9.48201 8.0678C9.6473 8.02358 9.82102 8 10.0003 8C11.1048 8 12.0003 8.89543 12.0003 10C12.0003 10.1792 11.9767 10.353 11.9325 10.5182L13.4463 12.0321C13.7983 11.4366 14.0003 10.7419 14.0003 10C14.0003 7.79086 12.2094 6 10.0003 6C9.25838 6 8.56367 6.20197 7.96813 6.55391Z",
          fill: "#4B5563"
        },
        {
          d: "M12.4541 16.6967L9.74965 13.9923C7.74013 13.8681 6.1322 12.2601 6.00798 10.2506L2.33492 6.57754C1.50063 7.57223 0.856368 8.73169 0.458008 10C1.73228 14.0571 5.52257 17 10.0002 17C10.8469 17 11.6689 16.8948 12.4541 16.6967Z",
          fill: "#4B5563"
        }
      ]
    }
  },
  eye,
  "fast-forward": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M11.9333 12.8C12.4667 12.4 12.4667 11.6 11.9333 11.2L6.6 7.19998C5.94076 6.70556 5 7.17594 5 7.99998L5 16C5 16.824 5.94076 17.2944 6.6 16.8L11.9333 12.8Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        },
        {
          d: "M19.9333 12.8C20.4667 12.4 20.4667 11.6 19.9333 11.2L14.6 7.19998C13.9408 6.70556 13 7.17594 13 7.99998L13 16C13 16.824 13.9408 17.2944 14.6 16.8L19.9333 12.8Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M4.5547 5.16795C4.24784 4.96338 3.8533 4.94431 3.52814 5.11833C3.20298 5.29235 3 5.63121 3 6V14C3 14.3688 3.20298 14.7077 3.52814 14.8817C3.8533 15.0557 4.24784 15.0366 4.5547 14.8321L10 11.2019V14C10 14.3688 10.203 14.7077 10.5281 14.8817C10.8533 15.0557 11.2478 15.0366 11.5547 14.8321L17.5547 10.8321C17.8329 10.6466 18 10.3344 18 10C18 9.66565 17.8329 9.35342 17.5547 9.16795L11.5547 5.16795C11.2478 4.96338 10.8533 4.94431 10.5281 5.11833C10.203 5.29235 10 5.63121 10 6V8.79815L4.5547 5.16795Z",
          fill: "#374151"
        }
      ]
    }
  },
  film,
  filter,
  "finger-print": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M11.9999 11C11.9999 14.5172 10.9911 17.7988 9.24707 20.5712M5.80688 18.5304C5.82459 18.5005 5.84273 18.4709 5.8613 18.4413C7.2158 16.2881 7.99991 13.7418 7.99991 11C7.99991 8.79086 9.79077 7 11.9999 7C14.209 7 15.9999 8.79086 15.9999 11C15.9999 12.017 15.9307 13.0186 15.7966 14M13.6792 20.8436C14.2909 19.6226 14.7924 18.3369 15.1707 17M19.0097 18.132C19.6547 15.8657 20 13.4732 20 11C20 6.58172 16.4183 3 12 3C10.5429 3 9.17669 3.38958 8 4.07026M3 15.3641C3.64066 14.0454 4 12.5646 4 11C4 9.54285 4.38958 8.17669 5.07026 7",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M6.62478 2.65458C7.6684 2.23213 8.80833 2 10 2C14.9706 2 19 6.02944 19 11C19 11.5523 18.5523 12 18 12C17.4477 12 17 11.5523 17 11C17 7.13401 13.866 4 10 4C9.06987 4 8.18446 4.18088 7.37522 4.50845C6.86328 4.71568 6.28029 4.46867 6.07306 3.95673C5.86584 3.4448 6.11285 2.8618 6.62478 2.65458ZM4.66173 4.95861C5.0758 5.32408 5.1152 5.95602 4.74974 6.37008C3.66007 7.60467 3 9.22404 3 11C3 11.5523 2.55228 12 2 12C1.44772 12 1 11.5523 1 11C1 8.71818 1.85048 6.63256 3.25026 5.04662C3.61573 4.63255 4.24766 4.59315 4.66173 4.95861Z",
          fill: "#374151"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5 11C5 8.23858 7.23857 6 10 6C12.7614 6 15 8.23858 15 11C15 11.5523 14.5523 12 14 12C13.4477 12 13 11.5523 13 11C13 9.34315 11.6569 8 10 8C8.34315 8 7 9.34315 7 11C7 12.6772 6.65535 14.2764 6.03206 15.7288C5.81426 16.2363 5.22626 16.4712 4.71874 16.2533C4.21122 16.0355 3.97636 15.4475 4.19416 14.94C4.71247 13.7323 5 12.401 5 11ZM13.9212 13.0123C14.4666 13.0989 14.8387 13.6112 14.7521 14.1567C14.6205 14.9867 14.4378 15.7998 14.2072 16.5928C14.0531 17.1231 13.4982 17.428 12.9679 17.2739C12.4375 17.1197 12.1326 16.5648 12.2868 16.0345C12.494 15.3215 12.6584 14.5901 12.7768 13.8433C12.8634 13.2979 13.3757 12.9258 13.9212 13.0123Z",
          fill: "#374151"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 10C10.5523 10 11 10.4477 11 11C11 13.2363 10.5406 15.3679 9.71014 17.3036C9.49239 17.8111 8.90441 18.046 8.39687 17.8283C7.88933 17.6105 7.65441 17.0225 7.87217 16.515C8.59772 14.8239 9 12.9602 9 11C9 10.4477 9.44771 10 10 10Z",
          fill: "#374151"
        }
      ]
    }
  },
  fire,
  flag,
  "folder-add": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 13H15M12 10V16M3 17V7C3 5.89543 3.89543 5 5 5H11L13 7H19C20.1046 7 21 7.89543 21 9V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M2 6C2 4.89543 2.89543 4 4 4H9L11 6H16C17.1046 6 18 6.89543 18 8V14C18 15.1046 17.1046 16 16 16H4C2.89543 16 2 15.1046 2 14V6Z",
          fill: "#374151"
        },
        {
          d: "M8 11H12M10 9V13",
          stroke: "white",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    }
  },
  "folder-download": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M12 10V16M12 16L9 13M12 16L15 13M3 17V7C3 5.89543 3.89543 5 5 5H11L13 7H19C20.1046 7 21 7.89543 21 9V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M2 6C2 4.89543 2.89543 4 4 4H9L11 6H16C17.1046 6 18 6.89543 18 8V14C18 15.1046 17.1046 16 16 16H4C2.89543 16 2 15.1046 2 14V6Z",
          fill: "#374151"
        },
        {
          d: "M10 9V13M10 13L8 11M10 13L12 11",
          stroke: "white",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    }
  },
  "folder-open": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M5 19C3.89543 19 3 18.1046 3 17V7C3 5.89543 3.89543 5 5 5H9L11 7H15C16.1046 7 17 7.89543 17 9V10M5 19H19C20.1046 19 21 18.1046 21 17V12C21 10.8954 20.1046 10 19 10H9C7.89543 10 7 10.8954 7 12V17C7 18.1046 6.10457 19 5 19Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M2 6C2 4.89543 2.89543 4 4 4H8L10 6H14C15.1046 6 16 6.89543 16 8V9H8C6.34315 9 5 10.3431 5 12V13.5C5 14.3284 4.32843 15 3.5 15C2.67157 15 2 14.3284 2 13.5V6Z",
          fill: "#374151"
        },
        {
          d: "M6 12C6 10.8954 6.89543 10 8 10H16C17.1046 10 18 10.8954 18 12V14C18 15.1046 17.1046 16 16 16H2H4C5.10457 16 6 15.1046 6 14V12Z",
          fill: "#374151"
        }
      ]
    }
  },
  "folder-remove": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 13H15M3 17V7C3 5.89543 3.89543 5 5 5H11L13 7H19C20.1046 7 21 7.89543 21 9V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M2 6C2 4.89543 2.89543 4 4 4H9L11 6H16C17.1046 6 18 6.89543 18 8V14C18 15.1046 17.1046 16 16 16H4C2.89543 16 2 15.1046 2 14V6Z",
          fill: "#374151"
        },
        {
          d: "M8 11H12",
          stroke: "white",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    }
  },
  folder,
  gift,
  "globe-alt": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M21 12C21 16.9706 16.9706 21 12 21M21 12C21 7.02944 16.9706 3 12 3M21 12H3M12 21C7.02944 21 3 16.9706 3 12M12 21C13.6569 21 15 16.9706 15 12C15 7.02944 13.6569 3 12 3M12 21C10.3431 21 9 16.9706 9 12C9 7.02944 10.3431 3 12 3M3 12C3 7.02944 7.02944 3 12 3",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M4.08296 9H6.02863C6.11783 7.45361 6.41228 6.02907 6.86644 4.88228C5.41752 5.77135 4.37513 7.25848 4.08296 9ZM10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM10 4C9.92395 4 9.76787 4.03173 9.5347 4.26184C9.29723 4.4962 9.03751 4.8849 8.79782 5.44417C8.40914 6.3511 8.12491 7.58559 8.03237 9H11.9676C11.8751 7.58559 11.5909 6.3511 11.2022 5.44417C10.9625 4.8849 10.7028 4.4962 10.4653 4.26184C10.2321 4.03173 10.076 4 10 4ZM13.9714 9C13.8822 7.45361 13.5877 6.02907 13.1336 4.88228C14.5825 5.77135 15.6249 7.25848 15.917 9H13.9714ZM11.9676 11H8.03237C8.12491 12.4144 8.40914 13.6489 8.79782 14.5558C9.03751 15.1151 9.29723 15.5038 9.5347 15.7382C9.76787 15.9683 9.92395 16 10 16C10.076 16 10.2321 15.9683 10.4653 15.7382C10.7028 15.5038 10.9625 15.1151 11.2022 14.5558C11.5909 13.6489 11.8751 12.4144 11.9676 11ZM13.1336 15.1177C13.5877 13.9709 13.8822 12.5464 13.9714 11H15.917C15.6249 12.7415 14.5825 14.2287 13.1336 15.1177ZM6.86644 15.1177C6.41228 13.9709 6.11783 12.5464 6.02863 11H4.08296C4.37513 12.7415 5.41752 14.2287 6.86644 15.1177Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  globe,
  hand,
  hashtag,
  heart,
  home,
  identification,
  "inbox-in": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M8 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H16M12 3V11M12 11L15 8M12 11L9 8M4 13H6.58579C6.851 13 7.10536 13.1054 7.29289 13.2929L9.70711 15.7071C9.89464 15.8946 10.149 16 10.4142 16H13.5858C13.851 16 14.1054 15.8946 14.2929 15.7071L16.7071 13.2929C16.8946 13.1054 17.149 13 17.4142 13H20",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L9.29289 10.7071C9.48043 10.8946 9.73478 11 10 11C10.2652 11 10.5196 10.8946 10.7071 10.7071L12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289C12.3166 6.90237 11.6834 6.90237 11.2929 7.29289L11 7.58579L11 3C11 2.44771 10.5523 2 10 2C9.44771 2 9 2.44772 9 3V7.58579L8.70711 7.29289Z",
          fill: "#4A5568"
        },
        {
          d: "M3 5C3 3.89543 3.89543 3 5 3H6C6.55228 3 7 3.44772 7 4C7 4.55228 6.55228 5 6 5L5 5V12H7L8 14H12L13 12H15V5H14C13.4477 5 13 4.55228 13 4C13 3.44772 13.4477 3 14 3H15C16.1046 3 17 3.89543 17 5V15C17 16.1046 16.1046 17 15 17H5C3.89543 17 3 16.1046 3 15V5Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  inbox,
  "information-circle": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M13 16H12V12H11M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM11 6C11 6.55228 10.5523 7 10 7C9.44772 7 9 6.55228 9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6ZM9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11V14C9 14.5523 9.44772 15 10 15H11C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13V10C11 9.44772 10.5523 9 10 9H9Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  key: key$2,
  library,
  "light-bulb": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9.66347 17H14.3364M11.9999 3V4M18.3639 5.63604L17.6568 6.34315M21 11.9999H20M4 11.9999H3M6.34309 6.34315L5.63599 5.63604M8.46441 15.5356C6.51179 13.5829 6.51179 10.4171 8.46441 8.46449C10.417 6.51187 13.5829 6.51187 15.5355 8.46449C17.4881 10.4171 17.4881 13.5829 15.5355 15.5356L14.9884 16.0827C14.3555 16.7155 13.9999 17.5739 13.9999 18.469V19C13.9999 20.1046 13.1045 21 11.9999 21C10.8954 21 9.99995 20.1046 9.99995 19V18.469C9.99995 17.5739 9.6444 16.7155 9.01151 16.0827L8.46441 15.5356Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M11 3C11 2.44772 10.5523 2 10 2C9.44771 2 9 2.44772 9 3V4C9 4.55228 9.44771 5 10 5C10.5523 5 11 4.55228 11 4V3Z",
          fill: "#4A5568"
        },
        {
          d: "M15.6568 5.75731C16.0473 5.36678 16.0473 4.73362 15.6568 4.34309C15.2663 3.95257 14.6331 3.95257 14.2426 4.34309L13.5355 5.0502C13.145 5.44072 13.145 6.07389 13.5355 6.46441C13.926 6.85494 14.5592 6.85494 14.9497 6.46441L15.6568 5.75731Z",
          fill: "#4A5568"
        },
        {
          d: "M18 10C18 10.5523 17.5523 11 17 11H16C15.4477 11 15 10.5523 15 10C15 9.44771 15.4477 9 16 9H17C17.5523 9 18 9.44771 18 10Z",
          fill: "#4A5568"
        },
        {
          d: "M5.05019 6.46443C5.44071 6.85496 6.07388 6.85496 6.4644 6.46443C6.85493 6.07391 6.85493 5.44074 6.4644 5.05022L5.7573 4.34311C5.36677 3.95259 4.73361 3.95259 4.34308 4.34311C3.95256 4.73363 3.95256 5.3668 4.34308 5.75732L5.05019 6.46443Z",
          fill: "#4A5568"
        },
        {
          d: "M5 10C5 10.5523 4.55228 11 4 11H3C2.44772 11 2 10.5523 2 10C2 9.44771 2.44772 9 3 9H4C4.55228 9 5 9.44771 5 10Z",
          fill: "#4A5568"
        },
        {
          d: "M8 16V15H12V16C12 17.1046 11.1046 18 10 18C8.89543 18 8 17.1046 8 16Z",
          fill: "#4A5568"
        },
        {
          d: "M12.0009 14C12.0155 13.6597 12.2076 13.3537 12.4768 13.1411C13.4046 12.4086 14 11.2738 14 10C14 7.79086 12.2091 6 10 6C7.79086 6 6 7.79086 6 10C6 11.2738 6.59545 12.4086 7.52319 13.1411C7.79241 13.3537 7.98451 13.6597 7.99911 14H12.0009Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "lightning-bolt": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M13 10V3L4 14H11L11 21L20 10L13 10Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M11.3006 1.04621C11.7169 1.17743 12 1.56348 12 1.99995V6.99995L16 6.99995C16.3729 6.99995 16.7148 7.20741 16.887 7.53814C17.0592 7.86887 17.0331 8.26794 16.8192 8.57341L9.81924 18.5734C9.56894 18.931 9.11564 19.0849 8.69936 18.9537C8.28309 18.8225 8 18.4364 8 18L8 13H4C3.62713 13 3.28522 12.7925 3.11302 12.4618C2.94083 12.131 2.96694 11.732 3.18077 11.4265L10.1808 1.42649C10.4311 1.06892 10.8844 0.914992 11.3006 1.04621Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  link: link$1,
  "location-marker": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M17.6569 16.6569C16.7202 17.5935 14.7616 19.5521 13.4138 20.8999C12.6327 21.681 11.3677 21.6814 10.5866 20.9003C9.26234 19.576 7.34159 17.6553 6.34315 16.6569C3.21895 13.5327 3.21895 8.46734 6.34315 5.34315C9.46734 2.21895 14.5327 2.21895 17.6569 5.34315C20.781 8.46734 20.781 13.5327 17.6569 16.6569Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        },
        {
          d: "M15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5.05025 4.05025C7.78392 1.31658 12.2161 1.31658 14.9497 4.05025C17.6834 6.78392 17.6834 11.2161 14.9497 13.9497L10 18.8995L5.05025 13.9497C2.31658 11.2161 2.31658 6.78392 5.05025 4.05025ZM10 11C11.1046 11 12 10.1046 12 9C12 7.89543 11.1046 7 10 7C8.89543 7 8 7.89543 8 9C8 10.1046 8.89543 11 10 11Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "lock-closed": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M12 15V17M6 21H18C19.1046 21 20 20.1046 20 19V13C20 11.8954 19.1046 11 18 11H6C4.89543 11 4 11.8954 4 13V19C4 20.1046 4.89543 21 6 21ZM16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V11H16Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5 9V7C5 4.23858 7.23858 2 10 2C12.7614 2 15 4.23858 15 7V9C16.1046 9 17 9.89543 17 11V16C17 17.1046 16.1046 18 15 18H5C3.89543 18 3 17.1046 3 16V11C3 9.89543 3.89543 9 5 9ZM13 7V9H7V7C7 5.34315 8.34315 4 10 4C11.6569 4 13 5.34315 13 7Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "lock-open": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M8 11V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7M12 15V17M6 21H18C19.1046 21 20 20.1046 20 19V13C20 11.8954 19.1046 11 18 11H6C4.89543 11 4 11.8954 4 13V19C4 20.1046 4.89543 21 6 21Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M10 2C7.23858 2 5 4.23858 5 7V9C3.89543 9 3 9.89543 3 11V16C3 17.1046 3.89543 18 5 18H15C16.1046 18 17 17.1046 17 16V11C17 9.89543 16.1046 9 15 9H7V7C7 5.34315 8.34315 4 10 4C11.3965 4 12.5725 4.95512 12.9055 6.24926C13.0432 6.78411 13.5884 7.1061 14.1232 6.96844C14.6581 6.83078 14.9801 6.28559 14.8424 5.75074C14.2874 3.59442 12.3312 2 10 2Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  login,
  logout,
  "mail-open": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M3 19V10.0704C3 9.40165 3.3342 8.77718 3.8906 8.40625L10.8906 3.73959C11.5624 3.29172 12.4376 3.29172 13.1094 3.73959L20.1094 8.40625C20.6658 8.77718 21 9.40165 21 10.0704V19M3 19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19M3 19L9.75 14.5M21 19L14.25 14.5M3 9.99999L9.75 14.5M21 9.99999L14.25 14.5M14.25 14.5L13.1094 15.2604C12.4376 15.7083 11.5624 15.7083 10.8906 15.2604L9.75 14.5",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M2.94 6.4124C2.35524 6.77788 2 7.41882 2 8.1084V15.9999C2 17.1045 2.89543 17.9999 4 17.9999H16C17.1046 17.9999 18 17.1045 18 15.9999V8.1084C18 7.41882 17.6448 6.77788 17.06 6.4124L11.06 2.6624C10.4115 2.25706 9.58854 2.25706 8.94 2.6624L2.94 6.4124ZM5.5547 8.83462C5.09517 8.52826 4.4743 8.65244 4.16795 9.11197C3.8616 9.5715 3.98577 10.1924 4.4453 10.4987L9.4453 13.8321C9.7812 14.056 10.2188 14.056 10.5547 13.8321L15.5547 10.4987C16.0142 10.1924 16.1384 9.5715 15.8321 9.11197C15.5257 8.65244 14.9048 8.52826 14.4453 8.83462L10 11.7981L5.5547 8.83462Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  mail,
  map: map$1,
  "menu-alt-1": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M4 6H20M4 12H12M4 18H20",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3 5C3 4.44772 3.44772 4 4 4H16C16.5523 4 17 4.44772 17 5C17 5.55228 16.5523 6 16 6H4C3.44772 6 3 5.55228 3 5Z",
          fill: "#4A5568"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3 10C3 9.44772 3.44772 9 4 9H10C10.5523 9 11 9.44772 11 10C11 10.5523 10.5523 11 10 11H4C3.44772 11 3 10.5523 3 10Z",
          fill: "#4A5568"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3 15C3 14.4477 3.44772 14 4 14H16C16.5523 14 17 14.4477 17 15C17 15.5523 16.5523 16 16 16H4C3.44772 16 3 15.5523 3 15Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "menu-alt-2": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M4 6H20M4 12H20M4 18H11",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3 5C3 4.44772 3.44772 4 4 4H16C16.5523 4 17 4.44772 17 5C17 5.55228 16.5523 6 16 6H4C3.44772 6 3 5.55228 3 5Z",
          fill: "#4A5568"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3 10C3 9.44772 3.44772 9 4 9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H4C3.44772 11 3 10.5523 3 10Z",
          fill: "#4A5568"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3 15C3 14.4477 3.44772 14 4 14H10C10.5523 14 11 14.4477 11 15C11 15.5523 10.5523 16 10 16H4C3.44772 16 3 15.5523 3 15Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "menu-alt-3": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M4 6H20M4 12H20M13 18H20",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3 5C3 4.44772 3.44772 4 4 4H16C16.5523 4 17 4.44772 17 5C17 5.55228 16.5523 6 16 6H4C3.44772 6 3 5.55228 3 5Z",
          fill: "#4A5568"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3 10C3 9.44772 3.44772 9 4 9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H4C3.44772 11 3 10.5523 3 10Z",
          fill: "#4A5568"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M9 15C9 14.4477 9.44772 14 10 14H16C16.5523 14 17 14.4477 17 15C17 15.5523 16.5523 16 16 16H10C9.44772 16 9 15.5523 9 15Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "menu-alt-4": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M4 8H20M4 16H20",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3 7C3 6.44772 3.44772 6 4 6H16C16.5523 6 17 6.44772 17 7C17 7.55228 16.5523 8 16 8H4C3.44772 8 3 7.55228 3 7Z",
          fill: "#4A5568"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3 13C3 12.4477 3.44772 12 4 12H16C16.5523 12 17 12.4477 17 13C17 13.5523 16.5523 14 16 14H4C3.44772 14 3 13.5523 3 13Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  menu,
  microphone,
  "minus-circle": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M15 12H9M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H7Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "minus-sm": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M18 12H6",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5 10C5 9.44772 5.44772 9 6 9L14 9C14.5523 9 15 9.44772 15 10C15 10.5523 14.5523 11 14 11L6 11C5.44772 11 5 10.5523 5 10Z",
          fill: "#374151"
        }
      ]
    }
  },
  minus,
  moon,
  "music-note": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 19V6L21 3V16M9 19C9 20.1046 7.65685 21 6 21C4.34315 21 3 20.1046 3 19C3 17.8954 4.34315 17 6 17C7.65685 17 9 17.8954 9 19ZM21 16C21 17.1046 19.6569 18 18 18C16.3431 18 15 17.1046 15 16C15 14.8954 16.3431 14 18 14C19.6569 14 21 14.8954 21 16ZM9 10L21 7",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M18 3.00001C18 2.70042 17.8657 2.41661 17.634 2.22667C17.4023 2.03673 17.0977 1.96067 16.8039 2.01943L6.80388 4.01943C6.33646 4.11291 6 4.52333 6 5.00001V14.1138C5.68722 14.0401 5.35064 14 5 14C3.34315 14 2 14.8954 2 16C2 17.1046 3.34315 18 5 18C6.65685 18 7.99999 17.1046 8 16V7.81981L16 6.21981V12.1138C15.6872 12.0401 15.3506 12 15 12C13.3431 12 12 12.8954 12 14C12 15.1046 13.3431 16 15 16C16.6569 16 18 15.1046 18 14V3.00001Z",
          fill: "#374151"
        }
      ]
    }
  },
  newspaper,
  "office-building": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M19 21V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V21M19 21L21 21M19 21H14M5 21L3 21M5 21H10M9 6.99998H10M9 11H10M14 6.99998H15M14 11H15M10 21V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V21M10 21H14",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M4 4C4 2.89543 4.89543 2 6 2H14C15.1046 2 16 2.89543 16 4V16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H13C12.4477 18 12 17.5523 12 17V15C12 14.4477 11.5523 14 11 14H9C8.44772 14 8 14.4477 8 15V17C8 17.5523 7.55228 18 7 18H4C3.44772 18 3 17.5523 3 17C3 16.4477 3.44772 16 4 16V4ZM7 5H9V7H7V5ZM9 9H7V11H9V9ZM11 5H13V7H11V5ZM13 9H11V11H13V9Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "paper-airplane": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M12 19L21 21L12 3L3 21L12 19ZM12 19V11",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M10.8944 2.55279C10.725 2.214 10.3788 2 10 2C9.62124 2 9.27498 2.214 9.10558 2.55279L2.10558 16.5528C1.92823 16.9075 1.97724 17.3335 2.2305 17.6386C2.48376 17.9438 2.89342 18.0705 3.27473 17.9615L8.27472 16.533C8.70402 16.4103 9 16.0179 9 15.5714V11C9 10.4477 9.44772 10 10 10C10.5523 10 11 10.4477 11 11V15.5714C11 16.0179 11.296 16.4103 11.7253 16.533L16.7253 17.9615C17.1066 18.0705 17.5163 17.9438 17.7695 17.6386C18.0228 17.3335 18.0718 16.9075 17.8944 16.5528L10.8944 2.55279Z",
          fill: "#374151"
        }
      ]
    }
  },
  "paper-clip": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M15.1716 7L8.58579 13.5858C7.80474 14.3668 7.80474 15.6332 8.58579 16.4142C9.36684 17.1953 10.6332 17.1953 11.4142 16.4142L17.8284 9.82843C19.3905 8.26633 19.3905 5.73367 17.8284 4.17157C16.2663 2.60948 13.7337 2.60948 12.1716 4.17157L5.75736 10.7574C3.41421 13.1005 3.41421 16.8995 5.75736 19.2426C8.1005 21.5858 11.8995 21.5858 14.2426 19.2426L20.5 13",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M8 4C6.34315 4 5 5.34315 5 7V11C5 13.7614 7.23858 16 10 16C12.7614 16 15 13.7614 15 11V7C15 6.44772 15.4477 6 16 6C16.5523 6 17 6.44772 17 7V11C17 14.866 13.866 18 10 18C6.13401 18 3 14.866 3 11V7C3 4.23858 5.23858 2 8 2C10.7614 2 13 4.23858 13 7V11C13 12.6569 11.6569 14 10 14C8.34315 14 7 12.6569 7 11V7C7 6.44772 7.44772 6 8 6C8.55228 6 9 6.44772 9 7V11C9 11.5523 9.44772 12 10 12C10.5523 12 11 11.5523 11 11V7C11 5.34315 9.65685 4 8 4Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  pause,
  "pencil-alt": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M11 5H6C4.89543 5 4 5.89543 4 7V18C4 19.1046 4.89543 20 6 20H17C18.1046 20 19 19.1046 19 18V13M17.5858 3.58579C18.3668 2.80474 19.6332 2.80474 20.4142 3.58579C21.1953 4.36683 21.1953 5.63316 20.4142 6.41421L11.8284 15H9L9 12.1716L17.5858 3.58579Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M17.4142 2.58579C16.6332 1.80474 15.3668 1.80474 14.5858 2.58579L7 10.1716V13H9.82842L17.4142 5.41421C18.1953 4.63316 18.1953 3.36683 17.4142 2.58579Z",
          fill: "#4A5568"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M2 6C2 4.89543 2.89543 4 4 4H8C8.55228 4 9 4.44772 9 5C9 5.55228 8.55228 6 8 6H4V16H14V12C14 11.4477 14.4477 11 15 11C15.5523 11 16 11.4477 16 12V16C16 17.1046 15.1046 18 14 18H4C2.89543 18 2 17.1046 2 16V6Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  pencil,
  "phone-incoming": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M21 3L15 9M15 9V4M15 9H20M5 3C3.89543 3 3 3.89543 3 5V6C3 14.2843 9.71573 21 18 21H19C20.1046 21 21 20.1046 21 19V15.7208C21 15.2903 20.7246 14.9082 20.3162 14.7721L15.8228 13.2743C15.3507 13.1169 14.8347 13.3306 14.6121 13.7757L13.4835 16.033C11.0388 14.9308 9.06925 12.9612 7.96701 10.5165L10.2243 9.38787C10.6694 9.16531 10.8831 8.64932 10.7257 8.17721L9.22792 3.68377C9.09181 3.27543 8.70967 3 8.27924 3H5Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M14.4142 7L17.7071 3.70711C18.0976 3.31658 18.0976 2.68342 17.7071 2.29289C17.3166 1.90237 16.6834 1.90237 16.2929 2.29289L13 5.58579V4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V7.99931C11 8.00031 11 8.002 11 8.003C11.0004 8.1375 11.0273 8.26575 11.0759 8.38278C11.1236 8.49805 11.1937 8.6062 11.2864 8.70055C11.2907 8.70494 11.2951 8.70929 11.2995 8.7136C11.3938 8.80626 11.502 8.87643 11.6172 8.92412C11.7351 8.97301 11.8644 9 12 9H16C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7H14.4142Z",
          fill: "#4A5568"
        },
        {
          d: "M2 3C2 2.44772 2.44772 2 3 2H5.15287C5.64171 2 6.0589 2.35341 6.13927 2.8356L6.87858 7.27147C6.95075 7.70451 6.73206 8.13397 6.3394 8.3303L4.79126 9.10437C5.90756 11.8783 8.12168 14.0924 10.8956 15.2087L11.6697 13.6606C11.866 13.2679 12.2955 13.0492 12.7285 13.1214L17.1644 13.8607C17.6466 13.9411 18 14.3583 18 14.8471V17C18 17.5523 17.5523 18 17 18H15C7.8203 18 2 12.1797 2 5V3Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "phone-missed-call": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M16 8L18 6M18 6L20 4M18 6L16 4M18 6L20 8M5 3C3.89543 3 3 3.89543 3 5V6C3 14.2843 9.71573 21 18 21H19C20.1046 21 21 20.1046 21 19V15.7208C21 15.2903 20.7246 14.9082 20.3162 14.7721L15.8228 13.2743C15.3507 13.1169 14.8347 13.3306 14.6121 13.7757L13.4835 16.033C11.0388 14.9308 9.06925 12.9612 7.96701 10.5165L10.2243 9.38787C10.6694 9.16531 10.8831 8.64932 10.7257 8.17721L9.22792 3.68377C9.09181 3.27543 8.70967 3 8.27924 3H5Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M2 3C2 2.44772 2.44772 2 3 2H5.15287C5.64171 2 6.0589 2.35341 6.13927 2.8356L6.87858 7.27147C6.95075 7.70451 6.73206 8.13397 6.3394 8.3303L4.79126 9.10437C5.90756 11.8783 8.12168 14.0924 10.8956 15.2087L11.6697 13.6606C11.866 13.2679 12.2955 13.0492 12.7285 13.1214L17.1644 13.8607C17.6466 13.9411 18 14.3583 18 14.8471V17C18 17.5523 17.5523 18 17 18H15C7.8203 18 2 12.1797 2 5V3Z",
          fill: "#374151"
        },
        {
          d: "M16.7071 3.29289C17.0976 3.68342 17.0976 4.31658 16.7071 4.70711L15.4142 6L16.7071 7.29289C17.0976 7.68342 17.0976 8.31658 16.7071 8.70711C16.3166 9.09763 15.6834 9.09763 15.2929 8.70711L14 7.41421L12.7071 8.70711C12.3166 9.09763 11.6834 9.09763 11.2929 8.70711C10.9024 8.31658 10.9024 7.68342 11.2929 7.29289L12.5858 6L11.2929 4.70711C10.9024 4.31658 10.9024 3.68342 11.2929 3.29289C11.6834 2.90237 12.3166 2.90237 12.7071 3.29289L14 4.58579L15.2929 3.29289C15.6834 2.90237 16.3166 2.90237 16.7071 3.29289Z",
          fill: "#374151"
        }
      ]
    }
  },
  "phone-outgoing": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M16 3H21M21 3V8M21 3L15 9M5 3C3.89543 3 3 3.89543 3 5V6C3 14.2843 9.71573 21 18 21H19C20.1046 21 21 20.1046 21 19V15.7208C21 15.2903 20.7246 14.9082 20.3162 14.7721L15.8228 13.2743C15.3507 13.1169 14.8347 13.3306 14.6121 13.7757L13.4835 16.033C11.0388 14.9308 9.06925 12.9612 7.96701 10.5165L10.2243 9.38787C10.6694 9.16531 10.8831 8.64932 10.7257 8.17721L9.22792 3.68377C9.09181 3.27543 8.70967 3 8.27924 3H5Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M17.9241 2.61722C17.8757 2.50014 17.804 2.3904 17.7092 2.29502C17.7078 2.2936 17.7064 2.29219 17.705 2.29078C17.5242 2.11106 17.2751 2 17 2H13C12.4477 2 12 2.44772 12 3C12 3.55228 12.4477 4 13 4H14.5858L11.2929 7.29289C10.9024 7.68342 10.9024 8.31658 11.2929 8.70711C11.6834 9.09763 12.3166 9.09763 12.7071 8.70711L16 5.41421V7C16 7.55228 16.4477 8 17 8C17.5523 8 18 7.55228 18 7V3C18 2.86441 17.973 2.73512 17.9241 2.61722Z",
          fill: "#4A5568"
        },
        {
          d: "M2 3C2 2.44772 2.44772 2 3 2H5.15287C5.64171 2 6.0589 2.35341 6.13927 2.8356L6.87858 7.27147C6.95075 7.70451 6.73206 8.13397 6.3394 8.3303L4.79126 9.10437C5.90756 11.8783 8.12168 14.0924 10.8956 15.2087L11.6697 13.6606C11.866 13.2679 12.2955 13.0492 12.7285 13.1214L17.1644 13.8607C17.6466 13.9411 18 14.3583 18 14.8471V17C18 17.5523 17.5523 18 17 18H15C7.8203 18 2 12.1797 2 5V3Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  phone,
  photograph,
  play,
  "plus-circle": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M12 9V12M12 12V15M12 12H15M12 12H9M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 7C11 6.44772 10.5523 6 10 6C9.44772 6 9 6.44772 9 7V9H7C6.44772 9 6 9.44771 6 10C6 10.5523 6.44772 11 7 11H9V13C9 13.5523 9.44772 14 10 14C10.5523 14 11 13.5523 11 13V11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H11V7Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "plus-sm": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M12 6V12M12 12V18M12 12H18M12 12L6 12",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 5C10.5523 5 11 5.44772 11 6V9L14 9C14.5523 9 15 9.44772 15 10C15 10.5523 14.5523 11 14 11H11V14C11 14.5523 10.5523 15 10 15C9.44771 15 9 14.5523 9 14V11H6C5.44772 11 5 10.5523 5 10C5 9.44771 5.44772 9 6 9L9 9V6C9 5.44772 9.44771 5 10 5Z",
          fill: "#374151"
        }
      ]
    }
  },
  plus,
  "presentation-chart-bar": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M8 13V12M12 13V10M16 13V8M8 21L12 17L16 21M3 4H21M4 4H20V16C20 16.5523 19.5523 17 19 17H5C4.44772 17 4 16.5523 4 16V4Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3 3C2.44772 3 2 3.44772 2 4C2 4.55228 2.44772 5 3 5V13C3 14.1046 3.89543 15 5 15H7.58579L6.29289 16.2929C5.90237 16.6834 5.90237 17.3166 6.29289 17.7071C6.68342 18.0976 7.31658 18.0976 7.70711 17.7071L10 15.4142L12.2929 17.7071C12.6834 18.0976 13.3166 18.0976 13.7071 17.7071C14.0976 17.3166 14.0976 16.6834 13.7071 16.2929L12.4142 15H15C16.1046 15 17 14.1046 17 13V5C17.5523 5 18 4.55228 18 4C18 3.44772 17.5523 3 17 3H3ZM14 7C14 6.44772 13.5523 6 13 6C12.4477 6 12 6.44772 12 7V11C12 11.5523 12.4477 12 13 12C13.5523 12 14 11.5523 14 11V7ZM11 8C11 7.44772 10.5523 7 10 7C9.44772 7 9 7.44772 9 8V11C9 11.5523 9.44772 12 10 12C10.5523 12 11 11.5523 11 11V8ZM8 9C8 8.44772 7.55228 8 7 8C6.44772 8 6 8.44772 6 9V11C6 11.5523 6.44772 12 7 12C7.55228 12 8 11.5523 8 11V9Z",
          fill: "#374151"
        }
      ]
    }
  },
  "presentation-chart-line": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M7 12L10 9L13 12L17 8M8 21L12 17L16 21M3 4H21M4 4H20V16C20 16.5523 19.5523 17 19 17H5C4.44772 17 4 16.5523 4 16V4Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3 3C2.44772 3 2 3.44772 2 4C2 4.55228 2.44772 5 3 5V13C3 14.1046 3.89543 15 5 15H7.58579L6.29289 16.2929C5.90237 16.6834 5.90237 17.3166 6.29289 17.7071C6.68342 18.0976 7.31658 18.0976 7.70711 17.7071L10 15.4142L12.2929 17.7071C12.6834 18.0976 13.3166 18.0976 13.7071 17.7071C14.0976 17.3166 14.0976 16.6834 13.7071 16.2929L12.4142 15H15C16.1046 15 17 14.1046 17 13V5C17.5523 5 18 4.55228 18 4C18 3.44772 17.5523 3 17 3H3ZM14.7071 7.70711C15.0976 7.31658 15.0976 6.68342 14.7071 6.29289C14.3166 5.90237 13.6834 5.90237 13.2929 6.29289L10 9.58579L8.70711 8.29289C8.31658 7.90237 7.68342 7.90237 7.29289 8.29289L5.29289 10.2929C4.90237 10.6834 4.90237 11.3166 5.29289 11.7071C5.68342 12.0976 6.31658 12.0976 6.70711 11.7071L8 10.4142L9.29289 11.7071C9.68342 12.0976 10.3166 12.0976 10.7071 11.7071L14.7071 7.70711Z",
          fill: "#374151"
        }
      ]
    }
  },
  printer,
  puzzle,
  qrcode,
  "question-mark-circle": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M8.22766 9C8.77678 7.83481 10.2584 7 12.0001 7C14.2092 7 16.0001 8.34315 16.0001 10C16.0001 11.3994 14.7224 12.5751 12.9943 12.9066C12.4519 13.0106 12.0001 13.4477 12.0001 14M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM10 7C9.63113 7 9.3076 7.19922 9.13318 7.50073C8.85664 7.97879 8.24491 8.14215 7.76685 7.86561C7.28879 7.58906 7.12543 6.97733 7.40197 6.49927C7.91918 5.60518 8.88833 5 10 5C11.6569 5 13 6.34315 13 8C13 9.30622 12.1652 10.4175 11 10.8293V11C11 11.5523 10.5523 12 10 12C9.44773 12 9.00001 11.5523 9.00001 11V10C9.00001 9.44772 9.44773 9 10 9C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7ZM10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "receipt-refund": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M16 15V14C16 11.7909 14.2091 10 12 10H8M8 10L11 13M8 10L11 7M20 21V5C20 3.89543 19.1046 3 18 3H6C4.89543 3 4 3.89543 4 5V21L8 19L12 21L16 19L20 21Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5 2C3.89543 2 3 2.89543 3 4V18L6.5 16L10 18L13.5 16L17 18V4C17 2.89543 16.1046 2 15 2H5ZM9.70711 5.70711C10.0976 5.31658 10.0976 4.68342 9.70711 4.29289C9.31658 3.90237 8.68342 3.90237 8.29289 4.29289L5.29289 7.29289C4.90237 7.68342 4.90237 8.31658 5.29289 8.70711L8.29289 11.7071C8.68342 12.0976 9.31658 12.0976 9.70711 11.7071C10.0976 11.3166 10.0976 10.6834 9.70711 10.2929L8.41421 9H10C11.6569 9 13 10.3431 13 12V13C13 13.5523 13.4477 14 14 14C14.5523 14 15 13.5523 15 13V12C15 9.23858 12.7614 7 10 7H8.41421L9.70711 5.70711Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "receipt-tax": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 14L15 8M9.50003 8.5H9.51003M14.5 13.5H14.51M19 21V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V21L8.5 19L12 21L15.5 19L19 21ZM10 8.5C10 8.77614 9.77614 9 9.5 9C9.22386 9 9 8.77614 9 8.5C9 8.22386 9.22386 8 9.5 8C9.77614 8 10 8.22386 10 8.5ZM15 13.5C15 13.7761 14.7761 14 14.5 14C14.2239 14 14 13.7761 14 13.5C14 13.2239 14.2239 13 14.5 13C14.7761 13 15 13.2239 15 13.5Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5 2C3.89543 2 3 2.89543 3 4V18L6.5 16L10 18L13.5 16L17 18V4C17 2.89543 16.1046 2 15 2H5ZM7.5 5C6.67157 5 6 5.67157 6 6.5C6 7.32843 6.67157 8 7.5 8C8.32843 8 9 7.32843 9 6.5C9 5.67157 8.32843 5 7.5 5ZM13.7071 5.29289C13.3166 4.90237 12.6834 4.90237 12.2929 5.29289L6.29289 11.2929C5.90237 11.6834 5.90237 12.3166 6.29289 12.7071C6.68342 13.0976 7.31658 13.0976 7.70711 12.7071L13.7071 6.70711C14.0976 6.31658 14.0976 5.68342 13.7071 5.29289ZM12.5 10C11.6716 10 11 10.6716 11 11.5C11 12.3284 11.6716 13 12.5 13C13.3284 13 14 12.3284 14 11.5C14 10.6716 13.3284 10 12.5 10Z",
          fill: "#374151"
        }
      ]
    }
  },
  refresh,
  reply,
  rewind,
  rss,
  "save-as": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M17 16V18C17 19.1046 16.1046 20 15 20H5C3.89543 20 3 19.1046 3 18V11C3 9.89543 3.89543 9 5 9H7M10 5H9C7.89543 5 7 5.89543 7 7V14C7 15.1046 7.89543 16 9 16H19C20.1046 16 21 15.1046 21 14V7C21 5.89543 20.1046 5 19 5H18M17 9L14 12M14 12L11 9M14 12L14 3",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9.70711 7.29289C9.31658 6.90237 8.68342 6.90237 8.29289 7.29289C7.90237 7.68342 7.90237 8.31658 8.29289 8.70711L11.2929 11.7071C11.6834 12.0976 12.3166 12.0976 12.7071 11.7071L15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289C15.3166 6.90237 14.6834 6.90237 14.2929 7.29289L13 8.58579L13 5H16C17.1046 5 18 5.89543 18 7V12C18 13.1046 17.1046 14 16 14H8C6.89543 14 6 13.1046 6 12V7C6 5.89543 6.89543 5 8 5H11L11 8.58579L9.70711 7.29289Z",
          fill: "#374151"
        },
        {
          d: "M11 3C11 2.44772 11.4477 2 12 2C12.5523 2 13 2.44772 13 3L13 5H11L11 3Z",
          fill: "#374151"
        },
        {
          d: "M4 9C2.89543 9 2 9.89543 2 11V16C2 17.1046 2.89543 18 4 18H12C13.1046 18 14 17.1046 14 16H4V9Z",
          fill: "#374151"
        }
      ]
    }
  },
  save: save$1,
  scale,
  scissors,
  "search-circle": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M8 16L10.8787 13.1213M10.8787 13.1213C11.4216 13.6642 12.1716 14 13 14C14.6569 14 16 12.6569 16 11C16 9.34315 14.6569 8 13 8C11.3431 8 10 9.34315 10 11C10 11.8284 10.3358 12.5784 10.8787 13.1213ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 9C9 7.89543 9.89543 7 11 7C12.1046 7 13 7.89543 13 9C13 10.1046 12.1046 11 11 11C10.4474 11 9.94881 10.7772 9.58579 10.4142C9.22276 10.0512 9 9.55256 9 9Z",
          fill: "#374151"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 5C8.79086 5 7 6.79086 7 9C7 9.74138 7.20229 10.4364 7.55397 11.0318L5.29289 13.2929C4.90237 13.6834 4.90237 14.3166 5.29289 14.7071C5.68342 15.0976 6.31658 15.0976 6.70711 14.7071L8.96818 12.446C9.56362 12.7977 10.2586 13 11 13C13.2091 13 15 11.2091 15 9C15 6.79086 13.2091 5 11 5Z",
          fill: "#374151"
        }
      ]
    }
  },
  search,
  selector,
  server,
  share,
  "shield-check": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 12L11 14L15 10M20.6179 5.98434C20.4132 5.99472 20.2072 5.99997 20 5.99997C16.9265 5.99997 14.123 4.84453 11.9999 2.94434C9.87691 4.84446 7.07339 5.99985 4 5.99985C3.79277 5.99985 3.58678 5.9946 3.38213 5.98422C3.1327 6.94783 3 7.95842 3 9.00001C3 14.5915 6.82432 19.2898 12 20.622C17.1757 19.2898 21 14.5915 21 9.00001C21 7.95847 20.8673 6.94791 20.6179 5.98434Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M2.16611 4.99891C5.17437 4.95809 7.91528 3.81033 10 1.94446C12.0847 3.81033 14.8256 4.95809 17.8339 4.99891C17.9431 5.64968 18 6.31821 18 7.00003C18 12.2249 14.6608 16.6698 10 18.3172C5.33923 16.6698 2 12.2249 2 7.00003C2 6.31821 2.05686 5.64968 2.16611 4.99891ZM13.7071 8.70711C14.0976 8.31658 14.0976 7.68342 13.7071 7.29289C13.3166 6.90237 12.6834 6.90237 12.2929 7.29289L9 10.5858L7.70711 9.29289C7.31658 8.90237 6.68342 8.90237 6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071L8.29289 12.7071C8.68342 13.0976 9.31658 13.0976 9.70711 12.7071L13.7071 8.70711Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "shield-exclamation": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M20.6179 5.98434C20.4132 5.99472 20.2072 5.99997 20 5.99997C16.9265 5.99997 14.123 4.84453 11.9999 2.94434C9.87691 4.84446 7.07339 5.99985 4 5.99985C3.79277 5.99985 3.58678 5.9946 3.38213 5.98422C3.1327 6.94783 3 7.95842 3 9.00001C3 14.5915 6.82432 19.2898 12 20.622C17.1757 19.2898 21 14.5915 21 9.00001C21 7.95847 20.8673 6.94791 20.6179 5.98434Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        },
        {
          d: "M12 9V11M12 15H12.01",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 1.94446C7.91528 3.81033 5.17437 4.95809 2.16611 4.99891C2.05686 5.64968 2 6.31821 2 7.00003C2 12.2249 5.33923 16.6698 10 18.3172C14.6608 16.6698 18 12.2249 18 7.00003C18 6.31821 17.9431 5.64968 17.8339 4.99891C14.8256 4.95809 12.0847 3.81033 10 1.94446ZM11 14C11 14.5523 10.5523 15 10 15C9.44771 15 9 14.5523 9 14C9 13.4477 9.44771 13 10 13C10.5523 13 11 13.4477 11 14ZM11 7C11 6.44772 10.5523 6 10 6C9.44771 6 9 6.44772 9 7V10C9 10.5523 9.44771 11 10 11C10.5523 11 11 10.5523 11 10V7Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "shopping-bag": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V11M5 9H19L20 21H4L5 9Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 2C7.79086 2 6 3.79086 6 6V7H5C4.49046 7 4.06239 7.38314 4.00612 7.88957L3.00612 16.8896C2.97471 17.1723 3.06518 17.455 3.25488 17.6669C3.44458 17.8789 3.71556 18 4 18H16C16.2844 18 16.5554 17.8789 16.7451 17.6669C16.9348 17.455 17.0253 17.1723 16.9939 16.8896L15.9939 7.88957C15.9376 7.38314 15.5096 7 15 7H14V6C14 3.79086 12.2091 2 10 2ZM12 7V6C12 4.89543 11.1046 4 10 4C8.89543 4 8 4.89543 8 6V7H12ZM6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10ZM13 9C12.4477 9 12 9.44772 12 10C12 10.5523 12.4477 11 13 11C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9Z",
          fill: "#374151"
        }
      ]
    }
  },
  "shopping-cart": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M3 3H5L5.4 5M7 13H17L21 5H5.4M7 13L5.4 5M7 13L4.70711 15.2929C4.07714 15.9229 4.52331 17 5.41421 17H17M17 17C15.8954 17 15 17.8954 15 19C15 20.1046 15.8954 21 17 21C18.1046 21 19 20.1046 19 19C19 17.8954 18.1046 17 17 17ZM9 19C9 20.1046 8.10457 21 7 21C5.89543 21 5 20.1046 5 19C5 17.8954 5.89543 17 7 17C8.10457 17 9 17.8954 9 19Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M3 1C2.44772 1 2 1.44772 2 2C2 2.55228 2.44772 3 3 3H4.21922L4.52478 4.22224C4.52799 4.23637 4.5315 4.25039 4.5353 4.26429L5.89253 9.69321L4.99995 10.5858C3.74002 11.8457 4.63235 14 6.41416 14H15C15.5522 14 16 13.5523 16 13C16 12.4477 15.5522 12 15 12L6.41417 12L7.41416 11H14C14.3788 11 14.725 10.786 14.8944 10.4472L17.8944 4.44721C18.0494 4.13723 18.0329 3.76909 17.8507 3.47427C17.6684 3.17945 17.3466 3 17 3H6.28078L5.97014 1.75746C5.85885 1.3123 5.45887 1 5 1H3Z",
          fill: "#4B5563"
        },
        {
          d: "M16 16.5C16 17.3284 15.3284 18 14.5 18C13.6716 18 13 17.3284 13 16.5C13 15.6716 13.6716 15 14.5 15C15.3284 15 16 15.6716 16 16.5Z",
          fill: "#4B5563"
        },
        {
          d: "M6.5 18C7.32843 18 8 17.3284 8 16.5C8 15.6716 7.32843 15 6.5 15C5.67157 15 5 15.6716 5 16.5C5 17.3284 5.67157 18 6.5 18Z",
          fill: "#4B5563"
        }
      ]
    }
  },
  "sort-ascending": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M3 4H16M3 8H12M3 12H9M13 12L17 8M17 8L21 12M17 8V20",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M3 3C2.44772 3 2 3.44772 2 4C2 4.55228 2.44772 5 3 5H14C14.5523 5 15 4.55228 15 4C15 3.44772 14.5523 3 14 3H3Z",
          fill: "#4A5568"
        },
        {
          d: "M3 7C2.44772 7 2 7.44772 2 8C2 8.55228 2.44772 9 3 9H8C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7H3Z",
          fill: "#4A5568"
        },
        {
          d: "M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H7C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11H3Z",
          fill: "#4A5568"
        },
        {
          d: "M13 16C13 16.5523 13.4477 17 14 17C14.5523 17 15 16.5523 15 16L15 10.4142L16.2929 11.7071C16.6834 12.0976 17.3166 12.0976 17.7071 11.7071C18.0976 11.3166 18.0976 10.6834 17.7071 10.2929L14.7071 7.29289C14.5196 7.10536 14.2652 7 14 7C13.7348 7 13.4804 7.10536 13.2929 7.29289L10.2929 10.2929C9.90237 10.6834 9.90237 11.3166 10.2929 11.7071C10.6834 12.0976 11.3166 12.0976 11.7071 11.7071L13 10.4142L13 16Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "sort-descending": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M3 4H16M3 8H12M3 12H12M17 8V20M17 20L13 16M17 20L21 16",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M3 3C2.44772 3 2 3.44772 2 4C2 4.55228 2.44772 5 3 5H14C14.5523 5 15 4.55228 15 4C15 3.44772 14.5523 3 14 3H3Z",
          fill: "#4A5568"
        },
        {
          d: "M3 7C2.44772 7 2 7.44772 2 8C2 8.55228 2.44772 9 3 9H10C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7H3Z",
          fill: "#4A5568"
        },
        {
          d: "M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H7C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11H3Z",
          fill: "#4A5568"
        },
        {
          d: "M15 8C15 7.44772 14.5523 7 14 7C13.4477 7 13 7.44771 13 8L13 13.5858L11.7071 12.2929C11.3166 11.9024 10.6834 11.9024 10.2929 12.2929C9.90237 12.6834 9.90237 13.3166 10.2929 13.7071L13.2929 16.7071C13.4804 16.8946 13.7348 17 14 17C14.2652 17 14.5196 16.8946 14.7071 16.7071L17.7071 13.7071C18.0976 13.3166 18.0976 12.6834 17.7071 12.2929C17.3166 11.9024 16.6834 11.9024 16.2929 12.2929L15 13.5858L15 8Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  sparkles,
  speakerphone,
  star,
  "status-offline": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M18.364 5.63605C21.8787 9.15077 21.8787 14.8493 18.364 18.364M18.364 18.364L15.5355 15.5355M18.364 18.364L21 21M15.5355 8.46447C17.4882 10.4171 17.4882 13.5829 15.5355 15.5355M15.5355 15.5355L12.7071 12.7071M8.46447 15.5355C7.66839 14.7395 7.19687 13.7417 7.04991 12.7068M5.63604 18.364C3.13732 15.8652 2.41501 12.2628 3.46913 9.12598M11.2929 11.2929C11.4739 11.1119 11.7239 11 12 11C12.5523 11 13 11.4477 13 12C13 12.2761 12.8881 12.5261 12.7071 12.7071M11.2929 11.2929L3 3M11.2929 11.2929L12.7071 12.7071",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M3.70711 2.29289C3.31658 1.90237 2.68342 1.90237 2.29289 2.29289C1.90237 2.68342 1.90237 3.31658 2.29289 3.70711L9.21426 10.6285C9.26325 10.6906 9.31947 10.7469 9.38164 10.7958L16.2929 17.7071C16.6834 18.0976 17.3166 18.0976 17.7071 17.7071C18.0976 17.3166 18.0976 16.6834 17.7071 16.2929L17.0323 15.6181C19.8626 12.0844 19.6398 6.91177 16.3641 3.63603C15.9736 3.24551 15.3404 3.24551 14.9499 3.63603C14.5593 4.02656 14.5593 4.65972 14.9499 5.05025C17.4435 7.54386 17.6625 11.4508 15.6068 14.1926L14.172 12.7578C15.4582 10.8164 15.2461 8.17494 13.5357 6.46446C13.1451 6.07394 12.512 6.07394 12.1214 6.46446C11.7309 6.85498 11.7309 7.48815 12.1214 7.87867C13.0451 8.80233 13.2406 10.1784 12.7078 11.2936L10.7164 9.30219C10.7103 9.29595 10.7042 9.28979 10.6979 9.2837L3.70711 2.29289Z",
          fill: "#374151"
        },
        {
          d: "M3.23766 8.1865C3.38012 7.65291 3.06305 7.10485 2.52946 6.96239C1.99586 6.81992 1.44781 7.137 1.30535 7.67059C0.5045 10.6701 1.27982 14.0074 3.63615 16.3637C4.02667 16.7542 4.65984 16.7542 5.05036 16.3637C5.44089 15.9732 5.44089 15.34 5.05036 14.9495C3.21924 13.1184 2.6134 10.5246 3.23766 8.1865Z",
          fill: "#374151"
        },
        {
          d: "M7.40075 11.4995C7.12434 11.0214 6.51266 10.8578 6.03452 11.1343C5.55639 11.4107 5.39285 12.0223 5.66926 12.5005C5.88367 12.8714 6.14907 13.2198 6.46458 13.5353C6.85511 13.9258 7.48827 13.9258 7.8788 13.5353C8.26932 13.1448 8.26932 12.5116 7.8788 12.1211C7.68771 11.93 7.52865 11.7208 7.40075 11.4995Z",
          fill: "#374151"
        }
      ]
    }
  },
  "status-online": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M5.63604 18.3639C2.12132 14.8492 2.12132 9.15071 5.63604 5.63599M18.364 5.63599C21.8787 9.15071 21.8787 14.8492 18.364 18.3639M8.46447 15.5355C6.51184 13.5829 6.51184 10.417 8.46447 8.46441M15.5355 8.46441C17.4882 10.417 17.4882 13.5829 15.5355 15.5355M13 11.9999C13 12.5522 12.5523 12.9999 12 12.9999C11.4477 12.9999 11 12.5522 11 11.9999C11 11.4477 11.4477 10.9999 12 10.9999C12.5523 10.9999 13 11.4477 13 11.9999Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5.05025 3.63579C5.44078 4.02631 5.44078 4.65948 5.05025 5.05C2.31658 7.78367 2.31658 12.2158 5.05025 14.9495C5.44078 15.34 5.44078 15.9732 5.05025 16.3637C4.65973 16.7542 4.02656 16.7542 3.63604 16.3637C0.12132 12.849 0.12132 7.15051 3.63604 3.63579C4.02656 3.24526 4.65973 3.24526 5.05025 3.63579ZM14.9498 3.63602C15.3403 3.2455 15.9735 3.2455 16.364 3.63602C19.8787 7.15074 19.8787 12.8492 16.364 16.3639C15.9735 16.7545 15.3403 16.7545 14.9498 16.3639C14.5592 15.9734 14.5592 15.3403 14.9498 14.9497C17.6834 12.2161 17.6834 7.78391 14.9498 5.05023C14.5592 4.65971 14.5592 4.02655 14.9498 3.63602ZM7.87869 6.46422C8.26921 6.85474 8.26921 7.48791 7.87869 7.87843C6.70711 9.05 6.70711 10.9495 7.87869 12.1211C8.26921 12.5116 8.26921 13.1448 7.87868 13.5353C7.48816 13.9258 6.855 13.9258 6.46447 13.5353C4.51185 11.5827 4.51185 8.41684 6.46447 6.46422C6.855 6.07369 7.48816 6.07369 7.87869 6.46422ZM12.1213 6.46445C12.5119 6.07392 13.145 6.07392 13.5355 6.46445C15.4882 8.41707 15.4882 11.5829 13.5355 13.5355C13.145 13.926 12.5119 13.926 12.1213 13.5355C11.7308 13.145 11.7308 12.5118 12.1213 12.1213C13.2929 10.9497 13.2929 9.05023 12.1213 7.87866C11.7308 7.48814 11.7308 6.85497 12.1213 6.46445ZM10 8.99998C10.5523 8.99998 11 9.4477 11 9.99998V10.01C11 10.5623 10.5523 11.01 10 11.01C9.44772 11.01 9 10.5623 9 10.01V9.99998C9 9.4477 9.44772 8.99998 10 8.99998Z",
          fill: "#374151"
        }
      ]
    }
  },
  stop,
  sun,
  support,
  "switch-horizontal": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M8 7L20 7M20 7L16 3M20 7L16 11M16 17L4 17M4 17L8 21M4 17L8 13",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M8 5C7.44772 5 7 5.44771 7 6C7 6.55228 7.44772 7 8 7L13.5858 7L12.2929 8.29289C11.9024 8.68342 11.9024 9.31658 12.2929 9.70711C12.6834 10.0976 13.3166 10.0976 13.7071 9.70711L16.7071 6.70711C16.8946 6.51957 17 6.26522 17 6C17 5.73478 16.8946 5.48043 16.7071 5.29289L13.7071 2.29289C13.3166 1.90237 12.6834 1.90237 12.2929 2.29289C11.9024 2.68342 11.9024 3.31658 12.2929 3.70711L13.5858 5L8 5Z",
          fill: "#4A5568"
        },
        {
          d: "M12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13L6.41421 13L7.70711 11.7071C8.09763 11.3166 8.09763 10.6834 7.70711 10.2929C7.31658 9.90237 6.68342 9.90237 6.29289 10.2929L3.29289 13.2929C3.10536 13.4804 3 13.7348 3 14C3 14.2652 3.10536 14.5196 3.29289 14.7071L6.29289 17.7071C6.68342 18.0976 7.31658 18.0976 7.70711 17.7071C8.09763 17.3166 8.09763 16.6834 7.70711 16.2929L6.41421 15L12 15Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "switch-vertical": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M7 16V4M7 4L3 8M7 4L11 8M17 8V20M17 20L21 16M17 20L13 16",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M5 12C5 12.5523 5.44771 13 6 13C6.55228 13 7 12.5523 7 12L7 6.41421L8.29289 7.70711C8.68342 8.09763 9.31658 8.09763 9.70711 7.70711C10.0976 7.31658 10.0976 6.68342 9.70711 6.29289L6.70711 3.29289C6.51957 3.10536 6.26522 3 6 3C5.73478 3 5.48043 3.10536 5.29289 3.29289L2.29289 6.29289C1.90237 6.68342 1.90237 7.31658 2.29289 7.70711C2.68342 8.09763 3.31658 8.09763 3.70711 7.70711L5 6.41421L5 12Z",
          fill: "#4A5568"
        },
        {
          d: "M15 8C15 7.44772 14.5523 7 14 7C13.4477 7 13 7.44772 13 8L13 13.5858L11.7071 12.2929C11.3166 11.9024 10.6834 11.9024 10.2929 12.2929C9.90237 12.6834 9.90237 13.3166 10.2929 13.7071L13.2929 16.7071C13.4804 16.8946 13.7348 17 14 17C14.2652 17 14.5196 16.8946 14.7071 16.7071L17.7071 13.7071C18.0976 13.3166 18.0976 12.6834 17.7071 12.2929C17.3166 11.9024 16.6834 11.9024 16.2929 12.2929L15 13.5858L15 8Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  table,
  tag,
  template: template$1,
  terminal,
  "thumb-down": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9.99991 14H5.23598C3.74922 14 2.78222 12.4354 3.44712 11.1056L6.94712 4.10557C7.28591 3.42801 7.97843 3 8.73598 3H12.7537C12.9172 3 13.0801 3.02005 13.2388 3.05972L16.9999 4M9.99991 14V19C9.99991 20.1046 10.8953 21 11.9999 21H12.0954C12.5949 21 12.9999 20.595 12.9999 20.0955C12.9999 19.3812 13.2113 18.6828 13.6076 18.0885L16.9999 13V4M9.99991 14H11.9999M16.9999 4H18.9999C20.1045 4 20.9999 4.89543 20.9999 6V12C20.9999 13.1046 20.1045 14 18.9999 14H16.4999",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M18 9.5C18 10.3284 17.3285 11 16.5 11C15.6716 11 15 10.3284 15 9.5V3.5C15 2.67157 15.6716 2 16.5 2C17.3285 2 18 2.67157 18 3.5V9.5Z",
          fill: "#374151"
        },
        {
          d: "M14 9.66667V4.23607C14 3.47852 13.572 2.786 12.8945 2.44721L12.8446 2.42229C12.2892 2.14458 11.6767 2 11.0558 2L5.63964 2C4.68628 2 3.86545 2.67292 3.67848 3.60777L2.47848 9.60777C2.23097 10.8453 3.17755 12 4.43964 12H8.00004V16C8.00004 17.1046 8.89547 18 10 18C10.5523 18 11 17.5523 11 17V16.3333C11 15.4679 11.2807 14.6257 11.8 13.9333L13.2 12.0667C13.7193 11.3743 14 10.5321 14 9.66667Z",
          fill: "#374151"
        }
      ]
    }
  },
  "thumb-up": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M14 10H18.7639C20.2507 10 21.2177 11.5646 20.5528 12.8944L17.0528 19.8944C16.714 20.572 16.0215 21 15.2639 21H11.2462C11.0827 21 10.9198 20.9799 10.7611 20.9403L7 20M14 10V5C14 3.89543 13.1046 3 12 3H11.9045C11.405 3 11 3.40497 11 3.90453C11 4.61883 10.7886 5.31715 10.3923 5.91149L7 11V20M14 10H12M7 20H5C3.89543 20 3 19.1046 3 18V12C3 10.8954 3.89543 10 5 10H7.5",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M2 10.5C2 9.67157 2.67157 9 3.5 9C4.32843 9 5 9.67157 5 10.5V16.5C5 17.3284 4.32843 18 3.5 18C2.67157 18 2 17.3284 2 16.5V10.5Z",
          fill: "#374151"
        },
        {
          d: "M6 10.3333V15.7639C6 16.5215 6.428 17.214 7.10557 17.5528L7.15542 17.5777C7.71084 17.8554 8.32329 18 8.94427 18H14.3604C15.3138 18 16.1346 17.3271 16.3216 16.3922L17.5216 10.3922C17.7691 9.15465 16.8225 8 15.5604 8H12V4C12 2.89543 11.1046 2 10 2C9.44772 2 9 2.44772 9 3V3.66667C9 4.53215 8.71929 5.37428 8.2 6.06667L6.8 7.93333C6.28071 8.62572 6 9.46785 6 10.3333Z",
          fill: "#374151"
        }
      ]
    }
  },
  ticket,
  translate: translate$1,
  trash,
  "trending-down": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M13 17H21M21 17V9M21 17L13 9L9 13L3 7",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M12 13C11.4477 13 11 13.4477 11 14C11 14.5523 11.4477 15 12 15H17C17.5523 15 18 14.5523 18 14V9C18 8.44772 17.5523 8 17 8C16.4477 8 16 8.44772 16 9V11.5858L11.7071 7.29289C11.3166 6.90237 10.6834 6.90237 10.2929 7.29289L8 9.58579L3.70711 5.29289C3.31658 4.90237 2.68342 4.90237 2.29289 5.29289C1.90237 5.68342 1.90237 6.31658 2.29289 6.70711L7.29289 11.7071C7.68342 12.0976 8.31658 12.0976 8.70711 11.7071L11 9.41421L14.5858 13H12Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "trending-up": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M13 7H21M21 7V15M21 7L13 15L9 11L3 17",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M12 7C11.4477 7 11 6.55228 11 6C11 5.44772 11.4477 5 12 5H17C17.5523 5 18 5.44772 18 6V11C18 11.5523 17.5523 12 17 12C16.4477 12 16 11.5523 16 11V8.41421L11.7071 12.7071C11.3166 13.0976 10.6834 13.0976 10.2929 12.7071L8 10.4142L3.70711 14.7071C3.31658 15.0976 2.68342 15.0976 2.29289 14.7071C1.90237 14.3166 1.90237 13.6834 2.29289 13.2929L7.29289 8.29289C7.68342 7.90237 8.31658 7.90237 8.70711 8.29289L11 10.5858L14.5858 7H12Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  truck,
  upload,
  "user-add": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M18 9V12M18 12V15M18 12H21M18 12H15M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7ZM3 20C3 16.6863 5.68629 14 9 14C12.3137 14 15 16.6863 15 20V21H3V20Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M8 9C9.65685 9 11 7.65685 11 6C11 4.34315 9.65685 3 8 3C6.34315 3 5 4.34315 5 6C5 7.65685 6.34315 9 8 9Z",
          fill: "#4A5568"
        },
        {
          d: "M8 11C11.3137 11 14 13.6863 14 17H2C2 13.6863 4.68629 11 8 11Z",
          fill: "#4A5568"
        },
        {
          d: "M16 7C16 6.44772 15.5523 6 15 6C14.4477 6 14 6.44772 14 7V8H13C12.4477 8 12 8.44771 12 9C12 9.55228 12.4477 10 13 10H14V11C14 11.5523 14.4477 12 15 12C15.5523 12 16 11.5523 16 11V10H17C17.5523 10 18 9.55228 18 9C18 8.44772 17.5523 8 17 8H16V7Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "user-circle": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M5.12104 17.8037C7.15267 16.6554 9.4998 16 12 16C14.5002 16 16.8473 16.6554 18.879 17.8037M15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "user-group": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M17 20H22V18C22 16.3431 20.6569 15 19 15C18.0444 15 17.1931 15.4468 16.6438 16.1429M17 20H7M17 20V18C17 17.3438 16.8736 16.717 16.6438 16.1429M7 20H2V18C2 16.3431 3.34315 15 5 15C5.95561 15 6.80686 15.4468 7.35625 16.1429M7 20V18C7 17.3438 7.12642 16.717 7.35625 16.1429M7.35625 16.1429C8.0935 14.301 9.89482 13 12 13C14.1052 13 15.9065 14.301 16.6438 16.1429M15 7C15 8.65685 13.6569 10 12 10C10.3431 10 9 8.65685 9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7ZM21 10C21 11.1046 20.1046 12 19 12C17.8954 12 17 11.1046 17 10C17 8.89543 17.8954 8 19 8C20.1046 8 21 8.89543 21 10ZM7 10C7 11.1046 6.10457 12 5 12C3.89543 12 3 11.1046 3 10C3 8.89543 3.89543 8 5 8C6.10457 8 7 8.89543 7 10Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M13 6C13 7.65685 11.6569 9 10 9C8.34315 9 7 7.65685 7 6C7 4.34315 8.34315 3 10 3C11.6569 3 13 4.34315 13 6Z",
          fill: "#4A5568"
        },
        {
          d: "M18 8C18 9.10457 17.1046 10 16 10C14.8954 10 14 9.10457 14 8C14 6.89543 14.8954 6 16 6C17.1046 6 18 6.89543 18 8Z",
          fill: "#4A5568"
        },
        {
          d: "M14 15C14 12.7909 12.2091 11 10 11C7.79086 11 6 12.7909 6 15V18H14V15Z",
          fill: "#4A5568"
        },
        {
          d: "M6 8C6 9.10457 5.10457 10 4 10C2.89543 10 2 9.10457 2 8C2 6.89543 2.89543 6 4 6C5.10457 6 6 6.89543 6 8Z",
          fill: "#4A5568"
        },
        {
          d: "M16 18V15C16 13.9459 15.7282 12.9552 15.2507 12.0943C15.4902 12.0327 15.7413 12 16 12C17.6569 12 19 13.3431 19 15V18H16Z",
          fill: "#4A5568"
        },
        {
          d: "M4.74926 12.0943C4.27185 12.9552 4 13.9459 4 15V18H1V15C1 13.3431 2.34315 12 4 12C4.25871 12 4.50977 12.0327 4.74926 12.0943Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "user-remove": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        },
        {
          d: "M9 14C5.68629 14 3 16.6863 3 20V21H15V20C15 16.6863 12.3137 14 9 14Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        },
        {
          d: "M21 12L15 12",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M11 6C11 7.65685 9.65685 9 8 9C6.34315 9 5 7.65685 5 6C5 4.34315 6.34315 3 8 3C9.65685 3 11 4.34315 11 6Z",
          fill: "#4A5568"
        },
        {
          d: "M14 17C14 13.6863 11.3137 11 8 11C4.68629 11 2 13.6863 2 17H14Z",
          fill: "#4A5568"
        },
        {
          d: "M13 8C12.4477 8 12 8.44771 12 9C12 9.55229 12.4477 10 13 10H17C17.5523 10 18 9.55229 18 9C18 8.44771 17.5523 8 17 8H13Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  user,
  users,
  variable,
  "video-camera": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M15 10L19.5528 7.72361C20.2177 7.39116 21 7.87465 21 8.61803V15.382C21 16.1253 20.2177 16.6088 19.5528 16.2764L15 14M5 18H13C14.1046 18 15 17.1046 15 16V8C15 6.89543 14.1046 6 13 6H5C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M2 6C2 4.89543 2.89543 4 4 4H10C11.1046 4 12 4.89543 12 6V14C12 15.1046 11.1046 16 10 16H4C2.89543 16 2 15.1046 2 14V6Z",
          fill: "#374151"
        },
        {
          d: "M14.5528 7.10557C14.214 7.27497 14 7.62123 14 8V12C14 12.3788 14.214 12.725 14.5528 12.8944L16.5528 13.8944C16.8628 14.0494 17.2309 14.0329 17.5257 13.8507C17.8205 13.6684 18 13.3466 18 13V7C18 6.65342 17.8205 6.33156 17.5257 6.14935C17.2309 5.96714 16.8628 5.95058 16.5528 6.10557L14.5528 7.10557Z",
          fill: "#374151"
        }
      ]
    }
  },
  "view-boards": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M9 17V7M9 17C9 18.1046 8.10457 19 7 19H5C3.89543 19 3 18.1046 3 17V7C3 5.89543 3.89543 5 5 5H7C8.10457 5 9 5.89543 9 7M9 17C9 18.1046 9.89543 19 11 19H13C14.1046 19 15 18.1046 15 17M9 7C9 5.89543 9.89543 5 11 5H13C14.1046 5 15 5.89543 15 7M15 17V7M15 17C15 18.1046 15.8954 19 17 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H17C15.8954 5 15 5.89543 15 7",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M2 4C2 3.44772 2.44772 3 3 3H5C5.55228 3 6 3.44772 6 4V16C6 16.5523 5.55228 17 5 17H3C2.44772 17 2 16.5523 2 16V4Z",
          fill: "#4A5568"
        },
        {
          d: "M8 4C8 3.44772 8.44772 3 9 3H11C11.5523 3 12 3.44772 12 4V16C12 16.5523 11.5523 17 11 17H9C8.44772 17 8 16.5523 8 16V4Z",
          fill: "#4A5568"
        },
        {
          d: "M15 3C14.4477 3 14 3.44772 14 4V16C14 16.5523 14.4477 17 15 17H17C17.5523 17 18 16.5523 18 16V4C18 3.44772 17.5523 3 17 3H15Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "view-grid-add": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M17 14V20M14 17H20M6 10H8C9.10457 10 10 9.10457 10 8V6C10 4.89543 9.10457 4 8 4H6C4.89543 4 4 4.89543 4 6V8C4 9.10457 4.89543 10 6 10ZM16 10H18C19.1046 10 20 9.10457 20 8V6C20 4.89543 19.1046 4 18 4H16C14.8954 4 14 4.89543 14 6V8C14 9.10457 14.8954 10 16 10ZM6 20H8C9.10457 20 10 19.1046 10 18V16C10 14.8954 9.10457 14 8 14H6C4.89543 14 4 14.8954 4 16V18C4 19.1046 4.89543 20 6 20Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M5 3C3.89543 3 3 3.89543 3 5V7C3 8.10457 3.89543 9 5 9H7C8.10457 9 9 8.10457 9 7V5C9 3.89543 8.10457 3 7 3H5Z",
          fill: "#4B5563"
        },
        {
          d: "M5 11C3.89543 11 3 11.8954 3 13V15C3 16.1046 3.89543 17 5 17H7C8.10457 17 9 16.1046 9 15V13C9 11.8954 8.10457 11 7 11H5Z",
          fill: "#4B5563"
        },
        {
          d: "M11 5C11 3.89543 11.8954 3 13 3H15C16.1046 3 17 3.89543 17 5V7C17 8.10457 16.1046 9 15 9H13C11.8954 9 11 8.10457 11 7V5Z",
          fill: "#4B5563"
        },
        {
          d: "M14 11C14.5523 11 15 11.4477 15 12V13H16C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15H15V16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16V15H12C11.4477 15 11 14.5523 11 14C11 13.4477 11.4477 13 12 13H13V12C13 11.4477 13.4477 11 14 11Z",
          fill: "#4B5563"
        }
      ]
    }
  },
  "view-grid": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M4 6C4 4.89543 4.89543 4 6 4H8C9.10457 4 10 4.89543 10 6V8C10 9.10457 9.10457 10 8 10H6C4.89543 10 4 9.10457 4 8V6Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        },
        {
          d: "M14 6C14 4.89543 14.8954 4 16 4H18C19.1046 4 20 4.89543 20 6V8C20 9.10457 19.1046 10 18 10H16C14.8954 10 14 9.10457 14 8V6Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        },
        {
          d: "M4 16C4 14.8954 4.89543 14 6 14H8C9.10457 14 10 14.8954 10 16V18C10 19.1046 9.10457 20 8 20H6C4.89543 20 4 19.1046 4 18V16Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        },
        {
          d: "M14 16C14 14.8954 14.8954 14 16 14H18C19.1046 14 20 14.8954 20 16V18C20 19.1046 19.1046 20 18 20H16C14.8954 20 14 19.1046 14 18V16Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M5 3C3.89543 3 3 3.89543 3 5V7C3 8.10457 3.89543 9 5 9H7C8.10457 9 9 8.10457 9 7V5C9 3.89543 8.10457 3 7 3H5Z",
          fill: "#374151"
        },
        {
          d: "M5 11C3.89543 11 3 11.8954 3 13V15C3 16.1046 3.89543 17 5 17H7C8.10457 17 9 16.1046 9 15V13C9 11.8954 8.10457 11 7 11H5Z",
          fill: "#374151"
        },
        {
          d: "M11 5C11 3.89543 11.8954 3 13 3H15C16.1046 3 17 3.89543 17 5V7C17 8.10457 16.1046 9 15 9H13C11.8954 9 11 8.10457 11 7V5Z",
          fill: "#374151"
        },
        {
          d: "M11 13C11 11.8954 11.8954 11 13 11H15C16.1046 11 17 11.8954 17 13V15C17 16.1046 16.1046 17 15 17H13C11.8954 17 11 16.1046 11 15V13Z",
          fill: "#374151"
        }
      ]
    }
  },
  "view-list": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M4 6H20M4 10H20M4 14H20M4 18H20",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4C17 4.55228 16.5523 5 16 5H4C3.44772 5 3 4.55228 3 4ZM3 8C3 7.44772 3.44772 7 4 7H16C16.5523 7 17 7.44772 17 8C17 8.55228 16.5523 9 16 9H4C3.44772 9 3 8.55228 3 8ZM3 12C3 11.4477 3.44772 11 4 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H4C3.44772 13 3 12.5523 3 12ZM3 16C3 15.4477 3.44772 15 4 15H16C16.5523 15 17 15.4477 17 16C17 16.5523 16.5523 17 16 17H4C3.44772 17 3 16.5523 3 16Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "volume-off": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5.58579 15.0001H4C3.44772 15.0001 3 14.5523 3 14.0001V10.0001C3 9.44777 3.44772 9.00005 4 9.00005H5.58579L10.2929 4.29294C10.9229 3.66298 12 4.10915 12 5.00005V19.0001C12 19.891 10.9229 20.3371 10.2929 19.7072L5.58579 15.0001Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        },
        {
          d: "M17 14L19 12M19 12L21 10M19 12L17 10M19 12L21 14",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M9.38268 3.07615C9.75636 3.23093 10 3.59557 10 4.00003V16C10 16.4045 9.75636 16.7691 9.38268 16.9239C9.00901 17.0787 8.57889 16.9931 8.29289 16.7071L4.58579 13H2C1.44772 13 1 12.5523 1 12V8.00003C1 7.44774 1.44772 7.00003 2 7.00003H4.58579L8.29289 3.29292C8.57889 3.00692 9.00901 2.92137 9.38268 3.07615Z",
          fill: "#4A5568"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M12.2929 7.29289C12.6834 6.90237 13.3166 6.90237 13.7071 7.29289L15 8.58579L16.2929 7.29289C16.6834 6.90237 17.3166 6.90237 17.7071 7.29289C18.0976 7.68342 18.0976 8.31658 17.7071 8.70711L16.4142 10L17.7071 11.2929C18.0976 11.6834 18.0976 12.3166 17.7071 12.7071C17.3166 13.0976 16.6834 13.0976 16.2929 12.7071L15 11.4142L13.7071 12.7071C13.3166 13.0976 12.6834 13.0976 12.2929 12.7071C11.9024 12.3166 11.9024 11.6834 12.2929 11.2929L13.5858 10L12.2929 8.70711C11.9024 8.31658 11.9024 7.68342 12.2929 7.29289Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "volume-up": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M15.5355 8.46448C17.4881 10.4171 17.4881 13.5829 15.5355 15.5355M18.364 5.63599C21.8787 9.15071 21.8787 14.8492 18.364 18.3639M5.58579 15.0001H4C3.44772 15.0001 3 14.5523 3 14.0001V10.0001C3 9.44777 3.44772 9.00005 4 9.00005H5.58579L10.2929 4.29294C10.9229 3.66298 12 4.10915 12 5.00005V19.0001C12 19.891 10.9229 20.3371 10.2929 19.7072L5.58579 15.0001Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M9.38268 3.07615C9.75636 3.23093 10 3.59557 10 4.00003V16C10 16.4045 9.75636 16.7691 9.38268 16.9239C9.00901 17.0787 8.57889 16.9931 8.29289 16.7071L4.58579 13H2C1.44772 13 1 12.5523 1 12V8.00003C1 7.44774 1.44772 7.00003 2 7.00003H4.58579L8.29289 3.29292C8.57889 3.00692 9.00901 2.92137 9.38268 3.07615Z",
          fill: "#4A5568"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M14.6568 2.92888C15.0474 2.53836 15.6805 2.53836 16.0711 2.92888C17.8796 4.73743 19 7.2388 19 9.99995C19 12.7611 17.8796 15.2625 16.0711 17.071C15.6805 17.4615 15.0474 17.4615 14.6568 17.071C14.2663 16.6805 14.2663 16.0473 14.6568 15.6568C16.1057 14.208 17 12.2094 17 9.99995C17 7.79053 16.1057 5.7919 14.6568 4.34309C14.2663 3.95257 14.2663 3.3194 14.6568 2.92888ZM11.8284 5.75731C12.2189 5.36678 12.8521 5.36678 13.2426 5.75731C13.7685 6.28319 14.1976 6.90687 14.5003 7.59958C14.822 8.33592 15 9.14847 15 9.99995C15 11.6565 14.3273 13.1579 13.2426 14.2426C12.8521 14.6331 12.2189 14.6331 11.8284 14.2426C11.4379 13.8521 11.4379 13.2189 11.8284 12.8284C12.5534 12.1034 13 11.1048 13 9.99995C13 9.42922 12.8811 8.8889 12.6676 8.40032C12.4663 7.93958 12.1802 7.52327 11.8284 7.17152C11.4379 6.781 11.4379 6.14783 11.8284 5.75731Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  wifi,
  "x-circle": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M10 14L12 12M12 12L14 10M12 12L10 10M12 12L14 14M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L8.58579 10L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071C7.68342 13.0976 8.31658 13.0976 8.70711 12.7071L10 11.4142L11.2929 12.7071C11.6834 13.0976 12.3166 13.0976 12.7071 12.7071C13.0976 12.3166 13.0976 11.6834 12.7071 11.2929L11.4142 10L12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289C12.3166 6.90237 11.6834 6.90237 11.2929 7.29289L10 8.58579L8.70711 7.29289Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  x,
  "zoom-in": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        },
        {
          d: "M10 7V10M10 10V13M10 10H13M10 10H7",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M5 8C5 7.44772 5.44772 7 6 7H7V6C7 5.44772 7.44772 5 8 5C8.55228 5 9 5.44772 9 6V7H10C10.5523 7 11 7.44772 11 8C11 8.55228 10.5523 9 10 9H9V10C9 10.5523 8.55228 11 8 11C7.44771 11 7 10.5523 7 10V9H6C5.44772 9 5 8.55228 5 8Z",
          fill: "#4A5568"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 9.29583 13.5892 10.4957 12.8907 11.4765L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L11.4765 12.8907C10.4957 13.5892 9.29583 14 8 14C4.68629 14 2 11.3137 2 8ZM8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4Z",
          fill: "#4A5568"
        }
      ]
    }
  },
  "zoom-out": {
    normal: {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          d: "M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        },
        {
          d: "M13 10H7",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ]
    },
    small: {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      paths: [
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4ZM2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 9.29583 13.5892 10.4957 12.8907 11.4765L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L11.4765 12.8907C10.4957 13.5892 9.29583 14 8 14C4.68629 14 2 11.3137 2 8Z",
          fill: "#4A5568"
        },
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5 8C5 7.44772 5.44772 7 6 7H10C10.5523 7 11 7.44772 11 8C11 8.55228 10.5523 9 10 9H6C5.44772 9 5 8.55228 5 8Z",
          fill: "#4A5568"
        }
      ]
    }
  }
};
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main$w = defineComponent({
  name: "SIcon",
  props: {
    icon: { type: String },
    small: { type: Boolean, default: false }
  },
  setup(props) {
    return {
      iconValue: computed(() => {
        const iv = icons$1[props.icon];
        if (props.small) {
          return iv.small;
        } else {
          return iv.normal;
        }
      })
    };
  }
});
function _sfc_render$w(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", mergeProps({ xmlns: "http://www.w3.org/2000/svg" }, _ctx.iconValue.attrs, { "aria-hidden": "true" }), [
    (openBlock(true), createElementBlock(Fragment$1, null, renderList(_ctx.iconValue.paths, (p) => {
      return openBlock(), createElementBlock("path", normalizeProps(guardReactiveProps(p)), null, 16);
    }), 256))
  ], 16);
}
var SIcon = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["render", _sfc_render$w]]);
function colorize$2(props, extras) {
  const color = props.color || "btn";
  let colorClasses = `text-${color} hover:text-${color}-contrast bg-${color}-contrast hover:bg-${color}-hover active:bg-${color}-active`;
  let colorClasses3d = `focus:border-${color} focus:ring-${color}`;
  if (props.flat) {
    return colorClasses;
  } else {
    return colorClasses + " " + colorClasses3d;
  }
}
function buttonize(props, extras) {
  const c = [colorize$2(props), " transition-colors duration-300 inline-flex justify-between disabled:opacity-50 focus:outline-none px-2 py-1 relative"];
  if (!props.flat) {
    c.push("border rounded", "border-gray-300", "focus:ring", "focus:ring-offset-0", "focus:ring-opacity-50");
  }
  return c;
}
const _sfc_main$v = defineComponent({
  props: {
    solid: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "btn"
    },
    icon: {
      type: String,
      default: null
    },
    endIcon: {
      type: String,
      default: null
    }
  },
  setup(props) {
    return {
      cls: computed(() => {
        return buttonize(props);
      })
    };
  },
  components: { SIcon }
});
const _hoisted_1$o = ["disabled"];
const _hoisted_2$i = {
  key: 2,
  class: "absolute inset-1 flex justify-center items-center bg-inherit"
};
const _hoisted_3$e = /* @__PURE__ */ createElementVNode("svg", {
  class: "animate-spin h-5 w-5 text-current",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /* @__PURE__ */ createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /* @__PURE__ */ createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1);
function _sfc_render$v(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SIcon = resolveComponent("SIcon");
  return openBlock(), createElementBlock("button", {
    class: normalizeClass(_ctx.cls),
    disabled: _ctx.disabled || _ctx.loading
  }, [
    !!_ctx.icon ? (openBlock(), createBlock(_component_SIcon, {
      key: 0,
      icon: _ctx.icon,
      class: "-ml-1 text-current"
    }, null, 8, ["icon"])) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "default"),
    !!_ctx.endIcon ? (openBlock(), createBlock(_component_SIcon, {
      key: 1,
      icon: _ctx.endIcon,
      class: "-mr-1 text-current"
    }, null, 8, ["icon"])) : createCommentVNode("", true),
    _ctx.loading ? (openBlock(), createElementBlock("div", _hoisted_2$i, [
      renderSlot(_ctx.$slots, "loader", {}, () => [
        _hoisted_3$e
      ])
    ])) : createCommentVNode("", true)
  ], 10, _hoisted_1$o);
}
var SButton = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["render", _sfc_render$v]]);
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getAugmentedNamespace(n) {
  if (n.__esModule)
    return n;
  var a = Object.defineProperty({}, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
var forge$C = {
  options: {
    usePureJavaScript: false
  }
};
var api = {};
var baseN$1 = api;
var _reverseAlphabets = {};
api.encode = function(input, alphabet, maxline) {
  if (typeof alphabet !== "string") {
    throw new TypeError('"alphabet" must be a string.');
  }
  if (maxline !== void 0 && typeof maxline !== "number") {
    throw new TypeError('"maxline" must be a number.');
  }
  var output = "";
  if (!(input instanceof Uint8Array)) {
    output = _encodeWithByteBuffer(input, alphabet);
  } else {
    var i2 = 0;
    var base2 = alphabet.length;
    var first = alphabet.charAt(0);
    var digits = [0];
    for (i2 = 0; i2 < input.length; ++i2) {
      for (var j = 0, carry = input[i2]; j < digits.length; ++j) {
        carry += digits[j] << 8;
        digits[j] = carry % base2;
        carry = carry / base2 | 0;
      }
      while (carry > 0) {
        digits.push(carry % base2);
        carry = carry / base2 | 0;
      }
    }
    for (i2 = 0; input[i2] === 0 && i2 < input.length - 1; ++i2) {
      output += first;
    }
    for (i2 = digits.length - 1; i2 >= 0; --i2) {
      output += alphabet[digits[i2]];
    }
  }
  if (maxline) {
    var regex = new RegExp(".{1," + maxline + "}", "g");
    output = output.match(regex).join("\r\n");
  }
  return output;
};
api.decode = function(input, alphabet) {
  if (typeof input !== "string") {
    throw new TypeError('"input" must be a string.');
  }
  if (typeof alphabet !== "string") {
    throw new TypeError('"alphabet" must be a string.');
  }
  var table2 = _reverseAlphabets[alphabet];
  if (!table2) {
    table2 = _reverseAlphabets[alphabet] = [];
    for (var i2 = 0; i2 < alphabet.length; ++i2) {
      table2[alphabet.charCodeAt(i2)] = i2;
    }
  }
  input = input.replace(/\s/g, "");
  var base2 = alphabet.length;
  var first = alphabet.charAt(0);
  var bytes = [0];
  for (var i2 = 0; i2 < input.length; i2++) {
    var value = table2[input.charCodeAt(i2)];
    if (value === void 0) {
      return;
    }
    for (var j = 0, carry = value; j < bytes.length; ++j) {
      carry += bytes[j] * base2;
      bytes[j] = carry & 255;
      carry >>= 8;
    }
    while (carry > 0) {
      bytes.push(carry & 255);
      carry >>= 8;
    }
  }
  for (var k = 0; input[k] === first && k < input.length - 1; ++k) {
    bytes.push(0);
  }
  if (typeof Buffer !== "undefined") {
    return Buffer.from(bytes.reverse());
  }
  return new Uint8Array(bytes.reverse());
};
function _encodeWithByteBuffer(input, alphabet) {
  var i2 = 0;
  var base2 = alphabet.length;
  var first = alphabet.charAt(0);
  var digits = [0];
  for (i2 = 0; i2 < input.length(); ++i2) {
    for (var j = 0, carry = input.at(i2); j < digits.length; ++j) {
      carry += digits[j] << 8;
      digits[j] = carry % base2;
      carry = carry / base2 | 0;
    }
    while (carry > 0) {
      digits.push(carry % base2);
      carry = carry / base2 | 0;
    }
  }
  var output = "";
  for (i2 = 0; input.at(i2) === 0 && i2 < input.length() - 1; ++i2) {
    output += first;
  }
  for (i2 = digits.length - 1; i2 >= 0; --i2) {
    output += alphabet[digits[i2]];
  }
  return output;
}
var forge$B = forge$C;
var baseN = baseN$1;
var util$2 = forge$B.util = forge$B.util || {};
(function() {
  if (typeof process !== "undefined" && process.nextTick && !process.browser) {
    util$2.nextTick = process.nextTick;
    if (typeof setImmediate === "function") {
      util$2.setImmediate = setImmediate;
    } else {
      util$2.setImmediate = util$2.nextTick;
    }
    return;
  }
  if (typeof setImmediate === "function") {
    util$2.setImmediate = function() {
      return setImmediate.apply(void 0, arguments);
    };
    util$2.nextTick = function(callback) {
      return setImmediate(callback);
    };
    return;
  }
  util$2.setImmediate = function(callback) {
    setTimeout(callback, 0);
  };
  if (typeof window !== "undefined" && typeof window.postMessage === "function") {
    let handler = function(event) {
      if (event.source === window && event.data === msg) {
        event.stopPropagation();
        var copy5 = callbacks.slice();
        callbacks.length = 0;
        copy5.forEach(function(callback) {
          callback();
        });
      }
    };
    var msg = "forge.setImmediate";
    var callbacks = [];
    util$2.setImmediate = function(callback) {
      callbacks.push(callback);
      if (callbacks.length === 1) {
        window.postMessage(msg, "*");
      }
    };
    window.addEventListener("message", handler, true);
  }
  if (typeof MutationObserver !== "undefined") {
    var now2 = Date.now();
    var attr = true;
    var div = document.createElement("div");
    var callbacks = [];
    new MutationObserver(function() {
      var copy5 = callbacks.slice();
      callbacks.length = 0;
      copy5.forEach(function(callback) {
        callback();
      });
    }).observe(div, { attributes: true });
    var oldSetImmediate = util$2.setImmediate;
    util$2.setImmediate = function(callback) {
      if (Date.now() - now2 > 15) {
        now2 = Date.now();
        oldSetImmediate(callback);
      } else {
        callbacks.push(callback);
        if (callbacks.length === 1) {
          div.setAttribute("a", attr = !attr);
        }
      }
    };
  }
  util$2.nextTick = util$2.setImmediate;
})();
util$2.isNodejs = typeof process !== "undefined" && process.versions && process.versions.node;
util$2.globalScope = function() {
  if (util$2.isNodejs) {
    return commonjsGlobal;
  }
  return typeof self === "undefined" ? window : self;
}();
util$2.isArray = Array.isArray || function(x2) {
  return Object.prototype.toString.call(x2) === "[object Array]";
};
util$2.isArrayBuffer = function(x2) {
  return typeof ArrayBuffer !== "undefined" && x2 instanceof ArrayBuffer;
};
util$2.isArrayBufferView = function(x2) {
  return x2 && util$2.isArrayBuffer(x2.buffer) && x2.byteLength !== void 0;
};
function _checkBitsParam(n) {
  if (!(n === 8 || n === 16 || n === 24 || n === 32)) {
    throw new Error("Only 8, 16, 24, or 32 bits supported: " + n);
  }
}
util$2.ByteBuffer = ByteStringBuffer;
function ByteStringBuffer(b) {
  this.data = "";
  this.read = 0;
  if (typeof b === "string") {
    this.data = b;
  } else if (util$2.isArrayBuffer(b) || util$2.isArrayBufferView(b)) {
    if (typeof Buffer !== "undefined" && b instanceof Buffer) {
      this.data = b.toString("binary");
    } else {
      var arr = new Uint8Array(b);
      try {
        this.data = String.fromCharCode.apply(null, arr);
      } catch (e) {
        for (var i2 = 0; i2 < arr.length; ++i2) {
          this.putByte(arr[i2]);
        }
      }
    }
  } else if (b instanceof ByteStringBuffer || typeof b === "object" && typeof b.data === "string" && typeof b.read === "number") {
    this.data = b.data;
    this.read = b.read;
  }
  this._constructedStringLength = 0;
}
util$2.ByteStringBuffer = ByteStringBuffer;
var _MAX_CONSTRUCTED_STRING_LENGTH = 4096;
util$2.ByteStringBuffer.prototype._optimizeConstructedString = function(x2) {
  this._constructedStringLength += x2;
  if (this._constructedStringLength > _MAX_CONSTRUCTED_STRING_LENGTH) {
    this.data.substr(0, 1);
    this._constructedStringLength = 0;
  }
};
util$2.ByteStringBuffer.prototype.length = function() {
  return this.data.length - this.read;
};
util$2.ByteStringBuffer.prototype.isEmpty = function() {
  return this.length() <= 0;
};
util$2.ByteStringBuffer.prototype.putByte = function(b) {
  return this.putBytes(String.fromCharCode(b));
};
util$2.ByteStringBuffer.prototype.fillWithByte = function(b, n) {
  b = String.fromCharCode(b);
  var d = this.data;
  while (n > 0) {
    if (n & 1) {
      d += b;
    }
    n >>>= 1;
    if (n > 0) {
      b += b;
    }
  }
  this.data = d;
  this._optimizeConstructedString(n);
  return this;
};
util$2.ByteStringBuffer.prototype.putBytes = function(bytes) {
  this.data += bytes;
  this._optimizeConstructedString(bytes.length);
  return this;
};
util$2.ByteStringBuffer.prototype.putString = function(str) {
  return this.putBytes(util$2.encodeUtf8(str));
};
util$2.ByteStringBuffer.prototype.putInt16 = function(i2) {
  return this.putBytes(String.fromCharCode(i2 >> 8 & 255) + String.fromCharCode(i2 & 255));
};
util$2.ByteStringBuffer.prototype.putInt24 = function(i2) {
  return this.putBytes(String.fromCharCode(i2 >> 16 & 255) + String.fromCharCode(i2 >> 8 & 255) + String.fromCharCode(i2 & 255));
};
util$2.ByteStringBuffer.prototype.putInt32 = function(i2) {
  return this.putBytes(String.fromCharCode(i2 >> 24 & 255) + String.fromCharCode(i2 >> 16 & 255) + String.fromCharCode(i2 >> 8 & 255) + String.fromCharCode(i2 & 255));
};
util$2.ByteStringBuffer.prototype.putInt16Le = function(i2) {
  return this.putBytes(String.fromCharCode(i2 & 255) + String.fromCharCode(i2 >> 8 & 255));
};
util$2.ByteStringBuffer.prototype.putInt24Le = function(i2) {
  return this.putBytes(String.fromCharCode(i2 & 255) + String.fromCharCode(i2 >> 8 & 255) + String.fromCharCode(i2 >> 16 & 255));
};
util$2.ByteStringBuffer.prototype.putInt32Le = function(i2) {
  return this.putBytes(String.fromCharCode(i2 & 255) + String.fromCharCode(i2 >> 8 & 255) + String.fromCharCode(i2 >> 16 & 255) + String.fromCharCode(i2 >> 24 & 255));
};
util$2.ByteStringBuffer.prototype.putInt = function(i2, n) {
  _checkBitsParam(n);
  var bytes = "";
  do {
    n -= 8;
    bytes += String.fromCharCode(i2 >> n & 255);
  } while (n > 0);
  return this.putBytes(bytes);
};
util$2.ByteStringBuffer.prototype.putSignedInt = function(i2, n) {
  if (i2 < 0) {
    i2 += 2 << n - 1;
  }
  return this.putInt(i2, n);
};
util$2.ByteStringBuffer.prototype.putBuffer = function(buffer) {
  return this.putBytes(buffer.getBytes());
};
util$2.ByteStringBuffer.prototype.getByte = function() {
  return this.data.charCodeAt(this.read++);
};
util$2.ByteStringBuffer.prototype.getInt16 = function() {
  var rval = this.data.charCodeAt(this.read) << 8 ^ this.data.charCodeAt(this.read + 1);
  this.read += 2;
  return rval;
};
util$2.ByteStringBuffer.prototype.getInt24 = function() {
  var rval = this.data.charCodeAt(this.read) << 16 ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2);
  this.read += 3;
  return rval;
};
util$2.ByteStringBuffer.prototype.getInt32 = function() {
  var rval = this.data.charCodeAt(this.read) << 24 ^ this.data.charCodeAt(this.read + 1) << 16 ^ this.data.charCodeAt(this.read + 2) << 8 ^ this.data.charCodeAt(this.read + 3);
  this.read += 4;
  return rval;
};
util$2.ByteStringBuffer.prototype.getInt16Le = function() {
  var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8;
  this.read += 2;
  return rval;
};
util$2.ByteStringBuffer.prototype.getInt24Le = function() {
  var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16;
  this.read += 3;
  return rval;
};
util$2.ByteStringBuffer.prototype.getInt32Le = function() {
  var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16 ^ this.data.charCodeAt(this.read + 3) << 24;
  this.read += 4;
  return rval;
};
util$2.ByteStringBuffer.prototype.getInt = function(n) {
  _checkBitsParam(n);
  var rval = 0;
  do {
    rval = (rval << 8) + this.data.charCodeAt(this.read++);
    n -= 8;
  } while (n > 0);
  return rval;
};
util$2.ByteStringBuffer.prototype.getSignedInt = function(n) {
  var x2 = this.getInt(n);
  var max3 = 2 << n - 2;
  if (x2 >= max3) {
    x2 -= max3 << 1;
  }
  return x2;
};
util$2.ByteStringBuffer.prototype.getBytes = function(count) {
  var rval;
  if (count) {
    count = Math.min(this.length(), count);
    rval = this.data.slice(this.read, this.read + count);
    this.read += count;
  } else if (count === 0) {
    rval = "";
  } else {
    rval = this.read === 0 ? this.data : this.data.slice(this.read);
    this.clear();
  }
  return rval;
};
util$2.ByteStringBuffer.prototype.bytes = function(count) {
  return typeof count === "undefined" ? this.data.slice(this.read) : this.data.slice(this.read, this.read + count);
};
util$2.ByteStringBuffer.prototype.at = function(i2) {
  return this.data.charCodeAt(this.read + i2);
};
util$2.ByteStringBuffer.prototype.setAt = function(i2, b) {
  this.data = this.data.substr(0, this.read + i2) + String.fromCharCode(b) + this.data.substr(this.read + i2 + 1);
  return this;
};
util$2.ByteStringBuffer.prototype.last = function() {
  return this.data.charCodeAt(this.data.length - 1);
};
util$2.ByteStringBuffer.prototype.copy = function() {
  var c = util$2.createBuffer(this.data);
  c.read = this.read;
  return c;
};
util$2.ByteStringBuffer.prototype.compact = function() {
  if (this.read > 0) {
    this.data = this.data.slice(this.read);
    this.read = 0;
  }
  return this;
};
util$2.ByteStringBuffer.prototype.clear = function() {
  this.data = "";
  this.read = 0;
  return this;
};
util$2.ByteStringBuffer.prototype.truncate = function(count) {
  var len = Math.max(0, this.length() - count);
  this.data = this.data.substr(this.read, len);
  this.read = 0;
  return this;
};
util$2.ByteStringBuffer.prototype.toHex = function() {
  var rval = "";
  for (var i2 = this.read; i2 < this.data.length; ++i2) {
    var b = this.data.charCodeAt(i2);
    if (b < 16) {
      rval += "0";
    }
    rval += b.toString(16);
  }
  return rval;
};
util$2.ByteStringBuffer.prototype.toString = function() {
  return util$2.decodeUtf8(this.bytes());
};
function DataBuffer(b, options) {
  options = options || {};
  this.read = options.readOffset || 0;
  this.growSize = options.growSize || 1024;
  var isArrayBuffer = util$2.isArrayBuffer(b);
  var isArrayBufferView = util$2.isArrayBufferView(b);
  if (isArrayBuffer || isArrayBufferView) {
    if (isArrayBuffer) {
      this.data = new DataView(b);
    } else {
      this.data = new DataView(b.buffer, b.byteOffset, b.byteLength);
    }
    this.write = "writeOffset" in options ? options.writeOffset : this.data.byteLength;
    return;
  }
  this.data = new DataView(new ArrayBuffer(0));
  this.write = 0;
  if (b !== null && b !== void 0) {
    this.putBytes(b);
  }
  if ("writeOffset" in options) {
    this.write = options.writeOffset;
  }
}
util$2.DataBuffer = DataBuffer;
util$2.DataBuffer.prototype.length = function() {
  return this.write - this.read;
};
util$2.DataBuffer.prototype.isEmpty = function() {
  return this.length() <= 0;
};
util$2.DataBuffer.prototype.accommodate = function(amount, growSize) {
  if (this.length() >= amount) {
    return this;
  }
  growSize = Math.max(growSize || this.growSize, amount);
  var src = new Uint8Array(this.data.buffer, this.data.byteOffset, this.data.byteLength);
  var dst = new Uint8Array(this.length() + growSize);
  dst.set(src);
  this.data = new DataView(dst.buffer);
  return this;
};
util$2.DataBuffer.prototype.putByte = function(b) {
  this.accommodate(1);
  this.data.setUint8(this.write++, b);
  return this;
};
util$2.DataBuffer.prototype.fillWithByte = function(b, n) {
  this.accommodate(n);
  for (var i2 = 0; i2 < n; ++i2) {
    this.data.setUint8(b);
  }
  return this;
};
util$2.DataBuffer.prototype.putBytes = function(bytes, encoding) {
  if (util$2.isArrayBufferView(bytes)) {
    var src = new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    var len = src.byteLength - src.byteOffset;
    this.accommodate(len);
    var dst = new Uint8Array(this.data.buffer, this.write);
    dst.set(src);
    this.write += len;
    return this;
  }
  if (util$2.isArrayBuffer(bytes)) {
    var src = new Uint8Array(bytes);
    this.accommodate(src.byteLength);
    var dst = new Uint8Array(this.data.buffer);
    dst.set(src, this.write);
    this.write += src.byteLength;
    return this;
  }
  if (bytes instanceof util$2.DataBuffer || typeof bytes === "object" && typeof bytes.read === "number" && typeof bytes.write === "number" && util$2.isArrayBufferView(bytes.data)) {
    var src = new Uint8Array(bytes.data.byteLength, bytes.read, bytes.length());
    this.accommodate(src.byteLength);
    var dst = new Uint8Array(bytes.data.byteLength, this.write);
    dst.set(src);
    this.write += src.byteLength;
    return this;
  }
  if (bytes instanceof util$2.ByteStringBuffer) {
    bytes = bytes.data;
    encoding = "binary";
  }
  encoding = encoding || "binary";
  if (typeof bytes === "string") {
    var view;
    if (encoding === "hex") {
      this.accommodate(Math.ceil(bytes.length / 2));
      view = new Uint8Array(this.data.buffer, this.write);
      this.write += util$2.binary.hex.decode(bytes, view, this.write);
      return this;
    }
    if (encoding === "base64") {
      this.accommodate(Math.ceil(bytes.length / 4) * 3);
      view = new Uint8Array(this.data.buffer, this.write);
      this.write += util$2.binary.base64.decode(bytes, view, this.write);
      return this;
    }
    if (encoding === "utf8") {
      bytes = util$2.encodeUtf8(bytes);
      encoding = "binary";
    }
    if (encoding === "binary" || encoding === "raw") {
      this.accommodate(bytes.length);
      view = new Uint8Array(this.data.buffer, this.write);
      this.write += util$2.binary.raw.decode(view);
      return this;
    }
    if (encoding === "utf16") {
      this.accommodate(bytes.length * 2);
      view = new Uint16Array(this.data.buffer, this.write);
      this.write += util$2.text.utf16.encode(view);
      return this;
    }
    throw new Error("Invalid encoding: " + encoding);
  }
  throw Error("Invalid parameter: " + bytes);
};
util$2.DataBuffer.prototype.putBuffer = function(buffer) {
  this.putBytes(buffer);
  buffer.clear();
  return this;
};
util$2.DataBuffer.prototype.putString = function(str) {
  return this.putBytes(str, "utf16");
};
util$2.DataBuffer.prototype.putInt16 = function(i2) {
  this.accommodate(2);
  this.data.setInt16(this.write, i2);
  this.write += 2;
  return this;
};
util$2.DataBuffer.prototype.putInt24 = function(i2) {
  this.accommodate(3);
  this.data.setInt16(this.write, i2 >> 8 & 65535);
  this.data.setInt8(this.write, i2 >> 16 & 255);
  this.write += 3;
  return this;
};
util$2.DataBuffer.prototype.putInt32 = function(i2) {
  this.accommodate(4);
  this.data.setInt32(this.write, i2);
  this.write += 4;
  return this;
};
util$2.DataBuffer.prototype.putInt16Le = function(i2) {
  this.accommodate(2);
  this.data.setInt16(this.write, i2, true);
  this.write += 2;
  return this;
};
util$2.DataBuffer.prototype.putInt24Le = function(i2) {
  this.accommodate(3);
  this.data.setInt8(this.write, i2 >> 16 & 255);
  this.data.setInt16(this.write, i2 >> 8 & 65535, true);
  this.write += 3;
  return this;
};
util$2.DataBuffer.prototype.putInt32Le = function(i2) {
  this.accommodate(4);
  this.data.setInt32(this.write, i2, true);
  this.write += 4;
  return this;
};
util$2.DataBuffer.prototype.putInt = function(i2, n) {
  _checkBitsParam(n);
  this.accommodate(n / 8);
  do {
    n -= 8;
    this.data.setInt8(this.write++, i2 >> n & 255);
  } while (n > 0);
  return this;
};
util$2.DataBuffer.prototype.putSignedInt = function(i2, n) {
  _checkBitsParam(n);
  this.accommodate(n / 8);
  if (i2 < 0) {
    i2 += 2 << n - 1;
  }
  return this.putInt(i2, n);
};
util$2.DataBuffer.prototype.getByte = function() {
  return this.data.getInt8(this.read++);
};
util$2.DataBuffer.prototype.getInt16 = function() {
  var rval = this.data.getInt16(this.read);
  this.read += 2;
  return rval;
};
util$2.DataBuffer.prototype.getInt24 = function() {
  var rval = this.data.getInt16(this.read) << 8 ^ this.data.getInt8(this.read + 2);
  this.read += 3;
  return rval;
};
util$2.DataBuffer.prototype.getInt32 = function() {
  var rval = this.data.getInt32(this.read);
  this.read += 4;
  return rval;
};
util$2.DataBuffer.prototype.getInt16Le = function() {
  var rval = this.data.getInt16(this.read, true);
  this.read += 2;
  return rval;
};
util$2.DataBuffer.prototype.getInt24Le = function() {
  var rval = this.data.getInt8(this.read) ^ this.data.getInt16(this.read + 1, true) << 8;
  this.read += 3;
  return rval;
};
util$2.DataBuffer.prototype.getInt32Le = function() {
  var rval = this.data.getInt32(this.read, true);
  this.read += 4;
  return rval;
};
util$2.DataBuffer.prototype.getInt = function(n) {
  _checkBitsParam(n);
  var rval = 0;
  do {
    rval = (rval << 8) + this.data.getInt8(this.read++);
    n -= 8;
  } while (n > 0);
  return rval;
};
util$2.DataBuffer.prototype.getSignedInt = function(n) {
  var x2 = this.getInt(n);
  var max3 = 2 << n - 2;
  if (x2 >= max3) {
    x2 -= max3 << 1;
  }
  return x2;
};
util$2.DataBuffer.prototype.getBytes = function(count) {
  var rval;
  if (count) {
    count = Math.min(this.length(), count);
    rval = this.data.slice(this.read, this.read + count);
    this.read += count;
  } else if (count === 0) {
    rval = "";
  } else {
    rval = this.read === 0 ? this.data : this.data.slice(this.read);
    this.clear();
  }
  return rval;
};
util$2.DataBuffer.prototype.bytes = function(count) {
  return typeof count === "undefined" ? this.data.slice(this.read) : this.data.slice(this.read, this.read + count);
};
util$2.DataBuffer.prototype.at = function(i2) {
  return this.data.getUint8(this.read + i2);
};
util$2.DataBuffer.prototype.setAt = function(i2, b) {
  this.data.setUint8(i2, b);
  return this;
};
util$2.DataBuffer.prototype.last = function() {
  return this.data.getUint8(this.write - 1);
};
util$2.DataBuffer.prototype.copy = function() {
  return new util$2.DataBuffer(this);
};
util$2.DataBuffer.prototype.compact = function() {
  if (this.read > 0) {
    var src = new Uint8Array(this.data.buffer, this.read);
    var dst = new Uint8Array(src.byteLength);
    dst.set(src);
    this.data = new DataView(dst);
    this.write -= this.read;
    this.read = 0;
  }
  return this;
};
util$2.DataBuffer.prototype.clear = function() {
  this.data = new DataView(new ArrayBuffer(0));
  this.read = this.write = 0;
  return this;
};
util$2.DataBuffer.prototype.truncate = function(count) {
  this.write = Math.max(0, this.length() - count);
  this.read = Math.min(this.read, this.write);
  return this;
};
util$2.DataBuffer.prototype.toHex = function() {
  var rval = "";
  for (var i2 = this.read; i2 < this.data.byteLength; ++i2) {
    var b = this.data.getUint8(i2);
    if (b < 16) {
      rval += "0";
    }
    rval += b.toString(16);
  }
  return rval;
};
util$2.DataBuffer.prototype.toString = function(encoding) {
  var view = new Uint8Array(this.data, this.read, this.length());
  encoding = encoding || "utf8";
  if (encoding === "binary" || encoding === "raw") {
    return util$2.binary.raw.encode(view);
  }
  if (encoding === "hex") {
    return util$2.binary.hex.encode(view);
  }
  if (encoding === "base64") {
    return util$2.binary.base64.encode(view);
  }
  if (encoding === "utf8") {
    return util$2.text.utf8.decode(view);
  }
  if (encoding === "utf16") {
    return util$2.text.utf16.decode(view);
  }
  throw new Error("Invalid encoding: " + encoding);
};
util$2.createBuffer = function(input, encoding) {
  encoding = encoding || "raw";
  if (input !== void 0 && encoding === "utf8") {
    input = util$2.encodeUtf8(input);
  }
  return new util$2.ByteBuffer(input);
};
util$2.fillString = function(c, n) {
  var s2 = "";
  while (n > 0) {
    if (n & 1) {
      s2 += c;
    }
    n >>>= 1;
    if (n > 0) {
      c += c;
    }
  }
  return s2;
};
util$2.xorBytes = function(s1, s2, n) {
  var s3 = "";
  var b = "";
  var t = "";
  var i2 = 0;
  var c = 0;
  for (; n > 0; --n, ++i2) {
    b = s1.charCodeAt(i2) ^ s2.charCodeAt(i2);
    if (c >= 10) {
      s3 += t;
      t = "";
      c = 0;
    }
    t += String.fromCharCode(b);
    ++c;
  }
  s3 += t;
  return s3;
};
util$2.hexToBytes = function(hex) {
  var rval = "";
  var i2 = 0;
  if (hex.length & true) {
    i2 = 1;
    rval += String.fromCharCode(parseInt(hex[0], 16));
  }
  for (; i2 < hex.length; i2 += 2) {
    rval += String.fromCharCode(parseInt(hex.substr(i2, 2), 16));
  }
  return rval;
};
util$2.bytesToHex = function(bytes) {
  return util$2.createBuffer(bytes).toHex();
};
util$2.int32ToBytes = function(i2) {
  return String.fromCharCode(i2 >> 24 & 255) + String.fromCharCode(i2 >> 16 & 255) + String.fromCharCode(i2 >> 8 & 255) + String.fromCharCode(i2 & 255);
};
var _base64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
var _base64Idx = [
  62,
  -1,
  -1,
  -1,
  63,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  -1,
  -1,
  -1,
  64,
  -1,
  -1,
  -1,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51
];
var _base58 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
util$2.encode64 = function(input, maxline) {
  var line = "";
  var output = "";
  var chr1, chr2, chr3;
  var i2 = 0;
  while (i2 < input.length) {
    chr1 = input.charCodeAt(i2++);
    chr2 = input.charCodeAt(i2++);
    chr3 = input.charCodeAt(i2++);
    line += _base64.charAt(chr1 >> 2);
    line += _base64.charAt((chr1 & 3) << 4 | chr2 >> 4);
    if (isNaN(chr2)) {
      line += "==";
    } else {
      line += _base64.charAt((chr2 & 15) << 2 | chr3 >> 6);
      line += isNaN(chr3) ? "=" : _base64.charAt(chr3 & 63);
    }
    if (maxline && line.length > maxline) {
      output += line.substr(0, maxline) + "\r\n";
      line = line.substr(maxline);
    }
  }
  output += line;
  return output;
};
util$2.decode64 = function(input) {
  input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  var output = "";
  var enc1, enc2, enc3, enc4;
  var i2 = 0;
  while (i2 < input.length) {
    enc1 = _base64Idx[input.charCodeAt(i2++) - 43];
    enc2 = _base64Idx[input.charCodeAt(i2++) - 43];
    enc3 = _base64Idx[input.charCodeAt(i2++) - 43];
    enc4 = _base64Idx[input.charCodeAt(i2++) - 43];
    output += String.fromCharCode(enc1 << 2 | enc2 >> 4);
    if (enc3 !== 64) {
      output += String.fromCharCode((enc2 & 15) << 4 | enc3 >> 2);
      if (enc4 !== 64) {
        output += String.fromCharCode((enc3 & 3) << 6 | enc4);
      }
    }
  }
  return output;
};
util$2.encodeUtf8 = function(str) {
  return unescape(encodeURIComponent(str));
};
util$2.decodeUtf8 = function(str) {
  return decodeURIComponent(escape(str));
};
util$2.binary = {
  raw: {},
  hex: {},
  base64: {},
  base58: {},
  baseN: {
    encode: baseN.encode,
    decode: baseN.decode
  }
};
util$2.binary.raw.encode = function(bytes) {
  return String.fromCharCode.apply(null, bytes);
};
util$2.binary.raw.decode = function(str, output, offset3) {
  var out = output;
  if (!out) {
    out = new Uint8Array(str.length);
  }
  offset3 = offset3 || 0;
  var j = offset3;
  for (var i2 = 0; i2 < str.length; ++i2) {
    out[j++] = str.charCodeAt(i2);
  }
  return output ? j - offset3 : out;
};
util$2.binary.hex.encode = util$2.bytesToHex;
util$2.binary.hex.decode = function(hex, output, offset3) {
  var out = output;
  if (!out) {
    out = new Uint8Array(Math.ceil(hex.length / 2));
  }
  offset3 = offset3 || 0;
  var i2 = 0, j = offset3;
  if (hex.length & 1) {
    i2 = 1;
    out[j++] = parseInt(hex[0], 16);
  }
  for (; i2 < hex.length; i2 += 2) {
    out[j++] = parseInt(hex.substr(i2, 2), 16);
  }
  return output ? j - offset3 : out;
};
util$2.binary.base64.encode = function(input, maxline) {
  var line = "";
  var output = "";
  var chr1, chr2, chr3;
  var i2 = 0;
  while (i2 < input.byteLength) {
    chr1 = input[i2++];
    chr2 = input[i2++];
    chr3 = input[i2++];
    line += _base64.charAt(chr1 >> 2);
    line += _base64.charAt((chr1 & 3) << 4 | chr2 >> 4);
    if (isNaN(chr2)) {
      line += "==";
    } else {
      line += _base64.charAt((chr2 & 15) << 2 | chr3 >> 6);
      line += isNaN(chr3) ? "=" : _base64.charAt(chr3 & 63);
    }
    if (maxline && line.length > maxline) {
      output += line.substr(0, maxline) + "\r\n";
      line = line.substr(maxline);
    }
  }
  output += line;
  return output;
};
util$2.binary.base64.decode = function(input, output, offset3) {
  var out = output;
  if (!out) {
    out = new Uint8Array(Math.ceil(input.length / 4) * 3);
  }
  input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  offset3 = offset3 || 0;
  var enc1, enc2, enc3, enc4;
  var i2 = 0, j = offset3;
  while (i2 < input.length) {
    enc1 = _base64Idx[input.charCodeAt(i2++) - 43];
    enc2 = _base64Idx[input.charCodeAt(i2++) - 43];
    enc3 = _base64Idx[input.charCodeAt(i2++) - 43];
    enc4 = _base64Idx[input.charCodeAt(i2++) - 43];
    out[j++] = enc1 << 2 | enc2 >> 4;
    if (enc3 !== 64) {
      out[j++] = (enc2 & 15) << 4 | enc3 >> 2;
      if (enc4 !== 64) {
        out[j++] = (enc3 & 3) << 6 | enc4;
      }
    }
  }
  return output ? j - offset3 : out.subarray(0, j);
};
util$2.binary.base58.encode = function(input, maxline) {
  return util$2.binary.baseN.encode(input, _base58, maxline);
};
util$2.binary.base58.decode = function(input, maxline) {
  return util$2.binary.baseN.decode(input, _base58, maxline);
};
util$2.text = {
  utf8: {},
  utf16: {}
};
util$2.text.utf8.encode = function(str, output, offset3) {
  str = util$2.encodeUtf8(str);
  var out = output;
  if (!out) {
    out = new Uint8Array(str.length);
  }
  offset3 = offset3 || 0;
  var j = offset3;
  for (var i2 = 0; i2 < str.length; ++i2) {
    out[j++] = str.charCodeAt(i2);
  }
  return output ? j - offset3 : out;
};
util$2.text.utf8.decode = function(bytes) {
  return util$2.decodeUtf8(String.fromCharCode.apply(null, bytes));
};
util$2.text.utf16.encode = function(str, output, offset3) {
  var out = output;
  if (!out) {
    out = new Uint8Array(str.length * 2);
  }
  var view = new Uint16Array(out.buffer);
  offset3 = offset3 || 0;
  var j = offset3;
  var k = offset3;
  for (var i2 = 0; i2 < str.length; ++i2) {
    view[k++] = str.charCodeAt(i2);
    j += 2;
  }
  return output ? j - offset3 : out;
};
util$2.text.utf16.decode = function(bytes) {
  return String.fromCharCode.apply(null, new Uint16Array(bytes.buffer));
};
util$2.deflate = function(api2, bytes, raw) {
  bytes = util$2.decode64(api2.deflate(util$2.encode64(bytes)).rval);
  if (raw) {
    var start3 = 2;
    var flg = bytes.charCodeAt(1);
    if (flg & 32) {
      start3 = 6;
    }
    bytes = bytes.substring(start3, bytes.length - 4);
  }
  return bytes;
};
util$2.inflate = function(api2, bytes, raw) {
  var rval = api2.inflate(util$2.encode64(bytes)).rval;
  return rval === null ? null : util$2.decode64(rval);
};
var _setStorageObject = function(api2, id, obj) {
  if (!api2) {
    throw new Error("WebStorage not available.");
  }
  var rval;
  if (obj === null) {
    rval = api2.removeItem(id);
  } else {
    obj = util$2.encode64(JSON.stringify(obj));
    rval = api2.setItem(id, obj);
  }
  if (typeof rval !== "undefined" && rval.rval !== true) {
    var error = new Error(rval.error.message);
    error.id = rval.error.id;
    error.name = rval.error.name;
    throw error;
  }
};
var _getStorageObject = function(api2, id) {
  if (!api2) {
    throw new Error("WebStorage not available.");
  }
  var rval = api2.getItem(id);
  if (api2.init) {
    if (rval.rval === null) {
      if (rval.error) {
        var error = new Error(rval.error.message);
        error.id = rval.error.id;
        error.name = rval.error.name;
        throw error;
      }
      rval = null;
    } else {
      rval = rval.rval;
    }
  }
  if (rval !== null) {
    rval = JSON.parse(util$2.decode64(rval));
  }
  return rval;
};
var _setItem = function(api2, id, key, data) {
  var obj = _getStorageObject(api2, id);
  if (obj === null) {
    obj = {};
  }
  obj[key] = data;
  _setStorageObject(api2, id, obj);
};
var _getItem = function(api2, id, key) {
  var rval = _getStorageObject(api2, id);
  if (rval !== null) {
    rval = key in rval ? rval[key] : null;
  }
  return rval;
};
var _removeItem = function(api2, id, key) {
  var obj = _getStorageObject(api2, id);
  if (obj !== null && key in obj) {
    delete obj[key];
    var empty2 = true;
    for (var prop in obj) {
      empty2 = false;
      break;
    }
    if (empty2) {
      obj = null;
    }
    _setStorageObject(api2, id, obj);
  }
};
var _clearItems = function(api2, id) {
  _setStorageObject(api2, id, null);
};
var _callStorageFunction = function(func2, args, location) {
  var rval = null;
  if (typeof location === "undefined") {
    location = ["web", "flash"];
  }
  var type;
  var done2 = false;
  var exception = null;
  for (var idx in location) {
    type = location[idx];
    try {
      if (type === "flash" || type === "both") {
        if (args[0] === null) {
          throw new Error("Flash local storage not available.");
        }
        rval = func2.apply(this, args);
        done2 = type === "flash";
      }
      if (type === "web" || type === "both") {
        args[0] = localStorage;
        rval = func2.apply(this, args);
        done2 = true;
      }
    } catch (ex) {
      exception = ex;
    }
    if (done2) {
      break;
    }
  }
  if (!done2) {
    throw exception;
  }
  return rval;
};
util$2.setItem = function(api2, id, key, data, location) {
  _callStorageFunction(_setItem, arguments, location);
};
util$2.getItem = function(api2, id, key, location) {
  return _callStorageFunction(_getItem, arguments, location);
};
util$2.removeItem = function(api2, id, key, location) {
  _callStorageFunction(_removeItem, arguments, location);
};
util$2.clearItems = function(api2, id, location) {
  _callStorageFunction(_clearItems, arguments, location);
};
util$2.isEmpty = function(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false;
    }
  }
  return true;
};
util$2.format = function(format2) {
  var re = /%./g;
  var match;
  var part;
  var argi = 0;
  var parts = [];
  var last = 0;
  while (match = re.exec(format2)) {
    part = format2.substring(last, re.lastIndex - 2);
    if (part.length > 0) {
      parts.push(part);
    }
    last = re.lastIndex;
    var code = match[0][1];
    switch (code) {
      case "s":
      case "o":
        if (argi < arguments.length) {
          parts.push(arguments[argi++ + 1]);
        } else {
          parts.push("<?>");
        }
        break;
      case "%":
        parts.push("%");
        break;
      default:
        parts.push("<%" + code + "?>");
    }
  }
  parts.push(format2.substring(last));
  return parts.join("");
};
util$2.formatNumber = function(number2, decimals, dec_point, thousands_sep) {
  var n = number2, c = isNaN(decimals = Math.abs(decimals)) ? 2 : decimals;
  var d = dec_point === void 0 ? "," : dec_point;
  var t = thousands_sep === void 0 ? "." : thousands_sep, s2 = n < 0 ? "-" : "";
  var i2 = parseInt(n = Math.abs(+n || 0).toFixed(c), 10) + "";
  var j = i2.length > 3 ? i2.length % 3 : 0;
  return s2 + (j ? i2.substr(0, j) + t : "") + i2.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i2).toFixed(c).slice(2) : "");
};
util$2.formatSize = function(size) {
  if (size >= 1073741824) {
    size = util$2.formatNumber(size / 1073741824, 2, ".", "") + " GiB";
  } else if (size >= 1048576) {
    size = util$2.formatNumber(size / 1048576, 2, ".", "") + " MiB";
  } else if (size >= 1024) {
    size = util$2.formatNumber(size / 1024, 0) + " KiB";
  } else {
    size = util$2.formatNumber(size, 0) + " bytes";
  }
  return size;
};
util$2.bytesFromIP = function(ip) {
  if (ip.indexOf(".") !== -1) {
    return util$2.bytesFromIPv4(ip);
  }
  if (ip.indexOf(":") !== -1) {
    return util$2.bytesFromIPv6(ip);
  }
  return null;
};
util$2.bytesFromIPv4 = function(ip) {
  ip = ip.split(".");
  if (ip.length !== 4) {
    return null;
  }
  var b = util$2.createBuffer();
  for (var i2 = 0; i2 < ip.length; ++i2) {
    var num = parseInt(ip[i2], 10);
    if (isNaN(num)) {
      return null;
    }
    b.putByte(num);
  }
  return b.getBytes();
};
util$2.bytesFromIPv6 = function(ip) {
  var blanks = 0;
  ip = ip.split(":").filter(function(e) {
    if (e.length === 0)
      ++blanks;
    return true;
  });
  var zeros = (8 - ip.length + blanks) * 2;
  var b = util$2.createBuffer();
  for (var i2 = 0; i2 < 8; ++i2) {
    if (!ip[i2] || ip[i2].length === 0) {
      b.fillWithByte(0, zeros);
      zeros = 0;
      continue;
    }
    var bytes = util$2.hexToBytes(ip[i2]);
    if (bytes.length < 2) {
      b.putByte(0);
    }
    b.putBytes(bytes);
  }
  return b.getBytes();
};
util$2.bytesToIP = function(bytes) {
  if (bytes.length === 4) {
    return util$2.bytesToIPv4(bytes);
  }
  if (bytes.length === 16) {
    return util$2.bytesToIPv6(bytes);
  }
  return null;
};
util$2.bytesToIPv4 = function(bytes) {
  if (bytes.length !== 4) {
    return null;
  }
  var ip = [];
  for (var i2 = 0; i2 < bytes.length; ++i2) {
    ip.push(bytes.charCodeAt(i2));
  }
  return ip.join(".");
};
util$2.bytesToIPv6 = function(bytes) {
  if (bytes.length !== 16) {
    return null;
  }
  var ip = [];
  var zeroGroups = [];
  var zeroMaxGroup = 0;
  for (var i2 = 0; i2 < bytes.length; i2 += 2) {
    var hex = util$2.bytesToHex(bytes[i2] + bytes[i2 + 1]);
    while (hex[0] === "0" && hex !== "0") {
      hex = hex.substr(1);
    }
    if (hex === "0") {
      var last = zeroGroups[zeroGroups.length - 1];
      var idx = ip.length;
      if (!last || idx !== last.end + 1) {
        zeroGroups.push({ start: idx, end: idx });
      } else {
        last.end = idx;
        if (last.end - last.start > zeroGroups[zeroMaxGroup].end - zeroGroups[zeroMaxGroup].start) {
          zeroMaxGroup = zeroGroups.length - 1;
        }
      }
    }
    ip.push(hex);
  }
  if (zeroGroups.length > 0) {
    var group = zeroGroups[zeroMaxGroup];
    if (group.end - group.start > 0) {
      ip.splice(group.start, group.end - group.start + 1, "");
      if (group.start === 0) {
        ip.unshift("");
      }
      if (group.end === 7) {
        ip.push("");
      }
    }
  }
  return ip.join(":");
};
util$2.estimateCores = function(options, callback) {
  if (typeof options === "function") {
    callback = options;
    options = {};
  }
  options = options || {};
  if ("cores" in util$2 && !options.update) {
    return callback(null, util$2.cores);
  }
  if (typeof navigator !== "undefined" && "hardwareConcurrency" in navigator && navigator.hardwareConcurrency > 0) {
    util$2.cores = navigator.hardwareConcurrency;
    return callback(null, util$2.cores);
  }
  if (typeof Worker === "undefined") {
    util$2.cores = 1;
    return callback(null, util$2.cores);
  }
  if (typeof Blob === "undefined") {
    util$2.cores = 2;
    return callback(null, util$2.cores);
  }
  var blobUrl = URL.createObjectURL(new Blob([
    "(",
    function() {
      self.addEventListener("message", function(e) {
        var st = Date.now();
        var et = st + 4;
        self.postMessage({ st, et });
      });
    }.toString(),
    ")()"
  ], { type: "application/javascript" }));
  sample([], 5, 16);
  function sample(max3, samples, numWorkers) {
    if (samples === 0) {
      var avg = Math.floor(max3.reduce(function(avg2, x2) {
        return avg2 + x2;
      }, 0) / max3.length);
      util$2.cores = Math.max(1, avg);
      URL.revokeObjectURL(blobUrl);
      return callback(null, util$2.cores);
    }
    map16(numWorkers, function(err2, results) {
      max3.push(reduce2(numWorkers, results));
      sample(max3, samples - 1, numWorkers);
    });
  }
  function map16(numWorkers, callback2) {
    var workers = [];
    var results = [];
    for (var i2 = 0; i2 < numWorkers; ++i2) {
      var worker = new Worker(blobUrl);
      worker.addEventListener("message", function(e) {
        results.push(e.data);
        if (results.length === numWorkers) {
          for (var i3 = 0; i3 < numWorkers; ++i3) {
            workers[i3].terminate();
          }
          callback2(null, results);
        }
      });
      workers.push(worker);
    }
    for (var i2 = 0; i2 < numWorkers; ++i2) {
      workers[i2].postMessage(i2);
    }
  }
  function reduce2(numWorkers, results) {
    var overlaps = [];
    for (var n = 0; n < numWorkers; ++n) {
      var r1 = results[n];
      var overlap = overlaps[n] = [];
      for (var i2 = 0; i2 < numWorkers; ++i2) {
        if (n === i2) {
          continue;
        }
        var r2 = results[i2];
        if (r1.st > r2.st && r1.st < r2.et || r2.st > r1.st && r2.st < r1.et) {
          overlap.push(i2);
        }
      }
    }
    return overlaps.reduce(function(max3, overlap2) {
      return Math.max(max3, overlap2.length);
    }, 0);
  }
};
var forge$A = forge$C;
forge$A.cipher = forge$A.cipher || {};
forge$A.cipher.algorithms = forge$A.cipher.algorithms || {};
forge$A.cipher.createCipher = function(algorithm, key) {
  var api2 = algorithm;
  if (typeof api2 === "string") {
    api2 = forge$A.cipher.getAlgorithm(api2);
    if (api2) {
      api2 = api2();
    }
  }
  if (!api2) {
    throw new Error("Unsupported algorithm: " + algorithm);
  }
  return new forge$A.cipher.BlockCipher({
    algorithm: api2,
    key,
    decrypt: false
  });
};
forge$A.cipher.createDecipher = function(algorithm, key) {
  var api2 = algorithm;
  if (typeof api2 === "string") {
    api2 = forge$A.cipher.getAlgorithm(api2);
    if (api2) {
      api2 = api2();
    }
  }
  if (!api2) {
    throw new Error("Unsupported algorithm: " + algorithm);
  }
  return new forge$A.cipher.BlockCipher({
    algorithm: api2,
    key,
    decrypt: true
  });
};
forge$A.cipher.registerAlgorithm = function(name, algorithm) {
  name = name.toUpperCase();
  forge$A.cipher.algorithms[name] = algorithm;
};
forge$A.cipher.getAlgorithm = function(name) {
  name = name.toUpperCase();
  if (name in forge$A.cipher.algorithms) {
    return forge$A.cipher.algorithms[name];
  }
  return null;
};
var BlockCipher = forge$A.cipher.BlockCipher = function(options) {
  this.algorithm = options.algorithm;
  this.mode = this.algorithm.mode;
  this.blockSize = this.mode.blockSize;
  this._finish = false;
  this._input = null;
  this.output = null;
  this._op = options.decrypt ? this.mode.decrypt : this.mode.encrypt;
  this._decrypt = options.decrypt;
  this.algorithm.initialize(options);
};
BlockCipher.prototype.start = function(options) {
  options = options || {};
  var opts = {};
  for (var key in options) {
    opts[key] = options[key];
  }
  opts.decrypt = this._decrypt;
  this._finish = false;
  this._input = forge$A.util.createBuffer();
  this.output = options.output || forge$A.util.createBuffer();
  this.mode.start(opts);
};
BlockCipher.prototype.update = function(input) {
  if (input) {
    this._input.putBuffer(input);
  }
  while (!this._op.call(this.mode, this._input, this.output, this._finish) && !this._finish) {
  }
  this._input.compact();
};
BlockCipher.prototype.finish = function(pad) {
  if (pad && (this.mode.name === "ECB" || this.mode.name === "CBC")) {
    this.mode.pad = function(input) {
      return pad(this.blockSize, input, false);
    };
    this.mode.unpad = function(output) {
      return pad(this.blockSize, output, true);
    };
  }
  var options = {};
  options.decrypt = this._decrypt;
  options.overflow = this._input.length() % this.blockSize;
  if (!this._decrypt && this.mode.pad) {
    if (!this.mode.pad(this._input, options)) {
      return false;
    }
  }
  this._finish = true;
  this.update();
  if (this._decrypt && this.mode.unpad) {
    if (!this.mode.unpad(this.output, options)) {
      return false;
    }
  }
  if (this.mode.afterFinish) {
    if (!this.mode.afterFinish(this.output, options)) {
      return false;
    }
  }
  return true;
};
var forge$z = forge$C;
forge$z.cipher = forge$z.cipher || {};
var modes = forge$z.cipher.modes = forge$z.cipher.modes || {};
modes.ecb = function(options) {
  options = options || {};
  this.name = "ECB";
  this.cipher = options.cipher;
  this.blockSize = options.blockSize || 16;
  this._ints = this.blockSize / 4;
  this._inBlock = new Array(this._ints);
  this._outBlock = new Array(this._ints);
};
modes.ecb.prototype.start = function(options) {
};
modes.ecb.prototype.encrypt = function(input, output, finish3) {
  if (input.length() < this.blockSize && !(finish3 && input.length() > 0)) {
    return true;
  }
  for (var i2 = 0; i2 < this._ints; ++i2) {
    this._inBlock[i2] = input.getInt32();
  }
  this.cipher.encrypt(this._inBlock, this._outBlock);
  for (var i2 = 0; i2 < this._ints; ++i2) {
    output.putInt32(this._outBlock[i2]);
  }
};
modes.ecb.prototype.decrypt = function(input, output, finish3) {
  if (input.length() < this.blockSize && !(finish3 && input.length() > 0)) {
    return true;
  }
  for (var i2 = 0; i2 < this._ints; ++i2) {
    this._inBlock[i2] = input.getInt32();
  }
  this.cipher.decrypt(this._inBlock, this._outBlock);
  for (var i2 = 0; i2 < this._ints; ++i2) {
    output.putInt32(this._outBlock[i2]);
  }
};
modes.ecb.prototype.pad = function(input, options) {
  var padding = input.length() === this.blockSize ? this.blockSize : this.blockSize - input.length();
  input.fillWithByte(padding, padding);
  return true;
};
modes.ecb.prototype.unpad = function(output, options) {
  if (options.overflow > 0) {
    return false;
  }
  var len = output.length();
  var count = output.at(len - 1);
  if (count > this.blockSize << 2) {
    return false;
  }
  output.truncate(count);
  return true;
};
modes.cbc = function(options) {
  options = options || {};
  this.name = "CBC";
  this.cipher = options.cipher;
  this.blockSize = options.blockSize || 16;
  this._ints = this.blockSize / 4;
  this._inBlock = new Array(this._ints);
  this._outBlock = new Array(this._ints);
};
modes.cbc.prototype.start = function(options) {
  if (options.iv === null) {
    if (!this._prev) {
      throw new Error("Invalid IV parameter.");
    }
    this._iv = this._prev.slice(0);
  } else if (!("iv" in options)) {
    throw new Error("Invalid IV parameter.");
  } else {
    this._iv = transformIV(options.iv, this.blockSize);
    this._prev = this._iv.slice(0);
  }
};
modes.cbc.prototype.encrypt = function(input, output, finish3) {
  if (input.length() < this.blockSize && !(finish3 && input.length() > 0)) {
    return true;
  }
  for (var i2 = 0; i2 < this._ints; ++i2) {
    this._inBlock[i2] = this._prev[i2] ^ input.getInt32();
  }
  this.cipher.encrypt(this._inBlock, this._outBlock);
  for (var i2 = 0; i2 < this._ints; ++i2) {
    output.putInt32(this._outBlock[i2]);
  }
  this._prev = this._outBlock;
};
modes.cbc.prototype.decrypt = function(input, output, finish3) {
  if (input.length() < this.blockSize && !(finish3 && input.length() > 0)) {
    return true;
  }
  for (var i2 = 0; i2 < this._ints; ++i2) {
    this._inBlock[i2] = input.getInt32();
  }
  this.cipher.decrypt(this._inBlock, this._outBlock);
  for (var i2 = 0; i2 < this._ints; ++i2) {
    output.putInt32(this._prev[i2] ^ this._outBlock[i2]);
  }
  this._prev = this._inBlock.slice(0);
};
modes.cbc.prototype.pad = function(input, options) {
  var padding = input.length() === this.blockSize ? this.blockSize : this.blockSize - input.length();
  input.fillWithByte(padding, padding);
  return true;
};
modes.cbc.prototype.unpad = function(output, options) {
  if (options.overflow > 0) {
    return false;
  }
  var len = output.length();
  var count = output.at(len - 1);
  if (count > this.blockSize << 2) {
    return false;
  }
  output.truncate(count);
  return true;
};
modes.cfb = function(options) {
  options = options || {};
  this.name = "CFB";
  this.cipher = options.cipher;
  this.blockSize = options.blockSize || 16;
  this._ints = this.blockSize / 4;
  this._inBlock = null;
  this._outBlock = new Array(this._ints);
  this._partialBlock = new Array(this._ints);
  this._partialOutput = forge$z.util.createBuffer();
  this._partialBytes = 0;
};
modes.cfb.prototype.start = function(options) {
  if (!("iv" in options)) {
    throw new Error("Invalid IV parameter.");
  }
  this._iv = transformIV(options.iv, this.blockSize);
  this._inBlock = this._iv.slice(0);
  this._partialBytes = 0;
};
modes.cfb.prototype.encrypt = function(input, output, finish3) {
  var inputLength = input.length();
  if (inputLength === 0) {
    return true;
  }
  this.cipher.encrypt(this._inBlock, this._outBlock);
  if (this._partialBytes === 0 && inputLength >= this.blockSize) {
    for (var i2 = 0; i2 < this._ints; ++i2) {
      this._inBlock[i2] = input.getInt32() ^ this._outBlock[i2];
      output.putInt32(this._inBlock[i2]);
    }
    return;
  }
  var partialBytes = (this.blockSize - inputLength) % this.blockSize;
  if (partialBytes > 0) {
    partialBytes = this.blockSize - partialBytes;
  }
  this._partialOutput.clear();
  for (var i2 = 0; i2 < this._ints; ++i2) {
    this._partialBlock[i2] = input.getInt32() ^ this._outBlock[i2];
    this._partialOutput.putInt32(this._partialBlock[i2]);
  }
  if (partialBytes > 0) {
    input.read -= this.blockSize;
  } else {
    for (var i2 = 0; i2 < this._ints; ++i2) {
      this._inBlock[i2] = this._partialBlock[i2];
    }
  }
  if (this._partialBytes > 0) {
    this._partialOutput.getBytes(this._partialBytes);
  }
  if (partialBytes > 0 && !finish3) {
    output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
    this._partialBytes = partialBytes;
    return true;
  }
  output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
  this._partialBytes = 0;
};
modes.cfb.prototype.decrypt = function(input, output, finish3) {
  var inputLength = input.length();
  if (inputLength === 0) {
    return true;
  }
  this.cipher.encrypt(this._inBlock, this._outBlock);
  if (this._partialBytes === 0 && inputLength >= this.blockSize) {
    for (var i2 = 0; i2 < this._ints; ++i2) {
      this._inBlock[i2] = input.getInt32();
      output.putInt32(this._inBlock[i2] ^ this._outBlock[i2]);
    }
    return;
  }
  var partialBytes = (this.blockSize - inputLength) % this.blockSize;
  if (partialBytes > 0) {
    partialBytes = this.blockSize - partialBytes;
  }
  this._partialOutput.clear();
  for (var i2 = 0; i2 < this._ints; ++i2) {
    this._partialBlock[i2] = input.getInt32();
    this._partialOutput.putInt32(this._partialBlock[i2] ^ this._outBlock[i2]);
  }
  if (partialBytes > 0) {
    input.read -= this.blockSize;
  } else {
    for (var i2 = 0; i2 < this._ints; ++i2) {
      this._inBlock[i2] = this._partialBlock[i2];
    }
  }
  if (this._partialBytes > 0) {
    this._partialOutput.getBytes(this._partialBytes);
  }
  if (partialBytes > 0 && !finish3) {
    output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
    this._partialBytes = partialBytes;
    return true;
  }
  output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
  this._partialBytes = 0;
};
modes.ofb = function(options) {
  options = options || {};
  this.name = "OFB";
  this.cipher = options.cipher;
  this.blockSize = options.blockSize || 16;
  this._ints = this.blockSize / 4;
  this._inBlock = null;
  this._outBlock = new Array(this._ints);
  this._partialOutput = forge$z.util.createBuffer();
  this._partialBytes = 0;
};
modes.ofb.prototype.start = function(options) {
  if (!("iv" in options)) {
    throw new Error("Invalid IV parameter.");
  }
  this._iv = transformIV(options.iv, this.blockSize);
  this._inBlock = this._iv.slice(0);
  this._partialBytes = 0;
};
modes.ofb.prototype.encrypt = function(input, output, finish3) {
  var inputLength = input.length();
  if (input.length() === 0) {
    return true;
  }
  this.cipher.encrypt(this._inBlock, this._outBlock);
  if (this._partialBytes === 0 && inputLength >= this.blockSize) {
    for (var i2 = 0; i2 < this._ints; ++i2) {
      output.putInt32(input.getInt32() ^ this._outBlock[i2]);
      this._inBlock[i2] = this._outBlock[i2];
    }
    return;
  }
  var partialBytes = (this.blockSize - inputLength) % this.blockSize;
  if (partialBytes > 0) {
    partialBytes = this.blockSize - partialBytes;
  }
  this._partialOutput.clear();
  for (var i2 = 0; i2 < this._ints; ++i2) {
    this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i2]);
  }
  if (partialBytes > 0) {
    input.read -= this.blockSize;
  } else {
    for (var i2 = 0; i2 < this._ints; ++i2) {
      this._inBlock[i2] = this._outBlock[i2];
    }
  }
  if (this._partialBytes > 0) {
    this._partialOutput.getBytes(this._partialBytes);
  }
  if (partialBytes > 0 && !finish3) {
    output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
    this._partialBytes = partialBytes;
    return true;
  }
  output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
  this._partialBytes = 0;
};
modes.ofb.prototype.decrypt = modes.ofb.prototype.encrypt;
modes.ctr = function(options) {
  options = options || {};
  this.name = "CTR";
  this.cipher = options.cipher;
  this.blockSize = options.blockSize || 16;
  this._ints = this.blockSize / 4;
  this._inBlock = null;
  this._outBlock = new Array(this._ints);
  this._partialOutput = forge$z.util.createBuffer();
  this._partialBytes = 0;
};
modes.ctr.prototype.start = function(options) {
  if (!("iv" in options)) {
    throw new Error("Invalid IV parameter.");
  }
  this._iv = transformIV(options.iv, this.blockSize);
  this._inBlock = this._iv.slice(0);
  this._partialBytes = 0;
};
modes.ctr.prototype.encrypt = function(input, output, finish3) {
  var inputLength = input.length();
  if (inputLength === 0) {
    return true;
  }
  this.cipher.encrypt(this._inBlock, this._outBlock);
  if (this._partialBytes === 0 && inputLength >= this.blockSize) {
    for (var i2 = 0; i2 < this._ints; ++i2) {
      output.putInt32(input.getInt32() ^ this._outBlock[i2]);
    }
  } else {
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if (partialBytes > 0) {
      partialBytes = this.blockSize - partialBytes;
    }
    this._partialOutput.clear();
    for (var i2 = 0; i2 < this._ints; ++i2) {
      this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i2]);
    }
    if (partialBytes > 0) {
      input.read -= this.blockSize;
    }
    if (this._partialBytes > 0) {
      this._partialOutput.getBytes(this._partialBytes);
    }
    if (partialBytes > 0 && !finish3) {
      output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
      this._partialBytes = partialBytes;
      return true;
    }
    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
  }
  inc32(this._inBlock);
};
modes.ctr.prototype.decrypt = modes.ctr.prototype.encrypt;
modes.gcm = function(options) {
  options = options || {};
  this.name = "GCM";
  this.cipher = options.cipher;
  this.blockSize = options.blockSize || 16;
  this._ints = this.blockSize / 4;
  this._inBlock = new Array(this._ints);
  this._outBlock = new Array(this._ints);
  this._partialOutput = forge$z.util.createBuffer();
  this._partialBytes = 0;
  this._R = 3774873600;
};
modes.gcm.prototype.start = function(options) {
  if (!("iv" in options)) {
    throw new Error("Invalid IV parameter.");
  }
  var iv = forge$z.util.createBuffer(options.iv);
  this._cipherLength = 0;
  var additionalData;
  if ("additionalData" in options) {
    additionalData = forge$z.util.createBuffer(options.additionalData);
  } else {
    additionalData = forge$z.util.createBuffer();
  }
  if ("tagLength" in options) {
    this._tagLength = options.tagLength;
  } else {
    this._tagLength = 128;
  }
  this._tag = null;
  if (options.decrypt) {
    this._tag = forge$z.util.createBuffer(options.tag).getBytes();
    if (this._tag.length !== this._tagLength / 8) {
      throw new Error("Authentication tag does not match tag length.");
    }
  }
  this._hashBlock = new Array(this._ints);
  this.tag = null;
  this._hashSubkey = new Array(this._ints);
  this.cipher.encrypt([0, 0, 0, 0], this._hashSubkey);
  this.componentBits = 4;
  this._m = this.generateHashTable(this._hashSubkey, this.componentBits);
  var ivLength = iv.length();
  if (ivLength === 12) {
    this._j0 = [iv.getInt32(), iv.getInt32(), iv.getInt32(), 1];
  } else {
    this._j0 = [0, 0, 0, 0];
    while (iv.length() > 0) {
      this._j0 = this.ghash(this._hashSubkey, this._j0, [iv.getInt32(), iv.getInt32(), iv.getInt32(), iv.getInt32()]);
    }
    this._j0 = this.ghash(this._hashSubkey, this._j0, [0, 0].concat(from64To32(ivLength * 8)));
  }
  this._inBlock = this._j0.slice(0);
  inc32(this._inBlock);
  this._partialBytes = 0;
  additionalData = forge$z.util.createBuffer(additionalData);
  this._aDataLength = from64To32(additionalData.length() * 8);
  var overflow = additionalData.length() % this.blockSize;
  if (overflow) {
    additionalData.fillWithByte(0, this.blockSize - overflow);
  }
  this._s = [0, 0, 0, 0];
  while (additionalData.length() > 0) {
    this._s = this.ghash(this._hashSubkey, this._s, [
      additionalData.getInt32(),
      additionalData.getInt32(),
      additionalData.getInt32(),
      additionalData.getInt32()
    ]);
  }
};
modes.gcm.prototype.encrypt = function(input, output, finish3) {
  var inputLength = input.length();
  if (inputLength === 0) {
    return true;
  }
  this.cipher.encrypt(this._inBlock, this._outBlock);
  if (this._partialBytes === 0 && inputLength >= this.blockSize) {
    for (var i2 = 0; i2 < this._ints; ++i2) {
      output.putInt32(this._outBlock[i2] ^= input.getInt32());
    }
    this._cipherLength += this.blockSize;
  } else {
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if (partialBytes > 0) {
      partialBytes = this.blockSize - partialBytes;
    }
    this._partialOutput.clear();
    for (var i2 = 0; i2 < this._ints; ++i2) {
      this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i2]);
    }
    if (partialBytes <= 0 || finish3) {
      if (finish3) {
        var overflow = inputLength % this.blockSize;
        this._cipherLength += overflow;
        this._partialOutput.truncate(this.blockSize - overflow);
      } else {
        this._cipherLength += this.blockSize;
      }
      for (var i2 = 0; i2 < this._ints; ++i2) {
        this._outBlock[i2] = this._partialOutput.getInt32();
      }
      this._partialOutput.read -= this.blockSize;
    }
    if (this._partialBytes > 0) {
      this._partialOutput.getBytes(this._partialBytes);
    }
    if (partialBytes > 0 && !finish3) {
      input.read -= this.blockSize;
      output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
      this._partialBytes = partialBytes;
      return true;
    }
    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
  }
  this._s = this.ghash(this._hashSubkey, this._s, this._outBlock);
  inc32(this._inBlock);
};
modes.gcm.prototype.decrypt = function(input, output, finish3) {
  var inputLength = input.length();
  if (inputLength < this.blockSize && !(finish3 && inputLength > 0)) {
    return true;
  }
  this.cipher.encrypt(this._inBlock, this._outBlock);
  inc32(this._inBlock);
  this._hashBlock[0] = input.getInt32();
  this._hashBlock[1] = input.getInt32();
  this._hashBlock[2] = input.getInt32();
  this._hashBlock[3] = input.getInt32();
  this._s = this.ghash(this._hashSubkey, this._s, this._hashBlock);
  for (var i2 = 0; i2 < this._ints; ++i2) {
    output.putInt32(this._outBlock[i2] ^ this._hashBlock[i2]);
  }
  if (inputLength < this.blockSize) {
    this._cipherLength += inputLength % this.blockSize;
  } else {
    this._cipherLength += this.blockSize;
  }
};
modes.gcm.prototype.afterFinish = function(output, options) {
  var rval = true;
  if (options.decrypt && options.overflow) {
    output.truncate(this.blockSize - options.overflow);
  }
  this.tag = forge$z.util.createBuffer();
  var lengths = this._aDataLength.concat(from64To32(this._cipherLength * 8));
  this._s = this.ghash(this._hashSubkey, this._s, lengths);
  var tag2 = [];
  this.cipher.encrypt(this._j0, tag2);
  for (var i2 = 0; i2 < this._ints; ++i2) {
    this.tag.putInt32(this._s[i2] ^ tag2[i2]);
  }
  this.tag.truncate(this.tag.length() % (this._tagLength / 8));
  if (options.decrypt && this.tag.bytes() !== this._tag) {
    rval = false;
  }
  return rval;
};
modes.gcm.prototype.multiply = function(x2, y) {
  var z_i = [0, 0, 0, 0];
  var v_i = y.slice(0);
  for (var i2 = 0; i2 < 128; ++i2) {
    var x_i = x2[i2 / 32 | 0] & 1 << 31 - i2 % 32;
    if (x_i) {
      z_i[0] ^= v_i[0];
      z_i[1] ^= v_i[1];
      z_i[2] ^= v_i[2];
      z_i[3] ^= v_i[3];
    }
    this.pow(v_i, v_i);
  }
  return z_i;
};
modes.gcm.prototype.pow = function(x2, out) {
  var lsb = x2[3] & 1;
  for (var i2 = 3; i2 > 0; --i2) {
    out[i2] = x2[i2] >>> 1 | (x2[i2 - 1] & 1) << 31;
  }
  out[0] = x2[0] >>> 1;
  if (lsb) {
    out[0] ^= this._R;
  }
};
modes.gcm.prototype.tableMultiply = function(x2) {
  var z = [0, 0, 0, 0];
  for (var i2 = 0; i2 < 32; ++i2) {
    var idx = i2 / 8 | 0;
    var x_i = x2[idx] >>> (7 - i2 % 8) * 4 & 15;
    var ah = this._m[i2][x_i];
    z[0] ^= ah[0];
    z[1] ^= ah[1];
    z[2] ^= ah[2];
    z[3] ^= ah[3];
  }
  return z;
};
modes.gcm.prototype.ghash = function(h, y, x2) {
  y[0] ^= x2[0];
  y[1] ^= x2[1];
  y[2] ^= x2[2];
  y[3] ^= x2[3];
  return this.tableMultiply(y);
};
modes.gcm.prototype.generateHashTable = function(h, bits) {
  var multiplier = 8 / bits;
  var perInt = 4 * multiplier;
  var size = 16 * multiplier;
  var m = new Array(size);
  for (var i2 = 0; i2 < size; ++i2) {
    var tmp = [0, 0, 0, 0];
    var idx = i2 / perInt | 0;
    var shft = (perInt - 1 - i2 % perInt) * bits;
    tmp[idx] = 1 << bits - 1 << shft;
    m[i2] = this.generateSubHashTable(this.multiply(tmp, h), bits);
  }
  return m;
};
modes.gcm.prototype.generateSubHashTable = function(mid, bits) {
  var size = 1 << bits;
  var half = size >>> 1;
  var m = new Array(size);
  m[half] = mid.slice(0);
  var i2 = half >>> 1;
  while (i2 > 0) {
    this.pow(m[2 * i2], m[i2] = []);
    i2 >>= 1;
  }
  i2 = 2;
  while (i2 < half) {
    for (var j = 1; j < i2; ++j) {
      var m_i = m[i2];
      var m_j = m[j];
      m[i2 + j] = [
        m_i[0] ^ m_j[0],
        m_i[1] ^ m_j[1],
        m_i[2] ^ m_j[2],
        m_i[3] ^ m_j[3]
      ];
    }
    i2 *= 2;
  }
  m[0] = [0, 0, 0, 0];
  for (i2 = half + 1; i2 < size; ++i2) {
    var c = m[i2 ^ half];
    m[i2] = [mid[0] ^ c[0], mid[1] ^ c[1], mid[2] ^ c[2], mid[3] ^ c[3]];
  }
  return m;
};
function transformIV(iv, blockSize) {
  if (typeof iv === "string") {
    iv = forge$z.util.createBuffer(iv);
  }
  if (forge$z.util.isArray(iv) && iv.length > 4) {
    var tmp = iv;
    iv = forge$z.util.createBuffer();
    for (var i2 = 0; i2 < tmp.length; ++i2) {
      iv.putByte(tmp[i2]);
    }
  }
  if (iv.length() < blockSize) {
    throw new Error("Invalid IV length; got " + iv.length() + " bytes and expected " + blockSize + " bytes.");
  }
  if (!forge$z.util.isArray(iv)) {
    var ints = [];
    var blocks = blockSize / 4;
    for (var i2 = 0; i2 < blocks; ++i2) {
      ints.push(iv.getInt32());
    }
    iv = ints;
  }
  return iv;
}
function inc32(block) {
  block[block.length - 1] = block[block.length - 1] + 1 & 4294967295;
}
function from64To32(num) {
  return [num / 4294967296 | 0, num & 4294967295];
}
var forge$y = forge$C;
forge$y.aes = forge$y.aes || {};
forge$y.aes.startEncrypting = function(key, iv, output, mode) {
  var cipher = _createCipher$1({
    key,
    output,
    decrypt: false,
    mode
  });
  cipher.start(iv);
  return cipher;
};
forge$y.aes.createEncryptionCipher = function(key, mode) {
  return _createCipher$1({
    key,
    output: null,
    decrypt: false,
    mode
  });
};
forge$y.aes.startDecrypting = function(key, iv, output, mode) {
  var cipher = _createCipher$1({
    key,
    output,
    decrypt: true,
    mode
  });
  cipher.start(iv);
  return cipher;
};
forge$y.aes.createDecryptionCipher = function(key, mode) {
  return _createCipher$1({
    key,
    output: null,
    decrypt: true,
    mode
  });
};
forge$y.aes.Algorithm = function(name, mode) {
  if (!init$1) {
    initialize();
  }
  var self2 = this;
  self2.name = name;
  self2.mode = new mode({
    blockSize: 16,
    cipher: {
      encrypt: function(inBlock, outBlock) {
        return _updateBlock$1(self2._w, inBlock, outBlock, false);
      },
      decrypt: function(inBlock, outBlock) {
        return _updateBlock$1(self2._w, inBlock, outBlock, true);
      }
    }
  });
  self2._init = false;
};
forge$y.aes.Algorithm.prototype.initialize = function(options) {
  if (this._init) {
    return;
  }
  var key = options.key;
  var tmp;
  if (typeof key === "string" && (key.length === 16 || key.length === 24 || key.length === 32)) {
    key = forge$y.util.createBuffer(key);
  } else if (forge$y.util.isArray(key) && (key.length === 16 || key.length === 24 || key.length === 32)) {
    tmp = key;
    key = forge$y.util.createBuffer();
    for (var i2 = 0; i2 < tmp.length; ++i2) {
      key.putByte(tmp[i2]);
    }
  }
  if (!forge$y.util.isArray(key)) {
    tmp = key;
    key = [];
    var len = tmp.length();
    if (len === 16 || len === 24 || len === 32) {
      len = len >>> 2;
      for (var i2 = 0; i2 < len; ++i2) {
        key.push(tmp.getInt32());
      }
    }
  }
  if (!forge$y.util.isArray(key) || !(key.length === 4 || key.length === 6 || key.length === 8)) {
    throw new Error("Invalid key parameter.");
  }
  var mode = this.mode.name;
  var encryptOp = ["CFB", "OFB", "CTR", "GCM"].indexOf(mode) !== -1;
  this._w = _expandKey(key, options.decrypt && !encryptOp);
  this._init = true;
};
forge$y.aes._expandKey = function(key, decrypt) {
  if (!init$1) {
    initialize();
  }
  return _expandKey(key, decrypt);
};
forge$y.aes._updateBlock = _updateBlock$1;
registerAlgorithm$1("AES-ECB", forge$y.cipher.modes.ecb);
registerAlgorithm$1("AES-CBC", forge$y.cipher.modes.cbc);
registerAlgorithm$1("AES-CFB", forge$y.cipher.modes.cfb);
registerAlgorithm$1("AES-OFB", forge$y.cipher.modes.ofb);
registerAlgorithm$1("AES-CTR", forge$y.cipher.modes.ctr);
registerAlgorithm$1("AES-GCM", forge$y.cipher.modes.gcm);
function registerAlgorithm$1(name, mode) {
  var factory = function() {
    return new forge$y.aes.Algorithm(name, mode);
  };
  forge$y.cipher.registerAlgorithm(name, factory);
}
var init$1 = false;
var Nb = 4;
var sbox;
var isbox;
var rcon;
var mix;
var imix;
function initialize() {
  init$1 = true;
  rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54];
  var xtime = new Array(256);
  for (var i2 = 0; i2 < 128; ++i2) {
    xtime[i2] = i2 << 1;
    xtime[i2 + 128] = i2 + 128 << 1 ^ 283;
  }
  sbox = new Array(256);
  isbox = new Array(256);
  mix = new Array(4);
  imix = new Array(4);
  for (var i2 = 0; i2 < 4; ++i2) {
    mix[i2] = new Array(256);
    imix[i2] = new Array(256);
  }
  var e = 0, ei = 0, e2, e4, e8, sx, sx2, me, ime;
  for (var i2 = 0; i2 < 256; ++i2) {
    sx = ei ^ ei << 1 ^ ei << 2 ^ ei << 3 ^ ei << 4;
    sx = sx >> 8 ^ sx & 255 ^ 99;
    sbox[e] = sx;
    isbox[sx] = e;
    sx2 = xtime[sx];
    e2 = xtime[e];
    e4 = xtime[e2];
    e8 = xtime[e4];
    me = sx2 << 24 ^ sx << 16 ^ sx << 8 ^ (sx ^ sx2);
    ime = (e2 ^ e4 ^ e8) << 24 ^ (e ^ e8) << 16 ^ (e ^ e4 ^ e8) << 8 ^ (e ^ e2 ^ e8);
    for (var n = 0; n < 4; ++n) {
      mix[n][e] = me;
      imix[n][sx] = ime;
      me = me << 24 | me >>> 8;
      ime = ime << 24 | ime >>> 8;
    }
    if (e === 0) {
      e = ei = 1;
    } else {
      e = e2 ^ xtime[xtime[xtime[e2 ^ e8]]];
      ei ^= xtime[xtime[ei]];
    }
  }
}
function _expandKey(key, decrypt) {
  var w = key.slice(0);
  var temp, iNk = 1;
  var Nk = w.length;
  var Nr1 = Nk + 6 + 1;
  var end2 = Nb * Nr1;
  for (var i2 = Nk; i2 < end2; ++i2) {
    temp = w[i2 - 1];
    if (i2 % Nk === 0) {
      temp = sbox[temp >>> 16 & 255] << 24 ^ sbox[temp >>> 8 & 255] << 16 ^ sbox[temp & 255] << 8 ^ sbox[temp >>> 24] ^ rcon[iNk] << 24;
      iNk++;
    } else if (Nk > 6 && i2 % Nk === 4) {
      temp = sbox[temp >>> 24] << 24 ^ sbox[temp >>> 16 & 255] << 16 ^ sbox[temp >>> 8 & 255] << 8 ^ sbox[temp & 255];
    }
    w[i2] = w[i2 - Nk] ^ temp;
  }
  if (decrypt) {
    var tmp;
    var m0 = imix[0];
    var m1 = imix[1];
    var m2 = imix[2];
    var m3 = imix[3];
    var wnew = w.slice(0);
    end2 = w.length;
    for (var i2 = 0, wi = end2 - Nb; i2 < end2; i2 += Nb, wi -= Nb) {
      if (i2 === 0 || i2 === end2 - Nb) {
        wnew[i2] = w[wi];
        wnew[i2 + 1] = w[wi + 3];
        wnew[i2 + 2] = w[wi + 2];
        wnew[i2 + 3] = w[wi + 1];
      } else {
        for (var n = 0; n < Nb; ++n) {
          tmp = w[wi + n];
          wnew[i2 + (3 & -n)] = m0[sbox[tmp >>> 24]] ^ m1[sbox[tmp >>> 16 & 255]] ^ m2[sbox[tmp >>> 8 & 255]] ^ m3[sbox[tmp & 255]];
        }
      }
    }
    w = wnew;
  }
  return w;
}
function _updateBlock$1(w, input, output, decrypt) {
  var Nr = w.length / 4 - 1;
  var m0, m1, m2, m3, sub;
  if (decrypt) {
    m0 = imix[0];
    m1 = imix[1];
    m2 = imix[2];
    m3 = imix[3];
    sub = isbox;
  } else {
    m0 = mix[0];
    m1 = mix[1];
    m2 = mix[2];
    m3 = mix[3];
    sub = sbox;
  }
  var a, b, c, d, a2, b2, c2;
  a = input[0] ^ w[0];
  b = input[decrypt ? 3 : 1] ^ w[1];
  c = input[2] ^ w[2];
  d = input[decrypt ? 1 : 3] ^ w[3];
  var i2 = 3;
  for (var round2 = 1; round2 < Nr; ++round2) {
    a2 = m0[a >>> 24] ^ m1[b >>> 16 & 255] ^ m2[c >>> 8 & 255] ^ m3[d & 255] ^ w[++i2];
    b2 = m0[b >>> 24] ^ m1[c >>> 16 & 255] ^ m2[d >>> 8 & 255] ^ m3[a & 255] ^ w[++i2];
    c2 = m0[c >>> 24] ^ m1[d >>> 16 & 255] ^ m2[a >>> 8 & 255] ^ m3[b & 255] ^ w[++i2];
    d = m0[d >>> 24] ^ m1[a >>> 16 & 255] ^ m2[b >>> 8 & 255] ^ m3[c & 255] ^ w[++i2];
    a = a2;
    b = b2;
    c = c2;
  }
  output[0] = sub[a >>> 24] << 24 ^ sub[b >>> 16 & 255] << 16 ^ sub[c >>> 8 & 255] << 8 ^ sub[d & 255] ^ w[++i2];
  output[decrypt ? 3 : 1] = sub[b >>> 24] << 24 ^ sub[c >>> 16 & 255] << 16 ^ sub[d >>> 8 & 255] << 8 ^ sub[a & 255] ^ w[++i2];
  output[2] = sub[c >>> 24] << 24 ^ sub[d >>> 16 & 255] << 16 ^ sub[a >>> 8 & 255] << 8 ^ sub[b & 255] ^ w[++i2];
  output[decrypt ? 1 : 3] = sub[d >>> 24] << 24 ^ sub[a >>> 16 & 255] << 16 ^ sub[b >>> 8 & 255] << 8 ^ sub[c & 255] ^ w[++i2];
}
function _createCipher$1(options) {
  options = options || {};
  var mode = (options.mode || "CBC").toUpperCase();
  var algorithm = "AES-" + mode;
  var cipher;
  if (options.decrypt) {
    cipher = forge$y.cipher.createDecipher(algorithm, options.key);
  } else {
    cipher = forge$y.cipher.createCipher(algorithm, options.key);
  }
  var start3 = cipher.start;
  cipher.start = function(iv, options2) {
    var output = null;
    if (options2 instanceof forge$y.util.ByteBuffer) {
      output = options2;
      options2 = {};
    }
    options2 = options2 || {};
    options2.output = output;
    options2.iv = iv;
    start3.call(cipher, options2);
  };
  return cipher;
}
var forge$x = forge$C;
forge$x.pki = forge$x.pki || {};
var oids$2 = forge$x.pki.oids = forge$x.oids = forge$x.oids || {};
function _IN(id, name) {
  oids$2[id] = name;
  oids$2[name] = id;
}
function _I_(id, name) {
  oids$2[id] = name;
}
_IN("1.2.840.113549.1.1.1", "rsaEncryption");
_IN("1.2.840.113549.1.1.4", "md5WithRSAEncryption");
_IN("1.2.840.113549.1.1.5", "sha1WithRSAEncryption");
_IN("1.2.840.113549.1.1.7", "RSAES-OAEP");
_IN("1.2.840.113549.1.1.8", "mgf1");
_IN("1.2.840.113549.1.1.9", "pSpecified");
_IN("1.2.840.113549.1.1.10", "RSASSA-PSS");
_IN("1.2.840.113549.1.1.11", "sha256WithRSAEncryption");
_IN("1.2.840.113549.1.1.12", "sha384WithRSAEncryption");
_IN("1.2.840.113549.1.1.13", "sha512WithRSAEncryption");
_IN("1.3.101.112", "EdDSA25519");
_IN("1.2.840.10040.4.3", "dsa-with-sha1");
_IN("1.3.14.3.2.7", "desCBC");
_IN("1.3.14.3.2.26", "sha1");
_IN("1.3.14.3.2.29", "sha1WithRSASignature");
_IN("2.16.840.1.101.3.4.2.1", "sha256");
_IN("2.16.840.1.101.3.4.2.2", "sha384");
_IN("2.16.840.1.101.3.4.2.3", "sha512");
_IN("1.2.840.113549.2.5", "md5");
_IN("1.2.840.113549.1.7.1", "data");
_IN("1.2.840.113549.1.7.2", "signedData");
_IN("1.2.840.113549.1.7.3", "envelopedData");
_IN("1.2.840.113549.1.7.4", "signedAndEnvelopedData");
_IN("1.2.840.113549.1.7.5", "digestedData");
_IN("1.2.840.113549.1.7.6", "encryptedData");
_IN("1.2.840.113549.1.9.1", "emailAddress");
_IN("1.2.840.113549.1.9.2", "unstructuredName");
_IN("1.2.840.113549.1.9.3", "contentType");
_IN("1.2.840.113549.1.9.4", "messageDigest");
_IN("1.2.840.113549.1.9.5", "signingTime");
_IN("1.2.840.113549.1.9.6", "counterSignature");
_IN("1.2.840.113549.1.9.7", "challengePassword");
_IN("1.2.840.113549.1.9.8", "unstructuredAddress");
_IN("1.2.840.113549.1.9.14", "extensionRequest");
_IN("1.2.840.113549.1.9.20", "friendlyName");
_IN("1.2.840.113549.1.9.21", "localKeyId");
_IN("1.2.840.113549.1.9.22.1", "x509Certificate");
_IN("1.2.840.113549.1.12.10.1.1", "keyBag");
_IN("1.2.840.113549.1.12.10.1.2", "pkcs8ShroudedKeyBag");
_IN("1.2.840.113549.1.12.10.1.3", "certBag");
_IN("1.2.840.113549.1.12.10.1.4", "crlBag");
_IN("1.2.840.113549.1.12.10.1.5", "secretBag");
_IN("1.2.840.113549.1.12.10.1.6", "safeContentsBag");
_IN("1.2.840.113549.1.5.13", "pkcs5PBES2");
_IN("1.2.840.113549.1.5.12", "pkcs5PBKDF2");
_IN("1.2.840.113549.1.12.1.1", "pbeWithSHAAnd128BitRC4");
_IN("1.2.840.113549.1.12.1.2", "pbeWithSHAAnd40BitRC4");
_IN("1.2.840.113549.1.12.1.3", "pbeWithSHAAnd3-KeyTripleDES-CBC");
_IN("1.2.840.113549.1.12.1.4", "pbeWithSHAAnd2-KeyTripleDES-CBC");
_IN("1.2.840.113549.1.12.1.5", "pbeWithSHAAnd128BitRC2-CBC");
_IN("1.2.840.113549.1.12.1.6", "pbewithSHAAnd40BitRC2-CBC");
_IN("1.2.840.113549.2.7", "hmacWithSHA1");
_IN("1.2.840.113549.2.8", "hmacWithSHA224");
_IN("1.2.840.113549.2.9", "hmacWithSHA256");
_IN("1.2.840.113549.2.10", "hmacWithSHA384");
_IN("1.2.840.113549.2.11", "hmacWithSHA512");
_IN("1.2.840.113549.3.7", "des-EDE3-CBC");
_IN("2.16.840.1.101.3.4.1.2", "aes128-CBC");
_IN("2.16.840.1.101.3.4.1.22", "aes192-CBC");
_IN("2.16.840.1.101.3.4.1.42", "aes256-CBC");
_IN("2.5.4.3", "commonName");
_IN("2.5.4.4", "surname");
_IN("2.5.4.5", "serialNumber");
_IN("2.5.4.6", "countryName");
_IN("2.5.4.7", "localityName");
_IN("2.5.4.8", "stateOrProvinceName");
_IN("2.5.4.9", "streetAddress");
_IN("2.5.4.10", "organizationName");
_IN("2.5.4.11", "organizationalUnitName");
_IN("2.5.4.12", "title");
_IN("2.5.4.13", "description");
_IN("2.5.4.15", "businessCategory");
_IN("2.5.4.17", "postalCode");
_IN("2.5.4.42", "givenName");
_IN("1.3.6.1.4.1.311.60.2.1.2", "jurisdictionOfIncorporationStateOrProvinceName");
_IN("1.3.6.1.4.1.311.60.2.1.3", "jurisdictionOfIncorporationCountryName");
_IN("2.16.840.1.113730.1.1", "nsCertType");
_IN("2.16.840.1.113730.1.13", "nsComment");
_I_("2.5.29.1", "authorityKeyIdentifier");
_I_("2.5.29.2", "keyAttributes");
_I_("2.5.29.3", "certificatePolicies");
_I_("2.5.29.4", "keyUsageRestriction");
_I_("2.5.29.5", "policyMapping");
_I_("2.5.29.6", "subtreesConstraint");
_I_("2.5.29.7", "subjectAltName");
_I_("2.5.29.8", "issuerAltName");
_I_("2.5.29.9", "subjectDirectoryAttributes");
_I_("2.5.29.10", "basicConstraints");
_I_("2.5.29.11", "nameConstraints");
_I_("2.5.29.12", "policyConstraints");
_I_("2.5.29.13", "basicConstraints");
_IN("2.5.29.14", "subjectKeyIdentifier");
_IN("2.5.29.15", "keyUsage");
_I_("2.5.29.16", "privateKeyUsagePeriod");
_IN("2.5.29.17", "subjectAltName");
_IN("2.5.29.18", "issuerAltName");
_IN("2.5.29.19", "basicConstraints");
_I_("2.5.29.20", "cRLNumber");
_I_("2.5.29.21", "cRLReason");
_I_("2.5.29.22", "expirationDate");
_I_("2.5.29.23", "instructionCode");
_I_("2.5.29.24", "invalidityDate");
_I_("2.5.29.25", "cRLDistributionPoints");
_I_("2.5.29.26", "issuingDistributionPoint");
_I_("2.5.29.27", "deltaCRLIndicator");
_I_("2.5.29.28", "issuingDistributionPoint");
_I_("2.5.29.29", "certificateIssuer");
_I_("2.5.29.30", "nameConstraints");
_IN("2.5.29.31", "cRLDistributionPoints");
_IN("2.5.29.32", "certificatePolicies");
_I_("2.5.29.33", "policyMappings");
_I_("2.5.29.34", "policyConstraints");
_IN("2.5.29.35", "authorityKeyIdentifier");
_I_("2.5.29.36", "policyConstraints");
_IN("2.5.29.37", "extKeyUsage");
_I_("2.5.29.46", "freshestCRL");
_I_("2.5.29.54", "inhibitAnyPolicy");
_IN("1.3.6.1.4.1.11129.2.4.2", "timestampList");
_IN("1.3.6.1.5.5.7.1.1", "authorityInfoAccess");
_IN("1.3.6.1.5.5.7.3.1", "serverAuth");
_IN("1.3.6.1.5.5.7.3.2", "clientAuth");
_IN("1.3.6.1.5.5.7.3.3", "codeSigning");
_IN("1.3.6.1.5.5.7.3.4", "emailProtection");
_IN("1.3.6.1.5.5.7.3.8", "timeStamping");
var forge$w = forge$C;
var asn1$8 = forge$w.asn1 = forge$w.asn1 || {};
asn1$8.Class = {
  UNIVERSAL: 0,
  APPLICATION: 64,
  CONTEXT_SPECIFIC: 128,
  PRIVATE: 192
};
asn1$8.Type = {
  NONE: 0,
  BOOLEAN: 1,
  INTEGER: 2,
  BITSTRING: 3,
  OCTETSTRING: 4,
  NULL: 5,
  OID: 6,
  ODESC: 7,
  EXTERNAL: 8,
  REAL: 9,
  ENUMERATED: 10,
  EMBEDDED: 11,
  UTF8: 12,
  ROID: 13,
  SEQUENCE: 16,
  SET: 17,
  PRINTABLESTRING: 19,
  IA5STRING: 22,
  UTCTIME: 23,
  GENERALIZEDTIME: 24,
  BMPSTRING: 30
};
asn1$8.create = function(tagClass, type, constructed, value, options) {
  if (forge$w.util.isArray(value)) {
    var tmp = [];
    for (var i2 = 0; i2 < value.length; ++i2) {
      if (value[i2] !== void 0) {
        tmp.push(value[i2]);
      }
    }
    value = tmp;
  }
  var obj = {
    tagClass,
    type,
    constructed,
    composed: constructed || forge$w.util.isArray(value),
    value
  };
  if (options && "bitStringContents" in options) {
    obj.bitStringContents = options.bitStringContents;
    obj.original = asn1$8.copy(obj);
  }
  return obj;
};
asn1$8.copy = function(obj, options) {
  var copy5;
  if (forge$w.util.isArray(obj)) {
    copy5 = [];
    for (var i2 = 0; i2 < obj.length; ++i2) {
      copy5.push(asn1$8.copy(obj[i2], options));
    }
    return copy5;
  }
  if (typeof obj === "string") {
    return obj;
  }
  copy5 = {
    tagClass: obj.tagClass,
    type: obj.type,
    constructed: obj.constructed,
    composed: obj.composed,
    value: asn1$8.copy(obj.value, options)
  };
  if (options && !options.excludeBitStringContents) {
    copy5.bitStringContents = obj.bitStringContents;
  }
  return copy5;
};
asn1$8.equals = function(obj1, obj2, options) {
  if (forge$w.util.isArray(obj1)) {
    if (!forge$w.util.isArray(obj2)) {
      return false;
    }
    if (obj1.length !== obj2.length) {
      return false;
    }
    for (var i2 = 0; i2 < obj1.length; ++i2) {
      if (!asn1$8.equals(obj1[i2], obj2[i2])) {
        return false;
      }
    }
    return true;
  }
  if (typeof obj1 !== typeof obj2) {
    return false;
  }
  if (typeof obj1 === "string") {
    return obj1 === obj2;
  }
  var equal2 = obj1.tagClass === obj2.tagClass && obj1.type === obj2.type && obj1.constructed === obj2.constructed && obj1.composed === obj2.composed && asn1$8.equals(obj1.value, obj2.value);
  if (options && options.includeBitStringContents) {
    equal2 = equal2 && obj1.bitStringContents === obj2.bitStringContents;
  }
  return equal2;
};
asn1$8.getBerValueLength = function(b) {
  var b2 = b.getByte();
  if (b2 === 128) {
    return void 0;
  }
  var length;
  var longForm = b2 & 128;
  if (!longForm) {
    length = b2;
  } else {
    length = b.getInt((b2 & 127) << 3);
  }
  return length;
};
function _checkBufferLength(bytes, remaining, n) {
  if (n > remaining) {
    var error = new Error("Too few bytes to parse DER.");
    error.available = bytes.length();
    error.remaining = remaining;
    error.requested = n;
    throw error;
  }
}
var _getValueLength = function(bytes, remaining) {
  var b2 = bytes.getByte();
  remaining--;
  if (b2 === 128) {
    return void 0;
  }
  var length;
  var longForm = b2 & 128;
  if (!longForm) {
    length = b2;
  } else {
    var longFormBytes = b2 & 127;
    _checkBufferLength(bytes, remaining, longFormBytes);
    length = bytes.getInt(longFormBytes << 3);
  }
  if (length < 0) {
    throw new Error("Negative length: " + length);
  }
  return length;
};
asn1$8.fromDer = function(bytes, options) {
  if (options === void 0) {
    options = {
      strict: true,
      decodeBitStrings: true
    };
  }
  if (typeof options === "boolean") {
    options = {
      strict: options,
      decodeBitStrings: true
    };
  }
  if (!("strict" in options)) {
    options.strict = true;
  }
  if (!("decodeBitStrings" in options)) {
    options.decodeBitStrings = true;
  }
  if (typeof bytes === "string") {
    bytes = forge$w.util.createBuffer(bytes);
  }
  return _fromDer(bytes, bytes.length(), 0, options);
};
function _fromDer(bytes, remaining, depth, options) {
  var start3;
  _checkBufferLength(bytes, remaining, 2);
  var b1 = bytes.getByte();
  remaining--;
  var tagClass = b1 & 192;
  var type = b1 & 31;
  start3 = bytes.length();
  var length = _getValueLength(bytes, remaining);
  remaining -= start3 - bytes.length();
  if (length !== void 0 && length > remaining) {
    if (options.strict) {
      var error = new Error("Too few bytes to read ASN.1 value.");
      error.available = bytes.length();
      error.remaining = remaining;
      error.requested = length;
      throw error;
    }
    length = remaining;
  }
  var value;
  var bitStringContents;
  var constructed = (b1 & 32) === 32;
  if (constructed) {
    value = [];
    if (length === void 0) {
      for (; ; ) {
        _checkBufferLength(bytes, remaining, 2);
        if (bytes.bytes(2) === String.fromCharCode(0, 0)) {
          bytes.getBytes(2);
          remaining -= 2;
          break;
        }
        start3 = bytes.length();
        value.push(_fromDer(bytes, remaining, depth + 1, options));
        remaining -= start3 - bytes.length();
      }
    } else {
      while (length > 0) {
        start3 = bytes.length();
        value.push(_fromDer(bytes, length, depth + 1, options));
        remaining -= start3 - bytes.length();
        length -= start3 - bytes.length();
      }
    }
  }
  if (value === void 0 && tagClass === asn1$8.Class.UNIVERSAL && type === asn1$8.Type.BITSTRING) {
    bitStringContents = bytes.bytes(length);
  }
  if (value === void 0 && options.decodeBitStrings && tagClass === asn1$8.Class.UNIVERSAL && type === asn1$8.Type.BITSTRING && length > 1) {
    var savedRead = bytes.read;
    var savedRemaining = remaining;
    var unused = 0;
    if (type === asn1$8.Type.BITSTRING) {
      _checkBufferLength(bytes, remaining, 1);
      unused = bytes.getByte();
      remaining--;
    }
    if (unused === 0) {
      try {
        start3 = bytes.length();
        var subOptions = {
          verbose: options.verbose,
          strict: true,
          decodeBitStrings: true
        };
        var composed = _fromDer(bytes, remaining, depth + 1, subOptions);
        var used = start3 - bytes.length();
        remaining -= used;
        if (type == asn1$8.Type.BITSTRING) {
          used++;
        }
        var tc = composed.tagClass;
        if (used === length && (tc === asn1$8.Class.UNIVERSAL || tc === asn1$8.Class.CONTEXT_SPECIFIC)) {
          value = [composed];
        }
      } catch (ex) {
      }
    }
    if (value === void 0) {
      bytes.read = savedRead;
      remaining = savedRemaining;
    }
  }
  if (value === void 0) {
    if (length === void 0) {
      if (options.strict) {
        throw new Error("Non-constructed ASN.1 object of indefinite length.");
      }
      length = remaining;
    }
    if (type === asn1$8.Type.BMPSTRING) {
      value = "";
      for (; length > 0; length -= 2) {
        _checkBufferLength(bytes, remaining, 2);
        value += String.fromCharCode(bytes.getInt16());
        remaining -= 2;
      }
    } else {
      value = bytes.getBytes(length);
    }
  }
  var asn1Options = bitStringContents === void 0 ? null : {
    bitStringContents
  };
  return asn1$8.create(tagClass, type, constructed, value, asn1Options);
}
asn1$8.toDer = function(obj) {
  var bytes = forge$w.util.createBuffer();
  var b1 = obj.tagClass | obj.type;
  var value = forge$w.util.createBuffer();
  var useBitStringContents = false;
  if ("bitStringContents" in obj) {
    useBitStringContents = true;
    if (obj.original) {
      useBitStringContents = asn1$8.equals(obj, obj.original);
    }
  }
  if (useBitStringContents) {
    value.putBytes(obj.bitStringContents);
  } else if (obj.composed) {
    if (obj.constructed) {
      b1 |= 32;
    } else {
      value.putByte(0);
    }
    for (var i2 = 0; i2 < obj.value.length; ++i2) {
      if (obj.value[i2] !== void 0) {
        value.putBuffer(asn1$8.toDer(obj.value[i2]));
      }
    }
  } else {
    if (obj.type === asn1$8.Type.BMPSTRING) {
      for (var i2 = 0; i2 < obj.value.length; ++i2) {
        value.putInt16(obj.value.charCodeAt(i2));
      }
    } else {
      if (obj.type === asn1$8.Type.INTEGER && obj.value.length > 1 && (obj.value.charCodeAt(0) === 0 && (obj.value.charCodeAt(1) & 128) === 0 || obj.value.charCodeAt(0) === 255 && (obj.value.charCodeAt(1) & 128) === 128)) {
        value.putBytes(obj.value.substr(1));
      } else {
        value.putBytes(obj.value);
      }
    }
  }
  bytes.putByte(b1);
  if (value.length() <= 127) {
    bytes.putByte(value.length() & 127);
  } else {
    var len = value.length();
    var lenBytes = "";
    do {
      lenBytes += String.fromCharCode(len & 255);
      len = len >>> 8;
    } while (len > 0);
    bytes.putByte(lenBytes.length | 128);
    for (var i2 = lenBytes.length - 1; i2 >= 0; --i2) {
      bytes.putByte(lenBytes.charCodeAt(i2));
    }
  }
  bytes.putBuffer(value);
  return bytes;
};
asn1$8.oidToDer = function(oid) {
  var values = oid.split(".");
  var bytes = forge$w.util.createBuffer();
  bytes.putByte(40 * parseInt(values[0], 10) + parseInt(values[1], 10));
  var last, valueBytes, value, b;
  for (var i2 = 2; i2 < values.length; ++i2) {
    last = true;
    valueBytes = [];
    value = parseInt(values[i2], 10);
    do {
      b = value & 127;
      value = value >>> 7;
      if (!last) {
        b |= 128;
      }
      valueBytes.push(b);
      last = false;
    } while (value > 0);
    for (var n = valueBytes.length - 1; n >= 0; --n) {
      bytes.putByte(valueBytes[n]);
    }
  }
  return bytes;
};
asn1$8.derToOid = function(bytes) {
  var oid;
  if (typeof bytes === "string") {
    bytes = forge$w.util.createBuffer(bytes);
  }
  var b = bytes.getByte();
  oid = Math.floor(b / 40) + "." + b % 40;
  var value = 0;
  while (bytes.length() > 0) {
    b = bytes.getByte();
    value = value << 7;
    if (b & 128) {
      value += b & 127;
    } else {
      oid += "." + (value + b);
      value = 0;
    }
  }
  return oid;
};
asn1$8.utcTimeToDate = function(utc) {
  var date2 = new Date();
  var year = parseInt(utc.substr(0, 2), 10);
  year = year >= 50 ? 1900 + year : 2e3 + year;
  var MM = parseInt(utc.substr(2, 2), 10) - 1;
  var DD = parseInt(utc.substr(4, 2), 10);
  var hh = parseInt(utc.substr(6, 2), 10);
  var mm = parseInt(utc.substr(8, 2), 10);
  var ss = 0;
  if (utc.length > 11) {
    var c = utc.charAt(10);
    var end2 = 10;
    if (c !== "+" && c !== "-") {
      ss = parseInt(utc.substr(10, 2), 10);
      end2 += 2;
    }
  }
  date2.setUTCFullYear(year, MM, DD);
  date2.setUTCHours(hh, mm, ss, 0);
  if (end2) {
    c = utc.charAt(end2);
    if (c === "+" || c === "-") {
      var hhoffset = parseInt(utc.substr(end2 + 1, 2), 10);
      var mmoffset = parseInt(utc.substr(end2 + 4, 2), 10);
      var offset3 = hhoffset * 60 + mmoffset;
      offset3 *= 6e4;
      if (c === "+") {
        date2.setTime(+date2 - offset3);
      } else {
        date2.setTime(+date2 + offset3);
      }
    }
  }
  return date2;
};
asn1$8.generalizedTimeToDate = function(gentime) {
  var date2 = new Date();
  var YYYY = parseInt(gentime.substr(0, 4), 10);
  var MM = parseInt(gentime.substr(4, 2), 10) - 1;
  var DD = parseInt(gentime.substr(6, 2), 10);
  var hh = parseInt(gentime.substr(8, 2), 10);
  var mm = parseInt(gentime.substr(10, 2), 10);
  var ss = parseInt(gentime.substr(12, 2), 10);
  var fff = 0;
  var offset3 = 0;
  var isUTC = false;
  if (gentime.charAt(gentime.length - 1) === "Z") {
    isUTC = true;
  }
  var end2 = gentime.length - 5, c = gentime.charAt(end2);
  if (c === "+" || c === "-") {
    var hhoffset = parseInt(gentime.substr(end2 + 1, 2), 10);
    var mmoffset = parseInt(gentime.substr(end2 + 4, 2), 10);
    offset3 = hhoffset * 60 + mmoffset;
    offset3 *= 6e4;
    if (c === "+") {
      offset3 *= -1;
    }
    isUTC = true;
  }
  if (gentime.charAt(14) === ".") {
    fff = parseFloat(gentime.substr(14), 10) * 1e3;
  }
  if (isUTC) {
    date2.setUTCFullYear(YYYY, MM, DD);
    date2.setUTCHours(hh, mm, ss, fff);
    date2.setTime(+date2 + offset3);
  } else {
    date2.setFullYear(YYYY, MM, DD);
    date2.setHours(hh, mm, ss, fff);
  }
  return date2;
};
asn1$8.dateToUtcTime = function(date2) {
  if (typeof date2 === "string") {
    return date2;
  }
  var rval = "";
  var format2 = [];
  format2.push(("" + date2.getUTCFullYear()).substr(2));
  format2.push("" + (date2.getUTCMonth() + 1));
  format2.push("" + date2.getUTCDate());
  format2.push("" + date2.getUTCHours());
  format2.push("" + date2.getUTCMinutes());
  format2.push("" + date2.getUTCSeconds());
  for (var i2 = 0; i2 < format2.length; ++i2) {
    if (format2[i2].length < 2) {
      rval += "0";
    }
    rval += format2[i2];
  }
  rval += "Z";
  return rval;
};
asn1$8.dateToGeneralizedTime = function(date2) {
  if (typeof date2 === "string") {
    return date2;
  }
  var rval = "";
  var format2 = [];
  format2.push("" + date2.getUTCFullYear());
  format2.push("" + (date2.getUTCMonth() + 1));
  format2.push("" + date2.getUTCDate());
  format2.push("" + date2.getUTCHours());
  format2.push("" + date2.getUTCMinutes());
  format2.push("" + date2.getUTCSeconds());
  for (var i2 = 0; i2 < format2.length; ++i2) {
    if (format2[i2].length < 2) {
      rval += "0";
    }
    rval += format2[i2];
  }
  rval += "Z";
  return rval;
};
asn1$8.integerToDer = function(x2) {
  var rval = forge$w.util.createBuffer();
  if (x2 >= -128 && x2 < 128) {
    return rval.putSignedInt(x2, 8);
  }
  if (x2 >= -32768 && x2 < 32768) {
    return rval.putSignedInt(x2, 16);
  }
  if (x2 >= -8388608 && x2 < 8388608) {
    return rval.putSignedInt(x2, 24);
  }
  if (x2 >= -2147483648 && x2 < 2147483648) {
    return rval.putSignedInt(x2, 32);
  }
  var error = new Error("Integer too large; max is 32-bits.");
  error.integer = x2;
  throw error;
};
asn1$8.derToInteger = function(bytes) {
  if (typeof bytes === "string") {
    bytes = forge$w.util.createBuffer(bytes);
  }
  var n = bytes.length() * 8;
  if (n > 32) {
    throw new Error("Integer too large; max is 32-bits.");
  }
  return bytes.getSignedInt(n);
};
asn1$8.validate = function(obj, v2, capture, errors) {
  var rval = false;
  if ((obj.tagClass === v2.tagClass || typeof v2.tagClass === "undefined") && (obj.type === v2.type || typeof v2.type === "undefined")) {
    if (obj.constructed === v2.constructed || typeof v2.constructed === "undefined") {
      rval = true;
      if (v2.value && forge$w.util.isArray(v2.value)) {
        var j = 0;
        for (var i2 = 0; rval && i2 < v2.value.length; ++i2) {
          rval = v2.value[i2].optional || false;
          if (obj.value[j]) {
            rval = asn1$8.validate(obj.value[j], v2.value[i2], capture, errors);
            if (rval) {
              ++j;
            } else if (v2.value[i2].optional) {
              rval = true;
            }
          }
          if (!rval && errors) {
            errors.push("[" + v2.name + '] Tag class "' + v2.tagClass + '", type "' + v2.type + '" expected value length "' + v2.value.length + '", got "' + obj.value.length + '"');
          }
        }
      }
      if (rval && capture) {
        if (v2.capture) {
          capture[v2.capture] = obj.value;
        }
        if (v2.captureAsn1) {
          capture[v2.captureAsn1] = obj;
        }
        if (v2.captureBitStringContents && "bitStringContents" in obj) {
          capture[v2.captureBitStringContents] = obj.bitStringContents;
        }
        if (v2.captureBitStringValue && "bitStringContents" in obj) {
          if (obj.bitStringContents.length < 2) {
            capture[v2.captureBitStringValue] = "";
          } else {
            var unused = obj.bitStringContents.charCodeAt(0);
            if (unused !== 0) {
              throw new Error("captureBitStringValue only supported for zero unused bits");
            }
            capture[v2.captureBitStringValue] = obj.bitStringContents.slice(1);
          }
        }
      }
    } else if (errors) {
      errors.push("[" + v2.name + '] Expected constructed "' + v2.constructed + '", got "' + obj.constructed + '"');
    }
  } else if (errors) {
    if (obj.tagClass !== v2.tagClass) {
      errors.push("[" + v2.name + '] Expected tag class "' + v2.tagClass + '", got "' + obj.tagClass + '"');
    }
    if (obj.type !== v2.type) {
      errors.push("[" + v2.name + '] Expected type "' + v2.type + '", got "' + obj.type + '"');
    }
  }
  return rval;
};
var _nonLatinRegex = /[^\\u0000-\\u00ff]/;
asn1$8.prettyPrint = function(obj, level, indentation) {
  var rval = "";
  level = level || 0;
  indentation = indentation || 2;
  if (level > 0) {
    rval += "\n";
  }
  var indent = "";
  for (var i2 = 0; i2 < level * indentation; ++i2) {
    indent += " ";
  }
  rval += indent + "Tag: ";
  switch (obj.tagClass) {
    case asn1$8.Class.UNIVERSAL:
      rval += "Universal:";
      break;
    case asn1$8.Class.APPLICATION:
      rval += "Application:";
      break;
    case asn1$8.Class.CONTEXT_SPECIFIC:
      rval += "Context-Specific:";
      break;
    case asn1$8.Class.PRIVATE:
      rval += "Private:";
      break;
  }
  if (obj.tagClass === asn1$8.Class.UNIVERSAL) {
    rval += obj.type;
    switch (obj.type) {
      case asn1$8.Type.NONE:
        rval += " (None)";
        break;
      case asn1$8.Type.BOOLEAN:
        rval += " (Boolean)";
        break;
      case asn1$8.Type.INTEGER:
        rval += " (Integer)";
        break;
      case asn1$8.Type.BITSTRING:
        rval += " (Bit string)";
        break;
      case asn1$8.Type.OCTETSTRING:
        rval += " (Octet string)";
        break;
      case asn1$8.Type.NULL:
        rval += " (Null)";
        break;
      case asn1$8.Type.OID:
        rval += " (Object Identifier)";
        break;
      case asn1$8.Type.ODESC:
        rval += " (Object Descriptor)";
        break;
      case asn1$8.Type.EXTERNAL:
        rval += " (External or Instance of)";
        break;
      case asn1$8.Type.REAL:
        rval += " (Real)";
        break;
      case asn1$8.Type.ENUMERATED:
        rval += " (Enumerated)";
        break;
      case asn1$8.Type.EMBEDDED:
        rval += " (Embedded PDV)";
        break;
      case asn1$8.Type.UTF8:
        rval += " (UTF8)";
        break;
      case asn1$8.Type.ROID:
        rval += " (Relative Object Identifier)";
        break;
      case asn1$8.Type.SEQUENCE:
        rval += " (Sequence)";
        break;
      case asn1$8.Type.SET:
        rval += " (Set)";
        break;
      case asn1$8.Type.PRINTABLESTRING:
        rval += " (Printable String)";
        break;
      case asn1$8.Type.IA5String:
        rval += " (IA5String (ASCII))";
        break;
      case asn1$8.Type.UTCTIME:
        rval += " (UTC time)";
        break;
      case asn1$8.Type.GENERALIZEDTIME:
        rval += " (Generalized time)";
        break;
      case asn1$8.Type.BMPSTRING:
        rval += " (BMP String)";
        break;
    }
  } else {
    rval += obj.type;
  }
  rval += "\n";
  rval += indent + "Constructed: " + obj.constructed + "\n";
  if (obj.composed) {
    var subvalues = 0;
    var sub = "";
    for (var i2 = 0; i2 < obj.value.length; ++i2) {
      if (obj.value[i2] !== void 0) {
        subvalues += 1;
        sub += asn1$8.prettyPrint(obj.value[i2], level + 1, indentation);
        if (i2 + 1 < obj.value.length) {
          sub += ",";
        }
      }
    }
    rval += indent + "Sub values: " + subvalues + sub;
  } else {
    rval += indent + "Value: ";
    if (obj.type === asn1$8.Type.OID) {
      var oid = asn1$8.derToOid(obj.value);
      rval += oid;
      if (forge$w.pki && forge$w.pki.oids) {
        if (oid in forge$w.pki.oids) {
          rval += " (" + forge$w.pki.oids[oid] + ") ";
        }
      }
    }
    if (obj.type === asn1$8.Type.INTEGER) {
      try {
        rval += asn1$8.derToInteger(obj.value);
      } catch (ex) {
        rval += "0x" + forge$w.util.bytesToHex(obj.value);
      }
    } else if (obj.type === asn1$8.Type.BITSTRING) {
      if (obj.value.length > 1) {
        rval += "0x" + forge$w.util.bytesToHex(obj.value.slice(1));
      } else {
        rval += "(none)";
      }
      if (obj.value.length > 0) {
        var unused = obj.value.charCodeAt(0);
        if (unused == 1) {
          rval += " (1 unused bit shown)";
        } else if (unused > 1) {
          rval += " (" + unused + " unused bits shown)";
        }
      }
    } else if (obj.type === asn1$8.Type.OCTETSTRING) {
      if (!_nonLatinRegex.test(obj.value)) {
        rval += "(" + obj.value + ") ";
      }
      rval += "0x" + forge$w.util.bytesToHex(obj.value);
    } else if (obj.type === asn1$8.Type.UTF8) {
      rval += forge$w.util.decodeUtf8(obj.value);
    } else if (obj.type === asn1$8.Type.PRINTABLESTRING || obj.type === asn1$8.Type.IA5String) {
      rval += obj.value;
    } else if (_nonLatinRegex.test(obj.value)) {
      rval += "0x" + forge$w.util.bytesToHex(obj.value);
    } else if (obj.value.length === 0) {
      rval += "[null]";
    } else {
      rval += obj.value;
    }
  }
  return rval;
};
var forge$v = forge$C;
forge$v.md = forge$v.md || {};
forge$v.md.algorithms = forge$v.md.algorithms || {};
var forge$u = forge$C;
var hmac = forge$u.hmac = forge$u.hmac || {};
hmac.create = function() {
  var _key = null;
  var _md = null;
  var _ipadding = null;
  var _opadding = null;
  var ctx = {};
  ctx.start = function(md, key) {
    if (md !== null) {
      if (typeof md === "string") {
        md = md.toLowerCase();
        if (md in forge$u.md.algorithms) {
          _md = forge$u.md.algorithms[md].create();
        } else {
          throw new Error('Unknown hash algorithm "' + md + '"');
        }
      } else {
        _md = md;
      }
    }
    if (key === null) {
      key = _key;
    } else {
      if (typeof key === "string") {
        key = forge$u.util.createBuffer(key);
      } else if (forge$u.util.isArray(key)) {
        var tmp = key;
        key = forge$u.util.createBuffer();
        for (var i2 = 0; i2 < tmp.length; ++i2) {
          key.putByte(tmp[i2]);
        }
      }
      var keylen = key.length();
      if (keylen > _md.blockLength) {
        _md.start();
        _md.update(key.bytes());
        key = _md.digest();
      }
      _ipadding = forge$u.util.createBuffer();
      _opadding = forge$u.util.createBuffer();
      keylen = key.length();
      for (var i2 = 0; i2 < keylen; ++i2) {
        var tmp = key.at(i2);
        _ipadding.putByte(54 ^ tmp);
        _opadding.putByte(92 ^ tmp);
      }
      if (keylen < _md.blockLength) {
        var tmp = _md.blockLength - keylen;
        for (var i2 = 0; i2 < tmp; ++i2) {
          _ipadding.putByte(54);
          _opadding.putByte(92);
        }
      }
      _key = key;
      _ipadding = _ipadding.bytes();
      _opadding = _opadding.bytes();
    }
    _md.start();
    _md.update(_ipadding);
  };
  ctx.update = function(bytes) {
    _md.update(bytes);
  };
  ctx.getMac = function() {
    var inner = _md.digest().bytes();
    _md.start();
    _md.update(_opadding);
    _md.update(inner);
    return _md.digest();
  };
  ctx.digest = ctx.getMac;
  return ctx;
};
var forge$t = forge$C;
var md5$1 = forge$t.md5 = forge$t.md5 || {};
forge$t.md.md5 = forge$t.md.algorithms.md5 = md5$1;
md5$1.create = function() {
  if (!_initialized$3) {
    _init$3();
  }
  var _state = null;
  var _input = forge$t.util.createBuffer();
  var _w = new Array(16);
  var md = {
    algorithm: "md5",
    blockLength: 64,
    digestLength: 16,
    messageLength: 0,
    fullMessageLength: null,
    messageLengthSize: 8
  };
  md.start = function() {
    md.messageLength = 0;
    md.fullMessageLength = md.messageLength64 = [];
    var int32s = md.messageLengthSize / 4;
    for (var i2 = 0; i2 < int32s; ++i2) {
      md.fullMessageLength.push(0);
    }
    _input = forge$t.util.createBuffer();
    _state = {
      h0: 1732584193,
      h1: 4023233417,
      h2: 2562383102,
      h3: 271733878
    };
    return md;
  };
  md.start();
  md.update = function(msg, encoding) {
    if (encoding === "utf8") {
      msg = forge$t.util.encodeUtf8(msg);
    }
    var len = msg.length;
    md.messageLength += len;
    len = [len / 4294967296 >>> 0, len >>> 0];
    for (var i2 = md.fullMessageLength.length - 1; i2 >= 0; --i2) {
      md.fullMessageLength[i2] += len[1];
      len[1] = len[0] + (md.fullMessageLength[i2] / 4294967296 >>> 0);
      md.fullMessageLength[i2] = md.fullMessageLength[i2] >>> 0;
      len[0] = len[1] / 4294967296 >>> 0;
    }
    _input.putBytes(msg);
    _update$3(_state, _w, _input);
    if (_input.read > 2048 || _input.length() === 0) {
      _input.compact();
    }
    return md;
  };
  md.digest = function() {
    var finalBlock = forge$t.util.createBuffer();
    finalBlock.putBytes(_input.bytes());
    var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
    var overflow = remaining & md.blockLength - 1;
    finalBlock.putBytes(_padding$3.substr(0, md.blockLength - overflow));
    var bits, carry = 0;
    for (var i2 = md.fullMessageLength.length - 1; i2 >= 0; --i2) {
      bits = md.fullMessageLength[i2] * 8 + carry;
      carry = bits / 4294967296 >>> 0;
      finalBlock.putInt32Le(bits >>> 0);
    }
    var s2 = {
      h0: _state.h0,
      h1: _state.h1,
      h2: _state.h2,
      h3: _state.h3
    };
    _update$3(s2, _w, finalBlock);
    var rval = forge$t.util.createBuffer();
    rval.putInt32Le(s2.h0);
    rval.putInt32Le(s2.h1);
    rval.putInt32Le(s2.h2);
    rval.putInt32Le(s2.h3);
    return rval;
  };
  return md;
};
var _padding$3 = null;
var _g = null;
var _r = null;
var _k$2 = null;
var _initialized$3 = false;
function _init$3() {
  _padding$3 = String.fromCharCode(128);
  _padding$3 += forge$t.util.fillString(String.fromCharCode(0), 64);
  _g = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    1,
    6,
    11,
    0,
    5,
    10,
    15,
    4,
    9,
    14,
    3,
    8,
    13,
    2,
    7,
    12,
    5,
    8,
    11,
    14,
    1,
    4,
    7,
    10,
    13,
    0,
    3,
    6,
    9,
    12,
    15,
    2,
    0,
    7,
    14,
    5,
    12,
    3,
    10,
    1,
    8,
    15,
    6,
    13,
    4,
    11,
    2,
    9
  ];
  _r = [
    7,
    12,
    17,
    22,
    7,
    12,
    17,
    22,
    7,
    12,
    17,
    22,
    7,
    12,
    17,
    22,
    5,
    9,
    14,
    20,
    5,
    9,
    14,
    20,
    5,
    9,
    14,
    20,
    5,
    9,
    14,
    20,
    4,
    11,
    16,
    23,
    4,
    11,
    16,
    23,
    4,
    11,
    16,
    23,
    4,
    11,
    16,
    23,
    6,
    10,
    15,
    21,
    6,
    10,
    15,
    21,
    6,
    10,
    15,
    21,
    6,
    10,
    15,
    21
  ];
  _k$2 = new Array(64);
  for (var i2 = 0; i2 < 64; ++i2) {
    _k$2[i2] = Math.floor(Math.abs(Math.sin(i2 + 1)) * 4294967296);
  }
  _initialized$3 = true;
}
function _update$3(s2, w, bytes) {
  var t, a, b, c, d, f, r, i2;
  var len = bytes.length();
  while (len >= 64) {
    a = s2.h0;
    b = s2.h1;
    c = s2.h2;
    d = s2.h3;
    for (i2 = 0; i2 < 16; ++i2) {
      w[i2] = bytes.getInt32Le();
      f = d ^ b & (c ^ d);
      t = a + f + _k$2[i2] + w[i2];
      r = _r[i2];
      a = d;
      d = c;
      c = b;
      b += t << r | t >>> 32 - r;
    }
    for (; i2 < 32; ++i2) {
      f = c ^ d & (b ^ c);
      t = a + f + _k$2[i2] + w[_g[i2]];
      r = _r[i2];
      a = d;
      d = c;
      c = b;
      b += t << r | t >>> 32 - r;
    }
    for (; i2 < 48; ++i2) {
      f = b ^ c ^ d;
      t = a + f + _k$2[i2] + w[_g[i2]];
      r = _r[i2];
      a = d;
      d = c;
      c = b;
      b += t << r | t >>> 32 - r;
    }
    for (; i2 < 64; ++i2) {
      f = c ^ (b | ~d);
      t = a + f + _k$2[i2] + w[_g[i2]];
      r = _r[i2];
      a = d;
      d = c;
      c = b;
      b += t << r | t >>> 32 - r;
    }
    s2.h0 = s2.h0 + a | 0;
    s2.h1 = s2.h1 + b | 0;
    s2.h2 = s2.h2 + c | 0;
    s2.h3 = s2.h3 + d | 0;
    len -= 64;
  }
}
var forge$s = forge$C;
var pem = forge$s.pem = forge$s.pem || {};
pem.encode = function(msg, options) {
  options = options || {};
  var rval = "-----BEGIN " + msg.type + "-----\r\n";
  var header;
  if (msg.procType) {
    header = {
      name: "Proc-Type",
      values: [String(msg.procType.version), msg.procType.type]
    };
    rval += foldHeader(header);
  }
  if (msg.contentDomain) {
    header = { name: "Content-Domain", values: [msg.contentDomain] };
    rval += foldHeader(header);
  }
  if (msg.dekInfo) {
    header = { name: "DEK-Info", values: [msg.dekInfo.algorithm] };
    if (msg.dekInfo.parameters) {
      header.values.push(msg.dekInfo.parameters);
    }
    rval += foldHeader(header);
  }
  if (msg.headers) {
    for (var i2 = 0; i2 < msg.headers.length; ++i2) {
      rval += foldHeader(msg.headers[i2]);
    }
  }
  if (msg.procType) {
    rval += "\r\n";
  }
  rval += forge$s.util.encode64(msg.body, options.maxline || 64) + "\r\n";
  rval += "-----END " + msg.type + "-----\r\n";
  return rval;
};
pem.decode = function(str) {
  var rval = [];
  var rMessage = /\s*-----BEGIN ([A-Z0-9- ]+)-----\r?\n?([\x21-\x7e\s]+?(?:\r?\n\r?\n))?([:A-Za-z0-9+\/=\s]+?)-----END \1-----/g;
  var rHeader = /([\x21-\x7e]+):\s*([\x21-\x7e\s^:]+)/;
  var rCRLF = /\r?\n/;
  var match;
  while (true) {
    match = rMessage.exec(str);
    if (!match) {
      break;
    }
    var type = match[1];
    if (type === "NEW CERTIFICATE REQUEST") {
      type = "CERTIFICATE REQUEST";
    }
    var msg = {
      type,
      procType: null,
      contentDomain: null,
      dekInfo: null,
      headers: [],
      body: forge$s.util.decode64(match[3])
    };
    rval.push(msg);
    if (!match[2]) {
      continue;
    }
    var lines = match[2].split(rCRLF);
    var li = 0;
    while (match && li < lines.length) {
      var line = lines[li].replace(/\s+$/, "");
      for (var nl = li + 1; nl < lines.length; ++nl) {
        var next = lines[nl];
        if (!/\s/.test(next[0])) {
          break;
        }
        line += next;
        li = nl;
      }
      match = line.match(rHeader);
      if (match) {
        var header = { name: match[1], values: [] };
        var values = match[2].split(",");
        for (var vi = 0; vi < values.length; ++vi) {
          header.values.push(ltrim(values[vi]));
        }
        if (!msg.procType) {
          if (header.name !== "Proc-Type") {
            throw new Error('Invalid PEM formatted message. The first encapsulated header must be "Proc-Type".');
          } else if (header.values.length !== 2) {
            throw new Error('Invalid PEM formatted message. The "Proc-Type" header must have two subfields.');
          }
          msg.procType = { version: values[0], type: values[1] };
        } else if (!msg.contentDomain && header.name === "Content-Domain") {
          msg.contentDomain = values[0] || "";
        } else if (!msg.dekInfo && header.name === "DEK-Info") {
          if (header.values.length === 0) {
            throw new Error('Invalid PEM formatted message. The "DEK-Info" header must have at least one subfield.');
          }
          msg.dekInfo = { algorithm: values[0], parameters: values[1] || null };
        } else {
          msg.headers.push(header);
        }
      }
      ++li;
    }
    if (msg.procType === "ENCRYPTED" && !msg.dekInfo) {
      throw new Error('Invalid PEM formatted message. The "DEK-Info" header must be present if "Proc-Type" is "ENCRYPTED".');
    }
  }
  if (rval.length === 0) {
    throw new Error("Invalid PEM formatted message.");
  }
  return rval;
};
function foldHeader(header) {
  var rval = header.name + ": ";
  var values = [];
  var insertSpace = function(match, $1) {
    return " " + $1;
  };
  for (var i2 = 0; i2 < header.values.length; ++i2) {
    values.push(header.values[i2].replace(/^(\S+\r\n)/, insertSpace));
  }
  rval += values.join(",") + "\r\n";
  var length = 0;
  var candidate = -1;
  for (var i2 = 0; i2 < rval.length; ++i2, ++length) {
    if (length > 65 && candidate !== -1) {
      var insert = rval[candidate];
      if (insert === ",") {
        ++candidate;
        rval = rval.substr(0, candidate) + "\r\n " + rval.substr(candidate);
      } else {
        rval = rval.substr(0, candidate) + "\r\n" + insert + rval.substr(candidate + 1);
      }
      length = i2 - candidate - 1;
      candidate = -1;
      ++i2;
    } else if (rval[i2] === " " || rval[i2] === "	" || rval[i2] === ",") {
      candidate = i2;
    }
  }
  return rval;
}
function ltrim(str) {
  return str.replace(/^\s+/, "");
}
var forge$r = forge$C;
forge$r.des = forge$r.des || {};
forge$r.des.startEncrypting = function(key, iv, output, mode) {
  var cipher = _createCipher({
    key,
    output,
    decrypt: false,
    mode: mode || (iv === null ? "ECB" : "CBC")
  });
  cipher.start(iv);
  return cipher;
};
forge$r.des.createEncryptionCipher = function(key, mode) {
  return _createCipher({
    key,
    output: null,
    decrypt: false,
    mode
  });
};
forge$r.des.startDecrypting = function(key, iv, output, mode) {
  var cipher = _createCipher({
    key,
    output,
    decrypt: true,
    mode: mode || (iv === null ? "ECB" : "CBC")
  });
  cipher.start(iv);
  return cipher;
};
forge$r.des.createDecryptionCipher = function(key, mode) {
  return _createCipher({
    key,
    output: null,
    decrypt: true,
    mode
  });
};
forge$r.des.Algorithm = function(name, mode) {
  var self2 = this;
  self2.name = name;
  self2.mode = new mode({
    blockSize: 8,
    cipher: {
      encrypt: function(inBlock, outBlock) {
        return _updateBlock(self2._keys, inBlock, outBlock, false);
      },
      decrypt: function(inBlock, outBlock) {
        return _updateBlock(self2._keys, inBlock, outBlock, true);
      }
    }
  });
  self2._init = false;
};
forge$r.des.Algorithm.prototype.initialize = function(options) {
  if (this._init) {
    return;
  }
  var key = forge$r.util.createBuffer(options.key);
  if (this.name.indexOf("3DES") === 0) {
    if (key.length() !== 24) {
      throw new Error("Invalid Triple-DES key size: " + key.length() * 8);
    }
  }
  this._keys = _createKeys(key);
  this._init = true;
};
registerAlgorithm("DES-ECB", forge$r.cipher.modes.ecb);
registerAlgorithm("DES-CBC", forge$r.cipher.modes.cbc);
registerAlgorithm("DES-CFB", forge$r.cipher.modes.cfb);
registerAlgorithm("DES-OFB", forge$r.cipher.modes.ofb);
registerAlgorithm("DES-CTR", forge$r.cipher.modes.ctr);
registerAlgorithm("3DES-ECB", forge$r.cipher.modes.ecb);
registerAlgorithm("3DES-CBC", forge$r.cipher.modes.cbc);
registerAlgorithm("3DES-CFB", forge$r.cipher.modes.cfb);
registerAlgorithm("3DES-OFB", forge$r.cipher.modes.ofb);
registerAlgorithm("3DES-CTR", forge$r.cipher.modes.ctr);
function registerAlgorithm(name, mode) {
  var factory = function() {
    return new forge$r.des.Algorithm(name, mode);
  };
  forge$r.cipher.registerAlgorithm(name, factory);
}
var spfunction1 = [16843776, 0, 65536, 16843780, 16842756, 66564, 4, 65536, 1024, 16843776, 16843780, 1024, 16778244, 16842756, 16777216, 4, 1028, 16778240, 16778240, 66560, 66560, 16842752, 16842752, 16778244, 65540, 16777220, 16777220, 65540, 0, 1028, 66564, 16777216, 65536, 16843780, 4, 16842752, 16843776, 16777216, 16777216, 1024, 16842756, 65536, 66560, 16777220, 1024, 4, 16778244, 66564, 16843780, 65540, 16842752, 16778244, 16777220, 1028, 66564, 16843776, 1028, 16778240, 16778240, 0, 65540, 66560, 0, 16842756];
var spfunction2 = [-2146402272, -2147450880, 32768, 1081376, 1048576, 32, -2146435040, -2147450848, -2147483616, -2146402272, -2146402304, -2147483648, -2147450880, 1048576, 32, -2146435040, 1081344, 1048608, -2147450848, 0, -2147483648, 32768, 1081376, -2146435072, 1048608, -2147483616, 0, 1081344, 32800, -2146402304, -2146435072, 32800, 0, 1081376, -2146435040, 1048576, -2147450848, -2146435072, -2146402304, 32768, -2146435072, -2147450880, 32, -2146402272, 1081376, 32, 32768, -2147483648, 32800, -2146402304, 1048576, -2147483616, 1048608, -2147450848, -2147483616, 1048608, 1081344, 0, -2147450880, 32800, -2147483648, -2146435040, -2146402272, 1081344];
var spfunction3 = [520, 134349312, 0, 134348808, 134218240, 0, 131592, 134218240, 131080, 134217736, 134217736, 131072, 134349320, 131080, 134348800, 520, 134217728, 8, 134349312, 512, 131584, 134348800, 134348808, 131592, 134218248, 131584, 131072, 134218248, 8, 134349320, 512, 134217728, 134349312, 134217728, 131080, 520, 131072, 134349312, 134218240, 0, 512, 131080, 134349320, 134218240, 134217736, 512, 0, 134348808, 134218248, 131072, 134217728, 134349320, 8, 131592, 131584, 134217736, 134348800, 134218248, 520, 134348800, 131592, 8, 134348808, 131584];
var spfunction4 = [8396801, 8321, 8321, 128, 8396928, 8388737, 8388609, 8193, 0, 8396800, 8396800, 8396929, 129, 0, 8388736, 8388609, 1, 8192, 8388608, 8396801, 128, 8388608, 8193, 8320, 8388737, 1, 8320, 8388736, 8192, 8396928, 8396929, 129, 8388736, 8388609, 8396800, 8396929, 129, 0, 0, 8396800, 8320, 8388736, 8388737, 1, 8396801, 8321, 8321, 128, 8396929, 129, 1, 8192, 8388609, 8193, 8396928, 8388737, 8193, 8320, 8388608, 8396801, 128, 8388608, 8192, 8396928];
var spfunction5 = [256, 34078976, 34078720, 1107296512, 524288, 256, 1073741824, 34078720, 1074266368, 524288, 33554688, 1074266368, 1107296512, 1107820544, 524544, 1073741824, 33554432, 1074266112, 1074266112, 0, 1073742080, 1107820800, 1107820800, 33554688, 1107820544, 1073742080, 0, 1107296256, 34078976, 33554432, 1107296256, 524544, 524288, 1107296512, 256, 33554432, 1073741824, 34078720, 1107296512, 1074266368, 33554688, 1073741824, 1107820544, 34078976, 1074266368, 256, 33554432, 1107820544, 1107820800, 524544, 1107296256, 1107820800, 34078720, 0, 1074266112, 1107296256, 524544, 33554688, 1073742080, 524288, 0, 1074266112, 34078976, 1073742080];
var spfunction6 = [536870928, 541065216, 16384, 541081616, 541065216, 16, 541081616, 4194304, 536887296, 4210704, 4194304, 536870928, 4194320, 536887296, 536870912, 16400, 0, 4194320, 536887312, 16384, 4210688, 536887312, 16, 541065232, 541065232, 0, 4210704, 541081600, 16400, 4210688, 541081600, 536870912, 536887296, 16, 541065232, 4210688, 541081616, 4194304, 16400, 536870928, 4194304, 536887296, 536870912, 16400, 536870928, 541081616, 4210688, 541065216, 4210704, 541081600, 0, 541065232, 16, 16384, 541065216, 4210704, 16384, 4194320, 536887312, 0, 541081600, 536870912, 4194320, 536887312];
var spfunction7 = [2097152, 69206018, 67110914, 0, 2048, 67110914, 2099202, 69208064, 69208066, 2097152, 0, 67108866, 2, 67108864, 69206018, 2050, 67110912, 2099202, 2097154, 67110912, 67108866, 69206016, 69208064, 2097154, 69206016, 2048, 2050, 69208066, 2099200, 2, 67108864, 2099200, 67108864, 2099200, 2097152, 67110914, 67110914, 69206018, 69206018, 2, 2097154, 67108864, 67110912, 2097152, 69208064, 2050, 2099202, 69208064, 2050, 67108866, 69208066, 69206016, 2099200, 0, 2, 69208066, 0, 2099202, 69206016, 2048, 67108866, 67110912, 2048, 2097154];
var spfunction8 = [268439616, 4096, 262144, 268701760, 268435456, 268439616, 64, 268435456, 262208, 268697600, 268701760, 266240, 268701696, 266304, 4096, 64, 268697600, 268435520, 268439552, 4160, 266240, 262208, 268697664, 268701696, 4160, 0, 0, 268697664, 268435520, 268439552, 266304, 262144, 266304, 262144, 268701696, 4096, 64, 268697664, 4096, 266304, 268439552, 64, 268435520, 268697600, 268697664, 268435456, 262144, 268439616, 0, 268701760, 262208, 268435520, 268697600, 268439552, 268439616, 0, 268701760, 266240, 266240, 4160, 4160, 262208, 268435456, 268701696];
function _createKeys(key) {
  var pc2bytes0 = [0, 4, 536870912, 536870916, 65536, 65540, 536936448, 536936452, 512, 516, 536871424, 536871428, 66048, 66052, 536936960, 536936964], pc2bytes1 = [0, 1, 1048576, 1048577, 67108864, 67108865, 68157440, 68157441, 256, 257, 1048832, 1048833, 67109120, 67109121, 68157696, 68157697], pc2bytes2 = [0, 8, 2048, 2056, 16777216, 16777224, 16779264, 16779272, 0, 8, 2048, 2056, 16777216, 16777224, 16779264, 16779272], pc2bytes3 = [0, 2097152, 134217728, 136314880, 8192, 2105344, 134225920, 136323072, 131072, 2228224, 134348800, 136445952, 139264, 2236416, 134356992, 136454144], pc2bytes4 = [0, 262144, 16, 262160, 0, 262144, 16, 262160, 4096, 266240, 4112, 266256, 4096, 266240, 4112, 266256], pc2bytes5 = [0, 1024, 32, 1056, 0, 1024, 32, 1056, 33554432, 33555456, 33554464, 33555488, 33554432, 33555456, 33554464, 33555488], pc2bytes6 = [0, 268435456, 524288, 268959744, 2, 268435458, 524290, 268959746, 0, 268435456, 524288, 268959744, 2, 268435458, 524290, 268959746], pc2bytes7 = [0, 65536, 2048, 67584, 536870912, 536936448, 536872960, 536938496, 131072, 196608, 133120, 198656, 537001984, 537067520, 537004032, 537069568], pc2bytes8 = [0, 262144, 0, 262144, 2, 262146, 2, 262146, 33554432, 33816576, 33554432, 33816576, 33554434, 33816578, 33554434, 33816578], pc2bytes9 = [0, 268435456, 8, 268435464, 0, 268435456, 8, 268435464, 1024, 268436480, 1032, 268436488, 1024, 268436480, 1032, 268436488], pc2bytes10 = [0, 32, 0, 32, 1048576, 1048608, 1048576, 1048608, 8192, 8224, 8192, 8224, 1056768, 1056800, 1056768, 1056800], pc2bytes11 = [0, 16777216, 512, 16777728, 2097152, 18874368, 2097664, 18874880, 67108864, 83886080, 67109376, 83886592, 69206016, 85983232, 69206528, 85983744], pc2bytes12 = [0, 4096, 134217728, 134221824, 524288, 528384, 134742016, 134746112, 16, 4112, 134217744, 134221840, 524304, 528400, 134742032, 134746128], pc2bytes13 = [0, 4, 256, 260, 0, 4, 256, 260, 1, 5, 257, 261, 1, 5, 257, 261];
  var iterations = key.length() > 8 ? 3 : 1;
  var keys2 = [];
  var shifts = [0, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 0];
  var n = 0, tmp;
  for (var j = 0; j < iterations; j++) {
    var left = key.getInt32();
    var right = key.getInt32();
    tmp = (left >>> 4 ^ right) & 252645135;
    right ^= tmp;
    left ^= tmp << 4;
    tmp = (right >>> -16 ^ left) & 65535;
    left ^= tmp;
    right ^= tmp << -16;
    tmp = (left >>> 2 ^ right) & 858993459;
    right ^= tmp;
    left ^= tmp << 2;
    tmp = (right >>> -16 ^ left) & 65535;
    left ^= tmp;
    right ^= tmp << -16;
    tmp = (left >>> 1 ^ right) & 1431655765;
    right ^= tmp;
    left ^= tmp << 1;
    tmp = (right >>> 8 ^ left) & 16711935;
    left ^= tmp;
    right ^= tmp << 8;
    tmp = (left >>> 1 ^ right) & 1431655765;
    right ^= tmp;
    left ^= tmp << 1;
    tmp = left << 8 | right >>> 20 & 240;
    left = right << 24 | right << 8 & 16711680 | right >>> 8 & 65280 | right >>> 24 & 240;
    right = tmp;
    for (var i2 = 0; i2 < shifts.length; ++i2) {
      if (shifts[i2]) {
        left = left << 2 | left >>> 26;
        right = right << 2 | right >>> 26;
      } else {
        left = left << 1 | left >>> 27;
        right = right << 1 | right >>> 27;
      }
      left &= -15;
      right &= -15;
      var lefttmp = pc2bytes0[left >>> 28] | pc2bytes1[left >>> 24 & 15] | pc2bytes2[left >>> 20 & 15] | pc2bytes3[left >>> 16 & 15] | pc2bytes4[left >>> 12 & 15] | pc2bytes5[left >>> 8 & 15] | pc2bytes6[left >>> 4 & 15];
      var righttmp = pc2bytes7[right >>> 28] | pc2bytes8[right >>> 24 & 15] | pc2bytes9[right >>> 20 & 15] | pc2bytes10[right >>> 16 & 15] | pc2bytes11[right >>> 12 & 15] | pc2bytes12[right >>> 8 & 15] | pc2bytes13[right >>> 4 & 15];
      tmp = (righttmp >>> 16 ^ lefttmp) & 65535;
      keys2[n++] = lefttmp ^ tmp;
      keys2[n++] = righttmp ^ tmp << 16;
    }
  }
  return keys2;
}
function _updateBlock(keys2, input, output, decrypt) {
  var iterations = keys2.length === 32 ? 3 : 9;
  var looping;
  if (iterations === 3) {
    looping = decrypt ? [30, -2, -2] : [0, 32, 2];
  } else {
    looping = decrypt ? [94, 62, -2, 32, 64, 2, 30, -2, -2] : [0, 32, 2, 62, 30, -2, 64, 96, 2];
  }
  var tmp;
  var left = input[0];
  var right = input[1];
  tmp = (left >>> 4 ^ right) & 252645135;
  right ^= tmp;
  left ^= tmp << 4;
  tmp = (left >>> 16 ^ right) & 65535;
  right ^= tmp;
  left ^= tmp << 16;
  tmp = (right >>> 2 ^ left) & 858993459;
  left ^= tmp;
  right ^= tmp << 2;
  tmp = (right >>> 8 ^ left) & 16711935;
  left ^= tmp;
  right ^= tmp << 8;
  tmp = (left >>> 1 ^ right) & 1431655765;
  right ^= tmp;
  left ^= tmp << 1;
  left = left << 1 | left >>> 31;
  right = right << 1 | right >>> 31;
  for (var j = 0; j < iterations; j += 3) {
    var endloop = looping[j + 1];
    var loopinc = looping[j + 2];
    for (var i2 = looping[j]; i2 != endloop; i2 += loopinc) {
      var right1 = right ^ keys2[i2];
      var right2 = (right >>> 4 | right << 28) ^ keys2[i2 + 1];
      tmp = left;
      left = right;
      right = tmp ^ (spfunction2[right1 >>> 24 & 63] | spfunction4[right1 >>> 16 & 63] | spfunction6[right1 >>> 8 & 63] | spfunction8[right1 & 63] | spfunction1[right2 >>> 24 & 63] | spfunction3[right2 >>> 16 & 63] | spfunction5[right2 >>> 8 & 63] | spfunction7[right2 & 63]);
    }
    tmp = left;
    left = right;
    right = tmp;
  }
  left = left >>> 1 | left << 31;
  right = right >>> 1 | right << 31;
  tmp = (left >>> 1 ^ right) & 1431655765;
  right ^= tmp;
  left ^= tmp << 1;
  tmp = (right >>> 8 ^ left) & 16711935;
  left ^= tmp;
  right ^= tmp << 8;
  tmp = (right >>> 2 ^ left) & 858993459;
  left ^= tmp;
  right ^= tmp << 2;
  tmp = (left >>> 16 ^ right) & 65535;
  right ^= tmp;
  left ^= tmp << 16;
  tmp = (left >>> 4 ^ right) & 252645135;
  right ^= tmp;
  left ^= tmp << 4;
  output[0] = left;
  output[1] = right;
}
function _createCipher(options) {
  options = options || {};
  var mode = (options.mode || "CBC").toUpperCase();
  var algorithm = "DES-" + mode;
  var cipher;
  if (options.decrypt) {
    cipher = forge$r.cipher.createDecipher(algorithm, options.key);
  } else {
    cipher = forge$r.cipher.createCipher(algorithm, options.key);
  }
  var start3 = cipher.start;
  cipher.start = function(iv, options2) {
    var output = null;
    if (options2 instanceof forge$r.util.ByteBuffer) {
      output = options2;
      options2 = {};
    }
    options2 = options2 || {};
    options2.output = output;
    options2.iv = iv;
    start3.call(cipher, options2);
  };
  return cipher;
}
var __viteBrowserExternal = {};
var __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
var require$$1 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var forge$q = forge$C;
var pkcs5 = forge$q.pkcs5 = forge$q.pkcs5 || {};
var crypto$1;
if (forge$q.util.isNodejs && !forge$q.options.usePureJavaScript) {
  crypto$1 = require$$1;
}
forge$q.pbkdf2 = pkcs5.pbkdf2 = function(p, s2, c, dkLen, md, callback) {
  if (typeof md === "function") {
    callback = md;
    md = null;
  }
  if (forge$q.util.isNodejs && !forge$q.options.usePureJavaScript && crypto$1.pbkdf2 && (md === null || typeof md !== "object") && (crypto$1.pbkdf2Sync.length > 4 || (!md || md === "sha1"))) {
    if (typeof md !== "string") {
      md = "sha1";
    }
    p = Buffer.from(p, "binary");
    s2 = Buffer.from(s2, "binary");
    if (!callback) {
      if (crypto$1.pbkdf2Sync.length === 4) {
        return crypto$1.pbkdf2Sync(p, s2, c, dkLen).toString("binary");
      }
      return crypto$1.pbkdf2Sync(p, s2, c, dkLen, md).toString("binary");
    }
    if (crypto$1.pbkdf2Sync.length === 4) {
      return crypto$1.pbkdf2(p, s2, c, dkLen, function(err3, key) {
        if (err3) {
          return callback(err3);
        }
        callback(null, key.toString("binary"));
      });
    }
    return crypto$1.pbkdf2(p, s2, c, dkLen, md, function(err3, key) {
      if (err3) {
        return callback(err3);
      }
      callback(null, key.toString("binary"));
    });
  }
  if (typeof md === "undefined" || md === null) {
    md = "sha1";
  }
  if (typeof md === "string") {
    if (!(md in forge$q.md.algorithms)) {
      throw new Error("Unknown hash algorithm: " + md);
    }
    md = forge$q.md[md].create();
  }
  var hLen = md.digestLength;
  if (dkLen > 4294967295 * hLen) {
    var err2 = new Error("Derived key is too long.");
    if (callback) {
      return callback(err2);
    }
    throw err2;
  }
  var len = Math.ceil(dkLen / hLen);
  var r = dkLen - (len - 1) * hLen;
  var prf = forge$q.hmac.create();
  prf.start(md, p);
  var dk = "";
  var xor, u_c, u_c1;
  if (!callback) {
    for (var i2 = 1; i2 <= len; ++i2) {
      prf.start(null, null);
      prf.update(s2);
      prf.update(forge$q.util.int32ToBytes(i2));
      xor = u_c1 = prf.digest().getBytes();
      for (var j = 2; j <= c; ++j) {
        prf.start(null, null);
        prf.update(u_c1);
        u_c = prf.digest().getBytes();
        xor = forge$q.util.xorBytes(xor, u_c, hLen);
        u_c1 = u_c;
      }
      dk += i2 < len ? xor : xor.substr(0, r);
    }
    return dk;
  }
  var i2 = 1, j;
  function outer() {
    if (i2 > len) {
      return callback(null, dk);
    }
    prf.start(null, null);
    prf.update(s2);
    prf.update(forge$q.util.int32ToBytes(i2));
    xor = u_c1 = prf.digest().getBytes();
    j = 2;
    inner();
  }
  function inner() {
    if (j <= c) {
      prf.start(null, null);
      prf.update(u_c1);
      u_c = prf.digest().getBytes();
      xor = forge$q.util.xorBytes(xor, u_c, hLen);
      u_c1 = u_c;
      ++j;
      return forge$q.util.setImmediate(inner);
    }
    dk += i2 < len ? xor : xor.substr(0, r);
    ++i2;
    outer();
  }
  outer();
};
var forge$p = forge$C;
var sha256 = forge$p.sha256 = forge$p.sha256 || {};
forge$p.md.sha256 = forge$p.md.algorithms.sha256 = sha256;
sha256.create = function() {
  if (!_initialized$2) {
    _init$2();
  }
  var _state = null;
  var _input = forge$p.util.createBuffer();
  var _w = new Array(64);
  var md = {
    algorithm: "sha256",
    blockLength: 64,
    digestLength: 32,
    messageLength: 0,
    fullMessageLength: null,
    messageLengthSize: 8
  };
  md.start = function() {
    md.messageLength = 0;
    md.fullMessageLength = md.messageLength64 = [];
    var int32s = md.messageLengthSize / 4;
    for (var i2 = 0; i2 < int32s; ++i2) {
      md.fullMessageLength.push(0);
    }
    _input = forge$p.util.createBuffer();
    _state = {
      h0: 1779033703,
      h1: 3144134277,
      h2: 1013904242,
      h3: 2773480762,
      h4: 1359893119,
      h5: 2600822924,
      h6: 528734635,
      h7: 1541459225
    };
    return md;
  };
  md.start();
  md.update = function(msg, encoding) {
    if (encoding === "utf8") {
      msg = forge$p.util.encodeUtf8(msg);
    }
    var len = msg.length;
    md.messageLength += len;
    len = [len / 4294967296 >>> 0, len >>> 0];
    for (var i2 = md.fullMessageLength.length - 1; i2 >= 0; --i2) {
      md.fullMessageLength[i2] += len[1];
      len[1] = len[0] + (md.fullMessageLength[i2] / 4294967296 >>> 0);
      md.fullMessageLength[i2] = md.fullMessageLength[i2] >>> 0;
      len[0] = len[1] / 4294967296 >>> 0;
    }
    _input.putBytes(msg);
    _update$2(_state, _w, _input);
    if (_input.read > 2048 || _input.length() === 0) {
      _input.compact();
    }
    return md;
  };
  md.digest = function() {
    var finalBlock = forge$p.util.createBuffer();
    finalBlock.putBytes(_input.bytes());
    var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
    var overflow = remaining & md.blockLength - 1;
    finalBlock.putBytes(_padding$2.substr(0, md.blockLength - overflow));
    var next, carry;
    var bits = md.fullMessageLength[0] * 8;
    for (var i2 = 0; i2 < md.fullMessageLength.length - 1; ++i2) {
      next = md.fullMessageLength[i2 + 1] * 8;
      carry = next / 4294967296 >>> 0;
      bits += carry;
      finalBlock.putInt32(bits >>> 0);
      bits = next >>> 0;
    }
    finalBlock.putInt32(bits);
    var s2 = {
      h0: _state.h0,
      h1: _state.h1,
      h2: _state.h2,
      h3: _state.h3,
      h4: _state.h4,
      h5: _state.h5,
      h6: _state.h6,
      h7: _state.h7
    };
    _update$2(s2, _w, finalBlock);
    var rval = forge$p.util.createBuffer();
    rval.putInt32(s2.h0);
    rval.putInt32(s2.h1);
    rval.putInt32(s2.h2);
    rval.putInt32(s2.h3);
    rval.putInt32(s2.h4);
    rval.putInt32(s2.h5);
    rval.putInt32(s2.h6);
    rval.putInt32(s2.h7);
    return rval;
  };
  return md;
};
var _padding$2 = null;
var _initialized$2 = false;
var _k$1 = null;
function _init$2() {
  _padding$2 = String.fromCharCode(128);
  _padding$2 += forge$p.util.fillString(String.fromCharCode(0), 64);
  _k$1 = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ];
  _initialized$2 = true;
}
function _update$2(s2, w, bytes) {
  var t1, t2, s0, s1, ch, maj, i2, a, b, c, d, e, f, g, h;
  var len = bytes.length();
  while (len >= 64) {
    for (i2 = 0; i2 < 16; ++i2) {
      w[i2] = bytes.getInt32();
    }
    for (; i2 < 64; ++i2) {
      t1 = w[i2 - 2];
      t1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
      t2 = w[i2 - 15];
      t2 = (t2 >>> 7 | t2 << 25) ^ (t2 >>> 18 | t2 << 14) ^ t2 >>> 3;
      w[i2] = t1 + w[i2 - 7] + t2 + w[i2 - 16] | 0;
    }
    a = s2.h0;
    b = s2.h1;
    c = s2.h2;
    d = s2.h3;
    e = s2.h4;
    f = s2.h5;
    g = s2.h6;
    h = s2.h7;
    for (i2 = 0; i2 < 64; ++i2) {
      s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
      ch = g ^ e & (f ^ g);
      s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
      maj = a & b | c & (a ^ b);
      t1 = h + s1 + ch + _k$1[i2] + w[i2];
      t2 = s0 + maj;
      h = g;
      g = f;
      f = e;
      e = d + t1 >>> 0;
      d = c;
      c = b;
      b = a;
      a = t1 + t2 >>> 0;
    }
    s2.h0 = s2.h0 + a | 0;
    s2.h1 = s2.h1 + b | 0;
    s2.h2 = s2.h2 + c | 0;
    s2.h3 = s2.h3 + d | 0;
    s2.h4 = s2.h4 + e | 0;
    s2.h5 = s2.h5 + f | 0;
    s2.h6 = s2.h6 + g | 0;
    s2.h7 = s2.h7 + h | 0;
    len -= 64;
  }
}
var forge$o = forge$C;
var _crypto$1 = null;
if (forge$o.util.isNodejs && !forge$o.options.usePureJavaScript && !process.versions["node-webkit"]) {
  _crypto$1 = require$$1;
}
var prng = forge$o.prng = forge$o.prng || {};
prng.create = function(plugin) {
  var ctx = {
    plugin,
    key: null,
    seed: null,
    time: null,
    reseeds: 0,
    generated: 0,
    keyBytes: ""
  };
  var md = plugin.md;
  var pools = new Array(32);
  for (var i2 = 0; i2 < 32; ++i2) {
    pools[i2] = md.create();
  }
  ctx.pools = pools;
  ctx.pool = 0;
  ctx.generate = function(count, callback) {
    if (!callback) {
      return ctx.generateSync(count);
    }
    var cipher = ctx.plugin.cipher;
    var increment = ctx.plugin.increment;
    var formatKey = ctx.plugin.formatKey;
    var formatSeed = ctx.plugin.formatSeed;
    var b = forge$o.util.createBuffer();
    ctx.key = null;
    generate();
    function generate(err2) {
      if (err2) {
        return callback(err2);
      }
      if (b.length() >= count) {
        return callback(null, b.getBytes(count));
      }
      if (ctx.generated > 1048575) {
        ctx.key = null;
      }
      if (ctx.key === null) {
        return forge$o.util.nextTick(function() {
          _reseed(generate);
        });
      }
      var bytes = cipher(ctx.key, ctx.seed);
      ctx.generated += bytes.length;
      b.putBytes(bytes);
      ctx.key = formatKey(cipher(ctx.key, increment(ctx.seed)));
      ctx.seed = formatSeed(cipher(ctx.key, ctx.seed));
      forge$o.util.setImmediate(generate);
    }
  };
  ctx.generateSync = function(count) {
    var cipher = ctx.plugin.cipher;
    var increment = ctx.plugin.increment;
    var formatKey = ctx.plugin.formatKey;
    var formatSeed = ctx.plugin.formatSeed;
    ctx.key = null;
    var b = forge$o.util.createBuffer();
    while (b.length() < count) {
      if (ctx.generated > 1048575) {
        ctx.key = null;
      }
      if (ctx.key === null) {
        _reseedSync();
      }
      var bytes = cipher(ctx.key, ctx.seed);
      ctx.generated += bytes.length;
      b.putBytes(bytes);
      ctx.key = formatKey(cipher(ctx.key, increment(ctx.seed)));
      ctx.seed = formatSeed(cipher(ctx.key, ctx.seed));
    }
    return b.getBytes(count);
  };
  function _reseed(callback) {
    if (ctx.pools[0].messageLength >= 32) {
      _seed();
      return callback();
    }
    var needed = 32 - ctx.pools[0].messageLength << 5;
    ctx.seedFile(needed, function(err2, bytes) {
      if (err2) {
        return callback(err2);
      }
      ctx.collect(bytes);
      _seed();
      callback();
    });
  }
  function _reseedSync() {
    if (ctx.pools[0].messageLength >= 32) {
      return _seed();
    }
    var needed = 32 - ctx.pools[0].messageLength << 5;
    ctx.collect(ctx.seedFileSync(needed));
    _seed();
  }
  function _seed() {
    ctx.reseeds = ctx.reseeds === 4294967295 ? 0 : ctx.reseeds + 1;
    var md2 = ctx.plugin.md.create();
    md2.update(ctx.keyBytes);
    var _2powK = 1;
    for (var k = 0; k < 32; ++k) {
      if (ctx.reseeds % _2powK === 0) {
        md2.update(ctx.pools[k].digest().getBytes());
        ctx.pools[k].start();
      }
      _2powK = _2powK << 1;
    }
    ctx.keyBytes = md2.digest().getBytes();
    md2.start();
    md2.update(ctx.keyBytes);
    var seedBytes = md2.digest().getBytes();
    ctx.key = ctx.plugin.formatKey(ctx.keyBytes);
    ctx.seed = ctx.plugin.formatSeed(seedBytes);
    ctx.generated = 0;
  }
  function defaultSeedFile(needed) {
    var getRandomValues = null;
    var globalScope = forge$o.util.globalScope;
    var _crypto2 = globalScope.crypto || globalScope.msCrypto;
    if (_crypto2 && _crypto2.getRandomValues) {
      getRandomValues = function(arr) {
        return _crypto2.getRandomValues(arr);
      };
    }
    var b = forge$o.util.createBuffer();
    if (getRandomValues) {
      while (b.length() < needed) {
        var count = Math.max(1, Math.min(needed - b.length(), 65536) / 4);
        var entropy = new Uint32Array(Math.floor(count));
        try {
          getRandomValues(entropy);
          for (var i3 = 0; i3 < entropy.length; ++i3) {
            b.putInt32(entropy[i3]);
          }
        } catch (e) {
          if (!(typeof QuotaExceededError !== "undefined" && e instanceof QuotaExceededError)) {
            throw e;
          }
        }
      }
    }
    if (b.length() < needed) {
      var hi, lo, next;
      var seed = Math.floor(Math.random() * 65536);
      while (b.length() < needed) {
        lo = 16807 * (seed & 65535);
        hi = 16807 * (seed >> 16);
        lo += (hi & 32767) << 16;
        lo += hi >> 15;
        lo = (lo & 2147483647) + (lo >> 31);
        seed = lo & 4294967295;
        for (var i3 = 0; i3 < 3; ++i3) {
          next = seed >>> (i3 << 3);
          next ^= Math.floor(Math.random() * 256);
          b.putByte(next & 255);
        }
      }
    }
    return b.getBytes(needed);
  }
  if (_crypto$1) {
    ctx.seedFile = function(needed, callback) {
      _crypto$1.randomBytes(needed, function(err2, bytes) {
        if (err2) {
          return callback(err2);
        }
        callback(null, bytes.toString());
      });
    };
    ctx.seedFileSync = function(needed) {
      return _crypto$1.randomBytes(needed).toString();
    };
  } else {
    ctx.seedFile = function(needed, callback) {
      try {
        callback(null, defaultSeedFile(needed));
      } catch (e) {
        callback(e);
      }
    };
    ctx.seedFileSync = defaultSeedFile;
  }
  ctx.collect = function(bytes) {
    var count = bytes.length;
    for (var i3 = 0; i3 < count; ++i3) {
      ctx.pools[ctx.pool].update(bytes.substr(i3, 1));
      ctx.pool = ctx.pool === 31 ? 0 : ctx.pool + 1;
    }
  };
  ctx.collectInt = function(i3, n) {
    var bytes = "";
    for (var x2 = 0; x2 < n; x2 += 8) {
      bytes += String.fromCharCode(i3 >> x2 & 255);
    }
    ctx.collect(bytes);
  };
  ctx.registerWorker = function(worker) {
    if (worker === self) {
      ctx.seedFile = function(needed, callback) {
        function listener2(e) {
          var data = e.data;
          if (data.forge && data.forge.prng) {
            self.removeEventListener("message", listener2);
            callback(data.forge.prng.err, data.forge.prng.bytes);
          }
        }
        self.addEventListener("message", listener2);
        self.postMessage({ forge: { prng: { needed } } });
      };
    } else {
      var listener = function(e) {
        var data = e.data;
        if (data.forge && data.forge.prng) {
          ctx.seedFile(data.forge.prng.needed, function(err2, bytes) {
            worker.postMessage({ forge: { prng: { err: err2, bytes } } });
          });
        }
      };
      worker.addEventListener("message", listener);
    }
  };
  return ctx;
};
var forge$n = forge$C;
(function() {
  if (forge$n.random && forge$n.random.getBytes) {
    return;
  }
  (function(jQuery2) {
    var prng_aes = {};
    var _prng_aes_output = new Array(4);
    var _prng_aes_buffer = forge$n.util.createBuffer();
    prng_aes.formatKey = function(key2) {
      var tmp = forge$n.util.createBuffer(key2);
      key2 = new Array(4);
      key2[0] = tmp.getInt32();
      key2[1] = tmp.getInt32();
      key2[2] = tmp.getInt32();
      key2[3] = tmp.getInt32();
      return forge$n.aes._expandKey(key2, false);
    };
    prng_aes.formatSeed = function(seed) {
      var tmp = forge$n.util.createBuffer(seed);
      seed = new Array(4);
      seed[0] = tmp.getInt32();
      seed[1] = tmp.getInt32();
      seed[2] = tmp.getInt32();
      seed[3] = tmp.getInt32();
      return seed;
    };
    prng_aes.cipher = function(key2, seed) {
      forge$n.aes._updateBlock(key2, seed, _prng_aes_output, false);
      _prng_aes_buffer.putInt32(_prng_aes_output[0]);
      _prng_aes_buffer.putInt32(_prng_aes_output[1]);
      _prng_aes_buffer.putInt32(_prng_aes_output[2]);
      _prng_aes_buffer.putInt32(_prng_aes_output[3]);
      return _prng_aes_buffer.getBytes();
    };
    prng_aes.increment = function(seed) {
      ++seed[3];
      return seed;
    };
    prng_aes.md = forge$n.md.sha256;
    function spawnPrng() {
      var ctx = forge$n.prng.create(prng_aes);
      ctx.getBytes = function(count, callback) {
        return ctx.generate(count, callback);
      };
      ctx.getBytesSync = function(count) {
        return ctx.generate(count);
      };
      return ctx;
    }
    var _ctx = spawnPrng();
    var getRandomValues = null;
    var globalScope = forge$n.util.globalScope;
    var _crypto2 = globalScope.crypto || globalScope.msCrypto;
    if (_crypto2 && _crypto2.getRandomValues) {
      getRandomValues = function(arr) {
        return _crypto2.getRandomValues(arr);
      };
    }
    if (!forge$n.util.isNodejs && !getRandomValues) {
      _ctx.collectInt(+new Date(), 32);
      if (typeof navigator !== "undefined") {
        var _navBytes = "";
        for (var key in navigator) {
          try {
            if (typeof navigator[key] == "string") {
              _navBytes += navigator[key];
            }
          } catch (e) {
          }
        }
        _ctx.collect(_navBytes);
        _navBytes = null;
      }
      if (jQuery2) {
        jQuery2().mousemove(function(e) {
          _ctx.collectInt(e.clientX, 16);
          _ctx.collectInt(e.clientY, 16);
        });
        jQuery2().keypress(function(e) {
          _ctx.collectInt(e.charCode, 8);
        });
      }
    }
    if (!forge$n.random) {
      forge$n.random = _ctx;
    } else {
      for (var key in _ctx) {
        forge$n.random[key] = _ctx[key];
      }
    }
    forge$n.random.createInstance = spawnPrng;
  })(typeof jQuery !== "undefined" ? jQuery : null);
})();
var forge$m = forge$C;
var piTable = [
  217,
  120,
  249,
  196,
  25,
  221,
  181,
  237,
  40,
  233,
  253,
  121,
  74,
  160,
  216,
  157,
  198,
  126,
  55,
  131,
  43,
  118,
  83,
  142,
  98,
  76,
  100,
  136,
  68,
  139,
  251,
  162,
  23,
  154,
  89,
  245,
  135,
  179,
  79,
  19,
  97,
  69,
  109,
  141,
  9,
  129,
  125,
  50,
  189,
  143,
  64,
  235,
  134,
  183,
  123,
  11,
  240,
  149,
  33,
  34,
  92,
  107,
  78,
  130,
  84,
  214,
  101,
  147,
  206,
  96,
  178,
  28,
  115,
  86,
  192,
  20,
  167,
  140,
  241,
  220,
  18,
  117,
  202,
  31,
  59,
  190,
  228,
  209,
  66,
  61,
  212,
  48,
  163,
  60,
  182,
  38,
  111,
  191,
  14,
  218,
  70,
  105,
  7,
  87,
  39,
  242,
  29,
  155,
  188,
  148,
  67,
  3,
  248,
  17,
  199,
  246,
  144,
  239,
  62,
  231,
  6,
  195,
  213,
  47,
  200,
  102,
  30,
  215,
  8,
  232,
  234,
  222,
  128,
  82,
  238,
  247,
  132,
  170,
  114,
  172,
  53,
  77,
  106,
  42,
  150,
  26,
  210,
  113,
  90,
  21,
  73,
  116,
  75,
  159,
  208,
  94,
  4,
  24,
  164,
  236,
  194,
  224,
  65,
  110,
  15,
  81,
  203,
  204,
  36,
  145,
  175,
  80,
  161,
  244,
  112,
  57,
  153,
  124,
  58,
  133,
  35,
  184,
  180,
  122,
  252,
  2,
  54,
  91,
  37,
  85,
  151,
  49,
  45,
  93,
  250,
  152,
  227,
  138,
  146,
  174,
  5,
  223,
  41,
  16,
  103,
  108,
  186,
  201,
  211,
  0,
  230,
  207,
  225,
  158,
  168,
  44,
  99,
  22,
  1,
  63,
  88,
  226,
  137,
  169,
  13,
  56,
  52,
  27,
  171,
  51,
  255,
  176,
  187,
  72,
  12,
  95,
  185,
  177,
  205,
  46,
  197,
  243,
  219,
  71,
  229,
  165,
  156,
  119,
  10,
  166,
  32,
  104,
  254,
  127,
  193,
  173
];
var s = [1, 2, 3, 5];
var rol = function(word, bits) {
  return word << bits & 65535 | (word & 65535) >> 16 - bits;
};
var ror = function(word, bits) {
  return (word & 65535) >> bits | word << 16 - bits & 65535;
};
forge$m.rc2 = forge$m.rc2 || {};
forge$m.rc2.expandKey = function(key, effKeyBits) {
  if (typeof key === "string") {
    key = forge$m.util.createBuffer(key);
  }
  effKeyBits = effKeyBits || 128;
  var L2 = key;
  var T = key.length();
  var T1 = effKeyBits;
  var T8 = Math.ceil(T1 / 8);
  var TM = 255 >> (T1 & 7);
  var i2;
  for (i2 = T; i2 < 128; i2++) {
    L2.putByte(piTable[L2.at(i2 - 1) + L2.at(i2 - T) & 255]);
  }
  L2.setAt(128 - T8, piTable[L2.at(128 - T8) & TM]);
  for (i2 = 127 - T8; i2 >= 0; i2--) {
    L2.setAt(i2, piTable[L2.at(i2 + 1) ^ L2.at(i2 + T8)]);
  }
  return L2;
};
var createCipher = function(key, bits, encrypt) {
  var _finish = false, _input = null, _output = null, _iv = null;
  var mixRound, mashRound;
  var i2, j, K = [];
  key = forge$m.rc2.expandKey(key, bits);
  for (i2 = 0; i2 < 64; i2++) {
    K.push(key.getInt16Le());
  }
  if (encrypt) {
    mixRound = function(R5) {
      for (i2 = 0; i2 < 4; i2++) {
        R5[i2] += K[j] + (R5[(i2 + 3) % 4] & R5[(i2 + 2) % 4]) + (~R5[(i2 + 3) % 4] & R5[(i2 + 1) % 4]);
        R5[i2] = rol(R5[i2], s[i2]);
        j++;
      }
    };
    mashRound = function(R5) {
      for (i2 = 0; i2 < 4; i2++) {
        R5[i2] += K[R5[(i2 + 3) % 4] & 63];
      }
    };
  } else {
    mixRound = function(R5) {
      for (i2 = 3; i2 >= 0; i2--) {
        R5[i2] = ror(R5[i2], s[i2]);
        R5[i2] -= K[j] + (R5[(i2 + 3) % 4] & R5[(i2 + 2) % 4]) + (~R5[(i2 + 3) % 4] & R5[(i2 + 1) % 4]);
        j--;
      }
    };
    mashRound = function(R5) {
      for (i2 = 3; i2 >= 0; i2--) {
        R5[i2] -= K[R5[(i2 + 3) % 4] & 63];
      }
    };
  }
  var runPlan = function(plan) {
    var R5 = [];
    for (i2 = 0; i2 < 4; i2++) {
      var val = _input.getInt16Le();
      if (_iv !== null) {
        if (encrypt) {
          val ^= _iv.getInt16Le();
        } else {
          _iv.putInt16Le(val);
        }
      }
      R5.push(val & 65535);
    }
    j = encrypt ? 0 : 63;
    for (var ptr = 0; ptr < plan.length; ptr++) {
      for (var ctr = 0; ctr < plan[ptr][0]; ctr++) {
        plan[ptr][1](R5);
      }
    }
    for (i2 = 0; i2 < 4; i2++) {
      if (_iv !== null) {
        if (encrypt) {
          _iv.putInt16Le(R5[i2]);
        } else {
          R5[i2] ^= _iv.getInt16Le();
        }
      }
      _output.putInt16Le(R5[i2]);
    }
  };
  var cipher = null;
  cipher = {
    start: function(iv, output) {
      if (iv) {
        if (typeof iv === "string") {
          iv = forge$m.util.createBuffer(iv);
        }
      }
      _finish = false;
      _input = forge$m.util.createBuffer();
      _output = output || new forge$m.util.createBuffer();
      _iv = iv;
      cipher.output = _output;
    },
    update: function(input) {
      if (!_finish) {
        _input.putBuffer(input);
      }
      while (_input.length() >= 8) {
        runPlan([
          [5, mixRound],
          [1, mashRound],
          [6, mixRound],
          [1, mashRound],
          [5, mixRound]
        ]);
      }
    },
    finish: function(pad) {
      var rval = true;
      if (encrypt) {
        if (pad) {
          rval = pad(8, _input, !encrypt);
        } else {
          var padding = _input.length() === 8 ? 8 : 8 - _input.length();
          _input.fillWithByte(padding, padding);
        }
      }
      if (rval) {
        _finish = true;
        cipher.update();
      }
      if (!encrypt) {
        rval = _input.length() === 0;
        if (rval) {
          if (pad) {
            rval = pad(8, _output, !encrypt);
          } else {
            var len = _output.length();
            var count = _output.at(len - 1);
            if (count > len) {
              rval = false;
            } else {
              _output.truncate(count);
            }
          }
        }
      }
      return rval;
    }
  };
  return cipher;
};
forge$m.rc2.startEncrypting = function(key, iv, output) {
  var cipher = forge$m.rc2.createEncryptionCipher(key, 128);
  cipher.start(iv, output);
  return cipher;
};
forge$m.rc2.createEncryptionCipher = function(key, bits) {
  return createCipher(key, bits, true);
};
forge$m.rc2.startDecrypting = function(key, iv, output) {
  var cipher = forge$m.rc2.createDecryptionCipher(key, 128);
  cipher.start(iv, output);
  return cipher;
};
forge$m.rc2.createDecryptionCipher = function(key, bits) {
  return createCipher(key, bits, false);
};
var forge$l = forge$C;
forge$l.jsbn = forge$l.jsbn || {};
var dbits;
function BigInteger$4(a, b, c) {
  this.data = [];
  if (a != null)
    if (typeof a == "number")
      this.fromNumber(a, b, c);
    else if (b == null && typeof a != "string")
      this.fromString(a, 256);
    else
      this.fromString(a, b);
}
forge$l.jsbn.BigInteger = BigInteger$4;
function nbi() {
  return new BigInteger$4(null);
}
function am1(i2, x2, w, j, c, n) {
  while (--n >= 0) {
    var v2 = x2 * this.data[i2++] + w.data[j] + c;
    c = Math.floor(v2 / 67108864);
    w.data[j++] = v2 & 67108863;
  }
  return c;
}
function am2(i2, x2, w, j, c, n) {
  var xl = x2 & 32767, xh = x2 >> 15;
  while (--n >= 0) {
    var l = this.data[i2] & 32767;
    var h = this.data[i2++] >> 15;
    var m = xh * l + h * xl;
    l = xl * l + ((m & 32767) << 15) + w.data[j] + (c & 1073741823);
    c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
    w.data[j++] = l & 1073741823;
  }
  return c;
}
function am3(i2, x2, w, j, c, n) {
  var xl = x2 & 16383, xh = x2 >> 14;
  while (--n >= 0) {
    var l = this.data[i2] & 16383;
    var h = this.data[i2++] >> 14;
    var m = xh * l + h * xl;
    l = xl * l + ((m & 16383) << 14) + w.data[j] + c;
    c = (l >> 28) + (m >> 14) + xh * h;
    w.data[j++] = l & 268435455;
  }
  return c;
}
if (typeof navigator === "undefined") {
  BigInteger$4.prototype.am = am3;
  dbits = 28;
} else if (navigator.appName == "Microsoft Internet Explorer") {
  BigInteger$4.prototype.am = am2;
  dbits = 30;
} else if (navigator.appName != "Netscape") {
  BigInteger$4.prototype.am = am1;
  dbits = 26;
} else {
  BigInteger$4.prototype.am = am3;
  dbits = 28;
}
BigInteger$4.prototype.DB = dbits;
BigInteger$4.prototype.DM = (1 << dbits) - 1;
BigInteger$4.prototype.DV = 1 << dbits;
var BI_FP = 52;
BigInteger$4.prototype.FV = Math.pow(2, BI_FP);
BigInteger$4.prototype.F1 = BI_FP - dbits;
BigInteger$4.prototype.F2 = 2 * dbits - BI_FP;
var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var BI_RC = new Array();
var rr, vv;
rr = "0".charCodeAt(0);
for (vv = 0; vv <= 9; ++vv)
  BI_RC[rr++] = vv;
rr = "a".charCodeAt(0);
for (vv = 10; vv < 36; ++vv)
  BI_RC[rr++] = vv;
rr = "A".charCodeAt(0);
for (vv = 10; vv < 36; ++vv)
  BI_RC[rr++] = vv;
function int2char(n) {
  return BI_RM.charAt(n);
}
function intAt(s2, i2) {
  var c = BI_RC[s2.charCodeAt(i2)];
  return c == null ? -1 : c;
}
function bnpCopyTo(r) {
  for (var i2 = this.t - 1; i2 >= 0; --i2)
    r.data[i2] = this.data[i2];
  r.t = this.t;
  r.s = this.s;
}
function bnpFromInt(x2) {
  this.t = 1;
  this.s = x2 < 0 ? -1 : 0;
  if (x2 > 0)
    this.data[0] = x2;
  else if (x2 < -1)
    this.data[0] = x2 + this.DV;
  else
    this.t = 0;
}
function nbv(i2) {
  var r = nbi();
  r.fromInt(i2);
  return r;
}
function bnpFromString(s2, b) {
  var k;
  if (b == 16)
    k = 4;
  else if (b == 8)
    k = 3;
  else if (b == 256)
    k = 8;
  else if (b == 2)
    k = 1;
  else if (b == 32)
    k = 5;
  else if (b == 4)
    k = 2;
  else {
    this.fromRadix(s2, b);
    return;
  }
  this.t = 0;
  this.s = 0;
  var i2 = s2.length, mi = false, sh = 0;
  while (--i2 >= 0) {
    var x2 = k == 8 ? s2[i2] & 255 : intAt(s2, i2);
    if (x2 < 0) {
      if (s2.charAt(i2) == "-")
        mi = true;
      continue;
    }
    mi = false;
    if (sh == 0)
      this.data[this.t++] = x2;
    else if (sh + k > this.DB) {
      this.data[this.t - 1] |= (x2 & (1 << this.DB - sh) - 1) << sh;
      this.data[this.t++] = x2 >> this.DB - sh;
    } else
      this.data[this.t - 1] |= x2 << sh;
    sh += k;
    if (sh >= this.DB)
      sh -= this.DB;
  }
  if (k == 8 && (s2[0] & 128) != 0) {
    this.s = -1;
    if (sh > 0)
      this.data[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
  }
  this.clamp();
  if (mi)
    BigInteger$4.ZERO.subTo(this, this);
}
function bnpClamp() {
  var c = this.s & this.DM;
  while (this.t > 0 && this.data[this.t - 1] == c)
    --this.t;
}
function bnToString(b) {
  if (this.s < 0)
    return "-" + this.negate().toString(b);
  var k;
  if (b == 16)
    k = 4;
  else if (b == 8)
    k = 3;
  else if (b == 2)
    k = 1;
  else if (b == 32)
    k = 5;
  else if (b == 4)
    k = 2;
  else
    return this.toRadix(b);
  var km = (1 << k) - 1, d, m = false, r = "", i2 = this.t;
  var p = this.DB - i2 * this.DB % k;
  if (i2-- > 0) {
    if (p < this.DB && (d = this.data[i2] >> p) > 0) {
      m = true;
      r = int2char(d);
    }
    while (i2 >= 0) {
      if (p < k) {
        d = (this.data[i2] & (1 << p) - 1) << k - p;
        d |= this.data[--i2] >> (p += this.DB - k);
      } else {
        d = this.data[i2] >> (p -= k) & km;
        if (p <= 0) {
          p += this.DB;
          --i2;
        }
      }
      if (d > 0)
        m = true;
      if (m)
        r += int2char(d);
    }
  }
  return m ? r : "0";
}
function bnNegate() {
  var r = nbi();
  BigInteger$4.ZERO.subTo(this, r);
  return r;
}
function bnAbs() {
  return this.s < 0 ? this.negate() : this;
}
function bnCompareTo(a) {
  var r = this.s - a.s;
  if (r != 0)
    return r;
  var i2 = this.t;
  r = i2 - a.t;
  if (r != 0)
    return this.s < 0 ? -r : r;
  while (--i2 >= 0)
    if ((r = this.data[i2] - a.data[i2]) != 0)
      return r;
  return 0;
}
function nbits(x2) {
  var r = 1, t;
  if ((t = x2 >>> 16) != 0) {
    x2 = t;
    r += 16;
  }
  if ((t = x2 >> 8) != 0) {
    x2 = t;
    r += 8;
  }
  if ((t = x2 >> 4) != 0) {
    x2 = t;
    r += 4;
  }
  if ((t = x2 >> 2) != 0) {
    x2 = t;
    r += 2;
  }
  if ((t = x2 >> 1) != 0) {
    x2 = t;
    r += 1;
  }
  return r;
}
function bnBitLength() {
  if (this.t <= 0)
    return 0;
  return this.DB * (this.t - 1) + nbits(this.data[this.t - 1] ^ this.s & this.DM);
}
function bnpDLShiftTo(n, r) {
  var i2;
  for (i2 = this.t - 1; i2 >= 0; --i2)
    r.data[i2 + n] = this.data[i2];
  for (i2 = n - 1; i2 >= 0; --i2)
    r.data[i2] = 0;
  r.t = this.t + n;
  r.s = this.s;
}
function bnpDRShiftTo(n, r) {
  for (var i2 = n; i2 < this.t; ++i2)
    r.data[i2 - n] = this.data[i2];
  r.t = Math.max(this.t - n, 0);
  r.s = this.s;
}
function bnpLShiftTo(n, r) {
  var bs = n % this.DB;
  var cbs = this.DB - bs;
  var bm = (1 << cbs) - 1;
  var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i2;
  for (i2 = this.t - 1; i2 >= 0; --i2) {
    r.data[i2 + ds + 1] = this.data[i2] >> cbs | c;
    c = (this.data[i2] & bm) << bs;
  }
  for (i2 = ds - 1; i2 >= 0; --i2)
    r.data[i2] = 0;
  r.data[ds] = c;
  r.t = this.t + ds + 1;
  r.s = this.s;
  r.clamp();
}
function bnpRShiftTo(n, r) {
  r.s = this.s;
  var ds = Math.floor(n / this.DB);
  if (ds >= this.t) {
    r.t = 0;
    return;
  }
  var bs = n % this.DB;
  var cbs = this.DB - bs;
  var bm = (1 << bs) - 1;
  r.data[0] = this.data[ds] >> bs;
  for (var i2 = ds + 1; i2 < this.t; ++i2) {
    r.data[i2 - ds - 1] |= (this.data[i2] & bm) << cbs;
    r.data[i2 - ds] = this.data[i2] >> bs;
  }
  if (bs > 0)
    r.data[this.t - ds - 1] |= (this.s & bm) << cbs;
  r.t = this.t - ds;
  r.clamp();
}
function bnpSubTo(a, r) {
  var i2 = 0, c = 0, m = Math.min(a.t, this.t);
  while (i2 < m) {
    c += this.data[i2] - a.data[i2];
    r.data[i2++] = c & this.DM;
    c >>= this.DB;
  }
  if (a.t < this.t) {
    c -= a.s;
    while (i2 < this.t) {
      c += this.data[i2];
      r.data[i2++] = c & this.DM;
      c >>= this.DB;
    }
    c += this.s;
  } else {
    c += this.s;
    while (i2 < a.t) {
      c -= a.data[i2];
      r.data[i2++] = c & this.DM;
      c >>= this.DB;
    }
    c -= a.s;
  }
  r.s = c < 0 ? -1 : 0;
  if (c < -1)
    r.data[i2++] = this.DV + c;
  else if (c > 0)
    r.data[i2++] = c;
  r.t = i2;
  r.clamp();
}
function bnpMultiplyTo(a, r) {
  var x2 = this.abs(), y = a.abs();
  var i2 = x2.t;
  r.t = i2 + y.t;
  while (--i2 >= 0)
    r.data[i2] = 0;
  for (i2 = 0; i2 < y.t; ++i2)
    r.data[i2 + x2.t] = x2.am(0, y.data[i2], r, i2, 0, x2.t);
  r.s = 0;
  r.clamp();
  if (this.s != a.s)
    BigInteger$4.ZERO.subTo(r, r);
}
function bnpSquareTo(r) {
  var x2 = this.abs();
  var i2 = r.t = 2 * x2.t;
  while (--i2 >= 0)
    r.data[i2] = 0;
  for (i2 = 0; i2 < x2.t - 1; ++i2) {
    var c = x2.am(i2, x2.data[i2], r, 2 * i2, 0, 1);
    if ((r.data[i2 + x2.t] += x2.am(i2 + 1, 2 * x2.data[i2], r, 2 * i2 + 1, c, x2.t - i2 - 1)) >= x2.DV) {
      r.data[i2 + x2.t] -= x2.DV;
      r.data[i2 + x2.t + 1] = 1;
    }
  }
  if (r.t > 0)
    r.data[r.t - 1] += x2.am(i2, x2.data[i2], r, 2 * i2, 0, 1);
  r.s = 0;
  r.clamp();
}
function bnpDivRemTo(m, q, r) {
  var pm = m.abs();
  if (pm.t <= 0)
    return;
  var pt = this.abs();
  if (pt.t < pm.t) {
    if (q != null)
      q.fromInt(0);
    if (r != null)
      this.copyTo(r);
    return;
  }
  if (r == null)
    r = nbi();
  var y = nbi(), ts = this.s, ms = m.s;
  var nsh = this.DB - nbits(pm.data[pm.t - 1]);
  if (nsh > 0) {
    pm.lShiftTo(nsh, y);
    pt.lShiftTo(nsh, r);
  } else {
    pm.copyTo(y);
    pt.copyTo(r);
  }
  var ys = y.t;
  var y0 = y.data[ys - 1];
  if (y0 == 0)
    return;
  var yt = y0 * (1 << this.F1) + (ys > 1 ? y.data[ys - 2] >> this.F2 : 0);
  var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
  var i2 = r.t, j = i2 - ys, t = q == null ? nbi() : q;
  y.dlShiftTo(j, t);
  if (r.compareTo(t) >= 0) {
    r.data[r.t++] = 1;
    r.subTo(t, r);
  }
  BigInteger$4.ONE.dlShiftTo(ys, t);
  t.subTo(y, y);
  while (y.t < ys)
    y.data[y.t++] = 0;
  while (--j >= 0) {
    var qd = r.data[--i2] == y0 ? this.DM : Math.floor(r.data[i2] * d1 + (r.data[i2 - 1] + e) * d2);
    if ((r.data[i2] += y.am(0, qd, r, j, 0, ys)) < qd) {
      y.dlShiftTo(j, t);
      r.subTo(t, r);
      while (r.data[i2] < --qd)
        r.subTo(t, r);
    }
  }
  if (q != null) {
    r.drShiftTo(ys, q);
    if (ts != ms)
      BigInteger$4.ZERO.subTo(q, q);
  }
  r.t = ys;
  r.clamp();
  if (nsh > 0)
    r.rShiftTo(nsh, r);
  if (ts < 0)
    BigInteger$4.ZERO.subTo(r, r);
}
function bnMod(a) {
  var r = nbi();
  this.abs().divRemTo(a, null, r);
  if (this.s < 0 && r.compareTo(BigInteger$4.ZERO) > 0)
    a.subTo(r, r);
  return r;
}
function Classic(m) {
  this.m = m;
}
function cConvert(x2) {
  if (x2.s < 0 || x2.compareTo(this.m) >= 0)
    return x2.mod(this.m);
  else
    return x2;
}
function cRevert(x2) {
  return x2;
}
function cReduce(x2) {
  x2.divRemTo(this.m, null, x2);
}
function cMulTo(x2, y, r) {
  x2.multiplyTo(y, r);
  this.reduce(r);
}
function cSqrTo(x2, r) {
  x2.squareTo(r);
  this.reduce(r);
}
Classic.prototype.convert = cConvert;
Classic.prototype.revert = cRevert;
Classic.prototype.reduce = cReduce;
Classic.prototype.mulTo = cMulTo;
Classic.prototype.sqrTo = cSqrTo;
function bnpInvDigit() {
  if (this.t < 1)
    return 0;
  var x2 = this.data[0];
  if ((x2 & 1) == 0)
    return 0;
  var y = x2 & 3;
  y = y * (2 - (x2 & 15) * y) & 15;
  y = y * (2 - (x2 & 255) * y) & 255;
  y = y * (2 - ((x2 & 65535) * y & 65535)) & 65535;
  y = y * (2 - x2 * y % this.DV) % this.DV;
  return y > 0 ? this.DV - y : -y;
}
function Montgomery(m) {
  this.m = m;
  this.mp = m.invDigit();
  this.mpl = this.mp & 32767;
  this.mph = this.mp >> 15;
  this.um = (1 << m.DB - 15) - 1;
  this.mt2 = 2 * m.t;
}
function montConvert(x2) {
  var r = nbi();
  x2.abs().dlShiftTo(this.m.t, r);
  r.divRemTo(this.m, null, r);
  if (x2.s < 0 && r.compareTo(BigInteger$4.ZERO) > 0)
    this.m.subTo(r, r);
  return r;
}
function montRevert(x2) {
  var r = nbi();
  x2.copyTo(r);
  this.reduce(r);
  return r;
}
function montReduce(x2) {
  while (x2.t <= this.mt2)
    x2.data[x2.t++] = 0;
  for (var i2 = 0; i2 < this.m.t; ++i2) {
    var j = x2.data[i2] & 32767;
    var u0 = j * this.mpl + ((j * this.mph + (x2.data[i2] >> 15) * this.mpl & this.um) << 15) & x2.DM;
    j = i2 + this.m.t;
    x2.data[j] += this.m.am(0, u0, x2, i2, 0, this.m.t);
    while (x2.data[j] >= x2.DV) {
      x2.data[j] -= x2.DV;
      x2.data[++j]++;
    }
  }
  x2.clamp();
  x2.drShiftTo(this.m.t, x2);
  if (x2.compareTo(this.m) >= 0)
    x2.subTo(this.m, x2);
}
function montSqrTo(x2, r) {
  x2.squareTo(r);
  this.reduce(r);
}
function montMulTo(x2, y, r) {
  x2.multiplyTo(y, r);
  this.reduce(r);
}
Montgomery.prototype.convert = montConvert;
Montgomery.prototype.revert = montRevert;
Montgomery.prototype.reduce = montReduce;
Montgomery.prototype.mulTo = montMulTo;
Montgomery.prototype.sqrTo = montSqrTo;
function bnpIsEven() {
  return (this.t > 0 ? this.data[0] & 1 : this.s) == 0;
}
function bnpExp(e, z) {
  if (e > 4294967295 || e < 1)
    return BigInteger$4.ONE;
  var r = nbi(), r2 = nbi(), g = z.convert(this), i2 = nbits(e) - 1;
  g.copyTo(r);
  while (--i2 >= 0) {
    z.sqrTo(r, r2);
    if ((e & 1 << i2) > 0)
      z.mulTo(r2, g, r);
    else {
      var t = r;
      r = r2;
      r2 = t;
    }
  }
  return z.revert(r);
}
function bnModPowInt(e, m) {
  var z;
  if (e < 256 || m.isEven())
    z = new Classic(m);
  else
    z = new Montgomery(m);
  return this.exp(e, z);
}
BigInteger$4.prototype.copyTo = bnpCopyTo;
BigInteger$4.prototype.fromInt = bnpFromInt;
BigInteger$4.prototype.fromString = bnpFromString;
BigInteger$4.prototype.clamp = bnpClamp;
BigInteger$4.prototype.dlShiftTo = bnpDLShiftTo;
BigInteger$4.prototype.drShiftTo = bnpDRShiftTo;
BigInteger$4.prototype.lShiftTo = bnpLShiftTo;
BigInteger$4.prototype.rShiftTo = bnpRShiftTo;
BigInteger$4.prototype.subTo = bnpSubTo;
BigInteger$4.prototype.multiplyTo = bnpMultiplyTo;
BigInteger$4.prototype.squareTo = bnpSquareTo;
BigInteger$4.prototype.divRemTo = bnpDivRemTo;
BigInteger$4.prototype.invDigit = bnpInvDigit;
BigInteger$4.prototype.isEven = bnpIsEven;
BigInteger$4.prototype.exp = bnpExp;
BigInteger$4.prototype.toString = bnToString;
BigInteger$4.prototype.negate = bnNegate;
BigInteger$4.prototype.abs = bnAbs;
BigInteger$4.prototype.compareTo = bnCompareTo;
BigInteger$4.prototype.bitLength = bnBitLength;
BigInteger$4.prototype.mod = bnMod;
BigInteger$4.prototype.modPowInt = bnModPowInt;
BigInteger$4.ZERO = nbv(0);
BigInteger$4.ONE = nbv(1);
function bnClone() {
  var r = nbi();
  this.copyTo(r);
  return r;
}
function bnIntValue() {
  if (this.s < 0) {
    if (this.t == 1)
      return this.data[0] - this.DV;
    else if (this.t == 0)
      return -1;
  } else if (this.t == 1)
    return this.data[0];
  else if (this.t == 0)
    return 0;
  return (this.data[1] & (1 << 32 - this.DB) - 1) << this.DB | this.data[0];
}
function bnByteValue() {
  return this.t == 0 ? this.s : this.data[0] << 24 >> 24;
}
function bnShortValue() {
  return this.t == 0 ? this.s : this.data[0] << 16 >> 16;
}
function bnpChunkSize(r) {
  return Math.floor(Math.LN2 * this.DB / Math.log(r));
}
function bnSigNum() {
  if (this.s < 0)
    return -1;
  else if (this.t <= 0 || this.t == 1 && this.data[0] <= 0)
    return 0;
  else
    return 1;
}
function bnpToRadix(b) {
  if (b == null)
    b = 10;
  if (this.signum() == 0 || b < 2 || b > 36)
    return "0";
  var cs = this.chunkSize(b);
  var a = Math.pow(b, cs);
  var d = nbv(a), y = nbi(), z = nbi(), r = "";
  this.divRemTo(d, y, z);
  while (y.signum() > 0) {
    r = (a + z.intValue()).toString(b).substr(1) + r;
    y.divRemTo(d, y, z);
  }
  return z.intValue().toString(b) + r;
}
function bnpFromRadix(s2, b) {
  this.fromInt(0);
  if (b == null)
    b = 10;
  var cs = this.chunkSize(b);
  var d = Math.pow(b, cs), mi = false, j = 0, w = 0;
  for (var i2 = 0; i2 < s2.length; ++i2) {
    var x2 = intAt(s2, i2);
    if (x2 < 0) {
      if (s2.charAt(i2) == "-" && this.signum() == 0)
        mi = true;
      continue;
    }
    w = b * w + x2;
    if (++j >= cs) {
      this.dMultiply(d);
      this.dAddOffset(w, 0);
      j = 0;
      w = 0;
    }
  }
  if (j > 0) {
    this.dMultiply(Math.pow(b, j));
    this.dAddOffset(w, 0);
  }
  if (mi)
    BigInteger$4.ZERO.subTo(this, this);
}
function bnpFromNumber(a, b, c) {
  if (typeof b == "number") {
    if (a < 2)
      this.fromInt(1);
    else {
      this.fromNumber(a, c);
      if (!this.testBit(a - 1))
        this.bitwiseTo(BigInteger$4.ONE.shiftLeft(a - 1), op_or, this);
      if (this.isEven())
        this.dAddOffset(1, 0);
      while (!this.isProbablePrime(b)) {
        this.dAddOffset(2, 0);
        if (this.bitLength() > a)
          this.subTo(BigInteger$4.ONE.shiftLeft(a - 1), this);
      }
    }
  } else {
    var x2 = new Array(), t = a & 7;
    x2.length = (a >> 3) + 1;
    b.nextBytes(x2);
    if (t > 0)
      x2[0] &= (1 << t) - 1;
    else
      x2[0] = 0;
    this.fromString(x2, 256);
  }
}
function bnToByteArray() {
  var i2 = this.t, r = new Array();
  r[0] = this.s;
  var p = this.DB - i2 * this.DB % 8, d, k = 0;
  if (i2-- > 0) {
    if (p < this.DB && (d = this.data[i2] >> p) != (this.s & this.DM) >> p)
      r[k++] = d | this.s << this.DB - p;
    while (i2 >= 0) {
      if (p < 8) {
        d = (this.data[i2] & (1 << p) - 1) << 8 - p;
        d |= this.data[--i2] >> (p += this.DB - 8);
      } else {
        d = this.data[i2] >> (p -= 8) & 255;
        if (p <= 0) {
          p += this.DB;
          --i2;
        }
      }
      if ((d & 128) != 0)
        d |= -256;
      if (k == 0 && (this.s & 128) != (d & 128))
        ++k;
      if (k > 0 || d != this.s)
        r[k++] = d;
    }
  }
  return r;
}
function bnEquals(a) {
  return this.compareTo(a) == 0;
}
function bnMin(a) {
  return this.compareTo(a) < 0 ? this : a;
}
function bnMax(a) {
  return this.compareTo(a) > 0 ? this : a;
}
function bnpBitwiseTo(a, op, r) {
  var i2, f, m = Math.min(a.t, this.t);
  for (i2 = 0; i2 < m; ++i2)
    r.data[i2] = op(this.data[i2], a.data[i2]);
  if (a.t < this.t) {
    f = a.s & this.DM;
    for (i2 = m; i2 < this.t; ++i2)
      r.data[i2] = op(this.data[i2], f);
    r.t = this.t;
  } else {
    f = this.s & this.DM;
    for (i2 = m; i2 < a.t; ++i2)
      r.data[i2] = op(f, a.data[i2]);
    r.t = a.t;
  }
  r.s = op(this.s, a.s);
  r.clamp();
}
function op_and(x2, y) {
  return x2 & y;
}
function bnAnd(a) {
  var r = nbi();
  this.bitwiseTo(a, op_and, r);
  return r;
}
function op_or(x2, y) {
  return x2 | y;
}
function bnOr(a) {
  var r = nbi();
  this.bitwiseTo(a, op_or, r);
  return r;
}
function op_xor(x2, y) {
  return x2 ^ y;
}
function bnXor(a) {
  var r = nbi();
  this.bitwiseTo(a, op_xor, r);
  return r;
}
function op_andnot(x2, y) {
  return x2 & ~y;
}
function bnAndNot(a) {
  var r = nbi();
  this.bitwiseTo(a, op_andnot, r);
  return r;
}
function bnNot() {
  var r = nbi();
  for (var i2 = 0; i2 < this.t; ++i2)
    r.data[i2] = this.DM & ~this.data[i2];
  r.t = this.t;
  r.s = ~this.s;
  return r;
}
function bnShiftLeft(n) {
  var r = nbi();
  if (n < 0)
    this.rShiftTo(-n, r);
  else
    this.lShiftTo(n, r);
  return r;
}
function bnShiftRight(n) {
  var r = nbi();
  if (n < 0)
    this.lShiftTo(-n, r);
  else
    this.rShiftTo(n, r);
  return r;
}
function lbit(x2) {
  if (x2 == 0)
    return -1;
  var r = 0;
  if ((x2 & 65535) == 0) {
    x2 >>= 16;
    r += 16;
  }
  if ((x2 & 255) == 0) {
    x2 >>= 8;
    r += 8;
  }
  if ((x2 & 15) == 0) {
    x2 >>= 4;
    r += 4;
  }
  if ((x2 & 3) == 0) {
    x2 >>= 2;
    r += 2;
  }
  if ((x2 & 1) == 0)
    ++r;
  return r;
}
function bnGetLowestSetBit() {
  for (var i2 = 0; i2 < this.t; ++i2)
    if (this.data[i2] != 0)
      return i2 * this.DB + lbit(this.data[i2]);
  if (this.s < 0)
    return this.t * this.DB;
  return -1;
}
function cbit(x2) {
  var r = 0;
  while (x2 != 0) {
    x2 &= x2 - 1;
    ++r;
  }
  return r;
}
function bnBitCount() {
  var r = 0, x2 = this.s & this.DM;
  for (var i2 = 0; i2 < this.t; ++i2)
    r += cbit(this.data[i2] ^ x2);
  return r;
}
function bnTestBit(n) {
  var j = Math.floor(n / this.DB);
  if (j >= this.t)
    return this.s != 0;
  return (this.data[j] & 1 << n % this.DB) != 0;
}
function bnpChangeBit(n, op) {
  var r = BigInteger$4.ONE.shiftLeft(n);
  this.bitwiseTo(r, op, r);
  return r;
}
function bnSetBit(n) {
  return this.changeBit(n, op_or);
}
function bnClearBit(n) {
  return this.changeBit(n, op_andnot);
}
function bnFlipBit(n) {
  return this.changeBit(n, op_xor);
}
function bnpAddTo(a, r) {
  var i2 = 0, c = 0, m = Math.min(a.t, this.t);
  while (i2 < m) {
    c += this.data[i2] + a.data[i2];
    r.data[i2++] = c & this.DM;
    c >>= this.DB;
  }
  if (a.t < this.t) {
    c += a.s;
    while (i2 < this.t) {
      c += this.data[i2];
      r.data[i2++] = c & this.DM;
      c >>= this.DB;
    }
    c += this.s;
  } else {
    c += this.s;
    while (i2 < a.t) {
      c += a.data[i2];
      r.data[i2++] = c & this.DM;
      c >>= this.DB;
    }
    c += a.s;
  }
  r.s = c < 0 ? -1 : 0;
  if (c > 0)
    r.data[i2++] = c;
  else if (c < -1)
    r.data[i2++] = this.DV + c;
  r.t = i2;
  r.clamp();
}
function bnAdd(a) {
  var r = nbi();
  this.addTo(a, r);
  return r;
}
function bnSubtract(a) {
  var r = nbi();
  this.subTo(a, r);
  return r;
}
function bnMultiply(a) {
  var r = nbi();
  this.multiplyTo(a, r);
  return r;
}
function bnDivide(a) {
  var r = nbi();
  this.divRemTo(a, r, null);
  return r;
}
function bnRemainder(a) {
  var r = nbi();
  this.divRemTo(a, null, r);
  return r;
}
function bnDivideAndRemainder(a) {
  var q = nbi(), r = nbi();
  this.divRemTo(a, q, r);
  return new Array(q, r);
}
function bnpDMultiply(n) {
  this.data[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
  ++this.t;
  this.clamp();
}
function bnpDAddOffset(n, w) {
  if (n == 0)
    return;
  while (this.t <= w)
    this.data[this.t++] = 0;
  this.data[w] += n;
  while (this.data[w] >= this.DV) {
    this.data[w] -= this.DV;
    if (++w >= this.t)
      this.data[this.t++] = 0;
    ++this.data[w];
  }
}
function NullExp() {
}
function nNop(x2) {
  return x2;
}
function nMulTo(x2, y, r) {
  x2.multiplyTo(y, r);
}
function nSqrTo(x2, r) {
  x2.squareTo(r);
}
NullExp.prototype.convert = nNop;
NullExp.prototype.revert = nNop;
NullExp.prototype.mulTo = nMulTo;
NullExp.prototype.sqrTo = nSqrTo;
function bnPow(e) {
  return this.exp(e, new NullExp());
}
function bnpMultiplyLowerTo(a, n, r) {
  var i2 = Math.min(this.t + a.t, n);
  r.s = 0;
  r.t = i2;
  while (i2 > 0)
    r.data[--i2] = 0;
  var j;
  for (j = r.t - this.t; i2 < j; ++i2)
    r.data[i2 + this.t] = this.am(0, a.data[i2], r, i2, 0, this.t);
  for (j = Math.min(a.t, n); i2 < j; ++i2)
    this.am(0, a.data[i2], r, i2, 0, n - i2);
  r.clamp();
}
function bnpMultiplyUpperTo(a, n, r) {
  --n;
  var i2 = r.t = this.t + a.t - n;
  r.s = 0;
  while (--i2 >= 0)
    r.data[i2] = 0;
  for (i2 = Math.max(n - this.t, 0); i2 < a.t; ++i2)
    r.data[this.t + i2 - n] = this.am(n - i2, a.data[i2], r, 0, 0, this.t + i2 - n);
  r.clamp();
  r.drShiftTo(1, r);
}
function Barrett(m) {
  this.r2 = nbi();
  this.q3 = nbi();
  BigInteger$4.ONE.dlShiftTo(2 * m.t, this.r2);
  this.mu = this.r2.divide(m);
  this.m = m;
}
function barrettConvert(x2) {
  if (x2.s < 0 || x2.t > 2 * this.m.t)
    return x2.mod(this.m);
  else if (x2.compareTo(this.m) < 0)
    return x2;
  else {
    var r = nbi();
    x2.copyTo(r);
    this.reduce(r);
    return r;
  }
}
function barrettRevert(x2) {
  return x2;
}
function barrettReduce(x2) {
  x2.drShiftTo(this.m.t - 1, this.r2);
  if (x2.t > this.m.t + 1) {
    x2.t = this.m.t + 1;
    x2.clamp();
  }
  this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
  this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
  while (x2.compareTo(this.r2) < 0)
    x2.dAddOffset(1, this.m.t + 1);
  x2.subTo(this.r2, x2);
  while (x2.compareTo(this.m) >= 0)
    x2.subTo(this.m, x2);
}
function barrettSqrTo(x2, r) {
  x2.squareTo(r);
  this.reduce(r);
}
function barrettMulTo(x2, y, r) {
  x2.multiplyTo(y, r);
  this.reduce(r);
}
Barrett.prototype.convert = barrettConvert;
Barrett.prototype.revert = barrettRevert;
Barrett.prototype.reduce = barrettReduce;
Barrett.prototype.mulTo = barrettMulTo;
Barrett.prototype.sqrTo = barrettSqrTo;
function bnModPow(e, m) {
  var i2 = e.bitLength(), k, r = nbv(1), z;
  if (i2 <= 0)
    return r;
  else if (i2 < 18)
    k = 1;
  else if (i2 < 48)
    k = 3;
  else if (i2 < 144)
    k = 4;
  else if (i2 < 768)
    k = 5;
  else
    k = 6;
  if (i2 < 8)
    z = new Classic(m);
  else if (m.isEven())
    z = new Barrett(m);
  else
    z = new Montgomery(m);
  var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
  g[1] = z.convert(this);
  if (k > 1) {
    var g2 = nbi();
    z.sqrTo(g[1], g2);
    while (n <= km) {
      g[n] = nbi();
      z.mulTo(g2, g[n - 2], g[n]);
      n += 2;
    }
  }
  var j = e.t - 1, w, is1 = true, r2 = nbi(), t;
  i2 = nbits(e.data[j]) - 1;
  while (j >= 0) {
    if (i2 >= k1)
      w = e.data[j] >> i2 - k1 & km;
    else {
      w = (e.data[j] & (1 << i2 + 1) - 1) << k1 - i2;
      if (j > 0)
        w |= e.data[j - 1] >> this.DB + i2 - k1;
    }
    n = k;
    while ((w & 1) == 0) {
      w >>= 1;
      --n;
    }
    if ((i2 -= n) < 0) {
      i2 += this.DB;
      --j;
    }
    if (is1) {
      g[w].copyTo(r);
      is1 = false;
    } else {
      while (n > 1) {
        z.sqrTo(r, r2);
        z.sqrTo(r2, r);
        n -= 2;
      }
      if (n > 0)
        z.sqrTo(r, r2);
      else {
        t = r;
        r = r2;
        r2 = t;
      }
      z.mulTo(r2, g[w], r);
    }
    while (j >= 0 && (e.data[j] & 1 << i2) == 0) {
      z.sqrTo(r, r2);
      t = r;
      r = r2;
      r2 = t;
      if (--i2 < 0) {
        i2 = this.DB - 1;
        --j;
      }
    }
  }
  return z.revert(r);
}
function bnGCD(a) {
  var x2 = this.s < 0 ? this.negate() : this.clone();
  var y = a.s < 0 ? a.negate() : a.clone();
  if (x2.compareTo(y) < 0) {
    var t = x2;
    x2 = y;
    y = t;
  }
  var i2 = x2.getLowestSetBit(), g = y.getLowestSetBit();
  if (g < 0)
    return x2;
  if (i2 < g)
    g = i2;
  if (g > 0) {
    x2.rShiftTo(g, x2);
    y.rShiftTo(g, y);
  }
  while (x2.signum() > 0) {
    if ((i2 = x2.getLowestSetBit()) > 0)
      x2.rShiftTo(i2, x2);
    if ((i2 = y.getLowestSetBit()) > 0)
      y.rShiftTo(i2, y);
    if (x2.compareTo(y) >= 0) {
      x2.subTo(y, x2);
      x2.rShiftTo(1, x2);
    } else {
      y.subTo(x2, y);
      y.rShiftTo(1, y);
    }
  }
  if (g > 0)
    y.lShiftTo(g, y);
  return y;
}
function bnpModInt(n) {
  if (n <= 0)
    return 0;
  var d = this.DV % n, r = this.s < 0 ? n - 1 : 0;
  if (this.t > 0)
    if (d == 0)
      r = this.data[0] % n;
    else
      for (var i2 = this.t - 1; i2 >= 0; --i2)
        r = (d * r + this.data[i2]) % n;
  return r;
}
function bnModInverse(m) {
  var ac = m.isEven();
  if (this.isEven() && ac || m.signum() == 0)
    return BigInteger$4.ZERO;
  var u = m.clone(), v2 = this.clone();
  var a = nbv(1), b = nbv(0), c = nbv(0), d = nbv(1);
  while (u.signum() != 0) {
    while (u.isEven()) {
      u.rShiftTo(1, u);
      if (ac) {
        if (!a.isEven() || !b.isEven()) {
          a.addTo(this, a);
          b.subTo(m, b);
        }
        a.rShiftTo(1, a);
      } else if (!b.isEven())
        b.subTo(m, b);
      b.rShiftTo(1, b);
    }
    while (v2.isEven()) {
      v2.rShiftTo(1, v2);
      if (ac) {
        if (!c.isEven() || !d.isEven()) {
          c.addTo(this, c);
          d.subTo(m, d);
        }
        c.rShiftTo(1, c);
      } else if (!d.isEven())
        d.subTo(m, d);
      d.rShiftTo(1, d);
    }
    if (u.compareTo(v2) >= 0) {
      u.subTo(v2, u);
      if (ac)
        a.subTo(c, a);
      b.subTo(d, b);
    } else {
      v2.subTo(u, v2);
      if (ac)
        c.subTo(a, c);
      d.subTo(b, d);
    }
  }
  if (v2.compareTo(BigInteger$4.ONE) != 0)
    return BigInteger$4.ZERO;
  if (d.compareTo(m) >= 0)
    return d.subtract(m);
  if (d.signum() < 0)
    d.addTo(m, d);
  else
    return d;
  if (d.signum() < 0)
    return d.add(m);
  else
    return d;
}
var lowprimes = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509];
var lplim = (1 << 26) / lowprimes[lowprimes.length - 1];
function bnIsProbablePrime(t) {
  var i2, x2 = this.abs();
  if (x2.t == 1 && x2.data[0] <= lowprimes[lowprimes.length - 1]) {
    for (i2 = 0; i2 < lowprimes.length; ++i2)
      if (x2.data[0] == lowprimes[i2])
        return true;
    return false;
  }
  if (x2.isEven())
    return false;
  i2 = 1;
  while (i2 < lowprimes.length) {
    var m = lowprimes[i2], j = i2 + 1;
    while (j < lowprimes.length && m < lplim)
      m *= lowprimes[j++];
    m = x2.modInt(m);
    while (i2 < j)
      if (m % lowprimes[i2++] == 0)
        return false;
  }
  return x2.millerRabin(t);
}
function bnpMillerRabin(t) {
  var n1 = this.subtract(BigInteger$4.ONE);
  var k = n1.getLowestSetBit();
  if (k <= 0)
    return false;
  var r = n1.shiftRight(k);
  var prng2 = bnGetPrng();
  var a;
  for (var i2 = 0; i2 < t; ++i2) {
    do {
      a = new BigInteger$4(this.bitLength(), prng2);
    } while (a.compareTo(BigInteger$4.ONE) <= 0 || a.compareTo(n1) >= 0);
    var y = a.modPow(r, this);
    if (y.compareTo(BigInteger$4.ONE) != 0 && y.compareTo(n1) != 0) {
      var j = 1;
      while (j++ < k && y.compareTo(n1) != 0) {
        y = y.modPowInt(2, this);
        if (y.compareTo(BigInteger$4.ONE) == 0)
          return false;
      }
      if (y.compareTo(n1) != 0)
        return false;
    }
  }
  return true;
}
function bnGetPrng() {
  return {
    nextBytes: function(x2) {
      for (var i2 = 0; i2 < x2.length; ++i2) {
        x2[i2] = Math.floor(Math.random() * 256);
      }
    }
  };
}
BigInteger$4.prototype.chunkSize = bnpChunkSize;
BigInteger$4.prototype.toRadix = bnpToRadix;
BigInteger$4.prototype.fromRadix = bnpFromRadix;
BigInteger$4.prototype.fromNumber = bnpFromNumber;
BigInteger$4.prototype.bitwiseTo = bnpBitwiseTo;
BigInteger$4.prototype.changeBit = bnpChangeBit;
BigInteger$4.prototype.addTo = bnpAddTo;
BigInteger$4.prototype.dMultiply = bnpDMultiply;
BigInteger$4.prototype.dAddOffset = bnpDAddOffset;
BigInteger$4.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
BigInteger$4.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
BigInteger$4.prototype.modInt = bnpModInt;
BigInteger$4.prototype.millerRabin = bnpMillerRabin;
BigInteger$4.prototype.clone = bnClone;
BigInteger$4.prototype.intValue = bnIntValue;
BigInteger$4.prototype.byteValue = bnByteValue;
BigInteger$4.prototype.shortValue = bnShortValue;
BigInteger$4.prototype.signum = bnSigNum;
BigInteger$4.prototype.toByteArray = bnToByteArray;
BigInteger$4.prototype.equals = bnEquals;
BigInteger$4.prototype.min = bnMin;
BigInteger$4.prototype.max = bnMax;
BigInteger$4.prototype.and = bnAnd;
BigInteger$4.prototype.or = bnOr;
BigInteger$4.prototype.xor = bnXor;
BigInteger$4.prototype.andNot = bnAndNot;
BigInteger$4.prototype.not = bnNot;
BigInteger$4.prototype.shiftLeft = bnShiftLeft;
BigInteger$4.prototype.shiftRight = bnShiftRight;
BigInteger$4.prototype.getLowestSetBit = bnGetLowestSetBit;
BigInteger$4.prototype.bitCount = bnBitCount;
BigInteger$4.prototype.testBit = bnTestBit;
BigInteger$4.prototype.setBit = bnSetBit;
BigInteger$4.prototype.clearBit = bnClearBit;
BigInteger$4.prototype.flipBit = bnFlipBit;
BigInteger$4.prototype.add = bnAdd;
BigInteger$4.prototype.subtract = bnSubtract;
BigInteger$4.prototype.multiply = bnMultiply;
BigInteger$4.prototype.divide = bnDivide;
BigInteger$4.prototype.remainder = bnRemainder;
BigInteger$4.prototype.divideAndRemainder = bnDivideAndRemainder;
BigInteger$4.prototype.modPow = bnModPow;
BigInteger$4.prototype.modInverse = bnModInverse;
BigInteger$4.prototype.pow = bnPow;
BigInteger$4.prototype.gcd = bnGCD;
BigInteger$4.prototype.isProbablePrime = bnIsProbablePrime;
var forge$k = forge$C;
var sha1 = forge$k.sha1 = forge$k.sha1 || {};
forge$k.md.sha1 = forge$k.md.algorithms.sha1 = sha1;
sha1.create = function() {
  if (!_initialized$1) {
    _init$1();
  }
  var _state = null;
  var _input = forge$k.util.createBuffer();
  var _w = new Array(80);
  var md = {
    algorithm: "sha1",
    blockLength: 64,
    digestLength: 20,
    messageLength: 0,
    fullMessageLength: null,
    messageLengthSize: 8
  };
  md.start = function() {
    md.messageLength = 0;
    md.fullMessageLength = md.messageLength64 = [];
    var int32s = md.messageLengthSize / 4;
    for (var i2 = 0; i2 < int32s; ++i2) {
      md.fullMessageLength.push(0);
    }
    _input = forge$k.util.createBuffer();
    _state = {
      h0: 1732584193,
      h1: 4023233417,
      h2: 2562383102,
      h3: 271733878,
      h4: 3285377520
    };
    return md;
  };
  md.start();
  md.update = function(msg, encoding) {
    if (encoding === "utf8") {
      msg = forge$k.util.encodeUtf8(msg);
    }
    var len = msg.length;
    md.messageLength += len;
    len = [len / 4294967296 >>> 0, len >>> 0];
    for (var i2 = md.fullMessageLength.length - 1; i2 >= 0; --i2) {
      md.fullMessageLength[i2] += len[1];
      len[1] = len[0] + (md.fullMessageLength[i2] / 4294967296 >>> 0);
      md.fullMessageLength[i2] = md.fullMessageLength[i2] >>> 0;
      len[0] = len[1] / 4294967296 >>> 0;
    }
    _input.putBytes(msg);
    _update$1(_state, _w, _input);
    if (_input.read > 2048 || _input.length() === 0) {
      _input.compact();
    }
    return md;
  };
  md.digest = function() {
    var finalBlock = forge$k.util.createBuffer();
    finalBlock.putBytes(_input.bytes());
    var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
    var overflow = remaining & md.blockLength - 1;
    finalBlock.putBytes(_padding$1.substr(0, md.blockLength - overflow));
    var next, carry;
    var bits = md.fullMessageLength[0] * 8;
    for (var i2 = 0; i2 < md.fullMessageLength.length - 1; ++i2) {
      next = md.fullMessageLength[i2 + 1] * 8;
      carry = next / 4294967296 >>> 0;
      bits += carry;
      finalBlock.putInt32(bits >>> 0);
      bits = next >>> 0;
    }
    finalBlock.putInt32(bits);
    var s2 = {
      h0: _state.h0,
      h1: _state.h1,
      h2: _state.h2,
      h3: _state.h3,
      h4: _state.h4
    };
    _update$1(s2, _w, finalBlock);
    var rval = forge$k.util.createBuffer();
    rval.putInt32(s2.h0);
    rval.putInt32(s2.h1);
    rval.putInt32(s2.h2);
    rval.putInt32(s2.h3);
    rval.putInt32(s2.h4);
    return rval;
  };
  return md;
};
var _padding$1 = null;
var _initialized$1 = false;
function _init$1() {
  _padding$1 = String.fromCharCode(128);
  _padding$1 += forge$k.util.fillString(String.fromCharCode(0), 64);
  _initialized$1 = true;
}
function _update$1(s2, w, bytes) {
  var t, a, b, c, d, e, f, i2;
  var len = bytes.length();
  while (len >= 64) {
    a = s2.h0;
    b = s2.h1;
    c = s2.h2;
    d = s2.h3;
    e = s2.h4;
    for (i2 = 0; i2 < 16; ++i2) {
      t = bytes.getInt32();
      w[i2] = t;
      f = d ^ b & (c ^ d);
      t = (a << 5 | a >>> 27) + f + e + 1518500249 + t;
      e = d;
      d = c;
      c = (b << 30 | b >>> 2) >>> 0;
      b = a;
      a = t;
    }
    for (; i2 < 20; ++i2) {
      t = w[i2 - 3] ^ w[i2 - 8] ^ w[i2 - 14] ^ w[i2 - 16];
      t = t << 1 | t >>> 31;
      w[i2] = t;
      f = d ^ b & (c ^ d);
      t = (a << 5 | a >>> 27) + f + e + 1518500249 + t;
      e = d;
      d = c;
      c = (b << 30 | b >>> 2) >>> 0;
      b = a;
      a = t;
    }
    for (; i2 < 32; ++i2) {
      t = w[i2 - 3] ^ w[i2 - 8] ^ w[i2 - 14] ^ w[i2 - 16];
      t = t << 1 | t >>> 31;
      w[i2] = t;
      f = b ^ c ^ d;
      t = (a << 5 | a >>> 27) + f + e + 1859775393 + t;
      e = d;
      d = c;
      c = (b << 30 | b >>> 2) >>> 0;
      b = a;
      a = t;
    }
    for (; i2 < 40; ++i2) {
      t = w[i2 - 6] ^ w[i2 - 16] ^ w[i2 - 28] ^ w[i2 - 32];
      t = t << 2 | t >>> 30;
      w[i2] = t;
      f = b ^ c ^ d;
      t = (a << 5 | a >>> 27) + f + e + 1859775393 + t;
      e = d;
      d = c;
      c = (b << 30 | b >>> 2) >>> 0;
      b = a;
      a = t;
    }
    for (; i2 < 60; ++i2) {
      t = w[i2 - 6] ^ w[i2 - 16] ^ w[i2 - 28] ^ w[i2 - 32];
      t = t << 2 | t >>> 30;
      w[i2] = t;
      f = b & c | d & (b ^ c);
      t = (a << 5 | a >>> 27) + f + e + 2400959708 + t;
      e = d;
      d = c;
      c = (b << 30 | b >>> 2) >>> 0;
      b = a;
      a = t;
    }
    for (; i2 < 80; ++i2) {
      t = w[i2 - 6] ^ w[i2 - 16] ^ w[i2 - 28] ^ w[i2 - 32];
      t = t << 2 | t >>> 30;
      w[i2] = t;
      f = b ^ c ^ d;
      t = (a << 5 | a >>> 27) + f + e + 3395469782 + t;
      e = d;
      d = c;
      c = (b << 30 | b >>> 2) >>> 0;
      b = a;
      a = t;
    }
    s2.h0 = s2.h0 + a | 0;
    s2.h1 = s2.h1 + b | 0;
    s2.h2 = s2.h2 + c | 0;
    s2.h3 = s2.h3 + d | 0;
    s2.h4 = s2.h4 + e | 0;
    len -= 64;
  }
}
var forge$j = forge$C;
var pkcs1 = forge$j.pkcs1 = forge$j.pkcs1 || {};
pkcs1.encode_rsa_oaep = function(key, message, options) {
  var label;
  var seed;
  var md;
  var mgf1Md;
  if (typeof options === "string") {
    label = options;
    seed = arguments[3] || void 0;
    md = arguments[4] || void 0;
  } else if (options) {
    label = options.label || void 0;
    seed = options.seed || void 0;
    md = options.md || void 0;
    if (options.mgf1 && options.mgf1.md) {
      mgf1Md = options.mgf1.md;
    }
  }
  if (!md) {
    md = forge$j.md.sha1.create();
  } else {
    md.start();
  }
  if (!mgf1Md) {
    mgf1Md = md;
  }
  var keyLength = Math.ceil(key.n.bitLength() / 8);
  var maxLength = keyLength - 2 * md.digestLength - 2;
  if (message.length > maxLength) {
    var error = new Error("RSAES-OAEP input message length is too long.");
    error.length = message.length;
    error.maxLength = maxLength;
    throw error;
  }
  if (!label) {
    label = "";
  }
  md.update(label, "raw");
  var lHash = md.digest();
  var PS = "";
  var PS_length = maxLength - message.length;
  for (var i2 = 0; i2 < PS_length; i2++) {
    PS += "\0";
  }
  var DB = lHash.getBytes() + PS + "" + message;
  if (!seed) {
    seed = forge$j.random.getBytes(md.digestLength);
  } else if (seed.length !== md.digestLength) {
    var error = new Error("Invalid RSAES-OAEP seed. The seed length must match the digest length.");
    error.seedLength = seed.length;
    error.digestLength = md.digestLength;
    throw error;
  }
  var dbMask = rsa_mgf1(seed, keyLength - md.digestLength - 1, mgf1Md);
  var maskedDB = forge$j.util.xorBytes(DB, dbMask, DB.length);
  var seedMask = rsa_mgf1(maskedDB, md.digestLength, mgf1Md);
  var maskedSeed = forge$j.util.xorBytes(seed, seedMask, seed.length);
  return "\0" + maskedSeed + maskedDB;
};
pkcs1.decode_rsa_oaep = function(key, em, options) {
  var label;
  var md;
  var mgf1Md;
  if (typeof options === "string") {
    label = options;
    md = arguments[3] || void 0;
  } else if (options) {
    label = options.label || void 0;
    md = options.md || void 0;
    if (options.mgf1 && options.mgf1.md) {
      mgf1Md = options.mgf1.md;
    }
  }
  var keyLength = Math.ceil(key.n.bitLength() / 8);
  if (em.length !== keyLength) {
    var error = new Error("RSAES-OAEP encoded message length is invalid.");
    error.length = em.length;
    error.expectedLength = keyLength;
    throw error;
  }
  if (md === void 0) {
    md = forge$j.md.sha1.create();
  } else {
    md.start();
  }
  if (!mgf1Md) {
    mgf1Md = md;
  }
  if (keyLength < 2 * md.digestLength + 2) {
    throw new Error("RSAES-OAEP key is too short for the hash function.");
  }
  if (!label) {
    label = "";
  }
  md.update(label, "raw");
  var lHash = md.digest().getBytes();
  var y = em.charAt(0);
  var maskedSeed = em.substring(1, md.digestLength + 1);
  var maskedDB = em.substring(1 + md.digestLength);
  var seedMask = rsa_mgf1(maskedDB, md.digestLength, mgf1Md);
  var seed = forge$j.util.xorBytes(maskedSeed, seedMask, maskedSeed.length);
  var dbMask = rsa_mgf1(seed, keyLength - md.digestLength - 1, mgf1Md);
  var db = forge$j.util.xorBytes(maskedDB, dbMask, maskedDB.length);
  var lHashPrime = db.substring(0, md.digestLength);
  var error = y !== "\0";
  for (var i2 = 0; i2 < md.digestLength; ++i2) {
    error |= lHash.charAt(i2) !== lHashPrime.charAt(i2);
  }
  var in_ps = 1;
  var index3 = md.digestLength;
  for (var j = md.digestLength; j < db.length; j++) {
    var code = db.charCodeAt(j);
    var is_0 = code & 1 ^ 1;
    var error_mask = in_ps ? 65534 : 0;
    error |= code & error_mask;
    in_ps = in_ps & is_0;
    index3 += in_ps;
  }
  if (error || db.charCodeAt(index3) !== 1) {
    throw new Error("Invalid RSAES-OAEP padding.");
  }
  return db.substring(index3 + 1);
};
function rsa_mgf1(seed, maskLength, hash2) {
  if (!hash2) {
    hash2 = forge$j.md.sha1.create();
  }
  var t = "";
  var count = Math.ceil(maskLength / hash2.digestLength);
  for (var i2 = 0; i2 < count; ++i2) {
    var c = String.fromCharCode(i2 >> 24 & 255, i2 >> 16 & 255, i2 >> 8 & 255, i2 & 255);
    hash2.start();
    hash2.update(seed + c);
    t += hash2.digest().getBytes();
  }
  return t.substring(0, maskLength);
}
var forge$i = forge$C;
(function() {
  if (forge$i.prime) {
    return;
  }
  var prime = forge$i.prime = forge$i.prime || {};
  var BigInteger2 = forge$i.jsbn.BigInteger;
  var GCD_30_DELTA2 = [6, 4, 2, 4, 2, 4, 6, 2];
  var THIRTY = new BigInteger2(null);
  THIRTY.fromInt(30);
  var op_or2 = function(x2, y) {
    return x2 | y;
  };
  prime.generateProbablePrime = function(bits, options, callback) {
    if (typeof options === "function") {
      callback = options;
      options = {};
    }
    options = options || {};
    var algorithm = options.algorithm || "PRIMEINC";
    if (typeof algorithm === "string") {
      algorithm = { name: algorithm };
    }
    algorithm.options = algorithm.options || {};
    var prng2 = options.prng || forge$i.random;
    var rng = {
      nextBytes: function(x2) {
        var b = prng2.getBytesSync(x2.length);
        for (var i2 = 0; i2 < x2.length; ++i2) {
          x2[i2] = b.charCodeAt(i2);
        }
      }
    };
    if (algorithm.name === "PRIMEINC") {
      return primeincFindPrime(bits, rng, algorithm.options, callback);
    }
    throw new Error("Invalid prime generation algorithm: " + algorithm.name);
  };
  function primeincFindPrime(bits, rng, options, callback) {
    if ("workers" in options) {
      return primeincFindPrimeWithWorkers(bits, rng, options, callback);
    }
    return primeincFindPrimeWithoutWorkers(bits, rng, options, callback);
  }
  function primeincFindPrimeWithoutWorkers(bits, rng, options, callback) {
    var num = generateRandom(bits, rng);
    var deltaIdx = 0;
    var mrTests = getMillerRabinTests(num.bitLength());
    if ("millerRabinTests" in options) {
      mrTests = options.millerRabinTests;
    }
    var maxBlockTime = 10;
    if ("maxBlockTime" in options) {
      maxBlockTime = options.maxBlockTime;
    }
    _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback);
  }
  function _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback) {
    var start3 = +new Date();
    do {
      if (num.bitLength() > bits) {
        num = generateRandom(bits, rng);
      }
      if (num.isProbablePrime(mrTests)) {
        return callback(null, num);
      }
      num.dAddOffset(GCD_30_DELTA2[deltaIdx++ % 8], 0);
    } while (maxBlockTime < 0 || +new Date() - start3 < maxBlockTime);
    forge$i.util.setImmediate(function() {
      _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback);
    });
  }
  function primeincFindPrimeWithWorkers(bits, rng, options, callback) {
    if (typeof Worker === "undefined") {
      return primeincFindPrimeWithoutWorkers(bits, rng, options, callback);
    }
    var num = generateRandom(bits, rng);
    var numWorkers = options.workers;
    var workLoad = options.workLoad || 100;
    var range2 = workLoad * 30 / 8;
    var workerScript = options.workerScript || "forge/prime.worker.js";
    if (numWorkers === -1) {
      return forge$i.util.estimateCores(function(err2, cores) {
        if (err2) {
          cores = 2;
        }
        numWorkers = cores - 1;
        generate();
      });
    }
    generate();
    function generate() {
      numWorkers = Math.max(1, numWorkers);
      var workers = [];
      for (var i2 = 0; i2 < numWorkers; ++i2) {
        workers[i2] = new Worker(workerScript);
      }
      for (var i2 = 0; i2 < numWorkers; ++i2) {
        workers[i2].addEventListener("message", workerMessage);
      }
      var found2 = false;
      function workerMessage(e) {
        if (found2) {
          return;
        }
        var data = e.data;
        if (data.found) {
          for (var i3 = 0; i3 < workers.length; ++i3) {
            workers[i3].terminate();
          }
          found2 = true;
          return callback(null, new BigInteger2(data.prime, 16));
        }
        if (num.bitLength() > bits) {
          num = generateRandom(bits, rng);
        }
        var hex = num.toString(16);
        e.target.postMessage({
          hex,
          workLoad
        });
        num.dAddOffset(range2, 0);
      }
    }
  }
  function generateRandom(bits, rng) {
    var num = new BigInteger2(bits, rng);
    var bits1 = bits - 1;
    if (!num.testBit(bits1)) {
      num.bitwiseTo(BigInteger2.ONE.shiftLeft(bits1), op_or2, num);
    }
    num.dAddOffset(31 - num.mod(THIRTY).byteValue(), 0);
    return num;
  }
  function getMillerRabinTests(bits) {
    if (bits <= 100)
      return 27;
    if (bits <= 150)
      return 18;
    if (bits <= 200)
      return 15;
    if (bits <= 250)
      return 12;
    if (bits <= 300)
      return 9;
    if (bits <= 350)
      return 8;
    if (bits <= 400)
      return 7;
    if (bits <= 500)
      return 6;
    if (bits <= 600)
      return 5;
    if (bits <= 800)
      return 4;
    if (bits <= 1250)
      return 3;
    return 2;
  }
})();
var forge$h = forge$C;
if (typeof BigInteger$3 === "undefined") {
  var BigInteger$3 = forge$h.jsbn.BigInteger;
}
var _crypto = forge$h.util.isNodejs ? require$$1 : null;
var asn1$7 = forge$h.asn1;
var util$1 = forge$h.util;
forge$h.pki = forge$h.pki || {};
forge$h.pki.rsa = forge$h.rsa = forge$h.rsa || {};
var pki$4 = forge$h.pki;
var GCD_30_DELTA = [6, 4, 2, 4, 2, 4, 6, 2];
var privateKeyValidator$1 = {
  name: "PrivateKeyInfo",
  tagClass: asn1$7.Class.UNIVERSAL,
  type: asn1$7.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "PrivateKeyInfo.version",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: false,
    capture: "privateKeyVersion"
  }, {
    name: "PrivateKeyInfo.privateKeyAlgorithm",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: "AlgorithmIdentifier.algorithm",
      tagClass: asn1$7.Class.UNIVERSAL,
      type: asn1$7.Type.OID,
      constructed: false,
      capture: "privateKeyOid"
    }]
  }, {
    name: "PrivateKeyInfo",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.OCTETSTRING,
    constructed: false,
    capture: "privateKey"
  }]
};
var rsaPrivateKeyValidator = {
  name: "RSAPrivateKey",
  tagClass: asn1$7.Class.UNIVERSAL,
  type: asn1$7.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "RSAPrivateKey.version",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: false,
    capture: "privateKeyVersion"
  }, {
    name: "RSAPrivateKey.modulus",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: false,
    capture: "privateKeyModulus"
  }, {
    name: "RSAPrivateKey.publicExponent",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: false,
    capture: "privateKeyPublicExponent"
  }, {
    name: "RSAPrivateKey.privateExponent",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: false,
    capture: "privateKeyPrivateExponent"
  }, {
    name: "RSAPrivateKey.prime1",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: false,
    capture: "privateKeyPrime1"
  }, {
    name: "RSAPrivateKey.prime2",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: false,
    capture: "privateKeyPrime2"
  }, {
    name: "RSAPrivateKey.exponent1",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: false,
    capture: "privateKeyExponent1"
  }, {
    name: "RSAPrivateKey.exponent2",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: false,
    capture: "privateKeyExponent2"
  }, {
    name: "RSAPrivateKey.coefficient",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: false,
    capture: "privateKeyCoefficient"
  }]
};
var rsaPublicKeyValidator = {
  name: "RSAPublicKey",
  tagClass: asn1$7.Class.UNIVERSAL,
  type: asn1$7.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "RSAPublicKey.modulus",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: false,
    capture: "publicKeyModulus"
  }, {
    name: "RSAPublicKey.exponent",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: false,
    capture: "publicKeyExponent"
  }]
};
var publicKeyValidator$2 = forge$h.pki.rsa.publicKeyValidator = {
  name: "SubjectPublicKeyInfo",
  tagClass: asn1$7.Class.UNIVERSAL,
  type: asn1$7.Type.SEQUENCE,
  constructed: true,
  captureAsn1: "subjectPublicKeyInfo",
  value: [{
    name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: "AlgorithmIdentifier.algorithm",
      tagClass: asn1$7.Class.UNIVERSAL,
      type: asn1$7.Type.OID,
      constructed: false,
      capture: "publicKeyOid"
    }]
  }, {
    name: "SubjectPublicKeyInfo.subjectPublicKey",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.BITSTRING,
    constructed: false,
    value: [{
      name: "SubjectPublicKeyInfo.subjectPublicKey.RSAPublicKey",
      tagClass: asn1$7.Class.UNIVERSAL,
      type: asn1$7.Type.SEQUENCE,
      constructed: true,
      optional: true,
      captureAsn1: "rsaPublicKey"
    }]
  }]
};
var emsaPkcs1v15encode = function(md) {
  var oid;
  if (md.algorithm in pki$4.oids) {
    oid = pki$4.oids[md.algorithm];
  } else {
    var error = new Error("Unknown message digest algorithm.");
    error.algorithm = md.algorithm;
    throw error;
  }
  var oidBytes = asn1$7.oidToDer(oid).getBytes();
  var digestInfo = asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.SEQUENCE, true, []);
  var digestAlgorithm = asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.SEQUENCE, true, []);
  digestAlgorithm.value.push(asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.OID, false, oidBytes));
  digestAlgorithm.value.push(asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.NULL, false, ""));
  var digest = asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.OCTETSTRING, false, md.digest().getBytes());
  digestInfo.value.push(digestAlgorithm);
  digestInfo.value.push(digest);
  return asn1$7.toDer(digestInfo).getBytes();
};
var _modPow = function(x2, key, pub) {
  if (pub) {
    return x2.modPow(key.e, key.n);
  }
  if (!key.p || !key.q) {
    return x2.modPow(key.d, key.n);
  }
  if (!key.dP) {
    key.dP = key.d.mod(key.p.subtract(BigInteger$3.ONE));
  }
  if (!key.dQ) {
    key.dQ = key.d.mod(key.q.subtract(BigInteger$3.ONE));
  }
  if (!key.qInv) {
    key.qInv = key.q.modInverse(key.p);
  }
  var r;
  do {
    r = new BigInteger$3(forge$h.util.bytesToHex(forge$h.random.getBytes(key.n.bitLength() / 8)), 16);
  } while (r.compareTo(key.n) >= 0 || !r.gcd(key.n).equals(BigInteger$3.ONE));
  x2 = x2.multiply(r.modPow(key.e, key.n)).mod(key.n);
  var xp = x2.mod(key.p).modPow(key.dP, key.p);
  var xq = x2.mod(key.q).modPow(key.dQ, key.q);
  while (xp.compareTo(xq) < 0) {
    xp = xp.add(key.p);
  }
  var y = xp.subtract(xq).multiply(key.qInv).mod(key.p).multiply(key.q).add(xq);
  y = y.multiply(r.modInverse(key.n)).mod(key.n);
  return y;
};
pki$4.rsa.encrypt = function(m, key, bt) {
  var pub = bt;
  var eb;
  var k = Math.ceil(key.n.bitLength() / 8);
  if (bt !== false && bt !== true) {
    pub = bt === 2;
    eb = _encodePkcs1_v1_5(m, key, bt);
  } else {
    eb = forge$h.util.createBuffer();
    eb.putBytes(m);
  }
  var x2 = new BigInteger$3(eb.toHex(), 16);
  var y = _modPow(x2, key, pub);
  var yhex = y.toString(16);
  var ed = forge$h.util.createBuffer();
  var zeros = k - Math.ceil(yhex.length / 2);
  while (zeros > 0) {
    ed.putByte(0);
    --zeros;
  }
  ed.putBytes(forge$h.util.hexToBytes(yhex));
  return ed.getBytes();
};
pki$4.rsa.decrypt = function(ed, key, pub, ml) {
  var k = Math.ceil(key.n.bitLength() / 8);
  if (ed.length !== k) {
    var error = new Error("Encrypted message length is invalid.");
    error.length = ed.length;
    error.expected = k;
    throw error;
  }
  var y = new BigInteger$3(forge$h.util.createBuffer(ed).toHex(), 16);
  if (y.compareTo(key.n) >= 0) {
    throw new Error("Encrypted message is invalid.");
  }
  var x2 = _modPow(y, key, pub);
  var xhex = x2.toString(16);
  var eb = forge$h.util.createBuffer();
  var zeros = k - Math.ceil(xhex.length / 2);
  while (zeros > 0) {
    eb.putByte(0);
    --zeros;
  }
  eb.putBytes(forge$h.util.hexToBytes(xhex));
  if (ml !== false) {
    return _decodePkcs1_v1_5(eb.getBytes(), key, pub);
  }
  return eb.getBytes();
};
pki$4.rsa.createKeyPairGenerationState = function(bits, e, options) {
  if (typeof bits === "string") {
    bits = parseInt(bits, 10);
  }
  bits = bits || 2048;
  options = options || {};
  var prng2 = options.prng || forge$h.random;
  var rng = {
    nextBytes: function(x2) {
      var b = prng2.getBytesSync(x2.length);
      for (var i2 = 0; i2 < x2.length; ++i2) {
        x2[i2] = b.charCodeAt(i2);
      }
    }
  };
  var algorithm = options.algorithm || "PRIMEINC";
  var rval;
  if (algorithm === "PRIMEINC") {
    rval = {
      algorithm,
      state: 0,
      bits,
      rng,
      eInt: e || 65537,
      e: new BigInteger$3(null),
      p: null,
      q: null,
      qBits: bits >> 1,
      pBits: bits - (bits >> 1),
      pqState: 0,
      num: null,
      keys: null
    };
    rval.e.fromInt(rval.eInt);
  } else {
    throw new Error("Invalid key generation algorithm: " + algorithm);
  }
  return rval;
};
pki$4.rsa.stepKeyPairGenerationState = function(state, n) {
  if (!("algorithm" in state)) {
    state.algorithm = "PRIMEINC";
  }
  var THIRTY = new BigInteger$3(null);
  THIRTY.fromInt(30);
  var deltaIdx = 0;
  var op_or2 = function(x2, y) {
    return x2 | y;
  };
  var t1 = +new Date();
  var t2;
  var total = 0;
  while (state.keys === null && (n <= 0 || total < n)) {
    if (state.state === 0) {
      var bits = state.p === null ? state.pBits : state.qBits;
      var bits1 = bits - 1;
      if (state.pqState === 0) {
        state.num = new BigInteger$3(bits, state.rng);
        if (!state.num.testBit(bits1)) {
          state.num.bitwiseTo(BigInteger$3.ONE.shiftLeft(bits1), op_or2, state.num);
        }
        state.num.dAddOffset(31 - state.num.mod(THIRTY).byteValue(), 0);
        deltaIdx = 0;
        ++state.pqState;
      } else if (state.pqState === 1) {
        if (state.num.bitLength() > bits) {
          state.pqState = 0;
        } else if (state.num.isProbablePrime(_getMillerRabinTests(state.num.bitLength()))) {
          ++state.pqState;
        } else {
          state.num.dAddOffset(GCD_30_DELTA[deltaIdx++ % 8], 0);
        }
      } else if (state.pqState === 2) {
        state.pqState = state.num.subtract(BigInteger$3.ONE).gcd(state.e).compareTo(BigInteger$3.ONE) === 0 ? 3 : 0;
      } else if (state.pqState === 3) {
        state.pqState = 0;
        if (state.p === null) {
          state.p = state.num;
        } else {
          state.q = state.num;
        }
        if (state.p !== null && state.q !== null) {
          ++state.state;
        }
        state.num = null;
      }
    } else if (state.state === 1) {
      if (state.p.compareTo(state.q) < 0) {
        state.num = state.p;
        state.p = state.q;
        state.q = state.num;
      }
      ++state.state;
    } else if (state.state === 2) {
      state.p1 = state.p.subtract(BigInteger$3.ONE);
      state.q1 = state.q.subtract(BigInteger$3.ONE);
      state.phi = state.p1.multiply(state.q1);
      ++state.state;
    } else if (state.state === 3) {
      if (state.phi.gcd(state.e).compareTo(BigInteger$3.ONE) === 0) {
        ++state.state;
      } else {
        state.p = null;
        state.q = null;
        state.state = 0;
      }
    } else if (state.state === 4) {
      state.n = state.p.multiply(state.q);
      if (state.n.bitLength() === state.bits) {
        ++state.state;
      } else {
        state.q = null;
        state.state = 0;
      }
    } else if (state.state === 5) {
      var d = state.e.modInverse(state.phi);
      state.keys = {
        privateKey: pki$4.rsa.setPrivateKey(state.n, state.e, d, state.p, state.q, d.mod(state.p1), d.mod(state.q1), state.q.modInverse(state.p)),
        publicKey: pki$4.rsa.setPublicKey(state.n, state.e)
      };
    }
    t2 = +new Date();
    total += t2 - t1;
    t1 = t2;
  }
  return state.keys !== null;
};
pki$4.rsa.generateKeyPair = function(bits, e, options, callback) {
  if (arguments.length === 1) {
    if (typeof bits === "object") {
      options = bits;
      bits = void 0;
    } else if (typeof bits === "function") {
      callback = bits;
      bits = void 0;
    }
  } else if (arguments.length === 2) {
    if (typeof bits === "number") {
      if (typeof e === "function") {
        callback = e;
        e = void 0;
      } else if (typeof e !== "number") {
        options = e;
        e = void 0;
      }
    } else {
      options = bits;
      callback = e;
      bits = void 0;
      e = void 0;
    }
  } else if (arguments.length === 3) {
    if (typeof e === "number") {
      if (typeof options === "function") {
        callback = options;
        options = void 0;
      }
    } else {
      callback = options;
      options = e;
      e = void 0;
    }
  }
  options = options || {};
  if (bits === void 0) {
    bits = options.bits || 2048;
  }
  if (e === void 0) {
    e = options.e || 65537;
  }
  if (!options.prng && bits >= 256 && bits <= 16384 && (e === 65537 || e === 3)) {
    if (callback) {
      if (_detectNodeCrypto("generateKeyPair")) {
        return _crypto.generateKeyPair("rsa", {
          modulusLength: bits,
          publicExponent: e,
          publicKeyEncoding: {
            type: "spki",
            format: "pem"
          },
          privateKeyEncoding: {
            type: "pkcs8",
            format: "pem"
          }
        }, function(err2, pub, priv) {
          if (err2) {
            return callback(err2);
          }
          callback(null, {
            privateKey: pki$4.privateKeyFromPem(priv),
            publicKey: pki$4.publicKeyFromPem(pub)
          });
        });
      }
      if (_detectSubtleCrypto("generateKey") && _detectSubtleCrypto("exportKey")) {
        return util$1.globalScope.crypto.subtle.generateKey({
          name: "RSASSA-PKCS1-v1_5",
          modulusLength: bits,
          publicExponent: _intToUint8Array(e),
          hash: { name: "SHA-256" }
        }, true, ["sign", "verify"]).then(function(pair) {
          return util$1.globalScope.crypto.subtle.exportKey("pkcs8", pair.privateKey);
        }).then(void 0, function(err2) {
          callback(err2);
        }).then(function(pkcs8) {
          if (pkcs8) {
            var privateKey = pki$4.privateKeyFromAsn1(asn1$7.fromDer(forge$h.util.createBuffer(pkcs8)));
            callback(null, {
              privateKey,
              publicKey: pki$4.setRsaPublicKey(privateKey.n, privateKey.e)
            });
          }
        });
      }
      if (_detectSubtleMsCrypto("generateKey") && _detectSubtleMsCrypto("exportKey")) {
        var genOp = util$1.globalScope.msCrypto.subtle.generateKey({
          name: "RSASSA-PKCS1-v1_5",
          modulusLength: bits,
          publicExponent: _intToUint8Array(e),
          hash: { name: "SHA-256" }
        }, true, ["sign", "verify"]);
        genOp.oncomplete = function(e2) {
          var pair = e2.target.result;
          var exportOp = util$1.globalScope.msCrypto.subtle.exportKey("pkcs8", pair.privateKey);
          exportOp.oncomplete = function(e3) {
            var pkcs8 = e3.target.result;
            var privateKey = pki$4.privateKeyFromAsn1(asn1$7.fromDer(forge$h.util.createBuffer(pkcs8)));
            callback(null, {
              privateKey,
              publicKey: pki$4.setRsaPublicKey(privateKey.n, privateKey.e)
            });
          };
          exportOp.onerror = function(err2) {
            callback(err2);
          };
        };
        genOp.onerror = function(err2) {
          callback(err2);
        };
        return;
      }
    } else {
      if (_detectNodeCrypto("generateKeyPairSync")) {
        var keypair = _crypto.generateKeyPairSync("rsa", {
          modulusLength: bits,
          publicExponent: e,
          publicKeyEncoding: {
            type: "spki",
            format: "pem"
          },
          privateKeyEncoding: {
            type: "pkcs8",
            format: "pem"
          }
        });
        return {
          privateKey: pki$4.privateKeyFromPem(keypair.privateKey),
          publicKey: pki$4.publicKeyFromPem(keypair.publicKey)
        };
      }
    }
  }
  var state = pki$4.rsa.createKeyPairGenerationState(bits, e, options);
  if (!callback) {
    pki$4.rsa.stepKeyPairGenerationState(state, 0);
    return state.keys;
  }
  _generateKeyPair(state, options, callback);
};
pki$4.setRsaPublicKey = pki$4.rsa.setPublicKey = function(n, e) {
  var key = {
    n,
    e
  };
  key.encrypt = function(data, scheme, schemeOptions) {
    if (typeof scheme === "string") {
      scheme = scheme.toUpperCase();
    } else if (scheme === void 0) {
      scheme = "RSAES-PKCS1-V1_5";
    }
    if (scheme === "RSAES-PKCS1-V1_5") {
      scheme = {
        encode: function(m, key2, pub) {
          return _encodePkcs1_v1_5(m, key2, 2).getBytes();
        }
      };
    } else if (scheme === "RSA-OAEP" || scheme === "RSAES-OAEP") {
      scheme = {
        encode: function(m, key2) {
          return forge$h.pkcs1.encode_rsa_oaep(key2, m, schemeOptions);
        }
      };
    } else if (["RAW", "NONE", "NULL", null].indexOf(scheme) !== -1) {
      scheme = { encode: function(e3) {
        return e3;
      } };
    } else if (typeof scheme === "string") {
      throw new Error('Unsupported encryption scheme: "' + scheme + '".');
    }
    var e2 = scheme.encode(data, key, true);
    return pki$4.rsa.encrypt(e2, key, true);
  };
  key.verify = function(digest, signature, scheme) {
    if (typeof scheme === "string") {
      scheme = scheme.toUpperCase();
    } else if (scheme === void 0) {
      scheme = "RSASSA-PKCS1-V1_5";
    }
    if (scheme === "RSASSA-PKCS1-V1_5") {
      scheme = {
        verify: function(digest2, d2) {
          d2 = _decodePkcs1_v1_5(d2, key, true);
          var obj = asn1$7.fromDer(d2);
          return digest2 === obj.value[1].value;
        }
      };
    } else if (scheme === "NONE" || scheme === "NULL" || scheme === null) {
      scheme = {
        verify: function(digest2, d2) {
          d2 = _decodePkcs1_v1_5(d2, key, true);
          return digest2 === d2;
        }
      };
    }
    var d = pki$4.rsa.decrypt(signature, key, true, false);
    return scheme.verify(digest, d, key.n.bitLength());
  };
  return key;
};
pki$4.setRsaPrivateKey = pki$4.rsa.setPrivateKey = function(n, e, d, p, q, dP, dQ, qInv) {
  var key = {
    n,
    e,
    d,
    p,
    q,
    dP,
    dQ,
    qInv
  };
  key.decrypt = function(data, scheme, schemeOptions) {
    if (typeof scheme === "string") {
      scheme = scheme.toUpperCase();
    } else if (scheme === void 0) {
      scheme = "RSAES-PKCS1-V1_5";
    }
    var d2 = pki$4.rsa.decrypt(data, key, false, false);
    if (scheme === "RSAES-PKCS1-V1_5") {
      scheme = { decode: _decodePkcs1_v1_5 };
    } else if (scheme === "RSA-OAEP" || scheme === "RSAES-OAEP") {
      scheme = {
        decode: function(d3, key2) {
          return forge$h.pkcs1.decode_rsa_oaep(key2, d3, schemeOptions);
        }
      };
    } else if (["RAW", "NONE", "NULL", null].indexOf(scheme) !== -1) {
      scheme = { decode: function(d3) {
        return d3;
      } };
    } else {
      throw new Error('Unsupported encryption scheme: "' + scheme + '".');
    }
    return scheme.decode(d2, key, false);
  };
  key.sign = function(md, scheme) {
    var bt = false;
    if (typeof scheme === "string") {
      scheme = scheme.toUpperCase();
    }
    if (scheme === void 0 || scheme === "RSASSA-PKCS1-V1_5") {
      scheme = { encode: emsaPkcs1v15encode };
      bt = 1;
    } else if (scheme === "NONE" || scheme === "NULL" || scheme === null) {
      scheme = { encode: function() {
        return md;
      } };
      bt = 1;
    }
    var d2 = scheme.encode(md, key.n.bitLength());
    return pki$4.rsa.encrypt(d2, key, bt);
  };
  return key;
};
pki$4.wrapRsaPrivateKey = function(rsaKey) {
  return asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.SEQUENCE, true, [
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.INTEGER, false, asn1$7.integerToDer(0).getBytes()),
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.SEQUENCE, true, [
      asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.OID, false, asn1$7.oidToDer(pki$4.oids.rsaEncryption).getBytes()),
      asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.NULL, false, "")
    ]),
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.OCTETSTRING, false, asn1$7.toDer(rsaKey).getBytes())
  ]);
};
pki$4.privateKeyFromAsn1 = function(obj) {
  var capture = {};
  var errors = [];
  if (asn1$7.validate(obj, privateKeyValidator$1, capture, errors)) {
    obj = asn1$7.fromDer(forge$h.util.createBuffer(capture.privateKey));
  }
  capture = {};
  errors = [];
  if (!asn1$7.validate(obj, rsaPrivateKeyValidator, capture, errors)) {
    var error = new Error("Cannot read private key. ASN.1 object does not contain an RSAPrivateKey.");
    error.errors = errors;
    throw error;
  }
  var n, e, d, p, q, dP, dQ, qInv;
  n = forge$h.util.createBuffer(capture.privateKeyModulus).toHex();
  e = forge$h.util.createBuffer(capture.privateKeyPublicExponent).toHex();
  d = forge$h.util.createBuffer(capture.privateKeyPrivateExponent).toHex();
  p = forge$h.util.createBuffer(capture.privateKeyPrime1).toHex();
  q = forge$h.util.createBuffer(capture.privateKeyPrime2).toHex();
  dP = forge$h.util.createBuffer(capture.privateKeyExponent1).toHex();
  dQ = forge$h.util.createBuffer(capture.privateKeyExponent2).toHex();
  qInv = forge$h.util.createBuffer(capture.privateKeyCoefficient).toHex();
  return pki$4.setRsaPrivateKey(new BigInteger$3(n, 16), new BigInteger$3(e, 16), new BigInteger$3(d, 16), new BigInteger$3(p, 16), new BigInteger$3(q, 16), new BigInteger$3(dP, 16), new BigInteger$3(dQ, 16), new BigInteger$3(qInv, 16));
};
pki$4.privateKeyToAsn1 = pki$4.privateKeyToRSAPrivateKey = function(key) {
  return asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.SEQUENCE, true, [
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.INTEGER, false, asn1$7.integerToDer(0).getBytes()),
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.INTEGER, false, _bnToBytes(key.n)),
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.INTEGER, false, _bnToBytes(key.e)),
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.INTEGER, false, _bnToBytes(key.d)),
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.INTEGER, false, _bnToBytes(key.p)),
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.INTEGER, false, _bnToBytes(key.q)),
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.INTEGER, false, _bnToBytes(key.dP)),
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.INTEGER, false, _bnToBytes(key.dQ)),
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.INTEGER, false, _bnToBytes(key.qInv))
  ]);
};
pki$4.publicKeyFromAsn1 = function(obj) {
  var capture = {};
  var errors = [];
  if (asn1$7.validate(obj, publicKeyValidator$2, capture, errors)) {
    var oid = asn1$7.derToOid(capture.publicKeyOid);
    if (oid !== pki$4.oids.rsaEncryption) {
      var error = new Error("Cannot read public key. Unknown OID.");
      error.oid = oid;
      throw error;
    }
    obj = capture.rsaPublicKey;
  }
  errors = [];
  if (!asn1$7.validate(obj, rsaPublicKeyValidator, capture, errors)) {
    var error = new Error("Cannot read public key. ASN.1 object does not contain an RSAPublicKey.");
    error.errors = errors;
    throw error;
  }
  var n = forge$h.util.createBuffer(capture.publicKeyModulus).toHex();
  var e = forge$h.util.createBuffer(capture.publicKeyExponent).toHex();
  return pki$4.setRsaPublicKey(new BigInteger$3(n, 16), new BigInteger$3(e, 16));
};
pki$4.publicKeyToAsn1 = pki$4.publicKeyToSubjectPublicKeyInfo = function(key) {
  return asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.SEQUENCE, true, [
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.SEQUENCE, true, [
      asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.OID, false, asn1$7.oidToDer(pki$4.oids.rsaEncryption).getBytes()),
      asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.NULL, false, "")
    ]),
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.BITSTRING, false, [
      pki$4.publicKeyToRSAPublicKey(key)
    ])
  ]);
};
pki$4.publicKeyToRSAPublicKey = function(key) {
  return asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.SEQUENCE, true, [
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.INTEGER, false, _bnToBytes(key.n)),
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.INTEGER, false, _bnToBytes(key.e))
  ]);
};
function _encodePkcs1_v1_5(m, key, bt) {
  var eb = forge$h.util.createBuffer();
  var k = Math.ceil(key.n.bitLength() / 8);
  if (m.length > k - 11) {
    var error = new Error("Message is too long for PKCS#1 v1.5 padding.");
    error.length = m.length;
    error.max = k - 11;
    throw error;
  }
  eb.putByte(0);
  eb.putByte(bt);
  var padNum = k - 3 - m.length;
  var padByte;
  if (bt === 0 || bt === 1) {
    padByte = bt === 0 ? 0 : 255;
    for (var i2 = 0; i2 < padNum; ++i2) {
      eb.putByte(padByte);
    }
  } else {
    while (padNum > 0) {
      var numZeros = 0;
      var padBytes = forge$h.random.getBytes(padNum);
      for (var i2 = 0; i2 < padNum; ++i2) {
        padByte = padBytes.charCodeAt(i2);
        if (padByte === 0) {
          ++numZeros;
        } else {
          eb.putByte(padByte);
        }
      }
      padNum = numZeros;
    }
  }
  eb.putByte(0);
  eb.putBytes(m);
  return eb;
}
function _decodePkcs1_v1_5(em, key, pub, ml) {
  var k = Math.ceil(key.n.bitLength() / 8);
  var eb = forge$h.util.createBuffer(em);
  var first = eb.getByte();
  var bt = eb.getByte();
  if (first !== 0 || pub && bt !== 0 && bt !== 1 || !pub && bt != 2 || pub && bt === 0 && typeof ml === "undefined") {
    throw new Error("Encryption block is invalid.");
  }
  var padNum = 0;
  if (bt === 0) {
    padNum = k - 3 - ml;
    for (var i2 = 0; i2 < padNum; ++i2) {
      if (eb.getByte() !== 0) {
        throw new Error("Encryption block is invalid.");
      }
    }
  } else if (bt === 1) {
    padNum = 0;
    while (eb.length() > 1) {
      if (eb.getByte() !== 255) {
        --eb.read;
        break;
      }
      ++padNum;
    }
  } else if (bt === 2) {
    padNum = 0;
    while (eb.length() > 1) {
      if (eb.getByte() === 0) {
        --eb.read;
        break;
      }
      ++padNum;
    }
  }
  var zero = eb.getByte();
  if (zero !== 0 || padNum !== k - 3 - eb.length()) {
    throw new Error("Encryption block is invalid.");
  }
  return eb.getBytes();
}
function _generateKeyPair(state, options, callback) {
  if (typeof options === "function") {
    callback = options;
    options = {};
  }
  options = options || {};
  var opts = {
    algorithm: {
      name: options.algorithm || "PRIMEINC",
      options: {
        workers: options.workers || 2,
        workLoad: options.workLoad || 100,
        workerScript: options.workerScript
      }
    }
  };
  if ("prng" in options) {
    opts.prng = options.prng;
  }
  generate();
  function generate() {
    getPrime(state.pBits, function(err2, num) {
      if (err2) {
        return callback(err2);
      }
      state.p = num;
      if (state.q !== null) {
        return finish3(err2, state.q);
      }
      getPrime(state.qBits, finish3);
    });
  }
  function getPrime(bits, callback2) {
    forge$h.prime.generateProbablePrime(bits, opts, callback2);
  }
  function finish3(err2, num) {
    if (err2) {
      return callback(err2);
    }
    state.q = num;
    if (state.p.compareTo(state.q) < 0) {
      var tmp = state.p;
      state.p = state.q;
      state.q = tmp;
    }
    if (state.p.subtract(BigInteger$3.ONE).gcd(state.e).compareTo(BigInteger$3.ONE) !== 0) {
      state.p = null;
      generate();
      return;
    }
    if (state.q.subtract(BigInteger$3.ONE).gcd(state.e).compareTo(BigInteger$3.ONE) !== 0) {
      state.q = null;
      getPrime(state.qBits, finish3);
      return;
    }
    state.p1 = state.p.subtract(BigInteger$3.ONE);
    state.q1 = state.q.subtract(BigInteger$3.ONE);
    state.phi = state.p1.multiply(state.q1);
    if (state.phi.gcd(state.e).compareTo(BigInteger$3.ONE) !== 0) {
      state.p = state.q = null;
      generate();
      return;
    }
    state.n = state.p.multiply(state.q);
    if (state.n.bitLength() !== state.bits) {
      state.q = null;
      getPrime(state.qBits, finish3);
      return;
    }
    var d = state.e.modInverse(state.phi);
    state.keys = {
      privateKey: pki$4.rsa.setPrivateKey(state.n, state.e, d, state.p, state.q, d.mod(state.p1), d.mod(state.q1), state.q.modInverse(state.p)),
      publicKey: pki$4.rsa.setPublicKey(state.n, state.e)
    };
    callback(null, state.keys);
  }
}
function _bnToBytes(b) {
  var hex = b.toString(16);
  if (hex[0] >= "8") {
    hex = "00" + hex;
  }
  var bytes = forge$h.util.hexToBytes(hex);
  if (bytes.length > 1 && (bytes.charCodeAt(0) === 0 && (bytes.charCodeAt(1) & 128) === 0 || bytes.charCodeAt(0) === 255 && (bytes.charCodeAt(1) & 128) === 128)) {
    return bytes.substr(1);
  }
  return bytes;
}
function _getMillerRabinTests(bits) {
  if (bits <= 100)
    return 27;
  if (bits <= 150)
    return 18;
  if (bits <= 200)
    return 15;
  if (bits <= 250)
    return 12;
  if (bits <= 300)
    return 9;
  if (bits <= 350)
    return 8;
  if (bits <= 400)
    return 7;
  if (bits <= 500)
    return 6;
  if (bits <= 600)
    return 5;
  if (bits <= 800)
    return 4;
  if (bits <= 1250)
    return 3;
  return 2;
}
function _detectNodeCrypto(fn) {
  return forge$h.util.isNodejs && typeof _crypto[fn] === "function";
}
function _detectSubtleCrypto(fn) {
  return typeof util$1.globalScope !== "undefined" && typeof util$1.globalScope.crypto === "object" && typeof util$1.globalScope.crypto.subtle === "object" && typeof util$1.globalScope.crypto.subtle[fn] === "function";
}
function _detectSubtleMsCrypto(fn) {
  return typeof util$1.globalScope !== "undefined" && typeof util$1.globalScope.msCrypto === "object" && typeof util$1.globalScope.msCrypto.subtle === "object" && typeof util$1.globalScope.msCrypto.subtle[fn] === "function";
}
function _intToUint8Array(x2) {
  var bytes = forge$h.util.hexToBytes(x2.toString(16));
  var buffer = new Uint8Array(bytes.length);
  for (var i2 = 0; i2 < bytes.length; ++i2) {
    buffer[i2] = bytes.charCodeAt(i2);
  }
  return buffer;
}
var forge$g = forge$C;
if (typeof BigInteger$2 === "undefined") {
  var BigInteger$2 = forge$g.jsbn.BigInteger;
}
var asn1$6 = forge$g.asn1;
var pki$3 = forge$g.pki = forge$g.pki || {};
pki$3.pbe = forge$g.pbe = forge$g.pbe || {};
var oids$1 = pki$3.oids;
var encryptedPrivateKeyValidator = {
  name: "EncryptedPrivateKeyInfo",
  tagClass: asn1$6.Class.UNIVERSAL,
  type: asn1$6.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "EncryptedPrivateKeyInfo.encryptionAlgorithm",
    tagClass: asn1$6.Class.UNIVERSAL,
    type: asn1$6.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: "AlgorithmIdentifier.algorithm",
      tagClass: asn1$6.Class.UNIVERSAL,
      type: asn1$6.Type.OID,
      constructed: false,
      capture: "encryptionOid"
    }, {
      name: "AlgorithmIdentifier.parameters",
      tagClass: asn1$6.Class.UNIVERSAL,
      type: asn1$6.Type.SEQUENCE,
      constructed: true,
      captureAsn1: "encryptionParams"
    }]
  }, {
    name: "EncryptedPrivateKeyInfo.encryptedData",
    tagClass: asn1$6.Class.UNIVERSAL,
    type: asn1$6.Type.OCTETSTRING,
    constructed: false,
    capture: "encryptedData"
  }]
};
var PBES2AlgorithmsValidator = {
  name: "PBES2Algorithms",
  tagClass: asn1$6.Class.UNIVERSAL,
  type: asn1$6.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "PBES2Algorithms.keyDerivationFunc",
    tagClass: asn1$6.Class.UNIVERSAL,
    type: asn1$6.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: "PBES2Algorithms.keyDerivationFunc.oid",
      tagClass: asn1$6.Class.UNIVERSAL,
      type: asn1$6.Type.OID,
      constructed: false,
      capture: "kdfOid"
    }, {
      name: "PBES2Algorithms.params",
      tagClass: asn1$6.Class.UNIVERSAL,
      type: asn1$6.Type.SEQUENCE,
      constructed: true,
      value: [{
        name: "PBES2Algorithms.params.salt",
        tagClass: asn1$6.Class.UNIVERSAL,
        type: asn1$6.Type.OCTETSTRING,
        constructed: false,
        capture: "kdfSalt"
      }, {
        name: "PBES2Algorithms.params.iterationCount",
        tagClass: asn1$6.Class.UNIVERSAL,
        type: asn1$6.Type.INTEGER,
        constructed: false,
        capture: "kdfIterationCount"
      }, {
        name: "PBES2Algorithms.params.keyLength",
        tagClass: asn1$6.Class.UNIVERSAL,
        type: asn1$6.Type.INTEGER,
        constructed: false,
        optional: true,
        capture: "keyLength"
      }, {
        name: "PBES2Algorithms.params.prf",
        tagClass: asn1$6.Class.UNIVERSAL,
        type: asn1$6.Type.SEQUENCE,
        constructed: true,
        optional: true,
        value: [{
          name: "PBES2Algorithms.params.prf.algorithm",
          tagClass: asn1$6.Class.UNIVERSAL,
          type: asn1$6.Type.OID,
          constructed: false,
          capture: "prfOid"
        }]
      }]
    }]
  }, {
    name: "PBES2Algorithms.encryptionScheme",
    tagClass: asn1$6.Class.UNIVERSAL,
    type: asn1$6.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: "PBES2Algorithms.encryptionScheme.oid",
      tagClass: asn1$6.Class.UNIVERSAL,
      type: asn1$6.Type.OID,
      constructed: false,
      capture: "encOid"
    }, {
      name: "PBES2Algorithms.encryptionScheme.iv",
      tagClass: asn1$6.Class.UNIVERSAL,
      type: asn1$6.Type.OCTETSTRING,
      constructed: false,
      capture: "encIv"
    }]
  }]
};
var pkcs12PbeParamsValidator = {
  name: "pkcs-12PbeParams",
  tagClass: asn1$6.Class.UNIVERSAL,
  type: asn1$6.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "pkcs-12PbeParams.salt",
    tagClass: asn1$6.Class.UNIVERSAL,
    type: asn1$6.Type.OCTETSTRING,
    constructed: false,
    capture: "salt"
  }, {
    name: "pkcs-12PbeParams.iterations",
    tagClass: asn1$6.Class.UNIVERSAL,
    type: asn1$6.Type.INTEGER,
    constructed: false,
    capture: "iterations"
  }]
};
pki$3.encryptPrivateKeyInfo = function(obj, password, options) {
  options = options || {};
  options.saltSize = options.saltSize || 8;
  options.count = options.count || 2048;
  options.algorithm = options.algorithm || "aes128";
  options.prfAlgorithm = options.prfAlgorithm || "sha1";
  var salt = forge$g.random.getBytesSync(options.saltSize);
  var count = options.count;
  var countBytes = asn1$6.integerToDer(count);
  var dkLen;
  var encryptionAlgorithm;
  var encryptedData;
  if (options.algorithm.indexOf("aes") === 0 || options.algorithm === "des") {
    var ivLen, encOid, cipherFn;
    switch (options.algorithm) {
      case "aes128":
        dkLen = 16;
        ivLen = 16;
        encOid = oids$1["aes128-CBC"];
        cipherFn = forge$g.aes.createEncryptionCipher;
        break;
      case "aes192":
        dkLen = 24;
        ivLen = 16;
        encOid = oids$1["aes192-CBC"];
        cipherFn = forge$g.aes.createEncryptionCipher;
        break;
      case "aes256":
        dkLen = 32;
        ivLen = 16;
        encOid = oids$1["aes256-CBC"];
        cipherFn = forge$g.aes.createEncryptionCipher;
        break;
      case "des":
        dkLen = 8;
        ivLen = 8;
        encOid = oids$1["desCBC"];
        cipherFn = forge$g.des.createEncryptionCipher;
        break;
      default:
        var error = new Error("Cannot encrypt private key. Unknown encryption algorithm.");
        error.algorithm = options.algorithm;
        throw error;
    }
    var prfAlgorithm = "hmacWith" + options.prfAlgorithm.toUpperCase();
    var md = prfAlgorithmToMessageDigest(prfAlgorithm);
    var dk = forge$g.pkcs5.pbkdf2(password, salt, count, dkLen, md);
    var iv = forge$g.random.getBytesSync(ivLen);
    var cipher = cipherFn(dk);
    cipher.start(iv);
    cipher.update(asn1$6.toDer(obj));
    cipher.finish();
    encryptedData = cipher.output.getBytes();
    var params = createPbkdf2Params(salt, countBytes, dkLen, prfAlgorithm);
    encryptionAlgorithm = asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.SEQUENCE, true, [
      asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.OID, false, asn1$6.oidToDer(oids$1["pkcs5PBES2"]).getBytes()),
      asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.SEQUENCE, true, [
        asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.SEQUENCE, true, [
          asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.OID, false, asn1$6.oidToDer(oids$1["pkcs5PBKDF2"]).getBytes()),
          params
        ]),
        asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.SEQUENCE, true, [
          asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.OID, false, asn1$6.oidToDer(encOid).getBytes()),
          asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.OCTETSTRING, false, iv)
        ])
      ])
    ]);
  } else if (options.algorithm === "3des") {
    dkLen = 24;
    var saltBytes = new forge$g.util.ByteBuffer(salt);
    var dk = pki$3.pbe.generatePkcs12Key(password, saltBytes, 1, count, dkLen);
    var iv = pki$3.pbe.generatePkcs12Key(password, saltBytes, 2, count, dkLen);
    var cipher = forge$g.des.createEncryptionCipher(dk);
    cipher.start(iv);
    cipher.update(asn1$6.toDer(obj));
    cipher.finish();
    encryptedData = cipher.output.getBytes();
    encryptionAlgorithm = asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.SEQUENCE, true, [
      asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.OID, false, asn1$6.oidToDer(oids$1["pbeWithSHAAnd3-KeyTripleDES-CBC"]).getBytes()),
      asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.SEQUENCE, true, [
        asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.OCTETSTRING, false, salt),
        asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.INTEGER, false, countBytes.getBytes())
      ])
    ]);
  } else {
    var error = new Error("Cannot encrypt private key. Unknown encryption algorithm.");
    error.algorithm = options.algorithm;
    throw error;
  }
  var rval = asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.SEQUENCE, true, [
    encryptionAlgorithm,
    asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.OCTETSTRING, false, encryptedData)
  ]);
  return rval;
};
pki$3.decryptPrivateKeyInfo = function(obj, password) {
  var rval = null;
  var capture = {};
  var errors = [];
  if (!asn1$6.validate(obj, encryptedPrivateKeyValidator, capture, errors)) {
    var error = new Error("Cannot read encrypted private key. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
    error.errors = errors;
    throw error;
  }
  var oid = asn1$6.derToOid(capture.encryptionOid);
  var cipher = pki$3.pbe.getCipher(oid, capture.encryptionParams, password);
  var encrypted = forge$g.util.createBuffer(capture.encryptedData);
  cipher.update(encrypted);
  if (cipher.finish()) {
    rval = asn1$6.fromDer(cipher.output);
  }
  return rval;
};
pki$3.encryptedPrivateKeyToPem = function(epki, maxline) {
  var msg = {
    type: "ENCRYPTED PRIVATE KEY",
    body: asn1$6.toDer(epki).getBytes()
  };
  return forge$g.pem.encode(msg, { maxline });
};
pki$3.encryptedPrivateKeyFromPem = function(pem2) {
  var msg = forge$g.pem.decode(pem2)[0];
  if (msg.type !== "ENCRYPTED PRIVATE KEY") {
    var error = new Error('Could not convert encrypted private key from PEM; PEM header type is "ENCRYPTED PRIVATE KEY".');
    error.headerType = msg.type;
    throw error;
  }
  if (msg.procType && msg.procType.type === "ENCRYPTED") {
    throw new Error("Could not convert encrypted private key from PEM; PEM is encrypted.");
  }
  return asn1$6.fromDer(msg.body);
};
pki$3.encryptRsaPrivateKey = function(rsaKey, password, options) {
  options = options || {};
  if (!options.legacy) {
    var rval = pki$3.wrapRsaPrivateKey(pki$3.privateKeyToAsn1(rsaKey));
    rval = pki$3.encryptPrivateKeyInfo(rval, password, options);
    return pki$3.encryptedPrivateKeyToPem(rval);
  }
  var algorithm;
  var iv;
  var dkLen;
  var cipherFn;
  switch (options.algorithm) {
    case "aes128":
      algorithm = "AES-128-CBC";
      dkLen = 16;
      iv = forge$g.random.getBytesSync(16);
      cipherFn = forge$g.aes.createEncryptionCipher;
      break;
    case "aes192":
      algorithm = "AES-192-CBC";
      dkLen = 24;
      iv = forge$g.random.getBytesSync(16);
      cipherFn = forge$g.aes.createEncryptionCipher;
      break;
    case "aes256":
      algorithm = "AES-256-CBC";
      dkLen = 32;
      iv = forge$g.random.getBytesSync(16);
      cipherFn = forge$g.aes.createEncryptionCipher;
      break;
    case "3des":
      algorithm = "DES-EDE3-CBC";
      dkLen = 24;
      iv = forge$g.random.getBytesSync(8);
      cipherFn = forge$g.des.createEncryptionCipher;
      break;
    case "des":
      algorithm = "DES-CBC";
      dkLen = 8;
      iv = forge$g.random.getBytesSync(8);
      cipherFn = forge$g.des.createEncryptionCipher;
      break;
    default:
      var error = new Error('Could not encrypt RSA private key; unsupported encryption algorithm "' + options.algorithm + '".');
      error.algorithm = options.algorithm;
      throw error;
  }
  var dk = forge$g.pbe.opensslDeriveBytes(password, iv.substr(0, 8), dkLen);
  var cipher = cipherFn(dk);
  cipher.start(iv);
  cipher.update(asn1$6.toDer(pki$3.privateKeyToAsn1(rsaKey)));
  cipher.finish();
  var msg = {
    type: "RSA PRIVATE KEY",
    procType: {
      version: "4",
      type: "ENCRYPTED"
    },
    dekInfo: {
      algorithm,
      parameters: forge$g.util.bytesToHex(iv).toUpperCase()
    },
    body: cipher.output.getBytes()
  };
  return forge$g.pem.encode(msg);
};
pki$3.decryptRsaPrivateKey = function(pem2, password) {
  var rval = null;
  var msg = forge$g.pem.decode(pem2)[0];
  if (msg.type !== "ENCRYPTED PRIVATE KEY" && msg.type !== "PRIVATE KEY" && msg.type !== "RSA PRIVATE KEY") {
    var error = new Error('Could not convert private key from PEM; PEM header type is not "ENCRYPTED PRIVATE KEY", "PRIVATE KEY", or "RSA PRIVATE KEY".');
    error.headerType = error;
    throw error;
  }
  if (msg.procType && msg.procType.type === "ENCRYPTED") {
    var dkLen;
    var cipherFn;
    switch (msg.dekInfo.algorithm) {
      case "DES-CBC":
        dkLen = 8;
        cipherFn = forge$g.des.createDecryptionCipher;
        break;
      case "DES-EDE3-CBC":
        dkLen = 24;
        cipherFn = forge$g.des.createDecryptionCipher;
        break;
      case "AES-128-CBC":
        dkLen = 16;
        cipherFn = forge$g.aes.createDecryptionCipher;
        break;
      case "AES-192-CBC":
        dkLen = 24;
        cipherFn = forge$g.aes.createDecryptionCipher;
        break;
      case "AES-256-CBC":
        dkLen = 32;
        cipherFn = forge$g.aes.createDecryptionCipher;
        break;
      case "RC2-40-CBC":
        dkLen = 5;
        cipherFn = function(key) {
          return forge$g.rc2.createDecryptionCipher(key, 40);
        };
        break;
      case "RC2-64-CBC":
        dkLen = 8;
        cipherFn = function(key) {
          return forge$g.rc2.createDecryptionCipher(key, 64);
        };
        break;
      case "RC2-128-CBC":
        dkLen = 16;
        cipherFn = function(key) {
          return forge$g.rc2.createDecryptionCipher(key, 128);
        };
        break;
      default:
        var error = new Error('Could not decrypt private key; unsupported encryption algorithm "' + msg.dekInfo.algorithm + '".');
        error.algorithm = msg.dekInfo.algorithm;
        throw error;
    }
    var iv = forge$g.util.hexToBytes(msg.dekInfo.parameters);
    var dk = forge$g.pbe.opensslDeriveBytes(password, iv.substr(0, 8), dkLen);
    var cipher = cipherFn(dk);
    cipher.start(iv);
    cipher.update(forge$g.util.createBuffer(msg.body));
    if (cipher.finish()) {
      rval = cipher.output.getBytes();
    } else {
      return rval;
    }
  } else {
    rval = msg.body;
  }
  if (msg.type === "ENCRYPTED PRIVATE KEY") {
    rval = pki$3.decryptPrivateKeyInfo(asn1$6.fromDer(rval), password);
  } else {
    rval = asn1$6.fromDer(rval);
  }
  if (rval !== null) {
    rval = pki$3.privateKeyFromAsn1(rval);
  }
  return rval;
};
pki$3.pbe.generatePkcs12Key = function(password, salt, id, iter, n, md) {
  var j, l;
  if (typeof md === "undefined" || md === null) {
    if (!("sha1" in forge$g.md)) {
      throw new Error('"sha1" hash algorithm unavailable.');
    }
    md = forge$g.md.sha1.create();
  }
  var u = md.digestLength;
  var v2 = md.blockLength;
  var result2 = new forge$g.util.ByteBuffer();
  var passBuf = new forge$g.util.ByteBuffer();
  if (password !== null && password !== void 0) {
    for (l = 0; l < password.length; l++) {
      passBuf.putInt16(password.charCodeAt(l));
    }
    passBuf.putInt16(0);
  }
  var p = passBuf.length();
  var s2 = salt.length();
  var D3 = new forge$g.util.ByteBuffer();
  D3.fillWithByte(id, v2);
  var Slen = v2 * Math.ceil(s2 / v2);
  var S2 = new forge$g.util.ByteBuffer();
  for (l = 0; l < Slen; l++) {
    S2.putByte(salt.at(l % s2));
  }
  var Plen = v2 * Math.ceil(p / v2);
  var P = new forge$g.util.ByteBuffer();
  for (l = 0; l < Plen; l++) {
    P.putByte(passBuf.at(l % p));
  }
  var I2 = S2;
  I2.putBuffer(P);
  var c = Math.ceil(n / u);
  for (var i2 = 1; i2 <= c; i2++) {
    var buf = new forge$g.util.ByteBuffer();
    buf.putBytes(D3.bytes());
    buf.putBytes(I2.bytes());
    for (var round2 = 0; round2 < iter; round2++) {
      md.start();
      md.update(buf.getBytes());
      buf = md.digest();
    }
    var B2 = new forge$g.util.ByteBuffer();
    for (l = 0; l < v2; l++) {
      B2.putByte(buf.at(l % u));
    }
    var k = Math.ceil(s2 / v2) + Math.ceil(p / v2);
    var Inew = new forge$g.util.ByteBuffer();
    for (j = 0; j < k; j++) {
      var chunk = new forge$g.util.ByteBuffer(I2.getBytes(v2));
      var x2 = 511;
      for (l = B2.length() - 1; l >= 0; l--) {
        x2 = x2 >> 8;
        x2 += B2.at(l) + chunk.at(l);
        chunk.setAt(l, x2 & 255);
      }
      Inew.putBuffer(chunk);
    }
    I2 = Inew;
    result2.putBuffer(buf);
  }
  result2.truncate(result2.length() - n);
  return result2;
};
pki$3.pbe.getCipher = function(oid, params, password) {
  switch (oid) {
    case pki$3.oids["pkcs5PBES2"]:
      return pki$3.pbe.getCipherForPBES2(oid, params, password);
    case pki$3.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
    case pki$3.oids["pbewithSHAAnd40BitRC2-CBC"]:
      return pki$3.pbe.getCipherForPKCS12PBE(oid, params, password);
    default:
      var error = new Error("Cannot read encrypted PBE data block. Unsupported OID.");
      error.oid = oid;
      error.supportedOids = [
        "pkcs5PBES2",
        "pbeWithSHAAnd3-KeyTripleDES-CBC",
        "pbewithSHAAnd40BitRC2-CBC"
      ];
      throw error;
  }
};
pki$3.pbe.getCipherForPBES2 = function(oid, params, password) {
  var capture = {};
  var errors = [];
  if (!asn1$6.validate(params, PBES2AlgorithmsValidator, capture, errors)) {
    var error = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
    error.errors = errors;
    throw error;
  }
  oid = asn1$6.derToOid(capture.kdfOid);
  if (oid !== pki$3.oids["pkcs5PBKDF2"]) {
    var error = new Error("Cannot read encrypted private key. Unsupported key derivation function OID.");
    error.oid = oid;
    error.supportedOids = ["pkcs5PBKDF2"];
    throw error;
  }
  oid = asn1$6.derToOid(capture.encOid);
  if (oid !== pki$3.oids["aes128-CBC"] && oid !== pki$3.oids["aes192-CBC"] && oid !== pki$3.oids["aes256-CBC"] && oid !== pki$3.oids["des-EDE3-CBC"] && oid !== pki$3.oids["desCBC"]) {
    var error = new Error("Cannot read encrypted private key. Unsupported encryption scheme OID.");
    error.oid = oid;
    error.supportedOids = [
      "aes128-CBC",
      "aes192-CBC",
      "aes256-CBC",
      "des-EDE3-CBC",
      "desCBC"
    ];
    throw error;
  }
  var salt = capture.kdfSalt;
  var count = forge$g.util.createBuffer(capture.kdfIterationCount);
  count = count.getInt(count.length() << 3);
  var dkLen;
  var cipherFn;
  switch (pki$3.oids[oid]) {
    case "aes128-CBC":
      dkLen = 16;
      cipherFn = forge$g.aes.createDecryptionCipher;
      break;
    case "aes192-CBC":
      dkLen = 24;
      cipherFn = forge$g.aes.createDecryptionCipher;
      break;
    case "aes256-CBC":
      dkLen = 32;
      cipherFn = forge$g.aes.createDecryptionCipher;
      break;
    case "des-EDE3-CBC":
      dkLen = 24;
      cipherFn = forge$g.des.createDecryptionCipher;
      break;
    case "desCBC":
      dkLen = 8;
      cipherFn = forge$g.des.createDecryptionCipher;
      break;
  }
  var md = prfOidToMessageDigest(capture.prfOid);
  var dk = forge$g.pkcs5.pbkdf2(password, salt, count, dkLen, md);
  var iv = capture.encIv;
  var cipher = cipherFn(dk);
  cipher.start(iv);
  return cipher;
};
pki$3.pbe.getCipherForPKCS12PBE = function(oid, params, password) {
  var capture = {};
  var errors = [];
  if (!asn1$6.validate(params, pkcs12PbeParamsValidator, capture, errors)) {
    var error = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
    error.errors = errors;
    throw error;
  }
  var salt = forge$g.util.createBuffer(capture.salt);
  var count = forge$g.util.createBuffer(capture.iterations);
  count = count.getInt(count.length() << 3);
  var dkLen, dIvLen, cipherFn;
  switch (oid) {
    case pki$3.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
      dkLen = 24;
      dIvLen = 8;
      cipherFn = forge$g.des.startDecrypting;
      break;
    case pki$3.oids["pbewithSHAAnd40BitRC2-CBC"]:
      dkLen = 5;
      dIvLen = 8;
      cipherFn = function(key2, iv2) {
        var cipher = forge$g.rc2.createDecryptionCipher(key2, 40);
        cipher.start(iv2, null);
        return cipher;
      };
      break;
    default:
      var error = new Error("Cannot read PKCS #12 PBE data block. Unsupported OID.");
      error.oid = oid;
      throw error;
  }
  var md = prfOidToMessageDigest(capture.prfOid);
  var key = pki$3.pbe.generatePkcs12Key(password, salt, 1, count, dkLen, md);
  md.start();
  var iv = pki$3.pbe.generatePkcs12Key(password, salt, 2, count, dIvLen, md);
  return cipherFn(key, iv);
};
pki$3.pbe.opensslDeriveBytes = function(password, salt, dkLen, md) {
  if (typeof md === "undefined" || md === null) {
    if (!("md5" in forge$g.md)) {
      throw new Error('"md5" hash algorithm unavailable.');
    }
    md = forge$g.md.md5.create();
  }
  if (salt === null) {
    salt = "";
  }
  var digests = [hash(md, password + salt)];
  for (var length = 16, i2 = 1; length < dkLen; ++i2, length += 16) {
    digests.push(hash(md, digests[i2 - 1] + password + salt));
  }
  return digests.join("").substr(0, dkLen);
};
function hash(md, bytes) {
  return md.start().update(bytes).digest().getBytes();
}
function prfOidToMessageDigest(prfOid) {
  var prfAlgorithm;
  if (!prfOid) {
    prfAlgorithm = "hmacWithSHA1";
  } else {
    prfAlgorithm = pki$3.oids[asn1$6.derToOid(prfOid)];
    if (!prfAlgorithm) {
      var error = new Error("Unsupported PRF OID.");
      error.oid = prfOid;
      error.supported = [
        "hmacWithSHA1",
        "hmacWithSHA224",
        "hmacWithSHA256",
        "hmacWithSHA384",
        "hmacWithSHA512"
      ];
      throw error;
    }
  }
  return prfAlgorithmToMessageDigest(prfAlgorithm);
}
function prfAlgorithmToMessageDigest(prfAlgorithm) {
  var factory = forge$g.md;
  switch (prfAlgorithm) {
    case "hmacWithSHA224":
      factory = forge$g.md.sha512;
    case "hmacWithSHA1":
    case "hmacWithSHA256":
    case "hmacWithSHA384":
    case "hmacWithSHA512":
      prfAlgorithm = prfAlgorithm.substr(8).toLowerCase();
      break;
    default:
      var error = new Error("Unsupported PRF algorithm.");
      error.algorithm = prfAlgorithm;
      error.supported = [
        "hmacWithSHA1",
        "hmacWithSHA224",
        "hmacWithSHA256",
        "hmacWithSHA384",
        "hmacWithSHA512"
      ];
      throw error;
  }
  if (!factory || !(prfAlgorithm in factory)) {
    throw new Error("Unknown hash algorithm: " + prfAlgorithm);
  }
  return factory[prfAlgorithm].create();
}
function createPbkdf2Params(salt, countBytes, dkLen, prfAlgorithm) {
  var params = asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.SEQUENCE, true, [
    asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.OCTETSTRING, false, salt),
    asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.INTEGER, false, countBytes.getBytes())
  ]);
  if (prfAlgorithm !== "hmacWithSHA1") {
    params.value.push(asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.INTEGER, false, forge$g.util.hexToBytes(dkLen.toString(16))), asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.SEQUENCE, true, [
      asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.OID, false, asn1$6.oidToDer(pki$3.oids[prfAlgorithm]).getBytes()),
      asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.NULL, false, "")
    ]));
  }
  return params;
}
var forge$f = forge$C;
var asn1$5 = forge$f.asn1;
var p7v = forge$f.pkcs7asn1 = forge$f.pkcs7asn1 || {};
forge$f.pkcs7 = forge$f.pkcs7 || {};
forge$f.pkcs7.asn1 = p7v;
var contentInfoValidator$1 = {
  name: "ContentInfo",
  tagClass: asn1$5.Class.UNIVERSAL,
  type: asn1$5.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "ContentInfo.ContentType",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.OID,
    constructed: false,
    capture: "contentType"
  }, {
    name: "ContentInfo.content",
    tagClass: asn1$5.Class.CONTEXT_SPECIFIC,
    type: 0,
    constructed: true,
    optional: true,
    captureAsn1: "content"
  }]
};
p7v.contentInfoValidator = contentInfoValidator$1;
var encryptedContentInfoValidator = {
  name: "EncryptedContentInfo",
  tagClass: asn1$5.Class.UNIVERSAL,
  type: asn1$5.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "EncryptedContentInfo.contentType",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.OID,
    constructed: false,
    capture: "contentType"
  }, {
    name: "EncryptedContentInfo.contentEncryptionAlgorithm",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: "EncryptedContentInfo.contentEncryptionAlgorithm.algorithm",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.OID,
      constructed: false,
      capture: "encAlgorithm"
    }, {
      name: "EncryptedContentInfo.contentEncryptionAlgorithm.parameter",
      tagClass: asn1$5.Class.UNIVERSAL,
      captureAsn1: "encParameter"
    }]
  }, {
    name: "EncryptedContentInfo.encryptedContent",
    tagClass: asn1$5.Class.CONTEXT_SPECIFIC,
    type: 0,
    capture: "encryptedContent",
    captureAsn1: "encryptedContentAsn1"
  }]
};
p7v.envelopedDataValidator = {
  name: "EnvelopedData",
  tagClass: asn1$5.Class.UNIVERSAL,
  type: asn1$5.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "EnvelopedData.Version",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.INTEGER,
    constructed: false,
    capture: "version"
  }, {
    name: "EnvelopedData.RecipientInfos",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.SET,
    constructed: true,
    captureAsn1: "recipientInfos"
  }].concat(encryptedContentInfoValidator)
};
p7v.encryptedDataValidator = {
  name: "EncryptedData",
  tagClass: asn1$5.Class.UNIVERSAL,
  type: asn1$5.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "EncryptedData.Version",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.INTEGER,
    constructed: false,
    capture: "version"
  }].concat(encryptedContentInfoValidator)
};
var signerValidator = {
  name: "SignerInfo",
  tagClass: asn1$5.Class.UNIVERSAL,
  type: asn1$5.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "SignerInfo.version",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.INTEGER,
    constructed: false
  }, {
    name: "SignerInfo.issuerAndSerialNumber",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: "SignerInfo.issuerAndSerialNumber.issuer",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.SEQUENCE,
      constructed: true,
      captureAsn1: "issuer"
    }, {
      name: "SignerInfo.issuerAndSerialNumber.serialNumber",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.INTEGER,
      constructed: false,
      capture: "serial"
    }]
  }, {
    name: "SignerInfo.digestAlgorithm",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: "SignerInfo.digestAlgorithm.algorithm",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.OID,
      constructed: false,
      capture: "digestAlgorithm"
    }, {
      name: "SignerInfo.digestAlgorithm.parameter",
      tagClass: asn1$5.Class.UNIVERSAL,
      constructed: false,
      captureAsn1: "digestParameter",
      optional: true
    }]
  }, {
    name: "SignerInfo.authenticatedAttributes",
    tagClass: asn1$5.Class.CONTEXT_SPECIFIC,
    type: 0,
    constructed: true,
    optional: true,
    capture: "authenticatedAttributes"
  }, {
    name: "SignerInfo.digestEncryptionAlgorithm",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.SEQUENCE,
    constructed: true,
    capture: "signatureAlgorithm"
  }, {
    name: "SignerInfo.encryptedDigest",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.OCTETSTRING,
    constructed: false,
    capture: "signature"
  }, {
    name: "SignerInfo.unauthenticatedAttributes",
    tagClass: asn1$5.Class.CONTEXT_SPECIFIC,
    type: 1,
    constructed: true,
    optional: true,
    capture: "unauthenticatedAttributes"
  }]
};
p7v.signedDataValidator = {
  name: "SignedData",
  tagClass: asn1$5.Class.UNIVERSAL,
  type: asn1$5.Type.SEQUENCE,
  constructed: true,
  value: [
    {
      name: "SignedData.Version",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.INTEGER,
      constructed: false,
      capture: "version"
    },
    {
      name: "SignedData.DigestAlgorithms",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.SET,
      constructed: true,
      captureAsn1: "digestAlgorithms"
    },
    contentInfoValidator$1,
    {
      name: "SignedData.Certificates",
      tagClass: asn1$5.Class.CONTEXT_SPECIFIC,
      type: 0,
      optional: true,
      captureAsn1: "certificates"
    },
    {
      name: "SignedData.CertificateRevocationLists",
      tagClass: asn1$5.Class.CONTEXT_SPECIFIC,
      type: 1,
      optional: true,
      captureAsn1: "crls"
    },
    {
      name: "SignedData.SignerInfos",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.SET,
      capture: "signerInfos",
      optional: true,
      value: [signerValidator]
    }
  ]
};
p7v.recipientInfoValidator = {
  name: "RecipientInfo",
  tagClass: asn1$5.Class.UNIVERSAL,
  type: asn1$5.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "RecipientInfo.version",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.INTEGER,
    constructed: false,
    capture: "version"
  }, {
    name: "RecipientInfo.issuerAndSerial",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: "RecipientInfo.issuerAndSerial.issuer",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.SEQUENCE,
      constructed: true,
      captureAsn1: "issuer"
    }, {
      name: "RecipientInfo.issuerAndSerial.serialNumber",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.INTEGER,
      constructed: false,
      capture: "serial"
    }]
  }, {
    name: "RecipientInfo.keyEncryptionAlgorithm",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: "RecipientInfo.keyEncryptionAlgorithm.algorithm",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.OID,
      constructed: false,
      capture: "encAlgorithm"
    }, {
      name: "RecipientInfo.keyEncryptionAlgorithm.parameter",
      tagClass: asn1$5.Class.UNIVERSAL,
      constructed: false,
      captureAsn1: "encParameter",
      optional: true
    }]
  }, {
    name: "RecipientInfo.encryptedKey",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.OCTETSTRING,
    constructed: false,
    capture: "encKey"
  }]
};
var forge$e = forge$C;
forge$e.mgf = forge$e.mgf || {};
var mgf1 = forge$e.mgf.mgf1 = forge$e.mgf1 = forge$e.mgf1 || {};
mgf1.create = function(md) {
  var mgf = {
    generate: function(seed, maskLen) {
      var t = new forge$e.util.ByteBuffer();
      var len = Math.ceil(maskLen / md.digestLength);
      for (var i2 = 0; i2 < len; i2++) {
        var c = new forge$e.util.ByteBuffer();
        c.putInt32(i2);
        md.start();
        md.update(seed + c.getBytes());
        t.putBuffer(md.digest());
      }
      t.truncate(t.length() - maskLen);
      return t.getBytes();
    }
  };
  return mgf;
};
var forge$d = forge$C;
forge$d.mgf = forge$d.mgf || {};
forge$d.mgf.mgf1 = forge$d.mgf1;
var forge$c = forge$C;
var pss = forge$c.pss = forge$c.pss || {};
pss.create = function(options) {
  if (arguments.length === 3) {
    options = {
      md: arguments[0],
      mgf: arguments[1],
      saltLength: arguments[2]
    };
  }
  var hash2 = options.md;
  var mgf = options.mgf;
  var hLen = hash2.digestLength;
  var salt_ = options.salt || null;
  if (typeof salt_ === "string") {
    salt_ = forge$c.util.createBuffer(salt_);
  }
  var sLen;
  if ("saltLength" in options) {
    sLen = options.saltLength;
  } else if (salt_ !== null) {
    sLen = salt_.length();
  } else {
    throw new Error("Salt length not specified or specific salt not given.");
  }
  if (salt_ !== null && salt_.length() !== sLen) {
    throw new Error("Given salt length does not match length of given salt.");
  }
  var prng2 = options.prng || forge$c.random;
  var pssobj = {};
  pssobj.encode = function(md, modBits) {
    var i2;
    var emBits = modBits - 1;
    var emLen = Math.ceil(emBits / 8);
    var mHash = md.digest().getBytes();
    if (emLen < hLen + sLen + 2) {
      throw new Error("Message is too long to encrypt.");
    }
    var salt;
    if (salt_ === null) {
      salt = prng2.getBytesSync(sLen);
    } else {
      salt = salt_.bytes();
    }
    var m_ = new forge$c.util.ByteBuffer();
    m_.fillWithByte(0, 8);
    m_.putBytes(mHash);
    m_.putBytes(salt);
    hash2.start();
    hash2.update(m_.getBytes());
    var h = hash2.digest().getBytes();
    var ps = new forge$c.util.ByteBuffer();
    ps.fillWithByte(0, emLen - sLen - hLen - 2);
    ps.putByte(1);
    ps.putBytes(salt);
    var db = ps.getBytes();
    var maskLen = emLen - hLen - 1;
    var dbMask = mgf.generate(h, maskLen);
    var maskedDB = "";
    for (i2 = 0; i2 < maskLen; i2++) {
      maskedDB += String.fromCharCode(db.charCodeAt(i2) ^ dbMask.charCodeAt(i2));
    }
    var mask = 65280 >> 8 * emLen - emBits & 255;
    maskedDB = String.fromCharCode(maskedDB.charCodeAt(0) & ~mask) + maskedDB.substr(1);
    return maskedDB + h + String.fromCharCode(188);
  };
  pssobj.verify = function(mHash, em, modBits) {
    var i2;
    var emBits = modBits - 1;
    var emLen = Math.ceil(emBits / 8);
    em = em.substr(-emLen);
    if (emLen < hLen + sLen + 2) {
      throw new Error("Inconsistent parameters to PSS signature verification.");
    }
    if (em.charCodeAt(emLen - 1) !== 188) {
      throw new Error("Encoded message does not end in 0xBC.");
    }
    var maskLen = emLen - hLen - 1;
    var maskedDB = em.substr(0, maskLen);
    var h = em.substr(maskLen, hLen);
    var mask = 65280 >> 8 * emLen - emBits & 255;
    if ((maskedDB.charCodeAt(0) & mask) !== 0) {
      throw new Error("Bits beyond keysize not zero as expected.");
    }
    var dbMask = mgf.generate(h, maskLen);
    var db = "";
    for (i2 = 0; i2 < maskLen; i2++) {
      db += String.fromCharCode(maskedDB.charCodeAt(i2) ^ dbMask.charCodeAt(i2));
    }
    db = String.fromCharCode(db.charCodeAt(0) & ~mask) + db.substr(1);
    var checkLen = emLen - hLen - sLen - 2;
    for (i2 = 0; i2 < checkLen; i2++) {
      if (db.charCodeAt(i2) !== 0) {
        throw new Error("Leftmost octets not zero as expected");
      }
    }
    if (db.charCodeAt(checkLen) !== 1) {
      throw new Error("Inconsistent PSS signature, 0x01 marker not found");
    }
    var salt = db.substr(-sLen);
    var m_ = new forge$c.util.ByteBuffer();
    m_.fillWithByte(0, 8);
    m_.putBytes(mHash);
    m_.putBytes(salt);
    hash2.start();
    hash2.update(m_.getBytes());
    var h_ = hash2.digest().getBytes();
    return h === h_;
  };
  return pssobj;
};
var forge$b = forge$C;
var asn1$4 = forge$b.asn1;
var pki$2 = forge$b.pki = forge$b.pki || {};
var oids = pki$2.oids;
var _shortNames = {};
_shortNames["CN"] = oids["commonName"];
_shortNames["commonName"] = "CN";
_shortNames["C"] = oids["countryName"];
_shortNames["countryName"] = "C";
_shortNames["L"] = oids["localityName"];
_shortNames["localityName"] = "L";
_shortNames["ST"] = oids["stateOrProvinceName"];
_shortNames["stateOrProvinceName"] = "ST";
_shortNames["O"] = oids["organizationName"];
_shortNames["organizationName"] = "O";
_shortNames["OU"] = oids["organizationalUnitName"];
_shortNames["organizationalUnitName"] = "OU";
_shortNames["E"] = oids["emailAddress"];
_shortNames["emailAddress"] = "E";
var publicKeyValidator$1 = forge$b.pki.rsa.publicKeyValidator;
var x509CertificateValidator = {
  name: "Certificate",
  tagClass: asn1$4.Class.UNIVERSAL,
  type: asn1$4.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "Certificate.TBSCertificate",
    tagClass: asn1$4.Class.UNIVERSAL,
    type: asn1$4.Type.SEQUENCE,
    constructed: true,
    captureAsn1: "tbsCertificate",
    value: [
      {
        name: "Certificate.TBSCertificate.version",
        tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
        type: 0,
        constructed: true,
        optional: true,
        value: [{
          name: "Certificate.TBSCertificate.version.integer",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.INTEGER,
          constructed: false,
          capture: "certVersion"
        }]
      },
      {
        name: "Certificate.TBSCertificate.serialNumber",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.INTEGER,
        constructed: false,
        capture: "certSerialNumber"
      },
      {
        name: "Certificate.TBSCertificate.signature",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.SEQUENCE,
        constructed: true,
        value: [{
          name: "Certificate.TBSCertificate.signature.algorithm",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.OID,
          constructed: false,
          capture: "certinfoSignatureOid"
        }, {
          name: "Certificate.TBSCertificate.signature.parameters",
          tagClass: asn1$4.Class.UNIVERSAL,
          optional: true,
          captureAsn1: "certinfoSignatureParams"
        }]
      },
      {
        name: "Certificate.TBSCertificate.issuer",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.SEQUENCE,
        constructed: true,
        captureAsn1: "certIssuer"
      },
      {
        name: "Certificate.TBSCertificate.validity",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.SEQUENCE,
        constructed: true,
        value: [{
          name: "Certificate.TBSCertificate.validity.notBefore (utc)",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.UTCTIME,
          constructed: false,
          optional: true,
          capture: "certValidity1UTCTime"
        }, {
          name: "Certificate.TBSCertificate.validity.notBefore (generalized)",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.GENERALIZEDTIME,
          constructed: false,
          optional: true,
          capture: "certValidity2GeneralizedTime"
        }, {
          name: "Certificate.TBSCertificate.validity.notAfter (utc)",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.UTCTIME,
          constructed: false,
          optional: true,
          capture: "certValidity3UTCTime"
        }, {
          name: "Certificate.TBSCertificate.validity.notAfter (generalized)",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.GENERALIZEDTIME,
          constructed: false,
          optional: true,
          capture: "certValidity4GeneralizedTime"
        }]
      },
      {
        name: "Certificate.TBSCertificate.subject",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.SEQUENCE,
        constructed: true,
        captureAsn1: "certSubject"
      },
      publicKeyValidator$1,
      {
        name: "Certificate.TBSCertificate.issuerUniqueID",
        tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
        type: 1,
        constructed: true,
        optional: true,
        value: [{
          name: "Certificate.TBSCertificate.issuerUniqueID.id",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.BITSTRING,
          constructed: false,
          captureBitStringValue: "certIssuerUniqueId"
        }]
      },
      {
        name: "Certificate.TBSCertificate.subjectUniqueID",
        tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
        type: 2,
        constructed: true,
        optional: true,
        value: [{
          name: "Certificate.TBSCertificate.subjectUniqueID.id",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.BITSTRING,
          constructed: false,
          captureBitStringValue: "certSubjectUniqueId"
        }]
      },
      {
        name: "Certificate.TBSCertificate.extensions",
        tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
        type: 3,
        constructed: true,
        captureAsn1: "certExtensions",
        optional: true
      }
    ]
  }, {
    name: "Certificate.signatureAlgorithm",
    tagClass: asn1$4.Class.UNIVERSAL,
    type: asn1$4.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: "Certificate.signatureAlgorithm.algorithm",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Type.OID,
      constructed: false,
      capture: "certSignatureOid"
    }, {
      name: "Certificate.TBSCertificate.signature.parameters",
      tagClass: asn1$4.Class.UNIVERSAL,
      optional: true,
      captureAsn1: "certSignatureParams"
    }]
  }, {
    name: "Certificate.signatureValue",
    tagClass: asn1$4.Class.UNIVERSAL,
    type: asn1$4.Type.BITSTRING,
    constructed: false,
    captureBitStringValue: "certSignature"
  }]
};
var rsassaPssParameterValidator = {
  name: "rsapss",
  tagClass: asn1$4.Class.UNIVERSAL,
  type: asn1$4.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "rsapss.hashAlgorithm",
    tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
    type: 0,
    constructed: true,
    value: [{
      name: "rsapss.hashAlgorithm.AlgorithmIdentifier",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Class.SEQUENCE,
      constructed: true,
      optional: true,
      value: [{
        name: "rsapss.hashAlgorithm.AlgorithmIdentifier.algorithm",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.OID,
        constructed: false,
        capture: "hashOid"
      }]
    }]
  }, {
    name: "rsapss.maskGenAlgorithm",
    tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
    type: 1,
    constructed: true,
    value: [{
      name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Class.SEQUENCE,
      constructed: true,
      optional: true,
      value: [{
        name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.algorithm",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.OID,
        constructed: false,
        capture: "maskGenOid"
      }, {
        name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.SEQUENCE,
        constructed: true,
        value: [{
          name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params.algorithm",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.OID,
          constructed: false,
          capture: "maskGenHashOid"
        }]
      }]
    }]
  }, {
    name: "rsapss.saltLength",
    tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
    type: 2,
    optional: true,
    value: [{
      name: "rsapss.saltLength.saltLength",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Class.INTEGER,
      constructed: false,
      capture: "saltLength"
    }]
  }, {
    name: "rsapss.trailerField",
    tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
    type: 3,
    optional: true,
    value: [{
      name: "rsapss.trailer.trailer",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Class.INTEGER,
      constructed: false,
      capture: "trailer"
    }]
  }]
};
var certificationRequestInfoValidator = {
  name: "CertificationRequestInfo",
  tagClass: asn1$4.Class.UNIVERSAL,
  type: asn1$4.Type.SEQUENCE,
  constructed: true,
  captureAsn1: "certificationRequestInfo",
  value: [
    {
      name: "CertificationRequestInfo.integer",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Type.INTEGER,
      constructed: false,
      capture: "certificationRequestInfoVersion"
    },
    {
      name: "CertificationRequestInfo.subject",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Type.SEQUENCE,
      constructed: true,
      captureAsn1: "certificationRequestInfoSubject"
    },
    publicKeyValidator$1,
    {
      name: "CertificationRequestInfo.attributes",
      tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
      type: 0,
      constructed: true,
      optional: true,
      capture: "certificationRequestInfoAttributes",
      value: [{
        name: "CertificationRequestInfo.attributes",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.SEQUENCE,
        constructed: true,
        value: [{
          name: "CertificationRequestInfo.attributes.type",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.OID,
          constructed: false
        }, {
          name: "CertificationRequestInfo.attributes.value",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.SET,
          constructed: true
        }]
      }]
    }
  ]
};
var certificationRequestValidator = {
  name: "CertificationRequest",
  tagClass: asn1$4.Class.UNIVERSAL,
  type: asn1$4.Type.SEQUENCE,
  constructed: true,
  captureAsn1: "csr",
  value: [
    certificationRequestInfoValidator,
    {
      name: "CertificationRequest.signatureAlgorithm",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Type.SEQUENCE,
      constructed: true,
      value: [{
        name: "CertificationRequest.signatureAlgorithm.algorithm",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.OID,
        constructed: false,
        capture: "csrSignatureOid"
      }, {
        name: "CertificationRequest.signatureAlgorithm.parameters",
        tagClass: asn1$4.Class.UNIVERSAL,
        optional: true,
        captureAsn1: "csrSignatureParams"
      }]
    },
    {
      name: "CertificationRequest.signature",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Type.BITSTRING,
      constructed: false,
      captureBitStringValue: "csrSignature"
    }
  ]
};
pki$2.RDNAttributesAsArray = function(rdn, md) {
  var rval = [];
  var set3, attr, obj;
  for (var si = 0; si < rdn.value.length; ++si) {
    set3 = rdn.value[si];
    for (var i2 = 0; i2 < set3.value.length; ++i2) {
      obj = {};
      attr = set3.value[i2];
      obj.type = asn1$4.derToOid(attr.value[0].value);
      obj.value = attr.value[1].value;
      obj.valueTagClass = attr.value[1].type;
      if (obj.type in oids) {
        obj.name = oids[obj.type];
        if (obj.name in _shortNames) {
          obj.shortName = _shortNames[obj.name];
        }
      }
      if (md) {
        md.update(obj.type);
        md.update(obj.value);
      }
      rval.push(obj);
    }
  }
  return rval;
};
pki$2.CRIAttributesAsArray = function(attributes) {
  var rval = [];
  for (var si = 0; si < attributes.length; ++si) {
    var seq = attributes[si];
    var type = asn1$4.derToOid(seq.value[0].value);
    var values = seq.value[1].value;
    for (var vi = 0; vi < values.length; ++vi) {
      var obj = {};
      obj.type = type;
      obj.value = values[vi].value;
      obj.valueTagClass = values[vi].type;
      if (obj.type in oids) {
        obj.name = oids[obj.type];
        if (obj.name in _shortNames) {
          obj.shortName = _shortNames[obj.name];
        }
      }
      if (obj.type === oids.extensionRequest) {
        obj.extensions = [];
        for (var ei = 0; ei < obj.value.length; ++ei) {
          obj.extensions.push(pki$2.certificateExtensionFromAsn1(obj.value[ei]));
        }
      }
      rval.push(obj);
    }
  }
  return rval;
};
function _getAttribute(obj, options) {
  if (typeof options === "string") {
    options = { shortName: options };
  }
  var rval = null;
  var attr;
  for (var i2 = 0; rval === null && i2 < obj.attributes.length; ++i2) {
    attr = obj.attributes[i2];
    if (options.type && options.type === attr.type) {
      rval = attr;
    } else if (options.name && options.name === attr.name) {
      rval = attr;
    } else if (options.shortName && options.shortName === attr.shortName) {
      rval = attr;
    }
  }
  return rval;
}
var _readSignatureParameters = function(oid, obj, fillDefaults) {
  var params = {};
  if (oid !== oids["RSASSA-PSS"]) {
    return params;
  }
  if (fillDefaults) {
    params = {
      hash: {
        algorithmOid: oids["sha1"]
      },
      mgf: {
        algorithmOid: oids["mgf1"],
        hash: {
          algorithmOid: oids["sha1"]
        }
      },
      saltLength: 20
    };
  }
  var capture = {};
  var errors = [];
  if (!asn1$4.validate(obj, rsassaPssParameterValidator, capture, errors)) {
    var error = new Error("Cannot read RSASSA-PSS parameter block.");
    error.errors = errors;
    throw error;
  }
  if (capture.hashOid !== void 0) {
    params.hash = params.hash || {};
    params.hash.algorithmOid = asn1$4.derToOid(capture.hashOid);
  }
  if (capture.maskGenOid !== void 0) {
    params.mgf = params.mgf || {};
    params.mgf.algorithmOid = asn1$4.derToOid(capture.maskGenOid);
    params.mgf.hash = params.mgf.hash || {};
    params.mgf.hash.algorithmOid = asn1$4.derToOid(capture.maskGenHashOid);
  }
  if (capture.saltLength !== void 0) {
    params.saltLength = capture.saltLength.charCodeAt(0);
  }
  return params;
};
var _createSignatureDigest = function(options) {
  switch (oids[options.signatureOid]) {
    case "sha1WithRSAEncryption":
    case "sha1WithRSASignature":
      return forge$b.md.sha1.create();
    case "md5WithRSAEncryption":
      return forge$b.md.md5.create();
    case "sha256WithRSAEncryption":
      return forge$b.md.sha256.create();
    case "sha384WithRSAEncryption":
      return forge$b.md.sha384.create();
    case "sha512WithRSAEncryption":
      return forge$b.md.sha512.create();
    case "RSASSA-PSS":
      return forge$b.md.sha256.create();
    default:
      var error = new Error("Could not compute " + options.type + " digest. Unknown signature OID.");
      error.signatureOid = options.signatureOid;
      throw error;
  }
};
var _verifySignature = function(options) {
  var cert = options.certificate;
  var scheme;
  switch (cert.signatureOid) {
    case oids.sha1WithRSAEncryption:
    case oids.sha1WithRSASignature:
      break;
    case oids["RSASSA-PSS"]:
      var hash2, mgf;
      hash2 = oids[cert.signatureParameters.mgf.hash.algorithmOid];
      if (hash2 === void 0 || forge$b.md[hash2] === void 0) {
        var error = new Error("Unsupported MGF hash function.");
        error.oid = cert.signatureParameters.mgf.hash.algorithmOid;
        error.name = hash2;
        throw error;
      }
      mgf = oids[cert.signatureParameters.mgf.algorithmOid];
      if (mgf === void 0 || forge$b.mgf[mgf] === void 0) {
        var error = new Error("Unsupported MGF function.");
        error.oid = cert.signatureParameters.mgf.algorithmOid;
        error.name = mgf;
        throw error;
      }
      mgf = forge$b.mgf[mgf].create(forge$b.md[hash2].create());
      hash2 = oids[cert.signatureParameters.hash.algorithmOid];
      if (hash2 === void 0 || forge$b.md[hash2] === void 0) {
        var error = new Error("Unsupported RSASSA-PSS hash function.");
        error.oid = cert.signatureParameters.hash.algorithmOid;
        error.name = hash2;
        throw error;
      }
      scheme = forge$b.pss.create(forge$b.md[hash2].create(), mgf, cert.signatureParameters.saltLength);
      break;
  }
  return cert.publicKey.verify(options.md.digest().getBytes(), options.signature, scheme);
};
pki$2.certificateFromPem = function(pem2, computeHash, strict) {
  var msg = forge$b.pem.decode(pem2)[0];
  if (msg.type !== "CERTIFICATE" && msg.type !== "X509 CERTIFICATE" && msg.type !== "TRUSTED CERTIFICATE") {
    var error = new Error('Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".');
    error.headerType = msg.type;
    throw error;
  }
  if (msg.procType && msg.procType.type === "ENCRYPTED") {
    throw new Error("Could not convert certificate from PEM; PEM is encrypted.");
  }
  var obj = asn1$4.fromDer(msg.body, strict);
  return pki$2.certificateFromAsn1(obj, computeHash);
};
pki$2.certificateToPem = function(cert, maxline) {
  var msg = {
    type: "CERTIFICATE",
    body: asn1$4.toDer(pki$2.certificateToAsn1(cert)).getBytes()
  };
  return forge$b.pem.encode(msg, { maxline });
};
pki$2.publicKeyFromPem = function(pem2) {
  var msg = forge$b.pem.decode(pem2)[0];
  if (msg.type !== "PUBLIC KEY" && msg.type !== "RSA PUBLIC KEY") {
    var error = new Error('Could not convert public key from PEM; PEM header type is not "PUBLIC KEY" or "RSA PUBLIC KEY".');
    error.headerType = msg.type;
    throw error;
  }
  if (msg.procType && msg.procType.type === "ENCRYPTED") {
    throw new Error("Could not convert public key from PEM; PEM is encrypted.");
  }
  var obj = asn1$4.fromDer(msg.body);
  return pki$2.publicKeyFromAsn1(obj);
};
pki$2.publicKeyToPem = function(key, maxline) {
  var msg = {
    type: "PUBLIC KEY",
    body: asn1$4.toDer(pki$2.publicKeyToAsn1(key)).getBytes()
  };
  return forge$b.pem.encode(msg, { maxline });
};
pki$2.publicKeyToRSAPublicKeyPem = function(key, maxline) {
  var msg = {
    type: "RSA PUBLIC KEY",
    body: asn1$4.toDer(pki$2.publicKeyToRSAPublicKey(key)).getBytes()
  };
  return forge$b.pem.encode(msg, { maxline });
};
pki$2.getPublicKeyFingerprint = function(key, options) {
  options = options || {};
  var md = options.md || forge$b.md.sha1.create();
  var type = options.type || "RSAPublicKey";
  var bytes;
  switch (type) {
    case "RSAPublicKey":
      bytes = asn1$4.toDer(pki$2.publicKeyToRSAPublicKey(key)).getBytes();
      break;
    case "SubjectPublicKeyInfo":
      bytes = asn1$4.toDer(pki$2.publicKeyToAsn1(key)).getBytes();
      break;
    default:
      throw new Error('Unknown fingerprint type "' + options.type + '".');
  }
  md.start();
  md.update(bytes);
  var digest = md.digest();
  if (options.encoding === "hex") {
    var hex = digest.toHex();
    if (options.delimiter) {
      return hex.match(/.{2}/g).join(options.delimiter);
    }
    return hex;
  } else if (options.encoding === "binary") {
    return digest.getBytes();
  } else if (options.encoding) {
    throw new Error('Unknown encoding "' + options.encoding + '".');
  }
  return digest;
};
pki$2.certificationRequestFromPem = function(pem2, computeHash, strict) {
  var msg = forge$b.pem.decode(pem2)[0];
  if (msg.type !== "CERTIFICATE REQUEST") {
    var error = new Error('Could not convert certification request from PEM; PEM header type is not "CERTIFICATE REQUEST".');
    error.headerType = msg.type;
    throw error;
  }
  if (msg.procType && msg.procType.type === "ENCRYPTED") {
    throw new Error("Could not convert certification request from PEM; PEM is encrypted.");
  }
  var obj = asn1$4.fromDer(msg.body, strict);
  return pki$2.certificationRequestFromAsn1(obj, computeHash);
};
pki$2.certificationRequestToPem = function(csr, maxline) {
  var msg = {
    type: "CERTIFICATE REQUEST",
    body: asn1$4.toDer(pki$2.certificationRequestToAsn1(csr)).getBytes()
  };
  return forge$b.pem.encode(msg, { maxline });
};
pki$2.createCertificate = function() {
  var cert = {};
  cert.version = 2;
  cert.serialNumber = "00";
  cert.signatureOid = null;
  cert.signature = null;
  cert.siginfo = {};
  cert.siginfo.algorithmOid = null;
  cert.validity = {};
  cert.validity.notBefore = new Date();
  cert.validity.notAfter = new Date();
  cert.issuer = {};
  cert.issuer.getField = function(sn) {
    return _getAttribute(cert.issuer, sn);
  };
  cert.issuer.addField = function(attr) {
    _fillMissingFields([attr]);
    cert.issuer.attributes.push(attr);
  };
  cert.issuer.attributes = [];
  cert.issuer.hash = null;
  cert.subject = {};
  cert.subject.getField = function(sn) {
    return _getAttribute(cert.subject, sn);
  };
  cert.subject.addField = function(attr) {
    _fillMissingFields([attr]);
    cert.subject.attributes.push(attr);
  };
  cert.subject.attributes = [];
  cert.subject.hash = null;
  cert.extensions = [];
  cert.publicKey = null;
  cert.md = null;
  cert.setSubject = function(attrs, uniqueId) {
    _fillMissingFields(attrs);
    cert.subject.attributes = attrs;
    delete cert.subject.uniqueId;
    if (uniqueId) {
      cert.subject.uniqueId = uniqueId;
    }
    cert.subject.hash = null;
  };
  cert.setIssuer = function(attrs, uniqueId) {
    _fillMissingFields(attrs);
    cert.issuer.attributes = attrs;
    delete cert.issuer.uniqueId;
    if (uniqueId) {
      cert.issuer.uniqueId = uniqueId;
    }
    cert.issuer.hash = null;
  };
  cert.setExtensions = function(exts) {
    for (var i2 = 0; i2 < exts.length; ++i2) {
      _fillMissingExtensionFields(exts[i2], { cert });
    }
    cert.extensions = exts;
  };
  cert.getExtension = function(options) {
    if (typeof options === "string") {
      options = { name: options };
    }
    var rval = null;
    var ext;
    for (var i2 = 0; rval === null && i2 < cert.extensions.length; ++i2) {
      ext = cert.extensions[i2];
      if (options.id && ext.id === options.id) {
        rval = ext;
      } else if (options.name && ext.name === options.name) {
        rval = ext;
      }
    }
    return rval;
  };
  cert.sign = function(key, md) {
    cert.md = md || forge$b.md.sha1.create();
    var algorithmOid = oids[cert.md.algorithm + "WithRSAEncryption"];
    if (!algorithmOid) {
      var error = new Error("Could not compute certificate digest. Unknown message digest algorithm OID.");
      error.algorithm = cert.md.algorithm;
      throw error;
    }
    cert.signatureOid = cert.siginfo.algorithmOid = algorithmOid;
    cert.tbsCertificate = pki$2.getTBSCertificate(cert);
    var bytes = asn1$4.toDer(cert.tbsCertificate);
    cert.md.update(bytes.getBytes());
    cert.signature = key.sign(cert.md);
  };
  cert.verify = function(child3) {
    var rval = false;
    if (!cert.issued(child3)) {
      var issuer = child3.issuer;
      var subject = cert.subject;
      var error = new Error("The parent certificate did not issue the given child certificate; the child certificate's issuer does not match the parent's subject.");
      error.expectedIssuer = subject.attributes;
      error.actualIssuer = issuer.attributes;
      throw error;
    }
    var md = child3.md;
    if (md === null) {
      md = _createSignatureDigest({
        signatureOid: child3.signatureOid,
        type: "certificate"
      });
      var tbsCertificate = child3.tbsCertificate || pki$2.getTBSCertificate(child3);
      var bytes = asn1$4.toDer(tbsCertificate);
      md.update(bytes.getBytes());
    }
    if (md !== null) {
      rval = _verifySignature({
        certificate: cert,
        md,
        signature: child3.signature
      });
    }
    return rval;
  };
  cert.isIssuer = function(parent) {
    var rval = false;
    var i2 = cert.issuer;
    var s2 = parent.subject;
    if (i2.hash && s2.hash) {
      rval = i2.hash === s2.hash;
    } else if (i2.attributes.length === s2.attributes.length) {
      rval = true;
      var iattr, sattr;
      for (var n = 0; rval && n < i2.attributes.length; ++n) {
        iattr = i2.attributes[n];
        sattr = s2.attributes[n];
        if (iattr.type !== sattr.type || iattr.value !== sattr.value) {
          rval = false;
        }
      }
    }
    return rval;
  };
  cert.issued = function(child3) {
    return child3.isIssuer(cert);
  };
  cert.generateSubjectKeyIdentifier = function() {
    return pki$2.getPublicKeyFingerprint(cert.publicKey, { type: "RSAPublicKey" });
  };
  cert.verifySubjectKeyIdentifier = function() {
    var oid = oids["subjectKeyIdentifier"];
    for (var i2 = 0; i2 < cert.extensions.length; ++i2) {
      var ext = cert.extensions[i2];
      if (ext.id === oid) {
        var ski = cert.generateSubjectKeyIdentifier().getBytes();
        return forge$b.util.hexToBytes(ext.subjectKeyIdentifier) === ski;
      }
    }
    return false;
  };
  return cert;
};
pki$2.certificateFromAsn1 = function(obj, computeHash) {
  var capture = {};
  var errors = [];
  if (!asn1$4.validate(obj, x509CertificateValidator, capture, errors)) {
    var error = new Error("Cannot read X.509 certificate. ASN.1 object is not an X509v3 Certificate.");
    error.errors = errors;
    throw error;
  }
  var oid = asn1$4.derToOid(capture.publicKeyOid);
  if (oid !== pki$2.oids.rsaEncryption) {
    throw new Error("Cannot read public key. OID is not RSA.");
  }
  var cert = pki$2.createCertificate();
  cert.version = capture.certVersion ? capture.certVersion.charCodeAt(0) : 0;
  var serial = forge$b.util.createBuffer(capture.certSerialNumber);
  cert.serialNumber = serial.toHex();
  cert.signatureOid = forge$b.asn1.derToOid(capture.certSignatureOid);
  cert.signatureParameters = _readSignatureParameters(cert.signatureOid, capture.certSignatureParams, true);
  cert.siginfo.algorithmOid = forge$b.asn1.derToOid(capture.certinfoSignatureOid);
  cert.siginfo.parameters = _readSignatureParameters(cert.siginfo.algorithmOid, capture.certinfoSignatureParams, false);
  cert.signature = capture.certSignature;
  var validity = [];
  if (capture.certValidity1UTCTime !== void 0) {
    validity.push(asn1$4.utcTimeToDate(capture.certValidity1UTCTime));
  }
  if (capture.certValidity2GeneralizedTime !== void 0) {
    validity.push(asn1$4.generalizedTimeToDate(capture.certValidity2GeneralizedTime));
  }
  if (capture.certValidity3UTCTime !== void 0) {
    validity.push(asn1$4.utcTimeToDate(capture.certValidity3UTCTime));
  }
  if (capture.certValidity4GeneralizedTime !== void 0) {
    validity.push(asn1$4.generalizedTimeToDate(capture.certValidity4GeneralizedTime));
  }
  if (validity.length > 2) {
    throw new Error("Cannot read notBefore/notAfter validity times; more than two times were provided in the certificate.");
  }
  if (validity.length < 2) {
    throw new Error("Cannot read notBefore/notAfter validity times; they were not provided as either UTCTime or GeneralizedTime.");
  }
  cert.validity.notBefore = validity[0];
  cert.validity.notAfter = validity[1];
  cert.tbsCertificate = capture.tbsCertificate;
  if (computeHash) {
    cert.md = _createSignatureDigest({
      signatureOid: cert.signatureOid,
      type: "certificate"
    });
    var bytes = asn1$4.toDer(cert.tbsCertificate);
    cert.md.update(bytes.getBytes());
  }
  var imd = forge$b.md.sha1.create();
  var ibytes = asn1$4.toDer(capture.certIssuer);
  imd.update(ibytes.getBytes());
  cert.issuer.getField = function(sn) {
    return _getAttribute(cert.issuer, sn);
  };
  cert.issuer.addField = function(attr) {
    _fillMissingFields([attr]);
    cert.issuer.attributes.push(attr);
  };
  cert.issuer.attributes = pki$2.RDNAttributesAsArray(capture.certIssuer);
  if (capture.certIssuerUniqueId) {
    cert.issuer.uniqueId = capture.certIssuerUniqueId;
  }
  cert.issuer.hash = imd.digest().toHex();
  var smd = forge$b.md.sha1.create();
  var sbytes = asn1$4.toDer(capture.certSubject);
  smd.update(sbytes.getBytes());
  cert.subject.getField = function(sn) {
    return _getAttribute(cert.subject, sn);
  };
  cert.subject.addField = function(attr) {
    _fillMissingFields([attr]);
    cert.subject.attributes.push(attr);
  };
  cert.subject.attributes = pki$2.RDNAttributesAsArray(capture.certSubject);
  if (capture.certSubjectUniqueId) {
    cert.subject.uniqueId = capture.certSubjectUniqueId;
  }
  cert.subject.hash = smd.digest().toHex();
  if (capture.certExtensions) {
    cert.extensions = pki$2.certificateExtensionsFromAsn1(capture.certExtensions);
  } else {
    cert.extensions = [];
  }
  cert.publicKey = pki$2.publicKeyFromAsn1(capture.subjectPublicKeyInfo);
  return cert;
};
pki$2.certificateExtensionsFromAsn1 = function(exts) {
  var rval = [];
  for (var i2 = 0; i2 < exts.value.length; ++i2) {
    var extseq = exts.value[i2];
    for (var ei = 0; ei < extseq.value.length; ++ei) {
      rval.push(pki$2.certificateExtensionFromAsn1(extseq.value[ei]));
    }
  }
  return rval;
};
pki$2.certificateExtensionFromAsn1 = function(ext) {
  var e = {};
  e.id = asn1$4.derToOid(ext.value[0].value);
  e.critical = false;
  if (ext.value[1].type === asn1$4.Type.BOOLEAN) {
    e.critical = ext.value[1].value.charCodeAt(0) !== 0;
    e.value = ext.value[2].value;
  } else {
    e.value = ext.value[1].value;
  }
  if (e.id in oids) {
    e.name = oids[e.id];
    if (e.name === "keyUsage") {
      var ev = asn1$4.fromDer(e.value);
      var b2 = 0;
      var b3 = 0;
      if (ev.value.length > 1) {
        b2 = ev.value.charCodeAt(1);
        b3 = ev.value.length > 2 ? ev.value.charCodeAt(2) : 0;
      }
      e.digitalSignature = (b2 & 128) === 128;
      e.nonRepudiation = (b2 & 64) === 64;
      e.keyEncipherment = (b2 & 32) === 32;
      e.dataEncipherment = (b2 & 16) === 16;
      e.keyAgreement = (b2 & 8) === 8;
      e.keyCertSign = (b2 & 4) === 4;
      e.cRLSign = (b2 & 2) === 2;
      e.encipherOnly = (b2 & 1) === 1;
      e.decipherOnly = (b3 & 128) === 128;
    } else if (e.name === "basicConstraints") {
      var ev = asn1$4.fromDer(e.value);
      if (ev.value.length > 0 && ev.value[0].type === asn1$4.Type.BOOLEAN) {
        e.cA = ev.value[0].value.charCodeAt(0) !== 0;
      } else {
        e.cA = false;
      }
      var value = null;
      if (ev.value.length > 0 && ev.value[0].type === asn1$4.Type.INTEGER) {
        value = ev.value[0].value;
      } else if (ev.value.length > 1) {
        value = ev.value[1].value;
      }
      if (value !== null) {
        e.pathLenConstraint = asn1$4.derToInteger(value);
      }
    } else if (e.name === "extKeyUsage") {
      var ev = asn1$4.fromDer(e.value);
      for (var vi = 0; vi < ev.value.length; ++vi) {
        var oid = asn1$4.derToOid(ev.value[vi].value);
        if (oid in oids) {
          e[oids[oid]] = true;
        } else {
          e[oid] = true;
        }
      }
    } else if (e.name === "nsCertType") {
      var ev = asn1$4.fromDer(e.value);
      var b2 = 0;
      if (ev.value.length > 1) {
        b2 = ev.value.charCodeAt(1);
      }
      e.client = (b2 & 128) === 128;
      e.server = (b2 & 64) === 64;
      e.email = (b2 & 32) === 32;
      e.objsign = (b2 & 16) === 16;
      e.reserved = (b2 & 8) === 8;
      e.sslCA = (b2 & 4) === 4;
      e.emailCA = (b2 & 2) === 2;
      e.objCA = (b2 & 1) === 1;
    } else if (e.name === "subjectAltName" || e.name === "issuerAltName") {
      e.altNames = [];
      var gn;
      var ev = asn1$4.fromDer(e.value);
      for (var n = 0; n < ev.value.length; ++n) {
        gn = ev.value[n];
        var altName = {
          type: gn.type,
          value: gn.value
        };
        e.altNames.push(altName);
        switch (gn.type) {
          case 1:
          case 2:
          case 6:
            break;
          case 7:
            altName.ip = forge$b.util.bytesToIP(gn.value);
            break;
          case 8:
            altName.oid = asn1$4.derToOid(gn.value);
            break;
        }
      }
    } else if (e.name === "subjectKeyIdentifier") {
      var ev = asn1$4.fromDer(e.value);
      e.subjectKeyIdentifier = forge$b.util.bytesToHex(ev.value);
    }
  }
  return e;
};
pki$2.certificationRequestFromAsn1 = function(obj, computeHash) {
  var capture = {};
  var errors = [];
  if (!asn1$4.validate(obj, certificationRequestValidator, capture, errors)) {
    var error = new Error("Cannot read PKCS#10 certificate request. ASN.1 object is not a PKCS#10 CertificationRequest.");
    error.errors = errors;
    throw error;
  }
  var oid = asn1$4.derToOid(capture.publicKeyOid);
  if (oid !== pki$2.oids.rsaEncryption) {
    throw new Error("Cannot read public key. OID is not RSA.");
  }
  var csr = pki$2.createCertificationRequest();
  csr.version = capture.csrVersion ? capture.csrVersion.charCodeAt(0) : 0;
  csr.signatureOid = forge$b.asn1.derToOid(capture.csrSignatureOid);
  csr.signatureParameters = _readSignatureParameters(csr.signatureOid, capture.csrSignatureParams, true);
  csr.siginfo.algorithmOid = forge$b.asn1.derToOid(capture.csrSignatureOid);
  csr.siginfo.parameters = _readSignatureParameters(csr.siginfo.algorithmOid, capture.csrSignatureParams, false);
  csr.signature = capture.csrSignature;
  csr.certificationRequestInfo = capture.certificationRequestInfo;
  if (computeHash) {
    csr.md = _createSignatureDigest({
      signatureOid: csr.signatureOid,
      type: "certification request"
    });
    var bytes = asn1$4.toDer(csr.certificationRequestInfo);
    csr.md.update(bytes.getBytes());
  }
  var smd = forge$b.md.sha1.create();
  csr.subject.getField = function(sn) {
    return _getAttribute(csr.subject, sn);
  };
  csr.subject.addField = function(attr) {
    _fillMissingFields([attr]);
    csr.subject.attributes.push(attr);
  };
  csr.subject.attributes = pki$2.RDNAttributesAsArray(capture.certificationRequestInfoSubject, smd);
  csr.subject.hash = smd.digest().toHex();
  csr.publicKey = pki$2.publicKeyFromAsn1(capture.subjectPublicKeyInfo);
  csr.getAttribute = function(sn) {
    return _getAttribute(csr, sn);
  };
  csr.addAttribute = function(attr) {
    _fillMissingFields([attr]);
    csr.attributes.push(attr);
  };
  csr.attributes = pki$2.CRIAttributesAsArray(capture.certificationRequestInfoAttributes || []);
  return csr;
};
pki$2.createCertificationRequest = function() {
  var csr = {};
  csr.version = 0;
  csr.signatureOid = null;
  csr.signature = null;
  csr.siginfo = {};
  csr.siginfo.algorithmOid = null;
  csr.subject = {};
  csr.subject.getField = function(sn) {
    return _getAttribute(csr.subject, sn);
  };
  csr.subject.addField = function(attr) {
    _fillMissingFields([attr]);
    csr.subject.attributes.push(attr);
  };
  csr.subject.attributes = [];
  csr.subject.hash = null;
  csr.publicKey = null;
  csr.attributes = [];
  csr.getAttribute = function(sn) {
    return _getAttribute(csr, sn);
  };
  csr.addAttribute = function(attr) {
    _fillMissingFields([attr]);
    csr.attributes.push(attr);
  };
  csr.md = null;
  csr.setSubject = function(attrs) {
    _fillMissingFields(attrs);
    csr.subject.attributes = attrs;
    csr.subject.hash = null;
  };
  csr.setAttributes = function(attrs) {
    _fillMissingFields(attrs);
    csr.attributes = attrs;
  };
  csr.sign = function(key, md) {
    csr.md = md || forge$b.md.sha1.create();
    var algorithmOid = oids[csr.md.algorithm + "WithRSAEncryption"];
    if (!algorithmOid) {
      var error = new Error("Could not compute certification request digest. Unknown message digest algorithm OID.");
      error.algorithm = csr.md.algorithm;
      throw error;
    }
    csr.signatureOid = csr.siginfo.algorithmOid = algorithmOid;
    csr.certificationRequestInfo = pki$2.getCertificationRequestInfo(csr);
    var bytes = asn1$4.toDer(csr.certificationRequestInfo);
    csr.md.update(bytes.getBytes());
    csr.signature = key.sign(csr.md);
  };
  csr.verify = function() {
    var rval = false;
    var md = csr.md;
    if (md === null) {
      md = _createSignatureDigest({
        signatureOid: csr.signatureOid,
        type: "certification request"
      });
      var cri = csr.certificationRequestInfo || pki$2.getCertificationRequestInfo(csr);
      var bytes = asn1$4.toDer(cri);
      md.update(bytes.getBytes());
    }
    if (md !== null) {
      rval = _verifySignature({
        certificate: csr,
        md,
        signature: csr.signature
      });
    }
    return rval;
  };
  return csr;
};
function _dnToAsn1(obj) {
  var rval = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, []);
  var attr, set3;
  var attrs = obj.attributes;
  for (var i2 = 0; i2 < attrs.length; ++i2) {
    attr = attrs[i2];
    var value = attr.value;
    var valueTagClass = asn1$4.Type.PRINTABLESTRING;
    if ("valueTagClass" in attr) {
      valueTagClass = attr.valueTagClass;
      if (valueTagClass === asn1$4.Type.UTF8) {
        value = forge$b.util.encodeUtf8(value);
      }
    }
    set3 = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SET, true, [
      asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, [
        asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.OID, false, asn1$4.oidToDer(attr.type).getBytes()),
        asn1$4.create(asn1$4.Class.UNIVERSAL, valueTagClass, false, value)
      ])
    ]);
    rval.value.push(set3);
  }
  return rval;
}
function _fillMissingFields(attrs) {
  var attr;
  for (var i2 = 0; i2 < attrs.length; ++i2) {
    attr = attrs[i2];
    if (typeof attr.name === "undefined") {
      if (attr.type && attr.type in pki$2.oids) {
        attr.name = pki$2.oids[attr.type];
      } else if (attr.shortName && attr.shortName in _shortNames) {
        attr.name = pki$2.oids[_shortNames[attr.shortName]];
      }
    }
    if (typeof attr.type === "undefined") {
      if (attr.name && attr.name in pki$2.oids) {
        attr.type = pki$2.oids[attr.name];
      } else {
        var error = new Error("Attribute type not specified.");
        error.attribute = attr;
        throw error;
      }
    }
    if (typeof attr.shortName === "undefined") {
      if (attr.name && attr.name in _shortNames) {
        attr.shortName = _shortNames[attr.name];
      }
    }
    if (attr.type === oids.extensionRequest) {
      attr.valueConstructed = true;
      attr.valueTagClass = asn1$4.Type.SEQUENCE;
      if (!attr.value && attr.extensions) {
        attr.value = [];
        for (var ei = 0; ei < attr.extensions.length; ++ei) {
          attr.value.push(pki$2.certificateExtensionToAsn1(_fillMissingExtensionFields(attr.extensions[ei])));
        }
      }
    }
    if (typeof attr.value === "undefined") {
      var error = new Error("Attribute value not specified.");
      error.attribute = attr;
      throw error;
    }
  }
}
function _fillMissingExtensionFields(e, options) {
  options = options || {};
  if (typeof e.name === "undefined") {
    if (e.id && e.id in pki$2.oids) {
      e.name = pki$2.oids[e.id];
    }
  }
  if (typeof e.id === "undefined") {
    if (e.name && e.name in pki$2.oids) {
      e.id = pki$2.oids[e.name];
    } else {
      var error = new Error("Extension ID not specified.");
      error.extension = e;
      throw error;
    }
  }
  if (typeof e.value !== "undefined") {
    return e;
  }
  if (e.name === "keyUsage") {
    var unused = 0;
    var b2 = 0;
    var b3 = 0;
    if (e.digitalSignature) {
      b2 |= 128;
      unused = 7;
    }
    if (e.nonRepudiation) {
      b2 |= 64;
      unused = 6;
    }
    if (e.keyEncipherment) {
      b2 |= 32;
      unused = 5;
    }
    if (e.dataEncipherment) {
      b2 |= 16;
      unused = 4;
    }
    if (e.keyAgreement) {
      b2 |= 8;
      unused = 3;
    }
    if (e.keyCertSign) {
      b2 |= 4;
      unused = 2;
    }
    if (e.cRLSign) {
      b2 |= 2;
      unused = 1;
    }
    if (e.encipherOnly) {
      b2 |= 1;
      unused = 0;
    }
    if (e.decipherOnly) {
      b3 |= 128;
      unused = 7;
    }
    var value = String.fromCharCode(unused);
    if (b3 !== 0) {
      value += String.fromCharCode(b2) + String.fromCharCode(b3);
    } else if (b2 !== 0) {
      value += String.fromCharCode(b2);
    }
    e.value = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.BITSTRING, false, value);
  } else if (e.name === "basicConstraints") {
    e.value = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, []);
    if (e.cA) {
      e.value.value.push(asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.BOOLEAN, false, String.fromCharCode(255)));
    }
    if ("pathLenConstraint" in e) {
      e.value.value.push(asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.INTEGER, false, asn1$4.integerToDer(e.pathLenConstraint).getBytes()));
    }
  } else if (e.name === "extKeyUsage") {
    e.value = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, []);
    var seq = e.value.value;
    for (var key in e) {
      if (e[key] !== true) {
        continue;
      }
      if (key in oids) {
        seq.push(asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.OID, false, asn1$4.oidToDer(oids[key]).getBytes()));
      } else if (key.indexOf(".") !== -1) {
        seq.push(asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.OID, false, asn1$4.oidToDer(key).getBytes()));
      }
    }
  } else if (e.name === "nsCertType") {
    var unused = 0;
    var b2 = 0;
    if (e.client) {
      b2 |= 128;
      unused = 7;
    }
    if (e.server) {
      b2 |= 64;
      unused = 6;
    }
    if (e.email) {
      b2 |= 32;
      unused = 5;
    }
    if (e.objsign) {
      b2 |= 16;
      unused = 4;
    }
    if (e.reserved) {
      b2 |= 8;
      unused = 3;
    }
    if (e.sslCA) {
      b2 |= 4;
      unused = 2;
    }
    if (e.emailCA) {
      b2 |= 2;
      unused = 1;
    }
    if (e.objCA) {
      b2 |= 1;
      unused = 0;
    }
    var value = String.fromCharCode(unused);
    if (b2 !== 0) {
      value += String.fromCharCode(b2);
    }
    e.value = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.BITSTRING, false, value);
  } else if (e.name === "subjectAltName" || e.name === "issuerAltName") {
    e.value = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, []);
    var altName;
    for (var n = 0; n < e.altNames.length; ++n) {
      altName = e.altNames[n];
      var value = altName.value;
      if (altName.type === 7 && altName.ip) {
        value = forge$b.util.bytesFromIP(altName.ip);
        if (value === null) {
          var error = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.');
          error.extension = e;
          throw error;
        }
      } else if (altName.type === 8) {
        if (altName.oid) {
          value = asn1$4.oidToDer(asn1$4.oidToDer(altName.oid));
        } else {
          value = asn1$4.oidToDer(value);
        }
      }
      e.value.value.push(asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, altName.type, false, value));
    }
  } else if (e.name === "nsComment" && options.cert) {
    if (!/^[\x00-\x7F]*$/.test(e.comment) || e.comment.length < 1 || e.comment.length > 128) {
      throw new Error('Invalid "nsComment" content.');
    }
    e.value = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.IA5STRING, false, e.comment);
  } else if (e.name === "subjectKeyIdentifier" && options.cert) {
    var ski = options.cert.generateSubjectKeyIdentifier();
    e.subjectKeyIdentifier = ski.toHex();
    e.value = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.OCTETSTRING, false, ski.getBytes());
  } else if (e.name === "authorityKeyIdentifier" && options.cert) {
    e.value = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, []);
    var seq = e.value.value;
    if (e.keyIdentifier) {
      var keyIdentifier = e.keyIdentifier === true ? options.cert.generateSubjectKeyIdentifier().getBytes() : e.keyIdentifier;
      seq.push(asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 0, false, keyIdentifier));
    }
    if (e.authorityCertIssuer) {
      var authorityCertIssuer = [
        asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 4, true, [
          _dnToAsn1(e.authorityCertIssuer === true ? options.cert.issuer : e.authorityCertIssuer)
        ])
      ];
      seq.push(asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 1, true, authorityCertIssuer));
    }
    if (e.serialNumber) {
      var serialNumber = forge$b.util.hexToBytes(e.serialNumber === true ? options.cert.serialNumber : e.serialNumber);
      seq.push(asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 2, false, serialNumber));
    }
  } else if (e.name === "cRLDistributionPoints") {
    e.value = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, []);
    var seq = e.value.value;
    var subSeq = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, []);
    var fullNameGeneralNames = asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 0, true, []);
    var altName;
    for (var n = 0; n < e.altNames.length; ++n) {
      altName = e.altNames[n];
      var value = altName.value;
      if (altName.type === 7 && altName.ip) {
        value = forge$b.util.bytesFromIP(altName.ip);
        if (value === null) {
          var error = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.');
          error.extension = e;
          throw error;
        }
      } else if (altName.type === 8) {
        if (altName.oid) {
          value = asn1$4.oidToDer(asn1$4.oidToDer(altName.oid));
        } else {
          value = asn1$4.oidToDer(value);
        }
      }
      fullNameGeneralNames.value.push(asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, altName.type, false, value));
    }
    subSeq.value.push(asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 0, true, [fullNameGeneralNames]));
    seq.push(subSeq);
  }
  if (typeof e.value === "undefined") {
    var error = new Error("Extension value not specified.");
    error.extension = e;
    throw error;
  }
  return e;
}
function _signatureParametersToAsn1(oid, params) {
  switch (oid) {
    case oids["RSASSA-PSS"]:
      var parts = [];
      if (params.hash.algorithmOid !== void 0) {
        parts.push(asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 0, true, [
          asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, [
            asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.OID, false, asn1$4.oidToDer(params.hash.algorithmOid).getBytes()),
            asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.NULL, false, "")
          ])
        ]));
      }
      if (params.mgf.algorithmOid !== void 0) {
        parts.push(asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 1, true, [
          asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, [
            asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.OID, false, asn1$4.oidToDer(params.mgf.algorithmOid).getBytes()),
            asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, [
              asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.OID, false, asn1$4.oidToDer(params.mgf.hash.algorithmOid).getBytes()),
              asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.NULL, false, "")
            ])
          ])
        ]));
      }
      if (params.saltLength !== void 0) {
        parts.push(asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 2, true, [
          asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.INTEGER, false, asn1$4.integerToDer(params.saltLength).getBytes())
        ]));
      }
      return asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, parts);
    default:
      return asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.NULL, false, "");
  }
}
function _CRIAttributesToAsn1(csr) {
  var rval = asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 0, true, []);
  if (csr.attributes.length === 0) {
    return rval;
  }
  var attrs = csr.attributes;
  for (var i2 = 0; i2 < attrs.length; ++i2) {
    var attr = attrs[i2];
    var value = attr.value;
    var valueTagClass = asn1$4.Type.UTF8;
    if ("valueTagClass" in attr) {
      valueTagClass = attr.valueTagClass;
    }
    if (valueTagClass === asn1$4.Type.UTF8) {
      value = forge$b.util.encodeUtf8(value);
    }
    var valueConstructed = false;
    if ("valueConstructed" in attr) {
      valueConstructed = attr.valueConstructed;
    }
    var seq = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, [
      asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.OID, false, asn1$4.oidToDer(attr.type).getBytes()),
      asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SET, true, [
        asn1$4.create(asn1$4.Class.UNIVERSAL, valueTagClass, valueConstructed, value)
      ])
    ]);
    rval.value.push(seq);
  }
  return rval;
}
var jan_1_1950 = new Date("1950-01-01T00:00:00Z");
var jan_1_2050 = new Date("2050-01-01T00:00:00Z");
function _dateToAsn1(date2) {
  if (date2 >= jan_1_1950 && date2 < jan_1_2050) {
    return asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.UTCTIME, false, asn1$4.dateToUtcTime(date2));
  } else {
    return asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.GENERALIZEDTIME, false, asn1$4.dateToGeneralizedTime(date2));
  }
}
pki$2.getTBSCertificate = function(cert) {
  var notBefore = _dateToAsn1(cert.validity.notBefore);
  var notAfter = _dateToAsn1(cert.validity.notAfter);
  var tbs = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, [
    asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 0, true, [
      asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.INTEGER, false, asn1$4.integerToDer(cert.version).getBytes())
    ]),
    asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.INTEGER, false, forge$b.util.hexToBytes(cert.serialNumber)),
    asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, [
      asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.OID, false, asn1$4.oidToDer(cert.siginfo.algorithmOid).getBytes()),
      _signatureParametersToAsn1(cert.siginfo.algorithmOid, cert.siginfo.parameters)
    ]),
    _dnToAsn1(cert.issuer),
    asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, [
      notBefore,
      notAfter
    ]),
    _dnToAsn1(cert.subject),
    pki$2.publicKeyToAsn1(cert.publicKey)
  ]);
  if (cert.issuer.uniqueId) {
    tbs.value.push(asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 1, true, [
      asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.BITSTRING, false, String.fromCharCode(0) + cert.issuer.uniqueId)
    ]));
  }
  if (cert.subject.uniqueId) {
    tbs.value.push(asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 2, true, [
      asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.BITSTRING, false, String.fromCharCode(0) + cert.subject.uniqueId)
    ]));
  }
  if (cert.extensions.length > 0) {
    tbs.value.push(pki$2.certificateExtensionsToAsn1(cert.extensions));
  }
  return tbs;
};
pki$2.getCertificationRequestInfo = function(csr) {
  var cri = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, [
    asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.INTEGER, false, asn1$4.integerToDer(csr.version).getBytes()),
    _dnToAsn1(csr.subject),
    pki$2.publicKeyToAsn1(csr.publicKey),
    _CRIAttributesToAsn1(csr)
  ]);
  return cri;
};
pki$2.distinguishedNameToAsn1 = function(dn) {
  return _dnToAsn1(dn);
};
pki$2.certificateToAsn1 = function(cert) {
  var tbsCertificate = cert.tbsCertificate || pki$2.getTBSCertificate(cert);
  return asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, [
    tbsCertificate,
    asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, [
      asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.OID, false, asn1$4.oidToDer(cert.signatureOid).getBytes()),
      _signatureParametersToAsn1(cert.signatureOid, cert.signatureParameters)
    ]),
    asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.BITSTRING, false, String.fromCharCode(0) + cert.signature)
  ]);
};
pki$2.certificateExtensionsToAsn1 = function(exts) {
  var rval = asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 3, true, []);
  var seq = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, []);
  rval.value.push(seq);
  for (var i2 = 0; i2 < exts.length; ++i2) {
    seq.value.push(pki$2.certificateExtensionToAsn1(exts[i2]));
  }
  return rval;
};
pki$2.certificateExtensionToAsn1 = function(ext) {
  var extseq = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, []);
  extseq.value.push(asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.OID, false, asn1$4.oidToDer(ext.id).getBytes()));
  if (ext.critical) {
    extseq.value.push(asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.BOOLEAN, false, String.fromCharCode(255)));
  }
  var value = ext.value;
  if (typeof ext.value !== "string") {
    value = asn1$4.toDer(value).getBytes();
  }
  extseq.value.push(asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.OCTETSTRING, false, value));
  return extseq;
};
pki$2.certificationRequestToAsn1 = function(csr) {
  var cri = csr.certificationRequestInfo || pki$2.getCertificationRequestInfo(csr);
  return asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, [
    cri,
    asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, true, [
      asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.OID, false, asn1$4.oidToDer(csr.signatureOid).getBytes()),
      _signatureParametersToAsn1(csr.signatureOid, csr.signatureParameters)
    ]),
    asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.BITSTRING, false, String.fromCharCode(0) + csr.signature)
  ]);
};
pki$2.createCaStore = function(certs) {
  var caStore = {
    certs: {}
  };
  caStore.getIssuer = function(cert2) {
    var rval = getBySubject(cert2.issuer);
    return rval;
  };
  caStore.addCertificate = function(cert2) {
    if (typeof cert2 === "string") {
      cert2 = forge$b.pki.certificateFromPem(cert2);
    }
    ensureSubjectHasHash(cert2.subject);
    if (!caStore.hasCertificate(cert2)) {
      if (cert2.subject.hash in caStore.certs) {
        var tmp = caStore.certs[cert2.subject.hash];
        if (!forge$b.util.isArray(tmp)) {
          tmp = [tmp];
        }
        tmp.push(cert2);
        caStore.certs[cert2.subject.hash] = tmp;
      } else {
        caStore.certs[cert2.subject.hash] = cert2;
      }
    }
  };
  caStore.hasCertificate = function(cert2) {
    if (typeof cert2 === "string") {
      cert2 = forge$b.pki.certificateFromPem(cert2);
    }
    var match = getBySubject(cert2.subject);
    if (!match) {
      return false;
    }
    if (!forge$b.util.isArray(match)) {
      match = [match];
    }
    var der1 = asn1$4.toDer(pki$2.certificateToAsn1(cert2)).getBytes();
    for (var i3 = 0; i3 < match.length; ++i3) {
      var der2 = asn1$4.toDer(pki$2.certificateToAsn1(match[i3])).getBytes();
      if (der1 === der2) {
        return true;
      }
    }
    return false;
  };
  caStore.listAllCertificates = function() {
    var certList = [];
    for (var hash2 in caStore.certs) {
      if (caStore.certs.hasOwnProperty(hash2)) {
        var value = caStore.certs[hash2];
        if (!forge$b.util.isArray(value)) {
          certList.push(value);
        } else {
          for (var i3 = 0; i3 < value.length; ++i3) {
            certList.push(value[i3]);
          }
        }
      }
    }
    return certList;
  };
  caStore.removeCertificate = function(cert2) {
    var result2;
    if (typeof cert2 === "string") {
      cert2 = forge$b.pki.certificateFromPem(cert2);
    }
    ensureSubjectHasHash(cert2.subject);
    if (!caStore.hasCertificate(cert2)) {
      return null;
    }
    var match = getBySubject(cert2.subject);
    if (!forge$b.util.isArray(match)) {
      result2 = caStore.certs[cert2.subject.hash];
      delete caStore.certs[cert2.subject.hash];
      return result2;
    }
    var der1 = asn1$4.toDer(pki$2.certificateToAsn1(cert2)).getBytes();
    for (var i3 = 0; i3 < match.length; ++i3) {
      var der2 = asn1$4.toDer(pki$2.certificateToAsn1(match[i3])).getBytes();
      if (der1 === der2) {
        result2 = match[i3];
        match.splice(i3, 1);
      }
    }
    if (match.length === 0) {
      delete caStore.certs[cert2.subject.hash];
    }
    return result2;
  };
  function getBySubject(subject) {
    ensureSubjectHasHash(subject);
    return caStore.certs[subject.hash] || null;
  }
  function ensureSubjectHasHash(subject) {
    if (!subject.hash) {
      var md = forge$b.md.sha1.create();
      subject.attributes = pki$2.RDNAttributesAsArray(_dnToAsn1(subject), md);
      subject.hash = md.digest().toHex();
    }
  }
  if (certs) {
    for (var i2 = 0; i2 < certs.length; ++i2) {
      var cert = certs[i2];
      caStore.addCertificate(cert);
    }
  }
  return caStore;
};
pki$2.certificateError = {
  bad_certificate: "forge.pki.BadCertificate",
  unsupported_certificate: "forge.pki.UnsupportedCertificate",
  certificate_revoked: "forge.pki.CertificateRevoked",
  certificate_expired: "forge.pki.CertificateExpired",
  certificate_unknown: "forge.pki.CertificateUnknown",
  unknown_ca: "forge.pki.UnknownCertificateAuthority"
};
pki$2.verifyCertificateChain = function(caStore, chain, options) {
  if (typeof options === "function") {
    options = { verify: options };
  }
  options = options || {};
  chain = chain.slice(0);
  var certs = chain.slice(0);
  var validityCheckDate = options.validityCheckDate;
  if (typeof validityCheckDate === "undefined") {
    validityCheckDate = new Date();
  }
  var first = true;
  var error = null;
  var depth = 0;
  do {
    var cert = chain.shift();
    var parent = null;
    var selfSigned = false;
    if (validityCheckDate) {
      if (validityCheckDate < cert.validity.notBefore || validityCheckDate > cert.validity.notAfter) {
        error = {
          message: "Certificate is not valid yet or has expired.",
          error: pki$2.certificateError.certificate_expired,
          notBefore: cert.validity.notBefore,
          notAfter: cert.validity.notAfter,
          now: validityCheckDate
        };
      }
    }
    if (error === null) {
      parent = chain[0] || caStore.getIssuer(cert);
      if (parent === null) {
        if (cert.isIssuer(cert)) {
          selfSigned = true;
          parent = cert;
        }
      }
      if (parent) {
        var parents = parent;
        if (!forge$b.util.isArray(parents)) {
          parents = [parents];
        }
        var verified = false;
        while (!verified && parents.length > 0) {
          parent = parents.shift();
          try {
            verified = parent.verify(cert);
          } catch (ex) {
          }
        }
        if (!verified) {
          error = {
            message: "Certificate signature is invalid.",
            error: pki$2.certificateError.bad_certificate
          };
        }
      }
      if (error === null && (!parent || selfSigned) && !caStore.hasCertificate(cert)) {
        error = {
          message: "Certificate is not trusted.",
          error: pki$2.certificateError.unknown_ca
        };
      }
    }
    if (error === null && parent && !cert.isIssuer(parent)) {
      error = {
        message: "Certificate issuer is invalid.",
        error: pki$2.certificateError.bad_certificate
      };
    }
    if (error === null) {
      var se = {
        keyUsage: true,
        basicConstraints: true
      };
      for (var i2 = 0; error === null && i2 < cert.extensions.length; ++i2) {
        var ext = cert.extensions[i2];
        if (ext.critical && !(ext.name in se)) {
          error = {
            message: "Certificate has an unsupported critical extension.",
            error: pki$2.certificateError.unsupported_certificate
          };
        }
      }
    }
    if (error === null && (!first || chain.length === 0 && (!parent || selfSigned))) {
      var bcExt = cert.getExtension("basicConstraints");
      var keyUsageExt = cert.getExtension("keyUsage");
      if (keyUsageExt !== null) {
        if (!keyUsageExt.keyCertSign || bcExt === null) {
          error = {
            message: "Certificate keyUsage or basicConstraints conflict or indicate that the certificate is not a CA. If the certificate is the only one in the chain or isn't the first then the certificate must be a valid CA.",
            error: pki$2.certificateError.bad_certificate
          };
        }
      }
      if (error === null && bcExt !== null && !bcExt.cA) {
        error = {
          message: "Certificate basicConstraints indicates the certificate is not a CA.",
          error: pki$2.certificateError.bad_certificate
        };
      }
      if (error === null && keyUsageExt !== null && "pathLenConstraint" in bcExt) {
        var pathLen = depth - 1;
        if (pathLen > bcExt.pathLenConstraint) {
          error = {
            message: "Certificate basicConstraints pathLenConstraint violated.",
            error: pki$2.certificateError.bad_certificate
          };
        }
      }
    }
    var vfd = error === null ? true : error.error;
    var ret = options.verify ? options.verify(vfd, depth, certs) : vfd;
    if (ret === true) {
      error = null;
    } else {
      if (vfd === true) {
        error = {
          message: "The application rejected the certificate.",
          error: pki$2.certificateError.bad_certificate
        };
      }
      if (ret || ret === 0) {
        if (typeof ret === "object" && !forge$b.util.isArray(ret)) {
          if (ret.message) {
            error.message = ret.message;
          }
          if (ret.error) {
            error.error = ret.error;
          }
        } else if (typeof ret === "string") {
          error.error = ret;
        }
      }
      throw error;
    }
    first = false;
    ++depth;
  } while (chain.length > 0);
  return true;
};
var forge$a = forge$C;
var asn1$3 = forge$a.asn1;
var pki$1 = forge$a.pki;
var p12 = forge$a.pkcs12 = forge$a.pkcs12 || {};
var contentInfoValidator = {
  name: "ContentInfo",
  tagClass: asn1$3.Class.UNIVERSAL,
  type: asn1$3.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "ContentInfo.contentType",
    tagClass: asn1$3.Class.UNIVERSAL,
    type: asn1$3.Type.OID,
    constructed: false,
    capture: "contentType"
  }, {
    name: "ContentInfo.content",
    tagClass: asn1$3.Class.CONTEXT_SPECIFIC,
    constructed: true,
    captureAsn1: "content"
  }]
};
var pfxValidator = {
  name: "PFX",
  tagClass: asn1$3.Class.UNIVERSAL,
  type: asn1$3.Type.SEQUENCE,
  constructed: true,
  value: [
    {
      name: "PFX.version",
      tagClass: asn1$3.Class.UNIVERSAL,
      type: asn1$3.Type.INTEGER,
      constructed: false,
      capture: "version"
    },
    contentInfoValidator,
    {
      name: "PFX.macData",
      tagClass: asn1$3.Class.UNIVERSAL,
      type: asn1$3.Type.SEQUENCE,
      constructed: true,
      optional: true,
      captureAsn1: "mac",
      value: [{
        name: "PFX.macData.mac",
        tagClass: asn1$3.Class.UNIVERSAL,
        type: asn1$3.Type.SEQUENCE,
        constructed: true,
        value: [{
          name: "PFX.macData.mac.digestAlgorithm",
          tagClass: asn1$3.Class.UNIVERSAL,
          type: asn1$3.Type.SEQUENCE,
          constructed: true,
          value: [{
            name: "PFX.macData.mac.digestAlgorithm.algorithm",
            tagClass: asn1$3.Class.UNIVERSAL,
            type: asn1$3.Type.OID,
            constructed: false,
            capture: "macAlgorithm"
          }, {
            name: "PFX.macData.mac.digestAlgorithm.parameters",
            tagClass: asn1$3.Class.UNIVERSAL,
            captureAsn1: "macAlgorithmParameters"
          }]
        }, {
          name: "PFX.macData.mac.digest",
          tagClass: asn1$3.Class.UNIVERSAL,
          type: asn1$3.Type.OCTETSTRING,
          constructed: false,
          capture: "macDigest"
        }]
      }, {
        name: "PFX.macData.macSalt",
        tagClass: asn1$3.Class.UNIVERSAL,
        type: asn1$3.Type.OCTETSTRING,
        constructed: false,
        capture: "macSalt"
      }, {
        name: "PFX.macData.iterations",
        tagClass: asn1$3.Class.UNIVERSAL,
        type: asn1$3.Type.INTEGER,
        constructed: false,
        optional: true,
        capture: "macIterations"
      }]
    }
  ]
};
var safeBagValidator = {
  name: "SafeBag",
  tagClass: asn1$3.Class.UNIVERSAL,
  type: asn1$3.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "SafeBag.bagId",
    tagClass: asn1$3.Class.UNIVERSAL,
    type: asn1$3.Type.OID,
    constructed: false,
    capture: "bagId"
  }, {
    name: "SafeBag.bagValue",
    tagClass: asn1$3.Class.CONTEXT_SPECIFIC,
    constructed: true,
    captureAsn1: "bagValue"
  }, {
    name: "SafeBag.bagAttributes",
    tagClass: asn1$3.Class.UNIVERSAL,
    type: asn1$3.Type.SET,
    constructed: true,
    optional: true,
    capture: "bagAttributes"
  }]
};
var attributeValidator = {
  name: "Attribute",
  tagClass: asn1$3.Class.UNIVERSAL,
  type: asn1$3.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "Attribute.attrId",
    tagClass: asn1$3.Class.UNIVERSAL,
    type: asn1$3.Type.OID,
    constructed: false,
    capture: "oid"
  }, {
    name: "Attribute.attrValues",
    tagClass: asn1$3.Class.UNIVERSAL,
    type: asn1$3.Type.SET,
    constructed: true,
    capture: "values"
  }]
};
var certBagValidator = {
  name: "CertBag",
  tagClass: asn1$3.Class.UNIVERSAL,
  type: asn1$3.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "CertBag.certId",
    tagClass: asn1$3.Class.UNIVERSAL,
    type: asn1$3.Type.OID,
    constructed: false,
    capture: "certId"
  }, {
    name: "CertBag.certValue",
    tagClass: asn1$3.Class.CONTEXT_SPECIFIC,
    constructed: true,
    value: [{
      name: "CertBag.certValue[0]",
      tagClass: asn1$3.Class.UNIVERSAL,
      type: asn1$3.Class.OCTETSTRING,
      constructed: false,
      capture: "cert"
    }]
  }]
};
function _getBagsByAttribute(safeContents, attrName, attrValue, bagType) {
  var result2 = [];
  for (var i2 = 0; i2 < safeContents.length; i2++) {
    for (var j = 0; j < safeContents[i2].safeBags.length; j++) {
      var bag = safeContents[i2].safeBags[j];
      if (bagType !== void 0 && bag.type !== bagType) {
        continue;
      }
      if (attrName === null) {
        result2.push(bag);
        continue;
      }
      if (bag.attributes[attrName] !== void 0 && bag.attributes[attrName].indexOf(attrValue) >= 0) {
        result2.push(bag);
      }
    }
  }
  return result2;
}
p12.pkcs12FromAsn1 = function(obj, strict, password) {
  if (typeof strict === "string") {
    password = strict;
    strict = true;
  } else if (strict === void 0) {
    strict = true;
  }
  var capture = {};
  var errors = [];
  if (!asn1$3.validate(obj, pfxValidator, capture, errors)) {
    var error = new Error("Cannot read PKCS#12 PFX. ASN.1 object is not an PKCS#12 PFX.");
    error.errors = error;
    throw error;
  }
  var pfx = {
    version: capture.version.charCodeAt(0),
    safeContents: [],
    getBags: function(filter2) {
      var rval = {};
      var localKeyId;
      if ("localKeyId" in filter2) {
        localKeyId = filter2.localKeyId;
      } else if ("localKeyIdHex" in filter2) {
        localKeyId = forge$a.util.hexToBytes(filter2.localKeyIdHex);
      }
      if (localKeyId === void 0 && !("friendlyName" in filter2) && "bagType" in filter2) {
        rval[filter2.bagType] = _getBagsByAttribute(pfx.safeContents, null, null, filter2.bagType);
      }
      if (localKeyId !== void 0) {
        rval.localKeyId = _getBagsByAttribute(pfx.safeContents, "localKeyId", localKeyId, filter2.bagType);
      }
      if ("friendlyName" in filter2) {
        rval.friendlyName = _getBagsByAttribute(pfx.safeContents, "friendlyName", filter2.friendlyName, filter2.bagType);
      }
      return rval;
    },
    getBagsByFriendlyName: function(friendlyName, bagType) {
      return _getBagsByAttribute(pfx.safeContents, "friendlyName", friendlyName, bagType);
    },
    getBagsByLocalKeyId: function(localKeyId, bagType) {
      return _getBagsByAttribute(pfx.safeContents, "localKeyId", localKeyId, bagType);
    }
  };
  if (capture.version.charCodeAt(0) !== 3) {
    var error = new Error("PKCS#12 PFX of version other than 3 not supported.");
    error.version = capture.version.charCodeAt(0);
    throw error;
  }
  if (asn1$3.derToOid(capture.contentType) !== pki$1.oids.data) {
    var error = new Error("Only PKCS#12 PFX in password integrity mode supported.");
    error.oid = asn1$3.derToOid(capture.contentType);
    throw error;
  }
  var data = capture.content.value[0];
  if (data.tagClass !== asn1$3.Class.UNIVERSAL || data.type !== asn1$3.Type.OCTETSTRING) {
    throw new Error("PKCS#12 authSafe content data is not an OCTET STRING.");
  }
  data = _decodePkcs7Data(data);
  if (capture.mac) {
    var md = null;
    var macKeyBytes = 0;
    var macAlgorithm = asn1$3.derToOid(capture.macAlgorithm);
    switch (macAlgorithm) {
      case pki$1.oids.sha1:
        md = forge$a.md.sha1.create();
        macKeyBytes = 20;
        break;
      case pki$1.oids.sha256:
        md = forge$a.md.sha256.create();
        macKeyBytes = 32;
        break;
      case pki$1.oids.sha384:
        md = forge$a.md.sha384.create();
        macKeyBytes = 48;
        break;
      case pki$1.oids.sha512:
        md = forge$a.md.sha512.create();
        macKeyBytes = 64;
        break;
      case pki$1.oids.md5:
        md = forge$a.md.md5.create();
        macKeyBytes = 16;
        break;
    }
    if (md === null) {
      throw new Error("PKCS#12 uses unsupported MAC algorithm: " + macAlgorithm);
    }
    var macSalt = new forge$a.util.ByteBuffer(capture.macSalt);
    var macIterations = "macIterations" in capture ? parseInt(forge$a.util.bytesToHex(capture.macIterations), 16) : 1;
    var macKey = p12.generateKey(password, macSalt, 3, macIterations, macKeyBytes, md);
    var mac2 = forge$a.hmac.create();
    mac2.start(md, macKey);
    mac2.update(data.value);
    var macValue = mac2.getMac();
    if (macValue.getBytes() !== capture.macDigest) {
      throw new Error("PKCS#12 MAC could not be verified. Invalid password?");
    }
  }
  _decodeAuthenticatedSafe(pfx, data.value, strict, password);
  return pfx;
};
function _decodePkcs7Data(data) {
  if (data.composed || data.constructed) {
    var value = forge$a.util.createBuffer();
    for (var i2 = 0; i2 < data.value.length; ++i2) {
      value.putBytes(data.value[i2].value);
    }
    data.composed = data.constructed = false;
    data.value = value.getBytes();
  }
  return data;
}
function _decodeAuthenticatedSafe(pfx, authSafe, strict, password) {
  authSafe = asn1$3.fromDer(authSafe, strict);
  if (authSafe.tagClass !== asn1$3.Class.UNIVERSAL || authSafe.type !== asn1$3.Type.SEQUENCE || authSafe.constructed !== true) {
    throw new Error("PKCS#12 AuthenticatedSafe expected to be a SEQUENCE OF ContentInfo");
  }
  for (var i2 = 0; i2 < authSafe.value.length; i2++) {
    var contentInfo = authSafe.value[i2];
    var capture = {};
    var errors = [];
    if (!asn1$3.validate(contentInfo, contentInfoValidator, capture, errors)) {
      var error = new Error("Cannot read ContentInfo.");
      error.errors = errors;
      throw error;
    }
    var obj = {
      encrypted: false
    };
    var safeContents = null;
    var data = capture.content.value[0];
    switch (asn1$3.derToOid(capture.contentType)) {
      case pki$1.oids.data:
        if (data.tagClass !== asn1$3.Class.UNIVERSAL || data.type !== asn1$3.Type.OCTETSTRING) {
          throw new Error("PKCS#12 SafeContents Data is not an OCTET STRING.");
        }
        safeContents = _decodePkcs7Data(data).value;
        break;
      case pki$1.oids.encryptedData:
        safeContents = _decryptSafeContents(data, password);
        obj.encrypted = true;
        break;
      default:
        var error = new Error("Unsupported PKCS#12 contentType.");
        error.contentType = asn1$3.derToOid(capture.contentType);
        throw error;
    }
    obj.safeBags = _decodeSafeContents(safeContents, strict, password);
    pfx.safeContents.push(obj);
  }
}
function _decryptSafeContents(data, password) {
  var capture = {};
  var errors = [];
  if (!asn1$3.validate(data, forge$a.pkcs7.asn1.encryptedDataValidator, capture, errors)) {
    var error = new Error("Cannot read EncryptedContentInfo.");
    error.errors = errors;
    throw error;
  }
  var oid = asn1$3.derToOid(capture.contentType);
  if (oid !== pki$1.oids.data) {
    var error = new Error("PKCS#12 EncryptedContentInfo ContentType is not Data.");
    error.oid = oid;
    throw error;
  }
  oid = asn1$3.derToOid(capture.encAlgorithm);
  var cipher = pki$1.pbe.getCipher(oid, capture.encParameter, password);
  var encryptedContentAsn1 = _decodePkcs7Data(capture.encryptedContentAsn1);
  var encrypted = forge$a.util.createBuffer(encryptedContentAsn1.value);
  cipher.update(encrypted);
  if (!cipher.finish()) {
    throw new Error("Failed to decrypt PKCS#12 SafeContents.");
  }
  return cipher.output.getBytes();
}
function _decodeSafeContents(safeContents, strict, password) {
  if (!strict && safeContents.length === 0) {
    return [];
  }
  safeContents = asn1$3.fromDer(safeContents, strict);
  if (safeContents.tagClass !== asn1$3.Class.UNIVERSAL || safeContents.type !== asn1$3.Type.SEQUENCE || safeContents.constructed !== true) {
    throw new Error("PKCS#12 SafeContents expected to be a SEQUENCE OF SafeBag.");
  }
  var res = [];
  for (var i2 = 0; i2 < safeContents.value.length; i2++) {
    var safeBag = safeContents.value[i2];
    var capture = {};
    var errors = [];
    if (!asn1$3.validate(safeBag, safeBagValidator, capture, errors)) {
      var error = new Error("Cannot read SafeBag.");
      error.errors = errors;
      throw error;
    }
    var bag = {
      type: asn1$3.derToOid(capture.bagId),
      attributes: _decodeBagAttributes(capture.bagAttributes)
    };
    res.push(bag);
    var validator2, decoder;
    var bagAsn1 = capture.bagValue.value[0];
    switch (bag.type) {
      case pki$1.oids.pkcs8ShroudedKeyBag:
        bagAsn1 = pki$1.decryptPrivateKeyInfo(bagAsn1, password);
        if (bagAsn1 === null) {
          throw new Error("Unable to decrypt PKCS#8 ShroudedKeyBag, wrong password?");
        }
      case pki$1.oids.keyBag:
        try {
          bag.key = pki$1.privateKeyFromAsn1(bagAsn1);
        } catch (e) {
          bag.key = null;
          bag.asn1 = bagAsn1;
        }
        continue;
      case pki$1.oids.certBag:
        validator2 = certBagValidator;
        decoder = function() {
          if (asn1$3.derToOid(capture.certId) !== pki$1.oids.x509Certificate) {
            var error2 = new Error("Unsupported certificate type, only X.509 supported.");
            error2.oid = asn1$3.derToOid(capture.certId);
            throw error2;
          }
          var certAsn1 = asn1$3.fromDer(capture.cert, strict);
          try {
            bag.cert = pki$1.certificateFromAsn1(certAsn1, true);
          } catch (e) {
            bag.cert = null;
            bag.asn1 = certAsn1;
          }
        };
        break;
      default:
        var error = new Error("Unsupported PKCS#12 SafeBag type.");
        error.oid = bag.type;
        throw error;
    }
    if (validator2 !== void 0 && !asn1$3.validate(bagAsn1, validator2, capture, errors)) {
      var error = new Error("Cannot read PKCS#12 " + validator2.name);
      error.errors = errors;
      throw error;
    }
    decoder();
  }
  return res;
}
function _decodeBagAttributes(attributes) {
  var decodedAttrs = {};
  if (attributes !== void 0) {
    for (var i2 = 0; i2 < attributes.length; ++i2) {
      var capture = {};
      var errors = [];
      if (!asn1$3.validate(attributes[i2], attributeValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#12 BagAttribute.");
        error.errors = errors;
        throw error;
      }
      var oid = asn1$3.derToOid(capture.oid);
      if (pki$1.oids[oid] === void 0) {
        continue;
      }
      decodedAttrs[pki$1.oids[oid]] = [];
      for (var j = 0; j < capture.values.length; ++j) {
        decodedAttrs[pki$1.oids[oid]].push(capture.values[j].value);
      }
    }
  }
  return decodedAttrs;
}
p12.toPkcs12Asn1 = function(key, cert, password, options) {
  options = options || {};
  options.saltSize = options.saltSize || 8;
  options.count = options.count || 2048;
  options.algorithm = options.algorithm || options.encAlgorithm || "aes128";
  if (!("useMac" in options)) {
    options.useMac = true;
  }
  if (!("localKeyId" in options)) {
    options.localKeyId = null;
  }
  if (!("generateLocalKeyId" in options)) {
    options.generateLocalKeyId = true;
  }
  var localKeyId = options.localKeyId;
  var bagAttrs;
  if (localKeyId !== null) {
    localKeyId = forge$a.util.hexToBytes(localKeyId);
  } else if (options.generateLocalKeyId) {
    if (cert) {
      var pairedCert = forge$a.util.isArray(cert) ? cert[0] : cert;
      if (typeof pairedCert === "string") {
        pairedCert = pki$1.certificateFromPem(pairedCert);
      }
      var sha12 = forge$a.md.sha1.create();
      sha12.update(asn1$3.toDer(pki$1.certificateToAsn1(pairedCert)).getBytes());
      localKeyId = sha12.digest().getBytes();
    } else {
      localKeyId = forge$a.random.getBytes(20);
    }
  }
  var attrs = [];
  if (localKeyId !== null) {
    attrs.push(asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, true, [
      asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.OID, false, asn1$3.oidToDer(pki$1.oids.localKeyId).getBytes()),
      asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SET, true, [
        asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.OCTETSTRING, false, localKeyId)
      ])
    ]));
  }
  if ("friendlyName" in options) {
    attrs.push(asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, true, [
      asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.OID, false, asn1$3.oidToDer(pki$1.oids.friendlyName).getBytes()),
      asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SET, true, [
        asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.BMPSTRING, false, options.friendlyName)
      ])
    ]));
  }
  if (attrs.length > 0) {
    bagAttrs = asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SET, true, attrs);
  }
  var contents = [];
  var chain = [];
  if (cert !== null) {
    if (forge$a.util.isArray(cert)) {
      chain = cert;
    } else {
      chain = [cert];
    }
  }
  var certSafeBags = [];
  for (var i2 = 0; i2 < chain.length; ++i2) {
    cert = chain[i2];
    if (typeof cert === "string") {
      cert = pki$1.certificateFromPem(cert);
    }
    var certBagAttrs = i2 === 0 ? bagAttrs : void 0;
    var certAsn1 = pki$1.certificateToAsn1(cert);
    var certSafeBag = asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, true, [
      asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.OID, false, asn1$3.oidToDer(pki$1.oids.certBag).getBytes()),
      asn1$3.create(asn1$3.Class.CONTEXT_SPECIFIC, 0, true, [
        asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, true, [
          asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.OID, false, asn1$3.oidToDer(pki$1.oids.x509Certificate).getBytes()),
          asn1$3.create(asn1$3.Class.CONTEXT_SPECIFIC, 0, true, [
            asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.OCTETSTRING, false, asn1$3.toDer(certAsn1).getBytes())
          ])
        ])
      ]),
      certBagAttrs
    ]);
    certSafeBags.push(certSafeBag);
  }
  if (certSafeBags.length > 0) {
    var certSafeContents = asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, true, certSafeBags);
    var certCI = asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, true, [
      asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.OID, false, asn1$3.oidToDer(pki$1.oids.data).getBytes()),
      asn1$3.create(asn1$3.Class.CONTEXT_SPECIFIC, 0, true, [
        asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.OCTETSTRING, false, asn1$3.toDer(certSafeContents).getBytes())
      ])
    ]);
    contents.push(certCI);
  }
  var keyBag = null;
  if (key !== null) {
    var pkAsn1 = pki$1.wrapRsaPrivateKey(pki$1.privateKeyToAsn1(key));
    if (password === null) {
      keyBag = asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, true, [
        asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.OID, false, asn1$3.oidToDer(pki$1.oids.keyBag).getBytes()),
        asn1$3.create(asn1$3.Class.CONTEXT_SPECIFIC, 0, true, [
          pkAsn1
        ]),
        bagAttrs
      ]);
    } else {
      keyBag = asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, true, [
        asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.OID, false, asn1$3.oidToDer(pki$1.oids.pkcs8ShroudedKeyBag).getBytes()),
        asn1$3.create(asn1$3.Class.CONTEXT_SPECIFIC, 0, true, [
          pki$1.encryptPrivateKeyInfo(pkAsn1, password, options)
        ]),
        bagAttrs
      ]);
    }
    var keySafeContents = asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, true, [keyBag]);
    var keyCI = asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, true, [
      asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.OID, false, asn1$3.oidToDer(pki$1.oids.data).getBytes()),
      asn1$3.create(asn1$3.Class.CONTEXT_SPECIFIC, 0, true, [
        asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.OCTETSTRING, false, asn1$3.toDer(keySafeContents).getBytes())
      ])
    ]);
    contents.push(keyCI);
  }
  var safe = asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, true, contents);
  var macData;
  if (options.useMac) {
    var sha12 = forge$a.md.sha1.create();
    var macSalt = new forge$a.util.ByteBuffer(forge$a.random.getBytes(options.saltSize));
    var count = options.count;
    var key = p12.generateKey(password, macSalt, 3, count, 20);
    var mac2 = forge$a.hmac.create();
    mac2.start(sha12, key);
    mac2.update(asn1$3.toDer(safe).getBytes());
    var macValue = mac2.getMac();
    macData = asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, true, [
      asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, true, [
        asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, true, [
          asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.OID, false, asn1$3.oidToDer(pki$1.oids.sha1).getBytes()),
          asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.NULL, false, "")
        ]),
        asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.OCTETSTRING, false, macValue.getBytes())
      ]),
      asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.OCTETSTRING, false, macSalt.getBytes()),
      asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.INTEGER, false, asn1$3.integerToDer(count).getBytes())
    ]);
  }
  return asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, true, [
    asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.INTEGER, false, asn1$3.integerToDer(3).getBytes()),
    asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, true, [
      asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.OID, false, asn1$3.oidToDer(pki$1.oids.data).getBytes()),
      asn1$3.create(asn1$3.Class.CONTEXT_SPECIFIC, 0, true, [
        asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.OCTETSTRING, false, asn1$3.toDer(safe).getBytes())
      ])
    ]),
    macData
  ]);
};
p12.generateKey = forge$a.pbe.generatePkcs12Key;
var forge$9 = forge$C;
var asn1$2 = forge$9.asn1;
var pki = forge$9.pki = forge$9.pki || {};
pki.pemToDer = function(pem2) {
  var msg = forge$9.pem.decode(pem2)[0];
  if (msg.procType && msg.procType.type === "ENCRYPTED") {
    throw new Error("Could not convert PEM to DER; PEM is encrypted.");
  }
  return forge$9.util.createBuffer(msg.body);
};
pki.privateKeyFromPem = function(pem2) {
  var msg = forge$9.pem.decode(pem2)[0];
  if (msg.type !== "PRIVATE KEY" && msg.type !== "RSA PRIVATE KEY") {
    var error = new Error('Could not convert private key from PEM; PEM header type is not "PRIVATE KEY" or "RSA PRIVATE KEY".');
    error.headerType = msg.type;
    throw error;
  }
  if (msg.procType && msg.procType.type === "ENCRYPTED") {
    throw new Error("Could not convert private key from PEM; PEM is encrypted.");
  }
  var obj = asn1$2.fromDer(msg.body);
  return pki.privateKeyFromAsn1(obj);
};
pki.privateKeyToPem = function(key, maxline) {
  var msg = {
    type: "RSA PRIVATE KEY",
    body: asn1$2.toDer(pki.privateKeyToAsn1(key)).getBytes()
  };
  return forge$9.pem.encode(msg, { maxline });
};
pki.privateKeyInfoToPem = function(pki2, maxline) {
  var msg = {
    type: "PRIVATE KEY",
    body: asn1$2.toDer(pki2).getBytes()
  };
  return forge$9.pem.encode(msg, { maxline });
};
var forge$8 = forge$C;
var prf_TLS1 = function(secret, label, seed, length) {
  var rval = forge$8.util.createBuffer();
  var idx = secret.length >> 1;
  var slen = idx + (secret.length & 1);
  var s1 = secret.substr(0, slen);
  var s2 = secret.substr(idx, slen);
  var ai = forge$8.util.createBuffer();
  var hmac2 = forge$8.hmac.create();
  seed = label + seed;
  var md5itr = Math.ceil(length / 16);
  var sha1itr = Math.ceil(length / 20);
  hmac2.start("MD5", s1);
  var md5bytes = forge$8.util.createBuffer();
  ai.putBytes(seed);
  for (var i2 = 0; i2 < md5itr; ++i2) {
    hmac2.start(null, null);
    hmac2.update(ai.getBytes());
    ai.putBuffer(hmac2.digest());
    hmac2.start(null, null);
    hmac2.update(ai.bytes() + seed);
    md5bytes.putBuffer(hmac2.digest());
  }
  hmac2.start("SHA1", s2);
  var sha1bytes = forge$8.util.createBuffer();
  ai.clear();
  ai.putBytes(seed);
  for (var i2 = 0; i2 < sha1itr; ++i2) {
    hmac2.start(null, null);
    hmac2.update(ai.getBytes());
    ai.putBuffer(hmac2.digest());
    hmac2.start(null, null);
    hmac2.update(ai.bytes() + seed);
    sha1bytes.putBuffer(hmac2.digest());
  }
  rval.putBytes(forge$8.util.xorBytes(md5bytes.getBytes(), sha1bytes.getBytes(), length));
  return rval;
};
var hmac_sha1 = function(key, seqNum, record) {
  var hmac2 = forge$8.hmac.create();
  hmac2.start("SHA1", key);
  var b = forge$8.util.createBuffer();
  b.putInt32(seqNum[0]);
  b.putInt32(seqNum[1]);
  b.putByte(record.type);
  b.putByte(record.version.major);
  b.putByte(record.version.minor);
  b.putInt16(record.length);
  b.putBytes(record.fragment.bytes());
  hmac2.update(b.getBytes());
  return hmac2.digest().getBytes();
};
var deflate = function(c, record, s2) {
  var rval = false;
  try {
    var bytes = c.deflate(record.fragment.getBytes());
    record.fragment = forge$8.util.createBuffer(bytes);
    record.length = bytes.length;
    rval = true;
  } catch (ex) {
  }
  return rval;
};
var inflate = function(c, record, s2) {
  var rval = false;
  try {
    var bytes = c.inflate(record.fragment.getBytes());
    record.fragment = forge$8.util.createBuffer(bytes);
    record.length = bytes.length;
    rval = true;
  } catch (ex) {
  }
  return rval;
};
var readVector = function(b, lenBytes) {
  var len = 0;
  switch (lenBytes) {
    case 1:
      len = b.getByte();
      break;
    case 2:
      len = b.getInt16();
      break;
    case 3:
      len = b.getInt24();
      break;
    case 4:
      len = b.getInt32();
      break;
  }
  return forge$8.util.createBuffer(b.getBytes(len));
};
var writeVector = function(b, lenBytes, v2) {
  b.putInt(v2.length(), lenBytes << 3);
  b.putBuffer(v2);
};
var tls$1 = {};
tls$1.Versions = {
  TLS_1_0: { major: 3, minor: 1 },
  TLS_1_1: { major: 3, minor: 2 },
  TLS_1_2: { major: 3, minor: 3 }
};
tls$1.SupportedVersions = [
  tls$1.Versions.TLS_1_1,
  tls$1.Versions.TLS_1_0
];
tls$1.Version = tls$1.SupportedVersions[0];
tls$1.MaxFragment = 16384 - 1024;
tls$1.ConnectionEnd = {
  server: 0,
  client: 1
};
tls$1.PRFAlgorithm = {
  tls_prf_sha256: 0
};
tls$1.BulkCipherAlgorithm = {
  none: null,
  rc4: 0,
  des3: 1,
  aes: 2
};
tls$1.CipherType = {
  stream: 0,
  block: 1,
  aead: 2
};
tls$1.MACAlgorithm = {
  none: null,
  hmac_md5: 0,
  hmac_sha1: 1,
  hmac_sha256: 2,
  hmac_sha384: 3,
  hmac_sha512: 4
};
tls$1.CompressionMethod = {
  none: 0,
  deflate: 1
};
tls$1.ContentType = {
  change_cipher_spec: 20,
  alert: 21,
  handshake: 22,
  application_data: 23,
  heartbeat: 24
};
tls$1.HandshakeType = {
  hello_request: 0,
  client_hello: 1,
  server_hello: 2,
  certificate: 11,
  server_key_exchange: 12,
  certificate_request: 13,
  server_hello_done: 14,
  certificate_verify: 15,
  client_key_exchange: 16,
  finished: 20
};
tls$1.Alert = {};
tls$1.Alert.Level = {
  warning: 1,
  fatal: 2
};
tls$1.Alert.Description = {
  close_notify: 0,
  unexpected_message: 10,
  bad_record_mac: 20,
  decryption_failed: 21,
  record_overflow: 22,
  decompression_failure: 30,
  handshake_failure: 40,
  bad_certificate: 42,
  unsupported_certificate: 43,
  certificate_revoked: 44,
  certificate_expired: 45,
  certificate_unknown: 46,
  illegal_parameter: 47,
  unknown_ca: 48,
  access_denied: 49,
  decode_error: 50,
  decrypt_error: 51,
  export_restriction: 60,
  protocol_version: 70,
  insufficient_security: 71,
  internal_error: 80,
  user_canceled: 90,
  no_renegotiation: 100
};
tls$1.HeartbeatMessageType = {
  heartbeat_request: 1,
  heartbeat_response: 2
};
tls$1.CipherSuites = {};
tls$1.getCipherSuite = function(twoBytes) {
  var rval = null;
  for (var key in tls$1.CipherSuites) {
    var cs = tls$1.CipherSuites[key];
    if (cs.id[0] === twoBytes.charCodeAt(0) && cs.id[1] === twoBytes.charCodeAt(1)) {
      rval = cs;
      break;
    }
  }
  return rval;
};
tls$1.handleUnexpected = function(c, record) {
  var ignore = !c.open && c.entity === tls$1.ConnectionEnd.client;
  if (!ignore) {
    c.error(c, {
      message: "Unexpected message. Received TLS record out of order.",
      send: true,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.unexpected_message
      }
    });
  }
};
tls$1.handleHelloRequest = function(c, record, length) {
  if (!c.handshaking && c.handshakes > 0) {
    tls$1.queue(c, tls$1.createAlert(c, {
      level: tls$1.Alert.Level.warning,
      description: tls$1.Alert.Description.no_renegotiation
    }));
    tls$1.flush(c);
  }
  c.process();
};
tls$1.parseHelloMessage = function(c, record, length) {
  var msg = null;
  var client2 = c.entity === tls$1.ConnectionEnd.client;
  if (length < 38) {
    c.error(c, {
      message: client2 ? "Invalid ServerHello message. Message too short." : "Invalid ClientHello message. Message too short.",
      send: true,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.illegal_parameter
      }
    });
  } else {
    var b = record.fragment;
    var remaining = b.length();
    msg = {
      version: {
        major: b.getByte(),
        minor: b.getByte()
      },
      random: forge$8.util.createBuffer(b.getBytes(32)),
      session_id: readVector(b, 1),
      extensions: []
    };
    if (client2) {
      msg.cipher_suite = b.getBytes(2);
      msg.compression_method = b.getByte();
    } else {
      msg.cipher_suites = readVector(b, 2);
      msg.compression_methods = readVector(b, 1);
    }
    remaining = length - (remaining - b.length());
    if (remaining > 0) {
      var exts = readVector(b, 2);
      while (exts.length() > 0) {
        msg.extensions.push({
          type: [exts.getByte(), exts.getByte()],
          data: readVector(exts, 2)
        });
      }
      if (!client2) {
        for (var i2 = 0; i2 < msg.extensions.length; ++i2) {
          var ext = msg.extensions[i2];
          if (ext.type[0] === 0 && ext.type[1] === 0) {
            var snl = readVector(ext.data, 2);
            while (snl.length() > 0) {
              var snType = snl.getByte();
              if (snType !== 0) {
                break;
              }
              c.session.extensions.server_name.serverNameList.push(readVector(snl, 2).getBytes());
            }
          }
        }
      }
    }
    if (c.session.version) {
      if (msg.version.major !== c.session.version.major || msg.version.minor !== c.session.version.minor) {
        return c.error(c, {
          message: "TLS version change is disallowed during renegotiation.",
          send: true,
          alert: {
            level: tls$1.Alert.Level.fatal,
            description: tls$1.Alert.Description.protocol_version
          }
        });
      }
    }
    if (client2) {
      c.session.cipherSuite = tls$1.getCipherSuite(msg.cipher_suite);
    } else {
      var tmp = forge$8.util.createBuffer(msg.cipher_suites.bytes());
      while (tmp.length() > 0) {
        c.session.cipherSuite = tls$1.getCipherSuite(tmp.getBytes(2));
        if (c.session.cipherSuite !== null) {
          break;
        }
      }
    }
    if (c.session.cipherSuite === null) {
      return c.error(c, {
        message: "No cipher suites in common.",
        send: true,
        alert: {
          level: tls$1.Alert.Level.fatal,
          description: tls$1.Alert.Description.handshake_failure
        },
        cipherSuite: forge$8.util.bytesToHex(msg.cipher_suite)
      });
    }
    if (client2) {
      c.session.compressionMethod = msg.compression_method;
    } else {
      c.session.compressionMethod = tls$1.CompressionMethod.none;
    }
  }
  return msg;
};
tls$1.createSecurityParameters = function(c, msg) {
  var client2 = c.entity === tls$1.ConnectionEnd.client;
  var msgRandom = msg.random.bytes();
  var cRandom = client2 ? c.session.sp.client_random : msgRandom;
  var sRandom = client2 ? msgRandom : tls$1.createRandom().getBytes();
  c.session.sp = {
    entity: c.entity,
    prf_algorithm: tls$1.PRFAlgorithm.tls_prf_sha256,
    bulk_cipher_algorithm: null,
    cipher_type: null,
    enc_key_length: null,
    block_length: null,
    fixed_iv_length: null,
    record_iv_length: null,
    mac_algorithm: null,
    mac_length: null,
    mac_key_length: null,
    compression_algorithm: c.session.compressionMethod,
    pre_master_secret: null,
    master_secret: null,
    client_random: cRandom,
    server_random: sRandom
  };
};
tls$1.handleServerHello = function(c, record, length) {
  var msg = tls$1.parseHelloMessage(c, record, length);
  if (c.fail) {
    return;
  }
  if (msg.version.minor <= c.version.minor) {
    c.version.minor = msg.version.minor;
  } else {
    return c.error(c, {
      message: "Incompatible TLS version.",
      send: true,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.protocol_version
      }
    });
  }
  c.session.version = c.version;
  var sessionId = msg.session_id.bytes();
  if (sessionId.length > 0 && sessionId === c.session.id) {
    c.expect = SCC;
    c.session.resuming = true;
    c.session.sp.server_random = msg.random.bytes();
  } else {
    c.expect = SCE;
    c.session.resuming = false;
    tls$1.createSecurityParameters(c, msg);
  }
  c.session.id = sessionId;
  c.process();
};
tls$1.handleClientHello = function(c, record, length) {
  var msg = tls$1.parseHelloMessage(c, record, length);
  if (c.fail) {
    return;
  }
  var sessionId = msg.session_id.bytes();
  var session = null;
  if (c.sessionCache) {
    session = c.sessionCache.getSession(sessionId);
    if (session === null) {
      sessionId = "";
    } else if (session.version.major !== msg.version.major || session.version.minor > msg.version.minor) {
      session = null;
      sessionId = "";
    }
  }
  if (sessionId.length === 0) {
    sessionId = forge$8.random.getBytes(32);
  }
  c.session.id = sessionId;
  c.session.clientHelloVersion = msg.version;
  c.session.sp = {};
  if (session) {
    c.version = c.session.version = session.version;
    c.session.sp = session.sp;
  } else {
    var version;
    for (var i2 = 1; i2 < tls$1.SupportedVersions.length; ++i2) {
      version = tls$1.SupportedVersions[i2];
      if (version.minor <= msg.version.minor) {
        break;
      }
    }
    c.version = { major: version.major, minor: version.minor };
    c.session.version = c.version;
  }
  if (session !== null) {
    c.expect = CCC;
    c.session.resuming = true;
    c.session.sp.client_random = msg.random.bytes();
  } else {
    c.expect = c.verifyClient !== false ? CCE : CKE;
    c.session.resuming = false;
    tls$1.createSecurityParameters(c, msg);
  }
  c.open = true;
  tls$1.queue(c, tls$1.createRecord(c, {
    type: tls$1.ContentType.handshake,
    data: tls$1.createServerHello(c)
  }));
  if (c.session.resuming) {
    tls$1.queue(c, tls$1.createRecord(c, {
      type: tls$1.ContentType.change_cipher_spec,
      data: tls$1.createChangeCipherSpec()
    }));
    c.state.pending = tls$1.createConnectionState(c);
    c.state.current.write = c.state.pending.write;
    tls$1.queue(c, tls$1.createRecord(c, {
      type: tls$1.ContentType.handshake,
      data: tls$1.createFinished(c)
    }));
  } else {
    tls$1.queue(c, tls$1.createRecord(c, {
      type: tls$1.ContentType.handshake,
      data: tls$1.createCertificate(c)
    }));
    if (!c.fail) {
      tls$1.queue(c, tls$1.createRecord(c, {
        type: tls$1.ContentType.handshake,
        data: tls$1.createServerKeyExchange(c)
      }));
      if (c.verifyClient !== false) {
        tls$1.queue(c, tls$1.createRecord(c, {
          type: tls$1.ContentType.handshake,
          data: tls$1.createCertificateRequest(c)
        }));
      }
      tls$1.queue(c, tls$1.createRecord(c, {
        type: tls$1.ContentType.handshake,
        data: tls$1.createServerHelloDone(c)
      }));
    }
  }
  tls$1.flush(c);
  c.process();
};
tls$1.handleCertificate = function(c, record, length) {
  if (length < 3) {
    return c.error(c, {
      message: "Invalid Certificate message. Message too short.",
      send: true,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.illegal_parameter
      }
    });
  }
  var b = record.fragment;
  var msg = {
    certificate_list: readVector(b, 3)
  };
  var cert, asn12;
  var certs = [];
  try {
    while (msg.certificate_list.length() > 0) {
      cert = readVector(msg.certificate_list, 3);
      asn12 = forge$8.asn1.fromDer(cert);
      cert = forge$8.pki.certificateFromAsn1(asn12, true);
      certs.push(cert);
    }
  } catch (ex) {
    return c.error(c, {
      message: "Could not parse certificate list.",
      cause: ex,
      send: true,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.bad_certificate
      }
    });
  }
  var client2 = c.entity === tls$1.ConnectionEnd.client;
  if ((client2 || c.verifyClient === true) && certs.length === 0) {
    c.error(c, {
      message: client2 ? "No server certificate provided." : "No client certificate provided.",
      send: true,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.illegal_parameter
      }
    });
  } else if (certs.length === 0) {
    c.expect = client2 ? SKE : CKE;
  } else {
    if (client2) {
      c.session.serverCertificate = certs[0];
    } else {
      c.session.clientCertificate = certs[0];
    }
    if (tls$1.verifyCertificateChain(c, certs)) {
      c.expect = client2 ? SKE : CKE;
    }
  }
  c.process();
};
tls$1.handleServerKeyExchange = function(c, record, length) {
  if (length > 0) {
    return c.error(c, {
      message: "Invalid key parameters. Only RSA is supported.",
      send: true,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.unsupported_certificate
      }
    });
  }
  c.expect = SCR;
  c.process();
};
tls$1.handleClientKeyExchange = function(c, record, length) {
  if (length < 48) {
    return c.error(c, {
      message: "Invalid key parameters. Only RSA is supported.",
      send: true,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.unsupported_certificate
      }
    });
  }
  var b = record.fragment;
  var msg = {
    enc_pre_master_secret: readVector(b, 2).getBytes()
  };
  var privateKey = null;
  if (c.getPrivateKey) {
    try {
      privateKey = c.getPrivateKey(c, c.session.serverCertificate);
      privateKey = forge$8.pki.privateKeyFromPem(privateKey);
    } catch (ex) {
      c.error(c, {
        message: "Could not get private key.",
        cause: ex,
        send: true,
        alert: {
          level: tls$1.Alert.Level.fatal,
          description: tls$1.Alert.Description.internal_error
        }
      });
    }
  }
  if (privateKey === null) {
    return c.error(c, {
      message: "No private key set.",
      send: true,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.internal_error
      }
    });
  }
  try {
    var sp = c.session.sp;
    sp.pre_master_secret = privateKey.decrypt(msg.enc_pre_master_secret);
    var version = c.session.clientHelloVersion;
    if (version.major !== sp.pre_master_secret.charCodeAt(0) || version.minor !== sp.pre_master_secret.charCodeAt(1)) {
      throw new Error("TLS version rollback attack detected.");
    }
  } catch (ex) {
    sp.pre_master_secret = forge$8.random.getBytes(48);
  }
  c.expect = CCC;
  if (c.session.clientCertificate !== null) {
    c.expect = CCV;
  }
  c.process();
};
tls$1.handleCertificateRequest = function(c, record, length) {
  if (length < 3) {
    return c.error(c, {
      message: "Invalid CertificateRequest. Message too short.",
      send: true,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.illegal_parameter
      }
    });
  }
  var b = record.fragment;
  var msg = {
    certificate_types: readVector(b, 1),
    certificate_authorities: readVector(b, 2)
  };
  c.session.certificateRequest = msg;
  c.expect = SHD;
  c.process();
};
tls$1.handleCertificateVerify = function(c, record, length) {
  if (length < 2) {
    return c.error(c, {
      message: "Invalid CertificateVerify. Message too short.",
      send: true,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.illegal_parameter
      }
    });
  }
  var b = record.fragment;
  b.read -= 4;
  var msgBytes = b.bytes();
  b.read += 4;
  var msg = {
    signature: readVector(b, 2).getBytes()
  };
  var verify = forge$8.util.createBuffer();
  verify.putBuffer(c.session.md5.digest());
  verify.putBuffer(c.session.sha1.digest());
  verify = verify.getBytes();
  try {
    var cert = c.session.clientCertificate;
    if (!cert.publicKey.verify(verify, msg.signature, "NONE")) {
      throw new Error("CertificateVerify signature does not match.");
    }
    c.session.md5.update(msgBytes);
    c.session.sha1.update(msgBytes);
  } catch (ex) {
    return c.error(c, {
      message: "Bad signature in CertificateVerify.",
      send: true,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.handshake_failure
      }
    });
  }
  c.expect = CCC;
  c.process();
};
tls$1.handleServerHelloDone = function(c, record, length) {
  if (length > 0) {
    return c.error(c, {
      message: "Invalid ServerHelloDone message. Invalid length.",
      send: true,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.record_overflow
      }
    });
  }
  if (c.serverCertificate === null) {
    var error = {
      message: "No server certificate provided. Not enough security.",
      send: true,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.insufficient_security
      }
    };
    var depth = 0;
    var ret = c.verify(c, error.alert.description, depth, []);
    if (ret !== true) {
      if (ret || ret === 0) {
        if (typeof ret === "object" && !forge$8.util.isArray(ret)) {
          if (ret.message) {
            error.message = ret.message;
          }
          if (ret.alert) {
            error.alert.description = ret.alert;
          }
        } else if (typeof ret === "number") {
          error.alert.description = ret;
        }
      }
      return c.error(c, error);
    }
  }
  if (c.session.certificateRequest !== null) {
    record = tls$1.createRecord(c, {
      type: tls$1.ContentType.handshake,
      data: tls$1.createCertificate(c)
    });
    tls$1.queue(c, record);
  }
  record = tls$1.createRecord(c, {
    type: tls$1.ContentType.handshake,
    data: tls$1.createClientKeyExchange(c)
  });
  tls$1.queue(c, record);
  c.expect = SER;
  var callback = function(c2, signature) {
    if (c2.session.certificateRequest !== null && c2.session.clientCertificate !== null) {
      tls$1.queue(c2, tls$1.createRecord(c2, {
        type: tls$1.ContentType.handshake,
        data: tls$1.createCertificateVerify(c2, signature)
      }));
    }
    tls$1.queue(c2, tls$1.createRecord(c2, {
      type: tls$1.ContentType.change_cipher_spec,
      data: tls$1.createChangeCipherSpec()
    }));
    c2.state.pending = tls$1.createConnectionState(c2);
    c2.state.current.write = c2.state.pending.write;
    tls$1.queue(c2, tls$1.createRecord(c2, {
      type: tls$1.ContentType.handshake,
      data: tls$1.createFinished(c2)
    }));
    c2.expect = SCC;
    tls$1.flush(c2);
    c2.process();
  };
  if (c.session.certificateRequest === null || c.session.clientCertificate === null) {
    return callback(c, null);
  }
  tls$1.getClientSignature(c, callback);
};
tls$1.handleChangeCipherSpec = function(c, record) {
  if (record.fragment.getByte() !== 1) {
    return c.error(c, {
      message: "Invalid ChangeCipherSpec message received.",
      send: true,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.illegal_parameter
      }
    });
  }
  var client2 = c.entity === tls$1.ConnectionEnd.client;
  if (c.session.resuming && client2 || !c.session.resuming && !client2) {
    c.state.pending = tls$1.createConnectionState(c);
  }
  c.state.current.read = c.state.pending.read;
  if (!c.session.resuming && client2 || c.session.resuming && !client2) {
    c.state.pending = null;
  }
  c.expect = client2 ? SFI : CFI;
  c.process();
};
tls$1.handleFinished = function(c, record, length) {
  var b = record.fragment;
  b.read -= 4;
  var msgBytes = b.bytes();
  b.read += 4;
  var vd = record.fragment.getBytes();
  b = forge$8.util.createBuffer();
  b.putBuffer(c.session.md5.digest());
  b.putBuffer(c.session.sha1.digest());
  var client2 = c.entity === tls$1.ConnectionEnd.client;
  var label = client2 ? "server finished" : "client finished";
  var sp = c.session.sp;
  var vdl = 12;
  var prf = prf_TLS1;
  b = prf(sp.master_secret, label, b.getBytes(), vdl);
  if (b.getBytes() !== vd) {
    return c.error(c, {
      message: "Invalid verify_data in Finished message.",
      send: true,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.decrypt_error
      }
    });
  }
  c.session.md5.update(msgBytes);
  c.session.sha1.update(msgBytes);
  if (c.session.resuming && client2 || !c.session.resuming && !client2) {
    tls$1.queue(c, tls$1.createRecord(c, {
      type: tls$1.ContentType.change_cipher_spec,
      data: tls$1.createChangeCipherSpec()
    }));
    c.state.current.write = c.state.pending.write;
    c.state.pending = null;
    tls$1.queue(c, tls$1.createRecord(c, {
      type: tls$1.ContentType.handshake,
      data: tls$1.createFinished(c)
    }));
  }
  c.expect = client2 ? SAD : CAD;
  c.handshaking = false;
  ++c.handshakes;
  c.peerCertificate = client2 ? c.session.serverCertificate : c.session.clientCertificate;
  tls$1.flush(c);
  c.isConnected = true;
  c.connected(c);
  c.process();
};
tls$1.handleAlert = function(c, record) {
  var b = record.fragment;
  var alert2 = {
    level: b.getByte(),
    description: b.getByte()
  };
  var msg;
  switch (alert2.description) {
    case tls$1.Alert.Description.close_notify:
      msg = "Connection closed.";
      break;
    case tls$1.Alert.Description.unexpected_message:
      msg = "Unexpected message.";
      break;
    case tls$1.Alert.Description.bad_record_mac:
      msg = "Bad record MAC.";
      break;
    case tls$1.Alert.Description.decryption_failed:
      msg = "Decryption failed.";
      break;
    case tls$1.Alert.Description.record_overflow:
      msg = "Record overflow.";
      break;
    case tls$1.Alert.Description.decompression_failure:
      msg = "Decompression failed.";
      break;
    case tls$1.Alert.Description.handshake_failure:
      msg = "Handshake failure.";
      break;
    case tls$1.Alert.Description.bad_certificate:
      msg = "Bad certificate.";
      break;
    case tls$1.Alert.Description.unsupported_certificate:
      msg = "Unsupported certificate.";
      break;
    case tls$1.Alert.Description.certificate_revoked:
      msg = "Certificate revoked.";
      break;
    case tls$1.Alert.Description.certificate_expired:
      msg = "Certificate expired.";
      break;
    case tls$1.Alert.Description.certificate_unknown:
      msg = "Certificate unknown.";
      break;
    case tls$1.Alert.Description.illegal_parameter:
      msg = "Illegal parameter.";
      break;
    case tls$1.Alert.Description.unknown_ca:
      msg = "Unknown certificate authority.";
      break;
    case tls$1.Alert.Description.access_denied:
      msg = "Access denied.";
      break;
    case tls$1.Alert.Description.decode_error:
      msg = "Decode error.";
      break;
    case tls$1.Alert.Description.decrypt_error:
      msg = "Decrypt error.";
      break;
    case tls$1.Alert.Description.export_restriction:
      msg = "Export restriction.";
      break;
    case tls$1.Alert.Description.protocol_version:
      msg = "Unsupported protocol version.";
      break;
    case tls$1.Alert.Description.insufficient_security:
      msg = "Insufficient security.";
      break;
    case tls$1.Alert.Description.internal_error:
      msg = "Internal error.";
      break;
    case tls$1.Alert.Description.user_canceled:
      msg = "User canceled.";
      break;
    case tls$1.Alert.Description.no_renegotiation:
      msg = "Renegotiation not supported.";
      break;
    default:
      msg = "Unknown error.";
      break;
  }
  if (alert2.description === tls$1.Alert.Description.close_notify) {
    return c.close();
  }
  c.error(c, {
    message: msg,
    send: false,
    origin: c.entity === tls$1.ConnectionEnd.client ? "server" : "client",
    alert: alert2
  });
  c.process();
};
tls$1.handleHandshake = function(c, record) {
  var b = record.fragment;
  var type = b.getByte();
  var length = b.getInt24();
  if (length > b.length()) {
    c.fragmented = record;
    record.fragment = forge$8.util.createBuffer();
    b.read -= 4;
    return c.process();
  }
  c.fragmented = null;
  b.read -= 4;
  var bytes = b.bytes(length + 4);
  b.read += 4;
  if (type in hsTable[c.entity][c.expect]) {
    if (c.entity === tls$1.ConnectionEnd.server && !c.open && !c.fail) {
      c.handshaking = true;
      c.session = {
        version: null,
        extensions: {
          server_name: {
            serverNameList: []
          }
        },
        cipherSuite: null,
        compressionMethod: null,
        serverCertificate: null,
        clientCertificate: null,
        md5: forge$8.md.md5.create(),
        sha1: forge$8.md.sha1.create()
      };
    }
    if (type !== tls$1.HandshakeType.hello_request && type !== tls$1.HandshakeType.certificate_verify && type !== tls$1.HandshakeType.finished) {
      c.session.md5.update(bytes);
      c.session.sha1.update(bytes);
    }
    hsTable[c.entity][c.expect][type](c, record, length);
  } else {
    tls$1.handleUnexpected(c, record);
  }
};
tls$1.handleApplicationData = function(c, record) {
  c.data.putBuffer(record.fragment);
  c.dataReady(c);
  c.process();
};
tls$1.handleHeartbeat = function(c, record) {
  var b = record.fragment;
  var type = b.getByte();
  var length = b.getInt16();
  var payload = b.getBytes(length);
  if (type === tls$1.HeartbeatMessageType.heartbeat_request) {
    if (c.handshaking || length > payload.length) {
      return c.process();
    }
    tls$1.queue(c, tls$1.createRecord(c, {
      type: tls$1.ContentType.heartbeat,
      data: tls$1.createHeartbeat(tls$1.HeartbeatMessageType.heartbeat_response, payload)
    }));
    tls$1.flush(c);
  } else if (type === tls$1.HeartbeatMessageType.heartbeat_response) {
    if (payload !== c.expectedHeartbeatPayload) {
      return c.process();
    }
    if (c.heartbeatReceived) {
      c.heartbeatReceived(c, forge$8.util.createBuffer(payload));
    }
  }
  c.process();
};
var SHE = 0;
var SCE = 1;
var SKE = 2;
var SCR = 3;
var SHD = 4;
var SCC = 5;
var SFI = 6;
var SAD = 7;
var SER = 8;
var CHE = 0;
var CCE = 1;
var CKE = 2;
var CCV = 3;
var CCC = 4;
var CFI = 5;
var CAD = 6;
var __ = tls$1.handleUnexpected;
var R0 = tls$1.handleChangeCipherSpec;
var R1 = tls$1.handleAlert;
var R2 = tls$1.handleHandshake;
var R3 = tls$1.handleApplicationData;
var R4 = tls$1.handleHeartbeat;
var ctTable = [];
ctTable[tls$1.ConnectionEnd.client] = [
  [__, R1, R2, __, R4],
  [__, R1, R2, __, R4],
  [__, R1, R2, __, R4],
  [__, R1, R2, __, R4],
  [__, R1, R2, __, R4],
  [R0, R1, __, __, R4],
  [__, R1, R2, __, R4],
  [__, R1, R2, R3, R4],
  [__, R1, R2, __, R4]
];
ctTable[tls$1.ConnectionEnd.server] = [
  [__, R1, R2, __, R4],
  [__, R1, R2, __, R4],
  [__, R1, R2, __, R4],
  [__, R1, R2, __, R4],
  [R0, R1, __, __, R4],
  [__, R1, R2, __, R4],
  [__, R1, R2, R3, R4],
  [__, R1, R2, __, R4]
];
var H0 = tls$1.handleHelloRequest;
var H1 = tls$1.handleServerHello;
var H2 = tls$1.handleCertificate;
var H3 = tls$1.handleServerKeyExchange;
var H4 = tls$1.handleCertificateRequest;
var H5 = tls$1.handleServerHelloDone;
var H6 = tls$1.handleFinished;
var hsTable = [];
hsTable[tls$1.ConnectionEnd.client] = [
  [__, __, H1, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __],
  [H0, __, __, __, __, __, __, __, __, __, __, H2, H3, H4, H5, __, __, __, __, __, __],
  [H0, __, __, __, __, __, __, __, __, __, __, __, H3, H4, H5, __, __, __, __, __, __],
  [H0, __, __, __, __, __, __, __, __, __, __, __, __, H4, H5, __, __, __, __, __, __],
  [H0, __, __, __, __, __, __, __, __, __, __, __, __, __, H5, __, __, __, __, __, __],
  [H0, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __],
  [H0, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, H6],
  [H0, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __],
  [H0, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __]
];
var H7 = tls$1.handleClientHello;
var H8 = tls$1.handleClientKeyExchange;
var H9 = tls$1.handleCertificateVerify;
hsTable[tls$1.ConnectionEnd.server] = [
  [__, H7, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __],
  [__, __, __, __, __, __, __, __, __, __, __, H2, __, __, __, __, __, __, __, __, __],
  [__, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, H8, __, __, __, __],
  [__, __, __, __, __, __, __, __, __, __, __, __, __, __, __, H9, __, __, __, __, __],
  [__, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __],
  [__, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, H6],
  [__, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __],
  [__, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __]
];
tls$1.generateKeys = function(c, sp) {
  var prf = prf_TLS1;
  var random = sp.client_random + sp.server_random;
  if (!c.session.resuming) {
    sp.master_secret = prf(sp.pre_master_secret, "master secret", random, 48).bytes();
    sp.pre_master_secret = null;
  }
  random = sp.server_random + sp.client_random;
  var length = 2 * sp.mac_key_length + 2 * sp.enc_key_length;
  var tls10 = c.version.major === tls$1.Versions.TLS_1_0.major && c.version.minor === tls$1.Versions.TLS_1_0.minor;
  if (tls10) {
    length += 2 * sp.fixed_iv_length;
  }
  var km = prf(sp.master_secret, "key expansion", random, length);
  var rval = {
    client_write_MAC_key: km.getBytes(sp.mac_key_length),
    server_write_MAC_key: km.getBytes(sp.mac_key_length),
    client_write_key: km.getBytes(sp.enc_key_length),
    server_write_key: km.getBytes(sp.enc_key_length)
  };
  if (tls10) {
    rval.client_write_IV = km.getBytes(sp.fixed_iv_length);
    rval.server_write_IV = km.getBytes(sp.fixed_iv_length);
  }
  return rval;
};
tls$1.createConnectionState = function(c) {
  var client2 = c.entity === tls$1.ConnectionEnd.client;
  var createMode = function() {
    var mode = {
      sequenceNumber: [0, 0],
      macKey: null,
      macLength: 0,
      macFunction: null,
      cipherState: null,
      cipherFunction: function(record) {
        return true;
      },
      compressionState: null,
      compressFunction: function(record) {
        return true;
      },
      updateSequenceNumber: function() {
        if (mode.sequenceNumber[1] === 4294967295) {
          mode.sequenceNumber[1] = 0;
          ++mode.sequenceNumber[0];
        } else {
          ++mode.sequenceNumber[1];
        }
      }
    };
    return mode;
  };
  var state = {
    read: createMode(),
    write: createMode()
  };
  state.read.update = function(c2, record) {
    if (!state.read.cipherFunction(record, state.read)) {
      c2.error(c2, {
        message: "Could not decrypt record or bad MAC.",
        send: true,
        alert: {
          level: tls$1.Alert.Level.fatal,
          description: tls$1.Alert.Description.bad_record_mac
        }
      });
    } else if (!state.read.compressFunction(c2, record, state.read)) {
      c2.error(c2, {
        message: "Could not decompress record.",
        send: true,
        alert: {
          level: tls$1.Alert.Level.fatal,
          description: tls$1.Alert.Description.decompression_failure
        }
      });
    }
    return !c2.fail;
  };
  state.write.update = function(c2, record) {
    if (!state.write.compressFunction(c2, record, state.write)) {
      c2.error(c2, {
        message: "Could not compress record.",
        send: false,
        alert: {
          level: tls$1.Alert.Level.fatal,
          description: tls$1.Alert.Description.internal_error
        }
      });
    } else if (!state.write.cipherFunction(record, state.write)) {
      c2.error(c2, {
        message: "Could not encrypt record.",
        send: false,
        alert: {
          level: tls$1.Alert.Level.fatal,
          description: tls$1.Alert.Description.internal_error
        }
      });
    }
    return !c2.fail;
  };
  if (c.session) {
    var sp = c.session.sp;
    c.session.cipherSuite.initSecurityParameters(sp);
    sp.keys = tls$1.generateKeys(c, sp);
    state.read.macKey = client2 ? sp.keys.server_write_MAC_key : sp.keys.client_write_MAC_key;
    state.write.macKey = client2 ? sp.keys.client_write_MAC_key : sp.keys.server_write_MAC_key;
    c.session.cipherSuite.initConnectionState(state, c, sp);
    switch (sp.compression_algorithm) {
      case tls$1.CompressionMethod.none:
        break;
      case tls$1.CompressionMethod.deflate:
        state.read.compressFunction = inflate;
        state.write.compressFunction = deflate;
        break;
      default:
        throw new Error("Unsupported compression algorithm.");
    }
  }
  return state;
};
tls$1.createRandom = function() {
  var d = new Date();
  var utc = +d + d.getTimezoneOffset() * 6e4;
  var rval = forge$8.util.createBuffer();
  rval.putInt32(utc);
  rval.putBytes(forge$8.random.getBytes(28));
  return rval;
};
tls$1.createRecord = function(c, options) {
  if (!options.data) {
    return null;
  }
  var record = {
    type: options.type,
    version: {
      major: c.version.major,
      minor: c.version.minor
    },
    length: options.data.length(),
    fragment: options.data
  };
  return record;
};
tls$1.createAlert = function(c, alert2) {
  var b = forge$8.util.createBuffer();
  b.putByte(alert2.level);
  b.putByte(alert2.description);
  return tls$1.createRecord(c, {
    type: tls$1.ContentType.alert,
    data: b
  });
};
tls$1.createClientHello = function(c) {
  c.session.clientHelloVersion = {
    major: c.version.major,
    minor: c.version.minor
  };
  var cipherSuites = forge$8.util.createBuffer();
  for (var i2 = 0; i2 < c.cipherSuites.length; ++i2) {
    var cs = c.cipherSuites[i2];
    cipherSuites.putByte(cs.id[0]);
    cipherSuites.putByte(cs.id[1]);
  }
  var cSuites = cipherSuites.length();
  var compressionMethods = forge$8.util.createBuffer();
  compressionMethods.putByte(tls$1.CompressionMethod.none);
  var cMethods = compressionMethods.length();
  var extensions = forge$8.util.createBuffer();
  if (c.virtualHost) {
    var ext = forge$8.util.createBuffer();
    ext.putByte(0);
    ext.putByte(0);
    var serverName = forge$8.util.createBuffer();
    serverName.putByte(0);
    writeVector(serverName, 2, forge$8.util.createBuffer(c.virtualHost));
    var snList = forge$8.util.createBuffer();
    writeVector(snList, 2, serverName);
    writeVector(ext, 2, snList);
    extensions.putBuffer(ext);
  }
  var extLength = extensions.length();
  if (extLength > 0) {
    extLength += 2;
  }
  var sessionId = c.session.id;
  var length = sessionId.length + 1 + 2 + 4 + 28 + 2 + cSuites + 1 + cMethods + extLength;
  var rval = forge$8.util.createBuffer();
  rval.putByte(tls$1.HandshakeType.client_hello);
  rval.putInt24(length);
  rval.putByte(c.version.major);
  rval.putByte(c.version.minor);
  rval.putBytes(c.session.sp.client_random);
  writeVector(rval, 1, forge$8.util.createBuffer(sessionId));
  writeVector(rval, 2, cipherSuites);
  writeVector(rval, 1, compressionMethods);
  if (extLength > 0) {
    writeVector(rval, 2, extensions);
  }
  return rval;
};
tls$1.createServerHello = function(c) {
  var sessionId = c.session.id;
  var length = sessionId.length + 1 + 2 + 4 + 28 + 2 + 1;
  var rval = forge$8.util.createBuffer();
  rval.putByte(tls$1.HandshakeType.server_hello);
  rval.putInt24(length);
  rval.putByte(c.version.major);
  rval.putByte(c.version.minor);
  rval.putBytes(c.session.sp.server_random);
  writeVector(rval, 1, forge$8.util.createBuffer(sessionId));
  rval.putByte(c.session.cipherSuite.id[0]);
  rval.putByte(c.session.cipherSuite.id[1]);
  rval.putByte(c.session.compressionMethod);
  return rval;
};
tls$1.createCertificate = function(c) {
  var client2 = c.entity === tls$1.ConnectionEnd.client;
  var cert = null;
  if (c.getCertificate) {
    var hint;
    if (client2) {
      hint = c.session.certificateRequest;
    } else {
      hint = c.session.extensions.server_name.serverNameList;
    }
    cert = c.getCertificate(c, hint);
  }
  var certList = forge$8.util.createBuffer();
  if (cert !== null) {
    try {
      if (!forge$8.util.isArray(cert)) {
        cert = [cert];
      }
      var asn12 = null;
      for (var i2 = 0; i2 < cert.length; ++i2) {
        var msg = forge$8.pem.decode(cert[i2])[0];
        if (msg.type !== "CERTIFICATE" && msg.type !== "X509 CERTIFICATE" && msg.type !== "TRUSTED CERTIFICATE") {
          var error = new Error('Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".');
          error.headerType = msg.type;
          throw error;
        }
        if (msg.procType && msg.procType.type === "ENCRYPTED") {
          throw new Error("Could not convert certificate from PEM; PEM is encrypted.");
        }
        var der = forge$8.util.createBuffer(msg.body);
        if (asn12 === null) {
          asn12 = forge$8.asn1.fromDer(der.bytes(), false);
        }
        var certBuffer = forge$8.util.createBuffer();
        writeVector(certBuffer, 3, der);
        certList.putBuffer(certBuffer);
      }
      cert = forge$8.pki.certificateFromAsn1(asn12);
      if (client2) {
        c.session.clientCertificate = cert;
      } else {
        c.session.serverCertificate = cert;
      }
    } catch (ex) {
      return c.error(c, {
        message: "Could not send certificate list.",
        cause: ex,
        send: true,
        alert: {
          level: tls$1.Alert.Level.fatal,
          description: tls$1.Alert.Description.bad_certificate
        }
      });
    }
  }
  var length = 3 + certList.length();
  var rval = forge$8.util.createBuffer();
  rval.putByte(tls$1.HandshakeType.certificate);
  rval.putInt24(length);
  writeVector(rval, 3, certList);
  return rval;
};
tls$1.createClientKeyExchange = function(c) {
  var b = forge$8.util.createBuffer();
  b.putByte(c.session.clientHelloVersion.major);
  b.putByte(c.session.clientHelloVersion.minor);
  b.putBytes(forge$8.random.getBytes(46));
  var sp = c.session.sp;
  sp.pre_master_secret = b.getBytes();
  var key = c.session.serverCertificate.publicKey;
  b = key.encrypt(sp.pre_master_secret);
  var length = b.length + 2;
  var rval = forge$8.util.createBuffer();
  rval.putByte(tls$1.HandshakeType.client_key_exchange);
  rval.putInt24(length);
  rval.putInt16(b.length);
  rval.putBytes(b);
  return rval;
};
tls$1.createServerKeyExchange = function(c) {
  var rval = forge$8.util.createBuffer();
  return rval;
};
tls$1.getClientSignature = function(c, callback) {
  var b = forge$8.util.createBuffer();
  b.putBuffer(c.session.md5.digest());
  b.putBuffer(c.session.sha1.digest());
  b = b.getBytes();
  c.getSignature = c.getSignature || function(c2, b2, callback2) {
    var privateKey = null;
    if (c2.getPrivateKey) {
      try {
        privateKey = c2.getPrivateKey(c2, c2.session.clientCertificate);
        privateKey = forge$8.pki.privateKeyFromPem(privateKey);
      } catch (ex) {
        c2.error(c2, {
          message: "Could not get private key.",
          cause: ex,
          send: true,
          alert: {
            level: tls$1.Alert.Level.fatal,
            description: tls$1.Alert.Description.internal_error
          }
        });
      }
    }
    if (privateKey === null) {
      c2.error(c2, {
        message: "No private key set.",
        send: true,
        alert: {
          level: tls$1.Alert.Level.fatal,
          description: tls$1.Alert.Description.internal_error
        }
      });
    } else {
      b2 = privateKey.sign(b2, null);
    }
    callback2(c2, b2);
  };
  c.getSignature(c, b, callback);
};
tls$1.createCertificateVerify = function(c, signature) {
  var length = signature.length + 2;
  var rval = forge$8.util.createBuffer();
  rval.putByte(tls$1.HandshakeType.certificate_verify);
  rval.putInt24(length);
  rval.putInt16(signature.length);
  rval.putBytes(signature);
  return rval;
};
tls$1.createCertificateRequest = function(c) {
  var certTypes = forge$8.util.createBuffer();
  certTypes.putByte(1);
  var cAs = forge$8.util.createBuffer();
  for (var key in c.caStore.certs) {
    var cert = c.caStore.certs[key];
    var dn = forge$8.pki.distinguishedNameToAsn1(cert.subject);
    var byteBuffer = forge$8.asn1.toDer(dn);
    cAs.putInt16(byteBuffer.length());
    cAs.putBuffer(byteBuffer);
  }
  var length = 1 + certTypes.length() + 2 + cAs.length();
  var rval = forge$8.util.createBuffer();
  rval.putByte(tls$1.HandshakeType.certificate_request);
  rval.putInt24(length);
  writeVector(rval, 1, certTypes);
  writeVector(rval, 2, cAs);
  return rval;
};
tls$1.createServerHelloDone = function(c) {
  var rval = forge$8.util.createBuffer();
  rval.putByte(tls$1.HandshakeType.server_hello_done);
  rval.putInt24(0);
  return rval;
};
tls$1.createChangeCipherSpec = function() {
  var rval = forge$8.util.createBuffer();
  rval.putByte(1);
  return rval;
};
tls$1.createFinished = function(c) {
  var b = forge$8.util.createBuffer();
  b.putBuffer(c.session.md5.digest());
  b.putBuffer(c.session.sha1.digest());
  var client2 = c.entity === tls$1.ConnectionEnd.client;
  var sp = c.session.sp;
  var vdl = 12;
  var prf = prf_TLS1;
  var label = client2 ? "client finished" : "server finished";
  b = prf(sp.master_secret, label, b.getBytes(), vdl);
  var rval = forge$8.util.createBuffer();
  rval.putByte(tls$1.HandshakeType.finished);
  rval.putInt24(b.length());
  rval.putBuffer(b);
  return rval;
};
tls$1.createHeartbeat = function(type, payload, payloadLength) {
  if (typeof payloadLength === "undefined") {
    payloadLength = payload.length;
  }
  var rval = forge$8.util.createBuffer();
  rval.putByte(type);
  rval.putInt16(payloadLength);
  rval.putBytes(payload);
  var plaintextLength = rval.length();
  var paddingLength = Math.max(16, plaintextLength - payloadLength - 3);
  rval.putBytes(forge$8.random.getBytes(paddingLength));
  return rval;
};
tls$1.queue = function(c, record) {
  if (!record) {
    return;
  }
  if (record.fragment.length() === 0) {
    if (record.type === tls$1.ContentType.handshake || record.type === tls$1.ContentType.alert || record.type === tls$1.ContentType.change_cipher_spec) {
      return;
    }
  }
  if (record.type === tls$1.ContentType.handshake) {
    var bytes = record.fragment.bytes();
    c.session.md5.update(bytes);
    c.session.sha1.update(bytes);
    bytes = null;
  }
  var records;
  if (record.fragment.length() <= tls$1.MaxFragment) {
    records = [record];
  } else {
    records = [];
    var data = record.fragment.bytes();
    while (data.length > tls$1.MaxFragment) {
      records.push(tls$1.createRecord(c, {
        type: record.type,
        data: forge$8.util.createBuffer(data.slice(0, tls$1.MaxFragment))
      }));
      data = data.slice(tls$1.MaxFragment);
    }
    if (data.length > 0) {
      records.push(tls$1.createRecord(c, {
        type: record.type,
        data: forge$8.util.createBuffer(data)
      }));
    }
  }
  for (var i2 = 0; i2 < records.length && !c.fail; ++i2) {
    var rec = records[i2];
    var s2 = c.state.current.write;
    if (s2.update(c, rec)) {
      c.records.push(rec);
    }
  }
};
tls$1.flush = function(c) {
  for (var i2 = 0; i2 < c.records.length; ++i2) {
    var record = c.records[i2];
    c.tlsData.putByte(record.type);
    c.tlsData.putByte(record.version.major);
    c.tlsData.putByte(record.version.minor);
    c.tlsData.putInt16(record.fragment.length());
    c.tlsData.putBuffer(c.records[i2].fragment);
  }
  c.records = [];
  return c.tlsDataReady(c);
};
var _certErrorToAlertDesc = function(error) {
  switch (error) {
    case true:
      return true;
    case forge$8.pki.certificateError.bad_certificate:
      return tls$1.Alert.Description.bad_certificate;
    case forge$8.pki.certificateError.unsupported_certificate:
      return tls$1.Alert.Description.unsupported_certificate;
    case forge$8.pki.certificateError.certificate_revoked:
      return tls$1.Alert.Description.certificate_revoked;
    case forge$8.pki.certificateError.certificate_expired:
      return tls$1.Alert.Description.certificate_expired;
    case forge$8.pki.certificateError.certificate_unknown:
      return tls$1.Alert.Description.certificate_unknown;
    case forge$8.pki.certificateError.unknown_ca:
      return tls$1.Alert.Description.unknown_ca;
    default:
      return tls$1.Alert.Description.bad_certificate;
  }
};
var _alertDescToCertError = function(desc) {
  switch (desc) {
    case true:
      return true;
    case tls$1.Alert.Description.bad_certificate:
      return forge$8.pki.certificateError.bad_certificate;
    case tls$1.Alert.Description.unsupported_certificate:
      return forge$8.pki.certificateError.unsupported_certificate;
    case tls$1.Alert.Description.certificate_revoked:
      return forge$8.pki.certificateError.certificate_revoked;
    case tls$1.Alert.Description.certificate_expired:
      return forge$8.pki.certificateError.certificate_expired;
    case tls$1.Alert.Description.certificate_unknown:
      return forge$8.pki.certificateError.certificate_unknown;
    case tls$1.Alert.Description.unknown_ca:
      return forge$8.pki.certificateError.unknown_ca;
    default:
      return forge$8.pki.certificateError.bad_certificate;
  }
};
tls$1.verifyCertificateChain = function(c, chain) {
  try {
    var options = {};
    for (var key in c.verifyOptions) {
      options[key] = c.verifyOptions[key];
    }
    options.verify = function(vfd, depth, chain2) {
      var desc = _certErrorToAlertDesc(vfd);
      var ret = c.verify(c, vfd, depth, chain2);
      if (ret !== true) {
        if (typeof ret === "object" && !forge$8.util.isArray(ret)) {
          var error = new Error("The application rejected the certificate.");
          error.send = true;
          error.alert = {
            level: tls$1.Alert.Level.fatal,
            description: tls$1.Alert.Description.bad_certificate
          };
          if (ret.message) {
            error.message = ret.message;
          }
          if (ret.alert) {
            error.alert.description = ret.alert;
          }
          throw error;
        }
        if (ret !== vfd) {
          ret = _alertDescToCertError(ret);
        }
      }
      return ret;
    };
    forge$8.pki.verifyCertificateChain(c.caStore, chain, options);
  } catch (ex) {
    var err2 = ex;
    if (typeof err2 !== "object" || forge$8.util.isArray(err2)) {
      err2 = {
        send: true,
        alert: {
          level: tls$1.Alert.Level.fatal,
          description: _certErrorToAlertDesc(ex)
        }
      };
    }
    if (!("send" in err2)) {
      err2.send = true;
    }
    if (!("alert" in err2)) {
      err2.alert = {
        level: tls$1.Alert.Level.fatal,
        description: _certErrorToAlertDesc(err2.error)
      };
    }
    c.error(c, err2);
  }
  return !c.fail;
};
tls$1.createSessionCache = function(cache, capacity) {
  var rval = null;
  if (cache && cache.getSession && cache.setSession && cache.order) {
    rval = cache;
  } else {
    rval = {};
    rval.cache = cache || {};
    rval.capacity = Math.max(capacity || 100, 1);
    rval.order = [];
    for (var key in cache) {
      if (rval.order.length <= capacity) {
        rval.order.push(key);
      } else {
        delete cache[key];
      }
    }
    rval.getSession = function(sessionId) {
      var session = null;
      var key2 = null;
      if (sessionId) {
        key2 = forge$8.util.bytesToHex(sessionId);
      } else if (rval.order.length > 0) {
        key2 = rval.order[0];
      }
      if (key2 !== null && key2 in rval.cache) {
        session = rval.cache[key2];
        delete rval.cache[key2];
        for (var i2 in rval.order) {
          if (rval.order[i2] === key2) {
            rval.order.splice(i2, 1);
            break;
          }
        }
      }
      return session;
    };
    rval.setSession = function(sessionId, session) {
      if (rval.order.length === rval.capacity) {
        var key2 = rval.order.shift();
        delete rval.cache[key2];
      }
      var key2 = forge$8.util.bytesToHex(sessionId);
      rval.order.push(key2);
      rval.cache[key2] = session;
    };
  }
  return rval;
};
tls$1.createConnection = function(options) {
  var caStore = null;
  if (options.caStore) {
    if (forge$8.util.isArray(options.caStore)) {
      caStore = forge$8.pki.createCaStore(options.caStore);
    } else {
      caStore = options.caStore;
    }
  } else {
    caStore = forge$8.pki.createCaStore();
  }
  var cipherSuites = options.cipherSuites || null;
  if (cipherSuites === null) {
    cipherSuites = [];
    for (var key in tls$1.CipherSuites) {
      cipherSuites.push(tls$1.CipherSuites[key]);
    }
  }
  var entity = options.server || false ? tls$1.ConnectionEnd.server : tls$1.ConnectionEnd.client;
  var sessionCache = options.sessionCache ? tls$1.createSessionCache(options.sessionCache) : null;
  var c = {
    version: { major: tls$1.Version.major, minor: tls$1.Version.minor },
    entity,
    sessionId: options.sessionId,
    caStore,
    sessionCache,
    cipherSuites,
    connected: options.connected,
    virtualHost: options.virtualHost || null,
    verifyClient: options.verifyClient || false,
    verify: options.verify || function(cn, vfd, dpth, cts) {
      return vfd;
    },
    verifyOptions: options.verifyOptions || {},
    getCertificate: options.getCertificate || null,
    getPrivateKey: options.getPrivateKey || null,
    getSignature: options.getSignature || null,
    input: forge$8.util.createBuffer(),
    tlsData: forge$8.util.createBuffer(),
    data: forge$8.util.createBuffer(),
    tlsDataReady: options.tlsDataReady,
    dataReady: options.dataReady,
    heartbeatReceived: options.heartbeatReceived,
    closed: options.closed,
    error: function(c2, ex) {
      ex.origin = ex.origin || (c2.entity === tls$1.ConnectionEnd.client ? "client" : "server");
      if (ex.send) {
        tls$1.queue(c2, tls$1.createAlert(c2, ex.alert));
        tls$1.flush(c2);
      }
      var fatal = ex.fatal !== false;
      if (fatal) {
        c2.fail = true;
      }
      options.error(c2, ex);
      if (fatal) {
        c2.close(false);
      }
    },
    deflate: options.deflate || null,
    inflate: options.inflate || null
  };
  c.reset = function(clearFail) {
    c.version = { major: tls$1.Version.major, minor: tls$1.Version.minor };
    c.record = null;
    c.session = null;
    c.peerCertificate = null;
    c.state = {
      pending: null,
      current: null
    };
    c.expect = c.entity === tls$1.ConnectionEnd.client ? SHE : CHE;
    c.fragmented = null;
    c.records = [];
    c.open = false;
    c.handshakes = 0;
    c.handshaking = false;
    c.isConnected = false;
    c.fail = !(clearFail || typeof clearFail === "undefined");
    c.input.clear();
    c.tlsData.clear();
    c.data.clear();
    c.state.current = tls$1.createConnectionState(c);
  };
  c.reset();
  var _update2 = function(c2, record) {
    var aligned = record.type - tls$1.ContentType.change_cipher_spec;
    var handlers2 = ctTable[c2.entity][c2.expect];
    if (aligned in handlers2) {
      handlers2[aligned](c2, record);
    } else {
      tls$1.handleUnexpected(c2, record);
    }
  };
  var _readRecordHeader = function(c2) {
    var rval = 0;
    var b = c2.input;
    var len = b.length();
    if (len < 5) {
      rval = 5 - len;
    } else {
      c2.record = {
        type: b.getByte(),
        version: {
          major: b.getByte(),
          minor: b.getByte()
        },
        length: b.getInt16(),
        fragment: forge$8.util.createBuffer(),
        ready: false
      };
      var compatibleVersion = c2.record.version.major === c2.version.major;
      if (compatibleVersion && c2.session && c2.session.version) {
        compatibleVersion = c2.record.version.minor === c2.version.minor;
      }
      if (!compatibleVersion) {
        c2.error(c2, {
          message: "Incompatible TLS version.",
          send: true,
          alert: {
            level: tls$1.Alert.Level.fatal,
            description: tls$1.Alert.Description.protocol_version
          }
        });
      }
    }
    return rval;
  };
  var _readRecord = function(c2) {
    var rval = 0;
    var b = c2.input;
    var len = b.length();
    if (len < c2.record.length) {
      rval = c2.record.length - len;
    } else {
      c2.record.fragment.putBytes(b.getBytes(c2.record.length));
      b.compact();
      var s2 = c2.state.current.read;
      if (s2.update(c2, c2.record)) {
        if (c2.fragmented !== null) {
          if (c2.fragmented.type === c2.record.type) {
            c2.fragmented.fragment.putBuffer(c2.record.fragment);
            c2.record = c2.fragmented;
          } else {
            c2.error(c2, {
              message: "Invalid fragmented record.",
              send: true,
              alert: {
                level: tls$1.Alert.Level.fatal,
                description: tls$1.Alert.Description.unexpected_message
              }
            });
          }
        }
        c2.record.ready = true;
      }
    }
    return rval;
  };
  c.handshake = function(sessionId) {
    if (c.entity !== tls$1.ConnectionEnd.client) {
      c.error(c, {
        message: "Cannot initiate handshake as a server.",
        fatal: false
      });
    } else if (c.handshaking) {
      c.error(c, {
        message: "Handshake already in progress.",
        fatal: false
      });
    } else {
      if (c.fail && !c.open && c.handshakes === 0) {
        c.fail = false;
      }
      c.handshaking = true;
      sessionId = sessionId || "";
      var session = null;
      if (sessionId.length > 0) {
        if (c.sessionCache) {
          session = c.sessionCache.getSession(sessionId);
        }
        if (session === null) {
          sessionId = "";
        }
      }
      if (sessionId.length === 0 && c.sessionCache) {
        session = c.sessionCache.getSession();
        if (session !== null) {
          sessionId = session.id;
        }
      }
      c.session = {
        id: sessionId,
        version: null,
        cipherSuite: null,
        compressionMethod: null,
        serverCertificate: null,
        certificateRequest: null,
        clientCertificate: null,
        sp: {},
        md5: forge$8.md.md5.create(),
        sha1: forge$8.md.sha1.create()
      };
      if (session) {
        c.version = session.version;
        c.session.sp = session.sp;
      }
      c.session.sp.client_random = tls$1.createRandom().getBytes();
      c.open = true;
      tls$1.queue(c, tls$1.createRecord(c, {
        type: tls$1.ContentType.handshake,
        data: tls$1.createClientHello(c)
      }));
      tls$1.flush(c);
    }
  };
  c.process = function(data) {
    var rval = 0;
    if (data) {
      c.input.putBytes(data);
    }
    if (!c.fail) {
      if (c.record !== null && c.record.ready && c.record.fragment.isEmpty()) {
        c.record = null;
      }
      if (c.record === null) {
        rval = _readRecordHeader(c);
      }
      if (!c.fail && c.record !== null && !c.record.ready) {
        rval = _readRecord(c);
      }
      if (!c.fail && c.record !== null && c.record.ready) {
        _update2(c, c.record);
      }
    }
    return rval;
  };
  c.prepare = function(data) {
    tls$1.queue(c, tls$1.createRecord(c, {
      type: tls$1.ContentType.application_data,
      data: forge$8.util.createBuffer(data)
    }));
    return tls$1.flush(c);
  };
  c.prepareHeartbeatRequest = function(payload, payloadLength) {
    if (payload instanceof forge$8.util.ByteBuffer) {
      payload = payload.bytes();
    }
    if (typeof payloadLength === "undefined") {
      payloadLength = payload.length;
    }
    c.expectedHeartbeatPayload = payload;
    tls$1.queue(c, tls$1.createRecord(c, {
      type: tls$1.ContentType.heartbeat,
      data: tls$1.createHeartbeat(tls$1.HeartbeatMessageType.heartbeat_request, payload, payloadLength)
    }));
    return tls$1.flush(c);
  };
  c.close = function(clearFail) {
    if (!c.fail && c.sessionCache && c.session) {
      var session = {
        id: c.session.id,
        version: c.session.version,
        sp: c.session.sp
      };
      session.sp.keys = null;
      c.sessionCache.setSession(session.id, session);
    }
    if (c.open) {
      c.open = false;
      c.input.clear();
      if (c.isConnected || c.handshaking) {
        c.isConnected = c.handshaking = false;
        tls$1.queue(c, tls$1.createAlert(c, {
          level: tls$1.Alert.Level.warning,
          description: tls$1.Alert.Description.close_notify
        }));
        tls$1.flush(c);
      }
      c.closed(c);
    }
    c.reset(clearFail);
  };
  return c;
};
forge$8.tls = forge$8.tls || {};
for (var key$1 in tls$1) {
  if (typeof tls$1[key$1] !== "function") {
    forge$8.tls[key$1] = tls$1[key$1];
  }
}
forge$8.tls.prf_tls1 = prf_TLS1;
forge$8.tls.hmac_sha1 = hmac_sha1;
forge$8.tls.createSessionCache = tls$1.createSessionCache;
forge$8.tls.createConnection = tls$1.createConnection;
var forge$7 = forge$C;
var tls = forge$7.tls;
tls.CipherSuites["TLS_RSA_WITH_AES_128_CBC_SHA"] = {
  id: [0, 47],
  name: "TLS_RSA_WITH_AES_128_CBC_SHA",
  initSecurityParameters: function(sp) {
    sp.bulk_cipher_algorithm = tls.BulkCipherAlgorithm.aes;
    sp.cipher_type = tls.CipherType.block;
    sp.enc_key_length = 16;
    sp.block_length = 16;
    sp.fixed_iv_length = 16;
    sp.record_iv_length = 16;
    sp.mac_algorithm = tls.MACAlgorithm.hmac_sha1;
    sp.mac_length = 20;
    sp.mac_key_length = 20;
  },
  initConnectionState
};
tls.CipherSuites["TLS_RSA_WITH_AES_256_CBC_SHA"] = {
  id: [0, 53],
  name: "TLS_RSA_WITH_AES_256_CBC_SHA",
  initSecurityParameters: function(sp) {
    sp.bulk_cipher_algorithm = tls.BulkCipherAlgorithm.aes;
    sp.cipher_type = tls.CipherType.block;
    sp.enc_key_length = 32;
    sp.block_length = 16;
    sp.fixed_iv_length = 16;
    sp.record_iv_length = 16;
    sp.mac_algorithm = tls.MACAlgorithm.hmac_sha1;
    sp.mac_length = 20;
    sp.mac_key_length = 20;
  },
  initConnectionState
};
function initConnectionState(state, c, sp) {
  var client2 = c.entity === forge$7.tls.ConnectionEnd.client;
  state.read.cipherState = {
    init: false,
    cipher: forge$7.cipher.createDecipher("AES-CBC", client2 ? sp.keys.server_write_key : sp.keys.client_write_key),
    iv: client2 ? sp.keys.server_write_IV : sp.keys.client_write_IV
  };
  state.write.cipherState = {
    init: false,
    cipher: forge$7.cipher.createCipher("AES-CBC", client2 ? sp.keys.client_write_key : sp.keys.server_write_key),
    iv: client2 ? sp.keys.client_write_IV : sp.keys.server_write_IV
  };
  state.read.cipherFunction = decrypt_aes_cbc_sha1;
  state.write.cipherFunction = encrypt_aes_cbc_sha1;
  state.read.macLength = state.write.macLength = sp.mac_length;
  state.read.macFunction = state.write.macFunction = tls.hmac_sha1;
}
function encrypt_aes_cbc_sha1(record, s2) {
  var rval = false;
  var mac2 = s2.macFunction(s2.macKey, s2.sequenceNumber, record);
  record.fragment.putBytes(mac2);
  s2.updateSequenceNumber();
  var iv;
  if (record.version.minor === tls.Versions.TLS_1_0.minor) {
    iv = s2.cipherState.init ? null : s2.cipherState.iv;
  } else {
    iv = forge$7.random.getBytesSync(16);
  }
  s2.cipherState.init = true;
  var cipher = s2.cipherState.cipher;
  cipher.start({ iv });
  if (record.version.minor >= tls.Versions.TLS_1_1.minor) {
    cipher.output.putBytes(iv);
  }
  cipher.update(record.fragment);
  if (cipher.finish(encrypt_aes_cbc_sha1_padding)) {
    record.fragment = cipher.output;
    record.length = record.fragment.length();
    rval = true;
  }
  return rval;
}
function encrypt_aes_cbc_sha1_padding(blockSize, input, decrypt) {
  if (!decrypt) {
    var padding = blockSize - input.length() % blockSize;
    input.fillWithByte(padding - 1, padding);
  }
  return true;
}
function decrypt_aes_cbc_sha1_padding(blockSize, output, decrypt) {
  var rval = true;
  if (decrypt) {
    var len = output.length();
    var paddingLength = output.last();
    for (var i2 = len - 1 - paddingLength; i2 < len - 1; ++i2) {
      rval = rval && output.at(i2) == paddingLength;
    }
    if (rval) {
      output.truncate(paddingLength + 1);
    }
  }
  return rval;
}
function decrypt_aes_cbc_sha1(record, s2) {
  var rval = false;
  var iv;
  if (record.version.minor === tls.Versions.TLS_1_0.minor) {
    iv = s2.cipherState.init ? null : s2.cipherState.iv;
  } else {
    iv = record.fragment.getBytes(16);
  }
  s2.cipherState.init = true;
  var cipher = s2.cipherState.cipher;
  cipher.start({ iv });
  cipher.update(record.fragment);
  rval = cipher.finish(decrypt_aes_cbc_sha1_padding);
  var macLen = s2.macLength;
  var mac2 = forge$7.random.getBytesSync(macLen);
  var len = cipher.output.length();
  if (len >= macLen) {
    record.fragment = cipher.output.getBytes(len - macLen);
    mac2 = cipher.output.getBytes(macLen);
  } else {
    record.fragment = cipher.output.getBytes();
  }
  record.fragment = forge$7.util.createBuffer(record.fragment);
  record.length = record.fragment.length();
  var mac22 = s2.macFunction(s2.macKey, s2.sequenceNumber, record);
  s2.updateSequenceNumber();
  rval = compareMacs(s2.macKey, mac2, mac22) && rval;
  return rval;
}
function compareMacs(key, mac1, mac2) {
  var hmac2 = forge$7.hmac.create();
  hmac2.start("SHA1", key);
  hmac2.update(mac1);
  mac1 = hmac2.digest().getBytes();
  hmac2.start(null, null);
  hmac2.update(mac2);
  mac2 = hmac2.digest().getBytes();
  return mac1 === mac2;
}
var forge$6 = forge$C;
var sha512$1 = forge$6.sha512 = forge$6.sha512 || {};
forge$6.md.sha512 = forge$6.md.algorithms.sha512 = sha512$1;
var sha384 = forge$6.sha384 = forge$6.sha512.sha384 = forge$6.sha512.sha384 || {};
sha384.create = function() {
  return sha512$1.create("SHA-384");
};
forge$6.md.sha384 = forge$6.md.algorithms.sha384 = sha384;
forge$6.sha512.sha256 = forge$6.sha512.sha256 || {
  create: function() {
    return sha512$1.create("SHA-512/256");
  }
};
forge$6.md["sha512/256"] = forge$6.md.algorithms["sha512/256"] = forge$6.sha512.sha256;
forge$6.sha512.sha224 = forge$6.sha512.sha224 || {
  create: function() {
    return sha512$1.create("SHA-512/224");
  }
};
forge$6.md["sha512/224"] = forge$6.md.algorithms["sha512/224"] = forge$6.sha512.sha224;
sha512$1.create = function(algorithm) {
  if (!_initialized) {
    _init();
  }
  if (typeof algorithm === "undefined") {
    algorithm = "SHA-512";
  }
  if (!(algorithm in _states)) {
    throw new Error("Invalid SHA-512 algorithm: " + algorithm);
  }
  var _state = _states[algorithm];
  var _h = null;
  var _input = forge$6.util.createBuffer();
  var _w = new Array(80);
  for (var wi = 0; wi < 80; ++wi) {
    _w[wi] = new Array(2);
  }
  var digestLength = 64;
  switch (algorithm) {
    case "SHA-384":
      digestLength = 48;
      break;
    case "SHA-512/256":
      digestLength = 32;
      break;
    case "SHA-512/224":
      digestLength = 28;
      break;
  }
  var md = {
    algorithm: algorithm.replace("-", "").toLowerCase(),
    blockLength: 128,
    digestLength,
    messageLength: 0,
    fullMessageLength: null,
    messageLengthSize: 16
  };
  md.start = function() {
    md.messageLength = 0;
    md.fullMessageLength = md.messageLength128 = [];
    var int32s = md.messageLengthSize / 4;
    for (var i2 = 0; i2 < int32s; ++i2) {
      md.fullMessageLength.push(0);
    }
    _input = forge$6.util.createBuffer();
    _h = new Array(_state.length);
    for (var i2 = 0; i2 < _state.length; ++i2) {
      _h[i2] = _state[i2].slice(0);
    }
    return md;
  };
  md.start();
  md.update = function(msg, encoding) {
    if (encoding === "utf8") {
      msg = forge$6.util.encodeUtf8(msg);
    }
    var len = msg.length;
    md.messageLength += len;
    len = [len / 4294967296 >>> 0, len >>> 0];
    for (var i2 = md.fullMessageLength.length - 1; i2 >= 0; --i2) {
      md.fullMessageLength[i2] += len[1];
      len[1] = len[0] + (md.fullMessageLength[i2] / 4294967296 >>> 0);
      md.fullMessageLength[i2] = md.fullMessageLength[i2] >>> 0;
      len[0] = len[1] / 4294967296 >>> 0;
    }
    _input.putBytes(msg);
    _update(_h, _w, _input);
    if (_input.read > 2048 || _input.length() === 0) {
      _input.compact();
    }
    return md;
  };
  md.digest = function() {
    var finalBlock = forge$6.util.createBuffer();
    finalBlock.putBytes(_input.bytes());
    var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
    var overflow = remaining & md.blockLength - 1;
    finalBlock.putBytes(_padding.substr(0, md.blockLength - overflow));
    var next, carry;
    var bits = md.fullMessageLength[0] * 8;
    for (var i2 = 0; i2 < md.fullMessageLength.length - 1; ++i2) {
      next = md.fullMessageLength[i2 + 1] * 8;
      carry = next / 4294967296 >>> 0;
      bits += carry;
      finalBlock.putInt32(bits >>> 0);
      bits = next >>> 0;
    }
    finalBlock.putInt32(bits);
    var h = new Array(_h.length);
    for (var i2 = 0; i2 < _h.length; ++i2) {
      h[i2] = _h[i2].slice(0);
    }
    _update(h, _w, finalBlock);
    var rval = forge$6.util.createBuffer();
    var hlen;
    if (algorithm === "SHA-512") {
      hlen = h.length;
    } else if (algorithm === "SHA-384") {
      hlen = h.length - 2;
    } else {
      hlen = h.length - 4;
    }
    for (var i2 = 0; i2 < hlen; ++i2) {
      rval.putInt32(h[i2][0]);
      if (i2 !== hlen - 1 || algorithm !== "SHA-512/224") {
        rval.putInt32(h[i2][1]);
      }
    }
    return rval;
  };
  return md;
};
var _padding = null;
var _initialized = false;
var _k = null;
var _states = null;
function _init() {
  _padding = String.fromCharCode(128);
  _padding += forge$6.util.fillString(String.fromCharCode(0), 128);
  _k = [
    [1116352408, 3609767458],
    [1899447441, 602891725],
    [3049323471, 3964484399],
    [3921009573, 2173295548],
    [961987163, 4081628472],
    [1508970993, 3053834265],
    [2453635748, 2937671579],
    [2870763221, 3664609560],
    [3624381080, 2734883394],
    [310598401, 1164996542],
    [607225278, 1323610764],
    [1426881987, 3590304994],
    [1925078388, 4068182383],
    [2162078206, 991336113],
    [2614888103, 633803317],
    [3248222580, 3479774868],
    [3835390401, 2666613458],
    [4022224774, 944711139],
    [264347078, 2341262773],
    [604807628, 2007800933],
    [770255983, 1495990901],
    [1249150122, 1856431235],
    [1555081692, 3175218132],
    [1996064986, 2198950837],
    [2554220882, 3999719339],
    [2821834349, 766784016],
    [2952996808, 2566594879],
    [3210313671, 3203337956],
    [3336571891, 1034457026],
    [3584528711, 2466948901],
    [113926993, 3758326383],
    [338241895, 168717936],
    [666307205, 1188179964],
    [773529912, 1546045734],
    [1294757372, 1522805485],
    [1396182291, 2643833823],
    [1695183700, 2343527390],
    [1986661051, 1014477480],
    [2177026350, 1206759142],
    [2456956037, 344077627],
    [2730485921, 1290863460],
    [2820302411, 3158454273],
    [3259730800, 3505952657],
    [3345764771, 106217008],
    [3516065817, 3606008344],
    [3600352804, 1432725776],
    [4094571909, 1467031594],
    [275423344, 851169720],
    [430227734, 3100823752],
    [506948616, 1363258195],
    [659060556, 3750685593],
    [883997877, 3785050280],
    [958139571, 3318307427],
    [1322822218, 3812723403],
    [1537002063, 2003034995],
    [1747873779, 3602036899],
    [1955562222, 1575990012],
    [2024104815, 1125592928],
    [2227730452, 2716904306],
    [2361852424, 442776044],
    [2428436474, 593698344],
    [2756734187, 3733110249],
    [3204031479, 2999351573],
    [3329325298, 3815920427],
    [3391569614, 3928383900],
    [3515267271, 566280711],
    [3940187606, 3454069534],
    [4118630271, 4000239992],
    [116418474, 1914138554],
    [174292421, 2731055270],
    [289380356, 3203993006],
    [460393269, 320620315],
    [685471733, 587496836],
    [852142971, 1086792851],
    [1017036298, 365543100],
    [1126000580, 2618297676],
    [1288033470, 3409855158],
    [1501505948, 4234509866],
    [1607167915, 987167468],
    [1816402316, 1246189591]
  ];
  _states = {};
  _states["SHA-512"] = [
    [1779033703, 4089235720],
    [3144134277, 2227873595],
    [1013904242, 4271175723],
    [2773480762, 1595750129],
    [1359893119, 2917565137],
    [2600822924, 725511199],
    [528734635, 4215389547],
    [1541459225, 327033209]
  ];
  _states["SHA-384"] = [
    [3418070365, 3238371032],
    [1654270250, 914150663],
    [2438529370, 812702999],
    [355462360, 4144912697],
    [1731405415, 4290775857],
    [2394180231, 1750603025],
    [3675008525, 1694076839],
    [1203062813, 3204075428]
  ];
  _states["SHA-512/256"] = [
    [573645204, 4230739756],
    [2673172387, 3360449730],
    [596883563, 1867755857],
    [2520282905, 1497426621],
    [2519219938, 2827943907],
    [3193839141, 1401305490],
    [721525244, 746961066],
    [246885852, 2177182882]
  ];
  _states["SHA-512/224"] = [
    [2352822216, 424955298],
    [1944164710, 2312950998],
    [502970286, 855612546],
    [1738396948, 1479516111],
    [258812777, 2077511080],
    [2011393907, 79989058],
    [1067287976, 1780299464],
    [286451373, 2446758561]
  ];
  _initialized = true;
}
function _update(s2, w, bytes) {
  var t1_hi, t1_lo;
  var t2_hi, t2_lo;
  var s0_hi, s0_lo;
  var s1_hi, s1_lo;
  var ch_hi, ch_lo;
  var maj_hi, maj_lo;
  var a_hi, a_lo;
  var b_hi, b_lo;
  var c_hi, c_lo;
  var d_hi, d_lo;
  var e_hi, e_lo;
  var f_hi, f_lo;
  var g_hi, g_lo;
  var h_hi, h_lo;
  var i2, hi, lo, w2, w7, w15, w16;
  var len = bytes.length();
  while (len >= 128) {
    for (i2 = 0; i2 < 16; ++i2) {
      w[i2][0] = bytes.getInt32() >>> 0;
      w[i2][1] = bytes.getInt32() >>> 0;
    }
    for (; i2 < 80; ++i2) {
      w2 = w[i2 - 2];
      hi = w2[0];
      lo = w2[1];
      t1_hi = ((hi >>> 19 | lo << 13) ^ (lo >>> 29 | hi << 3) ^ hi >>> 6) >>> 0;
      t1_lo = ((hi << 13 | lo >>> 19) ^ (lo << 3 | hi >>> 29) ^ (hi << 26 | lo >>> 6)) >>> 0;
      w15 = w[i2 - 15];
      hi = w15[0];
      lo = w15[1];
      t2_hi = ((hi >>> 1 | lo << 31) ^ (hi >>> 8 | lo << 24) ^ hi >>> 7) >>> 0;
      t2_lo = ((hi << 31 | lo >>> 1) ^ (hi << 24 | lo >>> 8) ^ (hi << 25 | lo >>> 7)) >>> 0;
      w7 = w[i2 - 7];
      w16 = w[i2 - 16];
      lo = t1_lo + w7[1] + t2_lo + w16[1];
      w[i2][0] = t1_hi + w7[0] + t2_hi + w16[0] + (lo / 4294967296 >>> 0) >>> 0;
      w[i2][1] = lo >>> 0;
    }
    a_hi = s2[0][0];
    a_lo = s2[0][1];
    b_hi = s2[1][0];
    b_lo = s2[1][1];
    c_hi = s2[2][0];
    c_lo = s2[2][1];
    d_hi = s2[3][0];
    d_lo = s2[3][1];
    e_hi = s2[4][0];
    e_lo = s2[4][1];
    f_hi = s2[5][0];
    f_lo = s2[5][1];
    g_hi = s2[6][0];
    g_lo = s2[6][1];
    h_hi = s2[7][0];
    h_lo = s2[7][1];
    for (i2 = 0; i2 < 80; ++i2) {
      s1_hi = ((e_hi >>> 14 | e_lo << 18) ^ (e_hi >>> 18 | e_lo << 14) ^ (e_lo >>> 9 | e_hi << 23)) >>> 0;
      s1_lo = ((e_hi << 18 | e_lo >>> 14) ^ (e_hi << 14 | e_lo >>> 18) ^ (e_lo << 23 | e_hi >>> 9)) >>> 0;
      ch_hi = (g_hi ^ e_hi & (f_hi ^ g_hi)) >>> 0;
      ch_lo = (g_lo ^ e_lo & (f_lo ^ g_lo)) >>> 0;
      s0_hi = ((a_hi >>> 28 | a_lo << 4) ^ (a_lo >>> 2 | a_hi << 30) ^ (a_lo >>> 7 | a_hi << 25)) >>> 0;
      s0_lo = ((a_hi << 4 | a_lo >>> 28) ^ (a_lo << 30 | a_hi >>> 2) ^ (a_lo << 25 | a_hi >>> 7)) >>> 0;
      maj_hi = (a_hi & b_hi | c_hi & (a_hi ^ b_hi)) >>> 0;
      maj_lo = (a_lo & b_lo | c_lo & (a_lo ^ b_lo)) >>> 0;
      lo = h_lo + s1_lo + ch_lo + _k[i2][1] + w[i2][1];
      t1_hi = h_hi + s1_hi + ch_hi + _k[i2][0] + w[i2][0] + (lo / 4294967296 >>> 0) >>> 0;
      t1_lo = lo >>> 0;
      lo = s0_lo + maj_lo;
      t2_hi = s0_hi + maj_hi + (lo / 4294967296 >>> 0) >>> 0;
      t2_lo = lo >>> 0;
      h_hi = g_hi;
      h_lo = g_lo;
      g_hi = f_hi;
      g_lo = f_lo;
      f_hi = e_hi;
      f_lo = e_lo;
      lo = d_lo + t1_lo;
      e_hi = d_hi + t1_hi + (lo / 4294967296 >>> 0) >>> 0;
      e_lo = lo >>> 0;
      d_hi = c_hi;
      d_lo = c_lo;
      c_hi = b_hi;
      c_lo = b_lo;
      b_hi = a_hi;
      b_lo = a_lo;
      lo = t1_lo + t2_lo;
      a_hi = t1_hi + t2_hi + (lo / 4294967296 >>> 0) >>> 0;
      a_lo = lo >>> 0;
    }
    lo = s2[0][1] + a_lo;
    s2[0][0] = s2[0][0] + a_hi + (lo / 4294967296 >>> 0) >>> 0;
    s2[0][1] = lo >>> 0;
    lo = s2[1][1] + b_lo;
    s2[1][0] = s2[1][0] + b_hi + (lo / 4294967296 >>> 0) >>> 0;
    s2[1][1] = lo >>> 0;
    lo = s2[2][1] + c_lo;
    s2[2][0] = s2[2][0] + c_hi + (lo / 4294967296 >>> 0) >>> 0;
    s2[2][1] = lo >>> 0;
    lo = s2[3][1] + d_lo;
    s2[3][0] = s2[3][0] + d_hi + (lo / 4294967296 >>> 0) >>> 0;
    s2[3][1] = lo >>> 0;
    lo = s2[4][1] + e_lo;
    s2[4][0] = s2[4][0] + e_hi + (lo / 4294967296 >>> 0) >>> 0;
    s2[4][1] = lo >>> 0;
    lo = s2[5][1] + f_lo;
    s2[5][0] = s2[5][0] + f_hi + (lo / 4294967296 >>> 0) >>> 0;
    s2[5][1] = lo >>> 0;
    lo = s2[6][1] + g_lo;
    s2[6][0] = s2[6][0] + g_hi + (lo / 4294967296 >>> 0) >>> 0;
    s2[6][1] = lo >>> 0;
    lo = s2[7][1] + h_lo;
    s2[7][0] = s2[7][0] + h_hi + (lo / 4294967296 >>> 0) >>> 0;
    s2[7][1] = lo >>> 0;
    len -= 128;
  }
}
var asn1Validator$1 = {};
var forge$5 = forge$C;
var asn1$1 = forge$5.asn1;
asn1Validator$1.privateKeyValidator = {
  name: "PrivateKeyInfo",
  tagClass: asn1$1.Class.UNIVERSAL,
  type: asn1$1.Type.SEQUENCE,
  constructed: true,
  value: [{
    name: "PrivateKeyInfo.version",
    tagClass: asn1$1.Class.UNIVERSAL,
    type: asn1$1.Type.INTEGER,
    constructed: false,
    capture: "privateKeyVersion"
  }, {
    name: "PrivateKeyInfo.privateKeyAlgorithm",
    tagClass: asn1$1.Class.UNIVERSAL,
    type: asn1$1.Type.SEQUENCE,
    constructed: true,
    value: [{
      name: "AlgorithmIdentifier.algorithm",
      tagClass: asn1$1.Class.UNIVERSAL,
      type: asn1$1.Type.OID,
      constructed: false,
      capture: "privateKeyOid"
    }]
  }, {
    name: "PrivateKeyInfo",
    tagClass: asn1$1.Class.UNIVERSAL,
    type: asn1$1.Type.OCTETSTRING,
    constructed: false,
    capture: "privateKey"
  }]
};
asn1Validator$1.publicKeyValidator = {
  name: "SubjectPublicKeyInfo",
  tagClass: asn1$1.Class.UNIVERSAL,
  type: asn1$1.Type.SEQUENCE,
  constructed: true,
  captureAsn1: "subjectPublicKeyInfo",
  value: [
    {
      name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
      tagClass: asn1$1.Class.UNIVERSAL,
      type: asn1$1.Type.SEQUENCE,
      constructed: true,
      value: [{
        name: "AlgorithmIdentifier.algorithm",
        tagClass: asn1$1.Class.UNIVERSAL,
        type: asn1$1.Type.OID,
        constructed: false,
        capture: "publicKeyOid"
      }]
    },
    {
      tagClass: asn1$1.Class.UNIVERSAL,
      type: asn1$1.Type.BITSTRING,
      constructed: false,
      composed: true,
      captureBitStringValue: "ed25519PublicKey"
    }
  ]
};
var forge$4 = forge$C;
var asn1Validator = asn1Validator$1;
var publicKeyValidator = asn1Validator.publicKeyValidator;
var privateKeyValidator = asn1Validator.privateKeyValidator;
if (typeof BigInteger$1 === "undefined") {
  var BigInteger$1 = forge$4.jsbn.BigInteger;
}
var ByteBuffer = forge$4.util.ByteBuffer;
var NativeBuffer = typeof Buffer === "undefined" ? Uint8Array : Buffer;
forge$4.pki = forge$4.pki || {};
forge$4.pki.ed25519 = forge$4.ed25519 = forge$4.ed25519 || {};
var ed25519 = forge$4.ed25519;
ed25519.constants = {};
ed25519.constants.PUBLIC_KEY_BYTE_LENGTH = 32;
ed25519.constants.PRIVATE_KEY_BYTE_LENGTH = 64;
ed25519.constants.SEED_BYTE_LENGTH = 32;
ed25519.constants.SIGN_BYTE_LENGTH = 64;
ed25519.constants.HASH_BYTE_LENGTH = 64;
ed25519.generateKeyPair = function(options) {
  options = options || {};
  var seed = options.seed;
  if (seed === void 0) {
    seed = forge$4.random.getBytesSync(ed25519.constants.SEED_BYTE_LENGTH);
  } else if (typeof seed === "string") {
    if (seed.length !== ed25519.constants.SEED_BYTE_LENGTH) {
      throw new TypeError('"seed" must be ' + ed25519.constants.SEED_BYTE_LENGTH + " bytes in length.");
    }
  } else if (!(seed instanceof Uint8Array)) {
    throw new TypeError('"seed" must be a node.js Buffer, Uint8Array, or a binary string.');
  }
  seed = messageToNativeBuffer({ message: seed, encoding: "binary" });
  var pk = new NativeBuffer(ed25519.constants.PUBLIC_KEY_BYTE_LENGTH);
  var sk = new NativeBuffer(ed25519.constants.PRIVATE_KEY_BYTE_LENGTH);
  for (var i2 = 0; i2 < 32; ++i2) {
    sk[i2] = seed[i2];
  }
  crypto_sign_keypair(pk, sk);
  return { publicKey: pk, privateKey: sk };
};
ed25519.privateKeyFromAsn1 = function(obj) {
  var capture = {};
  var errors = [];
  var valid4 = forge$4.asn1.validate(obj, privateKeyValidator, capture, errors);
  if (!valid4) {
    var error = new Error("Invalid Key.");
    error.errors = errors;
    throw error;
  }
  var oid = forge$4.asn1.derToOid(capture.privateKeyOid);
  var ed25519Oid = forge$4.oids.EdDSA25519;
  if (oid !== ed25519Oid) {
    throw new Error('Invalid OID "' + oid + '"; OID must be "' + ed25519Oid + '".');
  }
  var privateKey = capture.privateKey;
  var privateKeyBytes = messageToNativeBuffer({
    message: forge$4.asn1.fromDer(privateKey).value,
    encoding: "binary"
  });
  return { privateKeyBytes };
};
ed25519.publicKeyFromAsn1 = function(obj) {
  var capture = {};
  var errors = [];
  var valid4 = forge$4.asn1.validate(obj, publicKeyValidator, capture, errors);
  if (!valid4) {
    var error = new Error("Invalid Key.");
    error.errors = errors;
    throw error;
  }
  var oid = forge$4.asn1.derToOid(capture.publicKeyOid);
  var ed25519Oid = forge$4.oids.EdDSA25519;
  if (oid !== ed25519Oid) {
    throw new Error('Invalid OID "' + oid + '"; OID must be "' + ed25519Oid + '".');
  }
  var publicKeyBytes = capture.ed25519PublicKey;
  if (publicKeyBytes.length !== ed25519.constants.PUBLIC_KEY_BYTE_LENGTH) {
    throw new Error("Key length is invalid.");
  }
  return messageToNativeBuffer({
    message: publicKeyBytes,
    encoding: "binary"
  });
};
ed25519.publicKeyFromPrivateKey = function(options) {
  options = options || {};
  var privateKey = messageToNativeBuffer({
    message: options.privateKey,
    encoding: "binary"
  });
  if (privateKey.length !== ed25519.constants.PRIVATE_KEY_BYTE_LENGTH) {
    throw new TypeError('"options.privateKey" must have a byte length of ' + ed25519.constants.PRIVATE_KEY_BYTE_LENGTH);
  }
  var pk = new NativeBuffer(ed25519.constants.PUBLIC_KEY_BYTE_LENGTH);
  for (var i2 = 0; i2 < pk.length; ++i2) {
    pk[i2] = privateKey[32 + i2];
  }
  return pk;
};
ed25519.sign = function(options) {
  options = options || {};
  var msg = messageToNativeBuffer(options);
  var privateKey = messageToNativeBuffer({
    message: options.privateKey,
    encoding: "binary"
  });
  if (privateKey.length === ed25519.constants.SEED_BYTE_LENGTH) {
    var keyPair = ed25519.generateKeyPair({ seed: privateKey });
    privateKey = keyPair.privateKey;
  } else if (privateKey.length !== ed25519.constants.PRIVATE_KEY_BYTE_LENGTH) {
    throw new TypeError('"options.privateKey" must have a byte length of ' + ed25519.constants.SEED_BYTE_LENGTH + " or " + ed25519.constants.PRIVATE_KEY_BYTE_LENGTH);
  }
  var signedMsg = new NativeBuffer(ed25519.constants.SIGN_BYTE_LENGTH + msg.length);
  crypto_sign(signedMsg, msg, msg.length, privateKey);
  var sig = new NativeBuffer(ed25519.constants.SIGN_BYTE_LENGTH);
  for (var i2 = 0; i2 < sig.length; ++i2) {
    sig[i2] = signedMsg[i2];
  }
  return sig;
};
ed25519.verify = function(options) {
  options = options || {};
  var msg = messageToNativeBuffer(options);
  if (options.signature === void 0) {
    throw new TypeError('"options.signature" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a binary string.');
  }
  var sig = messageToNativeBuffer({
    message: options.signature,
    encoding: "binary"
  });
  if (sig.length !== ed25519.constants.SIGN_BYTE_LENGTH) {
    throw new TypeError('"options.signature" must have a byte length of ' + ed25519.constants.SIGN_BYTE_LENGTH);
  }
  var publicKey = messageToNativeBuffer({
    message: options.publicKey,
    encoding: "binary"
  });
  if (publicKey.length !== ed25519.constants.PUBLIC_KEY_BYTE_LENGTH) {
    throw new TypeError('"options.publicKey" must have a byte length of ' + ed25519.constants.PUBLIC_KEY_BYTE_LENGTH);
  }
  var sm = new NativeBuffer(ed25519.constants.SIGN_BYTE_LENGTH + msg.length);
  var m = new NativeBuffer(ed25519.constants.SIGN_BYTE_LENGTH + msg.length);
  var i2;
  for (i2 = 0; i2 < ed25519.constants.SIGN_BYTE_LENGTH; ++i2) {
    sm[i2] = sig[i2];
  }
  for (i2 = 0; i2 < msg.length; ++i2) {
    sm[i2 + ed25519.constants.SIGN_BYTE_LENGTH] = msg[i2];
  }
  return crypto_sign_open(m, sm, sm.length, publicKey) >= 0;
};
function messageToNativeBuffer(options) {
  var message = options.message;
  if (message instanceof Uint8Array || message instanceof NativeBuffer) {
    return message;
  }
  var encoding = options.encoding;
  if (message === void 0) {
    if (options.md) {
      message = options.md.digest().getBytes();
      encoding = "binary";
    } else {
      throw new TypeError('"options.message" or "options.md" not specified.');
    }
  }
  if (typeof message === "string" && !encoding) {
    throw new TypeError('"options.encoding" must be "binary" or "utf8".');
  }
  if (typeof message === "string") {
    if (typeof Buffer !== "undefined") {
      return Buffer.from(message, encoding);
    }
    message = new ByteBuffer(message, encoding);
  } else if (!(message instanceof ByteBuffer)) {
    throw new TypeError('"options.message" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a string with "options.encoding" specifying its encoding.');
  }
  var buffer = new NativeBuffer(message.length());
  for (var i2 = 0; i2 < buffer.length; ++i2) {
    buffer[i2] = message.at(i2);
  }
  return buffer;
}
var gf0 = gf();
var gf1 = gf([1]);
var D = gf([
  30883,
  4953,
  19914,
  30187,
  55467,
  16705,
  2637,
  112,
  59544,
  30585,
  16505,
  36039,
  65139,
  11119,
  27886,
  20995
]);
var D2 = gf([
  61785,
  9906,
  39828,
  60374,
  45398,
  33411,
  5274,
  224,
  53552,
  61171,
  33010,
  6542,
  64743,
  22239,
  55772,
  9222
]);
var X = gf([
  54554,
  36645,
  11616,
  51542,
  42930,
  38181,
  51040,
  26924,
  56412,
  64982,
  57905,
  49316,
  21502,
  52590,
  14035,
  8553
]);
var Y = gf([
  26200,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214
]);
var L$2 = new Float64Array([
  237,
  211,
  245,
  92,
  26,
  99,
  18,
  88,
  214,
  156,
  247,
  162,
  222,
  249,
  222,
  20,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  16
]);
var I = gf([
  41136,
  18958,
  6951,
  50414,
  58488,
  44335,
  6150,
  12099,
  55207,
  15867,
  153,
  11085,
  57099,
  20417,
  9344,
  11139
]);
function sha512(msg, msgLen) {
  var md = forge$4.md.sha512.create();
  var buffer = new ByteBuffer(msg);
  md.update(buffer.getBytes(msgLen), "binary");
  var hash2 = md.digest().getBytes();
  if (typeof Buffer !== "undefined") {
    return Buffer.from(hash2, "binary");
  }
  var out = new NativeBuffer(ed25519.constants.HASH_BYTE_LENGTH);
  for (var i2 = 0; i2 < 64; ++i2) {
    out[i2] = hash2.charCodeAt(i2);
  }
  return out;
}
function crypto_sign_keypair(pk, sk) {
  var p = [gf(), gf(), gf(), gf()];
  var i2;
  var d = sha512(sk, 32);
  d[0] &= 248;
  d[31] &= 127;
  d[31] |= 64;
  scalarbase(p, d);
  pack(pk, p);
  for (i2 = 0; i2 < 32; ++i2) {
    sk[i2 + 32] = pk[i2];
  }
  return 0;
}
function crypto_sign(sm, m, n, sk) {
  var i2, j, x2 = new Float64Array(64);
  var p = [gf(), gf(), gf(), gf()];
  var d = sha512(sk, 32);
  d[0] &= 248;
  d[31] &= 127;
  d[31] |= 64;
  var smlen = n + 64;
  for (i2 = 0; i2 < n; ++i2) {
    sm[64 + i2] = m[i2];
  }
  for (i2 = 0; i2 < 32; ++i2) {
    sm[32 + i2] = d[32 + i2];
  }
  var r = sha512(sm.subarray(32), n + 32);
  reduce(r);
  scalarbase(p, r);
  pack(sm, p);
  for (i2 = 32; i2 < 64; ++i2) {
    sm[i2] = sk[i2];
  }
  var h = sha512(sm, n + 64);
  reduce(h);
  for (i2 = 32; i2 < 64; ++i2) {
    x2[i2] = 0;
  }
  for (i2 = 0; i2 < 32; ++i2) {
    x2[i2] = r[i2];
  }
  for (i2 = 0; i2 < 32; ++i2) {
    for (j = 0; j < 32; j++) {
      x2[i2 + j] += h[i2] * d[j];
    }
  }
  modL(sm.subarray(32), x2);
  return smlen;
}
function crypto_sign_open(m, sm, n, pk) {
  var i2, mlen;
  var t = new NativeBuffer(32);
  var p = [gf(), gf(), gf(), gf()], q = [gf(), gf(), gf(), gf()];
  mlen = -1;
  if (n < 64) {
    return -1;
  }
  if (unpackneg(q, pk)) {
    return -1;
  }
  for (i2 = 0; i2 < n; ++i2) {
    m[i2] = sm[i2];
  }
  for (i2 = 0; i2 < 32; ++i2) {
    m[i2 + 32] = pk[i2];
  }
  var h = sha512(m, n);
  reduce(h);
  scalarmult(p, q, h);
  scalarbase(q, sm.subarray(32));
  add$3(p, q);
  pack(t, p);
  n -= 64;
  if (crypto_verify_32(sm, 0, t, 0)) {
    for (i2 = 0; i2 < n; ++i2) {
      m[i2] = 0;
    }
    return -1;
  }
  for (i2 = 0; i2 < n; ++i2) {
    m[i2] = sm[i2 + 64];
  }
  mlen = n;
  return mlen;
}
function modL(r, x2) {
  var carry, i2, j, k;
  for (i2 = 63; i2 >= 32; --i2) {
    carry = 0;
    for (j = i2 - 32, k = i2 - 12; j < k; ++j) {
      x2[j] += carry - 16 * x2[i2] * L$2[j - (i2 - 32)];
      carry = x2[j] + 128 >> 8;
      x2[j] -= carry * 256;
    }
    x2[j] += carry;
    x2[i2] = 0;
  }
  carry = 0;
  for (j = 0; j < 32; ++j) {
    x2[j] += carry - (x2[31] >> 4) * L$2[j];
    carry = x2[j] >> 8;
    x2[j] &= 255;
  }
  for (j = 0; j < 32; ++j) {
    x2[j] -= carry * L$2[j];
  }
  for (i2 = 0; i2 < 32; ++i2) {
    x2[i2 + 1] += x2[i2] >> 8;
    r[i2] = x2[i2] & 255;
  }
}
function reduce(r) {
  var x2 = new Float64Array(64);
  for (var i2 = 0; i2 < 64; ++i2) {
    x2[i2] = r[i2];
    r[i2] = 0;
  }
  modL(r, x2);
}
function add$3(p, q) {
  var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf(), g = gf(), h = gf(), t = gf();
  Z(a, p[1], p[0]);
  Z(t, q[1], q[0]);
  M(a, a, t);
  A(b, p[0], p[1]);
  A(t, q[0], q[1]);
  M(b, b, t);
  M(c, p[3], q[3]);
  M(c, c, D2);
  M(d, p[2], q[2]);
  A(d, d, d);
  Z(e, b, a);
  Z(f, d, c);
  A(g, d, c);
  A(h, b, a);
  M(p[0], e, f);
  M(p[1], h, g);
  M(p[2], g, f);
  M(p[3], e, h);
}
function cswap(p, q, b) {
  for (var i2 = 0; i2 < 4; ++i2) {
    sel25519(p[i2], q[i2], b);
  }
}
function pack(r, p) {
  var tx = gf(), ty = gf(), zi = gf();
  inv25519(zi, p[2]);
  M(tx, p[0], zi);
  M(ty, p[1], zi);
  pack25519(r, ty);
  r[31] ^= par25519(tx) << 7;
}
function pack25519(o, n) {
  var i2, j, b;
  var m = gf(), t = gf();
  for (i2 = 0; i2 < 16; ++i2) {
    t[i2] = n[i2];
  }
  car25519(t);
  car25519(t);
  car25519(t);
  for (j = 0; j < 2; ++j) {
    m[0] = t[0] - 65517;
    for (i2 = 1; i2 < 15; ++i2) {
      m[i2] = t[i2] - 65535 - (m[i2 - 1] >> 16 & 1);
      m[i2 - 1] &= 65535;
    }
    m[15] = t[15] - 32767 - (m[14] >> 16 & 1);
    b = m[15] >> 16 & 1;
    m[14] &= 65535;
    sel25519(t, m, 1 - b);
  }
  for (i2 = 0; i2 < 16; i2++) {
    o[2 * i2] = t[i2] & 255;
    o[2 * i2 + 1] = t[i2] >> 8;
  }
}
function unpackneg(r, p) {
  var t = gf(), chk = gf(), num = gf(), den = gf(), den2 = gf(), den4 = gf(), den6 = gf();
  set25519(r[2], gf1);
  unpack25519(r[1], p);
  S(num, r[1]);
  M(den, num, D);
  Z(num, num, r[2]);
  A(den, r[2], den);
  S(den2, den);
  S(den4, den2);
  M(den6, den4, den2);
  M(t, den6, num);
  M(t, t, den);
  pow2523(t, t);
  M(t, t, num);
  M(t, t, den);
  M(t, t, den);
  M(r[0], t, den);
  S(chk, r[0]);
  M(chk, chk, den);
  if (neq25519(chk, num)) {
    M(r[0], r[0], I);
  }
  S(chk, r[0]);
  M(chk, chk, den);
  if (neq25519(chk, num)) {
    return -1;
  }
  if (par25519(r[0]) === p[31] >> 7) {
    Z(r[0], gf0, r[0]);
  }
  M(r[3], r[0], r[1]);
  return 0;
}
function unpack25519(o, n) {
  var i2;
  for (i2 = 0; i2 < 16; ++i2) {
    o[i2] = n[2 * i2] + (n[2 * i2 + 1] << 8);
  }
  o[15] &= 32767;
}
function pow2523(o, i2) {
  var c = gf();
  var a;
  for (a = 0; a < 16; ++a) {
    c[a] = i2[a];
  }
  for (a = 250; a >= 0; --a) {
    S(c, c);
    if (a !== 1) {
      M(c, c, i2);
    }
  }
  for (a = 0; a < 16; ++a) {
    o[a] = c[a];
  }
}
function neq25519(a, b) {
  var c = new NativeBuffer(32);
  var d = new NativeBuffer(32);
  pack25519(c, a);
  pack25519(d, b);
  return crypto_verify_32(c, 0, d, 0);
}
function crypto_verify_32(x2, xi, y, yi) {
  return vn(x2, xi, y, yi, 32);
}
function vn(x2, xi, y, yi, n) {
  var i2, d = 0;
  for (i2 = 0; i2 < n; ++i2) {
    d |= x2[xi + i2] ^ y[yi + i2];
  }
  return (1 & d - 1 >>> 8) - 1;
}
function par25519(a) {
  var d = new NativeBuffer(32);
  pack25519(d, a);
  return d[0] & 1;
}
function scalarmult(p, q, s2) {
  var b, i2;
  set25519(p[0], gf0);
  set25519(p[1], gf1);
  set25519(p[2], gf1);
  set25519(p[3], gf0);
  for (i2 = 255; i2 >= 0; --i2) {
    b = s2[i2 / 8 | 0] >> (i2 & 7) & 1;
    cswap(p, q, b);
    add$3(q, p);
    add$3(p, p);
    cswap(p, q, b);
  }
}
function scalarbase(p, s2) {
  var q = [gf(), gf(), gf(), gf()];
  set25519(q[0], X);
  set25519(q[1], Y);
  set25519(q[2], gf1);
  M(q[3], X, Y);
  scalarmult(p, q, s2);
}
function set25519(r, a) {
  var i2;
  for (i2 = 0; i2 < 16; i2++) {
    r[i2] = a[i2] | 0;
  }
}
function inv25519(o, i2) {
  var c = gf();
  var a;
  for (a = 0; a < 16; ++a) {
    c[a] = i2[a];
  }
  for (a = 253; a >= 0; --a) {
    S(c, c);
    if (a !== 2 && a !== 4) {
      M(c, c, i2);
    }
  }
  for (a = 0; a < 16; ++a) {
    o[a] = c[a];
  }
}
function car25519(o) {
  var i2, v2, c = 1;
  for (i2 = 0; i2 < 16; ++i2) {
    v2 = o[i2] + c + 65535;
    c = Math.floor(v2 / 65536);
    o[i2] = v2 - c * 65536;
  }
  o[0] += c - 1 + 37 * (c - 1);
}
function sel25519(p, q, b) {
  var t, c = ~(b - 1);
  for (var i2 = 0; i2 < 16; ++i2) {
    t = c & (p[i2] ^ q[i2]);
    p[i2] ^= t;
    q[i2] ^= t;
  }
}
function gf(init6) {
  var i2, r = new Float64Array(16);
  if (init6) {
    for (i2 = 0; i2 < init6.length; ++i2) {
      r[i2] = init6[i2];
    }
  }
  return r;
}
function A(o, a, b) {
  for (var i2 = 0; i2 < 16; ++i2) {
    o[i2] = a[i2] + b[i2];
  }
}
function Z(o, a, b) {
  for (var i2 = 0; i2 < 16; ++i2) {
    o[i2] = a[i2] - b[i2];
  }
}
function S(o, a) {
  M(o, a, a);
}
function M(o, a, b) {
  var v2, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
  v2 = a[0];
  t0 += v2 * b0;
  t1 += v2 * b1;
  t2 += v2 * b2;
  t3 += v2 * b3;
  t4 += v2 * b4;
  t5 += v2 * b5;
  t6 += v2 * b6;
  t7 += v2 * b7;
  t8 += v2 * b8;
  t9 += v2 * b9;
  t10 += v2 * b10;
  t11 += v2 * b11;
  t12 += v2 * b12;
  t13 += v2 * b13;
  t14 += v2 * b14;
  t15 += v2 * b15;
  v2 = a[1];
  t1 += v2 * b0;
  t2 += v2 * b1;
  t3 += v2 * b2;
  t4 += v2 * b3;
  t5 += v2 * b4;
  t6 += v2 * b5;
  t7 += v2 * b6;
  t8 += v2 * b7;
  t9 += v2 * b8;
  t10 += v2 * b9;
  t11 += v2 * b10;
  t12 += v2 * b11;
  t13 += v2 * b12;
  t14 += v2 * b13;
  t15 += v2 * b14;
  t16 += v2 * b15;
  v2 = a[2];
  t2 += v2 * b0;
  t3 += v2 * b1;
  t4 += v2 * b2;
  t5 += v2 * b3;
  t6 += v2 * b4;
  t7 += v2 * b5;
  t8 += v2 * b6;
  t9 += v2 * b7;
  t10 += v2 * b8;
  t11 += v2 * b9;
  t12 += v2 * b10;
  t13 += v2 * b11;
  t14 += v2 * b12;
  t15 += v2 * b13;
  t16 += v2 * b14;
  t17 += v2 * b15;
  v2 = a[3];
  t3 += v2 * b0;
  t4 += v2 * b1;
  t5 += v2 * b2;
  t6 += v2 * b3;
  t7 += v2 * b4;
  t8 += v2 * b5;
  t9 += v2 * b6;
  t10 += v2 * b7;
  t11 += v2 * b8;
  t12 += v2 * b9;
  t13 += v2 * b10;
  t14 += v2 * b11;
  t15 += v2 * b12;
  t16 += v2 * b13;
  t17 += v2 * b14;
  t18 += v2 * b15;
  v2 = a[4];
  t4 += v2 * b0;
  t5 += v2 * b1;
  t6 += v2 * b2;
  t7 += v2 * b3;
  t8 += v2 * b4;
  t9 += v2 * b5;
  t10 += v2 * b6;
  t11 += v2 * b7;
  t12 += v2 * b8;
  t13 += v2 * b9;
  t14 += v2 * b10;
  t15 += v2 * b11;
  t16 += v2 * b12;
  t17 += v2 * b13;
  t18 += v2 * b14;
  t19 += v2 * b15;
  v2 = a[5];
  t5 += v2 * b0;
  t6 += v2 * b1;
  t7 += v2 * b2;
  t8 += v2 * b3;
  t9 += v2 * b4;
  t10 += v2 * b5;
  t11 += v2 * b6;
  t12 += v2 * b7;
  t13 += v2 * b8;
  t14 += v2 * b9;
  t15 += v2 * b10;
  t16 += v2 * b11;
  t17 += v2 * b12;
  t18 += v2 * b13;
  t19 += v2 * b14;
  t20 += v2 * b15;
  v2 = a[6];
  t6 += v2 * b0;
  t7 += v2 * b1;
  t8 += v2 * b2;
  t9 += v2 * b3;
  t10 += v2 * b4;
  t11 += v2 * b5;
  t12 += v2 * b6;
  t13 += v2 * b7;
  t14 += v2 * b8;
  t15 += v2 * b9;
  t16 += v2 * b10;
  t17 += v2 * b11;
  t18 += v2 * b12;
  t19 += v2 * b13;
  t20 += v2 * b14;
  t21 += v2 * b15;
  v2 = a[7];
  t7 += v2 * b0;
  t8 += v2 * b1;
  t9 += v2 * b2;
  t10 += v2 * b3;
  t11 += v2 * b4;
  t12 += v2 * b5;
  t13 += v2 * b6;
  t14 += v2 * b7;
  t15 += v2 * b8;
  t16 += v2 * b9;
  t17 += v2 * b10;
  t18 += v2 * b11;
  t19 += v2 * b12;
  t20 += v2 * b13;
  t21 += v2 * b14;
  t22 += v2 * b15;
  v2 = a[8];
  t8 += v2 * b0;
  t9 += v2 * b1;
  t10 += v2 * b2;
  t11 += v2 * b3;
  t12 += v2 * b4;
  t13 += v2 * b5;
  t14 += v2 * b6;
  t15 += v2 * b7;
  t16 += v2 * b8;
  t17 += v2 * b9;
  t18 += v2 * b10;
  t19 += v2 * b11;
  t20 += v2 * b12;
  t21 += v2 * b13;
  t22 += v2 * b14;
  t23 += v2 * b15;
  v2 = a[9];
  t9 += v2 * b0;
  t10 += v2 * b1;
  t11 += v2 * b2;
  t12 += v2 * b3;
  t13 += v2 * b4;
  t14 += v2 * b5;
  t15 += v2 * b6;
  t16 += v2 * b7;
  t17 += v2 * b8;
  t18 += v2 * b9;
  t19 += v2 * b10;
  t20 += v2 * b11;
  t21 += v2 * b12;
  t22 += v2 * b13;
  t23 += v2 * b14;
  t24 += v2 * b15;
  v2 = a[10];
  t10 += v2 * b0;
  t11 += v2 * b1;
  t12 += v2 * b2;
  t13 += v2 * b3;
  t14 += v2 * b4;
  t15 += v2 * b5;
  t16 += v2 * b6;
  t17 += v2 * b7;
  t18 += v2 * b8;
  t19 += v2 * b9;
  t20 += v2 * b10;
  t21 += v2 * b11;
  t22 += v2 * b12;
  t23 += v2 * b13;
  t24 += v2 * b14;
  t25 += v2 * b15;
  v2 = a[11];
  t11 += v2 * b0;
  t12 += v2 * b1;
  t13 += v2 * b2;
  t14 += v2 * b3;
  t15 += v2 * b4;
  t16 += v2 * b5;
  t17 += v2 * b6;
  t18 += v2 * b7;
  t19 += v2 * b8;
  t20 += v2 * b9;
  t21 += v2 * b10;
  t22 += v2 * b11;
  t23 += v2 * b12;
  t24 += v2 * b13;
  t25 += v2 * b14;
  t26 += v2 * b15;
  v2 = a[12];
  t12 += v2 * b0;
  t13 += v2 * b1;
  t14 += v2 * b2;
  t15 += v2 * b3;
  t16 += v2 * b4;
  t17 += v2 * b5;
  t18 += v2 * b6;
  t19 += v2 * b7;
  t20 += v2 * b8;
  t21 += v2 * b9;
  t22 += v2 * b10;
  t23 += v2 * b11;
  t24 += v2 * b12;
  t25 += v2 * b13;
  t26 += v2 * b14;
  t27 += v2 * b15;
  v2 = a[13];
  t13 += v2 * b0;
  t14 += v2 * b1;
  t15 += v2 * b2;
  t16 += v2 * b3;
  t17 += v2 * b4;
  t18 += v2 * b5;
  t19 += v2 * b6;
  t20 += v2 * b7;
  t21 += v2 * b8;
  t22 += v2 * b9;
  t23 += v2 * b10;
  t24 += v2 * b11;
  t25 += v2 * b12;
  t26 += v2 * b13;
  t27 += v2 * b14;
  t28 += v2 * b15;
  v2 = a[14];
  t14 += v2 * b0;
  t15 += v2 * b1;
  t16 += v2 * b2;
  t17 += v2 * b3;
  t18 += v2 * b4;
  t19 += v2 * b5;
  t20 += v2 * b6;
  t21 += v2 * b7;
  t22 += v2 * b8;
  t23 += v2 * b9;
  t24 += v2 * b10;
  t25 += v2 * b11;
  t26 += v2 * b12;
  t27 += v2 * b13;
  t28 += v2 * b14;
  t29 += v2 * b15;
  v2 = a[15];
  t15 += v2 * b0;
  t16 += v2 * b1;
  t17 += v2 * b2;
  t18 += v2 * b3;
  t19 += v2 * b4;
  t20 += v2 * b5;
  t21 += v2 * b6;
  t22 += v2 * b7;
  t23 += v2 * b8;
  t24 += v2 * b9;
  t25 += v2 * b10;
  t26 += v2 * b11;
  t27 += v2 * b12;
  t28 += v2 * b13;
  t29 += v2 * b14;
  t30 += v2 * b15;
  t0 += 38 * t16;
  t1 += 38 * t17;
  t2 += 38 * t18;
  t3 += 38 * t19;
  t4 += 38 * t20;
  t5 += 38 * t21;
  t6 += 38 * t22;
  t7 += 38 * t23;
  t8 += 38 * t24;
  t9 += 38 * t25;
  t10 += 38 * t26;
  t11 += 38 * t27;
  t12 += 38 * t28;
  t13 += 38 * t29;
  t14 += 38 * t30;
  c = 1;
  v2 = t0 + c + 65535;
  c = Math.floor(v2 / 65536);
  t0 = v2 - c * 65536;
  v2 = t1 + c + 65535;
  c = Math.floor(v2 / 65536);
  t1 = v2 - c * 65536;
  v2 = t2 + c + 65535;
  c = Math.floor(v2 / 65536);
  t2 = v2 - c * 65536;
  v2 = t3 + c + 65535;
  c = Math.floor(v2 / 65536);
  t3 = v2 - c * 65536;
  v2 = t4 + c + 65535;
  c = Math.floor(v2 / 65536);
  t4 = v2 - c * 65536;
  v2 = t5 + c + 65535;
  c = Math.floor(v2 / 65536);
  t5 = v2 - c * 65536;
  v2 = t6 + c + 65535;
  c = Math.floor(v2 / 65536);
  t6 = v2 - c * 65536;
  v2 = t7 + c + 65535;
  c = Math.floor(v2 / 65536);
  t7 = v2 - c * 65536;
  v2 = t8 + c + 65535;
  c = Math.floor(v2 / 65536);
  t8 = v2 - c * 65536;
  v2 = t9 + c + 65535;
  c = Math.floor(v2 / 65536);
  t9 = v2 - c * 65536;
  v2 = t10 + c + 65535;
  c = Math.floor(v2 / 65536);
  t10 = v2 - c * 65536;
  v2 = t11 + c + 65535;
  c = Math.floor(v2 / 65536);
  t11 = v2 - c * 65536;
  v2 = t12 + c + 65535;
  c = Math.floor(v2 / 65536);
  t12 = v2 - c * 65536;
  v2 = t13 + c + 65535;
  c = Math.floor(v2 / 65536);
  t13 = v2 - c * 65536;
  v2 = t14 + c + 65535;
  c = Math.floor(v2 / 65536);
  t14 = v2 - c * 65536;
  v2 = t15 + c + 65535;
  c = Math.floor(v2 / 65536);
  t15 = v2 - c * 65536;
  t0 += c - 1 + 37 * (c - 1);
  c = 1;
  v2 = t0 + c + 65535;
  c = Math.floor(v2 / 65536);
  t0 = v2 - c * 65536;
  v2 = t1 + c + 65535;
  c = Math.floor(v2 / 65536);
  t1 = v2 - c * 65536;
  v2 = t2 + c + 65535;
  c = Math.floor(v2 / 65536);
  t2 = v2 - c * 65536;
  v2 = t3 + c + 65535;
  c = Math.floor(v2 / 65536);
  t3 = v2 - c * 65536;
  v2 = t4 + c + 65535;
  c = Math.floor(v2 / 65536);
  t4 = v2 - c * 65536;
  v2 = t5 + c + 65535;
  c = Math.floor(v2 / 65536);
  t5 = v2 - c * 65536;
  v2 = t6 + c + 65535;
  c = Math.floor(v2 / 65536);
  t6 = v2 - c * 65536;
  v2 = t7 + c + 65535;
  c = Math.floor(v2 / 65536);
  t7 = v2 - c * 65536;
  v2 = t8 + c + 65535;
  c = Math.floor(v2 / 65536);
  t8 = v2 - c * 65536;
  v2 = t9 + c + 65535;
  c = Math.floor(v2 / 65536);
  t9 = v2 - c * 65536;
  v2 = t10 + c + 65535;
  c = Math.floor(v2 / 65536);
  t10 = v2 - c * 65536;
  v2 = t11 + c + 65535;
  c = Math.floor(v2 / 65536);
  t11 = v2 - c * 65536;
  v2 = t12 + c + 65535;
  c = Math.floor(v2 / 65536);
  t12 = v2 - c * 65536;
  v2 = t13 + c + 65535;
  c = Math.floor(v2 / 65536);
  t13 = v2 - c * 65536;
  v2 = t14 + c + 65535;
  c = Math.floor(v2 / 65536);
  t14 = v2 - c * 65536;
  v2 = t15 + c + 65535;
  c = Math.floor(v2 / 65536);
  t15 = v2 - c * 65536;
  t0 += c - 1 + 37 * (c - 1);
  o[0] = t0;
  o[1] = t1;
  o[2] = t2;
  o[3] = t3;
  o[4] = t4;
  o[5] = t5;
  o[6] = t6;
  o[7] = t7;
  o[8] = t8;
  o[9] = t9;
  o[10] = t10;
  o[11] = t11;
  o[12] = t12;
  o[13] = t13;
  o[14] = t14;
  o[15] = t15;
}
var forge$3 = forge$C;
forge$3.kem = forge$3.kem || {};
var BigInteger = forge$3.jsbn.BigInteger;
forge$3.kem.rsa = {};
forge$3.kem.rsa.create = function(kdf, options) {
  options = options || {};
  var prng2 = options.prng || forge$3.random;
  var kem = {};
  kem.encrypt = function(publicKey, keyLength) {
    var byteLength = Math.ceil(publicKey.n.bitLength() / 8);
    var r;
    do {
      r = new BigInteger(forge$3.util.bytesToHex(prng2.getBytesSync(byteLength)), 16).mod(publicKey.n);
    } while (r.compareTo(BigInteger.ONE) <= 0);
    r = forge$3.util.hexToBytes(r.toString(16));
    var zeros = byteLength - r.length;
    if (zeros > 0) {
      r = forge$3.util.fillString(String.fromCharCode(0), zeros) + r;
    }
    var encapsulation = publicKey.encrypt(r, "NONE");
    var key = kdf.generate(r, keyLength);
    return { encapsulation, key };
  };
  kem.decrypt = function(privateKey, encapsulation, keyLength) {
    var r = privateKey.decrypt(encapsulation, "NONE");
    return kdf.generate(r, keyLength);
  };
  return kem;
};
forge$3.kem.kdf1 = function(md, digestLength) {
  _createKDF(this, md, 0, digestLength || md.digestLength);
};
forge$3.kem.kdf2 = function(md, digestLength) {
  _createKDF(this, md, 1, digestLength || md.digestLength);
};
function _createKDF(kdf, md, counterStart, digestLength) {
  kdf.generate = function(x2, length) {
    var key = new forge$3.util.ByteBuffer();
    var k = Math.ceil(length / digestLength) + counterStart;
    var c = new forge$3.util.ByteBuffer();
    for (var i2 = counterStart; i2 < k; ++i2) {
      c.putInt32(i2);
      md.start();
      md.update(x2 + c.getBytes());
      var hash2 = md.digest();
      key.putBytes(hash2.getBytes(digestLength));
    }
    key.truncate(key.length() - length);
    return key.getBytes();
  };
}
var forge$2 = forge$C;
forge$2.log = forge$2.log || {};
forge$2.log.levels = [
  "none",
  "error",
  "warning",
  "info",
  "debug",
  "verbose",
  "max"
];
var sLevelInfo = {};
var sLoggers = [];
var sConsoleLogger = null;
forge$2.log.LEVEL_LOCKED = 1 << 1;
forge$2.log.NO_LEVEL_CHECK = 1 << 2;
forge$2.log.INTERPOLATE = 1 << 3;
for (var i$2 = 0; i$2 < forge$2.log.levels.length; ++i$2) {
  var level = forge$2.log.levels[i$2];
  sLevelInfo[level] = {
    index: i$2,
    name: level.toUpperCase()
  };
}
forge$2.log.logMessage = function(message) {
  var messageLevelIndex = sLevelInfo[message.level].index;
  for (var i2 = 0; i2 < sLoggers.length; ++i2) {
    var logger = sLoggers[i2];
    if (logger.flags & forge$2.log.NO_LEVEL_CHECK) {
      logger.f(message);
    } else {
      var loggerLevelIndex = sLevelInfo[logger.level].index;
      if (messageLevelIndex <= loggerLevelIndex) {
        logger.f(logger, message);
      }
    }
  }
};
forge$2.log.prepareStandard = function(message) {
  if (!("standard" in message)) {
    message.standard = sLevelInfo[message.level].name + " [" + message.category + "] " + message.message;
  }
};
forge$2.log.prepareFull = function(message) {
  if (!("full" in message)) {
    var args = [message.message];
    args = args.concat([]);
    message.full = forge$2.util.format.apply(this, args);
  }
};
forge$2.log.prepareStandardFull = function(message) {
  if (!("standardFull" in message)) {
    forge$2.log.prepareStandard(message);
    message.standardFull = message.standard;
  }
};
{
  var levels = ["error", "warning", "info", "debug", "verbose"];
  for (var i$2 = 0; i$2 < levels.length; ++i$2) {
    (function(level) {
      forge$2.log[level] = function(category, message) {
        var args = Array.prototype.slice.call(arguments).slice(2);
        var msg = {
          timestamp: new Date(),
          level,
          category,
          message,
          "arguments": args
        };
        forge$2.log.logMessage(msg);
      };
    })(levels[i$2]);
  }
}
forge$2.log.makeLogger = function(logFunction) {
  var logger = {
    flags: 0,
    f: logFunction
  };
  forge$2.log.setLevel(logger, "none");
  return logger;
};
forge$2.log.setLevel = function(logger, level) {
  var rval = false;
  if (logger && !(logger.flags & forge$2.log.LEVEL_LOCKED)) {
    for (var i2 = 0; i2 < forge$2.log.levels.length; ++i2) {
      var aValidLevel = forge$2.log.levels[i2];
      if (level == aValidLevel) {
        logger.level = level;
        rval = true;
        break;
      }
    }
  }
  return rval;
};
forge$2.log.lock = function(logger, lock) {
  if (typeof lock === "undefined" || lock) {
    logger.flags |= forge$2.log.LEVEL_LOCKED;
  } else {
    logger.flags &= ~forge$2.log.LEVEL_LOCKED;
  }
};
forge$2.log.addLogger = function(logger) {
  sLoggers.push(logger);
};
if (typeof console !== "undefined" && "log" in console) {
  var logger;
  if (console.error && console.warn && console.info && console.debug) {
    var levelHandlers = {
      error: console.error,
      warning: console.warn,
      info: console.info,
      debug: console.debug,
      verbose: console.debug
    };
    var f = function(logger2, message) {
      forge$2.log.prepareStandard(message);
      var handler = levelHandlers[message.level];
      var args = [message.standard];
      args = args.concat(message["arguments"].slice());
      handler.apply(console, args);
    };
    logger = forge$2.log.makeLogger(f);
  } else {
    var f = function(logger2, message) {
      forge$2.log.prepareStandardFull(message);
      console.log(message.standardFull);
    };
    logger = forge$2.log.makeLogger(f);
  }
  forge$2.log.setLevel(logger, "debug");
  forge$2.log.addLogger(logger);
  sConsoleLogger = logger;
} else {
  console = {
    log: function() {
    }
  };
}
if (sConsoleLogger !== null && typeof window !== "undefined" && window.location) {
  var query = new URL(window.location.href).searchParams;
  if (query.has("console.level")) {
    forge$2.log.setLevel(sConsoleLogger, query.get("console.level").slice(-1)[0]);
  }
  if (query.has("console.lock")) {
    var lock = query.get("console.lock").slice(-1)[0];
    if (lock == "true") {
      forge$2.log.lock(sConsoleLogger);
    }
  }
}
forge$2.log.consoleLogger = sConsoleLogger;
var forge$1 = forge$C;
var asn1 = forge$1.asn1;
var p7 = forge$1.pkcs7 = forge$1.pkcs7 || {};
p7.messageFromPem = function(pem2) {
  var msg = forge$1.pem.decode(pem2)[0];
  if (msg.type !== "PKCS7") {
    var error = new Error('Could not convert PKCS#7 message from PEM; PEM header type is not "PKCS#7".');
    error.headerType = msg.type;
    throw error;
  }
  if (msg.procType && msg.procType.type === "ENCRYPTED") {
    throw new Error("Could not convert PKCS#7 message from PEM; PEM is encrypted.");
  }
  var obj = asn1.fromDer(msg.body);
  return p7.messageFromAsn1(obj);
};
p7.messageToPem = function(msg, maxline) {
  var pemObj = {
    type: "PKCS7",
    body: asn1.toDer(msg.toAsn1()).getBytes()
  };
  return forge$1.pem.encode(pemObj, { maxline });
};
p7.messageFromAsn1 = function(obj) {
  var capture = {};
  var errors = [];
  if (!asn1.validate(obj, p7.asn1.contentInfoValidator, capture, errors)) {
    var error = new Error("Cannot read PKCS#7 message. ASN.1 object is not an PKCS#7 ContentInfo.");
    error.errors = errors;
    throw error;
  }
  var contentType = asn1.derToOid(capture.contentType);
  var msg;
  switch (contentType) {
    case forge$1.pki.oids.envelopedData:
      msg = p7.createEnvelopedData();
      break;
    case forge$1.pki.oids.encryptedData:
      msg = p7.createEncryptedData();
      break;
    case forge$1.pki.oids.signedData:
      msg = p7.createSignedData();
      break;
    default:
      throw new Error("Cannot read PKCS#7 message. ContentType with OID " + contentType + " is not (yet) supported.");
  }
  msg.fromAsn1(capture.content.value[0]);
  return msg;
};
p7.createSignedData = function() {
  var msg = null;
  msg = {
    type: forge$1.pki.oids.signedData,
    version: 1,
    certificates: [],
    crls: [],
    signers: [],
    digestAlgorithmIdentifiers: [],
    contentInfo: null,
    signerInfos: [],
    fromAsn1: function(obj) {
      _fromAsn1(msg, obj, p7.asn1.signedDataValidator);
      msg.certificates = [];
      msg.crls = [];
      msg.digestAlgorithmIdentifiers = [];
      msg.contentInfo = null;
      msg.signerInfos = [];
      if (msg.rawCapture.certificates) {
        var certs = msg.rawCapture.certificates.value;
        for (var i2 = 0; i2 < certs.length; ++i2) {
          msg.certificates.push(forge$1.pki.certificateFromAsn1(certs[i2]));
        }
      }
    },
    toAsn1: function() {
      if (!msg.contentInfo) {
        msg.sign();
      }
      var certs = [];
      for (var i2 = 0; i2 < msg.certificates.length; ++i2) {
        certs.push(forge$1.pki.certificateToAsn1(msg.certificates[i2]));
      }
      var crls = [];
      var signedData = asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [
          asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, asn1.integerToDer(msg.version).getBytes()),
          asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SET, true, msg.digestAlgorithmIdentifiers),
          msg.contentInfo
        ])
      ]);
      if (certs.length > 0) {
        signedData.value[0].value.push(asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, certs));
      }
      if (crls.length > 0) {
        signedData.value[0].value.push(asn1.create(asn1.Class.CONTEXT_SPECIFIC, 1, true, crls));
      }
      signedData.value[0].value.push(asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SET, true, msg.signerInfos));
      return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(msg.type).getBytes()),
        signedData
      ]);
    },
    addSigner: function(signer) {
      var issuer = signer.issuer;
      var serialNumber = signer.serialNumber;
      if (signer.certificate) {
        var cert = signer.certificate;
        if (typeof cert === "string") {
          cert = forge$1.pki.certificateFromPem(cert);
        }
        issuer = cert.issuer.attributes;
        serialNumber = cert.serialNumber;
      }
      var key = signer.key;
      if (!key) {
        throw new Error("Could not add PKCS#7 signer; no private key specified.");
      }
      if (typeof key === "string") {
        key = forge$1.pki.privateKeyFromPem(key);
      }
      var digestAlgorithm = signer.digestAlgorithm || forge$1.pki.oids.sha1;
      switch (digestAlgorithm) {
        case forge$1.pki.oids.sha1:
        case forge$1.pki.oids.sha256:
        case forge$1.pki.oids.sha384:
        case forge$1.pki.oids.sha512:
        case forge$1.pki.oids.md5:
          break;
        default:
          throw new Error("Could not add PKCS#7 signer; unknown message digest algorithm: " + digestAlgorithm);
      }
      var authenticatedAttributes = signer.authenticatedAttributes || [];
      if (authenticatedAttributes.length > 0) {
        var contentType = false;
        var messageDigest = false;
        for (var i2 = 0; i2 < authenticatedAttributes.length; ++i2) {
          var attr = authenticatedAttributes[i2];
          if (!contentType && attr.type === forge$1.pki.oids.contentType) {
            contentType = true;
            if (messageDigest) {
              break;
            }
            continue;
          }
          if (!messageDigest && attr.type === forge$1.pki.oids.messageDigest) {
            messageDigest = true;
            if (contentType) {
              break;
            }
            continue;
          }
        }
        if (!contentType || !messageDigest) {
          throw new Error("Invalid signer.authenticatedAttributes. If signer.authenticatedAttributes is specified, then it must contain at least two attributes, PKCS #9 content-type and PKCS #9 message-digest.");
        }
      }
      msg.signers.push({
        key,
        version: 1,
        issuer,
        serialNumber,
        digestAlgorithm,
        signatureAlgorithm: forge$1.pki.oids.rsaEncryption,
        signature: null,
        authenticatedAttributes,
        unauthenticatedAttributes: []
      });
    },
    sign: function(options) {
      options = options || {};
      if (typeof msg.content !== "object" || msg.contentInfo === null) {
        msg.contentInfo = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [
          asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(forge$1.pki.oids.data).getBytes())
        ]);
        if ("content" in msg) {
          var content2;
          if (msg.content instanceof forge$1.util.ByteBuffer) {
            content2 = msg.content.bytes();
          } else if (typeof msg.content === "string") {
            content2 = forge$1.util.encodeUtf8(msg.content);
          }
          if (options.detached) {
            msg.detachedContent = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, content2);
          } else {
            msg.contentInfo.value.push(asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [
              asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, content2)
            ]));
          }
        }
      }
      if (msg.signers.length === 0) {
        return;
      }
      var mds = addDigestAlgorithmIds();
      addSignerInfos(mds);
    },
    verify: function() {
      throw new Error("PKCS#7 signature verification not yet implemented.");
    },
    addCertificate: function(cert) {
      if (typeof cert === "string") {
        cert = forge$1.pki.certificateFromPem(cert);
      }
      msg.certificates.push(cert);
    },
    addCertificateRevokationList: function(crl) {
      throw new Error("PKCS#7 CRL support not yet implemented.");
    }
  };
  return msg;
  function addDigestAlgorithmIds() {
    var mds = {};
    for (var i2 = 0; i2 < msg.signers.length; ++i2) {
      var signer = msg.signers[i2];
      var oid = signer.digestAlgorithm;
      if (!(oid in mds)) {
        mds[oid] = forge$1.md[forge$1.pki.oids[oid]].create();
      }
      if (signer.authenticatedAttributes.length === 0) {
        signer.md = mds[oid];
      } else {
        signer.md = forge$1.md[forge$1.pki.oids[oid]].create();
      }
    }
    msg.digestAlgorithmIdentifiers = [];
    for (var oid in mds) {
      msg.digestAlgorithmIdentifiers.push(asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(oid).getBytes()),
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, false, "")
      ]));
    }
    return mds;
  }
  function addSignerInfos(mds) {
    var content2;
    if (msg.detachedContent) {
      content2 = msg.detachedContent;
    } else {
      content2 = msg.contentInfo.value[1];
      content2 = content2.value[0];
    }
    if (!content2) {
      throw new Error("Could not sign PKCS#7 message; there is no content to sign.");
    }
    var contentType = asn1.derToOid(msg.contentInfo.value[0].value);
    var bytes = asn1.toDer(content2);
    bytes.getByte();
    asn1.getBerValueLength(bytes);
    bytes = bytes.getBytes();
    for (var oid in mds) {
      mds[oid].start().update(bytes);
    }
    var signingTime = new Date();
    for (var i2 = 0; i2 < msg.signers.length; ++i2) {
      var signer = msg.signers[i2];
      if (signer.authenticatedAttributes.length === 0) {
        if (contentType !== forge$1.pki.oids.data) {
          throw new Error("Invalid signer; authenticatedAttributes must be present when the ContentInfo content type is not PKCS#7 Data.");
        }
      } else {
        signer.authenticatedAttributesAsn1 = asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, []);
        var attrsAsn1 = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SET, true, []);
        for (var ai = 0; ai < signer.authenticatedAttributes.length; ++ai) {
          var attr = signer.authenticatedAttributes[ai];
          if (attr.type === forge$1.pki.oids.messageDigest) {
            attr.value = mds[signer.digestAlgorithm].digest();
          } else if (attr.type === forge$1.pki.oids.signingTime) {
            if (!attr.value) {
              attr.value = signingTime;
            }
          }
          attrsAsn1.value.push(_attributeToAsn1(attr));
          signer.authenticatedAttributesAsn1.value.push(_attributeToAsn1(attr));
        }
        bytes = asn1.toDer(attrsAsn1).getBytes();
        signer.md.start().update(bytes);
      }
      signer.signature = signer.key.sign(signer.md, "RSASSA-PKCS1-V1_5");
    }
    msg.signerInfos = _signersToAsn1(msg.signers);
  }
};
p7.createEncryptedData = function() {
  var msg = null;
  msg = {
    type: forge$1.pki.oids.encryptedData,
    version: 0,
    encryptedContent: {
      algorithm: forge$1.pki.oids["aes256-CBC"]
    },
    fromAsn1: function(obj) {
      _fromAsn1(msg, obj, p7.asn1.encryptedDataValidator);
    },
    decrypt: function(key) {
      if (key !== void 0) {
        msg.encryptedContent.key = key;
      }
      _decryptContent(msg);
    }
  };
  return msg;
};
p7.createEnvelopedData = function() {
  var msg = null;
  msg = {
    type: forge$1.pki.oids.envelopedData,
    version: 0,
    recipients: [],
    encryptedContent: {
      algorithm: forge$1.pki.oids["aes256-CBC"]
    },
    fromAsn1: function(obj) {
      var capture = _fromAsn1(msg, obj, p7.asn1.envelopedDataValidator);
      msg.recipients = _recipientsFromAsn1(capture.recipientInfos.value);
    },
    toAsn1: function() {
      return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(msg.type).getBytes()),
        asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [
          asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [
            asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, asn1.integerToDer(msg.version).getBytes()),
            asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SET, true, _recipientsToAsn1(msg.recipients)),
            asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, _encryptedContentToAsn1(msg.encryptedContent))
          ])
        ])
      ]);
    },
    findRecipient: function(cert) {
      var sAttr = cert.issuer.attributes;
      for (var i2 = 0; i2 < msg.recipients.length; ++i2) {
        var r = msg.recipients[i2];
        var rAttr = r.issuer;
        if (r.serialNumber !== cert.serialNumber) {
          continue;
        }
        if (rAttr.length !== sAttr.length) {
          continue;
        }
        var match = true;
        for (var j = 0; j < sAttr.length; ++j) {
          if (rAttr[j].type !== sAttr[j].type || rAttr[j].value !== sAttr[j].value) {
            match = false;
            break;
          }
        }
        if (match) {
          return r;
        }
      }
      return null;
    },
    decrypt: function(recipient, privKey) {
      if (msg.encryptedContent.key === void 0 && recipient !== void 0 && privKey !== void 0) {
        switch (recipient.encryptedContent.algorithm) {
          case forge$1.pki.oids.rsaEncryption:
          case forge$1.pki.oids.desCBC:
            var key = privKey.decrypt(recipient.encryptedContent.content);
            msg.encryptedContent.key = forge$1.util.createBuffer(key);
            break;
          default:
            throw new Error("Unsupported asymmetric cipher, OID " + recipient.encryptedContent.algorithm);
        }
      }
      _decryptContent(msg);
    },
    addRecipient: function(cert) {
      msg.recipients.push({
        version: 0,
        issuer: cert.issuer.attributes,
        serialNumber: cert.serialNumber,
        encryptedContent: {
          algorithm: forge$1.pki.oids.rsaEncryption,
          key: cert.publicKey
        }
      });
    },
    encrypt: function(key, cipher) {
      if (msg.encryptedContent.content === void 0) {
        cipher = cipher || msg.encryptedContent.algorithm;
        key = key || msg.encryptedContent.key;
        var keyLen, ivLen, ciphFn;
        switch (cipher) {
          case forge$1.pki.oids["aes128-CBC"]:
            keyLen = 16;
            ivLen = 16;
            ciphFn = forge$1.aes.createEncryptionCipher;
            break;
          case forge$1.pki.oids["aes192-CBC"]:
            keyLen = 24;
            ivLen = 16;
            ciphFn = forge$1.aes.createEncryptionCipher;
            break;
          case forge$1.pki.oids["aes256-CBC"]:
            keyLen = 32;
            ivLen = 16;
            ciphFn = forge$1.aes.createEncryptionCipher;
            break;
          case forge$1.pki.oids["des-EDE3-CBC"]:
            keyLen = 24;
            ivLen = 8;
            ciphFn = forge$1.des.createEncryptionCipher;
            break;
          default:
            throw new Error("Unsupported symmetric cipher, OID " + cipher);
        }
        if (key === void 0) {
          key = forge$1.util.createBuffer(forge$1.random.getBytes(keyLen));
        } else if (key.length() != keyLen) {
          throw new Error("Symmetric key has wrong length; got " + key.length() + " bytes, expected " + keyLen + ".");
        }
        msg.encryptedContent.algorithm = cipher;
        msg.encryptedContent.key = key;
        msg.encryptedContent.parameter = forge$1.util.createBuffer(forge$1.random.getBytes(ivLen));
        var ciph = ciphFn(key);
        ciph.start(msg.encryptedContent.parameter.copy());
        ciph.update(msg.content);
        if (!ciph.finish()) {
          throw new Error("Symmetric encryption failed.");
        }
        msg.encryptedContent.content = ciph.output;
      }
      for (var i2 = 0; i2 < msg.recipients.length; ++i2) {
        var recipient = msg.recipients[i2];
        if (recipient.encryptedContent.content !== void 0) {
          continue;
        }
        switch (recipient.encryptedContent.algorithm) {
          case forge$1.pki.oids.rsaEncryption:
            recipient.encryptedContent.content = recipient.encryptedContent.key.encrypt(msg.encryptedContent.key.data);
            break;
          default:
            throw new Error("Unsupported asymmetric cipher, OID " + recipient.encryptedContent.algorithm);
        }
      }
    }
  };
  return msg;
};
function _recipientFromAsn1(obj) {
  var capture = {};
  var errors = [];
  if (!asn1.validate(obj, p7.asn1.recipientInfoValidator, capture, errors)) {
    var error = new Error("Cannot read PKCS#7 RecipientInfo. ASN.1 object is not an PKCS#7 RecipientInfo.");
    error.errors = errors;
    throw error;
  }
  return {
    version: capture.version.charCodeAt(0),
    issuer: forge$1.pki.RDNAttributesAsArray(capture.issuer),
    serialNumber: forge$1.util.createBuffer(capture.serial).toHex(),
    encryptedContent: {
      algorithm: asn1.derToOid(capture.encAlgorithm),
      parameter: capture.encParameter ? capture.encParameter.value : void 0,
      content: capture.encKey
    }
  };
}
function _recipientToAsn1(obj) {
  return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, asn1.integerToDer(obj.version).getBytes()),
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [
      forge$1.pki.distinguishedNameToAsn1({ attributes: obj.issuer }),
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, forge$1.util.hexToBytes(obj.serialNumber))
    ]),
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(obj.encryptedContent.algorithm).getBytes()),
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, false, "")
    ]),
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, obj.encryptedContent.content)
  ]);
}
function _recipientsFromAsn1(infos) {
  var ret = [];
  for (var i2 = 0; i2 < infos.length; ++i2) {
    ret.push(_recipientFromAsn1(infos[i2]));
  }
  return ret;
}
function _recipientsToAsn1(recipients) {
  var ret = [];
  for (var i2 = 0; i2 < recipients.length; ++i2) {
    ret.push(_recipientToAsn1(recipients[i2]));
  }
  return ret;
}
function _signerToAsn1(obj) {
  var rval = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, asn1.integerToDer(obj.version).getBytes()),
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [
      forge$1.pki.distinguishedNameToAsn1({ attributes: obj.issuer }),
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.INTEGER, false, forge$1.util.hexToBytes(obj.serialNumber))
    ]),
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(obj.digestAlgorithm).getBytes()),
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, false, "")
    ])
  ]);
  if (obj.authenticatedAttributesAsn1) {
    rval.value.push(obj.authenticatedAttributesAsn1);
  }
  rval.value.push(asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(obj.signatureAlgorithm).getBytes()),
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, false, "")
  ]));
  rval.value.push(asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, obj.signature));
  if (obj.unauthenticatedAttributes.length > 0) {
    var attrsAsn1 = asn1.create(asn1.Class.CONTEXT_SPECIFIC, 1, true, []);
    for (var i2 = 0; i2 < obj.unauthenticatedAttributes.length; ++i2) {
      var attr = obj.unauthenticatedAttributes[i2];
      attrsAsn1.values.push(_attributeToAsn1(attr));
    }
    rval.value.push(attrsAsn1);
  }
  return rval;
}
function _signersToAsn1(signers) {
  var ret = [];
  for (var i2 = 0; i2 < signers.length; ++i2) {
    ret.push(_signerToAsn1(signers[i2]));
  }
  return ret;
}
function _attributeToAsn1(attr) {
  var value;
  if (attr.type === forge$1.pki.oids.contentType) {
    value = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(attr.value).getBytes());
  } else if (attr.type === forge$1.pki.oids.messageDigest) {
    value = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, attr.value.bytes());
  } else if (attr.type === forge$1.pki.oids.signingTime) {
    var jan_1_19502 = new Date("1950-01-01T00:00:00Z");
    var jan_1_20502 = new Date("2050-01-01T00:00:00Z");
    var date2 = attr.value;
    if (typeof date2 === "string") {
      var timestamp = Date.parse(date2);
      if (!isNaN(timestamp)) {
        date2 = new Date(timestamp);
      } else if (date2.length === 13) {
        date2 = asn1.utcTimeToDate(date2);
      } else {
        date2 = asn1.generalizedTimeToDate(date2);
      }
    }
    if (date2 >= jan_1_19502 && date2 < jan_1_20502) {
      value = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.UTCTIME, false, asn1.dateToUtcTime(date2));
    } else {
      value = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.GENERALIZEDTIME, false, asn1.dateToGeneralizedTime(date2));
    }
  }
  return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(attr.type).getBytes()),
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SET, true, [
      value
    ])
  ]);
}
function _encryptedContentToAsn1(ec) {
  return [
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(forge$1.pki.oids.data).getBytes()),
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, true, [
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OID, false, asn1.oidToDer(ec.algorithm).getBytes()),
      !ec.parameter ? void 0 : asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, ec.parameter.getBytes())
    ]),
    asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, true, [
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, false, ec.content.getBytes())
    ])
  ];
}
function _fromAsn1(msg, obj, validator2) {
  var capture = {};
  var errors = [];
  if (!asn1.validate(obj, validator2, capture, errors)) {
    var error = new Error("Cannot read PKCS#7 message. ASN.1 object is not a supported PKCS#7 message.");
    error.errors = error;
    throw error;
  }
  var contentType = asn1.derToOid(capture.contentType);
  if (contentType !== forge$1.pki.oids.data) {
    throw new Error("Unsupported PKCS#7 message. Only wrapped ContentType Data supported.");
  }
  if (capture.encryptedContent) {
    var content2 = "";
    if (forge$1.util.isArray(capture.encryptedContent)) {
      for (var i2 = 0; i2 < capture.encryptedContent.length; ++i2) {
        if (capture.encryptedContent[i2].type !== asn1.Type.OCTETSTRING) {
          throw new Error("Malformed PKCS#7 message, expecting encrypted content constructed of only OCTET STRING objects.");
        }
        content2 += capture.encryptedContent[i2].value;
      }
    } else {
      content2 = capture.encryptedContent;
    }
    msg.encryptedContent = {
      algorithm: asn1.derToOid(capture.encAlgorithm),
      parameter: forge$1.util.createBuffer(capture.encParameter.value),
      content: forge$1.util.createBuffer(content2)
    };
  }
  if (capture.content) {
    var content2 = "";
    if (forge$1.util.isArray(capture.content)) {
      for (var i2 = 0; i2 < capture.content.length; ++i2) {
        if (capture.content[i2].type !== asn1.Type.OCTETSTRING) {
          throw new Error("Malformed PKCS#7 message, expecting content constructed of only OCTET STRING objects.");
        }
        content2 += capture.content[i2].value;
      }
    } else {
      content2 = capture.content;
    }
    msg.content = forge$1.util.createBuffer(content2);
  }
  msg.version = capture.version.charCodeAt(0);
  msg.rawCapture = capture;
  return capture;
}
function _decryptContent(msg) {
  if (msg.encryptedContent.key === void 0) {
    throw new Error("Symmetric key not available.");
  }
  if (msg.content === void 0) {
    var ciph;
    switch (msg.encryptedContent.algorithm) {
      case forge$1.pki.oids["aes128-CBC"]:
      case forge$1.pki.oids["aes192-CBC"]:
      case forge$1.pki.oids["aes256-CBC"]:
        ciph = forge$1.aes.createDecryptionCipher(msg.encryptedContent.key);
        break;
      case forge$1.pki.oids["desCBC"]:
      case forge$1.pki.oids["des-EDE3-CBC"]:
        ciph = forge$1.des.createDecryptionCipher(msg.encryptedContent.key);
        break;
      default:
        throw new Error("Unsupported symmetric cipher, OID " + msg.encryptedContent.algorithm);
    }
    ciph.start(msg.encryptedContent.parameter);
    ciph.update(msg.encryptedContent.content);
    if (!ciph.finish()) {
      throw new Error("Symmetric decryption failed.");
    }
    msg.content = ciph.output;
  }
}
var forge = forge$C;
var ssh = forge.ssh = forge.ssh || {};
ssh.privateKeyToPutty = function(privateKey, passphrase, comment) {
  comment = comment || "";
  passphrase = passphrase || "";
  var algorithm = "ssh-rsa";
  var encryptionAlgorithm = passphrase === "" ? "none" : "aes256-cbc";
  var ppk = "PuTTY-User-Key-File-2: " + algorithm + "\r\n";
  ppk += "Encryption: " + encryptionAlgorithm + "\r\n";
  ppk += "Comment: " + comment + "\r\n";
  var pubbuffer = forge.util.createBuffer();
  _addStringToBuffer(pubbuffer, algorithm);
  _addBigIntegerToBuffer(pubbuffer, privateKey.e);
  _addBigIntegerToBuffer(pubbuffer, privateKey.n);
  var pub = forge.util.encode64(pubbuffer.bytes(), 64);
  var length = Math.floor(pub.length / 66) + 1;
  ppk += "Public-Lines: " + length + "\r\n";
  ppk += pub;
  var privbuffer = forge.util.createBuffer();
  _addBigIntegerToBuffer(privbuffer, privateKey.d);
  _addBigIntegerToBuffer(privbuffer, privateKey.p);
  _addBigIntegerToBuffer(privbuffer, privateKey.q);
  _addBigIntegerToBuffer(privbuffer, privateKey.qInv);
  var priv;
  if (!passphrase) {
    priv = forge.util.encode64(privbuffer.bytes(), 64);
  } else {
    var encLen = privbuffer.length() + 16 - 1;
    encLen -= encLen % 16;
    var padding = _sha1(privbuffer.bytes());
    padding.truncate(padding.length() - encLen + privbuffer.length());
    privbuffer.putBuffer(padding);
    var aeskey = forge.util.createBuffer();
    aeskey.putBuffer(_sha1("\0\0\0\0", passphrase));
    aeskey.putBuffer(_sha1("\0\0\0", passphrase));
    var cipher = forge.aes.createEncryptionCipher(aeskey.truncate(8), "CBC");
    cipher.start(forge.util.createBuffer().fillWithByte(0, 16));
    cipher.update(privbuffer.copy());
    cipher.finish();
    var encrypted = cipher.output;
    encrypted.truncate(16);
    priv = forge.util.encode64(encrypted.bytes(), 64);
  }
  length = Math.floor(priv.length / 66) + 1;
  ppk += "\r\nPrivate-Lines: " + length + "\r\n";
  ppk += priv;
  var mackey = _sha1("putty-private-key-file-mac-key", passphrase);
  var macbuffer = forge.util.createBuffer();
  _addStringToBuffer(macbuffer, algorithm);
  _addStringToBuffer(macbuffer, encryptionAlgorithm);
  _addStringToBuffer(macbuffer, comment);
  macbuffer.putInt32(pubbuffer.length());
  macbuffer.putBuffer(pubbuffer);
  macbuffer.putInt32(privbuffer.length());
  macbuffer.putBuffer(privbuffer);
  var hmac2 = forge.hmac.create();
  hmac2.start("sha1", mackey);
  hmac2.update(macbuffer.bytes());
  ppk += "\r\nPrivate-MAC: " + hmac2.digest().toHex() + "\r\n";
  return ppk;
};
ssh.publicKeyToOpenSSH = function(key, comment) {
  var type = "ssh-rsa";
  comment = comment || "";
  var buffer = forge.util.createBuffer();
  _addStringToBuffer(buffer, type);
  _addBigIntegerToBuffer(buffer, key.e);
  _addBigIntegerToBuffer(buffer, key.n);
  return type + " " + forge.util.encode64(buffer.bytes()) + " " + comment;
};
ssh.privateKeyToOpenSSH = function(privateKey, passphrase) {
  if (!passphrase) {
    return forge.pki.privateKeyToPem(privateKey);
  }
  return forge.pki.encryptRsaPrivateKey(privateKey, passphrase, { legacy: true, algorithm: "aes128" });
};
ssh.getPublicKeyFingerprint = function(key, options) {
  options = options || {};
  var md = options.md || forge.md.md5.create();
  var type = "ssh-rsa";
  var buffer = forge.util.createBuffer();
  _addStringToBuffer(buffer, type);
  _addBigIntegerToBuffer(buffer, key.e);
  _addBigIntegerToBuffer(buffer, key.n);
  md.start();
  md.update(buffer.getBytes());
  var digest = md.digest();
  if (options.encoding === "hex") {
    var hex = digest.toHex();
    if (options.delimiter) {
      return hex.match(/.{2}/g).join(options.delimiter);
    }
    return hex;
  } else if (options.encoding === "binary") {
    return digest.getBytes();
  } else if (options.encoding) {
    throw new Error('Unknown encoding "' + options.encoding + '".');
  }
  return digest;
};
function _addBigIntegerToBuffer(buffer, val) {
  var hexVal = val.toString(16);
  if (hexVal[0] >= "8") {
    hexVal = "00" + hexVal;
  }
  var bytes = forge.util.hexToBytes(hexVal);
  buffer.putInt32(bytes.length);
  buffer.putBytes(bytes);
}
function _addStringToBuffer(buffer, val) {
  buffer.putInt32(val.length);
  buffer.putString(val);
}
function _sha1() {
  var sha = forge.md.sha1.create();
  var num = arguments.length;
  for (var i2 = 0; i2 < num; ++i2) {
    sha.update(arguments[i2]);
  }
  return sha.digest();
}
var lib$2 = forge$C;
function uuid() {
  var dt = new Date().getTime();
  var uuid2 = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c == "x" ? r : r & 3 | 8).toString(16);
  });
  return uuid2;
}
function debounce$2(context, f, timeout = 250, leading = false, trailing = true) {
  let timer;
  return (...args) => {
    if (leading) {
      f.apply(context, args);
    }
    clearTimeout(timer);
    timer = window.setTimeout(() => {
      if (trailing) {
        f.apply(context, args);
      }
    }, timeout);
  };
}
function md5(o) {
  if (typeof o !== "string") {
    o = JSON.stringify(o);
  }
  const md = lib$2.md.md5.create();
  md.update(o);
  return md.digest().toHex();
}
function setSessionSetting(k, v2) {
  if (typeof v2 !== "string") {
    v2 = JSON.stringify(v2);
  }
  sessionStorage.setItem(k, v2);
}
function getSessionSetting(k, d) {
  const v2 = sessionStorage.getItem(k);
  if (v2) {
    try {
      return JSON.parse(v2);
    } catch (error) {
    }
  }
  return d;
}
const _sfc_main$u = defineComponent({
  emits: ["togglefocused", "move"],
  props: {
    flat: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    triggerLabel: {
      type: String,
      default: "Select"
    },
    placement: {
      validator: function(value) {
        return ["auto", "auto-start", "auto-end", "top", "bottom", "right", "left", "top-start", "top-end", "bottom-start", "bottom-end", "right-start", "right-end", "left-start", "left-end"].indexOf(value) !== -1;
      },
      default: "bottom-end"
    }
  },
  components: { SButton },
  name: "SBaseDropdown",
  setup(props, { emit: emit2 }) {
    const showDropdown = ref(false);
    const triggerWrapper = ref(null);
    const dropdownWrapper = ref(null);
    const popperStyle = ref(null);
    const popperAttrs = ref(null);
    watch(showDropdown, (a, b) => {
      nextTick(() => {
      });
    });
    const dropdownUUID = "dd-" + uuid();
    const clickOutsideHandler = (e) => {
      if (!e.target.closest(`[data-dd=${dropdownUUID}]`)) {
        toggleDropdown(false);
      }
    };
    const onFocusTrigger = () => {
      window.addEventListener("keydown", onUpDown, false);
    };
    const onBlurTrigger = (e) => {
      window.removeEventListener("keydown", onUpDown, false);
    };
    const toggleDropdown = (on) => {
      on = typeof on != "boolean" ? !showDropdown.value : on;
      if (on) {
        window.addEventListener("keydown", onEscape, false);
        window.addEventListener("click", clickOutsideHandler, false);
        showDropdown.value = true;
        nextTick(() => emit2("move", dropdownWrapper.value, "selection"));
      } else {
        window.removeEventListener("keydown", onEscape, false);
        window.removeEventListener("click", clickOutsideHandler, false);
        showDropdown.value = false;
      }
    };
    const onEscape = (e) => {
      var _a;
      if (e.code == "Escape") {
        if (showDropdown.value) {
          toggleDropdown(false);
          e.preventDefault();
          (_a = dropdownWrapper.value) == null ? void 0 : _a.focus();
          return false;
        }
      }
    };
    const onUpDown = (e) => {
      if (showDropdown.value) {
        if (e.code == "ArrowDown") {
          emit2("move", dropdownWrapper.value, "down");
          e.preventDefault();
          return false;
        } else if (e.code == "ArrowUp") {
          emit2("move", dropdownWrapper.value, "up");
          e.preventDefault();
          return false;
        } else if (e.code == "Space" || e.code == "Enter") {
          emit2("togglefocused", e.code, toggleDropdown);
          e.preventDefault();
          return false;
        } else if (e.code == "Tab") {
          e.preventDefault();
          return false;
        }
      } else {
        if (e.code == "ArrowDown" || e.code == "ArrowUp" || e.code == "Space") {
          toggleDropdown(true);
          e.preventDefault();
          return false;
        }
      }
    };
    return {
      popperStyle,
      popperAttrs,
      dropdownUUID,
      showDropdown,
      toggleDropdown,
      triggerWrapper,
      dropdownWrapper,
      onFocusTrigger,
      onBlurTrigger
    };
  }
});
const _hoisted_1$n = { class: "relative" };
const _hoisted_2$h = ["data-dd"];
const _hoisted_3$d = ["textContent"];
const _hoisted_4$a = /* @__PURE__ */ createElementVNode("svg", {
  class: "h-4 mt-1 ml-2 float-right fill-current text-current",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 129 129",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "enable-background": "new 0 0 129 129"
}, [
  /* @__PURE__ */ createElementVNode("g", null, [
    /* @__PURE__ */ createElementVNode("path", { d: "m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z" })
  ])
], -1);
const _hoisted_5$7 = ["data-dd"];
function _sfc_render$u(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SButton = resolveComponent("SButton");
  return openBlock(), createElementBlock("div", _hoisted_1$n, [
    createElementVNode("div", {
      "data-dd": _ctx.dropdownUUID,
      ref: "triggerWrapper",
      class: normalizeClass(_ctx.$attrs.class)
    }, [
      renderSlot(_ctx.$slots, "trigger", {
        toggleDropdown: _ctx.toggleDropdown,
        showDropdown: _ctx.showDropdown,
        onFocusTrigger: _ctx.onFocusTrigger,
        onBlurTrigger: _ctx.onBlurTrigger
      }, () => [
        createVNode(_component_SButton, {
          flat: _ctx.flat,
          disabled: _ctx.disabled,
          onClick: _ctx.toggleDropdown,
          onFocus: _ctx.onFocusTrigger,
          onBlur: _ctx.onBlurTrigger,
          class: "max-w-full w-full text-left"
        }, {
          default: withCtx(() => [
            createElementVNode("span", {
              class: "pr-2 truncate",
              textContent: toDisplayString(_ctx.triggerLabel)
            }, null, 8, _hoisted_3$d),
            _hoisted_4$a
          ]),
          _: 1
        }, 8, ["flat", "disabled", "onClick", "onFocus", "onBlur"])
      ])
    ], 10, _hoisted_2$h),
    _ctx.showDropdown ? (openBlock(), createElementBlock("div", mergeProps({
      key: 0,
      "data-dd": _ctx.dropdownUUID,
      ref: "dropdownWrapper",
      class: "absolute z-10 left-1 bg-white rounded-b shadow-md",
      style: _ctx.popperStyle
    }, _ctx.popperAttrs), [
      renderSlot(_ctx.$slots, "default", { toggleDropdown: _ctx.toggleDropdown })
    ], 16, _hoisted_5$7)) : createCommentVNode("", true)
  ]);
}
var SBaseDropdown = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["render", _sfc_render$u]]);
const _sfc_main$t = defineComponent({
  components: { SBaseDropdown },
  name: "SelectorInput",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    modelValue: null,
    nullable: { type: Boolean, default: false },
    multi: { type: Boolean, default: false },
    list: {
      type: Array,
      required: true
    },
    triggerLabel: {
      type: Function,
      default: (s2, itemLabel) => {
        if (s2.length > 0) {
          return s2.map(itemLabel).join(", ");
        } else {
          return "Select";
        }
      }
    },
    itemLabel: { type: Function, default: (i2) => i2.label },
    itemId: { type: Function, default: (i2) => i2.id }
  },
  setup(props, { emit: emit2 }) {
    const focusedIndex = ref(0);
    const autoScroll = (dropdownElement) => {
      if (dropdownElement) {
        const focusedItem = dropdownElement.querySelector(".focused");
        if (focusedItem) {
          if (typeof focusedItem.scrollIntoViewIfNeeded === "function") {
            focusedItem.scrollIntoViewIfNeeded();
          } else {
            focusedItem.scrollIntoView();
          }
        }
      }
    };
    const onMove = (dropdownElement, direction) => {
      switch (direction) {
        case "up":
          focusedIndex.value = focusedIndex.value == null ? 0 : Math.max(focusedIndex.value - 1, 0);
          break;
        case "down":
          focusedIndex.value = focusedIndex.value == null ? 0 : Math.min(focusedIndex.value + 1, props.list.length - 1);
          break;
        case "selection":
          if (selection.value.length) {
            focusedIndex.value = Math.max(0, props.list.findIndex((x2) => props.itemId(x2) == props.itemId(selection.value[0])));
          }
          break;
      }
      nextTick(() => autoScroll(dropdownElement));
    };
    let m = [];
    if (props.modelValue) {
      if (props.multi) {
        for (let i2 = 0; i2 < props.modelValue.length; i2++) {
          const x2 = props.list.find((x22) => props.itemId(x22) == props.modelValue[i2]);
          if (typeof x2 != "undefined" && x2 !== null) {
            m.push(x2);
          }
        }
      } else {
        const x2 = props.list.find((x22) => props.itemId(x22) == props.modelValue);
        if (typeof x2 != "undefined" && x2 !== null) {
          m.push(x2);
        }
      }
    }
    const selection = ref(m);
    const autoTriggerLabel = computed(() => {
      return props.triggerLabel(selection.value, props.itemLabel);
    });
    const triggerClass = computed(() => {
      return selection.value.length > 0 ? "font-normal" : "text-gray-200";
    });
    const toggleItem = (i2, closeFunction) => {
      const ix = selection.value.findIndex((o) => {
        return props.itemId(o) == props.itemId(i2);
      });
      if (ix >= 0) {
        if (props.multi) {
          if (selection.value.length > 1 || props.nullable) {
            selection.value.splice(ix, 1);
          }
        } else if (props.nullable) {
          selection.value.splice(0, selection.value.length);
        }
      } else {
        if (props.multi) {
          selection.value.push(i2);
        } else {
          selection.value.splice(0, selection.value.length);
          selection.value.push(i2);
        }
      }
      if (props.multi) {
        emit2("update:modelValue", selection.value.map(props.itemId));
      } else if (selection.value.length > 0) {
        emit2("update:modelValue", props.itemId(selection.value[0]));
      }
      if (closeFunction) {
        closeFunction();
      }
    };
    watch(() => props.modelValue, (nv) => {
      let m2 = [];
      if (nv !== null) {
        if (props.multi) {
          for (let i2 = 0; i2 < nv.length; i2++) {
            const x2 = props.list.find((x22) => props.itemId(x22) == nv[i2]);
            if (typeof x2 != "undefined" && x2 !== null) {
              m2.push(x2);
            }
          }
          selection.value.splice(0, selection.value.length, ...m2);
        } else {
          const x2 = props.list.find((x22) => props.itemId(x22) == props.modelValue);
          if (typeof x2 != "undefined" && x2 !== null) {
            selection.value.splice(0, selection.value.length, x2);
          }
        }
      }
    });
    watch(() => props.list, (nv) => {
      let m2 = [];
      if (nv) {
        if (props.multi) {
          for (let i2 = 0; i2 < nv.length; i2++) {
            const x2 = props.list.find((x22) => props.itemId(x22) == nv[i2]);
            if (typeof x2 != "undefined" && x2 !== null) {
              m2.push(x2);
            }
          }
          selection.value.splice(0, selection.value.length, ...m2);
        } else {
          const x2 = props.list.find((x22) => props.itemId(x22) == props.modelValue);
          if (typeof x2 != "undefined" && x2 !== null) {
            selection.value.splice(0, selection.value.length, x2);
          }
        }
      }
    });
    return {
      focusedIndex,
      isSelected(i2) {
        return !!selection.value.find((o) => props.itemId(o) == props.itemId(i2));
      },
      onToggleFocused(keyCode, closeFunction) {
        if (focusedIndex.value != null) {
          toggleItem(props.list[focusedIndex.value], !props.multi || keyCode == "Enter" ? closeFunction : void 0);
        }
      },
      itemClass: (focused) => {
        let cls = `text-sm bg-white cursor-default select-none relative py-2 px-4 pr-9 cursor-pointer disabled:opacity-50`;
        cls += ` hover:bg-brand hover:bg-opacity-10`;
        return cls;
      },
      triggerClass,
      autoTriggerLabel,
      selection,
      onMove,
      onItemClicked: (item, toggleDropdown) => {
        if (!props.multi) {
          toggleItem(item, toggleDropdown);
        }
      },
      onItemMouseDown(index3, toggleDropdown) {
        if (props.multi) {
          toggleItem(index3);
        }
      },
      onMouseEnterItem(i2, e) {
        focusedIndex.value = null;
        if ((e.buttons & 1) == 1) {
          toggleItem(i2);
        }
      }
    };
  }
});
const _hoisted_1$m = {
  tabindex: "-1",
  class: "max-h-56 rounded-b py-1 text-base ring-1 ring-gray-200 overflow-auto focus:outline-none"
};
const _hoisted_2$g = ["onClick", "onMousedown"];
const _hoisted_3$c = {
  key: 0,
  class: "absolute right-0 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18"
};
const _hoisted_4$9 = /* @__PURE__ */ createElementVNode("path", { d: "M6.61 11.89L3.5 8.78 2.44 9.84 6.61 14l8.95-8.95L14.5 4z" }, null, -1);
const _hoisted_5$6 = [
  _hoisted_4$9
];
const _hoisted_6$5 = { class: "flex items-center justify-between" };
const _hoisted_7$4 = ["textContent"];
function _sfc_render$t(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SBaseDropdown = resolveComponent("SBaseDropdown");
  return openBlock(), createBlock(_component_SBaseDropdown, {
    disabled: _ctx.disabled,
    triggerLabel: _ctx.autoTriggerLabel,
    onMove: _ctx.onMove,
    count: _ctx.list.length,
    onTogglefocused: _ctx.onToggleFocused
  }, {
    default: withCtx(({ toggleDropdown }) => [
      createElementVNode("ul", _hoisted_1$m, [
        (openBlock(true), createElementBlock(Fragment$1, null, renderList(_ctx.list, (item, ix) => {
          return openBlock(), createElementBlock("li", {
            key: ix,
            role: "option",
            class: normalizeClass([_ctx.itemClass(_ctx.focusedIndex == ix), _ctx.isSelected(item) ? "selected" : ""]),
            onClick: ($event) => _ctx.onItemClicked(item, toggleDropdown),
            onMousedown: ($event) => _ctx.onItemMouseDown(item)
          }, [
            _ctx.isSelected(item) ? (openBlock(), createElementBlock("svg", _hoisted_3$c, _hoisted_5$6)) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_6$5, [
              createElementVNode("span", {
                class: normalizeClass(["block font-normal truncate", { "font-semibold": _ctx.isSelected(item) }]),
                textContent: toDisplayString(_ctx.itemLabel(item))
              }, null, 10, _hoisted_7$4)
            ])
          ], 42, _hoisted_2$g);
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["disabled", "triggerLabel", "onMove", "count", "onTogglefocused"]);
}
var SSelectorInput = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["render", _sfc_render$t]]);
const _sfc_main$s = defineComponent({
  name: "STextareaInput",
  props: {
    modelValue: {
      type: [Number, String],
      default: null
    },
    disabled: { type: Boolean, default: false },
    rows: { type: Number, default: 1 }
  },
  setup(props, { emit: emit2 }) {
    const emitValue = (v2) => {
      emit2("update:modelValue", v2);
    };
    const onInput = (event) => {
      emitValue(event.target.value);
    };
    return {
      onInput
    };
  }
});
const _hoisted_1$l = ["rows", "disabled", "value"];
function _sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("textarea", {
    onInput: _cache[0] || (_cache[0] = (...args) => _ctx.onInput && _ctx.onInput(...args)),
    rows: _ctx.rows,
    disabled: _ctx.disabled,
    value: _ctx.modelValue
  }, null, 40, _hoisted_1$l);
}
var STextareaInput = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["render", _sfc_render$s]]);
function colorize$1(props, extras) {
  let c = `bg-${props.color}-contrast text-${props.color} hover:bg-${props.color}-light active:bg-${props.color}-active focus:border-${props.color} focus:ring-${props.color}`;
  if (!props.flat) {
    c += " border border-gray-300";
  }
  return c;
}
const _sfc_main$r = defineComponent({
  props: {
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    round: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    color: {
      type: String,
      default: "btn"
    },
    icon: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const cls = computed(() => {
      const c = [colorize$1(props)];
      if (props.round) {
        c.push(" rounded-full");
      } else {
        c.push(" rounded");
      }
      c.push("transition-colors duration-300 disabled:opacity-50 inline-block align-middle relative p-0 mouse focus:outline-none", "focus:ring", "focus:ring-offset-0", "focus:ring-opacity-50");
      if (props.small) {
        c.push("w-6 h-6");
      } else {
        c.push("w-8 h-8");
      }
      return c;
    });
    return {
      cls
    };
  }
});
const _hoisted_1$k = ["disabled"];
const _hoisted_2$f = {
  key: 0,
  class: "absolute rounded-full inset-0 flex justify-center items-center bg-inherit"
};
const _hoisted_3$b = /* @__PURE__ */ createElementVNode("svg", {
  class: "animate-spin h-5 w-5 text-current",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /* @__PURE__ */ createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /* @__PURE__ */ createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1);
function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SIcon = resolveComponent("SIcon");
  return openBlock(), createElementBlock("button", {
    class: normalizeClass(_ctx.cls),
    disabled: _ctx.disabled || _ctx.loading
  }, [
    createElementVNode("div", {
      class: normalizeClass(["absolute rounded-full inset-0 flex justify-center items-center bg-inherit", _ctx.small ? "w-6 h-6" : ""])
    }, [
      !!_ctx.icon ? (openBlock(), createBlock(_component_SIcon, {
        key: 0,
        icon: _ctx.icon,
        small: _ctx.small
      }, null, 8, ["icon", "small"])) : renderSlot(_ctx.$slots, "default", { key: 1 })
    ], 2),
    _ctx.loading ? (openBlock(), createElementBlock("div", _hoisted_2$f, [
      renderSlot(_ctx.$slots, "loader", {}, () => [
        _hoisted_3$b
      ])
    ])) : createCommentVNode("", true)
  ], 10, _hoisted_1$k);
}
var SIconButton = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["render", _sfc_render$r]]);
function colorize(props, extras) {
  const color = props.color || "btn";
  let colorClasses = ` border-gray-300 focus:border-${color}-hover focus:outline-none focus:ring focus:ring-offset-0 focus:ring-opacity-50 focus:ring-${color}-active `;
  let colorClasses3d = ` border rounded `;
  if (props.flat) {
    return colorClasses + " focus:ring-inset ";
  } else {
    return colorClasses + " " + colorClasses3d;
  }
}
const _sfc_main$q = defineComponent({
  props: {
    modelValue: null,
    icon: { type: String, default: null },
    endIcon: { type: String, default: null },
    inputClass: { type: String, default: null },
    placeholder: { type: String, default: null },
    type: { type: String, default: "text" },
    color: { type: String, default: "btn" },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    autocomplete: { type: String, default: "xx" },
    flat: { type: Boolean, default: false }
  },
  setup(props, { emit: emit2, attrs }) {
    const inputElement = ref(null);
    const cls = computed(() => {
      const c = [props.inputClass, "block w-full  p-1", colorize(props)];
      if (props.icon) {
        c.push("pl-8");
      }
      if (props.endIcon) {
        c.push("pr-8");
      }
      if (props.color == "brand") {
        c.push("focus:border-brand focus:ring-brand");
      }
      return c;
    });
    const iconClass = computed(() => {
      const c = [];
      if (attrs.hasOwnProperty("onClick:icon")) {
        c.push("cursor-pointer rounded-full");
        c.push(colorize$1({ color: props.color, flat: true }));
      }
      return c;
    });
    const endIconClass = computed(() => {
      const c = [];
      if (attrs.hasOwnProperty("onClick:endIcon")) {
        c.push("cursor-pointer rounded-full");
        c.push(colorize$1({ color: props.color, flat: true }));
      }
      return c;
    });
    const handleInput = (e) => {
      if (e.target)
        emit2("update:modelValue", e.target.value);
    };
    return {
      cls,
      iconClass,
      endIconClass,
      handleInput,
      inputElement
    };
  }
});
const _hoisted_1$j = { class: "relative" };
const _hoisted_2$e = ["autocomplete", "disabled", "readonly", "type", "placeholder", "value"];
function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SIcon = resolveComponent("SIcon");
  const _directive_absorb = resolveDirective("absorb");
  return openBlock(), createElementBlock("div", _hoisted_1$j, [
    _ctx.icon ? (openBlock(), createElementBlock("span", {
      key: 0,
      class: normalizeClass(["absolute inset-y-1 left-1 flex justify-center items-center w-6", _ctx.iconClass])
    }, [
      withDirectives(createVNode(_component_SIcon, {
        icon: _ctx.icon,
        small: ""
      }, null, 8, ["icon"]), [
        [_directive_absorb, (e) => {
          e.button == 0 && _ctx.$emit("click:icon");
        }, "mousedown"]
      ])
    ], 2)) : createCommentVNode("", true),
    createElementVNode("input", {
      ref: "inputElement",
      autocomplete: _ctx.autocomplete,
      class: normalizeClass(_ctx.cls),
      disabled: _ctx.disabled,
      readonly: _ctx.readonly,
      type: _ctx.type,
      placeholder: _ctx.placeholder,
      value: _ctx.modelValue,
      onInput: _cache[0] || (_cache[0] = (...args) => _ctx.handleInput && _ctx.handleInput(...args))
    }, null, 42, _hoisted_2$e),
    _ctx.endIcon ? (openBlock(), createElementBlock("span", {
      key: 1,
      class: normalizeClass(["absolute inset-y-1 right-1 flex justify-center items-center w-6", _ctx.endIconClass])
    }, [
      withDirectives(createVNode(_component_SIcon, {
        icon: _ctx.endIcon,
        small: ""
      }, null, 8, ["icon"]), [
        [_directive_absorb, (e) => {
          e.button == 0 && _ctx.$emit("click:endIcon");
        }, "mousedown"]
      ])
    ], 2)) : createCommentVNode("", true)
  ]);
}
var STextInput = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$q]]);
//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var hookCallback;
function hooks() {
  return hookCallback.apply(null, arguments);
}
function setHookCallback(callback) {
  hookCallback = callback;
}
function isArray$1(input) {
  return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
}
function isObject$3(input) {
  return input != null && Object.prototype.toString.call(input) === "[object Object]";
}
function hasOwnProp(a, b) {
  return Object.prototype.hasOwnProperty.call(a, b);
}
function isObjectEmpty(obj) {
  if (Object.getOwnPropertyNames) {
    return Object.getOwnPropertyNames(obj).length === 0;
  } else {
    var k;
    for (k in obj) {
      if (hasOwnProp(obj, k)) {
        return false;
      }
    }
    return true;
  }
}
function isUndefined(input) {
  return input === void 0;
}
function isNumber(input) {
  return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
}
function isDate(input) {
  return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
}
function map(arr, fn) {
  var res = [], i2;
  for (i2 = 0; i2 < arr.length; ++i2) {
    res.push(fn(arr[i2], i2));
  }
  return res;
}
function extend$3(a, b) {
  for (var i2 in b) {
    if (hasOwnProp(b, i2)) {
      a[i2] = b[i2];
    }
  }
  if (hasOwnProp(b, "toString")) {
    a.toString = b.toString;
  }
  if (hasOwnProp(b, "valueOf")) {
    a.valueOf = b.valueOf;
  }
  return a;
}
function createUTC(input, format2, locale2, strict) {
  return createLocalOrUTC(input, format2, locale2, strict, true).utc();
}
function defaultParsingFlags() {
  return {
    empty: false,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: false,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: false,
    userInvalidated: false,
    iso: false,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: false,
    weekdayMismatch: false
  };
}
function getParsingFlags(m) {
  if (m._pf == null) {
    m._pf = defaultParsingFlags();
  }
  return m._pf;
}
var some;
if (Array.prototype.some) {
  some = Array.prototype.some;
} else {
  some = function(fun) {
    var t = Object(this), len = t.length >>> 0, i2;
    for (i2 = 0; i2 < len; i2++) {
      if (i2 in t && fun.call(this, t[i2], i2, t)) {
        return true;
      }
    }
    return false;
  };
}
function isValid(m) {
  if (m._isValid == null) {
    var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i2) {
      return i2 != null;
    }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
    if (m._strict) {
      isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === void 0;
    }
    if (Object.isFrozen == null || !Object.isFrozen(m)) {
      m._isValid = isNowValid;
    } else {
      return isNowValid;
    }
  }
  return m._isValid;
}
function createInvalid(flags) {
  var m = createUTC(NaN);
  if (flags != null) {
    extend$3(getParsingFlags(m), flags);
  } else {
    getParsingFlags(m).userInvalidated = true;
  }
  return m;
}
var momentProperties = hooks.momentProperties = [], updateInProgress = false;
function copyConfig(to2, from5) {
  var i2, prop, val;
  if (!isUndefined(from5._isAMomentObject)) {
    to2._isAMomentObject = from5._isAMomentObject;
  }
  if (!isUndefined(from5._i)) {
    to2._i = from5._i;
  }
  if (!isUndefined(from5._f)) {
    to2._f = from5._f;
  }
  if (!isUndefined(from5._l)) {
    to2._l = from5._l;
  }
  if (!isUndefined(from5._strict)) {
    to2._strict = from5._strict;
  }
  if (!isUndefined(from5._tzm)) {
    to2._tzm = from5._tzm;
  }
  if (!isUndefined(from5._isUTC)) {
    to2._isUTC = from5._isUTC;
  }
  if (!isUndefined(from5._offset)) {
    to2._offset = from5._offset;
  }
  if (!isUndefined(from5._pf)) {
    to2._pf = getParsingFlags(from5);
  }
  if (!isUndefined(from5._locale)) {
    to2._locale = from5._locale;
  }
  if (momentProperties.length > 0) {
    for (i2 = 0; i2 < momentProperties.length; i2++) {
      prop = momentProperties[i2];
      val = from5[prop];
      if (!isUndefined(val)) {
        to2[prop] = val;
      }
    }
  }
  return to2;
}
function Moment(config2) {
  copyConfig(this, config2);
  this._d = new Date(config2._d != null ? config2._d.getTime() : NaN);
  if (!this.isValid()) {
    this._d = new Date(NaN);
  }
  if (updateInProgress === false) {
    updateInProgress = true;
    hooks.updateOffset(this);
    updateInProgress = false;
  }
}
function isMoment(obj) {
  return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
}
function warn$1(msg) {
  if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) {
    console.warn("Deprecation warning: " + msg);
  }
}
function deprecate(msg, fn) {
  var firstTime = true;
  return extend$3(function() {
    if (hooks.deprecationHandler != null) {
      hooks.deprecationHandler(null, msg);
    }
    if (firstTime) {
      var args = [], arg, i2, key;
      for (i2 = 0; i2 < arguments.length; i2++) {
        arg = "";
        if (typeof arguments[i2] === "object") {
          arg += "\n[" + i2 + "] ";
          for (key in arguments[0]) {
            if (hasOwnProp(arguments[0], key)) {
              arg += key + ": " + arguments[0][key] + ", ";
            }
          }
          arg = arg.slice(0, -2);
        } else {
          arg = arguments[i2];
        }
        args.push(arg);
      }
      warn$1(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
      firstTime = false;
    }
    return fn.apply(this, arguments);
  }, fn);
}
var deprecations = {};
function deprecateSimple(name, msg) {
  if (hooks.deprecationHandler != null) {
    hooks.deprecationHandler(name, msg);
  }
  if (!deprecations[name]) {
    warn$1(msg);
    deprecations[name] = true;
  }
}
hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;
function isFunction$1(input) {
  return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
}
function set(config2) {
  var prop, i2;
  for (i2 in config2) {
    if (hasOwnProp(config2, i2)) {
      prop = config2[i2];
      if (isFunction$1(prop)) {
        this[i2] = prop;
      } else {
        this["_" + i2] = prop;
      }
    }
  }
  this._config = config2;
  this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
}
function mergeConfigs(parentConfig, childConfig) {
  var res = extend$3({}, parentConfig), prop;
  for (prop in childConfig) {
    if (hasOwnProp(childConfig, prop)) {
      if (isObject$3(parentConfig[prop]) && isObject$3(childConfig[prop])) {
        res[prop] = {};
        extend$3(res[prop], parentConfig[prop]);
        extend$3(res[prop], childConfig[prop]);
      } else if (childConfig[prop] != null) {
        res[prop] = childConfig[prop];
      } else {
        delete res[prop];
      }
    }
  }
  for (prop in parentConfig) {
    if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject$3(parentConfig[prop])) {
      res[prop] = extend$3({}, res[prop]);
    }
  }
  return res;
}
function Locale(config2) {
  if (config2 != null) {
    this.set(config2);
  }
}
var keys$2;
if (Object.keys) {
  keys$2 = Object.keys;
} else {
  keys$2 = function(obj) {
    var i2, res = [];
    for (i2 in obj) {
      if (hasOwnProp(obj, i2)) {
        res.push(i2);
      }
    }
    return res;
  };
}
var defaultCalendar = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function calendar(key, mom, now2) {
  var output = this._calendar[key] || this._calendar["sameElse"];
  return isFunction$1(output) ? output.call(mom, now2) : output;
}
function zeroFill(number2, targetLength, forceSign) {
  var absNumber = "" + Math.abs(number2), zerosToFill = targetLength - absNumber.length, sign2 = number2 >= 0;
  return (sign2 ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}
var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
function addFormatToken(token2, padded, ordinal2, callback) {
  var func2 = callback;
  if (typeof callback === "string") {
    func2 = function() {
      return this[callback]();
    };
  }
  if (token2) {
    formatTokenFunctions[token2] = func2;
  }
  if (padded) {
    formatTokenFunctions[padded[0]] = function() {
      return zeroFill(func2.apply(this, arguments), padded[1], padded[2]);
    };
  }
  if (ordinal2) {
    formatTokenFunctions[ordinal2] = function() {
      return this.localeData().ordinal(func2.apply(this, arguments), token2);
    };
  }
}
function removeFormattingTokens(input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|\]$/g, "");
  }
  return input.replace(/\\/g, "");
}
function makeFormatFunction(format2) {
  var array = format2.match(formattingTokens), i2, length;
  for (i2 = 0, length = array.length; i2 < length; i2++) {
    if (formatTokenFunctions[array[i2]]) {
      array[i2] = formatTokenFunctions[array[i2]];
    } else {
      array[i2] = removeFormattingTokens(array[i2]);
    }
  }
  return function(mom) {
    var output = "", i3;
    for (i3 = 0; i3 < length; i3++) {
      output += isFunction$1(array[i3]) ? array[i3].call(mom, format2) : array[i3];
    }
    return output;
  };
}
function formatMoment(m, format2) {
  if (!m.isValid()) {
    return m.localeData().invalidDate();
  }
  format2 = expandFormat(format2, m.localeData());
  formatFunctions[format2] = formatFunctions[format2] || makeFormatFunction(format2);
  return formatFunctions[format2](m);
}
function expandFormat(format2, locale2) {
  var i2 = 5;
  function replaceLongDateFormatTokens(input) {
    return locale2.longDateFormat(input) || input;
  }
  localFormattingTokens.lastIndex = 0;
  while (i2 >= 0 && localFormattingTokens.test(format2)) {
    format2 = format2.replace(localFormattingTokens, replaceLongDateFormatTokens);
    localFormattingTokens.lastIndex = 0;
    i2 -= 1;
  }
  return format2;
}
var defaultLongDateFormat = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function longDateFormat(key) {
  var format2 = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
  if (format2 || !formatUpper) {
    return format2;
  }
  this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
    if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") {
      return tok.slice(1);
    }
    return tok;
  }).join("");
  return this._longDateFormat[key];
}
var defaultInvalidDate = "Invalid date";
function invalidDate() {
  return this._invalidDate;
}
var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
function ordinal(number2) {
  return this._ordinal.replace("%d", number2);
}
var defaultRelativeTime = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function relativeTime(number2, withoutSuffix, string2, isFuture) {
  var output = this._relativeTime[string2];
  return isFunction$1(output) ? output(number2, withoutSuffix, string2, isFuture) : output.replace(/%d/i, number2);
}
function pastFuture(diff2, output) {
  var format2 = this._relativeTime[diff2 > 0 ? "future" : "past"];
  return isFunction$1(format2) ? format2(output) : format2.replace(/%s/i, output);
}
var aliases = {};
function addUnitAlias(unit, shorthand) {
  var lowerCase = unit.toLowerCase();
  aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
}
function normalizeUnits(units) {
  return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : void 0;
}
function normalizeObjectUnits(inputObject) {
  var normalizedInput = {}, normalizedProp, prop;
  for (prop in inputObject) {
    if (hasOwnProp(inputObject, prop)) {
      normalizedProp = normalizeUnits(prop);
      if (normalizedProp) {
        normalizedInput[normalizedProp] = inputObject[prop];
      }
    }
  }
  return normalizedInput;
}
var priorities = {};
function addUnitPriority(unit, priority) {
  priorities[unit] = priority;
}
function getPrioritizedUnits(unitsObj) {
  var units = [], u;
  for (u in unitsObj) {
    if (hasOwnProp(unitsObj, u)) {
      units.push({ unit: u, priority: priorities[u] });
    }
  }
  units.sort(function(a, b) {
    return a.priority - b.priority;
  });
  return units;
}
function isLeapYear(year) {
  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
function absFloor(number2) {
  if (number2 < 0) {
    return Math.ceil(number2) || 0;
  } else {
    return Math.floor(number2);
  }
}
function toInt(argumentForCoercion) {
  var coercedNumber = +argumentForCoercion, value = 0;
  if (coercedNumber !== 0 && isFinite(coercedNumber)) {
    value = absFloor(coercedNumber);
  }
  return value;
}
function makeGetSet(unit, keepTime) {
  return function(value) {
    if (value != null) {
      set$1(this, unit, value);
      hooks.updateOffset(this, keepTime);
      return this;
    } else {
      return get(this, unit);
    }
  };
}
function get(mom, unit) {
  return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
}
function set$1(mom, unit, value) {
  if (mom.isValid() && !isNaN(value)) {
    if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
      value = toInt(value);
      mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
    } else {
      mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
    }
  }
}
function stringGet(units) {
  units = normalizeUnits(units);
  if (isFunction$1(this[units])) {
    return this[units]();
  }
  return this;
}
function stringSet(units, value) {
  if (typeof units === "object") {
    units = normalizeObjectUnits(units);
    var prioritized = getPrioritizedUnits(units), i2;
    for (i2 = 0; i2 < prioritized.length; i2++) {
      this[prioritized[i2].unit](units[prioritized[i2].unit]);
    }
  } else {
    units = normalizeUnits(units);
    if (isFunction$1(this[units])) {
      return this[units](value);
    }
  }
  return this;
}
var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
regexes = {};
function addRegexToken(token2, regex, strictRegex) {
  regexes[token2] = isFunction$1(regex) ? regex : function(isStrict, localeData2) {
    return isStrict && strictRegex ? strictRegex : regex;
  };
}
function getParseRegexForToken(token2, config2) {
  if (!hasOwnProp(regexes, token2)) {
    return new RegExp(unescapeFormat(token2));
  }
  return regexes[token2](config2._strict, config2._locale);
}
function unescapeFormat(s2) {
  return regexEscape(s2.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
    return p1 || p2 || p3 || p4;
  }));
}
function regexEscape(s2) {
  return s2.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var tokens = {};
function addParseToken(token2, callback) {
  var i2, func2 = callback;
  if (typeof token2 === "string") {
    token2 = [token2];
  }
  if (isNumber(callback)) {
    func2 = function(input, array) {
      array[callback] = toInt(input);
    };
  }
  for (i2 = 0; i2 < token2.length; i2++) {
    tokens[token2[i2]] = func2;
  }
}
function addWeekParseToken(token2, callback) {
  addParseToken(token2, function(input, array, config2, token3) {
    config2._w = config2._w || {};
    callback(input, config2._w, config2, token3);
  });
}
function addTimeToArrayFromToken(token2, input, config2) {
  if (input != null && hasOwnProp(tokens, token2)) {
    tokens[token2](input, config2._a, config2, token2);
  }
}
var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
function mod(n, x2) {
  return (n % x2 + x2) % x2;
}
var indexOf;
if (Array.prototype.indexOf) {
  indexOf = Array.prototype.indexOf;
} else {
  indexOf = function(o) {
    var i2;
    for (i2 = 0; i2 < this.length; ++i2) {
      if (this[i2] === o) {
        return i2;
      }
    }
    return -1;
  };
}
function daysInMonth(year, month) {
  if (isNaN(year) || isNaN(month)) {
    return NaN;
  }
  var modMonth = mod(month, 12);
  year += (month - modMonth) / 12;
  return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
}
addFormatToken("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
addFormatToken("MMM", 0, 0, function(format2) {
  return this.localeData().monthsShort(this, format2);
});
addFormatToken("MMMM", 0, 0, function(format2) {
  return this.localeData().months(this, format2);
});
addUnitAlias("month", "M");
addUnitPriority("month", 8);
addRegexToken("M", match1to2);
addRegexToken("MM", match1to2, match2);
addRegexToken("MMM", function(isStrict, locale2) {
  return locale2.monthsShortRegex(isStrict);
});
addRegexToken("MMMM", function(isStrict, locale2) {
  return locale2.monthsRegex(isStrict);
});
addParseToken(["M", "MM"], function(input, array) {
  array[MONTH] = toInt(input) - 1;
});
addParseToken(["MMM", "MMMM"], function(input, array, config2, token2) {
  var month = config2._locale.monthsParse(input, token2, config2._strict);
  if (month != null) {
    array[MONTH] = month;
  } else {
    getParsingFlags(config2).invalidMonth = input;
  }
});
var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
function localeMonths(m, format2) {
  if (!m) {
    return isArray$1(this._months) ? this._months : this._months["standalone"];
  }
  return isArray$1(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format2) ? "format" : "standalone"][m.month()];
}
function localeMonthsShort(m, format2) {
  if (!m) {
    return isArray$1(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
  }
  return isArray$1(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format2) ? "format" : "standalone"][m.month()];
}
function handleStrictParse(monthName, format2, strict) {
  var i2, ii, mom, llc = monthName.toLocaleLowerCase();
  if (!this._monthsParse) {
    this._monthsParse = [];
    this._longMonthsParse = [];
    this._shortMonthsParse = [];
    for (i2 = 0; i2 < 12; ++i2) {
      mom = createUTC([2e3, i2]);
      this._shortMonthsParse[i2] = this.monthsShort(mom, "").toLocaleLowerCase();
      this._longMonthsParse[i2] = this.months(mom, "").toLocaleLowerCase();
    }
  }
  if (strict) {
    if (format2 === "MMM") {
      ii = indexOf.call(this._shortMonthsParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._longMonthsParse, llc);
      return ii !== -1 ? ii : null;
    }
  } else {
    if (format2 === "MMM") {
      ii = indexOf.call(this._shortMonthsParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._longMonthsParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._longMonthsParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortMonthsParse, llc);
      return ii !== -1 ? ii : null;
    }
  }
}
function localeMonthsParse(monthName, format2, strict) {
  var i2, mom, regex;
  if (this._monthsParseExact) {
    return handleStrictParse.call(this, monthName, format2, strict);
  }
  if (!this._monthsParse) {
    this._monthsParse = [];
    this._longMonthsParse = [];
    this._shortMonthsParse = [];
  }
  for (i2 = 0; i2 < 12; i2++) {
    mom = createUTC([2e3, i2]);
    if (strict && !this._longMonthsParse[i2]) {
      this._longMonthsParse[i2] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
      this._shortMonthsParse[i2] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
    }
    if (!strict && !this._monthsParse[i2]) {
      regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
      this._monthsParse[i2] = new RegExp(regex.replace(".", ""), "i");
    }
    if (strict && format2 === "MMMM" && this._longMonthsParse[i2].test(monthName)) {
      return i2;
    } else if (strict && format2 === "MMM" && this._shortMonthsParse[i2].test(monthName)) {
      return i2;
    } else if (!strict && this._monthsParse[i2].test(monthName)) {
      return i2;
    }
  }
}
function setMonth(mom, value) {
  var dayOfMonth;
  if (!mom.isValid()) {
    return mom;
  }
  if (typeof value === "string") {
    if (/^\d+$/.test(value)) {
      value = toInt(value);
    } else {
      value = mom.localeData().monthsParse(value);
      if (!isNumber(value)) {
        return mom;
      }
    }
  }
  dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
  mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
  return mom;
}
function getSetMonth(value) {
  if (value != null) {
    setMonth(this, value);
    hooks.updateOffset(this, true);
    return this;
  } else {
    return get(this, "Month");
  }
}
function getDaysInMonth() {
  return daysInMonth(this.year(), this.month());
}
function monthsShortRegex(isStrict) {
  if (this._monthsParseExact) {
    if (!hasOwnProp(this, "_monthsRegex")) {
      computeMonthsParse.call(this);
    }
    if (isStrict) {
      return this._monthsShortStrictRegex;
    } else {
      return this._monthsShortRegex;
    }
  } else {
    if (!hasOwnProp(this, "_monthsShortRegex")) {
      this._monthsShortRegex = defaultMonthsShortRegex;
    }
    return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
  }
}
function monthsRegex(isStrict) {
  if (this._monthsParseExact) {
    if (!hasOwnProp(this, "_monthsRegex")) {
      computeMonthsParse.call(this);
    }
    if (isStrict) {
      return this._monthsStrictRegex;
    } else {
      return this._monthsRegex;
    }
  } else {
    if (!hasOwnProp(this, "_monthsRegex")) {
      this._monthsRegex = defaultMonthsRegex;
    }
    return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
  }
}
function computeMonthsParse() {
  function cmpLenRev(a, b) {
    return b.length - a.length;
  }
  var shortPieces = [], longPieces = [], mixedPieces = [], i2, mom;
  for (i2 = 0; i2 < 12; i2++) {
    mom = createUTC([2e3, i2]);
    shortPieces.push(this.monthsShort(mom, ""));
    longPieces.push(this.months(mom, ""));
    mixedPieces.push(this.months(mom, ""));
    mixedPieces.push(this.monthsShort(mom, ""));
  }
  shortPieces.sort(cmpLenRev);
  longPieces.sort(cmpLenRev);
  mixedPieces.sort(cmpLenRev);
  for (i2 = 0; i2 < 12; i2++) {
    shortPieces[i2] = regexEscape(shortPieces[i2]);
    longPieces[i2] = regexEscape(longPieces[i2]);
  }
  for (i2 = 0; i2 < 24; i2++) {
    mixedPieces[i2] = regexEscape(mixedPieces[i2]);
  }
  this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._monthsShortRegex = this._monthsRegex;
  this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
  this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
}
addFormatToken("Y", 0, 0, function() {
  var y = this.year();
  return y <= 9999 ? zeroFill(y, 4) : "+" + y;
});
addFormatToken(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
addFormatToken(0, ["YYYY", 4], 0, "year");
addFormatToken(0, ["YYYYY", 5], 0, "year");
addFormatToken(0, ["YYYYYY", 6, true], 0, "year");
addUnitAlias("year", "y");
addUnitPriority("year", 1);
addRegexToken("Y", matchSigned);
addRegexToken("YY", match1to2, match2);
addRegexToken("YYYY", match1to4, match4);
addRegexToken("YYYYY", match1to6, match6);
addRegexToken("YYYYYY", match1to6, match6);
addParseToken(["YYYYY", "YYYYYY"], YEAR);
addParseToken("YYYY", function(input, array) {
  array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken("YY", function(input, array) {
  array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken("Y", function(input, array) {
  array[YEAR] = parseInt(input, 10);
});
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
hooks.parseTwoDigitYear = function(input) {
  return toInt(input) + (toInt(input) > 68 ? 1900 : 2e3);
};
var getSetYear = makeGetSet("FullYear", true);
function getIsLeapYear() {
  return isLeapYear(this.year());
}
function createDate(y, m, d, h, M2, s2, ms) {
  var date2;
  if (y < 100 && y >= 0) {
    date2 = new Date(y + 400, m, d, h, M2, s2, ms);
    if (isFinite(date2.getFullYear())) {
      date2.setFullYear(y);
    }
  } else {
    date2 = new Date(y, m, d, h, M2, s2, ms);
  }
  return date2;
}
function createUTCDate(y) {
  var date2, args;
  if (y < 100 && y >= 0) {
    args = Array.prototype.slice.call(arguments);
    args[0] = y + 400;
    date2 = new Date(Date.UTC.apply(null, args));
    if (isFinite(date2.getUTCFullYear())) {
      date2.setUTCFullYear(y);
    }
  } else {
    date2 = new Date(Date.UTC.apply(null, arguments));
  }
  return date2;
}
function firstWeekOffset(year, dow, doy) {
  var fwd = 7 + dow - doy, fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
  return -fwdlw + fwd - 1;
}
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
  var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
  if (dayOfYear <= 0) {
    resYear = year - 1;
    resDayOfYear = daysInYear(resYear) + dayOfYear;
  } else if (dayOfYear > daysInYear(year)) {
    resYear = year + 1;
    resDayOfYear = dayOfYear - daysInYear(year);
  } else {
    resYear = year;
    resDayOfYear = dayOfYear;
  }
  return {
    year: resYear,
    dayOfYear: resDayOfYear
  };
}
function weekOfYear(mom, dow, doy) {
  var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
  if (week < 1) {
    resYear = mom.year() - 1;
    resWeek = week + weeksInYear(resYear, dow, doy);
  } else if (week > weeksInYear(mom.year(), dow, doy)) {
    resWeek = week - weeksInYear(mom.year(), dow, doy);
    resYear = mom.year() + 1;
  } else {
    resYear = mom.year();
    resWeek = week;
  }
  return {
    week: resWeek,
    year: resYear
  };
}
function weeksInYear(year, dow, doy) {
  var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
  return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}
addFormatToken("w", ["ww", 2], "wo", "week");
addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
addUnitAlias("week", "w");
addUnitAlias("isoWeek", "W");
addUnitPriority("week", 5);
addUnitPriority("isoWeek", 5);
addRegexToken("w", match1to2);
addRegexToken("ww", match1to2, match2);
addRegexToken("W", match1to2);
addRegexToken("WW", match1to2, match2);
addWeekParseToken(["w", "ww", "W", "WW"], function(input, week, config2, token2) {
  week[token2.substr(0, 1)] = toInt(input);
});
function localeWeek(mom) {
  return weekOfYear(mom, this._week.dow, this._week.doy).week;
}
var defaultLocaleWeek = {
  dow: 0,
  doy: 6
};
function localeFirstDayOfWeek() {
  return this._week.dow;
}
function localeFirstDayOfYear() {
  return this._week.doy;
}
function getSetWeek(input) {
  var week = this.localeData().week(this);
  return input == null ? week : this.add((input - week) * 7, "d");
}
function getSetISOWeek(input) {
  var week = weekOfYear(this, 1, 4).week;
  return input == null ? week : this.add((input - week) * 7, "d");
}
addFormatToken("d", 0, "do", "day");
addFormatToken("dd", 0, 0, function(format2) {
  return this.localeData().weekdaysMin(this, format2);
});
addFormatToken("ddd", 0, 0, function(format2) {
  return this.localeData().weekdaysShort(this, format2);
});
addFormatToken("dddd", 0, 0, function(format2) {
  return this.localeData().weekdays(this, format2);
});
addFormatToken("e", 0, 0, "weekday");
addFormatToken("E", 0, 0, "isoWeekday");
addUnitAlias("day", "d");
addUnitAlias("weekday", "e");
addUnitAlias("isoWeekday", "E");
addUnitPriority("day", 11);
addUnitPriority("weekday", 11);
addUnitPriority("isoWeekday", 11);
addRegexToken("d", match1to2);
addRegexToken("e", match1to2);
addRegexToken("E", match1to2);
addRegexToken("dd", function(isStrict, locale2) {
  return locale2.weekdaysMinRegex(isStrict);
});
addRegexToken("ddd", function(isStrict, locale2) {
  return locale2.weekdaysShortRegex(isStrict);
});
addRegexToken("dddd", function(isStrict, locale2) {
  return locale2.weekdaysRegex(isStrict);
});
addWeekParseToken(["dd", "ddd", "dddd"], function(input, week, config2, token2) {
  var weekday = config2._locale.weekdaysParse(input, token2, config2._strict);
  if (weekday != null) {
    week.d = weekday;
  } else {
    getParsingFlags(config2).invalidWeekday = input;
  }
});
addWeekParseToken(["d", "e", "E"], function(input, week, config2, token2) {
  week[token2] = toInt(input);
});
function parseWeekday(input, locale2) {
  if (typeof input !== "string") {
    return input;
  }
  if (!isNaN(input)) {
    return parseInt(input, 10);
  }
  input = locale2.weekdaysParse(input);
  if (typeof input === "number") {
    return input;
  }
  return null;
}
function parseIsoWeekday(input, locale2) {
  if (typeof input === "string") {
    return locale2.weekdaysParse(input) % 7 || 7;
  }
  return isNaN(input) ? null : input;
}
function shiftWeekdays(ws, n) {
  return ws.slice(n, 7).concat(ws.slice(0, n));
}
var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
function localeWeekdays(m, format2) {
  var weekdays = isArray$1(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format2) ? "format" : "standalone"];
  return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
}
function localeWeekdaysShort(m) {
  return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}
function localeWeekdaysMin(m) {
  return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}
function handleStrictParse$1(weekdayName, format2, strict) {
  var i2, ii, mom, llc = weekdayName.toLocaleLowerCase();
  if (!this._weekdaysParse) {
    this._weekdaysParse = [];
    this._shortWeekdaysParse = [];
    this._minWeekdaysParse = [];
    for (i2 = 0; i2 < 7; ++i2) {
      mom = createUTC([2e3, 1]).day(i2);
      this._minWeekdaysParse[i2] = this.weekdaysMin(mom, "").toLocaleLowerCase();
      this._shortWeekdaysParse[i2] = this.weekdaysShort(mom, "").toLocaleLowerCase();
      this._weekdaysParse[i2] = this.weekdays(mom, "").toLocaleLowerCase();
    }
  }
  if (strict) {
    if (format2 === "dddd") {
      ii = indexOf.call(this._weekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else if (format2 === "ddd") {
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    }
  } else {
    if (format2 === "dddd") {
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else if (format2 === "ddd") {
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._minWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    }
  }
}
function localeWeekdaysParse(weekdayName, format2, strict) {
  var i2, mom, regex;
  if (this._weekdaysParseExact) {
    return handleStrictParse$1.call(this, weekdayName, format2, strict);
  }
  if (!this._weekdaysParse) {
    this._weekdaysParse = [];
    this._minWeekdaysParse = [];
    this._shortWeekdaysParse = [];
    this._fullWeekdaysParse = [];
  }
  for (i2 = 0; i2 < 7; i2++) {
    mom = createUTC([2e3, 1]).day(i2);
    if (strict && !this._fullWeekdaysParse[i2]) {
      this._fullWeekdaysParse[i2] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
      this._shortWeekdaysParse[i2] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
      this._minWeekdaysParse[i2] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
    }
    if (!this._weekdaysParse[i2]) {
      regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
      this._weekdaysParse[i2] = new RegExp(regex.replace(".", ""), "i");
    }
    if (strict && format2 === "dddd" && this._fullWeekdaysParse[i2].test(weekdayName)) {
      return i2;
    } else if (strict && format2 === "ddd" && this._shortWeekdaysParse[i2].test(weekdayName)) {
      return i2;
    } else if (strict && format2 === "dd" && this._minWeekdaysParse[i2].test(weekdayName)) {
      return i2;
    } else if (!strict && this._weekdaysParse[i2].test(weekdayName)) {
      return i2;
    }
  }
}
function getSetDayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  if (input != null) {
    input = parseWeekday(input, this.localeData());
    return this.add(input - day, "d");
  } else {
    return day;
  }
}
function getSetLocaleDayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return input == null ? weekday : this.add(input - weekday, "d");
}
function getSetISODayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  if (input != null) {
    var weekday = parseIsoWeekday(input, this.localeData());
    return this.day(this.day() % 7 ? weekday : weekday - 7);
  } else {
    return this.day() || 7;
  }
}
function weekdaysRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysStrictRegex;
    } else {
      return this._weekdaysRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      this._weekdaysRegex = defaultWeekdaysRegex;
    }
    return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
  }
}
function weekdaysShortRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysShortStrictRegex;
    } else {
      return this._weekdaysShortRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysShortRegex")) {
      this._weekdaysShortRegex = defaultWeekdaysShortRegex;
    }
    return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
  }
}
function weekdaysMinRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysMinStrictRegex;
    } else {
      return this._weekdaysMinRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysMinRegex")) {
      this._weekdaysMinRegex = defaultWeekdaysMinRegex;
    }
    return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
  }
}
function computeWeekdaysParse() {
  function cmpLenRev(a, b) {
    return b.length - a.length;
  }
  var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i2, mom, minp, shortp, longp;
  for (i2 = 0; i2 < 7; i2++) {
    mom = createUTC([2e3, 1]).day(i2);
    minp = regexEscape(this.weekdaysMin(mom, ""));
    shortp = regexEscape(this.weekdaysShort(mom, ""));
    longp = regexEscape(this.weekdays(mom, ""));
    minPieces.push(minp);
    shortPieces.push(shortp);
    longPieces.push(longp);
    mixedPieces.push(minp);
    mixedPieces.push(shortp);
    mixedPieces.push(longp);
  }
  minPieces.sort(cmpLenRev);
  shortPieces.sort(cmpLenRev);
  longPieces.sort(cmpLenRev);
  mixedPieces.sort(cmpLenRev);
  this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._weekdaysShortRegex = this._weekdaysRegex;
  this._weekdaysMinRegex = this._weekdaysRegex;
  this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
  this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
  this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
}
function hFormat() {
  return this.hours() % 12 || 12;
}
function kFormat() {
  return this.hours() || 24;
}
addFormatToken("H", ["HH", 2], 0, "hour");
addFormatToken("h", ["hh", 2], 0, hFormat);
addFormatToken("k", ["kk", 2], 0, kFormat);
addFormatToken("hmm", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});
addFormatToken("hmmss", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
addFormatToken("Hmm", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2);
});
addFormatToken("Hmmss", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
function meridiem(token2, lowercase) {
  addFormatToken(token2, 0, 0, function() {
    return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
  });
}
meridiem("a", true);
meridiem("A", false);
addUnitAlias("hour", "h");
addUnitPriority("hour", 13);
function matchMeridiem(isStrict, locale2) {
  return locale2._meridiemParse;
}
addRegexToken("a", matchMeridiem);
addRegexToken("A", matchMeridiem);
addRegexToken("H", match1to2);
addRegexToken("h", match1to2);
addRegexToken("k", match1to2);
addRegexToken("HH", match1to2, match2);
addRegexToken("hh", match1to2, match2);
addRegexToken("kk", match1to2, match2);
addRegexToken("hmm", match3to4);
addRegexToken("hmmss", match5to6);
addRegexToken("Hmm", match3to4);
addRegexToken("Hmmss", match5to6);
addParseToken(["H", "HH"], HOUR);
addParseToken(["k", "kk"], function(input, array, config2) {
  var kInput = toInt(input);
  array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(["a", "A"], function(input, array, config2) {
  config2._isPm = config2._locale.isPM(input);
  config2._meridiem = input;
});
addParseToken(["h", "hh"], function(input, array, config2) {
  array[HOUR] = toInt(input);
  getParsingFlags(config2).bigHour = true;
});
addParseToken("hmm", function(input, array, config2) {
  var pos = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos));
  array[MINUTE] = toInt(input.substr(pos));
  getParsingFlags(config2).bigHour = true;
});
addParseToken("hmmss", function(input, array, config2) {
  var pos1 = input.length - 4, pos2 = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos1));
  array[MINUTE] = toInt(input.substr(pos1, 2));
  array[SECOND] = toInt(input.substr(pos2));
  getParsingFlags(config2).bigHour = true;
});
addParseToken("Hmm", function(input, array, config2) {
  var pos = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos));
  array[MINUTE] = toInt(input.substr(pos));
});
addParseToken("Hmmss", function(input, array, config2) {
  var pos1 = input.length - 4, pos2 = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos1));
  array[MINUTE] = toInt(input.substr(pos1, 2));
  array[SECOND] = toInt(input.substr(pos2));
});
function localeIsPM(input) {
  return (input + "").toLowerCase().charAt(0) === "p";
}
var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", true);
function localeMeridiem(hours2, minutes2, isLower) {
  if (hours2 > 11) {
    return isLower ? "pm" : "PM";
  } else {
    return isLower ? "am" : "AM";
  }
}
var baseConfig = {
  calendar: defaultCalendar,
  longDateFormat: defaultLongDateFormat,
  invalidDate: defaultInvalidDate,
  ordinal: defaultOrdinal,
  dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
  relativeTime: defaultRelativeTime,
  months: defaultLocaleMonths,
  monthsShort: defaultLocaleMonthsShort,
  week: defaultLocaleWeek,
  weekdays: defaultLocaleWeekdays,
  weekdaysMin: defaultLocaleWeekdaysMin,
  weekdaysShort: defaultLocaleWeekdaysShort,
  meridiemParse: defaultLocaleMeridiemParse
};
var locales = {}, localeFamilies = {}, globalLocale;
function commonPrefix(arr1, arr2) {
  var i2, minl = Math.min(arr1.length, arr2.length);
  for (i2 = 0; i2 < minl; i2 += 1) {
    if (arr1[i2] !== arr2[i2]) {
      return i2;
    }
  }
  return minl;
}
function normalizeLocale(key) {
  return key ? key.toLowerCase().replace("_", "-") : key;
}
function chooseLocale(names) {
  var i2 = 0, j, next, locale2, split;
  while (i2 < names.length) {
    split = normalizeLocale(names[i2]).split("-");
    j = split.length;
    next = normalizeLocale(names[i2 + 1]);
    next = next ? next.split("-") : null;
    while (j > 0) {
      locale2 = loadLocale(split.slice(0, j).join("-"));
      if (locale2) {
        return locale2;
      }
      if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
        break;
      }
      j--;
    }
    i2++;
  }
  return globalLocale;
}
function loadLocale(name) {
  var oldLocale = null, aliasedRequire;
  if (locales[name] === void 0 && typeof module !== "undefined" && module && module.exports) {
    try {
      oldLocale = globalLocale._abbr;
      aliasedRequire = require;
      aliasedRequire("./locale/" + name);
      getSetGlobalLocale(oldLocale);
    } catch (e) {
      locales[name] = null;
    }
  }
  return locales[name];
}
function getSetGlobalLocale(key, values) {
  var data;
  if (key) {
    if (isUndefined(values)) {
      data = getLocale(key);
    } else {
      data = defineLocale(key, values);
    }
    if (data) {
      globalLocale = data;
    } else {
      if (typeof console !== "undefined" && console.warn) {
        console.warn("Locale " + key + " not found. Did you forget to load it?");
      }
    }
  }
  return globalLocale._abbr;
}
function defineLocale(name, config2) {
  if (config2 !== null) {
    var locale2, parentConfig = baseConfig;
    config2.abbr = name;
    if (locales[name] != null) {
      deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
      parentConfig = locales[name]._config;
    } else if (config2.parentLocale != null) {
      if (locales[config2.parentLocale] != null) {
        parentConfig = locales[config2.parentLocale]._config;
      } else {
        locale2 = loadLocale(config2.parentLocale);
        if (locale2 != null) {
          parentConfig = locale2._config;
        } else {
          if (!localeFamilies[config2.parentLocale]) {
            localeFamilies[config2.parentLocale] = [];
          }
          localeFamilies[config2.parentLocale].push({
            name,
            config: config2
          });
          return null;
        }
      }
    }
    locales[name] = new Locale(mergeConfigs(parentConfig, config2));
    if (localeFamilies[name]) {
      localeFamilies[name].forEach(function(x2) {
        defineLocale(x2.name, x2.config);
      });
    }
    getSetGlobalLocale(name);
    return locales[name];
  } else {
    delete locales[name];
    return null;
  }
}
function updateLocale(name, config2) {
  if (config2 != null) {
    var locale2, tmpLocale, parentConfig = baseConfig;
    if (locales[name] != null && locales[name].parentLocale != null) {
      locales[name].set(mergeConfigs(locales[name]._config, config2));
    } else {
      tmpLocale = loadLocale(name);
      if (tmpLocale != null) {
        parentConfig = tmpLocale._config;
      }
      config2 = mergeConfigs(parentConfig, config2);
      if (tmpLocale == null) {
        config2.abbr = name;
      }
      locale2 = new Locale(config2);
      locale2.parentLocale = locales[name];
      locales[name] = locale2;
    }
    getSetGlobalLocale(name);
  } else {
    if (locales[name] != null) {
      if (locales[name].parentLocale != null) {
        locales[name] = locales[name].parentLocale;
        if (name === getSetGlobalLocale()) {
          getSetGlobalLocale(name);
        }
      } else if (locales[name] != null) {
        delete locales[name];
      }
    }
  }
  return locales[name];
}
function getLocale(key) {
  var locale2;
  if (key && key._locale && key._locale._abbr) {
    key = key._locale._abbr;
  }
  if (!key) {
    return globalLocale;
  }
  if (!isArray$1(key)) {
    locale2 = loadLocale(key);
    if (locale2) {
      return locale2;
    }
    key = [key];
  }
  return chooseLocale(key);
}
function listLocales() {
  return keys$2(locales);
}
function checkOverflow(m) {
  var overflow, a = m._a;
  if (a && getParsingFlags(m).overflow === -2) {
    overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
    if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
      overflow = DATE;
    }
    if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
      overflow = WEEK;
    }
    if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
      overflow = WEEKDAY;
    }
    getParsingFlags(m).overflow = overflow;
  }
  return m;
}
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, false],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, false],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, false],
  ["YYYY", /\d{4}/, false]
], isoTimes = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function configFromISO(config2) {
  var i2, l, string2 = config2._i, match = extendedIsoRegex.exec(string2) || basicIsoRegex.exec(string2), allowTime, dateFormat, timeFormat, tzFormat;
  if (match) {
    getParsingFlags(config2).iso = true;
    for (i2 = 0, l = isoDates.length; i2 < l; i2++) {
      if (isoDates[i2][1].exec(match[1])) {
        dateFormat = isoDates[i2][0];
        allowTime = isoDates[i2][2] !== false;
        break;
      }
    }
    if (dateFormat == null) {
      config2._isValid = false;
      return;
    }
    if (match[3]) {
      for (i2 = 0, l = isoTimes.length; i2 < l; i2++) {
        if (isoTimes[i2][1].exec(match[3])) {
          timeFormat = (match[2] || " ") + isoTimes[i2][0];
          break;
        }
      }
      if (timeFormat == null) {
        config2._isValid = false;
        return;
      }
    }
    if (!allowTime && timeFormat != null) {
      config2._isValid = false;
      return;
    }
    if (match[4]) {
      if (tzRegex.exec(match[4])) {
        tzFormat = "Z";
      } else {
        config2._isValid = false;
        return;
      }
    }
    config2._f = dateFormat + (timeFormat || "") + (tzFormat || "");
    configFromStringAndFormat(config2);
  } else {
    config2._isValid = false;
  }
}
function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  var result2 = [
    untruncateYear(yearStr),
    defaultLocaleMonthsShort.indexOf(monthStr),
    parseInt(dayStr, 10),
    parseInt(hourStr, 10),
    parseInt(minuteStr, 10)
  ];
  if (secondStr) {
    result2.push(parseInt(secondStr, 10));
  }
  return result2;
}
function untruncateYear(yearStr) {
  var year = parseInt(yearStr, 10);
  if (year <= 49) {
    return 2e3 + year;
  } else if (year <= 999) {
    return 1900 + year;
  }
  return year;
}
function preprocessRFC2822(s2) {
  return s2.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function checkWeekday(weekdayStr, parsedInput, config2) {
  if (weekdayStr) {
    var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
    if (weekdayProvided !== weekdayActual) {
      getParsingFlags(config2).weekdayMismatch = true;
      config2._isValid = false;
      return false;
    }
  }
  return true;
}
function calculateOffset(obsOffset, militaryOffset, numOffset) {
  if (obsOffset) {
    return obsOffsets[obsOffset];
  } else if (militaryOffset) {
    return 0;
  } else {
    var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
    return h * 60 + m;
  }
}
function configFromRFC2822(config2) {
  var match = rfc2822.exec(preprocessRFC2822(config2._i)), parsedArray;
  if (match) {
    parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
    if (!checkWeekday(match[1], parsedArray, config2)) {
      return;
    }
    config2._a = parsedArray;
    config2._tzm = calculateOffset(match[8], match[9], match[10]);
    config2._d = createUTCDate.apply(null, config2._a);
    config2._d.setUTCMinutes(config2._d.getUTCMinutes() - config2._tzm);
    getParsingFlags(config2).rfc2822 = true;
  } else {
    config2._isValid = false;
  }
}
function configFromString(config2) {
  var matched = aspNetJsonRegex.exec(config2._i);
  if (matched !== null) {
    config2._d = new Date(+matched[1]);
    return;
  }
  configFromISO(config2);
  if (config2._isValid === false) {
    delete config2._isValid;
  } else {
    return;
  }
  configFromRFC2822(config2);
  if (config2._isValid === false) {
    delete config2._isValid;
  } else {
    return;
  }
  if (config2._strict) {
    config2._isValid = false;
  } else {
    hooks.createFromInputFallback(config2);
  }
}
hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config2) {
  config2._d = new Date(config2._i + (config2._useUTC ? " UTC" : ""));
});
function defaults(a, b, c) {
  if (a != null) {
    return a;
  }
  if (b != null) {
    return b;
  }
  return c;
}
function currentDateArray(config2) {
  var nowValue = new Date(hooks.now());
  if (config2._useUTC) {
    return [
      nowValue.getUTCFullYear(),
      nowValue.getUTCMonth(),
      nowValue.getUTCDate()
    ];
  }
  return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}
function configFromArray(config2) {
  var i2, date2, input = [], currentDate, expectedWeekday, yearToUse;
  if (config2._d) {
    return;
  }
  currentDate = currentDateArray(config2);
  if (config2._w && config2._a[DATE] == null && config2._a[MONTH] == null) {
    dayOfYearFromWeekInfo(config2);
  }
  if (config2._dayOfYear != null) {
    yearToUse = defaults(config2._a[YEAR], currentDate[YEAR]);
    if (config2._dayOfYear > daysInYear(yearToUse) || config2._dayOfYear === 0) {
      getParsingFlags(config2)._overflowDayOfYear = true;
    }
    date2 = createUTCDate(yearToUse, 0, config2._dayOfYear);
    config2._a[MONTH] = date2.getUTCMonth();
    config2._a[DATE] = date2.getUTCDate();
  }
  for (i2 = 0; i2 < 3 && config2._a[i2] == null; ++i2) {
    config2._a[i2] = input[i2] = currentDate[i2];
  }
  for (; i2 < 7; i2++) {
    config2._a[i2] = input[i2] = config2._a[i2] == null ? i2 === 2 ? 1 : 0 : config2._a[i2];
  }
  if (config2._a[HOUR] === 24 && config2._a[MINUTE] === 0 && config2._a[SECOND] === 0 && config2._a[MILLISECOND] === 0) {
    config2._nextDay = true;
    config2._a[HOUR] = 0;
  }
  config2._d = (config2._useUTC ? createUTCDate : createDate).apply(null, input);
  expectedWeekday = config2._useUTC ? config2._d.getUTCDay() : config2._d.getDay();
  if (config2._tzm != null) {
    config2._d.setUTCMinutes(config2._d.getUTCMinutes() - config2._tzm);
  }
  if (config2._nextDay) {
    config2._a[HOUR] = 24;
  }
  if (config2._w && typeof config2._w.d !== "undefined" && config2._w.d !== expectedWeekday) {
    getParsingFlags(config2).weekdayMismatch = true;
  }
}
function dayOfYearFromWeekInfo(config2) {
  var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
  w = config2._w;
  if (w.GG != null || w.W != null || w.E != null) {
    dow = 1;
    doy = 4;
    weekYear = defaults(w.GG, config2._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
    week = defaults(w.W, 1);
    weekday = defaults(w.E, 1);
    if (weekday < 1 || weekday > 7) {
      weekdayOverflow = true;
    }
  } else {
    dow = config2._locale._week.dow;
    doy = config2._locale._week.doy;
    curWeek = weekOfYear(createLocal(), dow, doy);
    weekYear = defaults(w.gg, config2._a[YEAR], curWeek.year);
    week = defaults(w.w, curWeek.week);
    if (w.d != null) {
      weekday = w.d;
      if (weekday < 0 || weekday > 6) {
        weekdayOverflow = true;
      }
    } else if (w.e != null) {
      weekday = w.e + dow;
      if (w.e < 0 || w.e > 6) {
        weekdayOverflow = true;
      }
    } else {
      weekday = dow;
    }
  }
  if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
    getParsingFlags(config2)._overflowWeeks = true;
  } else if (weekdayOverflow != null) {
    getParsingFlags(config2)._overflowWeekday = true;
  } else {
    temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
    config2._a[YEAR] = temp.year;
    config2._dayOfYear = temp.dayOfYear;
  }
}
hooks.ISO_8601 = function() {
};
hooks.RFC_2822 = function() {
};
function configFromStringAndFormat(config2) {
  if (config2._f === hooks.ISO_8601) {
    configFromISO(config2);
    return;
  }
  if (config2._f === hooks.RFC_2822) {
    configFromRFC2822(config2);
    return;
  }
  config2._a = [];
  getParsingFlags(config2).empty = true;
  var string2 = "" + config2._i, i2, parsedInput, tokens2, token2, skipped, stringLength = string2.length, totalParsedInputLength = 0, era;
  tokens2 = expandFormat(config2._f, config2._locale).match(formattingTokens) || [];
  for (i2 = 0; i2 < tokens2.length; i2++) {
    token2 = tokens2[i2];
    parsedInput = (string2.match(getParseRegexForToken(token2, config2)) || [])[0];
    if (parsedInput) {
      skipped = string2.substr(0, string2.indexOf(parsedInput));
      if (skipped.length > 0) {
        getParsingFlags(config2).unusedInput.push(skipped);
      }
      string2 = string2.slice(string2.indexOf(parsedInput) + parsedInput.length);
      totalParsedInputLength += parsedInput.length;
    }
    if (formatTokenFunctions[token2]) {
      if (parsedInput) {
        getParsingFlags(config2).empty = false;
      } else {
        getParsingFlags(config2).unusedTokens.push(token2);
      }
      addTimeToArrayFromToken(token2, parsedInput, config2);
    } else if (config2._strict && !parsedInput) {
      getParsingFlags(config2).unusedTokens.push(token2);
    }
  }
  getParsingFlags(config2).charsLeftOver = stringLength - totalParsedInputLength;
  if (string2.length > 0) {
    getParsingFlags(config2).unusedInput.push(string2);
  }
  if (config2._a[HOUR] <= 12 && getParsingFlags(config2).bigHour === true && config2._a[HOUR] > 0) {
    getParsingFlags(config2).bigHour = void 0;
  }
  getParsingFlags(config2).parsedDateParts = config2._a.slice(0);
  getParsingFlags(config2).meridiem = config2._meridiem;
  config2._a[HOUR] = meridiemFixWrap(config2._locale, config2._a[HOUR], config2._meridiem);
  era = getParsingFlags(config2).era;
  if (era !== null) {
    config2._a[YEAR] = config2._locale.erasConvertYear(era, config2._a[YEAR]);
  }
  configFromArray(config2);
  checkOverflow(config2);
}
function meridiemFixWrap(locale2, hour, meridiem2) {
  var isPm;
  if (meridiem2 == null) {
    return hour;
  }
  if (locale2.meridiemHour != null) {
    return locale2.meridiemHour(hour, meridiem2);
  } else if (locale2.isPM != null) {
    isPm = locale2.isPM(meridiem2);
    if (isPm && hour < 12) {
      hour += 12;
    }
    if (!isPm && hour === 12) {
      hour = 0;
    }
    return hour;
  } else {
    return hour;
  }
}
function configFromStringAndArray(config2) {
  var tempConfig, bestMoment, scoreToBeat, i2, currentScore, validFormatFound, bestFormatIsValid = false;
  if (config2._f.length === 0) {
    getParsingFlags(config2).invalidFormat = true;
    config2._d = new Date(NaN);
    return;
  }
  for (i2 = 0; i2 < config2._f.length; i2++) {
    currentScore = 0;
    validFormatFound = false;
    tempConfig = copyConfig({}, config2);
    if (config2._useUTC != null) {
      tempConfig._useUTC = config2._useUTC;
    }
    tempConfig._f = config2._f[i2];
    configFromStringAndFormat(tempConfig);
    if (isValid(tempConfig)) {
      validFormatFound = true;
    }
    currentScore += getParsingFlags(tempConfig).charsLeftOver;
    currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
    getParsingFlags(tempConfig).score = currentScore;
    if (!bestFormatIsValid) {
      if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
        if (validFormatFound) {
          bestFormatIsValid = true;
        }
      }
    } else {
      if (currentScore < scoreToBeat) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
      }
    }
  }
  extend$3(config2, bestMoment || tempConfig);
}
function configFromObject(config2) {
  if (config2._d) {
    return;
  }
  var i2 = normalizeObjectUnits(config2._i), dayOrDate = i2.day === void 0 ? i2.date : i2.day;
  config2._a = map([i2.year, i2.month, dayOrDate, i2.hour, i2.minute, i2.second, i2.millisecond], function(obj) {
    return obj && parseInt(obj, 10);
  });
  configFromArray(config2);
}
function createFromConfig(config2) {
  var res = new Moment(checkOverflow(prepareConfig(config2)));
  if (res._nextDay) {
    res.add(1, "d");
    res._nextDay = void 0;
  }
  return res;
}
function prepareConfig(config2) {
  var input = config2._i, format2 = config2._f;
  config2._locale = config2._locale || getLocale(config2._l);
  if (input === null || format2 === void 0 && input === "") {
    return createInvalid({ nullInput: true });
  }
  if (typeof input === "string") {
    config2._i = input = config2._locale.preparse(input);
  }
  if (isMoment(input)) {
    return new Moment(checkOverflow(input));
  } else if (isDate(input)) {
    config2._d = input;
  } else if (isArray$1(format2)) {
    configFromStringAndArray(config2);
  } else if (format2) {
    configFromStringAndFormat(config2);
  } else {
    configFromInput(config2);
  }
  if (!isValid(config2)) {
    config2._d = null;
  }
  return config2;
}
function configFromInput(config2) {
  var input = config2._i;
  if (isUndefined(input)) {
    config2._d = new Date(hooks.now());
  } else if (isDate(input)) {
    config2._d = new Date(input.valueOf());
  } else if (typeof input === "string") {
    configFromString(config2);
  } else if (isArray$1(input)) {
    config2._a = map(input.slice(0), function(obj) {
      return parseInt(obj, 10);
    });
    configFromArray(config2);
  } else if (isObject$3(input)) {
    configFromObject(config2);
  } else if (isNumber(input)) {
    config2._d = new Date(input);
  } else {
    hooks.createFromInputFallback(config2);
  }
}
function createLocalOrUTC(input, format2, locale2, strict, isUTC) {
  var c = {};
  if (format2 === true || format2 === false) {
    strict = format2;
    format2 = void 0;
  }
  if (locale2 === true || locale2 === false) {
    strict = locale2;
    locale2 = void 0;
  }
  if (isObject$3(input) && isObjectEmpty(input) || isArray$1(input) && input.length === 0) {
    input = void 0;
  }
  c._isAMomentObject = true;
  c._useUTC = c._isUTC = isUTC;
  c._l = locale2;
  c._i = input;
  c._f = format2;
  c._strict = strict;
  return createFromConfig(c);
}
function createLocal(input, format2, locale2, strict) {
  return createLocalOrUTC(input, format2, locale2, strict, false);
}
var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
  var other = createLocal.apply(null, arguments);
  if (this.isValid() && other.isValid()) {
    return other < this ? this : other;
  } else {
    return createInvalid();
  }
}), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
  var other = createLocal.apply(null, arguments);
  if (this.isValid() && other.isValid()) {
    return other > this ? this : other;
  } else {
    return createInvalid();
  }
});
function pickBy(fn, moments) {
  var res, i2;
  if (moments.length === 1 && isArray$1(moments[0])) {
    moments = moments[0];
  }
  if (!moments.length) {
    return createLocal();
  }
  res = moments[0];
  for (i2 = 1; i2 < moments.length; ++i2) {
    if (!moments[i2].isValid() || moments[i2][fn](res)) {
      res = moments[i2];
    }
  }
  return res;
}
function min() {
  var args = [].slice.call(arguments, 0);
  return pickBy("isBefore", args);
}
function max() {
  var args = [].slice.call(arguments, 0);
  return pickBy("isAfter", args);
}
var now$1 = function() {
  return Date.now ? Date.now() : +new Date();
};
var ordering = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function isDurationValid(m) {
  var key, unitHasDecimal = false, i2;
  for (key in m) {
    if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
      return false;
    }
  }
  for (i2 = 0; i2 < ordering.length; ++i2) {
    if (m[ordering[i2]]) {
      if (unitHasDecimal) {
        return false;
      }
      if (parseFloat(m[ordering[i2]]) !== toInt(m[ordering[i2]])) {
        unitHasDecimal = true;
      }
    }
  }
  return true;
}
function isValid$1() {
  return this._isValid;
}
function createInvalid$1() {
  return createDuration(NaN);
}
function Duration(duration) {
  var normalizedInput = normalizeObjectUnits(duration), years2 = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months2 = normalizedInput.month || 0, weeks2 = normalizedInput.week || normalizedInput.isoWeek || 0, days2 = normalizedInput.day || 0, hours2 = normalizedInput.hour || 0, minutes2 = normalizedInput.minute || 0, seconds2 = normalizedInput.second || 0, milliseconds2 = normalizedInput.millisecond || 0;
  this._isValid = isDurationValid(normalizedInput);
  this._milliseconds = +milliseconds2 + seconds2 * 1e3 + minutes2 * 6e4 + hours2 * 1e3 * 60 * 60;
  this._days = +days2 + weeks2 * 7;
  this._months = +months2 + quarters * 3 + years2 * 12;
  this._data = {};
  this._locale = getLocale();
  this._bubble();
}
function isDuration(obj) {
  return obj instanceof Duration;
}
function absRound(number2) {
  if (number2 < 0) {
    return Math.round(-1 * number2) * -1;
  } else {
    return Math.round(number2);
  }
}
function compareArrays(array1, array2, dontConvert) {
  var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i2;
  for (i2 = 0; i2 < len; i2++) {
    if (dontConvert && array1[i2] !== array2[i2] || !dontConvert && toInt(array1[i2]) !== toInt(array2[i2])) {
      diffs++;
    }
  }
  return diffs + lengthDiff;
}
function offset(token2, separator2) {
  addFormatToken(token2, 0, 0, function() {
    var offset3 = this.utcOffset(), sign2 = "+";
    if (offset3 < 0) {
      offset3 = -offset3;
      sign2 = "-";
    }
    return sign2 + zeroFill(~~(offset3 / 60), 2) + separator2 + zeroFill(~~offset3 % 60, 2);
  });
}
offset("Z", ":");
offset("ZZ", "");
addRegexToken("Z", matchShortOffset);
addRegexToken("ZZ", matchShortOffset);
addParseToken(["Z", "ZZ"], function(input, array, config2) {
  config2._useUTC = true;
  config2._tzm = offsetFromString(matchShortOffset, input);
});
var chunkOffset = /([\+\-]|\d\d)/gi;
function offsetFromString(matcher, string2) {
  var matches2 = (string2 || "").match(matcher), chunk, parts, minutes2;
  if (matches2 === null) {
    return null;
  }
  chunk = matches2[matches2.length - 1] || [];
  parts = (chunk + "").match(chunkOffset) || ["-", 0, 0];
  minutes2 = +(parts[1] * 60) + toInt(parts[2]);
  return minutes2 === 0 ? 0 : parts[0] === "+" ? minutes2 : -minutes2;
}
function cloneWithOffset(input, model) {
  var res, diff2;
  if (model._isUTC) {
    res = model.clone();
    diff2 = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
    res._d.setTime(res._d.valueOf() + diff2);
    hooks.updateOffset(res, false);
    return res;
  } else {
    return createLocal(input).local();
  }
}
function getDateOffset(m) {
  return -Math.round(m._d.getTimezoneOffset());
}
hooks.updateOffset = function() {
};
function getSetOffset(input, keepLocalTime, keepMinutes) {
  var offset3 = this._offset || 0, localAdjust;
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  if (input != null) {
    if (typeof input === "string") {
      input = offsetFromString(matchShortOffset, input);
      if (input === null) {
        return this;
      }
    } else if (Math.abs(input) < 16 && !keepMinutes) {
      input = input * 60;
    }
    if (!this._isUTC && keepLocalTime) {
      localAdjust = getDateOffset(this);
    }
    this._offset = input;
    this._isUTC = true;
    if (localAdjust != null) {
      this.add(localAdjust, "m");
    }
    if (offset3 !== input) {
      if (!keepLocalTime || this._changeInProgress) {
        addSubtract(this, createDuration(input - offset3, "m"), 1, false);
      } else if (!this._changeInProgress) {
        this._changeInProgress = true;
        hooks.updateOffset(this, true);
        this._changeInProgress = null;
      }
    }
    return this;
  } else {
    return this._isUTC ? offset3 : getDateOffset(this);
  }
}
function getSetZone(input, keepLocalTime) {
  if (input != null) {
    if (typeof input !== "string") {
      input = -input;
    }
    this.utcOffset(input, keepLocalTime);
    return this;
  } else {
    return -this.utcOffset();
  }
}
function setOffsetToUTC(keepLocalTime) {
  return this.utcOffset(0, keepLocalTime);
}
function setOffsetToLocal(keepLocalTime) {
  if (this._isUTC) {
    this.utcOffset(0, keepLocalTime);
    this._isUTC = false;
    if (keepLocalTime) {
      this.subtract(getDateOffset(this), "m");
    }
  }
  return this;
}
function setOffsetToParsedOffset() {
  if (this._tzm != null) {
    this.utcOffset(this._tzm, false, true);
  } else if (typeof this._i === "string") {
    var tZone = offsetFromString(matchOffset, this._i);
    if (tZone != null) {
      this.utcOffset(tZone);
    } else {
      this.utcOffset(0, true);
    }
  }
  return this;
}
function hasAlignedHourOffset(input) {
  if (!this.isValid()) {
    return false;
  }
  input = input ? createLocal(input).utcOffset() : 0;
  return (this.utcOffset() - input) % 60 === 0;
}
function isDaylightSavingTime() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function isDaylightSavingTimeShifted() {
  if (!isUndefined(this._isDSTShifted)) {
    return this._isDSTShifted;
  }
  var c = {}, other;
  copyConfig(c, this);
  c = prepareConfig(c);
  if (c._a) {
    other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
    this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
  } else {
    this._isDSTShifted = false;
  }
  return this._isDSTShifted;
}
function isLocal() {
  return this.isValid() ? !this._isUTC : false;
}
function isUtcOffset() {
  return this.isValid() ? this._isUTC : false;
}
function isUtc() {
  return this.isValid() ? this._isUTC && this._offset === 0 : false;
}
var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function createDuration(input, key) {
  var duration = input, match = null, sign2, ret, diffRes;
  if (isDuration(input)) {
    duration = {
      ms: input._milliseconds,
      d: input._days,
      M: input._months
    };
  } else if (isNumber(input) || !isNaN(+input)) {
    duration = {};
    if (key) {
      duration[key] = +input;
    } else {
      duration.milliseconds = +input;
    }
  } else if (match = aspNetRegex.exec(input)) {
    sign2 = match[1] === "-" ? -1 : 1;
    duration = {
      y: 0,
      d: toInt(match[DATE]) * sign2,
      h: toInt(match[HOUR]) * sign2,
      m: toInt(match[MINUTE]) * sign2,
      s: toInt(match[SECOND]) * sign2,
      ms: toInt(absRound(match[MILLISECOND] * 1e3)) * sign2
    };
  } else if (match = isoRegex.exec(input)) {
    sign2 = match[1] === "-" ? -1 : 1;
    duration = {
      y: parseIso(match[2], sign2),
      M: parseIso(match[3], sign2),
      w: parseIso(match[4], sign2),
      d: parseIso(match[5], sign2),
      h: parseIso(match[6], sign2),
      m: parseIso(match[7], sign2),
      s: parseIso(match[8], sign2)
    };
  } else if (duration == null) {
    duration = {};
  } else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
    diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
    duration = {};
    duration.ms = diffRes.milliseconds;
    duration.M = diffRes.months;
  }
  ret = new Duration(duration);
  if (isDuration(input) && hasOwnProp(input, "_locale")) {
    ret._locale = input._locale;
  }
  if (isDuration(input) && hasOwnProp(input, "_isValid")) {
    ret._isValid = input._isValid;
  }
  return ret;
}
createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;
function parseIso(inp, sign2) {
  var res = inp && parseFloat(inp.replace(",", "."));
  return (isNaN(res) ? 0 : res) * sign2;
}
function positiveMomentsDifference(base2, other) {
  var res = {};
  res.months = other.month() - base2.month() + (other.year() - base2.year()) * 12;
  if (base2.clone().add(res.months, "M").isAfter(other)) {
    --res.months;
  }
  res.milliseconds = +other - +base2.clone().add(res.months, "M");
  return res;
}
function momentsDifference(base2, other) {
  var res;
  if (!(base2.isValid() && other.isValid())) {
    return { milliseconds: 0, months: 0 };
  }
  other = cloneWithOffset(other, base2);
  if (base2.isBefore(other)) {
    res = positiveMomentsDifference(base2, other);
  } else {
    res = positiveMomentsDifference(other, base2);
    res.milliseconds = -res.milliseconds;
    res.months = -res.months;
  }
  return res;
}
function createAdder(direction, name) {
  return function(val, period) {
    var dur, tmp;
    if (period !== null && !isNaN(+period)) {
      deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
      tmp = val;
      val = period;
      period = tmp;
    }
    dur = createDuration(val, period);
    addSubtract(this, dur, direction);
    return this;
  };
}
function addSubtract(mom, duration, isAdding, updateOffset) {
  var milliseconds2 = duration._milliseconds, days2 = absRound(duration._days), months2 = absRound(duration._months);
  if (!mom.isValid()) {
    return;
  }
  updateOffset = updateOffset == null ? true : updateOffset;
  if (months2) {
    setMonth(mom, get(mom, "Month") + months2 * isAdding);
  }
  if (days2) {
    set$1(mom, "Date", get(mom, "Date") + days2 * isAdding);
  }
  if (milliseconds2) {
    mom._d.setTime(mom._d.valueOf() + milliseconds2 * isAdding);
  }
  if (updateOffset) {
    hooks.updateOffset(mom, days2 || months2);
  }
}
var add$2 = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
function isString(input) {
  return typeof input === "string" || input instanceof String;
}
function isMomentInput(input) {
  return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === void 0;
}
function isMomentInputObject(input) {
  var objectTest = isObject$3(input) && !isObjectEmpty(input), propertyTest = false, properties = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], i2, property;
  for (i2 = 0; i2 < properties.length; i2 += 1) {
    property = properties[i2];
    propertyTest = propertyTest || hasOwnProp(input, property);
  }
  return objectTest && propertyTest;
}
function isNumberOrStringArray(input) {
  var arrayTest = isArray$1(input), dataTypeTest = false;
  if (arrayTest) {
    dataTypeTest = input.filter(function(item) {
      return !isNumber(item) && isString(input);
    }).length === 0;
  }
  return arrayTest && dataTypeTest;
}
function isCalendarSpec(input) {
  var objectTest = isObject$3(input) && !isObjectEmpty(input), propertyTest = false, properties = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], i2, property;
  for (i2 = 0; i2 < properties.length; i2 += 1) {
    property = properties[i2];
    propertyTest = propertyTest || hasOwnProp(input, property);
  }
  return objectTest && propertyTest;
}
function getCalendarFormat(myMoment, now2) {
  var diff2 = myMoment.diff(now2, "days", true);
  return diff2 < -6 ? "sameElse" : diff2 < -1 ? "lastWeek" : diff2 < 0 ? "lastDay" : diff2 < 1 ? "sameDay" : diff2 < 2 ? "nextDay" : diff2 < 7 ? "nextWeek" : "sameElse";
}
function calendar$1(time, formats) {
  if (arguments.length === 1) {
    if (!arguments[0]) {
      time = void 0;
      formats = void 0;
    } else if (isMomentInput(arguments[0])) {
      time = arguments[0];
      formats = void 0;
    } else if (isCalendarSpec(arguments[0])) {
      formats = arguments[0];
      time = void 0;
    }
  }
  var now2 = time || createLocal(), sod = cloneWithOffset(now2, this).startOf("day"), format2 = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction$1(formats[format2]) ? formats[format2].call(this, now2) : formats[format2]);
  return this.format(output || this.localeData().calendar(format2, this, createLocal(now2)));
}
function clone() {
  return new Moment(this);
}
function isAfter(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input);
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() > localInput.valueOf();
  } else {
    return localInput.valueOf() < this.clone().startOf(units).valueOf();
  }
}
function isBefore(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input);
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() < localInput.valueOf();
  } else {
    return this.clone().endOf(units).valueOf() < localInput.valueOf();
  }
}
function isBetween(from5, to2, units, inclusivity) {
  var localFrom = isMoment(from5) ? from5 : createLocal(from5), localTo = isMoment(to2) ? to2 : createLocal(to2);
  if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
    return false;
  }
  inclusivity = inclusivity || "()";
  return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
}
function isSame(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input), inputMs;
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() === localInput.valueOf();
  } else {
    inputMs = localInput.valueOf();
    return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
  }
}
function isSameOrAfter(input, units) {
  return this.isSame(input, units) || this.isAfter(input, units);
}
function isSameOrBefore(input, units) {
  return this.isSame(input, units) || this.isBefore(input, units);
}
function diff(input, units, asFloat) {
  var that, zoneDelta, output;
  if (!this.isValid()) {
    return NaN;
  }
  that = cloneWithOffset(input, this);
  if (!that.isValid()) {
    return NaN;
  }
  zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
  units = normalizeUnits(units);
  switch (units) {
    case "year":
      output = monthDiff(this, that) / 12;
      break;
    case "month":
      output = monthDiff(this, that);
      break;
    case "quarter":
      output = monthDiff(this, that) / 3;
      break;
    case "second":
      output = (this - that) / 1e3;
      break;
    case "minute":
      output = (this - that) / 6e4;
      break;
    case "hour":
      output = (this - that) / 36e5;
      break;
    case "day":
      output = (this - that - zoneDelta) / 864e5;
      break;
    case "week":
      output = (this - that - zoneDelta) / 6048e5;
      break;
    default:
      output = this - that;
  }
  return asFloat ? output : absFloor(output);
}
function monthDiff(a, b) {
  if (a.date() < b.date()) {
    return -monthDiff(b, a);
  }
  var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
  if (b - anchor < 0) {
    anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
    adjust = (b - anchor) / (anchor - anchor2);
  } else {
    anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
    adjust = (b - anchor) / (anchor2 - anchor);
  }
  return -(wholeMonthDiff + adjust) || 0;
}
hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function toString$1() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function toISOString(keepOffset) {
  if (!this.isValid()) {
    return null;
  }
  var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
  if (m.year() < 0 || m.year() > 9999) {
    return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
  }
  if (isFunction$1(Date.prototype.toISOString)) {
    if (utc) {
      return this.toDate().toISOString();
    } else {
      return new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(m, "Z"));
    }
  }
  return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
}
function inspect() {
  if (!this.isValid()) {
    return "moment.invalid(/* " + this._i + " */)";
  }
  var func2 = "moment", zone = "", prefix2, year, datetime, suffix;
  if (!this.isLocal()) {
    func2 = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
    zone = "Z";
  }
  prefix2 = "[" + func2 + '("]';
  year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
  datetime = "-MM-DD[T]HH:mm:ss.SSS";
  suffix = zone + '[")]';
  return this.format(prefix2 + year + datetime + suffix);
}
function format(inputString) {
  if (!inputString) {
    inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
  }
  var output = formatMoment(this, inputString);
  return this.localeData().postformat(output);
}
function from(time, withoutSuffix) {
  if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
    return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
  } else {
    return this.localeData().invalidDate();
  }
}
function fromNow(withoutSuffix) {
  return this.from(createLocal(), withoutSuffix);
}
function to(time, withoutSuffix) {
  if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
    return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
  } else {
    return this.localeData().invalidDate();
  }
}
function toNow(withoutSuffix) {
  return this.to(createLocal(), withoutSuffix);
}
function locale(key) {
  var newLocaleData;
  if (key === void 0) {
    return this._locale._abbr;
  } else {
    newLocaleData = getLocale(key);
    if (newLocaleData != null) {
      this._locale = newLocaleData;
    }
    return this;
  }
}
var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
  if (key === void 0) {
    return this.localeData();
  } else {
    return this.locale(key);
  }
});
function localeData() {
  return this._locale;
}
var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
function mod$1(dividend, divisor) {
  return (dividend % divisor + divisor) % divisor;
}
function localStartOfDate(y, m, d) {
  if (y < 100 && y >= 0) {
    return new Date(y + 400, m, d) - MS_PER_400_YEARS;
  } else {
    return new Date(y, m, d).valueOf();
  }
}
function utcStartOfDate(y, m, d) {
  if (y < 100 && y >= 0) {
    return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
  } else {
    return Date.UTC(y, m, d);
  }
}
function startOf(units) {
  var time, startOfDate;
  units = normalizeUnits(units);
  if (units === void 0 || units === "millisecond" || !this.isValid()) {
    return this;
  }
  startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
  switch (units) {
    case "year":
      time = startOfDate(this.year(), 0, 1);
      break;
    case "quarter":
      time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
      break;
    case "month":
      time = startOfDate(this.year(), this.month(), 1);
      break;
    case "week":
      time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
      break;
    case "isoWeek":
      time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
      break;
    case "day":
    case "date":
      time = startOfDate(this.year(), this.month(), this.date());
      break;
    case "hour":
      time = this._d.valueOf();
      time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
      break;
    case "minute":
      time = this._d.valueOf();
      time -= mod$1(time, MS_PER_MINUTE);
      break;
    case "second":
      time = this._d.valueOf();
      time -= mod$1(time, MS_PER_SECOND);
      break;
  }
  this._d.setTime(time);
  hooks.updateOffset(this, true);
  return this;
}
function endOf(units) {
  var time, startOfDate;
  units = normalizeUnits(units);
  if (units === void 0 || units === "millisecond" || !this.isValid()) {
    return this;
  }
  startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
  switch (units) {
    case "year":
      time = startOfDate(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
      break;
    case "month":
      time = startOfDate(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
      break;
    case "isoWeek":
      time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
      break;
    case "day":
    case "date":
      time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      time = this._d.valueOf();
      time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
      break;
    case "minute":
      time = this._d.valueOf();
      time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
      break;
    case "second":
      time = this._d.valueOf();
      time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
      break;
  }
  this._d.setTime(time);
  hooks.updateOffset(this, true);
  return this;
}
function valueOf() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function unix() {
  return Math.floor(this.valueOf() / 1e3);
}
function toDate() {
  return new Date(this.valueOf());
}
function toArray() {
  var m = this;
  return [
    m.year(),
    m.month(),
    m.date(),
    m.hour(),
    m.minute(),
    m.second(),
    m.millisecond()
  ];
}
function toObject() {
  var m = this;
  return {
    years: m.year(),
    months: m.month(),
    date: m.date(),
    hours: m.hours(),
    minutes: m.minutes(),
    seconds: m.seconds(),
    milliseconds: m.milliseconds()
  };
}
function toJSON() {
  return this.isValid() ? this.toISOString() : null;
}
function isValid$2() {
  return isValid(this);
}
function parsingFlags() {
  return extend$3({}, getParsingFlags(this));
}
function invalidAt() {
  return getParsingFlags(this).overflow;
}
function creationData() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
addFormatToken("N", 0, 0, "eraAbbr");
addFormatToken("NN", 0, 0, "eraAbbr");
addFormatToken("NNN", 0, 0, "eraAbbr");
addFormatToken("NNNN", 0, 0, "eraName");
addFormatToken("NNNNN", 0, 0, "eraNarrow");
addFormatToken("y", ["y", 1], "yo", "eraYear");
addFormatToken("y", ["yy", 2], 0, "eraYear");
addFormatToken("y", ["yyy", 3], 0, "eraYear");
addFormatToken("y", ["yyyy", 4], 0, "eraYear");
addRegexToken("N", matchEraAbbr);
addRegexToken("NN", matchEraAbbr);
addRegexToken("NNN", matchEraAbbr);
addRegexToken("NNNN", matchEraName);
addRegexToken("NNNNN", matchEraNarrow);
addParseToken(["N", "NN", "NNN", "NNNN", "NNNNN"], function(input, array, config2, token2) {
  var era = config2._locale.erasParse(input, token2, config2._strict);
  if (era) {
    getParsingFlags(config2).era = era;
  } else {
    getParsingFlags(config2).invalidEra = input;
  }
});
addRegexToken("y", matchUnsigned);
addRegexToken("yy", matchUnsigned);
addRegexToken("yyy", matchUnsigned);
addRegexToken("yyyy", matchUnsigned);
addRegexToken("yo", matchEraYearOrdinal);
addParseToken(["y", "yy", "yyy", "yyyy"], YEAR);
addParseToken(["yo"], function(input, array, config2, token2) {
  var match;
  if (config2._locale._eraYearOrdinalRegex) {
    match = input.match(config2._locale._eraYearOrdinalRegex);
  }
  if (config2._locale.eraYearOrdinalParse) {
    array[YEAR] = config2._locale.eraYearOrdinalParse(input, match);
  } else {
    array[YEAR] = parseInt(input, 10);
  }
});
function localeEras(m, format2) {
  var i2, l, date2, eras = this._eras || getLocale("en")._eras;
  for (i2 = 0, l = eras.length; i2 < l; ++i2) {
    switch (typeof eras[i2].since) {
      case "string":
        date2 = hooks(eras[i2].since).startOf("day");
        eras[i2].since = date2.valueOf();
        break;
    }
    switch (typeof eras[i2].until) {
      case "undefined":
        eras[i2].until = Infinity;
        break;
      case "string":
        date2 = hooks(eras[i2].until).startOf("day").valueOf();
        eras[i2].until = date2.valueOf();
        break;
    }
  }
  return eras;
}
function localeErasParse(eraName, format2, strict) {
  var i2, l, eras = this.eras(), name, abbr, narrow;
  eraName = eraName.toUpperCase();
  for (i2 = 0, l = eras.length; i2 < l; ++i2) {
    name = eras[i2].name.toUpperCase();
    abbr = eras[i2].abbr.toUpperCase();
    narrow = eras[i2].narrow.toUpperCase();
    if (strict) {
      switch (format2) {
        case "N":
        case "NN":
        case "NNN":
          if (abbr === eraName) {
            return eras[i2];
          }
          break;
        case "NNNN":
          if (name === eraName) {
            return eras[i2];
          }
          break;
        case "NNNNN":
          if (narrow === eraName) {
            return eras[i2];
          }
          break;
      }
    } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
      return eras[i2];
    }
  }
}
function localeErasConvertYear(era, year) {
  var dir = era.since <= era.until ? 1 : -1;
  if (year === void 0) {
    return hooks(era.since).year();
  } else {
    return hooks(era.since).year() + (year - era.offset) * dir;
  }
}
function getEraName() {
  var i2, l, val, eras = this.localeData().eras();
  for (i2 = 0, l = eras.length; i2 < l; ++i2) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i2].since <= val && val <= eras[i2].until) {
      return eras[i2].name;
    }
    if (eras[i2].until <= val && val <= eras[i2].since) {
      return eras[i2].name;
    }
  }
  return "";
}
function getEraNarrow() {
  var i2, l, val, eras = this.localeData().eras();
  for (i2 = 0, l = eras.length; i2 < l; ++i2) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i2].since <= val && val <= eras[i2].until) {
      return eras[i2].narrow;
    }
    if (eras[i2].until <= val && val <= eras[i2].since) {
      return eras[i2].narrow;
    }
  }
  return "";
}
function getEraAbbr() {
  var i2, l, val, eras = this.localeData().eras();
  for (i2 = 0, l = eras.length; i2 < l; ++i2) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i2].since <= val && val <= eras[i2].until) {
      return eras[i2].abbr;
    }
    if (eras[i2].until <= val && val <= eras[i2].since) {
      return eras[i2].abbr;
    }
  }
  return "";
}
function getEraYear() {
  var i2, l, dir, val, eras = this.localeData().eras();
  for (i2 = 0, l = eras.length; i2 < l; ++i2) {
    dir = eras[i2].since <= eras[i2].until ? 1 : -1;
    val = this.clone().startOf("day").valueOf();
    if (eras[i2].since <= val && val <= eras[i2].until || eras[i2].until <= val && val <= eras[i2].since) {
      return (this.year() - hooks(eras[i2].since).year()) * dir + eras[i2].offset;
    }
  }
  return this.year();
}
function erasNameRegex(isStrict) {
  if (!hasOwnProp(this, "_erasNameRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasNameRegex : this._erasRegex;
}
function erasAbbrRegex(isStrict) {
  if (!hasOwnProp(this, "_erasAbbrRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasAbbrRegex : this._erasRegex;
}
function erasNarrowRegex(isStrict) {
  if (!hasOwnProp(this, "_erasNarrowRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasNarrowRegex : this._erasRegex;
}
function matchEraAbbr(isStrict, locale2) {
  return locale2.erasAbbrRegex(isStrict);
}
function matchEraName(isStrict, locale2) {
  return locale2.erasNameRegex(isStrict);
}
function matchEraNarrow(isStrict, locale2) {
  return locale2.erasNarrowRegex(isStrict);
}
function matchEraYearOrdinal(isStrict, locale2) {
  return locale2._eraYearOrdinalRegex || matchUnsigned;
}
function computeErasParse() {
  var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i2, l, eras = this.eras();
  for (i2 = 0, l = eras.length; i2 < l; ++i2) {
    namePieces.push(regexEscape(eras[i2].name));
    abbrPieces.push(regexEscape(eras[i2].abbr));
    narrowPieces.push(regexEscape(eras[i2].narrow));
    mixedPieces.push(regexEscape(eras[i2].name));
    mixedPieces.push(regexEscape(eras[i2].abbr));
    mixedPieces.push(regexEscape(eras[i2].narrow));
  }
  this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
  this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
  this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
}
addFormatToken(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
addFormatToken(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function addWeekYearFormatToken(token2, getter) {
  addFormatToken(0, [token2, token2.length], 0, getter);
}
addWeekYearFormatToken("gggg", "weekYear");
addWeekYearFormatToken("ggggg", "weekYear");
addWeekYearFormatToken("GGGG", "isoWeekYear");
addWeekYearFormatToken("GGGGG", "isoWeekYear");
addUnitAlias("weekYear", "gg");
addUnitAlias("isoWeekYear", "GG");
addUnitPriority("weekYear", 1);
addUnitPriority("isoWeekYear", 1);
addRegexToken("G", matchSigned);
addRegexToken("g", matchSigned);
addRegexToken("GG", match1to2, match2);
addRegexToken("gg", match1to2, match2);
addRegexToken("GGGG", match1to4, match4);
addRegexToken("gggg", match1to4, match4);
addRegexToken("GGGGG", match1to6, match6);
addRegexToken("ggggg", match1to6, match6);
addWeekParseToken(["gggg", "ggggg", "GGGG", "GGGGG"], function(input, week, config2, token2) {
  week[token2.substr(0, 2)] = toInt(input);
});
addWeekParseToken(["gg", "GG"], function(input, week, config2, token2) {
  week[token2] = hooks.parseTwoDigitYear(input);
});
function getSetWeekYear(input) {
  return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
}
function getSetISOWeekYear(input) {
  return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
}
function getISOWeeksInYear() {
  return weeksInYear(this.year(), 1, 4);
}
function getISOWeeksInISOWeekYear() {
  return weeksInYear(this.isoWeekYear(), 1, 4);
}
function getWeeksInYear() {
  var weekInfo = this.localeData()._week;
  return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}
function getWeeksInWeekYear() {
  var weekInfo = this.localeData()._week;
  return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
}
function getSetWeekYearHelper(input, week, weekday, dow, doy) {
  var weeksTarget;
  if (input == null) {
    return weekOfYear(this, dow, doy).year;
  } else {
    weeksTarget = weeksInYear(input, dow, doy);
    if (week > weeksTarget) {
      week = weeksTarget;
    }
    return setWeekAll.call(this, input, week, weekday, dow, doy);
  }
}
function setWeekAll(weekYear, week, weekday, dow, doy) {
  var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date2 = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
  this.year(date2.getUTCFullYear());
  this.month(date2.getUTCMonth());
  this.date(date2.getUTCDate());
  return this;
}
addFormatToken("Q", 0, "Qo", "quarter");
addUnitAlias("quarter", "Q");
addUnitPriority("quarter", 7);
addRegexToken("Q", match1);
addParseToken("Q", function(input, array) {
  array[MONTH] = (toInt(input) - 1) * 3;
});
function getSetQuarter(input) {
  return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}
addFormatToken("D", ["DD", 2], "Do", "date");
addUnitAlias("date", "D");
addUnitPriority("date", 9);
addRegexToken("D", match1to2);
addRegexToken("DD", match1to2, match2);
addRegexToken("Do", function(isStrict, locale2) {
  return isStrict ? locale2._dayOfMonthOrdinalParse || locale2._ordinalParse : locale2._dayOfMonthOrdinalParseLenient;
});
addParseToken(["D", "DD"], DATE);
addParseToken("Do", function(input, array) {
  array[DATE] = toInt(input.match(match1to2)[0]);
});
var getSetDayOfMonth = makeGetSet("Date", true);
addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
addUnitAlias("dayOfYear", "DDD");
addUnitPriority("dayOfYear", 4);
addRegexToken("DDD", match1to3);
addRegexToken("DDDD", match3);
addParseToken(["DDD", "DDDD"], function(input, array, config2) {
  config2._dayOfYear = toInt(input);
});
function getSetDayOfYear(input) {
  var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
  return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
}
addFormatToken("m", ["mm", 2], 0, "minute");
addUnitAlias("minute", "m");
addUnitPriority("minute", 14);
addRegexToken("m", match1to2);
addRegexToken("mm", match1to2, match2);
addParseToken(["m", "mm"], MINUTE);
var getSetMinute = makeGetSet("Minutes", false);
addFormatToken("s", ["ss", 2], 0, "second");
addUnitAlias("second", "s");
addUnitPriority("second", 15);
addRegexToken("s", match1to2);
addRegexToken("ss", match1to2, match2);
addParseToken(["s", "ss"], SECOND);
var getSetSecond = makeGetSet("Seconds", false);
addFormatToken("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
addFormatToken(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
addFormatToken(0, ["SSS", 3], 0, "millisecond");
addFormatToken(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
addFormatToken(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
addFormatToken(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
addFormatToken(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
addUnitAlias("millisecond", "ms");
addUnitPriority("millisecond", 16);
addRegexToken("S", match1to3, match1);
addRegexToken("SS", match1to3, match2);
addRegexToken("SSS", match1to3, match3);
var token, getSetMillisecond;
for (token = "SSSS"; token.length <= 9; token += "S") {
  addRegexToken(token, matchUnsigned);
}
function parseMs(input, array) {
  array[MILLISECOND] = toInt(("0." + input) * 1e3);
}
for (token = "S"; token.length <= 9; token += "S") {
  addParseToken(token, parseMs);
}
getSetMillisecond = makeGetSet("Milliseconds", false);
addFormatToken("z", 0, 0, "zoneAbbr");
addFormatToken("zz", 0, 0, "zoneName");
function getZoneAbbr() {
  return this._isUTC ? "UTC" : "";
}
function getZoneName() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var proto$1 = Moment.prototype;
proto$1.add = add$2;
proto$1.calendar = calendar$1;
proto$1.clone = clone;
proto$1.diff = diff;
proto$1.endOf = endOf;
proto$1.format = format;
proto$1.from = from;
proto$1.fromNow = fromNow;
proto$1.to = to;
proto$1.toNow = toNow;
proto$1.get = stringGet;
proto$1.invalidAt = invalidAt;
proto$1.isAfter = isAfter;
proto$1.isBefore = isBefore;
proto$1.isBetween = isBetween;
proto$1.isSame = isSame;
proto$1.isSameOrAfter = isSameOrAfter;
proto$1.isSameOrBefore = isSameOrBefore;
proto$1.isValid = isValid$2;
proto$1.lang = lang;
proto$1.locale = locale;
proto$1.localeData = localeData;
proto$1.max = prototypeMax;
proto$1.min = prototypeMin;
proto$1.parsingFlags = parsingFlags;
proto$1.set = stringSet;
proto$1.startOf = startOf;
proto$1.subtract = subtract;
proto$1.toArray = toArray;
proto$1.toObject = toObject;
proto$1.toDate = toDate;
proto$1.toISOString = toISOString;
proto$1.inspect = inspect;
if (typeof Symbol !== "undefined" && Symbol.for != null) {
  proto$1[Symbol.for("nodejs.util.inspect.custom")] = function() {
    return "Moment<" + this.format() + ">";
  };
}
proto$1.toJSON = toJSON;
proto$1.toString = toString$1;
proto$1.unix = unix;
proto$1.valueOf = valueOf;
proto$1.creationData = creationData;
proto$1.eraName = getEraName;
proto$1.eraNarrow = getEraNarrow;
proto$1.eraAbbr = getEraAbbr;
proto$1.eraYear = getEraYear;
proto$1.year = getSetYear;
proto$1.isLeapYear = getIsLeapYear;
proto$1.weekYear = getSetWeekYear;
proto$1.isoWeekYear = getSetISOWeekYear;
proto$1.quarter = proto$1.quarters = getSetQuarter;
proto$1.month = getSetMonth;
proto$1.daysInMonth = getDaysInMonth;
proto$1.week = proto$1.weeks = getSetWeek;
proto$1.isoWeek = proto$1.isoWeeks = getSetISOWeek;
proto$1.weeksInYear = getWeeksInYear;
proto$1.weeksInWeekYear = getWeeksInWeekYear;
proto$1.isoWeeksInYear = getISOWeeksInYear;
proto$1.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
proto$1.date = getSetDayOfMonth;
proto$1.day = proto$1.days = getSetDayOfWeek;
proto$1.weekday = getSetLocaleDayOfWeek;
proto$1.isoWeekday = getSetISODayOfWeek;
proto$1.dayOfYear = getSetDayOfYear;
proto$1.hour = proto$1.hours = getSetHour;
proto$1.minute = proto$1.minutes = getSetMinute;
proto$1.second = proto$1.seconds = getSetSecond;
proto$1.millisecond = proto$1.milliseconds = getSetMillisecond;
proto$1.utcOffset = getSetOffset;
proto$1.utc = setOffsetToUTC;
proto$1.local = setOffsetToLocal;
proto$1.parseZone = setOffsetToParsedOffset;
proto$1.hasAlignedHourOffset = hasAlignedHourOffset;
proto$1.isDST = isDaylightSavingTime;
proto$1.isLocal = isLocal;
proto$1.isUtcOffset = isUtcOffset;
proto$1.isUtc = isUtc;
proto$1.isUTC = isUtc;
proto$1.zoneAbbr = getZoneAbbr;
proto$1.zoneName = getZoneName;
proto$1.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
proto$1.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
proto$1.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
proto$1.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
proto$1.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
function createUnix(input) {
  return createLocal(input * 1e3);
}
function createInZone() {
  return createLocal.apply(null, arguments).parseZone();
}
function preParsePostFormat(string2) {
  return string2;
}
var proto$1$1 = Locale.prototype;
proto$1$1.calendar = calendar;
proto$1$1.longDateFormat = longDateFormat;
proto$1$1.invalidDate = invalidDate;
proto$1$1.ordinal = ordinal;
proto$1$1.preparse = preParsePostFormat;
proto$1$1.postformat = preParsePostFormat;
proto$1$1.relativeTime = relativeTime;
proto$1$1.pastFuture = pastFuture;
proto$1$1.set = set;
proto$1$1.eras = localeEras;
proto$1$1.erasParse = localeErasParse;
proto$1$1.erasConvertYear = localeErasConvertYear;
proto$1$1.erasAbbrRegex = erasAbbrRegex;
proto$1$1.erasNameRegex = erasNameRegex;
proto$1$1.erasNarrowRegex = erasNarrowRegex;
proto$1$1.months = localeMonths;
proto$1$1.monthsShort = localeMonthsShort;
proto$1$1.monthsParse = localeMonthsParse;
proto$1$1.monthsRegex = monthsRegex;
proto$1$1.monthsShortRegex = monthsShortRegex;
proto$1$1.week = localeWeek;
proto$1$1.firstDayOfYear = localeFirstDayOfYear;
proto$1$1.firstDayOfWeek = localeFirstDayOfWeek;
proto$1$1.weekdays = localeWeekdays;
proto$1$1.weekdaysMin = localeWeekdaysMin;
proto$1$1.weekdaysShort = localeWeekdaysShort;
proto$1$1.weekdaysParse = localeWeekdaysParse;
proto$1$1.weekdaysRegex = weekdaysRegex;
proto$1$1.weekdaysShortRegex = weekdaysShortRegex;
proto$1$1.weekdaysMinRegex = weekdaysMinRegex;
proto$1$1.isPM = localeIsPM;
proto$1$1.meridiem = localeMeridiem;
function get$1(format2, index3, field, setter) {
  var locale2 = getLocale(), utc = createUTC().set(setter, index3);
  return locale2[field](utc, format2);
}
function listMonthsImpl(format2, index3, field) {
  if (isNumber(format2)) {
    index3 = format2;
    format2 = void 0;
  }
  format2 = format2 || "";
  if (index3 != null) {
    return get$1(format2, index3, field, "month");
  }
  var i2, out = [];
  for (i2 = 0; i2 < 12; i2++) {
    out[i2] = get$1(format2, i2, field, "month");
  }
  return out;
}
function listWeekdaysImpl(localeSorted, format2, index3, field) {
  if (typeof localeSorted === "boolean") {
    if (isNumber(format2)) {
      index3 = format2;
      format2 = void 0;
    }
    format2 = format2 || "";
  } else {
    format2 = localeSorted;
    index3 = format2;
    localeSorted = false;
    if (isNumber(format2)) {
      index3 = format2;
      format2 = void 0;
    }
    format2 = format2 || "";
  }
  var locale2 = getLocale(), shift2 = localeSorted ? locale2._week.dow : 0, i2, out = [];
  if (index3 != null) {
    return get$1(format2, (index3 + shift2) % 7, field, "day");
  }
  for (i2 = 0; i2 < 7; i2++) {
    out[i2] = get$1(format2, (i2 + shift2) % 7, field, "day");
  }
  return out;
}
function listMonths(format2, index3) {
  return listMonthsImpl(format2, index3, "months");
}
function listMonthsShort(format2, index3) {
  return listMonthsImpl(format2, index3, "monthsShort");
}
function listWeekdays(localeSorted, format2, index3) {
  return listWeekdaysImpl(localeSorted, format2, index3, "weekdays");
}
function listWeekdaysShort(localeSorted, format2, index3) {
  return listWeekdaysImpl(localeSorted, format2, index3, "weekdaysShort");
}
function listWeekdaysMin(localeSorted, format2, index3) {
  return listWeekdaysImpl(localeSorted, format2, index3, "weekdaysMin");
}
getSetGlobalLocale("en", {
  eras: [
    {
      since: "0001-01-01",
      until: Infinity,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -Infinity,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(number2) {
    var b = number2 % 10, output = toInt(number2 % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
    return number2 + output;
  }
});
hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
var mathAbs = Math.abs;
function abs() {
  var data = this._data;
  this._milliseconds = mathAbs(this._milliseconds);
  this._days = mathAbs(this._days);
  this._months = mathAbs(this._months);
  data.milliseconds = mathAbs(data.milliseconds);
  data.seconds = mathAbs(data.seconds);
  data.minutes = mathAbs(data.minutes);
  data.hours = mathAbs(data.hours);
  data.months = mathAbs(data.months);
  data.years = mathAbs(data.years);
  return this;
}
function addSubtract$1(duration, input, value, direction) {
  var other = createDuration(input, value);
  duration._milliseconds += direction * other._milliseconds;
  duration._days += direction * other._days;
  duration._months += direction * other._months;
  return duration._bubble();
}
function add$1$1(input, value) {
  return addSubtract$1(this, input, value, 1);
}
function subtract$1(input, value) {
  return addSubtract$1(this, input, value, -1);
}
function absCeil(number2) {
  if (number2 < 0) {
    return Math.floor(number2);
  } else {
    return Math.ceil(number2);
  }
}
function bubble() {
  var milliseconds2 = this._milliseconds, days2 = this._days, months2 = this._months, data = this._data, seconds2, minutes2, hours2, years2, monthsFromDays;
  if (!(milliseconds2 >= 0 && days2 >= 0 && months2 >= 0 || milliseconds2 <= 0 && days2 <= 0 && months2 <= 0)) {
    milliseconds2 += absCeil(monthsToDays(months2) + days2) * 864e5;
    days2 = 0;
    months2 = 0;
  }
  data.milliseconds = milliseconds2 % 1e3;
  seconds2 = absFloor(milliseconds2 / 1e3);
  data.seconds = seconds2 % 60;
  minutes2 = absFloor(seconds2 / 60);
  data.minutes = minutes2 % 60;
  hours2 = absFloor(minutes2 / 60);
  data.hours = hours2 % 24;
  days2 += absFloor(hours2 / 24);
  monthsFromDays = absFloor(daysToMonths(days2));
  months2 += monthsFromDays;
  days2 -= absCeil(monthsToDays(monthsFromDays));
  years2 = absFloor(months2 / 12);
  months2 %= 12;
  data.days = days2;
  data.months = months2;
  data.years = years2;
  return this;
}
function daysToMonths(days2) {
  return days2 * 4800 / 146097;
}
function monthsToDays(months2) {
  return months2 * 146097 / 4800;
}
function as(units) {
  if (!this.isValid()) {
    return NaN;
  }
  var days2, months2, milliseconds2 = this._milliseconds;
  units = normalizeUnits(units);
  if (units === "month" || units === "quarter" || units === "year") {
    days2 = this._days + milliseconds2 / 864e5;
    months2 = this._months + daysToMonths(days2);
    switch (units) {
      case "month":
        return months2;
      case "quarter":
        return months2 / 3;
      case "year":
        return months2 / 12;
    }
  } else {
    days2 = this._days + Math.round(monthsToDays(this._months));
    switch (units) {
      case "week":
        return days2 / 7 + milliseconds2 / 6048e5;
      case "day":
        return days2 + milliseconds2 / 864e5;
      case "hour":
        return days2 * 24 + milliseconds2 / 36e5;
      case "minute":
        return days2 * 1440 + milliseconds2 / 6e4;
      case "second":
        return days2 * 86400 + milliseconds2 / 1e3;
      case "millisecond":
        return Math.floor(days2 * 864e5) + milliseconds2;
      default:
        throw new Error("Unknown unit " + units);
    }
  }
}
function valueOf$1() {
  if (!this.isValid()) {
    return NaN;
  }
  return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
}
function makeAs(alias) {
  return function() {
    return this.as(alias);
  };
}
var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
function clone$1() {
  return createDuration(this);
}
function get$2(units) {
  units = normalizeUnits(units);
  return this.isValid() ? this[units + "s"]() : NaN;
}
function makeGetter(name) {
  return function() {
    return this.isValid() ? this._data[name] : NaN;
  };
}
var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
function weeks() {
  return absFloor(this.days() / 7);
}
var round = Math.round, thresholds = {
  ss: 44,
  s: 45,
  m: 45,
  h: 22,
  d: 26,
  w: null,
  M: 11
};
function substituteTimeAgo(string2, number2, withoutSuffix, isFuture, locale2) {
  return locale2.relativeTime(number2 || 1, !!withoutSuffix, string2, isFuture);
}
function relativeTime$1(posNegDuration, withoutSuffix, thresholds2, locale2) {
  var duration = createDuration(posNegDuration).abs(), seconds2 = round(duration.as("s")), minutes2 = round(duration.as("m")), hours2 = round(duration.as("h")), days2 = round(duration.as("d")), months2 = round(duration.as("M")), weeks2 = round(duration.as("w")), years2 = round(duration.as("y")), a = seconds2 <= thresholds2.ss && ["s", seconds2] || seconds2 < thresholds2.s && ["ss", seconds2] || minutes2 <= 1 && ["m"] || minutes2 < thresholds2.m && ["mm", minutes2] || hours2 <= 1 && ["h"] || hours2 < thresholds2.h && ["hh", hours2] || days2 <= 1 && ["d"] || days2 < thresholds2.d && ["dd", days2];
  if (thresholds2.w != null) {
    a = a || weeks2 <= 1 && ["w"] || weeks2 < thresholds2.w && ["ww", weeks2];
  }
  a = a || months2 <= 1 && ["M"] || months2 < thresholds2.M && ["MM", months2] || years2 <= 1 && ["y"] || ["yy", years2];
  a[2] = withoutSuffix;
  a[3] = +posNegDuration > 0;
  a[4] = locale2;
  return substituteTimeAgo.apply(null, a);
}
function getSetRelativeTimeRounding(roundingFunction) {
  if (roundingFunction === void 0) {
    return round;
  }
  if (typeof roundingFunction === "function") {
    round = roundingFunction;
    return true;
  }
  return false;
}
function getSetRelativeTimeThreshold(threshold, limit) {
  if (thresholds[threshold] === void 0) {
    return false;
  }
  if (limit === void 0) {
    return thresholds[threshold];
  }
  thresholds[threshold] = limit;
  if (threshold === "s") {
    thresholds.ss = limit - 1;
  }
  return true;
}
function humanize(argWithSuffix, argThresholds) {
  if (!this.isValid()) {
    return this.localeData().invalidDate();
  }
  var withSuffix = false, th = thresholds, locale2, output;
  if (typeof argWithSuffix === "object") {
    argThresholds = argWithSuffix;
    argWithSuffix = false;
  }
  if (typeof argWithSuffix === "boolean") {
    withSuffix = argWithSuffix;
  }
  if (typeof argThresholds === "object") {
    th = Object.assign({}, thresholds, argThresholds);
    if (argThresholds.s != null && argThresholds.ss == null) {
      th.ss = argThresholds.s - 1;
    }
  }
  locale2 = this.localeData();
  output = relativeTime$1(this, !withSuffix, th, locale2);
  if (withSuffix) {
    output = locale2.pastFuture(+this, output);
  }
  return locale2.postformat(output);
}
var abs$1 = Math.abs;
function sign(x2) {
  return (x2 > 0) - (x2 < 0) || +x2;
}
function toISOString$1() {
  if (!this.isValid()) {
    return this.localeData().invalidDate();
  }
  var seconds2 = abs$1(this._milliseconds) / 1e3, days2 = abs$1(this._days), months2 = abs$1(this._months), minutes2, hours2, years2, s2, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
  if (!total) {
    return "P0D";
  }
  minutes2 = absFloor(seconds2 / 60);
  hours2 = absFloor(minutes2 / 60);
  seconds2 %= 60;
  minutes2 %= 60;
  years2 = absFloor(months2 / 12);
  months2 %= 12;
  s2 = seconds2 ? seconds2.toFixed(3).replace(/\.?0+$/, "") : "";
  totalSign = total < 0 ? "-" : "";
  ymSign = sign(this._months) !== sign(total) ? "-" : "";
  daysSign = sign(this._days) !== sign(total) ? "-" : "";
  hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
  return totalSign + "P" + (years2 ? ymSign + years2 + "Y" : "") + (months2 ? ymSign + months2 + "M" : "") + (days2 ? daysSign + days2 + "D" : "") + (hours2 || minutes2 || seconds2 ? "T" : "") + (hours2 ? hmsSign + hours2 + "H" : "") + (minutes2 ? hmsSign + minutes2 + "M" : "") + (seconds2 ? hmsSign + s2 + "S" : "");
}
var proto$2 = Duration.prototype;
proto$2.isValid = isValid$1;
proto$2.abs = abs;
proto$2.add = add$1$1;
proto$2.subtract = subtract$1;
proto$2.as = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds = asSeconds;
proto$2.asMinutes = asMinutes;
proto$2.asHours = asHours;
proto$2.asDays = asDays;
proto$2.asWeeks = asWeeks;
proto$2.asMonths = asMonths;
proto$2.asQuarters = asQuarters;
proto$2.asYears = asYears;
proto$2.valueOf = valueOf$1;
proto$2._bubble = bubble;
proto$2.clone = clone$1;
proto$2.get = get$2;
proto$2.milliseconds = milliseconds;
proto$2.seconds = seconds;
proto$2.minutes = minutes;
proto$2.hours = hours;
proto$2.days = days;
proto$2.weeks = weeks;
proto$2.months = months;
proto$2.years = years;
proto$2.humanize = humanize;
proto$2.toISOString = toISOString$1;
proto$2.toString = toISOString$1;
proto$2.toJSON = toISOString$1;
proto$2.locale = locale;
proto$2.localeData = localeData;
proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
proto$2.lang = lang;
addFormatToken("X", 0, 0, "unix");
addFormatToken("x", 0, 0, "valueOf");
addRegexToken("x", matchSigned);
addRegexToken("X", matchTimestamp);
addParseToken("X", function(input, array, config2) {
  config2._d = new Date(parseFloat(input) * 1e3);
});
addParseToken("x", function(input, array, config2) {
  config2._d = new Date(toInt(input));
});
//! moment.js
hooks.version = "2.29.1";
setHookCallback(createLocal);
hooks.fn = proto$1;
hooks.min = min;
hooks.max = max;
hooks.now = now$1;
hooks.utc = createUTC;
hooks.unix = createUnix;
hooks.months = listMonths;
hooks.isDate = isDate;
hooks.locale = getSetGlobalLocale;
hooks.invalid = createInvalid;
hooks.duration = createDuration;
hooks.isMoment = isMoment;
hooks.weekdays = listWeekdays;
hooks.parseZone = createInZone;
hooks.localeData = getLocale;
hooks.isDuration = isDuration;
hooks.monthsShort = listMonthsShort;
hooks.weekdaysMin = listWeekdaysMin;
hooks.defineLocale = defineLocale;
hooks.updateLocale = updateLocale;
hooks.locales = listLocales;
hooks.weekdaysShort = listWeekdaysShort;
hooks.normalizeUnits = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat = getCalendarFormat;
hooks.prototype = proto$1;
hooks.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  DATE: "YYYY-MM-DD",
  TIME: "HH:mm",
  TIME_SECONDS: "HH:mm:ss",
  TIME_MS: "HH:mm:ss.SSS",
  WEEK: "GGGG-[W]WW",
  MONTH: "YYYY-MM"
};
const _sfc_main$p = defineComponent({
  props: {
    modelValue: null,
    allowNull: { type: Boolean, default: true },
    renderFormat: { type: String, default() {
      return "Y-MM-DD";
    } },
    displayFormat: {
      type: Array || String,
      default() {
        return [
          "DD/MM/Y",
          "DD/MM",
          "DDMMY",
          "DDMM",
          "Y-MM-DD"
        ];
      }
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit: emit2 }) {
    const textInput = ref(null);
    const isValid2 = computed(() => {
      if (props.allowNull && !localValue.value) {
        return true;
      }
      return !!parsedValue.value;
    });
    computed(() => {
      let k = ["font-mono block w-36 text-center border rounded p-1 focus:outline-none focus:ring focus:ring-brand focus:ring-opacity-50"];
      if (!isValid2.value) {
        k.push(" bg-danger-light");
      }
      k.push("border-gray-300", "focus:border-brand", "focus:ring", "focus:ring-offset-0", "focus:ring-brand", "focus:ring-opacity-50");
      return k;
    });
    const localValue = ref(props.modelValue);
    watch(() => props.modelValue, (nv, ov) => {
      let v2 = parse3(nv, [props.renderFormat]);
      if (v2) {
        v2 = formatValue(v2);
        if (v2 != localValue.value) {
          localValue.value = v2;
        }
      } else {
        localValue.value = nv;
      }
    });
    const parseValue = (value) => {
      let formats = props.displayFormat.toString() === props.displayFormat ? [props.displayFormat] : props.displayFormat;
      return parse3(value, formats);
    };
    const parse3 = (value, formats) => {
      if (!value) {
        return null;
      }
      for (let i2 = 0; i2 < formats.length; i2++) {
        const m = hooks(value, formats[i2], true);
        if (m.isValid()) {
          return m;
        }
      }
      return false;
    };
    const parsedValue = computed(() => {
      return parseValue(localValue.value);
    });
    const formatValue = (value) => {
      const format2 = props.displayFormat.toString() === props.displayFormat ? props.displayFormat : props.displayFormat[0];
      return value.format(format2);
    };
    const handleBlur = () => {
      if (isValid2.value) {
        emit2("update:modelValue", parsedValue.value ? parsedValue.value.format(props.renderFormat) : parsedValue.value);
      }
    };
    const stepCurrentDatePart = (step2, defaultPart) => {
      var _a;
      if (isValid2.value && parsedValue.value) {
        const inputElement = (_a = textInput.value) == null ? void 0 : _a.$refs.inputElement;
        let s2 = inputElement.selectionStart || -1;
        let e = inputElement.selectionEnd || -1;
        let fs = inputElement.value.indexOf("/");
        let ls = inputElement.value.lastIndexOf("/");
        const m = parsedValue.value.clone();
        if (defaultPart || s2 <= fs && e <= fs) {
          m.add(step2, "days");
          emit2("update:modelValue", m.format(props.renderFormat));
          nextTick(() => {
            inputElement.setSelectionRange(0, fs);
          });
        } else if (s2 <= ls && e <= ls) {
          m.add(step2, "months");
          emit2("update:modelValue", m.format(props.renderFormat));
          nextTick(() => {
            inputElement.setSelectionRange(fs + 1, ls);
          });
        } else {
          m.add(step2, "years");
          emit2("update:modelValue", m.format(props.renderFormat));
          nextTick(() => {
            inputElement.setSelectionRange(ls + 1, inputElement.value.length);
          });
        }
      }
    };
    onMounted(() => {
      var _a;
      (_a = textInput.value) == null ? void 0 : _a.$refs.inputElement.addEventListener("keydown", (e) => {
        if (e.code == "ArrowUp") {
          e.preventDefault();
          stepCurrentDatePart(1);
          return false;
        } else if (e.code == "ArrowDown") {
          e.preventDefault();
          stepCurrentDatePart(-1);
          return false;
        }
      });
    });
    return {
      textInput,
      localValue,
      handleBlur,
      stepCurrentDatePart
    };
  }
});
function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_STextInput = resolveComponent("STextInput");
  return openBlock(), createBlock(_component_STextInput, {
    icon: _ctx.modelValue ? "minus" : null,
    endIcon: _ctx.modelValue ? "plus" : "",
    "onClick:icon": _cache[0] || (_cache[0] = ($event) => _ctx.stepCurrentDatePart(-1, true)),
    "onClick:endIcon": _cache[1] || (_cache[1] = ($event) => _ctx.stepCurrentDatePart(1, true)),
    ref: "textInput",
    class: "w-40",
    inputClass: "text-center",
    modelValue: _ctx.localValue,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.localValue = $event),
    onBlur: _ctx.handleBlur,
    onKeydown: withKeys(_ctx.handleBlur, ["enter"])
  }, null, 8, ["icon", "endIcon", "modelValue", "onBlur", "onKeydown"]);
}
var SDateInput = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render$p]]);
const _sfc_main$o = defineComponent({
  props: {
    modelValue: null,
    seconds: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(props, { emit: emit2 }) {
    const el = ref(null);
    const cls = computed(() => {
      let k = "font-mono w-24 text-center block border rounded p-1 focus:outline-none focus:ring focus:ring-brand focus:ring-opacity-50";
      const m = hooks.utc(props.modelValue, format2.value, true);
      if (!m.isValid()) {
        k += " bg-red-50";
      }
      return k;
    });
    const format2 = ref(props.seconds ? "HH:mm:ss" : "HH:mm");
    const localValue = computed({
      get: () => {
        const m = hooks.utc(props.modelValue, format2.value, true);
        if (m.isValid()) {
          return m.format(format2.value);
        }
        return props.modelValue;
      },
      set: (v2) => {
        const m = hooks.utc(v2, format2.value, true);
        if (m.isValid()) {
          emit2("update:modelValue", m.format(format2.value));
        } else {
          emit2("update:modelValue", v2);
        }
      }
    });
    const stepCurrentDatePart = (step2) => {
      if (el.value) {
        const inputElement = el.value;
        let s2 = inputElement.selectionStart || -1;
        let e = inputElement.selectionEnd || -1;
        let fs = inputElement.value.indexOf(":");
        let ls = inputElement.value.lastIndexOf(":");
        if (s2 <= fs && e <= fs) {
          const m = hooks.utc(props.modelValue, format2.value, true);
          if (m.isValid()) {
            m.add(step2, "hours");
            emit2("update:modelValue", m.format(format2.value));
            nextTick(() => {
              inputElement.setSelectionRange(0, fs);
            });
          }
        } else if (!props.seconds || s2 <= ls && e <= ls) {
          const m = hooks.utc(props.modelValue, format2.value, true);
          if (m.isValid()) {
            m.add(step2, "minutes");
            emit2("update:modelValue", m.format(format2.value));
            nextTick(() => {
              inputElement.setSelectionRange(fs + 1, props.seconds ? ls : inputElement.value.length);
            });
          }
        } else {
          const m = hooks.utc(props.modelValue, format2.value, true);
          if (m.isValid()) {
            m.add(step2, "seconds");
            emit2("update:modelValue", m.format(format2.value));
            nextTick(() => {
              inputElement.setSelectionRange(ls + 1, inputElement.value.length);
            });
          }
        }
      }
    };
    onMounted(() => {
      var _a;
      (_a = el.value) == null ? void 0 : _a.addEventListener("keydown", (e) => {
        if (e.code == "ArrowUp") {
          e.preventDefault();
          stepCurrentDatePart(1);
          return false;
        } else if (e.code == "ArrowDown") {
          e.preventDefault();
          stepCurrentDatePart(-1);
          return false;
        }
      });
    });
    return {
      el,
      cls,
      format: format2,
      localValue
    };
  }
});
function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
  return withDirectives((openBlock(), createElementBlock("input", {
    class: normalizeClass(_ctx.cls),
    type: "text",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.localValue = $event),
    ref: "el"
  }, null, 2)), [
    [vModelText, _ctx.localValue]
  ]);
}
var STimeInput = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$o]]);
const _sfc_main$n = defineComponent({
  props: {
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(props, { emit: emit2 }) {
    const el = ref(null);
    const cls = computed(() => {
      let k = ["font-mono w-42 text-center block border rounded p-1 focus:outline-none focus:ring focus:ring-brand focus:ring-opacity-50"];
      const m = hooks.utc(props.modelValue, true);
      if (!m.isValid()) {
        k.push(" bg-red-50");
      }
      k.push("border-gray-300", "focus:border-brand", "focus:ring", "focus:ring-offset-0", "focus:ring-brand", "focus:ring-opacity-50");
      return k;
    });
    const localValue = computed({
      get: () => {
        const m = hooks.utc(props.modelValue, true);
        if (m.isValid()) {
          return m.format("DD/MM/Y HH:mm");
        }
        return props.modelValue;
      },
      set: (v2) => {
        const m = hooks.utc(v2, "DD/MM/YYYY HH:mm", true);
        if (m.isValid()) {
          emit2("update:modelValue", m.toISOString());
        } else {
          emit2("update:modelValue", v2);
        }
      }
    });
    const handleBlur = () => {
      let m = hooks.utc(props.modelValue, "Y-MM-DD'T'HH:mm", true);
      if (m.isValid()) {
        return;
      }
      if (props.modelValue.match(/^[0-3][0-9]\/[0-3][0-9]\/[0-9][0-9]$/)) {
        m = hooks.utc(props.modelValue, "DD/MM/YY HH:mm", true);
        if (m.isValid()) {
          emit2("update:modelValue", m.toISOString());
        }
      } else if (props.modelValue.match(/^[0-3][0-9][0-3][0-9][0-9][0-9]$/)) {
        m = hooks.utc(props.modelValue, "DDMMYY", true);
        if (m.isValid()) {
          emit2("update:modelValue", m.toISOString());
        }
      } else if (props.modelValue.match(/^[0-3]?[0-9]\/[0-3]?[0-9]\/[0-9][0-9]$/)) {
        m = hooks.utc(props.modelValue, "D/M/YY", true);
        if (m.isValid()) {
          emit2("update:modelValue", m.toISOString());
        }
      } else if (props.modelValue.match(/^[0-3]?[0-9]\/[0-3]?[0-9]\/[0-9][0-9][0-9][0-9]$/)) {
        m = hooks.utc(props.modelValue, "D/M/YYYY", true);
        if (m.isValid()) {
          emit2("update:modelValue", m.toISOString());
        }
      }
    };
    const stepCurrentDatePart = (step2) => {
      if (el.value) {
        const inputElement = el.value;
        let s2 = inputElement.selectionStart || -1;
        let e = inputElement.selectionEnd || -1;
        let fs = inputElement.value.indexOf("/");
        let ls = inputElement.value.lastIndexOf("/");
        if (s2 <= fs && e <= fs) {
          const m = hooks.utc(props.modelValue, "Y-MM-DD'T'HH:mm", true);
          if (m.isValid()) {
            m.add(step2, "days");
            emit2("update:modelValue", m.toISOString());
            nextTick(() => {
              inputElement.setSelectionRange(0, fs);
            });
          }
        } else if (s2 <= ls && e <= ls) {
          const m = hooks.utc(props.modelValue, "Y-MM-DD'T'HH:mm", true);
          if (m.isValid()) {
            m.add(step2, "months");
            emit2("update:modelValue", m.toISOString());
            nextTick(() => {
              inputElement.setSelectionRange(fs + 1, ls);
            });
          }
        } else {
          const m = hooks.utc(props.modelValue, "Y-MM-DD'T'HH:mm", true);
          if (m.isValid()) {
            m.add(step2, "years");
            emit2("update:modelValue", m.toISOString());
            nextTick(() => {
              inputElement.setSelectionRange(ls + 1, inputElement.value.length);
            });
          }
        }
      }
    };
    onMounted(() => {
      var _a;
      (_a = el.value) == null ? void 0 : _a.addEventListener("keydown", (e) => {
        if (e.code == "ArrowUp") {
          e.preventDefault();
          stepCurrentDatePart(1);
          return false;
        } else if (e.code == "ArrowDown") {
          e.preventDefault();
          stepCurrentDatePart(-1);
          return false;
        }
      });
    });
    return {
      el,
      cls,
      localValue,
      handleBlur
    };
  }
});
function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
  return withDirectives((openBlock(), createElementBlock("input", {
    class: normalizeClass(_ctx.cls),
    type: "text",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.localValue = $event),
    ref: "el",
    onBlur: _cache[1] || (_cache[1] = (...args) => _ctx.handleBlur && _ctx.handleBlur(...args))
  }, null, 34)), [
    [vModelText, _ctx.localValue]
  ]);
}
var SDatetimeInput = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$n]]);
const _sfc_main$m = defineComponent({
  props: { modelValue: null },
  emits: ["update:modelValue"],
  setup(props, { emit: emit2 }) {
    const id = uuid();
    const handleInput = (e) => {
      if (e.target)
        emit2("update:modelValue", e.target.checked);
    };
    return {
      id,
      handleInput,
      cls: ref([
        "transition-colors duration-300",
        "m-1",
        "rounded",
        "rounded",
        "text-brand",
        "border-gray-300",
        "focus:border-brand",
        "focus:ring",
        "focus:ring-offset-0",
        "focus:ring-brand",
        "focus:ring-opacity-50"
      ])
    };
  }
});
const _hoisted_1$i = { class: "flex items-center" };
const _hoisted_2$d = ["id", "checked"];
const _hoisted_3$a = ["for"];
function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$i, [
    createElementVNode("input", {
      id: _ctx.id,
      class: normalizeClass(_ctx.cls),
      type: "checkbox",
      checked: _ctx.modelValue,
      onChange: _cache[0] || (_cache[0] = (...args) => _ctx.handleInput && _ctx.handleInput(...args))
    }, null, 42, _hoisted_2$d),
    createElementVNode("label", { for: _ctx.id }, [
      renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_3$a)
  ]);
}
var SCheckbox = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$m]]);
const _sfc_main$l = defineComponent({
  props: {
    value: null,
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(props, { emit: emit2 }) {
    const id = uuid();
    const cls = ref([
      "transition-colors duration-300",
      "m-1",
      "text-brand",
      "border-gray-300",
      "focus:border-brand",
      "focus:ring",
      "focus:ring-offset-0",
      "focus:ring-brand",
      "focus:ring-opacity-50"
    ]);
    const handleInput = (e) => {
      if (e.target)
        emit2("update:modelValue", e.target.checked);
    };
    return {
      id,
      cls,
      handleInput
    };
  }
});
const _hoisted_1$h = { class: "flex items-center" };
const _hoisted_2$c = ["id", "value", "checked"];
const _hoisted_3$9 = ["for"];
function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$h, [
    createElementVNode("input", {
      class: normalizeClass(_ctx.cls),
      type: "radio",
      id: _ctx.id,
      value: _ctx.value,
      checked: _ctx.modelValue === _ctx.value,
      onChange: _cache[0] || (_cache[0] = (...args) => _ctx.handleInput && _ctx.handleInput(...args))
    }, null, 42, _hoisted_2$c),
    createElementVNode("label", { for: _ctx.id }, [
      renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_3$9)
  ]);
}
var SRadio = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$l]]);
const _sfc_main$k = defineComponent({
  components: { SRadio },
  props: {
    modelValue: null,
    options: {
      type: Array,
      required: true
    },
    itemLabel: { type: Function, default: (i2) => i2.label },
    itemId: { type: Function, default: (i2) => i2.id }
  },
  emits: ["update:modelValue"],
  setup(props, { emit: emit2 }) {
    const cls = ref("m-1");
    const handleInput = (e) => {
      if (e.target)
        emit2("update:modelValue", e.target.value);
    };
    return {
      cls,
      handleInput
    };
  }
});
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SRadio = resolveComponent("SRadio");
  return openBlock(), createElementBlock("div", null, [
    (openBlock(true), createElementBlock(Fragment$1, null, renderList(_ctx.options, (o) => {
      return openBlock(), createBlock(_component_SRadio, {
        value: _ctx.itemId(o),
        modelValue: _ctx.modelValue,
        "onUpdate:modelValue": ($event) => _ctx.$emit("update:modelValue", _ctx.itemId(o))
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.itemLabel(o)), 1)
        ]),
        _: 2
      }, 1032, ["value", "modelValue", "onUpdate:modelValue"]);
    }), 256))
  ]);
}
var SRadioButtons = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$k]]);
const _sfc_main$j = defineComponent({
  props: {
    fieldClass: { type: String, default: "" },
    fieldExpandedClass: { type: String, default: "" },
    label: { type: String, default: "&nbsp;" },
    info: { type: String, default: null },
    expandable: { type: Boolean, default: false },
    errors: null,
    errorKey: null
  },
  components: { SIconButton },
  setup() {
    const expanded = ref(false);
    const cls = computed(() => {
      if (expanded.value) {
        return "bg-white absolute z-50 inset-0 p-4 grid grid-rows-toolbar";
      }
      return "";
    });
    const tmpCls = ref("");
    return {
      tmpCls,
      toggle() {
        if (expanded.value) {
          expanded.value = false;
          setTimeout(() => {
            tmpCls.value = "w-0";
            setTimeout(() => {
              tmpCls.value = "";
            }, 50);
          }, 50);
        } else {
          expanded.value = true;
        }
      },
      expanded,
      cls
    };
  }
});
const _hoisted_1$g = { class: "flex" };
const _hoisted_2$b = ["innerHTML"];
const _hoisted_3$8 = /* @__PURE__ */ createElementVNode("div", { class: "grow" }, null, -1);
const _hoisted_4$8 = ["innerHTML"];
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SIconButton = resolveComponent("SIconButton");
  const _component_SValidationErrors = resolveComponent("SValidationErrors");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.cls)
  }, [
    createElementVNode("div", _hoisted_1$g, [
      createElementVNode("label", { innerHTML: _ctx.label }, null, 8, _hoisted_2$b),
      renderSlot(_ctx.$slots, "buttons"),
      _hoisted_3$8,
      _ctx.expandable ? (openBlock(), createBlock(_component_SIconButton, {
        key: 0,
        flat: "",
        small: "",
        icon: "arrows-expand",
        onClick: _ctx.toggle
      }, null, 8, ["onClick"])) : createCommentVNode("", true)
    ]),
    _ctx.info ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "text-sm text-sub",
      innerHTML: _ctx.info
    }, null, 8, _hoisted_4$8)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: normalizeClass([_ctx.expanded ? _ctx.fieldExpandedClass : _ctx.fieldClass, _ctx.tmpCls])
    }, [
      renderSlot(_ctx.$slots, "default")
    ], 2),
    createVNode(_component_SValidationErrors, {
      errors: _ctx.errors,
      errorKey: _ctx.errorKey
    }, null, 8, ["errors", "errorKey"])
  ], 2);
}
var SField = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$j]]);
const _sfc_main$i = defineComponent({
  props: {
    modelValue: null,
    trigger: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    nullable: { type: Boolean, default: false },
    multi: { type: Boolean, default: false },
    search: { type: Function, default: async (q) => [] },
    getById: { type: Function, default: async (id) => null },
    itemLabel: { type: Function, default: (i2) => i2 ? i2.label : "" },
    itemId: { type: Function, default: (i2) => i2 ? i2.id : null }
  },
  setup(props, { emit: emit2 }) {
    const dropdownState = ref("closed");
    const openDropdown = () => {
      updateHits(query.value);
      dropdownState.value = "open";
    };
    const closeDropdown = () => {
      if (dropdownState.value == "open") {
        dropdownState.value = "closing";
        nextTick(() => {
          if (dropdownState.value == "closing") {
            dropdownState.value = "closed";
          }
        });
      }
    };
    const selectionSet = ref(/* @__PURE__ */ new Map());
    watch(() => props.modelValue, async (newValue, oldValue) => {
      if (props.multi)
        ;
      else {
        if (newValue !== null) {
          if (!selectionSet.value.has(newValue)) {
            const selected = await props.getById(newValue);
            selectionSet.value.clear();
            selectionSet.value.set(newValue, selected);
          }
        } else {
          selectionSet.value.clear();
        }
      }
    });
    if (props.modelValue) {
      if (props.multi) {
        props.modelValue.forEach((id) => {
          props.getById(id).then((v2) => {
            selectionSet.value.set(props.itemId(v2), v2);
          });
        });
      } else {
        props.getById(props.modelValue).then((v2) => {
          selectionSet.value.set(props.itemId(v2), v2);
        });
      }
    }
    const selection = computed(() => [...selectionSet.value.values()]);
    const emitValue = () => {
      if (props.multi) {
        emit2("update:modelValue", selection.value.map((o) => props.itemId(o)));
      } else {
        emit2("update:modelValue", selection.value.length ? props.itemId(selection.value[0]) : null);
      }
    };
    const deselect = (o) => {
      if (props.nullable || selectionSet.value.size > 1) {
        selectionSet.value.delete(props.itemId(o));
        emitValue();
      } else if (!props.nullable) {
        closeDropdown();
      }
    };
    const select = (o) => {
      const v2 = props.itemId(o);
      if (props.multi) {
        selectionSet.value.set(v2, o);
        emitValue();
      } else {
        if (!selectionSet.value.has(v2)) {
          selectionSet.value.clear();
          selectionSet.value.set(v2, o);
          emitValue();
          closeDropdown();
        }
      }
    };
    const toggle = (o) => {
      if (selectionSet.value.has(props.itemId(o))) {
        deselect(o);
      } else {
        select(o);
      }
    };
    const updateHits = async (q) => {
      list2.value = await props.search(q);
    };
    const query = ref("");
    const list2 = ref([]);
    const handleKeys = (e) => {
      if (e.code == "Tab") {
        if (list2.value.length == 1) {
          select(list2.value[0]);
        }
        closeDropdown();
      } else if (e.code == "Escape") {
        closeDropdown();
      } else if (e.code == "Enter" || e.code == "NumpadEnter") {
        if (list2.value.length == 1) {
          select(list2.value[0]);
        }
        closeDropdown();
      }
    };
    return {
      dropdownState,
      openDropdown,
      closeDropdown,
      handleKeys,
      list: list2,
      toggle,
      selectionSet,
      selection,
      updateHits,
      query
    };
  },
  components: { STextInput }
});
const _hoisted_1$f = { class: "relative" };
const _hoisted_2$a = { key: 0 };
const _hoisted_3$7 = {
  key: 1,
  class: "inline-block max-w-full overflow-hidden overflow-ellipsis whitespace-nowrap pr-6"
};
const _hoisted_4$7 = /* @__PURE__ */ createElementVNode("svg", {
  class: "h-4 mt-1 ml-2 float-right fill-current text-current",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 129 129",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "enable-background": "new 0 0 129 129"
}, [
  /* @__PURE__ */ createElementVNode("g", null, [
    /* @__PURE__ */ createElementVNode("path", { d: "m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z" })
  ])
], -1);
const _hoisted_5$5 = {
  key: 0,
  class: "rounded-b shadow-md absolute top-full z-10 bg-white left-1 max-w-lg"
};
const _hoisted_6$4 = { class: "p-2 border-b" };
const _hoisted_7$3 = ["onClick"];
const _hoisted_8$2 = {
  key: 0,
  class: "float-right",
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18"
};
const _hoisted_9$2 = /* @__PURE__ */ createElementVNode("path", { d: "M6.61 11.89L3.5 8.78 2.44 9.84 6.61 14l8.95-8.95L14.5 4z" }, null, -1);
const _hoisted_10$1 = [
  _hoisted_9$2
];
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SButton = resolveComponent("SButton");
  const _component_STextInput = resolveComponent("STextInput");
  const _directive_focus = resolveDirective("focus");
  const _directive_absorb = resolveDirective("absorb");
  const _directive_click_outside = resolveDirective("click-outside");
  return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$f, [
    createVNode(_component_SButton, {
      disabled: _ctx.disabled,
      onFocus: _ctx.openDropdown,
      class: "max-w-full text-left"
    }, {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default", { selection: _ctx.selection }, () => [
          _ctx.selection.length == 0 ? (openBlock(), createElementBlock("span", _hoisted_2$a, "-")) : (openBlock(), createElementBlock("div", _hoisted_3$7, toDisplayString(_ctx.selection.map((o) => o.label).join(", ")), 1)),
          _hoisted_4$7
        ])
      ]),
      _: 3
    }, 8, ["disabled", "onFocus"]),
    _ctx.dropdownState != "closed" ? (openBlock(), createElementBlock("div", _hoisted_5$5, [
      createElementVNode("ul", null, [
        createElementVNode("li", _hoisted_6$4, [
          withDirectives(createVNode(_component_STextInput, {
            placeholder: "Search",
            modelValue: _ctx.query,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.query = $event),
            onKeydown: _ctx.handleKeys,
            onInput: _cache[1] || (_cache[1] = ($event) => _ctx.updateHits($event.target.value))
          }, null, 8, ["modelValue", "onKeydown"]), [
            [_directive_focus],
            [_directive_absorb]
          ])
        ]),
        (openBlock(true), createElementBlock(Fragment$1, null, renderList(_ctx.list, (o, ix) => {
          return openBlock(), createElementBlock("li", null, [
            createElementVNode("div", {
              onClick: ($event) => _ctx.toggle(o),
              class: "p-2 block text-black whitespace-nowrap hover:bg-brand hover:bg-opacity-10 cursor-pointer max-w-full overflow-hidden text-ellipsis"
            }, [
              createTextVNode(toDisplayString(_ctx.itemLabel(o)) + " ", 1),
              _ctx.selectionSet.has(o.id) ? (openBlock(), createElementBlock("svg", _hoisted_8$2, _hoisted_10$1)) : createCommentVNode("", true)
            ], 8, _hoisted_7$3)
          ]);
        }), 256))
      ])
    ])) : createCommentVNode("", true)
  ])), [
    [_directive_click_outside, _ctx.closeDropdown]
  ]);
}
var SSearchSelect = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$i]]);
const _sfc_main$h = defineComponent({
  props: { errors: null, errorKey: null },
  setup(props) {
    const theErrors = reactive([]);
    watch(() => props.errors, (errors, prevErrors) => {
      theErrors.splice(0, theErrors.length);
      if (errors.hasOwnProperty(props.errorKey)) {
        theErrors.push(...errors[props.errorKey]);
      }
    }, { deep: true });
    return {
      theErrors
    };
  }
});
const _hoisted_1$e = ["textContent"];
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(true), createElementBlock(Fragment$1, null, renderList(_ctx.theErrors, (e, ix) => {
    return openBlock(), createElementBlock("div", {
      class: "text-red-500 text-sm",
      textContent: toDisplayString(e)
    }, null, 8, _hoisted_1$e);
  }), 256);
}
var SValidationErrors = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$h]]);
const dialogs = reactive([]);
const dialog = (options) => {
  const s2 = Symbol();
  const closeDialog = () => {
    dialogs.splice(dialogs.findIndex((t) => t.key === s2), 1);
    if (options.onClose) {
      options.onClose();
    }
  };
  options.key = s2;
  options.closeDialog = closeDialog;
  if (!options.onAction) {
    options.onAction = closeDialog;
  }
  dialogs.push(options);
  return {
    options() {
      return dialogs.find((t) => t.key === s2);
    },
    closeDialog
  };
};
const alert$1 = (title, message, icon, color) => {
  dialog({
    component: "SNotification",
    props: {
      title,
      icon,
      color,
      message
    }
  });
};
const confirm = async (title, message, options) => {
  return new Promise((resolve7) => {
    options = options ? options : {};
    let buttons = options.buttons ? options.buttons : [];
    if (buttons.findIndex((b) => b.action == "confirm") < 0) {
      buttons.push({ label: options.confirm_text || "Ok", color: "success", action: "confirm" });
    }
    if (buttons.findIndex((b) => b.action == "cancel") < 0) {
      buttons.push({ label: options.cancel_text || "Ok", color: "warning", action: "cancel" });
    }
    const dialogInfo = dialog({
      component: "SNotification",
      props: {
        title,
        icon: options.icon,
        color: options.color,
        message
      },
      buttons,
      onAction(e) {
        resolve7({
          confirm: e.code == "confirm",
          code: e.code,
          closeDialog: dialogInfo.closeDialog
        });
      }
    });
  });
};
const useDialogs = () => {
  return {
    dialogs,
    dialog,
    alert: alert$1,
    confirm
  };
};
const defaultButtons = () => {
  return [
    { label: "Close", action: "close" }
  ];
};
const _sfc_main$g = defineComponent({
  name: "Dialog",
  components: { SButton },
  props: {
    size: { type: String, default: "small" },
    type: { type: String, default: "white" },
    buttons: {
      type: Object,
      default: defaultButtons
    },
    defaultAction: { type: String, default: "cancel" },
    onAction: null,
    component: null,
    componentProps: null
  },
  setup(props, { emit: emit2 }) {
    const componentInstance = ref(null);
    const windowkeydown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.code == "KeyS") {
        emit2("action", { code: "save" });
        e.preventDefault();
        return false;
      } else if (e.code == "Escape") {
        emit2("action", { code: "cancel" });
        e.preventDefault();
        return false;
      }
    };
    onMounted(() => {
      window.addEventListener("keydown", windowkeydown, false);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("keydown", windowkeydown, false);
    });
    return {
      componentInstance,
      sizeClass: computed(() => {
        switch (props.size) {
          case "small":
            return "sm:max-w-md";
          case "medium":
            return "sm:max-w-xl";
          case "large":
            return "sm:max-w-5xl";
        }
      })
    };
  }
});
const _hoisted_1$d = { class: "fixed z-10 inset-0 overflow-y-auto" };
const _hoisted_2$9 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" };
const _hoisted_3$6 = /* @__PURE__ */ createElementVNode("div", {
  class: "fixed inset-0 transition-opacity",
  "aria-hidden": "true"
}, [
  /* @__PURE__ */ createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" })
], -1);
const _hoisted_4$6 = /* @__PURE__ */ createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "\u200B", -1);
const _hoisted_5$4 = { class: "bg-white text-left" };
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SButton = resolveComponent("SButton");
  const _directive_focus = resolveDirective("focus");
  return openBlock(), createElementBlock("div", _hoisted_1$d, [
    (openBlock(), createBlock(Suspense, { timeout: "300" }, {
      default: withCtx(() => [
        createElementVNode("div", _hoisted_2$9, [
          createVNode(Transition, {
            appear: "",
            "enter-from-class": "opacity-0",
            "enter-active-class": "ease-out duration-300",
            "enter-to-class": "opacity-100"
          }, {
            default: withCtx(() => [
              _hoisted_3$6
            ]),
            _: 1
          }),
          _hoisted_4$6,
          createVNode(Transition, {
            appear: "",
            "enter-from-class": "opacity-0 translate-y-6 sm:translate-y-0 sm:scale-90",
            "enter-active-class": "ease-out duration-300",
            "enter-to-class": "opacity-100 translate-y-0 sm:scale-100"
          }, {
            default: withCtx(() => [
              createElementVNode("div", {
                class: normalizeClass([[_ctx.sizeClass], "inline-block align-bottom bg-white rounded overflow-visible shadow-xl transform transition-all sm:my-8 sm:align-middle w-full"]),
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "modal-headline"
              }, [
                createElementVNode("div", _hoisted_5$4, [
                  renderSlot(_ctx.$slots, "default", {}, () => [
                    _ctx.component ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.component), mergeProps({ key: 0 }, _ctx.componentProps, { ref: "componentInstance" }), null, 16)) : createCommentVNode("", true)
                  ])
                ]),
                createElementVNode("div", {
                  class: normalizeClass(["bg-gray-50 px-4 pt-2 pb-3 flex flex-wrap justify-center sm:justify-end border-t-2", `border-${_ctx.type}-100`])
                }, [
                  (openBlock(true), createElementBlock(Fragment$1, null, renderList(_ctx.buttons, (b, ix) => {
                    return withDirectives((openBlock(), createBlock(_component_SButton, {
                      key: ix,
                      disabled: b.disabled,
                      onClick: ($event) => _ctx.onAction({ code: b.action, component: _ctx.componentInstance }),
                      color: b.color,
                      class: "ml-1 sm:ml-0 sm:mr-1 mt-1 sm:w-auto"
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(b.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick", "color"])), [
                      [_directive_focus, _ctx.defaultAction === b.action]
                    ]);
                  }), 128))
                ], 2)
              ], 2)
            ]),
            _: 3
          })
        ])
      ]),
      _: 3
    }))
  ]);
}
var SDialog = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$g]]);
const _sfc_main$f = defineComponent({
  components: {
    SDialog
  },
  name: "Dialogs",
  setup() {
    const { dialogs: dialogs2 } = useDialogs();
    return {
      dialogs: dialogs2
    };
  }
});
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SDialog = resolveComponent("SDialog");
  return openBlock(), createElementBlock("div", null, [
    (openBlock(true), createElementBlock(Fragment$1, null, renderList(_ctx.dialogs, (dialog2) => {
      return openBlock(), createBlock(_component_SDialog, {
        key: dialog2.key,
        buttons: dialog2.buttons,
        onAction: (info) => {
          dialog2.onAction(info, dialog2);
        },
        component: dialog2.component,
        componentProps: dialog2.props
      }, null, 8, ["buttons", "onAction", "component", "componentProps"]);
    }), 128))
  ]);
}
var SDialogs = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$f]]);
const toasties = reactive([]);
const toast = (options) => {
  options = Object.assign({
    key: uuid(),
    color: "info",
    duration: 3e3
  }, options);
  let t = toasties.find((t2) => t2.key === options.key);
  if (t) {
    clearTimeout(t.timeout);
    if (typeof t.closeToast == "function") {
      t.timeout = window.setTimeout(t.closeToast, t.duration);
    }
  } else {
    options.closeToast = () => {
      toasties.splice(toasties.findIndex((t2) => t2.key === options.key), 1);
    };
    if (options.duration) {
      options.timeout = setTimeout(options.closeToast, options.duration);
    }
    toasties.push(options);
  }
};
const useToasties = () => {
  return {
    toasties,
    toast
  };
};
const _sfc_main$e = defineComponent({
  props: {
    toast: null
  },
  setup(props) {
    return {
      toastClass: computed(() => {
        let color = "border-brand";
        switch (props.toast.color) {
          case "sub":
            color = "border-sub";
            break;
          case "muted":
            color = "border-muted";
            break;
          case "brand":
            color = "border-brand";
            break;
          case "btn":
            color = "border-btn";
            break;
          case "primary":
            color = "border-primary";
            break;
          case "secondary":
            color = "border-secondary";
            break;
          case "success":
            color = "border-success";
            break;
          case "info":
            color = "border-info";
            break;
          case "warning":
            color = "border-warning";
            break;
          case "danger":
            color = "border-danger";
            break;
          case "gray":
            color = "border-gray";
            break;
        }
        return [color];
      })
    };
  }
});
const _hoisted_1$c = { class: "flex-grow" };
const _hoisted_2$8 = { class: "font-medium text-gray-900" };
const _hoisted_3$5 = {
  key: 0,
  class: "text-gray-500"
};
const _hoisted_4$5 = ["innerHTML"];
const _hoisted_5$3 = /* @__PURE__ */ createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1);
const _hoisted_6$3 = [
  _hoisted_5$3
];
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["relative flex items-start justify-between w-full p-3 bg-white ring-1 ring-gray-200 border-l-4 rounded shadow-lg mt-6", _ctx.toastClass])
  }, [
    createElementVNode("div", _hoisted_1$c, [
      createElementVNode("div", _hoisted_2$8, toDisplayString(_ctx.toast.title), 1),
      _ctx.toast.subtitle ? (openBlock(), createElementBlock("div", _hoisted_3$5, toDisplayString(_ctx.toast.subtitle), 1)) : createCommentVNode("", true),
      _ctx.toast.content ? (openBlock(), createElementBlock("div", {
        key: 1,
        innerHTML: _ctx.toast.content
      }, null, 8, _hoisted_4$5)) : createCommentVNode("", true)
    ]),
    createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.toast.closeToast && _ctx.toast.closeToast(...args)),
      class: "absolute top-0 right-0 transform translate-x-2 -translate-y-2 rounded-full cursor-pointer flex-shrink-0 flex items-center justify-center h-10 w-10 bg-white text-gray-500 hover:bg-gray-100 sm:h-8 sm:w-8"
    }, _hoisted_6$3)
  ], 2);
}
var SToast = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$e]]);
const _sfc_main$d = defineComponent({
  components: {
    SToast
  },
  name: "Toasties",
  setup() {
    const { toasties: toasties2 } = useToasties();
    return {
      toasties: toasties2
    };
  }
});
const _hoisted_1$b = { class: "alert-toast fixed z-10 top-0 right-0 w-5/6 md:w-full max-w-md pr-6" };
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SToast = resolveComponent("SToast");
  return openBlock(), createElementBlock("div", _hoisted_1$b, [
    createVNode(TransitionGroup, {
      "enter-from-class": "opacity-0 translate-x-20 ",
      "enter-active-class": "transform ease-out duration-300",
      "enter-to-class": "opacity-100 translate-x-0 ",
      "leave-from-class": "opacity-100 translate-x-0 ",
      "leave-active-class": "transform ease-out duration-300",
      "leave-to-class": "opacity-0 translate-x-20 "
    }, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment$1, null, renderList(_ctx.toasties, (toast2, ix) => {
          return openBlock(), createBlock(_component_SToast, {
            key: toast2.key,
            toast: toast2
          }, null, 8, ["toast"]);
        }), 128))
      ]),
      _: 1
    })
  ]);
}
var SToasties = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$d]]);
const _sfc_main$c = defineComponent({
  name: "SNotification",
  props: {
    title: { type: String },
    message: { type: String },
    color: {
      type: String,
      default: "info"
    }
  },
  setup(props) {
    const typeClass = computed(() => {
      switch (props.color) {
        case "success":
        case "info":
        case "warning":
        case "danger":
          return { bg: `bg-${props.color}-100`, text: `text-${props.color}-600` };
        default:
          return { bg: "bg-gray-200", text: "text-gray-800" };
      }
    });
    return { typeClass };
  }
});
const _hoisted_1$a = { class: "sm:flex sm:items-start p-3" };
const _hoisted_2$7 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" };
const _hoisted_3$4 = ["innerHTML"];
const _hoisted_4$4 = ["innerHTML"];
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$a, [
    createElementVNode("div", _hoisted_2$7, [
      createElementVNode("h3", {
        class: "text-lg leading-6 font-medium text-gray-800",
        innerHTML: _ctx.title
      }, null, 8, _hoisted_3$4),
      _ctx.message ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "mt-2 text-gray-500",
        innerHTML: _ctx.message
      }, null, 8, _hoisted_4$4)) : createCommentVNode("", true)
    ])
  ]);
}
var SNotification = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$c]]);
const _sfc_main$b = defineComponent({
  components: { SIcon, draggable },
  name: "SPaginatedList",
  props: {
    wrapperClass: { type: String, default: null },
    flat: { type: Boolean, default: false },
    sortable: { type: Boolean, default: false },
    itemKey: { type: String, default: "id" },
    itemClass: { type: String, default: "" },
    ghostClass: { type: String, default: "bg-table-header" },
    chosenClass: { type: String, default: "bg-table-header" },
    dragClass: { type: String, default: "" },
    tag: { type: String, default: "div" },
    params: {
      type: Object,
      default() {
        return {};
      }
    },
    paginator: null
  },
  setup(props, { emit: emit2 }) {
    const changing = ref(false);
    const listKey = ref(0);
    const isSortable = computed(() => {
      const s2 = props.sortable;
      const p = props.paginator.totalPages.value == 1;
      return p && s2;
    });
    const localList = computed({
      get() {
        return props.paginator.visibleItems.value;
      },
      set(value) {
        emit2("reorder", value);
      }
    });
    const onCurrentPerPageChanged = (pp) => {
      changing.value = true;
      props.paginator.setParams({ perPage: Number(pp), page: 1 });
      props.paginator.loadData();
      listKey.value = listKey.value + 1;
      nextTick(() => {
        changing.value = false;
      });
    };
    const perPageOptions = computed(() => {
      const possibleValues = [50, 100];
      const res = [4, 20];
      for (let i2 = 0; i2 < possibleValues.length; i2++) {
        if (possibleValues[i2] <= props.paginator.totalCount.value) {
          res.push(possibleValues[i2]);
        } else {
          break;
        }
      }
      if (res[res.length - 1] < props.paginator.totalCount.value) {
        res.push(props.paginator.totalCount.value);
      }
      return res;
    });
    return {
      onEnd: (evt) => {
        let drags = document.getElementsByClassName("draggable-cover");
        for (let i2 = 0; i2 < drags.length; i2++) {
          drags[i2].remove();
        }
      },
      localList,
      createNewItem() {
        props.paginator.goto("createNewItem");
      },
      importFromFile() {
        props.paginator.goto("importFromFile");
      },
      perPageOptions,
      currentPage: props.paginator.page,
      currentPerPage: props.paginator.perPage,
      prev: props.paginator.prev,
      next: props.paginator.next,
      loading: props.paginator.loading,
      visibleItems: props.paginator.visibleItems,
      totalPages: props.paginator.totalPages,
      totalCount: props.paginator.totalCount,
      toggleSort: props.paginator.toggleSort,
      sortInfo: props.paginator.sortInfo,
      onCurrentPerPageChanged,
      isSortable,
      listKey,
      changing
    };
  }
});
const _hoisted_1$9 = { class: "relative" };
const _hoisted_2$6 = { key: 0 };
const _hoisted_3$3 = {
  key: 1,
  class: "divide-y divide-gray-200"
};
const _hoisted_4$3 = {
  key: 0,
  class: "absolute inset-0 flex justify-center items-center text-2xl"
};
const _hoisted_5$2 = /* @__PURE__ */ createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "animate-spin h-20 w-20",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
  })
], -1);
const _hoisted_6$2 = [
  _hoisted_5$2
];
const _hoisted_7$2 = { class: "bg-gray-light flex flex-row justify-start items-center p-1" };
const _hoisted_8$1 = {
  key: 0,
  tabindex: "-1",
  class: "mx-3 inline-flex justify-center items-center rounded-full w-6 h-6 bg-gray hover:bg-gray-light disabled:opacity-50"
};
const _hoisted_9$1 = {
  key: 1,
  tabindex: "-1",
  class: "mx-3 inline-flex justify-center items-center rounded-full w-6 h-6 bg-gray hover:bg-gray-light disabled:opacity-50"
};
const _hoisted_10 = /* @__PURE__ */ createElementVNode("div", { class: "flex-grow" }, null, -1);
const _hoisted_11 = {
  key: 2,
  class: "flex flex-row justify-start items-center"
};
const _hoisted_12 = {
  tabindex: "-1",
  class: "mx-3 inline-flex justify-center items-center rounded-full w-6 h-6 bg-gray hover:bg-gray-light disabled:opacity-50"
};
const _hoisted_13 = { class: "font-mono" };
const _hoisted_14 = {
  tabindex: "-1",
  class: "mx-3 inline-flex justify-center items-center rounded-full w-6 h-6 bg-gray hover:bg-gray-light disabled:opacity-50"
};
const _hoisted_15 = ["value"];
const _hoisted_16 = ["value"];
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_draggable = resolveComponent("draggable");
  const _component_SIcon = resolveComponent("SIcon");
  const _directive_absorb = resolveDirective("absorb");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["grid grid-rows-statusbar", [_ctx.flat ? "" : "border rounded"]])
  }, [
    createElementVNode("div", _hoisted_1$9, [
      (openBlock(), createBlock(resolveDynamicComponent(_ctx.tag), {
        class: normalizeClass(["overflow-auto max-h-full", _ctx.wrapperClass])
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "header", {
            toggleSort: _ctx.toggleSort,
            sortInfo: _ctx.sortInfo
          }),
          _ctx.changing ? (openBlock(), createElementBlock("div", _hoisted_2$6, "...")) : (openBlock(), createElementBlock("div", _hoisted_3$3, [
            _ctx.isSortable ? (openBlock(), createBlock(_component_draggable, {
              modelValue: _ctx.localList,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.localList = $event),
              onEnd: _ctx.onEnd,
              itemKey: _ctx.itemKey,
              ghostClass: _ctx.ghostClass,
              chosenClass: _ctx.chosenClass,
              dragClass: _ctx.dragClass,
              key: _ctx.listKey
            }, {
              item: withCtx(({ element, index: index3 }) => [
                createElementVNode("div", {
                  class: normalizeClass(_ctx.itemClass)
                }, [
                  renderSlot(_ctx.$slots, "item", {
                    item: element,
                    index: index3
                  })
                ], 2)
              ]),
              _: 3
            }, 8, ["modelValue", "onEnd", "itemKey", "ghostClass", "chosenClass", "dragClass"])) : (openBlock(true), createElementBlock(Fragment$1, { key: 1 }, renderList(_ctx.visibleItems, (item, index3) => {
              return openBlock(), createElementBlock("div", {
                key: index3,
                class: normalizeClass(_ctx.itemClass)
              }, [
                renderSlot(_ctx.$slots, "item", {
                  item,
                  index: index3
                })
              ], 2);
            }), 128))
          ])),
          renderSlot(_ctx.$slots, "footer")
        ]),
        _: 3
      }, 8, ["class"])),
      _ctx.loading ? (openBlock(), createElementBlock("div", _hoisted_4$3, _hoisted_6$2)) : createCommentVNode("", true)
    ]),
    createElementVNode("div", _hoisted_7$2, [
      _ctx.paginator.canCreate ? withDirectives((openBlock(), createElementBlock("button", _hoisted_8$1, [
        createVNode(_component_SIcon, { icon: "plus" })
      ])), [
        [_directive_absorb, (e) => {
          e.button == 0 && _ctx.createNewItem();
        }, "mousedown"]
      ]) : createCommentVNode("", true),
      _ctx.paginator.canImport ? withDirectives((openBlock(), createElementBlock("button", _hoisted_9$1, [
        createVNode(_component_SIcon, { icon: "upload" })
      ])), [
        [_directive_absorb, (e) => {
          e.button == 0 && _ctx.importFromFile();
        }, "mousedown"]
      ]) : createCommentVNode("", true),
      _hoisted_10,
      _ctx.totalPages > 1 || _ctx.currentPerPage > 20 ? (openBlock(), createElementBlock("div", _hoisted_11, [
        withDirectives((openBlock(), createElementBlock("button", _hoisted_12, [
          createVNode(_component_SIcon, { icon: "chevron-left" })
        ])), [
          [_directive_absorb, () => {
            _ctx.prev();
          }, "mousedown"]
        ]),
        createElementVNode("span", _hoisted_13, "Page " + toDisplayString(_ctx.currentPage) + " / " + toDisplayString(_ctx.totalPages), 1),
        withDirectives((openBlock(), createElementBlock("button", _hoisted_14, [
          createVNode(_component_SIcon, { icon: "chevron-right" })
        ])), [
          [_directive_absorb, () => {
            _ctx.next();
          }, "mousedown"]
        ]),
        createElementVNode("select", {
          class: "py-0 font-mono w-26 rounded border-gray",
          value: _ctx.currentPerPage,
          onChange: _cache[1] || (_cache[1] = ($event) => _ctx.onCurrentPerPageChanged($event.target.value))
        }, [
          (openBlock(true), createElementBlock(Fragment$1, null, renderList(_ctx.perPageOptions, (perPage, ix) => {
            return openBlock(), createElementBlock("option", {
              key: ix,
              value: perPage
            }, toDisplayString(perPage), 9, _hoisted_16);
          }), 128))
        ], 40, _hoisted_15)
      ])) : createCommentVNode("", true)
    ])
  ], 2);
}
var SPaginatedList = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$b]]);
const _sfc_main$a = defineComponent({
  name: "SUploader",
  emits: ["update:modelValue", "fileUploaded"],
  props: {
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    color: {
      type: String,
      default: "btn"
    },
    upload: { type: Function, default: () => {
    } },
    modelValue: null
  },
  setup(props, { emit: emit2 }) {
    const selection = ref([]);
    const progress = (e, fileInfo) => {
      fileInfo.progress = Math.round(100 * e.loaded / e.total);
    };
    const success = (fileInfo) => {
      emit2("update:modelValue", fileInfo);
      emit2("fileUploaded");
    };
    const handleInput = (e) => {
      if (e.target) {
        const files = e.target.files;
        if (files) {
          for (let i2 = 0; i2 < files.length; i2++) {
            const file2 = files.item(i2);
            if (file2) {
              const fileInfo = reactive({ file: file2, progress: 0, filename: null });
              selection.value.push(fileInfo);
              props.upload(fileInfo, progress, success);
            }
          }
        }
      }
    };
    return {
      selection,
      handleInput,
      cls: computed(() => {
        return buttonize(props);
      })
    };
  }
});
const _hoisted_1$8 = /* @__PURE__ */ createElementVNode("span", null, "Select a file", -1);
const _hoisted_2$5 = ["multiple", "disabled"];
const _hoisted_3$2 = { class: "relative pt-1" };
const _hoisted_4$2 = { class: "flex mb-2 items-center justify-between" };
const _hoisted_5$1 = { class: "text-xs font-semibold inline-block" };
const _hoisted_6$1 = { class: "text-right" };
const _hoisted_7$1 = {
  key: 0,
  class: "overflow-hidden h-2 mb-4 text-xs flex rounded bg-info-light"
};
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    createElementVNode("label", {
      class: normalizeClass(_ctx.cls)
    }, [
      _hoisted_1$8,
      createElementVNode("input", {
        type: "file",
        class: "hidden",
        multiple: _ctx.multiple,
        disabled: _ctx.disabled,
        onInput: _cache[0] || (_cache[0] = (...args) => _ctx.handleInput && _ctx.handleInput(...args))
      }, null, 40, _hoisted_2$5)
    ], 2),
    createElementVNode("div", null, [
      (openBlock(true), createElementBlock(Fragment$1, null, renderList(_ctx.selection, (fileInfo) => {
        return openBlock(), createElementBlock("div", null, [
          createElementVNode("div", _hoisted_3$2, [
            createElementVNode("div", _hoisted_4$2, [
              createElementVNode("div", null, [
                createElementVNode("span", _hoisted_5$1, toDisplayString(fileInfo.file.name), 1)
              ]),
              createElementVNode("div", _hoisted_6$1, [
                createElementVNode("span", {
                  class: normalizeClass(["text-xs font-semibold inline-block", fileInfo.progress >= 100 ? "text-success" : "text-info"])
                }, toDisplayString(fileInfo.progress) + "% ", 3)
              ])
            ]),
            fileInfo.progress < 100 ? (openBlock(), createElementBlock("div", _hoisted_7$1, [
              createElementVNode("div", {
                style: normalizeStyle(`width:${fileInfo.progress}%`),
                class: "shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-info"
              }, null, 4)
            ])) : createCommentVNode("", true)
          ])
        ]);
      }), 256))
    ])
  ]);
}
var SUploader = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$a]]);
const _sfc_main$9 = defineComponent({
  name: "STabs",
  props: {
    tabs: { type: Array, default: () => [] },
    label: { type: Function, default: (t) => t.name }
  },
  setup(props) {
    const currentIndex = ref(getSessionSetting("STabs-" + md5(props.tabs), props.tabs.length ? 0 : null));
    const openTab = (index3) => {
      currentIndex.value = index3;
      setSessionSetting("STabs-" + md5({ a: document.location, x: props.tabs }), index3);
    };
    onMounted(() => {
      currentIndex.value = getSessionSetting("STabs-" + md5({ a: document.location, x: props.tabs }), props.tabs.length ? 0 : null);
    });
    return {
      openTab,
      currentTab: computed(() => {
        if (currentIndex.value !== null) {
          return props.tabs[currentIndex.value];
        }
        return null;
      }),
      currentIndex
    };
  }
});
const _hoisted_1$7 = { class: "grid grid-rows-toolbar" };
const _hoisted_2$4 = { class: "border-b flex px-2" };
const _hoisted_3$1 = ["onClick"];
const _hoisted_4$1 = { class: "p-3" };
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$7, [
    createElementVNode("div", _hoisted_2$4, [
      (openBlock(true), createElementBlock(Fragment$1, null, renderList(_ctx.tabs, (tab, index3) => {
        return openBlock(), createElementBlock("div", null, [
          createElementVNode("div", {
            onClick: ($event) => _ctx.openTab(index3),
            class: normalizeClass(["px-1 border border-b-0 mr-1 cursor-pointer", [_ctx.currentTab != tab || "text-brand"]])
          }, toDisplayString(_ctx.label(tab)), 11, _hoisted_3$1)
        ]);
      }), 256))
    ]),
    createElementVNode("div", _hoisted_4$1, [
      renderSlot(_ctx.$slots, "default", {
        currentTab: _ctx.currentTab,
        currentIndex: _ctx.currentIndex
      })
    ])
  ]);
}
var STabs = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$9]]);
window.moment = hooks;
const _sfc_main$8 = defineComponent({
  props: {
    modelValue: null,
    view: { type: String, default: "month" },
    renderFormat: { type: String, default: "Y-MM-DD" },
    displayFormat: { type: String, default: "DD MMM Y" },
    mode: { type: String, default: "date" }
  },
  setup(props, { emit: emit2 }) {
    const parseDate = (dateString, format2) => {
      const date2 = hooks(dateString, format2);
      if (date2 && date2.isValid()) {
        return date2;
      }
      return false;
    };
    watch(() => props.modelValue, (nv, ov) => {
      if (nv) {
        const dv2 = parseDate(props.modelValue, "Y-MM-DD");
        if (dv2) {
          focusedDate.value = dv2;
        }
      }
    });
    const renderDate = (date2, format2) => {
      return date2 ? date2.format(format2) : null;
    };
    const submode = ref("month");
    const toggleSubmode = () => {
      submode.value = submode.value == "month" ? "year" : "month";
    };
    const dateValue = computed(() => {
      if (props.modelValue) {
        const dv2 = parseDate(props.modelValue, "Y-MM-DD");
        return dv2 ? dv2 : false;
      }
      return null;
    });
    const startOfPeriod = computed(() => {
      return focusedDate.value.clone().startOf("month");
    });
    const endOfPeriod = computed(() => {
      return focusedDate.value.clone().endOf("month");
    });
    const firstWeek = computed(() => {
      return visibleDates.value.slice(0, 7);
    });
    const hours2 = computed(() => {
      const h2 = [];
      for (let i2 = 0; i2 < 24; i2++) {
        h2.push({
          isSelectable: true,
          value: i2
        });
      }
      return h2;
    });
    const minutes2 = computed(() => {
      const m2 = [];
      for (let i2 = 0; i2 < 60; i2++) {
        m2.push({
          isSelectable: true,
          value: i2
        });
      }
      return m2;
    });
    const visibleDates = computed(() => {
      let date2 = startOfPeriod.value.clone();
      const dates = [];
      for (let i2 = (startOfPeriod.value.day() + 6) % 7; i2 > 0; i2--) {
        dates.push({
          isCurrentPeriod: false,
          date: date2.clone().add(-i2, "day")
        });
      }
      while (date2.isSameOrBefore(endOfPeriod.value)) {
        dates.push({
          isCurrentPeriod: true,
          date: date2.clone()
        });
        date2.add(1, "day");
      }
      for (let i2 = dates.length; i2 < 42; i2++) {
        dates.push({
          isCurrentPeriod: false,
          date: date2.clone()
        });
        date2.add(1, "day");
      }
      return dates;
    });
    const visibleMonths = computed(() => {
      let date2 = startOfPeriod.value.clone().startOf("year");
      const dates = [];
      for (let i2 = 0; i2 < 12; i2++) {
        dates.push({
          date: date2.clone()
        });
        date2.add(1, "month");
      }
      return dates;
    });
    const monthClass = (date2) => {
      const cls = [];
      if (dateValue && date2.date.isSame(dateValue.value, "month")) {
        cls.push("font-bold bg-brand text-white");
      } else {
        cls.push("hover:bg-gray-200");
        if (date2.date.isSame(focusedDate.value, "month")) {
          cls.push("bg-gray-300");
        }
      }
      return cls;
    };
    const dayHeaderClass = (date2) => {
      const cls = ["text-gray-400"];
      return cls;
    };
    const dayClass = (date2) => {
      const cls = ["w-8", "h-8", "rounded-full flex justify-center items-center"];
      if (!date2.isCurrentPeriod) {
        cls.push("text-gray-200 hover:text-white");
      }
      if (dateValue && date2.date.isSame(dateValue.value, "day")) {
        cls.push("font-bold bg-brand text-white");
      } else {
        cls.push("hover:bg-gray-200");
        if (date2.date.isSame(focusedDate.value, "day")) {
          cls.push("bg-gray-300");
        }
      }
      return cls;
    };
    const dayClicked = (date2) => {
      focusedDate.value = date2.date.clone();
      const renderedDate = renderDate(date2.date, props.renderFormat);
      if (renderedDate != props.modelValue) {
        emit2("update:modelValue", renderedDate);
      }
    };
    const monthClicked = (date2) => {
      date2 = date2.date.clone();
      if (dateValue.value) {
        date2 = dateValue.value.clone().year(date2.year()).month(date2.month());
      }
      focusedDate.value = date2;
      toggleSubmode();
    };
    const dv = parseDate(props.modelValue, "Y-MM-DD");
    const focusedDate = ref(dv ? dv : hooks());
    const move2 = (delta) => {
      moveTo(focusedDate.value.clone().add(delta, submode.value));
    };
    const moveTo = (date2) => {
      focusedDate.value = date2.clone();
    };
    const h = computed(() => {
      if (props.mode == "datetime" && dateValue.value) {
        return dateValue.value.hour;
      }
      return null;
    });
    const m = computed(() => {
      if (props.mode == "datetime" && dateValue.value) {
        return dateValue.value.hour;
      }
      return null;
    });
    return {
      move: move2,
      moveTo,
      dayClicked,
      monthClicked,
      renderDate,
      parseDate,
      dateValue,
      dayClass,
      dayHeaderClass,
      monthClass,
      visibleDates,
      firstWeek,
      visibleMonths,
      focusedDate,
      hours: hours2,
      minutes: minutes2,
      h,
      m,
      toggleSubmode,
      submode
    };
  }
});
const _hoisted_1$6 = { class: "w-64 border bg-white shadow-lg rounded-md select-none" };
const _hoisted_2$3 = { class: "flex h-8 justify-evenly border-b border-gray-100" };
const _hoisted_3 = {
  key: 0,
  class: "grid grid-cols-7 cursor-pointer p-1 border-b border-gray-100"
};
const _hoisted_4 = ["onMousedown"];
const _hoisted_5 = {
  key: 1,
  class: "grid grid-cols-2 cursor-pointer p-1 border-b border-gray-100"
};
const _hoisted_6 = ["onMousedown"];
const _hoisted_7 = { key: 2 };
const _hoisted_8 = ["value"];
const _hoisted_9 = ["value"];
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SIcon = resolveComponent("SIcon");
  return openBlock(), createElementBlock("div", _hoisted_1$6, [
    createElementVNode("div", _hoisted_2$3, [
      createElementVNode("div", {
        class: "flex flex-grow justify-center items-center cursor-pointer hover:bg-gray-200",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.move(-1))
      }, [
        createVNode(_component_SIcon, { icon: "chevron-left" })
      ]),
      createElementVNode("div", {
        class: "flex flex-grow justify-center items-center cursor-pointer hover:bg-gray-200",
        onClick: _cache[1] || (_cache[1] = (...args) => _ctx.toggleSubmode && _ctx.toggleSubmode(...args))
      }, toDisplayString(_ctx.renderDate(_ctx.focusedDate, _ctx.submode == "month" ? "MMMM Y" : "Y")), 1),
      createElementVNode("div", {
        class: "flex flex-grow justify-center items-center cursor-pointer hover:bg-gray-200",
        onClick: _cache[2] || (_cache[2] = ($event) => _ctx.move(1))
      }, [
        createVNode(_component_SIcon, { icon: "chevron-right" })
      ])
    ]),
    _ctx.submode == "month" ? (openBlock(), createElementBlock("div", _hoisted_3, [
      (openBlock(true), createElementBlock(Fragment$1, null, renderList(_ctx.firstWeek, (date2) => {
        return openBlock(), createElementBlock("div", {
          class: normalizeClass(["inline-flex h-8 justify-center items-center", _ctx.dayHeaderClass(date2)])
        }, toDisplayString(date2.date.format("dd")), 3);
      }), 256)),
      (openBlock(true), createElementBlock(Fragment$1, null, renderList(_ctx.visibleDates, (date2) => {
        return openBlock(), createElementBlock("div", {
          class: "h-8",
          onMousedown: ($event) => _ctx.dayClicked(date2)
        }, [
          createElementVNode("div", {
            class: normalizeClass(_ctx.dayClass(date2))
          }, toDisplayString(date2.date.format("D")), 3)
        ], 40, _hoisted_4);
      }), 256))
    ])) : _ctx.submode == "year" ? (openBlock(), createElementBlock("div", _hoisted_5, [
      (openBlock(true), createElementBlock(Fragment$1, null, renderList(_ctx.visibleMonths, (date2) => {
        return openBlock(), createElementBlock("div", {
          class: normalizeClass(["inline-flex h-8 justify-center items-center", _ctx.monthClass(date2)]),
          onMousedown: ($event) => _ctx.monthClicked(date2)
        }, toDisplayString(date2.date.format("MMMM")), 43, _hoisted_6);
      }), 256))
    ])) : createCommentVNode("", true),
    _ctx.mode == "datetime" ? (openBlock(), createElementBlock("div", _hoisted_7, [
      withDirectives(createElementVNode("select", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.h = $event)
      }, [
        (openBlock(true), createElementBlock(Fragment$1, null, renderList(_ctx.hours, (h) => {
          return openBlock(), createElementBlock("option", {
            value: h.value
          }, toDisplayString(h.value), 9, _hoisted_8);
        }), 256))
      ], 512), [
        [vModelSelect, _ctx.h]
      ]),
      withDirectives(createElementVNode("select", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.m = $event)
      }, [
        (openBlock(true), createElementBlock(Fragment$1, null, renderList(_ctx.minutes, (m) => {
          return openBlock(), createElementBlock("option", {
            value: m.value
          }, toDisplayString(m.value), 9, _hoisted_9);
        }), 256))
      ], 512), [
        [vModelSelect, _ctx.m]
      ])
    ])) : createCommentVNode("", true)
  ]);
}
var SCalendar = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8]]);
const _sfc_main$7 = defineComponent({
  props: {
    modelValue: null,
    allowNull: { type: Boolean, default: true },
    renderFormat: { type: String, default() {
      return "Y-MM-DD";
    } },
    displayFormat: { type: String, default() {
      return "DD MMMM Y";
    } },
    mode: { type: String, default() {
      return "date";
    } }
  },
  setup(props, { emit: emit2 }) {
    const calendarState = ref("closed");
    const closeCalendar = () => {
      calendarState.value = "closing";
      nextTick(() => {
        if (calendarState.value == "closing") {
          calendarState.value = "closed";
        }
      });
    };
    return {
      calendarState,
      openCalendar() {
        calendarState.value = "open";
      },
      calendarPicked(value) {
        emit2("update:modelValue", value);
        closeCalendar();
      },
      closeCalendar
    };
  }
});
const _hoisted_1$5 = { class: "relative inline-block" };
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SDateInput = resolveComponent("SDateInput");
  const _component_SCalendar = resolveComponent("SCalendar");
  const _directive_click_outside = resolveDirective("click-outside");
  return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$5, [
    createVNode(_component_SDateInput, {
      onKeydown: [
        withKeys(_ctx.closeCalendar, ["tab"]),
        withKeys(_ctx.closeCalendar, ["esc"])
      ],
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event)),
      modelValue: _ctx.modelValue,
      onFocus: _ctx.openCalendar,
      onMousedown: _ctx.openCalendar
    }, null, 8, ["onKeydown", "modelValue", "onFocus", "onMousedown"]),
    _ctx.calendarState != "closed" ? (openBlock(), createBlock(_component_SCalendar, {
      key: 0,
      "onUpdate:modelValue": _ctx.calendarPicked,
      class: "absolute z-10",
      modelValue: _ctx.modelValue,
      mode: _ctx.mode,
      renderFormat: _ctx.renderFormat,
      displayFormat: _ctx.displayFormat
    }, null, 8, ["onUpdate:modelValue", "modelValue", "mode", "renderFormat", "displayFormat"])) : createCommentVNode("", true)
  ])), [
    [_directive_click_outside, _ctx.closeCalendar]
  ]);
}
var SDatePicker = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7]]);
const _sfc_main$6 = defineComponent({
  props: {
    modelValue: { type: Array },
    deletable: { type: Boolean, default: false },
    itemKey: { type: String, default: "id" },
    itemClass: { type: String, default: "flex-grow border-l-2 border-brand pl-3 py-1" },
    ghostClass: { type: String, default: "bg-table-hover" },
    chosenClass: { type: String, default: "bg-white" },
    dragClass: { type: String, default: "bg-white" },
    wrapperClass: { type: String, default: "flex p-1 items-center" }
  },
  components: { draggable },
  emits: ["update:modelValue"],
  setup(props, { emit: emit2 }) {
    const localList = computed({
      get() {
        return props.modelValue;
      },
      set(value) {
        console.log(value);
        emit2("update:modelValue", value);
      }
    });
    return {
      dragging: ref(false),
      localList,
      setData(dataTransfer, dragEl) {
        dragEl.classList.add("relative");
        const cover = document.createElement("div");
        cover.className = "draggable-cover absolute inset-0";
        dragEl.appendChild(cover);
      },
      onEnd: (evt) => {
        let drags = document.getElementsByClassName("draggable-cover");
        for (let i2 = 0; i2 < drags.length; i2++) {
          drags[i2].remove();
        }
      },
      deleteElement(e, i2) {
        const value = JSON.parse(JSON.stringify(props.modelValue));
        value.splice(i2, 1);
        emit2("update:modelValue", value);
      }
    };
  }
});
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SIcon = resolveComponent("SIcon");
  const _component_SIconButton = resolveComponent("SIconButton");
  const _component_draggable = resolveComponent("draggable");
  return openBlock(), createBlock(_component_draggable, {
    modelValue: _ctx.localList,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.localList = $event),
    onStart: _cache[1] || (_cache[1] = ($event) => _ctx.dragging = true),
    onEnd: [
      _cache[2] || (_cache[2] = ($event) => _ctx.dragging = false),
      _ctx.onEnd
    ],
    setData: _ctx.setData,
    itemKey: _ctx.itemKey,
    handle: ".drag-handle",
    ghostClass: _ctx.ghostClass,
    chosenClass: _ctx.chosenClass,
    dragClass: _ctx.dragClass
  }, {
    item: withCtx(({ element, index: index3 }) => [
      createElementVNode("div", {
        class: normalizeClass(_ctx.wrapperClass)
      }, [
        createVNode(_component_SIcon, {
          icon: "selector",
          class: "drag-handle flex-shrink-0 text-gray-200 hover:text-gray-500 cursor-move"
        }),
        createElementVNode("div", {
          class: normalizeClass(_ctx.itemClass)
        }, [
          renderSlot(_ctx.$slots, "item", {
            item: element,
            index: index3
          }, () => [
            createTextVNode(toDisplayString(element[_ctx.itemKey]), 1)
          ])
        ], 2),
        createVNode(_component_SIconButton, {
          round: "",
          small: "",
          flat: "",
          color: "danger",
          icon: "trash",
          class: "flex-shrink-0",
          onClick: ($event) => _ctx.deleteElement(element, index3)
        }, null, 8, ["onClick"])
      ], 2)
    ]),
    _: 3
  }, 8, ["modelValue", "setData", "onEnd", "itemKey", "ghostClass", "chosenClass", "dragClass"]);
}
var SSortable = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6]]);
const _sfc_main$5 = defineComponent({
  name: "SSortIndicator",
  props: {
    sortInfo: null
  },
  setup(props) {
    return {
      icon: computed(() => {
        return props.sortInfo.dir == "asc" ? "sort-descending" : props.sortInfo.dir == "desc" ? "sort-ascending" : null;
      })
    };
  }
});
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SIcon = resolveComponent("SIcon");
  return _ctx.icon ? (openBlock(), createBlock(_component_SIcon, {
    key: 0,
    icon: _ctx.icon,
    small: ""
  }, null, 8, ["icon"])) : createCommentVNode("", true);
}
var SSortIndicator = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5]]);
const _sfc_main$4 = defineComponent({
  name: "SListHeader",
  props: {
    toggleSort: null,
    sortInfo: null,
    column: null
  }
});
const _hoisted_1$4 = /* @__PURE__ */ createTextVNode();
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SSortIndicator = resolveComponent("SSortIndicator");
  return openBlock(), createElementBlock("div", {
    class: "px-3 py-1 cursor-pointer flex",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.toggleSort($event, _ctx.column))
  }, [
    createElementVNode("span", null, [
      renderSlot(_ctx.$slots, "default")
    ]),
    _hoisted_1$4,
    _ctx.sortInfo[_ctx.column] ? (openBlock(), createBlock(_component_SSortIndicator, {
      key: 0,
      class: "pl-1",
      sortInfo: _ctx.sortInfo[_ctx.column]
    }, null, 8, ["sortInfo"])) : createCommentVNode("", true)
  ]);
}
var SListHeader = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4]]);
function OrderedMap(content2) {
  this.content = content2;
}
OrderedMap.prototype = {
  constructor: OrderedMap,
  find: function(key) {
    for (var i2 = 0; i2 < this.content.length; i2 += 2)
      if (this.content[i2] === key)
        return i2;
    return -1;
  },
  get: function(key) {
    var found2 = this.find(key);
    return found2 == -1 ? void 0 : this.content[found2 + 1];
  },
  update: function(key, value, newKey) {
    var self2 = newKey && newKey != key ? this.remove(newKey) : this;
    var found2 = self2.find(key), content2 = self2.content.slice();
    if (found2 == -1) {
      content2.push(newKey || key, value);
    } else {
      content2[found2 + 1] = value;
      if (newKey)
        content2[found2] = newKey;
    }
    return new OrderedMap(content2);
  },
  remove: function(key) {
    var found2 = this.find(key);
    if (found2 == -1)
      return this;
    var content2 = this.content.slice();
    content2.splice(found2, 2);
    return new OrderedMap(content2);
  },
  addToStart: function(key, value) {
    return new OrderedMap([key, value].concat(this.remove(key).content));
  },
  addToEnd: function(key, value) {
    var content2 = this.remove(key).content.slice();
    content2.push(key, value);
    return new OrderedMap(content2);
  },
  addBefore: function(place, key, value) {
    var without = this.remove(key), content2 = without.content.slice();
    var found2 = without.find(place);
    content2.splice(found2 == -1 ? content2.length : found2, 0, key, value);
    return new OrderedMap(content2);
  },
  forEach: function(f) {
    for (var i2 = 0; i2 < this.content.length; i2 += 2)
      f(this.content[i2], this.content[i2 + 1]);
  },
  prepend: function(map16) {
    map16 = OrderedMap.from(map16);
    if (!map16.size)
      return this;
    return new OrderedMap(map16.content.concat(this.subtract(map16).content));
  },
  append: function(map16) {
    map16 = OrderedMap.from(map16);
    if (!map16.size)
      return this;
    return new OrderedMap(this.subtract(map16).content.concat(map16.content));
  },
  subtract: function(map16) {
    var result2 = this;
    map16 = OrderedMap.from(map16);
    for (var i2 = 0; i2 < map16.content.length; i2 += 2)
      result2 = result2.remove(map16.content[i2]);
    return result2;
  },
  get size() {
    return this.content.length >> 1;
  }
};
OrderedMap.from = function(value) {
  if (value instanceof OrderedMap)
    return value;
  var content2 = [];
  if (value)
    for (var prop in value)
      content2.push(prop, value[prop]);
  return new OrderedMap(content2);
};
var orderedmap = OrderedMap;
function findDiffStart(a, b, pos) {
  for (var i2 = 0; ; i2++) {
    if (i2 == a.childCount || i2 == b.childCount) {
      return a.childCount == b.childCount ? null : pos;
    }
    var childA = a.child(i2), childB = b.child(i2);
    if (childA == childB) {
      pos += childA.nodeSize;
      continue;
    }
    if (!childA.sameMarkup(childB)) {
      return pos;
    }
    if (childA.isText && childA.text != childB.text) {
      for (var j = 0; childA.text[j] == childB.text[j]; j++) {
        pos++;
      }
      return pos;
    }
    if (childA.content.size || childB.content.size) {
      var inner = findDiffStart(childA.content, childB.content, pos + 1);
      if (inner != null) {
        return inner;
      }
    }
    pos += childA.nodeSize;
  }
}
function findDiffEnd(a, b, posA, posB) {
  for (var iA = a.childCount, iB = b.childCount; ; ) {
    if (iA == 0 || iB == 0) {
      return iA == iB ? null : { a: posA, b: posB };
    }
    var childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
    if (childA == childB) {
      posA -= size;
      posB -= size;
      continue;
    }
    if (!childA.sameMarkup(childB)) {
      return { a: posA, b: posB };
    }
    if (childA.isText && childA.text != childB.text) {
      var same = 0, minSize = Math.min(childA.text.length, childB.text.length);
      while (same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]) {
        same++;
        posA--;
        posB--;
      }
      return { a: posA, b: posB };
    }
    if (childA.content.size || childB.content.size) {
      var inner = findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
      if (inner) {
        return inner;
      }
    }
    posA -= size;
    posB -= size;
  }
}
var Fragment = function Fragment2(content2, size) {
  this.content = content2;
  this.size = size || 0;
  if (size == null) {
    for (var i2 = 0; i2 < content2.length; i2++) {
      this.size += content2[i2].nodeSize;
    }
  }
};
var prototypeAccessors$5 = { firstChild: { configurable: true }, lastChild: { configurable: true }, childCount: { configurable: true } };
Fragment.prototype.nodesBetween = function nodesBetween(from5, to2, f, nodeStart, parent) {
  if (nodeStart === void 0)
    nodeStart = 0;
  for (var i2 = 0, pos = 0; pos < to2; i2++) {
    var child3 = this.content[i2], end2 = pos + child3.nodeSize;
    if (end2 > from5 && f(child3, nodeStart + pos, parent, i2) !== false && child3.content.size) {
      var start3 = pos + 1;
      child3.nodesBetween(Math.max(0, from5 - start3), Math.min(child3.content.size, to2 - start3), f, nodeStart + start3);
    }
    pos = end2;
  }
};
Fragment.prototype.descendants = function descendants(f) {
  this.nodesBetween(0, this.size, f);
};
Fragment.prototype.textBetween = function textBetween(from5, to2, blockSeparator, leafText) {
  var text2 = "", separated = true;
  this.nodesBetween(from5, to2, function(node4, pos) {
    if (node4.isText) {
      text2 += node4.text.slice(Math.max(from5, pos) - pos, to2 - pos);
      separated = !blockSeparator;
    } else if (node4.isLeaf && leafText) {
      text2 += typeof leafText === "function" ? leafText(node4) : leafText;
      separated = !blockSeparator;
    } else if (!separated && node4.isBlock) {
      text2 += blockSeparator;
      separated = true;
    }
  }, 0);
  return text2;
};
Fragment.prototype.append = function append(other) {
  if (!other.size) {
    return this;
  }
  if (!this.size) {
    return other;
  }
  var last = this.lastChild, first = other.firstChild, content2 = this.content.slice(), i2 = 0;
  if (last.isText && last.sameMarkup(first)) {
    content2[content2.length - 1] = last.withText(last.text + first.text);
    i2 = 1;
  }
  for (; i2 < other.content.length; i2++) {
    content2.push(other.content[i2]);
  }
  return new Fragment(content2, this.size + other.size);
};
Fragment.prototype.cut = function cut(from5, to2) {
  if (to2 == null) {
    to2 = this.size;
  }
  if (from5 == 0 && to2 == this.size) {
    return this;
  }
  var result2 = [], size = 0;
  if (to2 > from5) {
    for (var i2 = 0, pos = 0; pos < to2; i2++) {
      var child3 = this.content[i2], end2 = pos + child3.nodeSize;
      if (end2 > from5) {
        if (pos < from5 || end2 > to2) {
          if (child3.isText) {
            child3 = child3.cut(Math.max(0, from5 - pos), Math.min(child3.text.length, to2 - pos));
          } else {
            child3 = child3.cut(Math.max(0, from5 - pos - 1), Math.min(child3.content.size, to2 - pos - 1));
          }
        }
        result2.push(child3);
        size += child3.nodeSize;
      }
      pos = end2;
    }
  }
  return new Fragment(result2, size);
};
Fragment.prototype.cutByIndex = function cutByIndex(from5, to2) {
  if (from5 == to2) {
    return Fragment.empty;
  }
  if (from5 == 0 && to2 == this.content.length) {
    return this;
  }
  return new Fragment(this.content.slice(from5, to2));
};
Fragment.prototype.replaceChild = function replaceChild(index3, node4) {
  var current = this.content[index3];
  if (current == node4) {
    return this;
  }
  var copy5 = this.content.slice();
  var size = this.size + node4.nodeSize - current.nodeSize;
  copy5[index3] = node4;
  return new Fragment(copy5, size);
};
Fragment.prototype.addToStart = function addToStart(node4) {
  return new Fragment([node4].concat(this.content), this.size + node4.nodeSize);
};
Fragment.prototype.addToEnd = function addToEnd(node4) {
  return new Fragment(this.content.concat(node4), this.size + node4.nodeSize);
};
Fragment.prototype.eq = function eq(other) {
  if (this.content.length != other.content.length) {
    return false;
  }
  for (var i2 = 0; i2 < this.content.length; i2++) {
    if (!this.content[i2].eq(other.content[i2])) {
      return false;
    }
  }
  return true;
};
prototypeAccessors$5.firstChild.get = function() {
  return this.content.length ? this.content[0] : null;
};
prototypeAccessors$5.lastChild.get = function() {
  return this.content.length ? this.content[this.content.length - 1] : null;
};
prototypeAccessors$5.childCount.get = function() {
  return this.content.length;
};
Fragment.prototype.child = function child(index3) {
  var found2 = this.content[index3];
  if (!found2) {
    throw new RangeError("Index " + index3 + " out of range for " + this);
  }
  return found2;
};
Fragment.prototype.maybeChild = function maybeChild(index3) {
  return this.content[index3];
};
Fragment.prototype.forEach = function forEach(f) {
  for (var i2 = 0, p = 0; i2 < this.content.length; i2++) {
    var child3 = this.content[i2];
    f(child3, p, i2);
    p += child3.nodeSize;
  }
};
Fragment.prototype.findDiffStart = function findDiffStart$1(other, pos) {
  if (pos === void 0)
    pos = 0;
  return findDiffStart(this, other, pos);
};
Fragment.prototype.findDiffEnd = function findDiffEnd$1(other, pos, otherPos) {
  if (pos === void 0)
    pos = this.size;
  if (otherPos === void 0)
    otherPos = other.size;
  return findDiffEnd(this, other, pos, otherPos);
};
Fragment.prototype.findIndex = function findIndex(pos, round2) {
  if (round2 === void 0)
    round2 = -1;
  if (pos == 0) {
    return retIndex(0, pos);
  }
  if (pos == this.size) {
    return retIndex(this.content.length, pos);
  }
  if (pos > this.size || pos < 0) {
    throw new RangeError("Position " + pos + " outside of fragment (" + this + ")");
  }
  for (var i2 = 0, curPos = 0; ; i2++) {
    var cur = this.child(i2), end2 = curPos + cur.nodeSize;
    if (end2 >= pos) {
      if (end2 == pos || round2 > 0) {
        return retIndex(i2 + 1, end2);
      }
      return retIndex(i2, curPos);
    }
    curPos = end2;
  }
};
Fragment.prototype.toString = function toString() {
  return "<" + this.toStringInner() + ">";
};
Fragment.prototype.toStringInner = function toStringInner() {
  return this.content.join(", ");
};
Fragment.prototype.toJSON = function toJSON2() {
  return this.content.length ? this.content.map(function(n) {
    return n.toJSON();
  }) : null;
};
Fragment.fromJSON = function fromJSON(schema, value) {
  if (!value) {
    return Fragment.empty;
  }
  if (!Array.isArray(value)) {
    throw new RangeError("Invalid input for Fragment.fromJSON");
  }
  return new Fragment(value.map(schema.nodeFromJSON));
};
Fragment.fromArray = function fromArray(array) {
  if (!array.length) {
    return Fragment.empty;
  }
  var joined, size = 0;
  for (var i2 = 0; i2 < array.length; i2++) {
    var node4 = array[i2];
    size += node4.nodeSize;
    if (i2 && node4.isText && array[i2 - 1].sameMarkup(node4)) {
      if (!joined) {
        joined = array.slice(0, i2);
      }
      joined[joined.length - 1] = node4.withText(joined[joined.length - 1].text + node4.text);
    } else if (joined) {
      joined.push(node4);
    }
  }
  return new Fragment(joined || array, size);
};
Fragment.from = function from2(nodes) {
  if (!nodes) {
    return Fragment.empty;
  }
  if (nodes instanceof Fragment) {
    return nodes;
  }
  if (Array.isArray(nodes)) {
    return this.fromArray(nodes);
  }
  if (nodes.attrs) {
    return new Fragment([nodes], nodes.nodeSize);
  }
  throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
};
Object.defineProperties(Fragment.prototype, prototypeAccessors$5);
var found = { index: 0, offset: 0 };
function retIndex(index3, offset3) {
  found.index = index3;
  found.offset = offset3;
  return found;
}
Fragment.empty = new Fragment([], 0);
function compareDeep(a, b) {
  if (a === b) {
    return true;
  }
  if (!(a && typeof a == "object") || !(b && typeof b == "object")) {
    return false;
  }
  var array = Array.isArray(a);
  if (Array.isArray(b) != array) {
    return false;
  }
  if (array) {
    if (a.length != b.length) {
      return false;
    }
    for (var i2 = 0; i2 < a.length; i2++) {
      if (!compareDeep(a[i2], b[i2])) {
        return false;
      }
    }
  } else {
    for (var p in a) {
      if (!(p in b) || !compareDeep(a[p], b[p])) {
        return false;
      }
    }
    for (var p$1 in b) {
      if (!(p$1 in a)) {
        return false;
      }
    }
  }
  return true;
}
var Mark = function Mark2(type, attrs) {
  this.type = type;
  this.attrs = attrs;
};
Mark.prototype.addToSet = function addToSet(set3) {
  var copy5, placed = false;
  for (var i2 = 0; i2 < set3.length; i2++) {
    var other = set3[i2];
    if (this.eq(other)) {
      return set3;
    }
    if (this.type.excludes(other.type)) {
      if (!copy5) {
        copy5 = set3.slice(0, i2);
      }
    } else if (other.type.excludes(this.type)) {
      return set3;
    } else {
      if (!placed && other.type.rank > this.type.rank) {
        if (!copy5) {
          copy5 = set3.slice(0, i2);
        }
        copy5.push(this);
        placed = true;
      }
      if (copy5) {
        copy5.push(other);
      }
    }
  }
  if (!copy5) {
    copy5 = set3.slice();
  }
  if (!placed) {
    copy5.push(this);
  }
  return copy5;
};
Mark.prototype.removeFromSet = function removeFromSet(set3) {
  for (var i2 = 0; i2 < set3.length; i2++) {
    if (this.eq(set3[i2])) {
      return set3.slice(0, i2).concat(set3.slice(i2 + 1));
    }
  }
  return set3;
};
Mark.prototype.isInSet = function isInSet(set3) {
  for (var i2 = 0; i2 < set3.length; i2++) {
    if (this.eq(set3[i2])) {
      return true;
    }
  }
  return false;
};
Mark.prototype.eq = function eq2(other) {
  return this == other || this.type == other.type && compareDeep(this.attrs, other.attrs);
};
Mark.prototype.toJSON = function toJSON3() {
  var obj = { type: this.type.name };
  for (var _ in this.attrs) {
    obj.attrs = this.attrs;
    break;
  }
  return obj;
};
Mark.fromJSON = function fromJSON2(schema, json) {
  if (!json) {
    throw new RangeError("Invalid input for Mark.fromJSON");
  }
  var type = schema.marks[json.type];
  if (!type) {
    throw new RangeError("There is no mark type " + json.type + " in this schema");
  }
  return type.create(json.attrs);
};
Mark.sameSet = function sameSet(a, b) {
  if (a == b) {
    return true;
  }
  if (a.length != b.length) {
    return false;
  }
  for (var i2 = 0; i2 < a.length; i2++) {
    if (!a[i2].eq(b[i2])) {
      return false;
    }
  }
  return true;
};
Mark.setFrom = function setFrom(marks2) {
  if (!marks2 || marks2.length == 0) {
    return Mark.none;
  }
  if (marks2 instanceof Mark) {
    return [marks2];
  }
  var copy5 = marks2.slice();
  copy5.sort(function(a, b) {
    return a.type.rank - b.type.rank;
  });
  return copy5;
};
Mark.none = [];
function ReplaceError(message) {
  var err2 = Error.call(this, message);
  err2.__proto__ = ReplaceError.prototype;
  return err2;
}
ReplaceError.prototype = Object.create(Error.prototype);
ReplaceError.prototype.constructor = ReplaceError;
ReplaceError.prototype.name = "ReplaceError";
var Slice = function Slice2(content2, openStart, openEnd) {
  this.content = content2;
  this.openStart = openStart;
  this.openEnd = openEnd;
};
var prototypeAccessors$1$3 = { size: { configurable: true } };
prototypeAccessors$1$3.size.get = function() {
  return this.content.size - this.openStart - this.openEnd;
};
Slice.prototype.insertAt = function insertAt(pos, fragment) {
  var content2 = insertInto(this.content, pos + this.openStart, fragment, null);
  return content2 && new Slice(content2, this.openStart, this.openEnd);
};
Slice.prototype.removeBetween = function removeBetween(from5, to2) {
  return new Slice(removeRange(this.content, from5 + this.openStart, to2 + this.openStart), this.openStart, this.openEnd);
};
Slice.prototype.eq = function eq3(other) {
  return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
};
Slice.prototype.toString = function toString2() {
  return this.content + "(" + this.openStart + "," + this.openEnd + ")";
};
Slice.prototype.toJSON = function toJSON4() {
  if (!this.content.size) {
    return null;
  }
  var json = { content: this.content.toJSON() };
  if (this.openStart > 0) {
    json.openStart = this.openStart;
  }
  if (this.openEnd > 0) {
    json.openEnd = this.openEnd;
  }
  return json;
};
Slice.fromJSON = function fromJSON3(schema, json) {
  if (!json) {
    return Slice.empty;
  }
  var openStart = json.openStart || 0, openEnd = json.openEnd || 0;
  if (typeof openStart != "number" || typeof openEnd != "number") {
    throw new RangeError("Invalid input for Slice.fromJSON");
  }
  return new Slice(Fragment.fromJSON(schema, json.content), openStart, openEnd);
};
Slice.maxOpen = function maxOpen(fragment, openIsolating) {
  if (openIsolating === void 0)
    openIsolating = true;
  var openStart = 0, openEnd = 0;
  for (var n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild) {
    openStart++;
  }
  for (var n$1 = fragment.lastChild; n$1 && !n$1.isLeaf && (openIsolating || !n$1.type.spec.isolating); n$1 = n$1.lastChild) {
    openEnd++;
  }
  return new Slice(fragment, openStart, openEnd);
};
Object.defineProperties(Slice.prototype, prototypeAccessors$1$3);
function removeRange(content2, from5, to2) {
  var ref2 = content2.findIndex(from5);
  var index3 = ref2.index;
  var offset3 = ref2.offset;
  var child3 = content2.maybeChild(index3);
  var ref$1 = content2.findIndex(to2);
  var indexTo = ref$1.index;
  var offsetTo = ref$1.offset;
  if (offset3 == from5 || child3.isText) {
    if (offsetTo != to2 && !content2.child(indexTo).isText) {
      throw new RangeError("Removing non-flat range");
    }
    return content2.cut(0, from5).append(content2.cut(to2));
  }
  if (index3 != indexTo) {
    throw new RangeError("Removing non-flat range");
  }
  return content2.replaceChild(index3, child3.copy(removeRange(child3.content, from5 - offset3 - 1, to2 - offset3 - 1)));
}
function insertInto(content2, dist, insert, parent) {
  var ref2 = content2.findIndex(dist);
  var index3 = ref2.index;
  var offset3 = ref2.offset;
  var child3 = content2.maybeChild(index3);
  if (offset3 == dist || child3.isText) {
    if (parent && !parent.canReplace(index3, index3, insert)) {
      return null;
    }
    return content2.cut(0, dist).append(insert).append(content2.cut(dist));
  }
  var inner = insertInto(child3.content, dist - offset3 - 1, insert);
  return inner && content2.replaceChild(index3, child3.copy(inner));
}
Slice.empty = new Slice(Fragment.empty, 0, 0);
function replace($from, $to, slice4) {
  if (slice4.openStart > $from.depth) {
    throw new ReplaceError("Inserted content deeper than insertion position");
  }
  if ($from.depth - slice4.openStart != $to.depth - slice4.openEnd) {
    throw new ReplaceError("Inconsistent open depths");
  }
  return replaceOuter($from, $to, slice4, 0);
}
function replaceOuter($from, $to, slice4, depth) {
  var index3 = $from.index(depth), node4 = $from.node(depth);
  if (index3 == $to.index(depth) && depth < $from.depth - slice4.openStart) {
    var inner = replaceOuter($from, $to, slice4, depth + 1);
    return node4.copy(node4.content.replaceChild(index3, inner));
  } else if (!slice4.content.size) {
    return close(node4, replaceTwoWay($from, $to, depth));
  } else if (!slice4.openStart && !slice4.openEnd && $from.depth == depth && $to.depth == depth) {
    var parent = $from.parent, content2 = parent.content;
    return close(parent, content2.cut(0, $from.parentOffset).append(slice4.content).append(content2.cut($to.parentOffset)));
  } else {
    var ref2 = prepareSliceForReplace(slice4, $from);
    var start3 = ref2.start;
    var end2 = ref2.end;
    return close(node4, replaceThreeWay($from, start3, end2, $to, depth));
  }
}
function checkJoin(main, sub) {
  if (!sub.type.compatibleContent(main.type)) {
    throw new ReplaceError("Cannot join " + sub.type.name + " onto " + main.type.name);
  }
}
function joinable$1($before, $after, depth) {
  var node4 = $before.node(depth);
  checkJoin(node4, $after.node(depth));
  return node4;
}
function addNode(child3, target) {
  var last = target.length - 1;
  if (last >= 0 && child3.isText && child3.sameMarkup(target[last])) {
    target[last] = child3.withText(target[last].text + child3.text);
  } else {
    target.push(child3);
  }
}
function addRange($start, $end, depth, target) {
  var node4 = ($end || $start).node(depth);
  var startIndex = 0, endIndex = $end ? $end.index(depth) : node4.childCount;
  if ($start) {
    startIndex = $start.index(depth);
    if ($start.depth > depth) {
      startIndex++;
    } else if ($start.textOffset) {
      addNode($start.nodeAfter, target);
      startIndex++;
    }
  }
  for (var i2 = startIndex; i2 < endIndex; i2++) {
    addNode(node4.child(i2), target);
  }
  if ($end && $end.depth == depth && $end.textOffset) {
    addNode($end.nodeBefore, target);
  }
}
function close(node4, content2) {
  if (!node4.type.validContent(content2)) {
    throw new ReplaceError("Invalid content for node " + node4.type.name);
  }
  return node4.copy(content2);
}
function replaceThreeWay($from, $start, $end, $to, depth) {
  var openStart = $from.depth > depth && joinable$1($from, $start, depth + 1);
  var openEnd = $to.depth > depth && joinable$1($end, $to, depth + 1);
  var content2 = [];
  addRange(null, $from, depth, content2);
  if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
    checkJoin(openStart, openEnd);
    addNode(close(openStart, replaceThreeWay($from, $start, $end, $to, depth + 1)), content2);
  } else {
    if (openStart) {
      addNode(close(openStart, replaceTwoWay($from, $start, depth + 1)), content2);
    }
    addRange($start, $end, depth, content2);
    if (openEnd) {
      addNode(close(openEnd, replaceTwoWay($end, $to, depth + 1)), content2);
    }
  }
  addRange($to, null, depth, content2);
  return new Fragment(content2);
}
function replaceTwoWay($from, $to, depth) {
  var content2 = [];
  addRange(null, $from, depth, content2);
  if ($from.depth > depth) {
    var type = joinable$1($from, $to, depth + 1);
    addNode(close(type, replaceTwoWay($from, $to, depth + 1)), content2);
  }
  addRange($to, null, depth, content2);
  return new Fragment(content2);
}
function prepareSliceForReplace(slice4, $along) {
  var extra = $along.depth - slice4.openStart, parent = $along.node(extra);
  var node4 = parent.copy(slice4.content);
  for (var i2 = extra - 1; i2 >= 0; i2--) {
    node4 = $along.node(i2).copy(Fragment.from(node4));
  }
  return {
    start: node4.resolveNoCache(slice4.openStart + extra),
    end: node4.resolveNoCache(node4.content.size - slice4.openEnd - extra)
  };
}
var ResolvedPos = function ResolvedPos2(pos, path, parentOffset) {
  this.pos = pos;
  this.path = path;
  this.depth = path.length / 3 - 1;
  this.parentOffset = parentOffset;
};
var prototypeAccessors$2$1 = { parent: { configurable: true }, doc: { configurable: true }, textOffset: { configurable: true }, nodeAfter: { configurable: true }, nodeBefore: { configurable: true } };
ResolvedPos.prototype.resolveDepth = function resolveDepth(val) {
  if (val == null) {
    return this.depth;
  }
  if (val < 0) {
    return this.depth + val;
  }
  return val;
};
prototypeAccessors$2$1.parent.get = function() {
  return this.node(this.depth);
};
prototypeAccessors$2$1.doc.get = function() {
  return this.node(0);
};
ResolvedPos.prototype.node = function node(depth) {
  return this.path[this.resolveDepth(depth) * 3];
};
ResolvedPos.prototype.index = function index(depth) {
  return this.path[this.resolveDepth(depth) * 3 + 1];
};
ResolvedPos.prototype.indexAfter = function indexAfter(depth) {
  depth = this.resolveDepth(depth);
  return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
};
ResolvedPos.prototype.start = function start(depth) {
  depth = this.resolveDepth(depth);
  return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
};
ResolvedPos.prototype.end = function end(depth) {
  depth = this.resolveDepth(depth);
  return this.start(depth) + this.node(depth).content.size;
};
ResolvedPos.prototype.before = function before(depth) {
  depth = this.resolveDepth(depth);
  if (!depth) {
    throw new RangeError("There is no position before the top-level node");
  }
  return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
};
ResolvedPos.prototype.after = function after(depth) {
  depth = this.resolveDepth(depth);
  if (!depth) {
    throw new RangeError("There is no position after the top-level node");
  }
  return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
};
prototypeAccessors$2$1.textOffset.get = function() {
  return this.pos - this.path[this.path.length - 1];
};
prototypeAccessors$2$1.nodeAfter.get = function() {
  var parent = this.parent, index3 = this.index(this.depth);
  if (index3 == parent.childCount) {
    return null;
  }
  var dOff = this.pos - this.path[this.path.length - 1], child3 = parent.child(index3);
  return dOff ? parent.child(index3).cut(dOff) : child3;
};
prototypeAccessors$2$1.nodeBefore.get = function() {
  var index3 = this.index(this.depth);
  var dOff = this.pos - this.path[this.path.length - 1];
  if (dOff) {
    return this.parent.child(index3).cut(0, dOff);
  }
  return index3 == 0 ? null : this.parent.child(index3 - 1);
};
ResolvedPos.prototype.posAtIndex = function posAtIndex(index3, depth) {
  depth = this.resolveDepth(depth);
  var node4 = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
  for (var i2 = 0; i2 < index3; i2++) {
    pos += node4.child(i2).nodeSize;
  }
  return pos;
};
ResolvedPos.prototype.marks = function marks() {
  var parent = this.parent, index3 = this.index();
  if (parent.content.size == 0) {
    return Mark.none;
  }
  if (this.textOffset) {
    return parent.child(index3).marks;
  }
  var main = parent.maybeChild(index3 - 1), other = parent.maybeChild(index3);
  if (!main) {
    var tmp = main;
    main = other;
    other = tmp;
  }
  var marks2 = main.marks;
  for (var i2 = 0; i2 < marks2.length; i2++) {
    if (marks2[i2].type.spec.inclusive === false && (!other || !marks2[i2].isInSet(other.marks))) {
      marks2 = marks2[i2--].removeFromSet(marks2);
    }
  }
  return marks2;
};
ResolvedPos.prototype.marksAcross = function marksAcross($end) {
  var after2 = this.parent.maybeChild(this.index());
  if (!after2 || !after2.isInline) {
    return null;
  }
  var marks2 = after2.marks, next = $end.parent.maybeChild($end.index());
  for (var i2 = 0; i2 < marks2.length; i2++) {
    if (marks2[i2].type.spec.inclusive === false && (!next || !marks2[i2].isInSet(next.marks))) {
      marks2 = marks2[i2--].removeFromSet(marks2);
    }
  }
  return marks2;
};
ResolvedPos.prototype.sharedDepth = function sharedDepth(pos) {
  for (var depth = this.depth; depth > 0; depth--) {
    if (this.start(depth) <= pos && this.end(depth) >= pos) {
      return depth;
    }
  }
  return 0;
};
ResolvedPos.prototype.blockRange = function blockRange(other, pred) {
  if (other === void 0)
    other = this;
  if (other.pos < this.pos) {
    return other.blockRange(this);
  }
  for (var d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--) {
    if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) {
      return new NodeRange(this, other, d);
    }
  }
};
ResolvedPos.prototype.sameParent = function sameParent(other) {
  return this.pos - this.parentOffset == other.pos - other.parentOffset;
};
ResolvedPos.prototype.max = function max2(other) {
  return other.pos > this.pos ? other : this;
};
ResolvedPos.prototype.min = function min2(other) {
  return other.pos < this.pos ? other : this;
};
ResolvedPos.prototype.toString = function toString3() {
  var str = "";
  for (var i2 = 1; i2 <= this.depth; i2++) {
    str += (str ? "/" : "") + this.node(i2).type.name + "_" + this.index(i2 - 1);
  }
  return str + ":" + this.parentOffset;
};
ResolvedPos.resolve = function resolve(doc2, pos) {
  if (!(pos >= 0 && pos <= doc2.content.size)) {
    throw new RangeError("Position " + pos + " out of range");
  }
  var path = [];
  var start3 = 0, parentOffset = pos;
  for (var node4 = doc2; ; ) {
    var ref2 = node4.content.findIndex(parentOffset);
    var index3 = ref2.index;
    var offset3 = ref2.offset;
    var rem = parentOffset - offset3;
    path.push(node4, index3, start3 + offset3);
    if (!rem) {
      break;
    }
    node4 = node4.child(index3);
    if (node4.isText) {
      break;
    }
    parentOffset = rem - 1;
    start3 += offset3 + 1;
  }
  return new ResolvedPos(pos, path, parentOffset);
};
ResolvedPos.resolveCached = function resolveCached(doc2, pos) {
  for (var i2 = 0; i2 < resolveCache.length; i2++) {
    var cached = resolveCache[i2];
    if (cached.pos == pos && cached.doc == doc2) {
      return cached;
    }
  }
  var result2 = resolveCache[resolveCachePos] = ResolvedPos.resolve(doc2, pos);
  resolveCachePos = (resolveCachePos + 1) % resolveCacheSize;
  return result2;
};
Object.defineProperties(ResolvedPos.prototype, prototypeAccessors$2$1);
var resolveCache = [], resolveCachePos = 0, resolveCacheSize = 12;
var NodeRange = function NodeRange2($from, $to, depth) {
  this.$from = $from;
  this.$to = $to;
  this.depth = depth;
};
var prototypeAccessors$1$1$1 = { start: { configurable: true }, end: { configurable: true }, parent: { configurable: true }, startIndex: { configurable: true }, endIndex: { configurable: true } };
prototypeAccessors$1$1$1.start.get = function() {
  return this.$from.before(this.depth + 1);
};
prototypeAccessors$1$1$1.end.get = function() {
  return this.$to.after(this.depth + 1);
};
prototypeAccessors$1$1$1.parent.get = function() {
  return this.$from.node(this.depth);
};
prototypeAccessors$1$1$1.startIndex.get = function() {
  return this.$from.index(this.depth);
};
prototypeAccessors$1$1$1.endIndex.get = function() {
  return this.$to.indexAfter(this.depth);
};
Object.defineProperties(NodeRange.prototype, prototypeAccessors$1$1$1);
var emptyAttrs = /* @__PURE__ */ Object.create(null);
var Node$1 = function Node2(type, attrs, content2, marks2) {
  this.type = type;
  this.attrs = attrs;
  this.content = content2 || Fragment.empty;
  this.marks = marks2 || Mark.none;
};
var prototypeAccessors$3$1 = { nodeSize: { configurable: true }, childCount: { configurable: true }, textContent: { configurable: true }, firstChild: { configurable: true }, lastChild: { configurable: true }, isBlock: { configurable: true }, isTextblock: { configurable: true }, inlineContent: { configurable: true }, isInline: { configurable: true }, isText: { configurable: true }, isLeaf: { configurable: true }, isAtom: { configurable: true } };
prototypeAccessors$3$1.nodeSize.get = function() {
  return this.isLeaf ? 1 : 2 + this.content.size;
};
prototypeAccessors$3$1.childCount.get = function() {
  return this.content.childCount;
};
Node$1.prototype.child = function child2(index3) {
  return this.content.child(index3);
};
Node$1.prototype.maybeChild = function maybeChild2(index3) {
  return this.content.maybeChild(index3);
};
Node$1.prototype.forEach = function forEach2(f) {
  this.content.forEach(f);
};
Node$1.prototype.nodesBetween = function nodesBetween2(from5, to2, f, startPos) {
  if (startPos === void 0)
    startPos = 0;
  this.content.nodesBetween(from5, to2, f, startPos, this);
};
Node$1.prototype.descendants = function descendants2(f) {
  this.nodesBetween(0, this.content.size, f);
};
prototypeAccessors$3$1.textContent.get = function() {
  return this.textBetween(0, this.content.size, "");
};
Node$1.prototype.textBetween = function textBetween2(from5, to2, blockSeparator, leafText) {
  return this.content.textBetween(from5, to2, blockSeparator, leafText);
};
prototypeAccessors$3$1.firstChild.get = function() {
  return this.content.firstChild;
};
prototypeAccessors$3$1.lastChild.get = function() {
  return this.content.lastChild;
};
Node$1.prototype.eq = function eq4(other) {
  return this == other || this.sameMarkup(other) && this.content.eq(other.content);
};
Node$1.prototype.sameMarkup = function sameMarkup(other) {
  return this.hasMarkup(other.type, other.attrs, other.marks);
};
Node$1.prototype.hasMarkup = function hasMarkup(type, attrs, marks2) {
  return this.type == type && compareDeep(this.attrs, attrs || type.defaultAttrs || emptyAttrs) && Mark.sameSet(this.marks, marks2 || Mark.none);
};
Node$1.prototype.copy = function copy(content2) {
  if (content2 === void 0)
    content2 = null;
  if (content2 == this.content) {
    return this;
  }
  return new this.constructor(this.type, this.attrs, content2, this.marks);
};
Node$1.prototype.mark = function mark(marks2) {
  return marks2 == this.marks ? this : new this.constructor(this.type, this.attrs, this.content, marks2);
};
Node$1.prototype.cut = function cut2(from5, to2) {
  if (from5 == 0 && to2 == this.content.size) {
    return this;
  }
  return this.copy(this.content.cut(from5, to2));
};
Node$1.prototype.slice = function slice(from5, to2, includeParents) {
  if (to2 === void 0)
    to2 = this.content.size;
  if (includeParents === void 0)
    includeParents = false;
  if (from5 == to2) {
    return Slice.empty;
  }
  var $from = this.resolve(from5), $to = this.resolve(to2);
  var depth = includeParents ? 0 : $from.sharedDepth(to2);
  var start3 = $from.start(depth), node4 = $from.node(depth);
  var content2 = node4.content.cut($from.pos - start3, $to.pos - start3);
  return new Slice(content2, $from.depth - depth, $to.depth - depth);
};
Node$1.prototype.replace = function replace$1(from5, to2, slice4) {
  return replace(this.resolve(from5), this.resolve(to2), slice4);
};
Node$1.prototype.nodeAt = function nodeAt(pos) {
  for (var node4 = this; ; ) {
    var ref2 = node4.content.findIndex(pos);
    var index3 = ref2.index;
    var offset3 = ref2.offset;
    node4 = node4.maybeChild(index3);
    if (!node4) {
      return null;
    }
    if (offset3 == pos || node4.isText) {
      return node4;
    }
    pos -= offset3 + 1;
  }
};
Node$1.prototype.childAfter = function childAfter(pos) {
  var ref2 = this.content.findIndex(pos);
  var index3 = ref2.index;
  var offset3 = ref2.offset;
  return { node: this.content.maybeChild(index3), index: index3, offset: offset3 };
};
Node$1.prototype.childBefore = function childBefore(pos) {
  if (pos == 0) {
    return { node: null, index: 0, offset: 0 };
  }
  var ref2 = this.content.findIndex(pos);
  var index3 = ref2.index;
  var offset3 = ref2.offset;
  if (offset3 < pos) {
    return { node: this.content.child(index3), index: index3, offset: offset3 };
  }
  var node4 = this.content.child(index3 - 1);
  return { node: node4, index: index3 - 1, offset: offset3 - node4.nodeSize };
};
Node$1.prototype.resolve = function resolve2(pos) {
  return ResolvedPos.resolveCached(this, pos);
};
Node$1.prototype.resolveNoCache = function resolveNoCache(pos) {
  return ResolvedPos.resolve(this, pos);
};
Node$1.prototype.rangeHasMark = function rangeHasMark(from5, to2, type) {
  var found2 = false;
  if (to2 > from5) {
    this.nodesBetween(from5, to2, function(node4) {
      if (type.isInSet(node4.marks)) {
        found2 = true;
      }
      return !found2;
    });
  }
  return found2;
};
prototypeAccessors$3$1.isBlock.get = function() {
  return this.type.isBlock;
};
prototypeAccessors$3$1.isTextblock.get = function() {
  return this.type.isTextblock;
};
prototypeAccessors$3$1.inlineContent.get = function() {
  return this.type.inlineContent;
};
prototypeAccessors$3$1.isInline.get = function() {
  return this.type.isInline;
};
prototypeAccessors$3$1.isText.get = function() {
  return this.type.isText;
};
prototypeAccessors$3$1.isLeaf.get = function() {
  return this.type.isLeaf;
};
prototypeAccessors$3$1.isAtom.get = function() {
  return this.type.isAtom;
};
Node$1.prototype.toString = function toString4() {
  if (this.type.spec.toDebugString) {
    return this.type.spec.toDebugString(this);
  }
  var name = this.type.name;
  if (this.content.size) {
    name += "(" + this.content.toStringInner() + ")";
  }
  return wrapMarks(this.marks, name);
};
Node$1.prototype.contentMatchAt = function contentMatchAt(index3) {
  var match = this.type.contentMatch.matchFragment(this.content, 0, index3);
  if (!match) {
    throw new Error("Called contentMatchAt on a node with invalid content");
  }
  return match;
};
Node$1.prototype.canReplace = function canReplace(from5, to2, replacement, start3, end2) {
  if (replacement === void 0)
    replacement = Fragment.empty;
  if (start3 === void 0)
    start3 = 0;
  if (end2 === void 0)
    end2 = replacement.childCount;
  var one = this.contentMatchAt(from5).matchFragment(replacement, start3, end2);
  var two = one && one.matchFragment(this.content, to2);
  if (!two || !two.validEnd) {
    return false;
  }
  for (var i2 = start3; i2 < end2; i2++) {
    if (!this.type.allowsMarks(replacement.child(i2).marks)) {
      return false;
    }
  }
  return true;
};
Node$1.prototype.canReplaceWith = function canReplaceWith(from5, to2, type, marks2) {
  if (marks2 && !this.type.allowsMarks(marks2)) {
    return false;
  }
  var start3 = this.contentMatchAt(from5).matchType(type);
  var end2 = start3 && start3.matchFragment(this.content, to2);
  return end2 ? end2.validEnd : false;
};
Node$1.prototype.canAppend = function canAppend(other) {
  if (other.content.size) {
    return this.canReplace(this.childCount, this.childCount, other.content);
  } else {
    return this.type.compatibleContent(other.type);
  }
};
Node$1.prototype.check = function check2() {
  if (!this.type.validContent(this.content)) {
    throw new RangeError("Invalid content for node " + this.type.name + ": " + this.content.toString().slice(0, 50));
  }
  var copy5 = Mark.none;
  for (var i2 = 0; i2 < this.marks.length; i2++) {
    copy5 = this.marks[i2].addToSet(copy5);
  }
  if (!Mark.sameSet(copy5, this.marks)) {
    throw new RangeError("Invalid collection of marks for node " + this.type.name + ": " + this.marks.map(function(m) {
      return m.type.name;
    }));
  }
  this.content.forEach(function(node4) {
    return node4.check();
  });
};
Node$1.prototype.toJSON = function toJSON5() {
  var obj = { type: this.type.name };
  for (var _ in this.attrs) {
    obj.attrs = this.attrs;
    break;
  }
  if (this.content.size) {
    obj.content = this.content.toJSON();
  }
  if (this.marks.length) {
    obj.marks = this.marks.map(function(n) {
      return n.toJSON();
    });
  }
  return obj;
};
Node$1.fromJSON = function fromJSON4(schema, json) {
  if (!json) {
    throw new RangeError("Invalid input for Node.fromJSON");
  }
  var marks2 = null;
  if (json.marks) {
    if (!Array.isArray(json.marks)) {
      throw new RangeError("Invalid mark data for Node.fromJSON");
    }
    marks2 = json.marks.map(schema.markFromJSON);
  }
  if (json.type == "text") {
    if (typeof json.text != "string") {
      throw new RangeError("Invalid text node in JSON");
    }
    return schema.text(json.text, marks2);
  }
  var content2 = Fragment.fromJSON(schema, json.content);
  return schema.nodeType(json.type).create(json.attrs, content2, marks2);
};
Object.defineProperties(Node$1.prototype, prototypeAccessors$3$1);
var TextNode = /* @__PURE__ */ function(Node3) {
  function TextNode2(type, attrs, content2, marks2) {
    Node3.call(this, type, attrs, null, marks2);
    if (!content2) {
      throw new RangeError("Empty text nodes are not allowed");
    }
    this.text = content2;
  }
  if (Node3)
    TextNode2.__proto__ = Node3;
  TextNode2.prototype = Object.create(Node3 && Node3.prototype);
  TextNode2.prototype.constructor = TextNode2;
  var prototypeAccessors$12 = { textContent: { configurable: true }, nodeSize: { configurable: true } };
  TextNode2.prototype.toString = function toString8() {
    if (this.type.spec.toDebugString) {
      return this.type.spec.toDebugString(this);
    }
    return wrapMarks(this.marks, JSON.stringify(this.text));
  };
  prototypeAccessors$12.textContent.get = function() {
    return this.text;
  };
  TextNode2.prototype.textBetween = function textBetween3(from5, to2) {
    return this.text.slice(from5, to2);
  };
  prototypeAccessors$12.nodeSize.get = function() {
    return this.text.length;
  };
  TextNode2.prototype.mark = function mark3(marks2) {
    return marks2 == this.marks ? this : new TextNode2(this.type, this.attrs, this.text, marks2);
  };
  TextNode2.prototype.withText = function withText(text2) {
    if (text2 == this.text) {
      return this;
    }
    return new TextNode2(this.type, this.attrs, text2, this.marks);
  };
  TextNode2.prototype.cut = function cut3(from5, to2) {
    if (from5 === void 0)
      from5 = 0;
    if (to2 === void 0)
      to2 = this.text.length;
    if (from5 == 0 && to2 == this.text.length) {
      return this;
    }
    return this.withText(this.text.slice(from5, to2));
  };
  TextNode2.prototype.eq = function eq12(other) {
    return this.sameMarkup(other) && this.text == other.text;
  };
  TextNode2.prototype.toJSON = function toJSON8() {
    var base2 = Node3.prototype.toJSON.call(this);
    base2.text = this.text;
    return base2;
  };
  Object.defineProperties(TextNode2.prototype, prototypeAccessors$12);
  return TextNode2;
}(Node$1);
function wrapMarks(marks2, str) {
  for (var i2 = marks2.length - 1; i2 >= 0; i2--) {
    str = marks2[i2].type.name + "(" + str + ")";
  }
  return str;
}
var ContentMatch = function ContentMatch2(validEnd) {
  this.validEnd = validEnd;
  this.next = [];
  this.wrapCache = [];
};
var prototypeAccessors$4$1 = { inlineContent: { configurable: true }, defaultType: { configurable: true }, edgeCount: { configurable: true } };
ContentMatch.parse = function parse(string2, nodeTypes) {
  var stream = new TokenStream(string2, nodeTypes);
  if (stream.next == null) {
    return ContentMatch.empty;
  }
  var expr = parseExpr(stream);
  if (stream.next) {
    stream.err("Unexpected trailing text");
  }
  var match = dfa(nfa(expr));
  checkForDeadEnds(match, stream);
  return match;
};
ContentMatch.prototype.matchType = function matchType(type) {
  for (var i2 = 0; i2 < this.next.length; i2 += 2) {
    if (this.next[i2] == type) {
      return this.next[i2 + 1];
    }
  }
  return null;
};
ContentMatch.prototype.matchFragment = function matchFragment(frag, start3, end2) {
  if (start3 === void 0)
    start3 = 0;
  if (end2 === void 0)
    end2 = frag.childCount;
  var cur = this;
  for (var i2 = start3; cur && i2 < end2; i2++) {
    cur = cur.matchType(frag.child(i2).type);
  }
  return cur;
};
prototypeAccessors$4$1.inlineContent.get = function() {
  var first = this.next[0];
  return first ? first.isInline : false;
};
prototypeAccessors$4$1.defaultType.get = function() {
  for (var i2 = 0; i2 < this.next.length; i2 += 2) {
    var type = this.next[i2];
    if (!(type.isText || type.hasRequiredAttrs())) {
      return type;
    }
  }
};
ContentMatch.prototype.compatible = function compatible(other) {
  for (var i2 = 0; i2 < this.next.length; i2 += 2) {
    for (var j = 0; j < other.next.length; j += 2) {
      if (this.next[i2] == other.next[j]) {
        return true;
      }
    }
  }
  return false;
};
ContentMatch.prototype.fillBefore = function fillBefore(after2, toEnd, startIndex) {
  if (toEnd === void 0)
    toEnd = false;
  if (startIndex === void 0)
    startIndex = 0;
  var seen = [this];
  function search2(match, types) {
    var finished = match.matchFragment(after2, startIndex);
    if (finished && (!toEnd || finished.validEnd)) {
      return Fragment.from(types.map(function(tp) {
        return tp.createAndFill();
      }));
    }
    for (var i2 = 0; i2 < match.next.length; i2 += 2) {
      var type = match.next[i2], next = match.next[i2 + 1];
      if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
        seen.push(next);
        var found2 = search2(next, types.concat(type));
        if (found2) {
          return found2;
        }
      }
    }
  }
  return search2(this, []);
};
ContentMatch.prototype.findWrapping = function findWrapping(target) {
  for (var i2 = 0; i2 < this.wrapCache.length; i2 += 2) {
    if (this.wrapCache[i2] == target) {
      return this.wrapCache[i2 + 1];
    }
  }
  var computed2 = this.computeWrapping(target);
  this.wrapCache.push(target, computed2);
  return computed2;
};
ContentMatch.prototype.computeWrapping = function computeWrapping(target) {
  var seen = /* @__PURE__ */ Object.create(null), active = [{ match: this, type: null, via: null }];
  while (active.length) {
    var current = active.shift(), match = current.match;
    if (match.matchType(target)) {
      var result2 = [];
      for (var obj = current; obj.type; obj = obj.via) {
        result2.push(obj.type);
      }
      return result2.reverse();
    }
    for (var i2 = 0; i2 < match.next.length; i2 += 2) {
      var type = match.next[i2];
      if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || match.next[i2 + 1].validEnd)) {
        active.push({ match: type.contentMatch, type, via: current });
        seen[type.name] = true;
      }
    }
  }
};
prototypeAccessors$4$1.edgeCount.get = function() {
  return this.next.length >> 1;
};
ContentMatch.prototype.edge = function edge(n) {
  var i2 = n << 1;
  if (i2 >= this.next.length) {
    throw new RangeError("There's no " + n + "th edge in this content match");
  }
  return { type: this.next[i2], next: this.next[i2 + 1] };
};
ContentMatch.prototype.toString = function toString5() {
  var seen = [];
  function scan(m) {
    seen.push(m);
    for (var i2 = 1; i2 < m.next.length; i2 += 2) {
      if (seen.indexOf(m.next[i2]) == -1) {
        scan(m.next[i2]);
      }
    }
  }
  scan(this);
  return seen.map(function(m, i2) {
    var out = i2 + (m.validEnd ? "*" : " ") + " ";
    for (var i$1 = 0; i$1 < m.next.length; i$1 += 2) {
      out += (i$1 ? ", " : "") + m.next[i$1].name + "->" + seen.indexOf(m.next[i$1 + 1]);
    }
    return out;
  }).join("\n");
};
Object.defineProperties(ContentMatch.prototype, prototypeAccessors$4$1);
ContentMatch.empty = new ContentMatch(true);
var TokenStream = function TokenStream2(string2, nodeTypes) {
  this.string = string2;
  this.nodeTypes = nodeTypes;
  this.inline = null;
  this.pos = 0;
  this.tokens = string2.split(/\s*(?=\b|\W|$)/);
  if (this.tokens[this.tokens.length - 1] == "") {
    this.tokens.pop();
  }
  if (this.tokens[0] == "") {
    this.tokens.shift();
  }
};
var prototypeAccessors$1$2$1 = { next: { configurable: true } };
prototypeAccessors$1$2$1.next.get = function() {
  return this.tokens[this.pos];
};
TokenStream.prototype.eat = function eat(tok) {
  return this.next == tok && (this.pos++ || true);
};
TokenStream.prototype.err = function err(str) {
  throw new SyntaxError(str + " (in content expression '" + this.string + "')");
};
Object.defineProperties(TokenStream.prototype, prototypeAccessors$1$2$1);
function parseExpr(stream) {
  var exprs = [];
  do {
    exprs.push(parseExprSeq(stream));
  } while (stream.eat("|"));
  return exprs.length == 1 ? exprs[0] : { type: "choice", exprs };
}
function parseExprSeq(stream) {
  var exprs = [];
  do {
    exprs.push(parseExprSubscript(stream));
  } while (stream.next && stream.next != ")" && stream.next != "|");
  return exprs.length == 1 ? exprs[0] : { type: "seq", exprs };
}
function parseExprSubscript(stream) {
  var expr = parseExprAtom(stream);
  for (; ; ) {
    if (stream.eat("+")) {
      expr = { type: "plus", expr };
    } else if (stream.eat("*")) {
      expr = { type: "star", expr };
    } else if (stream.eat("?")) {
      expr = { type: "opt", expr };
    } else if (stream.eat("{")) {
      expr = parseExprRange(stream, expr);
    } else {
      break;
    }
  }
  return expr;
}
function parseNum(stream) {
  if (/\D/.test(stream.next)) {
    stream.err("Expected number, got '" + stream.next + "'");
  }
  var result2 = Number(stream.next);
  stream.pos++;
  return result2;
}
function parseExprRange(stream, expr) {
  var min3 = parseNum(stream), max3 = min3;
  if (stream.eat(",")) {
    if (stream.next != "}") {
      max3 = parseNum(stream);
    } else {
      max3 = -1;
    }
  }
  if (!stream.eat("}")) {
    stream.err("Unclosed braced range");
  }
  return { type: "range", min: min3, max: max3, expr };
}
function resolveName(stream, name) {
  var types = stream.nodeTypes, type = types[name];
  if (type) {
    return [type];
  }
  var result2 = [];
  for (var typeName in types) {
    var type$1 = types[typeName];
    if (type$1.groups.indexOf(name) > -1) {
      result2.push(type$1);
    }
  }
  if (result2.length == 0) {
    stream.err("No node type or group '" + name + "' found");
  }
  return result2;
}
function parseExprAtom(stream) {
  if (stream.eat("(")) {
    var expr = parseExpr(stream);
    if (!stream.eat(")")) {
      stream.err("Missing closing paren");
    }
    return expr;
  } else if (!/\W/.test(stream.next)) {
    var exprs = resolveName(stream, stream.next).map(function(type) {
      if (stream.inline == null) {
        stream.inline = type.isInline;
      } else if (stream.inline != type.isInline) {
        stream.err("Mixing inline and block content");
      }
      return { type: "name", value: type };
    });
    stream.pos++;
    return exprs.length == 1 ? exprs[0] : { type: "choice", exprs };
  } else {
    stream.err("Unexpected token '" + stream.next + "'");
  }
}
function nfa(expr) {
  var nfa2 = [[]];
  connect(compile3(expr, 0), node4());
  return nfa2;
  function node4() {
    return nfa2.push([]) - 1;
  }
  function edge2(from5, to2, term) {
    var edge3 = { term, to: to2 };
    nfa2[from5].push(edge3);
    return edge3;
  }
  function connect(edges, to2) {
    edges.forEach(function(edge3) {
      return edge3.to = to2;
    });
  }
  function compile3(expr2, from5) {
    if (expr2.type == "choice") {
      return expr2.exprs.reduce(function(out, expr3) {
        return out.concat(compile3(expr3, from5));
      }, []);
    } else if (expr2.type == "seq") {
      for (var i2 = 0; ; i2++) {
        var next = compile3(expr2.exprs[i2], from5);
        if (i2 == expr2.exprs.length - 1) {
          return next;
        }
        connect(next, from5 = node4());
      }
    } else if (expr2.type == "star") {
      var loop = node4();
      edge2(from5, loop);
      connect(compile3(expr2.expr, loop), loop);
      return [edge2(loop)];
    } else if (expr2.type == "plus") {
      var loop$1 = node4();
      connect(compile3(expr2.expr, from5), loop$1);
      connect(compile3(expr2.expr, loop$1), loop$1);
      return [edge2(loop$1)];
    } else if (expr2.type == "opt") {
      return [edge2(from5)].concat(compile3(expr2.expr, from5));
    } else if (expr2.type == "range") {
      var cur = from5;
      for (var i$1 = 0; i$1 < expr2.min; i$1++) {
        var next$1 = node4();
        connect(compile3(expr2.expr, cur), next$1);
        cur = next$1;
      }
      if (expr2.max == -1) {
        connect(compile3(expr2.expr, cur), cur);
      } else {
        for (var i$2 = expr2.min; i$2 < expr2.max; i$2++) {
          var next$2 = node4();
          edge2(cur, next$2);
          connect(compile3(expr2.expr, cur), next$2);
          cur = next$2;
        }
      }
      return [edge2(cur)];
    } else if (expr2.type == "name") {
      return [edge2(from5, null, expr2.value)];
    }
  }
}
function cmp(a, b) {
  return b - a;
}
function nullFrom(nfa2, node4) {
  var result2 = [];
  scan(node4);
  return result2.sort(cmp);
  function scan(node5) {
    var edges = nfa2[node5];
    if (edges.length == 1 && !edges[0].term) {
      return scan(edges[0].to);
    }
    result2.push(node5);
    for (var i2 = 0; i2 < edges.length; i2++) {
      var ref2 = edges[i2];
      var term = ref2.term;
      var to2 = ref2.to;
      if (!term && result2.indexOf(to2) == -1) {
        scan(to2);
      }
    }
  }
}
function dfa(nfa2) {
  var labeled = /* @__PURE__ */ Object.create(null);
  return explore(nullFrom(nfa2, 0));
  function explore(states) {
    var out = [];
    states.forEach(function(node4) {
      nfa2[node4].forEach(function(ref2) {
        var term = ref2.term;
        var to2 = ref2.to;
        if (!term) {
          return;
        }
        var known = out.indexOf(term), set3 = known > -1 && out[known + 1];
        nullFrom(nfa2, to2).forEach(function(node5) {
          if (!set3) {
            out.push(term, set3 = []);
          }
          if (set3.indexOf(node5) == -1) {
            set3.push(node5);
          }
        });
      });
    });
    var state = labeled[states.join(",")] = new ContentMatch(states.indexOf(nfa2.length - 1) > -1);
    for (var i2 = 0; i2 < out.length; i2 += 2) {
      var states$1 = out[i2 + 1].sort(cmp);
      state.next.push(out[i2], labeled[states$1.join(",")] || explore(states$1));
    }
    return state;
  }
}
function checkForDeadEnds(match, stream) {
  for (var i2 = 0, work = [match]; i2 < work.length; i2++) {
    var state = work[i2], dead = !state.validEnd, nodes = [];
    for (var j = 0; j < state.next.length; j += 2) {
      var node4 = state.next[j], next = state.next[j + 1];
      nodes.push(node4.name);
      if (dead && !(node4.isText || node4.hasRequiredAttrs())) {
        dead = false;
      }
      if (work.indexOf(next) == -1) {
        work.push(next);
      }
    }
    if (dead) {
      stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
  }
}
function defaultAttrs(attrs) {
  var defaults2 = /* @__PURE__ */ Object.create(null);
  for (var attrName in attrs) {
    var attr = attrs[attrName];
    if (!attr.hasDefault) {
      return null;
    }
    defaults2[attrName] = attr.default;
  }
  return defaults2;
}
function computeAttrs(attrs, value) {
  var built = /* @__PURE__ */ Object.create(null);
  for (var name in attrs) {
    var given = value && value[name];
    if (given === void 0) {
      var attr = attrs[name];
      if (attr.hasDefault) {
        given = attr.default;
      } else {
        throw new RangeError("No value supplied for attribute " + name);
      }
    }
    built[name] = given;
  }
  return built;
}
function initAttrs(attrs) {
  var result2 = /* @__PURE__ */ Object.create(null);
  if (attrs) {
    for (var name in attrs) {
      result2[name] = new Attribute(attrs[name]);
    }
  }
  return result2;
}
var NodeType$1 = function NodeType(name, schema, spec) {
  this.name = name;
  this.schema = schema;
  this.spec = spec;
  this.groups = spec.group ? spec.group.split(" ") : [];
  this.attrs = initAttrs(spec.attrs);
  this.defaultAttrs = defaultAttrs(this.attrs);
  this.contentMatch = null;
  this.markSet = null;
  this.inlineContent = null;
  this.isBlock = !(spec.inline || name == "text");
  this.isText = name == "text";
};
var prototypeAccessors$5$1 = { isInline: { configurable: true }, isTextblock: { configurable: true }, isLeaf: { configurable: true }, isAtom: { configurable: true }, whitespace: { configurable: true } };
prototypeAccessors$5$1.isInline.get = function() {
  return !this.isBlock;
};
prototypeAccessors$5$1.isTextblock.get = function() {
  return this.isBlock && this.inlineContent;
};
prototypeAccessors$5$1.isLeaf.get = function() {
  return this.contentMatch == ContentMatch.empty;
};
prototypeAccessors$5$1.isAtom.get = function() {
  return this.isLeaf || this.spec.atom;
};
prototypeAccessors$5$1.whitespace.get = function() {
  return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
};
NodeType$1.prototype.hasRequiredAttrs = function hasRequiredAttrs() {
  for (var n in this.attrs) {
    if (this.attrs[n].isRequired) {
      return true;
    }
  }
  return false;
};
NodeType$1.prototype.compatibleContent = function compatibleContent(other) {
  return this == other || this.contentMatch.compatible(other.contentMatch);
};
NodeType$1.prototype.computeAttrs = function computeAttrs$1(attrs) {
  if (!attrs && this.defaultAttrs) {
    return this.defaultAttrs;
  } else {
    return computeAttrs(this.attrs, attrs);
  }
};
NodeType$1.prototype.create = function create(attrs, content2, marks2) {
  if (this.isText) {
    throw new Error("NodeType.create can't construct text nodes");
  }
  return new Node$1(this, this.computeAttrs(attrs), Fragment.from(content2), Mark.setFrom(marks2));
};
NodeType$1.prototype.createChecked = function createChecked(attrs, content2, marks2) {
  content2 = Fragment.from(content2);
  if (!this.validContent(content2)) {
    throw new RangeError("Invalid content for node " + this.name);
  }
  return new Node$1(this, this.computeAttrs(attrs), content2, Mark.setFrom(marks2));
};
NodeType$1.prototype.createAndFill = function createAndFill(attrs, content2, marks2) {
  attrs = this.computeAttrs(attrs);
  content2 = Fragment.from(content2);
  if (content2.size) {
    var before2 = this.contentMatch.fillBefore(content2);
    if (!before2) {
      return null;
    }
    content2 = before2.append(content2);
  }
  var after2 = this.contentMatch.matchFragment(content2).fillBefore(Fragment.empty, true);
  if (!after2) {
    return null;
  }
  return new Node$1(this, attrs, content2.append(after2), Mark.setFrom(marks2));
};
NodeType$1.prototype.validContent = function validContent(content2) {
  var result2 = this.contentMatch.matchFragment(content2);
  if (!result2 || !result2.validEnd) {
    return false;
  }
  for (var i2 = 0; i2 < content2.childCount; i2++) {
    if (!this.allowsMarks(content2.child(i2).marks)) {
      return false;
    }
  }
  return true;
};
NodeType$1.prototype.allowsMarkType = function allowsMarkType(markType) {
  return this.markSet == null || this.markSet.indexOf(markType) > -1;
};
NodeType$1.prototype.allowsMarks = function allowsMarks(marks2) {
  if (this.markSet == null) {
    return true;
  }
  for (var i2 = 0; i2 < marks2.length; i2++) {
    if (!this.allowsMarkType(marks2[i2].type)) {
      return false;
    }
  }
  return true;
};
NodeType$1.prototype.allowedMarks = function allowedMarks(marks2) {
  if (this.markSet == null) {
    return marks2;
  }
  var copy5;
  for (var i2 = 0; i2 < marks2.length; i2++) {
    if (!this.allowsMarkType(marks2[i2].type)) {
      if (!copy5) {
        copy5 = marks2.slice(0, i2);
      }
    } else if (copy5) {
      copy5.push(marks2[i2]);
    }
  }
  return !copy5 ? marks2 : copy5.length ? copy5 : Mark.empty;
};
NodeType$1.compile = function compile(nodes, schema) {
  var result2 = /* @__PURE__ */ Object.create(null);
  nodes.forEach(function(name, spec) {
    return result2[name] = new NodeType$1(name, schema, spec);
  });
  var topType = schema.spec.topNode || "doc";
  if (!result2[topType]) {
    throw new RangeError("Schema is missing its top node type ('" + topType + "')");
  }
  if (!result2.text) {
    throw new RangeError("Every schema needs a 'text' type");
  }
  for (var _ in result2.text.attrs) {
    throw new RangeError("The text node type should not have attributes");
  }
  return result2;
};
Object.defineProperties(NodeType$1.prototype, prototypeAccessors$5$1);
var Attribute = function Attribute2(options) {
  this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
  this.default = options.default;
};
var prototypeAccessors$1$3$1 = { isRequired: { configurable: true } };
prototypeAccessors$1$3$1.isRequired.get = function() {
  return !this.hasDefault;
};
Object.defineProperties(Attribute.prototype, prototypeAccessors$1$3$1);
var MarkType = function MarkType2(name, rank, schema, spec) {
  this.name = name;
  this.schema = schema;
  this.spec = spec;
  this.attrs = initAttrs(spec.attrs);
  this.rank = rank;
  this.excluded = null;
  var defaults2 = defaultAttrs(this.attrs);
  this.instance = defaults2 && new Mark(this, defaults2);
};
MarkType.prototype.create = function create2(attrs) {
  if (!attrs && this.instance) {
    return this.instance;
  }
  return new Mark(this, computeAttrs(this.attrs, attrs));
};
MarkType.compile = function compile2(marks2, schema) {
  var result2 = /* @__PURE__ */ Object.create(null), rank = 0;
  marks2.forEach(function(name, spec) {
    return result2[name] = new MarkType(name, rank++, schema, spec);
  });
  return result2;
};
MarkType.prototype.removeFromSet = function removeFromSet2(set3) {
  for (var i2 = 0; i2 < set3.length; i2++) {
    if (set3[i2].type == this) {
      set3 = set3.slice(0, i2).concat(set3.slice(i2 + 1));
      i2--;
    }
  }
  return set3;
};
MarkType.prototype.isInSet = function isInSet2(set3) {
  for (var i2 = 0; i2 < set3.length; i2++) {
    if (set3[i2].type == this) {
      return set3[i2];
    }
  }
};
MarkType.prototype.excludes = function excludes(other) {
  return this.excluded.indexOf(other) > -1;
};
var Schema = function Schema2(spec) {
  this.spec = {};
  for (var prop in spec) {
    this.spec[prop] = spec[prop];
  }
  this.spec.nodes = orderedmap.from(spec.nodes);
  this.spec.marks = orderedmap.from(spec.marks);
  this.nodes = NodeType$1.compile(this.spec.nodes, this);
  this.marks = MarkType.compile(this.spec.marks, this);
  var contentExprCache = /* @__PURE__ */ Object.create(null);
  for (var prop$1 in this.nodes) {
    if (prop$1 in this.marks) {
      throw new RangeError(prop$1 + " can not be both a node and a mark");
    }
    var type = this.nodes[prop$1], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
    type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = ContentMatch.parse(contentExpr, this.nodes));
    type.inlineContent = type.contentMatch.inlineContent;
    type.markSet = markExpr == "_" ? null : markExpr ? gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
  }
  for (var prop$2 in this.marks) {
    var type$1 = this.marks[prop$2], excl = type$1.spec.excludes;
    type$1.excluded = excl == null ? [type$1] : excl == "" ? [] : gatherMarks(this, excl.split(" "));
  }
  this.nodeFromJSON = this.nodeFromJSON.bind(this);
  this.markFromJSON = this.markFromJSON.bind(this);
  this.topNodeType = this.nodes[this.spec.topNode || "doc"];
  this.cached = /* @__PURE__ */ Object.create(null);
  this.cached.wrappings = /* @__PURE__ */ Object.create(null);
};
Schema.prototype.node = function node2(type, attrs, content2, marks2) {
  if (typeof type == "string") {
    type = this.nodeType(type);
  } else if (!(type instanceof NodeType$1)) {
    throw new RangeError("Invalid node type: " + type);
  } else if (type.schema != this) {
    throw new RangeError("Node type from different schema used (" + type.name + ")");
  }
  return type.createChecked(attrs, content2, marks2);
};
Schema.prototype.text = function text(text$1, marks2) {
  var type = this.nodes.text;
  return new TextNode(type, type.defaultAttrs, text$1, Mark.setFrom(marks2));
};
Schema.prototype.mark = function mark2(type, attrs) {
  if (typeof type == "string") {
    type = this.marks[type];
  }
  return type.create(attrs);
};
Schema.prototype.nodeFromJSON = function nodeFromJSON(json) {
  return Node$1.fromJSON(this, json);
};
Schema.prototype.markFromJSON = function markFromJSON(json) {
  return Mark.fromJSON(this, json);
};
Schema.prototype.nodeType = function nodeType(name) {
  var found2 = this.nodes[name];
  if (!found2) {
    throw new RangeError("Unknown node type: " + name);
  }
  return found2;
};
function gatherMarks(schema, marks2) {
  var found2 = [];
  for (var i2 = 0; i2 < marks2.length; i2++) {
    var name = marks2[i2], mark3 = schema.marks[name], ok2 = mark3;
    if (mark3) {
      found2.push(mark3);
    } else {
      for (var prop in schema.marks) {
        var mark$1 = schema.marks[prop];
        if (name == "_" || mark$1.spec.group && mark$1.spec.group.split(" ").indexOf(name) > -1) {
          found2.push(ok2 = mark$1);
        }
      }
    }
    if (!ok2) {
      throw new SyntaxError("Unknown mark type: '" + marks2[i2] + "'");
    }
  }
  return found2;
}
var DOMParser = function DOMParser2(schema, rules) {
  var this$1$1 = this;
  this.schema = schema;
  this.rules = rules;
  this.tags = [];
  this.styles = [];
  rules.forEach(function(rule) {
    if (rule.tag) {
      this$1$1.tags.push(rule);
    } else if (rule.style) {
      this$1$1.styles.push(rule);
    }
  });
  this.normalizeLists = !this.tags.some(function(r) {
    if (!/^(ul|ol)\b/.test(r.tag) || !r.node) {
      return false;
    }
    var node4 = schema.nodes[r.node];
    return node4.contentMatch.matchType(node4);
  });
};
DOMParser.prototype.parse = function parse2(dom, options) {
  if (options === void 0)
    options = {};
  var context = new ParseContext(this, options, false);
  context.addAll(dom, null, options.from, options.to);
  return context.finish();
};
DOMParser.prototype.parseSlice = function parseSlice(dom, options) {
  if (options === void 0)
    options = {};
  var context = new ParseContext(this, options, true);
  context.addAll(dom, null, options.from, options.to);
  return Slice.maxOpen(context.finish());
};
DOMParser.prototype.matchTag = function matchTag(dom, context, after2) {
  for (var i2 = after2 ? this.tags.indexOf(after2) + 1 : 0; i2 < this.tags.length; i2++) {
    var rule = this.tags[i2];
    if (matches(dom, rule.tag) && (rule.namespace === void 0 || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
      if (rule.getAttrs) {
        var result2 = rule.getAttrs(dom);
        if (result2 === false) {
          continue;
        }
        rule.attrs = result2;
      }
      return rule;
    }
  }
};
DOMParser.prototype.matchStyle = function matchStyle(prop, value, context, after2) {
  for (var i2 = after2 ? this.styles.indexOf(after2) + 1 : 0; i2 < this.styles.length; i2++) {
    var rule = this.styles[i2];
    if (rule.style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || rule.style.length > prop.length && (rule.style.charCodeAt(prop.length) != 61 || rule.style.slice(prop.length + 1) != value)) {
      continue;
    }
    if (rule.getAttrs) {
      var result2 = rule.getAttrs(value);
      if (result2 === false) {
        continue;
      }
      rule.attrs = result2;
    }
    return rule;
  }
};
DOMParser.schemaRules = function schemaRules(schema) {
  var result2 = [];
  function insert(rule) {
    var priority = rule.priority == null ? 50 : rule.priority, i2 = 0;
    for (; i2 < result2.length; i2++) {
      var next = result2[i2], nextPriority = next.priority == null ? 50 : next.priority;
      if (nextPriority < priority) {
        break;
      }
    }
    result2.splice(i2, 0, rule);
  }
  var loop = function(name2) {
    var rules = schema.marks[name2].spec.parseDOM;
    if (rules) {
      rules.forEach(function(rule) {
        insert(rule = copy2(rule));
        rule.mark = name2;
      });
    }
  };
  for (var name in schema.marks)
    loop(name);
  var loop$1 = function(name2) {
    var rules$1 = schema.nodes[name$1].spec.parseDOM;
    if (rules$1) {
      rules$1.forEach(function(rule) {
        insert(rule = copy2(rule));
        rule.node = name$1;
      });
    }
  };
  for (var name$1 in schema.nodes)
    loop$1();
  return result2;
};
DOMParser.fromSchema = function fromSchema(schema) {
  return schema.cached.domParser || (schema.cached.domParser = new DOMParser(schema, DOMParser.schemaRules(schema)));
};
var blockTags = {
  address: true,
  article: true,
  aside: true,
  blockquote: true,
  canvas: true,
  dd: true,
  div: true,
  dl: true,
  fieldset: true,
  figcaption: true,
  figure: true,
  footer: true,
  form: true,
  h1: true,
  h2: true,
  h3: true,
  h4: true,
  h5: true,
  h6: true,
  header: true,
  hgroup: true,
  hr: true,
  li: true,
  noscript: true,
  ol: true,
  output: true,
  p: true,
  pre: true,
  section: true,
  table: true,
  tfoot: true,
  ul: true
};
var ignoreTags = {
  head: true,
  noscript: true,
  object: true,
  script: true,
  style: true,
  title: true
};
var listTags = { ol: true, ul: true };
var OPT_PRESERVE_WS = 1, OPT_PRESERVE_WS_FULL = 2, OPT_OPEN_LEFT = 4;
function wsOptionsFor(type, preserveWhitespace, base2) {
  if (preserveWhitespace != null) {
    return (preserveWhitespace ? OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? OPT_PRESERVE_WS_FULL : 0);
  }
  return type && type.whitespace == "pre" ? OPT_PRESERVE_WS | OPT_PRESERVE_WS_FULL : base2 & ~OPT_OPEN_LEFT;
}
var NodeContext = function NodeContext2(type, attrs, marks2, pendingMarks, solid, match, options) {
  this.type = type;
  this.attrs = attrs;
  this.solid = solid;
  this.match = match || (options & OPT_OPEN_LEFT ? null : type.contentMatch);
  this.options = options;
  this.content = [];
  this.marks = marks2;
  this.activeMarks = Mark.none;
  this.pendingMarks = pendingMarks;
  this.stashMarks = [];
};
NodeContext.prototype.findWrapping = function findWrapping2(node4) {
  if (!this.match) {
    if (!this.type) {
      return [];
    }
    var fill = this.type.contentMatch.fillBefore(Fragment.from(node4));
    if (fill) {
      this.match = this.type.contentMatch.matchFragment(fill);
    } else {
      var start3 = this.type.contentMatch, wrap;
      if (wrap = start3.findWrapping(node4.type)) {
        this.match = start3;
        return wrap;
      } else {
        return null;
      }
    }
  }
  return this.match.findWrapping(node4.type);
};
NodeContext.prototype.finish = function finish(openEnd) {
  if (!(this.options & OPT_PRESERVE_WS)) {
    var last = this.content[this.content.length - 1], m;
    if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
      if (last.text.length == m[0].length) {
        this.content.pop();
      } else {
        this.content[this.content.length - 1] = last.withText(last.text.slice(0, last.text.length - m[0].length));
      }
    }
  }
  var content2 = Fragment.from(this.content);
  if (!openEnd && this.match) {
    content2 = content2.append(this.match.fillBefore(Fragment.empty, true));
  }
  return this.type ? this.type.create(this.attrs, content2, this.marks) : content2;
};
NodeContext.prototype.popFromStashMark = function popFromStashMark(mark3) {
  for (var i2 = this.stashMarks.length - 1; i2 >= 0; i2--) {
    if (mark3.eq(this.stashMarks[i2])) {
      return this.stashMarks.splice(i2, 1)[0];
    }
  }
};
NodeContext.prototype.applyPending = function applyPending(nextType) {
  for (var i2 = 0, pending = this.pendingMarks; i2 < pending.length; i2++) {
    var mark3 = pending[i2];
    if ((this.type ? this.type.allowsMarkType(mark3.type) : markMayApply(mark3.type, nextType)) && !mark3.isInSet(this.activeMarks)) {
      this.activeMarks = mark3.addToSet(this.activeMarks);
      this.pendingMarks = mark3.removeFromSet(this.pendingMarks);
    }
  }
};
NodeContext.prototype.inlineContext = function inlineContext(node4) {
  if (this.type) {
    return this.type.inlineContent;
  }
  if (this.content.length) {
    return this.content[0].isInline;
  }
  return node4.parentNode && !blockTags.hasOwnProperty(node4.parentNode.nodeName.toLowerCase());
};
var ParseContext = function ParseContext2(parser, options, open) {
  this.parser = parser;
  this.options = options;
  this.isOpen = open;
  var topNode = options.topNode, topContext;
  var topOptions = wsOptionsFor(null, options.preserveWhitespace, 0) | (open ? OPT_OPEN_LEFT : 0);
  if (topNode) {
    topContext = new NodeContext(topNode.type, topNode.attrs, Mark.none, Mark.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
  } else if (open) {
    topContext = new NodeContext(null, null, Mark.none, Mark.none, true, null, topOptions);
  } else {
    topContext = new NodeContext(parser.schema.topNodeType, null, Mark.none, Mark.none, true, null, topOptions);
  }
  this.nodes = [topContext];
  this.open = 0;
  this.find = options.findPositions;
  this.needsBlock = false;
};
var prototypeAccessors$6 = { top: { configurable: true }, currentPos: { configurable: true } };
prototypeAccessors$6.top.get = function() {
  return this.nodes[this.open];
};
ParseContext.prototype.addDOM = function addDOM(dom) {
  if (dom.nodeType == 3) {
    this.addTextNode(dom);
  } else if (dom.nodeType == 1) {
    var style = dom.getAttribute("style");
    var marks2 = style ? this.readStyles(parseStyles(style)) : null, top = this.top;
    if (marks2 != null) {
      for (var i2 = 0; i2 < marks2.length; i2++) {
        this.addPendingMark(marks2[i2]);
      }
    }
    this.addElement(dom);
    if (marks2 != null) {
      for (var i$1 = 0; i$1 < marks2.length; i$1++) {
        this.removePendingMark(marks2[i$1], top);
      }
    }
  }
};
ParseContext.prototype.addTextNode = function addTextNode(dom) {
  var value = dom.nodeValue;
  var top = this.top;
  if (top.options & OPT_PRESERVE_WS_FULL || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
    if (!(top.options & OPT_PRESERVE_WS)) {
      value = value.replace(/[ \t\r\n\u000c]+/g, " ");
      if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
        var nodeBefore = top.content[top.content.length - 1];
        var domNodeBefore = dom.previousSibling;
        if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == "BR" || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) {
          value = value.slice(1);
        }
      }
    } else if (!(top.options & OPT_PRESERVE_WS_FULL)) {
      value = value.replace(/\r?\n|\r/g, " ");
    } else {
      value = value.replace(/\r\n?/g, "\n");
    }
    if (value) {
      this.insertNode(this.parser.schema.text(value));
    }
    this.findInText(dom);
  } else {
    this.findInside(dom);
  }
};
ParseContext.prototype.addElement = function addElement(dom, matchAfter) {
  var name = dom.nodeName.toLowerCase(), ruleID;
  if (listTags.hasOwnProperty(name) && this.parser.normalizeLists) {
    normalizeList(dom);
  }
  var rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
  if (rule ? rule.ignore : ignoreTags.hasOwnProperty(name)) {
    this.findInside(dom);
    this.ignoreFallback(dom);
  } else if (!rule || rule.skip || rule.closeParent) {
    if (rule && rule.closeParent) {
      this.open = Math.max(0, this.open - 1);
    } else if (rule && rule.skip.nodeType) {
      dom = rule.skip;
    }
    var sync2, top = this.top, oldNeedsBlock = this.needsBlock;
    if (blockTags.hasOwnProperty(name)) {
      sync2 = true;
      if (!top.type) {
        this.needsBlock = true;
      }
    } else if (!dom.firstChild) {
      this.leafFallback(dom);
      return;
    }
    this.addAll(dom);
    if (sync2) {
      this.sync(top);
    }
    this.needsBlock = oldNeedsBlock;
  } else {
    this.addElementByRule(dom, rule, rule.consuming === false ? ruleID : null);
  }
};
ParseContext.prototype.leafFallback = function leafFallback(dom) {
  if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) {
    this.addTextNode(dom.ownerDocument.createTextNode("\n"));
  }
};
ParseContext.prototype.ignoreFallback = function ignoreFallback(dom) {
  if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) {
    this.findPlace(this.parser.schema.text("-"));
  }
};
ParseContext.prototype.readStyles = function readStyles(styles2) {
  var marks2 = Mark.none;
  style:
    for (var i2 = 0; i2 < styles2.length; i2 += 2) {
      for (var after2 = null; ; ) {
        var rule = this.parser.matchStyle(styles2[i2], styles2[i2 + 1], this, after2);
        if (!rule) {
          continue style;
        }
        if (rule.ignore) {
          return null;
        }
        marks2 = this.parser.schema.marks[rule.mark].create(rule.attrs).addToSet(marks2);
        if (rule.consuming === false) {
          after2 = rule;
        } else {
          break;
        }
      }
    }
  return marks2;
};
ParseContext.prototype.addElementByRule = function addElementByRule(dom, rule, continueAfter) {
  var this$1$1 = this;
  var sync2, nodeType2, markType, mark3;
  if (rule.node) {
    nodeType2 = this.parser.schema.nodes[rule.node];
    if (!nodeType2.isLeaf) {
      sync2 = this.enter(nodeType2, rule.attrs, rule.preserveWhitespace);
    } else if (!this.insertNode(nodeType2.create(rule.attrs))) {
      this.leafFallback(dom);
    }
  } else {
    markType = this.parser.schema.marks[rule.mark];
    mark3 = markType.create(rule.attrs);
    this.addPendingMark(mark3);
  }
  var startIn = this.top;
  if (nodeType2 && nodeType2.isLeaf) {
    this.findInside(dom);
  } else if (continueAfter) {
    this.addElement(dom, continueAfter);
  } else if (rule.getContent) {
    this.findInside(dom);
    rule.getContent(dom, this.parser.schema).forEach(function(node4) {
      return this$1$1.insertNode(node4);
    });
  } else {
    var contentDOM = rule.contentElement;
    if (typeof contentDOM == "string") {
      contentDOM = dom.querySelector(contentDOM);
    } else if (typeof contentDOM == "function") {
      contentDOM = contentDOM(dom);
    }
    if (!contentDOM) {
      contentDOM = dom;
    }
    this.findAround(dom, contentDOM, true);
    this.addAll(contentDOM, sync2);
  }
  if (sync2) {
    this.sync(startIn);
    this.open--;
  }
  if (mark3) {
    this.removePendingMark(mark3, startIn);
  }
};
ParseContext.prototype.addAll = function addAll(parent, sync2, startIndex, endIndex) {
  var index3 = startIndex || 0;
  for (var dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end2 = endIndex == null ? null : parent.childNodes[endIndex]; dom != end2; dom = dom.nextSibling, ++index3) {
    this.findAtPoint(parent, index3);
    this.addDOM(dom);
    if (sync2 && blockTags.hasOwnProperty(dom.nodeName.toLowerCase())) {
      this.sync(sync2);
    }
  }
  this.findAtPoint(parent, index3);
};
ParseContext.prototype.findPlace = function findPlace(node4) {
  var route2, sync2;
  for (var depth = this.open; depth >= 0; depth--) {
    var cx = this.nodes[depth];
    var found2 = cx.findWrapping(node4);
    if (found2 && (!route2 || route2.length > found2.length)) {
      route2 = found2;
      sync2 = cx;
      if (!found2.length) {
        break;
      }
    }
    if (cx.solid) {
      break;
    }
  }
  if (!route2) {
    return false;
  }
  this.sync(sync2);
  for (var i2 = 0; i2 < route2.length; i2++) {
    this.enterInner(route2[i2], null, false);
  }
  return true;
};
ParseContext.prototype.insertNode = function insertNode(node4) {
  if (node4.isInline && this.needsBlock && !this.top.type) {
    var block = this.textblockFromContext();
    if (block) {
      this.enterInner(block);
    }
  }
  if (this.findPlace(node4)) {
    this.closeExtra();
    var top = this.top;
    top.applyPending(node4.type);
    if (top.match) {
      top.match = top.match.matchType(node4.type);
    }
    var marks2 = top.activeMarks;
    for (var i2 = 0; i2 < node4.marks.length; i2++) {
      if (!top.type || top.type.allowsMarkType(node4.marks[i2].type)) {
        marks2 = node4.marks[i2].addToSet(marks2);
      }
    }
    top.content.push(node4.mark(marks2));
    return true;
  }
  return false;
};
ParseContext.prototype.enter = function enter(type, attrs, preserveWS) {
  var ok2 = this.findPlace(type.create(attrs));
  if (ok2) {
    this.enterInner(type, attrs, true, preserveWS);
  }
  return ok2;
};
ParseContext.prototype.enterInner = function enterInner(type, attrs, solid, preserveWS) {
  this.closeExtra();
  var top = this.top;
  top.applyPending(type);
  top.match = top.match && top.match.matchType(type, attrs);
  var options = wsOptionsFor(type, preserveWS, top.options);
  if (top.options & OPT_OPEN_LEFT && top.content.length == 0) {
    options |= OPT_OPEN_LEFT;
  }
  this.nodes.push(new NodeContext(type, attrs, top.activeMarks, top.pendingMarks, solid, null, options));
  this.open++;
};
ParseContext.prototype.closeExtra = function closeExtra(openEnd) {
  var i2 = this.nodes.length - 1;
  if (i2 > this.open) {
    for (; i2 > this.open; i2--) {
      this.nodes[i2 - 1].content.push(this.nodes[i2].finish(openEnd));
    }
    this.nodes.length = this.open + 1;
  }
};
ParseContext.prototype.finish = function finish2() {
  this.open = 0;
  this.closeExtra(this.isOpen);
  return this.nodes[0].finish(this.isOpen || this.options.topOpen);
};
ParseContext.prototype.sync = function sync(to2) {
  for (var i2 = this.open; i2 >= 0; i2--) {
    if (this.nodes[i2] == to2) {
      this.open = i2;
      return;
    }
  }
};
prototypeAccessors$6.currentPos.get = function() {
  this.closeExtra();
  var pos = 0;
  for (var i2 = this.open; i2 >= 0; i2--) {
    var content2 = this.nodes[i2].content;
    for (var j = content2.length - 1; j >= 0; j--) {
      pos += content2[j].nodeSize;
    }
    if (i2) {
      pos++;
    }
  }
  return pos;
};
ParseContext.prototype.findAtPoint = function findAtPoint(parent, offset3) {
  if (this.find) {
    for (var i2 = 0; i2 < this.find.length; i2++) {
      if (this.find[i2].node == parent && this.find[i2].offset == offset3) {
        this.find[i2].pos = this.currentPos;
      }
    }
  }
};
ParseContext.prototype.findInside = function findInside(parent) {
  if (this.find) {
    for (var i2 = 0; i2 < this.find.length; i2++) {
      if (this.find[i2].pos == null && parent.nodeType == 1 && parent.contains(this.find[i2].node)) {
        this.find[i2].pos = this.currentPos;
      }
    }
  }
};
ParseContext.prototype.findAround = function findAround(parent, content2, before2) {
  if (parent != content2 && this.find) {
    for (var i2 = 0; i2 < this.find.length; i2++) {
      if (this.find[i2].pos == null && parent.nodeType == 1 && parent.contains(this.find[i2].node)) {
        var pos = content2.compareDocumentPosition(this.find[i2].node);
        if (pos & (before2 ? 2 : 4)) {
          this.find[i2].pos = this.currentPos;
        }
      }
    }
  }
};
ParseContext.prototype.findInText = function findInText(textNode) {
  if (this.find) {
    for (var i2 = 0; i2 < this.find.length; i2++) {
      if (this.find[i2].node == textNode) {
        this.find[i2].pos = this.currentPos - (textNode.nodeValue.length - this.find[i2].offset);
      }
    }
  }
};
ParseContext.prototype.matchesContext = function matchesContext(context) {
  var this$1$1 = this;
  if (context.indexOf("|") > -1) {
    return context.split(/\s*\|\s*/).some(this.matchesContext, this);
  }
  var parts = context.split("/");
  var option = this.options.context;
  var useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
  var minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
  var match = function(i2, depth) {
    for (; i2 >= 0; i2--) {
      var part = parts[i2];
      if (part == "") {
        if (i2 == parts.length - 1 || i2 == 0) {
          continue;
        }
        for (; depth >= minDepth; depth--) {
          if (match(i2 - 1, depth)) {
            return true;
          }
        }
        return false;
      } else {
        var next = depth > 0 || depth == 0 && useRoot ? this$1$1.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
        if (!next || next.name != part && next.groups.indexOf(part) == -1) {
          return false;
        }
        depth--;
      }
    }
    return true;
  };
  return match(parts.length - 1, this.open);
};
ParseContext.prototype.textblockFromContext = function textblockFromContext() {
  var $context = this.options.context;
  if ($context) {
    for (var d = $context.depth; d >= 0; d--) {
      var deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
      if (deflt && deflt.isTextblock && deflt.defaultAttrs) {
        return deflt;
      }
    }
  }
  for (var name in this.parser.schema.nodes) {
    var type = this.parser.schema.nodes[name];
    if (type.isTextblock && type.defaultAttrs) {
      return type;
    }
  }
};
ParseContext.prototype.addPendingMark = function addPendingMark(mark3) {
  var found2 = findSameMarkInSet(mark3, this.top.pendingMarks);
  if (found2) {
    this.top.stashMarks.push(found2);
  }
  this.top.pendingMarks = mark3.addToSet(this.top.pendingMarks);
};
ParseContext.prototype.removePendingMark = function removePendingMark(mark3, upto) {
  for (var depth = this.open; depth >= 0; depth--) {
    var level = this.nodes[depth];
    var found2 = level.pendingMarks.lastIndexOf(mark3);
    if (found2 > -1) {
      level.pendingMarks = mark3.removeFromSet(level.pendingMarks);
    } else {
      level.activeMarks = mark3.removeFromSet(level.activeMarks);
      var stashMark = level.popFromStashMark(mark3);
      if (stashMark && level.type && level.type.allowsMarkType(stashMark.type)) {
        level.activeMarks = stashMark.addToSet(level.activeMarks);
      }
    }
    if (level == upto) {
      break;
    }
  }
};
Object.defineProperties(ParseContext.prototype, prototypeAccessors$6);
function normalizeList(dom) {
  for (var child3 = dom.firstChild, prevItem = null; child3; child3 = child3.nextSibling) {
    var name = child3.nodeType == 1 ? child3.nodeName.toLowerCase() : null;
    if (name && listTags.hasOwnProperty(name) && prevItem) {
      prevItem.appendChild(child3);
      child3 = prevItem;
    } else if (name == "li") {
      prevItem = child3;
    } else if (name) {
      prevItem = null;
    }
  }
}
function matches(dom, selector2) {
  return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector2);
}
function parseStyles(style) {
  var re = /\s*([\w-]+)\s*:\s*([^;]+)/g, m, result2 = [];
  while (m = re.exec(style)) {
    result2.push(m[1], m[2].trim());
  }
  return result2;
}
function copy2(obj) {
  var copy5 = {};
  for (var prop in obj) {
    copy5[prop] = obj[prop];
  }
  return copy5;
}
function markMayApply(markType, nodeType2) {
  var nodes = nodeType2.schema.nodes;
  var loop = function(name2) {
    var parent = nodes[name2];
    if (!parent.allowsMarkType(markType)) {
      return;
    }
    var seen = [], scan = function(match) {
      seen.push(match);
      for (var i2 = 0; i2 < match.edgeCount; i2++) {
        var ref2 = match.edge(i2);
        var type = ref2.type;
        var next = ref2.next;
        if (type == nodeType2) {
          return true;
        }
        if (seen.indexOf(next) < 0 && scan(next)) {
          return true;
        }
      }
    };
    if (scan(parent.contentMatch)) {
      return { v: true };
    }
  };
  for (var name in nodes) {
    var returned = loop(name);
    if (returned)
      return returned.v;
  }
}
function findSameMarkInSet(mark3, set3) {
  for (var i2 = 0; i2 < set3.length; i2++) {
    if (mark3.eq(set3[i2])) {
      return set3[i2];
    }
  }
}
var DOMSerializer = function DOMSerializer2(nodes, marks2) {
  this.nodes = nodes || {};
  this.marks = marks2 || {};
};
DOMSerializer.prototype.serializeFragment = function serializeFragment(fragment, options, target) {
  var this$1$1 = this;
  if (options === void 0)
    options = {};
  if (!target) {
    target = doc(options).createDocumentFragment();
  }
  var top = target, active = null;
  fragment.forEach(function(node4) {
    if (active || node4.marks.length) {
      if (!active) {
        active = [];
      }
      var keep = 0, rendered = 0;
      while (keep < active.length && rendered < node4.marks.length) {
        var next = node4.marks[rendered];
        if (!this$1$1.marks[next.type.name]) {
          rendered++;
          continue;
        }
        if (!next.eq(active[keep]) || next.type.spec.spanning === false) {
          break;
        }
        keep += 2;
        rendered++;
      }
      while (keep < active.length) {
        top = active.pop();
        active.pop();
      }
      while (rendered < node4.marks.length) {
        var add3 = node4.marks[rendered++];
        var markDOM = this$1$1.serializeMark(add3, node4.isInline, options);
        if (markDOM) {
          active.push(add3, top);
          top.appendChild(markDOM.dom);
          top = markDOM.contentDOM || markDOM.dom;
        }
      }
    }
    top.appendChild(this$1$1.serializeNodeInner(node4, options));
  });
  return target;
};
DOMSerializer.prototype.serializeNodeInner = function serializeNodeInner(node4, options) {
  if (options === void 0)
    options = {};
  var ref2 = DOMSerializer.renderSpec(doc(options), this.nodes[node4.type.name](node4));
  var dom = ref2.dom;
  var contentDOM = ref2.contentDOM;
  if (contentDOM) {
    if (node4.isLeaf) {
      throw new RangeError("Content hole not allowed in a leaf node spec");
    }
    if (options.onContent) {
      options.onContent(node4, contentDOM, options);
    } else {
      this.serializeFragment(node4.content, options, contentDOM);
    }
  }
  return dom;
};
DOMSerializer.prototype.serializeNode = function serializeNode(node4, options) {
  if (options === void 0)
    options = {};
  var dom = this.serializeNodeInner(node4, options);
  for (var i2 = node4.marks.length - 1; i2 >= 0; i2--) {
    var wrap = this.serializeMark(node4.marks[i2], node4.isInline, options);
    if (wrap) {
      (wrap.contentDOM || wrap.dom).appendChild(dom);
      dom = wrap.dom;
    }
  }
  return dom;
};
DOMSerializer.prototype.serializeMark = function serializeMark(mark3, inline2, options) {
  if (options === void 0)
    options = {};
  var toDOM = this.marks[mark3.type.name];
  return toDOM && DOMSerializer.renderSpec(doc(options), toDOM(mark3, inline2));
};
DOMSerializer.renderSpec = function renderSpec(doc2, structure, xmlNS) {
  if (xmlNS === void 0)
    xmlNS = null;
  if (typeof structure == "string") {
    return { dom: doc2.createTextNode(structure) };
  }
  if (structure.nodeType != null) {
    return { dom: structure };
  }
  if (structure.dom && structure.dom.nodeType != null) {
    return structure;
  }
  var tagName = structure[0], space = tagName.indexOf(" ");
  if (space > 0) {
    xmlNS = tagName.slice(0, space);
    tagName = tagName.slice(space + 1);
  }
  var contentDOM = null, dom = xmlNS ? doc2.createElementNS(xmlNS, tagName) : doc2.createElement(tagName);
  var attrs = structure[1], start3 = 1;
  if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
    start3 = 2;
    for (var name in attrs) {
      if (attrs[name] != null) {
        var space$1 = name.indexOf(" ");
        if (space$1 > 0) {
          dom.setAttributeNS(name.slice(0, space$1), name.slice(space$1 + 1), attrs[name]);
        } else {
          dom.setAttribute(name, attrs[name]);
        }
      }
    }
  }
  for (var i2 = start3; i2 < structure.length; i2++) {
    var child3 = structure[i2];
    if (child3 === 0) {
      if (i2 < structure.length - 1 || i2 > start3) {
        throw new RangeError("Content hole must be the only child of its parent node");
      }
      return { dom, contentDOM: dom };
    } else {
      var ref2 = DOMSerializer.renderSpec(doc2, child3, xmlNS);
      var inner = ref2.dom;
      var innerContent = ref2.contentDOM;
      dom.appendChild(inner);
      if (innerContent) {
        if (contentDOM) {
          throw new RangeError("Multiple content holes");
        }
        contentDOM = innerContent;
      }
    }
  }
  return { dom, contentDOM };
};
DOMSerializer.fromSchema = function fromSchema2(schema) {
  return schema.cached.domSerializer || (schema.cached.domSerializer = new DOMSerializer(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
};
DOMSerializer.nodesFromSchema = function nodesFromSchema(schema) {
  var result2 = gatherToDOM(schema.nodes);
  if (!result2.text) {
    result2.text = function(node4) {
      return node4.text;
    };
  }
  return result2;
};
DOMSerializer.marksFromSchema = function marksFromSchema(schema) {
  return gatherToDOM(schema.marks);
};
function gatherToDOM(obj) {
  var result2 = {};
  for (var name in obj) {
    var toDOM = obj[name].spec.toDOM;
    if (toDOM) {
      result2[name] = toDOM;
    }
  }
  return result2;
}
function doc(options) {
  return options.document || window.document;
}
var lower16 = 65535;
var factor16 = Math.pow(2, 16);
function makeRecover(index3, offset3) {
  return index3 + offset3 * factor16;
}
function recoverIndex(value) {
  return value & lower16;
}
function recoverOffset(value) {
  return (value - (value & lower16)) / factor16;
}
var MapResult = function MapResult2(pos, deleted, recover2) {
  if (deleted === void 0)
    deleted = false;
  if (recover2 === void 0)
    recover2 = null;
  this.pos = pos;
  this.deleted = deleted;
  this.recover = recover2;
};
var StepMap = function StepMap2(ranges, inverted) {
  if (inverted === void 0)
    inverted = false;
  if (!ranges.length && StepMap2.empty) {
    return StepMap2.empty;
  }
  this.ranges = ranges;
  this.inverted = inverted;
};
StepMap.prototype.recover = function recover(value) {
  var diff2 = 0, index3 = recoverIndex(value);
  if (!this.inverted) {
    for (var i2 = 0; i2 < index3; i2++) {
      diff2 += this.ranges[i2 * 3 + 2] - this.ranges[i2 * 3 + 1];
    }
  }
  return this.ranges[index3 * 3] + diff2 + recoverOffset(value);
};
StepMap.prototype.mapResult = function mapResult(pos, assoc) {
  if (assoc === void 0)
    assoc = 1;
  return this._map(pos, assoc, false);
};
StepMap.prototype.map = function map2(pos, assoc) {
  if (assoc === void 0)
    assoc = 1;
  return this._map(pos, assoc, true);
};
StepMap.prototype._map = function _map(pos, assoc, simple) {
  var diff2 = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i2 = 0; i2 < this.ranges.length; i2 += 3) {
    var start3 = this.ranges[i2] - (this.inverted ? diff2 : 0);
    if (start3 > pos) {
      break;
    }
    var oldSize = this.ranges[i2 + oldIndex], newSize = this.ranges[i2 + newIndex], end2 = start3 + oldSize;
    if (pos <= end2) {
      var side = !oldSize ? assoc : pos == start3 ? -1 : pos == end2 ? 1 : assoc;
      var result2 = start3 + diff2 + (side < 0 ? 0 : newSize);
      if (simple) {
        return result2;
      }
      var recover2 = pos == (assoc < 0 ? start3 : end2) ? null : makeRecover(i2 / 3, pos - start3);
      return new MapResult(result2, assoc < 0 ? pos != start3 : pos != end2, recover2);
    }
    diff2 += newSize - oldSize;
  }
  return simple ? pos + diff2 : new MapResult(pos + diff2);
};
StepMap.prototype.touches = function touches(pos, recover2) {
  var diff2 = 0, index3 = recoverIndex(recover2);
  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i2 = 0; i2 < this.ranges.length; i2 += 3) {
    var start3 = this.ranges[i2] - (this.inverted ? diff2 : 0);
    if (start3 > pos) {
      break;
    }
    var oldSize = this.ranges[i2 + oldIndex], end2 = start3 + oldSize;
    if (pos <= end2 && i2 == index3 * 3) {
      return true;
    }
    diff2 += this.ranges[i2 + newIndex] - oldSize;
  }
  return false;
};
StepMap.prototype.forEach = function forEach3(f) {
  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i2 = 0, diff2 = 0; i2 < this.ranges.length; i2 += 3) {
    var start3 = this.ranges[i2], oldStart = start3 - (this.inverted ? diff2 : 0), newStart = start3 + (this.inverted ? 0 : diff2);
    var oldSize = this.ranges[i2 + oldIndex], newSize = this.ranges[i2 + newIndex];
    f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
    diff2 += newSize - oldSize;
  }
};
StepMap.prototype.invert = function invert() {
  return new StepMap(this.ranges, !this.inverted);
};
StepMap.prototype.toString = function toString6() {
  return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
};
StepMap.offset = function offset2(n) {
  return n == 0 ? StepMap.empty : new StepMap(n < 0 ? [0, -n, 0] : [0, 0, n]);
};
StepMap.empty = new StepMap([]);
var Mapping = function Mapping2(maps, mirror, from5, to2) {
  this.maps = maps || [];
  this.from = from5 || 0;
  this.to = to2 == null ? this.maps.length : to2;
  this.mirror = mirror;
};
Mapping.prototype.slice = function slice2(from5, to2) {
  if (from5 === void 0)
    from5 = 0;
  if (to2 === void 0)
    to2 = this.maps.length;
  return new Mapping(this.maps, this.mirror, from5, to2);
};
Mapping.prototype.copy = function copy3() {
  return new Mapping(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
};
Mapping.prototype.appendMap = function appendMap(map16, mirrors) {
  this.to = this.maps.push(map16);
  if (mirrors != null) {
    this.setMirror(this.maps.length - 1, mirrors);
  }
};
Mapping.prototype.appendMapping = function appendMapping(mapping) {
  for (var i2 = 0, startSize = this.maps.length; i2 < mapping.maps.length; i2++) {
    var mirr = mapping.getMirror(i2);
    this.appendMap(mapping.maps[i2], mirr != null && mirr < i2 ? startSize + mirr : null);
  }
};
Mapping.prototype.getMirror = function getMirror(n) {
  if (this.mirror) {
    for (var i2 = 0; i2 < this.mirror.length; i2++) {
      if (this.mirror[i2] == n) {
        return this.mirror[i2 + (i2 % 2 ? -1 : 1)];
      }
    }
  }
};
Mapping.prototype.setMirror = function setMirror(n, m) {
  if (!this.mirror) {
    this.mirror = [];
  }
  this.mirror.push(n, m);
};
Mapping.prototype.appendMappingInverted = function appendMappingInverted(mapping) {
  for (var i2 = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i2 >= 0; i2--) {
    var mirr = mapping.getMirror(i2);
    this.appendMap(mapping.maps[i2].invert(), mirr != null && mirr > i2 ? totalSize - mirr - 1 : null);
  }
};
Mapping.prototype.invert = function invert2() {
  var inverse = new Mapping();
  inverse.appendMappingInverted(this);
  return inverse;
};
Mapping.prototype.map = function map3(pos, assoc) {
  if (assoc === void 0)
    assoc = 1;
  if (this.mirror) {
    return this._map(pos, assoc, true);
  }
  for (var i2 = this.from; i2 < this.to; i2++) {
    pos = this.maps[i2].map(pos, assoc);
  }
  return pos;
};
Mapping.prototype.mapResult = function mapResult2(pos, assoc) {
  if (assoc === void 0)
    assoc = 1;
  return this._map(pos, assoc, false);
};
Mapping.prototype._map = function _map2(pos, assoc, simple) {
  var deleted = false;
  for (var i2 = this.from; i2 < this.to; i2++) {
    var map16 = this.maps[i2], result2 = map16.mapResult(pos, assoc);
    if (result2.recover != null) {
      var corr = this.getMirror(i2);
      if (corr != null && corr > i2 && corr < this.to) {
        i2 = corr;
        pos = this.maps[corr].recover(result2.recover);
        continue;
      }
    }
    if (result2.deleted) {
      deleted = true;
    }
    pos = result2.pos;
  }
  return simple ? pos : new MapResult(pos, deleted);
};
function TransformError(message) {
  var err2 = Error.call(this, message);
  err2.__proto__ = TransformError.prototype;
  return err2;
}
TransformError.prototype = Object.create(Error.prototype);
TransformError.prototype.constructor = TransformError;
TransformError.prototype.name = "TransformError";
var Transform = function Transform2(doc2) {
  this.doc = doc2;
  this.steps = [];
  this.docs = [];
  this.mapping = new Mapping();
};
var prototypeAccessors$4 = { before: { configurable: true }, docChanged: { configurable: true } };
prototypeAccessors$4.before.get = function() {
  return this.docs.length ? this.docs[0] : this.doc;
};
Transform.prototype.step = function step(object) {
  var result2 = this.maybeStep(object);
  if (result2.failed) {
    throw new TransformError(result2.failed);
  }
  return this;
};
Transform.prototype.maybeStep = function maybeStep(step2) {
  var result2 = step2.apply(this.doc);
  if (!result2.failed) {
    this.addStep(step2, result2.doc);
  }
  return result2;
};
prototypeAccessors$4.docChanged.get = function() {
  return this.steps.length > 0;
};
Transform.prototype.addStep = function addStep(step2, doc2) {
  this.docs.push(this.doc);
  this.steps.push(step2);
  this.mapping.appendMap(step2.getMap());
  this.doc = doc2;
};
Object.defineProperties(Transform.prototype, prototypeAccessors$4);
function mustOverride() {
  throw new Error("Override me");
}
var stepsByID = /* @__PURE__ */ Object.create(null);
var Step = function Step2() {
};
Step.prototype.apply = function apply(_doc) {
  return mustOverride();
};
Step.prototype.getMap = function getMap() {
  return StepMap.empty;
};
Step.prototype.invert = function invert3(_doc) {
  return mustOverride();
};
Step.prototype.map = function map4(_mapping) {
  return mustOverride();
};
Step.prototype.merge = function merge(_other) {
  return null;
};
Step.prototype.toJSON = function toJSON6() {
  return mustOverride();
};
Step.fromJSON = function fromJSON5(schema, json) {
  if (!json || !json.stepType) {
    throw new RangeError("Invalid input for Step.fromJSON");
  }
  var type = stepsByID[json.stepType];
  if (!type) {
    throw new RangeError("No step type " + json.stepType + " defined");
  }
  return type.fromJSON(schema, json);
};
Step.jsonID = function jsonID(id, stepClass) {
  if (id in stepsByID) {
    throw new RangeError("Duplicate use of step JSON ID " + id);
  }
  stepsByID[id] = stepClass;
  stepClass.prototype.jsonID = id;
  return stepClass;
};
var StepResult = function StepResult2(doc2, failed) {
  this.doc = doc2;
  this.failed = failed;
};
StepResult.ok = function ok(doc2) {
  return new StepResult(doc2, null);
};
StepResult.fail = function fail(message) {
  return new StepResult(null, message);
};
StepResult.fromReplace = function fromReplace(doc2, from5, to2, slice4) {
  try {
    return StepResult.ok(doc2.replace(from5, to2, slice4));
  } catch (e) {
    if (e instanceof ReplaceError) {
      return StepResult.fail(e.message);
    }
    throw e;
  }
};
var ReplaceStep = /* @__PURE__ */ function(Step3) {
  function ReplaceStep2(from5, to2, slice4, structure) {
    Step3.call(this);
    this.from = from5;
    this.to = to2;
    this.slice = slice4;
    this.structure = !!structure;
  }
  if (Step3)
    ReplaceStep2.__proto__ = Step3;
  ReplaceStep2.prototype = Object.create(Step3 && Step3.prototype);
  ReplaceStep2.prototype.constructor = ReplaceStep2;
  ReplaceStep2.prototype.apply = function apply8(doc2) {
    if (this.structure && contentBetween(doc2, this.from, this.to)) {
      return StepResult.fail("Structure replace would overwrite content");
    }
    return StepResult.fromReplace(doc2, this.from, this.to, this.slice);
  };
  ReplaceStep2.prototype.getMap = function getMap2() {
    return new StepMap([this.from, this.to - this.from, this.slice.size]);
  };
  ReplaceStep2.prototype.invert = function invert4(doc2) {
    return new ReplaceStep2(this.from, this.from + this.slice.size, doc2.slice(this.from, this.to));
  };
  ReplaceStep2.prototype.map = function map16(mapping) {
    var from5 = mapping.mapResult(this.from, 1), to2 = mapping.mapResult(this.to, -1);
    if (from5.deleted && to2.deleted) {
      return null;
    }
    return new ReplaceStep2(from5.pos, Math.max(from5.pos, to2.pos), this.slice);
  };
  ReplaceStep2.prototype.merge = function merge4(other) {
    if (!(other instanceof ReplaceStep2) || other.structure || this.structure) {
      return null;
    }
    if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
      var slice4 = this.slice.size + other.slice.size == 0 ? Slice.empty : new Slice(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
      return new ReplaceStep2(this.from, this.to + (other.to - other.from), slice4, this.structure);
    } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
      var slice$1 = this.slice.size + other.slice.size == 0 ? Slice.empty : new Slice(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
      return new ReplaceStep2(other.from, this.to, slice$1, this.structure);
    } else {
      return null;
    }
  };
  ReplaceStep2.prototype.toJSON = function toJSON8() {
    var json = { stepType: "replace", from: this.from, to: this.to };
    if (this.slice.size) {
      json.slice = this.slice.toJSON();
    }
    if (this.structure) {
      json.structure = true;
    }
    return json;
  };
  ReplaceStep2.fromJSON = function fromJSON8(schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number") {
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    }
    return new ReplaceStep2(json.from, json.to, Slice.fromJSON(schema, json.slice), !!json.structure);
  };
  return ReplaceStep2;
}(Step);
Step.jsonID("replace", ReplaceStep);
var ReplaceAroundStep = /* @__PURE__ */ function(Step3) {
  function ReplaceAroundStep2(from5, to2, gapFrom, gapTo, slice4, insert, structure) {
    Step3.call(this);
    this.from = from5;
    this.to = to2;
    this.gapFrom = gapFrom;
    this.gapTo = gapTo;
    this.slice = slice4;
    this.insert = insert;
    this.structure = !!structure;
  }
  if (Step3)
    ReplaceAroundStep2.__proto__ = Step3;
  ReplaceAroundStep2.prototype = Object.create(Step3 && Step3.prototype);
  ReplaceAroundStep2.prototype.constructor = ReplaceAroundStep2;
  ReplaceAroundStep2.prototype.apply = function apply8(doc2) {
    if (this.structure && (contentBetween(doc2, this.from, this.gapFrom) || contentBetween(doc2, this.gapTo, this.to))) {
      return StepResult.fail("Structure gap-replace would overwrite content");
    }
    var gap = doc2.slice(this.gapFrom, this.gapTo);
    if (gap.openStart || gap.openEnd) {
      return StepResult.fail("Gap is not a flat range");
    }
    var inserted = this.slice.insertAt(this.insert, gap.content);
    if (!inserted) {
      return StepResult.fail("Content does not fit in gap");
    }
    return StepResult.fromReplace(doc2, this.from, this.to, inserted);
  };
  ReplaceAroundStep2.prototype.getMap = function getMap2() {
    return new StepMap([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  };
  ReplaceAroundStep2.prototype.invert = function invert4(doc2) {
    var gap = this.gapTo - this.gapFrom;
    return new ReplaceAroundStep2(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc2.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  };
  ReplaceAroundStep2.prototype.map = function map16(mapping) {
    var from5 = mapping.mapResult(this.from, 1), to2 = mapping.mapResult(this.to, -1);
    var gapFrom = mapping.map(this.gapFrom, -1), gapTo = mapping.map(this.gapTo, 1);
    if (from5.deleted && to2.deleted || gapFrom < from5.pos || gapTo > to2.pos) {
      return null;
    }
    return new ReplaceAroundStep2(from5.pos, to2.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
  };
  ReplaceAroundStep2.prototype.toJSON = function toJSON8() {
    var json = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    if (this.slice.size) {
      json.slice = this.slice.toJSON();
    }
    if (this.structure) {
      json.structure = true;
    }
    return json;
  };
  ReplaceAroundStep2.fromJSON = function fromJSON8(schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") {
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    }
    return new ReplaceAroundStep2(json.from, json.to, json.gapFrom, json.gapTo, Slice.fromJSON(schema, json.slice), json.insert, !!json.structure);
  };
  return ReplaceAroundStep2;
}(Step);
Step.jsonID("replaceAround", ReplaceAroundStep);
function contentBetween(doc2, from5, to2) {
  var $from = doc2.resolve(from5), dist = to2 - from5, depth = $from.depth;
  while (dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount) {
    depth--;
    dist--;
  }
  if (dist > 0) {
    var next = $from.node(depth).maybeChild($from.indexAfter(depth));
    while (dist > 0) {
      if (!next || next.isLeaf) {
        return true;
      }
      next = next.firstChild;
      dist--;
    }
  }
  return false;
}
function canCut(node4, start3, end2) {
  return (start3 == 0 || node4.canReplace(start3, node4.childCount)) && (end2 == node4.childCount || node4.canReplace(0, end2));
}
function liftTarget(range2) {
  var parent = range2.parent;
  var content2 = parent.content.cutByIndex(range2.startIndex, range2.endIndex);
  for (var depth = range2.depth; ; --depth) {
    var node4 = range2.$from.node(depth);
    var index3 = range2.$from.index(depth), endIndex = range2.$to.indexAfter(depth);
    if (depth < range2.depth && node4.canReplace(index3, endIndex, content2)) {
      return depth;
    }
    if (depth == 0 || node4.type.spec.isolating || !canCut(node4, index3, endIndex)) {
      break;
    }
  }
}
Transform.prototype.lift = function(range2, target) {
  var $from = range2.$from;
  var $to = range2.$to;
  var depth = range2.depth;
  var gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
  var start3 = gapStart, end2 = gapEnd;
  var before2 = Fragment.empty, openStart = 0;
  for (var d = depth, splitting = false; d > target; d--) {
    if (splitting || $from.index(d) > 0) {
      splitting = true;
      before2 = Fragment.from($from.node(d).copy(before2));
      openStart++;
    } else {
      start3--;
    }
  }
  var after2 = Fragment.empty, openEnd = 0;
  for (var d$1 = depth, splitting$1 = false; d$1 > target; d$1--) {
    if (splitting$1 || $to.after(d$1 + 1) < $to.end(d$1)) {
      splitting$1 = true;
      after2 = Fragment.from($to.node(d$1).copy(after2));
      openEnd++;
    } else {
      end2++;
    }
  }
  return this.step(new ReplaceAroundStep(start3, end2, gapStart, gapEnd, new Slice(before2.append(after2), openStart, openEnd), before2.size - openStart, true));
};
function findWrapping3(range2, nodeType2, attrs, innerRange) {
  if (innerRange === void 0)
    innerRange = range2;
  var around = findWrappingOutside(range2, nodeType2);
  var inner = around && findWrappingInside(innerRange, nodeType2);
  if (!inner) {
    return null;
  }
  return around.map(withAttrs).concat({ type: nodeType2, attrs }).concat(inner.map(withAttrs));
}
function withAttrs(type) {
  return { type, attrs: null };
}
function findWrappingOutside(range2, type) {
  var parent = range2.parent;
  var startIndex = range2.startIndex;
  var endIndex = range2.endIndex;
  var around = parent.contentMatchAt(startIndex).findWrapping(type);
  if (!around) {
    return null;
  }
  var outer = around.length ? around[0] : type;
  return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function findWrappingInside(range2, type) {
  var parent = range2.parent;
  var startIndex = range2.startIndex;
  var endIndex = range2.endIndex;
  var inner = parent.child(startIndex);
  var inside = type.contentMatch.findWrapping(inner.type);
  if (!inside) {
    return null;
  }
  var lastType = inside.length ? inside[inside.length - 1] : type;
  var innerMatch = lastType.contentMatch;
  for (var i2 = startIndex; innerMatch && i2 < endIndex; i2++) {
    innerMatch = innerMatch.matchType(parent.child(i2).type);
  }
  if (!innerMatch || !innerMatch.validEnd) {
    return null;
  }
  return inside;
}
Transform.prototype.wrap = function(range2, wrappers) {
  var content2 = Fragment.empty;
  for (var i2 = wrappers.length - 1; i2 >= 0; i2--) {
    if (content2.size) {
      var match = wrappers[i2].type.contentMatch.matchFragment(content2);
      if (!match || !match.validEnd) {
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
      }
    }
    content2 = Fragment.from(wrappers[i2].type.create(wrappers[i2].attrs, content2));
  }
  var start3 = range2.start, end2 = range2.end;
  return this.step(new ReplaceAroundStep(start3, end2, start3, end2, new Slice(content2, 0, 0), wrappers.length, true));
};
Transform.prototype.setBlockType = function(from5, to2, type, attrs) {
  var this$1$1 = this;
  if (to2 === void 0)
    to2 = from5;
  if (!type.isTextblock) {
    throw new RangeError("Type given to setBlockType should be a textblock");
  }
  var mapFrom = this.steps.length;
  this.doc.nodesBetween(from5, to2, function(node4, pos) {
    if (node4.isTextblock && !node4.hasMarkup(type, attrs) && canChangeType(this$1$1.doc, this$1$1.mapping.slice(mapFrom).map(pos), type)) {
      this$1$1.clearIncompatible(this$1$1.mapping.slice(mapFrom).map(pos, 1), type);
      var mapping = this$1$1.mapping.slice(mapFrom);
      var startM = mapping.map(pos, 1), endM = mapping.map(pos + node4.nodeSize, 1);
      this$1$1.step(new ReplaceAroundStep(startM, endM, startM + 1, endM - 1, new Slice(Fragment.from(type.create(attrs, null, node4.marks)), 0, 0), 1, true));
      return false;
    }
  });
  return this;
};
function canChangeType(doc2, pos, type) {
  var $pos = doc2.resolve(pos), index3 = $pos.index();
  return $pos.parent.canReplaceWith(index3, index3 + 1, type);
}
Transform.prototype.setNodeMarkup = function(pos, type, attrs, marks2) {
  var node4 = this.doc.nodeAt(pos);
  if (!node4) {
    throw new RangeError("No node at given position");
  }
  if (!type) {
    type = node4.type;
  }
  var newNode = type.create(attrs, null, marks2 || node4.marks);
  if (node4.isLeaf) {
    return this.replaceWith(pos, pos + node4.nodeSize, newNode);
  }
  if (!type.validContent(node4.content)) {
    throw new RangeError("Invalid content for node type " + type.name);
  }
  return this.step(new ReplaceAroundStep(pos, pos + node4.nodeSize, pos + 1, pos + node4.nodeSize - 1, new Slice(Fragment.from(newNode), 0, 0), 1, true));
};
function canSplit(doc2, pos, depth, typesAfter) {
  if (depth === void 0)
    depth = 1;
  var $pos = doc2.resolve(pos), base2 = $pos.depth - depth;
  var innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
  if (base2 < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) {
    return false;
  }
  for (var d = $pos.depth - 1, i2 = depth - 2; d > base2; d--, i2--) {
    var node4 = $pos.node(d), index$1 = $pos.index(d);
    if (node4.type.spec.isolating) {
      return false;
    }
    var rest = node4.content.cutByIndex(index$1, node4.childCount);
    var after2 = typesAfter && typesAfter[i2] || node4;
    if (after2 != node4) {
      rest = rest.replaceChild(0, after2.type.create(after2.attrs));
    }
    if (!node4.canReplace(index$1 + 1, node4.childCount) || !after2.type.validContent(rest)) {
      return false;
    }
  }
  var index3 = $pos.indexAfter(base2);
  var baseType = typesAfter && typesAfter[0];
  return $pos.node(base2).canReplaceWith(index3, index3, baseType ? baseType.type : $pos.node(base2 + 1).type);
}
Transform.prototype.split = function(pos, depth, typesAfter) {
  if (depth === void 0)
    depth = 1;
  var $pos = this.doc.resolve(pos), before2 = Fragment.empty, after2 = Fragment.empty;
  for (var d = $pos.depth, e = $pos.depth - depth, i2 = depth - 1; d > e; d--, i2--) {
    before2 = Fragment.from($pos.node(d).copy(before2));
    var typeAfter = typesAfter && typesAfter[i2];
    after2 = Fragment.from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after2) : $pos.node(d).copy(after2));
  }
  return this.step(new ReplaceStep(pos, pos, new Slice(before2.append(after2), depth, depth), true));
};
function canJoin(doc2, pos) {
  var $pos = doc2.resolve(pos), index3 = $pos.index();
  return joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index3, index3 + 1);
}
function joinable(a, b) {
  return a && b && !a.isLeaf && a.canAppend(b);
}
function joinPoint(doc2, pos, dir) {
  if (dir === void 0)
    dir = -1;
  var $pos = doc2.resolve(pos);
  for (var d = $pos.depth; ; d--) {
    var before2 = void 0, after2 = void 0, index3 = $pos.index(d);
    if (d == $pos.depth) {
      before2 = $pos.nodeBefore;
      after2 = $pos.nodeAfter;
    } else if (dir > 0) {
      before2 = $pos.node(d + 1);
      index3++;
      after2 = $pos.node(d).maybeChild(index3);
    } else {
      before2 = $pos.node(d).maybeChild(index3 - 1);
      after2 = $pos.node(d + 1);
    }
    if (before2 && !before2.isTextblock && joinable(before2, after2) && $pos.node(d).canReplace(index3, index3 + 1)) {
      return pos;
    }
    if (d == 0) {
      break;
    }
    pos = dir < 0 ? $pos.before(d) : $pos.after(d);
  }
}
Transform.prototype.join = function(pos, depth) {
  if (depth === void 0)
    depth = 1;
  var step2 = new ReplaceStep(pos - depth, pos + depth, Slice.empty, true);
  return this.step(step2);
};
function insertPoint(doc2, pos, nodeType2) {
  var $pos = doc2.resolve(pos);
  if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType2)) {
    return pos;
  }
  if ($pos.parentOffset == 0) {
    for (var d = $pos.depth - 1; d >= 0; d--) {
      var index3 = $pos.index(d);
      if ($pos.node(d).canReplaceWith(index3, index3, nodeType2)) {
        return $pos.before(d + 1);
      }
      if (index3 > 0) {
        return null;
      }
    }
  }
  if ($pos.parentOffset == $pos.parent.content.size) {
    for (var d$1 = $pos.depth - 1; d$1 >= 0; d$1--) {
      var index$1 = $pos.indexAfter(d$1);
      if ($pos.node(d$1).canReplaceWith(index$1, index$1, nodeType2)) {
        return $pos.after(d$1 + 1);
      }
      if (index$1 < $pos.node(d$1).childCount) {
        return null;
      }
    }
  }
}
function dropPoint(doc2, pos, slice4) {
  var $pos = doc2.resolve(pos);
  if (!slice4.content.size) {
    return pos;
  }
  var content2 = slice4.content;
  for (var i2 = 0; i2 < slice4.openStart; i2++) {
    content2 = content2.firstChild.content;
  }
  for (var pass = 1; pass <= (slice4.openStart == 0 && slice4.size ? 2 : 1); pass++) {
    for (var d = $pos.depth; d >= 0; d--) {
      var bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
      var insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
      var parent = $pos.node(d), fits = false;
      if (pass == 1) {
        fits = parent.canReplace(insertPos, insertPos, content2);
      } else {
        var wrapping = parent.contentMatchAt(insertPos).findWrapping(content2.firstChild.type);
        fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
      }
      if (fits) {
        return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
      }
    }
  }
  return null;
}
function mapFragment(fragment, f, parent) {
  var mapped = [];
  for (var i2 = 0; i2 < fragment.childCount; i2++) {
    var child3 = fragment.child(i2);
    if (child3.content.size) {
      child3 = child3.copy(mapFragment(child3.content, f, child3));
    }
    if (child3.isInline) {
      child3 = f(child3, parent, i2);
    }
    mapped.push(child3);
  }
  return Fragment.fromArray(mapped);
}
var AddMarkStep = /* @__PURE__ */ function(Step3) {
  function AddMarkStep2(from5, to2, mark3) {
    Step3.call(this);
    this.from = from5;
    this.to = to2;
    this.mark = mark3;
  }
  if (Step3)
    AddMarkStep2.__proto__ = Step3;
  AddMarkStep2.prototype = Object.create(Step3 && Step3.prototype);
  AddMarkStep2.prototype.constructor = AddMarkStep2;
  AddMarkStep2.prototype.apply = function apply8(doc2) {
    var this$1$1 = this;
    var oldSlice = doc2.slice(this.from, this.to), $from = doc2.resolve(this.from);
    var parent = $from.node($from.sharedDepth(this.to));
    var slice4 = new Slice(mapFragment(oldSlice.content, function(node4, parent2) {
      if (!node4.isAtom || !parent2.type.allowsMarkType(this$1$1.mark.type)) {
        return node4;
      }
      return node4.mark(this$1$1.mark.addToSet(node4.marks));
    }, parent), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc2, this.from, this.to, slice4);
  };
  AddMarkStep2.prototype.invert = function invert4() {
    return new RemoveMarkStep(this.from, this.to, this.mark);
  };
  AddMarkStep2.prototype.map = function map16(mapping) {
    var from5 = mapping.mapResult(this.from, 1), to2 = mapping.mapResult(this.to, -1);
    if (from5.deleted && to2.deleted || from5.pos >= to2.pos) {
      return null;
    }
    return new AddMarkStep2(from5.pos, to2.pos, this.mark);
  };
  AddMarkStep2.prototype.merge = function merge4(other) {
    if (other instanceof AddMarkStep2 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) {
      return new AddMarkStep2(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
    }
  };
  AddMarkStep2.prototype.toJSON = function toJSON8() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  };
  AddMarkStep2.fromJSON = function fromJSON8(schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number") {
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    }
    return new AddMarkStep2(json.from, json.to, schema.markFromJSON(json.mark));
  };
  return AddMarkStep2;
}(Step);
Step.jsonID("addMark", AddMarkStep);
var RemoveMarkStep = /* @__PURE__ */ function(Step3) {
  function RemoveMarkStep2(from5, to2, mark3) {
    Step3.call(this);
    this.from = from5;
    this.to = to2;
    this.mark = mark3;
  }
  if (Step3)
    RemoveMarkStep2.__proto__ = Step3;
  RemoveMarkStep2.prototype = Object.create(Step3 && Step3.prototype);
  RemoveMarkStep2.prototype.constructor = RemoveMarkStep2;
  RemoveMarkStep2.prototype.apply = function apply8(doc2) {
    var this$1$1 = this;
    var oldSlice = doc2.slice(this.from, this.to);
    var slice4 = new Slice(mapFragment(oldSlice.content, function(node4) {
      return node4.mark(this$1$1.mark.removeFromSet(node4.marks));
    }), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc2, this.from, this.to, slice4);
  };
  RemoveMarkStep2.prototype.invert = function invert4() {
    return new AddMarkStep(this.from, this.to, this.mark);
  };
  RemoveMarkStep2.prototype.map = function map16(mapping) {
    var from5 = mapping.mapResult(this.from, 1), to2 = mapping.mapResult(this.to, -1);
    if (from5.deleted && to2.deleted || from5.pos >= to2.pos) {
      return null;
    }
    return new RemoveMarkStep2(from5.pos, to2.pos, this.mark);
  };
  RemoveMarkStep2.prototype.merge = function merge4(other) {
    if (other instanceof RemoveMarkStep2 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) {
      return new RemoveMarkStep2(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
    }
  };
  RemoveMarkStep2.prototype.toJSON = function toJSON8() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  };
  RemoveMarkStep2.fromJSON = function fromJSON8(schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number") {
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    }
    return new RemoveMarkStep2(json.from, json.to, schema.markFromJSON(json.mark));
  };
  return RemoveMarkStep2;
}(Step);
Step.jsonID("removeMark", RemoveMarkStep);
Transform.prototype.addMark = function(from5, to2, mark3) {
  var this$1$1 = this;
  var removed = [], added = [], removing = null, adding = null;
  this.doc.nodesBetween(from5, to2, function(node4, pos, parent) {
    if (!node4.isInline) {
      return;
    }
    var marks2 = node4.marks;
    if (!mark3.isInSet(marks2) && parent.type.allowsMarkType(mark3.type)) {
      var start3 = Math.max(pos, from5), end2 = Math.min(pos + node4.nodeSize, to2);
      var newSet = mark3.addToSet(marks2);
      for (var i2 = 0; i2 < marks2.length; i2++) {
        if (!marks2[i2].isInSet(newSet)) {
          if (removing && removing.to == start3 && removing.mark.eq(marks2[i2])) {
            removing.to = end2;
          } else {
            removed.push(removing = new RemoveMarkStep(start3, end2, marks2[i2]));
          }
        }
      }
      if (adding && adding.to == start3) {
        adding.to = end2;
      } else {
        added.push(adding = new AddMarkStep(start3, end2, mark3));
      }
    }
  });
  removed.forEach(function(s2) {
    return this$1$1.step(s2);
  });
  added.forEach(function(s2) {
    return this$1$1.step(s2);
  });
  return this;
};
Transform.prototype.removeMark = function(from5, to2, mark3) {
  var this$1$1 = this;
  if (mark3 === void 0)
    mark3 = null;
  var matched = [], step2 = 0;
  this.doc.nodesBetween(from5, to2, function(node4, pos) {
    if (!node4.isInline) {
      return;
    }
    step2++;
    var toRemove = null;
    if (mark3 instanceof MarkType) {
      var set3 = node4.marks, found2;
      while (found2 = mark3.isInSet(set3)) {
        (toRemove || (toRemove = [])).push(found2);
        set3 = found2.removeFromSet(set3);
      }
    } else if (mark3) {
      if (mark3.isInSet(node4.marks)) {
        toRemove = [mark3];
      }
    } else {
      toRemove = node4.marks;
    }
    if (toRemove && toRemove.length) {
      var end2 = Math.min(pos + node4.nodeSize, to2);
      for (var i2 = 0; i2 < toRemove.length; i2++) {
        var style = toRemove[i2], found$1 = void 0;
        for (var j = 0; j < matched.length; j++) {
          var m = matched[j];
          if (m.step == step2 - 1 && style.eq(matched[j].style)) {
            found$1 = m;
          }
        }
        if (found$1) {
          found$1.to = end2;
          found$1.step = step2;
        } else {
          matched.push({ style, from: Math.max(pos, from5), to: end2, step: step2 });
        }
      }
    }
  });
  matched.forEach(function(m) {
    return this$1$1.step(new RemoveMarkStep(m.from, m.to, m.style));
  });
  return this;
};
Transform.prototype.clearIncompatible = function(pos, parentType, match) {
  if (match === void 0)
    match = parentType.contentMatch;
  var node4 = this.doc.nodeAt(pos);
  var delSteps = [], cur = pos + 1;
  for (var i2 = 0; i2 < node4.childCount; i2++) {
    var child3 = node4.child(i2), end2 = cur + child3.nodeSize;
    var allowed = match.matchType(child3.type, child3.attrs);
    if (!allowed) {
      delSteps.push(new ReplaceStep(cur, end2, Slice.empty));
    } else {
      match = allowed;
      for (var j = 0; j < child3.marks.length; j++) {
        if (!parentType.allowsMarkType(child3.marks[j].type)) {
          this.step(new RemoveMarkStep(cur, end2, child3.marks[j]));
        }
      }
    }
    cur = end2;
  }
  if (!match.validEnd) {
    var fill = match.fillBefore(Fragment.empty, true);
    this.replace(cur, cur, new Slice(fill, 0, 0));
  }
  for (var i$1 = delSteps.length - 1; i$1 >= 0; i$1--) {
    this.step(delSteps[i$1]);
  }
  return this;
};
function replaceStep(doc2, from5, to2, slice4) {
  if (to2 === void 0)
    to2 = from5;
  if (slice4 === void 0)
    slice4 = Slice.empty;
  if (from5 == to2 && !slice4.size) {
    return null;
  }
  var $from = doc2.resolve(from5), $to = doc2.resolve(to2);
  if (fitsTrivially($from, $to, slice4)) {
    return new ReplaceStep(from5, to2, slice4);
  }
  return new Fitter($from, $to, slice4).fit();
}
Transform.prototype.replace = function(from5, to2, slice4) {
  if (to2 === void 0)
    to2 = from5;
  if (slice4 === void 0)
    slice4 = Slice.empty;
  var step2 = replaceStep(this.doc, from5, to2, slice4);
  if (step2) {
    this.step(step2);
  }
  return this;
};
Transform.prototype.replaceWith = function(from5, to2, content2) {
  return this.replace(from5, to2, new Slice(Fragment.from(content2), 0, 0));
};
Transform.prototype.delete = function(from5, to2) {
  return this.replace(from5, to2, Slice.empty);
};
Transform.prototype.insert = function(pos, content2) {
  return this.replaceWith(pos, pos, content2);
};
function fitsTrivially($from, $to, slice4) {
  return !slice4.openStart && !slice4.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice4.content);
}
var Fitter = function Fitter2($from, $to, slice4) {
  this.$to = $to;
  this.$from = $from;
  this.unplaced = slice4;
  this.frontier = [];
  for (var i2 = 0; i2 <= $from.depth; i2++) {
    var node4 = $from.node(i2);
    this.frontier.push({
      type: node4.type,
      match: node4.contentMatchAt($from.indexAfter(i2))
    });
  }
  this.placed = Fragment.empty;
  for (var i$1 = $from.depth; i$1 > 0; i$1--) {
    this.placed = Fragment.from($from.node(i$1).copy(this.placed));
  }
};
var prototypeAccessors$1$2 = { depth: { configurable: true } };
prototypeAccessors$1$2.depth.get = function() {
  return this.frontier.length - 1;
};
Fitter.prototype.fit = function fit() {
  while (this.unplaced.size) {
    var fit2 = this.findFittable();
    if (fit2) {
      this.placeNodes(fit2);
    } else {
      this.openMore() || this.dropNode();
    }
  }
  var moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
  var $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
  if (!$to) {
    return null;
  }
  var content2 = this.placed, openStart = $from.depth, openEnd = $to.depth;
  while (openStart && openEnd && content2.childCount == 1) {
    content2 = content2.firstChild.content;
    openStart--;
    openEnd--;
  }
  var slice4 = new Slice(content2, openStart, openEnd);
  if (moveInline > -1) {
    return new ReplaceAroundStep($from.pos, moveInline, this.$to.pos, this.$to.end(), slice4, placedSize);
  }
  if (slice4.size || $from.pos != this.$to.pos) {
    return new ReplaceStep($from.pos, $to.pos, slice4);
  }
};
Fitter.prototype.findFittable = function findFittable() {
  for (var pass = 1; pass <= 2; pass++) {
    for (var sliceDepth = this.unplaced.openStart; sliceDepth >= 0; sliceDepth--) {
      var fragment = void 0, parent = void 0;
      if (sliceDepth) {
        parent = contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
        fragment = parent.content;
      } else {
        fragment = this.unplaced.content;
      }
      var first = fragment.firstChild;
      for (var frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--) {
        var ref2 = this.frontier[frontierDepth];
        var type = ref2.type;
        var match = ref2.match;
        var wrap = void 0, inject2 = void 0;
        if (pass == 1 && (first ? match.matchType(first.type) || (inject2 = match.fillBefore(Fragment.from(first), false)) : type.compatibleContent(parent.type))) {
          return { sliceDepth, frontierDepth, parent, inject: inject2 };
        } else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) {
          return { sliceDepth, frontierDepth, parent, wrap };
        }
        if (parent && match.matchType(parent.type)) {
          break;
        }
      }
    }
  }
};
Fitter.prototype.openMore = function openMore() {
  var ref2 = this.unplaced;
  var content2 = ref2.content;
  var openStart = ref2.openStart;
  var openEnd = ref2.openEnd;
  var inner = contentAt(content2, openStart);
  if (!inner.childCount || inner.firstChild.isLeaf) {
    return false;
  }
  this.unplaced = new Slice(content2, openStart + 1, Math.max(openEnd, inner.size + openStart >= content2.size - openEnd ? openStart + 1 : 0));
  return true;
};
Fitter.prototype.dropNode = function dropNode() {
  var ref2 = this.unplaced;
  var content2 = ref2.content;
  var openStart = ref2.openStart;
  var openEnd = ref2.openEnd;
  var inner = contentAt(content2, openStart);
  if (inner.childCount <= 1 && openStart > 0) {
    var openAtEnd = content2.size - openStart <= openStart + inner.size;
    this.unplaced = new Slice(dropFromFragment(content2, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
  } else {
    this.unplaced = new Slice(dropFromFragment(content2, openStart, 1), openStart, openEnd);
  }
};
Fitter.prototype.placeNodes = function placeNodes(ref2) {
  var sliceDepth = ref2.sliceDepth;
  var frontierDepth = ref2.frontierDepth;
  var parent = ref2.parent;
  var inject2 = ref2.inject;
  var wrap = ref2.wrap;
  while (this.depth > frontierDepth) {
    this.closeFrontierNode();
  }
  if (wrap) {
    for (var i2 = 0; i2 < wrap.length; i2++) {
      this.openFrontierNode(wrap[i2]);
    }
  }
  var slice4 = this.unplaced, fragment = parent ? parent.content : slice4.content;
  var openStart = slice4.openStart - sliceDepth;
  var taken = 0, add3 = [];
  var ref$1 = this.frontier[frontierDepth];
  var match = ref$1.match;
  var type = ref$1.type;
  if (inject2) {
    for (var i$1 = 0; i$1 < inject2.childCount; i$1++) {
      add3.push(inject2.child(i$1));
    }
    match = match.matchFragment(inject2);
  }
  var openEndCount = fragment.size + sliceDepth - (slice4.content.size - slice4.openEnd);
  while (taken < fragment.childCount) {
    var next = fragment.child(taken), matches2 = match.matchType(next.type);
    if (!matches2) {
      break;
    }
    taken++;
    if (taken > 1 || openStart == 0 || next.content.size) {
      match = matches2;
      add3.push(closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
    }
  }
  var toEnd = taken == fragment.childCount;
  if (!toEnd) {
    openEndCount = -1;
  }
  this.placed = addToFragment(this.placed, frontierDepth, Fragment.from(add3));
  this.frontier[frontierDepth].match = match;
  if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) {
    this.closeFrontierNode();
  }
  for (var i$2 = 0, cur = fragment; i$2 < openEndCount; i$2++) {
    var node4 = cur.lastChild;
    this.frontier.push({ type: node4.type, match: node4.contentMatchAt(node4.childCount) });
    cur = node4.content;
  }
  this.unplaced = !toEnd ? new Slice(dropFromFragment(slice4.content, sliceDepth, taken), slice4.openStart, slice4.openEnd) : sliceDepth == 0 ? Slice.empty : new Slice(dropFromFragment(slice4.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice4.openEnd : sliceDepth - 1);
};
Fitter.prototype.mustMoveInline = function mustMoveInline() {
  if (!this.$to.parent.isTextblock || this.$to.end() == this.$to.pos) {
    return -1;
  }
  var top = this.frontier[this.depth], level;
  if (!top.type.isTextblock || !contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) {
    return -1;
  }
  var ref2 = this.$to;
  var depth = ref2.depth;
  var after2 = this.$to.after(depth);
  while (depth > 1 && after2 == this.$to.end(--depth)) {
    ++after2;
  }
  return after2;
};
Fitter.prototype.findCloseLevel = function findCloseLevel($to) {
  scan:
    for (var i2 = Math.min(this.depth, $to.depth); i2 >= 0; i2--) {
      var ref2 = this.frontier[i2];
      var match = ref2.match;
      var type = ref2.type;
      var dropInner = i2 < $to.depth && $to.end(i2 + 1) == $to.pos + ($to.depth - (i2 + 1));
      var fit2 = contentAfterFits($to, i2, type, match, dropInner);
      if (!fit2) {
        continue;
      }
      for (var d = i2 - 1; d >= 0; d--) {
        var ref$1 = this.frontier[d];
        var match$1 = ref$1.match;
        var type$1 = ref$1.type;
        var matches2 = contentAfterFits($to, d, type$1, match$1, true);
        if (!matches2 || matches2.childCount) {
          continue scan;
        }
      }
      return { depth: i2, fit: fit2, move: dropInner ? $to.doc.resolve($to.after(i2 + 1)) : $to };
    }
};
Fitter.prototype.close = function close2($to) {
  var close3 = this.findCloseLevel($to);
  if (!close3) {
    return null;
  }
  while (this.depth > close3.depth) {
    this.closeFrontierNode();
  }
  if (close3.fit.childCount) {
    this.placed = addToFragment(this.placed, close3.depth, close3.fit);
  }
  $to = close3.move;
  for (var d = close3.depth + 1; d <= $to.depth; d++) {
    var node4 = $to.node(d), add3 = node4.type.contentMatch.fillBefore(node4.content, true, $to.index(d));
    this.openFrontierNode(node4.type, node4.attrs, add3);
  }
  return $to;
};
Fitter.prototype.openFrontierNode = function openFrontierNode(type, attrs, content2) {
  var top = this.frontier[this.depth];
  top.match = top.match.matchType(type);
  this.placed = addToFragment(this.placed, this.depth, Fragment.from(type.create(attrs, content2)));
  this.frontier.push({ type, match: type.contentMatch });
};
Fitter.prototype.closeFrontierNode = function closeFrontierNode() {
  var open = this.frontier.pop();
  var add3 = open.match.fillBefore(Fragment.empty, true);
  if (add3.childCount) {
    this.placed = addToFragment(this.placed, this.frontier.length, add3);
  }
};
Object.defineProperties(Fitter.prototype, prototypeAccessors$1$2);
function dropFromFragment(fragment, depth, count) {
  if (depth == 0) {
    return fragment.cutByIndex(count);
  }
  return fragment.replaceChild(0, fragment.firstChild.copy(dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function addToFragment(fragment, depth, content2) {
  if (depth == 0) {
    return fragment.append(content2);
  }
  return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy(addToFragment(fragment.lastChild.content, depth - 1, content2)));
}
function contentAt(fragment, depth) {
  for (var i2 = 0; i2 < depth; i2++) {
    fragment = fragment.firstChild.content;
  }
  return fragment;
}
function closeNodeStart(node4, openStart, openEnd) {
  if (openStart <= 0) {
    return node4;
  }
  var frag = node4.content;
  if (openStart > 1) {
    frag = frag.replaceChild(0, closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
  }
  if (openStart > 0) {
    frag = node4.type.contentMatch.fillBefore(frag).append(frag);
    if (openEnd <= 0) {
      frag = frag.append(node4.type.contentMatch.matchFragment(frag).fillBefore(Fragment.empty, true));
    }
  }
  return node4.copy(frag);
}
function contentAfterFits($to, depth, type, match, open) {
  var node4 = $to.node(depth), index3 = open ? $to.indexAfter(depth) : $to.index(depth);
  if (index3 == node4.childCount && !type.compatibleContent(node4.type)) {
    return null;
  }
  var fit2 = match.fillBefore(node4.content, true, index3);
  return fit2 && !invalidMarks(type, node4.content, index3) ? fit2 : null;
}
function invalidMarks(type, fragment, start3) {
  for (var i2 = start3; i2 < fragment.childCount; i2++) {
    if (!type.allowsMarks(fragment.child(i2).marks)) {
      return true;
    }
  }
  return false;
}
Transform.prototype.replaceRange = function(from5, to2, slice4) {
  if (!slice4.size) {
    return this.deleteRange(from5, to2);
  }
  var $from = this.doc.resolve(from5), $to = this.doc.resolve(to2);
  if (fitsTrivially($from, $to, slice4)) {
    return this.step(new ReplaceStep(from5, to2, slice4));
  }
  var targetDepths = coveredDepths($from, this.doc.resolve(to2));
  if (targetDepths[targetDepths.length - 1] == 0) {
    targetDepths.pop();
  }
  var preferredTarget = -($from.depth + 1);
  targetDepths.unshift(preferredTarget);
  for (var d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--) {
    var spec = $from.node(d).type.spec;
    if (spec.defining || spec.isolating) {
      break;
    }
    if (targetDepths.indexOf(d) > -1) {
      preferredTarget = d;
    } else if ($from.before(d) == pos) {
      targetDepths.splice(1, 0, -d);
    }
  }
  var preferredTargetIndex = targetDepths.indexOf(preferredTarget);
  var leftNodes = [], preferredDepth = slice4.openStart;
  for (var content2 = slice4.content, i2 = 0; ; i2++) {
    var node4 = content2.firstChild;
    leftNodes.push(node4);
    if (i2 == slice4.openStart) {
      break;
    }
    content2 = node4.content;
  }
  if (preferredDepth > 0 && leftNodes[preferredDepth - 1].type.spec.defining && $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 1].type) {
    preferredDepth -= 1;
  } else if (preferredDepth >= 2 && leftNodes[preferredDepth - 1].isTextblock && leftNodes[preferredDepth - 2].type.spec.defining && $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 2].type) {
    preferredDepth -= 2;
  }
  for (var j = slice4.openStart; j >= 0; j--) {
    var openDepth = (j + preferredDepth + 1) % (slice4.openStart + 1);
    var insert = leftNodes[openDepth];
    if (!insert) {
      continue;
    }
    for (var i$1 = 0; i$1 < targetDepths.length; i$1++) {
      var targetDepth = targetDepths[(i$1 + preferredTargetIndex) % targetDepths.length], expand = true;
      if (targetDepth < 0) {
        expand = false;
        targetDepth = -targetDepth;
      }
      var parent = $from.node(targetDepth - 1), index3 = $from.index(targetDepth - 1);
      if (parent.canReplaceWith(index3, index3, insert.type, insert.marks)) {
        return this.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to2, new Slice(closeFragment(slice4.content, 0, slice4.openStart, openDepth), openDepth, slice4.openEnd));
      }
    }
  }
  var startSteps = this.steps.length;
  for (var i$2 = targetDepths.length - 1; i$2 >= 0; i$2--) {
    this.replace(from5, to2, slice4);
    if (this.steps.length > startSteps) {
      break;
    }
    var depth = targetDepths[i$2];
    if (depth < 0) {
      continue;
    }
    from5 = $from.before(depth);
    to2 = $to.after(depth);
  }
  return this;
};
function closeFragment(fragment, depth, oldOpen, newOpen, parent) {
  if (depth < oldOpen) {
    var first = fragment.firstChild;
    fragment = fragment.replaceChild(0, first.copy(closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
  }
  if (depth > newOpen) {
    var match = parent.contentMatchAt(0);
    var start3 = match.fillBefore(fragment).append(fragment);
    fragment = start3.append(match.matchFragment(start3).fillBefore(Fragment.empty, true));
  }
  return fragment;
}
Transform.prototype.replaceRangeWith = function(from5, to2, node4) {
  if (!node4.isInline && from5 == to2 && this.doc.resolve(from5).parent.content.size) {
    var point = insertPoint(this.doc, from5, node4.type);
    if (point != null) {
      from5 = to2 = point;
    }
  }
  return this.replaceRange(from5, to2, new Slice(Fragment.from(node4), 0, 0));
};
Transform.prototype.deleteRange = function(from5, to2) {
  var $from = this.doc.resolve(from5), $to = this.doc.resolve(to2);
  var covered = coveredDepths($from, $to);
  for (var i2 = 0; i2 < covered.length; i2++) {
    var depth = covered[i2], last = i2 == covered.length - 1;
    if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) {
      return this.delete($from.start(depth), $to.end(depth));
    }
    if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) {
      return this.delete($from.before(depth), $to.after(depth));
    }
  }
  for (var d = 1; d <= $from.depth && d <= $to.depth; d++) {
    if (from5 - $from.start(d) == $from.depth - d && to2 > $from.end(d) && $to.end(d) - to2 != $to.depth - d) {
      return this.delete($from.before(d), to2);
    }
  }
  return this.delete(from5, to2);
};
function coveredDepths($from, $to) {
  var result2 = [], minDepth = Math.min($from.depth, $to.depth);
  for (var d = minDepth; d >= 0; d--) {
    var start3 = $from.start(d);
    if (start3 < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) {
      break;
    }
    if (start3 == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start3 - 1) {
      result2.push(d);
    }
  }
  return result2;
}
var classesById = /* @__PURE__ */ Object.create(null);
var Selection = function Selection2($anchor, $head, ranges) {
  this.ranges = ranges || [new SelectionRange($anchor.min($head), $anchor.max($head))];
  this.$anchor = $anchor;
  this.$head = $head;
};
var prototypeAccessors$3 = { anchor: { configurable: true }, head: { configurable: true }, from: { configurable: true }, to: { configurable: true }, $from: { configurable: true }, $to: { configurable: true }, empty: { configurable: true } };
prototypeAccessors$3.anchor.get = function() {
  return this.$anchor.pos;
};
prototypeAccessors$3.head.get = function() {
  return this.$head.pos;
};
prototypeAccessors$3.from.get = function() {
  return this.$from.pos;
};
prototypeAccessors$3.to.get = function() {
  return this.$to.pos;
};
prototypeAccessors$3.$from.get = function() {
  return this.ranges[0].$from;
};
prototypeAccessors$3.$to.get = function() {
  return this.ranges[0].$to;
};
prototypeAccessors$3.empty.get = function() {
  var ranges = this.ranges;
  for (var i2 = 0; i2 < ranges.length; i2++) {
    if (ranges[i2].$from.pos != ranges[i2].$to.pos) {
      return false;
    }
  }
  return true;
};
Selection.prototype.content = function content() {
  return this.$from.node(0).slice(this.from, this.to, true);
};
Selection.prototype.replace = function replace2(tr, content2) {
  if (content2 === void 0)
    content2 = Slice.empty;
  var lastNode = content2.content.lastChild, lastParent = null;
  for (var i2 = 0; i2 < content2.openEnd; i2++) {
    lastParent = lastNode;
    lastNode = lastNode.lastChild;
  }
  var mapFrom = tr.steps.length, ranges = this.ranges;
  for (var i$1 = 0; i$1 < ranges.length; i$1++) {
    var ref2 = ranges[i$1];
    var $from = ref2.$from;
    var $to = ref2.$to;
    var mapping = tr.mapping.slice(mapFrom);
    tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i$1 ? Slice.empty : content2);
    if (i$1 == 0) {
      selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
    }
  }
};
Selection.prototype.replaceWith = function replaceWith(tr, node4) {
  var mapFrom = tr.steps.length, ranges = this.ranges;
  for (var i2 = 0; i2 < ranges.length; i2++) {
    var ref2 = ranges[i2];
    var $from = ref2.$from;
    var $to = ref2.$to;
    var mapping = tr.mapping.slice(mapFrom);
    var from5 = mapping.map($from.pos), to2 = mapping.map($to.pos);
    if (i2) {
      tr.deleteRange(from5, to2);
    } else {
      tr.replaceRangeWith(from5, to2, node4);
      selectionToInsertionEnd(tr, mapFrom, node4.isInline ? -1 : 1);
    }
  }
};
Selection.findFrom = function findFrom($pos, dir, textOnly) {
  var inner = $pos.parent.inlineContent ? new TextSelection($pos) : findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
  if (inner) {
    return inner;
  }
  for (var depth = $pos.depth - 1; depth >= 0; depth--) {
    var found2 = dir < 0 ? findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
    if (found2) {
      return found2;
    }
  }
};
Selection.near = function near($pos, bias) {
  if (bias === void 0)
    bias = 1;
  return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new AllSelection($pos.node(0));
};
Selection.atStart = function atStart(doc2) {
  return findSelectionIn(doc2, doc2, 0, 0, 1) || new AllSelection(doc2);
};
Selection.atEnd = function atEnd(doc2) {
  return findSelectionIn(doc2, doc2, doc2.content.size, doc2.childCount, -1) || new AllSelection(doc2);
};
Selection.fromJSON = function fromJSON6(doc2, json) {
  if (!json || !json.type) {
    throw new RangeError("Invalid input for Selection.fromJSON");
  }
  var cls = classesById[json.type];
  if (!cls) {
    throw new RangeError("No selection type " + json.type + " defined");
  }
  return cls.fromJSON(doc2, json);
};
Selection.jsonID = function jsonID2(id, selectionClass) {
  if (id in classesById) {
    throw new RangeError("Duplicate use of selection JSON ID " + id);
  }
  classesById[id] = selectionClass;
  selectionClass.prototype.jsonID = id;
  return selectionClass;
};
Selection.prototype.getBookmark = function getBookmark() {
  return TextSelection.between(this.$anchor, this.$head).getBookmark();
};
Object.defineProperties(Selection.prototype, prototypeAccessors$3);
Selection.prototype.visible = true;
var SelectionRange = function SelectionRange2($from, $to) {
  this.$from = $from;
  this.$to = $to;
};
var TextSelection = /* @__PURE__ */ function(Selection3) {
  function TextSelection2($anchor, $head) {
    if ($head === void 0)
      $head = $anchor;
    Selection3.call(this, $anchor, $head);
  }
  if (Selection3)
    TextSelection2.__proto__ = Selection3;
  TextSelection2.prototype = Object.create(Selection3 && Selection3.prototype);
  TextSelection2.prototype.constructor = TextSelection2;
  var prototypeAccessors$12 = { $cursor: { configurable: true } };
  prototypeAccessors$12.$cursor.get = function() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  };
  TextSelection2.prototype.map = function map16(doc2, mapping) {
    var $head = doc2.resolve(mapping.map(this.head));
    if (!$head.parent.inlineContent) {
      return Selection3.near($head);
    }
    var $anchor = doc2.resolve(mapping.map(this.anchor));
    return new TextSelection2($anchor.parent.inlineContent ? $anchor : $head, $head);
  };
  TextSelection2.prototype.replace = function replace3(tr, content2) {
    if (content2 === void 0)
      content2 = Slice.empty;
    Selection3.prototype.replace.call(this, tr, content2);
    if (content2 == Slice.empty) {
      var marks2 = this.$from.marksAcross(this.$to);
      if (marks2) {
        tr.ensureMarks(marks2);
      }
    }
  };
  TextSelection2.prototype.eq = function eq12(other) {
    return other instanceof TextSelection2 && other.anchor == this.anchor && other.head == this.head;
  };
  TextSelection2.prototype.getBookmark = function getBookmark2() {
    return new TextBookmark(this.anchor, this.head);
  };
  TextSelection2.prototype.toJSON = function toJSON8() {
    return { type: "text", anchor: this.anchor, head: this.head };
  };
  TextSelection2.fromJSON = function fromJSON8(doc2, json) {
    if (typeof json.anchor != "number" || typeof json.head != "number") {
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    }
    return new TextSelection2(doc2.resolve(json.anchor), doc2.resolve(json.head));
  };
  TextSelection2.create = function create6(doc2, anchor, head) {
    if (head === void 0)
      head = anchor;
    var $anchor = doc2.resolve(anchor);
    return new this($anchor, head == anchor ? $anchor : doc2.resolve(head));
  };
  TextSelection2.between = function between($anchor, $head, bias) {
    var dPos = $anchor.pos - $head.pos;
    if (!bias || dPos) {
      bias = dPos >= 0 ? 1 : -1;
    }
    if (!$head.parent.inlineContent) {
      var found2 = Selection3.findFrom($head, bias, true) || Selection3.findFrom($head, -bias, true);
      if (found2) {
        $head = found2.$head;
      } else {
        return Selection3.near($head, bias);
      }
    }
    if (!$anchor.parent.inlineContent) {
      if (dPos == 0) {
        $anchor = $head;
      } else {
        $anchor = (Selection3.findFrom($anchor, -bias, true) || Selection3.findFrom($anchor, bias, true)).$anchor;
        if ($anchor.pos < $head.pos != dPos < 0) {
          $anchor = $head;
        }
      }
    }
    return new TextSelection2($anchor, $head);
  };
  Object.defineProperties(TextSelection2.prototype, prototypeAccessors$12);
  return TextSelection2;
}(Selection);
Selection.jsonID("text", TextSelection);
var TextBookmark = function TextBookmark2(anchor, head) {
  this.anchor = anchor;
  this.head = head;
};
TextBookmark.prototype.map = function map5(mapping) {
  return new TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
};
TextBookmark.prototype.resolve = function resolve3(doc2) {
  return TextSelection.between(doc2.resolve(this.anchor), doc2.resolve(this.head));
};
var NodeSelection = /* @__PURE__ */ function(Selection3) {
  function NodeSelection2($pos) {
    var node4 = $pos.nodeAfter;
    var $end = $pos.node(0).resolve($pos.pos + node4.nodeSize);
    Selection3.call(this, $pos, $end);
    this.node = node4;
  }
  if (Selection3)
    NodeSelection2.__proto__ = Selection3;
  NodeSelection2.prototype = Object.create(Selection3 && Selection3.prototype);
  NodeSelection2.prototype.constructor = NodeSelection2;
  NodeSelection2.prototype.map = function map16(doc2, mapping) {
    var ref2 = mapping.mapResult(this.anchor);
    var deleted = ref2.deleted;
    var pos = ref2.pos;
    var $pos = doc2.resolve(pos);
    if (deleted) {
      return Selection3.near($pos);
    }
    return new NodeSelection2($pos);
  };
  NodeSelection2.prototype.content = function content2() {
    return new Slice(Fragment.from(this.node), 0, 0);
  };
  NodeSelection2.prototype.eq = function eq12(other) {
    return other instanceof NodeSelection2 && other.anchor == this.anchor;
  };
  NodeSelection2.prototype.toJSON = function toJSON8() {
    return { type: "node", anchor: this.anchor };
  };
  NodeSelection2.prototype.getBookmark = function getBookmark2() {
    return new NodeBookmark(this.anchor);
  };
  NodeSelection2.fromJSON = function fromJSON8(doc2, json) {
    if (typeof json.anchor != "number") {
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    }
    return new NodeSelection2(doc2.resolve(json.anchor));
  };
  NodeSelection2.create = function create6(doc2, from5) {
    return new this(doc2.resolve(from5));
  };
  NodeSelection2.isSelectable = function isSelectable(node4) {
    return !node4.isText && node4.type.spec.selectable !== false;
  };
  return NodeSelection2;
}(Selection);
NodeSelection.prototype.visible = false;
Selection.jsonID("node", NodeSelection);
var NodeBookmark = function NodeBookmark2(anchor) {
  this.anchor = anchor;
};
NodeBookmark.prototype.map = function map6(mapping) {
  var ref2 = mapping.mapResult(this.anchor);
  var deleted = ref2.deleted;
  var pos = ref2.pos;
  return deleted ? new TextBookmark(pos, pos) : new NodeBookmark(pos);
};
NodeBookmark.prototype.resolve = function resolve4(doc2) {
  var $pos = doc2.resolve(this.anchor), node4 = $pos.nodeAfter;
  if (node4 && NodeSelection.isSelectable(node4)) {
    return new NodeSelection($pos);
  }
  return Selection.near($pos);
};
var AllSelection = /* @__PURE__ */ function(Selection3) {
  function AllSelection2(doc2) {
    Selection3.call(this, doc2.resolve(0), doc2.resolve(doc2.content.size));
  }
  if (Selection3)
    AllSelection2.__proto__ = Selection3;
  AllSelection2.prototype = Object.create(Selection3 && Selection3.prototype);
  AllSelection2.prototype.constructor = AllSelection2;
  AllSelection2.prototype.replace = function replace3(tr, content2) {
    if (content2 === void 0)
      content2 = Slice.empty;
    if (content2 == Slice.empty) {
      tr.delete(0, tr.doc.content.size);
      var sel = Selection3.atStart(tr.doc);
      if (!sel.eq(tr.selection)) {
        tr.setSelection(sel);
      }
    } else {
      Selection3.prototype.replace.call(this, tr, content2);
    }
  };
  AllSelection2.prototype.toJSON = function toJSON8() {
    return { type: "all" };
  };
  AllSelection2.fromJSON = function fromJSON8(doc2) {
    return new AllSelection2(doc2);
  };
  AllSelection2.prototype.map = function map16(doc2) {
    return new AllSelection2(doc2);
  };
  AllSelection2.prototype.eq = function eq12(other) {
    return other instanceof AllSelection2;
  };
  AllSelection2.prototype.getBookmark = function getBookmark2() {
    return AllBookmark;
  };
  return AllSelection2;
}(Selection);
Selection.jsonID("all", AllSelection);
var AllBookmark = {
  map: function map7() {
    return this;
  },
  resolve: function resolve5(doc2) {
    return new AllSelection(doc2);
  }
};
function findSelectionIn(doc2, node4, pos, index3, dir, text2) {
  if (node4.inlineContent) {
    return TextSelection.create(doc2, pos);
  }
  for (var i2 = index3 - (dir > 0 ? 0 : 1); dir > 0 ? i2 < node4.childCount : i2 >= 0; i2 += dir) {
    var child3 = node4.child(i2);
    if (!child3.isAtom) {
      var inner = findSelectionIn(doc2, child3, pos + dir, dir < 0 ? child3.childCount : 0, dir, text2);
      if (inner) {
        return inner;
      }
    } else if (!text2 && NodeSelection.isSelectable(child3)) {
      return NodeSelection.create(doc2, pos - (dir < 0 ? child3.nodeSize : 0));
    }
    pos += child3.nodeSize * dir;
  }
}
function selectionToInsertionEnd(tr, startLen, bias) {
  var last = tr.steps.length - 1;
  if (last < startLen) {
    return;
  }
  var step2 = tr.steps[last];
  if (!(step2 instanceof ReplaceStep || step2 instanceof ReplaceAroundStep)) {
    return;
  }
  var map16 = tr.mapping.maps[last], end2;
  map16.forEach(function(_from, _to, _newFrom, newTo) {
    if (end2 == null) {
      end2 = newTo;
    }
  });
  tr.setSelection(Selection.near(tr.doc.resolve(end2), bias));
}
var UPDATED_SEL = 1, UPDATED_MARKS = 2, UPDATED_SCROLL = 4;
var Transaction = /* @__PURE__ */ function(Transform3) {
  function Transaction2(state) {
    Transform3.call(this, state.doc);
    this.time = Date.now();
    this.curSelection = state.selection;
    this.curSelectionFor = 0;
    this.storedMarks = state.storedMarks;
    this.updated = 0;
    this.meta = /* @__PURE__ */ Object.create(null);
  }
  if (Transform3)
    Transaction2.__proto__ = Transform3;
  Transaction2.prototype = Object.create(Transform3 && Transform3.prototype);
  Transaction2.prototype.constructor = Transaction2;
  var prototypeAccessors2 = { selection: { configurable: true }, selectionSet: { configurable: true }, storedMarksSet: { configurable: true }, isGeneric: { configurable: true }, scrolledIntoView: { configurable: true } };
  prototypeAccessors2.selection.get = function() {
    if (this.curSelectionFor < this.steps.length) {
      this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
      this.curSelectionFor = this.steps.length;
    }
    return this.curSelection;
  };
  Transaction2.prototype.setSelection = function setSelection2(selection) {
    if (selection.$from.doc != this.doc) {
      throw new RangeError("Selection passed to setSelection must point at the current document");
    }
    this.curSelection = selection;
    this.curSelectionFor = this.steps.length;
    this.updated = (this.updated | UPDATED_SEL) & ~UPDATED_MARKS;
    this.storedMarks = null;
    return this;
  };
  prototypeAccessors2.selectionSet.get = function() {
    return (this.updated & UPDATED_SEL) > 0;
  };
  Transaction2.prototype.setStoredMarks = function setStoredMarks(marks2) {
    this.storedMarks = marks2;
    this.updated |= UPDATED_MARKS;
    return this;
  };
  Transaction2.prototype.ensureMarks = function ensureMarks(marks2) {
    if (!Mark.sameSet(this.storedMarks || this.selection.$from.marks(), marks2)) {
      this.setStoredMarks(marks2);
    }
    return this;
  };
  Transaction2.prototype.addStoredMark = function addStoredMark(mark3) {
    return this.ensureMarks(mark3.addToSet(this.storedMarks || this.selection.$head.marks()));
  };
  Transaction2.prototype.removeStoredMark = function removeStoredMark(mark3) {
    return this.ensureMarks(mark3.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  };
  prototypeAccessors2.storedMarksSet.get = function() {
    return (this.updated & UPDATED_MARKS) > 0;
  };
  Transaction2.prototype.addStep = function addStep2(step2, doc2) {
    Transform3.prototype.addStep.call(this, step2, doc2);
    this.updated = this.updated & ~UPDATED_MARKS;
    this.storedMarks = null;
  };
  Transaction2.prototype.setTime = function setTime(time) {
    this.time = time;
    return this;
  };
  Transaction2.prototype.replaceSelection = function replaceSelection(slice4) {
    this.selection.replace(this, slice4);
    return this;
  };
  Transaction2.prototype.replaceSelectionWith = function replaceSelectionWith(node4, inheritMarks) {
    var selection = this.selection;
    if (inheritMarks !== false) {
      node4 = node4.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || Mark.none));
    }
    selection.replaceWith(this, node4);
    return this;
  };
  Transaction2.prototype.deleteSelection = function deleteSelection2() {
    this.selection.replace(this);
    return this;
  };
  Transaction2.prototype.insertText = function insertText(text2, from5, to2) {
    if (to2 === void 0)
      to2 = from5;
    var schema = this.doc.type.schema;
    if (from5 == null) {
      if (!text2) {
        return this.deleteSelection();
      }
      return this.replaceSelectionWith(schema.text(text2), true);
    } else {
      if (!text2) {
        return this.deleteRange(from5, to2);
      }
      var marks2 = this.storedMarks;
      if (!marks2) {
        var $from = this.doc.resolve(from5);
        marks2 = to2 == from5 ? $from.marks() : $from.marksAcross(this.doc.resolve(to2));
      }
      this.replaceRangeWith(from5, to2, schema.text(text2, marks2));
      if (!this.selection.empty) {
        this.setSelection(Selection.near(this.selection.$to));
      }
      return this;
    }
  };
  Transaction2.prototype.setMeta = function setMeta(key, value) {
    this.meta[typeof key == "string" ? key : key.key] = value;
    return this;
  };
  Transaction2.prototype.getMeta = function getMeta(key) {
    return this.meta[typeof key == "string" ? key : key.key];
  };
  prototypeAccessors2.isGeneric.get = function() {
    for (var _ in this.meta) {
      return false;
    }
    return true;
  };
  Transaction2.prototype.scrollIntoView = function scrollIntoView() {
    this.updated |= UPDATED_SCROLL;
    return this;
  };
  prototypeAccessors2.scrolledIntoView.get = function() {
    return (this.updated & UPDATED_SCROLL) > 0;
  };
  Object.defineProperties(Transaction2.prototype, prototypeAccessors2);
  return Transaction2;
}(Transform);
function bind(f, self2) {
  return !self2 || !f ? f : f.bind(self2);
}
var FieldDesc = function FieldDesc2(name, desc, self2) {
  this.name = name;
  this.init = bind(desc.init, self2);
  this.apply = bind(desc.apply, self2);
};
var baseFields = [
  new FieldDesc("doc", {
    init: function init(config2) {
      return config2.doc || config2.schema.topNodeType.createAndFill();
    },
    apply: function apply2(tr) {
      return tr.doc;
    }
  }),
  new FieldDesc("selection", {
    init: function init2(config2, instance) {
      return config2.selection || Selection.atStart(instance.doc);
    },
    apply: function apply3(tr) {
      return tr.selection;
    }
  }),
  new FieldDesc("storedMarks", {
    init: function init3(config2) {
      return config2.storedMarks || null;
    },
    apply: function apply4(tr, _marks, _old, state) {
      return state.selection.$cursor ? tr.storedMarks : null;
    }
  }),
  new FieldDesc("scrollToSelection", {
    init: function init4() {
      return 0;
    },
    apply: function apply5(tr, prev) {
      return tr.scrolledIntoView ? prev + 1 : prev;
    }
  })
];
var Configuration = function Configuration2(schema, plugins) {
  var this$1$1 = this;
  this.schema = schema;
  this.fields = baseFields.concat();
  this.plugins = [];
  this.pluginsByKey = /* @__PURE__ */ Object.create(null);
  if (plugins) {
    plugins.forEach(function(plugin) {
      if (this$1$1.pluginsByKey[plugin.key]) {
        throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
      }
      this$1$1.plugins.push(plugin);
      this$1$1.pluginsByKey[plugin.key] = plugin;
      if (plugin.spec.state) {
        this$1$1.fields.push(new FieldDesc(plugin.key, plugin.spec.state, plugin));
      }
    });
  }
};
var EditorState = function EditorState2(config2) {
  this.config = config2;
};
var prototypeAccessors$1$1 = { schema: { configurable: true }, plugins: { configurable: true }, tr: { configurable: true } };
prototypeAccessors$1$1.schema.get = function() {
  return this.config.schema;
};
prototypeAccessors$1$1.plugins.get = function() {
  return this.config.plugins;
};
EditorState.prototype.apply = function apply6(tr) {
  return this.applyTransaction(tr).state;
};
EditorState.prototype.filterTransaction = function filterTransaction(tr, ignore) {
  if (ignore === void 0)
    ignore = -1;
  for (var i2 = 0; i2 < this.config.plugins.length; i2++) {
    if (i2 != ignore) {
      var plugin = this.config.plugins[i2];
      if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) {
        return false;
      }
    }
  }
  return true;
};
EditorState.prototype.applyTransaction = function applyTransaction(rootTr) {
  if (!this.filterTransaction(rootTr)) {
    return { state: this, transactions: [] };
  }
  var trs = [rootTr], newState = this.applyInner(rootTr), seen = null;
  for (; ; ) {
    var haveNew = false;
    for (var i2 = 0; i2 < this.config.plugins.length; i2++) {
      var plugin = this.config.plugins[i2];
      if (plugin.spec.appendTransaction) {
        var n = seen ? seen[i2].n : 0, oldState = seen ? seen[i2].state : this;
        var tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
        if (tr && newState.filterTransaction(tr, i2)) {
          tr.setMeta("appendedTransaction", rootTr);
          if (!seen) {
            seen = [];
            for (var j = 0; j < this.config.plugins.length; j++) {
              seen.push(j < i2 ? { state: newState, n: trs.length } : { state: this, n: 0 });
            }
          }
          trs.push(tr);
          newState = newState.applyInner(tr);
          haveNew = true;
        }
        if (seen) {
          seen[i2] = { state: newState, n: trs.length };
        }
      }
    }
    if (!haveNew) {
      return { state: newState, transactions: trs };
    }
  }
};
EditorState.prototype.applyInner = function applyInner(tr) {
  if (!tr.before.eq(this.doc)) {
    throw new RangeError("Applying a mismatched transaction");
  }
  var newInstance = new EditorState(this.config), fields = this.config.fields;
  for (var i2 = 0; i2 < fields.length; i2++) {
    var field = fields[i2];
    newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
  }
  for (var i$1 = 0; i$1 < applyListeners.length; i$1++) {
    applyListeners[i$1](this, tr, newInstance);
  }
  return newInstance;
};
prototypeAccessors$1$1.tr.get = function() {
  return new Transaction(this);
};
EditorState.create = function create3(config2) {
  var $config = new Configuration(config2.doc ? config2.doc.type.schema : config2.schema, config2.plugins);
  var instance = new EditorState($config);
  for (var i2 = 0; i2 < $config.fields.length; i2++) {
    instance[$config.fields[i2].name] = $config.fields[i2].init(config2, instance);
  }
  return instance;
};
EditorState.prototype.reconfigure = function reconfigure(config2) {
  var $config = new Configuration(this.schema, config2.plugins);
  var fields = $config.fields, instance = new EditorState($config);
  for (var i2 = 0; i2 < fields.length; i2++) {
    var name = fields[i2].name;
    instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i2].init(config2, instance);
  }
  return instance;
};
EditorState.prototype.toJSON = function toJSON7(pluginFields) {
  var result2 = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
  if (this.storedMarks) {
    result2.storedMarks = this.storedMarks.map(function(m) {
      return m.toJSON();
    });
  }
  if (pluginFields && typeof pluginFields == "object") {
    for (var prop in pluginFields) {
      if (prop == "doc" || prop == "selection") {
        throw new RangeError("The JSON fields `doc` and `selection` are reserved");
      }
      var plugin = pluginFields[prop], state = plugin.spec.state;
      if (state && state.toJSON) {
        result2[prop] = state.toJSON.call(plugin, this[plugin.key]);
      }
    }
  }
  return result2;
};
EditorState.fromJSON = function fromJSON7(config2, json, pluginFields) {
  if (!json) {
    throw new RangeError("Invalid input for EditorState.fromJSON");
  }
  if (!config2.schema) {
    throw new RangeError("Required config field 'schema' missing");
  }
  var $config = new Configuration(config2.schema, config2.plugins);
  var instance = new EditorState($config);
  $config.fields.forEach(function(field) {
    if (field.name == "doc") {
      instance.doc = Node$1.fromJSON(config2.schema, json.doc);
    } else if (field.name == "selection") {
      instance.selection = Selection.fromJSON(instance.doc, json.selection);
    } else if (field.name == "storedMarks") {
      if (json.storedMarks) {
        instance.storedMarks = json.storedMarks.map(config2.schema.markFromJSON);
      }
    } else {
      if (pluginFields) {
        for (var prop in pluginFields) {
          var plugin = pluginFields[prop], state = plugin.spec.state;
          if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
            instance[field.name] = state.fromJSON.call(plugin, config2, json[prop], instance);
            return;
          }
        }
      }
      instance[field.name] = field.init(config2, instance);
    }
  });
  return instance;
};
EditorState.addApplyListener = function addApplyListener(f) {
  applyListeners.push(f);
};
EditorState.removeApplyListener = function removeApplyListener(f) {
  var found2 = applyListeners.indexOf(f);
  if (found2 > -1) {
    applyListeners.splice(found2, 1);
  }
};
Object.defineProperties(EditorState.prototype, prototypeAccessors$1$1);
var applyListeners = [];
function bindProps(obj, self2, target) {
  for (var prop in obj) {
    var val = obj[prop];
    if (val instanceof Function) {
      val = val.bind(self2);
    } else if (prop == "handleDOMEvents") {
      val = bindProps(val, self2, {});
    }
    target[prop] = val;
  }
  return target;
}
var Plugin = function Plugin2(spec) {
  this.props = {};
  if (spec.props) {
    bindProps(spec.props, this, this.props);
  }
  this.spec = spec;
  this.key = spec.key ? spec.key.key : createKey("plugin");
};
Plugin.prototype.getState = function getState(state) {
  return state[this.key];
};
var keys$1 = /* @__PURE__ */ Object.create(null);
function createKey(name) {
  if (name in keys$1) {
    return name + "$" + ++keys$1[name];
  }
  keys$1[name] = 0;
  return name + "$";
}
var PluginKey = function PluginKey2(name) {
  if (name === void 0)
    name = "key";
  this.key = createKey(name);
};
PluginKey.prototype.get = function get2(state) {
  return state.config.pluginsByKey[this.key];
};
PluginKey.prototype.getState = function getState2(state) {
  return state[this.key];
};
var result = {};
if (typeof navigator != "undefined" && typeof document != "undefined") {
  var ie_edge = /Edge\/(\d+)/.exec(navigator.userAgent);
  var ie_upto10 = /MSIE \d/.test(navigator.userAgent);
  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
  var ie$1 = result.ie = !!(ie_upto10 || ie_11up || ie_edge);
  result.ie_version = ie_upto10 ? document.documentMode || 6 : ie_11up ? +ie_11up[1] : ie_edge ? +ie_edge[1] : null;
  result.gecko = !ie$1 && /gecko\/(\d+)/i.test(navigator.userAgent);
  result.gecko_version = result.gecko && +(/Firefox\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1];
  var chrome$1 = !ie$1 && /Chrome\/(\d+)/.exec(navigator.userAgent);
  result.chrome = !!chrome$1;
  result.chrome_version = chrome$1 && +chrome$1[1];
  result.safari = !ie$1 && /Apple Computer/.test(navigator.vendor);
  result.ios = result.safari && (/Mobile\/\w+/.test(navigator.userAgent) || navigator.maxTouchPoints > 2);
  result.mac = result.ios || /Mac/.test(navigator.platform);
  result.android = /Android \d/.test(navigator.userAgent);
  result.webkit = "webkitFontSmoothing" in document.documentElement.style;
  result.webkit_version = result.webkit && +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1];
}
var domIndex = function(node4) {
  for (var index3 = 0; ; index3++) {
    node4 = node4.previousSibling;
    if (!node4) {
      return index3;
    }
  }
};
var parentNode = function(node4) {
  var parent = node4.assignedSlot || node4.parentNode;
  return parent && parent.nodeType == 11 ? parent.host : parent;
};
var reusedRange = null;
var textRange = function(node4, from5, to2) {
  var range2 = reusedRange || (reusedRange = document.createRange());
  range2.setEnd(node4, to2 == null ? node4.nodeValue.length : to2);
  range2.setStart(node4, from5 || 0);
  return range2;
};
var isEquivalentPosition = function(node4, off, targetNode, targetOff) {
  return targetNode && (scanFor(node4, off, targetNode, targetOff, -1) || scanFor(node4, off, targetNode, targetOff, 1));
};
var atomElements = /^(img|br|input|textarea|hr)$/i;
function scanFor(node4, off, targetNode, targetOff, dir) {
  for (; ; ) {
    if (node4 == targetNode && off == targetOff) {
      return true;
    }
    if (off == (dir < 0 ? 0 : nodeSize(node4))) {
      var parent = node4.parentNode;
      if (!parent || parent.nodeType != 1 || hasBlockDesc(node4) || atomElements.test(node4.nodeName) || node4.contentEditable == "false") {
        return false;
      }
      off = domIndex(node4) + (dir < 0 ? 0 : 1);
      node4 = parent;
    } else if (node4.nodeType == 1) {
      node4 = node4.childNodes[off + (dir < 0 ? -1 : 0)];
      if (node4.contentEditable == "false") {
        return false;
      }
      off = dir < 0 ? nodeSize(node4) : 0;
    } else {
      return false;
    }
  }
}
function nodeSize(node4) {
  return node4.nodeType == 3 ? node4.nodeValue.length : node4.childNodes.length;
}
function isOnEdge(node4, offset3, parent) {
  for (var atStart2 = offset3 == 0, atEnd2 = offset3 == nodeSize(node4); atStart2 || atEnd2; ) {
    if (node4 == parent) {
      return true;
    }
    var index3 = domIndex(node4);
    node4 = node4.parentNode;
    if (!node4) {
      return false;
    }
    atStart2 = atStart2 && index3 == 0;
    atEnd2 = atEnd2 && index3 == nodeSize(node4);
  }
}
function hasBlockDesc(dom) {
  var desc;
  for (var cur = dom; cur; cur = cur.parentNode) {
    if (desc = cur.pmViewDesc) {
      break;
    }
  }
  return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
var selectionCollapsed = function(domSel) {
  var collapsed = domSel.isCollapsed;
  if (collapsed && result.chrome && domSel.rangeCount && !domSel.getRangeAt(0).collapsed) {
    collapsed = false;
  }
  return collapsed;
};
function keyEvent(keyCode, key) {
  var event = document.createEvent("Event");
  event.initEvent("keydown", true, true);
  event.keyCode = keyCode;
  event.key = event.code = key;
  return event;
}
function windowRect(doc2) {
  return {
    left: 0,
    right: doc2.documentElement.clientWidth,
    top: 0,
    bottom: doc2.documentElement.clientHeight
  };
}
function getSide(value, side) {
  return typeof value == "number" ? value : value[side];
}
function clientRect(node4) {
  var rect = node4.getBoundingClientRect();
  var scaleX = rect.width / node4.offsetWidth || 1;
  var scaleY = rect.height / node4.offsetHeight || 1;
  return {
    left: rect.left,
    right: rect.left + node4.clientWidth * scaleX,
    top: rect.top,
    bottom: rect.top + node4.clientHeight * scaleY
  };
}
function scrollRectIntoView(view, rect, startDOM) {
  var scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
  var doc2 = view.dom.ownerDocument;
  for (var parent = startDOM || view.dom; ; parent = parentNode(parent)) {
    if (!parent) {
      break;
    }
    if (parent.nodeType != 1) {
      continue;
    }
    var atTop = parent == doc2.body || parent.nodeType != 1;
    var bounding = atTop ? windowRect(doc2) : clientRect(parent);
    var moveX = 0, moveY = 0;
    if (rect.top < bounding.top + getSide(scrollThreshold, "top")) {
      moveY = -(bounding.top - rect.top + getSide(scrollMargin, "top"));
    } else if (rect.bottom > bounding.bottom - getSide(scrollThreshold, "bottom")) {
      moveY = rect.bottom - bounding.bottom + getSide(scrollMargin, "bottom");
    }
    if (rect.left < bounding.left + getSide(scrollThreshold, "left")) {
      moveX = -(bounding.left - rect.left + getSide(scrollMargin, "left"));
    } else if (rect.right > bounding.right - getSide(scrollThreshold, "right")) {
      moveX = rect.right - bounding.right + getSide(scrollMargin, "right");
    }
    if (moveX || moveY) {
      if (atTop) {
        doc2.defaultView.scrollBy(moveX, moveY);
      } else {
        var startX = parent.scrollLeft, startY = parent.scrollTop;
        if (moveY) {
          parent.scrollTop += moveY;
        }
        if (moveX) {
          parent.scrollLeft += moveX;
        }
        var dX = parent.scrollLeft - startX, dY = parent.scrollTop - startY;
        rect = { left: rect.left - dX, top: rect.top - dY, right: rect.right - dX, bottom: rect.bottom - dY };
      }
    }
    if (atTop) {
      break;
    }
  }
}
function storeScrollPos(view) {
  var rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
  var refDOM, refTop;
  for (var x2 = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5) {
    var dom = view.root.elementFromPoint(x2, y);
    if (dom == view.dom || !view.dom.contains(dom)) {
      continue;
    }
    var localRect = dom.getBoundingClientRect();
    if (localRect.top >= startY - 20) {
      refDOM = dom;
      refTop = localRect.top;
      break;
    }
  }
  return { refDOM, refTop, stack: scrollStack(view.dom) };
}
function scrollStack(dom) {
  var stack = [], doc2 = dom.ownerDocument;
  for (; dom; dom = parentNode(dom)) {
    stack.push({ dom, top: dom.scrollTop, left: dom.scrollLeft });
    if (dom == doc2) {
      break;
    }
  }
  return stack;
}
function resetScrollPos(ref2) {
  var refDOM = ref2.refDOM;
  var refTop = ref2.refTop;
  var stack = ref2.stack;
  var newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
  restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function restoreScrollStack(stack, dTop) {
  for (var i2 = 0; i2 < stack.length; i2++) {
    var ref2 = stack[i2];
    var dom = ref2.dom;
    var top = ref2.top;
    var left = ref2.left;
    if (dom.scrollTop != top + dTop) {
      dom.scrollTop = top + dTop;
    }
    if (dom.scrollLeft != left) {
      dom.scrollLeft = left;
    }
  }
}
var preventScrollSupported = null;
function focusPreventScroll(dom) {
  if (dom.setActive) {
    return dom.setActive();
  }
  if (preventScrollSupported) {
    return dom.focus(preventScrollSupported);
  }
  var stored = scrollStack(dom);
  dom.focus(preventScrollSupported == null ? {
    get preventScroll() {
      preventScrollSupported = { preventScroll: true };
      return true;
    }
  } : void 0);
  if (!preventScrollSupported) {
    preventScrollSupported = false;
    restoreScrollStack(stored, 0);
  }
}
function findOffsetInNode(node4, coords) {
  var closest, dxClosest = 2e8, coordsClosest, offset3 = 0;
  var rowBot = coords.top, rowTop = coords.top;
  for (var child3 = node4.firstChild, childIndex = 0; child3; child3 = child3.nextSibling, childIndex++) {
    var rects = void 0;
    if (child3.nodeType == 1) {
      rects = child3.getClientRects();
    } else if (child3.nodeType == 3) {
      rects = textRange(child3).getClientRects();
    } else {
      continue;
    }
    for (var i2 = 0; i2 < rects.length; i2++) {
      var rect = rects[i2];
      if (rect.top <= rowBot && rect.bottom >= rowTop) {
        rowBot = Math.max(rect.bottom, rowBot);
        rowTop = Math.min(rect.top, rowTop);
        var dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
        if (dx < dxClosest) {
          closest = child3;
          dxClosest = dx;
          coordsClosest = dx && closest.nodeType == 3 ? { left: rect.right < coords.left ? rect.right : rect.left, top: coords.top } : coords;
          if (child3.nodeType == 1 && dx) {
            offset3 = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
          }
          continue;
        }
      }
      if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) {
        offset3 = childIndex + 1;
      }
    }
  }
  if (closest && closest.nodeType == 3) {
    return findOffsetInText(closest, coordsClosest);
  }
  if (!closest || dxClosest && closest.nodeType == 1) {
    return { node: node4, offset: offset3 };
  }
  return findOffsetInNode(closest, coordsClosest);
}
function findOffsetInText(node4, coords) {
  var len = node4.nodeValue.length;
  var range2 = document.createRange();
  for (var i2 = 0; i2 < len; i2++) {
    range2.setEnd(node4, i2 + 1);
    range2.setStart(node4, i2);
    var rect = singleRect(range2, 1);
    if (rect.top == rect.bottom) {
      continue;
    }
    if (inRect(coords, rect)) {
      return { node: node4, offset: i2 + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0) };
    }
  }
  return { node: node4, offset: 0 };
}
function inRect(coords, rect) {
  return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function targetKludge(dom, coords) {
  var parent = dom.parentNode;
  if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) {
    return parent;
  }
  return dom;
}
function posFromElement(view, elt, coords) {
  var ref2 = findOffsetInNode(elt, coords);
  var node4 = ref2.node;
  var offset3 = ref2.offset;
  var bias = -1;
  if (node4.nodeType == 1 && !node4.firstChild) {
    var rect = node4.getBoundingClientRect();
    bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
  }
  return view.docView.posFromDOM(node4, offset3, bias);
}
function posFromCaret(view, node4, offset3, coords) {
  var outside = -1;
  for (var cur = node4; ; ) {
    if (cur == view.dom) {
      break;
    }
    var desc = view.docView.nearestDesc(cur, true);
    if (!desc) {
      return null;
    }
    if (desc.node.isBlock && desc.parent) {
      var rect = desc.dom.getBoundingClientRect();
      if (rect.left > coords.left || rect.top > coords.top) {
        outside = desc.posBefore;
      } else if (rect.right < coords.left || rect.bottom < coords.top) {
        outside = desc.posAfter;
      } else {
        break;
      }
    }
    cur = desc.dom.parentNode;
  }
  return outside > -1 ? outside : view.docView.posFromDOM(node4, offset3);
}
function elementFromPoint(element, coords, box) {
  var len = element.childNodes.length;
  if (len && box.top < box.bottom) {
    for (var startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i2 = startI; ; ) {
      var child3 = element.childNodes[i2];
      if (child3.nodeType == 1) {
        var rects = child3.getClientRects();
        for (var j = 0; j < rects.length; j++) {
          var rect = rects[j];
          if (inRect(coords, rect)) {
            return elementFromPoint(child3, coords, rect);
          }
        }
      }
      if ((i2 = (i2 + 1) % len) == startI) {
        break;
      }
    }
  }
  return element;
}
function posAtCoords(view, coords) {
  var assign, assign$1;
  var doc2 = view.dom.ownerDocument, node4, offset3;
  if (doc2.caretPositionFromPoint) {
    try {
      var pos$1 = doc2.caretPositionFromPoint(coords.left, coords.top);
      if (pos$1) {
        assign = pos$1, node4 = assign.offsetNode, offset3 = assign.offset;
      }
    } catch (_) {
    }
  }
  if (!node4 && doc2.caretRangeFromPoint) {
    var range2 = doc2.caretRangeFromPoint(coords.left, coords.top);
    if (range2) {
      assign$1 = range2, node4 = assign$1.startContainer, offset3 = assign$1.startOffset;
    }
  }
  var elt = (view.root.elementFromPoint ? view.root : doc2).elementFromPoint(coords.left, coords.top + 1), pos;
  if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
    var box = view.dom.getBoundingClientRect();
    if (!inRect(coords, box)) {
      return null;
    }
    elt = elementFromPoint(view.dom, coords, box);
    if (!elt) {
      return null;
    }
  }
  if (result.safari) {
    for (var p = elt; node4 && p; p = parentNode(p)) {
      if (p.draggable) {
        node4 = offset3 = null;
      }
    }
  }
  elt = targetKludge(elt, coords);
  if (node4) {
    if (result.gecko && node4.nodeType == 1) {
      offset3 = Math.min(offset3, node4.childNodes.length);
      if (offset3 < node4.childNodes.length) {
        var next = node4.childNodes[offset3], box$1;
        if (next.nodeName == "IMG" && (box$1 = next.getBoundingClientRect()).right <= coords.left && box$1.bottom > coords.top) {
          offset3++;
        }
      }
    }
    if (node4 == view.dom && offset3 == node4.childNodes.length - 1 && node4.lastChild.nodeType == 1 && coords.top > node4.lastChild.getBoundingClientRect().bottom) {
      pos = view.state.doc.content.size;
    } else if (offset3 == 0 || node4.nodeType != 1 || node4.childNodes[offset3 - 1].nodeName != "BR") {
      pos = posFromCaret(view, node4, offset3, coords);
    }
  }
  if (pos == null) {
    pos = posFromElement(view, elt, coords);
  }
  var desc = view.docView.nearestDesc(elt, true);
  return { pos, inside: desc ? desc.posAtStart - desc.border : -1 };
}
function singleRect(object, bias) {
  var rects = object.getClientRects();
  return !rects.length ? object.getBoundingClientRect() : rects[bias < 0 ? 0 : rects.length - 1];
}
var BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function coordsAtPos(view, pos, side) {
  var ref2 = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
  var node4 = ref2.node;
  var offset3 = ref2.offset;
  var supportEmptyRange = result.webkit || result.gecko;
  if (node4.nodeType == 3) {
    if (supportEmptyRange && (BIDI.test(node4.nodeValue) || (side < 0 ? !offset3 : offset3 == node4.nodeValue.length))) {
      var rect = singleRect(textRange(node4, offset3, offset3), side);
      if (result.gecko && offset3 && /\s/.test(node4.nodeValue[offset3 - 1]) && offset3 < node4.nodeValue.length) {
        var rectBefore = singleRect(textRange(node4, offset3 - 1, offset3 - 1), -1);
        if (rectBefore.top == rect.top) {
          var rectAfter = singleRect(textRange(node4, offset3, offset3 + 1), -1);
          if (rectAfter.top != rect.top) {
            return flattenV(rectAfter, rectAfter.left < rectBefore.left);
          }
        }
      }
      return rect;
    } else {
      var from5 = offset3, to2 = offset3, takeSide = side < 0 ? 1 : -1;
      if (side < 0 && !offset3) {
        to2++;
        takeSide = -1;
      } else if (side >= 0 && offset3 == node4.nodeValue.length) {
        from5--;
        takeSide = 1;
      } else if (side < 0) {
        from5--;
      } else {
        to2++;
      }
      return flattenV(singleRect(textRange(node4, from5, to2), takeSide), takeSide < 0);
    }
  }
  if (!view.state.doc.resolve(pos).parent.inlineContent) {
    if (offset3 && (side < 0 || offset3 == nodeSize(node4))) {
      var before2 = node4.childNodes[offset3 - 1];
      if (before2.nodeType == 1) {
        return flattenH(before2.getBoundingClientRect(), false);
      }
    }
    if (offset3 < nodeSize(node4)) {
      var after2 = node4.childNodes[offset3];
      if (after2.nodeType == 1) {
        return flattenH(after2.getBoundingClientRect(), true);
      }
    }
    return flattenH(node4.getBoundingClientRect(), side >= 0);
  }
  if (offset3 && (side < 0 || offset3 == nodeSize(node4))) {
    var before$1 = node4.childNodes[offset3 - 1];
    var target = before$1.nodeType == 3 ? textRange(before$1, nodeSize(before$1) - (supportEmptyRange ? 0 : 1)) : before$1.nodeType == 1 && (before$1.nodeName != "BR" || !before$1.nextSibling) ? before$1 : null;
    if (target) {
      return flattenV(singleRect(target, 1), false);
    }
  }
  if (offset3 < nodeSize(node4)) {
    var after$1 = node4.childNodes[offset3];
    while (after$1.pmViewDesc && after$1.pmViewDesc.ignoreForCoords) {
      after$1 = after$1.nextSibling;
    }
    var target$1 = !after$1 ? null : after$1.nodeType == 3 ? textRange(after$1, 0, supportEmptyRange ? 0 : 1) : after$1.nodeType == 1 ? after$1 : null;
    if (target$1) {
      return flattenV(singleRect(target$1, -1), true);
    }
  }
  return flattenV(singleRect(node4.nodeType == 3 ? textRange(node4) : node4, -side), side >= 0);
}
function flattenV(rect, left) {
  if (rect.width == 0) {
    return rect;
  }
  var x2 = left ? rect.left : rect.right;
  return { top: rect.top, bottom: rect.bottom, left: x2, right: x2 };
}
function flattenH(rect, top) {
  if (rect.height == 0) {
    return rect;
  }
  var y = top ? rect.top : rect.bottom;
  return { top: y, bottom: y, left: rect.left, right: rect.right };
}
function withFlushedState(view, state, f) {
  var viewState = view.state, active = view.root.activeElement;
  if (viewState != state) {
    view.updateState(state);
  }
  if (active != view.dom) {
    view.focus();
  }
  try {
    return f();
  } finally {
    if (viewState != state) {
      view.updateState(viewState);
    }
    if (active != view.dom && active) {
      active.focus();
    }
  }
}
function endOfTextblockVertical(view, state, dir) {
  var sel = state.selection;
  var $pos = dir == "up" ? sel.$from : sel.$to;
  return withFlushedState(view, state, function() {
    var ref2 = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
    var dom = ref2.node;
    for (; ; ) {
      var nearest = view.docView.nearestDesc(dom, true);
      if (!nearest) {
        break;
      }
      if (nearest.node.isBlock) {
        dom = nearest.dom;
        break;
      }
      dom = nearest.dom.parentNode;
    }
    var coords = coordsAtPos(view, $pos.pos, 1);
    for (var child3 = dom.firstChild; child3; child3 = child3.nextSibling) {
      var boxes = void 0;
      if (child3.nodeType == 1) {
        boxes = child3.getClientRects();
      } else if (child3.nodeType == 3) {
        boxes = textRange(child3, 0, child3.nodeValue.length).getClientRects();
      } else {
        continue;
      }
      for (var i2 = 0; i2 < boxes.length; i2++) {
        var box = boxes[i2];
        if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) {
          return false;
        }
      }
    }
    return true;
  });
}
var maybeRTL = /[\u0590-\u08ac]/;
function endOfTextblockHorizontal(view, state, dir) {
  var ref2 = state.selection;
  var $head = ref2.$head;
  if (!$head.parent.isTextblock) {
    return false;
  }
  var offset3 = $head.parentOffset, atStart2 = !offset3, atEnd2 = offset3 == $head.parent.content.size;
  var sel = view.root.getSelection();
  if (!maybeRTL.test($head.parent.textContent) || !sel.modify) {
    return dir == "left" || dir == "backward" ? atStart2 : atEnd2;
  }
  return withFlushedState(view, state, function() {
    var oldRange = sel.getRangeAt(0), oldNode = sel.focusNode, oldOff = sel.focusOffset;
    var oldBidiLevel = sel.caretBidiLevel;
    sel.modify("move", dir, "character");
    var parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
    var result2 = !parentDOM.contains(sel.focusNode.nodeType == 1 ? sel.focusNode : sel.focusNode.parentNode) || oldNode == sel.focusNode && oldOff == sel.focusOffset;
    sel.removeAllRanges();
    sel.addRange(oldRange);
    if (oldBidiLevel != null) {
      sel.caretBidiLevel = oldBidiLevel;
    }
    return result2;
  });
}
var cachedState = null, cachedDir = null, cachedResult = false;
function endOfTextblock(view, state, dir) {
  if (cachedState == state && cachedDir == dir) {
    return cachedResult;
  }
  cachedState = state;
  cachedDir = dir;
  return cachedResult = dir == "up" || dir == "down" ? endOfTextblockVertical(view, state, dir) : endOfTextblockHorizontal(view, state, dir);
}
var NOT_DIRTY = 0, CHILD_DIRTY = 1, CONTENT_DIRTY = 2, NODE_DIRTY = 3;
var ViewDesc = function ViewDesc2(parent, children, dom, contentDOM) {
  this.parent = parent;
  this.children = children;
  this.dom = dom;
  dom.pmViewDesc = this;
  this.contentDOM = contentDOM;
  this.dirty = NOT_DIRTY;
};
var prototypeAccessors = { size: { configurable: true }, border: { configurable: true }, posBefore: { configurable: true }, posAtStart: { configurable: true }, posAfter: { configurable: true }, posAtEnd: { configurable: true }, contentLost: { configurable: true }, domAtom: { configurable: true }, ignoreForCoords: { configurable: true } };
ViewDesc.prototype.matchesWidget = function matchesWidget() {
  return false;
};
ViewDesc.prototype.matchesMark = function matchesMark() {
  return false;
};
ViewDesc.prototype.matchesNode = function matchesNode() {
  return false;
};
ViewDesc.prototype.matchesHack = function matchesHack(_nodeName) {
  return false;
};
ViewDesc.prototype.parseRule = function parseRule() {
  return null;
};
ViewDesc.prototype.stopEvent = function stopEvent() {
  return false;
};
prototypeAccessors.size.get = function() {
  var size = 0;
  for (var i2 = 0; i2 < this.children.length; i2++) {
    size += this.children[i2].size;
  }
  return size;
};
prototypeAccessors.border.get = function() {
  return 0;
};
ViewDesc.prototype.destroy = function destroy() {
  this.parent = null;
  if (this.dom.pmViewDesc == this) {
    this.dom.pmViewDesc = null;
  }
  for (var i2 = 0; i2 < this.children.length; i2++) {
    this.children[i2].destroy();
  }
};
ViewDesc.prototype.posBeforeChild = function posBeforeChild(child3) {
  for (var i2 = 0, pos = this.posAtStart; i2 < this.children.length; i2++) {
    var cur = this.children[i2];
    if (cur == child3) {
      return pos;
    }
    pos += cur.size;
  }
};
prototypeAccessors.posBefore.get = function() {
  return this.parent.posBeforeChild(this);
};
prototypeAccessors.posAtStart.get = function() {
  return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
};
prototypeAccessors.posAfter.get = function() {
  return this.posBefore + this.size;
};
prototypeAccessors.posAtEnd.get = function() {
  return this.posAtStart + this.size - 2 * this.border;
};
ViewDesc.prototype.localPosFromDOM = function localPosFromDOM(dom, offset3, bias) {
  if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
    if (bias < 0) {
      var domBefore, desc;
      if (dom == this.contentDOM) {
        domBefore = dom.childNodes[offset3 - 1];
      } else {
        while (dom.parentNode != this.contentDOM) {
          dom = dom.parentNode;
        }
        domBefore = dom.previousSibling;
      }
      while (domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this)) {
        domBefore = domBefore.previousSibling;
      }
      return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
    } else {
      var domAfter, desc$1;
      if (dom == this.contentDOM) {
        domAfter = dom.childNodes[offset3];
      } else {
        while (dom.parentNode != this.contentDOM) {
          dom = dom.parentNode;
        }
        domAfter = dom.nextSibling;
      }
      while (domAfter && !((desc$1 = domAfter.pmViewDesc) && desc$1.parent == this)) {
        domAfter = domAfter.nextSibling;
      }
      return domAfter ? this.posBeforeChild(desc$1) : this.posAtEnd;
    }
  }
  var atEnd2;
  if (dom == this.dom && this.contentDOM) {
    atEnd2 = offset3 > domIndex(this.contentDOM);
  } else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) {
    atEnd2 = dom.compareDocumentPosition(this.contentDOM) & 2;
  } else if (this.dom.firstChild) {
    if (offset3 == 0) {
      for (var search2 = dom; ; search2 = search2.parentNode) {
        if (search2 == this.dom) {
          atEnd2 = false;
          break;
        }
        if (search2.parentNode.firstChild != search2) {
          break;
        }
      }
    }
    if (atEnd2 == null && offset3 == dom.childNodes.length) {
      for (var search$1 = dom; ; search$1 = search$1.parentNode) {
        if (search$1 == this.dom) {
          atEnd2 = true;
          break;
        }
        if (search$1.parentNode.lastChild != search$1) {
          break;
        }
      }
    }
  }
  return (atEnd2 == null ? bias > 0 : atEnd2) ? this.posAtEnd : this.posAtStart;
};
ViewDesc.prototype.nearestDesc = function nearestDesc(dom, onlyNodes) {
  for (var first = true, cur = dom; cur; cur = cur.parentNode) {
    var desc = this.getDesc(cur);
    if (desc && (!onlyNodes || desc.node)) {
      if (first && desc.nodeDOM && !(desc.nodeDOM.nodeType == 1 ? desc.nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : desc.nodeDOM == dom)) {
        first = false;
      } else {
        return desc;
      }
    }
  }
};
ViewDesc.prototype.getDesc = function getDesc(dom) {
  var desc = dom.pmViewDesc;
  for (var cur = desc; cur; cur = cur.parent) {
    if (cur == this) {
      return desc;
    }
  }
};
ViewDesc.prototype.posFromDOM = function posFromDOM(dom, offset3, bias) {
  for (var scan = dom; scan; scan = scan.parentNode) {
    var desc = this.getDesc(scan);
    if (desc) {
      return desc.localPosFromDOM(dom, offset3, bias);
    }
  }
  return -1;
};
ViewDesc.prototype.descAt = function descAt(pos) {
  for (var i2 = 0, offset3 = 0; i2 < this.children.length; i2++) {
    var child3 = this.children[i2], end2 = offset3 + child3.size;
    if (offset3 == pos && end2 != offset3) {
      while (!child3.border && child3.children.length) {
        child3 = child3.children[0];
      }
      return child3;
    }
    if (pos < end2) {
      return child3.descAt(pos - offset3 - child3.border);
    }
    offset3 = end2;
  }
};
ViewDesc.prototype.domFromPos = function domFromPos(pos, side) {
  if (!this.contentDOM) {
    return { node: this.dom, offset: 0 };
  }
  var i2 = 0, offset3 = 0;
  for (var curPos = 0; i2 < this.children.length; i2++) {
    var child3 = this.children[i2], end2 = curPos + child3.size;
    if (end2 > pos || child3 instanceof TrailingHackViewDesc) {
      offset3 = pos - curPos;
      break;
    }
    curPos = end2;
  }
  if (offset3) {
    return this.children[i2].domFromPos(offset3 - this.children[i2].border, side);
  }
  for (var prev = void 0; i2 && !(prev = this.children[i2 - 1]).size && prev instanceof WidgetViewDesc && prev.widget.type.side >= 0; i2--) {
  }
  if (side <= 0) {
    var prev$1, enter2 = true;
    for (; ; i2--, enter2 = false) {
      prev$1 = i2 ? this.children[i2 - 1] : null;
      if (!prev$1 || prev$1.dom.parentNode == this.contentDOM) {
        break;
      }
    }
    if (prev$1 && side && enter2 && !prev$1.border && !prev$1.domAtom) {
      return prev$1.domFromPos(prev$1.size, side);
    }
    return { node: this.contentDOM, offset: prev$1 ? domIndex(prev$1.dom) + 1 : 0 };
  } else {
    var next, enter$1 = true;
    for (; ; i2++, enter$1 = false) {
      next = i2 < this.children.length ? this.children[i2] : null;
      if (!next || next.dom.parentNode == this.contentDOM) {
        break;
      }
    }
    if (next && enter$1 && !next.border && !next.domAtom) {
      return next.domFromPos(0, side);
    }
    return { node: this.contentDOM, offset: next ? domIndex(next.dom) : this.contentDOM.childNodes.length };
  }
};
ViewDesc.prototype.parseRange = function parseRange(from5, to2, base2) {
  if (base2 === void 0)
    base2 = 0;
  if (this.children.length == 0) {
    return { node: this.contentDOM, from: from5, to: to2, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
  }
  var fromOffset = -1, toOffset = -1;
  for (var offset3 = base2, i2 = 0; ; i2++) {
    var child3 = this.children[i2], end2 = offset3 + child3.size;
    if (fromOffset == -1 && from5 <= end2) {
      var childBase = offset3 + child3.border;
      if (from5 >= childBase && to2 <= end2 - child3.border && child3.node && child3.contentDOM && this.contentDOM.contains(child3.contentDOM)) {
        return child3.parseRange(from5, to2, childBase);
      }
      from5 = offset3;
      for (var j = i2; j > 0; j--) {
        var prev = this.children[j - 1];
        if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
          fromOffset = domIndex(prev.dom) + 1;
          break;
        }
        from5 -= prev.size;
      }
      if (fromOffset == -1) {
        fromOffset = 0;
      }
    }
    if (fromOffset > -1 && (end2 > to2 || i2 == this.children.length - 1)) {
      to2 = end2;
      for (var j$1 = i2 + 1; j$1 < this.children.length; j$1++) {
        var next = this.children[j$1];
        if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
          toOffset = domIndex(next.dom);
          break;
        }
        to2 += next.size;
      }
      if (toOffset == -1) {
        toOffset = this.contentDOM.childNodes.length;
      }
      break;
    }
    offset3 = end2;
  }
  return { node: this.contentDOM, from: from5, to: to2, fromOffset, toOffset };
};
ViewDesc.prototype.emptyChildAt = function emptyChildAt(side) {
  if (this.border || !this.contentDOM || !this.children.length) {
    return false;
  }
  var child3 = this.children[side < 0 ? 0 : this.children.length - 1];
  return child3.size == 0 || child3.emptyChildAt(side);
};
ViewDesc.prototype.domAfterPos = function domAfterPos(pos) {
  var ref2 = this.domFromPos(pos, 0);
  var node4 = ref2.node;
  var offset3 = ref2.offset;
  if (node4.nodeType != 1 || offset3 == node4.childNodes.length) {
    throw new RangeError("No node after pos " + pos);
  }
  return node4.childNodes[offset3];
};
ViewDesc.prototype.setSelection = function setSelection(anchor, head, root2, force) {
  var from5 = Math.min(anchor, head), to2 = Math.max(anchor, head);
  for (var i2 = 0, offset3 = 0; i2 < this.children.length; i2++) {
    var child3 = this.children[i2], end2 = offset3 + child3.size;
    if (from5 > offset3 && to2 < end2) {
      return child3.setSelection(anchor - offset3 - child3.border, head - offset3 - child3.border, root2, force);
    }
    offset3 = end2;
  }
  var anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
  var headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
  var domSel = root2.getSelection();
  var brKludge = false;
  if ((result.gecko || result.safari) && anchor == head) {
    var node4 = anchorDOM.node;
    var offset$1 = anchorDOM.offset;
    if (node4.nodeType == 3) {
      brKludge = offset$1 && node4.nodeValue[offset$1 - 1] == "\n";
      if (brKludge && offset$1 == node4.nodeValue.length) {
        for (var scan = node4, after2 = void 0; scan; scan = scan.parentNode) {
          if (after2 = scan.nextSibling) {
            if (after2.nodeName == "BR") {
              anchorDOM = headDOM = { node: after2.parentNode, offset: domIndex(after2) + 1 };
            }
            break;
          }
          var desc = scan.pmViewDesc;
          if (desc && desc.node && desc.node.isBlock) {
            break;
          }
        }
      }
    } else {
      var prev = node4.childNodes[offset$1 - 1];
      brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
    }
  }
  if (result.gecko && domSel.focusNode && domSel.focusNode != headDOM.node && domSel.focusNode.nodeType == 1) {
    var after$1 = domSel.focusNode.childNodes[domSel.focusOffset];
    if (after$1 && after$1.contentEditable == "false") {
      force = true;
    }
  }
  if (!(force || brKludge && result.safari) && isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset) && isEquivalentPosition(headDOM.node, headDOM.offset, domSel.focusNode, domSel.focusOffset)) {
    return;
  }
  var domSelExtended = false;
  if ((domSel.extend || anchor == head) && !brKludge) {
    domSel.collapse(anchorDOM.node, anchorDOM.offset);
    try {
      if (anchor != head) {
        domSel.extend(headDOM.node, headDOM.offset);
      }
      domSelExtended = true;
    } catch (err2) {
      if (!(err2 instanceof DOMException)) {
        throw err2;
      }
    }
  }
  if (!domSelExtended) {
    if (anchor > head) {
      var tmp = anchorDOM;
      anchorDOM = headDOM;
      headDOM = tmp;
    }
    var range2 = document.createRange();
    range2.setEnd(headDOM.node, headDOM.offset);
    range2.setStart(anchorDOM.node, anchorDOM.offset);
    domSel.removeAllRanges();
    domSel.addRange(range2);
  }
};
ViewDesc.prototype.ignoreMutation = function ignoreMutation(mutation) {
  return !this.contentDOM && mutation.type != "selection";
};
prototypeAccessors.contentLost.get = function() {
  return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
};
ViewDesc.prototype.markDirty = function markDirty(from5, to2) {
  for (var offset3 = 0, i2 = 0; i2 < this.children.length; i2++) {
    var child3 = this.children[i2], end2 = offset3 + child3.size;
    if (offset3 == end2 ? from5 <= end2 && to2 >= offset3 : from5 < end2 && to2 > offset3) {
      var startInside = offset3 + child3.border, endInside = end2 - child3.border;
      if (from5 >= startInside && to2 <= endInside) {
        this.dirty = from5 == offset3 || to2 == end2 ? CONTENT_DIRTY : CHILD_DIRTY;
        if (from5 == startInside && to2 == endInside && (child3.contentLost || child3.dom.parentNode != this.contentDOM)) {
          child3.dirty = NODE_DIRTY;
        } else {
          child3.markDirty(from5 - startInside, to2 - startInside);
        }
        return;
      } else {
        child3.dirty = child3.dom == child3.contentDOM && child3.dom.parentNode == this.contentDOM && !child3.children.length ? CONTENT_DIRTY : NODE_DIRTY;
      }
    }
    offset3 = end2;
  }
  this.dirty = CONTENT_DIRTY;
};
ViewDesc.prototype.markParentsDirty = function markParentsDirty() {
  var level = 1;
  for (var node4 = this.parent; node4; node4 = node4.parent, level++) {
    var dirty = level == 1 ? CONTENT_DIRTY : CHILD_DIRTY;
    if (node4.dirty < dirty) {
      node4.dirty = dirty;
    }
  }
};
prototypeAccessors.domAtom.get = function() {
  return false;
};
prototypeAccessors.ignoreForCoords.get = function() {
  return false;
};
Object.defineProperties(ViewDesc.prototype, prototypeAccessors);
var nothing = [];
var WidgetViewDesc = /* @__PURE__ */ function(ViewDesc3) {
  function WidgetViewDesc2(parent, widget2, view, pos) {
    var self2, dom = widget2.type.toDOM;
    if (typeof dom == "function") {
      dom = dom(view, function() {
        if (!self2) {
          return pos;
        }
        if (self2.parent) {
          return self2.parent.posBeforeChild(self2);
        }
      });
    }
    if (!widget2.type.spec.raw) {
      if (dom.nodeType != 1) {
        var wrap = document.createElement("span");
        wrap.appendChild(dom);
        dom = wrap;
      }
      dom.contentEditable = false;
      dom.classList.add("ProseMirror-widget");
    }
    ViewDesc3.call(this, parent, nothing, dom, null);
    this.widget = widget2;
    self2 = this;
  }
  if (ViewDesc3)
    WidgetViewDesc2.__proto__ = ViewDesc3;
  WidgetViewDesc2.prototype = Object.create(ViewDesc3 && ViewDesc3.prototype);
  WidgetViewDesc2.prototype.constructor = WidgetViewDesc2;
  var prototypeAccessors$12 = { domAtom: { configurable: true } };
  WidgetViewDesc2.prototype.matchesWidget = function matchesWidget2(widget2) {
    return this.dirty == NOT_DIRTY && widget2.type.eq(this.widget.type);
  };
  WidgetViewDesc2.prototype.parseRule = function parseRule2() {
    return { ignore: true };
  };
  WidgetViewDesc2.prototype.stopEvent = function stopEvent2(event) {
    var stop3 = this.widget.spec.stopEvent;
    return stop3 ? stop3(event) : false;
  };
  WidgetViewDesc2.prototype.ignoreMutation = function ignoreMutation2(mutation) {
    return mutation.type != "selection" || this.widget.spec.ignoreSelection;
  };
  WidgetViewDesc2.prototype.destroy = function destroy5() {
    this.widget.type.destroy(this.dom);
    ViewDesc3.prototype.destroy.call(this);
  };
  prototypeAccessors$12.domAtom.get = function() {
    return true;
  };
  Object.defineProperties(WidgetViewDesc2.prototype, prototypeAccessors$12);
  return WidgetViewDesc2;
}(ViewDesc);
var CompositionViewDesc = /* @__PURE__ */ function(ViewDesc3) {
  function CompositionViewDesc2(parent, dom, textDOM, text2) {
    ViewDesc3.call(this, parent, nothing, dom, null);
    this.textDOM = textDOM;
    this.text = text2;
  }
  if (ViewDesc3)
    CompositionViewDesc2.__proto__ = ViewDesc3;
  CompositionViewDesc2.prototype = Object.create(ViewDesc3 && ViewDesc3.prototype);
  CompositionViewDesc2.prototype.constructor = CompositionViewDesc2;
  var prototypeAccessors$22 = { size: { configurable: true } };
  prototypeAccessors$22.size.get = function() {
    return this.text.length;
  };
  CompositionViewDesc2.prototype.localPosFromDOM = function localPosFromDOM2(dom, offset3) {
    if (dom != this.textDOM) {
      return this.posAtStart + (offset3 ? this.size : 0);
    }
    return this.posAtStart + offset3;
  };
  CompositionViewDesc2.prototype.domFromPos = function domFromPos2(pos) {
    return { node: this.textDOM, offset: pos };
  };
  CompositionViewDesc2.prototype.ignoreMutation = function ignoreMutation2(mut) {
    return mut.type === "characterData" && mut.target.nodeValue == mut.oldValue;
  };
  Object.defineProperties(CompositionViewDesc2.prototype, prototypeAccessors$22);
  return CompositionViewDesc2;
}(ViewDesc);
var MarkViewDesc = /* @__PURE__ */ function(ViewDesc3) {
  function MarkViewDesc2(parent, mark3, dom, contentDOM) {
    ViewDesc3.call(this, parent, [], dom, contentDOM);
    this.mark = mark3;
  }
  if (ViewDesc3)
    MarkViewDesc2.__proto__ = ViewDesc3;
  MarkViewDesc2.prototype = Object.create(ViewDesc3 && ViewDesc3.prototype);
  MarkViewDesc2.prototype.constructor = MarkViewDesc2;
  MarkViewDesc2.create = function create6(parent, mark3, inline2, view) {
    var custom = view.nodeViews[mark3.type.name];
    var spec = custom && custom(mark3, view, inline2);
    if (!spec || !spec.dom) {
      spec = DOMSerializer.renderSpec(document, mark3.type.spec.toDOM(mark3, inline2));
    }
    return new MarkViewDesc2(parent, mark3, spec.dom, spec.contentDOM || spec.dom);
  };
  MarkViewDesc2.prototype.parseRule = function parseRule2() {
    if (this.dirty & NODE_DIRTY || this.mark.type.spec.reparseInView) {
      return null;
    }
    return { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  };
  MarkViewDesc2.prototype.matchesMark = function matchesMark2(mark3) {
    return this.dirty != NODE_DIRTY && this.mark.eq(mark3);
  };
  MarkViewDesc2.prototype.markDirty = function markDirty2(from5, to2) {
    ViewDesc3.prototype.markDirty.call(this, from5, to2);
    if (this.dirty != NOT_DIRTY) {
      var parent = this.parent;
      while (!parent.node) {
        parent = parent.parent;
      }
      if (parent.dirty < this.dirty) {
        parent.dirty = this.dirty;
      }
      this.dirty = NOT_DIRTY;
    }
  };
  MarkViewDesc2.prototype.slice = function slice4(from5, to2, view) {
    var copy5 = MarkViewDesc2.create(this.parent, this.mark, true, view);
    var nodes = this.children, size = this.size;
    if (to2 < size) {
      nodes = replaceNodes(nodes, to2, size, view);
    }
    if (from5 > 0) {
      nodes = replaceNodes(nodes, 0, from5, view);
    }
    for (var i2 = 0; i2 < nodes.length; i2++) {
      nodes[i2].parent = copy5;
    }
    copy5.children = nodes;
    return copy5;
  };
  return MarkViewDesc2;
}(ViewDesc);
var NodeViewDesc = /* @__PURE__ */ function(ViewDesc3) {
  function NodeViewDesc2(parent, node4, outerDeco, innerDeco, dom, contentDOM, nodeDOM2, view, pos) {
    ViewDesc3.call(this, parent, node4.isLeaf ? nothing : [], dom, contentDOM);
    this.nodeDOM = nodeDOM2;
    this.node = node4;
    this.outerDeco = outerDeco;
    this.innerDeco = innerDeco;
    if (contentDOM) {
      this.updateChildren(view, pos);
    }
  }
  if (ViewDesc3)
    NodeViewDesc2.__proto__ = ViewDesc3;
  NodeViewDesc2.prototype = Object.create(ViewDesc3 && ViewDesc3.prototype);
  NodeViewDesc2.prototype.constructor = NodeViewDesc2;
  var prototypeAccessors$32 = { size: { configurable: true }, border: { configurable: true }, domAtom: { configurable: true } };
  NodeViewDesc2.create = function create6(parent, node4, outerDeco, innerDeco, view, pos) {
    var assign;
    var custom = view.nodeViews[node4.type.name], descObj;
    var spec = custom && custom(node4, view, function() {
      if (!descObj) {
        return pos;
      }
      if (descObj.parent) {
        return descObj.parent.posBeforeChild(descObj);
      }
    }, outerDeco, innerDeco);
    var dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
    if (node4.isText) {
      if (!dom) {
        dom = document.createTextNode(node4.text);
      } else if (dom.nodeType != 3) {
        throw new RangeError("Text must be rendered as a DOM text node");
      }
    } else if (!dom) {
      assign = DOMSerializer.renderSpec(document, node4.type.spec.toDOM(node4)), dom = assign.dom, contentDOM = assign.contentDOM;
    }
    if (!contentDOM && !node4.isText && dom.nodeName != "BR") {
      if (!dom.hasAttribute("contenteditable")) {
        dom.contentEditable = false;
      }
      if (node4.type.spec.draggable) {
        dom.draggable = true;
      }
    }
    var nodeDOM2 = dom;
    dom = applyOuterDeco(dom, outerDeco, node4);
    if (spec) {
      return descObj = new CustomNodeViewDesc(parent, node4, outerDeco, innerDeco, dom, contentDOM, nodeDOM2, spec, view, pos + 1);
    } else if (node4.isText) {
      return new TextViewDesc(parent, node4, outerDeco, innerDeco, dom, nodeDOM2, view);
    } else {
      return new NodeViewDesc2(parent, node4, outerDeco, innerDeco, dom, contentDOM, nodeDOM2, view, pos + 1);
    }
  };
  NodeViewDesc2.prototype.parseRule = function parseRule2() {
    var this$1$1 = this;
    if (this.node.type.spec.reparseInView) {
      return null;
    }
    var rule = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre") {
      rule.preserveWhitespace = "full";
    }
    if (this.contentDOM && !this.contentLost) {
      rule.contentElement = this.contentDOM;
    } else {
      rule.getContent = function() {
        return this$1$1.contentDOM ? Fragment.empty : this$1$1.node.content;
      };
    }
    return rule;
  };
  NodeViewDesc2.prototype.matchesNode = function matchesNode2(node4, outerDeco, innerDeco) {
    return this.dirty == NOT_DIRTY && node4.eq(this.node) && sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
  };
  prototypeAccessors$32.size.get = function() {
    return this.node.nodeSize;
  };
  prototypeAccessors$32.border.get = function() {
    return this.node.isLeaf ? 0 : 1;
  };
  NodeViewDesc2.prototype.updateChildren = function updateChildren(view, pos) {
    var this$1$1 = this;
    var inline2 = this.node.inlineContent, off = pos;
    var composition = view.composing && this.localCompositionInfo(view, pos);
    var localComposition = composition && composition.pos > -1 ? composition : null;
    var compositionInChild = composition && composition.pos < 0;
    var updater = new ViewTreeUpdater(this, localComposition && localComposition.node);
    iterDeco(this.node, this.innerDeco, function(widget2, i2, insideNode) {
      if (widget2.spec.marks) {
        updater.syncToMarks(widget2.spec.marks, inline2, view);
      } else if (widget2.type.side >= 0 && !insideNode) {
        updater.syncToMarks(i2 == this$1$1.node.childCount ? Mark.none : this$1$1.node.child(i2).marks, inline2, view);
      }
      updater.placeWidget(widget2, view, off);
    }, function(child3, outerDeco, innerDeco, i2) {
      updater.syncToMarks(child3.marks, inline2, view);
      var compIndex;
      if (updater.findNodeMatch(child3, outerDeco, innerDeco, i2))
        ;
      else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child3.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child3, outerDeco, innerDeco, compIndex, view))
        ;
      else if (updater.updateNextNode(child3, outerDeco, innerDeco, view, i2))
        ;
      else {
        updater.addNode(child3, outerDeco, innerDeco, view, off);
      }
      off += child3.nodeSize;
    });
    updater.syncToMarks(nothing, inline2, view);
    if (this.node.isTextblock) {
      updater.addTextblockHacks();
    }
    updater.destroyRest();
    if (updater.changed || this.dirty == CONTENT_DIRTY) {
      if (localComposition) {
        this.protectLocalComposition(view, localComposition);
      }
      renderDescs(this.contentDOM, this.children, view);
      if (result.ios) {
        iosHacks(this.dom);
      }
    }
  };
  NodeViewDesc2.prototype.localCompositionInfo = function localCompositionInfo(view, pos) {
    var ref2 = view.state.selection;
    var from5 = ref2.from;
    var to2 = ref2.to;
    if (!(view.state.selection instanceof TextSelection) || from5 < pos || to2 > pos + this.node.content.size) {
      return;
    }
    var sel = view.root.getSelection();
    var textNode = nearbyTextNode(sel.focusNode, sel.focusOffset);
    if (!textNode || !this.dom.contains(textNode.parentNode)) {
      return;
    }
    if (this.node.inlineContent) {
      var text2 = textNode.nodeValue;
      var textPos = findTextInFragment(this.node.content, text2, from5 - pos, to2 - pos);
      return textPos < 0 ? null : { node: textNode, pos: textPos, text: text2 };
    } else {
      return { node: textNode, pos: -1 };
    }
  };
  NodeViewDesc2.prototype.protectLocalComposition = function protectLocalComposition(view, ref2) {
    var node4 = ref2.node;
    var pos = ref2.pos;
    var text2 = ref2.text;
    if (this.getDesc(node4)) {
      return;
    }
    var topNode = node4;
    for (; ; topNode = topNode.parentNode) {
      if (topNode.parentNode == this.contentDOM) {
        break;
      }
      while (topNode.previousSibling) {
        topNode.parentNode.removeChild(topNode.previousSibling);
      }
      while (topNode.nextSibling) {
        topNode.parentNode.removeChild(topNode.nextSibling);
      }
      if (topNode.pmViewDesc) {
        topNode.pmViewDesc = null;
      }
    }
    var desc = new CompositionViewDesc(this, topNode, node4, text2);
    view.compositionNodes.push(desc);
    this.children = replaceNodes(this.children, pos, pos + text2.length, view, desc);
  };
  NodeViewDesc2.prototype.update = function update3(node4, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY || !node4.sameMarkup(this.node)) {
      return false;
    }
    this.updateInner(node4, outerDeco, innerDeco, view);
    return true;
  };
  NodeViewDesc2.prototype.updateInner = function updateInner(node4, outerDeco, innerDeco, view) {
    this.updateOuterDeco(outerDeco);
    this.node = node4;
    this.innerDeco = innerDeco;
    if (this.contentDOM) {
      this.updateChildren(view, this.posAtStart);
    }
    this.dirty = NOT_DIRTY;
  };
  NodeViewDesc2.prototype.updateOuterDeco = function updateOuterDeco(outerDeco) {
    if (sameOuterDeco(outerDeco, this.outerDeco)) {
      return;
    }
    var needsWrap = this.nodeDOM.nodeType != 1;
    var oldDOM = this.dom;
    this.dom = patchOuterDeco(this.dom, this.nodeDOM, computeOuterDeco(this.outerDeco, this.node, needsWrap), computeOuterDeco(outerDeco, this.node, needsWrap));
    if (this.dom != oldDOM) {
      oldDOM.pmViewDesc = null;
      this.dom.pmViewDesc = this;
    }
    this.outerDeco = outerDeco;
  };
  NodeViewDesc2.prototype.selectNode = function selectNode() {
    this.nodeDOM.classList.add("ProseMirror-selectednode");
    if (this.contentDOM || !this.node.type.spec.draggable) {
      this.dom.draggable = true;
    }
  };
  NodeViewDesc2.prototype.deselectNode = function deselectNode() {
    this.nodeDOM.classList.remove("ProseMirror-selectednode");
    if (this.contentDOM || !this.node.type.spec.draggable) {
      this.dom.removeAttribute("draggable");
    }
  };
  prototypeAccessors$32.domAtom.get = function() {
    return this.node.isAtom;
  };
  Object.defineProperties(NodeViewDesc2.prototype, prototypeAccessors$32);
  return NodeViewDesc2;
}(ViewDesc);
function docViewDesc(doc2, outerDeco, innerDeco, dom, view) {
  applyOuterDeco(dom, outerDeco, doc2);
  return new NodeViewDesc(null, doc2, outerDeco, innerDeco, dom, dom, dom, view, 0);
}
var TextViewDesc = /* @__PURE__ */ function(NodeViewDesc2) {
  function TextViewDesc2(parent, node4, outerDeco, innerDeco, dom, nodeDOM2, view) {
    NodeViewDesc2.call(this, parent, node4, outerDeco, innerDeco, dom, null, nodeDOM2, view);
  }
  if (NodeViewDesc2)
    TextViewDesc2.__proto__ = NodeViewDesc2;
  TextViewDesc2.prototype = Object.create(NodeViewDesc2 && NodeViewDesc2.prototype);
  TextViewDesc2.prototype.constructor = TextViewDesc2;
  var prototypeAccessors$42 = { domAtom: { configurable: true } };
  TextViewDesc2.prototype.parseRule = function parseRule2() {
    var skip = this.nodeDOM.parentNode;
    while (skip && skip != this.dom && !skip.pmIsDeco) {
      skip = skip.parentNode;
    }
    return { skip: skip || true };
  };
  TextViewDesc2.prototype.update = function update3(node4, outerDeco, _, view) {
    if (this.dirty == NODE_DIRTY || this.dirty != NOT_DIRTY && !this.inParent() || !node4.sameMarkup(this.node)) {
      return false;
    }
    this.updateOuterDeco(outerDeco);
    if ((this.dirty != NOT_DIRTY || node4.text != this.node.text) && node4.text != this.nodeDOM.nodeValue) {
      this.nodeDOM.nodeValue = node4.text;
      if (view.trackWrites == this.nodeDOM) {
        view.trackWrites = null;
      }
    }
    this.node = node4;
    this.dirty = NOT_DIRTY;
    return true;
  };
  TextViewDesc2.prototype.inParent = function inParent() {
    var parentDOM = this.parent.contentDOM;
    for (var n = this.nodeDOM; n; n = n.parentNode) {
      if (n == parentDOM) {
        return true;
      }
    }
    return false;
  };
  TextViewDesc2.prototype.domFromPos = function domFromPos2(pos) {
    return { node: this.nodeDOM, offset: pos };
  };
  TextViewDesc2.prototype.localPosFromDOM = function localPosFromDOM2(dom, offset3, bias) {
    if (dom == this.nodeDOM) {
      return this.posAtStart + Math.min(offset3, this.node.text.length);
    }
    return NodeViewDesc2.prototype.localPosFromDOM.call(this, dom, offset3, bias);
  };
  TextViewDesc2.prototype.ignoreMutation = function ignoreMutation2(mutation) {
    return mutation.type != "characterData" && mutation.type != "selection";
  };
  TextViewDesc2.prototype.slice = function slice4(from5, to2, view) {
    var node4 = this.node.cut(from5, to2), dom = document.createTextNode(node4.text);
    return new TextViewDesc2(this.parent, node4, this.outerDeco, this.innerDeco, dom, dom, view);
  };
  TextViewDesc2.prototype.markDirty = function markDirty2(from5, to2) {
    NodeViewDesc2.prototype.markDirty.call(this, from5, to2);
    if (this.dom != this.nodeDOM && (from5 == 0 || to2 == this.nodeDOM.nodeValue.length)) {
      this.dirty = NODE_DIRTY;
    }
  };
  prototypeAccessors$42.domAtom.get = function() {
    return false;
  };
  Object.defineProperties(TextViewDesc2.prototype, prototypeAccessors$42);
  return TextViewDesc2;
}(NodeViewDesc);
var TrailingHackViewDesc = /* @__PURE__ */ function(ViewDesc3) {
  function TrailingHackViewDesc2() {
    ViewDesc3.apply(this, arguments);
  }
  if (ViewDesc3)
    TrailingHackViewDesc2.__proto__ = ViewDesc3;
  TrailingHackViewDesc2.prototype = Object.create(ViewDesc3 && ViewDesc3.prototype);
  TrailingHackViewDesc2.prototype.constructor = TrailingHackViewDesc2;
  var prototypeAccessors$52 = { domAtom: { configurable: true }, ignoreForCoords: { configurable: true } };
  TrailingHackViewDesc2.prototype.parseRule = function parseRule2() {
    return { ignore: true };
  };
  TrailingHackViewDesc2.prototype.matchesHack = function matchesHack2(nodeName) {
    return this.dirty == NOT_DIRTY && this.dom.nodeName == nodeName;
  };
  prototypeAccessors$52.domAtom.get = function() {
    return true;
  };
  prototypeAccessors$52.ignoreForCoords.get = function() {
    return this.dom.nodeName == "IMG";
  };
  Object.defineProperties(TrailingHackViewDesc2.prototype, prototypeAccessors$52);
  return TrailingHackViewDesc2;
}(ViewDesc);
var CustomNodeViewDesc = /* @__PURE__ */ function(NodeViewDesc2) {
  function CustomNodeViewDesc2(parent, node4, outerDeco, innerDeco, dom, contentDOM, nodeDOM2, spec, view, pos) {
    NodeViewDesc2.call(this, parent, node4, outerDeco, innerDeco, dom, contentDOM, nodeDOM2, view, pos);
    this.spec = spec;
  }
  if (NodeViewDesc2)
    CustomNodeViewDesc2.__proto__ = NodeViewDesc2;
  CustomNodeViewDesc2.prototype = Object.create(NodeViewDesc2 && NodeViewDesc2.prototype);
  CustomNodeViewDesc2.prototype.constructor = CustomNodeViewDesc2;
  CustomNodeViewDesc2.prototype.update = function update3(node4, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY) {
      return false;
    }
    if (this.spec.update) {
      var result2 = this.spec.update(node4, outerDeco, innerDeco);
      if (result2) {
        this.updateInner(node4, outerDeco, innerDeco, view);
      }
      return result2;
    } else if (!this.contentDOM && !node4.isLeaf) {
      return false;
    } else {
      return NodeViewDesc2.prototype.update.call(this, node4, outerDeco, innerDeco, view);
    }
  };
  CustomNodeViewDesc2.prototype.selectNode = function selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : NodeViewDesc2.prototype.selectNode.call(this);
  };
  CustomNodeViewDesc2.prototype.deselectNode = function deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : NodeViewDesc2.prototype.deselectNode.call(this);
  };
  CustomNodeViewDesc2.prototype.setSelection = function setSelection2(anchor, head, root2, force) {
    this.spec.setSelection ? this.spec.setSelection(anchor, head, root2) : NodeViewDesc2.prototype.setSelection.call(this, anchor, head, root2, force);
  };
  CustomNodeViewDesc2.prototype.destroy = function destroy5() {
    if (this.spec.destroy) {
      this.spec.destroy();
    }
    NodeViewDesc2.prototype.destroy.call(this);
  };
  CustomNodeViewDesc2.prototype.stopEvent = function stopEvent2(event) {
    return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
  };
  CustomNodeViewDesc2.prototype.ignoreMutation = function ignoreMutation2(mutation) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : NodeViewDesc2.prototype.ignoreMutation.call(this, mutation);
  };
  return CustomNodeViewDesc2;
}(NodeViewDesc);
function renderDescs(parentDOM, descs, view) {
  var dom = parentDOM.firstChild, written = false;
  for (var i2 = 0; i2 < descs.length; i2++) {
    var desc = descs[i2], childDOM = desc.dom;
    if (childDOM.parentNode == parentDOM) {
      while (childDOM != dom) {
        dom = rm(dom);
        written = true;
      }
      dom = dom.nextSibling;
    } else {
      written = true;
      parentDOM.insertBefore(childDOM, dom);
    }
    if (desc instanceof MarkViewDesc) {
      var pos = dom ? dom.previousSibling : parentDOM.lastChild;
      renderDescs(desc.contentDOM, desc.children, view);
      dom = pos ? pos.nextSibling : parentDOM.firstChild;
    }
  }
  while (dom) {
    dom = rm(dom);
    written = true;
  }
  if (written && view.trackWrites == parentDOM) {
    view.trackWrites = null;
  }
}
function OuterDecoLevel(nodeName) {
  if (nodeName) {
    this.nodeName = nodeName;
  }
}
OuterDecoLevel.prototype = /* @__PURE__ */ Object.create(null);
var noDeco = [new OuterDecoLevel()];
function computeOuterDeco(outerDeco, node4, needsWrap) {
  if (outerDeco.length == 0) {
    return noDeco;
  }
  var top = needsWrap ? noDeco[0] : new OuterDecoLevel(), result2 = [top];
  for (var i2 = 0; i2 < outerDeco.length; i2++) {
    var attrs = outerDeco[i2].type.attrs;
    if (!attrs) {
      continue;
    }
    if (attrs.nodeName) {
      result2.push(top = new OuterDecoLevel(attrs.nodeName));
    }
    for (var name in attrs) {
      var val = attrs[name];
      if (val == null) {
        continue;
      }
      if (needsWrap && result2.length == 1) {
        result2.push(top = new OuterDecoLevel(node4.isInline ? "span" : "div"));
      }
      if (name == "class") {
        top.class = (top.class ? top.class + " " : "") + val;
      } else if (name == "style") {
        top.style = (top.style ? top.style + ";" : "") + val;
      } else if (name != "nodeName") {
        top[name] = val;
      }
    }
  }
  return result2;
}
function patchOuterDeco(outerDOM, nodeDOM2, prevComputed, curComputed) {
  if (prevComputed == noDeco && curComputed == noDeco) {
    return nodeDOM2;
  }
  var curDOM = nodeDOM2;
  for (var i2 = 0; i2 < curComputed.length; i2++) {
    var deco = curComputed[i2], prev = prevComputed[i2];
    if (i2) {
      var parent = void 0;
      if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.tagName.toLowerCase() == deco.nodeName) {
        curDOM = parent;
      } else {
        parent = document.createElement(deco.nodeName);
        parent.pmIsDeco = true;
        parent.appendChild(curDOM);
        prev = noDeco[0];
        curDOM = parent;
      }
    }
    patchAttributes(curDOM, prev || noDeco[0], deco);
  }
  return curDOM;
}
function patchAttributes(dom, prev, cur) {
  for (var name in prev) {
    if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) {
      dom.removeAttribute(name);
    }
  }
  for (var name$1 in cur) {
    if (name$1 != "class" && name$1 != "style" && name$1 != "nodeName" && cur[name$1] != prev[name$1]) {
      dom.setAttribute(name$1, cur[name$1]);
    }
  }
  if (prev.class != cur.class) {
    var prevList = prev.class ? prev.class.split(" ").filter(Boolean) : nothing;
    var curList = cur.class ? cur.class.split(" ").filter(Boolean) : nothing;
    for (var i2 = 0; i2 < prevList.length; i2++) {
      if (curList.indexOf(prevList[i2]) == -1) {
        dom.classList.remove(prevList[i2]);
      }
    }
    for (var i$1 = 0; i$1 < curList.length; i$1++) {
      if (prevList.indexOf(curList[i$1]) == -1) {
        dom.classList.add(curList[i$1]);
      }
    }
    if (dom.classList.length == 0) {
      dom.removeAttribute("class");
    }
  }
  if (prev.style != cur.style) {
    if (prev.style) {
      var prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
      while (m = prop.exec(prev.style)) {
        dom.style.removeProperty(m[1]);
      }
    }
    if (cur.style) {
      dom.style.cssText += cur.style;
    }
  }
}
function applyOuterDeco(dom, deco, node4) {
  return patchOuterDeco(dom, dom, noDeco, computeOuterDeco(deco, node4, dom.nodeType != 1));
}
function sameOuterDeco(a, b) {
  if (a.length != b.length) {
    return false;
  }
  for (var i2 = 0; i2 < a.length; i2++) {
    if (!a[i2].type.eq(b[i2].type)) {
      return false;
    }
  }
  return true;
}
function rm(dom) {
  var next = dom.nextSibling;
  dom.parentNode.removeChild(dom);
  return next;
}
var ViewTreeUpdater = function ViewTreeUpdater2(top, lockedNode) {
  this.top = top;
  this.lock = lockedNode;
  this.index = 0;
  this.stack = [];
  this.changed = false;
  this.preMatch = preMatch(top.node.content, top);
};
ViewTreeUpdater.prototype.destroyBetween = function destroyBetween(start3, end2) {
  if (start3 == end2) {
    return;
  }
  for (var i2 = start3; i2 < end2; i2++) {
    this.top.children[i2].destroy();
  }
  this.top.children.splice(start3, end2 - start3);
  this.changed = true;
};
ViewTreeUpdater.prototype.destroyRest = function destroyRest() {
  this.destroyBetween(this.index, this.top.children.length);
};
ViewTreeUpdater.prototype.syncToMarks = function syncToMarks(marks2, inline2, view) {
  var keep = 0, depth = this.stack.length >> 1;
  var maxKeep = Math.min(depth, marks2.length);
  while (keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks2[keep]) && marks2[keep].type.spec.spanning !== false) {
    keep++;
  }
  while (keep < depth) {
    this.destroyRest();
    this.top.dirty = NOT_DIRTY;
    this.index = this.stack.pop();
    this.top = this.stack.pop();
    depth--;
  }
  while (depth < marks2.length) {
    this.stack.push(this.top, this.index + 1);
    var found2 = -1;
    for (var i2 = this.index; i2 < Math.min(this.index + 3, this.top.children.length); i2++) {
      if (this.top.children[i2].matchesMark(marks2[depth])) {
        found2 = i2;
        break;
      }
    }
    if (found2 > -1) {
      if (found2 > this.index) {
        this.changed = true;
        this.destroyBetween(this.index, found2);
      }
      this.top = this.top.children[this.index];
    } else {
      var markDesc = MarkViewDesc.create(this.top, marks2[depth], inline2, view);
      this.top.children.splice(this.index, 0, markDesc);
      this.top = markDesc;
      this.changed = true;
    }
    this.index = 0;
    depth++;
  }
};
ViewTreeUpdater.prototype.findNodeMatch = function findNodeMatch(node4, outerDeco, innerDeco, index3) {
  var found2 = -1, targetDesc;
  if (index3 >= this.preMatch.index && (targetDesc = this.preMatch.matches[index3 - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node4, outerDeco, innerDeco)) {
    found2 = this.top.children.indexOf(targetDesc, this.index);
  } else {
    for (var i2 = this.index, e = Math.min(this.top.children.length, i2 + 5); i2 < e; i2++) {
      var child3 = this.top.children[i2];
      if (child3.matchesNode(node4, outerDeco, innerDeco) && !this.preMatch.matched.has(child3)) {
        found2 = i2;
        break;
      }
    }
  }
  if (found2 < 0) {
    return false;
  }
  this.destroyBetween(this.index, found2);
  this.index++;
  return true;
};
ViewTreeUpdater.prototype.updateNodeAt = function updateNodeAt(node4, outerDeco, innerDeco, index3, view) {
  var child3 = this.top.children[index3];
  if (!child3.update(node4, outerDeco, innerDeco, view)) {
    return false;
  }
  this.destroyBetween(this.index, index3);
  this.index = index3 + 1;
  return true;
};
ViewTreeUpdater.prototype.findIndexWithChild = function findIndexWithChild(domNode) {
  for (; ; ) {
    var parent = domNode.parentNode;
    if (!parent) {
      return -1;
    }
    if (parent == this.top.contentDOM) {
      var desc = domNode.pmViewDesc;
      if (desc) {
        for (var i2 = this.index; i2 < this.top.children.length; i2++) {
          if (this.top.children[i2] == desc) {
            return i2;
          }
        }
      }
      return -1;
    }
    domNode = parent;
  }
};
ViewTreeUpdater.prototype.updateNextNode = function updateNextNode(node4, outerDeco, innerDeco, view, index3) {
  for (var i2 = this.index; i2 < this.top.children.length; i2++) {
    var next = this.top.children[i2];
    if (next instanceof NodeViewDesc) {
      var preMatch2 = this.preMatch.matched.get(next);
      if (preMatch2 != null && preMatch2 != index3) {
        return false;
      }
      var nextDOM = next.dom;
      var locked = this.lock && (nextDOM == this.lock || nextDOM.nodeType == 1 && nextDOM.contains(this.lock.parentNode)) && !(node4.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node4.text && next.dirty != NODE_DIRTY && sameOuterDeco(outerDeco, next.outerDeco));
      if (!locked && next.update(node4, outerDeco, innerDeco, view)) {
        this.destroyBetween(this.index, i2);
        if (next.dom != nextDOM) {
          this.changed = true;
        }
        this.index++;
        return true;
      }
      break;
    }
  }
  return false;
};
ViewTreeUpdater.prototype.addNode = function addNode2(node4, outerDeco, innerDeco, view, pos) {
  this.top.children.splice(this.index++, 0, NodeViewDesc.create(this.top, node4, outerDeco, innerDeco, view, pos));
  this.changed = true;
};
ViewTreeUpdater.prototype.placeWidget = function placeWidget(widget2, view, pos) {
  var next = this.index < this.top.children.length ? this.top.children[this.index] : null;
  if (next && next.matchesWidget(widget2) && (widget2 == next.widget || !next.widget.type.toDOM.parentNode)) {
    this.index++;
  } else {
    var desc = new WidgetViewDesc(this.top, widget2, view, pos);
    this.top.children.splice(this.index++, 0, desc);
    this.changed = true;
  }
};
ViewTreeUpdater.prototype.addTextblockHacks = function addTextblockHacks() {
  var lastChild = this.top.children[this.index - 1];
  while (lastChild instanceof MarkViewDesc) {
    lastChild = lastChild.children[lastChild.children.length - 1];
  }
  if (!lastChild || !(lastChild instanceof TextViewDesc) || /\n$/.test(lastChild.node.text)) {
    if ((result.safari || result.chrome) && lastChild && lastChild.dom.contentEditable == "false") {
      this.addHackNode("IMG");
    }
    this.addHackNode("BR");
  }
};
ViewTreeUpdater.prototype.addHackNode = function addHackNode(nodeName) {
  if (this.index < this.top.children.length && this.top.children[this.index].matchesHack(nodeName)) {
    this.index++;
  } else {
    var dom = document.createElement(nodeName);
    if (nodeName == "IMG") {
      dom.className = "ProseMirror-separator";
    }
    if (nodeName == "BR") {
      dom.className = "ProseMirror-trailingBreak";
    }
    this.top.children.splice(this.index++, 0, new TrailingHackViewDesc(this.top, nothing, dom, null));
    this.changed = true;
  }
};
function preMatch(frag, parentDesc) {
  var curDesc = parentDesc, descI = curDesc.children.length;
  var fI = frag.childCount, matched = /* @__PURE__ */ new Map(), matches2 = [];
  outer:
    while (fI > 0) {
      var desc = void 0;
      for (; ; ) {
        if (descI) {
          var next = curDesc.children[descI - 1];
          if (next instanceof MarkViewDesc) {
            curDesc = next;
            descI = next.children.length;
          } else {
            desc = next;
            descI--;
            break;
          }
        } else if (curDesc == parentDesc) {
          break outer;
        } else {
          descI = curDesc.parent.children.indexOf(curDesc);
          curDesc = curDesc.parent;
        }
      }
      var node4 = desc.node;
      if (!node4) {
        continue;
      }
      if (node4 != frag.child(fI - 1)) {
        break;
      }
      --fI;
      matched.set(desc, fI);
      matches2.push(desc);
    }
  return { index: fI, matched, matches: matches2.reverse() };
}
function compareSide(a, b) {
  return a.type.side - b.type.side;
}
function iterDeco(parent, deco, onWidget, onNode) {
  var locals3 = deco.locals(parent), offset3 = 0;
  if (locals3.length == 0) {
    for (var i2 = 0; i2 < parent.childCount; i2++) {
      var child3 = parent.child(i2);
      onNode(child3, locals3, deco.forChild(offset3, child3), i2);
      offset3 += child3.nodeSize;
    }
    return;
  }
  var decoIndex = 0, active = [], restNode = null;
  for (var parentIndex = 0; ; ) {
    if (decoIndex < locals3.length && locals3[decoIndex].to == offset3) {
      var widget2 = locals3[decoIndex++], widgets = void 0;
      while (decoIndex < locals3.length && locals3[decoIndex].to == offset3) {
        (widgets || (widgets = [widget2])).push(locals3[decoIndex++]);
      }
      if (widgets) {
        widgets.sort(compareSide);
        for (var i$1 = 0; i$1 < widgets.length; i$1++) {
          onWidget(widgets[i$1], parentIndex, !!restNode);
        }
      } else {
        onWidget(widget2, parentIndex, !!restNode);
      }
    }
    var child$1 = void 0, index3 = void 0;
    if (restNode) {
      index3 = -1;
      child$1 = restNode;
      restNode = null;
    } else if (parentIndex < parent.childCount) {
      index3 = parentIndex;
      child$1 = parent.child(parentIndex++);
    } else {
      break;
    }
    for (var i$2 = 0; i$2 < active.length; i$2++) {
      if (active[i$2].to <= offset3) {
        active.splice(i$2--, 1);
      }
    }
    while (decoIndex < locals3.length && locals3[decoIndex].from <= offset3 && locals3[decoIndex].to > offset3) {
      active.push(locals3[decoIndex++]);
    }
    var end2 = offset3 + child$1.nodeSize;
    if (child$1.isText) {
      var cutAt = end2;
      if (decoIndex < locals3.length && locals3[decoIndex].from < cutAt) {
        cutAt = locals3[decoIndex].from;
      }
      for (var i$3 = 0; i$3 < active.length; i$3++) {
        if (active[i$3].to < cutAt) {
          cutAt = active[i$3].to;
        }
      }
      if (cutAt < end2) {
        restNode = child$1.cut(cutAt - offset3);
        child$1 = child$1.cut(0, cutAt - offset3);
        end2 = cutAt;
        index3 = -1;
      }
    }
    var outerDeco = !active.length ? nothing : child$1.isInline && !child$1.isLeaf ? active.filter(function(d) {
      return !d.inline;
    }) : active.slice();
    onNode(child$1, outerDeco, deco.forChild(offset3, child$1), index3);
    offset3 = end2;
  }
}
function iosHacks(dom) {
  if (dom.nodeName == "UL" || dom.nodeName == "OL") {
    var oldCSS = dom.style.cssText;
    dom.style.cssText = oldCSS + "; list-style: square !important";
    window.getComputedStyle(dom).listStyle;
    dom.style.cssText = oldCSS;
  }
}
function nearbyTextNode(node4, offset3) {
  for (; ; ) {
    if (node4.nodeType == 3) {
      return node4;
    }
    if (node4.nodeType == 1 && offset3 > 0) {
      if (node4.childNodes.length > offset3 && node4.childNodes[offset3].nodeType == 3) {
        return node4.childNodes[offset3];
      }
      node4 = node4.childNodes[offset3 - 1];
      offset3 = nodeSize(node4);
    } else if (node4.nodeType == 1 && offset3 < node4.childNodes.length) {
      node4 = node4.childNodes[offset3];
      offset3 = 0;
    } else {
      return null;
    }
  }
}
function findTextInFragment(frag, text2, from5, to2) {
  for (var i2 = 0, pos = 0; i2 < frag.childCount && pos <= to2; ) {
    var child3 = frag.child(i2++), childStart = pos;
    pos += child3.nodeSize;
    if (!child3.isText) {
      continue;
    }
    var str = child3.text;
    while (i2 < frag.childCount) {
      var next = frag.child(i2++);
      pos += next.nodeSize;
      if (!next.isText) {
        break;
      }
      str += next.text;
    }
    if (pos >= from5 && childStart < to2) {
      var found2 = str.lastIndexOf(text2, to2 - childStart - 1);
      if (found2 >= 0 && found2 + text2.length + childStart >= from5) {
        return childStart + found2;
      }
    }
  }
  return -1;
}
function replaceNodes(nodes, from5, to2, view, replacement) {
  var result2 = [];
  for (var i2 = 0, off = 0; i2 < nodes.length; i2++) {
    var child3 = nodes[i2], start3 = off, end2 = off += child3.size;
    if (start3 >= to2 || end2 <= from5) {
      result2.push(child3);
    } else {
      if (start3 < from5) {
        result2.push(child3.slice(0, from5 - start3, view));
      }
      if (replacement) {
        result2.push(replacement);
        replacement = null;
      }
      if (end2 > to2) {
        result2.push(child3.slice(to2 - start3, child3.size, view));
      }
    }
  }
  return result2;
}
function selectionFromDOM(view, origin) {
  var domSel = view.root.getSelection(), doc2 = view.state.doc;
  if (!domSel.focusNode) {
    return null;
  }
  var nearestDesc2 = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc2 && nearestDesc2.size == 0;
  var head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
  if (head < 0) {
    return null;
  }
  var $head = doc2.resolve(head), $anchor, selection;
  if (selectionCollapsed(domSel)) {
    $anchor = $head;
    while (nearestDesc2 && !nearestDesc2.node) {
      nearestDesc2 = nearestDesc2.parent;
    }
    if (nearestDesc2 && nearestDesc2.node.isAtom && NodeSelection.isSelectable(nearestDesc2.node) && nearestDesc2.parent && !(nearestDesc2.node.isInline && isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc2.dom))) {
      var pos = nearestDesc2.posBefore;
      selection = new NodeSelection(head == pos ? $head : doc2.resolve(pos));
    }
  } else {
    var anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset);
    if (anchor < 0) {
      return null;
    }
    $anchor = doc2.resolve(anchor);
  }
  if (!selection) {
    var bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
    selection = selectionBetween(view, $anchor, $head, bias);
  }
  return selection;
}
function editorOwnsSelection(view) {
  return view.editable ? view.hasFocus() : hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function selectionToDOM(view, force) {
  var sel = view.state.selection;
  syncNodeSelection(view, sel);
  if (!editorOwnsSelection(view)) {
    return;
  }
  if (!force && view.mouseDown && view.mouseDown.allowDefault && result.chrome) {
    var domSel = view.root.getSelection(), curSel = view.domObserver.currentSelection;
    if (domSel.anchorNode && isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
      view.mouseDown.delayedSelectionSync = true;
      view.domObserver.setCurSelection();
      return;
    }
  }
  view.domObserver.disconnectSelection();
  if (view.cursorWrapper) {
    selectCursorWrapper(view);
  } else {
    var anchor = sel.anchor;
    var head = sel.head;
    var resetEditableFrom, resetEditableTo;
    if (brokenSelectBetweenUneditable && !(sel instanceof TextSelection)) {
      if (!sel.$from.parent.inlineContent) {
        resetEditableFrom = temporarilyEditableNear(view, sel.from);
      }
      if (!sel.empty && !sel.$from.parent.inlineContent) {
        resetEditableTo = temporarilyEditableNear(view, sel.to);
      }
    }
    view.docView.setSelection(anchor, head, view.root, force);
    if (brokenSelectBetweenUneditable) {
      if (resetEditableFrom) {
        resetEditable(resetEditableFrom);
      }
      if (resetEditableTo) {
        resetEditable(resetEditableTo);
      }
    }
    if (sel.visible) {
      view.dom.classList.remove("ProseMirror-hideselection");
    } else {
      view.dom.classList.add("ProseMirror-hideselection");
      if ("onselectionchange" in document) {
        removeClassOnSelectionChange(view);
      }
    }
  }
  view.domObserver.setCurSelection();
  view.domObserver.connectSelection();
}
var brokenSelectBetweenUneditable = result.safari || result.chrome && result.chrome_version < 63;
function temporarilyEditableNear(view, pos) {
  var ref2 = view.docView.domFromPos(pos, 0);
  var node4 = ref2.node;
  var offset3 = ref2.offset;
  var after2 = offset3 < node4.childNodes.length ? node4.childNodes[offset3] : null;
  var before2 = offset3 ? node4.childNodes[offset3 - 1] : null;
  if (result.safari && after2 && after2.contentEditable == "false") {
    return setEditable(after2);
  }
  if ((!after2 || after2.contentEditable == "false") && (!before2 || before2.contentEditable == "false")) {
    if (after2) {
      return setEditable(after2);
    } else if (before2) {
      return setEditable(before2);
    }
  }
}
function setEditable(element) {
  element.contentEditable = "true";
  if (result.safari && element.draggable) {
    element.draggable = false;
    element.wasDraggable = true;
  }
  return element;
}
function resetEditable(element) {
  element.contentEditable = "false";
  if (element.wasDraggable) {
    element.draggable = true;
    element.wasDraggable = null;
  }
}
function removeClassOnSelectionChange(view) {
  var doc2 = view.dom.ownerDocument;
  doc2.removeEventListener("selectionchange", view.hideSelectionGuard);
  var domSel = view.root.getSelection();
  var node4 = domSel.anchorNode, offset3 = domSel.anchorOffset;
  doc2.addEventListener("selectionchange", view.hideSelectionGuard = function() {
    if (domSel.anchorNode != node4 || domSel.anchorOffset != offset3) {
      doc2.removeEventListener("selectionchange", view.hideSelectionGuard);
      setTimeout(function() {
        if (!editorOwnsSelection(view) || view.state.selection.visible) {
          view.dom.classList.remove("ProseMirror-hideselection");
        }
      }, 20);
    }
  });
}
function selectCursorWrapper(view) {
  var domSel = view.root.getSelection(), range2 = document.createRange();
  var node4 = view.cursorWrapper.dom, img = node4.nodeName == "IMG";
  if (img) {
    range2.setEnd(node4.parentNode, domIndex(node4) + 1);
  } else {
    range2.setEnd(node4, 0);
  }
  range2.collapse(false);
  domSel.removeAllRanges();
  domSel.addRange(range2);
  if (!img && !view.state.selection.visible && result.ie && result.ie_version <= 11) {
    node4.disabled = true;
    node4.disabled = false;
  }
}
function syncNodeSelection(view, sel) {
  if (sel instanceof NodeSelection) {
    var desc = view.docView.descAt(sel.from);
    if (desc != view.lastSelectedViewDesc) {
      clearNodeSelection(view);
      if (desc) {
        desc.selectNode();
      }
      view.lastSelectedViewDesc = desc;
    }
  } else {
    clearNodeSelection(view);
  }
}
function clearNodeSelection(view) {
  if (view.lastSelectedViewDesc) {
    if (view.lastSelectedViewDesc.parent) {
      view.lastSelectedViewDesc.deselectNode();
    }
    view.lastSelectedViewDesc = null;
  }
}
function selectionBetween(view, $anchor, $head, bias) {
  return view.someProp("createSelectionBetween", function(f) {
    return f(view, $anchor, $head);
  }) || TextSelection.between($anchor, $head, bias);
}
function hasFocusAndSelection(view) {
  if (view.editable && view.root.activeElement != view.dom) {
    return false;
  }
  return hasSelection(view);
}
function hasSelection(view) {
  var sel = view.root.getSelection();
  if (!sel.anchorNode) {
    return false;
  }
  try {
    return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
  } catch (_) {
    return false;
  }
}
function anchorInRightPlace(view) {
  var anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
  var domSel = view.root.getSelection();
  return isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function moveSelectionBlock(state, dir) {
  var ref2 = state.selection;
  var $anchor = ref2.$anchor;
  var $head = ref2.$head;
  var $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
  var $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
  return $start && Selection.findFrom($start, dir);
}
function apply7(view, sel) {
  view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
  return true;
}
function selectHorizontally(view, dir, mods) {
  var sel = view.state.selection;
  if (sel instanceof TextSelection) {
    if (!sel.empty || mods.indexOf("s") > -1) {
      return false;
    } else if (view.endOfTextblock(dir > 0 ? "right" : "left")) {
      var next = moveSelectionBlock(view.state, dir);
      if (next && next instanceof NodeSelection) {
        return apply7(view, next);
      }
      return false;
    } else if (!(result.mac && mods.indexOf("m") > -1)) {
      var $head = sel.$head, node4 = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
      if (!node4 || node4.isText) {
        return false;
      }
      var nodePos = dir < 0 ? $head.pos - node4.nodeSize : $head.pos;
      if (!(node4.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) {
        return false;
      }
      if (NodeSelection.isSelectable(node4)) {
        return apply7(view, new NodeSelection(dir < 0 ? view.state.doc.resolve($head.pos - node4.nodeSize) : $head));
      } else if (result.webkit) {
        return apply7(view, new TextSelection(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node4.nodeSize)));
      } else {
        return false;
      }
    }
  } else if (sel instanceof NodeSelection && sel.node.isInline) {
    return apply7(view, new TextSelection(dir > 0 ? sel.$to : sel.$from));
  } else {
    var next$1 = moveSelectionBlock(view.state, dir);
    if (next$1) {
      return apply7(view, next$1);
    }
    return false;
  }
}
function nodeLen(node4) {
  return node4.nodeType == 3 ? node4.nodeValue.length : node4.childNodes.length;
}
function isIgnorable(dom) {
  var desc = dom.pmViewDesc;
  return desc && desc.size == 0 && (dom.nextSibling || dom.nodeName != "BR");
}
function skipIgnoredNodesLeft(view) {
  var sel = view.root.getSelection();
  var node4 = sel.focusNode, offset3 = sel.focusOffset;
  if (!node4) {
    return;
  }
  var moveNode, moveOffset, force = false;
  if (result.gecko && node4.nodeType == 1 && offset3 < nodeLen(node4) && isIgnorable(node4.childNodes[offset3])) {
    force = true;
  }
  for (; ; ) {
    if (offset3 > 0) {
      if (node4.nodeType != 1) {
        break;
      } else {
        var before2 = node4.childNodes[offset3 - 1];
        if (isIgnorable(before2)) {
          moveNode = node4;
          moveOffset = --offset3;
        } else if (before2.nodeType == 3) {
          node4 = before2;
          offset3 = node4.nodeValue.length;
        } else {
          break;
        }
      }
    } else if (isBlockNode(node4)) {
      break;
    } else {
      var prev = node4.previousSibling;
      while (prev && isIgnorable(prev)) {
        moveNode = node4.parentNode;
        moveOffset = domIndex(prev);
        prev = prev.previousSibling;
      }
      if (!prev) {
        node4 = node4.parentNode;
        if (node4 == view.dom) {
          break;
        }
        offset3 = 0;
      } else {
        node4 = prev;
        offset3 = nodeLen(node4);
      }
    }
  }
  if (force) {
    setSelFocus(view, sel, node4, offset3);
  } else if (moveNode) {
    setSelFocus(view, sel, moveNode, moveOffset);
  }
}
function skipIgnoredNodesRight(view) {
  var sel = view.root.getSelection();
  var node4 = sel.focusNode, offset3 = sel.focusOffset;
  if (!node4) {
    return;
  }
  var len = nodeLen(node4);
  var moveNode, moveOffset;
  for (; ; ) {
    if (offset3 < len) {
      if (node4.nodeType != 1) {
        break;
      }
      var after2 = node4.childNodes[offset3];
      if (isIgnorable(after2)) {
        moveNode = node4;
        moveOffset = ++offset3;
      } else {
        break;
      }
    } else if (isBlockNode(node4)) {
      break;
    } else {
      var next = node4.nextSibling;
      while (next && isIgnorable(next)) {
        moveNode = next.parentNode;
        moveOffset = domIndex(next) + 1;
        next = next.nextSibling;
      }
      if (!next) {
        node4 = node4.parentNode;
        if (node4 == view.dom) {
          break;
        }
        offset3 = len = 0;
      } else {
        node4 = next;
        offset3 = 0;
        len = nodeLen(node4);
      }
    }
  }
  if (moveNode) {
    setSelFocus(view, sel, moveNode, moveOffset);
  }
}
function isBlockNode(dom) {
  var desc = dom.pmViewDesc;
  return desc && desc.node && desc.node.isBlock;
}
function setSelFocus(view, sel, node4, offset3) {
  if (selectionCollapsed(sel)) {
    var range2 = document.createRange();
    range2.setEnd(node4, offset3);
    range2.setStart(node4, offset3);
    sel.removeAllRanges();
    sel.addRange(range2);
  } else if (sel.extend) {
    sel.extend(node4, offset3);
  }
  view.domObserver.setCurSelection();
  var state = view.state;
  setTimeout(function() {
    if (view.state == state) {
      selectionToDOM(view);
    }
  }, 50);
}
function selectVertically(view, dir, mods) {
  var sel = view.state.selection;
  if (sel instanceof TextSelection && !sel.empty || mods.indexOf("s") > -1) {
    return false;
  }
  if (result.mac && mods.indexOf("m") > -1) {
    return false;
  }
  var $from = sel.$from;
  var $to = sel.$to;
  if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
    var next = moveSelectionBlock(view.state, dir);
    if (next && next instanceof NodeSelection) {
      return apply7(view, next);
    }
  }
  if (!$from.parent.inlineContent) {
    var side = dir < 0 ? $from : $to;
    var beyond = sel instanceof AllSelection ? Selection.near(side, dir) : Selection.findFrom(side, dir);
    return beyond ? apply7(view, beyond) : false;
  }
  return false;
}
function stopNativeHorizontalDelete(view, dir) {
  if (!(view.state.selection instanceof TextSelection)) {
    return true;
  }
  var ref2 = view.state.selection;
  var $head = ref2.$head;
  var $anchor = ref2.$anchor;
  var empty2 = ref2.empty;
  if (!$head.sameParent($anchor)) {
    return true;
  }
  if (!empty2) {
    return false;
  }
  if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
    return true;
  }
  var nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
  if (nextNode && !nextNode.isText) {
    var tr = view.state.tr;
    if (dir < 0) {
      tr.delete($head.pos - nextNode.nodeSize, $head.pos);
    } else {
      tr.delete($head.pos, $head.pos + nextNode.nodeSize);
    }
    view.dispatch(tr);
    return true;
  }
  return false;
}
function switchEditable(view, node4, state) {
  view.domObserver.stop();
  node4.contentEditable = state;
  view.domObserver.start();
}
function safariDownArrowBug(view) {
  if (!result.safari || view.state.selection.$head.parentOffset > 0) {
    return;
  }
  var ref2 = view.root.getSelection();
  var focusNode = ref2.focusNode;
  var focusOffset = ref2.focusOffset;
  if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
    var child3 = focusNode.firstChild;
    switchEditable(view, child3, true);
    setTimeout(function() {
      return switchEditable(view, child3, false);
    }, 20);
  }
}
function getMods(event) {
  var result2 = "";
  if (event.ctrlKey) {
    result2 += "c";
  }
  if (event.metaKey) {
    result2 += "m";
  }
  if (event.altKey) {
    result2 += "a";
  }
  if (event.shiftKey) {
    result2 += "s";
  }
  return result2;
}
function captureKeyDown(view, event) {
  var code = event.keyCode, mods = getMods(event);
  if (code == 8 || result.mac && code == 72 && mods == "c") {
    return stopNativeHorizontalDelete(view, -1) || skipIgnoredNodesLeft(view);
  } else if (code == 46 || result.mac && code == 68 && mods == "c") {
    return stopNativeHorizontalDelete(view, 1) || skipIgnoredNodesRight(view);
  } else if (code == 13 || code == 27) {
    return true;
  } else if (code == 37) {
    return selectHorizontally(view, -1, mods) || skipIgnoredNodesLeft(view);
  } else if (code == 39) {
    return selectHorizontally(view, 1, mods) || skipIgnoredNodesRight(view);
  } else if (code == 38) {
    return selectVertically(view, -1, mods) || skipIgnoredNodesLeft(view);
  } else if (code == 40) {
    return safariDownArrowBug(view) || selectVertically(view, 1, mods) || skipIgnoredNodesRight(view);
  } else if (mods == (result.mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) {
    return true;
  }
  return false;
}
function parseBetween(view, from_, to_) {
  var ref2 = view.docView.parseRange(from_, to_);
  var parent = ref2.node;
  var fromOffset = ref2.fromOffset;
  var toOffset = ref2.toOffset;
  var from5 = ref2.from;
  var to2 = ref2.to;
  var domSel = view.root.getSelection(), find2 = null, anchor = domSel.anchorNode;
  if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
    find2 = [{ node: anchor, offset: domSel.anchorOffset }];
    if (!selectionCollapsed(domSel)) {
      find2.push({ node: domSel.focusNode, offset: domSel.focusOffset });
    }
  }
  if (result.chrome && view.lastKeyCode === 8) {
    for (var off = toOffset; off > fromOffset; off--) {
      var node4 = parent.childNodes[off - 1], desc = node4.pmViewDesc;
      if (node4.nodeName == "BR" && !desc) {
        toOffset = off;
        break;
      }
      if (!desc || desc.size) {
        break;
      }
    }
  }
  var startDoc = view.state.doc;
  var parser = view.someProp("domParser") || DOMParser.fromSchema(view.state.schema);
  var $from = startDoc.resolve(from5);
  var sel = null, doc2 = parser.parse(parent, {
    topNode: $from.parent,
    topMatch: $from.parent.contentMatchAt($from.index()),
    topOpen: true,
    from: fromOffset,
    to: toOffset,
    preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
    editableContent: true,
    findPositions: find2,
    ruleFromNode,
    context: $from
  });
  if (find2 && find2[0].pos != null) {
    var anchor$1 = find2[0].pos, head = find2[1] && find2[1].pos;
    if (head == null) {
      head = anchor$1;
    }
    sel = { anchor: anchor$1 + from5, head: head + from5 };
  }
  return { doc: doc2, sel, from: from5, to: to2 };
}
function ruleFromNode(dom) {
  var desc = dom.pmViewDesc;
  if (desc) {
    return desc.parseRule();
  } else if (dom.nodeName == "BR" && dom.parentNode) {
    if (result.safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
      var skip = document.createElement("div");
      skip.appendChild(document.createElement("li"));
      return { skip };
    } else if (dom.parentNode.lastChild == dom || result.safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) {
      return { ignore: true };
    }
  } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) {
    return { ignore: true };
  }
}
function readDOMChange(view, from5, to2, typeOver, addedNodes) {
  if (from5 < 0) {
    var origin = view.lastSelectionTime > Date.now() - 50 ? view.lastSelectionOrigin : null;
    var newSel = selectionFromDOM(view, origin);
    if (newSel && !view.state.selection.eq(newSel)) {
      var tr$1 = view.state.tr.setSelection(newSel);
      if (origin == "pointer") {
        tr$1.setMeta("pointer", true);
      } else if (origin == "key") {
        tr$1.scrollIntoView();
      }
      view.dispatch(tr$1);
    }
    return;
  }
  var $before = view.state.doc.resolve(from5);
  var shared = $before.sharedDepth(to2);
  from5 = $before.before(shared + 1);
  to2 = view.state.doc.resolve(to2).after(shared + 1);
  var sel = view.state.selection;
  var parse3 = parseBetween(view, from5, to2);
  if (result.chrome && view.cursorWrapper && parse3.sel && parse3.sel.anchor == view.cursorWrapper.deco.from) {
    var text2 = view.cursorWrapper.deco.type.toDOM.nextSibling;
    var size = text2 && text2.nodeValue ? text2.nodeValue.length : 1;
    parse3.sel = { anchor: parse3.sel.anchor + size, head: parse3.sel.anchor + size };
  }
  var doc2 = view.state.doc, compare = doc2.slice(parse3.from, parse3.to);
  var preferredPos, preferredSide;
  if (view.lastKeyCode === 8 && Date.now() - 100 < view.lastKeyCodeTime) {
    preferredPos = view.state.selection.to;
    preferredSide = "end";
  } else {
    preferredPos = view.state.selection.from;
    preferredSide = "start";
  }
  view.lastKeyCode = null;
  var change = findDiff(compare.content, parse3.doc.content, parse3.from, preferredPos, preferredSide);
  if (!change) {
    if (typeOver && sel instanceof TextSelection && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse3.sel && parse3.sel.anchor != parse3.sel.head)) {
      change = { start: sel.from, endA: sel.to, endB: sel.to };
    } else if ((result.ios && view.lastIOSEnter > Date.now() - 225 || result.android) && addedNodes.some(function(n) {
      return n.nodeName == "DIV" || n.nodeName == "P";
    }) && view.someProp("handleKeyDown", function(f) {
      return f(view, keyEvent(13, "Enter"));
    })) {
      view.lastIOSEnter = 0;
      return;
    } else {
      if (parse3.sel) {
        var sel$1 = resolveSelection(view, view.state.doc, parse3.sel);
        if (sel$1 && !sel$1.eq(view.state.selection)) {
          view.dispatch(view.state.tr.setSelection(sel$1));
        }
      }
      return;
    }
  }
  view.domChangeCount++;
  if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof TextSelection) {
    if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2) {
      change.start = view.state.selection.from;
    } else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2) {
      change.endB += view.state.selection.to - change.endA;
      change.endA = view.state.selection.to;
    }
  }
  if (result.ie && result.ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse3.from && parse3.doc.textBetween(change.start - parse3.from - 1, change.start - parse3.from + 1) == " \xA0") {
    change.start--;
    change.endA--;
    change.endB--;
  }
  var $from = parse3.doc.resolveNoCache(change.start - parse3.from);
  var $to = parse3.doc.resolveNoCache(change.endB - parse3.from);
  var inlineChange = $from.sameParent($to) && $from.parent.inlineContent;
  var nextSel;
  if ((result.ios && view.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some(function(n) {
    return n.nodeName == "DIV" || n.nodeName == "P";
  })) || !inlineChange && $from.pos < parse3.doc.content.size && (nextSel = Selection.findFrom(parse3.doc.resolve($from.pos + 1), 1, true)) && nextSel.head == $to.pos) && view.someProp("handleKeyDown", function(f) {
    return f(view, keyEvent(13, "Enter"));
  })) {
    view.lastIOSEnter = 0;
    return;
  }
  if (view.state.selection.anchor > change.start && looksLikeJoin(doc2, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", function(f) {
    return f(view, keyEvent(8, "Backspace"));
  })) {
    if (result.android && result.chrome) {
      view.domObserver.suppressSelectionUpdates();
    }
    return;
  }
  if (result.chrome && result.android && change.toB == change.from) {
    view.lastAndroidDelete = Date.now();
  }
  if (result.android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse3.sel && parse3.sel.anchor == parse3.sel.head && parse3.sel.head == change.endA) {
    change.endB -= 2;
    $to = parse3.doc.resolveNoCache(change.endB - parse3.from);
    setTimeout(function() {
      view.someProp("handleKeyDown", function(f) {
        return f(view, keyEvent(13, "Enter"));
      });
    }, 20);
  }
  var chFrom = change.start, chTo = change.endA;
  var tr, storedMarks, markChange, $from1;
  if (inlineChange) {
    if ($from.pos == $to.pos) {
      if (result.ie && result.ie_version <= 11 && $from.parentOffset == 0) {
        view.domObserver.suppressSelectionUpdates();
        setTimeout(function() {
          return selectionToDOM(view);
        }, 20);
      }
      tr = view.state.tr.delete(chFrom, chTo);
      storedMarks = doc2.resolve(change.start).marksAcross(doc2.resolve(change.endA));
    } else if (change.endA == change.endB && ($from1 = doc2.resolve(change.start)) && (markChange = isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $from1.parent.content.cut($from1.parentOffset, change.endA - $from1.start())))) {
      tr = view.state.tr;
      if (markChange.type == "add") {
        tr.addMark(chFrom, chTo, markChange.mark);
      } else {
        tr.removeMark(chFrom, chTo, markChange.mark);
      }
    } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
      var text$1 = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
      if (view.someProp("handleTextInput", function(f) {
        return f(view, chFrom, chTo, text$1);
      })) {
        return;
      }
      tr = view.state.tr.insertText(text$1, chFrom, chTo);
    }
  }
  if (!tr) {
    tr = view.state.tr.replace(chFrom, chTo, parse3.doc.slice(change.start - parse3.from, change.endB - parse3.from));
  }
  if (parse3.sel) {
    var sel$2 = resolveSelection(view, tr.doc, parse3.sel);
    if (sel$2 && !(result.chrome && result.android && view.composing && sel$2.empty && (change.start != change.endB || view.lastAndroidDelete < Date.now() - 100) && (sel$2.head == chFrom || sel$2.head == tr.mapping.map(chTo) - 1) || result.ie && sel$2.empty && sel$2.head == chFrom)) {
      tr.setSelection(sel$2);
    }
  }
  if (storedMarks) {
    tr.ensureMarks(storedMarks);
  }
  view.dispatch(tr.scrollIntoView());
}
function resolveSelection(view, doc2, parsedSel) {
  if (Math.max(parsedSel.anchor, parsedSel.head) > doc2.content.size) {
    return null;
  }
  return selectionBetween(view, doc2.resolve(parsedSel.anchor), doc2.resolve(parsedSel.head));
}
function isMarkChange(cur, prev) {
  var curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
  var added = curMarks, removed = prevMarks, type, mark3, update3;
  for (var i2 = 0; i2 < prevMarks.length; i2++) {
    added = prevMarks[i2].removeFromSet(added);
  }
  for (var i$1 = 0; i$1 < curMarks.length; i$1++) {
    removed = curMarks[i$1].removeFromSet(removed);
  }
  if (added.length == 1 && removed.length == 0) {
    mark3 = added[0];
    type = "add";
    update3 = function(node4) {
      return node4.mark(mark3.addToSet(node4.marks));
    };
  } else if (added.length == 0 && removed.length == 1) {
    mark3 = removed[0];
    type = "remove";
    update3 = function(node4) {
      return node4.mark(mark3.removeFromSet(node4.marks));
    };
  } else {
    return null;
  }
  var updated = [];
  for (var i$2 = 0; i$2 < prev.childCount; i$2++) {
    updated.push(update3(prev.child(i$2)));
  }
  if (Fragment.from(updated).eq(cur)) {
    return { mark: mark3, type };
  }
}
function looksLikeJoin(old, start3, end2, $newStart, $newEnd) {
  if (!$newStart.parent.isTextblock || end2 - start3 <= $newEnd.pos - $newStart.pos || skipClosingAndOpening($newStart, true, false) < $newEnd.pos) {
    return false;
  }
  var $start = old.resolve(start3);
  if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) {
    return false;
  }
  var $next = old.resolve(skipClosingAndOpening($start, true, true));
  if (!$next.parent.isTextblock || $next.pos > end2 || skipClosingAndOpening($next, true, false) < end2) {
    return false;
  }
  return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function skipClosingAndOpening($pos, fromEnd, mayOpen) {
  var depth = $pos.depth, end2 = fromEnd ? $pos.end() : $pos.pos;
  while (depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)) {
    depth--;
    end2++;
    fromEnd = false;
  }
  if (mayOpen) {
    var next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
    while (next && !next.isLeaf) {
      next = next.firstChild;
      end2++;
    }
  }
  return end2;
}
function findDiff(a, b, pos, preferredPos, preferredSide) {
  var start3 = a.findDiffStart(b, pos);
  if (start3 == null) {
    return null;
  }
  var ref2 = a.findDiffEnd(b, pos + a.size, pos + b.size);
  var endA = ref2.a;
  var endB = ref2.b;
  if (preferredSide == "end") {
    var adjust = Math.max(0, start3 - Math.min(endA, endB));
    preferredPos -= endA + adjust - start3;
  }
  if (endA < start3 && a.size < b.size) {
    var move2 = preferredPos <= start3 && preferredPos >= endA ? start3 - preferredPos : 0;
    start3 -= move2;
    endB = start3 + (endB - endA);
    endA = start3;
  } else if (endB < start3) {
    var move$1 = preferredPos <= start3 && preferredPos >= endB ? start3 - preferredPos : 0;
    start3 -= move$1;
    endA = start3 + (endA - endB);
    endB = start3;
  }
  return { start: start3, endA, endB };
}
function serializeForClipboard(view, slice4) {
  var context = [];
  var content2 = slice4.content;
  var openStart = slice4.openStart;
  var openEnd = slice4.openEnd;
  while (openStart > 1 && openEnd > 1 && content2.childCount == 1 && content2.firstChild.childCount == 1) {
    openStart--;
    openEnd--;
    var node4 = content2.firstChild;
    context.push(node4.type.name, node4.attrs != node4.type.defaultAttrs ? node4.attrs : null);
    content2 = node4.content;
  }
  var serializer = view.someProp("clipboardSerializer") || DOMSerializer.fromSchema(view.state.schema);
  var doc2 = detachedDoc(), wrap = doc2.createElement("div");
  wrap.appendChild(serializer.serializeFragment(content2, { document: doc2 }));
  var firstChild = wrap.firstChild, needsWrap;
  while (firstChild && firstChild.nodeType == 1 && (needsWrap = wrapMap[firstChild.nodeName.toLowerCase()])) {
    for (var i2 = needsWrap.length - 1; i2 >= 0; i2--) {
      var wrapper = doc2.createElement(needsWrap[i2]);
      while (wrap.firstChild) {
        wrapper.appendChild(wrap.firstChild);
      }
      wrap.appendChild(wrapper);
      if (needsWrap[i2] != "tbody") {
        openStart++;
        openEnd++;
      }
    }
    firstChild = wrap.firstChild;
  }
  if (firstChild && firstChild.nodeType == 1) {
    firstChild.setAttribute("data-pm-slice", openStart + " " + openEnd + " " + JSON.stringify(context));
  }
  var text2 = view.someProp("clipboardTextSerializer", function(f) {
    return f(slice4);
  }) || slice4.content.textBetween(0, slice4.content.size, "\n\n");
  return { dom: wrap, text: text2 };
}
function parseFromClipboard(view, text2, html, plainText, $context) {
  var dom, inCode = $context.parent.type.spec.code, slice4;
  if (!html && !text2) {
    return null;
  }
  var asText = text2 && (plainText || inCode || !html);
  if (asText) {
    view.someProp("transformPastedText", function(f) {
      text2 = f(text2, inCode || plainText);
    });
    if (inCode) {
      return text2 ? new Slice(Fragment.from(view.state.schema.text(text2.replace(/\r\n?/g, "\n"))), 0, 0) : Slice.empty;
    }
    var parsed = view.someProp("clipboardTextParser", function(f) {
      return f(text2, $context, plainText);
    });
    if (parsed) {
      slice4 = parsed;
    } else {
      var marks2 = $context.marks();
      var ref2 = view.state;
      var schema = ref2.schema;
      var serializer = DOMSerializer.fromSchema(schema);
      dom = document.createElement("div");
      text2.split(/(?:\r\n?|\n)+/).forEach(function(block) {
        var p = dom.appendChild(document.createElement("p"));
        if (block) {
          p.appendChild(serializer.serializeNode(schema.text(block, marks2)));
        }
      });
    }
  } else {
    view.someProp("transformPastedHTML", function(f) {
      html = f(html);
    });
    dom = readHTML(html);
    if (result.webkit) {
      restoreReplacedSpaces(dom);
    }
  }
  var contextNode = dom && dom.querySelector("[data-pm-slice]");
  var sliceData = contextNode && /^(\d+) (\d+) (.*)/.exec(contextNode.getAttribute("data-pm-slice"));
  if (!slice4) {
    var parser = view.someProp("clipboardParser") || view.someProp("domParser") || DOMParser.fromSchema(view.state.schema);
    slice4 = parser.parseSlice(dom, {
      preserveWhitespace: !!(asText || sliceData),
      context: $context,
      ruleFromNode: function ruleFromNode2(dom2) {
        if (dom2.nodeName == "BR" && !dom2.nextSibling && dom2.parentNode && !inlineParents.test(dom2.parentNode.nodeName)) {
          return { ignore: true };
        }
      }
    });
  }
  if (sliceData) {
    slice4 = addContext(closeSlice(slice4, +sliceData[1], +sliceData[2]), sliceData[3]);
  } else {
    slice4 = Slice.maxOpen(normalizeSiblings(slice4.content, $context), true);
    if (slice4.openStart || slice4.openEnd) {
      var openStart = 0, openEnd = 0;
      for (var node4 = slice4.content.firstChild; openStart < slice4.openStart && !node4.type.spec.isolating; openStart++, node4 = node4.firstChild) {
      }
      for (var node$1 = slice4.content.lastChild; openEnd < slice4.openEnd && !node$1.type.spec.isolating; openEnd++, node$1 = node$1.lastChild) {
      }
      slice4 = closeSlice(slice4, openStart, openEnd);
    }
  }
  view.someProp("transformPasted", function(f) {
    slice4 = f(slice4);
  });
  return slice4;
}
var inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function normalizeSiblings(fragment, $context) {
  if (fragment.childCount < 2) {
    return fragment;
  }
  var loop = function(d2) {
    var parent = $context.node(d2);
    var match = parent.contentMatchAt($context.index(d2));
    var lastWrap = void 0, result2 = [];
    fragment.forEach(function(node4) {
      if (!result2) {
        return;
      }
      var wrap = match.findWrapping(node4.type), inLast;
      if (!wrap) {
        return result2 = null;
      }
      if (inLast = result2.length && lastWrap.length && addToSibling(wrap, lastWrap, node4, result2[result2.length - 1], 0)) {
        result2[result2.length - 1] = inLast;
      } else {
        if (result2.length) {
          result2[result2.length - 1] = closeRight(result2[result2.length - 1], lastWrap.length);
        }
        var wrapped = withWrappers(node4, wrap);
        result2.push(wrapped);
        match = match.matchType(wrapped.type, wrapped.attrs);
        lastWrap = wrap;
      }
    });
    if (result2) {
      return { v: Fragment.from(result2) };
    }
  };
  for (var d = $context.depth; d >= 0; d--) {
    var returned = loop(d);
    if (returned)
      return returned.v;
  }
  return fragment;
}
function withWrappers(node4, wrap, from5) {
  if (from5 === void 0)
    from5 = 0;
  for (var i2 = wrap.length - 1; i2 >= from5; i2--) {
    node4 = wrap[i2].create(null, Fragment.from(node4));
  }
  return node4;
}
function addToSibling(wrap, lastWrap, node4, sibling, depth) {
  if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
    var inner = addToSibling(wrap, lastWrap, node4, sibling.lastChild, depth + 1);
    if (inner) {
      return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
    }
    var match = sibling.contentMatchAt(sibling.childCount);
    if (match.matchType(depth == wrap.length - 1 ? node4.type : wrap[depth + 1])) {
      return sibling.copy(sibling.content.append(Fragment.from(withWrappers(node4, wrap, depth + 1))));
    }
  }
}
function closeRight(node4, depth) {
  if (depth == 0) {
    return node4;
  }
  var fragment = node4.content.replaceChild(node4.childCount - 1, closeRight(node4.lastChild, depth - 1));
  var fill = node4.contentMatchAt(node4.childCount).fillBefore(Fragment.empty, true);
  return node4.copy(fragment.append(fill));
}
function closeRange(fragment, side, from5, to2, depth, openEnd) {
  var node4 = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node4.content;
  if (depth < to2 - 1) {
    inner = closeRange(inner, side, from5, to2, depth + 1, openEnd);
  }
  if (depth >= from5) {
    inner = side < 0 ? node4.contentMatchAt(0).fillBefore(inner, fragment.childCount > 1 || openEnd <= depth).append(inner) : inner.append(node4.contentMatchAt(node4.childCount).fillBefore(Fragment.empty, true));
  }
  return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node4.copy(inner));
}
function closeSlice(slice4, openStart, openEnd) {
  if (openStart < slice4.openStart) {
    slice4 = new Slice(closeRange(slice4.content, -1, openStart, slice4.openStart, 0, slice4.openEnd), openStart, slice4.openEnd);
  }
  if (openEnd < slice4.openEnd) {
    slice4 = new Slice(closeRange(slice4.content, 1, openEnd, slice4.openEnd, 0, 0), slice4.openStart, openEnd);
  }
  return slice4;
}
var wrapMap = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
var _detachedDoc = null;
function detachedDoc() {
  return _detachedDoc || (_detachedDoc = document.implementation.createHTMLDocument("title"));
}
function readHTML(html) {
  var metas = /^(\s*<meta [^>]*>)*/.exec(html);
  if (metas) {
    html = html.slice(metas[0].length);
  }
  var elt = detachedDoc().createElement("div");
  var firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
  if (wrap = firstTag && wrapMap[firstTag[1].toLowerCase()]) {
    html = wrap.map(function(n) {
      return "<" + n + ">";
    }).join("") + html + wrap.map(function(n) {
      return "</" + n + ">";
    }).reverse().join("");
  }
  elt.innerHTML = html;
  if (wrap) {
    for (var i2 = 0; i2 < wrap.length; i2++) {
      elt = elt.querySelector(wrap[i2]) || elt;
    }
  }
  return elt;
}
function restoreReplacedSpaces(dom) {
  var nodes = dom.querySelectorAll(result.chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (var i2 = 0; i2 < nodes.length; i2++) {
    var node4 = nodes[i2];
    if (node4.childNodes.length == 1 && node4.textContent == "\xA0" && node4.parentNode) {
      node4.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node4);
    }
  }
}
function addContext(slice4, context) {
  if (!slice4.size) {
    return slice4;
  }
  var schema = slice4.content.firstChild.type.schema, array;
  try {
    array = JSON.parse(context);
  } catch (e) {
    return slice4;
  }
  var content2 = slice4.content;
  var openStart = slice4.openStart;
  var openEnd = slice4.openEnd;
  for (var i2 = array.length - 2; i2 >= 0; i2 -= 2) {
    var type = schema.nodes[array[i2]];
    if (!type || type.hasRequiredAttrs()) {
      break;
    }
    content2 = Fragment.from(type.create(array[i2 + 1], content2));
    openStart++;
    openEnd++;
  }
  return new Slice(content2, openStart, openEnd);
}
var observeOptions = {
  childList: true,
  characterData: true,
  characterDataOldValue: true,
  attributes: true,
  attributeOldValue: true,
  subtree: true
};
var useCharData = result.ie && result.ie_version <= 11;
var SelectionState = function SelectionState2() {
  this.anchorNode = this.anchorOffset = this.focusNode = this.focusOffset = null;
};
SelectionState.prototype.set = function set2(sel) {
  this.anchorNode = sel.anchorNode;
  this.anchorOffset = sel.anchorOffset;
  this.focusNode = sel.focusNode;
  this.focusOffset = sel.focusOffset;
};
SelectionState.prototype.eq = function eq5(sel) {
  return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
};
var DOMObserver = function DOMObserver2(view, handleDOMChange) {
  var this$1$1 = this;
  this.view = view;
  this.handleDOMChange = handleDOMChange;
  this.queue = [];
  this.flushingSoon = -1;
  this.observer = window.MutationObserver && new window.MutationObserver(function(mutations) {
    for (var i2 = 0; i2 < mutations.length; i2++) {
      this$1$1.queue.push(mutations[i2]);
    }
    if (result.ie && result.ie_version <= 11 && mutations.some(function(m) {
      return m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length;
    })) {
      this$1$1.flushSoon();
    } else {
      this$1$1.flush();
    }
  });
  this.currentSelection = new SelectionState();
  if (useCharData) {
    this.onCharData = function(e) {
      this$1$1.queue.push({ target: e.target, type: "characterData", oldValue: e.prevValue });
      this$1$1.flushSoon();
    };
  }
  this.onSelectionChange = this.onSelectionChange.bind(this);
  this.suppressingSelectionUpdates = false;
};
DOMObserver.prototype.flushSoon = function flushSoon() {
  var this$1$1 = this;
  if (this.flushingSoon < 0) {
    this.flushingSoon = window.setTimeout(function() {
      this$1$1.flushingSoon = -1;
      this$1$1.flush();
    }, 20);
  }
};
DOMObserver.prototype.forceFlush = function forceFlush() {
  if (this.flushingSoon > -1) {
    window.clearTimeout(this.flushingSoon);
    this.flushingSoon = -1;
    this.flush();
  }
};
DOMObserver.prototype.start = function start2() {
  if (this.observer) {
    this.observer.observe(this.view.dom, observeOptions);
  }
  if (useCharData) {
    this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
  }
  this.connectSelection();
};
DOMObserver.prototype.stop = function stop2() {
  var this$1$1 = this;
  if (this.observer) {
    var take = this.observer.takeRecords();
    if (take.length) {
      for (var i2 = 0; i2 < take.length; i2++) {
        this.queue.push(take[i2]);
      }
      window.setTimeout(function() {
        return this$1$1.flush();
      }, 20);
    }
    this.observer.disconnect();
  }
  if (useCharData) {
    this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
  }
  this.disconnectSelection();
};
DOMObserver.prototype.connectSelection = function connectSelection() {
  this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
};
DOMObserver.prototype.disconnectSelection = function disconnectSelection() {
  this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
};
DOMObserver.prototype.suppressSelectionUpdates = function suppressSelectionUpdates() {
  var this$1$1 = this;
  this.suppressingSelectionUpdates = true;
  setTimeout(function() {
    return this$1$1.suppressingSelectionUpdates = false;
  }, 50);
};
DOMObserver.prototype.onSelectionChange = function onSelectionChange() {
  if (!hasFocusAndSelection(this.view)) {
    return;
  }
  if (this.suppressingSelectionUpdates) {
    return selectionToDOM(this.view);
  }
  if (result.ie && result.ie_version <= 11 && !this.view.state.selection.empty) {
    var sel = this.view.root.getSelection();
    if (sel.focusNode && isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) {
      return this.flushSoon();
    }
  }
  this.flush();
};
DOMObserver.prototype.setCurSelection = function setCurSelection() {
  this.currentSelection.set(this.view.root.getSelection());
};
DOMObserver.prototype.ignoreSelectionChange = function ignoreSelectionChange(sel) {
  if (sel.rangeCount == 0) {
    return true;
  }
  var container = sel.getRangeAt(0).commonAncestorContainer;
  var desc = this.view.docView.nearestDesc(container);
  if (desc && desc.ignoreMutation({ type: "selection", target: container.nodeType == 3 ? container.parentNode : container })) {
    this.setCurSelection();
    return true;
  }
};
DOMObserver.prototype.flush = function flush() {
  if (!this.view.docView || this.flushingSoon > -1) {
    return;
  }
  var mutations = this.observer ? this.observer.takeRecords() : [];
  if (this.queue.length) {
    mutations = this.queue.concat(mutations);
    this.queue.length = 0;
  }
  var sel = this.view.root.getSelection();
  var newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && hasSelection(this.view) && !this.ignoreSelectionChange(sel);
  var from5 = -1, to2 = -1, typeOver = false, added = [];
  if (this.view.editable) {
    for (var i2 = 0; i2 < mutations.length; i2++) {
      var result$1 = this.registerMutation(mutations[i2], added);
      if (result$1) {
        from5 = from5 < 0 ? result$1.from : Math.min(result$1.from, from5);
        to2 = to2 < 0 ? result$1.to : Math.max(result$1.to, to2);
        if (result$1.typeOver) {
          typeOver = true;
        }
      }
    }
  }
  if (result.gecko && added.length > 1) {
    var brs = added.filter(function(n) {
      return n.nodeName == "BR";
    });
    if (brs.length == 2) {
      var a = brs[0];
      var b = brs[1];
      if (a.parentNode && a.parentNode.parentNode == b.parentNode) {
        b.remove();
      } else {
        a.remove();
      }
    }
  }
  if (from5 > -1 || newSel) {
    if (from5 > -1) {
      this.view.docView.markDirty(from5, to2);
      checkCSS(this.view);
    }
    this.handleDOMChange(from5, to2, typeOver, added);
    if (this.view.docView && this.view.docView.dirty) {
      this.view.updateState(this.view.state);
    } else if (!this.currentSelection.eq(sel)) {
      selectionToDOM(this.view);
    }
    this.currentSelection.set(sel);
  }
};
DOMObserver.prototype.registerMutation = function registerMutation(mut, added) {
  if (added.indexOf(mut.target) > -1) {
    return null;
  }
  var desc = this.view.docView.nearestDesc(mut.target);
  if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) {
    return null;
  }
  if (!desc || desc.ignoreMutation(mut)) {
    return null;
  }
  if (mut.type == "childList") {
    for (var i2 = 0; i2 < mut.addedNodes.length; i2++) {
      added.push(mut.addedNodes[i2]);
    }
    if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) {
      return { from: desc.posBefore, to: desc.posAfter };
    }
    var prev = mut.previousSibling, next = mut.nextSibling;
    if (result.ie && result.ie_version <= 11 && mut.addedNodes.length) {
      for (var i$1 = 0; i$1 < mut.addedNodes.length; i$1++) {
        var ref2 = mut.addedNodes[i$1];
        var previousSibling = ref2.previousSibling;
        var nextSibling = ref2.nextSibling;
        if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) {
          prev = previousSibling;
        }
        if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) {
          next = nextSibling;
        }
      }
    }
    var fromOffset = prev && prev.parentNode == mut.target ? domIndex(prev) + 1 : 0;
    var from5 = desc.localPosFromDOM(mut.target, fromOffset, -1);
    var toOffset = next && next.parentNode == mut.target ? domIndex(next) : mut.target.childNodes.length;
    var to2 = desc.localPosFromDOM(mut.target, toOffset, 1);
    return { from: from5, to: to2 };
  } else if (mut.type == "attributes") {
    return { from: desc.posAtStart - desc.border, to: desc.posAtEnd + desc.border };
  } else {
    return {
      from: desc.posAtStart,
      to: desc.posAtEnd,
      typeOver: mut.target.nodeValue == mut.oldValue
    };
  }
};
var cssChecked = false;
function checkCSS(view) {
  if (cssChecked) {
    return;
  }
  cssChecked = true;
  if (getComputedStyle(view.dom).whiteSpace == "normal") {
    console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
  }
}
var handlers = {}, editHandlers = {};
function initInput(view) {
  view.shiftKey = false;
  view.mouseDown = null;
  view.lastKeyCode = null;
  view.lastKeyCodeTime = 0;
  view.lastClick = { time: 0, x: 0, y: 0, type: "" };
  view.lastSelectionOrigin = null;
  view.lastSelectionTime = 0;
  view.lastIOSEnter = 0;
  view.lastIOSEnterFallbackTimeout = null;
  view.lastAndroidDelete = 0;
  view.composing = false;
  view.composingTimeout = null;
  view.compositionNodes = [];
  view.compositionEndedAt = -2e8;
  view.domObserver = new DOMObserver(view, function(from5, to2, typeOver, added) {
    return readDOMChange(view, from5, to2, typeOver, added);
  });
  view.domObserver.start();
  view.domChangeCount = 0;
  view.eventHandlers = /* @__PURE__ */ Object.create(null);
  var loop = function(event2) {
    var handler = handlers[event2];
    view.dom.addEventListener(event2, view.eventHandlers[event2] = function(event3) {
      if (eventBelongsToView(view, event3) && !runCustomHandler(view, event3) && (view.editable || !(event3.type in editHandlers))) {
        handler(view, event3);
      }
    });
  };
  for (var event in handlers)
    loop(event);
  if (result.safari) {
    view.dom.addEventListener("input", function() {
      return null;
    });
  }
  ensureListeners(view);
}
function setSelectionOrigin(view, origin) {
  view.lastSelectionOrigin = origin;
  view.lastSelectionTime = Date.now();
}
function destroyInput(view) {
  view.domObserver.stop();
  for (var type in view.eventHandlers) {
    view.dom.removeEventListener(type, view.eventHandlers[type]);
  }
  clearTimeout(view.composingTimeout);
  clearTimeout(view.lastIOSEnterFallbackTimeout);
}
function ensureListeners(view) {
  view.someProp("handleDOMEvents", function(currentHandlers) {
    for (var type in currentHandlers) {
      if (!view.eventHandlers[type]) {
        view.dom.addEventListener(type, view.eventHandlers[type] = function(event) {
          return runCustomHandler(view, event);
        });
      }
    }
  });
}
function runCustomHandler(view, event) {
  return view.someProp("handleDOMEvents", function(handlers2) {
    var handler = handlers2[event.type];
    return handler ? handler(view, event) || event.defaultPrevented : false;
  });
}
function eventBelongsToView(view, event) {
  if (!event.bubbles) {
    return true;
  }
  if (event.defaultPrevented) {
    return false;
  }
  for (var node4 = event.target; node4 != view.dom; node4 = node4.parentNode) {
    if (!node4 || node4.nodeType == 11 || node4.pmViewDesc && node4.pmViewDesc.stopEvent(event)) {
      return false;
    }
  }
  return true;
}
function dispatchEvent(view, event) {
  if (!runCustomHandler(view, event) && handlers[event.type] && (view.editable || !(event.type in editHandlers))) {
    handlers[event.type](view, event);
  }
}
editHandlers.keydown = function(view, event) {
  view.shiftKey = event.keyCode == 16 || event.shiftKey;
  if (inOrNearComposition(view, event)) {
    return;
  }
  view.lastKeyCode = event.keyCode;
  view.lastKeyCodeTime = Date.now();
  if (result.android && result.chrome && event.keyCode == 13) {
    return;
  }
  if (event.keyCode != 229) {
    view.domObserver.forceFlush();
  }
  if (result.ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
    var now2 = Date.now();
    view.lastIOSEnter = now2;
    view.lastIOSEnterFallbackTimeout = setTimeout(function() {
      if (view.lastIOSEnter == now2) {
        view.someProp("handleKeyDown", function(f) {
          return f(view, keyEvent(13, "Enter"));
        });
        view.lastIOSEnter = 0;
      }
    }, 200);
  } else if (view.someProp("handleKeyDown", function(f) {
    return f(view, event);
  }) || captureKeyDown(view, event)) {
    event.preventDefault();
  } else {
    setSelectionOrigin(view, "key");
  }
};
editHandlers.keyup = function(view, e) {
  if (e.keyCode == 16) {
    view.shiftKey = false;
  }
};
editHandlers.keypress = function(view, event) {
  if (inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || result.mac && event.metaKey) {
    return;
  }
  if (view.someProp("handleKeyPress", function(f) {
    return f(view, event);
  })) {
    event.preventDefault();
    return;
  }
  var sel = view.state.selection;
  if (!(sel instanceof TextSelection) || !sel.$from.sameParent(sel.$to)) {
    var text2 = String.fromCharCode(event.charCode);
    if (!view.someProp("handleTextInput", function(f) {
      return f(view, sel.$from.pos, sel.$to.pos, text2);
    })) {
      view.dispatch(view.state.tr.insertText(text2).scrollIntoView());
    }
    event.preventDefault();
  }
};
function eventCoords(event) {
  return { left: event.clientX, top: event.clientY };
}
function isNear(event, click) {
  var dx = click.x - event.clientX, dy = click.y - event.clientY;
  return dx * dx + dy * dy < 100;
}
function runHandlerOnContext(view, propName, pos, inside, event) {
  if (inside == -1) {
    return false;
  }
  var $pos = view.state.doc.resolve(inside);
  var loop = function(i3) {
    if (view.someProp(propName, function(f) {
      return i3 > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i3), event, true) : f(view, pos, $pos.node(i3), $pos.before(i3), event, false);
    })) {
      return { v: true };
    }
  };
  for (var i2 = $pos.depth + 1; i2 > 0; i2--) {
    var returned = loop(i2);
    if (returned)
      return returned.v;
  }
  return false;
}
function updateSelection(view, selection, origin) {
  if (!view.focused) {
    view.focus();
  }
  var tr = view.state.tr.setSelection(selection);
  if (origin == "pointer") {
    tr.setMeta("pointer", true);
  }
  view.dispatch(tr);
}
function selectClickedLeaf(view, inside) {
  if (inside == -1) {
    return false;
  }
  var $pos = view.state.doc.resolve(inside), node4 = $pos.nodeAfter;
  if (node4 && node4.isAtom && NodeSelection.isSelectable(node4)) {
    updateSelection(view, new NodeSelection($pos), "pointer");
    return true;
  }
  return false;
}
function selectClickedNode(view, inside) {
  if (inside == -1) {
    return false;
  }
  var sel = view.state.selection, selectedNode, selectAt;
  if (sel instanceof NodeSelection) {
    selectedNode = sel.node;
  }
  var $pos = view.state.doc.resolve(inside);
  for (var i2 = $pos.depth + 1; i2 > 0; i2--) {
    var node4 = i2 > $pos.depth ? $pos.nodeAfter : $pos.node(i2);
    if (NodeSelection.isSelectable(node4)) {
      if (selectedNode && sel.$from.depth > 0 && i2 >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) {
        selectAt = $pos.before(sel.$from.depth);
      } else {
        selectAt = $pos.before(i2);
      }
      break;
    }
  }
  if (selectAt != null) {
    updateSelection(view, NodeSelection.create(view.state.doc, selectAt), "pointer");
    return true;
  } else {
    return false;
  }
}
function handleSingleClick(view, pos, inside, event, selectNode) {
  return runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", function(f) {
    return f(view, pos, event);
  }) || (selectNode ? selectClickedNode(view, inside) : selectClickedLeaf(view, inside));
}
function handleDoubleClick(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", function(f) {
    return f(view, pos, event);
  });
}
function handleTripleClick(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", function(f) {
    return f(view, pos, event);
  }) || defaultTripleClick(view, inside, event);
}
function defaultTripleClick(view, inside, event) {
  if (event.button != 0) {
    return false;
  }
  var doc2 = view.state.doc;
  if (inside == -1) {
    if (doc2.inlineContent) {
      updateSelection(view, TextSelection.create(doc2, 0, doc2.content.size), "pointer");
      return true;
    }
    return false;
  }
  var $pos = doc2.resolve(inside);
  for (var i2 = $pos.depth + 1; i2 > 0; i2--) {
    var node4 = i2 > $pos.depth ? $pos.nodeAfter : $pos.node(i2);
    var nodePos = $pos.before(i2);
    if (node4.inlineContent) {
      updateSelection(view, TextSelection.create(doc2, nodePos + 1, nodePos + 1 + node4.content.size), "pointer");
    } else if (NodeSelection.isSelectable(node4)) {
      updateSelection(view, NodeSelection.create(doc2, nodePos), "pointer");
    } else {
      continue;
    }
    return true;
  }
}
function forceDOMFlush(view) {
  return endComposition(view);
}
var selectNodeModifier = result.mac ? "metaKey" : "ctrlKey";
handlers.mousedown = function(view, event) {
  view.shiftKey = event.shiftKey;
  var flushed = forceDOMFlush(view);
  var now2 = Date.now(), type = "singleClick";
  if (now2 - view.lastClick.time < 500 && isNear(event, view.lastClick) && !event[selectNodeModifier]) {
    if (view.lastClick.type == "singleClick") {
      type = "doubleClick";
    } else if (view.lastClick.type == "doubleClick") {
      type = "tripleClick";
    }
  }
  view.lastClick = { time: now2, x: event.clientX, y: event.clientY, type };
  var pos = view.posAtCoords(eventCoords(event));
  if (!pos) {
    return;
  }
  if (type == "singleClick") {
    if (view.mouseDown) {
      view.mouseDown.done();
    }
    view.mouseDown = new MouseDown(view, pos, event, flushed);
  } else if ((type == "doubleClick" ? handleDoubleClick : handleTripleClick)(view, pos.pos, pos.inside, event)) {
    event.preventDefault();
  } else {
    setSelectionOrigin(view, "pointer");
  }
};
var MouseDown = function MouseDown2(view, pos, event, flushed) {
  var this$1$1 = this;
  this.view = view;
  this.startDoc = view.state.doc;
  this.pos = pos;
  this.event = event;
  this.flushed = flushed;
  this.selectNode = event[selectNodeModifier];
  this.allowDefault = event.shiftKey;
  this.delayedSelectionSync = false;
  var targetNode, targetPos;
  if (pos.inside > -1) {
    targetNode = view.state.doc.nodeAt(pos.inside);
    targetPos = pos.inside;
  } else {
    var $pos = view.state.doc.resolve(pos.pos);
    targetNode = $pos.parent;
    targetPos = $pos.depth ? $pos.before() : 0;
  }
  this.mightDrag = null;
  var target = flushed ? null : event.target;
  var targetDesc = target ? view.docView.nearestDesc(target, true) : null;
  this.target = targetDesc ? targetDesc.dom : null;
  var ref2 = view.state;
  var selection = ref2.selection;
  if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof NodeSelection && selection.from <= targetPos && selection.to > targetPos) {
    this.mightDrag = {
      node: targetNode,
      pos: targetPos,
      addAttr: this.target && !this.target.draggable,
      setUneditable: this.target && result.gecko && !this.target.hasAttribute("contentEditable")
    };
  }
  if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
    this.view.domObserver.stop();
    if (this.mightDrag.addAttr) {
      this.target.draggable = true;
    }
    if (this.mightDrag.setUneditable) {
      setTimeout(function() {
        if (this$1$1.view.mouseDown == this$1$1) {
          this$1$1.target.setAttribute("contentEditable", "false");
        }
      }, 20);
    }
    this.view.domObserver.start();
  }
  view.root.addEventListener("mouseup", this.up = this.up.bind(this));
  view.root.addEventListener("mousemove", this.move = this.move.bind(this));
  setSelectionOrigin(view, "pointer");
};
MouseDown.prototype.done = function done() {
  var this$1$1 = this;
  this.view.root.removeEventListener("mouseup", this.up);
  this.view.root.removeEventListener("mousemove", this.move);
  if (this.mightDrag && this.target) {
    this.view.domObserver.stop();
    if (this.mightDrag.addAttr) {
      this.target.removeAttribute("draggable");
    }
    if (this.mightDrag.setUneditable) {
      this.target.removeAttribute("contentEditable");
    }
    this.view.domObserver.start();
  }
  if (this.delayedSelectionSync) {
    setTimeout(function() {
      return selectionToDOM(this$1$1.view);
    });
  }
  this.view.mouseDown = null;
};
MouseDown.prototype.up = function up(event) {
  this.done();
  if (!this.view.dom.contains(event.target.nodeType == 3 ? event.target.parentNode : event.target)) {
    return;
  }
  var pos = this.pos;
  if (this.view.state.doc != this.startDoc) {
    pos = this.view.posAtCoords(eventCoords(event));
  }
  if (this.allowDefault || !pos) {
    setSelectionOrigin(this.view, "pointer");
  } else if (handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) {
    event.preventDefault();
  } else if (event.button == 0 && (this.flushed || result.safari && this.mightDrag && !this.mightDrag.node.isAtom || result.chrome && !(this.view.state.selection instanceof TextSelection) && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
    updateSelection(this.view, Selection.near(this.view.state.doc.resolve(pos.pos)), "pointer");
    event.preventDefault();
  } else {
    setSelectionOrigin(this.view, "pointer");
  }
};
MouseDown.prototype.move = function move(event) {
  if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) {
    this.allowDefault = true;
  }
  setSelectionOrigin(this.view, "pointer");
  if (event.buttons == 0) {
    this.done();
  }
};
handlers.touchdown = function(view) {
  forceDOMFlush(view);
  setSelectionOrigin(view, "pointer");
};
handlers.contextmenu = function(view) {
  return forceDOMFlush(view);
};
function inOrNearComposition(view, event) {
  if (view.composing) {
    return true;
  }
  if (result.safari && Math.abs(event.timeStamp - view.compositionEndedAt) < 500) {
    view.compositionEndedAt = -2e8;
    return true;
  }
  return false;
}
var timeoutComposition = result.android ? 5e3 : -1;
editHandlers.compositionstart = editHandlers.compositionupdate = function(view) {
  if (!view.composing) {
    view.domObserver.flush();
    var state = view.state;
    var $pos = state.selection.$from;
    if (state.selection.empty && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some(function(m) {
      return m.type.spec.inclusive === false;
    }))) {
      view.markCursor = view.state.storedMarks || $pos.marks();
      endComposition(view, true);
      view.markCursor = null;
    } else {
      endComposition(view);
      if (result.gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
        var sel = view.root.getSelection();
        for (var node4 = sel.focusNode, offset3 = sel.focusOffset; node4 && node4.nodeType == 1 && offset3 != 0; ) {
          var before2 = offset3 < 0 ? node4.lastChild : node4.childNodes[offset3 - 1];
          if (!before2) {
            break;
          }
          if (before2.nodeType == 3) {
            sel.collapse(before2, before2.nodeValue.length);
            break;
          } else {
            node4 = before2;
            offset3 = -1;
          }
        }
      }
    }
    view.composing = true;
  }
  scheduleComposeEnd(view, timeoutComposition);
};
editHandlers.compositionend = function(view, event) {
  if (view.composing) {
    view.composing = false;
    view.compositionEndedAt = event.timeStamp;
    scheduleComposeEnd(view, 20);
  }
};
function scheduleComposeEnd(view, delay) {
  clearTimeout(view.composingTimeout);
  if (delay > -1) {
    view.composingTimeout = setTimeout(function() {
      return endComposition(view);
    }, delay);
  }
}
function clearComposition(view) {
  if (view.composing) {
    view.composing = false;
    view.compositionEndedAt = timestampFromCustomEvent();
  }
  while (view.compositionNodes.length > 0) {
    view.compositionNodes.pop().markParentsDirty();
  }
}
function timestampFromCustomEvent() {
  var event = document.createEvent("Event");
  event.initEvent("event", true, true);
  return event.timeStamp;
}
function endComposition(view, forceUpdate) {
  if (result.android && view.domObserver.flushingSoon >= 0) {
    return;
  }
  view.domObserver.forceFlush();
  clearComposition(view);
  if (forceUpdate || view.docView && view.docView.dirty) {
    var sel = selectionFromDOM(view);
    if (sel && !sel.eq(view.state.selection)) {
      view.dispatch(view.state.tr.setSelection(sel));
    } else {
      view.updateState(view.state);
    }
    return true;
  }
  return false;
}
function captureCopy(view, dom) {
  if (!view.dom.parentNode) {
    return;
  }
  var wrap = view.dom.parentNode.appendChild(document.createElement("div"));
  wrap.appendChild(dom);
  wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
  var sel = getSelection(), range2 = document.createRange();
  range2.selectNodeContents(dom);
  view.dom.blur();
  sel.removeAllRanges();
  sel.addRange(range2);
  setTimeout(function() {
    if (wrap.parentNode) {
      wrap.parentNode.removeChild(wrap);
    }
    view.focus();
  }, 50);
}
var brokenClipboardAPI = result.ie && result.ie_version < 15 || result.ios && result.webkit_version < 604;
handlers.copy = editHandlers.cut = function(view, e) {
  var sel = view.state.selection, cut3 = e.type == "cut";
  if (sel.empty) {
    return;
  }
  var data = brokenClipboardAPI ? null : e.clipboardData;
  var slice4 = sel.content();
  var ref2 = serializeForClipboard(view, slice4);
  var dom = ref2.dom;
  var text2 = ref2.text;
  if (data) {
    e.preventDefault();
    data.clearData();
    data.setData("text/html", dom.innerHTML);
    data.setData("text/plain", text2);
  } else {
    captureCopy(view, dom);
  }
  if (cut3) {
    view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
  }
};
function sliceSingleNode(slice4) {
  return slice4.openStart == 0 && slice4.openEnd == 0 && slice4.content.childCount == 1 ? slice4.content.firstChild : null;
}
function capturePaste(view, e) {
  if (!view.dom.parentNode) {
    return;
  }
  var plainText = view.shiftKey || view.state.selection.$from.parent.type.spec.code;
  var target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
  if (!plainText) {
    target.contentEditable = "true";
  }
  target.style.cssText = "position: fixed; left: -10000px; top: 10px";
  target.focus();
  setTimeout(function() {
    view.focus();
    if (target.parentNode) {
      target.parentNode.removeChild(target);
    }
    if (plainText) {
      doPaste(view, target.value, null, e);
    } else {
      doPaste(view, target.textContent, target.innerHTML, e);
    }
  }, 50);
}
function doPaste(view, text2, html, e) {
  var slice4 = parseFromClipboard(view, text2, html, view.shiftKey, view.state.selection.$from);
  if (view.someProp("handlePaste", function(f) {
    return f(view, e, slice4 || Slice.empty);
  })) {
    return true;
  }
  if (!slice4) {
    return false;
  }
  var singleNode = sliceSingleNode(slice4);
  var tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, view.shiftKey) : view.state.tr.replaceSelection(slice4);
  view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
  return true;
}
editHandlers.paste = function(view, e) {
  if (view.composing && !result.android) {
    return;
  }
  var data = brokenClipboardAPI ? null : e.clipboardData;
  if (data && doPaste(view, data.getData("text/plain"), data.getData("text/html"), e)) {
    e.preventDefault();
  } else {
    capturePaste(view, e);
  }
};
var Dragging = function Dragging2(slice4, move2) {
  this.slice = slice4;
  this.move = move2;
};
var dragCopyModifier = result.mac ? "altKey" : "ctrlKey";
handlers.dragstart = function(view, e) {
  var mouseDown = view.mouseDown;
  if (mouseDown) {
    mouseDown.done();
  }
  if (!e.dataTransfer) {
    return;
  }
  var sel = view.state.selection;
  var pos = sel.empty ? null : view.posAtCoords(eventCoords(e));
  if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof NodeSelection ? sel.to - 1 : sel.to))
    ;
  else if (mouseDown && mouseDown.mightDrag) {
    view.dispatch(view.state.tr.setSelection(NodeSelection.create(view.state.doc, mouseDown.mightDrag.pos)));
  } else if (e.target && e.target.nodeType == 1) {
    var desc = view.docView.nearestDesc(e.target, true);
    if (desc && desc.node.type.spec.draggable && desc != view.docView) {
      view.dispatch(view.state.tr.setSelection(NodeSelection.create(view.state.doc, desc.posBefore)));
    }
  }
  var slice4 = view.state.selection.content();
  var ref2 = serializeForClipboard(view, slice4);
  var dom = ref2.dom;
  var text2 = ref2.text;
  e.dataTransfer.clearData();
  e.dataTransfer.setData(brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
  e.dataTransfer.effectAllowed = "copyMove";
  if (!brokenClipboardAPI) {
    e.dataTransfer.setData("text/plain", text2);
  }
  view.dragging = new Dragging(slice4, !e[dragCopyModifier]);
};
handlers.dragend = function(view) {
  var dragging = view.dragging;
  window.setTimeout(function() {
    if (view.dragging == dragging) {
      view.dragging = null;
    }
  }, 50);
};
editHandlers.dragover = editHandlers.dragenter = function(_, e) {
  return e.preventDefault();
};
editHandlers.drop = function(view, e) {
  var dragging = view.dragging;
  view.dragging = null;
  if (!e.dataTransfer) {
    return;
  }
  var eventPos = view.posAtCoords(eventCoords(e));
  if (!eventPos) {
    return;
  }
  var $mouse = view.state.doc.resolve(eventPos.pos);
  if (!$mouse) {
    return;
  }
  var slice4 = dragging && dragging.slice;
  if (slice4) {
    view.someProp("transformPasted", function(f) {
      slice4 = f(slice4);
    });
  } else {
    slice4 = parseFromClipboard(view, e.dataTransfer.getData(brokenClipboardAPI ? "Text" : "text/plain"), brokenClipboardAPI ? null : e.dataTransfer.getData("text/html"), false, $mouse);
  }
  var move2 = dragging && !e[dragCopyModifier];
  if (view.someProp("handleDrop", function(f) {
    return f(view, e, slice4 || Slice.empty, move2);
  })) {
    e.preventDefault();
    return;
  }
  if (!slice4) {
    return;
  }
  e.preventDefault();
  var insertPos = slice4 ? dropPoint(view.state.doc, $mouse.pos, slice4) : $mouse.pos;
  if (insertPos == null) {
    insertPos = $mouse.pos;
  }
  var tr = view.state.tr;
  if (move2) {
    tr.deleteSelection();
  }
  var pos = tr.mapping.map(insertPos);
  var isNode = slice4.openStart == 0 && slice4.openEnd == 0 && slice4.content.childCount == 1;
  var beforeInsert = tr.doc;
  if (isNode) {
    tr.replaceRangeWith(pos, pos, slice4.content.firstChild);
  } else {
    tr.replaceRange(pos, pos, slice4);
  }
  if (tr.doc.eq(beforeInsert)) {
    return;
  }
  var $pos = tr.doc.resolve(pos);
  if (isNode && NodeSelection.isSelectable(slice4.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice4.content.firstChild)) {
    tr.setSelection(new NodeSelection($pos));
  } else {
    var end2 = tr.mapping.map(insertPos);
    tr.mapping.maps[tr.mapping.maps.length - 1].forEach(function(_from, _to, _newFrom, newTo) {
      return end2 = newTo;
    });
    tr.setSelection(selectionBetween(view, $pos, tr.doc.resolve(end2)));
  }
  view.focus();
  view.dispatch(tr.setMeta("uiEvent", "drop"));
};
handlers.focus = function(view) {
  if (!view.focused) {
    view.domObserver.stop();
    view.dom.classList.add("ProseMirror-focused");
    view.domObserver.start();
    view.focused = true;
    setTimeout(function() {
      if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.root.getSelection())) {
        selectionToDOM(view);
      }
    }, 20);
  }
};
handlers.blur = function(view, e) {
  if (view.focused) {
    view.domObserver.stop();
    view.dom.classList.remove("ProseMirror-focused");
    view.domObserver.start();
    if (e.relatedTarget && view.dom.contains(e.relatedTarget)) {
      view.domObserver.currentSelection.set({});
    }
    view.focused = false;
  }
};
handlers.beforeinput = function(view, event) {
  if (result.chrome && result.android && event.inputType == "deleteContentBackward") {
    view.domObserver.flushSoon();
    var domChangeCount = view.domChangeCount;
    setTimeout(function() {
      if (view.domChangeCount != domChangeCount) {
        return;
      }
      view.dom.blur();
      view.focus();
      if (view.someProp("handleKeyDown", function(f) {
        return f(view, keyEvent(8, "Backspace"));
      })) {
        return;
      }
      var ref2 = view.state.selection;
      var $cursor = ref2.$cursor;
      if ($cursor && $cursor.pos > 0) {
        view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
      }
    }, 50);
  }
};
for (var prop in editHandlers) {
  handlers[prop] = editHandlers[prop];
}
function compareObjs(a, b) {
  if (a == b) {
    return true;
  }
  for (var p in a) {
    if (a[p] !== b[p]) {
      return false;
    }
  }
  for (var p$1 in b) {
    if (!(p$1 in a)) {
      return false;
    }
  }
  return true;
}
var WidgetType = function WidgetType2(toDOM, spec) {
  this.spec = spec || noSpec;
  this.side = this.spec.side || 0;
  this.toDOM = toDOM;
};
WidgetType.prototype.map = function map8(mapping, span, offset3, oldOffset) {
  var ref2 = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
  var pos = ref2.pos;
  var deleted = ref2.deleted;
  return deleted ? null : new Decoration(pos - offset3, pos - offset3, this);
};
WidgetType.prototype.valid = function valid() {
  return true;
};
WidgetType.prototype.eq = function eq6(other) {
  return this == other || other instanceof WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && compareObjs(this.spec, other.spec));
};
WidgetType.prototype.destroy = function destroy2(node4) {
  if (this.spec.destroy) {
    this.spec.destroy(node4);
  }
};
var InlineType = function InlineType2(attrs, spec) {
  this.spec = spec || noSpec;
  this.attrs = attrs;
};
InlineType.prototype.map = function map9(mapping, span, offset3, oldOffset) {
  var from5 = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset3;
  var to2 = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset3;
  return from5 >= to2 ? null : new Decoration(from5, to2, this);
};
InlineType.prototype.valid = function valid2(_, span) {
  return span.from < span.to;
};
InlineType.prototype.eq = function eq7(other) {
  return this == other || other instanceof InlineType && compareObjs(this.attrs, other.attrs) && compareObjs(this.spec, other.spec);
};
InlineType.is = function is(span) {
  return span.type instanceof InlineType;
};
var NodeType2 = function NodeType3(attrs, spec) {
  this.spec = spec || noSpec;
  this.attrs = attrs;
};
NodeType2.prototype.map = function map10(mapping, span, offset3, oldOffset) {
  var from5 = mapping.mapResult(span.from + oldOffset, 1);
  if (from5.deleted) {
    return null;
  }
  var to2 = mapping.mapResult(span.to + oldOffset, -1);
  if (to2.deleted || to2.pos <= from5.pos) {
    return null;
  }
  return new Decoration(from5.pos - offset3, to2.pos - offset3, this);
};
NodeType2.prototype.valid = function valid3(node4, span) {
  var ref2 = node4.content.findIndex(span.from);
  var index3 = ref2.index;
  var offset3 = ref2.offset;
  var child3;
  return offset3 == span.from && !(child3 = node4.child(index3)).isText && offset3 + child3.nodeSize == span.to;
};
NodeType2.prototype.eq = function eq8(other) {
  return this == other || other instanceof NodeType2 && compareObjs(this.attrs, other.attrs) && compareObjs(this.spec, other.spec);
};
var Decoration = function Decoration2(from5, to2, type) {
  this.from = from5;
  this.to = to2;
  this.type = type;
};
var prototypeAccessors$1 = { spec: { configurable: true }, inline: { configurable: true } };
Decoration.prototype.copy = function copy4(from5, to2) {
  return new Decoration(from5, to2, this.type);
};
Decoration.prototype.eq = function eq9(other, offset3) {
  if (offset3 === void 0)
    offset3 = 0;
  return this.type.eq(other.type) && this.from + offset3 == other.from && this.to + offset3 == other.to;
};
Decoration.prototype.map = function map11(mapping, offset3, oldOffset) {
  return this.type.map(mapping, this, offset3, oldOffset);
};
Decoration.widget = function widget(pos, toDOM, spec) {
  return new Decoration(pos, pos, new WidgetType(toDOM, spec));
};
Decoration.inline = function inline(from5, to2, attrs, spec) {
  return new Decoration(from5, to2, new InlineType(attrs, spec));
};
Decoration.node = function node3(from5, to2, attrs, spec) {
  return new Decoration(from5, to2, new NodeType2(attrs, spec));
};
prototypeAccessors$1.spec.get = function() {
  return this.type.spec;
};
prototypeAccessors$1.inline.get = function() {
  return this.type instanceof InlineType;
};
Object.defineProperties(Decoration.prototype, prototypeAccessors$1);
var none = [], noSpec = {};
var DecorationSet = function DecorationSet2(local, children) {
  this.local = local && local.length ? local : none;
  this.children = children && children.length ? children : none;
};
DecorationSet.create = function create4(doc2, decorations) {
  return decorations.length ? buildTree(decorations, doc2, 0, noSpec) : empty;
};
DecorationSet.prototype.find = function find(start3, end2, predicate) {
  var result2 = [];
  this.findInner(start3 == null ? 0 : start3, end2 == null ? 1e9 : end2, result2, 0, predicate);
  return result2;
};
DecorationSet.prototype.findInner = function findInner(start3, end2, result2, offset3, predicate) {
  for (var i2 = 0; i2 < this.local.length; i2++) {
    var span = this.local[i2];
    if (span.from <= end2 && span.to >= start3 && (!predicate || predicate(span.spec))) {
      result2.push(span.copy(span.from + offset3, span.to + offset3));
    }
  }
  for (var i$1 = 0; i$1 < this.children.length; i$1 += 3) {
    if (this.children[i$1] < end2 && this.children[i$1 + 1] > start3) {
      var childOff = this.children[i$1] + 1;
      this.children[i$1 + 2].findInner(start3 - childOff, end2 - childOff, result2, offset3 + childOff, predicate);
    }
  }
};
DecorationSet.prototype.map = function map12(mapping, doc2, options) {
  if (this == empty || mapping.maps.length == 0) {
    return this;
  }
  return this.mapInner(mapping, doc2, 0, 0, options || noSpec);
};
DecorationSet.prototype.mapInner = function mapInner(mapping, node4, offset3, oldOffset, options) {
  var newLocal;
  for (var i2 = 0; i2 < this.local.length; i2++) {
    var mapped = this.local[i2].map(mapping, offset3, oldOffset);
    if (mapped && mapped.type.valid(node4, mapped)) {
      (newLocal || (newLocal = [])).push(mapped);
    } else if (options.onRemove) {
      options.onRemove(this.local[i2].spec);
    }
  }
  if (this.children.length) {
    return mapChildren(this.children, newLocal, mapping, node4, offset3, oldOffset, options);
  } else {
    return newLocal ? new DecorationSet(newLocal.sort(byPos)) : empty;
  }
};
DecorationSet.prototype.add = function add(doc2, decorations) {
  if (!decorations.length) {
    return this;
  }
  if (this == empty) {
    return DecorationSet.create(doc2, decorations);
  }
  return this.addInner(doc2, decorations, 0);
};
DecorationSet.prototype.addInner = function addInner(doc2, decorations, offset3) {
  var this$1$1 = this;
  var children, childIndex = 0;
  doc2.forEach(function(childNode, childOffset) {
    var baseOffset = childOffset + offset3, found2;
    if (!(found2 = takeSpansForNode(decorations, childNode, baseOffset))) {
      return;
    }
    if (!children) {
      children = this$1$1.children.slice();
    }
    while (childIndex < children.length && children[childIndex] < childOffset) {
      childIndex += 3;
    }
    if (children[childIndex] == childOffset) {
      children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found2, baseOffset + 1);
    } else {
      children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, buildTree(found2, childNode, baseOffset + 1, noSpec));
    }
    childIndex += 3;
  });
  var local = moveSpans(childIndex ? withoutNulls(decorations) : decorations, -offset3);
  for (var i2 = 0; i2 < local.length; i2++) {
    if (!local[i2].type.valid(doc2, local[i2])) {
      local.splice(i2--, 1);
    }
  }
  return new DecorationSet(local.length ? this.local.concat(local).sort(byPos) : this.local, children || this.children);
};
DecorationSet.prototype.remove = function remove(decorations) {
  if (decorations.length == 0 || this == empty) {
    return this;
  }
  return this.removeInner(decorations, 0);
};
DecorationSet.prototype.removeInner = function removeInner(decorations, offset3) {
  var children = this.children, local = this.local;
  for (var i2 = 0; i2 < children.length; i2 += 3) {
    var found2 = void 0, from5 = children[i2] + offset3, to2 = children[i2 + 1] + offset3;
    for (var j = 0, span = void 0; j < decorations.length; j++) {
      if (span = decorations[j]) {
        if (span.from > from5 && span.to < to2) {
          decorations[j] = null;
          (found2 || (found2 = [])).push(span);
        }
      }
    }
    if (!found2) {
      continue;
    }
    if (children == this.children) {
      children = this.children.slice();
    }
    var removed = children[i2 + 2].removeInner(found2, from5 + 1);
    if (removed != empty) {
      children[i2 + 2] = removed;
    } else {
      children.splice(i2, 3);
      i2 -= 3;
    }
  }
  if (local.length) {
    for (var i$1 = 0, span$1 = void 0; i$1 < decorations.length; i$1++) {
      if (span$1 = decorations[i$1]) {
        for (var j$1 = 0; j$1 < local.length; j$1++) {
          if (local[j$1].eq(span$1, offset3)) {
            if (local == this.local) {
              local = this.local.slice();
            }
            local.splice(j$1--, 1);
          }
        }
      }
    }
  }
  if (children == this.children && local == this.local) {
    return this;
  }
  return local.length || children.length ? new DecorationSet(local, children) : empty;
};
DecorationSet.prototype.forChild = function forChild(offset3, node4) {
  if (this == empty) {
    return this;
  }
  if (node4.isLeaf) {
    return DecorationSet.empty;
  }
  var child3, local;
  for (var i2 = 0; i2 < this.children.length; i2 += 3) {
    if (this.children[i2] >= offset3) {
      if (this.children[i2] == offset3) {
        child3 = this.children[i2 + 2];
      }
      break;
    }
  }
  var start3 = offset3 + 1, end2 = start3 + node4.content.size;
  for (var i$1 = 0; i$1 < this.local.length; i$1++) {
    var dec = this.local[i$1];
    if (dec.from < end2 && dec.to > start3 && dec.type instanceof InlineType) {
      var from5 = Math.max(start3, dec.from) - start3, to2 = Math.min(end2, dec.to) - start3;
      if (from5 < to2) {
        (local || (local = [])).push(dec.copy(from5, to2));
      }
    }
  }
  if (local) {
    var localSet = new DecorationSet(local.sort(byPos));
    return child3 ? new DecorationGroup([localSet, child3]) : localSet;
  }
  return child3 || empty;
};
DecorationSet.prototype.eq = function eq10(other) {
  if (this == other) {
    return true;
  }
  if (!(other instanceof DecorationSet) || this.local.length != other.local.length || this.children.length != other.children.length) {
    return false;
  }
  for (var i2 = 0; i2 < this.local.length; i2++) {
    if (!this.local[i2].eq(other.local[i2])) {
      return false;
    }
  }
  for (var i$1 = 0; i$1 < this.children.length; i$1 += 3) {
    if (this.children[i$1] != other.children[i$1] || this.children[i$1 + 1] != other.children[i$1 + 1] || !this.children[i$1 + 2].eq(other.children[i$1 + 2])) {
      return false;
    }
  }
  return true;
};
DecorationSet.prototype.locals = function locals(node4) {
  return removeOverlap(this.localsInner(node4));
};
DecorationSet.prototype.localsInner = function localsInner(node4) {
  if (this == empty) {
    return none;
  }
  if (node4.inlineContent || !this.local.some(InlineType.is)) {
    return this.local;
  }
  var result2 = [];
  for (var i2 = 0; i2 < this.local.length; i2++) {
    if (!(this.local[i2].type instanceof InlineType)) {
      result2.push(this.local[i2]);
    }
  }
  return result2;
};
var empty = new DecorationSet();
DecorationSet.empty = empty;
DecorationSet.removeOverlap = removeOverlap;
var DecorationGroup = function DecorationGroup2(members) {
  this.members = members;
};
DecorationGroup.prototype.map = function map13(mapping, doc2) {
  var mappedDecos = this.members.map(function(member) {
    return member.map(mapping, doc2, noSpec);
  });
  return DecorationGroup.from(mappedDecos);
};
DecorationGroup.prototype.forChild = function forChild2(offset3, child3) {
  if (child3.isLeaf) {
    return DecorationSet.empty;
  }
  var found2 = [];
  for (var i2 = 0; i2 < this.members.length; i2++) {
    var result2 = this.members[i2].forChild(offset3, child3);
    if (result2 == empty) {
      continue;
    }
    if (result2 instanceof DecorationGroup) {
      found2 = found2.concat(result2.members);
    } else {
      found2.push(result2);
    }
  }
  return DecorationGroup.from(found2);
};
DecorationGroup.prototype.eq = function eq11(other) {
  if (!(other instanceof DecorationGroup) || other.members.length != this.members.length) {
    return false;
  }
  for (var i2 = 0; i2 < this.members.length; i2++) {
    if (!this.members[i2].eq(other.members[i2])) {
      return false;
    }
  }
  return true;
};
DecorationGroup.prototype.locals = function locals2(node4) {
  var result2, sorted = true;
  for (var i2 = 0; i2 < this.members.length; i2++) {
    var locals3 = this.members[i2].localsInner(node4);
    if (!locals3.length) {
      continue;
    }
    if (!result2) {
      result2 = locals3;
    } else {
      if (sorted) {
        result2 = result2.slice();
        sorted = false;
      }
      for (var j = 0; j < locals3.length; j++) {
        result2.push(locals3[j]);
      }
    }
  }
  return result2 ? removeOverlap(sorted ? result2 : result2.sort(byPos)) : none;
};
DecorationGroup.from = function from3(members) {
  switch (members.length) {
    case 0:
      return empty;
    case 1:
      return members[0];
    default:
      return new DecorationGroup(members);
  }
};
function mapChildren(oldChildren, newLocal, mapping, node4, offset3, oldOffset, options) {
  var children = oldChildren.slice();
  var shift2 = function(oldStart, oldEnd, newStart, newEnd) {
    for (var i3 = 0; i3 < children.length; i3 += 3) {
      var end2 = children[i3 + 1], dSize = void 0;
      if (end2 == -1 || oldStart > end2 + oldOffset) {
        continue;
      }
      if (oldEnd >= children[i3] + oldOffset) {
        children[i3 + 1] = -1;
      } else if (newStart >= offset3 && (dSize = newEnd - newStart - (oldEnd - oldStart))) {
        children[i3] += dSize;
        children[i3 + 1] += dSize;
      }
    }
  };
  for (var i2 = 0; i2 < mapping.maps.length; i2++) {
    mapping.maps[i2].forEach(shift2);
  }
  var mustRebuild = false;
  for (var i$1 = 0; i$1 < children.length; i$1 += 3) {
    if (children[i$1 + 1] == -1) {
      var from5 = mapping.map(oldChildren[i$1] + oldOffset), fromLocal = from5 - offset3;
      if (fromLocal < 0 || fromLocal >= node4.content.size) {
        mustRebuild = true;
        continue;
      }
      var to2 = mapping.map(oldChildren[i$1 + 1] + oldOffset, -1), toLocal = to2 - offset3;
      var ref2 = node4.content.findIndex(fromLocal);
      var index3 = ref2.index;
      var childOffset = ref2.offset;
      var childNode = node4.maybeChild(index3);
      if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
        var mapped = children[i$1 + 2].mapInner(mapping, childNode, from5 + 1, oldChildren[i$1] + oldOffset + 1, options);
        if (mapped != empty) {
          children[i$1] = fromLocal;
          children[i$1 + 1] = toLocal;
          children[i$1 + 2] = mapped;
        } else {
          children[i$1 + 1] = -2;
          mustRebuild = true;
        }
      } else {
        mustRebuild = true;
      }
    }
  }
  if (mustRebuild) {
    var decorations = mapAndGatherRemainingDecorations(children, oldChildren, newLocal || [], mapping, offset3, oldOffset, options);
    var built = buildTree(decorations, node4, 0, options);
    newLocal = built.local;
    for (var i$2 = 0; i$2 < children.length; i$2 += 3) {
      if (children[i$2 + 1] < 0) {
        children.splice(i$2, 3);
        i$2 -= 3;
      }
    }
    for (var i$3 = 0, j = 0; i$3 < built.children.length; i$3 += 3) {
      var from$1 = built.children[i$3];
      while (j < children.length && children[j] < from$1) {
        j += 3;
      }
      children.splice(j, 0, built.children[i$3], built.children[i$3 + 1], built.children[i$3 + 2]);
    }
  }
  return new DecorationSet(newLocal && newLocal.sort(byPos), children);
}
function moveSpans(spans, offset3) {
  if (!offset3 || !spans.length) {
    return spans;
  }
  var result2 = [];
  for (var i2 = 0; i2 < spans.length; i2++) {
    var span = spans[i2];
    result2.push(new Decoration(span.from + offset3, span.to + offset3, span.type));
  }
  return result2;
}
function mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset3, oldOffset, options) {
  function gather(set3, oldOffset2) {
    for (var i3 = 0; i3 < set3.local.length; i3++) {
      var mapped = set3.local[i3].map(mapping, offset3, oldOffset2);
      if (mapped) {
        decorations.push(mapped);
      } else if (options.onRemove) {
        options.onRemove(set3.local[i3].spec);
      }
    }
    for (var i$1 = 0; i$1 < set3.children.length; i$1 += 3) {
      gather(set3.children[i$1 + 2], set3.children[i$1] + oldOffset2 + 1);
    }
  }
  for (var i2 = 0; i2 < children.length; i2 += 3) {
    if (children[i2 + 1] == -1) {
      gather(children[i2 + 2], oldChildren[i2] + oldOffset + 1);
    }
  }
  return decorations;
}
function takeSpansForNode(spans, node4, offset3) {
  if (node4.isLeaf) {
    return null;
  }
  var end2 = offset3 + node4.nodeSize, found2 = null;
  for (var i2 = 0, span = void 0; i2 < spans.length; i2++) {
    if ((span = spans[i2]) && span.from > offset3 && span.to < end2) {
      (found2 || (found2 = [])).push(span);
      spans[i2] = null;
    }
  }
  return found2;
}
function withoutNulls(array) {
  var result2 = [];
  for (var i2 = 0; i2 < array.length; i2++) {
    if (array[i2] != null) {
      result2.push(array[i2]);
    }
  }
  return result2;
}
function buildTree(spans, node4, offset3, options) {
  var children = [], hasNulls = false;
  node4.forEach(function(childNode, localStart) {
    var found2 = takeSpansForNode(spans, childNode, localStart + offset3);
    if (found2) {
      hasNulls = true;
      var subtree = buildTree(found2, childNode, offset3 + localStart + 1, options);
      if (subtree != empty) {
        children.push(localStart, localStart + childNode.nodeSize, subtree);
      }
    }
  });
  var locals3 = moveSpans(hasNulls ? withoutNulls(spans) : spans, -offset3).sort(byPos);
  for (var i2 = 0; i2 < locals3.length; i2++) {
    if (!locals3[i2].type.valid(node4, locals3[i2])) {
      if (options.onRemove) {
        options.onRemove(locals3[i2].spec);
      }
      locals3.splice(i2--, 1);
    }
  }
  return locals3.length || children.length ? new DecorationSet(locals3, children) : empty;
}
function byPos(a, b) {
  return a.from - b.from || a.to - b.to;
}
function removeOverlap(spans) {
  var working = spans;
  for (var i2 = 0; i2 < working.length - 1; i2++) {
    var span = working[i2];
    if (span.from != span.to) {
      for (var j = i2 + 1; j < working.length; j++) {
        var next = working[j];
        if (next.from == span.from) {
          if (next.to != span.to) {
            if (working == spans) {
              working = spans.slice();
            }
            working[j] = next.copy(next.from, span.to);
            insertAhead(working, j + 1, next.copy(span.to, next.to));
          }
          continue;
        } else {
          if (next.from < span.to) {
            if (working == spans) {
              working = spans.slice();
            }
            working[i2] = span.copy(span.from, next.from);
            insertAhead(working, j, span.copy(next.from, span.to));
          }
          break;
        }
      }
    }
  }
  return working;
}
function insertAhead(array, i2, deco) {
  while (i2 < array.length && byPos(deco, array[i2]) > 0) {
    i2++;
  }
  array.splice(i2, 0, deco);
}
function viewDecorations(view) {
  var found2 = [];
  view.someProp("decorations", function(f) {
    var result2 = f(view.state);
    if (result2 && result2 != empty) {
      found2.push(result2);
    }
  });
  if (view.cursorWrapper) {
    found2.push(DecorationSet.create(view.state.doc, [view.cursorWrapper.deco]));
  }
  return DecorationGroup.from(found2);
}
var EditorView = function EditorView2(place, props) {
  this._props = props;
  this.state = props.state;
  this.directPlugins = props.plugins || [];
  this.directPlugins.forEach(checkStateComponent);
  this.dispatch = this.dispatch.bind(this);
  this._root = null;
  this.focused = false;
  this.trackWrites = null;
  this.dom = place && place.mount || document.createElement("div");
  if (place) {
    if (place.appendChild) {
      place.appendChild(this.dom);
    } else if (place.apply) {
      place(this.dom);
    } else if (place.mount) {
      this.mounted = true;
    }
  }
  this.editable = getEditable(this);
  this.markCursor = null;
  this.cursorWrapper = null;
  updateCursorWrapper(this);
  this.nodeViews = buildNodeViews(this);
  this.docView = docViewDesc(this.state.doc, computeDocDeco(this), viewDecorations(this), this.dom, this);
  this.lastSelectedViewDesc = null;
  this.dragging = null;
  initInput(this);
  this.prevDirectPlugins = [];
  this.pluginViews = [];
  this.updatePluginViews();
};
var prototypeAccessors$2 = { props: { configurable: true }, root: { configurable: true }, isDestroyed: { configurable: true } };
prototypeAccessors$2.props.get = function() {
  if (this._props.state != this.state) {
    var prev = this._props;
    this._props = {};
    for (var name in prev) {
      this._props[name] = prev[name];
    }
    this._props.state = this.state;
  }
  return this._props;
};
EditorView.prototype.update = function update(props) {
  if (props.handleDOMEvents != this._props.handleDOMEvents) {
    ensureListeners(this);
  }
  this._props = props;
  if (props.plugins) {
    props.plugins.forEach(checkStateComponent);
    this.directPlugins = props.plugins;
  }
  this.updateStateInner(props.state, true);
};
EditorView.prototype.setProps = function setProps(props) {
  var updated = {};
  for (var name in this._props) {
    updated[name] = this._props[name];
  }
  updated.state = this.state;
  for (var name$1 in props) {
    updated[name$1] = props[name$1];
  }
  this.update(updated);
};
EditorView.prototype.updateState = function updateState(state) {
  this.updateStateInner(state, this.state.plugins != state.plugins);
};
EditorView.prototype.updateStateInner = function updateStateInner(state, reconfigured) {
  var this$1$1 = this;
  var prev = this.state, redraw = false, updateSel = false;
  if (state.storedMarks && this.composing) {
    clearComposition(this);
    updateSel = true;
  }
  this.state = state;
  if (reconfigured) {
    var nodeViews = buildNodeViews(this);
    if (changedNodeViews(nodeViews, this.nodeViews)) {
      this.nodeViews = nodeViews;
      redraw = true;
    }
    ensureListeners(this);
  }
  this.editable = getEditable(this);
  updateCursorWrapper(this);
  var innerDeco = viewDecorations(this), outerDeco = computeDocDeco(this);
  var scroll = reconfigured ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
  var updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
  if (updateDoc || !state.selection.eq(prev.selection)) {
    updateSel = true;
  }
  var oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && storeScrollPos(this);
  if (updateSel) {
    this.domObserver.stop();
    var forceSelUpdate = updateDoc && (result.ie || result.chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && selectionContextChanged(prev.selection, state.selection);
    if (updateDoc) {
      var chromeKludge = result.chrome ? this.trackWrites = this.root.getSelection().focusNode : null;
      if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
        this.docView.updateOuterDeco([]);
        this.docView.destroy();
        this.docView = docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
      }
      if (chromeKludge && !this.trackWrites) {
        forceSelUpdate = true;
      }
    }
    if (forceSelUpdate || !(this.mouseDown && this.domObserver.currentSelection.eq(this.root.getSelection()) && anchorInRightPlace(this))) {
      selectionToDOM(this, forceSelUpdate);
    } else {
      syncNodeSelection(this, state.selection);
      this.domObserver.setCurSelection();
    }
    this.domObserver.start();
  }
  this.updatePluginViews(prev);
  if (scroll == "reset") {
    this.dom.scrollTop = 0;
  } else if (scroll == "to selection") {
    var startDOM = this.root.getSelection().focusNode;
    if (this.someProp("handleScrollToSelection", function(f) {
      return f(this$1$1);
    }))
      ;
    else if (state.selection instanceof NodeSelection) {
      scrollRectIntoView(this, this.docView.domAfterPos(state.selection.from).getBoundingClientRect(), startDOM);
    } else {
      scrollRectIntoView(this, this.coordsAtPos(state.selection.head, 1), startDOM);
    }
  } else if (oldScrollPos) {
    resetScrollPos(oldScrollPos);
  }
};
EditorView.prototype.destroyPluginViews = function destroyPluginViews() {
  var view;
  while (view = this.pluginViews.pop()) {
    if (view.destroy) {
      view.destroy();
    }
  }
};
EditorView.prototype.updatePluginViews = function updatePluginViews(prevState) {
  if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
    this.prevDirectPlugins = this.directPlugins;
    this.destroyPluginViews();
    for (var i2 = 0; i2 < this.directPlugins.length; i2++) {
      var plugin = this.directPlugins[i2];
      if (plugin.spec.view) {
        this.pluginViews.push(plugin.spec.view(this));
      }
    }
    for (var i$1 = 0; i$1 < this.state.plugins.length; i$1++) {
      var plugin$1 = this.state.plugins[i$1];
      if (plugin$1.spec.view) {
        this.pluginViews.push(plugin$1.spec.view(this));
      }
    }
  } else {
    for (var i$2 = 0; i$2 < this.pluginViews.length; i$2++) {
      var pluginView = this.pluginViews[i$2];
      if (pluginView.update) {
        pluginView.update(this, prevState);
      }
    }
  }
};
EditorView.prototype.someProp = function someProp(propName, f) {
  var prop = this._props && this._props[propName], value;
  if (prop != null && (value = f ? f(prop) : prop)) {
    return value;
  }
  for (var i2 = 0; i2 < this.directPlugins.length; i2++) {
    var prop$1 = this.directPlugins[i2].props[propName];
    if (prop$1 != null && (value = f ? f(prop$1) : prop$1)) {
      return value;
    }
  }
  var plugins = this.state.plugins;
  if (plugins) {
    for (var i$1 = 0; i$1 < plugins.length; i$1++) {
      var prop$2 = plugins[i$1].props[propName];
      if (prop$2 != null && (value = f ? f(prop$2) : prop$2)) {
        return value;
      }
    }
  }
};
EditorView.prototype.hasFocus = function hasFocus() {
  return this.root.activeElement == this.dom;
};
EditorView.prototype.focus = function focus() {
  this.domObserver.stop();
  if (this.editable) {
    focusPreventScroll(this.dom);
  }
  selectionToDOM(this);
  this.domObserver.start();
};
prototypeAccessors$2.root.get = function() {
  var cached = this._root;
  if (cached == null) {
    for (var search2 = this.dom.parentNode; search2; search2 = search2.parentNode) {
      if (search2.nodeType == 9 || search2.nodeType == 11 && search2.host) {
        if (!search2.getSelection) {
          Object.getPrototypeOf(search2).getSelection = function() {
            return document.getSelection();
          };
        }
        return this._root = search2;
      }
    }
  }
  return cached || document;
};
EditorView.prototype.posAtCoords = function posAtCoords$1(coords) {
  return posAtCoords(this, coords);
};
EditorView.prototype.coordsAtPos = function coordsAtPos$1(pos, side) {
  if (side === void 0)
    side = 1;
  return coordsAtPos(this, pos, side);
};
EditorView.prototype.domAtPos = function domAtPos(pos, side) {
  if (side === void 0)
    side = 0;
  return this.docView.domFromPos(pos, side);
};
EditorView.prototype.nodeDOM = function nodeDOM(pos) {
  var desc = this.docView.descAt(pos);
  return desc ? desc.nodeDOM : null;
};
EditorView.prototype.posAtDOM = function posAtDOM(node4, offset3, bias) {
  if (bias === void 0)
    bias = -1;
  var pos = this.docView.posFromDOM(node4, offset3, bias);
  if (pos == null) {
    throw new RangeError("DOM position not inside the editor");
  }
  return pos;
};
EditorView.prototype.endOfTextblock = function endOfTextblock$1(dir, state) {
  return endOfTextblock(this, state || this.state, dir);
};
EditorView.prototype.destroy = function destroy3() {
  if (!this.docView) {
    return;
  }
  destroyInput(this);
  this.destroyPluginViews();
  if (this.mounted) {
    this.docView.update(this.state.doc, [], viewDecorations(this), this);
    this.dom.textContent = "";
  } else if (this.dom.parentNode) {
    this.dom.parentNode.removeChild(this.dom);
  }
  this.docView.destroy();
  this.docView = null;
};
prototypeAccessors$2.isDestroyed.get = function() {
  return this.docView == null;
};
EditorView.prototype.dispatchEvent = function dispatchEvent$1(event) {
  return dispatchEvent(this, event);
};
EditorView.prototype.dispatch = function dispatch(tr) {
  var dispatchTransaction = this._props.dispatchTransaction;
  if (dispatchTransaction) {
    dispatchTransaction.call(this, tr);
  } else {
    this.updateState(this.state.apply(tr));
  }
};
Object.defineProperties(EditorView.prototype, prototypeAccessors$2);
function computeDocDeco(view) {
  var attrs = /* @__PURE__ */ Object.create(null);
  attrs.class = "ProseMirror";
  attrs.contenteditable = String(view.editable);
  attrs.translate = "no";
  view.someProp("attributes", function(value) {
    if (typeof value == "function") {
      value = value(view.state);
    }
    if (value) {
      for (var attr in value) {
        if (attr == "class") {
          attrs.class += " " + value[attr];
        }
        if (attr == "style") {
          attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
        } else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") {
          attrs[attr] = String(value[attr]);
        }
      }
    }
  });
  return [Decoration.node(0, view.state.doc.content.size, attrs)];
}
function updateCursorWrapper(view) {
  if (view.markCursor) {
    var dom = document.createElement("img");
    dom.className = "ProseMirror-separator";
    dom.setAttribute("mark-placeholder", "true");
    view.cursorWrapper = { dom, deco: Decoration.widget(view.state.selection.head, dom, { raw: true, marks: view.markCursor }) };
  } else {
    view.cursorWrapper = null;
  }
}
function getEditable(view) {
  return !view.someProp("editable", function(value) {
    return value(view.state) === false;
  });
}
function selectionContextChanged(sel1, sel2) {
  var depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
  return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function buildNodeViews(view) {
  var result2 = {};
  view.someProp("nodeViews", function(obj) {
    for (var prop in obj) {
      if (!Object.prototype.hasOwnProperty.call(result2, prop)) {
        result2[prop] = obj[prop];
      }
    }
  });
  return result2;
}
function changedNodeViews(a, b) {
  var nA = 0, nB = 0;
  for (var prop in a) {
    if (a[prop] != b[prop]) {
      return true;
    }
    nA++;
  }
  for (var _ in b) {
    nB++;
  }
  return nA != nB;
}
function checkStateComponent(plugin) {
  if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) {
    throw new RangeError("Plugins passed directly to the view must not have a state component");
  }
}
var base = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'",
  229: "q"
};
var shift = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"',
  229: "Q"
};
var chrome = typeof navigator != "undefined" && /Chrome\/(\d+)/.exec(navigator.userAgent);
var safari = typeof navigator != "undefined" && /Apple Computer/.test(navigator.vendor);
var gecko = typeof navigator != "undefined" && /Gecko\/\d+/.test(navigator.userAgent);
var mac$3 = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
var brokenModifierNames = chrome && (mac$3 || +chrome[1] < 57) || gecko && mac$3;
for (var i$1 = 0; i$1 < 10; i$1++)
  base[48 + i$1] = base[96 + i$1] = String(i$1);
for (var i$1 = 1; i$1 <= 24; i$1++)
  base[i$1 + 111] = "F" + i$1;
for (var i$1 = 65; i$1 <= 90; i$1++) {
  base[i$1] = String.fromCharCode(i$1 + 32);
  shift[i$1] = String.fromCharCode(i$1);
}
for (var code in base)
  if (!shift.hasOwnProperty(code))
    shift[code] = base[code];
function keyName(event) {
  var ignoreKey = brokenModifierNames && (event.ctrlKey || event.altKey || event.metaKey) || (safari || ie) && event.shiftKey && event.key && event.key.length == 1;
  var name = !ignoreKey && event.key || (event.shiftKey ? shift : base)[event.keyCode] || event.key || "Unidentified";
  if (name == "Esc")
    name = "Escape";
  if (name == "Del")
    name = "Delete";
  if (name == "Left")
    name = "ArrowLeft";
  if (name == "Up")
    name = "ArrowUp";
  if (name == "Right")
    name = "ArrowRight";
  if (name == "Down")
    name = "ArrowDown";
  return name;
}
var mac$2 = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false;
function normalizeKeyName(name) {
  var parts = name.split(/-(?!$)/), result2 = parts[parts.length - 1];
  if (result2 == "Space") {
    result2 = " ";
  }
  var alt, ctrl, shift2, meta;
  for (var i2 = 0; i2 < parts.length - 1; i2++) {
    var mod2 = parts[i2];
    if (/^(cmd|meta|m)$/i.test(mod2)) {
      meta = true;
    } else if (/^a(lt)?$/i.test(mod2)) {
      alt = true;
    } else if (/^(c|ctrl|control)$/i.test(mod2)) {
      ctrl = true;
    } else if (/^s(hift)?$/i.test(mod2)) {
      shift2 = true;
    } else if (/^mod$/i.test(mod2)) {
      if (mac$2) {
        meta = true;
      } else {
        ctrl = true;
      }
    } else {
      throw new Error("Unrecognized modifier name: " + mod2);
    }
  }
  if (alt) {
    result2 = "Alt-" + result2;
  }
  if (ctrl) {
    result2 = "Ctrl-" + result2;
  }
  if (meta) {
    result2 = "Meta-" + result2;
  }
  if (shift2) {
    result2 = "Shift-" + result2;
  }
  return result2;
}
function normalize(map16) {
  var copy5 = /* @__PURE__ */ Object.create(null);
  for (var prop in map16) {
    copy5[normalizeKeyName(prop)] = map16[prop];
  }
  return copy5;
}
function modifiers(name, event, shift2) {
  if (event.altKey) {
    name = "Alt-" + name;
  }
  if (event.ctrlKey) {
    name = "Ctrl-" + name;
  }
  if (event.metaKey) {
    name = "Meta-" + name;
  }
  if (shift2 !== false && event.shiftKey) {
    name = "Shift-" + name;
  }
  return name;
}
function keymap(bindings) {
  return new Plugin({ props: { handleKeyDown: keydownHandler(bindings) } });
}
function keydownHandler(bindings) {
  var map16 = normalize(bindings);
  return function(view, event) {
    var name = keyName(event), isChar = name.length == 1 && name != " ", baseName;
    var direct = map16[modifiers(name, event, !isChar)];
    if (direct && direct(view.state, view.dispatch, view)) {
      return true;
    }
    if (isChar && (event.shiftKey || event.altKey || event.metaKey || name.charCodeAt(0) > 127) && (baseName = base[event.keyCode]) && baseName != name) {
      var fromCode = map16[modifiers(baseName, event, true)];
      if (fromCode && fromCode(view.state, view.dispatch, view)) {
        return true;
      }
    } else if (isChar && event.shiftKey) {
      var withShift = map16[modifiers(name, event, true)];
      if (withShift && withShift(view.state, view.dispatch, view)) {
        return true;
      }
    }
    return false;
  };
}
var GOOD_LEAF_SIZE = 200;
var RopeSequence = function RopeSequence2() {
};
RopeSequence.prototype.append = function append2(other) {
  if (!other.length) {
    return this;
  }
  other = RopeSequence.from(other);
  return !this.length && other || other.length < GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
RopeSequence.prototype.prepend = function prepend(other) {
  if (!other.length) {
    return this;
  }
  return RopeSequence.from(other).append(this);
};
RopeSequence.prototype.appendInner = function appendInner(other) {
  return new Append(this, other);
};
RopeSequence.prototype.slice = function slice3(from5, to2) {
  if (from5 === void 0)
    from5 = 0;
  if (to2 === void 0)
    to2 = this.length;
  if (from5 >= to2) {
    return RopeSequence.empty;
  }
  return this.sliceInner(Math.max(0, from5), Math.min(this.length, to2));
};
RopeSequence.prototype.get = function get3(i2) {
  if (i2 < 0 || i2 >= this.length) {
    return void 0;
  }
  return this.getInner(i2);
};
RopeSequence.prototype.forEach = function forEach4(f, from5, to2) {
  if (from5 === void 0)
    from5 = 0;
  if (to2 === void 0)
    to2 = this.length;
  if (from5 <= to2) {
    this.forEachInner(f, from5, to2, 0);
  } else {
    this.forEachInvertedInner(f, from5, to2, 0);
  }
};
RopeSequence.prototype.map = function map14(f, from5, to2) {
  if (from5 === void 0)
    from5 = 0;
  if (to2 === void 0)
    to2 = this.length;
  var result2 = [];
  this.forEach(function(elt, i2) {
    return result2.push(f(elt, i2));
  }, from5, to2);
  return result2;
};
RopeSequence.from = function from4(values) {
  if (values instanceof RopeSequence) {
    return values;
  }
  return values && values.length ? new Leaf(values) : RopeSequence.empty;
};
var Leaf = /* @__PURE__ */ function(RopeSequence3) {
  function Leaf2(values) {
    RopeSequence3.call(this);
    this.values = values;
  }
  if (RopeSequence3)
    Leaf2.__proto__ = RopeSequence3;
  Leaf2.prototype = Object.create(RopeSequence3 && RopeSequence3.prototype);
  Leaf2.prototype.constructor = Leaf2;
  var prototypeAccessors2 = { length: { configurable: true }, depth: { configurable: true } };
  Leaf2.prototype.flatten = function flatten() {
    return this.values;
  };
  Leaf2.prototype.sliceInner = function sliceInner(from5, to2) {
    if (from5 == 0 && to2 == this.length) {
      return this;
    }
    return new Leaf2(this.values.slice(from5, to2));
  };
  Leaf2.prototype.getInner = function getInner(i2) {
    return this.values[i2];
  };
  Leaf2.prototype.forEachInner = function forEachInner(f, from5, to2, start3) {
    for (var i2 = from5; i2 < to2; i2++) {
      if (f(this.values[i2], start3 + i2) === false) {
        return false;
      }
    }
  };
  Leaf2.prototype.forEachInvertedInner = function forEachInvertedInner(f, from5, to2, start3) {
    for (var i2 = from5 - 1; i2 >= to2; i2--) {
      if (f(this.values[i2], start3 + i2) === false) {
        return false;
      }
    }
  };
  Leaf2.prototype.leafAppend = function leafAppend(other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE) {
      return new Leaf2(this.values.concat(other.flatten()));
    }
  };
  Leaf2.prototype.leafPrepend = function leafPrepend(other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE) {
      return new Leaf2(other.flatten().concat(this.values));
    }
  };
  prototypeAccessors2.length.get = function() {
    return this.values.length;
  };
  prototypeAccessors2.depth.get = function() {
    return 0;
  };
  Object.defineProperties(Leaf2.prototype, prototypeAccessors2);
  return Leaf2;
}(RopeSequence);
RopeSequence.empty = new Leaf([]);
var Append = /* @__PURE__ */ function(RopeSequence3) {
  function Append2(left, right) {
    RopeSequence3.call(this);
    this.left = left;
    this.right = right;
    this.length = left.length + right.length;
    this.depth = Math.max(left.depth, right.depth) + 1;
  }
  if (RopeSequence3)
    Append2.__proto__ = RopeSequence3;
  Append2.prototype = Object.create(RopeSequence3 && RopeSequence3.prototype);
  Append2.prototype.constructor = Append2;
  Append2.prototype.flatten = function flatten() {
    return this.left.flatten().concat(this.right.flatten());
  };
  Append2.prototype.getInner = function getInner(i2) {
    return i2 < this.left.length ? this.left.get(i2) : this.right.get(i2 - this.left.length);
  };
  Append2.prototype.forEachInner = function forEachInner(f, from5, to2, start3) {
    var leftLen = this.left.length;
    if (from5 < leftLen && this.left.forEachInner(f, from5, Math.min(to2, leftLen), start3) === false) {
      return false;
    }
    if (to2 > leftLen && this.right.forEachInner(f, Math.max(from5 - leftLen, 0), Math.min(this.length, to2) - leftLen, start3 + leftLen) === false) {
      return false;
    }
  };
  Append2.prototype.forEachInvertedInner = function forEachInvertedInner(f, from5, to2, start3) {
    var leftLen = this.left.length;
    if (from5 > leftLen && this.right.forEachInvertedInner(f, from5 - leftLen, Math.max(to2, leftLen) - leftLen, start3 + leftLen) === false) {
      return false;
    }
    if (to2 < leftLen && this.left.forEachInvertedInner(f, Math.min(from5, leftLen), to2, start3) === false) {
      return false;
    }
  };
  Append2.prototype.sliceInner = function sliceInner(from5, to2) {
    if (from5 == 0 && to2 == this.length) {
      return this;
    }
    var leftLen = this.left.length;
    if (to2 <= leftLen) {
      return this.left.slice(from5, to2);
    }
    if (from5 >= leftLen) {
      return this.right.slice(from5 - leftLen, to2 - leftLen);
    }
    return this.left.slice(from5, leftLen).append(this.right.slice(0, to2 - leftLen));
  };
  Append2.prototype.leafAppend = function leafAppend(other) {
    var inner = this.right.leafAppend(other);
    if (inner) {
      return new Append2(this.left, inner);
    }
  };
  Append2.prototype.leafPrepend = function leafPrepend(other) {
    var inner = this.left.leafPrepend(other);
    if (inner) {
      return new Append2(inner, this.right);
    }
  };
  Append2.prototype.appendInner = function appendInner2(other) {
    if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) {
      return new Append2(this.left, new Append2(this.right, other));
    }
    return new Append2(this, other);
  };
  return Append2;
}(RopeSequence);
var ropeSequence = RopeSequence;
var max_empty_items = 500;
var Branch = function Branch2(items, eventCount) {
  this.items = items;
  this.eventCount = eventCount;
};
Branch.prototype.popEvent = function popEvent(state, preserveItems) {
  var this$1$1 = this;
  if (this.eventCount == 0) {
    return null;
  }
  var end2 = this.items.length;
  for (; ; end2--) {
    var next = this.items.get(end2 - 1);
    if (next.selection) {
      --end2;
      break;
    }
  }
  var remap, mapFrom;
  if (preserveItems) {
    remap = this.remapping(end2, this.items.length);
    mapFrom = remap.maps.length;
  }
  var transform = state.tr;
  var selection, remaining;
  var addAfter = [], addBefore = [];
  this.items.forEach(function(item, i2) {
    if (!item.step) {
      if (!remap) {
        remap = this$1$1.remapping(end2, i2 + 1);
        mapFrom = remap.maps.length;
      }
      mapFrom--;
      addBefore.push(item);
      return;
    }
    if (remap) {
      addBefore.push(new Item(item.map));
      var step2 = item.step.map(remap.slice(mapFrom)), map16;
      if (step2 && transform.maybeStep(step2).doc) {
        map16 = transform.mapping.maps[transform.mapping.maps.length - 1];
        addAfter.push(new Item(map16, null, null, addAfter.length + addBefore.length));
      }
      mapFrom--;
      if (map16) {
        remap.appendMap(map16, mapFrom);
      }
    } else {
      transform.maybeStep(item.step);
    }
    if (item.selection) {
      selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
      remaining = new Branch(this$1$1.items.slice(0, end2).append(addBefore.reverse().concat(addAfter)), this$1$1.eventCount - 1);
      return false;
    }
  }, this.items.length, 0);
  return { remaining, transform, selection };
};
Branch.prototype.addTransform = function addTransform(transform, selection, histOptions, preserveItems) {
  var newItems = [], eventCount = this.eventCount;
  var oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
  for (var i2 = 0; i2 < transform.steps.length; i2++) {
    var step2 = transform.steps[i2].invert(transform.docs[i2]);
    var item = new Item(transform.mapping.maps[i2], step2, selection), merged = void 0;
    if (merged = lastItem && lastItem.merge(item)) {
      item = merged;
      if (i2) {
        newItems.pop();
      } else {
        oldItems = oldItems.slice(0, oldItems.length - 1);
      }
    }
    newItems.push(item);
    if (selection) {
      eventCount++;
      selection = null;
    }
    if (!preserveItems) {
      lastItem = item;
    }
  }
  var overflow = eventCount - histOptions.depth;
  if (overflow > DEPTH_OVERFLOW) {
    oldItems = cutOffEvents(oldItems, overflow);
    eventCount -= overflow;
  }
  return new Branch(oldItems.append(newItems), eventCount);
};
Branch.prototype.remapping = function remapping(from5, to2) {
  var maps = new Mapping();
  this.items.forEach(function(item, i2) {
    var mirrorPos = item.mirrorOffset != null && i2 - item.mirrorOffset >= from5 ? maps.maps.length - item.mirrorOffset : null;
    maps.appendMap(item.map, mirrorPos);
  }, from5, to2);
  return maps;
};
Branch.prototype.addMaps = function addMaps(array) {
  if (this.eventCount == 0) {
    return this;
  }
  return new Branch(this.items.append(array.map(function(map16) {
    return new Item(map16);
  })), this.eventCount);
};
Branch.prototype.rebased = function rebased(rebasedTransform, rebasedCount) {
  if (!this.eventCount) {
    return this;
  }
  var rebasedItems = [], start3 = Math.max(0, this.items.length - rebasedCount);
  var mapping = rebasedTransform.mapping;
  var newUntil = rebasedTransform.steps.length;
  var eventCount = this.eventCount;
  this.items.forEach(function(item) {
    if (item.selection) {
      eventCount--;
    }
  }, start3);
  var iRebased = rebasedCount;
  this.items.forEach(function(item) {
    var pos = mapping.getMirror(--iRebased);
    if (pos == null) {
      return;
    }
    newUntil = Math.min(newUntil, pos);
    var map16 = mapping.maps[pos];
    if (item.step) {
      var step2 = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
      var selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
      if (selection) {
        eventCount++;
      }
      rebasedItems.push(new Item(map16, step2, selection));
    } else {
      rebasedItems.push(new Item(map16));
    }
  }, start3);
  var newMaps = [];
  for (var i2 = rebasedCount; i2 < newUntil; i2++) {
    newMaps.push(new Item(mapping.maps[i2]));
  }
  var items = this.items.slice(0, start3).append(newMaps).append(rebasedItems);
  var branch = new Branch(items, eventCount);
  if (branch.emptyItemCount() > max_empty_items) {
    branch = branch.compress(this.items.length - rebasedItems.length);
  }
  return branch;
};
Branch.prototype.emptyItemCount = function emptyItemCount() {
  var count = 0;
  this.items.forEach(function(item) {
    if (!item.step) {
      count++;
    }
  });
  return count;
};
Branch.prototype.compress = function compress(upto) {
  if (upto === void 0)
    upto = this.items.length;
  var remap = this.remapping(0, upto), mapFrom = remap.maps.length;
  var items = [], events2 = 0;
  this.items.forEach(function(item, i2) {
    if (i2 >= upto) {
      items.push(item);
      if (item.selection) {
        events2++;
      }
    } else if (item.step) {
      var step2 = item.step.map(remap.slice(mapFrom)), map16 = step2 && step2.getMap();
      mapFrom--;
      if (map16) {
        remap.appendMap(map16, mapFrom);
      }
      if (step2) {
        var selection = item.selection && item.selection.map(remap.slice(mapFrom));
        if (selection) {
          events2++;
        }
        var newItem = new Item(map16.invert(), step2, selection), merged, last = items.length - 1;
        if (merged = items.length && items[last].merge(newItem)) {
          items[last] = merged;
        } else {
          items.push(newItem);
        }
      }
    } else if (item.map) {
      mapFrom--;
    }
  }, this.items.length, 0);
  return new Branch(ropeSequence.from(items.reverse()), events2);
};
Branch.empty = new Branch(ropeSequence.empty, 0);
function cutOffEvents(items, n) {
  var cutPoint;
  items.forEach(function(item, i2) {
    if (item.selection && n-- == 0) {
      cutPoint = i2;
      return false;
    }
  });
  return items.slice(cutPoint);
}
var Item = function Item2(map16, step2, selection, mirrorOffset) {
  this.map = map16;
  this.step = step2;
  this.selection = selection;
  this.mirrorOffset = mirrorOffset;
};
Item.prototype.merge = function merge2(other) {
  if (this.step && other.step && !other.selection) {
    var step2 = other.step.merge(this.step);
    if (step2) {
      return new Item(step2.getMap().invert(), step2, this.selection);
    }
  }
};
var HistoryState = function HistoryState2(done2, undone, prevRanges, prevTime) {
  this.done = done2;
  this.undone = undone;
  this.prevRanges = prevRanges;
  this.prevTime = prevTime;
};
var DEPTH_OVERFLOW = 20;
function applyTransaction2(history2, state, tr, options) {
  var historyTr = tr.getMeta(historyKey), rebased2;
  if (historyTr) {
    return historyTr.historyState;
  }
  if (tr.getMeta(closeHistoryKey)) {
    history2 = new HistoryState(history2.done, history2.undone, null, 0);
  }
  var appended = tr.getMeta("appendedTransaction");
  if (tr.steps.length == 0) {
    return history2;
  } else if (appended && appended.getMeta(historyKey)) {
    if (appended.getMeta(historyKey).redo) {
      return new HistoryState(history2.done.addTransform(tr, null, options, mustPreserveItems(state)), history2.undone, rangesFor(tr.mapping.maps[tr.steps.length - 1]), history2.prevTime);
    } else {
      return new HistoryState(history2.done, history2.undone.addTransform(tr, null, options, mustPreserveItems(state)), null, history2.prevTime);
    }
  } else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
    var newGroup = history2.prevTime == 0 || !appended && (history2.prevTime < (tr.time || 0) - options.newGroupDelay || !isAdjacentTo(tr, history2.prevRanges));
    var prevRanges = appended ? mapRanges(history2.prevRanges, tr.mapping) : rangesFor(tr.mapping.maps[tr.steps.length - 1]);
    return new HistoryState(history2.done.addTransform(tr, newGroup ? state.selection.getBookmark() : null, options, mustPreserveItems(state)), Branch.empty, prevRanges, tr.time);
  } else if (rebased2 = tr.getMeta("rebased")) {
    return new HistoryState(history2.done.rebased(tr, rebased2), history2.undone.rebased(tr, rebased2), mapRanges(history2.prevRanges, tr.mapping), history2.prevTime);
  } else {
    return new HistoryState(history2.done.addMaps(tr.mapping.maps), history2.undone.addMaps(tr.mapping.maps), mapRanges(history2.prevRanges, tr.mapping), history2.prevTime);
  }
}
function isAdjacentTo(transform, prevRanges) {
  if (!prevRanges) {
    return false;
  }
  if (!transform.docChanged) {
    return true;
  }
  var adjacent = false;
  transform.mapping.maps[0].forEach(function(start3, end2) {
    for (var i2 = 0; i2 < prevRanges.length; i2 += 2) {
      if (start3 <= prevRanges[i2 + 1] && end2 >= prevRanges[i2]) {
        adjacent = true;
      }
    }
  });
  return adjacent;
}
function rangesFor(map16) {
  var result2 = [];
  map16.forEach(function(_from, _to, from5, to2) {
    return result2.push(from5, to2);
  });
  return result2;
}
function mapRanges(ranges, mapping) {
  if (!ranges) {
    return null;
  }
  var result2 = [];
  for (var i2 = 0; i2 < ranges.length; i2 += 2) {
    var from5 = mapping.map(ranges[i2], 1), to2 = mapping.map(ranges[i2 + 1], -1);
    if (from5 <= to2) {
      result2.push(from5, to2);
    }
  }
  return result2;
}
function histTransaction(history2, state, dispatch2, redo2) {
  var preserveItems = mustPreserveItems(state), histOptions = historyKey.get(state).spec.config;
  var pop = (redo2 ? history2.undone : history2.done).popEvent(state, preserveItems);
  if (!pop) {
    return;
  }
  var selection = pop.selection.resolve(pop.transform.doc);
  var added = (redo2 ? history2.done : history2.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
  var newHist = new HistoryState(redo2 ? added : pop.remaining, redo2 ? pop.remaining : added, null, 0);
  dispatch2(pop.transform.setSelection(selection).setMeta(historyKey, { redo: redo2, historyState: newHist }).scrollIntoView());
}
var cachedPreserveItems = false, cachedPreserveItemsPlugins = null;
function mustPreserveItems(state) {
  var plugins = state.plugins;
  if (cachedPreserveItemsPlugins != plugins) {
    cachedPreserveItems = false;
    cachedPreserveItemsPlugins = plugins;
    for (var i2 = 0; i2 < plugins.length; i2++) {
      if (plugins[i2].spec.historyPreserveItems) {
        cachedPreserveItems = true;
        break;
      }
    }
  }
  return cachedPreserveItems;
}
var historyKey = new PluginKey("history");
var closeHistoryKey = new PluginKey("closeHistory");
function history(config2) {
  config2 = {
    depth: config2 && config2.depth || 100,
    newGroupDelay: config2 && config2.newGroupDelay || 500
  };
  return new Plugin({
    key: historyKey,
    state: {
      init: function init6() {
        return new HistoryState(Branch.empty, Branch.empty, null, 0);
      },
      apply: function apply8(tr, hist, state) {
        return applyTransaction2(hist, state, tr, config2);
      }
    },
    config: config2,
    props: {
      handleDOMEvents: {
        beforeinput: function beforeinput2(view, e) {
          var handled = e.inputType == "historyUndo" ? undo(view.state, view.dispatch) : e.inputType == "historyRedo" ? redo(view.state, view.dispatch) : false;
          if (handled) {
            e.preventDefault();
          }
          return handled;
        }
      }
    }
  });
}
function undo(state, dispatch2) {
  var hist = historyKey.getState(state);
  if (!hist || hist.done.eventCount == 0) {
    return false;
  }
  if (dispatch2) {
    histTransaction(hist, state, dispatch2, false);
  }
  return true;
}
function redo(state, dispatch2) {
  var hist = historyKey.getState(state);
  if (!hist || hist.undone.eventCount == 0) {
    return false;
  }
  if (dispatch2) {
    histTransaction(hist, state, dispatch2, true);
  }
  return true;
}
function deleteSelection(state, dispatch2) {
  if (state.selection.empty) {
    return false;
  }
  if (dispatch2) {
    dispatch2(state.tr.deleteSelection().scrollIntoView());
  }
  return true;
}
function joinBackward(state, dispatch2, view) {
  var ref2 = state.selection;
  var $cursor = ref2.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) {
    return false;
  }
  var $cut = findCutBefore($cursor);
  if (!$cut) {
    var range2 = $cursor.blockRange(), target = range2 && liftTarget(range2);
    if (target == null) {
      return false;
    }
    if (dispatch2) {
      dispatch2(state.tr.lift(range2, target).scrollIntoView());
    }
    return true;
  }
  var before2 = $cut.nodeBefore;
  if (!before2.type.spec.isolating && deleteBarrier(state, $cut, dispatch2)) {
    return true;
  }
  if ($cursor.parent.content.size == 0 && (textblockAt(before2, "end") || NodeSelection.isSelectable(before2))) {
    var delStep = replaceStep(state.doc, $cursor.before(), $cursor.after(), Slice.empty);
    if (delStep.slice.size < delStep.to - delStep.from) {
      if (dispatch2) {
        var tr = state.tr.step(delStep);
        tr.setSelection(textblockAt(before2, "end") ? Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : NodeSelection.create(tr.doc, $cut.pos - before2.nodeSize));
        dispatch2(tr.scrollIntoView());
      }
      return true;
    }
  }
  if (before2.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch2) {
      dispatch2(state.tr.delete($cut.pos - before2.nodeSize, $cut.pos).scrollIntoView());
    }
    return true;
  }
  return false;
}
function textblockAt(node4, side, only) {
  for (; node4; node4 = side == "start" ? node4.firstChild : node4.lastChild) {
    if (node4.isTextblock) {
      return true;
    }
    if (only && node4.childCount != 1) {
      return false;
    }
  }
  return false;
}
function selectNodeBackward(state, dispatch2, view) {
  var ref2 = state.selection;
  var $head = ref2.$head;
  var empty2 = ref2.empty;
  var $cut = $head;
  if (!empty2) {
    return false;
  }
  if ($head.parent.isTextblock) {
    if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) {
      return false;
    }
    $cut = findCutBefore($head);
  }
  var node4 = $cut && $cut.nodeBefore;
  if (!node4 || !NodeSelection.isSelectable(node4)) {
    return false;
  }
  if (dispatch2) {
    dispatch2(state.tr.setSelection(NodeSelection.create(state.doc, $cut.pos - node4.nodeSize)).scrollIntoView());
  }
  return true;
}
function findCutBefore($pos) {
  if (!$pos.parent.type.spec.isolating) {
    for (var i2 = $pos.depth - 1; i2 >= 0; i2--) {
      if ($pos.index(i2) > 0) {
        return $pos.doc.resolve($pos.before(i2 + 1));
      }
      if ($pos.node(i2).type.spec.isolating) {
        break;
      }
    }
  }
  return null;
}
function joinForward(state, dispatch2, view) {
  var ref2 = state.selection;
  var $cursor = ref2.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) {
    return false;
  }
  var $cut = findCutAfter($cursor);
  if (!$cut) {
    return false;
  }
  var after2 = $cut.nodeAfter;
  if (deleteBarrier(state, $cut, dispatch2)) {
    return true;
  }
  if ($cursor.parent.content.size == 0 && (textblockAt(after2, "start") || NodeSelection.isSelectable(after2))) {
    var delStep = replaceStep(state.doc, $cursor.before(), $cursor.after(), Slice.empty);
    if (delStep.slice.size < delStep.to - delStep.from) {
      if (dispatch2) {
        var tr = state.tr.step(delStep);
        tr.setSelection(textblockAt(after2, "start") ? Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : NodeSelection.create(tr.doc, tr.mapping.map($cut.pos)));
        dispatch2(tr.scrollIntoView());
      }
      return true;
    }
  }
  if (after2.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch2) {
      dispatch2(state.tr.delete($cut.pos, $cut.pos + after2.nodeSize).scrollIntoView());
    }
    return true;
  }
  return false;
}
function selectNodeForward(state, dispatch2, view) {
  var ref2 = state.selection;
  var $head = ref2.$head;
  var empty2 = ref2.empty;
  var $cut = $head;
  if (!empty2) {
    return false;
  }
  if ($head.parent.isTextblock) {
    if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) {
      return false;
    }
    $cut = findCutAfter($head);
  }
  var node4 = $cut && $cut.nodeAfter;
  if (!node4 || !NodeSelection.isSelectable(node4)) {
    return false;
  }
  if (dispatch2) {
    dispatch2(state.tr.setSelection(NodeSelection.create(state.doc, $cut.pos)).scrollIntoView());
  }
  return true;
}
function findCutAfter($pos) {
  if (!$pos.parent.type.spec.isolating) {
    for (var i2 = $pos.depth - 1; i2 >= 0; i2--) {
      var parent = $pos.node(i2);
      if ($pos.index(i2) + 1 < parent.childCount) {
        return $pos.doc.resolve($pos.after(i2 + 1));
      }
      if (parent.type.spec.isolating) {
        break;
      }
    }
  }
  return null;
}
function joinUp(state, dispatch2) {
  var sel = state.selection, nodeSel = sel instanceof NodeSelection, point;
  if (nodeSel) {
    if (sel.node.isTextblock || !canJoin(state.doc, sel.from)) {
      return false;
    }
    point = sel.from;
  } else {
    point = joinPoint(state.doc, sel.from, -1);
    if (point == null) {
      return false;
    }
  }
  if (dispatch2) {
    var tr = state.tr.join(point);
    if (nodeSel) {
      tr.setSelection(NodeSelection.create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
    }
    dispatch2(tr.scrollIntoView());
  }
  return true;
}
function joinDown(state, dispatch2) {
  var sel = state.selection, point;
  if (sel instanceof NodeSelection) {
    if (sel.node.isTextblock || !canJoin(state.doc, sel.to)) {
      return false;
    }
    point = sel.to;
  } else {
    point = joinPoint(state.doc, sel.to, 1);
    if (point == null) {
      return false;
    }
  }
  if (dispatch2) {
    dispatch2(state.tr.join(point).scrollIntoView());
  }
  return true;
}
function lift(state, dispatch2) {
  var ref2 = state.selection;
  var $from = ref2.$from;
  var $to = ref2.$to;
  var range2 = $from.blockRange($to), target = range2 && liftTarget(range2);
  if (target == null) {
    return false;
  }
  if (dispatch2) {
    dispatch2(state.tr.lift(range2, target).scrollIntoView());
  }
  return true;
}
function newlineInCode(state, dispatch2) {
  var ref2 = state.selection;
  var $head = ref2.$head;
  var $anchor = ref2.$anchor;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) {
    return false;
  }
  if (dispatch2) {
    dispatch2(state.tr.insertText("\n").scrollIntoView());
  }
  return true;
}
function defaultBlockAt(match) {
  for (var i2 = 0; i2 < match.edgeCount; i2++) {
    var ref2 = match.edge(i2);
    var type = ref2.type;
    if (type.isTextblock && !type.hasRequiredAttrs()) {
      return type;
    }
  }
  return null;
}
function exitCode(state, dispatch2) {
  var ref2 = state.selection;
  var $head = ref2.$head;
  var $anchor = ref2.$anchor;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) {
    return false;
  }
  var above = $head.node(-1), after2 = $head.indexAfter(-1), type = defaultBlockAt(above.contentMatchAt(after2));
  if (!above.canReplaceWith(after2, after2, type)) {
    return false;
  }
  if (dispatch2) {
    var pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
    tr.setSelection(Selection.near(tr.doc.resolve(pos), 1));
    dispatch2(tr.scrollIntoView());
  }
  return true;
}
function createParagraphNear(state, dispatch2) {
  var sel = state.selection;
  var $from = sel.$from;
  var $to = sel.$to;
  if (sel instanceof AllSelection || $from.parent.inlineContent || $to.parent.inlineContent) {
    return false;
  }
  var type = defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
  if (!type || !type.isTextblock) {
    return false;
  }
  if (dispatch2) {
    var side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
    var tr = state.tr.insert(side, type.createAndFill());
    tr.setSelection(TextSelection.create(tr.doc, side + 1));
    dispatch2(tr.scrollIntoView());
  }
  return true;
}
function liftEmptyBlock(state, dispatch2) {
  var ref2 = state.selection;
  var $cursor = ref2.$cursor;
  if (!$cursor || $cursor.parent.content.size) {
    return false;
  }
  if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
    var before2 = $cursor.before();
    if (canSplit(state.doc, before2)) {
      if (dispatch2) {
        dispatch2(state.tr.split(before2).scrollIntoView());
      }
      return true;
    }
  }
  var range2 = $cursor.blockRange(), target = range2 && liftTarget(range2);
  if (target == null) {
    return false;
  }
  if (dispatch2) {
    dispatch2(state.tr.lift(range2, target).scrollIntoView());
  }
  return true;
}
function splitBlock(state, dispatch2) {
  var ref2 = state.selection;
  var $from = ref2.$from;
  var $to = ref2.$to;
  if (state.selection instanceof NodeSelection && state.selection.node.isBlock) {
    if (!$from.parentOffset || !canSplit(state.doc, $from.pos)) {
      return false;
    }
    if (dispatch2) {
      dispatch2(state.tr.split($from.pos).scrollIntoView());
    }
    return true;
  }
  if (!$from.parent.isBlock) {
    return false;
  }
  if (dispatch2) {
    var atEnd2 = $to.parentOffset == $to.parent.content.size;
    var tr = state.tr;
    if (state.selection instanceof TextSelection || state.selection instanceof AllSelection) {
      tr.deleteSelection();
    }
    var deflt = $from.depth == 0 ? null : defaultBlockAt($from.node(-1).contentMatchAt($from.indexAfter(-1)));
    var types = atEnd2 && deflt ? [{ type: deflt }] : null;
    var can = canSplit(tr.doc, tr.mapping.map($from.pos), 1, types);
    if (!types && !can && canSplit(tr.doc, tr.mapping.map($from.pos), 1, deflt && [{ type: deflt }])) {
      types = [{ type: deflt }];
      can = true;
    }
    if (can) {
      tr.split(tr.mapping.map($from.pos), 1, types);
      if (!atEnd2 && !$from.parentOffset && $from.parent.type != deflt) {
        var first = tr.mapping.map($from.before()), $first = tr.doc.resolve(first);
        if ($from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt)) {
          tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
        }
      }
    }
    dispatch2(tr.scrollIntoView());
  }
  return true;
}
function selectParentNode(state, dispatch2) {
  var ref2 = state.selection;
  var $from = ref2.$from;
  var to2 = ref2.to;
  var pos;
  var same = $from.sharedDepth(to2);
  if (same == 0) {
    return false;
  }
  pos = $from.before(same);
  if (dispatch2) {
    dispatch2(state.tr.setSelection(NodeSelection.create(state.doc, pos)));
  }
  return true;
}
function selectAll(state, dispatch2) {
  if (dispatch2) {
    dispatch2(state.tr.setSelection(new AllSelection(state.doc)));
  }
  return true;
}
function joinMaybeClear(state, $pos, dispatch2) {
  var before2 = $pos.nodeBefore, after2 = $pos.nodeAfter, index3 = $pos.index();
  if (!before2 || !after2 || !before2.type.compatibleContent(after2.type)) {
    return false;
  }
  if (!before2.content.size && $pos.parent.canReplace(index3 - 1, index3)) {
    if (dispatch2) {
      dispatch2(state.tr.delete($pos.pos - before2.nodeSize, $pos.pos).scrollIntoView());
    }
    return true;
  }
  if (!$pos.parent.canReplace(index3, index3 + 1) || !(after2.isTextblock || canJoin(state.doc, $pos.pos))) {
    return false;
  }
  if (dispatch2) {
    dispatch2(state.tr.clearIncompatible($pos.pos, before2.type, before2.contentMatchAt(before2.childCount)).join($pos.pos).scrollIntoView());
  }
  return true;
}
function deleteBarrier(state, $cut, dispatch2) {
  var before2 = $cut.nodeBefore, after2 = $cut.nodeAfter, conn, match;
  if (before2.type.spec.isolating || after2.type.spec.isolating) {
    return false;
  }
  if (joinMaybeClear(state, $cut, dispatch2)) {
    return true;
  }
  var canDelAfter = $cut.parent.canReplace($cut.index(), $cut.index() + 1);
  if (canDelAfter && (conn = (match = before2.contentMatchAt(before2.childCount)).findWrapping(after2.type)) && match.matchType(conn[0] || after2.type).validEnd) {
    if (dispatch2) {
      var end2 = $cut.pos + after2.nodeSize, wrap = Fragment.empty;
      for (var i2 = conn.length - 1; i2 >= 0; i2--) {
        wrap = Fragment.from(conn[i2].create(null, wrap));
      }
      wrap = Fragment.from(before2.copy(wrap));
      var tr = state.tr.step(new ReplaceAroundStep($cut.pos - 1, end2, $cut.pos, end2, new Slice(wrap, 1, 0), conn.length, true));
      var joinAt = end2 + 2 * conn.length;
      if (canJoin(tr.doc, joinAt)) {
        tr.join(joinAt);
      }
      dispatch2(tr.scrollIntoView());
    }
    return true;
  }
  var selAfter = Selection.findFrom($cut, 1);
  var range2 = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range2 && liftTarget(range2);
  if (target != null && target >= $cut.depth) {
    if (dispatch2) {
      dispatch2(state.tr.lift(range2, target).scrollIntoView());
    }
    return true;
  }
  if (canDelAfter && textblockAt(after2, "start", true) && textblockAt(before2, "end")) {
    var at = before2, wrap$1 = [];
    for (; ; ) {
      wrap$1.push(at);
      if (at.isTextblock) {
        break;
      }
      at = at.lastChild;
    }
    var afterText = after2, afterDepth = 1;
    for (; !afterText.isTextblock; afterText = afterText.firstChild) {
      afterDepth++;
    }
    if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
      if (dispatch2) {
        var end$1 = Fragment.empty;
        for (var i$1 = wrap$1.length - 1; i$1 >= 0; i$1--) {
          end$1 = Fragment.from(wrap$1[i$1].copy(end$1));
        }
        var tr$1 = state.tr.step(new ReplaceAroundStep($cut.pos - wrap$1.length, $cut.pos + after2.nodeSize, $cut.pos + afterDepth, $cut.pos + after2.nodeSize - afterDepth, new Slice(end$1, wrap$1.length, 0), 0, true));
        dispatch2(tr$1.scrollIntoView());
      }
      return true;
    }
  }
  return false;
}
function selectTextblockSide(side) {
  return function(state, dispatch2) {
    var sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
    var depth = $pos.depth;
    while ($pos.node(depth).isInline) {
      if (!depth) {
        return false;
      }
      depth--;
    }
    if (!$pos.node(depth).isTextblock) {
      return false;
    }
    if (dispatch2) {
      dispatch2(state.tr.setSelection(TextSelection.create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
    }
    return true;
  };
}
var selectTextblockStart = selectTextblockSide(-1);
var selectTextblockEnd = selectTextblockSide(1);
function wrapIn(nodeType2, attrs) {
  return function(state, dispatch2) {
    var ref2 = state.selection;
    var $from = ref2.$from;
    var $to = ref2.$to;
    var range2 = $from.blockRange($to), wrapping = range2 && findWrapping3(range2, nodeType2, attrs);
    if (!wrapping) {
      return false;
    }
    if (dispatch2) {
      dispatch2(state.tr.wrap(range2, wrapping).scrollIntoView());
    }
    return true;
  };
}
function setBlockType(nodeType2, attrs) {
  return function(state, dispatch2) {
    var ref2 = state.selection;
    var from5 = ref2.from;
    var to2 = ref2.to;
    var applicable = false;
    state.doc.nodesBetween(from5, to2, function(node4, pos) {
      if (applicable) {
        return false;
      }
      if (!node4.isTextblock || node4.hasMarkup(nodeType2, attrs)) {
        return;
      }
      if (node4.type == nodeType2) {
        applicable = true;
      } else {
        var $pos = state.doc.resolve(pos), index3 = $pos.index();
        applicable = $pos.parent.canReplaceWith(index3, index3 + 1, nodeType2);
      }
    });
    if (!applicable) {
      return false;
    }
    if (dispatch2) {
      dispatch2(state.tr.setBlockType(from5, to2, nodeType2, attrs).scrollIntoView());
    }
    return true;
  };
}
function markApplies(doc2, ranges, type) {
  var loop = function(i3) {
    var ref2 = ranges[i3];
    var $from = ref2.$from;
    var $to = ref2.$to;
    var can = $from.depth == 0 ? doc2.type.allowsMarkType(type) : false;
    doc2.nodesBetween($from.pos, $to.pos, function(node4) {
      if (can) {
        return false;
      }
      can = node4.inlineContent && node4.type.allowsMarkType(type);
    });
    if (can) {
      return { v: true };
    }
  };
  for (var i2 = 0; i2 < ranges.length; i2++) {
    var returned = loop(i2);
    if (returned)
      return returned.v;
  }
  return false;
}
function toggleMark(markType, attrs) {
  return function(state, dispatch2) {
    var ref2 = state.selection;
    var empty2 = ref2.empty;
    var $cursor = ref2.$cursor;
    var ranges = ref2.ranges;
    if (empty2 && !$cursor || !markApplies(state.doc, ranges, markType)) {
      return false;
    }
    if (dispatch2) {
      if ($cursor) {
        if (markType.isInSet(state.storedMarks || $cursor.marks())) {
          dispatch2(state.tr.removeStoredMark(markType));
        } else {
          dispatch2(state.tr.addStoredMark(markType.create(attrs)));
        }
      } else {
        var has2 = false, tr = state.tr;
        for (var i2 = 0; !has2 && i2 < ranges.length; i2++) {
          var ref$1 = ranges[i2];
          var $from = ref$1.$from;
          var $to = ref$1.$to;
          has2 = state.doc.rangeHasMark($from.pos, $to.pos, markType);
        }
        for (var i$1 = 0; i$1 < ranges.length; i$1++) {
          var ref$2 = ranges[i$1];
          var $from$1 = ref$2.$from;
          var $to$1 = ref$2.$to;
          if (has2) {
            tr.removeMark($from$1.pos, $to$1.pos, markType);
          } else {
            var from5 = $from$1.pos, to2 = $to$1.pos, start3 = $from$1.nodeAfter, end2 = $to$1.nodeBefore;
            var spaceStart = start3 && start3.isText ? /^\s*/.exec(start3.text)[0].length : 0;
            var spaceEnd = end2 && end2.isText ? /\s*$/.exec(end2.text)[0].length : 0;
            if (from5 + spaceStart < to2) {
              from5 += spaceStart;
              to2 -= spaceEnd;
            }
            tr.addMark(from5, to2, markType.create(attrs));
          }
        }
        dispatch2(tr.scrollIntoView());
      }
    }
    return true;
  };
}
function chainCommands() {
  var commands = [], len = arguments.length;
  while (len--)
    commands[len] = arguments[len];
  return function(state, dispatch2, view) {
    for (var i2 = 0; i2 < commands.length; i2++) {
      if (commands[i2](state, dispatch2, view)) {
        return true;
      }
    }
    return false;
  };
}
var backspace = chainCommands(deleteSelection, joinBackward, selectNodeBackward);
var del = chainCommands(deleteSelection, joinForward, selectNodeForward);
var pcBaseKeymap = {
  "Enter": chainCommands(newlineInCode, createParagraphNear, liftEmptyBlock, splitBlock),
  "Mod-Enter": exitCode,
  "Backspace": backspace,
  "Mod-Backspace": backspace,
  "Shift-Backspace": backspace,
  "Delete": del,
  "Mod-Delete": del,
  "Mod-a": selectAll
};
var macBaseKeymap = {
  "Ctrl-h": pcBaseKeymap["Backspace"],
  "Alt-Backspace": pcBaseKeymap["Mod-Backspace"],
  "Ctrl-d": pcBaseKeymap["Delete"],
  "Ctrl-Alt-Backspace": pcBaseKeymap["Mod-Delete"],
  "Alt-Delete": pcBaseKeymap["Mod-Delete"],
  "Alt-d": pcBaseKeymap["Mod-Delete"],
  "Ctrl-a": selectTextblockStart,
  "Ctrl-e": selectTextblockEnd
};
for (var key in pcBaseKeymap) {
  macBaseKeymap[key] = pcBaseKeymap[key];
}
pcBaseKeymap.Home = selectTextblockStart;
pcBaseKeymap.End = selectTextblockEnd;
var mac$1 = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" ? os.platform() == "darwin" : false;
var baseKeymap = mac$1 ? macBaseKeymap : pcBaseKeymap;
function dropCursor(options) {
  if (options === void 0)
    options = {};
  return new Plugin({
    view: function view(editorView) {
      return new DropCursorView(editorView, options);
    }
  });
}
var DropCursorView = function DropCursorView2(editorView, options) {
  var this$1$1 = this;
  this.editorView = editorView;
  this.width = options.width || 1;
  this.color = options.color || "black";
  this.class = options.class;
  this.cursorPos = null;
  this.element = null;
  this.timeout = null;
  this.handlers = ["dragover", "dragend", "drop", "dragleave"].map(function(name) {
    var handler = function(e) {
      return this$1$1[name](e);
    };
    editorView.dom.addEventListener(name, handler);
    return { name, handler };
  });
};
DropCursorView.prototype.destroy = function destroy4() {
  var this$1$1 = this;
  this.handlers.forEach(function(ref2) {
    var name = ref2.name;
    var handler = ref2.handler;
    return this$1$1.editorView.dom.removeEventListener(name, handler);
  });
};
DropCursorView.prototype.update = function update2(editorView, prevState) {
  if (this.cursorPos != null && prevState.doc != editorView.state.doc) {
    if (this.cursorPos > editorView.state.doc.content.size) {
      this.setCursor(null);
    } else {
      this.updateOverlay();
    }
  }
};
DropCursorView.prototype.setCursor = function setCursor(pos) {
  if (pos == this.cursorPos) {
    return;
  }
  this.cursorPos = pos;
  if (pos == null) {
    this.element.parentNode.removeChild(this.element);
    this.element = null;
  } else {
    this.updateOverlay();
  }
};
DropCursorView.prototype.updateOverlay = function updateOverlay() {
  var $pos = this.editorView.state.doc.resolve(this.cursorPos), rect;
  if (!$pos.parent.inlineContent) {
    var before2 = $pos.nodeBefore, after2 = $pos.nodeAfter;
    if (before2 || after2) {
      var nodeRect = this.editorView.nodeDOM(this.cursorPos - (before2 ? before2.nodeSize : 0)).getBoundingClientRect();
      var top = before2 ? nodeRect.bottom : nodeRect.top;
      if (before2 && after2) {
        top = (top + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2;
      }
      rect = { left: nodeRect.left, right: nodeRect.right, top: top - this.width / 2, bottom: top + this.width / 2 };
    }
  }
  if (!rect) {
    var coords = this.editorView.coordsAtPos(this.cursorPos);
    rect = { left: coords.left - this.width / 2, right: coords.left + this.width / 2, top: coords.top, bottom: coords.bottom };
  }
  var parent = this.editorView.dom.offsetParent;
  if (!this.element) {
    this.element = parent.appendChild(document.createElement("div"));
    if (this.class) {
      this.element.className = this.class;
    }
    this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none; background-color: " + this.color;
  }
  var parentLeft, parentTop;
  if (!parent || parent == document.body && getComputedStyle(parent).position == "static") {
    parentLeft = -pageXOffset;
    parentTop = -pageYOffset;
  } else {
    var rect$1 = parent.getBoundingClientRect();
    parentLeft = rect$1.left - parent.scrollLeft;
    parentTop = rect$1.top - parent.scrollTop;
  }
  this.element.style.left = rect.left - parentLeft + "px";
  this.element.style.top = rect.top - parentTop + "px";
  this.element.style.width = rect.right - rect.left + "px";
  this.element.style.height = rect.bottom - rect.top + "px";
};
DropCursorView.prototype.scheduleRemoval = function scheduleRemoval(timeout) {
  var this$1$1 = this;
  clearTimeout(this.timeout);
  this.timeout = setTimeout(function() {
    return this$1$1.setCursor(null);
  }, timeout);
};
DropCursorView.prototype.dragover = function dragover(event) {
  if (!this.editorView.editable) {
    return;
  }
  var pos = this.editorView.posAtCoords({ left: event.clientX, top: event.clientY });
  var node4 = pos && pos.inside >= 0 && this.editorView.state.doc.nodeAt(pos.inside);
  var disableDropCursor = node4 && node4.type.spec.disableDropCursor;
  var disabled = typeof disableDropCursor == "function" ? disableDropCursor(this.editorView, pos) : disableDropCursor;
  if (pos && !disabled) {
    var target = pos.pos;
    if (this.editorView.dragging && this.editorView.dragging.slice) {
      target = dropPoint(this.editorView.state.doc, target, this.editorView.dragging.slice);
      if (target == null) {
        return this.setCursor(null);
      }
    }
    this.setCursor(target);
    this.scheduleRemoval(5e3);
  }
};
DropCursorView.prototype.dragend = function dragend() {
  this.scheduleRemoval(20);
};
DropCursorView.prototype.drop = function drop() {
  this.scheduleRemoval(20);
};
DropCursorView.prototype.dragleave = function dragleave(event) {
  if (event.target == this.editorView.dom || !this.editorView.dom.contains(event.relatedTarget)) {
    this.setCursor(null);
  }
};
var GapCursor = /* @__PURE__ */ function(Selection3) {
  function GapCursor2($pos) {
    Selection3.call(this, $pos, $pos);
  }
  if (Selection3)
    GapCursor2.__proto__ = Selection3;
  GapCursor2.prototype = Object.create(Selection3 && Selection3.prototype);
  GapCursor2.prototype.constructor = GapCursor2;
  GapCursor2.prototype.map = function map16(doc2, mapping) {
    var $pos = doc2.resolve(mapping.map(this.head));
    return GapCursor2.valid($pos) ? new GapCursor2($pos) : Selection3.near($pos);
  };
  GapCursor2.prototype.content = function content2() {
    return Slice.empty;
  };
  GapCursor2.prototype.eq = function eq12(other) {
    return other instanceof GapCursor2 && other.head == this.head;
  };
  GapCursor2.prototype.toJSON = function toJSON8() {
    return { type: "gapcursor", pos: this.head };
  };
  GapCursor2.fromJSON = function fromJSON8(doc2, json) {
    if (typeof json.pos != "number") {
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    }
    return new GapCursor2(doc2.resolve(json.pos));
  };
  GapCursor2.prototype.getBookmark = function getBookmark2() {
    return new GapBookmark(this.anchor);
  };
  GapCursor2.valid = function valid4($pos) {
    var parent = $pos.parent;
    if (parent.isTextblock || !closedBefore($pos) || !closedAfter($pos)) {
      return false;
    }
    var override = parent.type.spec.allowGapCursor;
    if (override != null) {
      return override;
    }
    var deflt = parent.contentMatchAt($pos.index()).defaultType;
    return deflt && deflt.isTextblock;
  };
  GapCursor2.findFrom = function findFrom2($pos, dir, mustMove) {
    search:
      for (; ; ) {
        if (!mustMove && GapCursor2.valid($pos)) {
          return $pos;
        }
        var pos = $pos.pos, next = null;
        for (var d = $pos.depth; ; d--) {
          var parent = $pos.node(d);
          if (dir > 0 ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
            next = parent.child(dir > 0 ? $pos.indexAfter(d) : $pos.index(d) - 1);
            break;
          } else if (d == 0) {
            return null;
          }
          pos += dir;
          var $cur = $pos.doc.resolve(pos);
          if (GapCursor2.valid($cur)) {
            return $cur;
          }
        }
        for (; ; ) {
          var inside = dir > 0 ? next.firstChild : next.lastChild;
          if (!inside) {
            if (next.isAtom && !next.isText && !NodeSelection.isSelectable(next)) {
              $pos = $pos.doc.resolve(pos + next.nodeSize * dir);
              mustMove = false;
              continue search;
            }
            break;
          }
          next = inside;
          pos += dir;
          var $cur$1 = $pos.doc.resolve(pos);
          if (GapCursor2.valid($cur$1)) {
            return $cur$1;
          }
        }
        return null;
      }
  };
  return GapCursor2;
}(Selection);
GapCursor.prototype.visible = false;
Selection.jsonID("gapcursor", GapCursor);
var GapBookmark = function GapBookmark2(pos) {
  this.pos = pos;
};
GapBookmark.prototype.map = function map15(mapping) {
  return new GapBookmark(mapping.map(this.pos));
};
GapBookmark.prototype.resolve = function resolve6(doc2) {
  var $pos = doc2.resolve(this.pos);
  return GapCursor.valid($pos) ? new GapCursor($pos) : Selection.near($pos);
};
function closedBefore($pos) {
  for (var d = $pos.depth; d >= 0; d--) {
    var index3 = $pos.index(d), parent = $pos.node(d);
    if (index3 == 0) {
      if (parent.type.spec.isolating) {
        return true;
      }
      continue;
    }
    for (var before2 = parent.child(index3 - 1); ; before2 = before2.lastChild) {
      if (before2.childCount == 0 && !before2.inlineContent || before2.isAtom || before2.type.spec.isolating) {
        return true;
      }
      if (before2.inlineContent) {
        return false;
      }
    }
  }
  return true;
}
function closedAfter($pos) {
  for (var d = $pos.depth; d >= 0; d--) {
    var index3 = $pos.indexAfter(d), parent = $pos.node(d);
    if (index3 == parent.childCount) {
      if (parent.type.spec.isolating) {
        return true;
      }
      continue;
    }
    for (var after2 = parent.child(index3); ; after2 = after2.firstChild) {
      if (after2.childCount == 0 && !after2.inlineContent || after2.isAtom || after2.type.spec.isolating) {
        return true;
      }
      if (after2.inlineContent) {
        return false;
      }
    }
  }
  return true;
}
var gapCursor = function() {
  return new Plugin({
    props: {
      decorations: drawGapCursor,
      createSelectionBetween: function createSelectionBetween(_view, $anchor, $head) {
        if ($anchor.pos == $head.pos && GapCursor.valid($head)) {
          return new GapCursor($head);
        }
      },
      handleClick,
      handleKeyDown,
      handleDOMEvents: { beforeinput }
    }
  });
};
var handleKeyDown = keydownHandler({
  "ArrowLeft": arrow("horiz", -1),
  "ArrowRight": arrow("horiz", 1),
  "ArrowUp": arrow("vert", -1),
  "ArrowDown": arrow("vert", 1)
});
function arrow(axis, dir) {
  var dirStr = axis == "vert" ? dir > 0 ? "down" : "up" : dir > 0 ? "right" : "left";
  return function(state, dispatch2, view) {
    var sel = state.selection;
    var $start = dir > 0 ? sel.$to : sel.$from, mustMove = sel.empty;
    if (sel instanceof TextSelection) {
      if (!view.endOfTextblock(dirStr) || $start.depth == 0) {
        return false;
      }
      mustMove = false;
      $start = state.doc.resolve(dir > 0 ? $start.after() : $start.before());
    }
    var $found = GapCursor.findFrom($start, dir, mustMove);
    if (!$found) {
      return false;
    }
    if (dispatch2) {
      dispatch2(state.tr.setSelection(new GapCursor($found)));
    }
    return true;
  };
}
function handleClick(view, pos, event) {
  if (!view.editable) {
    return false;
  }
  var $pos = view.state.doc.resolve(pos);
  if (!GapCursor.valid($pos)) {
    return false;
  }
  var ref2 = view.posAtCoords({ left: event.clientX, top: event.clientY });
  var inside = ref2.inside;
  if (inside > -1 && NodeSelection.isSelectable(view.state.doc.nodeAt(inside))) {
    return false;
  }
  view.dispatch(view.state.tr.setSelection(new GapCursor($pos)));
  return true;
}
function beforeinput(view, event) {
  if (event.inputType != "insertCompositionText" || !(view.state.selection instanceof GapCursor)) {
    return false;
  }
  var ref2 = view.state.selection;
  var $from = ref2.$from;
  var insert = $from.parent.contentMatchAt($from.index()).findWrapping(view.state.schema.nodes.text);
  if (!insert) {
    return false;
  }
  var frag = Fragment.empty;
  for (var i2 = insert.length - 1; i2 >= 0; i2--) {
    frag = Fragment.from(insert[i2].createAndFill(null, frag));
  }
  var tr = view.state.tr.replace($from.pos, $from.pos, new Slice(frag, 0, 0));
  tr.setSelection(TextSelection.near(tr.doc.resolve($from.pos + 1)));
  view.dispatch(tr);
  return false;
}
function drawGapCursor(state) {
  if (!(state.selection instanceof GapCursor)) {
    return null;
  }
  var node4 = document.createElement("div");
  node4.className = "ProseMirror-gapcursor";
  return DecorationSet.create(state.doc, [Decoration.widget(state.selection.head, node4, { key: "gapcursor" })]);
}
function crelt() {
  var elt = arguments[0];
  if (typeof elt == "string")
    elt = document.createElement(elt);
  var i2 = 1, next = arguments[1];
  if (next && typeof next == "object" && next.nodeType == null && !Array.isArray(next)) {
    for (var name in next)
      if (Object.prototype.hasOwnProperty.call(next, name)) {
        var value = next[name];
        if (typeof value == "string")
          elt.setAttribute(name, value);
        else if (value != null)
          elt[name] = value;
      }
    i2++;
  }
  for (; i2 < arguments.length; i2++)
    add$1(elt, arguments[i2]);
  return elt;
}
function add$1(elt, child3) {
  if (typeof child3 == "string") {
    elt.appendChild(document.createTextNode(child3));
  } else if (child3 == null)
    ;
  else if (child3.nodeType != null) {
    elt.appendChild(child3);
  } else if (Array.isArray(child3)) {
    for (var i2 = 0; i2 < child3.length; i2++)
      add$1(elt, child3[i2]);
  } else {
    throw new RangeError("Unsupported child node: " + child3);
  }
}
const SVG = "http://www.w3.org/2000/svg";
const XLINK = "http://www.w3.org/1999/xlink";
const prefix$3 = "ProseMirror-icon";
function hashPath(path) {
  let hash2 = 0;
  for (let i2 = 0; i2 < path.length; i2++)
    hash2 = (hash2 << 5) - hash2 + path.charCodeAt(i2) | 0;
  return hash2;
}
function getIcon(icon) {
  let node4 = document.createElement("div");
  node4.className = prefix$3;
  if (icon.path) {
    let name = "pm-icon-" + hashPath(icon.path).toString(16);
    if (!document.getElementById(name))
      buildSVG(name, icon);
    let svg = node4.appendChild(document.createElementNS(SVG, "svg"));
    svg.style.width = icon.width / icon.height + "em";
    let use = svg.appendChild(document.createElementNS(SVG, "use"));
    use.setAttributeNS(XLINK, "href", /([^#]*)/.exec(document.location)[1] + "#" + name);
  } else if (icon.dom) {
    node4.appendChild(icon.dom.cloneNode(true));
  } else {
    node4.appendChild(document.createElement("span")).textContent = icon.text || "";
    if (icon.css)
      node4.firstChild.style.cssText = icon.css;
  }
  return node4;
}
function buildSVG(name, data) {
  let collection2 = document.getElementById(prefix$3 + "-collection");
  if (!collection2) {
    collection2 = document.createElementNS(SVG, "svg");
    collection2.id = prefix$3 + "-collection";
    collection2.style.display = "none";
    document.body.insertBefore(collection2, document.body.firstChild);
  }
  let sym = document.createElementNS(SVG, "symbol");
  sym.id = name;
  sym.setAttribute("viewBox", "0 0 " + data.width + " " + data.height);
  let path = sym.appendChild(document.createElementNS(SVG, "path"));
  path.setAttribute("d", data.path);
  collection2.appendChild(sym);
}
const prefix$2 = "ProseMirror-menu";
class MenuItem {
  constructor(spec) {
    this.spec = spec;
  }
  render(view) {
    let spec = this.spec;
    let dom = spec.render ? spec.render(view) : spec.icon ? getIcon(spec.icon) : spec.label ? crelt("div", { class: "txtitem" }, translate(view, spec.label)) : null;
    if (!dom)
      throw new RangeError("MenuItem without icon or label property");
    if (spec.title) {
      const title = typeof spec.title === "function" ? spec.title(view.state) : spec.title;
      dom.setAttribute("title", translate(view, title));
    }
    if (spec.class)
      dom.classList.add(spec.class);
    if (spec.css)
      dom.style.cssText += spec.css;
    dom.addEventListener("mousedown", (e) => {
      e.preventDefault();
      if (!dom.classList.contains(prefix$2 + "-disabled"))
        spec.run(view.state, view.dispatch, view, e);
    });
    function update3(state) {
      if (spec.select) {
        let selected = spec.select(state);
        dom.style.display = selected ? "" : "none";
        if (!selected)
          return false;
      }
      let enabled = true;
      if (spec.enable) {
        enabled = spec.enable(state) || false;
        if (spec.selectable) {
          setClass(dom, prefix$2 + "-selected", !enabled);
        } else {
          setClass(dom, prefix$2 + "-disabled", !enabled);
        }
      }
      if (spec.active) {
        let active = enabled && spec.active(state) || false;
        setClass(dom, prefix$2 + "-active", active);
      }
      return true;
    }
    return { dom, update: update3 };
  }
}
function translate(view, text2) {
  return view._props.translate ? view._props.translate(text2) : text2;
}
let lastMenuEvent = { time: 0, node: null };
function markMenuEvent(e) {
  lastMenuEvent.time = Date.now();
  lastMenuEvent.node = e.target;
}
function isMenuEvent(wrapper) {
  return Date.now() - 100 < lastMenuEvent.time && lastMenuEvent.node && wrapper.contains(lastMenuEvent.node);
}
class Dropdown {
  constructor(content2, options) {
    this.options = options || {};
    this.content = Array.isArray(content2) ? content2 : [content2];
  }
  render(view) {
    let content2 = renderDropdownItems(this.content, view);
    let label = crelt("div", {
      class: prefix$2 + "-dropdown " + (this.options.class || ""),
      style: this.options.css
    }, translate(view, this.options.label));
    if (this.options.title)
      label.setAttribute("title", translate(view, this.options.title));
    let wrap = crelt("div", { class: prefix$2 + "-dropdown-wrap" }, label);
    let open = null, listeningOnClose = null;
    let close3 = () => {
      if (open && open.close()) {
        open = null;
        window.removeEventListener("mousedown", listeningOnClose);
      }
    };
    label.addEventListener("mousedown", (e) => {
      e.preventDefault();
      markMenuEvent(e);
      if (open) {
        close3();
      } else {
        open = this.expand(wrap, content2.dom);
        window.addEventListener("mousedown", listeningOnClose = () => {
          if (!isMenuEvent(wrap))
            close3();
        });
      }
    });
    function update3(state) {
      let inner = content2.update(state);
      wrap.style.display = inner ? "" : "none";
      return inner;
    }
    return { dom: wrap, update: update3 };
  }
  expand(dom, items) {
    let menuDOM = crelt("div", { class: prefix$2 + "-dropdown-menu " + (this.options.class || "") }, items);
    let done2 = false;
    function close3() {
      if (done2)
        return;
      done2 = true;
      dom.removeChild(menuDOM);
      return true;
    }
    dom.appendChild(menuDOM);
    return { close: close3, node: menuDOM };
  }
}
function renderDropdownItems(items, view) {
  let rendered = [], updates = [];
  for (let i2 = 0; i2 < items.length; i2++) {
    let { dom, update: update3 } = items[i2].render(view);
    rendered.push(crelt("div", { class: prefix$2 + "-dropdown-item" }, dom));
    updates.push(update3);
  }
  return { dom: rendered, update: combineUpdates(updates, rendered) };
}
function combineUpdates(updates, nodes) {
  return (state) => {
    let something = false;
    for (let i2 = 0; i2 < updates.length; i2++) {
      let up2 = updates[i2](state);
      nodes[i2].style.display = up2 ? "" : "none";
      if (up2)
        something = true;
    }
    return something;
  };
}
function renderGrouped(view, content2) {
  let result2 = document.createDocumentFragment();
  let updates = [], separators = [];
  for (let i2 = 0; i2 < content2.length; i2++) {
    let items = content2[i2], localUpdates = [], localNodes = [];
    for (let j = 0; j < items.length; j++) {
      let { dom, update: update22 } = items[j].render(view);
      let span = crelt("span", { class: prefix$2 + "item" }, dom);
      result2.appendChild(span);
      localNodes.push(span);
      localUpdates.push(update22);
    }
    if (localUpdates.length) {
      updates.push(combineUpdates(localUpdates, localNodes));
      if (i2 < content2.length - 1)
        separators.push(result2.appendChild(separator()));
    }
  }
  function update3(state) {
    let something = false, needSep = false;
    for (let i2 = 0; i2 < updates.length; i2++) {
      let hasContent = updates[i2](state);
      if (i2)
        separators[i2 - 1].style.display = needSep && hasContent ? "" : "none";
      needSep = hasContent;
      if (hasContent)
        something = true;
    }
    return something;
  }
  return { dom: result2, update: update3 };
}
function separator() {
  return crelt("span", { class: prefix$2 + "separator" });
}
const icons = {
  join: {
    width: 800,
    height: 900,
    path: "M0 75h800v125h-800z M0 825h800v-125h-800z M250 400h100v-100h100v100h100v100h-100v100h-100v-100h-100z"
  },
  lift: {
    width: 1024,
    height: 1024,
    path: "M219 310v329q0 7-5 12t-12 5q-8 0-13-5l-164-164q-5-5-5-13t5-13l164-164q5-5 13-5 7 0 12 5t5 12zM1024 749v109q0 7-5 12t-12 5h-987q-7 0-12-5t-5-12v-109q0-7 5-12t12-5h987q7 0 12 5t5 12zM1024 530v109q0 7-5 12t-12 5h-621q-7 0-12-5t-5-12v-109q0-7 5-12t12-5h621q7 0 12 5t5 12zM1024 310v109q0 7-5 12t-12 5h-621q-7 0-12-5t-5-12v-109q0-7 5-12t12-5h621q7 0 12 5t5 12zM1024 91v109q0 7-5 12t-12 5h-987q-7 0-12-5t-5-12v-109q0-7 5-12t12-5h987q7 0 12 5t5 12z"
  },
  selectParentNode: { text: "\u2B1A", css: "font-weight: bold" },
  undo: {
    width: 1024,
    height: 1024,
    path: "M761 1024c113-206 132-520-313-509v253l-384-384 384-384v248c534-13 594 472 313 775z"
  },
  redo: {
    width: 1024,
    height: 1024,
    path: "M576 248v-248l384 384-384 384v-253c-446-10-427 303-313 509-280-303-221-789 313-775z"
  },
  strong: {
    width: 805,
    height: 1024,
    path: "M317 869q42 18 80 18 214 0 214-191 0-65-23-102-15-25-35-42t-38-26-46-14-48-6-54-1q-41 0-57 5 0 30-0 90t-0 90q0 4-0 38t-0 55 2 47 6 38zM309 442q24 4 62 4 46 0 81-7t62-25 42-51 14-81q0-40-16-70t-45-46-61-24-70-8q-28 0-74 7 0 28 2 86t2 86q0 15-0 45t-0 45q0 26 0 39zM0 950l1-53q8-2 48-9t60-15q4-6 7-15t4-19 3-18 1-21 0-19v-37q0-561-12-585-2-4-12-8t-25-6-28-4-27-2-17-1l-2-47q56-1 194-6t213-5q13 0 39 0t38 0q40 0 78 7t73 24 61 40 42 59 16 78q0 29-9 54t-22 41-36 32-41 25-48 22q88 20 146 76t58 141q0 57-20 102t-53 74-78 48-93 27-100 8q-25 0-75-1t-75-1q-60 0-175 6t-132 6z"
  },
  em: {
    width: 585,
    height: 1024,
    path: "M0 949l9-48q3-1 46-12t63-21q16-20 23-57 0-4 35-165t65-310 29-169v-14q-13-7-31-10t-39-4-33-3l10-58q18 1 68 3t85 4 68 1q27 0 56-1t69-4 56-3q-2 22-10 50-17 5-58 16t-62 19q-4 10-8 24t-5 22-4 26-3 24q-15 84-50 239t-44 203q-1 5-7 33t-11 51-9 47-3 32l0 10q9 2 105 17-1 25-9 56-6 0-18 0t-18 0q-16 0-49-5t-49-5q-78-1-117-1-29 0-81 5t-69 6z"
  },
  code: {
    width: 896,
    height: 1024,
    path: "M608 192l-96 96 224 224-224 224 96 96 288-320-288-320zM288 192l-288 320 288 320 96-96-224-224 224-224-96-96z"
  },
  link: {
    width: 951,
    height: 1024,
    path: "M832 694q0-22-16-38l-118-118q-16-16-38-16-24 0-41 18 1 1 10 10t12 12 8 10 7 14 2 15q0 22-16 38t-38 16q-8 0-15-2t-14-7-10-8-12-12-10-10q-18 17-18 41 0 22 16 38l117 118q15 15 38 15 22 0 38-14l84-83q16-16 16-38zM430 292q0-22-16-38l-117-118q-16-16-38-16-22 0-38 15l-84 83q-16 16-16 38 0 22 16 38l118 118q15 15 38 15 24 0 41-17-1-1-10-10t-12-12-8-10-7-14-2-15q0-22 16-38t38-16q8 0 15 2t14 7 10 8 12 12 10 10q18-17 18-41zM941 694q0 68-48 116l-84 83q-47 47-116 47-69 0-116-48l-117-118q-47-47-47-116 0-70 50-119l-50-50q-49 50-118 50-68 0-116-48l-118-118q-48-48-48-116t48-116l84-83q47-47 116-47 69 0 116 48l117 118q47 47 47 116 0 70-50 119l50 50q49-50 118-50 68 0 116 48l118 118q48 48 48 116z"
  },
  bulletList: {
    width: 768,
    height: 896,
    path: "M0 512h128v-128h-128v128zM0 256h128v-128h-128v128zM0 768h128v-128h-128v128zM256 512h512v-128h-512v128zM256 256h512v-128h-512v128zM256 768h512v-128h-512v128z"
  },
  orderedList: {
    width: 768,
    height: 896,
    path: "M320 512h448v-128h-448v128zM320 768h448v-128h-448v128zM320 128v128h448v-128h-448zM79 384h78v-256h-36l-85 23v50l43-2v185zM189 590c0-36-12-78-96-78-33 0-64 6-83 16l1 66c21-10 42-15 67-15s32 11 32 28c0 26-30 58-110 112v50h192v-67l-91 2c49-30 87-66 87-113l1-1z"
  },
  blockquote: {
    width: 640,
    height: 896,
    path: "M0 448v256h256v-256h-128c0 0 0-128 128-128v-128c0 0-256 0-256 256zM640 320v-128c0 0-256 0-256 256v256h256v-256h-128c0 0 0-128 128-128z"
  },
  image: {
    width: 24,
    height: 24,
    path: "M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17l-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z"
  },
  hr: {
    width: 24,
    height: 24,
    path: "M0 10 h24 v2 h-24 v-2 z"
  },
  paragraph: {
    width: 24,
    height: 24,
    path: "M0 10 h24 v2 h-24 v-2 z"
  }
};
const joinUpItem = new MenuItem({
  title: "Join with above block",
  run: joinUp,
  select: (state) => joinUp(state),
  icon: icons.join
});
const liftItem = new MenuItem({
  title: "Lift out of enclosing block",
  run: lift,
  select: (state) => lift(state),
  icon: icons.lift
});
const selectParentNodeItem = new MenuItem({
  title: "Select parent node",
  run: selectParentNode,
  select: (state) => selectParentNode(state),
  icon: icons.selectParentNode
});
let undoItem = new MenuItem({
  title: "Undo last change",
  run: undo,
  enable: (state) => undo(state),
  icon: icons.undo
});
let redoItem = new MenuItem({
  title: "Redo last undone change",
  run: redo,
  enable: (state) => redo(state),
  icon: icons.redo
});
function wrapItem(nodeType2, options) {
  let passedOptions = {
    run(state, dispatch2) {
      return wrapIn(nodeType2, options.attrs)(state, dispatch2);
    },
    select(state) {
      return wrapIn(nodeType2, options.attrs instanceof Function ? null : options.attrs)(state);
    }
  };
  for (let prop in options)
    passedOptions[prop] = options[prop];
  return new MenuItem(passedOptions);
}
function blockTypeItem(nodeType2, options) {
  let command = setBlockType(nodeType2, options.attrs);
  let passedOptions = {
    run: command,
    enable(state) {
      return command(state);
    },
    active(state) {
      let { $from, to: to2, node: node4 } = state.selection;
      if (node4)
        return node4.hasMarkup(nodeType2, options.attrs);
      return to2 <= $from.end() && $from.parent.hasMarkup(nodeType2, options.attrs);
    }
  };
  for (let prop in options)
    passedOptions[prop] = options[prop];
  return new MenuItem(passedOptions);
}
function setClass(dom, cls, on) {
  if (on)
    dom.classList.add(cls);
  else
    dom.classList.remove(cls);
}
const prefix$1 = "ProseMirror-menubar";
function isIOS() {
  if (typeof navigator == "undefined")
    return false;
  let agent = navigator.userAgent;
  return !/Edge\/\d/.test(agent) && /AppleWebKit/.test(agent) && /Mobile\/\w+/.test(agent);
}
function menuBar(options) {
  return new Plugin({
    view(editorView) {
      return new MenuBarView(editorView, options);
    }
  });
}
class MenuBarView {
  constructor(editorView, options) {
    this.editorView = editorView;
    this.options = options;
    this.wrapper = crelt("div", { class: prefix$1 + "-wrapper rounded-md w-full" });
    this.menu = this.wrapper.appendChild(crelt("div", { class: prefix$1 }));
    this.menu.className = prefix$1;
    this.spacer = null;
    editorView.dom.parentNode.replaceChild(this.wrapper, editorView.dom);
    this.wrapper.appendChild(editorView.dom);
    this.maxHeight = 0;
    this.widthForMaxHeight = 0;
    this.floating = false;
    let { dom, update: update3 } = renderGrouped(this.editorView, this.options.content);
    this.contentUpdate = update3;
    this.menu.appendChild(dom);
    this.update();
    if (options.floating && !isIOS()) {
      this.updateFloat();
      let potentialScrollers = getAllWrapping(this.wrapper);
      this.scrollFunc = (e) => {
        let root2 = this.editorView.root;
        if (!(root2.body || root2).contains(this.wrapper)) {
          potentialScrollers.forEach((el) => el.removeEventListener("scroll", this.scrollFunc));
        } else {
          this.updateFloat(e.target.getBoundingClientRect && e.target);
        }
      };
      potentialScrollers.forEach((el) => el.addEventListener("scroll", this.scrollFunc));
    }
  }
  update() {
    if (this.editorView.editable) {
      this.menu.classList.remove("pointer-events-none");
      this.menu.classList.remove("opacity-50");
    } else {
      this.menu.classList.add("pointer-events-none");
      this.menu.classList.add("opacity-50");
    }
    this.contentUpdate(this.editorView.state);
    if (this.floating) {
      this.updateScrollCursor();
    } else {
      if (this.menu.offsetWidth != this.widthForMaxHeight) {
        this.widthForMaxHeight = this.menu.offsetWidth;
        this.maxHeight = 0;
      }
      if (this.menu.offsetHeight > this.maxHeight) {
        this.maxHeight = this.menu.offsetHeight;
        this.menu.style.minHeight = this.maxHeight + "px";
      }
    }
  }
  updateScrollCursor() {
    let selection = this.editorView.root.getSelection();
    if (!selection.focusNode)
      return;
    let rects = selection.getRangeAt(0).getClientRects();
    let selRect = rects[selectionIsInverted(selection) ? 0 : rects.length - 1];
    if (!selRect)
      return;
    let menuRect = this.menu.getBoundingClientRect();
    if (selRect.top < menuRect.bottom && selRect.bottom > menuRect.top) {
      let scrollable = findWrappingScrollable(this.wrapper);
      if (scrollable)
        scrollable.scrollTop -= menuRect.bottom - selRect.top;
    }
  }
  updateFloat(scrollAncestor) {
    let parent = this.wrapper, editorRect = parent.getBoundingClientRect(), top = scrollAncestor ? Math.max(0, scrollAncestor.getBoundingClientRect().top) : 0;
    if (this.floating) {
      if (editorRect.top >= top || editorRect.bottom < this.menu.offsetHeight + 10) {
        this.floating = false;
        this.menu.style.position = this.menu.style.left = this.menu.style.top = this.menu.style.width = "";
        this.menu.style.display = "";
        this.spacer.parentNode.removeChild(this.spacer);
        this.spacer = null;
      } else {
        let border = (parent.offsetWidth - parent.clientWidth) / 2;
        this.menu.style.left = editorRect.left + border + "px";
        this.menu.style.display = editorRect.top > window.innerHeight ? "none" : "";
        if (scrollAncestor)
          this.menu.style.top = top + "px";
      }
    } else {
      if (editorRect.top < top && editorRect.bottom >= this.menu.offsetHeight + 10) {
        this.floating = true;
        let menuRect = this.menu.getBoundingClientRect();
        this.menu.style.left = menuRect.left + "px";
        this.menu.style.width = menuRect.width + "px";
        if (scrollAncestor)
          this.menu.style.top = top + "px";
        this.menu.style.position = "fixed";
        this.spacer = crelt("div", { class: prefix$1 + "-spacer", style: `height: ${menuRect.height}px` });
        parent.insertBefore(this.spacer, this.menu);
      }
    }
  }
  destroy() {
    if (this.wrapper.parentNode)
      this.wrapper.parentNode.replaceChild(this.editorView.dom, this.wrapper);
  }
}
function selectionIsInverted(selection) {
  if (selection.anchorNode == selection.focusNode)
    return selection.anchorOffset > selection.focusOffset;
  return selection.anchorNode.compareDocumentPosition(selection.focusNode) == Node.DOCUMENT_POSITION_FOLLOWING;
}
function findWrappingScrollable(node4) {
  for (let cur = node4.parentNode; cur; cur = cur.parentNode)
    if (cur.scrollHeight > cur.clientHeight)
      return cur;
}
function getAllWrapping(node4) {
  let res = [window];
  for (let cur = node4.parentNode; cur; cur = cur.parentNode)
    res.push(cur);
  return res;
}
function createSchema(def) {
  const schema = { nodes: {}, marks: {} };
  let items = [];
  if (typeof def == "string") {
    def = def.split("+");
    items.push(...getBaseSpecItems(def[0]));
    if (def.length > 1) {
      def = def[1].split("-");
      items.push(...def[0].split(","));
      if (def.length > 1) {
        const removeItems = def[1].split(",");
        for (let i2 = 0; i2 < removeItems.length; i2++) {
          const ix = items.indexOf(removeItems[i2]);
          if (ix >= 0) {
            items.splice(ix, 1);
          }
        }
      }
    }
  }
  for (let i2 = 0; i2 < items.length; i2++) {
    addSpec(schema, items[i2]);
  }
  return new Schema(schema);
}
const getBaseSpecItems = (code) => {
  switch (code) {
    case "content":
      return ["multi_blocks", "text", "p", "h1_6", "i", "b", "br", "hr", "li", "img", "a", "bq", "div"];
    case "paragraph":
      return ["single_p", "text", "p", "i", "b", "br"];
    case "basic":
    default:
      return ["multi_blocks", "text", "p", "br", "i", "b", "a"];
  }
  return [];
};
const addSpec = (schema, itemKey) => {
  if (keys.hasOwnProperty(itemKey)) {
    itemKey = keys[itemKey];
  }
  if (itemKey == "li" || itemKey == "ol" || itemKey == "ul") {
    addListNodes(schema.nodes, itemKey);
  } else if (/h[1-6](_[2-6])?/.test(itemKey)) {
    addHeadingNodes(schema.nodes, itemKey);
  } else if (topNodes.hasOwnProperty(itemKey)) {
    schema.nodes.doc = { content: topNodes[itemKey] };
  } else if (itemKey == "blockquote") {
    schema.nodes.cite = availableNodes.cite;
    schema.nodes[itemKey] = availableNodes[itemKey];
  } else if (availableNodes.hasOwnProperty(itemKey)) {
    schema.nodes[itemKey] = availableNodes[itemKey];
  } else if (availableMarks.hasOwnProperty(itemKey)) {
    schema.marks[itemKey] = availableMarks[itemKey];
  }
};
const keys = {
  p: "paragraph",
  bq: "blockquote",
  hr: "horizontal_rule",
  img: "image",
  br: "hard_break",
  a: "link",
  i: "em",
  b: "strong",
  code: "code"
};
const topNodes = {
  multi_blocks: "block+",
  single_p: "paragraph"
};
const validImgClasses = ["float-left", "float-right", "align-left", "align-right", "align-center"];
const availableNodes = {
  text: {
    group: "inline"
  },
  div: {
    group: "block",
    content: "inline*",
    parseDOM: [{ tag: "div" }],
    toDOM() {
      return ["div", 0];
    }
  },
  cite: {
    group: "block",
    content: "inline*",
    parseDOM: [{ tag: "cite" }],
    toDOM() {
      return ["cite", 0];
    }
  },
  paragraph: {
    content: "inline*",
    group: "block",
    parseDOM: [{ tag: "p" }],
    toDOM() {
      return ["p", 0];
    }
  },
  blockquote: {
    content: "block+",
    group: "block",
    defining: true,
    parseDOM: [{ tag: "blockquote" }],
    toDOM() {
      return ["blockquote", 0];
    }
  },
  horizontal_rule: {
    group: "block",
    parseDOM: [{ tag: "hr" }],
    toDOM() {
      return ["hr"];
    }
  },
  image: {
    inline: true,
    attrs: {
      src: {},
      alt: { default: null },
      title: { default: null },
      class: { default: null }
    },
    group: "inline",
    draggable: true,
    parseDOM: [{
      tag: "img[src]",
      getAttrs(dom) {
        let cls = dom.className;
        if (validImgClasses.indexOf(cls) == -1)
          cls = "";
        let attrs = {
          src: dom.getAttribute("src"),
          title: dom.getAttribute("title"),
          alt: dom.getAttribute("alt") || "",
          class: cls
        };
        return attrs;
      }
    }],
    toDOM(node4) {
      return ["img", { src: node4.attrs.src, alt: node4.attrs.alt, title: node4.attrs.title, class: node4.attrs.class }];
    }
  },
  hard_break: {
    inline: true,
    group: "inline",
    selectable: false,
    parseDOM: [{ tag: "br" }],
    toDOM() {
      return ["br"];
    }
  }
};
const availableMarks = {
  link: {
    attrs: {
      href: {},
      title: { default: null }
    },
    inclusive: false,
    parseDOM: [{
      tag: "a[href]",
      getAttrs(dom) {
        return { href: dom.getAttribute("href"), title: dom.getAttribute("title") };
      }
    }],
    toDOM(node4) {
      let { href, title } = node4.attrs;
      return ["a", { href, title }, 0];
    }
  },
  em: {
    parseDOM: [{ tag: "i" }, { tag: "em" }, { style: "font-style=italic" }],
    toDOM() {
      return ["em", 0];
    }
  },
  strong: {
    parseDOM: [
      { tag: "strong" },
      { tag: "b", getAttrs: (node4) => node4.style.fontWeight != "normal" && null },
      { style: "font-weight", getAttrs: (value) => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null }
    ],
    toDOM() {
      return ["strong", 0];
    }
  },
  code: {
    parseDOM: [{ tag: "code" }],
    toDOM() {
      return ["code", 0];
    }
  }
};
const orderedList = {
  attrs: { order: { default: 1 } },
  parseDOM: [{
    tag: "ol",
    getAttrs(dom) {
      return { order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1 };
    }
  }],
  toDOM(node4) {
    return node4.attrs.order == 1 ? ["ol", 0] : ["ol", { start: node4.attrs.order }, 0];
  }
};
const bulletList = {
  parseDOM: [{ tag: "ul" }],
  toDOM() {
    return ["ul", 0];
  }
};
const listItem = {
  parseDOM: [{ tag: "li" }],
  toDOM() {
    return ["li", 0];
  },
  defining: true
};
function add2(obj, props) {
  let copy5 = {};
  for (let prop in obj)
    copy5[prop] = obj[prop];
  for (let prop in props)
    copy5[prop] = props[prop];
  return copy5;
}
function addHeadingNodes(nodes, def) {
  const info = /h([1-6])(?:_([2-6]))?/.exec(def);
  if (info) {
    const min3 = parseInt(info[1]);
    const max3 = parseInt(info[2] || info[1]);
    let parsers = [];
    for (let i2 = min3; i2 <= max3; i2++) {
      parsers.push({ tag: `h${i2}`, attrs: { level: i2 } });
    }
    Object.assign(nodes, {
      heading: {
        attrs: { level: { default: 2 } },
        content: "inline*",
        group: "block",
        defining: true,
        parseDOM: parsers,
        toDOM(node4) {
          return ["h" + node4.attrs.level, 0];
        }
      }
    });
  }
}
function addListNodes(nodes, def) {
  const toAppend = {
    list_item: add2(listItem, { content: "paragraph block*" })
  };
  if (def == "ul") {
    toAppend.bullet_list = add2(bulletList, { content: "list_item+", group: "block" });
  } else if (def == "ol") {
    toAppend.ordered_list = add2(orderedList, { content: "list_item+", group: "block" });
  } else if (def == "li") {
    toAppend.bullet_list = add2(bulletList, { content: "list_item+", group: "block" });
    toAppend.ordered_list = add2(orderedList, { content: "list_item+", group: "block" });
  }
  Object.assign(nodes, toAppend);
}
function wrapInList(listType, attrs) {
  return function(state, dispatch2) {
    let { $from, $to } = state.selection;
    let range2 = $from.blockRange($to), doJoin = false, outerRange = range2;
    if (!range2)
      return false;
    if (range2.depth >= 2 && $from.node(range2.depth - 1).type.compatibleContent(listType) && range2.startIndex == 0) {
      if ($from.index(range2.depth - 1) == 0)
        return false;
      let $insert = state.doc.resolve(range2.start - 2);
      outerRange = new NodeRange($insert, $insert, range2.depth);
      if (range2.endIndex < range2.parent.childCount)
        range2 = new NodeRange($from, state.doc.resolve($to.end(range2.depth)), range2.depth);
      doJoin = true;
    }
    let wrap = findWrapping3(outerRange, listType, attrs, range2);
    if (!wrap)
      return false;
    if (dispatch2)
      dispatch2(doWrapInList(state.tr, range2, wrap, doJoin, listType).scrollIntoView());
    return true;
  };
}
function doWrapInList(tr, range2, wrappers, joinBefore, listType) {
  let content2 = Fragment.empty;
  for (let i2 = wrappers.length - 1; i2 >= 0; i2--)
    content2 = Fragment.from(wrappers[i2].type.create(wrappers[i2].attrs, content2));
  tr.step(new ReplaceAroundStep(range2.start - (joinBefore ? 2 : 0), range2.end, range2.start, range2.end, new Slice(content2, 0, 0), wrappers.length, true));
  let found2 = 0;
  for (let i2 = 0; i2 < wrappers.length; i2++)
    if (wrappers[i2].type == listType)
      found2 = i2 + 1;
  let splitDepth = wrappers.length - found2;
  let splitPos = range2.start + wrappers.length - (joinBefore ? 2 : 0), parent = range2.parent;
  for (let i2 = range2.startIndex, e = range2.endIndex, first = true; i2 < e; i2++, first = false) {
    if (!first && canSplit(tr.doc, splitPos, splitDepth)) {
      tr.split(splitPos, splitDepth);
      splitPos += 2 * splitDepth;
    }
    splitPos += parent.child(i2).nodeSize;
  }
  return tr;
}
function splitListItem(itemType) {
  return function(state, dispatch2) {
    let { $from, $to, node: node4 } = state.selection;
    if (node4 && node4.isBlock || $from.depth < 2 || !$from.sameParent($to))
      return false;
    let grandParent = $from.node(-1);
    if (grandParent.type != itemType)
      return false;
    if ($from.parent.content.size == 0 && $from.node(-1).childCount == $from.indexAfter(-1)) {
      if ($from.depth == 2 || $from.node(-3).type != itemType || $from.index(-2) != $from.node(-2).childCount - 1)
        return false;
      if (dispatch2) {
        let wrap = Fragment.empty;
        let depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
        for (let d = $from.depth - depthBefore; d >= $from.depth - 3; d--)
          wrap = Fragment.from($from.node(d).copy(wrap));
        let depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
        wrap = wrap.append(Fragment.from(itemType.createAndFill()));
        let start3 = $from.before($from.depth - (depthBefore - 1));
        let tr2 = state.tr.replace(start3, $from.after(-depthAfter), new Slice(wrap, 4 - depthBefore, 0));
        let sel = -1;
        tr2.doc.nodesBetween(start3, tr2.doc.content.size, (node22, pos) => {
          if (sel > -1)
            return false;
          if (node22.isTextblock && node22.content.size == 0)
            sel = pos + 1;
        });
        if (sel > -1)
          tr2.setSelection(state.selection.constructor.near(tr2.doc.resolve(sel)));
        dispatch2(tr2.scrollIntoView());
      }
      return true;
    }
    let nextType = $to.pos == $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
    let tr = state.tr.delete($from.pos, $to.pos);
    let types = nextType && [null, { type: nextType }];
    if (!canSplit(tr.doc, $from.pos, 2, types))
      return false;
    if (dispatch2)
      dispatch2(tr.split($from.pos, 2, types).scrollIntoView());
    return true;
  };
}
function liftListItem(itemType) {
  return function(state, dispatch2) {
    let { $from, $to } = state.selection;
    let range2 = $from.blockRange($to, (node4) => node4.childCount && node4.firstChild.type == itemType);
    if (!range2)
      return false;
    if (!dispatch2)
      return true;
    return liftToOuterList(state, dispatch2, itemType, range2);
  };
}
function liftToOuterList(state, dispatch2, itemType, range2) {
  let tr = state.tr, end2 = range2.end, endOfList = range2.$to.end(range2.depth);
  if (end2 < endOfList) {
    tr.step(new ReplaceAroundStep(end2 - 1, endOfList, end2, endOfList, new Slice(Fragment.from(itemType.create(null, range2.parent.copy())), 1, 0), 1, true));
    range2 = new NodeRange(tr.doc.resolve(range2.$from.pos), tr.doc.resolve(endOfList), range2.depth);
  }
  dispatch2(tr.lift(range2, liftTarget(range2)).scrollIntoView());
  return true;
}
function sinkListItem(itemType) {
  return function(state, dispatch2) {
    let { $from, $to } = state.selection;
    let range2 = $from.blockRange($to, (node4) => node4.childCount && node4.firstChild.type == itemType);
    if (!range2)
      return false;
    let startIndex = range2.startIndex;
    if (startIndex == 0)
      return false;
    let parent = range2.parent, nodeBefore = parent.child(startIndex - 1);
    if (nodeBefore.type != itemType)
      return false;
    if (dispatch2) {
      let nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type == parent.type;
      let inner = Fragment.from(nestedBefore ? itemType.create() : null);
      let slice4 = new Slice(Fragment.from(itemType.create(null, Fragment.from(parent.type.create(null, inner)))), nestedBefore ? 3 : 1, 0);
      let before2 = range2.start, after2 = range2.end;
      dispatch2(state.tr.step(new ReplaceAroundStep(before2 - (nestedBefore ? 3 : 1), after2, before2, after2, slice4, 1, true)).scrollIntoView());
    }
    return true;
  };
}
const prefix = "ProseMirror-prompt";
function openPrompt(options, cls) {
  let wrapper = document.body.appendChild(document.createElement("div"));
  wrapper.className = prefix + (cls ? ` ${cls}` : "") + " bg-white p-3 border shadow-lg fixed z-10 rounded;";
  let mouseOutside = (e) => {
    if (!wrapper.contains(e.target))
      close3();
  };
  setTimeout(() => window.addEventListener("mousedown", mouseOutside), 50);
  let close3 = () => {
    window.removeEventListener("mousedown", mouseOutside);
    if (wrapper.parentNode)
      wrapper.parentNode.removeChild(wrapper);
  };
  let domFields = [];
  let teleportTarget = null;
  let form = document.createElement("form");
  form.addEventListener("submit", (e) => {
    console.log(e);
    e.preventDefault();
    e.stopPropagation();
    return false;
  });
  let teleport = null;
  if (options.teleport) {
    teleportTarget = document.createElement("div");
    form.appendChild(teleportTarget);
    const values = {};
    for (let name in options.fields) {
      const hf = document.createElement("input");
      hf.type = "hidden";
      hf.value = options.fields[name].options.value || null;
      hf.name = name;
      hf.getValue = () => {
        return hf.value || null;
      };
      domFields.push(hf);
      values[name] = hf.value;
    }
    teleport = {
      targetElement: teleportTarget,
      updateField(k, v2) {
        form.querySelector('input[name="' + k + '"]').value = v2;
      },
      values,
      options,
      getField(k) {
        return form.querySelector('input[name="' + k + '"]').value;
      }
    };
  } else {
    for (let name in options.fields) {
      domFields.push(options.fields[name].render());
    }
  }
  let submit = () => {
    let params = getValues(options.fields, domFields);
    if (params) {
      close3();
      options.callback(params);
    }
  };
  let submitButton = document.createElement("button");
  submitButton.type = "button";
  submitButton.addEventListener("click", submit);
  submitButton.className = prefix + "-submit border rounded shadow px-2 py-1 relative bg-brand text-white disabled:opacity-50";
  submitButton.textContent = "OK";
  let cancelButton = document.createElement("button");
  cancelButton.type = "button";
  cancelButton.className = prefix + "-cancel border rounded shadow px-2 py-1 relative bg-white border-brand text-brand disabled:opacity-50";
  cancelButton.textContent = "Cancel";
  cancelButton.addEventListener("click", close3);
  wrapper.appendChild(form);
  const tElt = document.createElement("h5");
  tElt.className = "text-xl border-b";
  if (options.title)
    form.appendChild(tElt).textContent = options.title;
  if (teleportTarget) {
    form.appendChild(teleportTarget);
  }
  domFields.forEach((field) => {
    form.appendChild(document.createElement("div")).appendChild(field);
  });
  let buttons = form.appendChild(document.createElement("div"));
  buttons.className = prefix + "-buttons block mt-1";
  buttons.appendChild(submitButton);
  buttons.appendChild(document.createTextNode(" "));
  buttons.appendChild(cancelButton);
  let box = wrapper.getBoundingClientRect();
  wrapper.style.top = (window.innerHeight - box.height) / 2 + "px";
  wrapper.style.left = (window.innerWidth - box.width) / 2 + "px";
  form.addEventListener("keydown", (e) => {
    if (e.keyCode == 27) {
      e.preventDefault();
      close3();
    } else if (e.keyCode == 13 && !(e.ctrlKey || e.metaKey || e.shiftKey)) {
      e.preventDefault();
      submit();
    } else if (e.keyCode == 9) {
      window.setTimeout(() => {
        if (!wrapper.contains(document.activeElement))
          close3();
      }, 500);
    }
  });
  let input = form.elements[0];
  if (input)
    input.focus();
  if (options.teleport) {
    options.teleport(teleport);
  }
}
function getValues(fields, domFields) {
  let result2 = /* @__PURE__ */ Object.create(null), i2 = 0;
  for (let name in fields) {
    let field = fields[name], dom = domFields[i2++];
    let value = field.read(dom), bad = field.validate(value);
    if (bad) {
      reportInvalid(dom, bad);
      return null;
    }
    result2[name] = field.clean(value);
  }
  return result2;
}
function reportInvalid(dom, message) {
  let parent = dom.parentNode;
  let msg = parent.appendChild(document.createElement("div"));
  msg.style.left = dom.offsetLeft + dom.offsetWidth + 2 + "px";
  msg.style.top = dom.offsetTop - 5 + "px";
  msg.className = "ProseMirror-invalid";
  msg.textContent = message;
  setTimeout(() => parent.removeChild(msg), 1500);
}
class Field {
  constructor(options) {
    __publicField(this, "options");
    this.options = options;
  }
  read(dom) {
    return dom.getValue();
  }
  validateType(_value) {
  }
  validate(value) {
    if (!value && this.options.required)
      return "Required field";
    return this.validateType(value) || this.options.validate && this.options.validate(value);
  }
  clean(value) {
    return this.options.clean ? this.options.clean(value) : value;
  }
}
class TextField extends Field {
  render() {
    let input = document.createElement("input");
    input.type = "text";
    input.className = "mt-2 block w-full border rounded p-1 focus:outline-none focus:ring focus:ring-brand focus:ring-opacity-50";
    input.placeholder = this.options.label;
    input.value = this.options.value || "";
    input.autocomplete = "off";
    input.getValue = () => {
      return input.value || null;
    };
    return input;
  }
}
class ImagePicker extends Field {
  render() {
    let div = document.createElement("div");
    div.className = "flex";
    let btn = document.createElement("div");
    btn.className = "px-2 border border-transparent rounded-right right-1 top-1 bottom-1 flex items-center text-medium text-sm text-gray hover:text-brand cursor-pointer bg-white";
    btn.innerText = "browse";
    let input = document.createElement("input");
    input.type = "text";
    input.className = "grow";
    input.placeholder = this.options.label;
    input.value = this.options.value || "";
    input.autocomplete = "off";
    div.appendChild(input);
    div.appendChild(btn);
    btn.addEventListener("click", (e) => {
      if (window.imagePicker) {
        window.imagePicker(input);
      }
    });
    div.getValue = () => {
      return input.value || null;
    };
    return div;
  }
}
class SelectField extends Field {
  render() {
    let select = document.createElement("select");
    this.options.options.forEach((o) => {
      let opt = select.appendChild(document.createElement("option"));
      opt.value = o.value;
      opt.selected = o.value == this.options.value;
      opt.label = o.label;
    });
    select.getValue = () => {
      return select.value || null;
    };
    return select;
  }
}
function canInsert(state, nodeType2) {
  let $from = state.selection.$from;
  for (let d = $from.depth; d >= 0; d--) {
    let index3 = $from.index(d);
    if ($from.node(d).canReplaceWith(index3, index3, nodeType2))
      return true;
  }
  return false;
}
function insertImageItem(nodeType2) {
  return new MenuItem({
    title: "Image",
    label: "Img",
    icon: icons.image,
    enable(state) {
      return canInsert(state, nodeType2);
    },
    run(state, _, view) {
      let { from: from5, to: to2 } = state.selection, attrs = null;
      if (state.selection instanceof NodeSelection && state.selection.node.type == nodeType2)
        attrs = state.selection.node.attrs;
      openPrompt({
        title: "Insert image",
        fields: {
          src: new ImagePicker({ label: "URL", required: true, value: attrs && attrs.src }),
          alt: new TextField({
            label: "Alt",
            value: attrs ? attrs.alt : state.doc.textBetween(from5, to2, " ")
          }),
          title: new TextField({ label: "Title", value: attrs && attrs.title })
        },
        callback(attrs2) {
          view.dispatch(view.state.tr.replaceSelectionWith(nodeType2.createAndFill(attrs2)));
          view.focus();
        }
      }, " w-full max-w-xl min-w-min");
    }
  });
}
function cmdItem(cmd, options) {
  let passedOptions = {
    label: options.title,
    run: cmd
  };
  for (let prop in options)
    passedOptions[prop] = options[prop];
  if ((!options.enable || options.enable === true) && !options.select)
    passedOptions[options.enable ? "enable" : "select"] = (state) => cmd(state);
  return new MenuItem(passedOptions);
}
function markActive(state, type) {
  let { from: from5, $from, to: to2, empty: empty2 } = state.selection;
  if (empty2)
    return type.isInSet(state.storedMarks || $from.marks());
  else
    return state.doc.rangeHasMark(from5, to2, type);
}
function markItem(markType, options) {
  let passedOptions = {
    active(state) {
      return markActive(state, markType);
    },
    enable: true
  };
  for (let prop in options)
    passedOptions[prop] = options[prop];
  return cmdItem(toggleMark(markType), passedOptions);
}
function linkItem(markType, teleportCallback) {
  return new MenuItem({
    title: "Add or remove link",
    icon: icons.link,
    active(state) {
      return markActive(state, markType);
    },
    enable(state) {
      return !state.selection.empty;
    },
    run(state, dispatch2, view) {
      const attrs = {
        href: null,
        title: null
      };
      const isActive = markActive(state, markType);
      if (isActive) {
        toggleMark(markType)(view.state, view.dispatch);
      } else {
        const options = {
          title: "Link",
          teleport: null,
          fields: {
            href: new TextField({
              label: "Link target",
              value: attrs.href
            }),
            title: new TextField({ label: "Title", value: attrs.title })
          },
          callback(attrs2) {
            toggleMark(markType, attrs2)(view.state, view.dispatch);
            view.focus();
          }
        };
        if (teleportCallback) {
          options.teleport = teleportCallback;
        }
        openPrompt(options, " w-full max-w-xl min-w-min");
      }
    }
  });
}
function wrapListItem(nodeType2, options) {
  return cmdItem(wrapInList(nodeType2, options.attrs), options);
}
function buildMenuItems(schema, vues) {
  let r = {}, type;
  if (type = schema.marks.strong) {
    r.toggleStrong = markItem(type, { title: "Toggle strong style", icon: icons.strong });
  }
  if (type = schema.marks.em) {
    r.toggleEm = markItem(type, { title: "Toggle emphasis", icon: icons.em });
  }
  if (type = schema.marks.bigger) {
    r.toggleBigger = markItem(type, { title: "Toggle bigger text", icon: icons.strong });
  }
  if (type = schema.marks.smaller) {
    r.toggleSmaller = markItem(type, { title: "Toggle smaller text", icon: icons.strong });
  }
  if (type = schema.marks.code) {
    r.toggleCode = markItem(type, { title: "Toggle code font", icon: icons.code });
  }
  if (type = schema.marks.link) {
    const v2 = vues && vues.hasOwnProperty("link") ? vues.link : null;
    r.toggleLink = linkItem(type, v2);
  }
  if (type = schema.nodes.image) {
    r.insertImage = insertImageItem(type);
  }
  if (type = schema.nodes.bullet_list) {
    r.wrapBulletList = wrapListItem(type, {
      title: "Wrap in bullet list",
      icon: icons.bulletList
    });
  }
  if (type = schema.nodes.ordered_list) {
    r.wrapOrderedList = wrapListItem(type, {
      title: "Wrap in ordered list",
      icon: icons.orderedList
    });
  }
  if (type = schema.nodes.blockquote) {
    r.wrapBlockQuote = wrapItem(type, {
      title: "Wrap in block quote",
      icon: icons.blockquote
    });
    r.makeCite = blockTypeItem(schema.nodes.cite, {
      title: "Change to cite",
      label: "Sign",
      selectable: true
    });
  }
  if (type = schema.nodes.paragraph) {
    r.makeParagraph = blockTypeItem(type, {
      title: "Change to paragraph",
      label: "P",
      selectable: true
    });
  }
  if (type = schema.nodes.div) {
    r.makeDiv = blockTypeItem(type, {
      title: "Change to div",
      label: "div",
      selectable: true
    });
  }
  if (type = schema.nodes.code_block) {
    r.makeCodeBlock = blockTypeItem(type, {
      title: "Change to code block",
      label: "Code",
      selectable: true
    });
  }
  if (type = schema.nodes.heading) {
    for (let i2 = 0; i2 < schema.nodes.heading.spec.parseDOM.length; i2++) {
      r["makeHead" + schema.nodes.heading.spec.parseDOM[i2].attrs.level] = blockTypeItem(type, {
        title: "Change to heading " + schema.nodes.heading.spec.parseDOM[i2].attrs.level,
        label: "H" + schema.nodes.heading.spec.parseDOM[i2].attrs.level,
        attrs: { level: schema.nodes.heading.spec.parseDOM[i2].attrs.level },
        selectable: true
      });
    }
  }
  if (type = schema.nodes.horizontal_rule) {
    let hr = type;
    r.insertHorizontalRule = new MenuItem({
      title: "Insert horizontal rule",
      icon: icons.hr,
      enable(state) {
        return canInsert(state, hr);
      },
      run(state, dispatch2) {
        dispatch2(state.tr.replaceSelectionWith(hr.create()));
      }
    });
  }
  let cut3 = (arr) => arr.filter((x2) => x2);
  r.insertMenu = new Dropdown(cut3([r.insertImage, r.insertHorizontalRule]), { label: "Ins." });
  r.inlineMenu = [cut3([r.toggleStrong, r.toggleEm, r.toggleBigger, r.toggleSmaller, r.toggleCode])];
  r.insMenu = [cut3([r.toggleLink, r.insertImage, r.insertHorizontalRule])];
  r.typeMenu = [cut3([r.makeParagraph, r.makeCite, r.makeHead1, r.makeHead2, r.makeHead3, r.makeHead4, r.makeHead5, r.makeHead6, r.makeDiv])];
  r.blockMenu = [cut3([
    r.wrapBulletList,
    r.wrapOrderedList,
    r.wrapBlockQuote,
    joinUpItem,
    liftItem,
    selectParentNodeItem
  ])];
  r.fullMenu = [].concat([[undoItem, redoItem]], r.inlineMenu, r.typeMenu, r.blockMenu, r.insMenu);
  return r;
}
var InputRule = function InputRule2(match, handler) {
  this.match = match;
  this.handler = typeof handler == "string" ? stringHandler(handler) : handler;
};
function stringHandler(string2) {
  return function(state, match, start3, end2) {
    var insert = string2;
    if (match[1]) {
      var offset3 = match[0].lastIndexOf(match[1]);
      insert += match[0].slice(offset3 + match[1].length);
      start3 += offset3;
      var cutOff = start3 - end2;
      if (cutOff > 0) {
        insert = match[0].slice(offset3 - cutOff, offset3) + insert;
        start3 = end2;
      }
    }
    return state.tr.insertText(insert, start3, end2);
  };
}
var MAX_MATCH = 500;
function inputRules(ref2) {
  var rules = ref2.rules;
  var plugin = new Plugin({
    state: {
      init: function init6() {
        return null;
      },
      apply: function apply8(tr, prev) {
        var stored = tr.getMeta(this);
        if (stored) {
          return stored;
        }
        return tr.selectionSet || tr.docChanged ? null : prev;
      }
    },
    props: {
      handleTextInput: function handleTextInput(view, from5, to2, text2) {
        return run(view, from5, to2, text2, rules, plugin);
      },
      handleDOMEvents: {
        compositionend: function(view) {
          setTimeout(function() {
            var ref3 = view.state.selection;
            var $cursor = ref3.$cursor;
            if ($cursor) {
              run(view, $cursor.pos, $cursor.pos, "", rules, plugin);
            }
          });
        }
      }
    },
    isInputRules: true
  });
  return plugin;
}
function run(view, from5, to2, text2, rules, plugin) {
  if (view.composing) {
    return false;
  }
  var state = view.state, $from = state.doc.resolve(from5);
  if ($from.parent.type.spec.code) {
    return false;
  }
  var textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - MAX_MATCH), $from.parentOffset, null, "\uFFFC") + text2;
  for (var i2 = 0; i2 < rules.length; i2++) {
    var match = rules[i2].match.exec(textBefore);
    var tr = match && rules[i2].handler(state, match, from5 - (match[0].length - text2.length), to2);
    if (!tr) {
      continue;
    }
    view.dispatch(tr.setMeta(plugin, { transform: tr, from: from5, to: to2, text: text2 }));
    return true;
  }
  return false;
}
function undoInputRule(state, dispatch2) {
  var plugins = state.plugins;
  for (var i2 = 0; i2 < plugins.length; i2++) {
    var plugin = plugins[i2], undoable = void 0;
    if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
      if (dispatch2) {
        var tr = state.tr, toUndo = undoable.transform;
        for (var j = toUndo.steps.length - 1; j >= 0; j--) {
          tr.step(toUndo.steps[j].invert(toUndo.docs[j]));
        }
        if (undoable.text) {
          var marks2 = tr.doc.resolve(undoable.from).marks();
          tr.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks2));
        } else {
          tr.delete(undoable.from, undoable.to);
        }
        dispatch2(tr);
      }
      return true;
    }
  }
  return false;
}
var emDash = new InputRule(/--$/, "\u2014");
var ellipsis = new InputRule(/\.\.\.$/, "\u2026");
var openDoubleQuote = new InputRule(/(?:^|[\s\{\[\(\<'"\u2018\u201C])(")$/, "\u201C");
var closeDoubleQuote = new InputRule(/"$/, "\u201D");
var openSingleQuote = new InputRule(/(?:^|[\s\{\[\(\<'"\u2018\u201C])(')$/, "\u2018");
var closeSingleQuote = new InputRule(/'$/, "\u2019");
var smartQuotes = [openDoubleQuote, closeDoubleQuote, openSingleQuote, closeSingleQuote];
function wrappingInputRule(regexp, nodeType2, getAttrs, joinPredicate) {
  return new InputRule(regexp, function(state, match, start3, end2) {
    var attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
    var tr = state.tr.delete(start3, end2);
    var $start = tr.doc.resolve(start3), range2 = $start.blockRange(), wrapping = range2 && findWrapping3(range2, nodeType2, attrs);
    if (!wrapping) {
      return null;
    }
    tr.wrap(range2, wrapping);
    var before2 = tr.doc.resolve(start3 - 1).nodeBefore;
    if (before2 && before2.type == nodeType2 && canJoin(tr.doc, start3 - 1) && (!joinPredicate || joinPredicate(match, before2))) {
      tr.join(start3 - 1);
    }
    return tr;
  });
}
function textblockTypeInputRule(regexp, nodeType2, getAttrs) {
  return new InputRule(regexp, function(state, match, start3, end2) {
    var $start = state.doc.resolve(start3);
    var attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
    if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType2)) {
      return null;
    }
    return state.tr.delete(start3, end2).setBlockType(start3, start3, nodeType2, attrs);
  });
}
const mac = typeof navigator != "undefined" ? /Mac/.test(navigator.platform) : false;
function buildKeymap(schema, mapKeys) {
  let keys2 = {}, type;
  function bind2(key, cmd) {
    if (mapKeys) {
      let mapped = mapKeys[key];
      if (mapped === false)
        return;
      if (mapped)
        key = mapped;
    }
    keys2[key] = cmd;
  }
  bind2("Mod-z", undo);
  bind2("Shift-Mod-z", redo);
  bind2("Backspace", undoInputRule);
  if (!mac)
    bind2("Mod-y", redo);
  bind2("Alt-ArrowUp", joinUp);
  bind2("Alt-ArrowDown", joinDown);
  bind2("Mod-BracketLeft", lift);
  bind2("Escape", selectParentNode);
  if (type = schema.marks.strong) {
    bind2("Mod-b", toggleMark(type));
    bind2("Mod-B", toggleMark(type));
  }
  if (type = schema.marks.em) {
    bind2("Mod-i", toggleMark(type));
    bind2("Mod-I", toggleMark(type));
  }
  if (type = schema.marks.code)
    bind2("Mod-`", toggleMark(type));
  if (type = schema.nodes.bullet_list)
    bind2("Shift-Ctrl-8", wrapInList(type));
  if (type = schema.nodes.ordered_list)
    bind2("Shift-Ctrl-9", wrapInList(type));
  if (type = schema.nodes.blockquote)
    bind2("Ctrl->", wrapIn(type));
  if (type = schema.nodes.hard_break) {
    let br = type, cmd = chainCommands(exitCode, (state, dispatch2) => {
      dispatch2(state.tr.replaceSelectionWith(br.create()).scrollIntoView());
      return true;
    });
    bind2("Mod-Enter", cmd);
    bind2("Shift-Enter", cmd);
    if (mac)
      bind2("Ctrl-Enter", cmd);
  }
  if (type = schema.nodes.list_item) {
    bind2("Enter", splitListItem(type));
    bind2("Mod-[", liftListItem(type));
    bind2("Mod-]", sinkListItem(type));
  }
  if (type = schema.nodes.paragraph)
    bind2("Shift-Ctrl-0", setBlockType(type));
  if (type = schema.nodes.code_block)
    bind2("Shift-Ctrl-\\", setBlockType(type));
  if (type = schema.nodes.heading)
    for (let i2 = 1; i2 <= 6; i2++)
      bind2("Shift-Ctrl-" + i2, setBlockType(type, { level: i2 }));
  if (type = schema.nodes.horizontal_rule) {
    let hr = type;
    bind2("Mod-_", (state, dispatch2) => {
      dispatch2(state.tr.replaceSelectionWith(hr.create()).scrollIntoView());
      return true;
    });
  }
  return keys2;
}
function blockQuoteRule(nodeType2) {
  return wrappingInputRule(/^\s*>\s$/, nodeType2);
}
function orderedListRule(nodeType2) {
  return wrappingInputRule(/^(\d+)\.\s$/, nodeType2, (match) => ({ order: +match[1] }), (match, node4) => node4.childCount + node4.attrs.order == +match[1]);
}
function bulletListRule(nodeType2) {
  return wrappingInputRule(/^\s*([-+*])\s$/, nodeType2);
}
function codeBlockRule(nodeType2) {
  return textblockTypeInputRule(/^```$/, nodeType2);
}
function headingRule(nodeType2, maxLevel) {
  return textblockTypeInputRule(new RegExp("^(#{1," + maxLevel + "})\\s$"), nodeType2, (match) => ({ level: match[1].length }));
}
function buildInputRules(schema) {
  let rules = smartQuotes.concat(ellipsis, emDash), type;
  if (type = schema.nodes.blockquote)
    rules.push(blockQuoteRule(type));
  if (type = schema.nodes.ordered_list)
    rules.push(orderedListRule(type));
  if (type = schema.nodes.bullet_list)
    rules.push(bulletListRule(type));
  if (type = schema.nodes.code_block)
    rules.push(codeBlockRule(type));
  if (type = schema.nodes.heading)
    rules.push(headingRule(type, 6));
  return inputRules({ rules });
}
function useLinkTooltip(options) {
  let pluginOptions = {
    teleport: options.vues && options.vues.hasOwnProperty("link") ? options.vues.link : null
  };
  return new Plugin({
    view(editorView) {
      return new LinkTooltip(editorView, pluginOptions);
    }
  });
}
function queryLinkAttrs() {
  return (state) => {
    const { $from } = state.selection;
    const pos = $from.pos - $from.textOffset;
    const $pos = state.doc.resolve(pos);
    state.doc.nodeAt(pos);
    const { nodeAfter } = $pos;
    if (!nodeAfter) {
      return;
    }
    const type = state.schema.marks.link;
    const mark3 = type.isInSet(nodeAfter.marks || []);
    if (mark3) {
      return {
        href: mark3.attrs.href,
        title: mark3.attrs.title
      };
    }
  };
}
class LinkTooltip {
  constructor(view, options) {
    __publicField(this, "tooltip");
    __publicField(this, "tooltipText");
    __publicField(this, "options");
    var _a;
    this.options = options;
    this.tooltip = document.createElement("div");
    this.tooltip.className = "absolute border-2 px-2 py-1 rounded bg-white -translate-x-1/2 z-10 cursor-pointer flex justify-center items-center";
    (_a = view.dom.parentNode) == null ? void 0 : _a.appendChild(this.tooltip);
    const icon = getIcon(icons.link);
    icon.classList.add("text-slate-500", "p-0");
    this.tooltip.appendChild(icon);
    this.tooltip.style.display = "none";
    this.tooltipText = document.createElement("span");
    this.tooltipText.className = "pl-2";
    this.tooltip.appendChild(this.tooltipText);
    this.update(view, view.state);
    const _this = this;
    this.tooltip.addEventListener("click", function() {
      let state = view.state;
      const linkAttrs = queryLinkAttrs()(state);
      const promptOptions = {
        teleport: null,
        title: "Link",
        fields: {
          href: new TextField({
            label: "Link target",
            value: linkAttrs == null ? void 0 : linkAttrs.href
          }),
          title: new TextField({ label: "Title", value: linkAttrs == null ? void 0 : linkAttrs.title })
        },
        callback(attrs) {
          const { tr, schema, doc: doc2 } = state;
          if (tr.selection.empty) {
            const { $from } = state.selection;
            const start3 = $from.pos - $from.textOffset;
            let node4 = doc2.nodeAt($from.pos - $from.textOffset);
            const end2 = start3 + node4.nodeSize;
            tr.setSelection(TextSelection.create(doc2, start3, end2));
          }
          tr.removeMark(tr.selection.$from.pos, tr.selection.$to.pos, schema.marks.link);
          if (attrs.href) {
            const mark3 = schema.marks.link.create({
              href: attrs.href,
              title: attrs.title
            });
            tr.addMark(tr.selection.$from.pos, tr.selection.$to.pos, mark3);
          }
          view.dispatch(tr);
          view.focus();
        }
      };
      if (_this.options.teleport) {
        promptOptions.teleport = _this.options.teleport;
      }
      openPrompt(promptOptions, " w-full max-w-xl min-w-min");
    });
  }
  update(view, lastState) {
    var _a;
    let state = view.state;
    const linkAttrs = queryLinkAttrs()(state);
    if (lastState && lastState.doc.eq(state.doc) && lastState.selection.eq(state.selection))
      return;
    if (!linkAttrs || !linkAttrs.href) {
      this.tooltip.style.display = "none";
      return;
    }
    this.tooltip.style.display = "";
    let { from: from5, to: to2 } = state.selection;
    let start3 = view.coordsAtPos(from5), end2 = view.coordsAtPos(to2);
    let box = (_a = this.tooltip.offsetParent) == null ? void 0 : _a.getBoundingClientRect();
    let left = Math.max((start3.left + end2.left) / 2, start3.left + 3);
    this.tooltip.style.left = left - box.left + "px";
    this.tooltip.style.bottom = box.bottom - start3.top + 4 + "px";
    this.tooltipText.textContent = linkAttrs.href;
  }
  destroy() {
    this.tooltip.remove();
  }
}
function editorSetup(options) {
  let plugins = [
    buildInputRules(options.schema),
    keymap(buildKeymap(options.schema, options.mapKeys)),
    keymap(baseKeymap),
    dropCursor(),
    gapCursor(),
    useLinkTooltip({ vues: options.vues })
  ];
  if (options.menuBar !== false)
    plugins.push(menuBar({
      floating: options.floatingMenu !== false,
      content: options.menuContent || buildMenuItems(options.schema, options.vues).fullMenu
    }));
  if (options.history !== false)
    plugins.push(history());
  let size = "text-" + (options.size ? options.size : "sm");
  plugins.push(new Plugin({
    props: {
      attributes: { class: "prose px-3 py-2 rounded " + size }
    }
  }));
  plugins.push(new Plugin({
    props: {
      handleDoubleClickOn(view, pos, node4, nodePos, event, direct) {
        if (node4.type.name === "image") {
          openPrompt({
            title: "Insert image",
            fields: {
              src: new ImagePicker({
                label: "URL",
                required: true,
                value: node4.attrs.src
              }),
              alt: new TextField({
                label: "Alt",
                value: node4.attrs.alt
              }),
              class: new SelectField({
                label: "Class",
                value: node4.attrs.class,
                options: [
                  { value: "w-full", label: "Full width" },
                  { value: "align-left", label: "Align left" },
                  { value: "align-right", label: "Align right" },
                  { value: "align-center", label: "Align center" },
                  { value: "float-left", label: "Float left" },
                  { value: "float-right", label: "Float right" }
                ]
              }),
              title: new TextField({
                label: "Title",
                value: node4.attrs.title
              })
            },
            callback(attrs) {
              if (view.state.tr.selection.empty) {
                view.dispatch(view.state.tr.setSelection(NodeSelection.create(view.state.doc, nodePos)));
              }
              if (node4) {
                view.dispatch(view.state.tr.replaceSelectionWith(node4.type.createAndFill(attrs)));
              }
              view.focus();
            }
          }, " w-full max-w-xl min-w-min");
          return true;
        }
        return false;
      }
    }
  }));
  return plugins;
}
function getHTML(schema, state, props) {
  const div = document.createElement("div");
  const fragment = DOMSerializer.fromSchema(schema).serializeFragment(state.doc.content);
  div.appendChild(fragment);
  let v2 = div.innerHTML.replace(/^<(p|(h[1-6]))><\/(p|(h[1-6]))>$/g, "");
  if (props.unwrap) {
    v2 = v2.replace(/^<[^>]+>(.*)<\/[^>]+>$/, "$1");
  }
  return v2;
}
function createDoc(schema, htmlString) {
  let dom = document.createElement("div");
  dom.innerHTML = htmlString;
  return DOMParser.fromSchema(schema).parse(dom);
}
const _sfc_main$3 = defineComponent({
  name: "SHTMLInput",
  props: {
    modelValue: {
      type: String,
      default: null
    },
    plugins: {
      type: Array,
      default: () => []
    },
    unwrap: {
      type: Boolean,
      default: null
    },
    schema: {
      type: String,
      default: "content"
    }
  },
  setup(props, { emit: emit2, slots }) {
    const id = ref(uuid());
    let schema = markRaw(createSchema(props.schema));
    const editor = ref(null);
    let view = null;
    let linkPickerForm = ref(null);
    let linkPickerUpdateField = ref(null);
    let linkPickerGetField = ref(null);
    watch(() => props.schema, (newSchema) => {
      if (view) {
        schema = markRaw(createSchema(newSchema));
        let plugins = editorSetup({
          schema,
          size: props.size,
          vues: slots.linkPicker ? {
            link(tp) {
              linkPickerGetField.value = tp.getField;
              linkPickerUpdateField.value = tp.updateField;
              linkPickerForm.value = tp.targetElement;
            }
          } : null
        });
        if (props.plugins && props.plugins.length) {
          plugins = plugins.concat(...props.plugins);
        }
        view.updateState(EditorState.create({
          doc: createDoc(schema, props.modelValue),
          plugins
        }));
      }
    });
    watch(() => props.disabled, (newDisabledValue) => {
      if (view) {
        if (newDisabledValue) {
          view.docView.dom.classList.add("opacity-50");
        } else {
          view.docView.dom.classList.remove("opacity-50");
        }
        view.updateState(view.state);
      }
    });
    watch(() => props.modelValue, (newValue) => {
      if (view && newValue != getHTML(schema, view.state, props)) {
        view.updateState(EditorState.create({
          doc: createDoc(schema, newValue),
          plugins: view.state.plugins
        }));
      }
    });
    watch(editor, (newEditor) => {
      if (newEditor && !view) {
        createEditor();
      }
    });
    function createEditor() {
      const el = document.getElementById(id.value);
      if (el && !view) {
        let plugins = editorSetup({
          schema,
          size: props.size,
          vues: slots.linkPicker ? {
            link(tp) {
              linkPickerGetField.value = tp.getField;
              linkPickerUpdateField.value = tp.updateField;
              linkPickerForm.value = tp.targetElement;
            }
          } : null
        });
        if (props.plugins && props.plugins.length) {
          plugins = plugins.concat(...props.plugins);
        }
        view = new EditorView(el, {
          state: EditorState.create({
            doc: createDoc(schema, props.modelValue),
            plugins
          }),
          editable() {
            return !props.disabled;
          },
          dispatchTransaction(transaction) {
            if (view == null ? void 0 : view.editable) {
              let newState = view.state.apply(transaction);
              let newValue = getHTML(schema, newState, props);
              if (newValue != props.modelValue) {
                emit2("update:modelValue", newValue);
              }
              view.updateState(newState);
            }
          }
        });
      } else {
        setTimeout(createEditor, 100);
      }
    }
    onMounted(() => {
      nextTick(createEditor);
    });
    return {
      editor,
      linkPickerForm,
      linkPickerUpdateField,
      linkPickerGetField,
      id
    };
  }
});
const _hoisted_1$3 = { class: "border rounded relative" };
const _hoisted_2$2 = ["id"];
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(Fragment$1, null, [
    createElementVNode("div", _hoisted_1$3, [
      createElementVNode("div", {
        id: _ctx.id,
        ref: "editor",
        class: "w-full h-full"
      }, null, 8, _hoisted_2$2)
    ]),
    _ctx.linkPickerForm ? (openBlock(), createBlock(Teleport, {
      key: 0,
      to: _ctx.linkPickerForm
    }, [
      renderSlot(_ctx.$slots, "linkPicker", {
        updateField: _ctx.linkPickerUpdateField,
        getField: _ctx.linkPickerGetField
      })
    ], 8, ["to"])) : createCommentVNode("", true)
  ], 64);
}
var SHTMLInput = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3]]);
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys$1(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread2$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$1(Object(source2), true).forEach(function(key) {
        _defineProperty$1(target, key, source2[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
    } else {
      ownKeys$1(Object(source2)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
      });
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source2, excluded) {
  if (source2 == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source2);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source2[key];
  }
  return target;
}
function _objectWithoutProperties(source2, excluded) {
  if (source2 == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source2, excluded);
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source2);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source2, key))
        continue;
      target[key] = source2[key];
    }
  }
  return target;
}
function _slicedToArray(arr, i2) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i2) || _unsupportedIterableToArray(arr, i2) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit(arr, i2) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr)))
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = void 0;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err2) {
    _d = true;
    _e = err2;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys(Object(source2), true).forEach(function(key) {
        _defineProperty(target, key, source2[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
    } else {
      ownKeys(Object(source2)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
      });
    }
  }
  return target;
}
function compose$1() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function(x2) {
    return fns.reduceRight(function(y, f) {
      return f(y);
    }, x2);
  };
}
function curry$1(fn) {
  return function curried() {
    var _this = this;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return args.length >= fn.length ? fn.apply(this, args) : function() {
      for (var _len3 = arguments.length, nextArgs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        nextArgs[_key3] = arguments[_key3];
      }
      return curried.apply(_this, [].concat(args, nextArgs));
    };
  };
}
function isObject$2(value) {
  return {}.toString.call(value).includes("Object");
}
function isEmpty(obj) {
  return !Object.keys(obj).length;
}
function isFunction(value) {
  return typeof value === "function";
}
function hasOwnProperty$1(object, property) {
  return Object.prototype.hasOwnProperty.call(object, property);
}
function validateChanges(initial, changes) {
  if (!isObject$2(changes))
    errorHandler$1("changeType");
  if (Object.keys(changes).some(function(field) {
    return !hasOwnProperty$1(initial, field);
  }))
    errorHandler$1("changeField");
  return changes;
}
function validateSelector(selector2) {
  if (!isFunction(selector2))
    errorHandler$1("selectorType");
}
function validateHandler(handler) {
  if (!(isFunction(handler) || isObject$2(handler)))
    errorHandler$1("handlerType");
  if (isObject$2(handler) && Object.values(handler).some(function(_handler) {
    return !isFunction(_handler);
  }))
    errorHandler$1("handlersType");
}
function validateInitial(initial) {
  if (!initial)
    errorHandler$1("initialIsRequired");
  if (!isObject$2(initial))
    errorHandler$1("initialType");
  if (isEmpty(initial))
    errorHandler$1("initialContent");
}
function throwError$1(errorMessages2, type) {
  throw new Error(errorMessages2[type] || errorMessages2["default"]);
}
var errorMessages$1 = {
  initialIsRequired: "initial state is required",
  initialType: "initial state should be an object",
  initialContent: "initial state shouldn't be an empty object",
  handlerType: "handler should be an object or a function",
  handlersType: "all handlers should be a functions",
  selectorType: "selector should be a function",
  changeType: "provided value of changes should be an object",
  changeField: 'it seams you want to change a field in the state which is not specified in the "initial" state',
  "default": "an unknown error accured in `state-local` package"
};
var errorHandler$1 = curry$1(throwError$1)(errorMessages$1);
var validators$1 = {
  changes: validateChanges,
  selector: validateSelector,
  handler: validateHandler,
  initial: validateInitial
};
function create5(initial) {
  var handler = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  validators$1.initial(initial);
  validators$1.handler(handler);
  var state = {
    current: initial
  };
  var didUpdate = curry$1(didStateUpdate)(state, handler);
  var update3 = curry$1(updateState2)(state);
  var validate2 = curry$1(validators$1.changes)(initial);
  var getChanges = curry$1(extractChanges)(state);
  function getState4() {
    var selector2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(state2) {
      return state2;
    };
    validators$1.selector(selector2);
    return selector2(state.current);
  }
  function setState2(causedChanges) {
    compose$1(didUpdate, update3, validate2, getChanges)(causedChanges);
  }
  return [getState4, setState2];
}
function extractChanges(state, causedChanges) {
  return isFunction(causedChanges) ? causedChanges(state.current) : causedChanges;
}
function updateState2(state, changes) {
  state.current = _objectSpread2(_objectSpread2({}, state.current), changes);
  return changes;
}
function didStateUpdate(state, handler, changes) {
  isFunction(handler) ? handler(state.current) : Object.keys(changes).forEach(function(field) {
    var _handler$field;
    return (_handler$field = handler[field]) === null || _handler$field === void 0 ? void 0 : _handler$field.call(handler, state.current[field]);
  });
  return changes;
}
var index2 = {
  create: create5
};
var config$1 = {
  paths: {
    vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.33.0/min/vs"
  }
};
function curry(fn) {
  return function curried() {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return args.length >= fn.length ? fn.apply(this, args) : function() {
      for (var _len2 = arguments.length, nextArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        nextArgs[_key2] = arguments[_key2];
      }
      return curried.apply(_this, [].concat(args, nextArgs));
    };
  };
}
function isObject$1(value) {
  return {}.toString.call(value).includes("Object");
}
function validateConfig(config2) {
  if (!config2)
    errorHandler("configIsRequired");
  if (!isObject$1(config2))
    errorHandler("configType");
  if (config2.urls) {
    informAboutDeprecation();
    return {
      paths: {
        vs: config2.urls.monacoBase
      }
    };
  }
  return config2;
}
function informAboutDeprecation() {
  console.warn(errorMessages.deprecation);
}
function throwError(errorMessages2, type) {
  throw new Error(errorMessages2[type] || errorMessages2["default"]);
}
var errorMessages = {
  configIsRequired: "the configuration object is required",
  configType: "the configuration object should be an object",
  "default": "an unknown error accured in `@monaco-editor/loader` package",
  deprecation: "Deprecation warning!\n    You are using deprecated way of configuration.\n\n    Instead of using\n      monaco.config({ urls: { monacoBase: '...' } })\n    use\n      monaco.config({ paths: { vs: '...' } })\n\n    For more please check the link https://github.com/suren-atoyan/monaco-loader#config\n  "
};
var errorHandler = curry(throwError)(errorMessages);
var validators = {
  config: validateConfig
};
var compose = function compose2() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function(x2) {
    return fns.reduceRight(function(y, f) {
      return f(y);
    }, x2);
  };
};
function merge3(target, source2) {
  Object.keys(source2).forEach(function(key) {
    if (source2[key] instanceof Object) {
      if (target[key]) {
        Object.assign(source2[key], merge3(target[key], source2[key]));
      }
    }
  });
  return _objectSpread2$1(_objectSpread2$1({}, target), source2);
}
var CANCELATION_MESSAGE = {
  type: "cancelation",
  msg: "operation is manually canceled"
};
function makeCancelable(promise) {
  var hasCanceled_ = false;
  var wrappedPromise = new Promise(function(resolve7, reject) {
    promise.then(function(val) {
      return hasCanceled_ ? reject(CANCELATION_MESSAGE) : resolve7(val);
    });
    promise["catch"](reject);
  });
  return wrappedPromise.cancel = function() {
    return hasCanceled_ = true;
  }, wrappedPromise;
}
var _state$create = index2.create({
  config: config$1,
  isInitialized: false,
  resolve: null,
  reject: null,
  monaco: null
}), _state$create2 = _slicedToArray(_state$create, 2), getState3 = _state$create2[0], setState = _state$create2[1];
function config(globalConfig) {
  var _validators$config = validators.config(globalConfig), monaco = _validators$config.monaco, config2 = _objectWithoutProperties(_validators$config, ["monaco"]);
  setState(function(state) {
    return {
      config: merge3(state.config, config2),
      monaco
    };
  });
}
function init5() {
  var state = getState3(function(_ref) {
    var monaco = _ref.monaco, isInitialized = _ref.isInitialized;
    return {
      monaco,
      isInitialized
    };
  });
  if (!state.isInitialized) {
    setState({
      isInitialized: true
    });
    if (state.monaco) {
      return makeCancelable(Promise.resolve(state.monaco));
    }
    if (window.monaco && window.monaco.editor) {
      storeMonacoInstance(window.monaco);
      return makeCancelable(Promise.resolve(window.monaco));
    }
    compose(injectScripts, getMonacoLoaderScript)(configureLoader);
  }
  return makeCancelable(wrapperPromise);
}
function injectScripts(script) {
  return document.body.appendChild(script);
}
function createScript(src) {
  var script = document.createElement("script");
  return src && (script.src = src), script;
}
function getMonacoLoaderScript(configureLoader2) {
  var state = getState3(function(_ref2) {
    var config2 = _ref2.config, reject = _ref2.reject;
    return {
      config: config2,
      reject
    };
  });
  var loaderScript = createScript("".concat(state.config.paths.vs, "/loader.js"));
  loaderScript.onload = function() {
    return configureLoader2();
  };
  loaderScript.onerror = state.reject;
  return loaderScript;
}
function configureLoader() {
  var state = getState3(function(_ref3) {
    var config2 = _ref3.config, resolve7 = _ref3.resolve, reject = _ref3.reject;
    return {
      config: config2,
      resolve: resolve7,
      reject
    };
  });
  var require2 = window.require;
  require2.config(state.config);
  require2(["vs/editor/editor.main"], function(monaco) {
    storeMonacoInstance(monaco);
    state.resolve(monaco);
  }, function(error) {
    state.reject(error);
  });
}
function storeMonacoInstance(monaco) {
  if (!getState3().monaco) {
    setState({
      monaco
    });
  }
}
function __getMonacoInstance() {
  return getState3(function(_ref4) {
    var monaco = _ref4.monaco;
    return monaco;
  });
}
var wrapperPromise = new Promise(function(resolve7, reject) {
  return setState({
    resolve: resolve7,
    reject
  });
});
var loader = {
  config,
  init: init5,
  __getMonacoInstance
};
const _sfc_main$2 = defineComponent({
  props: {
    lang: { type: String, default: "html" },
    theme: { type: String, default: "vs" },
    options: { type: Object, default: () => ({}) },
    modelValue: null
  },
  emits: ["editorDidMount", "update:modelValue"],
  setup(props, { emit: emit2 }) {
    const root2 = ref(null);
    let newStuff = false;
    const id = ref(uuid());
    let editor = null;
    watch(() => props.modelValue, (n, o) => {
      let editorValue = editor.getValue();
      if (typeof n == "object" && props.lang == "json") {
        editorValue = JSON.stringify(JSON.parse(editorValue));
        n = JSON.stringify(n);
      }
      if (editor && editorValue !== n) {
        newStuff = true;
        editor.setValue(n);
      }
    });
    watch(() => props.lang, (n) => {
      if (editor) {
        window.monaco.editor.setModelLanguage(editor.getModel(), n.replace("_string", ""));
        if (n == "json") {
          try {
            editor.setValue(JSON.stringify(editor.getValue(), void 0, 2));
          } catch (x2) {
          }
        }
      }
    });
    onMounted(async () => {
      const initMonaco = () => {
        const stringValue = props.lang == "json" ? JSON.stringify(props.modelValue, void 0, 2) : props.modelValue;
        const options = __spreadValues({
          value: stringValue,
          theme: props.theme,
          automaticLayout: true,
          scrollbar: {
            alwaysConsumeMouseWheel: false
          },
          language: props.lang.replace("_string", ""),
          minimap: {
            enabled: false
          }
        }, props.options);
        editor = window.monaco.editor.create(root2.value, options);
        emit2("editorDidMount", editor);
        editor.onDidChangeModelContent(() => {
          if (newStuff) {
            newStuff = false;
            return;
          }
          const v2 = editor.getValue();
          if (props.lang == "json") {
            try {
              emit2("update:modelValue", JSON.parse(v2));
            } catch (x2) {
            }
          } else {
            emit2("update:modelValue", v2);
          }
        });
      };
      if (window.monaco) {
        initMonaco();
      } else {
        loader.init().then((monaco) => {
          window.monaco = monaco;
          initMonaco();
        });
      }
    });
    onBeforeUnmount(() => {
      if (editor) {
        editor.getModel().dispose();
        editor.dispose();
      }
    });
    return { uuid: id, root: root2 };
  }
});
const _hoisted_1$2 = {
  ref: "root",
  class: "w-full h-full resize border rounded"
};
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$2, null, 512);
}
var SCodeInput = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2]]);
var mapboxGl = { exports: {} };
(function(module2, exports) {
  (function(global2, factory) {
    module2.exports = factory();
  })(commonjsGlobal, function() {
    var shared, worker, mapboxgl2;
    function define(_, chunk) {
      if (!shared) {
        shared = chunk;
      } else if (!worker) {
        worker = chunk;
      } else {
        var workerBundleString = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk); self.onerror = null;";
        var sharedChunk = {};
        shared(sharedChunk);
        mapboxgl2 = chunk(sharedChunk);
        if (typeof window !== "undefined" && window && window.URL && window.URL.createObjectURL) {
          mapboxgl2.workerUrl = window.URL.createObjectURL(new Blob([workerBundleString], { type: "text/javascript" }));
        }
      }
    }
    define(["exports"], function(t) {
      var e = "2.7.0", r = n;
      function n(t2, e2, r2, n2) {
        this.cx = 3 * t2, this.bx = 3 * (r2 - t2) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e2, this.by = 3 * (n2 - e2) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t2, this.p1y = n2, this.p2x = r2, this.p2y = n2;
      }
      n.prototype.sampleCurveX = function(t2) {
        return ((this.ax * t2 + this.bx) * t2 + this.cx) * t2;
      }, n.prototype.sampleCurveY = function(t2) {
        return ((this.ay * t2 + this.by) * t2 + this.cy) * t2;
      }, n.prototype.sampleCurveDerivativeX = function(t2) {
        return (3 * this.ax * t2 + 2 * this.bx) * t2 + this.cx;
      }, n.prototype.solveCurveX = function(t2, e2) {
        var r2, n2, i3, s3, a2;
        for (e2 === void 0 && (e2 = 1e-6), i3 = t2, a2 = 0; a2 < 8; a2++) {
          if (s3 = this.sampleCurveX(i3) - t2, Math.abs(s3) < e2)
            return i3;
          var o2 = this.sampleCurveDerivativeX(i3);
          if (Math.abs(o2) < 1e-6)
            break;
          i3 -= s3 / o2;
        }
        if ((i3 = t2) < (r2 = 0))
          return r2;
        if (i3 > (n2 = 1))
          return n2;
        for (; r2 < n2; ) {
          if (s3 = this.sampleCurveX(i3), Math.abs(s3 - t2) < e2)
            return i3;
          t2 > s3 ? r2 = i3 : n2 = i3, i3 = 0.5 * (n2 - r2) + r2;
        }
        return i3;
      }, n.prototype.solve = function(t2, e2) {
        return this.sampleCurveY(this.solveCurveX(t2, e2));
      };
      var i2 = s2;
      function s2(t2, e2) {
        this.x = t2, this.y = e2;
      }
      s2.prototype = { clone: function() {
        return new s2(this.x, this.y);
      }, add: function(t2) {
        return this.clone()._add(t2);
      }, sub: function(t2) {
        return this.clone()._sub(t2);
      }, multByPoint: function(t2) {
        return this.clone()._multByPoint(t2);
      }, divByPoint: function(t2) {
        return this.clone()._divByPoint(t2);
      }, mult: function(t2) {
        return this.clone()._mult(t2);
      }, div: function(t2) {
        return this.clone()._div(t2);
      }, rotate: function(t2) {
        return this.clone()._rotate(t2);
      }, rotateAround: function(t2, e2) {
        return this.clone()._rotateAround(t2, e2);
      }, matMult: function(t2) {
        return this.clone()._matMult(t2);
      }, unit: function() {
        return this.clone()._unit();
      }, perp: function() {
        return this.clone()._perp();
      }, round: function() {
        return this.clone()._round();
      }, mag: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      }, equals: function(t2) {
        return this.x === t2.x && this.y === t2.y;
      }, dist: function(t2) {
        return Math.sqrt(this.distSqr(t2));
      }, distSqr: function(t2) {
        var e2 = t2.x - this.x, r2 = t2.y - this.y;
        return e2 * e2 + r2 * r2;
      }, angle: function() {
        return Math.atan2(this.y, this.x);
      }, angleTo: function(t2) {
        return Math.atan2(this.y - t2.y, this.x - t2.x);
      }, angleWith: function(t2) {
        return this.angleWithSep(t2.x, t2.y);
      }, angleWithSep: function(t2, e2) {
        return Math.atan2(this.x * e2 - this.y * t2, this.x * t2 + this.y * e2);
      }, _matMult: function(t2) {
        var e2 = t2[2] * this.x + t2[3] * this.y;
        return this.x = t2[0] * this.x + t2[1] * this.y, this.y = e2, this;
      }, _add: function(t2) {
        return this.x += t2.x, this.y += t2.y, this;
      }, _sub: function(t2) {
        return this.x -= t2.x, this.y -= t2.y, this;
      }, _mult: function(t2) {
        return this.x *= t2, this.y *= t2, this;
      }, _div: function(t2) {
        return this.x /= t2, this.y /= t2, this;
      }, _multByPoint: function(t2) {
        return this.x *= t2.x, this.y *= t2.y, this;
      }, _divByPoint: function(t2) {
        return this.x /= t2.x, this.y /= t2.y, this;
      }, _unit: function() {
        return this._div(this.mag()), this;
      }, _perp: function() {
        var t2 = this.y;
        return this.y = this.x, this.x = -t2, this;
      }, _rotate: function(t2) {
        var e2 = Math.cos(t2), r2 = Math.sin(t2), n2 = r2 * this.x + e2 * this.y;
        return this.x = e2 * this.x - r2 * this.y, this.y = n2, this;
      }, _rotateAround: function(t2, e2) {
        var r2 = Math.cos(t2), n2 = Math.sin(t2), i3 = e2.y + n2 * (this.x - e2.x) + r2 * (this.y - e2.y);
        return this.x = e2.x + r2 * (this.x - e2.x) - n2 * (this.y - e2.y), this.y = i3, this;
      }, _round: function() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
      } }, s2.convert = function(t2) {
        return t2 instanceof s2 ? t2 : Array.isArray(t2) ? new s2(t2[0], t2[1]) : t2;
      };
      var a = typeof self != "undefined" ? self : {}, o = 1e-6, l = typeof Float32Array != "undefined" ? Float32Array : Array;
      function u() {
        var t2 = new l(9);
        return l != Float32Array && (t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[5] = 0, t2[6] = 0, t2[7] = 0), t2[0] = 1, t2[4] = 1, t2[8] = 1, t2;
      }
      function c(t2) {
        return t2[0] = 1, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = 1, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[10] = 1, t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0, t2[15] = 1, t2;
      }
      function h(t2, e2, r2) {
        var n2 = e2[0], i3 = e2[1], s3 = e2[2], a2 = e2[3], o2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h2 = e2[8], p2 = e2[9], d2 = e2[10], f2 = e2[11], y2 = e2[12], m2 = e2[13], g2 = e2[14], x3 = e2[15], v3 = r2[0], b2 = r2[1], w2 = r2[2], _2 = r2[3];
        return t2[0] = v3 * n2 + b2 * o2 + w2 * h2 + _2 * y2, t2[1] = v3 * i3 + b2 * l2 + w2 * p2 + _2 * m2, t2[2] = v3 * s3 + b2 * u2 + w2 * d2 + _2 * g2, t2[3] = v3 * a2 + b2 * c2 + w2 * f2 + _2 * x3, t2[4] = (v3 = r2[4]) * n2 + (b2 = r2[5]) * o2 + (w2 = r2[6]) * h2 + (_2 = r2[7]) * y2, t2[5] = v3 * i3 + b2 * l2 + w2 * p2 + _2 * m2, t2[6] = v3 * s3 + b2 * u2 + w2 * d2 + _2 * g2, t2[7] = v3 * a2 + b2 * c2 + w2 * f2 + _2 * x3, t2[8] = (v3 = r2[8]) * n2 + (b2 = r2[9]) * o2 + (w2 = r2[10]) * h2 + (_2 = r2[11]) * y2, t2[9] = v3 * i3 + b2 * l2 + w2 * p2 + _2 * m2, t2[10] = v3 * s3 + b2 * u2 + w2 * d2 + _2 * g2, t2[11] = v3 * a2 + b2 * c2 + w2 * f2 + _2 * x3, t2[12] = (v3 = r2[12]) * n2 + (b2 = r2[13]) * o2 + (w2 = r2[14]) * h2 + (_2 = r2[15]) * y2, t2[13] = v3 * i3 + b2 * l2 + w2 * p2 + _2 * m2, t2[14] = v3 * s3 + b2 * u2 + w2 * d2 + _2 * g2, t2[15] = v3 * a2 + b2 * c2 + w2 * f2 + _2 * x3, t2;
      }
      function p(t2, e2, r2) {
        var n2, i3, s3, a2, o2, l2, u2, c2, h2, p2, d2, f2, y2 = r2[0], m2 = r2[1], g2 = r2[2];
        return e2 === t2 ? (t2[12] = e2[0] * y2 + e2[4] * m2 + e2[8] * g2 + e2[12], t2[13] = e2[1] * y2 + e2[5] * m2 + e2[9] * g2 + e2[13], t2[14] = e2[2] * y2 + e2[6] * m2 + e2[10] * g2 + e2[14], t2[15] = e2[3] * y2 + e2[7] * m2 + e2[11] * g2 + e2[15]) : (i3 = e2[1], s3 = e2[2], a2 = e2[3], o2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h2 = e2[8], p2 = e2[9], d2 = e2[10], f2 = e2[11], t2[0] = n2 = e2[0], t2[1] = i3, t2[2] = s3, t2[3] = a2, t2[4] = o2, t2[5] = l2, t2[6] = u2, t2[7] = c2, t2[8] = h2, t2[9] = p2, t2[10] = d2, t2[11] = f2, t2[12] = n2 * y2 + o2 * m2 + h2 * g2 + e2[12], t2[13] = i3 * y2 + l2 * m2 + p2 * g2 + e2[13], t2[14] = s3 * y2 + u2 * m2 + d2 * g2 + e2[14], t2[15] = a2 * y2 + c2 * m2 + f2 * g2 + e2[15]), t2;
      }
      function d(t2, e2, r2) {
        var n2 = r2[0], i3 = r2[1], s3 = r2[2];
        return t2[0] = e2[0] * n2, t2[1] = e2[1] * n2, t2[2] = e2[2] * n2, t2[3] = e2[3] * n2, t2[4] = e2[4] * i3, t2[5] = e2[5] * i3, t2[6] = e2[6] * i3, t2[7] = e2[7] * i3, t2[8] = e2[8] * s3, t2[9] = e2[9] * s3, t2[10] = e2[10] * s3, t2[11] = e2[11] * s3, t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15], t2;
      }
      function f(t2, e2, r2) {
        var n2 = Math.sin(r2), i3 = Math.cos(r2), s3 = e2[4], a2 = e2[5], o2 = e2[6], l2 = e2[7], u2 = e2[8], c2 = e2[9], h2 = e2[10], p2 = e2[11];
        return e2 !== t2 && (t2[0] = e2[0], t2[1] = e2[1], t2[2] = e2[2], t2[3] = e2[3], t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15]), t2[4] = s3 * i3 + u2 * n2, t2[5] = a2 * i3 + c2 * n2, t2[6] = o2 * i3 + h2 * n2, t2[7] = l2 * i3 + p2 * n2, t2[8] = u2 * i3 - s3 * n2, t2[9] = c2 * i3 - a2 * n2, t2[10] = h2 * i3 - o2 * n2, t2[11] = p2 * i3 - l2 * n2, t2;
      }
      function y(t2, e2, r2) {
        var n2 = Math.sin(r2), i3 = Math.cos(r2), s3 = e2[0], a2 = e2[1], o2 = e2[2], l2 = e2[3], u2 = e2[8], c2 = e2[9], h2 = e2[10], p2 = e2[11];
        return e2 !== t2 && (t2[4] = e2[4], t2[5] = e2[5], t2[6] = e2[6], t2[7] = e2[7], t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15]), t2[0] = s3 * i3 - u2 * n2, t2[1] = a2 * i3 - c2 * n2, t2[2] = o2 * i3 - h2 * n2, t2[3] = l2 * i3 - p2 * n2, t2[8] = s3 * n2 + u2 * i3, t2[9] = a2 * n2 + c2 * i3, t2[10] = o2 * n2 + h2 * i3, t2[11] = l2 * n2 + p2 * i3, t2;
      }
      Math.hypot || (Math.hypot = function() {
        for (var t2 = 0, e2 = arguments.length; e2--; )
          t2 += arguments[e2] * arguments[e2];
        return Math.sqrt(t2);
      });
      var m = h;
      function g() {
        var t2 = new l(3);
        return l != Float32Array && (t2[0] = 0, t2[1] = 0, t2[2] = 0), t2;
      }
      function x2(t2) {
        var e2 = new l(3);
        return e2[0] = t2[0], e2[1] = t2[1], e2[2] = t2[2], e2;
      }
      function v2(t2) {
        return Math.hypot(t2[0], t2[1], t2[2]);
      }
      function b(t2, e2, r2) {
        var n2 = new l(3);
        return n2[0] = t2, n2[1] = e2, n2[2] = r2, n2;
      }
      function w(t2, e2, r2) {
        return t2[0] = e2[0] + r2[0], t2[1] = e2[1] + r2[1], t2[2] = e2[2] + r2[2], t2;
      }
      function _(t2, e2, r2) {
        return t2[0] = e2[0] - r2[0], t2[1] = e2[1] - r2[1], t2[2] = e2[2] - r2[2], t2;
      }
      function A2(t2, e2, r2) {
        return t2[0] = e2[0] * r2[0], t2[1] = e2[1] * r2[1], t2[2] = e2[2] * r2[2], t2;
      }
      function k(t2, e2, r2) {
        return t2[0] = Math.max(e2[0], r2[0]), t2[1] = Math.max(e2[1], r2[1]), t2[2] = Math.max(e2[2], r2[2]), t2;
      }
      function S2(t2, e2, r2) {
        return t2[0] = e2[0] * r2, t2[1] = e2[1] * r2, t2[2] = e2[2] * r2, t2;
      }
      function I2(t2, e2, r2, n2) {
        return t2[0] = e2[0] + r2[0] * n2, t2[1] = e2[1] + r2[1] * n2, t2[2] = e2[2] + r2[2] * n2, t2;
      }
      function z(t2, e2) {
        var r2 = e2[0], n2 = e2[1], i3 = e2[2], s3 = r2 * r2 + n2 * n2 + i3 * i3;
        return s3 > 0 && (s3 = 1 / Math.sqrt(s3)), t2[0] = e2[0] * s3, t2[1] = e2[1] * s3, t2[2] = e2[2] * s3, t2;
      }
      function M2(t2, e2) {
        return t2[0] * e2[0] + t2[1] * e2[1] + t2[2] * e2[2];
      }
      function T(t2, e2, r2) {
        var n2 = e2[0], i3 = e2[1], s3 = e2[2], a2 = r2[0], o2 = r2[1], l2 = r2[2];
        return t2[0] = i3 * l2 - s3 * o2, t2[1] = s3 * a2 - n2 * l2, t2[2] = n2 * o2 - i3 * a2, t2;
      }
      function B2(t2, e2, r2) {
        var n2 = e2[0], i3 = e2[1], s3 = e2[2], a2 = r2[3] * n2 + r2[7] * i3 + r2[11] * s3 + r2[15];
        return t2[0] = (r2[0] * n2 + r2[4] * i3 + r2[8] * s3 + r2[12]) / (a2 = a2 || 1), t2[1] = (r2[1] * n2 + r2[5] * i3 + r2[9] * s3 + r2[13]) / a2, t2[2] = (r2[2] * n2 + r2[6] * i3 + r2[10] * s3 + r2[14]) / a2, t2;
      }
      function C(t2, e2, r2) {
        var n2 = r2[0], i3 = r2[1], s3 = r2[2], a2 = e2[0], o2 = e2[1], l2 = e2[2], u2 = i3 * l2 - s3 * o2, c2 = s3 * a2 - n2 * l2, h2 = n2 * o2 - i3 * a2, p2 = i3 * h2 - s3 * c2, d2 = s3 * u2 - n2 * h2, f2 = n2 * c2 - i3 * u2, y2 = 2 * r2[3];
        return c2 *= y2, h2 *= y2, d2 *= 2, f2 *= 2, t2[0] = a2 + (u2 *= y2) + (p2 *= 2), t2[1] = o2 + c2 + d2, t2[2] = l2 + h2 + f2, t2;
      }
      var P, E = _, D3 = A2, V = v2;
      function F(t2, e2, r2) {
        var n2 = e2[0], i3 = e2[1], s3 = e2[2], a2 = e2[3];
        return t2[0] = r2[0] * n2 + r2[4] * i3 + r2[8] * s3 + r2[12] * a2, t2[1] = r2[1] * n2 + r2[5] * i3 + r2[9] * s3 + r2[13] * a2, t2[2] = r2[2] * n2 + r2[6] * i3 + r2[10] * s3 + r2[14] * a2, t2[3] = r2[3] * n2 + r2[7] * i3 + r2[11] * s3 + r2[15] * a2, t2;
      }
      function L2() {
        var t2 = new l(4);
        return l != Float32Array && (t2[0] = 0, t2[1] = 0, t2[2] = 0), t2[3] = 1, t2;
      }
      function R5(t2) {
        return t2[0] = 0, t2[1] = 0, t2[2] = 0, t2[3] = 1, t2;
      }
      function U(t2, e2, r2) {
        r2 *= 0.5;
        var n2 = e2[0], i3 = e2[1], s3 = e2[2], a2 = e2[3], o2 = Math.sin(r2), l2 = Math.cos(r2);
        return t2[0] = n2 * l2 + a2 * o2, t2[1] = i3 * l2 + s3 * o2, t2[2] = s3 * l2 - i3 * o2, t2[3] = a2 * l2 - n2 * o2, t2;
      }
      function $(t2, e2) {
        return t2[0] === e2[0] && t2[1] === e2[1];
      }
      g(), P = new l(4), l != Float32Array && (P[0] = 0, P[1] = 0, P[2] = 0, P[3] = 0), g(), b(1, 0, 0), b(0, 1, 0), L2(), L2(), u(), function() {
        var t2;
        t2 = new l(2), l != Float32Array && (t2[0] = 0, t2[1] = 0);
      }();
      const O = Math.PI / 180, j = 180 / Math.PI;
      function q(t2) {
        return t2 * O;
      }
      function N(t2) {
        return t2 * j;
      }
      const G = [[0, 0], [1, 0], [1, 1], [0, 1]];
      function Z2(t2) {
        if (t2 <= 0)
          return 0;
        if (t2 >= 1)
          return 1;
        const e2 = t2 * t2, r2 = e2 * t2;
        return 4 * (t2 < 0.5 ? r2 : 3 * (t2 - e2) + r2 - 0.75);
      }
      function X2(t2, e2, n2, i3) {
        const s3 = new r(t2, e2, n2, i3);
        return function(t3) {
          return s3.solve(t3);
        };
      }
      const K = X2(0.25, 0.1, 0.25, 1);
      function Y2(t2, e2, r2) {
        return Math.min(r2, Math.max(e2, t2));
      }
      function H(t2, e2, r2) {
        return (r2 = Y2((r2 - t2) / (e2 - t2), 0, 1)) * r2 * (3 - 2 * r2);
      }
      function J(t2, e2, r2) {
        const n2 = r2 - e2, i3 = ((t2 - e2) % n2 + n2) % n2 + e2;
        return i3 === e2 ? r2 : i3;
      }
      function W(t2, e2, r2) {
        if (!t2.length)
          return r2(null, []);
        let n2 = t2.length;
        const i3 = new Array(t2.length);
        let s3 = null;
        t2.forEach((t3, a2) => {
          e2(t3, (t4, e3) => {
            t4 && (s3 = t4), i3[a2] = e3, --n2 == 0 && r2(s3, i3);
          });
        });
      }
      function Q(t2) {
        const e2 = [];
        for (const r2 in t2)
          e2.push(t2[r2]);
        return e2;
      }
      function tt(t2, ...e2) {
        for (const r2 of e2)
          for (const e3 in r2)
            t2[e3] = r2[e3];
        return t2;
      }
      let et = 1;
      function rt() {
        return et++;
      }
      function nt() {
        return function t2(e2) {
          return e2 ? (e2 ^ 16 * Math.random() >> e2 / 4).toString(16) : ([1e7] + -[1e3] + -4e3 + -8e3 + -1e11).replace(/[018]/g, t2);
        }();
      }
      function it(t2) {
        return t2 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t2) / Math.LN2));
      }
      function st(t2) {
        return !!t2 && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t2);
      }
      function at(t2, e2) {
        t2.forEach((t3) => {
          e2[t3] && (e2[t3] = e2[t3].bind(e2));
        });
      }
      function ot(t2, e2) {
        return t2.indexOf(e2, t2.length - e2.length) !== -1;
      }
      function lt(t2, e2, r2) {
        const n2 = {};
        for (const i3 in t2)
          n2[i3] = e2.call(r2 || this, t2[i3], i3, t2);
        return n2;
      }
      function ut(t2, e2, r2) {
        const n2 = {};
        for (const i3 in t2)
          e2.call(r2 || this, t2[i3], i3, t2) && (n2[i3] = t2[i3]);
        return n2;
      }
      function ct(t2) {
        return Array.isArray(t2) ? t2.map(ct) : typeof t2 == "object" && t2 ? lt(t2, ct) : t2;
      }
      const ht = {};
      function pt(t2) {
        ht[t2] || (typeof console != "undefined" && console.warn(t2), ht[t2] = true);
      }
      function dt(t2, e2, r2) {
        return (r2.y - t2.y) * (e2.x - t2.x) > (e2.y - t2.y) * (r2.x - t2.x);
      }
      function ft(t2) {
        let e2 = 0;
        for (let r2, n2, i3 = 0, s3 = t2.length, a2 = s3 - 1; i3 < s3; a2 = i3++)
          r2 = t2[i3], n2 = t2[a2], e2 += (n2.x - r2.x) * (r2.y + n2.y);
        return e2;
      }
      function yt() {
        return typeof WorkerGlobalScope != "undefined" && typeof self != "undefined" && self instanceof WorkerGlobalScope;
      }
      function mt(t2) {
        const e2 = {};
        if (t2.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t3, r2, n2, i3) => {
          const s3 = n2 || i3;
          return e2[r2] = !s3 || s3.toLowerCase(), "";
        }), e2["max-age"]) {
          const t3 = parseInt(e2["max-age"], 10);
          isNaN(t3) ? delete e2["max-age"] : e2["max-age"] = t3;
        }
        return e2;
      }
      let gt, xt, vt, bt = null;
      function wt(t2) {
        if (bt == null) {
          const e2 = t2.navigator ? t2.navigator.userAgent : null;
          bt = !!t2.safari || !(!e2 || !(/\b(iPad|iPhone|iPod)\b/.test(e2) || e2.match("Safari") && !e2.match("Chrome")));
        }
        return bt;
      }
      function _t(t2) {
        try {
          const e2 = a[t2];
          return e2.setItem("_mapbox_test_", 1), e2.removeItem("_mapbox_test_"), true;
        } catch (t3) {
          return false;
        }
      }
      const At = { now: () => vt !== void 0 ? vt : a.performance.now(), setNow(t2) {
        vt = t2;
      }, restoreNow() {
        vt = void 0;
      }, frame(t2) {
        const e2 = a.requestAnimationFrame(t2);
        return { cancel: () => a.cancelAnimationFrame(e2) };
      }, getImageData(t2, e2 = 0) {
        const r2 = a.document.createElement("canvas"), n2 = r2.getContext("2d");
        if (!n2)
          throw new Error("failed to create canvas 2d context");
        return r2.width = t2.width, r2.height = t2.height, n2.drawImage(t2, 0, 0, t2.width, t2.height), n2.getImageData(-e2, -e2, t2.width + 2 * e2, t2.height + 2 * e2);
      }, resolveURL: (t2) => (gt || (gt = a.document.createElement("a")), gt.href = t2, gt.href), get devicePixelRatio() {
        return a.devicePixelRatio;
      }, get prefersReducedMotion() {
        return !!a.matchMedia && (xt == null && (xt = a.matchMedia("(prefers-reduced-motion: reduce)")), xt.matches);
      } };
      let kt;
      const St = { API_URL: "https://api.mapbox.com", get API_URL_REGEX() {
        if (kt == null) {
          const t2 = /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
          try {
            kt = {}.API_URL_REGEX != null ? new RegExp({}.API_URL_REGEX) : t2;
          } catch (e2) {
            kt = t2;
          }
        }
        return kt;
      }, get EVENTS_URL() {
        return this.API_URL ? this.API_URL.indexOf("https://api.mapbox.cn") === 0 ? "https://events.mapbox.cn/events/v2" : this.API_URL.indexOf("https://api.mapbox.com") === 0 ? "https://events.mapbox.com/events/v2" : null : null;
      }, SESSION_PATH: "/map-sessions/v1", FEEDBACK_URL: "https://apps.mapbox.com/feedback", TILE_URL_VERSION: "v4", RASTER_URL_PREFIX: "raster/v1", REQUIRE_ACCESS_TOKEN: true, ACCESS_TOKEN: null, MAX_PARALLEL_IMAGE_REQUESTS: 16 }, It = { supported: false, testSupport: function(t2) {
        !Tt && Mt && (Bt ? Ct(t2) : zt = t2);
      } };
      let zt, Mt, Tt = false, Bt = false;
      function Ct(t2) {
        const e2 = t2.createTexture();
        t2.bindTexture(t2.TEXTURE_2D, e2);
        try {
          if (t2.texImage2D(t2.TEXTURE_2D, 0, t2.RGBA, t2.RGBA, t2.UNSIGNED_BYTE, Mt), t2.isContextLost())
            return;
          It.supported = true;
        } catch (t3) {
        }
        t2.deleteTexture(e2), Tt = true;
      }
      a.document && (Mt = a.document.createElement("img"), Mt.onload = function() {
        zt && Ct(zt), zt = null, Bt = true;
      }, Mt.onerror = function() {
        Tt = true, zt = null;
      }, Mt.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
      const Pt = "01", Et = "NO_ACCESS_TOKEN";
      function Dt(t2) {
        return t2.indexOf("mapbox:") === 0;
      }
      function Vt(t2) {
        return St.API_URL_REGEX.test(t2);
      }
      const Ft = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
      function Lt(t2) {
        const e2 = t2.match(Ft);
        if (!e2)
          throw new Error("Unable to parse URL object");
        return { protocol: e2[1], authority: e2[2], path: e2[3] || "/", params: e2[4] ? e2[4].split("&") : [] };
      }
      function Rt(t2) {
        const e2 = t2.params.length ? `?${t2.params.join("&")}` : "";
        return `${t2.protocol}://${t2.authority}${t2.path}${e2}`;
      }
      function Ut(t2) {
        if (!t2)
          return null;
        const e2 = t2.split(".");
        if (!e2 || e2.length !== 3)
          return null;
        try {
          return JSON.parse(decodeURIComponent(a.atob(e2[1]).split("").map((t3) => "%" + ("00" + t3.charCodeAt(0).toString(16)).slice(-2)).join("")));
        } catch (t3) {
          return null;
        }
      }
      class $t {
        constructor(t2) {
          this.type = t2, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
        }
        getStorageKey(t2) {
          const e2 = Ut(St.ACCESS_TOKEN);
          let r2 = "";
          return r2 = e2 && e2.u ? a.btoa(encodeURIComponent(e2.u).replace(/%([0-9A-F]{2})/g, (t3, e3) => String.fromCharCode(Number("0x" + e3)))) : St.ACCESS_TOKEN || "", t2 ? `mapbox.eventData.${t2}:${r2}` : `mapbox.eventData:${r2}`;
        }
        fetchEventData() {
          const t2 = _t("localStorage"), e2 = this.getStorageKey(), r2 = this.getStorageKey("uuid");
          if (t2)
            try {
              const t3 = a.localStorage.getItem(e2);
              t3 && (this.eventData = JSON.parse(t3));
              const n2 = a.localStorage.getItem(r2);
              n2 && (this.anonId = n2);
            } catch (t3) {
              pt("Unable to read from LocalStorage");
            }
        }
        saveEventData() {
          const t2 = _t("localStorage"), e2 = this.getStorageKey(), r2 = this.getStorageKey("uuid");
          if (t2)
            try {
              a.localStorage.setItem(r2, this.anonId), Object.keys(this.eventData).length >= 1 && a.localStorage.setItem(e2, JSON.stringify(this.eventData));
            } catch (t3) {
              pt("Unable to write to LocalStorage");
            }
        }
        processRequests(t2) {
        }
        postEvent(t2, r2, n2, i3) {
          if (!St.EVENTS_URL)
            return;
          const s3 = Lt(St.EVENTS_URL);
          s3.params.push(`access_token=${i3 || St.ACCESS_TOKEN || ""}`);
          const a2 = { event: this.type, created: new Date(t2).toISOString(), sdkIdentifier: "mapbox-gl-js", sdkVersion: e, skuId: Pt, userId: this.anonId }, o2 = r2 ? tt(a2, r2) : a2, l2 = { url: Rt(s3), headers: { "Content-Type": "text/plain" }, body: JSON.stringify([o2]) };
          this.pendingRequest = oe(l2, (t3) => {
            this.pendingRequest = null, n2(t3), this.saveEventData(), this.processRequests(i3);
          });
        }
        queueRequest(t2, e2) {
          this.queue.push(t2), this.processRequests(e2);
        }
      }
      const Ot = new class extends $t {
        constructor(t2) {
          super("appUserTurnstile"), this._customAccessToken = t2;
        }
        postTurnstileEvent(t2, e2) {
          St.EVENTS_URL && St.ACCESS_TOKEN && Array.isArray(t2) && t2.some((t3) => Dt(t3) || Vt(t3)) && this.queueRequest(Date.now(), e2);
        }
        processRequests(t2) {
          if (this.pendingRequest || this.queue.length === 0)
            return;
          this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
          const e2 = Ut(St.ACCESS_TOKEN), r2 = e2 ? e2.u : St.ACCESS_TOKEN;
          let n2 = r2 !== this.eventData.tokenU;
          st(this.anonId) || (this.anonId = nt(), n2 = true);
          const i3 = this.queue.shift();
          if (this.eventData.lastSuccess) {
            const t3 = new Date(this.eventData.lastSuccess), e3 = new Date(i3), r3 = (i3 - this.eventData.lastSuccess) / 864e5;
            n2 = n2 || r3 >= 1 || r3 < -1 || t3.getDate() !== e3.getDate();
          } else
            n2 = true;
          if (!n2)
            return this.processRequests();
          this.postEvent(i3, { "enabled.telemetry": false }, (t3) => {
            t3 || (this.eventData.lastSuccess = i3, this.eventData.tokenU = r2);
          }, t2);
        }
      }(), jt = Ot.postTurnstileEvent.bind(Ot), qt = new class extends $t {
        constructor() {
          super("map.load"), this.success = {}, this.skuToken = "";
        }
        postMapLoadEvent(t2, e2, r2, n2) {
          this.skuToken = e2, this.errorCb = n2, St.EVENTS_URL && (r2 || St.ACCESS_TOKEN ? this.queueRequest({ id: t2, timestamp: Date.now() }, r2) : this.errorCb(new Error(Et)));
        }
        processRequests(t2) {
          if (this.pendingRequest || this.queue.length === 0)
            return;
          const { id: e2, timestamp: r2 } = this.queue.shift();
          e2 && this.success[e2] || (this.anonId || this.fetchEventData(), st(this.anonId) || (this.anonId = nt()), this.postEvent(r2, { skuToken: this.skuToken }, (t3) => {
            t3 ? this.errorCb(t3) : e2 && (this.success[e2] = true);
          }, t2));
        }
      }(), Nt = qt.postMapLoadEvent.bind(qt), Gt = new class extends $t {
        constructor() {
          super("map.auth"), this.success = {}, this.skuToken = "";
        }
        getSession(t2, e2, r2, n2) {
          if (!St.API_URL || !St.SESSION_PATH)
            return;
          const i3 = Lt(St.API_URL + St.SESSION_PATH);
          i3.params.push(`sku=${e2 || ""}`), i3.params.push(`access_token=${n2 || St.ACCESS_TOKEN || ""}`);
          const s3 = { url: Rt(i3), headers: { "Content-Type": "text/plain" } };
          this.pendingRequest = le(s3, (t3) => {
            this.pendingRequest = null, r2(t3), this.saveEventData(), this.processRequests(n2);
          });
        }
        getSessionAPI(t2, e2, r2, n2) {
          this.skuToken = e2, this.errorCb = n2, St.SESSION_PATH && St.API_URL && (r2 || St.ACCESS_TOKEN ? this.queueRequest({ id: t2, timestamp: Date.now() }, r2) : this.errorCb(new Error(Et)));
        }
        processRequests(t2) {
          if (this.pendingRequest || this.queue.length === 0)
            return;
          const { id: e2, timestamp: r2 } = this.queue.shift();
          e2 && this.success[e2] || this.getSession(r2, this.skuToken, (t3) => {
            t3 ? this.errorCb(t3) : e2 && (this.success[e2] = true);
          }, t2);
        }
      }(), Zt = Gt.getSessionAPI.bind(Gt), Xt = /* @__PURE__ */ new Set(), Kt = "mapbox-tiles";
      let Yt, Ht, Jt = 500, Wt = 50;
      function Qt() {
        a.caches && !Yt && (Yt = a.caches.open(Kt));
      }
      function te(t2) {
        const e2 = t2.indexOf("?");
        return e2 < 0 ? t2 : t2.slice(0, e2);
      }
      let ee = 1 / 0;
      const re = { Unknown: "Unknown", Style: "Style", Source: "Source", Tile: "Tile", Glyphs: "Glyphs", SpriteImage: "SpriteImage", SpriteJSON: "SpriteJSON", Image: "Image" };
      typeof Object.freeze == "function" && Object.freeze(re);
      class ne extends Error {
        constructor(t2, e2, r2) {
          e2 === 401 && Vt(r2) && (t2 += ": you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes"), super(t2), this.status = e2, this.url = r2;
        }
        toString() {
          return `${this.name}: ${this.message} (${this.status}): ${this.url}`;
        }
      }
      const ie2 = yt() ? () => self.worker && self.worker.referrer : () => (a.location.protocol === "blob:" ? a.parent : a).location.href;
      const se = function(t2, e2) {
        if (!(/^file:/.test(r2 = t2.url) || /^file:/.test(ie2()) && !/^\w+:/.test(r2))) {
          if (a.fetch && a.Request && a.AbortController && a.Request.prototype.hasOwnProperty("signal"))
            return function(t3, e3) {
              const r3 = new a.AbortController(), n2 = new a.Request(t3.url, { method: t3.method || "GET", body: t3.body, credentials: t3.credentials, headers: t3.headers, referrer: ie2(), signal: r3.signal });
              let i3 = false, s3 = false;
              const o2 = (l2 = n2.url).indexOf("sku=") > 0 && Vt(l2);
              var l2;
              t3.type === "json" && n2.headers.set("Accept", "application/json");
              const u2 = (r4, i4, l3) => {
                if (s3)
                  return;
                if (r4 && r4.message !== "SecurityError" && pt(r4), i4 && l3)
                  return c2(i4);
                const u3 = Date.now();
                a.fetch(n2).then((r5) => {
                  if (r5.ok) {
                    const t4 = o2 ? r5.clone() : null;
                    return c2(r5, t4, u3);
                  }
                  return e3(new ne(r5.statusText, r5.status, t3.url));
                }).catch((t4) => {
                  t4.code !== 20 && e3(new Error(t4.message));
                });
              }, c2 = (r4, o3, l3) => {
                (t3.type === "arrayBuffer" ? r4.arrayBuffer() : t3.type === "json" ? r4.json() : r4.text()).then((t4) => {
                  s3 || (o3 && l3 && function(t5, e4, r5) {
                    if (Qt(), !Yt)
                      return;
                    const n3 = { status: e4.status, statusText: e4.statusText, headers: new a.Headers() };
                    e4.headers.forEach((t6, e5) => n3.headers.set(e5, t6));
                    const i4 = mt(e4.headers.get("Cache-Control") || "");
                    i4["no-store"] || (i4["max-age"] && n3.headers.set("Expires", new Date(r5 + 1e3 * i4["max-age"]).toUTCString()), new Date(n3.headers.get("Expires")).getTime() - r5 < 42e4 || function(t6, e5) {
                      if (Ht === void 0)
                        try {
                          new Response(new ReadableStream()), Ht = true;
                        } catch (t7) {
                          Ht = false;
                        }
                      Ht ? e5(t6.body) : t6.blob().then(e5);
                    }(e4, (e5) => {
                      const r6 = new a.Response(e5, n3);
                      Qt(), Yt && Yt.then((e6) => e6.put(te(t5.url), r6)).catch((t6) => pt(t6.message));
                    }));
                  }(n2, o3, l3), i3 = true, e3(null, t4, r4.headers.get("Cache-Control"), r4.headers.get("Expires")));
                }).catch((t4) => {
                  s3 || e3(new Error(t4.message));
                });
              };
              return o2 ? function(t4, e4) {
                if (Qt(), !Yt)
                  return e4(null);
                const r4 = te(t4.url);
                Yt.then((t5) => {
                  t5.match(r4).then((n3) => {
                    const i4 = function(t6) {
                      if (!t6)
                        return false;
                      const e5 = new Date(t6.headers.get("Expires") || 0), r5 = mt(t6.headers.get("Cache-Control") || "");
                      return e5 > Date.now() && !r5["no-cache"];
                    }(n3);
                    t5.delete(r4), i4 && t5.put(r4, n3.clone()), e4(null, n3, i4);
                  }).catch(e4);
                }).catch(e4);
              }(n2, u2) : u2(null, null), { cancel: () => {
                s3 = true, i3 || r3.abort();
              } };
            }(t2, e2);
          if (yt() && self.worker && self.worker.actor)
            return self.worker.actor.send("getResource", t2, e2, void 0, true);
        }
        var r2;
        return function(t3, e3) {
          const r3 = new a.XMLHttpRequest();
          r3.open(t3.method || "GET", t3.url, true), t3.type === "arrayBuffer" && (r3.responseType = "arraybuffer");
          for (const e4 in t3.headers)
            r3.setRequestHeader(e4, t3.headers[e4]);
          return t3.type === "json" && (r3.responseType = "text", r3.setRequestHeader("Accept", "application/json")), r3.withCredentials = t3.credentials === "include", r3.onerror = () => {
            e3(new Error(r3.statusText));
          }, r3.onload = () => {
            if ((r3.status >= 200 && r3.status < 300 || r3.status === 0) && r3.response !== null) {
              let n2 = r3.response;
              if (t3.type === "json")
                try {
                  n2 = JSON.parse(r3.response);
                } catch (t4) {
                  return e3(t4);
                }
              e3(null, n2, r3.getResponseHeader("Cache-Control"), r3.getResponseHeader("Expires"));
            } else
              e3(new ne(r3.statusText, r3.status, t3.url));
          }, r3.send(t3.body), { cancel: () => r3.abort() };
        }(t2, e2);
      }, ae = function(t2, e2) {
        return se(tt(t2, { type: "arrayBuffer" }), e2);
      }, oe = function(t2, e2) {
        return se(tt(t2, { method: "POST" }), e2);
      }, le = function(t2, e2) {
        return se(tt(t2, { method: "GET" }), e2);
      };
      function ue(t2) {
        const e2 = a.document.createElement("a");
        return e2.href = t2, e2.protocol === a.document.location.protocol && e2.host === a.document.location.host;
      }
      const ce = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
      let he, pe;
      he = [], pe = 0;
      const de = function(t2, e2) {
        if (It.supported && (t2.headers || (t2.headers = {}), t2.headers.accept = "image/webp,*/*"), pe >= St.MAX_PARALLEL_IMAGE_REQUESTS) {
          const r3 = { requestParameters: t2, callback: e2, cancelled: false, cancel() {
            this.cancelled = true;
          } };
          return he.push(r3), r3;
        }
        pe++;
        let r2 = false;
        const n2 = () => {
          if (!r2)
            for (r2 = true, pe--; he.length && pe < St.MAX_PARALLEL_IMAGE_REQUESTS; ) {
              const t3 = he.shift(), { requestParameters: e3, callback: r3, cancelled: n3 } = t3;
              n3 || (t3.cancel = de(e3, r3).cancel);
            }
        }, i3 = ae(t2, (t3, r3, i4, s3) => {
          n2(), t3 ? e2(t3) : r3 && (a.createImageBitmap ? function(t4, e3) {
            const r4 = new a.Blob([new Uint8Array(t4)], { type: "image/png" });
            a.createImageBitmap(r4).then((t5) => {
              e3(null, t5);
            }).catch((t5) => {
              e3(new Error(`Could not load image because of ${t5.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
            });
          }(r3, (t4, r4) => e2(t4, r4, i4, s3)) : function(t4, e3) {
            const r4 = new a.Image(), n3 = a.URL;
            r4.onload = () => {
              e3(null, r4), n3.revokeObjectURL(r4.src), r4.onload = null, a.requestAnimationFrame(() => {
                r4.src = ce;
              });
            }, r4.onerror = () => e3(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
            const i5 = new a.Blob([new Uint8Array(t4)], { type: "image/png" });
            r4.src = t4.byteLength ? n3.createObjectURL(i5) : ce;
          }(r3, (t4, r4) => e2(t4, r4, i4, s3)));
        });
        return { cancel: () => {
          i3.cancel(), n2();
        } };
      };
      function fe(t2, e2, r2) {
        r2[t2] && r2[t2].indexOf(e2) !== -1 || (r2[t2] = r2[t2] || [], r2[t2].push(e2));
      }
      function ye(t2, e2, r2) {
        if (r2 && r2[t2]) {
          const n2 = r2[t2].indexOf(e2);
          n2 !== -1 && r2[t2].splice(n2, 1);
        }
      }
      class me {
        constructor(t2, e2 = {}) {
          tt(this, e2), this.type = t2;
        }
      }
      class ge extends me {
        constructor(t2, e2 = {}) {
          super("error", tt({ error: t2 }, e2));
        }
      }
      class xe {
        on(t2, e2) {
          return this._listeners = this._listeners || {}, fe(t2, e2, this._listeners), this;
        }
        off(t2, e2) {
          return ye(t2, e2, this._listeners), ye(t2, e2, this._oneTimeListeners), this;
        }
        once(t2, e2) {
          return e2 ? (this._oneTimeListeners = this._oneTimeListeners || {}, fe(t2, e2, this._oneTimeListeners), this) : new Promise((e3) => this.once(t2, e3));
        }
        fire(t2, e2) {
          typeof t2 == "string" && (t2 = new me(t2, e2 || {}));
          const r2 = t2.type;
          if (this.listens(r2)) {
            t2.target = this;
            const e3 = this._listeners && this._listeners[r2] ? this._listeners[r2].slice() : [];
            for (const r3 of e3)
              r3.call(this, t2);
            const n2 = this._oneTimeListeners && this._oneTimeListeners[r2] ? this._oneTimeListeners[r2].slice() : [];
            for (const e4 of n2)
              ye(r2, e4, this._oneTimeListeners), e4.call(this, t2);
            const i3 = this._eventedParent;
            i3 && (tt(t2, typeof this._eventedParentData == "function" ? this._eventedParentData() : this._eventedParentData), i3.fire(t2));
          } else
            t2 instanceof ge && console.error(t2.error);
          return this;
        }
        listens(t2) {
          return !!(this._listeners && this._listeners[t2] && this._listeners[t2].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t2] && this._oneTimeListeners[t2].length > 0 || this._eventedParent && this._eventedParent.listens(t2));
        }
        setEventedParent(t2, e2) {
          return this._eventedParent = t2, this._eventedParentData = e2, this;
        }
      }
      var ve = JSON.parse('{"$version":8,"$root":{"version":{"required":true,"type":"enum","values":[8]},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360,"units":"degrees"},"pitch":{"type":"number","default":0,"units":"degrees"},"light":{"type":"light"},"terrain":{"type":"terrain"},"fog":{"type":"fog"},"sources":{"required":true,"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string"},"transition":{"type":"transition"},"projection":{"type":"projection"},"layers":{"required":true,"type":"array","value":"layer"}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_geojson","source_video","source_image"],"source_vector":{"type":{"required":true,"type":"enum","values":{"vector":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"scheme":{"type":"enum","values":{"xyz":{},"tms":{}},"default":"xyz"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"required":true,"type":"enum","values":{"raster":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512,"units":"pixels"},"scheme":{"type":"enum","values":{"xyz":{},"tms":{}},"default":"xyz"},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"required":true,"type":"enum","values":{"raster-dem":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512,"units":"pixels"},"attribution":{"type":"string"},"encoding":{"type":"enum","values":{"terrarium":{},"mapbox":{}},"default":"mapbox"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_geojson":{"type":{"required":true,"type":"enum","values":{"geojson":{}}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"}},"source_video":{"type":{"required":true,"type":"enum","values":{"video":{}}},"urls":{"required":true,"type":"array","value":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"required":true,"type":"enum","values":{"image":{}}},"url":{"required":true,"type":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"layer":{"id":{"type":"string","required":true},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"raster":{},"hillshade":{},"background":{},"sky":{}},"required":true},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"}},"layout":["layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_hillshade","layout_background","layout_sky"],"layout_background":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_sky":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_line":{"line-cap":{"type":"enum","values":{"butt":{},"round":{},"square":{}},"default":"butt","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-join":{"type":"enum","values":{"bevel":{},"round":{},"miter":{}},"default":"miter","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"requires":[{"line-join":"miter"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-round-limit":{"type":"number","default":1.05,"requires":[{"line-join":"round"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_symbol":{"symbol-placement":{"type":"enum","values":{"point":{},"line":{},"line-center":{}},"default":"point","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-spacing":{"type":"number","default":250,"minimum":1,"units":"pixels","requires":[{"symbol-placement":"line"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","values":{"auto":{},"viewport-y":{},"source":{}},"default":"auto","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{"type":"boolean","default":false,"requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{"type":"boolean","default":false,"requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-optional":{"type":"boolean","default":false,"requires":["icon-image","text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-size":{"type":"number","default":1,"minimum":0,"units":"factor of the original icon size","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit":{"type":"enum","values":{"none":{},"width":{},"height":{},"both":{}},"default":"none","requires":["icon-image","text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"units":"pixels","requires":["icon-image","text-field",{"icon-text-fit":["both","width","height"]}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-image":{"type":"resolvedImage","tokens":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{"type":"number","default":0,"period":360,"units":"degrees","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{"type":"number","default":2,"minimum":0,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{"type":"boolean","default":false,"requires":["icon-image",{"icon-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{"type":"enum","values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"default":"center","requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-field":{"type":"formatted","default":"","tokens":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-font":{"type":"array","value":"string","default":["Open Sans Regular","Arial Unicode MS Regular"],"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-width":{"type":"number","default":10,"minimum":0,"units":"ems","requires":["text-field",{"symbol-placement":["point"]}],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"units":"ems","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"units":"ems","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-justify":{"type":"enum","values":{"auto":{},"left":{},"center":{},"right":{}},"default":"center","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","units":"ems","default":0,"requires":["text-field"],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["zoom","feature"]}},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"requires":["text-field",{"symbol-placement":["point"]}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-anchor":{"type":"enum","values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"default":"center","requires":["text-field",{"!":"text-variable-anchor"}],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"units":"degrees","requires":["text-field",{"symbol-placement":["line","line-center"]}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":{},"vertical":{}},"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-rotate":{"type":"number","default":0,"period":360,"units":"degrees","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-padding":{"type":"number","default":2,"minimum":0,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-keep-upright":{"type":"boolean","default":true,"requires":["text-field",{"text-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-transform":{"type":"enum","values":{"none":{},"uppercase":{},"lowercase":{}},"default":"none","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-offset":{"type":"array","value":"number","units":"ems","length":2,"default":[0,0],"requires":["text-field",{"!":"text-radial-offset"}],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{"type":"boolean","default":false,"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{"type":"boolean","default":false,"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-optional":{"type":"boolean","default":false,"requires":["text-field","icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature","pitch","distance-from-center"]}},"filter_fill":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_line":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_circle":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_fill-extrusion":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_heatmap":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_operator":{"type":"enum","values":{"==":{},"!=":{},">":{},">=":{},"<":{},"<=":{},"in":{},"!in":{},"all":{},"any":{},"none":{},"has":{},"!has":{},"within":{}}},"geometry_type":{"type":"enum","values":{"Point":{},"LineString":{},"Polygon":{}}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":{},"exponential":{},"interval":{},"categorical":{}},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":{},"lab":{},"hcl":{}},"default":"rgb"},"default":{"type":"*","required":false}},"function_stop":{"type":"array","minimum":0,"maximum":24,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"horizon-blend":{"type":"number","property-type":"data-constant","default":0.1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":{},"viewport":{}},"property-type":"data-constant","transition":false,"expression":{"interpolated":false,"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"projection":{"name":{"type":"enum","values":{"albers":{},"equalEarth":{},"equirectangular":{},"lambertConformalConic":{},"mercator":{},"naturalEarth":{},"winkelTripel":{}},"default":"mercator","required":true},"center":{"type":"array","length":2,"value":"number","property-type":"data-constant","transition":false,"requires":[{"name":["albers","lambertConformalConic"]}]},"parallels":{"type":"array","length":2,"value":"number","property-type":"data-constant","transition":false,"requires":[{"name":["albers","lambertConformalConic"]}]}},"terrain":{"source":{"type":"string","required":true},"exaggeration":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_hillshade","paint_background","paint_sky"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"fill-pattern"}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-outline-color":{"type":"color","transition":true,"requires":[{"!":"fill-pattern"},{"fill-antialias":true}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["fill-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-pattern":{"type":"resolvedImage","transition":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"cross-faded-data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"fill-extrusion-pattern"}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["fill-extrusion-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{"type":"resolvedImage","transition":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"cross-faded-data-driven"},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"units":"meters","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"units":"meters","transition":true,"requires":["fill-extrusion-height"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"line-pattern"}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["line-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"line-width":{"type":"number","default":1,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-dasharray":{"type":"array","value":"number","minimum":0,"transition":true,"units":"line widths","requires":[{"!":"line-pattern"}],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"cross-faded-data-driven"},"line-pattern":{"type":"resolvedImage","transition":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"cross-faded-data-driven"},"line-gradient":{"type":"color","transition":false,"requires":[{"!":"line-pattern"},{"source":"geojson","has":{"lineMetrics":true}}],"expression":{"interpolated":true,"parameters":["line-progress"]},"property-type":"color-ramp"}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["circle-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{"type":"enum","values":{"map":{},"viewport":{}},"default":"viewport","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"transition":false,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"transition":false,"expression":{"interpolated":true,"parameters":["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-color":{"type":"color","default":"#000000","transition":true,"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["icon-image","icon-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-color":{"type":"color","default":"#000000","transition":true,"overridable":true,"requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["text-field","text-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-hue-rotate":{"type":"number","default":0,"period":360,"transition":true,"units":"degrees","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-resampling":{"type":"enum","values":{"linear":{},"nearest":{}},"default":"linear","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"transition":false,"units":"milliseconds","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"transition":false,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"viewport","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-accent-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_background":{"background-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"background-pattern"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-pattern":{"type":"resolvedImage","transition":true,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"cross-faded"},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_sky":{"sky-type":{"type":"enum","values":{"gradient":{},"atmosphere":{}},"default":"atmosphere","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun":{"type":"array","value":"number","length":2,"units":"degrees","minimum":[0,0],"maximum":[360,180],"transition":false,"requires":[{"sky-type":"atmosphere"}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun-intensity":{"type":"number","requires":[{"sky-type":"atmosphere"}],"default":10,"minimum":0,"maximum":100,"transition":false,"property-type":"data-constant"},"sky-gradient-center":{"type":"array","requires":[{"sky-type":"gradient"}],"value":"number","default":[0,0],"length":2,"units":"degrees","minimum":[0,0],"maximum":[360,180],"transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient-radius":{"type":"number","requires":[{"sky-type":"gradient"}],"default":90,"minimum":0,"maximum":180,"transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"transition":false,"requires":[{"sky-type":"gradient"}],"expression":{"interpolated":true,"parameters":["sky-radial-progress"]},"property-type":"color-ramp"},"sky-atmosphere-halo-color":{"type":"color","default":"white","transition":false,"requires":[{"sky-type":"atmosphere"}],"property-type":"data-constant"},"sky-atmosphere-color":{"type":"color","default":"white","transition":false,"requires":[{"sky-type":"atmosphere"}],"property-type":"data-constant"},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"transition":{"duration":{"type":"number","default":300,"minimum":0,"units":"milliseconds"},"delay":{"type":"number","default":0,"minimum":0,"units":"milliseconds"}},"property-type":{"data-driven":{"type":"property-type"},"cross-faded":{"type":"property-type"},"cross-faded-data-driven":{"type":"property-type"},"color-ramp":{"type":"property-type"},"data-constant":{"type":"property-type"},"constant":{"type":"property-type"}},"promoteId":{"*":{"type":"string"}}}');
      class be {
        constructor(t2, e2, r2, n2) {
          this.message = (t2 ? `${t2}: ` : "") + r2, n2 && (this.identifier = n2), e2 != null && e2.__line__ && (this.line = e2.__line__);
        }
      }
      function we(t2) {
        const e2 = t2.value;
        return e2 ? [new be(t2.key, e2, "constants have been deprecated as of v8")] : [];
      }
      function _e(t2, ...e2) {
        for (const r2 of e2)
          for (const e3 in r2)
            t2[e3] = r2[e3];
        return t2;
      }
      function Ae(t2) {
        return t2 instanceof Number || t2 instanceof String || t2 instanceof Boolean ? t2.valueOf() : t2;
      }
      function ke(t2) {
        if (Array.isArray(t2))
          return t2.map(ke);
        if (t2 instanceof Object && !(t2 instanceof Number || t2 instanceof String || t2 instanceof Boolean)) {
          const e2 = {};
          for (const r2 in t2)
            e2[r2] = ke(t2[r2]);
          return e2;
        }
        return Ae(t2);
      }
      class Se extends Error {
        constructor(t2, e2) {
          super(e2), this.message = e2, this.key = t2;
        }
      }
      class Ie {
        constructor(t2, e2 = []) {
          this.parent = t2, this.bindings = {};
          for (const [t3, r2] of e2)
            this.bindings[t3] = r2;
        }
        concat(t2) {
          return new Ie(this, t2);
        }
        get(t2) {
          if (this.bindings[t2])
            return this.bindings[t2];
          if (this.parent)
            return this.parent.get(t2);
          throw new Error(`${t2} not found in scope.`);
        }
        has(t2) {
          return !!this.bindings[t2] || !!this.parent && this.parent.has(t2);
        }
      }
      const ze = { kind: "null" }, Me = { kind: "number" }, Te = { kind: "string" }, Be = { kind: "boolean" }, Ce = { kind: "color" }, Pe = { kind: "object" }, Ee = { kind: "value" }, De = { kind: "collator" }, Ve = { kind: "formatted" }, Fe = { kind: "resolvedImage" };
      function Le(t2, e2) {
        return { kind: "array", itemType: t2, N: e2 };
      }
      function Re(t2) {
        if (t2.kind === "array") {
          const e2 = Re(t2.itemType);
          return typeof t2.N == "number" ? `array<${e2}, ${t2.N}>` : t2.itemType.kind === "value" ? "array" : `array<${e2}>`;
        }
        return t2.kind;
      }
      const Ue = [ze, Me, Te, Be, Ce, Ve, Pe, Le(Ee), Fe];
      function $e(t2, e2) {
        if (e2.kind === "error")
          return null;
        if (t2.kind === "array") {
          if (e2.kind === "array" && (e2.N === 0 && e2.itemType.kind === "value" || !$e(t2.itemType, e2.itemType)) && (typeof t2.N != "number" || t2.N === e2.N))
            return null;
        } else {
          if (t2.kind === e2.kind)
            return null;
          if (t2.kind === "value") {
            for (const t3 of Ue)
              if (!$e(t3, e2))
                return null;
          }
        }
        return `Expected ${Re(t2)} but found ${Re(e2)} instead.`;
      }
      function Oe(t2, e2) {
        return e2.some((e3) => e3.kind === t2.kind);
      }
      function je(t2, e2) {
        return e2.some((e3) => e3 === "null" ? t2 === null : e3 === "array" ? Array.isArray(t2) : e3 === "object" ? t2 && !Array.isArray(t2) && typeof t2 == "object" : e3 === typeof t2);
      }
      function qe(t2) {
        var e2 = { exports: {} };
        return t2(e2, e2.exports), e2.exports;
      }
      var Ne = qe(function(t2, e2) {
        var r2 = { transparent: [0, 0, 0, 0], aliceblue: [240, 248, 255, 1], antiquewhite: [250, 235, 215, 1], aqua: [0, 255, 255, 1], aquamarine: [127, 255, 212, 1], azure: [240, 255, 255, 1], beige: [245, 245, 220, 1], bisque: [255, 228, 196, 1], black: [0, 0, 0, 1], blanchedalmond: [255, 235, 205, 1], blue: [0, 0, 255, 1], blueviolet: [138, 43, 226, 1], brown: [165, 42, 42, 1], burlywood: [222, 184, 135, 1], cadetblue: [95, 158, 160, 1], chartreuse: [127, 255, 0, 1], chocolate: [210, 105, 30, 1], coral: [255, 127, 80, 1], cornflowerblue: [100, 149, 237, 1], cornsilk: [255, 248, 220, 1], crimson: [220, 20, 60, 1], cyan: [0, 255, 255, 1], darkblue: [0, 0, 139, 1], darkcyan: [0, 139, 139, 1], darkgoldenrod: [184, 134, 11, 1], darkgray: [169, 169, 169, 1], darkgreen: [0, 100, 0, 1], darkgrey: [169, 169, 169, 1], darkkhaki: [189, 183, 107, 1], darkmagenta: [139, 0, 139, 1], darkolivegreen: [85, 107, 47, 1], darkorange: [255, 140, 0, 1], darkorchid: [153, 50, 204, 1], darkred: [139, 0, 0, 1], darksalmon: [233, 150, 122, 1], darkseagreen: [143, 188, 143, 1], darkslateblue: [72, 61, 139, 1], darkslategray: [47, 79, 79, 1], darkslategrey: [47, 79, 79, 1], darkturquoise: [0, 206, 209, 1], darkviolet: [148, 0, 211, 1], deeppink: [255, 20, 147, 1], deepskyblue: [0, 191, 255, 1], dimgray: [105, 105, 105, 1], dimgrey: [105, 105, 105, 1], dodgerblue: [30, 144, 255, 1], firebrick: [178, 34, 34, 1], floralwhite: [255, 250, 240, 1], forestgreen: [34, 139, 34, 1], fuchsia: [255, 0, 255, 1], gainsboro: [220, 220, 220, 1], ghostwhite: [248, 248, 255, 1], gold: [255, 215, 0, 1], goldenrod: [218, 165, 32, 1], gray: [128, 128, 128, 1], green: [0, 128, 0, 1], greenyellow: [173, 255, 47, 1], grey: [128, 128, 128, 1], honeydew: [240, 255, 240, 1], hotpink: [255, 105, 180, 1], indianred: [205, 92, 92, 1], indigo: [75, 0, 130, 1], ivory: [255, 255, 240, 1], khaki: [240, 230, 140, 1], lavender: [230, 230, 250, 1], lavenderblush: [255, 240, 245, 1], lawngreen: [124, 252, 0, 1], lemonchiffon: [255, 250, 205, 1], lightblue: [173, 216, 230, 1], lightcoral: [240, 128, 128, 1], lightcyan: [224, 255, 255, 1], lightgoldenrodyellow: [250, 250, 210, 1], lightgray: [211, 211, 211, 1], lightgreen: [144, 238, 144, 1], lightgrey: [211, 211, 211, 1], lightpink: [255, 182, 193, 1], lightsalmon: [255, 160, 122, 1], lightseagreen: [32, 178, 170, 1], lightskyblue: [135, 206, 250, 1], lightslategray: [119, 136, 153, 1], lightslategrey: [119, 136, 153, 1], lightsteelblue: [176, 196, 222, 1], lightyellow: [255, 255, 224, 1], lime: [0, 255, 0, 1], limegreen: [50, 205, 50, 1], linen: [250, 240, 230, 1], magenta: [255, 0, 255, 1], maroon: [128, 0, 0, 1], mediumaquamarine: [102, 205, 170, 1], mediumblue: [0, 0, 205, 1], mediumorchid: [186, 85, 211, 1], mediumpurple: [147, 112, 219, 1], mediumseagreen: [60, 179, 113, 1], mediumslateblue: [123, 104, 238, 1], mediumspringgreen: [0, 250, 154, 1], mediumturquoise: [72, 209, 204, 1], mediumvioletred: [199, 21, 133, 1], midnightblue: [25, 25, 112, 1], mintcream: [245, 255, 250, 1], mistyrose: [255, 228, 225, 1], moccasin: [255, 228, 181, 1], navajowhite: [255, 222, 173, 1], navy: [0, 0, 128, 1], oldlace: [253, 245, 230, 1], olive: [128, 128, 0, 1], olivedrab: [107, 142, 35, 1], orange: [255, 165, 0, 1], orangered: [255, 69, 0, 1], orchid: [218, 112, 214, 1], palegoldenrod: [238, 232, 170, 1], palegreen: [152, 251, 152, 1], paleturquoise: [175, 238, 238, 1], palevioletred: [219, 112, 147, 1], papayawhip: [255, 239, 213, 1], peachpuff: [255, 218, 185, 1], peru: [205, 133, 63, 1], pink: [255, 192, 203, 1], plum: [221, 160, 221, 1], powderblue: [176, 224, 230, 1], purple: [128, 0, 128, 1], rebeccapurple: [102, 51, 153, 1], red: [255, 0, 0, 1], rosybrown: [188, 143, 143, 1], royalblue: [65, 105, 225, 1], saddlebrown: [139, 69, 19, 1], salmon: [250, 128, 114, 1], sandybrown: [244, 164, 96, 1], seagreen: [46, 139, 87, 1], seashell: [255, 245, 238, 1], sienna: [160, 82, 45, 1], silver: [192, 192, 192, 1], skyblue: [135, 206, 235, 1], slateblue: [106, 90, 205, 1], slategray: [112, 128, 144, 1], slategrey: [112, 128, 144, 1], snow: [255, 250, 250, 1], springgreen: [0, 255, 127, 1], steelblue: [70, 130, 180, 1], tan: [210, 180, 140, 1], teal: [0, 128, 128, 1], thistle: [216, 191, 216, 1], tomato: [255, 99, 71, 1], turquoise: [64, 224, 208, 1], violet: [238, 130, 238, 1], wheat: [245, 222, 179, 1], white: [255, 255, 255, 1], whitesmoke: [245, 245, 245, 1], yellow: [255, 255, 0, 1], yellowgreen: [154, 205, 50, 1] };
        function n2(t3) {
          return (t3 = Math.round(t3)) < 0 ? 0 : t3 > 255 ? 255 : t3;
        }
        function i3(t3) {
          return n2(t3[t3.length - 1] === "%" ? parseFloat(t3) / 100 * 255 : parseInt(t3));
        }
        function s3(t3) {
          return (e3 = t3[t3.length - 1] === "%" ? parseFloat(t3) / 100 : parseFloat(t3)) < 0 ? 0 : e3 > 1 ? 1 : e3;
          var e3;
        }
        function a2(t3, e3, r3) {
          return r3 < 0 ? r3 += 1 : r3 > 1 && (r3 -= 1), 6 * r3 < 1 ? t3 + (e3 - t3) * r3 * 6 : 2 * r3 < 1 ? e3 : 3 * r3 < 2 ? t3 + (e3 - t3) * (2 / 3 - r3) * 6 : t3;
        }
        try {
          e2.parseCSSColor = function(t3) {
            var e3, o2 = t3.replace(/ /g, "").toLowerCase();
            if (o2 in r2)
              return r2[o2].slice();
            if (o2[0] === "#")
              return o2.length === 4 ? (e3 = parseInt(o2.substr(1), 16)) >= 0 && e3 <= 4095 ? [(3840 & e3) >> 4 | (3840 & e3) >> 8, 240 & e3 | (240 & e3) >> 4, 15 & e3 | (15 & e3) << 4, 1] : null : o2.length === 7 && (e3 = parseInt(o2.substr(1), 16)) >= 0 && e3 <= 16777215 ? [(16711680 & e3) >> 16, (65280 & e3) >> 8, 255 & e3, 1] : null;
            var l2 = o2.indexOf("("), u2 = o2.indexOf(")");
            if (l2 !== -1 && u2 + 1 === o2.length) {
              var c2 = o2.substr(0, l2), h2 = o2.substr(l2 + 1, u2 - (l2 + 1)).split(","), p2 = 1;
              switch (c2) {
                case "rgba":
                  if (h2.length !== 4)
                    return null;
                  p2 = s3(h2.pop());
                case "rgb":
                  return h2.length !== 3 ? null : [i3(h2[0]), i3(h2[1]), i3(h2[2]), p2];
                case "hsla":
                  if (h2.length !== 4)
                    return null;
                  p2 = s3(h2.pop());
                case "hsl":
                  if (h2.length !== 3)
                    return null;
                  var d2 = (parseFloat(h2[0]) % 360 + 360) % 360 / 360, f2 = s3(h2[1]), y2 = s3(h2[2]), m2 = y2 <= 0.5 ? y2 * (f2 + 1) : y2 + f2 - y2 * f2, g2 = 2 * y2 - m2;
                  return [n2(255 * a2(g2, m2, d2 + 1 / 3)), n2(255 * a2(g2, m2, d2)), n2(255 * a2(g2, m2, d2 - 1 / 3)), p2];
                default:
                  return null;
              }
            }
            return null;
          };
        } catch (t3) {
        }
      });
      class Ge {
        constructor(t2, e2, r2, n2 = 1) {
          this.r = t2, this.g = e2, this.b = r2, this.a = n2;
        }
        static parse(t2) {
          if (!t2)
            return;
          if (t2 instanceof Ge)
            return t2;
          if (typeof t2 != "string")
            return;
          const e2 = Ne.parseCSSColor(t2);
          return e2 ? new Ge(e2[0] / 255 * e2[3], e2[1] / 255 * e2[3], e2[2] / 255 * e2[3], e2[3]) : void 0;
        }
        toString() {
          const [t2, e2, r2, n2] = this.toArray();
          return `rgba(${Math.round(t2)},${Math.round(e2)},${Math.round(r2)},${n2})`;
        }
        toArray() {
          const { r: t2, g: e2, b: r2, a: n2 } = this;
          return n2 === 0 ? [0, 0, 0, 0] : [255 * t2 / n2, 255 * e2 / n2, 255 * r2 / n2, n2];
        }
      }
      Ge.black = new Ge(0, 0, 0, 1), Ge.white = new Ge(1, 1, 1, 1), Ge.transparent = new Ge(0, 0, 0, 0), Ge.red = new Ge(1, 0, 0, 1), Ge.blue = new Ge(0, 0, 1, 1);
      class Ze {
        constructor(t2, e2, r2) {
          this.sensitivity = t2 ? e2 ? "variant" : "case" : e2 ? "accent" : "base", this.locale = r2, this.collator = new Intl.Collator(this.locale ? this.locale : [], { sensitivity: this.sensitivity, usage: "search" });
        }
        compare(t2, e2) {
          return this.collator.compare(t2, e2);
        }
        resolvedLocale() {
          return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
        }
      }
      class Xe {
        constructor(t2, e2, r2, n2, i3) {
          this.text = t2.normalize ? t2.normalize() : t2, this.image = e2, this.scale = r2, this.fontStack = n2, this.textColor = i3;
        }
      }
      class Ke {
        constructor(t2) {
          this.sections = t2;
        }
        static fromString(t2) {
          return new Ke([new Xe(t2, null, null, null, null)]);
        }
        isEmpty() {
          return this.sections.length === 0 || !this.sections.some((t2) => t2.text.length !== 0 || t2.image && t2.image.name.length !== 0);
        }
        static factory(t2) {
          return t2 instanceof Ke ? t2 : Ke.fromString(t2);
        }
        toString() {
          return this.sections.length === 0 ? "" : this.sections.map((t2) => t2.text).join("");
        }
        serialize() {
          const t2 = ["format"];
          for (const e2 of this.sections) {
            if (e2.image) {
              t2.push(["image", e2.image.name]);
              continue;
            }
            t2.push(e2.text);
            const r2 = {};
            e2.fontStack && (r2["text-font"] = ["literal", e2.fontStack.split(",")]), e2.scale && (r2["font-scale"] = e2.scale), e2.textColor && (r2["text-color"] = ["rgba"].concat(e2.textColor.toArray())), t2.push(r2);
          }
          return t2;
        }
      }
      class Ye {
        constructor(t2) {
          this.name = t2.name, this.available = t2.available;
        }
        toString() {
          return this.name;
        }
        static fromString(t2) {
          return t2 ? new Ye({ name: t2, available: false }) : null;
        }
        serialize() {
          return ["image", this.name];
        }
      }
      function He(t2, e2, r2, n2) {
        return typeof t2 == "number" && t2 >= 0 && t2 <= 255 && typeof e2 == "number" && e2 >= 0 && e2 <= 255 && typeof r2 == "number" && r2 >= 0 && r2 <= 255 ? n2 === void 0 || typeof n2 == "number" && n2 >= 0 && n2 <= 1 ? null : `Invalid rgba value [${[t2, e2, r2, n2].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${(typeof n2 == "number" ? [t2, e2, r2, n2] : [t2, e2, r2]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
      }
      function Je(t2) {
        if (t2 === null)
          return true;
        if (typeof t2 == "string")
          return true;
        if (typeof t2 == "boolean")
          return true;
        if (typeof t2 == "number")
          return true;
        if (t2 instanceof Ge)
          return true;
        if (t2 instanceof Ze)
          return true;
        if (t2 instanceof Ke)
          return true;
        if (t2 instanceof Ye)
          return true;
        if (Array.isArray(t2)) {
          for (const e2 of t2)
            if (!Je(e2))
              return false;
          return true;
        }
        if (typeof t2 == "object") {
          for (const e2 in t2)
            if (!Je(t2[e2]))
              return false;
          return true;
        }
        return false;
      }
      function We(t2) {
        if (t2 === null)
          return ze;
        if (typeof t2 == "string")
          return Te;
        if (typeof t2 == "boolean")
          return Be;
        if (typeof t2 == "number")
          return Me;
        if (t2 instanceof Ge)
          return Ce;
        if (t2 instanceof Ze)
          return De;
        if (t2 instanceof Ke)
          return Ve;
        if (t2 instanceof Ye)
          return Fe;
        if (Array.isArray(t2)) {
          const e2 = t2.length;
          let r2;
          for (const e3 of t2) {
            const t3 = We(e3);
            if (r2) {
              if (r2 === t3)
                continue;
              r2 = Ee;
              break;
            }
            r2 = t3;
          }
          return Le(r2 || Ee, e2);
        }
        return Pe;
      }
      function Qe(t2) {
        const e2 = typeof t2;
        return t2 === null ? "" : e2 === "string" || e2 === "number" || e2 === "boolean" ? String(t2) : t2 instanceof Ge || t2 instanceof Ke || t2 instanceof Ye ? t2.toString() : JSON.stringify(t2);
      }
      class tr {
        constructor(t2, e2) {
          this.type = t2, this.value = e2;
        }
        static parse(t2, e2) {
          if (t2.length !== 2)
            return e2.error(`'literal' expression requires exactly one argument, but found ${t2.length - 1} instead.`);
          if (!Je(t2[1]))
            return e2.error("invalid value");
          const r2 = t2[1];
          let n2 = We(r2);
          const i3 = e2.expectedType;
          return n2.kind !== "array" || n2.N !== 0 || !i3 || i3.kind !== "array" || typeof i3.N == "number" && i3.N !== 0 || (n2 = i3), new tr(n2, r2);
        }
        evaluate() {
          return this.value;
        }
        eachChild() {
        }
        outputDefined() {
          return true;
        }
        serialize() {
          return this.type.kind === "array" || this.type.kind === "object" ? ["literal", this.value] : this.value instanceof Ge ? ["rgba"].concat(this.value.toArray()) : this.value instanceof Ke ? this.value.serialize() : this.value;
        }
      }
      class er {
        constructor(t2) {
          this.name = "ExpressionEvaluationError", this.message = t2;
        }
        toJSON() {
          return this.message;
        }
      }
      const rr2 = { string: Te, number: Me, boolean: Be, object: Pe };
      class nr {
        constructor(t2, e2) {
          this.type = t2, this.args = e2;
        }
        static parse(t2, e2) {
          if (t2.length < 2)
            return e2.error("Expected at least one argument.");
          let r2, n2 = 1;
          const i3 = t2[0];
          if (i3 === "array") {
            let i4, s4;
            if (t2.length > 2) {
              const r3 = t2[1];
              if (typeof r3 != "string" || !(r3 in rr2) || r3 === "object")
                return e2.error('The item type argument of "array" must be one of string, number, boolean', 1);
              i4 = rr2[r3], n2++;
            } else
              i4 = Ee;
            if (t2.length > 3) {
              if (t2[2] !== null && (typeof t2[2] != "number" || t2[2] < 0 || t2[2] !== Math.floor(t2[2])))
                return e2.error('The length argument to "array" must be a positive integer literal', 2);
              s4 = t2[2], n2++;
            }
            r2 = Le(i4, s4);
          } else
            r2 = rr2[i3];
          const s3 = [];
          for (; n2 < t2.length; n2++) {
            const r3 = e2.parse(t2[n2], n2, Ee);
            if (!r3)
              return null;
            s3.push(r3);
          }
          return new nr(r2, s3);
        }
        evaluate(t2) {
          for (let e2 = 0; e2 < this.args.length; e2++) {
            const r2 = this.args[e2].evaluate(t2);
            if (!$e(this.type, We(r2)))
              return r2;
            if (e2 === this.args.length - 1)
              throw new er(`Expected value to be of type ${Re(this.type)}, but found ${Re(We(r2))} instead.`);
          }
          return null;
        }
        eachChild(t2) {
          this.args.forEach(t2);
        }
        outputDefined() {
          return this.args.every((t2) => t2.outputDefined());
        }
        serialize() {
          const t2 = this.type, e2 = [t2.kind];
          if (t2.kind === "array") {
            const r2 = t2.itemType;
            if (r2.kind === "string" || r2.kind === "number" || r2.kind === "boolean") {
              e2.push(r2.kind);
              const n2 = t2.N;
              (typeof n2 == "number" || this.args.length > 1) && e2.push(n2);
            }
          }
          return e2.concat(this.args.map((t3) => t3.serialize()));
        }
      }
      class ir {
        constructor(t2) {
          this.type = Ve, this.sections = t2;
        }
        static parse(t2, e2) {
          if (t2.length < 2)
            return e2.error("Expected at least one argument.");
          const r2 = t2[1];
          if (!Array.isArray(r2) && typeof r2 == "object")
            return e2.error("First argument must be an image or text section.");
          const n2 = [];
          let i3 = false;
          for (let r3 = 1; r3 <= t2.length - 1; ++r3) {
            const s3 = t2[r3];
            if (i3 && typeof s3 == "object" && !Array.isArray(s3)) {
              i3 = false;
              let t3 = null;
              if (s3["font-scale"] && (t3 = e2.parse(s3["font-scale"], 1, Me), !t3))
                return null;
              let r4 = null;
              if (s3["text-font"] && (r4 = e2.parse(s3["text-font"], 1, Le(Te)), !r4))
                return null;
              let a2 = null;
              if (s3["text-color"] && (a2 = e2.parse(s3["text-color"], 1, Ce), !a2))
                return null;
              const o2 = n2[n2.length - 1];
              o2.scale = t3, o2.font = r4, o2.textColor = a2;
            } else {
              const s4 = e2.parse(t2[r3], 1, Ee);
              if (!s4)
                return null;
              const a2 = s4.type.kind;
              if (a2 !== "string" && a2 !== "value" && a2 !== "null" && a2 !== "resolvedImage")
                return e2.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
              i3 = true, n2.push({ content: s4, scale: null, font: null, textColor: null });
            }
          }
          return new ir(n2);
        }
        evaluate(t2) {
          return new Ke(this.sections.map((e2) => {
            const r2 = e2.content.evaluate(t2);
            return We(r2) === Fe ? new Xe("", r2, null, null, null) : new Xe(Qe(r2), null, e2.scale ? e2.scale.evaluate(t2) : null, e2.font ? e2.font.evaluate(t2).join(",") : null, e2.textColor ? e2.textColor.evaluate(t2) : null);
          }));
        }
        eachChild(t2) {
          for (const e2 of this.sections)
            t2(e2.content), e2.scale && t2(e2.scale), e2.font && t2(e2.font), e2.textColor && t2(e2.textColor);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          const t2 = ["format"];
          for (const e2 of this.sections) {
            t2.push(e2.content.serialize());
            const r2 = {};
            e2.scale && (r2["font-scale"] = e2.scale.serialize()), e2.font && (r2["text-font"] = e2.font.serialize()), e2.textColor && (r2["text-color"] = e2.textColor.serialize()), t2.push(r2);
          }
          return t2;
        }
      }
      class sr {
        constructor(t2) {
          this.type = Fe, this.input = t2;
        }
        static parse(t2, e2) {
          if (t2.length !== 2)
            return e2.error("Expected two arguments.");
          const r2 = e2.parse(t2[1], 1, Te);
          return r2 ? new sr(r2) : e2.error("No image name provided.");
        }
        evaluate(t2) {
          const e2 = this.input.evaluate(t2), r2 = Ye.fromString(e2);
          return r2 && t2.availableImages && (r2.available = t2.availableImages.indexOf(e2) > -1), r2;
        }
        eachChild(t2) {
          t2(this.input);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          return ["image", this.input.serialize()];
        }
      }
      const ar = { "to-boolean": Be, "to-color": Ce, "to-number": Me, "to-string": Te };
      class or {
        constructor(t2, e2) {
          this.type = t2, this.args = e2;
        }
        static parse(t2, e2) {
          if (t2.length < 2)
            return e2.error("Expected at least one argument.");
          const r2 = t2[0];
          if ((r2 === "to-boolean" || r2 === "to-string") && t2.length !== 2)
            return e2.error("Expected one argument.");
          const n2 = ar[r2], i3 = [];
          for (let r3 = 1; r3 < t2.length; r3++) {
            const n3 = e2.parse(t2[r3], r3, Ee);
            if (!n3)
              return null;
            i3.push(n3);
          }
          return new or(n2, i3);
        }
        evaluate(t2) {
          if (this.type.kind === "boolean")
            return Boolean(this.args[0].evaluate(t2));
          if (this.type.kind === "color") {
            let e2, r2;
            for (const n2 of this.args) {
              if (e2 = n2.evaluate(t2), r2 = null, e2 instanceof Ge)
                return e2;
              if (typeof e2 == "string") {
                const r3 = t2.parseColor(e2);
                if (r3)
                  return r3;
              } else if (Array.isArray(e2) && (r2 = e2.length < 3 || e2.length > 4 ? `Invalid rbga value ${JSON.stringify(e2)}: expected an array containing either three or four numeric values.` : He(e2[0], e2[1], e2[2], e2[3]), !r2))
                return new Ge(e2[0] / 255, e2[1] / 255, e2[2] / 255, e2[3]);
            }
            throw new er(r2 || `Could not parse color from value '${typeof e2 == "string" ? e2 : String(JSON.stringify(e2))}'`);
          }
          if (this.type.kind === "number") {
            let e2 = null;
            for (const r2 of this.args) {
              if (e2 = r2.evaluate(t2), e2 === null)
                return 0;
              const n2 = Number(e2);
              if (!isNaN(n2))
                return n2;
            }
            throw new er(`Could not convert ${JSON.stringify(e2)} to number.`);
          }
          return this.type.kind === "formatted" ? Ke.fromString(Qe(this.args[0].evaluate(t2))) : this.type.kind === "resolvedImage" ? Ye.fromString(Qe(this.args[0].evaluate(t2))) : Qe(this.args[0].evaluate(t2));
        }
        eachChild(t2) {
          this.args.forEach(t2);
        }
        outputDefined() {
          return this.args.every((t2) => t2.outputDefined());
        }
        serialize() {
          if (this.type.kind === "formatted")
            return new ir([{ content: this.args[0], scale: null, font: null, textColor: null }]).serialize();
          if (this.type.kind === "resolvedImage")
            return new sr(this.args[0]).serialize();
          const t2 = [`to-${this.type.kind}`];
          return this.eachChild((e2) => {
            t2.push(e2.serialize());
          }), t2;
        }
      }
      const lr = ["Unknown", "Point", "LineString", "Polygon"];
      class ur {
        constructor() {
          this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null;
        }
        id() {
          return this.feature && "id" in this.feature ? this.feature.id : null;
        }
        geometryType() {
          return this.feature ? typeof this.feature.type == "number" ? lr[this.feature.type] : this.feature.type : null;
        }
        geometry() {
          return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
        }
        canonicalID() {
          return this.canonical;
        }
        properties() {
          return this.feature && this.feature.properties || {};
        }
        distanceFromCenter() {
          if (this.featureTileCoord && this.featureDistanceData) {
            const t2 = this.featureDistanceData.center, e2 = this.featureDistanceData.scale, { x: r2, y: n2 } = this.featureTileCoord;
            return this.featureDistanceData.bearing[0] * (r2 * e2 - t2[0]) + this.featureDistanceData.bearing[1] * (n2 * e2 - t2[1]);
          }
          return 0;
        }
        parseColor(t2) {
          let e2 = this._parseColorCache[t2];
          return e2 || (e2 = this._parseColorCache[t2] = Ge.parse(t2)), e2;
        }
      }
      class cr {
        constructor(t2, e2, r2, n2) {
          this.name = t2, this.type = e2, this._evaluate = r2, this.args = n2;
        }
        evaluate(t2) {
          return this._evaluate(t2, this.args);
        }
        eachChild(t2) {
          this.args.forEach(t2);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          return [this.name].concat(this.args.map((t2) => t2.serialize()));
        }
        static parse(t2, e2) {
          const r2 = t2[0], n2 = cr.definitions[r2];
          if (!n2)
            return e2.error(`Unknown expression "${r2}". If you wanted a literal array, use ["literal", [...]].`, 0);
          const i3 = Array.isArray(n2) ? n2[0] : n2.type, s3 = Array.isArray(n2) ? [[n2[1], n2[2]]] : n2.overloads, a2 = s3.filter(([e3]) => !Array.isArray(e3) || e3.length === t2.length - 1);
          let o2 = null;
          for (const [n3, s4] of a2) {
            o2 = new Er(e2.registry, e2.path, null, e2.scope);
            const a3 = [];
            let l2 = false;
            for (let e3 = 1; e3 < t2.length; e3++) {
              const r3 = t2[e3], i4 = Array.isArray(n3) ? n3[e3 - 1] : n3.type, s5 = o2.parse(r3, 1 + a3.length, i4);
              if (!s5) {
                l2 = true;
                break;
              }
              a3.push(s5);
            }
            if (!l2)
              if (Array.isArray(n3) && n3.length !== a3.length)
                o2.error(`Expected ${n3.length} arguments, but found ${a3.length} instead.`);
              else {
                for (let t3 = 0; t3 < a3.length; t3++) {
                  const e3 = Array.isArray(n3) ? n3[t3] : n3.type, r3 = a3[t3];
                  o2.concat(t3 + 1).checkSubtype(e3, r3.type);
                }
                if (o2.errors.length === 0)
                  return new cr(r2, i3, s4, a3);
              }
          }
          if (a2.length === 1)
            e2.errors.push(...o2.errors);
          else {
            const r3 = (a2.length ? a2 : s3).map(([t3]) => {
              return e3 = t3, Array.isArray(e3) ? `(${e3.map(Re).join(", ")})` : `(${Re(e3.type)}...)`;
              var e3;
            }).join(" | "), n3 = [];
            for (let r4 = 1; r4 < t2.length; r4++) {
              const i4 = e2.parse(t2[r4], 1 + n3.length);
              if (!i4)
                return null;
              n3.push(Re(i4.type));
            }
            e2.error(`Expected arguments of type ${r3}, but found (${n3.join(", ")}) instead.`);
          }
          return null;
        }
        static register(t2, e2) {
          cr.definitions = e2;
          for (const r2 in e2)
            t2[r2] = cr;
        }
      }
      class hr {
        constructor(t2, e2, r2) {
          this.type = De, this.locale = r2, this.caseSensitive = t2, this.diacriticSensitive = e2;
        }
        static parse(t2, e2) {
          if (t2.length !== 2)
            return e2.error("Expected one argument.");
          const r2 = t2[1];
          if (typeof r2 != "object" || Array.isArray(r2))
            return e2.error("Collator options argument must be an object.");
          const n2 = e2.parse(r2["case-sensitive"] !== void 0 && r2["case-sensitive"], 1, Be);
          if (!n2)
            return null;
          const i3 = e2.parse(r2["diacritic-sensitive"] !== void 0 && r2["diacritic-sensitive"], 1, Be);
          if (!i3)
            return null;
          let s3 = null;
          return r2.locale && (s3 = e2.parse(r2.locale, 1, Te), !s3) ? null : new hr(n2, i3, s3);
        }
        evaluate(t2) {
          return new Ze(this.caseSensitive.evaluate(t2), this.diacriticSensitive.evaluate(t2), this.locale ? this.locale.evaluate(t2) : null);
        }
        eachChild(t2) {
          t2(this.caseSensitive), t2(this.diacriticSensitive), this.locale && t2(this.locale);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          const t2 = {};
          return t2["case-sensitive"] = this.caseSensitive.serialize(), t2["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (t2.locale = this.locale.serialize()), ["collator", t2];
        }
      }
      const pr = 8192;
      function dr(t2, e2) {
        t2[0] = Math.min(t2[0], e2[0]), t2[1] = Math.min(t2[1], e2[1]), t2[2] = Math.max(t2[2], e2[0]), t2[3] = Math.max(t2[3], e2[1]);
      }
      function fr(t2, e2) {
        return !(t2[0] <= e2[0] || t2[2] >= e2[2] || t2[1] <= e2[1] || t2[3] >= e2[3]);
      }
      function yr(t2, e2) {
        const r2 = (180 + t2[0]) / 360, n2 = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t2[1] * Math.PI / 360))) / 360, i3 = Math.pow(2, e2.z);
        return [Math.round(r2 * i3 * pr), Math.round(n2 * i3 * pr)];
      }
      function mr(t2, e2, r2) {
        const n2 = t2[0] - e2[0], i3 = t2[1] - e2[1], s3 = t2[0] - r2[0], a2 = t2[1] - r2[1];
        return n2 * a2 - s3 * i3 == 0 && n2 * s3 <= 0 && i3 * a2 <= 0;
      }
      function gr(t2, e2) {
        let r2 = false;
        for (let a2 = 0, o2 = e2.length; a2 < o2; a2++) {
          const o3 = e2[a2];
          for (let e3 = 0, a3 = o3.length; e3 < a3 - 1; e3++) {
            if (mr(t2, o3[e3], o3[e3 + 1]))
              return false;
            (i3 = o3[e3])[1] > (n2 = t2)[1] != (s3 = o3[e3 + 1])[1] > n2[1] && n2[0] < (s3[0] - i3[0]) * (n2[1] - i3[1]) / (s3[1] - i3[1]) + i3[0] && (r2 = !r2);
          }
        }
        var n2, i3, s3;
        return r2;
      }
      function xr(t2, e2) {
        for (let r2 = 0; r2 < e2.length; r2++)
          if (gr(t2, e2[r2]))
            return true;
        return false;
      }
      function vr(t2, e2, r2, n2) {
        const i3 = n2[0] - r2[0], s3 = n2[1] - r2[1], a2 = (t2[0] - r2[0]) * s3 - i3 * (t2[1] - r2[1]), o2 = (e2[0] - r2[0]) * s3 - i3 * (e2[1] - r2[1]);
        return a2 > 0 && o2 < 0 || a2 < 0 && o2 > 0;
      }
      function br(t2, e2, r2) {
        for (const u2 of r2)
          for (let r3 = 0; r3 < u2.length - 1; ++r3)
            if ((o2 = [(a2 = u2[r3 + 1])[0] - (s3 = u2[r3])[0], a2[1] - s3[1]])[0] * (l2 = [(i3 = e2)[0] - (n2 = t2)[0], i3[1] - n2[1]])[1] - o2[1] * l2[0] != 0 && vr(n2, i3, s3, a2) && vr(s3, a2, n2, i3))
              return true;
        var n2, i3, s3, a2, o2, l2;
        return false;
      }
      function wr(t2, e2) {
        for (let r2 = 0; r2 < t2.length; ++r2)
          if (!gr(t2[r2], e2))
            return false;
        for (let r2 = 0; r2 < t2.length - 1; ++r2)
          if (br(t2[r2], t2[r2 + 1], e2))
            return false;
        return true;
      }
      function _r2(t2, e2) {
        for (let r2 = 0; r2 < e2.length; r2++)
          if (wr(t2, e2[r2]))
            return true;
        return false;
      }
      function Ar(t2, e2, r2) {
        const n2 = [];
        for (let i3 = 0; i3 < t2.length; i3++) {
          const s3 = [];
          for (let n3 = 0; n3 < t2[i3].length; n3++) {
            const a2 = yr(t2[i3][n3], r2);
            dr(e2, a2), s3.push(a2);
          }
          n2.push(s3);
        }
        return n2;
      }
      function kr(t2, e2, r2) {
        const n2 = [];
        for (let i3 = 0; i3 < t2.length; i3++) {
          const s3 = Ar(t2[i3], e2, r2);
          n2.push(s3);
        }
        return n2;
      }
      function Sr(t2, e2, r2, n2) {
        if (t2[0] < r2[0] || t2[0] > r2[2]) {
          const e3 = 0.5 * n2;
          let i3 = t2[0] - r2[0] > e3 ? -n2 : r2[0] - t2[0] > e3 ? n2 : 0;
          i3 === 0 && (i3 = t2[0] - r2[2] > e3 ? -n2 : r2[2] - t2[0] > e3 ? n2 : 0), t2[0] += i3;
        }
        dr(e2, t2);
      }
      function Ir(t2, e2, r2, n2) {
        const i3 = Math.pow(2, n2.z) * pr, s3 = [n2.x * pr, n2.y * pr], a2 = [];
        for (const n3 of t2)
          for (const t3 of n3) {
            const n4 = [t3.x + s3[0], t3.y + s3[1]];
            Sr(n4, e2, r2, i3), a2.push(n4);
          }
        return a2;
      }
      function zr(t2, e2, r2, n2) {
        const i3 = Math.pow(2, n2.z) * pr, s3 = [n2.x * pr, n2.y * pr], a2 = [];
        for (const r3 of t2) {
          const t3 = [];
          for (const n3 of r3) {
            const r4 = [n3.x + s3[0], n3.y + s3[1]];
            dr(e2, r4), t3.push(r4);
          }
          a2.push(t3);
        }
        if (e2[2] - e2[0] <= i3 / 2) {
          (o2 = e2)[0] = o2[1] = 1 / 0, o2[2] = o2[3] = -1 / 0;
          for (const t3 of a2)
            for (const n3 of t3)
              Sr(n3, e2, r2, i3);
        }
        var o2;
        return a2;
      }
      class Mr {
        constructor(t2, e2) {
          this.type = Be, this.geojson = t2, this.geometries = e2;
        }
        static parse(t2, e2) {
          if (t2.length !== 2)
            return e2.error(`'within' expression requires exactly one argument, but found ${t2.length - 1} instead.`);
          if (Je(t2[1])) {
            const e3 = t2[1];
            if (e3.type === "FeatureCollection")
              for (let t3 = 0; t3 < e3.features.length; ++t3) {
                const r2 = e3.features[t3].geometry.type;
                if (r2 === "Polygon" || r2 === "MultiPolygon")
                  return new Mr(e3, e3.features[t3].geometry);
              }
            else if (e3.type === "Feature") {
              const t3 = e3.geometry.type;
              if (t3 === "Polygon" || t3 === "MultiPolygon")
                return new Mr(e3, e3.geometry);
            } else if (e3.type === "Polygon" || e3.type === "MultiPolygon")
              return new Mr(e3, e3);
          }
          return e2.error("'within' expression requires valid geojson object that contains polygon geometry type.");
        }
        evaluate(t2) {
          if (t2.geometry() != null && t2.canonicalID() != null) {
            if (t2.geometryType() === "Point")
              return function(t3, e2) {
                const r2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], n2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], i3 = t3.canonicalID();
                if (e2.type === "Polygon") {
                  const s3 = Ar(e2.coordinates, n2, i3), a2 = Ir(t3.geometry(), r2, n2, i3);
                  if (!fr(r2, n2))
                    return false;
                  for (const t4 of a2)
                    if (!gr(t4, s3))
                      return false;
                }
                if (e2.type === "MultiPolygon") {
                  const s3 = kr(e2.coordinates, n2, i3), a2 = Ir(t3.geometry(), r2, n2, i3);
                  if (!fr(r2, n2))
                    return false;
                  for (const t4 of a2)
                    if (!xr(t4, s3))
                      return false;
                }
                return true;
              }(t2, this.geometries);
            if (t2.geometryType() === "LineString")
              return function(t3, e2) {
                const r2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], n2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], i3 = t3.canonicalID();
                if (e2.type === "Polygon") {
                  const s3 = Ar(e2.coordinates, n2, i3), a2 = zr(t3.geometry(), r2, n2, i3);
                  if (!fr(r2, n2))
                    return false;
                  for (const t4 of a2)
                    if (!wr(t4, s3))
                      return false;
                }
                if (e2.type === "MultiPolygon") {
                  const s3 = kr(e2.coordinates, n2, i3), a2 = zr(t3.geometry(), r2, n2, i3);
                  if (!fr(r2, n2))
                    return false;
                  for (const t4 of a2)
                    if (!_r2(t4, s3))
                      return false;
                }
                return true;
              }(t2, this.geometries);
          }
          return false;
        }
        eachChild() {
        }
        outputDefined() {
          return true;
        }
        serialize() {
          return ["within", this.geojson];
        }
      }
      function Tr(t2) {
        if (t2 instanceof cr) {
          if (t2.name === "get" && t2.args.length === 1)
            return false;
          if (t2.name === "feature-state")
            return false;
          if (t2.name === "has" && t2.args.length === 1)
            return false;
          if (t2.name === "properties" || t2.name === "geometry-type" || t2.name === "id")
            return false;
          if (/^filter-/.test(t2.name))
            return false;
        }
        if (t2 instanceof Mr)
          return false;
        let e2 = true;
        return t2.eachChild((t3) => {
          e2 && !Tr(t3) && (e2 = false);
        }), e2;
      }
      function Br(t2) {
        if (t2 instanceof cr && t2.name === "feature-state")
          return false;
        let e2 = true;
        return t2.eachChild((t3) => {
          e2 && !Br(t3) && (e2 = false);
        }), e2;
      }
      function Cr(t2, e2) {
        if (t2 instanceof cr && e2.indexOf(t2.name) >= 0)
          return false;
        let r2 = true;
        return t2.eachChild((t3) => {
          r2 && !Cr(t3, e2) && (r2 = false);
        }), r2;
      }
      class Pr {
        constructor(t2, e2) {
          this.type = e2.type, this.name = t2, this.boundExpression = e2;
        }
        static parse(t2, e2) {
          if (t2.length !== 2 || typeof t2[1] != "string")
            return e2.error("'var' expression requires exactly one string literal argument.");
          const r2 = t2[1];
          return e2.scope.has(r2) ? new Pr(r2, e2.scope.get(r2)) : e2.error(`Unknown variable "${r2}". Make sure "${r2}" has been bound in an enclosing "let" expression before using it.`, 1);
        }
        evaluate(t2) {
          return this.boundExpression.evaluate(t2);
        }
        eachChild() {
        }
        outputDefined() {
          return false;
        }
        serialize() {
          return ["var", this.name];
        }
      }
      class Er {
        constructor(t2, e2 = [], r2, n2 = new Ie(), i3 = []) {
          this.registry = t2, this.path = e2, this.key = e2.map((t3) => `[${t3}]`).join(""), this.scope = n2, this.errors = i3, this.expectedType = r2;
        }
        parse(t2, e2, r2, n2, i3 = {}) {
          return e2 ? this.concat(e2, r2, n2)._parse(t2, i3) : this._parse(t2, i3);
        }
        _parse(t2, e2) {
          function r2(t3, e3, r3) {
            return r3 === "assert" ? new nr(e3, [t3]) : r3 === "coerce" ? new or(e3, [t3]) : t3;
          }
          if (t2 !== null && typeof t2 != "string" && typeof t2 != "boolean" && typeof t2 != "number" || (t2 = ["literal", t2]), Array.isArray(t2)) {
            if (t2.length === 0)
              return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
            const n2 = t2[0];
            if (typeof n2 != "string")
              return this.error(`Expression name must be a string, but found ${typeof n2} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
            const i3 = this.registry[n2];
            if (i3) {
              let n3 = i3.parse(t2, this);
              if (!n3)
                return null;
              if (this.expectedType) {
                const t3 = this.expectedType, i4 = n3.type;
                if (t3.kind !== "string" && t3.kind !== "number" && t3.kind !== "boolean" && t3.kind !== "object" && t3.kind !== "array" || i4.kind !== "value")
                  if (t3.kind !== "color" && t3.kind !== "formatted" && t3.kind !== "resolvedImage" || i4.kind !== "value" && i4.kind !== "string") {
                    if (this.checkSubtype(t3, i4))
                      return null;
                  } else
                    n3 = r2(n3, t3, e2.typeAnnotation || "coerce");
                else
                  n3 = r2(n3, t3, e2.typeAnnotation || "assert");
              }
              if (!(n3 instanceof tr) && n3.type.kind !== "resolvedImage" && Dr(n3)) {
                const t3 = new ur();
                try {
                  n3 = new tr(n3.type, n3.evaluate(t3));
                } catch (t4) {
                  return this.error(t4.message), null;
                }
              }
              return n3;
            }
            return this.error(`Unknown expression "${n2}". If you wanted a literal array, use ["literal", [...]].`, 0);
          }
          return this.error(t2 === void 0 ? "'undefined' value invalid. Use null instead." : typeof t2 == "object" ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof t2} instead.`);
        }
        concat(t2, e2, r2) {
          const n2 = typeof t2 == "number" ? this.path.concat(t2) : this.path, i3 = r2 ? this.scope.concat(r2) : this.scope;
          return new Er(this.registry, n2, e2 || null, i3, this.errors);
        }
        error(t2, ...e2) {
          const r2 = `${this.key}${e2.map((t3) => `[${t3}]`).join("")}`;
          this.errors.push(new Se(r2, t2));
        }
        checkSubtype(t2, e2) {
          const r2 = $e(t2, e2);
          return r2 && this.error(r2), r2;
        }
      }
      function Dr(t2) {
        if (t2 instanceof Pr)
          return Dr(t2.boundExpression);
        if (t2 instanceof cr && t2.name === "error")
          return false;
        if (t2 instanceof hr)
          return false;
        if (t2 instanceof Mr)
          return false;
        const e2 = t2 instanceof or || t2 instanceof nr;
        let r2 = true;
        return t2.eachChild((t3) => {
          r2 = e2 ? r2 && Dr(t3) : r2 && t3 instanceof tr;
        }), !!r2 && Tr(t2) && Cr(t2, ["zoom", "heatmap-density", "line-progress", "sky-radial-progress", "accumulated", "is-supported-script", "pitch", "distance-from-center"]);
      }
      function Vr(t2, e2) {
        const r2 = t2.length - 1;
        let n2, i3, s3 = 0, a2 = r2, o2 = 0;
        for (; s3 <= a2; )
          if (o2 = Math.floor((s3 + a2) / 2), n2 = t2[o2], i3 = t2[o2 + 1], n2 <= e2) {
            if (o2 === r2 || e2 < i3)
              return o2;
            s3 = o2 + 1;
          } else {
            if (!(n2 > e2))
              throw new er("Input is not a number.");
            a2 = o2 - 1;
          }
        return 0;
      }
      class Fr {
        constructor(t2, e2, r2) {
          this.type = t2, this.input = e2, this.labels = [], this.outputs = [];
          for (const [t3, e3] of r2)
            this.labels.push(t3), this.outputs.push(e3);
        }
        static parse(t2, e2) {
          if (t2.length - 1 < 4)
            return e2.error(`Expected at least 4 arguments, but found only ${t2.length - 1}.`);
          if ((t2.length - 1) % 2 != 0)
            return e2.error("Expected an even number of arguments.");
          const r2 = e2.parse(t2[1], 1, Me);
          if (!r2)
            return null;
          const n2 = [];
          let i3 = null;
          e2.expectedType && e2.expectedType.kind !== "value" && (i3 = e2.expectedType);
          for (let r3 = 1; r3 < t2.length; r3 += 2) {
            const s3 = r3 === 1 ? -1 / 0 : t2[r3], a2 = t2[r3 + 1], o2 = r3, l2 = r3 + 1;
            if (typeof s3 != "number")
              return e2.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', o2);
            if (n2.length && n2[n2.length - 1][0] >= s3)
              return e2.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', o2);
            const u2 = e2.parse(a2, l2, i3);
            if (!u2)
              return null;
            i3 = i3 || u2.type, n2.push([s3, u2]);
          }
          return new Fr(i3, r2, n2);
        }
        evaluate(t2) {
          const e2 = this.labels, r2 = this.outputs;
          if (e2.length === 1)
            return r2[0].evaluate(t2);
          const n2 = this.input.evaluate(t2);
          if (n2 <= e2[0])
            return r2[0].evaluate(t2);
          const i3 = e2.length;
          return n2 >= e2[i3 - 1] ? r2[i3 - 1].evaluate(t2) : r2[Vr(e2, n2)].evaluate(t2);
        }
        eachChild(t2) {
          t2(this.input);
          for (const e2 of this.outputs)
            t2(e2);
        }
        outputDefined() {
          return this.outputs.every((t2) => t2.outputDefined());
        }
        serialize() {
          const t2 = ["step", this.input.serialize()];
          for (let e2 = 0; e2 < this.labels.length; e2++)
            e2 > 0 && t2.push(this.labels[e2]), t2.push(this.outputs[e2].serialize());
          return t2;
        }
      }
      function Lr(t2, e2, r2) {
        return t2 * (1 - r2) + e2 * r2;
      }
      var Rr = Object.freeze({ __proto__: null, number: Lr, color: function(t2, e2, r2) {
        return new Ge(Lr(t2.r, e2.r, r2), Lr(t2.g, e2.g, r2), Lr(t2.b, e2.b, r2), Lr(t2.a, e2.a, r2));
      }, array: function(t2, e2, r2) {
        return t2.map((t3, n2) => Lr(t3, e2[n2], r2));
      } });
      const Ur = 0.95047, $r = 1.08883, Or = 4 / 29, jr = 6 / 29, qr = 3 * jr * jr, Nr = Math.PI / 180, Gr = 180 / Math.PI;
      function Zr(t2) {
        return t2 > 0.008856451679035631 ? Math.pow(t2, 1 / 3) : t2 / qr + Or;
      }
      function Xr(t2) {
        return t2 > jr ? t2 * t2 * t2 : qr * (t2 - Or);
      }
      function Kr(t2) {
        return 255 * (t2 <= 31308e-7 ? 12.92 * t2 : 1.055 * Math.pow(t2, 1 / 2.4) - 0.055);
      }
      function Yr(t2) {
        return (t2 /= 255) <= 0.04045 ? t2 / 12.92 : Math.pow((t2 + 0.055) / 1.055, 2.4);
      }
      function Hr(t2) {
        const e2 = Yr(t2.r), r2 = Yr(t2.g), n2 = Yr(t2.b), i3 = Zr((0.4124564 * e2 + 0.3575761 * r2 + 0.1804375 * n2) / Ur), s3 = Zr((0.2126729 * e2 + 0.7151522 * r2 + 0.072175 * n2) / 1);
        return { l: 116 * s3 - 16, a: 500 * (i3 - s3), b: 200 * (s3 - Zr((0.0193339 * e2 + 0.119192 * r2 + 0.9503041 * n2) / $r)), alpha: t2.a };
      }
      function Jr(t2) {
        let e2 = (t2.l + 16) / 116, r2 = isNaN(t2.a) ? e2 : e2 + t2.a / 500, n2 = isNaN(t2.b) ? e2 : e2 - t2.b / 200;
        return e2 = 1 * Xr(e2), r2 = Ur * Xr(r2), n2 = $r * Xr(n2), new Ge(Kr(3.2404542 * r2 - 1.5371385 * e2 - 0.4985314 * n2), Kr(-0.969266 * r2 + 1.8760108 * e2 + 0.041556 * n2), Kr(0.0556434 * r2 - 0.2040259 * e2 + 1.0572252 * n2), t2.alpha);
      }
      function Wr(t2, e2, r2) {
        const n2 = e2 - t2;
        return t2 + r2 * (n2 > 180 || n2 < -180 ? n2 - 360 * Math.round(n2 / 360) : n2);
      }
      const Qr = { forward: Hr, reverse: Jr, interpolate: function(t2, e2, r2) {
        return { l: Lr(t2.l, e2.l, r2), a: Lr(t2.a, e2.a, r2), b: Lr(t2.b, e2.b, r2), alpha: Lr(t2.alpha, e2.alpha, r2) };
      } }, tn = { forward: function(t2) {
        const { l: e2, a: r2, b: n2 } = Hr(t2), i3 = Math.atan2(n2, r2) * Gr;
        return { h: i3 < 0 ? i3 + 360 : i3, c: Math.sqrt(r2 * r2 + n2 * n2), l: e2, alpha: t2.a };
      }, reverse: function(t2) {
        const e2 = t2.h * Nr, r2 = t2.c;
        return Jr({ l: t2.l, a: Math.cos(e2) * r2, b: Math.sin(e2) * r2, alpha: t2.alpha });
      }, interpolate: function(t2, e2, r2) {
        return { h: Wr(t2.h, e2.h, r2), c: Lr(t2.c, e2.c, r2), l: Lr(t2.l, e2.l, r2), alpha: Lr(t2.alpha, e2.alpha, r2) };
      } };
      var en = Object.freeze({ __proto__: null, lab: Qr, hcl: tn });
      class rn {
        constructor(t2, e2, r2, n2, i3) {
          this.type = t2, this.operator = e2, this.interpolation = r2, this.input = n2, this.labels = [], this.outputs = [];
          for (const [t3, e3] of i3)
            this.labels.push(t3), this.outputs.push(e3);
        }
        static interpolationFactor(t2, e2, n2, i3) {
          let s3 = 0;
          if (t2.name === "exponential")
            s3 = nn(e2, t2.base, n2, i3);
          else if (t2.name === "linear")
            s3 = nn(e2, 1, n2, i3);
          else if (t2.name === "cubic-bezier") {
            const a2 = t2.controlPoints;
            s3 = new r(a2[0], a2[1], a2[2], a2[3]).solve(nn(e2, 1, n2, i3));
          }
          return s3;
        }
        static parse(t2, e2) {
          let [r2, n2, i3, ...s3] = t2;
          if (!Array.isArray(n2) || n2.length === 0)
            return e2.error("Expected an interpolation type expression.", 1);
          if (n2[0] === "linear")
            n2 = { name: "linear" };
          else if (n2[0] === "exponential") {
            const t3 = n2[1];
            if (typeof t3 != "number")
              return e2.error("Exponential interpolation requires a numeric base.", 1, 1);
            n2 = { name: "exponential", base: t3 };
          } else {
            if (n2[0] !== "cubic-bezier")
              return e2.error(`Unknown interpolation type ${String(n2[0])}`, 1, 0);
            {
              const t3 = n2.slice(1);
              if (t3.length !== 4 || t3.some((t4) => typeof t4 != "number" || t4 < 0 || t4 > 1))
                return e2.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
              n2 = { name: "cubic-bezier", controlPoints: t3 };
            }
          }
          if (t2.length - 1 < 4)
            return e2.error(`Expected at least 4 arguments, but found only ${t2.length - 1}.`);
          if ((t2.length - 1) % 2 != 0)
            return e2.error("Expected an even number of arguments.");
          if (i3 = e2.parse(i3, 2, Me), !i3)
            return null;
          const a2 = [];
          let o2 = null;
          r2 === "interpolate-hcl" || r2 === "interpolate-lab" ? o2 = Ce : e2.expectedType && e2.expectedType.kind !== "value" && (o2 = e2.expectedType);
          for (let t3 = 0; t3 < s3.length; t3 += 2) {
            const r3 = s3[t3], n3 = s3[t3 + 1], i4 = t3 + 3, l2 = t3 + 4;
            if (typeof r3 != "number")
              return e2.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i4);
            if (a2.length && a2[a2.length - 1][0] >= r3)
              return e2.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i4);
            const u2 = e2.parse(n3, l2, o2);
            if (!u2)
              return null;
            o2 = o2 || u2.type, a2.push([r3, u2]);
          }
          return o2.kind === "number" || o2.kind === "color" || o2.kind === "array" && o2.itemType.kind === "number" && typeof o2.N == "number" ? new rn(o2, r2, n2, i3, a2) : e2.error(`Type ${Re(o2)} is not interpolatable.`);
        }
        evaluate(t2) {
          const e2 = this.labels, r2 = this.outputs;
          if (e2.length === 1)
            return r2[0].evaluate(t2);
          const n2 = this.input.evaluate(t2);
          if (n2 <= e2[0])
            return r2[0].evaluate(t2);
          const i3 = e2.length;
          if (n2 >= e2[i3 - 1])
            return r2[i3 - 1].evaluate(t2);
          const s3 = Vr(e2, n2), a2 = rn.interpolationFactor(this.interpolation, n2, e2[s3], e2[s3 + 1]), o2 = r2[s3].evaluate(t2), l2 = r2[s3 + 1].evaluate(t2);
          return this.operator === "interpolate" ? Rr[this.type.kind.toLowerCase()](o2, l2, a2) : this.operator === "interpolate-hcl" ? tn.reverse(tn.interpolate(tn.forward(o2), tn.forward(l2), a2)) : Qr.reverse(Qr.interpolate(Qr.forward(o2), Qr.forward(l2), a2));
        }
        eachChild(t2) {
          t2(this.input);
          for (const e2 of this.outputs)
            t2(e2);
        }
        outputDefined() {
          return this.outputs.every((t2) => t2.outputDefined());
        }
        serialize() {
          let t2;
          t2 = this.interpolation.name === "linear" ? ["linear"] : this.interpolation.name === "exponential" ? this.interpolation.base === 1 ? ["linear"] : ["exponential", this.interpolation.base] : ["cubic-bezier"].concat(this.interpolation.controlPoints);
          const e2 = [this.operator, t2, this.input.serialize()];
          for (let t3 = 0; t3 < this.labels.length; t3++)
            e2.push(this.labels[t3], this.outputs[t3].serialize());
          return e2;
        }
      }
      function nn(t2, e2, r2, n2) {
        const i3 = n2 - r2, s3 = t2 - r2;
        return i3 === 0 ? 0 : e2 === 1 ? s3 / i3 : (Math.pow(e2, s3) - 1) / (Math.pow(e2, i3) - 1);
      }
      class sn {
        constructor(t2, e2) {
          this.type = t2, this.args = e2;
        }
        static parse(t2, e2) {
          if (t2.length < 2)
            return e2.error("Expectected at least one argument.");
          let r2 = null;
          const n2 = e2.expectedType;
          n2 && n2.kind !== "value" && (r2 = n2);
          const i3 = [];
          for (const n3 of t2.slice(1)) {
            const t3 = e2.parse(n3, 1 + i3.length, r2, void 0, { typeAnnotation: "omit" });
            if (!t3)
              return null;
            r2 = r2 || t3.type, i3.push(t3);
          }
          const s3 = n2 && i3.some((t3) => $e(n2, t3.type));
          return new sn(s3 ? Ee : r2, i3);
        }
        evaluate(t2) {
          let e2, r2 = null, n2 = 0;
          for (const i3 of this.args) {
            if (n2++, r2 = i3.evaluate(t2), r2 && r2 instanceof Ye && !r2.available && (e2 || (e2 = r2), r2 = null, n2 === this.args.length))
              return e2;
            if (r2 !== null)
              break;
          }
          return r2;
        }
        eachChild(t2) {
          this.args.forEach(t2);
        }
        outputDefined() {
          return this.args.every((t2) => t2.outputDefined());
        }
        serialize() {
          const t2 = ["coalesce"];
          return this.eachChild((e2) => {
            t2.push(e2.serialize());
          }), t2;
        }
      }
      class an {
        constructor(t2, e2) {
          this.type = e2.type, this.bindings = [].concat(t2), this.result = e2;
        }
        evaluate(t2) {
          return this.result.evaluate(t2);
        }
        eachChild(t2) {
          for (const e2 of this.bindings)
            t2(e2[1]);
          t2(this.result);
        }
        static parse(t2, e2) {
          if (t2.length < 4)
            return e2.error(`Expected at least 3 arguments, but found ${t2.length - 1} instead.`);
          const r2 = [];
          for (let n3 = 1; n3 < t2.length - 1; n3 += 2) {
            const i3 = t2[n3];
            if (typeof i3 != "string")
              return e2.error(`Expected string, but found ${typeof i3} instead.`, n3);
            if (/[^a-zA-Z0-9_]/.test(i3))
              return e2.error("Variable names must contain only alphanumeric characters or '_'.", n3);
            const s3 = e2.parse(t2[n3 + 1], n3 + 1);
            if (!s3)
              return null;
            r2.push([i3, s3]);
          }
          const n2 = e2.parse(t2[t2.length - 1], t2.length - 1, e2.expectedType, r2);
          return n2 ? new an(r2, n2) : null;
        }
        outputDefined() {
          return this.result.outputDefined();
        }
        serialize() {
          const t2 = ["let"];
          for (const [e2, r2] of this.bindings)
            t2.push(e2, r2.serialize());
          return t2.push(this.result.serialize()), t2;
        }
      }
      class on {
        constructor(t2, e2, r2) {
          this.type = t2, this.index = e2, this.input = r2;
        }
        static parse(t2, e2) {
          if (t2.length !== 3)
            return e2.error(`Expected 2 arguments, but found ${t2.length - 1} instead.`);
          const r2 = e2.parse(t2[1], 1, Me), n2 = e2.parse(t2[2], 2, Le(e2.expectedType || Ee));
          return r2 && n2 ? new on(n2.type.itemType, r2, n2) : null;
        }
        evaluate(t2) {
          const e2 = this.index.evaluate(t2), r2 = this.input.evaluate(t2);
          if (e2 < 0)
            throw new er(`Array index out of bounds: ${e2} < 0.`);
          if (e2 >= r2.length)
            throw new er(`Array index out of bounds: ${e2} > ${r2.length - 1}.`);
          if (e2 !== Math.floor(e2))
            throw new er(`Array index must be an integer, but found ${e2} instead.`);
          return r2[e2];
        }
        eachChild(t2) {
          t2(this.index), t2(this.input);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          return ["at", this.index.serialize(), this.input.serialize()];
        }
      }
      class ln {
        constructor(t2, e2) {
          this.type = Be, this.needle = t2, this.haystack = e2;
        }
        static parse(t2, e2) {
          if (t2.length !== 3)
            return e2.error(`Expected 2 arguments, but found ${t2.length - 1} instead.`);
          const r2 = e2.parse(t2[1], 1, Ee), n2 = e2.parse(t2[2], 2, Ee);
          return r2 && n2 ? Oe(r2.type, [Be, Te, Me, ze, Ee]) ? new ln(r2, n2) : e2.error(`Expected first argument to be of type boolean, string, number or null, but found ${Re(r2.type)} instead`) : null;
        }
        evaluate(t2) {
          const e2 = this.needle.evaluate(t2), r2 = this.haystack.evaluate(t2);
          if (!r2)
            return false;
          if (!je(e2, ["boolean", "string", "number", "null"]))
            throw new er(`Expected first argument to be of type boolean, string, number or null, but found ${Re(We(e2))} instead.`);
          if (!je(r2, ["string", "array"]))
            throw new er(`Expected second argument to be of type array or string, but found ${Re(We(r2))} instead.`);
          return r2.indexOf(e2) >= 0;
        }
        eachChild(t2) {
          t2(this.needle), t2(this.haystack);
        }
        outputDefined() {
          return true;
        }
        serialize() {
          return ["in", this.needle.serialize(), this.haystack.serialize()];
        }
      }
      class un {
        constructor(t2, e2, r2) {
          this.type = Me, this.needle = t2, this.haystack = e2, this.fromIndex = r2;
        }
        static parse(t2, e2) {
          if (t2.length <= 2 || t2.length >= 5)
            return e2.error(`Expected 3 or 4 arguments, but found ${t2.length - 1} instead.`);
          const r2 = e2.parse(t2[1], 1, Ee), n2 = e2.parse(t2[2], 2, Ee);
          if (!r2 || !n2)
            return null;
          if (!Oe(r2.type, [Be, Te, Me, ze, Ee]))
            return e2.error(`Expected first argument to be of type boolean, string, number or null, but found ${Re(r2.type)} instead`);
          if (t2.length === 4) {
            const i3 = e2.parse(t2[3], 3, Me);
            return i3 ? new un(r2, n2, i3) : null;
          }
          return new un(r2, n2);
        }
        evaluate(t2) {
          const e2 = this.needle.evaluate(t2), r2 = this.haystack.evaluate(t2);
          if (!je(e2, ["boolean", "string", "number", "null"]))
            throw new er(`Expected first argument to be of type boolean, string, number or null, but found ${Re(We(e2))} instead.`);
          if (!je(r2, ["string", "array"]))
            throw new er(`Expected second argument to be of type array or string, but found ${Re(We(r2))} instead.`);
          if (this.fromIndex) {
            const n2 = this.fromIndex.evaluate(t2);
            return r2.indexOf(e2, n2);
          }
          return r2.indexOf(e2);
        }
        eachChild(t2) {
          t2(this.needle), t2(this.haystack), this.fromIndex && t2(this.fromIndex);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          if (this.fromIndex != null && this.fromIndex !== void 0) {
            const t2 = this.fromIndex.serialize();
            return ["index-of", this.needle.serialize(), this.haystack.serialize(), t2];
          }
          return ["index-of", this.needle.serialize(), this.haystack.serialize()];
        }
      }
      class cn {
        constructor(t2, e2, r2, n2, i3, s3) {
          this.inputType = t2, this.type = e2, this.input = r2, this.cases = n2, this.outputs = i3, this.otherwise = s3;
        }
        static parse(t2, e2) {
          if (t2.length < 5)
            return e2.error(`Expected at least 4 arguments, but found only ${t2.length - 1}.`);
          if (t2.length % 2 != 1)
            return e2.error("Expected an even number of arguments.");
          let r2, n2;
          e2.expectedType && e2.expectedType.kind !== "value" && (n2 = e2.expectedType);
          const i3 = {}, s3 = [];
          for (let a3 = 2; a3 < t2.length - 1; a3 += 2) {
            let o3 = t2[a3];
            const l2 = t2[a3 + 1];
            Array.isArray(o3) || (o3 = [o3]);
            const u2 = e2.concat(a3);
            if (o3.length === 0)
              return u2.error("Expected at least one branch label.");
            for (const t3 of o3) {
              if (typeof t3 != "number" && typeof t3 != "string")
                return u2.error("Branch labels must be numbers or strings.");
              if (typeof t3 == "number" && Math.abs(t3) > Number.MAX_SAFE_INTEGER)
                return u2.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
              if (typeof t3 == "number" && Math.floor(t3) !== t3)
                return u2.error("Numeric branch labels must be integer values.");
              if (r2) {
                if (u2.checkSubtype(r2, We(t3)))
                  return null;
              } else
                r2 = We(t3);
              if (i3[String(t3)] !== void 0)
                return u2.error("Branch labels must be unique.");
              i3[String(t3)] = s3.length;
            }
            const c2 = e2.parse(l2, a3, n2);
            if (!c2)
              return null;
            n2 = n2 || c2.type, s3.push(c2);
          }
          const a2 = e2.parse(t2[1], 1, Ee);
          if (!a2)
            return null;
          const o2 = e2.parse(t2[t2.length - 1], t2.length - 1, n2);
          return o2 ? a2.type.kind !== "value" && e2.concat(1).checkSubtype(r2, a2.type) ? null : new cn(r2, n2, a2, i3, s3, o2) : null;
        }
        evaluate(t2) {
          const e2 = this.input.evaluate(t2);
          return (We(e2) === this.inputType && this.outputs[this.cases[e2]] || this.otherwise).evaluate(t2);
        }
        eachChild(t2) {
          t2(this.input), this.outputs.forEach(t2), t2(this.otherwise);
        }
        outputDefined() {
          return this.outputs.every((t2) => t2.outputDefined()) && this.otherwise.outputDefined();
        }
        serialize() {
          const t2 = ["match", this.input.serialize()], e2 = Object.keys(this.cases).sort(), r2 = [], n2 = {};
          for (const t3 of e2) {
            const e3 = n2[this.cases[t3]];
            e3 === void 0 ? (n2[this.cases[t3]] = r2.length, r2.push([this.cases[t3], [t3]])) : r2[e3][1].push(t3);
          }
          const i3 = (t3) => this.inputType.kind === "number" ? Number(t3) : t3;
          for (const [e3, n3] of r2)
            t2.push(n3.length === 1 ? i3(n3[0]) : n3.map(i3)), t2.push(this.outputs[e3].serialize());
          return t2.push(this.otherwise.serialize()), t2;
        }
      }
      class hn {
        constructor(t2, e2, r2) {
          this.type = t2, this.branches = e2, this.otherwise = r2;
        }
        static parse(t2, e2) {
          if (t2.length < 4)
            return e2.error(`Expected at least 3 arguments, but found only ${t2.length - 1}.`);
          if (t2.length % 2 != 0)
            return e2.error("Expected an odd number of arguments.");
          let r2;
          e2.expectedType && e2.expectedType.kind !== "value" && (r2 = e2.expectedType);
          const n2 = [];
          for (let i4 = 1; i4 < t2.length - 1; i4 += 2) {
            const s3 = e2.parse(t2[i4], i4, Be);
            if (!s3)
              return null;
            const a2 = e2.parse(t2[i4 + 1], i4 + 1, r2);
            if (!a2)
              return null;
            n2.push([s3, a2]), r2 = r2 || a2.type;
          }
          const i3 = e2.parse(t2[t2.length - 1], t2.length - 1, r2);
          return i3 ? new hn(r2, n2, i3) : null;
        }
        evaluate(t2) {
          for (const [e2, r2] of this.branches)
            if (e2.evaluate(t2))
              return r2.evaluate(t2);
          return this.otherwise.evaluate(t2);
        }
        eachChild(t2) {
          for (const [e2, r2] of this.branches)
            t2(e2), t2(r2);
          t2(this.otherwise);
        }
        outputDefined() {
          return this.branches.every(([t2, e2]) => e2.outputDefined()) && this.otherwise.outputDefined();
        }
        serialize() {
          const t2 = ["case"];
          return this.eachChild((e2) => {
            t2.push(e2.serialize());
          }), t2;
        }
      }
      class pn {
        constructor(t2, e2, r2, n2) {
          this.type = t2, this.input = e2, this.beginIndex = r2, this.endIndex = n2;
        }
        static parse(t2, e2) {
          if (t2.length <= 2 || t2.length >= 5)
            return e2.error(`Expected 3 or 4 arguments, but found ${t2.length - 1} instead.`);
          const r2 = e2.parse(t2[1], 1, Ee), n2 = e2.parse(t2[2], 2, Me);
          if (!r2 || !n2)
            return null;
          if (!Oe(r2.type, [Le(Ee), Te, Ee]))
            return e2.error(`Expected first argument to be of type array or string, but found ${Re(r2.type)} instead`);
          if (t2.length === 4) {
            const i3 = e2.parse(t2[3], 3, Me);
            return i3 ? new pn(r2.type, r2, n2, i3) : null;
          }
          return new pn(r2.type, r2, n2);
        }
        evaluate(t2) {
          const e2 = this.input.evaluate(t2), r2 = this.beginIndex.evaluate(t2);
          if (!je(e2, ["string", "array"]))
            throw new er(`Expected first argument to be of type array or string, but found ${Re(We(e2))} instead.`);
          if (this.endIndex) {
            const n2 = this.endIndex.evaluate(t2);
            return e2.slice(r2, n2);
          }
          return e2.slice(r2);
        }
        eachChild(t2) {
          t2(this.input), t2(this.beginIndex), this.endIndex && t2(this.endIndex);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          if (this.endIndex != null && this.endIndex !== void 0) {
            const t2 = this.endIndex.serialize();
            return ["slice", this.input.serialize(), this.beginIndex.serialize(), t2];
          }
          return ["slice", this.input.serialize(), this.beginIndex.serialize()];
        }
      }
      function dn(t2, e2) {
        return t2 === "==" || t2 === "!=" ? e2.kind === "boolean" || e2.kind === "string" || e2.kind === "number" || e2.kind === "null" || e2.kind === "value" : e2.kind === "string" || e2.kind === "number" || e2.kind === "value";
      }
      function fn(t2, e2, r2, n2) {
        return n2.compare(e2, r2) === 0;
      }
      function yn(t2, e2, r2) {
        const n2 = t2 !== "==" && t2 !== "!=";
        return class i3 {
          constructor(t3, e3, r3) {
            this.type = Be, this.lhs = t3, this.rhs = e3, this.collator = r3, this.hasUntypedArgument = t3.type.kind === "value" || e3.type.kind === "value";
          }
          static parse(t3, e3) {
            if (t3.length !== 3 && t3.length !== 4)
              return e3.error("Expected two or three arguments.");
            const r3 = t3[0];
            let s3 = e3.parse(t3[1], 1, Ee);
            if (!s3)
              return null;
            if (!dn(r3, s3.type))
              return e3.concat(1).error(`"${r3}" comparisons are not supported for type '${Re(s3.type)}'.`);
            let a2 = e3.parse(t3[2], 2, Ee);
            if (!a2)
              return null;
            if (!dn(r3, a2.type))
              return e3.concat(2).error(`"${r3}" comparisons are not supported for type '${Re(a2.type)}'.`);
            if (s3.type.kind !== a2.type.kind && s3.type.kind !== "value" && a2.type.kind !== "value")
              return e3.error(`Cannot compare types '${Re(s3.type)}' and '${Re(a2.type)}'.`);
            n2 && (s3.type.kind === "value" && a2.type.kind !== "value" ? s3 = new nr(a2.type, [s3]) : s3.type.kind !== "value" && a2.type.kind === "value" && (a2 = new nr(s3.type, [a2])));
            let o2 = null;
            if (t3.length === 4) {
              if (s3.type.kind !== "string" && a2.type.kind !== "string" && s3.type.kind !== "value" && a2.type.kind !== "value")
                return e3.error("Cannot use collator to compare non-string types.");
              if (o2 = e3.parse(t3[3], 3, De), !o2)
                return null;
            }
            return new i3(s3, a2, o2);
          }
          evaluate(i4) {
            const s3 = this.lhs.evaluate(i4), a2 = this.rhs.evaluate(i4);
            if (n2 && this.hasUntypedArgument) {
              const e3 = We(s3), r3 = We(a2);
              if (e3.kind !== r3.kind || e3.kind !== "string" && e3.kind !== "number")
                throw new er(`Expected arguments for "${t2}" to be (string, string) or (number, number), but found (${e3.kind}, ${r3.kind}) instead.`);
            }
            if (this.collator && !n2 && this.hasUntypedArgument) {
              const t3 = We(s3), r3 = We(a2);
              if (t3.kind !== "string" || r3.kind !== "string")
                return e2(i4, s3, a2);
            }
            return this.collator ? r2(i4, s3, a2, this.collator.evaluate(i4)) : e2(i4, s3, a2);
          }
          eachChild(t3) {
            t3(this.lhs), t3(this.rhs), this.collator && t3(this.collator);
          }
          outputDefined() {
            return true;
          }
          serialize() {
            const e3 = [t2];
            return this.eachChild((t3) => {
              e3.push(t3.serialize());
            }), e3;
          }
        };
      }
      const mn = yn("==", function(t2, e2, r2) {
        return e2 === r2;
      }, fn), gn = yn("!=", function(t2, e2, r2) {
        return e2 !== r2;
      }, function(t2, e2, r2, n2) {
        return !fn(0, e2, r2, n2);
      }), xn = yn("<", function(t2, e2, r2) {
        return e2 < r2;
      }, function(t2, e2, r2, n2) {
        return n2.compare(e2, r2) < 0;
      }), vn2 = yn(">", function(t2, e2, r2) {
        return e2 > r2;
      }, function(t2, e2, r2, n2) {
        return n2.compare(e2, r2) > 0;
      }), bn = yn("<=", function(t2, e2, r2) {
        return e2 <= r2;
      }, function(t2, e2, r2, n2) {
        return n2.compare(e2, r2) <= 0;
      }), wn = yn(">=", function(t2, e2, r2) {
        return e2 >= r2;
      }, function(t2, e2, r2, n2) {
        return n2.compare(e2, r2) >= 0;
      });
      class _n {
        constructor(t2, e2, r2, n2, i3) {
          this.type = Te, this.number = t2, this.locale = e2, this.currency = r2, this.minFractionDigits = n2, this.maxFractionDigits = i3;
        }
        static parse(t2, e2) {
          if (t2.length !== 3)
            return e2.error("Expected two arguments.");
          const r2 = e2.parse(t2[1], 1, Me);
          if (!r2)
            return null;
          const n2 = t2[2];
          if (typeof n2 != "object" || Array.isArray(n2))
            return e2.error("NumberFormat options argument must be an object.");
          let i3 = null;
          if (n2.locale && (i3 = e2.parse(n2.locale, 1, Te), !i3))
            return null;
          let s3 = null;
          if (n2.currency && (s3 = e2.parse(n2.currency, 1, Te), !s3))
            return null;
          let a2 = null;
          if (n2["min-fraction-digits"] && (a2 = e2.parse(n2["min-fraction-digits"], 1, Me), !a2))
            return null;
          let o2 = null;
          return n2["max-fraction-digits"] && (o2 = e2.parse(n2["max-fraction-digits"], 1, Me), !o2) ? null : new _n(r2, i3, s3, a2, o2);
        }
        evaluate(t2) {
          return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t2) : [], { style: this.currency ? "currency" : "decimal", currency: this.currency ? this.currency.evaluate(t2) : void 0, minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t2) : void 0, maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t2) : void 0 }).format(this.number.evaluate(t2));
        }
        eachChild(t2) {
          t2(this.number), this.locale && t2(this.locale), this.currency && t2(this.currency), this.minFractionDigits && t2(this.minFractionDigits), this.maxFractionDigits && t2(this.maxFractionDigits);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          const t2 = {};
          return this.locale && (t2.locale = this.locale.serialize()), this.currency && (t2.currency = this.currency.serialize()), this.minFractionDigits && (t2["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (t2["max-fraction-digits"] = this.maxFractionDigits.serialize()), ["number-format", this.number.serialize(), t2];
        }
      }
      class An {
        constructor(t2) {
          this.type = Me, this.input = t2;
        }
        static parse(t2, e2) {
          if (t2.length !== 2)
            return e2.error(`Expected 1 argument, but found ${t2.length - 1} instead.`);
          const r2 = e2.parse(t2[1], 1);
          return r2 ? r2.type.kind !== "array" && r2.type.kind !== "string" && r2.type.kind !== "value" ? e2.error(`Expected argument of type string or array, but found ${Re(r2.type)} instead.`) : new An(r2) : null;
        }
        evaluate(t2) {
          const e2 = this.input.evaluate(t2);
          if (typeof e2 == "string")
            return e2.length;
          if (Array.isArray(e2))
            return e2.length;
          throw new er(`Expected value to be of type string or array, but found ${Re(We(e2))} instead.`);
        }
        eachChild(t2) {
          t2(this.input);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          const t2 = ["length"];
          return this.eachChild((e2) => {
            t2.push(e2.serialize());
          }), t2;
        }
      }
      const kn = { "==": mn, "!=": gn, ">": vn2, "<": xn, ">=": wn, "<=": bn, array: nr, at: on, boolean: nr, case: hn, coalesce: sn, collator: hr, format: ir, image: sr, in: ln, "index-of": un, interpolate: rn, "interpolate-hcl": rn, "interpolate-lab": rn, length: An, let: an, literal: tr, match: cn, number: nr, "number-format": _n, object: nr, slice: pn, step: Fr, string: nr, "to-boolean": or, "to-color": or, "to-number": or, "to-string": or, var: Pr, within: Mr };
      function Sn(t2, [e2, r2, n2, i3]) {
        e2 = e2.evaluate(t2), r2 = r2.evaluate(t2), n2 = n2.evaluate(t2);
        const s3 = i3 ? i3.evaluate(t2) : 1, a2 = He(e2, r2, n2, s3);
        if (a2)
          throw new er(a2);
        return new Ge(e2 / 255 * s3, r2 / 255 * s3, n2 / 255 * s3, s3);
      }
      function In(t2, e2) {
        return t2 in e2;
      }
      function zn(t2, e2) {
        const r2 = e2[t2];
        return r2 === void 0 ? null : r2;
      }
      function Mn(t2) {
        return { type: t2 };
      }
      function Tn(t2) {
        return { result: "success", value: t2 };
      }
      function Bn(t2) {
        return { result: "error", value: t2 };
      }
      function Cn(t2) {
        return t2["property-type"] === "data-driven" || t2["property-type"] === "cross-faded-data-driven";
      }
      function Pn(t2) {
        return !!t2.expression && t2.expression.parameters.indexOf("zoom") > -1;
      }
      function En(t2) {
        return !!t2.expression && t2.expression.interpolated;
      }
      function Dn(t2) {
        return t2 instanceof Number ? "number" : t2 instanceof String ? "string" : t2 instanceof Boolean ? "boolean" : Array.isArray(t2) ? "array" : t2 === null ? "null" : typeof t2;
      }
      function Vn(t2) {
        return typeof t2 == "object" && t2 !== null && !Array.isArray(t2);
      }
      function Fn(t2) {
        return t2;
      }
      function Ln(t2, e2) {
        const r2 = e2.type === "color", n2 = t2.stops && typeof t2.stops[0][0] == "object", i3 = n2 || !(n2 || t2.property !== void 0), s3 = t2.type || (En(e2) ? "exponential" : "interval");
        if (r2 && ((t2 = _e({}, t2)).stops && (t2.stops = t2.stops.map((t3) => [t3[0], Ge.parse(t3[1])])), t2.default = Ge.parse(t2.default ? t2.default : e2.default)), t2.colorSpace && t2.colorSpace !== "rgb" && !en[t2.colorSpace])
          throw new Error(`Unknown color space: ${t2.colorSpace}`);
        let a2, o2, l2;
        if (s3 === "exponential")
          a2 = On;
        else if (s3 === "interval")
          a2 = $n;
        else if (s3 === "categorical") {
          a2 = Un, o2 = /* @__PURE__ */ Object.create(null);
          for (const e3 of t2.stops)
            o2[e3[0]] = e3[1];
          l2 = typeof t2.stops[0][0];
        } else {
          if (s3 !== "identity")
            throw new Error(`Unknown function type "${s3}"`);
          a2 = jn;
        }
        if (n2) {
          const r3 = {}, n3 = [];
          for (let e3 = 0; e3 < t2.stops.length; e3++) {
            const i5 = t2.stops[e3], s5 = i5[0].zoom;
            r3[s5] === void 0 && (r3[s5] = { zoom: s5, type: t2.type, property: t2.property, default: t2.default, stops: [] }, n3.push(s5)), r3[s5].stops.push([i5[0].value, i5[1]]);
          }
          const i4 = [];
          for (const t3 of n3)
            i4.push([r3[t3].zoom, Ln(r3[t3], e2)]);
          const s4 = { name: "linear" };
          return { kind: "composite", interpolationType: s4, interpolationFactor: rn.interpolationFactor.bind(void 0, s4), zoomStops: i4.map((t3) => t3[0]), evaluate: ({ zoom: r4 }, n4) => On({ stops: i4, base: t2.base }, e2, r4).evaluate(r4, n4) };
        }
        if (i3) {
          const r3 = s3 === "exponential" ? { name: "exponential", base: t2.base !== void 0 ? t2.base : 1 } : null;
          return { kind: "camera", interpolationType: r3, interpolationFactor: rn.interpolationFactor.bind(void 0, r3), zoomStops: t2.stops.map((t3) => t3[0]), evaluate: ({ zoom: r4 }) => a2(t2, e2, r4, o2, l2) };
        }
        return { kind: "source", evaluate(r3, n3) {
          const i4 = n3 && n3.properties ? n3.properties[t2.property] : void 0;
          return i4 === void 0 ? Rn(t2.default, e2.default) : a2(t2, e2, i4, o2, l2);
        } };
      }
      function Rn(t2, e2, r2) {
        return t2 !== void 0 ? t2 : e2 !== void 0 ? e2 : r2 !== void 0 ? r2 : void 0;
      }
      function Un(t2, e2, r2, n2, i3) {
        return Rn(typeof r2 === i3 ? n2[r2] : void 0, t2.default, e2.default);
      }
      function $n(t2, e2, r2) {
        if (Dn(r2) !== "number")
          return Rn(t2.default, e2.default);
        const n2 = t2.stops.length;
        if (n2 === 1)
          return t2.stops[0][1];
        if (r2 <= t2.stops[0][0])
          return t2.stops[0][1];
        if (r2 >= t2.stops[n2 - 1][0])
          return t2.stops[n2 - 1][1];
        const i3 = Vr(t2.stops.map((t3) => t3[0]), r2);
        return t2.stops[i3][1];
      }
      function On(t2, e2, r2) {
        const n2 = t2.base !== void 0 ? t2.base : 1;
        if (Dn(r2) !== "number")
          return Rn(t2.default, e2.default);
        const i3 = t2.stops.length;
        if (i3 === 1)
          return t2.stops[0][1];
        if (r2 <= t2.stops[0][0])
          return t2.stops[0][1];
        if (r2 >= t2.stops[i3 - 1][0])
          return t2.stops[i3 - 1][1];
        const s3 = Vr(t2.stops.map((t3) => t3[0]), r2), a2 = function(t3, e3, r3, n3) {
          const i4 = n3 - r3, s4 = t3 - r3;
          return i4 === 0 ? 0 : e3 === 1 ? s4 / i4 : (Math.pow(e3, s4) - 1) / (Math.pow(e3, i4) - 1);
        }(r2, n2, t2.stops[s3][0], t2.stops[s3 + 1][0]), o2 = t2.stops[s3][1], l2 = t2.stops[s3 + 1][1];
        let u2 = Rr[e2.type] || Fn;
        if (t2.colorSpace && t2.colorSpace !== "rgb") {
          const e3 = en[t2.colorSpace];
          u2 = (t3, r3) => e3.reverse(e3.interpolate(e3.forward(t3), e3.forward(r3), a2));
        }
        return typeof o2.evaluate == "function" ? { evaluate(...t3) {
          const e3 = o2.evaluate.apply(void 0, t3), r3 = l2.evaluate.apply(void 0, t3);
          if (e3 !== void 0 && r3 !== void 0)
            return u2(e3, r3, a2);
        } } : u2(o2, l2, a2);
      }
      function jn(t2, e2, r2) {
        return e2.type === "color" ? r2 = Ge.parse(r2) : e2.type === "formatted" ? r2 = Ke.fromString(r2.toString()) : e2.type === "resolvedImage" ? r2 = Ye.fromString(r2.toString()) : Dn(r2) === e2.type || e2.type === "enum" && e2.values[r2] || (r2 = void 0), Rn(r2, t2.default, e2.default);
      }
      cr.register(kn, { error: [{ kind: "error" }, [Te], (t2, [e2]) => {
        throw new er(e2.evaluate(t2));
      }], typeof: [Te, [Ee], (t2, [e2]) => Re(We(e2.evaluate(t2)))], "to-rgba": [Le(Me, 4), [Ce], (t2, [e2]) => e2.evaluate(t2).toArray()], rgb: [Ce, [Me, Me, Me], Sn], rgba: [Ce, [Me, Me, Me, Me], Sn], has: { type: Be, overloads: [[[Te], (t2, [e2]) => In(e2.evaluate(t2), t2.properties())], [[Te, Pe], (t2, [e2, r2]) => In(e2.evaluate(t2), r2.evaluate(t2))]] }, get: { type: Ee, overloads: [[[Te], (t2, [e2]) => zn(e2.evaluate(t2), t2.properties())], [[Te, Pe], (t2, [e2, r2]) => zn(e2.evaluate(t2), r2.evaluate(t2))]] }, "feature-state": [Ee, [Te], (t2, [e2]) => zn(e2.evaluate(t2), t2.featureState || {})], properties: [Pe, [], (t2) => t2.properties()], "geometry-type": [Te, [], (t2) => t2.geometryType()], id: [Ee, [], (t2) => t2.id()], zoom: [Me, [], (t2) => t2.globals.zoom], pitch: [Me, [], (t2) => t2.globals.pitch || 0], "distance-from-center": [Me, [], (t2) => t2.distanceFromCenter()], "heatmap-density": [Me, [], (t2) => t2.globals.heatmapDensity || 0], "line-progress": [Me, [], (t2) => t2.globals.lineProgress || 0], "sky-radial-progress": [Me, [], (t2) => t2.globals.skyRadialProgress || 0], accumulated: [Ee, [], (t2) => t2.globals.accumulated === void 0 ? null : t2.globals.accumulated], "+": [Me, Mn(Me), (t2, e2) => {
        let r2 = 0;
        for (const n2 of e2)
          r2 += n2.evaluate(t2);
        return r2;
      }], "*": [Me, Mn(Me), (t2, e2) => {
        let r2 = 1;
        for (const n2 of e2)
          r2 *= n2.evaluate(t2);
        return r2;
      }], "-": { type: Me, overloads: [[[Me, Me], (t2, [e2, r2]) => e2.evaluate(t2) - r2.evaluate(t2)], [[Me], (t2, [e2]) => -e2.evaluate(t2)]] }, "/": [Me, [Me, Me], (t2, [e2, r2]) => e2.evaluate(t2) / r2.evaluate(t2)], "%": [Me, [Me, Me], (t2, [e2, r2]) => e2.evaluate(t2) % r2.evaluate(t2)], ln2: [Me, [], () => Math.LN2], pi: [Me, [], () => Math.PI], e: [Me, [], () => Math.E], "^": [Me, [Me, Me], (t2, [e2, r2]) => Math.pow(e2.evaluate(t2), r2.evaluate(t2))], sqrt: [Me, [Me], (t2, [e2]) => Math.sqrt(e2.evaluate(t2))], log10: [Me, [Me], (t2, [e2]) => Math.log(e2.evaluate(t2)) / Math.LN10], ln: [Me, [Me], (t2, [e2]) => Math.log(e2.evaluate(t2))], log2: [Me, [Me], (t2, [e2]) => Math.log(e2.evaluate(t2)) / Math.LN2], sin: [Me, [Me], (t2, [e2]) => Math.sin(e2.evaluate(t2))], cos: [Me, [Me], (t2, [e2]) => Math.cos(e2.evaluate(t2))], tan: [Me, [Me], (t2, [e2]) => Math.tan(e2.evaluate(t2))], asin: [Me, [Me], (t2, [e2]) => Math.asin(e2.evaluate(t2))], acos: [Me, [Me], (t2, [e2]) => Math.acos(e2.evaluate(t2))], atan: [Me, [Me], (t2, [e2]) => Math.atan(e2.evaluate(t2))], min: [Me, Mn(Me), (t2, e2) => Math.min(...e2.map((e3) => e3.evaluate(t2)))], max: [Me, Mn(Me), (t2, e2) => Math.max(...e2.map((e3) => e3.evaluate(t2)))], abs: [Me, [Me], (t2, [e2]) => Math.abs(e2.evaluate(t2))], round: [Me, [Me], (t2, [e2]) => {
        const r2 = e2.evaluate(t2);
        return r2 < 0 ? -Math.round(-r2) : Math.round(r2);
      }], floor: [Me, [Me], (t2, [e2]) => Math.floor(e2.evaluate(t2))], ceil: [Me, [Me], (t2, [e2]) => Math.ceil(e2.evaluate(t2))], "filter-==": [Be, [Te, Ee], (t2, [e2, r2]) => t2.properties()[e2.value] === r2.value], "filter-id-==": [Be, [Ee], (t2, [e2]) => t2.id() === e2.value], "filter-type-==": [Be, [Te], (t2, [e2]) => t2.geometryType() === e2.value], "filter-<": [Be, [Te, Ee], (t2, [e2, r2]) => {
        const n2 = t2.properties()[e2.value], i3 = r2.value;
        return typeof n2 == typeof i3 && n2 < i3;
      }], "filter-id-<": [Be, [Ee], (t2, [e2]) => {
        const r2 = t2.id(), n2 = e2.value;
        return typeof r2 == typeof n2 && r2 < n2;
      }], "filter->": [Be, [Te, Ee], (t2, [e2, r2]) => {
        const n2 = t2.properties()[e2.value], i3 = r2.value;
        return typeof n2 == typeof i3 && n2 > i3;
      }], "filter-id->": [Be, [Ee], (t2, [e2]) => {
        const r2 = t2.id(), n2 = e2.value;
        return typeof r2 == typeof n2 && r2 > n2;
      }], "filter-<=": [Be, [Te, Ee], (t2, [e2, r2]) => {
        const n2 = t2.properties()[e2.value], i3 = r2.value;
        return typeof n2 == typeof i3 && n2 <= i3;
      }], "filter-id-<=": [Be, [Ee], (t2, [e2]) => {
        const r2 = t2.id(), n2 = e2.value;
        return typeof r2 == typeof n2 && r2 <= n2;
      }], "filter->=": [Be, [Te, Ee], (t2, [e2, r2]) => {
        const n2 = t2.properties()[e2.value], i3 = r2.value;
        return typeof n2 == typeof i3 && n2 >= i3;
      }], "filter-id->=": [Be, [Ee], (t2, [e2]) => {
        const r2 = t2.id(), n2 = e2.value;
        return typeof r2 == typeof n2 && r2 >= n2;
      }], "filter-has": [Be, [Ee], (t2, [e2]) => e2.value in t2.properties()], "filter-has-id": [Be, [], (t2) => t2.id() !== null && t2.id() !== void 0], "filter-type-in": [Be, [Le(Te)], (t2, [e2]) => e2.value.indexOf(t2.geometryType()) >= 0], "filter-id-in": [Be, [Le(Ee)], (t2, [e2]) => e2.value.indexOf(t2.id()) >= 0], "filter-in-small": [Be, [Te, Le(Ee)], (t2, [e2, r2]) => r2.value.indexOf(t2.properties()[e2.value]) >= 0], "filter-in-large": [Be, [Te, Le(Ee)], (t2, [e2, r2]) => function(t3, e3, r3, n2) {
        for (; r3 <= n2; ) {
          const i3 = r3 + n2 >> 1;
          if (e3[i3] === t3)
            return true;
          e3[i3] > t3 ? n2 = i3 - 1 : r3 = i3 + 1;
        }
        return false;
      }(t2.properties()[e2.value], r2.value, 0, r2.value.length - 1)], all: { type: Be, overloads: [[[Be, Be], (t2, [e2, r2]) => e2.evaluate(t2) && r2.evaluate(t2)], [Mn(Be), (t2, e2) => {
        for (const r2 of e2)
          if (!r2.evaluate(t2))
            return false;
        return true;
      }]] }, any: { type: Be, overloads: [[[Be, Be], (t2, [e2, r2]) => e2.evaluate(t2) || r2.evaluate(t2)], [Mn(Be), (t2, e2) => {
        for (const r2 of e2)
          if (r2.evaluate(t2))
            return true;
        return false;
      }]] }, "!": [Be, [Be], (t2, [e2]) => !e2.evaluate(t2)], "is-supported-script": [Be, [Te], (t2, [e2]) => {
        const r2 = t2.globals && t2.globals.isSupportedScript;
        return !r2 || r2(e2.evaluate(t2));
      }], upcase: [Te, [Te], (t2, [e2]) => e2.evaluate(t2).toUpperCase()], downcase: [Te, [Te], (t2, [e2]) => e2.evaluate(t2).toLowerCase()], concat: [Te, Mn(Ee), (t2, e2) => e2.map((e3) => Qe(e3.evaluate(t2))).join("")], "resolved-locale": [Te, [De], (t2, [e2]) => e2.evaluate(t2).resolvedLocale()] });
      class qn {
        constructor(t2, e2) {
          this.expression = t2, this._warningHistory = {}, this._evaluator = new ur(), this._defaultValue = e2 ? function(t3) {
            return t3.type === "color" && Vn(t3.default) ? new Ge(0, 0, 0, 0) : t3.type === "color" ? Ge.parse(t3.default) || null : t3.default === void 0 ? null : t3.default;
          }(e2) : null, this._enumValues = e2 && e2.type === "enum" ? e2.values : null;
        }
        evaluateWithoutErrorHandling(t2, e2, r2, n2, i3, s3, a2, o2) {
          return this._evaluator.globals = t2, this._evaluator.feature = e2, this._evaluator.featureState = r2, this._evaluator.canonical = n2, this._evaluator.availableImages = i3 || null, this._evaluator.formattedSection = s3, this._evaluator.featureTileCoord = a2 || null, this._evaluator.featureDistanceData = o2 || null, this.expression.evaluate(this._evaluator);
        }
        evaluate(t2, e2, r2, n2, i3, s3, a2, o2) {
          this._evaluator.globals = t2, this._evaluator.feature = e2 || null, this._evaluator.featureState = r2 || null, this._evaluator.canonical = n2, this._evaluator.availableImages = i3 || null, this._evaluator.formattedSection = s3 || null, this._evaluator.featureTileCoord = a2 || null, this._evaluator.featureDistanceData = o2 || null;
          try {
            const t3 = this.expression.evaluate(this._evaluator);
            if (t3 == null || typeof t3 == "number" && t3 != t3)
              return this._defaultValue;
            if (this._enumValues && !(t3 in this._enumValues))
              throw new er(`Expected value to be one of ${Object.keys(this._enumValues).map((t4) => JSON.stringify(t4)).join(", ")}, but found ${JSON.stringify(t3)} instead.`);
            return t3;
          } catch (t3) {
            return this._warningHistory[t3.message] || (this._warningHistory[t3.message] = true, typeof console != "undefined" && console.warn(t3.message)), this._defaultValue;
          }
        }
      }
      function Nn(t2) {
        return Array.isArray(t2) && t2.length > 0 && typeof t2[0] == "string" && t2[0] in kn;
      }
      function Gn(t2, e2) {
        const r2 = new Er(kn, [], e2 ? function(t3) {
          const e3 = { color: Ce, string: Te, number: Me, enum: Te, boolean: Be, formatted: Ve, resolvedImage: Fe };
          return t3.type === "array" ? Le(e3[t3.value] || Ee, t3.length) : e3[t3.type];
        }(e2) : void 0), n2 = r2.parse(t2, void 0, void 0, void 0, e2 && e2.type === "string" ? { typeAnnotation: "coerce" } : void 0);
        return n2 ? Tn(new qn(n2, e2)) : Bn(r2.errors);
      }
      class Zn {
        constructor(t2, e2) {
          this.kind = t2, this._styleExpression = e2, this.isStateDependent = t2 !== "constant" && !Br(e2.expression);
        }
        evaluateWithoutErrorHandling(t2, e2, r2, n2, i3, s3) {
          return this._styleExpression.evaluateWithoutErrorHandling(t2, e2, r2, n2, i3, s3);
        }
        evaluate(t2, e2, r2, n2, i3, s3) {
          return this._styleExpression.evaluate(t2, e2, r2, n2, i3, s3);
        }
      }
      class Xn {
        constructor(t2, e2, r2, n2) {
          this.kind = t2, this.zoomStops = r2, this._styleExpression = e2, this.isStateDependent = t2 !== "camera" && !Br(e2.expression), this.interpolationType = n2;
        }
        evaluateWithoutErrorHandling(t2, e2, r2, n2, i3, s3) {
          return this._styleExpression.evaluateWithoutErrorHandling(t2, e2, r2, n2, i3, s3);
        }
        evaluate(t2, e2, r2, n2, i3, s3) {
          return this._styleExpression.evaluate(t2, e2, r2, n2, i3, s3);
        }
        interpolationFactor(t2, e2, r2) {
          return this.interpolationType ? rn.interpolationFactor(this.interpolationType, t2, e2, r2) : 0;
        }
      }
      function Kn(t2, e2) {
        if ((t2 = Gn(t2, e2)).result === "error")
          return t2;
        const r2 = t2.value.expression, n2 = Tr(r2);
        if (!n2 && !Cn(e2))
          return Bn([new Se("", "data expressions not supported")]);
        const i3 = Cr(r2, ["zoom", "pitch", "distance-from-center"]);
        if (!i3 && !Pn(e2))
          return Bn([new Se("", "zoom expressions not supported")]);
        const s3 = Hn(r2);
        return s3 || i3 ? s3 instanceof Se ? Bn([s3]) : s3 instanceof rn && !En(e2) ? Bn([new Se("", '"interpolate" expressions cannot be used with this property')]) : Tn(s3 ? new Xn(n2 ? "camera" : "composite", t2.value, s3.labels, s3 instanceof rn ? s3.interpolation : void 0) : new Zn(n2 ? "constant" : "source", t2.value)) : Bn([new Se("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')]);
      }
      class Yn {
        constructor(t2, e2) {
          this._parameters = t2, this._specification = e2, _e(this, Ln(this._parameters, this._specification));
        }
        static deserialize(t2) {
          return new Yn(t2._parameters, t2._specification);
        }
        static serialize(t2) {
          return { _parameters: t2._parameters, _specification: t2._specification };
        }
      }
      function Hn(t2) {
        let e2 = null;
        if (t2 instanceof an)
          e2 = Hn(t2.result);
        else if (t2 instanceof sn) {
          for (const r2 of t2.args)
            if (e2 = Hn(r2), e2)
              break;
        } else
          (t2 instanceof Fr || t2 instanceof rn) && t2.input instanceof cr && t2.input.name === "zoom" && (e2 = t2);
        return e2 instanceof Se || t2.eachChild((t3) => {
          const r2 = Hn(t3);
          r2 instanceof Se ? e2 = r2 : !e2 && r2 ? e2 = new Se("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : e2 && r2 && e2 !== r2 && (e2 = new Se("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
        }), e2;
      }
      function Jn(t2) {
        const e2 = t2.key, r2 = t2.value, n2 = t2.valueSpec || {}, i3 = t2.objectElementValidators || {}, s3 = t2.style, a2 = t2.styleSpec;
        let o2 = [];
        const l2 = Dn(r2);
        if (l2 !== "object")
          return [new be(e2, r2, `object expected, ${l2} found`)];
        for (const t3 in r2) {
          const l3 = t3.split(".")[0], u2 = n2[l3] || n2["*"];
          let c2;
          if (i3[l3])
            c2 = i3[l3];
          else if (n2[l3])
            c2 = Bi;
          else if (i3["*"])
            c2 = i3["*"];
          else {
            if (!n2["*"]) {
              o2.push(new be(e2, r2[t3], `unknown property "${t3}"`));
              continue;
            }
            c2 = Bi;
          }
          o2 = o2.concat(c2({ key: (e2 ? `${e2}.` : e2) + t3, value: r2[t3], valueSpec: u2, style: s3, styleSpec: a2, object: r2, objectKey: t3 }, r2));
        }
        for (const t3 in n2)
          i3[t3] || n2[t3].required && n2[t3].default === void 0 && r2[t3] === void 0 && o2.push(new be(e2, r2, `missing required property "${t3}"`));
        return o2;
      }
      function Wn(t2) {
        const e2 = t2.value, r2 = t2.valueSpec, n2 = t2.style, i3 = t2.styleSpec, s3 = t2.key, a2 = t2.arrayElementValidator || Bi;
        if (Dn(e2) !== "array")
          return [new be(s3, e2, `array expected, ${Dn(e2)} found`)];
        if (r2.length && e2.length !== r2.length)
          return [new be(s3, e2, `array length ${r2.length} expected, length ${e2.length} found`)];
        if (r2["min-length"] && e2.length < r2["min-length"])
          return [new be(s3, e2, `array length at least ${r2["min-length"]} expected, length ${e2.length} found`)];
        let o2 = { type: r2.value, values: r2.values, minimum: r2.minimum, maximum: r2.maximum };
        i3.$version < 7 && (o2.function = r2.function), Dn(r2.value) === "object" && (o2 = r2.value);
        let l2 = [];
        for (let t3 = 0; t3 < e2.length; t3++)
          l2 = l2.concat(a2({ array: e2, arrayIndex: t3, value: e2[t3], valueSpec: o2, style: n2, styleSpec: i3, key: `${s3}[${t3}]` }));
        return l2;
      }
      function Qn(t2) {
        const e2 = t2.key, r2 = t2.value, n2 = t2.valueSpec;
        let i3 = Dn(r2);
        if (i3 === "number" && r2 != r2 && (i3 = "NaN"), i3 !== "number")
          return [new be(e2, r2, `number expected, ${i3} found`)];
        if ("minimum" in n2) {
          let i4 = n2.minimum;
          if (Dn(n2.minimum) === "array" && (i4 = n2.minimum[t2.arrayIndex]), r2 < i4)
            return [new be(e2, r2, `${r2} is less than the minimum value ${i4}`)];
        }
        if ("maximum" in n2) {
          let i4 = n2.maximum;
          if (Dn(n2.maximum) === "array" && (i4 = n2.maximum[t2.arrayIndex]), r2 > i4)
            return [new be(e2, r2, `${r2} is greater than the maximum value ${i4}`)];
        }
        return [];
      }
      function ti(t2) {
        const e2 = t2.valueSpec, r2 = Ae(t2.value.type);
        let n2, i3, s3, a2 = {};
        const o2 = r2 !== "categorical" && t2.value.property === void 0, l2 = !o2, u2 = Dn(t2.value.stops) === "array" && Dn(t2.value.stops[0]) === "array" && Dn(t2.value.stops[0][0]) === "object", c2 = Jn({ key: t2.key, value: t2.value, valueSpec: t2.styleSpec.function, style: t2.style, styleSpec: t2.styleSpec, objectElementValidators: { stops: function(t3) {
          if (r2 === "identity")
            return [new be(t3.key, t3.value, 'identity function may not have a "stops" property')];
          let e3 = [];
          const n3 = t3.value;
          return e3 = e3.concat(Wn({ key: t3.key, value: n3, valueSpec: t3.valueSpec, style: t3.style, styleSpec: t3.styleSpec, arrayElementValidator: h2 })), Dn(n3) === "array" && n3.length === 0 && e3.push(new be(t3.key, n3, "array must have at least one stop")), e3;
        }, default: function(t3) {
          return Bi({ key: t3.key, value: t3.value, valueSpec: e2, style: t3.style, styleSpec: t3.styleSpec });
        } } });
        return r2 === "identity" && o2 && c2.push(new be(t2.key, t2.value, 'missing required property "property"')), r2 === "identity" || t2.value.stops || c2.push(new be(t2.key, t2.value, 'missing required property "stops"')), r2 === "exponential" && t2.valueSpec.expression && !En(t2.valueSpec) && c2.push(new be(t2.key, t2.value, "exponential functions not supported")), t2.styleSpec.$version >= 8 && (l2 && !Cn(t2.valueSpec) ? c2.push(new be(t2.key, t2.value, "property functions not supported")) : o2 && !Pn(t2.valueSpec) && c2.push(new be(t2.key, t2.value, "zoom functions not supported"))), r2 !== "categorical" && !u2 || t2.value.property !== void 0 || c2.push(new be(t2.key, t2.value, '"property" property is required')), c2;
        function h2(t3) {
          let r3 = [];
          const n3 = t3.value, o3 = t3.key;
          if (Dn(n3) !== "array")
            return [new be(o3, n3, `array expected, ${Dn(n3)} found`)];
          if (n3.length !== 2)
            return [new be(o3, n3, `array length 2 expected, length ${n3.length} found`)];
          if (u2) {
            if (Dn(n3[0]) !== "object")
              return [new be(o3, n3, `object expected, ${Dn(n3[0])} found`)];
            if (n3[0].zoom === void 0)
              return [new be(o3, n3, "object stop key must have zoom")];
            if (n3[0].value === void 0)
              return [new be(o3, n3, "object stop key must have value")];
            if (s3 && s3 > Ae(n3[0].zoom))
              return [new be(o3, n3[0].zoom, "stop zoom values must appear in ascending order")];
            Ae(n3[0].zoom) !== s3 && (s3 = Ae(n3[0].zoom), i3 = void 0, a2 = {}), r3 = r3.concat(Jn({ key: `${o3}[0]`, value: n3[0], valueSpec: { zoom: {} }, style: t3.style, styleSpec: t3.styleSpec, objectElementValidators: { zoom: Qn, value: p2 } }));
          } else
            r3 = r3.concat(p2({ key: `${o3}[0]`, value: n3[0], valueSpec: {}, style: t3.style, styleSpec: t3.styleSpec }, n3));
          return Nn(ke(n3[1])) ? r3.concat([new be(`${o3}[1]`, n3[1], "expressions are not allowed in function stops.")]) : r3.concat(Bi({ key: `${o3}[1]`, value: n3[1], valueSpec: e2, style: t3.style, styleSpec: t3.styleSpec }));
        }
        function p2(t3, s4) {
          const o3 = Dn(t3.value), l3 = Ae(t3.value), u3 = t3.value !== null ? t3.value : s4;
          if (n2) {
            if (o3 !== n2)
              return [new be(t3.key, u3, `${o3} stop domain type must match previous stop domain type ${n2}`)];
          } else
            n2 = o3;
          if (o3 !== "number" && o3 !== "string" && o3 !== "boolean")
            return [new be(t3.key, u3, "stop domain value must be a number, string, or boolean")];
          if (o3 !== "number" && r2 !== "categorical") {
            let n3 = `number expected, ${o3} found`;
            return Cn(e2) && r2 === void 0 && (n3 += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [new be(t3.key, u3, n3)];
          }
          return r2 !== "categorical" || o3 !== "number" || isFinite(l3) && Math.floor(l3) === l3 ? r2 !== "categorical" && o3 === "number" && i3 !== void 0 && l3 < i3 ? [new be(t3.key, u3, "stop domain values must appear in ascending order")] : (i3 = l3, r2 === "categorical" && l3 in a2 ? [new be(t3.key, u3, "stop domain values must be unique")] : (a2[l3] = true, [])) : [new be(t3.key, u3, `integer expected, found ${l3}`)];
        }
      }
      function ei(t2) {
        const e2 = (t2.expressionContext === "property" ? Kn : Gn)(ke(t2.value), t2.valueSpec);
        if (e2.result === "error")
          return e2.value.map((e3) => new be(`${t2.key}${e3.key}`, t2.value, e3.message));
        const r2 = e2.value.expression || e2.value._styleExpression.expression;
        if (t2.expressionContext === "property" && t2.propertyKey === "text-font" && !r2.outputDefined())
          return [new be(t2.key, t2.value, `Invalid data expression for "${t2.propertyKey}". Output values must be contained as literals within the expression.`)];
        if (t2.expressionContext === "property" && t2.propertyType === "layout" && !Br(r2))
          return [new be(t2.key, t2.value, '"feature-state" data expressions are not supported with layout properties.')];
        if (t2.expressionContext === "filter")
          return ri(r2, t2);
        if (t2.expressionContext && t2.expressionContext.indexOf("cluster") === 0) {
          if (!Cr(r2, ["zoom", "feature-state"]))
            return [new be(t2.key, t2.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')];
          if (t2.expressionContext === "cluster-initial" && !Tr(r2))
            return [new be(t2.key, t2.value, "Feature data expressions are not supported with initial expression part of cluster properties.")];
        }
        return [];
      }
      function ri(t2, e2) {
        const r2 = /* @__PURE__ */ new Set(["zoom", "feature-state", "pitch", "distance-from-center"]);
        for (const t3 of e2.valueSpec.expression.parameters)
          r2.delete(t3);
        if (r2.size === 0)
          return [];
        const n2 = [];
        return t2 instanceof cr && r2.has(t2.name) ? [new be(e2.key, e2.value, `["${t2.name}"] expression is not supported in a filter for a ${e2.object.type} layer with id: ${e2.object.id}`)] : (t2.eachChild((t3) => {
          n2.push(...ri(t3, e2));
        }), n2);
      }
      function ni(t2) {
        const e2 = t2.key, r2 = t2.value, n2 = t2.valueSpec, i3 = [];
        return Array.isArray(n2.values) ? n2.values.indexOf(Ae(r2)) === -1 && i3.push(new be(e2, r2, `expected one of [${n2.values.join(", ")}], ${JSON.stringify(r2)} found`)) : Object.keys(n2.values).indexOf(Ae(r2)) === -1 && i3.push(new be(e2, r2, `expected one of [${Object.keys(n2.values).join(", ")}], ${JSON.stringify(r2)} found`)), i3;
      }
      function ii(t2) {
        if (t2 === true || t2 === false)
          return true;
        if (!Array.isArray(t2) || t2.length === 0)
          return false;
        switch (t2[0]) {
          case "has":
            return t2.length >= 2 && t2[1] !== "$id" && t2[1] !== "$type";
          case "in":
            return t2.length >= 3 && (typeof t2[1] != "string" || Array.isArray(t2[2]));
          case "!in":
          case "!has":
          case "none":
            return false;
          case "==":
          case "!=":
          case ">":
          case ">=":
          case "<":
          case "<=":
            return t2.length !== 3 || Array.isArray(t2[1]) || Array.isArray(t2[2]);
          case "any":
          case "all":
            for (const e2 of t2.slice(1))
              if (!ii(e2) && typeof e2 != "boolean")
                return false;
            return true;
          default:
            return true;
        }
      }
      function si(t2, e2 = "fill") {
        if (t2 == null)
          return { filter: () => true, needGeometry: false, needFeature: false };
        ii(t2) || (t2 = pi(t2));
        const r2 = t2;
        let n2 = true;
        try {
          n2 = function(t3) {
            if (!li(t3))
              return t3;
            let e3 = ke(t3);
            return oi(e3), e3 = ai(e3), e3;
          }(r2);
        } catch (t3) {
          console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.
This is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md
and paste the contents of this message in the report.
Thank you!
Filter Expression:
${JSON.stringify(r2, null, 2)}
        `);
        }
        const i3 = ve[`filter_${e2}`], s3 = Gn(n2, i3);
        let a2 = null;
        if (s3.result === "error")
          throw new Error(s3.value.map((t3) => `${t3.key}: ${t3.message}`).join(", "));
        a2 = (t3, e3, r3) => s3.value.evaluate(t3, e3, {}, r3);
        let o2 = null, l2 = null;
        if (n2 !== r2) {
          const t3 = Gn(r2, i3);
          if (t3.result === "error")
            throw new Error(t3.value.map((t4) => `${t4.key}: ${t4.message}`).join(", "));
          o2 = (e3, r3, n3, i4, s4) => t3.value.evaluate(e3, r3, {}, n3, void 0, void 0, i4, s4), l2 = !Tr(t3.value.expression);
        }
        return a2 = a2, { filter: a2, dynamicFilter: o2 || void 0, needGeometry: hi(n2), needFeature: !!l2 };
      }
      function ai(t2) {
        if (!Array.isArray(t2))
          return t2;
        const e2 = function(t3) {
          if (ui.has(t3[0])) {
            for (let e3 = 1; e3 < t3.length; e3++)
              if (li(t3[e3]))
                return true;
          }
          return t3;
        }(t2);
        return e2 === true ? e2 : e2.map((t3) => ai(t3));
      }
      function oi(t2) {
        let e2 = false;
        const r2 = [];
        if (t2[0] === "case") {
          for (let n2 = 1; n2 < t2.length - 1; n2 += 2)
            e2 = e2 || li(t2[n2]), r2.push(t2[n2 + 1]);
          r2.push(t2[t2.length - 1]);
        } else if (t2[0] === "match") {
          e2 = e2 || li(t2[1]);
          for (let e3 = 2; e3 < t2.length - 1; e3 += 2)
            r2.push(t2[e3 + 1]);
          r2.push(t2[t2.length - 1]);
        } else if (t2[0] === "step") {
          e2 = e2 || li(t2[1]);
          for (let e3 = 1; e3 < t2.length - 1; e3 += 2)
            r2.push(t2[e3 + 1]);
        }
        e2 && (t2.length = 0, t2.push("any", ...r2));
        for (let e3 = 1; e3 < t2.length; e3++)
          oi(t2[e3]);
      }
      function li(t2) {
        if (!Array.isArray(t2))
          return false;
        if ((e2 = t2[0]) === "pitch" || e2 === "distance-from-center")
          return true;
        var e2;
        for (let e3 = 1; e3 < t2.length; e3++)
          if (li(t2[e3]))
            return true;
        return false;
      }
      const ui = /* @__PURE__ */ new Set(["in", "==", "!=", ">", ">=", "<", "<=", "to-boolean"]);
      function ci(t2, e2) {
        return t2 < e2 ? -1 : t2 > e2 ? 1 : 0;
      }
      function hi(t2) {
        if (!Array.isArray(t2))
          return false;
        if (t2[0] === "within")
          return true;
        for (let e2 = 1; e2 < t2.length; e2++)
          if (hi(t2[e2]))
            return true;
        return false;
      }
      function pi(t2) {
        if (!t2)
          return true;
        const e2 = t2[0];
        return t2.length <= 1 ? e2 !== "any" : e2 === "==" ? di(t2[1], t2[2], "==") : e2 === "!=" ? mi(di(t2[1], t2[2], "==")) : e2 === "<" || e2 === ">" || e2 === "<=" || e2 === ">=" ? di(t2[1], t2[2], e2) : e2 === "any" ? (r2 = t2.slice(1), ["any"].concat(r2.map(pi))) : e2 === "all" ? ["all"].concat(t2.slice(1).map(pi)) : e2 === "none" ? ["all"].concat(t2.slice(1).map(pi).map(mi)) : e2 === "in" ? fi(t2[1], t2.slice(2)) : e2 === "!in" ? mi(fi(t2[1], t2.slice(2))) : e2 === "has" ? yi(t2[1]) : e2 === "!has" ? mi(yi(t2[1])) : e2 !== "within" || t2;
        var r2;
      }
      function di(t2, e2, r2) {
        switch (t2) {
          case "$type":
            return [`filter-type-${r2}`, e2];
          case "$id":
            return [`filter-id-${r2}`, e2];
          default:
            return [`filter-${r2}`, t2, e2];
        }
      }
      function fi(t2, e2) {
        if (e2.length === 0)
          return false;
        switch (t2) {
          case "$type":
            return ["filter-type-in", ["literal", e2]];
          case "$id":
            return ["filter-id-in", ["literal", e2]];
          default:
            return e2.length > 200 && !e2.some((t3) => typeof t3 != typeof e2[0]) ? ["filter-in-large", t2, ["literal", e2.sort(ci)]] : ["filter-in-small", t2, ["literal", e2]];
        }
      }
      function yi(t2) {
        switch (t2) {
          case "$type":
            return true;
          case "$id":
            return ["filter-has-id"];
          default:
            return ["filter-has", t2];
        }
      }
      function mi(t2) {
        return ["!", t2];
      }
      function gi(t2) {
        if (ii(ke(t2.value))) {
          const e2 = ke(t2.layerType);
          return ei(_e({}, t2, { expressionContext: "filter", valueSpec: t2.styleSpec[`filter_${e2 || "fill"}`] }));
        }
        return xi(t2);
      }
      function xi(t2) {
        const e2 = t2.value, r2 = t2.key;
        if (Dn(e2) !== "array")
          return [new be(r2, e2, `array expected, ${Dn(e2)} found`)];
        const n2 = t2.styleSpec;
        let i3, s3 = [];
        if (e2.length < 1)
          return [new be(r2, e2, "filter array must have at least 1 element")];
        switch (s3 = s3.concat(ni({ key: `${r2}[0]`, value: e2[0], valueSpec: n2.filter_operator, style: t2.style, styleSpec: t2.styleSpec })), Ae(e2[0])) {
          case "<":
          case "<=":
          case ">":
          case ">=":
            e2.length >= 2 && Ae(e2[1]) === "$type" && s3.push(new be(r2, e2, `"$type" cannot be use with operator "${e2[0]}"`));
          case "==":
          case "!=":
            e2.length !== 3 && s3.push(new be(r2, e2, `filter array for operator "${e2[0]}" must have 3 elements`));
          case "in":
          case "!in":
            e2.length >= 2 && (i3 = Dn(e2[1]), i3 !== "string" && s3.push(new be(`${r2}[1]`, e2[1], `string expected, ${i3} found`)));
            for (let a2 = 2; a2 < e2.length; a2++)
              i3 = Dn(e2[a2]), Ae(e2[1]) === "$type" ? s3 = s3.concat(ni({ key: `${r2}[${a2}]`, value: e2[a2], valueSpec: n2.geometry_type, style: t2.style, styleSpec: t2.styleSpec })) : i3 !== "string" && i3 !== "number" && i3 !== "boolean" && s3.push(new be(`${r2}[${a2}]`, e2[a2], `string, number, or boolean expected, ${i3} found`));
            break;
          case "any":
          case "all":
          case "none":
            for (let n3 = 1; n3 < e2.length; n3++)
              s3 = s3.concat(xi({ key: `${r2}[${n3}]`, value: e2[n3], style: t2.style, styleSpec: t2.styleSpec }));
            break;
          case "has":
          case "!has":
            i3 = Dn(e2[1]), e2.length !== 2 ? s3.push(new be(r2, e2, `filter array for "${e2[0]}" operator must have 2 elements`)) : i3 !== "string" && s3.push(new be(`${r2}[1]`, e2[1], `string expected, ${i3} found`));
            break;
          case "within":
            i3 = Dn(e2[1]), e2.length !== 2 ? s3.push(new be(r2, e2, `filter array for "${e2[0]}" operator must have 2 elements`)) : i3 !== "object" && s3.push(new be(`${r2}[1]`, e2[1], `object expected, ${i3} found`));
        }
        return s3;
      }
      function vi(t2, e2) {
        const r2 = t2.key, n2 = t2.style, i3 = t2.styleSpec, s3 = t2.value, a2 = t2.objectKey, o2 = i3[`${e2}_${t2.layerType}`];
        if (!o2)
          return [];
        const l2 = a2.match(/^(.*)-transition$/);
        if (e2 === "paint" && l2 && o2[l2[1]] && o2[l2[1]].transition)
          return Bi({ key: r2, value: s3, valueSpec: i3.transition, style: n2, styleSpec: i3 });
        const u2 = t2.valueSpec || o2[a2];
        if (!u2)
          return [new be(r2, s3, `unknown property "${a2}"`)];
        let c2;
        if (Dn(s3) === "string" && Cn(u2) && !u2.tokens && (c2 = /^{([^}]+)}$/.exec(s3)))
          return [new be(r2, s3, `"${a2}" does not support interpolation syntax
Use an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(c2[1])} }\`.`)];
        const h2 = [];
        return t2.layerType === "symbol" && (a2 === "text-field" && n2 && !n2.glyphs && h2.push(new be(r2, s3, 'use of "text-field" requires a style "glyphs" property')), a2 === "text-font" && Vn(ke(s3)) && Ae(s3.type) === "identity" && h2.push(new be(r2, s3, '"text-font" does not support identity functions'))), h2.concat(Bi({ key: t2.key, value: s3, valueSpec: u2, style: n2, styleSpec: i3, expressionContext: "property", propertyType: e2, propertyKey: a2 }));
      }
      function bi(t2) {
        return vi(t2, "paint");
      }
      function wi(t2) {
        return vi(t2, "layout");
      }
      function _i(t2) {
        let e2 = [];
        const r2 = t2.value, n2 = t2.key, i3 = t2.style, s3 = t2.styleSpec;
        r2.type || r2.ref || e2.push(new be(n2, r2, 'either "type" or "ref" is required'));
        let a2 = Ae(r2.type);
        const o2 = Ae(r2.ref);
        if (r2.id) {
          const s4 = Ae(r2.id);
          for (let a3 = 0; a3 < t2.arrayIndex; a3++) {
            const t3 = i3.layers[a3];
            Ae(t3.id) === s4 && e2.push(new be(n2, r2.id, `duplicate layer id "${r2.id}", previously used at line ${t3.id.__line__}`));
          }
        }
        if ("ref" in r2) {
          let t3;
          ["type", "source", "source-layer", "filter", "layout"].forEach((t4) => {
            t4 in r2 && e2.push(new be(n2, r2[t4], `"${t4}" is prohibited for ref layers`));
          }), i3.layers.forEach((e3) => {
            Ae(e3.id) === o2 && (t3 = e3);
          }), t3 ? t3.ref ? e2.push(new be(n2, r2.ref, "ref cannot reference another ref layer")) : a2 = Ae(t3.type) : e2.push(new be(n2, r2.ref, `ref layer "${o2}" not found`));
        } else if (a2 !== "background" && a2 !== "sky")
          if (r2.source) {
            const t3 = i3.sources && i3.sources[r2.source], s4 = t3 && Ae(t3.type);
            t3 ? s4 === "vector" && a2 === "raster" ? e2.push(new be(n2, r2.source, `layer "${r2.id}" requires a raster source`)) : s4 === "raster" && a2 !== "raster" ? e2.push(new be(n2, r2.source, `layer "${r2.id}" requires a vector source`)) : s4 !== "vector" || r2["source-layer"] ? s4 === "raster-dem" && a2 !== "hillshade" ? e2.push(new be(n2, r2.source, "raster-dem source can only be used with layer type 'hillshade'.")) : a2 !== "line" || !r2.paint || !r2.paint["line-gradient"] || s4 === "geojson" && t3.lineMetrics || e2.push(new be(n2, r2, `layer "${r2.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : e2.push(new be(n2, r2, `layer "${r2.id}" must specify a "source-layer"`)) : e2.push(new be(n2, r2.source, `source "${r2.source}" not found`));
          } else
            e2.push(new be(n2, r2, 'missing required property "source"'));
        return e2 = e2.concat(Jn({ key: n2, value: r2, valueSpec: s3.layer, style: t2.style, styleSpec: t2.styleSpec, objectElementValidators: { "*": () => [], type: () => Bi({ key: `${n2}.type`, value: r2.type, valueSpec: s3.layer.type, style: t2.style, styleSpec: t2.styleSpec, object: r2, objectKey: "type" }), filter: (t3) => gi(_e({ layerType: a2 }, t3)), layout: (t3) => Jn({ layer: r2, key: t3.key, value: t3.value, style: t3.style, styleSpec: t3.styleSpec, objectElementValidators: { "*": (t4) => wi(_e({ layerType: a2 }, t4)) } }), paint: (t3) => Jn({ layer: r2, key: t3.key, value: t3.value, style: t3.style, styleSpec: t3.styleSpec, objectElementValidators: { "*": (t4) => bi(_e({ layerType: a2 }, t4)) } }) } })), e2;
      }
      function Ai(t2) {
        const e2 = t2.value, r2 = t2.key, n2 = Dn(e2);
        return n2 !== "string" ? [new be(r2, e2, `string expected, ${n2} found`)] : [];
      }
      const ki = { promoteId: function({ key: t2, value: e2 }) {
        if (Dn(e2) === "string")
          return Ai({ key: t2, value: e2 });
        {
          const r2 = [];
          for (const n2 in e2)
            r2.push(...Ai({ key: `${t2}.${n2}`, value: e2[n2] }));
          return r2;
        }
      } };
      function Si(t2) {
        const e2 = t2.value, r2 = t2.key, n2 = t2.styleSpec, i3 = t2.style;
        if (!e2.type)
          return [new be(r2, e2, '"type" is required')];
        const s3 = Ae(e2.type);
        let a2;
        switch (s3) {
          case "vector":
          case "raster":
          case "raster-dem":
            return a2 = Jn({ key: r2, value: e2, valueSpec: n2[`source_${s3.replace("-", "_")}`], style: t2.style, styleSpec: n2, objectElementValidators: ki }), a2;
          case "geojson":
            if (a2 = Jn({ key: r2, value: e2, valueSpec: n2.source_geojson, style: i3, styleSpec: n2, objectElementValidators: ki }), e2.cluster)
              for (const t3 in e2.clusterProperties) {
                const [n3, i4] = e2.clusterProperties[t3], s4 = typeof n3 == "string" ? [n3, ["accumulated"], ["get", t3]] : n3;
                a2.push(...ei({ key: `${r2}.${t3}.map`, value: i4, expressionContext: "cluster-map" })), a2.push(...ei({ key: `${r2}.${t3}.reduce`, value: s4, expressionContext: "cluster-reduce" }));
              }
            return a2;
          case "video":
            return Jn({ key: r2, value: e2, valueSpec: n2.source_video, style: i3, styleSpec: n2 });
          case "image":
            return Jn({ key: r2, value: e2, valueSpec: n2.source_image, style: i3, styleSpec: n2 });
          case "canvas":
            return [new be(r2, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")];
          default:
            return ni({ key: `${r2}.type`, value: e2.type, valueSpec: { values: ["vector", "raster", "raster-dem", "geojson", "video", "image"] }, style: i3, styleSpec: n2 });
        }
      }
      function Ii(t2) {
        const e2 = t2.value, r2 = t2.styleSpec, n2 = r2.light, i3 = t2.style;
        let s3 = [];
        const a2 = Dn(e2);
        if (e2 === void 0)
          return s3;
        if (a2 !== "object")
          return s3 = s3.concat([new be("light", e2, `object expected, ${a2} found`)]), s3;
        for (const t3 in e2) {
          const a3 = t3.match(/^(.*)-transition$/);
          s3 = s3.concat(a3 && n2[a3[1]] && n2[a3[1]].transition ? Bi({ key: t3, value: e2[t3], valueSpec: r2.transition, style: i3, styleSpec: r2 }) : n2[t3] ? Bi({ key: t3, value: e2[t3], valueSpec: n2[t3], style: i3, styleSpec: r2 }) : [new be(t3, e2[t3], `unknown property "${t3}"`)]);
        }
        return s3;
      }
      function zi(t2) {
        const e2 = t2.value, r2 = t2.key, n2 = t2.style, i3 = t2.styleSpec, s3 = i3.terrain;
        let a2 = [];
        const o2 = Dn(e2);
        if (e2 === void 0)
          return a2;
        if (o2 !== "object")
          return a2 = a2.concat([new be("terrain", e2, `object expected, ${o2} found`)]), a2;
        for (const t3 in e2) {
          const r3 = t3.match(/^(.*)-transition$/);
          a2 = a2.concat(r3 && s3[r3[1]] && s3[r3[1]].transition ? Bi({ key: t3, value: e2[t3], valueSpec: i3.transition, style: n2, styleSpec: i3 }) : s3[t3] ? Bi({ key: t3, value: e2[t3], valueSpec: s3[t3], style: n2, styleSpec: i3 }) : [new be(t3, e2[t3], `unknown property "${t3}"`)]);
        }
        if (e2.source) {
          const t3 = n2.sources && n2.sources[e2.source], i4 = t3 && Ae(t3.type);
          t3 ? i4 !== "raster-dem" && a2.push(new be(r2, e2.source, `terrain cannot be used with a source of type ${i4}, it only be used with a "raster-dem" source type`)) : a2.push(new be(r2, e2.source, `source "${e2.source}" not found`));
        } else
          a2.push(new be(r2, e2, 'terrain is missing required property "source"'));
        return a2;
      }
      function Mi(t2) {
        const e2 = t2.value, r2 = t2.style, n2 = t2.styleSpec, i3 = n2.fog;
        let s3 = [];
        const a2 = Dn(e2);
        if (e2 === void 0)
          return s3;
        if (a2 !== "object")
          return s3 = s3.concat([new be("fog", e2, `object expected, ${a2} found`)]), s3;
        for (const t3 in e2) {
          const a3 = t3.match(/^(.*)-transition$/);
          s3 = s3.concat(a3 && i3[a3[1]] && i3[a3[1]].transition ? Bi({ key: t3, value: e2[t3], valueSpec: n2.transition, style: r2, styleSpec: n2 }) : i3[t3] ? Bi({ key: t3, value: e2[t3], valueSpec: i3[t3], style: r2, styleSpec: n2 }) : [new be(t3, e2[t3], `unknown property "${t3}"`)]);
        }
        return s3;
      }
      const Ti = { "*": () => [], array: Wn, boolean: function(t2) {
        const e2 = t2.value, r2 = t2.key, n2 = Dn(e2);
        return n2 !== "boolean" ? [new be(r2, e2, `boolean expected, ${n2} found`)] : [];
      }, number: Qn, color: function(t2) {
        const e2 = t2.key, r2 = t2.value, n2 = Dn(r2);
        return n2 !== "string" ? [new be(e2, r2, `color expected, ${n2} found`)] : Ne.parseCSSColor(r2) === null ? [new be(e2, r2, `color expected, "${r2}" found`)] : [];
      }, constants: we, enum: ni, filter: gi, function: ti, layer: _i, object: Jn, source: Si, light: Ii, terrain: zi, fog: Mi, string: Ai, formatted: function(t2) {
        return Ai(t2).length === 0 ? [] : ei(t2);
      }, resolvedImage: function(t2) {
        return Ai(t2).length === 0 ? [] : ei(t2);
      }, projection: function(t2) {
        const e2 = t2.value, r2 = t2.styleSpec, n2 = r2.projection, i3 = t2.style;
        let s3 = [];
        const a2 = Dn(e2);
        if (a2 === "object")
          for (const t3 in e2)
            s3 = s3.concat(Bi({ key: t3, value: e2[t3], valueSpec: n2[t3], style: i3, styleSpec: r2 }));
        else
          a2 !== "string" && (s3 = s3.concat([new be("projection", e2, `object or string expected, ${a2} found`)]));
        return s3;
      } };
      function Bi(t2) {
        const e2 = t2.value, r2 = t2.valueSpec, n2 = t2.styleSpec;
        return r2.expression && Vn(Ae(e2)) ? ti(t2) : r2.expression && Nn(ke(e2)) ? ei(t2) : r2.type && Ti[r2.type] ? Ti[r2.type](t2) : Jn(_e({}, t2, { valueSpec: r2.type ? n2[r2.type] : r2 }));
      }
      function Ci(t2) {
        const e2 = t2.value, r2 = t2.key, n2 = Ai(t2);
        return n2.length || (e2.indexOf("{fontstack}") === -1 && n2.push(new be(r2, e2, '"glyphs" url must include a "{fontstack}" token')), e2.indexOf("{range}") === -1 && n2.push(new be(r2, e2, '"glyphs" url must include a "{range}" token'))), n2;
      }
      function Pi(t2, e2 = ve) {
        let r2 = [];
        return r2 = r2.concat(Bi({ key: "", value: t2, valueSpec: e2.$root, styleSpec: e2, style: t2, objectElementValidators: { glyphs: Ci, "*": () => [] } })), t2.constants && (r2 = r2.concat(we({ key: "constants", value: t2.constants, style: t2, styleSpec: e2 }))), Ei(r2);
      }
      function Ei(t2) {
        return [].concat(t2).sort((t3, e2) => t3.line - e2.line);
      }
      function Di(t2) {
        return function(...e2) {
          return Ei(t2.apply(this, e2));
        };
      }
      Pi.source = Di(Si), Pi.light = Di(Ii), Pi.terrain = Di(zi), Pi.fog = Di(Mi), Pi.layer = Di(_i), Pi.filter = Di(gi), Pi.paintProperty = Di(bi), Pi.layoutProperty = Di(wi);
      const Vi = Pi, Fi = Vi.light, Li = Vi.fog, Ri = Vi.paintProperty, Ui = Vi.layoutProperty;
      function $i(t2, e2) {
        let r2 = false;
        if (e2 && e2.length)
          for (const n2 of e2)
            t2.fire(new ge(new Error(n2.message))), r2 = true;
        return r2;
      }
      var Oi = ji;
      function ji(t2, e2, r2) {
        var n2 = this.cells = [];
        if (t2 instanceof ArrayBuffer) {
          this.arrayBuffer = t2;
          var i3 = new Int32Array(this.arrayBuffer);
          t2 = i3[0], this.d = (e2 = i3[1]) + 2 * (r2 = i3[2]);
          for (var s3 = 0; s3 < this.d * this.d; s3++) {
            var a2 = i3[3 + s3], o2 = i3[3 + s3 + 1];
            n2.push(a2 === o2 ? null : i3.subarray(a2, o2));
          }
          var l2 = i3[3 + n2.length + 1];
          this.keys = i3.subarray(i3[3 + n2.length], l2), this.bboxes = i3.subarray(l2), this.insert = this._insertReadonly;
        } else {
          this.d = e2 + 2 * r2;
          for (var u2 = 0; u2 < this.d * this.d; u2++)
            n2.push([]);
          this.keys = [], this.bboxes = [];
        }
        this.n = e2, this.extent = t2, this.padding = r2, this.scale = e2 / t2, this.uid = 0;
        var c2 = r2 / e2 * t2;
        this.min = -c2, this.max = t2 + c2;
      }
      ji.prototype.insert = function(t2, e2, r2, n2, i3) {
        this._forEachCell(e2, r2, n2, i3, this._insertCell, this.uid++), this.keys.push(t2), this.bboxes.push(e2), this.bboxes.push(r2), this.bboxes.push(n2), this.bboxes.push(i3);
      }, ji.prototype._insertReadonly = function() {
        throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
      }, ji.prototype._insertCell = function(t2, e2, r2, n2, i3, s3) {
        this.cells[i3].push(s3);
      }, ji.prototype.query = function(t2, e2, r2, n2, i3) {
        var s3 = this.min, a2 = this.max;
        if (t2 <= s3 && e2 <= s3 && a2 <= r2 && a2 <= n2 && !i3)
          return Array.prototype.slice.call(this.keys);
        var o2 = [];
        return this._forEachCell(t2, e2, r2, n2, this._queryCell, o2, {}, i3), o2;
      }, ji.prototype._queryCell = function(t2, e2, r2, n2, i3, s3, a2, o2) {
        var l2 = this.cells[i3];
        if (l2 !== null)
          for (var u2 = this.keys, c2 = this.bboxes, h2 = 0; h2 < l2.length; h2++) {
            var p2 = l2[h2];
            if (a2[p2] === void 0) {
              var d2 = 4 * p2;
              (o2 ? o2(c2[d2 + 0], c2[d2 + 1], c2[d2 + 2], c2[d2 + 3]) : t2 <= c2[d2 + 2] && e2 <= c2[d2 + 3] && r2 >= c2[d2 + 0] && n2 >= c2[d2 + 1]) ? (a2[p2] = true, s3.push(u2[p2])) : a2[p2] = false;
            }
          }
      }, ji.prototype._forEachCell = function(t2, e2, r2, n2, i3, s3, a2, o2) {
        for (var l2 = this._convertToCellCoord(t2), u2 = this._convertToCellCoord(e2), c2 = this._convertToCellCoord(r2), h2 = this._convertToCellCoord(n2), p2 = l2; p2 <= c2; p2++)
          for (var d2 = u2; d2 <= h2; d2++) {
            var f2 = this.d * d2 + p2;
            if ((!o2 || o2(this._convertFromCellCoord(p2), this._convertFromCellCoord(d2), this._convertFromCellCoord(p2 + 1), this._convertFromCellCoord(d2 + 1))) && i3.call(this, t2, e2, r2, n2, f2, s3, a2, o2))
              return;
          }
      }, ji.prototype._convertFromCellCoord = function(t2) {
        return (t2 - this.padding) / this.scale;
      }, ji.prototype._convertToCellCoord = function(t2) {
        return Math.max(0, Math.min(this.d - 1, Math.floor(t2 * this.scale) + this.padding));
      }, ji.prototype.toArrayBuffer = function() {
        if (this.arrayBuffer)
          return this.arrayBuffer;
        for (var t2 = this.cells, e2 = 3 + this.cells.length + 1 + 1, r2 = 0, n2 = 0; n2 < this.cells.length; n2++)
          r2 += this.cells[n2].length;
        var i3 = new Int32Array(e2 + r2 + this.keys.length + this.bboxes.length);
        i3[0] = this.extent, i3[1] = this.n, i3[2] = this.padding;
        for (var s3 = e2, a2 = 0; a2 < t2.length; a2++) {
          var o2 = t2[a2];
          i3[3 + a2] = s3, i3.set(o2, s3), s3 += o2.length;
        }
        return i3[3 + t2.length] = s3, i3.set(this.keys, s3), i3[3 + t2.length + 1] = s3 += this.keys.length, i3.set(this.bboxes, s3), s3 += this.bboxes.length, i3.buffer;
      };
      const { ImageData: qi, ImageBitmap: Ni } = a, Gi = {};
      function Zi(t2, e2, r2 = {}) {
        Object.defineProperty(e2, "_classRegistryKey", { value: t2, writeable: false }), Gi[t2] = { klass: e2, omit: r2.omit || [], shallow: r2.shallow || [] };
      }
      Zi("Object", Object), Oi.serialize = function(t2, e2) {
        const r2 = t2.toArrayBuffer();
        return e2 && e2.push(r2), { buffer: r2 };
      }, Oi.deserialize = function(t2) {
        return new Oi(t2.buffer);
      }, Zi("Grid", Oi), Zi("Color", Ge), Zi("Error", Error), Zi("ResolvedImage", Ye), Zi("StylePropertyFunction", Yn), Zi("StyleExpression", qn, { omit: ["_evaluator"] }), Zi("ZoomDependentExpression", Xn), Zi("ZoomConstantExpression", Zn), Zi("CompoundExpression", cr, { omit: ["_evaluate"] });
      for (const t2 in kn)
        kn[t2]._classRegistryKey || Zi(`Expression_${t2}`, kn[t2]);
      function Xi(t2) {
        return t2 && typeof ArrayBuffer != "undefined" && (t2 instanceof ArrayBuffer || t2.constructor && t2.constructor.name === "ArrayBuffer");
      }
      function Ki(t2) {
        return Ni && t2 instanceof Ni;
      }
      function Yi(t2, e2) {
        if (t2 == null || typeof t2 == "boolean" || typeof t2 == "number" || typeof t2 == "string" || t2 instanceof Boolean || t2 instanceof Number || t2 instanceof String || t2 instanceof Date || t2 instanceof RegExp)
          return t2;
        if (Xi(t2) || Ki(t2))
          return e2 && e2.push(t2), t2;
        if (ArrayBuffer.isView(t2)) {
          const r2 = t2;
          return e2 && e2.push(r2.buffer), r2;
        }
        if (t2 instanceof qi)
          return e2 && e2.push(t2.data.buffer), t2;
        if (Array.isArray(t2)) {
          const r2 = [];
          for (const n2 of t2)
            r2.push(Yi(n2, e2));
          return r2;
        }
        if (typeof t2 == "object") {
          const r2 = t2.constructor, n2 = r2._classRegistryKey;
          if (!n2)
            throw new Error("can't serialize object of unregistered class");
          const i3 = r2.serialize ? r2.serialize(t2, e2) : {};
          if (!r2.serialize) {
            for (const r3 in t2) {
              if (!t2.hasOwnProperty(r3))
                continue;
              if (Gi[n2].omit.indexOf(r3) >= 0)
                continue;
              const s3 = t2[r3];
              i3[r3] = Gi[n2].shallow.indexOf(r3) >= 0 ? s3 : Yi(s3, e2);
            }
            t2 instanceof Error && (i3.message = t2.message);
          }
          if (i3.$name)
            throw new Error("$name property is reserved for worker serialization logic.");
          return n2 !== "Object" && (i3.$name = n2), i3;
        }
        throw new Error("can't serialize object of type " + typeof t2);
      }
      function Hi(t2) {
        if (t2 == null || typeof t2 == "boolean" || typeof t2 == "number" || typeof t2 == "string" || t2 instanceof Boolean || t2 instanceof Number || t2 instanceof String || t2 instanceof Date || t2 instanceof RegExp || Xi(t2) || Ki(t2) || ArrayBuffer.isView(t2) || t2 instanceof qi)
          return t2;
        if (Array.isArray(t2))
          return t2.map(Hi);
        if (typeof t2 == "object") {
          const e2 = t2.$name || "Object", { klass: r2 } = Gi[e2];
          if (!r2)
            throw new Error(`can't deserialize unregistered class ${e2}`);
          if (r2.deserialize)
            return r2.deserialize(t2);
          const n2 = Object.create(r2.prototype);
          for (const r3 of Object.keys(t2)) {
            if (r3 === "$name")
              continue;
            const i3 = t2[r3];
            n2[r3] = Gi[e2].shallow.indexOf(r3) >= 0 ? i3 : Hi(i3);
          }
          return n2;
        }
        throw new Error("can't deserialize object of type " + typeof t2);
      }
      class Ji {
        constructor() {
          this.first = true;
        }
        update(t2, e2) {
          const r2 = Math.floor(t2);
          return this.first ? (this.first = false, this.lastIntegerZoom = r2, this.lastIntegerZoomTime = 0, this.lastZoom = t2, this.lastFloorZoom = r2, true) : (this.lastFloorZoom > r2 ? (this.lastIntegerZoom = r2 + 1, this.lastIntegerZoomTime = e2) : this.lastFloorZoom < r2 && (this.lastIntegerZoom = r2, this.lastIntegerZoomTime = e2), t2 !== this.lastZoom && (this.lastZoom = t2, this.lastFloorZoom = r2, true));
        }
      }
      const Wi = (t2) => t2 >= 1536 && t2 <= 1791, Qi = (t2) => t2 >= 1872 && t2 <= 1919, ts = (t2) => t2 >= 2208 && t2 <= 2303, es = (t2) => t2 >= 11904 && t2 <= 12031, rs = (t2) => t2 >= 12032 && t2 <= 12255, ns = (t2) => t2 >= 12272 && t2 <= 12287, is2 = (t2) => t2 >= 12288 && t2 <= 12351, ss = (t2) => t2 >= 12352 && t2 <= 12447, as2 = (t2) => t2 >= 12448 && t2 <= 12543, os2 = (t2) => t2 >= 12544 && t2 <= 12591, ls = (t2) => t2 >= 12704 && t2 <= 12735, us = (t2) => t2 >= 12736 && t2 <= 12783, cs = (t2) => t2 >= 12784 && t2 <= 12799, hs = (t2) => t2 >= 12800 && t2 <= 13055, ps = (t2) => t2 >= 13056 && t2 <= 13311, ds = (t2) => t2 >= 13312 && t2 <= 19903, fs = (t2) => t2 >= 19968 && t2 <= 40959, ys = (t2) => t2 >= 40960 && t2 <= 42127, ms = (t2) => t2 >= 42128 && t2 <= 42191, gs = (t2) => t2 >= 44032 && t2 <= 55215, xs = (t2) => t2 >= 63744 && t2 <= 64255, vs = (t2) => t2 >= 64336 && t2 <= 65023, bs = (t2) => t2 >= 65040 && t2 <= 65055, ws = (t2) => t2 >= 65072 && t2 <= 65103, _s = (t2) => t2 >= 65104 && t2 <= 65135, As = (t2) => t2 >= 65136 && t2 <= 65279, ks = (t2) => t2 >= 65280 && t2 <= 65519;
      function Ss(t2) {
        for (const e2 of t2)
          if (Ms(e2.charCodeAt(0)))
            return true;
        return false;
      }
      function Is(t2) {
        for (const e2 of t2)
          if (!zs(e2.charCodeAt(0)))
            return false;
        return true;
      }
      function zs(t2) {
        return !(Wi(t2) || Qi(t2) || ts(t2) || vs(t2) || As(t2));
      }
      function Ms(t2) {
        return !(t2 !== 746 && t2 !== 747 && (t2 < 4352 || !(ls(t2) || os2(t2) || ws(t2) && !(t2 >= 65097 && t2 <= 65103) || xs(t2) || ps(t2) || es(t2) || us(t2) || !(!is2(t2) || t2 >= 12296 && t2 <= 12305 || t2 >= 12308 && t2 <= 12319 || t2 === 12336) || ds(t2) || fs(t2) || hs(t2) || ((t3) => t3 >= 12592 && t3 <= 12687)(t2) || ((t3) => t3 >= 43360 && t3 <= 43391)(t2) || ((t3) => t3 >= 55216 && t3 <= 55295)(t2) || ((t3) => t3 >= 4352 && t3 <= 4607)(t2) || gs(t2) || ss(t2) || ns(t2) || ((t3) => t3 >= 12688 && t3 <= 12703)(t2) || rs(t2) || cs(t2) || as2(t2) && t2 !== 12540 || !(!ks(t2) || t2 === 65288 || t2 === 65289 || t2 === 65293 || t2 >= 65306 && t2 <= 65310 || t2 === 65339 || t2 === 65341 || t2 === 65343 || t2 >= 65371 && t2 <= 65503 || t2 === 65507 || t2 >= 65512 && t2 <= 65519) || !(!_s(t2) || t2 >= 65112 && t2 <= 65118 || t2 >= 65123 && t2 <= 65126) || ((t3) => t3 >= 5120 && t3 <= 5759)(t2) || ((t3) => t3 >= 6320 && t3 <= 6399)(t2) || bs(t2) || ((t3) => t3 >= 19904 && t3 <= 19967)(t2) || ys(t2) || ms(t2))));
      }
      function Ts(t2) {
        return !(Ms(t2) || function(t3) {
          return !!(((t4) => t4 >= 128 && t4 <= 255)(t3) && (t3 === 167 || t3 === 169 || t3 === 174 || t3 === 177 || t3 === 188 || t3 === 189 || t3 === 190 || t3 === 215 || t3 === 247) || ((t4) => t4 >= 8192 && t4 <= 8303)(t3) && (t3 === 8214 || t3 === 8224 || t3 === 8225 || t3 === 8240 || t3 === 8241 || t3 === 8251 || t3 === 8252 || t3 === 8258 || t3 === 8263 || t3 === 8264 || t3 === 8265 || t3 === 8273) || ((t4) => t4 >= 8448 && t4 <= 8527)(t3) || ((t4) => t4 >= 8528 && t4 <= 8591)(t3) || ((t4) => t4 >= 8960 && t4 <= 9215)(t3) && (t3 >= 8960 && t3 <= 8967 || t3 >= 8972 && t3 <= 8991 || t3 >= 8996 && t3 <= 9e3 || t3 === 9003 || t3 >= 9085 && t3 <= 9114 || t3 >= 9150 && t3 <= 9165 || t3 === 9167 || t3 >= 9169 && t3 <= 9179 || t3 >= 9186 && t3 <= 9215) || ((t4) => t4 >= 9216 && t4 <= 9279)(t3) && t3 !== 9251 || ((t4) => t4 >= 9280 && t4 <= 9311)(t3) || ((t4) => t4 >= 9312 && t4 <= 9471)(t3) || ((t4) => t4 >= 9632 && t4 <= 9727)(t3) || ((t4) => t4 >= 9728 && t4 <= 9983)(t3) && !(t3 >= 9754 && t3 <= 9759) || ((t4) => t4 >= 11008 && t4 <= 11263)(t3) && (t3 >= 11026 && t3 <= 11055 || t3 >= 11088 && t3 <= 11097 || t3 >= 11192 && t3 <= 11243) || is2(t3) || as2(t3) || ((t4) => t4 >= 57344 && t4 <= 63743)(t3) || ws(t3) || _s(t3) || ks(t3) || t3 === 8734 || t3 === 8756 || t3 === 8757 || t3 >= 9984 && t3 <= 10087 || t3 >= 10102 && t3 <= 10131 || t3 === 65532 || t3 === 65533);
        }(t2));
      }
      function Bs(t2) {
        return t2 >= 1424 && t2 <= 2303 || vs(t2) || As(t2);
      }
      function Cs(t2, e2) {
        return !(!e2 && Bs(t2) || t2 >= 2304 && t2 <= 3583 || t2 >= 3840 && t2 <= 4255 || ((t3) => t3 >= 6016 && t3 <= 6143)(t2));
      }
      function Ps(t2) {
        for (const e2 of t2)
          if (Bs(e2.charCodeAt(0)))
            return true;
        return false;
      }
      const Es = "deferred", Ds = "loading", Vs = "loaded";
      let Fs = null, Ls = "unavailable", Rs = null;
      const Us = function(t2) {
        t2 && typeof t2 == "string" && t2.indexOf("NetworkError") > -1 && (Ls = "error"), Fs && Fs(t2);
      };
      function $s() {
        Os.fire(new me("pluginStateChange", { pluginStatus: Ls, pluginURL: Rs }));
      }
      const Os = new xe(), js = function() {
        return Ls;
      }, qs = function() {
        if (Ls !== Es || !Rs)
          throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
        Ls = Ds, $s(), Rs && ae({ url: Rs }, (t2) => {
          t2 ? Us(t2) : (Ls = Vs, $s());
        });
      }, Ns = { applyArabicShaping: null, processBidirectionalText: null, processStyledBidirectionalText: null, isLoaded: () => Ls === Vs || Ns.applyArabicShaping != null, isLoading: () => Ls === Ds, setState(t2) {
        Ls = t2.pluginStatus, Rs = t2.pluginURL;
      }, isParsed: () => Ns.applyArabicShaping != null && Ns.processBidirectionalText != null && Ns.processStyledBidirectionalText != null, getPluginURL: () => Rs };
      class Gs {
        constructor(t2, e2) {
          this.zoom = t2, e2 ? (this.now = e2.now, this.fadeDuration = e2.fadeDuration, this.zoomHistory = e2.zoomHistory, this.transition = e2.transition, this.pitch = e2.pitch) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new Ji(), this.transition = {}, this.pitch = 0);
        }
        isSupportedScript(t2) {
          return function(t3, e2) {
            for (const r2 of t3)
              if (!Cs(r2.charCodeAt(0), e2))
                return false;
            return true;
          }(t2, Ns.isLoaded());
        }
        crossFadingFactor() {
          return this.fadeDuration === 0 ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
        }
        getCrossfadeParameters() {
          const t2 = this.zoom, e2 = t2 - Math.floor(t2), r2 = this.crossFadingFactor();
          return t2 > this.zoomHistory.lastIntegerZoom ? { fromScale: 2, toScale: 1, t: e2 + (1 - e2) * r2 } : { fromScale: 0.5, toScale: 1, t: 1 - (1 - r2) * e2 };
        }
      }
      class Zs {
        constructor(t2, e2) {
          this.property = t2, this.value = e2, this.expression = function(t3, e3) {
            if (Vn(t3))
              return new Yn(t3, e3);
            if (Nn(t3)) {
              const r2 = Kn(t3, e3);
              if (r2.result === "error")
                throw new Error(r2.value.map((t4) => `${t4.key}: ${t4.message}`).join(", "));
              return r2.value;
            }
            {
              let r2 = t3;
              return typeof t3 == "string" && e3.type === "color" && (r2 = Ge.parse(t3)), { kind: "constant", evaluate: () => r2 };
            }
          }(e2 === void 0 ? t2.specification.default : e2, t2.specification);
        }
        isDataDriven() {
          return this.expression.kind === "source" || this.expression.kind === "composite";
        }
        possiblyEvaluate(t2, e2, r2) {
          return this.property.possiblyEvaluate(this, t2, e2, r2);
        }
      }
      class Xs {
        constructor(t2) {
          this.property = t2, this.value = new Zs(t2, void 0);
        }
        transitioned(t2, e2) {
          return new Ys(this.property, this.value, e2, tt({}, t2.transition, this.transition), t2.now);
        }
        untransitioned() {
          return new Ys(this.property, this.value, null, {}, 0);
        }
      }
      class Ks {
        constructor(t2) {
          this._properties = t2, this._values = Object.create(t2.defaultTransitionablePropertyValues);
        }
        getValue(t2) {
          return ct(this._values[t2].value.value);
        }
        setValue(t2, e2) {
          this._values.hasOwnProperty(t2) || (this._values[t2] = new Xs(this._values[t2].property)), this._values[t2].value = new Zs(this._values[t2].property, e2 === null ? void 0 : ct(e2));
        }
        getTransition(t2) {
          return ct(this._values[t2].transition);
        }
        setTransition(t2, e2) {
          this._values.hasOwnProperty(t2) || (this._values[t2] = new Xs(this._values[t2].property)), this._values[t2].transition = ct(e2) || void 0;
        }
        serialize() {
          const t2 = {};
          for (const e2 of Object.keys(this._values)) {
            const r2 = this.getValue(e2);
            r2 !== void 0 && (t2[e2] = r2);
            const n2 = this.getTransition(e2);
            n2 !== void 0 && (t2[`${e2}-transition`] = n2);
          }
          return t2;
        }
        transitioned(t2, e2) {
          const r2 = new Hs(this._properties);
          for (const n2 of Object.keys(this._values))
            r2._values[n2] = this._values[n2].transitioned(t2, e2._values[n2]);
          return r2;
        }
        untransitioned() {
          const t2 = new Hs(this._properties);
          for (const e2 of Object.keys(this._values))
            t2._values[e2] = this._values[e2].untransitioned();
          return t2;
        }
      }
      class Ys {
        constructor(t2, e2, r2, n2, i3) {
          const s3 = n2.delay || 0, a2 = n2.duration || 0;
          i3 = i3 || 0, this.property = t2, this.value = e2, this.begin = i3 + s3, this.end = this.begin + a2, t2.specification.transition && (n2.delay || n2.duration) && (this.prior = r2);
        }
        possiblyEvaluate(t2, e2, r2) {
          const n2 = t2.now || 0, i3 = this.value.possiblyEvaluate(t2, e2, r2), s3 = this.prior;
          if (s3) {
            if (n2 > this.end)
              return this.prior = null, i3;
            if (this.value.isDataDriven())
              return this.prior = null, i3;
            if (n2 < this.begin)
              return s3.possiblyEvaluate(t2, e2, r2);
            {
              const a2 = (n2 - this.begin) / (this.end - this.begin);
              return this.property.interpolate(s3.possiblyEvaluate(t2, e2, r2), i3, Z2(a2));
            }
          }
          return i3;
        }
      }
      class Hs {
        constructor(t2) {
          this._properties = t2, this._values = Object.create(t2.defaultTransitioningPropertyValues);
        }
        possiblyEvaluate(t2, e2, r2) {
          const n2 = new Qs(this._properties);
          for (const i3 of Object.keys(this._values))
            n2._values[i3] = this._values[i3].possiblyEvaluate(t2, e2, r2);
          return n2;
        }
        hasTransition() {
          for (const t2 of Object.keys(this._values))
            if (this._values[t2].prior)
              return true;
          return false;
        }
      }
      class Js {
        constructor(t2) {
          this._properties = t2, this._values = Object.create(t2.defaultPropertyValues);
        }
        getValue(t2) {
          return ct(this._values[t2].value);
        }
        setValue(t2, e2) {
          this._values[t2] = new Zs(this._values[t2].property, e2 === null ? void 0 : ct(e2));
        }
        serialize() {
          const t2 = {};
          for (const e2 of Object.keys(this._values)) {
            const r2 = this.getValue(e2);
            r2 !== void 0 && (t2[e2] = r2);
          }
          return t2;
        }
        possiblyEvaluate(t2, e2, r2) {
          const n2 = new Qs(this._properties);
          for (const i3 of Object.keys(this._values))
            n2._values[i3] = this._values[i3].possiblyEvaluate(t2, e2, r2);
          return n2;
        }
      }
      class Ws {
        constructor(t2, e2, r2) {
          this.property = t2, this.value = e2, this.parameters = r2;
        }
        isConstant() {
          return this.value.kind === "constant";
        }
        constantOr(t2) {
          return this.value.kind === "constant" ? this.value.value : t2;
        }
        evaluate(t2, e2, r2, n2) {
          return this.property.evaluate(this.value, this.parameters, t2, e2, r2, n2);
        }
      }
      class Qs {
        constructor(t2) {
          this._properties = t2, this._values = Object.create(t2.defaultPossiblyEvaluatedValues);
        }
        get(t2) {
          return this._values[t2];
        }
      }
      class ta {
        constructor(t2) {
          this.specification = t2;
        }
        possiblyEvaluate(t2, e2) {
          return t2.expression.evaluate(e2);
        }
        interpolate(t2, e2, r2) {
          const n2 = Rr[this.specification.type];
          return n2 ? n2(t2, e2, r2) : t2;
        }
      }
      class ea {
        constructor(t2, e2) {
          this.specification = t2, this.overrides = e2;
        }
        possiblyEvaluate(t2, e2, r2, n2) {
          return new Ws(this, t2.expression.kind === "constant" || t2.expression.kind === "camera" ? { kind: "constant", value: t2.expression.evaluate(e2, null, {}, r2, n2) } : t2.expression, e2);
        }
        interpolate(t2, e2, r2) {
          if (t2.value.kind !== "constant" || e2.value.kind !== "constant")
            return t2;
          if (t2.value.value === void 0 || e2.value.value === void 0)
            return new Ws(this, { kind: "constant", value: void 0 }, t2.parameters);
          const n2 = Rr[this.specification.type];
          return n2 ? new Ws(this, { kind: "constant", value: n2(t2.value.value, e2.value.value, r2) }, t2.parameters) : t2;
        }
        evaluate(t2, e2, r2, n2, i3, s3) {
          return t2.kind === "constant" ? t2.value : t2.evaluate(e2, r2, n2, i3, s3);
        }
      }
      class ra extends ea {
        possiblyEvaluate(t2, e2, r2, n2) {
          if (t2.value === void 0)
            return new Ws(this, { kind: "constant", value: void 0 }, e2);
          if (t2.expression.kind === "constant") {
            const i3 = t2.expression.evaluate(e2, null, {}, r2, n2), s3 = t2.property.specification.type === "resolvedImage" && typeof i3 != "string" ? i3.name : i3, a2 = this._calculate(s3, s3, s3, e2);
            return new Ws(this, { kind: "constant", value: a2 }, e2);
          }
          if (t2.expression.kind === "camera") {
            const r3 = this._calculate(t2.expression.evaluate({ zoom: e2.zoom - 1 }), t2.expression.evaluate({ zoom: e2.zoom }), t2.expression.evaluate({ zoom: e2.zoom + 1 }), e2);
            return new Ws(this, { kind: "constant", value: r3 }, e2);
          }
          return new Ws(this, t2.expression, e2);
        }
        evaluate(t2, e2, r2, n2, i3, s3) {
          if (t2.kind === "source") {
            const a2 = t2.evaluate(e2, r2, n2, i3, s3);
            return this._calculate(a2, a2, a2, e2);
          }
          return t2.kind === "composite" ? this._calculate(t2.evaluate({ zoom: Math.floor(e2.zoom) - 1 }, r2, n2), t2.evaluate({ zoom: Math.floor(e2.zoom) }, r2, n2), t2.evaluate({ zoom: Math.floor(e2.zoom) + 1 }, r2, n2), e2) : t2.value;
        }
        _calculate(t2, e2, r2, n2) {
          return n2.zoom > n2.zoomHistory.lastIntegerZoom ? { from: t2, to: e2, other: r2 } : { from: r2, to: e2, other: t2 };
        }
        interpolate(t2) {
          return t2;
        }
      }
      class na {
        constructor(t2) {
          this.specification = t2;
        }
        possiblyEvaluate(t2, e2, r2, n2) {
          if (t2.value !== void 0) {
            if (t2.expression.kind === "constant") {
              const i3 = t2.expression.evaluate(e2, null, {}, r2, n2);
              return this._calculate(i3, i3, i3, e2);
            }
            return this._calculate(t2.expression.evaluate(new Gs(Math.floor(e2.zoom - 1), e2)), t2.expression.evaluate(new Gs(Math.floor(e2.zoom), e2)), t2.expression.evaluate(new Gs(Math.floor(e2.zoom + 1), e2)), e2);
          }
        }
        _calculate(t2, e2, r2, n2) {
          return n2.zoom > n2.zoomHistory.lastIntegerZoom ? { from: t2, to: e2 } : { from: r2, to: e2 };
        }
        interpolate(t2) {
          return t2;
        }
      }
      class ia {
        constructor(t2) {
          this.specification = t2;
        }
        possiblyEvaluate(t2, e2, r2, n2) {
          return !!t2.expression.evaluate(e2, null, {}, r2, n2);
        }
        interpolate() {
          return false;
        }
      }
      class sa {
        constructor(t2) {
          this.properties = t2, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
          for (const e2 in t2) {
            const r2 = t2[e2];
            r2.specification.overridable && this.overridableProperties.push(e2);
            const n2 = this.defaultPropertyValues[e2] = new Zs(r2, void 0), i3 = this.defaultTransitionablePropertyValues[e2] = new Xs(r2);
            this.defaultTransitioningPropertyValues[e2] = i3.untransitioned(), this.defaultPossiblyEvaluatedValues[e2] = n2.possiblyEvaluate({});
          }
        }
      }
      function aa(t2, e2) {
        return 256 * (t2 = Y2(Math.floor(t2), 0, 255)) + Y2(Math.floor(e2), 0, 255);
      }
      Zi("DataDrivenProperty", ea), Zi("DataConstantProperty", ta), Zi("CrossFadedDataDrivenProperty", ra), Zi("CrossFadedProperty", na), Zi("ColorRampProperty", ia);
      const oa = { Int8: Int8Array, Uint8: Uint8Array, Int16: Int16Array, Uint16: Uint16Array, Int32: Int32Array, Uint32: Uint32Array, Float32: Float32Array };
      class la {
        constructor(t2, e2) {
          this._structArray = t2, this._pos1 = e2 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
        }
      }
      class ua {
        constructor() {
          this.isTransferred = false, this.capacity = -1, this.resize(0);
        }
        static serialize(t2, e2) {
          return t2._trim(), e2 && (t2.isTransferred = true, e2.push(t2.arrayBuffer)), { length: t2.length, arrayBuffer: t2.arrayBuffer };
        }
        static deserialize(t2) {
          const e2 = Object.create(this.prototype);
          return e2.arrayBuffer = t2.arrayBuffer, e2.length = t2.length, e2.capacity = t2.arrayBuffer.byteLength / e2.bytesPerElement, e2._refreshViews(), e2;
        }
        _trim() {
          this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
        }
        clear() {
          this.length = 0;
        }
        resize(t2) {
          this.reserve(t2), this.length = t2;
        }
        reserve(t2) {
          if (t2 > this.capacity) {
            this.capacity = Math.max(t2, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
            const e2 = this.uint8;
            this._refreshViews(), e2 && this.uint8.set(e2);
          }
        }
        _refreshViews() {
          throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
        }
      }
      function ca(t2, e2 = 1) {
        let r2 = 0, n2 = 0;
        return { members: t2.map((t3) => {
          const i3 = oa[t3.type].BYTES_PER_ELEMENT, s3 = r2 = ha(r2, Math.max(e2, i3)), a2 = t3.components || 1;
          return n2 = Math.max(n2, i3), r2 += i3 * a2, { name: t3.name, type: t3.type, components: a2, offset: s3 };
        }), size: ha(r2, Math.max(n2, e2)), alignment: e2 };
      }
      function ha(t2, e2) {
        return Math.ceil(t2 / e2) * e2;
      }
      class pa extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2) {
          const r2 = this.length;
          return this.resize(r2 + 1), this.emplace(r2, t2, e2);
        }
        emplace(t2, e2, r2) {
          const n2 = 2 * t2;
          return this.int16[n2 + 0] = e2, this.int16[n2 + 1] = r2, t2;
        }
      }
      pa.prototype.bytesPerElement = 4, Zi("StructArrayLayout2i4", pa);
      class da extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2, r2, n2) {
          const i3 = this.length;
          return this.resize(i3 + 1), this.emplace(i3, t2, e2, r2, n2);
        }
        emplace(t2, e2, r2, n2, i3) {
          const s3 = 4 * t2;
          return this.int16[s3 + 0] = e2, this.int16[s3 + 1] = r2, this.int16[s3 + 2] = n2, this.int16[s3 + 3] = i3, t2;
        }
      }
      da.prototype.bytesPerElement = 8, Zi("StructArrayLayout4i8", da);
      class fa extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2, r2, n2, i3, s3, a2) {
          const o2 = this.length;
          return this.resize(o2 + 1), this.emplace(o2, t2, e2, r2, n2, i3, s3, a2);
        }
        emplace(t2, e2, r2, n2, i3, s3, a2, o2) {
          const l2 = 6 * t2, u2 = 12 * t2, c2 = 3 * t2;
          return this.int16[l2 + 0] = e2, this.int16[l2 + 1] = r2, this.uint8[u2 + 4] = n2, this.uint8[u2 + 5] = i3, this.uint8[u2 + 6] = s3, this.uint8[u2 + 7] = a2, this.float32[c2 + 2] = o2, t2;
        }
      }
      fa.prototype.bytesPerElement = 12, Zi("StructArrayLayout2i4ub1f12", fa);
      class ya extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2, r2) {
          const n2 = this.length;
          return this.resize(n2 + 1), this.emplace(n2, t2, e2, r2);
        }
        emplace(t2, e2, r2, n2) {
          const i3 = 3 * t2;
          return this.float32[i3 + 0] = e2, this.float32[i3 + 1] = r2, this.float32[i3 + 2] = n2, t2;
        }
      }
      ya.prototype.bytesPerElement = 12, Zi("StructArrayLayout3f12", ya);
      class ma extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2, r2, n2, i3, s3, a2, o2, l2, u2) {
          const c2 = this.length;
          return this.resize(c2 + 1), this.emplace(c2, t2, e2, r2, n2, i3, s3, a2, o2, l2, u2);
        }
        emplace(t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2) {
          const h2 = 10 * t2;
          return this.uint16[h2 + 0] = e2, this.uint16[h2 + 1] = r2, this.uint16[h2 + 2] = n2, this.uint16[h2 + 3] = i3, this.uint16[h2 + 4] = s3, this.uint16[h2 + 5] = a2, this.uint16[h2 + 6] = o2, this.uint16[h2 + 7] = l2, this.uint16[h2 + 8] = u2, this.uint16[h2 + 9] = c2, t2;
        }
      }
      ma.prototype.bytesPerElement = 20, Zi("StructArrayLayout10ui20", ma);
      class ga extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2, r2, n2, i3, s3, a2, o2) {
          const l2 = this.length;
          return this.resize(l2 + 1), this.emplace(l2, t2, e2, r2, n2, i3, s3, a2, o2);
        }
        emplace(t2, e2, r2, n2, i3, s3, a2, o2, l2) {
          const u2 = 8 * t2;
          return this.uint16[u2 + 0] = e2, this.uint16[u2 + 1] = r2, this.uint16[u2 + 2] = n2, this.uint16[u2 + 3] = i3, this.uint16[u2 + 4] = s3, this.uint16[u2 + 5] = a2, this.uint16[u2 + 6] = o2, this.uint16[u2 + 7] = l2, t2;
        }
      }
      ga.prototype.bytesPerElement = 16, Zi("StructArrayLayout8ui16", ga);
      class xa extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2, h2, p2, d2, f2, y2) {
          const m2 = this.length;
          return this.resize(m2 + 1), this.emplace(m2, t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2, h2, p2, d2, f2, y2);
        }
        emplace(t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2, h2, p2, d2, f2, y2, m2) {
          const g2 = 16 * t2;
          return this.int16[g2 + 0] = e2, this.int16[g2 + 1] = r2, this.int16[g2 + 2] = n2, this.int16[g2 + 3] = i3, this.uint16[g2 + 4] = s3, this.uint16[g2 + 5] = a2, this.uint16[g2 + 6] = o2, this.uint16[g2 + 7] = l2, this.int16[g2 + 8] = u2, this.int16[g2 + 9] = c2, this.int16[g2 + 10] = h2, this.int16[g2 + 11] = p2, this.int16[g2 + 12] = d2, this.int16[g2 + 13] = f2, this.int16[g2 + 14] = y2, this.int16[g2 + 15] = m2, t2;
        }
      }
      xa.prototype.bytesPerElement = 32, Zi("StructArrayLayout4i4ui4i4i32", xa);
      class va extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
        }
        emplaceBack(t2) {
          const e2 = this.length;
          return this.resize(e2 + 1), this.emplace(e2, t2);
        }
        emplace(t2, e2) {
          return this.uint32[1 * t2 + 0] = e2, t2;
        }
      }
      va.prototype.bytesPerElement = 4, Zi("StructArrayLayout1ul4", va);
      class ba extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2, h2, p2) {
          const d2 = this.length;
          return this.resize(d2 + 1), this.emplace(d2, t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2, h2, p2);
        }
        emplace(t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2, h2, p2, d2) {
          const f2 = 20 * t2, y2 = 10 * t2;
          return this.int16[f2 + 0] = e2, this.int16[f2 + 1] = r2, this.int16[f2 + 2] = n2, this.int16[f2 + 3] = i3, this.int16[f2 + 4] = s3, this.float32[y2 + 3] = a2, this.float32[y2 + 4] = o2, this.float32[y2 + 5] = l2, this.float32[y2 + 6] = u2, this.int16[f2 + 14] = c2, this.uint32[y2 + 8] = h2, this.uint16[f2 + 18] = p2, this.uint16[f2 + 19] = d2, t2;
        }
      }
      ba.prototype.bytesPerElement = 40, Zi("StructArrayLayout5i4f1i1ul2ui40", ba);
      class wa extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2, r2, n2, i3, s3, a2) {
          const o2 = this.length;
          return this.resize(o2 + 1), this.emplace(o2, t2, e2, r2, n2, i3, s3, a2);
        }
        emplace(t2, e2, r2, n2, i3, s3, a2, o2) {
          const l2 = 8 * t2;
          return this.int16[l2 + 0] = e2, this.int16[l2 + 1] = r2, this.int16[l2 + 2] = n2, this.int16[l2 + 4] = i3, this.int16[l2 + 5] = s3, this.int16[l2 + 6] = a2, this.int16[l2 + 7] = o2, t2;
        }
      }
      wa.prototype.bytesPerElement = 16, Zi("StructArrayLayout3i2i2i16", wa);
      class _a extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2, r2, n2, i3) {
          const s3 = this.length;
          return this.resize(s3 + 1), this.emplace(s3, t2, e2, r2, n2, i3);
        }
        emplace(t2, e2, r2, n2, i3, s3) {
          const a2 = 4 * t2, o2 = 8 * t2;
          return this.float32[a2 + 0] = e2, this.float32[a2 + 1] = r2, this.float32[a2 + 2] = n2, this.int16[o2 + 6] = i3, this.int16[o2 + 7] = s3, t2;
        }
      }
      _a.prototype.bytesPerElement = 16, Zi("StructArrayLayout2f1f2i16", _a);
      class Aa extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2, r2, n2) {
          const i3 = this.length;
          return this.resize(i3 + 1), this.emplace(i3, t2, e2, r2, n2);
        }
        emplace(t2, e2, r2, n2, i3) {
          const s3 = 12 * t2, a2 = 3 * t2;
          return this.uint8[s3 + 0] = e2, this.uint8[s3 + 1] = r2, this.float32[a2 + 1] = n2, this.float32[a2 + 2] = i3, t2;
        }
      }
      Aa.prototype.bytesPerElement = 12, Zi("StructArrayLayout2ub2f12", Aa);
      class ka extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2, r2) {
          const n2 = this.length;
          return this.resize(n2 + 1), this.emplace(n2, t2, e2, r2);
        }
        emplace(t2, e2, r2, n2) {
          const i3 = 3 * t2;
          return this.uint16[i3 + 0] = e2, this.uint16[i3 + 1] = r2, this.uint16[i3 + 2] = n2, t2;
        }
      }
      ka.prototype.bytesPerElement = 6, Zi("StructArrayLayout3ui6", ka);
      class Sa extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2, h2, p2, d2, f2, y2, m2, g2, x3, v3, b2) {
          const w2 = this.length;
          return this.resize(w2 + 1), this.emplace(w2, t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2, h2, p2, d2, f2, y2, m2, g2, x3, v3, b2);
        }
        emplace(t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2, h2, p2, d2, f2, y2, m2, g2, x3, v3, b2, w2) {
          const _2 = 30 * t2, A3 = 15 * t2, k2 = 60 * t2;
          return this.int16[_2 + 0] = e2, this.int16[_2 + 1] = r2, this.int16[_2 + 2] = n2, this.float32[A3 + 2] = i3, this.float32[A3 + 3] = s3, this.uint16[_2 + 8] = a2, this.uint16[_2 + 9] = o2, this.uint32[A3 + 5] = l2, this.uint32[A3 + 6] = u2, this.uint32[A3 + 7] = c2, this.uint16[_2 + 16] = h2, this.uint16[_2 + 17] = p2, this.uint16[_2 + 18] = d2, this.float32[A3 + 10] = f2, this.float32[A3 + 11] = y2, this.uint8[k2 + 48] = m2, this.uint8[k2 + 49] = g2, this.uint8[k2 + 50] = x3, this.uint32[A3 + 13] = v3, this.int16[_2 + 28] = b2, this.uint8[k2 + 58] = w2, t2;
        }
      }
      Sa.prototype.bytesPerElement = 60, Zi("StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60", Sa);
      class Ia extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2, h2, p2, d2, f2, y2, m2, g2, x3, v3, b2, w2, _2, A3, k2, S3, I3, z2, M3, T2) {
          const B3 = this.length;
          return this.resize(B3 + 1), this.emplace(B3, t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2, h2, p2, d2, f2, y2, m2, g2, x3, v3, b2, w2, _2, A3, k2, S3, I3, z2, M3, T2);
        }
        emplace(t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2, h2, p2, d2, f2, y2, m2, g2, x3, v3, b2, w2, _2, A3, k2, S3, I3, z2, M3, T2, B3) {
          const C2 = 38 * t2, P2 = 19 * t2;
          return this.int16[C2 + 0] = e2, this.int16[C2 + 1] = r2, this.int16[C2 + 2] = n2, this.float32[P2 + 2] = i3, this.float32[P2 + 3] = s3, this.int16[C2 + 8] = a2, this.int16[C2 + 9] = o2, this.int16[C2 + 10] = l2, this.int16[C2 + 11] = u2, this.int16[C2 + 12] = c2, this.int16[C2 + 13] = h2, this.uint16[C2 + 14] = p2, this.uint16[C2 + 15] = d2, this.uint16[C2 + 16] = f2, this.uint16[C2 + 17] = y2, this.uint16[C2 + 18] = m2, this.uint16[C2 + 19] = g2, this.uint16[C2 + 20] = x3, this.uint16[C2 + 21] = v3, this.uint16[C2 + 22] = b2, this.uint16[C2 + 23] = w2, this.uint16[C2 + 24] = _2, this.uint16[C2 + 25] = A3, this.uint16[C2 + 26] = k2, this.uint16[C2 + 27] = S3, this.uint16[C2 + 28] = I3, this.uint32[P2 + 15] = z2, this.float32[P2 + 16] = M3, this.float32[P2 + 17] = T2, this.float32[P2 + 18] = B3, t2;
        }
      }
      Ia.prototype.bytesPerElement = 76, Zi("StructArrayLayout3i2f6i15ui1ul3f76", Ia);
      class za extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t2) {
          const e2 = this.length;
          return this.resize(e2 + 1), this.emplace(e2, t2);
        }
        emplace(t2, e2) {
          return this.float32[1 * t2 + 0] = e2, t2;
        }
      }
      za.prototype.bytesPerElement = 4, Zi("StructArrayLayout1f4", za);
      class Ma extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2, r2) {
          const n2 = this.length;
          return this.resize(n2 + 1), this.emplace(n2, t2, e2, r2);
        }
        emplace(t2, e2, r2, n2) {
          const i3 = 3 * t2;
          return this.int16[i3 + 0] = e2, this.int16[i3 + 1] = r2, this.int16[i3 + 2] = n2, t2;
        }
      }
      Ma.prototype.bytesPerElement = 6, Zi("StructArrayLayout3i6", Ma);
      class Ta extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2, r2, n2, i3, s3, a2) {
          const o2 = this.length;
          return this.resize(o2 + 1), this.emplace(o2, t2, e2, r2, n2, i3, s3, a2);
        }
        emplace(t2, e2, r2, n2, i3, s3, a2, o2) {
          const l2 = 7 * t2;
          return this.float32[l2 + 0] = e2, this.float32[l2 + 1] = r2, this.float32[l2 + 2] = n2, this.float32[l2 + 3] = i3, this.float32[l2 + 4] = s3, this.float32[l2 + 5] = a2, this.float32[l2 + 6] = o2, t2;
        }
      }
      Ta.prototype.bytesPerElement = 28, Zi("StructArrayLayout7f28", Ta);
      class Ba extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2, r2, n2) {
          const i3 = this.length;
          return this.resize(i3 + 1), this.emplace(i3, t2, e2, r2, n2);
        }
        emplace(t2, e2, r2, n2, i3) {
          const s3 = 6 * t2;
          return this.uint32[3 * t2 + 0] = e2, this.uint16[s3 + 2] = r2, this.uint16[s3 + 3] = n2, this.uint16[s3 + 4] = i3, t2;
        }
      }
      Ba.prototype.bytesPerElement = 12, Zi("StructArrayLayout1ul3ui12", Ba);
      class Ca extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2) {
          const r2 = this.length;
          return this.resize(r2 + 1), this.emplace(r2, t2, e2);
        }
        emplace(t2, e2, r2) {
          const n2 = 2 * t2;
          return this.uint16[n2 + 0] = e2, this.uint16[n2 + 1] = r2, t2;
        }
      }
      Ca.prototype.bytesPerElement = 4, Zi("StructArrayLayout2ui4", Ca);
      class Pa extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(t2) {
          const e2 = this.length;
          return this.resize(e2 + 1), this.emplace(e2, t2);
        }
        emplace(t2, e2) {
          return this.uint16[1 * t2 + 0] = e2, t2;
        }
      }
      Pa.prototype.bytesPerElement = 2, Zi("StructArrayLayout1ui2", Pa);
      class Ea extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2) {
          const r2 = this.length;
          return this.resize(r2 + 1), this.emplace(r2, t2, e2);
        }
        emplace(t2, e2, r2) {
          const n2 = 2 * t2;
          return this.float32[n2 + 0] = e2, this.float32[n2 + 1] = r2, t2;
        }
      }
      Ea.prototype.bytesPerElement = 8, Zi("StructArrayLayout2f8", Ea);
      class Da extends ua {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t2, e2, r2, n2) {
          const i3 = this.length;
          return this.resize(i3 + 1), this.emplace(i3, t2, e2, r2, n2);
        }
        emplace(t2, e2, r2, n2, i3) {
          const s3 = 4 * t2;
          return this.float32[s3 + 0] = e2, this.float32[s3 + 1] = r2, this.float32[s3 + 2] = n2, this.float32[s3 + 3] = i3, t2;
        }
      }
      Da.prototype.bytesPerElement = 16, Zi("StructArrayLayout4f16", Da);
      class Va extends la {
        get projectedAnchorX() {
          return this._structArray.int16[this._pos2 + 0];
        }
        get projectedAnchorY() {
          return this._structArray.int16[this._pos2 + 1];
        }
        get projectedAnchorZ() {
          return this._structArray.int16[this._pos2 + 2];
        }
        get tileAnchorX() {
          return this._structArray.int16[this._pos2 + 3];
        }
        get tileAnchorY() {
          return this._structArray.int16[this._pos2 + 4];
        }
        get x1() {
          return this._structArray.float32[this._pos4 + 3];
        }
        get y1() {
          return this._structArray.float32[this._pos4 + 4];
        }
        get x2() {
          return this._structArray.float32[this._pos4 + 5];
        }
        get y2() {
          return this._structArray.float32[this._pos4 + 6];
        }
        get padding() {
          return this._structArray.int16[this._pos2 + 14];
        }
        get featureIndex() {
          return this._structArray.uint32[this._pos4 + 8];
        }
        get sourceLayerIndex() {
          return this._structArray.uint16[this._pos2 + 18];
        }
        get bucketIndex() {
          return this._structArray.uint16[this._pos2 + 19];
        }
      }
      Va.prototype.size = 40;
      class Fa extends ba {
        get(t2) {
          return new Va(this, t2);
        }
      }
      Zi("CollisionBoxArray", Fa);
      class La extends la {
        get projectedAnchorX() {
          return this._structArray.int16[this._pos2 + 0];
        }
        get projectedAnchorY() {
          return this._structArray.int16[this._pos2 + 1];
        }
        get projectedAnchorZ() {
          return this._structArray.int16[this._pos2 + 2];
        }
        get tileAnchorX() {
          return this._structArray.float32[this._pos4 + 2];
        }
        get tileAnchorY() {
          return this._structArray.float32[this._pos4 + 3];
        }
        get glyphStartIndex() {
          return this._structArray.uint16[this._pos2 + 8];
        }
        get numGlyphs() {
          return this._structArray.uint16[this._pos2 + 9];
        }
        get vertexStartIndex() {
          return this._structArray.uint32[this._pos4 + 5];
        }
        get lineStartIndex() {
          return this._structArray.uint32[this._pos4 + 6];
        }
        get lineLength() {
          return this._structArray.uint32[this._pos4 + 7];
        }
        get segment() {
          return this._structArray.uint16[this._pos2 + 16];
        }
        get lowerSize() {
          return this._structArray.uint16[this._pos2 + 17];
        }
        get upperSize() {
          return this._structArray.uint16[this._pos2 + 18];
        }
        get lineOffsetX() {
          return this._structArray.float32[this._pos4 + 10];
        }
        get lineOffsetY() {
          return this._structArray.float32[this._pos4 + 11];
        }
        get writingMode() {
          return this._structArray.uint8[this._pos1 + 48];
        }
        get placedOrientation() {
          return this._structArray.uint8[this._pos1 + 49];
        }
        set placedOrientation(t2) {
          this._structArray.uint8[this._pos1 + 49] = t2;
        }
        get hidden() {
          return this._structArray.uint8[this._pos1 + 50];
        }
        set hidden(t2) {
          this._structArray.uint8[this._pos1 + 50] = t2;
        }
        get crossTileID() {
          return this._structArray.uint32[this._pos4 + 13];
        }
        set crossTileID(t2) {
          this._structArray.uint32[this._pos4 + 13] = t2;
        }
        get associatedIconIndex() {
          return this._structArray.int16[this._pos2 + 28];
        }
        get flipState() {
          return this._structArray.uint8[this._pos1 + 58];
        }
        set flipState(t2) {
          this._structArray.uint8[this._pos1 + 58] = t2;
        }
      }
      La.prototype.size = 60;
      class Ra extends Sa {
        get(t2) {
          return new La(this, t2);
        }
      }
      Zi("PlacedSymbolArray", Ra);
      class Ua extends la {
        get projectedAnchorX() {
          return this._structArray.int16[this._pos2 + 0];
        }
        get projectedAnchorY() {
          return this._structArray.int16[this._pos2 + 1];
        }
        get projectedAnchorZ() {
          return this._structArray.int16[this._pos2 + 2];
        }
        get tileAnchorX() {
          return this._structArray.float32[this._pos4 + 2];
        }
        get tileAnchorY() {
          return this._structArray.float32[this._pos4 + 3];
        }
        get rightJustifiedTextSymbolIndex() {
          return this._structArray.int16[this._pos2 + 8];
        }
        get centerJustifiedTextSymbolIndex() {
          return this._structArray.int16[this._pos2 + 9];
        }
        get leftJustifiedTextSymbolIndex() {
          return this._structArray.int16[this._pos2 + 10];
        }
        get verticalPlacedTextSymbolIndex() {
          return this._structArray.int16[this._pos2 + 11];
        }
        get placedIconSymbolIndex() {
          return this._structArray.int16[this._pos2 + 12];
        }
        get verticalPlacedIconSymbolIndex() {
          return this._structArray.int16[this._pos2 + 13];
        }
        get key() {
          return this._structArray.uint16[this._pos2 + 14];
        }
        get textBoxStartIndex() {
          return this._structArray.uint16[this._pos2 + 15];
        }
        get textBoxEndIndex() {
          return this._structArray.uint16[this._pos2 + 16];
        }
        get verticalTextBoxStartIndex() {
          return this._structArray.uint16[this._pos2 + 17];
        }
        get verticalTextBoxEndIndex() {
          return this._structArray.uint16[this._pos2 + 18];
        }
        get iconBoxStartIndex() {
          return this._structArray.uint16[this._pos2 + 19];
        }
        get iconBoxEndIndex() {
          return this._structArray.uint16[this._pos2 + 20];
        }
        get verticalIconBoxStartIndex() {
          return this._structArray.uint16[this._pos2 + 21];
        }
        get verticalIconBoxEndIndex() {
          return this._structArray.uint16[this._pos2 + 22];
        }
        get featureIndex() {
          return this._structArray.uint16[this._pos2 + 23];
        }
        get numHorizontalGlyphVertices() {
          return this._structArray.uint16[this._pos2 + 24];
        }
        get numVerticalGlyphVertices() {
          return this._structArray.uint16[this._pos2 + 25];
        }
        get numIconVertices() {
          return this._structArray.uint16[this._pos2 + 26];
        }
        get numVerticalIconVertices() {
          return this._structArray.uint16[this._pos2 + 27];
        }
        get useRuntimeCollisionCircles() {
          return this._structArray.uint16[this._pos2 + 28];
        }
        get crossTileID() {
          return this._structArray.uint32[this._pos4 + 15];
        }
        set crossTileID(t2) {
          this._structArray.uint32[this._pos4 + 15] = t2;
        }
        get textOffset0() {
          return this._structArray.float32[this._pos4 + 16];
        }
        get textOffset1() {
          return this._structArray.float32[this._pos4 + 17];
        }
        get collisionCircleDiameter() {
          return this._structArray.float32[this._pos4 + 18];
        }
      }
      Ua.prototype.size = 76;
      class $a extends Ia {
        get(t2) {
          return new Ua(this, t2);
        }
      }
      Zi("SymbolInstanceArray", $a);
      class Oa extends za {
        getoffsetX(t2) {
          return this.float32[1 * t2 + 0];
        }
      }
      Zi("GlyphOffsetArray", Oa);
      class ja extends Ma {
        getx(t2) {
          return this.int16[3 * t2 + 0];
        }
        gety(t2) {
          return this.int16[3 * t2 + 1];
        }
        gettileUnitDistanceFromAnchor(t2) {
          return this.int16[3 * t2 + 2];
        }
      }
      Zi("SymbolLineVertexArray", ja);
      class qa extends la {
        get featureIndex() {
          return this._structArray.uint32[this._pos4 + 0];
        }
        get sourceLayerIndex() {
          return this._structArray.uint16[this._pos2 + 2];
        }
        get bucketIndex() {
          return this._structArray.uint16[this._pos2 + 3];
        }
        get layoutVertexArrayOffset() {
          return this._structArray.uint16[this._pos2 + 4];
        }
      }
      qa.prototype.size = 12;
      class Na extends Ba {
        get(t2) {
          return new qa(this, t2);
        }
      }
      Zi("FeatureIndexArray", Na);
      class Ga extends la {
        get a_centroid_pos0() {
          return this._structArray.uint16[this._pos2 + 0];
        }
        get a_centroid_pos1() {
          return this._structArray.uint16[this._pos2 + 1];
        }
      }
      Ga.prototype.size = 4;
      class Za extends Ca {
        get(t2) {
          return new Ga(this, t2);
        }
      }
      Zi("FillExtrusionCentroidArray", Za);
      const Xa = ca([{ name: "a_pattern_to", components: 4, type: "Uint16" }, { name: "a_pattern_from", components: 4, type: "Uint16" }, { name: "a_pixel_ratio_to", components: 1, type: "Uint16" }, { name: "a_pixel_ratio_from", components: 1, type: "Uint16" }]), Ka = ca([{ name: "a_dash_to", components: 4, type: "Uint16" }, { name: "a_dash_from", components: 4, type: "Uint16" }]);
      var Ya = qe(function(t2) {
        t2.exports = function(t3, e2) {
          var r2, n2, i3, s3, a2, o2, l2, u2;
          for (n2 = t3.length - (r2 = 3 & t3.length), i3 = e2, a2 = 3432918353, o2 = 461845907, u2 = 0; u2 < n2; )
            l2 = 255 & t3.charCodeAt(u2) | (255 & t3.charCodeAt(++u2)) << 8 | (255 & t3.charCodeAt(++u2)) << 16 | (255 & t3.charCodeAt(++u2)) << 24, ++u2, i3 = 27492 + (65535 & (s3 = 5 * (65535 & (i3 = (i3 ^= l2 = (65535 & (l2 = (l2 = (65535 & l2) * a2 + (((l2 >>> 16) * a2 & 65535) << 16) & 4294967295) << 15 | l2 >>> 17)) * o2 + (((l2 >>> 16) * o2 & 65535) << 16) & 4294967295) << 13 | i3 >>> 19)) + ((5 * (i3 >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (s3 >>> 16) & 65535) << 16);
          switch (l2 = 0, r2) {
            case 3:
              l2 ^= (255 & t3.charCodeAt(u2 + 2)) << 16;
            case 2:
              l2 ^= (255 & t3.charCodeAt(u2 + 1)) << 8;
            case 1:
              i3 ^= l2 = (65535 & (l2 = (l2 = (65535 & (l2 ^= 255 & t3.charCodeAt(u2))) * a2 + (((l2 >>> 16) * a2 & 65535) << 16) & 4294967295) << 15 | l2 >>> 17)) * o2 + (((l2 >>> 16) * o2 & 65535) << 16) & 4294967295;
          }
          return i3 ^= t3.length, i3 = 2246822507 * (65535 & (i3 ^= i3 >>> 16)) + ((2246822507 * (i3 >>> 16) & 65535) << 16) & 4294967295, i3 = 3266489909 * (65535 & (i3 ^= i3 >>> 13)) + ((3266489909 * (i3 >>> 16) & 65535) << 16) & 4294967295, (i3 ^= i3 >>> 16) >>> 0;
        };
      }), Ha = qe(function(t2) {
        t2.exports = function(t3, e2) {
          for (var r2, n2 = t3.length, i3 = e2 ^ n2, s3 = 0; n2 >= 4; )
            r2 = 1540483477 * (65535 & (r2 = 255 & t3.charCodeAt(s3) | (255 & t3.charCodeAt(++s3)) << 8 | (255 & t3.charCodeAt(++s3)) << 16 | (255 & t3.charCodeAt(++s3)) << 24)) + ((1540483477 * (r2 >>> 16) & 65535) << 16), i3 = 1540483477 * (65535 & i3) + ((1540483477 * (i3 >>> 16) & 65535) << 16) ^ (r2 = 1540483477 * (65535 & (r2 ^= r2 >>> 24)) + ((1540483477 * (r2 >>> 16) & 65535) << 16)), n2 -= 4, ++s3;
          switch (n2) {
            case 3:
              i3 ^= (255 & t3.charCodeAt(s3 + 2)) << 16;
            case 2:
              i3 ^= (255 & t3.charCodeAt(s3 + 1)) << 8;
            case 1:
              i3 = 1540483477 * (65535 & (i3 ^= 255 & t3.charCodeAt(s3))) + ((1540483477 * (i3 >>> 16) & 65535) << 16);
          }
          return i3 = 1540483477 * (65535 & (i3 ^= i3 >>> 13)) + ((1540483477 * (i3 >>> 16) & 65535) << 16), (i3 ^= i3 >>> 15) >>> 0;
        };
      }), Ja = Ya, Wa = Ha;
      Ja.murmur3 = Ya, Ja.murmur2 = Wa;
      class Qa {
        constructor() {
          this.ids = [], this.positions = [], this.indexed = false;
        }
        add(t2, e2, r2, n2) {
          this.ids.push(to2(t2)), this.positions.push(e2, r2, n2);
        }
        getPositions(t2) {
          const e2 = to2(t2);
          let r2 = 0, n2 = this.ids.length - 1;
          for (; r2 < n2; ) {
            const t3 = r2 + n2 >> 1;
            this.ids[t3] >= e2 ? n2 = t3 : r2 = t3 + 1;
          }
          const i3 = [];
          for (; this.ids[r2] === e2; )
            i3.push({ index: this.positions[3 * r2], start: this.positions[3 * r2 + 1], end: this.positions[3 * r2 + 2] }), r2++;
          return i3;
        }
        static serialize(t2, e2) {
          const r2 = new Float64Array(t2.ids), n2 = new Uint32Array(t2.positions);
          return eo(r2, n2, 0, r2.length - 1), e2 && e2.push(r2.buffer, n2.buffer), { ids: r2, positions: n2 };
        }
        static deserialize(t2) {
          const e2 = new Qa();
          return e2.ids = t2.ids, e2.positions = t2.positions, e2.indexed = true, e2;
        }
      }
      function to2(t2) {
        const e2 = +t2;
        return !isNaN(e2) && Number.MIN_SAFE_INTEGER <= e2 && e2 <= Number.MAX_SAFE_INTEGER ? e2 : Ja(String(t2));
      }
      function eo(t2, e2, r2, n2) {
        for (; r2 < n2; ) {
          const i3 = t2[r2 + n2 >> 1];
          let s3 = r2 - 1, a2 = n2 + 1;
          for (; ; ) {
            do {
              s3++;
            } while (t2[s3] < i3);
            do {
              a2--;
            } while (t2[a2] > i3);
            if (s3 >= a2)
              break;
            ro(t2, s3, a2), ro(e2, 3 * s3, 3 * a2), ro(e2, 3 * s3 + 1, 3 * a2 + 1), ro(e2, 3 * s3 + 2, 3 * a2 + 2);
          }
          a2 - r2 < n2 - a2 ? (eo(t2, e2, r2, a2), r2 = a2 + 1) : (eo(t2, e2, a2 + 1, n2), n2 = a2);
        }
      }
      function ro(t2, e2, r2) {
        const n2 = t2[e2];
        t2[e2] = t2[r2], t2[r2] = n2;
      }
      Zi("FeaturePositionMap", Qa);
      class no {
        constructor(t2, e2) {
          this.gl = t2.gl, this.location = e2;
        }
      }
      class io extends no {
        constructor(t2, e2) {
          super(t2, e2), this.current = 0;
        }
        set(t2) {
          this.current !== t2 && (this.current = t2, this.gl.uniform1f(this.location, t2));
        }
      }
      class so extends no {
        constructor(t2, e2) {
          super(t2, e2), this.current = [0, 0, 0, 0];
        }
        set(t2) {
          t2[0] === this.current[0] && t2[1] === this.current[1] && t2[2] === this.current[2] && t2[3] === this.current[3] || (this.current = t2, this.gl.uniform4f(this.location, t2[0], t2[1], t2[2], t2[3]));
        }
      }
      class ao extends no {
        constructor(t2, e2) {
          super(t2, e2), this.current = Ge.transparent;
        }
        set(t2) {
          t2.r === this.current.r && t2.g === this.current.g && t2.b === this.current.b && t2.a === this.current.a || (this.current = t2, this.gl.uniform4f(this.location, t2.r, t2.g, t2.b, t2.a));
        }
      }
      const oo = new Float32Array(16), lo = new Float32Array(9), uo = new Float32Array(4);
      function co(t2) {
        return [aa(255 * t2.r, 255 * t2.g), aa(255 * t2.b, 255 * t2.a)];
      }
      class ho {
        constructor(t2, e2, r2) {
          this.value = t2, this.uniformNames = e2.map((t3) => `u_${t3}`), this.type = r2;
        }
        setUniform(t2, e2, r2) {
          t2.set(r2.constantOr(this.value));
        }
        getBinding(t2, e2, r2) {
          return this.type === "color" ? new ao(t2, e2) : new io(t2, e2);
        }
      }
      class po {
        constructor(t2, e2) {
          this.uniformNames = e2.map((t3) => `u_${t3}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
        }
        setConstantPatternPositions(t2, e2) {
          this.pixelRatioFrom = e2.pixelRatio, this.pixelRatioTo = t2.pixelRatio, this.patternFrom = e2.tl.concat(e2.br), this.patternTo = t2.tl.concat(t2.br);
        }
        setUniform(t2, e2, r2, n2) {
          const i3 = n2 === "u_pattern_to" || n2 === "u_dash_to" ? this.patternTo : n2 === "u_pattern_from" || n2 === "u_dash_from" ? this.patternFrom : n2 === "u_pixel_ratio_to" ? this.pixelRatioTo : n2 === "u_pixel_ratio_from" ? this.pixelRatioFrom : null;
          i3 && t2.set(i3);
        }
        getBinding(t2, e2, r2) {
          return r2 === "u_pattern_from" || r2 === "u_pattern_to" || r2 === "u_dash_from" || r2 === "u_dash_to" ? new so(t2, e2) : new io(t2, e2);
        }
      }
      class fo {
        constructor(t2, e2, r2, n2) {
          this.expression = t2, this.type = r2, this.maxValue = 0, this.paintVertexAttributes = e2.map((t3) => ({ name: `a_${t3}`, type: "Float32", components: r2 === "color" ? 2 : 1, offset: 0 })), this.paintVertexArray = new n2();
        }
        populatePaintArray(t2, e2, r2, n2, i3, s3) {
          const a2 = this.paintVertexArray.length, o2 = this.expression.evaluate(new Gs(0), e2, {}, i3, n2, s3);
          this.paintVertexArray.resize(t2), this._setPaintValue(a2, t2, o2);
        }
        updatePaintArray(t2, e2, r2, n2, i3) {
          const s3 = this.expression.evaluate({ zoom: 0 }, r2, n2, void 0, i3);
          this._setPaintValue(t2, e2, s3);
        }
        _setPaintValue(t2, e2, r2) {
          if (this.type === "color") {
            const n2 = co(r2);
            for (let r3 = t2; r3 < e2; r3++)
              this.paintVertexArray.emplace(r3, n2[0], n2[1]);
          } else {
            for (let n2 = t2; n2 < e2; n2++)
              this.paintVertexArray.emplace(n2, r2);
            this.maxValue = Math.max(this.maxValue, Math.abs(r2));
          }
        }
        upload(t2) {
          this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t2.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
        }
        destroy() {
          this.paintVertexBuffer && this.paintVertexBuffer.destroy();
        }
      }
      class yo {
        constructor(t2, e2, r2, n2, i3, s3) {
          this.expression = t2, this.uniformNames = e2.map((t3) => `u_${t3}_t`), this.type = r2, this.useIntegerZoom = n2, this.zoom = i3, this.maxValue = 0, this.paintVertexAttributes = e2.map((t3) => ({ name: `a_${t3}`, type: "Float32", components: r2 === "color" ? 4 : 2, offset: 0 })), this.paintVertexArray = new s3();
        }
        populatePaintArray(t2, e2, r2, n2, i3, s3) {
          const a2 = this.expression.evaluate(new Gs(this.zoom), e2, {}, i3, n2, s3), o2 = this.expression.evaluate(new Gs(this.zoom + 1), e2, {}, i3, n2, s3), l2 = this.paintVertexArray.length;
          this.paintVertexArray.resize(t2), this._setPaintValue(l2, t2, a2, o2);
        }
        updatePaintArray(t2, e2, r2, n2, i3) {
          const s3 = this.expression.evaluate({ zoom: this.zoom }, r2, n2, void 0, i3), a2 = this.expression.evaluate({ zoom: this.zoom + 1 }, r2, n2, void 0, i3);
          this._setPaintValue(t2, e2, s3, a2);
        }
        _setPaintValue(t2, e2, r2, n2) {
          if (this.type === "color") {
            const i3 = co(r2), s3 = co(n2);
            for (let r3 = t2; r3 < e2; r3++)
              this.paintVertexArray.emplace(r3, i3[0], i3[1], s3[0], s3[1]);
          } else {
            for (let i3 = t2; i3 < e2; i3++)
              this.paintVertexArray.emplace(i3, r2, n2);
            this.maxValue = Math.max(this.maxValue, Math.abs(r2), Math.abs(n2));
          }
        }
        upload(t2) {
          this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t2.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
        }
        destroy() {
          this.paintVertexBuffer && this.paintVertexBuffer.destroy();
        }
        setUniform(t2, e2) {
          const r2 = this.useIntegerZoom ? Math.floor(e2.zoom) : e2.zoom, n2 = Y2(this.expression.interpolationFactor(r2, this.zoom, this.zoom + 1), 0, 1);
          t2.set(n2);
        }
        getBinding(t2, e2, r2) {
          return new io(t2, e2);
        }
      }
      class mo {
        constructor(t2, e2, r2, n2, i3, s3, a2) {
          this.expression = t2, this.type = r2, this.useIntegerZoom = n2, this.zoom = i3, this.layerId = a2, this.paintVertexAttributes = (r2 === "array" ? Ka : Xa).members;
          for (let t3 = 0; t3 < e2.length; ++t3)
            ;
          this.zoomInPaintVertexArray = new s3(), this.zoomOutPaintVertexArray = new s3();
        }
        populatePaintArray(t2, e2, r2) {
          const n2 = this.zoomInPaintVertexArray.length;
          this.zoomInPaintVertexArray.resize(t2), this.zoomOutPaintVertexArray.resize(t2), this._setPaintValues(n2, t2, e2.patterns && e2.patterns[this.layerId], r2);
        }
        updatePaintArray(t2, e2, r2, n2, i3, s3) {
          this._setPaintValues(t2, e2, r2.patterns && r2.patterns[this.layerId], s3);
        }
        _setPaintValues(t2, e2, r2, n2) {
          if (!n2 || !r2)
            return;
          const { min: i3, mid: s3, max: a2 } = r2, o2 = n2[i3], l2 = n2[s3], u2 = n2[a2];
          if (o2 && l2 && u2)
            for (let r3 = t2; r3 < e2; r3++)
              this._setPaintValue(this.zoomInPaintVertexArray, r3, l2, o2), this._setPaintValue(this.zoomOutPaintVertexArray, r3, l2, u2);
        }
        _setPaintValue(t2, e2, r2, n2) {
          t2.emplace(e2, r2.tl[0], r2.tl[1], r2.br[0], r2.br[1], n2.tl[0], n2.tl[1], n2.br[0], n2.br[1], r2.pixelRatio, n2.pixelRatio);
        }
        upload(t2) {
          this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = t2.createVertexBuffer(this.zoomInPaintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = t2.createVertexBuffer(this.zoomOutPaintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
        }
        destroy() {
          this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
        }
      }
      class go {
        constructor(t2, e2, r2 = () => true) {
          this.binders = {}, this._buffers = [];
          const n2 = [];
          for (const i3 in t2.paint._values) {
            if (!r2(i3))
              continue;
            const s3 = t2.paint.get(i3);
            if (!(s3 instanceof Ws && Cn(s3.property.specification)))
              continue;
            const a2 = bo(i3, t2.type), o2 = s3.value, l2 = s3.property.specification.type, u2 = s3.property.useIntegerZoom, c2 = s3.property.specification["property-type"], h2 = c2 === "cross-faded" || c2 === "cross-faded-data-driven", p2 = String(i3) === "line-dasharray" && t2.layout.get("line-cap").value.kind !== "constant";
            if (o2.kind !== "constant" || p2)
              if (o2.kind === "source" || p2 || h2) {
                const r3 = Ao(i3, l2, "source");
                this.binders[i3] = h2 ? new mo(o2, a2, l2, u2, e2, r3, t2.id) : new fo(o2, a2, l2, r3), n2.push(`/a_${i3}`);
              } else {
                const t3 = Ao(i3, l2, "composite");
                this.binders[i3] = new yo(o2, a2, l2, u2, e2, t3), n2.push(`/z_${i3}`);
              }
            else
              this.binders[i3] = h2 ? new po(o2.value, a2) : new ho(o2.value, a2, l2), n2.push(`/u_${i3}`);
          }
          this.cacheKey = n2.sort().join("");
        }
        getMaxValue(t2) {
          const e2 = this.binders[t2];
          return e2 instanceof fo || e2 instanceof yo ? e2.maxValue : 0;
        }
        populatePaintArrays(t2, e2, r2, n2, i3, s3) {
          for (const a2 in this.binders) {
            const o2 = this.binders[a2];
            (o2 instanceof fo || o2 instanceof yo || o2 instanceof mo) && o2.populatePaintArray(t2, e2, r2, n2, i3, s3);
          }
        }
        setConstantPatternPositions(t2, e2) {
          for (const r2 in this.binders) {
            const n2 = this.binders[r2];
            n2 instanceof po && n2.setConstantPatternPositions(t2, e2);
          }
        }
        updatePaintArrays(t2, e2, r2, n2, i3, s3) {
          let a2 = false;
          for (const o2 in t2) {
            const l2 = e2.getPositions(o2);
            for (const e3 of l2) {
              const l3 = r2.feature(e3.index);
              for (const r3 in this.binders) {
                const u2 = this.binders[r3];
                if ((u2 instanceof fo || u2 instanceof yo || u2 instanceof mo) && u2.expression.isStateDependent === true) {
                  const c2 = n2.paint.get(r3);
                  u2.expression = c2.value, u2.updatePaintArray(e3.start, e3.end, l3, t2[o2], i3, s3), a2 = true;
                }
              }
            }
          }
          return a2;
        }
        defines() {
          const t2 = [];
          for (const e2 in this.binders) {
            const r2 = this.binders[e2];
            (r2 instanceof ho || r2 instanceof po) && t2.push(...r2.uniformNames.map((t3) => `#define HAS_UNIFORM_${t3}`));
          }
          return t2;
        }
        getBinderAttributes() {
          const t2 = [];
          for (const e2 in this.binders) {
            const r2 = this.binders[e2];
            if (r2 instanceof fo || r2 instanceof yo || r2 instanceof mo)
              for (let e3 = 0; e3 < r2.paintVertexAttributes.length; e3++)
                t2.push(r2.paintVertexAttributes[e3].name);
          }
          return t2;
        }
        getBinderUniforms() {
          const t2 = [];
          for (const e2 in this.binders) {
            const r2 = this.binders[e2];
            if (r2 instanceof ho || r2 instanceof po || r2 instanceof yo)
              for (const e3 of r2.uniformNames)
                t2.push(e3);
          }
          return t2;
        }
        getPaintVertexBuffers() {
          return this._buffers;
        }
        getUniforms(t2, e2) {
          const r2 = [];
          for (const n2 in this.binders) {
            const i3 = this.binders[n2];
            if (i3 instanceof ho || i3 instanceof po || i3 instanceof yo) {
              for (const s3 of i3.uniformNames)
                if (e2[s3]) {
                  const a2 = i3.getBinding(t2, e2[s3], s3);
                  r2.push({ name: s3, property: n2, binding: a2 });
                }
            }
          }
          return r2;
        }
        setUniforms(t2, e2, r2, n2) {
          for (const { name: t3, property: i3, binding: s3 } of e2)
            this.binders[i3].setUniform(s3, n2, r2.get(i3), t3);
        }
        updatePaintBuffers(t2) {
          this._buffers = [];
          for (const e2 in this.binders) {
            const r2 = this.binders[e2];
            if (t2 && r2 instanceof mo) {
              const e3 = t2.fromScale === 2 ? r2.zoomInPaintVertexBuffer : r2.zoomOutPaintVertexBuffer;
              e3 && this._buffers.push(e3);
            } else
              (r2 instanceof fo || r2 instanceof yo) && r2.paintVertexBuffer && this._buffers.push(r2.paintVertexBuffer);
          }
        }
        upload(t2) {
          for (const e2 in this.binders) {
            const r2 = this.binders[e2];
            (r2 instanceof fo || r2 instanceof yo || r2 instanceof mo) && r2.upload(t2);
          }
          this.updatePaintBuffers();
        }
        destroy() {
          for (const t2 in this.binders) {
            const e2 = this.binders[t2];
            (e2 instanceof fo || e2 instanceof yo || e2 instanceof mo) && e2.destroy();
          }
        }
      }
      class xo {
        constructor(t2, e2, r2 = () => true) {
          this.programConfigurations = {};
          for (const n2 of t2)
            this.programConfigurations[n2.id] = new go(n2, e2, r2);
          this.needsUpload = false, this._featureMap = new Qa(), this._bufferOffset = 0;
        }
        populatePaintArrays(t2, e2, r2, n2, i3, s3, a2) {
          for (const r3 in this.programConfigurations)
            this.programConfigurations[r3].populatePaintArrays(t2, e2, n2, i3, s3, a2);
          e2.id !== void 0 && this._featureMap.add(e2.id, r2, this._bufferOffset, t2), this._bufferOffset = t2, this.needsUpload = true;
        }
        updatePaintArrays(t2, e2, r2, n2, i3) {
          for (const s3 of r2)
            this.needsUpload = this.programConfigurations[s3.id].updatePaintArrays(t2, this._featureMap, e2, s3, n2, i3) || this.needsUpload;
        }
        get(t2) {
          return this.programConfigurations[t2];
        }
        upload(t2) {
          if (this.needsUpload) {
            for (const e2 in this.programConfigurations)
              this.programConfigurations[e2].upload(t2);
            this.needsUpload = false;
          }
        }
        destroy() {
          for (const t2 in this.programConfigurations)
            this.programConfigurations[t2].destroy();
        }
      }
      const vo = { "text-opacity": ["opacity"], "icon-opacity": ["opacity"], "text-color": ["fill_color"], "icon-color": ["fill_color"], "text-halo-color": ["halo_color"], "icon-halo-color": ["halo_color"], "text-halo-blur": ["halo_blur"], "icon-halo-blur": ["halo_blur"], "text-halo-width": ["halo_width"], "icon-halo-width": ["halo_width"], "line-gap-width": ["gapwidth"], "line-pattern": ["pattern_to", "pattern_from", "pixel_ratio_to", "pixel_ratio_from"], "fill-pattern": ["pattern_to", "pattern_from", "pixel_ratio_to", "pixel_ratio_from"], "fill-extrusion-pattern": ["pattern_to", "pattern_from", "pixel_ratio_to", "pixel_ratio_from"], "line-dasharray": ["dash_to", "dash_from"] };
      function bo(t2, e2) {
        return vo[t2] || [t2.replace(`${e2}-`, "").replace(/-/g, "_")];
      }
      const wo = { "line-pattern": { source: ma, composite: ma }, "fill-pattern": { source: ma, composite: ma }, "fill-extrusion-pattern": { source: ma, composite: ma }, "line-dasharray": { source: ga, composite: ga } }, _o = { color: { source: Ea, composite: Da }, number: { source: za, composite: Ea } };
      function Ao(t2, e2, r2) {
        const n2 = wo[t2];
        return n2 && n2[r2] || _o[e2][r2];
      }
      Zi("ConstantBinder", ho), Zi("CrossFadedConstantBinder", po), Zi("SourceExpressionBinder", fo), Zi("CrossFadedCompositeBinder", mo), Zi("CompositeExpressionBinder", yo), Zi("ProgramConfiguration", go, { omit: ["_buffers"] }), Zi("ProgramConfigurationSet", xo);
      const ko = "-transition";
      class So extends xe {
        constructor(t2, e2) {
          if (super(), this.id = t2.id, this.type = t2.type, this._featureFilter = { filter: () => true, needGeometry: false, needFeature: false }, this._filterCompiled = false, t2.type !== "custom" && (this.metadata = (t2 = t2).metadata, this.minzoom = t2.minzoom, this.maxzoom = t2.maxzoom, t2.type !== "background" && t2.type !== "sky" && (this.source = t2.source, this.sourceLayer = t2["source-layer"], this.filter = t2.filter), e2.layout && (this._unevaluatedLayout = new Js(e2.layout)), e2.paint)) {
            this._transitionablePaint = new Ks(e2.paint);
            for (const e3 in t2.paint)
              this.setPaintProperty(e3, t2.paint[e3], { validate: false });
            for (const e3 in t2.layout)
              this.setLayoutProperty(e3, t2.layout[e3], { validate: false });
            this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new Qs(e2.paint);
          }
        }
        getCrossfadeParameters() {
          return this._crossfadeParameters;
        }
        getLayoutProperty(t2) {
          return t2 === "visibility" ? this.visibility : this._unevaluatedLayout.getValue(t2);
        }
        setLayoutProperty(t2, e2, r2 = {}) {
          e2 != null && this._validate(Ui, `layers.${this.id}.layout.${t2}`, t2, e2, r2) || (t2 !== "visibility" ? this._unevaluatedLayout.setValue(t2, e2) : this.visibility = e2);
        }
        getPaintProperty(t2) {
          return ot(t2, ko) ? this._transitionablePaint.getTransition(t2.slice(0, -ko.length)) : this._transitionablePaint.getValue(t2);
        }
        setPaintProperty(t2, e2, r2 = {}) {
          if (e2 != null && this._validate(Ri, `layers.${this.id}.paint.${t2}`, t2, e2, r2))
            return false;
          if (ot(t2, ko))
            return this._transitionablePaint.setTransition(t2.slice(0, -ko.length), e2 || void 0), false;
          {
            const r3 = this._transitionablePaint._values[t2], n2 = r3.property.specification["property-type"] === "cross-faded-data-driven", i3 = r3.value.isDataDriven(), s3 = r3.value;
            this._transitionablePaint.setValue(t2, e2), this._handleSpecialPaintPropertyUpdate(t2);
            const a2 = this._transitionablePaint._values[t2].value;
            return a2.isDataDriven() || i3 || n2 || this._handleOverridablePaintPropertyUpdate(t2, s3, a2);
          }
        }
        _handleSpecialPaintPropertyUpdate(t2) {
        }
        getProgramIds() {
          return null;
        }
        getProgramConfiguration(t2) {
          return null;
        }
        _handleOverridablePaintPropertyUpdate(t2, e2, r2) {
          return false;
        }
        isHidden(t2) {
          return !!(this.minzoom && t2 < this.minzoom) || !!(this.maxzoom && t2 >= this.maxzoom) || this.visibility === "none";
        }
        updateTransitions(t2) {
          this._transitioningPaint = this._transitionablePaint.transitioned(t2, this._transitioningPaint);
        }
        hasTransition() {
          return this._transitioningPaint.hasTransition();
        }
        recalculate(t2, e2) {
          t2.getCrossfadeParameters && (this._crossfadeParameters = t2.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t2, void 0, e2)), this.paint = this._transitioningPaint.possiblyEvaluate(t2, void 0, e2);
        }
        serialize() {
          const t2 = { id: this.id, type: this.type, source: this.source, "source-layer": this.sourceLayer, metadata: this.metadata, minzoom: this.minzoom, maxzoom: this.maxzoom, filter: this.filter, layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(), paint: this._transitionablePaint && this._transitionablePaint.serialize() };
          return this.visibility && (t2.layout = t2.layout || {}, t2.layout.visibility = this.visibility), ut(t2, (t3, e2) => !(t3 === void 0 || e2 === "layout" && !Object.keys(t3).length || e2 === "paint" && !Object.keys(t3).length));
        }
        _validate(t2, e2, r2, n2, i3 = {}) {
          return (!i3 || i3.validate !== false) && $i(this, t2.call(Vi, { key: e2, layerType: this.type, objectKey: r2, value: n2, styleSpec: ve, style: { glyphs: true, sprite: true } }));
        }
        is3D() {
          return false;
        }
        isSky() {
          return false;
        }
        isTileClipped() {
          return false;
        }
        hasOffscreenPass() {
          return false;
        }
        resize() {
        }
        isStateDependent() {
          for (const t2 in this.paint._values) {
            const e2 = this.paint.get(t2);
            if (e2 instanceof Ws && Cn(e2.property.specification) && (e2.value.kind === "source" || e2.value.kind === "composite") && e2.value.isStateDependent)
              return true;
          }
          return false;
        }
        compileFilter() {
          this._filterCompiled || (this._featureFilter = si(this.filter), this._filterCompiled = true);
        }
        invalidateCompiledFilter() {
          this._filterCompiled = false;
        }
        dynamicFilter() {
          return this._featureFilter.dynamicFilter;
        }
        dynamicFilterNeedsFeature() {
          return this._featureFilter.needFeature;
        }
      }
      const Io = ca([{ name: "a_pos", components: 2, type: "Int16" }], 4), { members: zo } = Io;
      class Mo {
        constructor(t2 = []) {
          this.segments = t2;
        }
        prepareSegment(t2, e2, r2, n2) {
          let i3 = this.segments[this.segments.length - 1];
          return t2 > Mo.MAX_VERTEX_ARRAY_LENGTH && pt(`Max vertices per segment is ${Mo.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t2}`), (!i3 || i3.vertexLength + t2 > Mo.MAX_VERTEX_ARRAY_LENGTH || i3.sortKey !== n2) && (i3 = { vertexOffset: e2.length, primitiveOffset: r2.length, vertexLength: 0, primitiveLength: 0 }, n2 !== void 0 && (i3.sortKey = n2), this.segments.push(i3)), i3;
        }
        get() {
          return this.segments;
        }
        destroy() {
          for (const t2 of this.segments)
            for (const e2 in t2.vaos)
              t2.vaos[e2].destroy();
        }
        static simpleSegment(t2, e2, r2, n2) {
          return new Mo([{ vertexOffset: t2, primitiveOffset: e2, vertexLength: r2, primitiveLength: n2, vaos: {}, sortKey: 0 }]);
        }
      }
      Mo.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Zi("SegmentVector", Mo);
      var To = 8192;
      class Bo {
        constructor(t2, e2) {
          t2 && (e2 ? this.setSouthWest(t2).setNorthEast(e2) : t2.length === 4 ? this.setSouthWest([t2[0], t2[1]]).setNorthEast([t2[2], t2[3]]) : this.setSouthWest(t2[0]).setNorthEast(t2[1]));
        }
        setNorthEast(t2) {
          return this._ne = t2 instanceof Po ? new Po(t2.lng, t2.lat) : Po.convert(t2), this;
        }
        setSouthWest(t2) {
          return this._sw = t2 instanceof Po ? new Po(t2.lng, t2.lat) : Po.convert(t2), this;
        }
        extend(t2) {
          const e2 = this._sw, r2 = this._ne;
          let n2, i3;
          if (t2 instanceof Po)
            n2 = t2, i3 = t2;
          else {
            if (!(t2 instanceof Bo))
              return Array.isArray(t2) ? t2.length === 4 || t2.every(Array.isArray) ? this.extend(Bo.convert(t2)) : this.extend(Po.convert(t2)) : this;
            if (n2 = t2._sw, i3 = t2._ne, !n2 || !i3)
              return this;
          }
          return e2 || r2 ? (e2.lng = Math.min(n2.lng, e2.lng), e2.lat = Math.min(n2.lat, e2.lat), r2.lng = Math.max(i3.lng, r2.lng), r2.lat = Math.max(i3.lat, r2.lat)) : (this._sw = new Po(n2.lng, n2.lat), this._ne = new Po(i3.lng, i3.lat)), this;
        }
        getCenter() {
          return new Po((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
        }
        getSouthWest() {
          return this._sw;
        }
        getNorthEast() {
          return this._ne;
        }
        getNorthWest() {
          return new Po(this.getWest(), this.getNorth());
        }
        getSouthEast() {
          return new Po(this.getEast(), this.getSouth());
        }
        getWest() {
          return this._sw.lng;
        }
        getSouth() {
          return this._sw.lat;
        }
        getEast() {
          return this._ne.lng;
        }
        getNorth() {
          return this._ne.lat;
        }
        toArray() {
          return [this._sw.toArray(), this._ne.toArray()];
        }
        toString() {
          return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
        }
        isEmpty() {
          return !(this._sw && this._ne);
        }
        contains(t2) {
          const { lng: e2, lat: r2 } = Po.convert(t2);
          let n2 = this._sw.lng <= e2 && e2 <= this._ne.lng;
          return this._sw.lng > this._ne.lng && (n2 = this._sw.lng >= e2 && e2 >= this._ne.lng), this._sw.lat <= r2 && r2 <= this._ne.lat && n2;
        }
        static convert(t2) {
          return !t2 || t2 instanceof Bo ? t2 : new Bo(t2);
        }
      }
      const Co = 63710088e-1;
      class Po {
        constructor(t2, e2) {
          if (isNaN(t2) || isNaN(e2))
            throw new Error(`Invalid LngLat object: (${t2}, ${e2})`);
          if (this.lng = +t2, this.lat = +e2, this.lat > 90 || this.lat < -90)
            throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
        }
        wrap() {
          return new Po(J(this.lng, -180, 180), this.lat);
        }
        toArray() {
          return [this.lng, this.lat];
        }
        toString() {
          return `LngLat(${this.lng}, ${this.lat})`;
        }
        distanceTo(t2) {
          const e2 = Math.PI / 180, r2 = this.lat * e2, n2 = t2.lat * e2, i3 = Math.sin(r2) * Math.sin(n2) + Math.cos(r2) * Math.cos(n2) * Math.cos((t2.lng - this.lng) * e2);
          return Co * Math.acos(Math.min(i3, 1));
        }
        toBounds(t2 = 0) {
          const e2 = 360 * t2 / 40075017, r2 = e2 / Math.cos(Math.PI / 180 * this.lat);
          return new Bo(new Po(this.lng - r2, this.lat - e2), new Po(this.lng + r2, this.lat + e2));
        }
        static convert(t2) {
          if (t2 instanceof Po)
            return t2;
          if (Array.isArray(t2) && (t2.length === 2 || t2.length === 3))
            return new Po(Number(t2[0]), Number(t2[1]));
          if (!Array.isArray(t2) && typeof t2 == "object" && t2 !== null)
            return new Po(Number("lng" in t2 ? t2.lng : t2.lon), Number(t2.lat));
          throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
        }
      }
      const Eo = 2 * Math.PI * Co;
      function Do(t2) {
        return Eo * Math.cos(t2 * Math.PI / 180);
      }
      function Vo(t2) {
        return (180 + t2) / 360;
      }
      function Fo(t2) {
        return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t2 * Math.PI / 360))) / 360;
      }
      function Lo(t2, e2) {
        return t2 / Do(e2);
      }
      function Ro(t2) {
        return 360 * t2 - 180;
      }
      function Uo(t2) {
        return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t2) * Math.PI / 180)) - 90;
      }
      function $o(t2, e2) {
        return t2 * Do(Uo(e2));
      }
      const Oo = 85.051129;
      class jo {
        constructor(t2, e2, r2 = 0) {
          this.x = +t2, this.y = +e2, this.z = +r2;
        }
        static fromLngLat(t2, e2 = 0) {
          const r2 = Po.convert(t2);
          return new jo(Vo(r2.lng), Fo(r2.lat), Lo(e2, r2.lat));
        }
        toLngLat() {
          return new Po(Ro(this.x), Uo(this.y));
        }
        toAltitude() {
          return $o(this.z, this.y);
        }
        meterInMercatorCoordinateUnits() {
          return 1 / Eo * (t2 = Uo(this.y), 1 / Math.cos(t2 * Math.PI / 180));
          var t2;
        }
      }
      function qo(t2, e2, r2, n2, s3, a2, o2, l2, u2) {
        const c2 = (e2 + n2) / 2, h2 = (r2 + s3) / 2, p2 = new i2(c2, h2);
        l2(p2), function(t3, e3, r3, n3, i3, s4) {
          const a3 = r3 - i3, o3 = n3 - s4;
          return Math.abs((n3 - e3) * a3 - (r3 - t3) * o3) / Math.hypot(a3, o3);
        }(p2.x, p2.y, a2.x, a2.y, o2.x, o2.y) >= u2 ? (qo(t2, e2, r2, c2, h2, a2, p2, l2, u2), qo(t2, c2, h2, n2, s3, p2, o2, l2, u2)) : t2.push(o2);
      }
      function No(t2, e2, r2) {
        const n2 = [];
        let i3, s3, a2;
        for (const o2 of t2) {
          const { x: t3, y: l2 } = o2;
          e2(o2), a2 ? qo(n2, i3, s3, t3, l2, a2, o2, e2, r2) : n2.push(o2), i3 = t3, s3 = l2, a2 = o2;
        }
        return n2;
      }
      const Go = Math.pow(2, 14) - 1, Zo = -Go - 1;
      function Xo(t2, e2) {
        const r2 = Math.round(t2.x * e2), n2 = Math.round(t2.y * e2);
        return t2.x = Y2(r2, Zo, Go), t2.y = Y2(n2, Zo, Go), (r2 < t2.x || r2 > t2.x + 1 || n2 < t2.y || n2 > t2.y + 1) && pt("Geometry exceeds allowed extent, reduce your vector tile buffer size"), t2;
      }
      function Ko(t2, e2, r2) {
        const n2 = t2.loadGeometry(), i3 = t2.extent, s3 = To / i3;
        if (e2 && r2 && r2.projection.isReprojectedInTileSpace) {
          const s4 = 1 << e2.z, { scale: a2, x: o2, y: l2, projection: u2 } = r2, c2 = (t3) => {
            const r3 = Ro((e2.x + t3.x / i3) / s4), n3 = Uo((e2.y + t3.y / i3) / s4), c3 = u2.project(r3, n3);
            t3.x = (c3.x * a2 - o2) * i3, t3.y = (c3.y * a2 - l2) * i3;
          };
          for (let e3 = 0; e3 < n2.length; e3++)
            if (t2.type !== 1)
              n2[e3] = No(n2[e3], c2, 1);
            else {
              const t3 = [];
              for (const r3 of n2[e3])
                r3.x < 0 || r3.x >= i3 || r3.y < 0 || r3.y >= i3 || (c2(r3), t3.push(r3));
              n2[e3] = t3;
            }
        }
        for (const t3 of n2)
          for (const e3 of t3)
            Xo(e3, s3);
        return n2;
      }
      function Yo(t2, e2) {
        return { type: t2.type, id: t2.id, properties: t2.properties, geometry: e2 ? Ko(t2) : [] };
      }
      function Ho(t2, e2, r2, n2, i3) {
        t2.emplaceBack(2 * e2 + (n2 + 1) / 2, 2 * r2 + (i3 + 1) / 2);
      }
      class Jo {
        constructor(t2) {
          this.zoom = t2.zoom, this.overscaling = t2.overscaling, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.id), this.index = t2.index, this.hasPattern = false, this.layoutVertexArray = new pa(), this.indexArray = new ka(), this.segments = new Mo(), this.programConfigurations = new xo(t2.layers, t2.zoom), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id);
        }
        populate(t2, e2, r2, n2) {
          const i3 = this.layers[0], s3 = [];
          let a2 = null;
          i3.type === "circle" && (a2 = i3.layout.get("circle-sort-key"));
          for (const { feature: e3, id: i4, index: o2, sourceLayerIndex: l2 } of t2) {
            const t3 = this.layers[0]._featureFilter.needGeometry, u2 = Yo(e3, t3);
            if (!this.layers[0]._featureFilter.filter(new Gs(this.zoom), u2, r2))
              continue;
            const c2 = a2 ? a2.evaluate(u2, {}, r2) : void 0, h2 = { id: i4, properties: e3.properties, type: e3.type, sourceLayerIndex: l2, index: o2, geometry: t3 ? u2.geometry : Ko(e3, r2, n2), patterns: {}, sortKey: c2 };
            s3.push(h2);
          }
          a2 && s3.sort((t3, e3) => t3.sortKey - e3.sortKey);
          for (const n3 of s3) {
            const { geometry: i4, index: s4, sourceLayerIndex: a3 } = n3, o2 = t2[s4].feature;
            this.addFeature(n3, i4, s4, e2.availableImages, r2), e2.featureIndex.insert(o2, i4, s4, a3, this.index);
          }
        }
        update(t2, e2, r2, n2) {
          this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t2, e2, this.stateDependentLayers, r2, n2);
        }
        isEmpty() {
          return this.layoutVertexArray.length === 0;
        }
        uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload;
        }
        upload(t2) {
          this.uploaded || (this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, zo), this.indexBuffer = t2.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t2), this.uploaded = true;
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
        }
        addFeature(t2, e2, r2, n2, i3) {
          for (const r3 of e2)
            for (const e3 of r3) {
              const r4 = e3.x, n3 = e3.y;
              if (r4 < 0 || r4 >= To || n3 < 0 || n3 >= To)
                continue;
              const i4 = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t2.sortKey), s3 = i4.vertexLength;
              Ho(this.layoutVertexArray, r4, n3, -1, -1), Ho(this.layoutVertexArray, r4, n3, 1, -1), Ho(this.layoutVertexArray, r4, n3, 1, 1), Ho(this.layoutVertexArray, r4, n3, -1, 1), this.indexArray.emplaceBack(s3, s3 + 1, s3 + 2), this.indexArray.emplaceBack(s3, s3 + 3, s3 + 2), i4.vertexLength += 4, i4.primitiveLength += 2;
            }
          this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t2, r2, {}, n2, i3);
        }
      }
      function Wo(t2, e2) {
        for (let r2 = 0; r2 < t2.length; r2++)
          if (ol(e2, t2[r2]))
            return true;
        for (let r2 = 0; r2 < e2.length; r2++)
          if (ol(t2, e2[r2]))
            return true;
        return !!rl(t2, e2);
      }
      function Qo(t2, e2, r2) {
        return !!ol(t2, e2) || !!il(e2, t2, r2);
      }
      function tl(t2, e2) {
        if (t2.length === 1)
          return al(e2, t2[0]);
        for (let r2 = 0; r2 < e2.length; r2++) {
          const n2 = e2[r2];
          for (let e3 = 0; e3 < n2.length; e3++)
            if (ol(t2, n2[e3]))
              return true;
        }
        for (let r2 = 0; r2 < t2.length; r2++)
          if (al(e2, t2[r2]))
            return true;
        for (let r2 = 0; r2 < e2.length; r2++)
          if (rl(t2, e2[r2]))
            return true;
        return false;
      }
      function el(t2, e2, r2) {
        if (t2.length > 1) {
          if (rl(t2, e2))
            return true;
          for (let n2 = 0; n2 < e2.length; n2++)
            if (il(e2[n2], t2, r2))
              return true;
        }
        for (let n2 = 0; n2 < t2.length; n2++)
          if (il(t2[n2], e2, r2))
            return true;
        return false;
      }
      function rl(t2, e2) {
        if (t2.length === 0 || e2.length === 0)
          return false;
        for (let r2 = 0; r2 < t2.length - 1; r2++) {
          const n2 = t2[r2], i3 = t2[r2 + 1];
          for (let t3 = 0; t3 < e2.length - 1; t3++)
            if (nl(n2, i3, e2[t3], e2[t3 + 1]))
              return true;
        }
        return false;
      }
      function nl(t2, e2, r2, n2) {
        return dt(t2, r2, n2) !== dt(e2, r2, n2) && dt(t2, e2, r2) !== dt(t2, e2, n2);
      }
      function il(t2, e2, r2) {
        const n2 = r2 * r2;
        if (e2.length === 1)
          return t2.distSqr(e2[0]) < n2;
        for (let r3 = 1; r3 < e2.length; r3++)
          if (sl(t2, e2[r3 - 1], e2[r3]) < n2)
            return true;
        return false;
      }
      function sl(t2, e2, r2) {
        const n2 = e2.distSqr(r2);
        if (n2 === 0)
          return t2.distSqr(e2);
        const i3 = ((t2.x - e2.x) * (r2.x - e2.x) + (t2.y - e2.y) * (r2.y - e2.y)) / n2;
        return t2.distSqr(i3 < 0 ? e2 : i3 > 1 ? r2 : r2.sub(e2)._mult(i3)._add(e2));
      }
      function al(t2, e2) {
        let r2, n2, i3, s3 = false;
        for (let a2 = 0; a2 < t2.length; a2++) {
          r2 = t2[a2];
          for (let t3 = 0, a3 = r2.length - 1; t3 < r2.length; a3 = t3++)
            n2 = r2[t3], i3 = r2[a3], n2.y > e2.y != i3.y > e2.y && e2.x < (i3.x - n2.x) * (e2.y - n2.y) / (i3.y - n2.y) + n2.x && (s3 = !s3);
        }
        return s3;
      }
      function ol(t2, e2) {
        let r2 = false;
        for (let n2 = 0, i3 = t2.length - 1; n2 < t2.length; i3 = n2++) {
          const s3 = t2[n2], a2 = t2[i3];
          s3.y > e2.y != a2.y > e2.y && e2.x < (a2.x - s3.x) * (e2.y - s3.y) / (a2.y - s3.y) + s3.x && (r2 = !r2);
        }
        return r2;
      }
      function ll(t2, e2, r2, n2, s3) {
        for (const i3 of t2)
          if (e2 <= i3.x && r2 <= i3.y && n2 >= i3.x && s3 >= i3.y)
            return true;
        const a2 = [new i2(e2, r2), new i2(e2, s3), new i2(n2, s3), new i2(n2, r2)];
        if (t2.length > 2) {
          for (const e3 of a2)
            if (ol(t2, e3))
              return true;
        }
        for (let e3 = 0; e3 < t2.length - 1; e3++)
          if (ul(t2[e3], t2[e3 + 1], a2))
            return true;
        return false;
      }
      function ul(t2, e2, r2) {
        const n2 = r2[0], i3 = r2[2];
        if (t2.x < n2.x && e2.x < n2.x || t2.x > i3.x && e2.x > i3.x || t2.y < n2.y && e2.y < n2.y || t2.y > i3.y && e2.y > i3.y)
          return false;
        const s3 = dt(t2, e2, r2[0]);
        return s3 !== dt(t2, e2, r2[1]) || s3 !== dt(t2, e2, r2[2]) || s3 !== dt(t2, e2, r2[3]);
      }
      function cl(t2, e2, r2) {
        const n2 = e2.paint.get(t2).value;
        return n2.kind === "constant" ? n2.value : r2.programConfigurations.get(e2.id).getMaxValue(t2);
      }
      function hl(t2) {
        return Math.sqrt(t2[0] * t2[0] + t2[1] * t2[1]);
      }
      function pl(t2, e2, r2, n2, s3) {
        if (!e2[0] && !e2[1])
          return t2;
        const a2 = i2.convert(e2)._mult(s3);
        r2 === "viewport" && a2._rotate(-n2);
        const o2 = [];
        for (let e3 = 0; e3 < t2.length; e3++)
          o2.push(t2[e3].sub(a2));
        return o2;
      }
      function dl(t2, e2, r2, n2) {
        const s3 = i2.convert(t2)._mult(n2);
        return e2 === "viewport" && s3._rotate(-r2), s3;
      }
      Zi("CircleBucket", Jo, { omit: ["layers"] });
      const fl = new sa({ "circle-sort-key": new ea(ve.layout_circle["circle-sort-key"]) });
      var yl = { paint: new sa({ "circle-radius": new ea(ve.paint_circle["circle-radius"]), "circle-color": new ea(ve.paint_circle["circle-color"]), "circle-blur": new ea(ve.paint_circle["circle-blur"]), "circle-opacity": new ea(ve.paint_circle["circle-opacity"]), "circle-translate": new ta(ve.paint_circle["circle-translate"]), "circle-translate-anchor": new ta(ve.paint_circle["circle-translate-anchor"]), "circle-pitch-scale": new ta(ve.paint_circle["circle-pitch-scale"]), "circle-pitch-alignment": new ta(ve.paint_circle["circle-pitch-alignment"]), "circle-stroke-width": new ea(ve.paint_circle["circle-stroke-width"]), "circle-stroke-color": new ea(ve.paint_circle["circle-stroke-color"]), "circle-stroke-opacity": new ea(ve.paint_circle["circle-stroke-opacity"]) }), layout: fl };
      class ml {
        constructor(t2, e2) {
          this.points = t2, this.planes = e2;
        }
        static fromInvProjectionMatrix(t2, e2, r2, n2) {
          const i3 = Math.pow(2, r2), s3 = [[-1, 1, -1, 1], [1, 1, -1, 1], [1, -1, -1, 1], [-1, -1, -1, 1], [-1, 1, 1, 1], [1, 1, 1, 1], [1, -1, 1, 1], [-1, -1, 1, 1]].map((r3) => {
            const s4 = F([], r3, t2), a3 = 1 / s4[3] / e2 * i3;
            return function(t3, e3, r4) {
              return t3[0] = e3[0] * r4[0], t3[1] = e3[1] * r4[1], t3[2] = e3[2] * r4[2], t3[3] = e3[3] * r4[3], t3;
            }(s4, s4, [a3, a3, n2 ? 1 / s4[3] : a3, a3]);
          }), a2 = [[0, 1, 2], [6, 5, 4], [0, 3, 7], [2, 1, 5], [3, 2, 6], [0, 4, 5]].map((t3) => {
            const e3 = z([], T([], E([], s3[t3[0]], s3[t3[1]]), E([], s3[t3[2]], s3[t3[1]]))), r3 = -M2(e3, s3[t3[1]]);
            return e3.concat(r3);
          });
          return new ml(s3, a2);
        }
      }
      class gl {
        constructor(t2, e2) {
          this.min = t2, this.max = e2, this.center = S2([], w([], this.min, this.max), 0.5);
        }
        quadrant(t2) {
          const e2 = [t2 % 2 == 0, t2 < 2], r2 = x2(this.min), n2 = x2(this.max);
          for (let t3 = 0; t3 < e2.length; t3++)
            r2[t3] = e2[t3] ? this.min[t3] : this.center[t3], n2[t3] = e2[t3] ? this.center[t3] : this.max[t3];
          return n2[2] = this.max[2], new gl(r2, n2);
        }
        distanceX(t2) {
          return Math.max(Math.min(this.max[0], t2[0]), this.min[0]) - t2[0];
        }
        distanceY(t2) {
          return Math.max(Math.min(this.max[1], t2[1]), this.min[1]) - t2[1];
        }
        distanceZ(t2) {
          return Math.max(Math.min(this.max[2], t2[2]), this.min[2]) - t2[2];
        }
        getCorners() {
          const t2 = this.min, e2 = this.max;
          return [[t2[0], t2[1], t2[2]], [e2[0], t2[1], t2[2]], [e2[0], e2[1], t2[2]], [t2[0], e2[1], t2[2]], [t2[0], t2[1], e2[2]], [e2[0], t2[1], e2[2]], [e2[0], e2[1], e2[2]], [t2[0], e2[1], e2[2]]];
        }
        intersects(t2) {
          const e2 = this.getCorners();
          let r2 = true;
          for (let n2 = 0; n2 < t2.planes.length; n2++) {
            const i3 = t2.planes[n2];
            let s3 = 0;
            for (let t3 = 0; t3 < e2.length; t3++)
              s3 += M2(i3, e2[t3]) + i3[3] >= 0;
            if (s3 === 0)
              return 0;
            s3 !== e2.length && (r2 = false);
          }
          if (r2)
            return 2;
          for (let e3 = 0; e3 < 3; e3++) {
            let r3 = Number.MAX_VALUE, n2 = -Number.MAX_VALUE;
            for (let i3 = 0; i3 < t2.points.length; i3++) {
              const s3 = t2.points[i3][e3] - this.min[e3];
              r3 = Math.min(r3, s3), n2 = Math.max(n2, s3);
            }
            if (n2 < 0 || r3 > this.max[e3] - this.min[e3])
              return 0;
          }
          return 1;
        }
      }
      function xl(t2, e2, r2, n2, i3, s3, a2, o2, l2) {
        if (s3 && t2.queryGeometry.isAboveHorizon)
          return false;
        s3 && (l2 *= t2.pixelToTileUnitsFactor);
        for (const u2 of e2)
          for (const e3 of u2) {
            const u3 = e3.add(o2), c2 = i3 && r2.elevation ? r2.elevation.exaggeration() * i3.getElevationAt(u3.x, u3.y, true) : 0, h2 = s3 ? u3 : vl(u3, c2, n2), p2 = s3 ? t2.tilespaceRays.map((t3) => _l(t3, c2)) : t2.queryGeometry.screenGeometry, d2 = F([], [e3.x, e3.y, c2, 1], n2);
            if (!a2 && s3 ? l2 *= d2[3] / r2.cameraToCenterDistance : a2 && !s3 && (l2 *= r2.cameraToCenterDistance / d2[3]), Qo(p2, h2, l2))
              return true;
          }
        return false;
      }
      function vl(t2, e2, r2) {
        const n2 = F([], [t2.x, t2.y, e2, 1], r2);
        return new i2(n2[0] / n2[3], n2[1] / n2[3]);
      }
      const bl = b(0, 0, 0), wl = b(0, 0, 1);
      function _l(t2, e2) {
        const r2 = g();
        return bl[2] = e2, t2.intersectsPlane(bl, wl, r2), new i2(r2[0], r2[1]);
      }
      class Al extends Jo {
      }
      function kl(t2, { width: e2, height: r2 }, n2, i3) {
        if (i3) {
          if (i3 instanceof Uint8ClampedArray)
            i3 = new Uint8Array(i3.buffer);
          else if (i3.length !== e2 * r2 * n2)
            throw new RangeError("mismatched image size");
        } else
          i3 = new Uint8Array(e2 * r2 * n2);
        return t2.width = e2, t2.height = r2, t2.data = i3, t2;
      }
      function Sl(t2, { width: e2, height: r2 }, n2) {
        if (e2 === t2.width && r2 === t2.height)
          return;
        const i3 = kl({}, { width: e2, height: r2 }, n2);
        Il(t2, i3, { x: 0, y: 0 }, { x: 0, y: 0 }, { width: Math.min(t2.width, e2), height: Math.min(t2.height, r2) }, n2), t2.width = e2, t2.height = r2, t2.data = i3.data;
      }
      function Il(t2, e2, r2, n2, i3, s3) {
        if (i3.width === 0 || i3.height === 0)
          return e2;
        if (i3.width > t2.width || i3.height > t2.height || r2.x > t2.width - i3.width || r2.y > t2.height - i3.height)
          throw new RangeError("out of range source coordinates for image copy");
        if (i3.width > e2.width || i3.height > e2.height || n2.x > e2.width - i3.width || n2.y > e2.height - i3.height)
          throw new RangeError("out of range destination coordinates for image copy");
        const a2 = t2.data, o2 = e2.data;
        for (let l2 = 0; l2 < i3.height; l2++) {
          const u2 = ((r2.y + l2) * t2.width + r2.x) * s3, c2 = ((n2.y + l2) * e2.width + n2.x) * s3;
          for (let t3 = 0; t3 < i3.width * s3; t3++)
            o2[c2 + t3] = a2[u2 + t3];
        }
        return e2;
      }
      Zi("HeatmapBucket", Al, { omit: ["layers"] });
      class zl {
        constructor(t2, e2) {
          kl(this, t2, 1, e2);
        }
        resize(t2) {
          Sl(this, t2, 1);
        }
        clone() {
          return new zl({ width: this.width, height: this.height }, new Uint8Array(this.data));
        }
        static copy(t2, e2, r2, n2, i3) {
          Il(t2, e2, r2, n2, i3, 1);
        }
      }
      class Ml {
        constructor(t2, e2) {
          kl(this, t2, 4, e2);
        }
        resize(t2) {
          Sl(this, t2, 4);
        }
        replace(t2, e2) {
          e2 ? this.data.set(t2) : this.data = t2 instanceof Uint8ClampedArray ? new Uint8Array(t2.buffer) : t2;
        }
        clone() {
          return new Ml({ width: this.width, height: this.height }, new Uint8Array(this.data));
        }
        static copy(t2, e2, r2, n2, i3) {
          Il(t2, e2, r2, n2, i3, 4);
        }
      }
      Zi("AlphaImage", zl), Zi("RGBAImage", Ml);
      var Tl = { paint: new sa({ "heatmap-radius": new ea(ve.paint_heatmap["heatmap-radius"]), "heatmap-weight": new ea(ve.paint_heatmap["heatmap-weight"]), "heatmap-intensity": new ta(ve.paint_heatmap["heatmap-intensity"]), "heatmap-color": new ia(ve.paint_heatmap["heatmap-color"]), "heatmap-opacity": new ta(ve.paint_heatmap["heatmap-opacity"]) }) };
      function Bl(t2) {
        const e2 = {}, r2 = t2.resolution || 256, n2 = t2.clips ? t2.clips.length : 1, i3 = t2.image || new Ml({ width: r2, height: n2 }), s3 = (r3, n3, s4) => {
          e2[t2.evaluationKey] = s4;
          const a2 = t2.expression.evaluate(e2);
          i3.data[r3 + n3 + 0] = Math.floor(255 * a2.r / a2.a), i3.data[r3 + n3 + 1] = Math.floor(255 * a2.g / a2.a), i3.data[r3 + n3 + 2] = Math.floor(255 * a2.b / a2.a), i3.data[r3 + n3 + 3] = Math.floor(255 * a2.a);
        };
        if (t2.clips)
          for (let e3 = 0, i4 = 0; e3 < n2; ++e3, i4 += 4 * r2)
            for (let n3 = 0, a2 = 0; n3 < r2; n3++, a2 += 4) {
              const o2 = n3 / (r2 - 1), { start: l2, end: u2 } = t2.clips[e3];
              s3(i4, a2, l2 * (1 - o2) + u2 * o2);
            }
        else
          for (let t3 = 0, e3 = 0; t3 < r2; t3++, e3 += 4)
            s3(0, e3, t3 / (r2 - 1));
        return i3;
      }
      var Cl = { paint: new sa({ "hillshade-illumination-direction": new ta(ve.paint_hillshade["hillshade-illumination-direction"]), "hillshade-illumination-anchor": new ta(ve.paint_hillshade["hillshade-illumination-anchor"]), "hillshade-exaggeration": new ta(ve.paint_hillshade["hillshade-exaggeration"]), "hillshade-shadow-color": new ta(ve.paint_hillshade["hillshade-shadow-color"]), "hillshade-highlight-color": new ta(ve.paint_hillshade["hillshade-highlight-color"]), "hillshade-accent-color": new ta(ve.paint_hillshade["hillshade-accent-color"]) }) };
      const Pl = ca([{ name: "a_pos", components: 2, type: "Int16" }], 4), { members: El } = Pl;
      var Dl = Fl, Vl = Fl;
      function Fl(t2, e2, r2) {
        r2 = r2 || 2;
        var n2, i3, s3, a2, o2, l2, u2, c2 = e2 && e2.length, h2 = c2 ? e2[0] * r2 : t2.length, p2 = Ll(t2, 0, h2, r2, true), d2 = [];
        if (!p2 || p2.next === p2.prev)
          return d2;
        if (c2 && (p2 = function(t3, e3, r3, n3) {
          var i4, s4, a3, o3 = [];
          for (i4 = 0, s4 = e3.length; i4 < s4; i4++)
            (a3 = Ll(t3, e3[i4] * n3, i4 < s4 - 1 ? e3[i4 + 1] * n3 : t3.length, n3, false)) === a3.next && (a3.steiner = true), o3.push(Kl(a3));
          for (o3.sort(Nl), i4 = 0; i4 < o3.length; i4++)
            r3 = Rl(r3 = Gl(o3[i4], r3), r3.next);
          return r3;
        }(t2, e2, p2, r2)), t2.length > 80 * r2) {
          n2 = s3 = t2[0], i3 = a2 = t2[1];
          for (var f2 = r2; f2 < h2; f2 += r2)
            (o2 = t2[f2]) < n2 && (n2 = o2), (l2 = t2[f2 + 1]) < i3 && (i3 = l2), o2 > s3 && (s3 = o2), l2 > a2 && (a2 = l2);
          u2 = (u2 = Math.max(s3 - n2, a2 - i3)) !== 0 ? 1 / u2 : 0;
        }
        return Ul(p2, d2, r2, n2, i3, u2), d2;
      }
      function Ll(t2, e2, r2, n2, i3) {
        var s3, a2;
        if (i3 === ou(t2, e2, r2, n2) > 0)
          for (s3 = e2; s3 < r2; s3 += n2)
            a2 = iu(s3, t2[s3], t2[s3 + 1], a2);
        else
          for (s3 = r2 - n2; s3 >= e2; s3 -= n2)
            a2 = iu(s3, t2[s3], t2[s3 + 1], a2);
        return a2 && Wl(a2, a2.next) && (su(a2), a2 = a2.next), a2;
      }
      function Rl(t2, e2) {
        if (!t2)
          return t2;
        e2 || (e2 = t2);
        var r2, n2 = t2;
        do {
          if (r2 = false, n2.steiner || !Wl(n2, n2.next) && Jl(n2.prev, n2, n2.next) !== 0)
            n2 = n2.next;
          else {
            if (su(n2), (n2 = e2 = n2.prev) === n2.next)
              break;
            r2 = true;
          }
        } while (r2 || n2 !== e2);
        return e2;
      }
      function Ul(t2, e2, r2, n2, i3, s3, a2) {
        if (t2) {
          !a2 && s3 && function(t3, e3, r3, n3) {
            var i4 = t3;
            do {
              i4.z === null && (i4.z = Xl(i4.x, i4.y, e3, r3, n3)), i4.prevZ = i4.prev, i4.nextZ = i4.next, i4 = i4.next;
            } while (i4 !== t3);
            i4.prevZ.nextZ = null, i4.prevZ = null, function(t4) {
              var e4, r4, n4, i5, s4, a3, o3, l3, u3 = 1;
              do {
                for (r4 = t4, t4 = null, s4 = null, a3 = 0; r4; ) {
                  for (a3++, n4 = r4, o3 = 0, e4 = 0; e4 < u3 && (o3++, n4 = n4.nextZ); e4++)
                    ;
                  for (l3 = u3; o3 > 0 || l3 > 0 && n4; )
                    o3 !== 0 && (l3 === 0 || !n4 || r4.z <= n4.z) ? (i5 = r4, r4 = r4.nextZ, o3--) : (i5 = n4, n4 = n4.nextZ, l3--), s4 ? s4.nextZ = i5 : t4 = i5, i5.prevZ = s4, s4 = i5;
                  r4 = n4;
                }
                s4.nextZ = null, u3 *= 2;
              } while (a3 > 1);
            }(i4);
          }(t2, n2, i3, s3);
          for (var o2, l2, u2 = t2; t2.prev !== t2.next; )
            if (o2 = t2.prev, l2 = t2.next, s3 ? Ol(t2, n2, i3, s3) : $l(t2))
              e2.push(o2.i / r2), e2.push(t2.i / r2), e2.push(l2.i / r2), su(t2), t2 = l2.next, u2 = l2.next;
            else if ((t2 = l2) === u2) {
              a2 ? a2 === 1 ? Ul(t2 = jl(Rl(t2), e2, r2), e2, r2, n2, i3, s3, 2) : a2 === 2 && ql(t2, e2, r2, n2, i3, s3) : Ul(Rl(t2), e2, r2, n2, i3, s3, 1);
              break;
            }
        }
      }
      function $l(t2) {
        var e2 = t2.prev, r2 = t2, n2 = t2.next;
        if (Jl(e2, r2, n2) >= 0)
          return false;
        for (var i3 = t2.next.next; i3 !== t2.prev; ) {
          if (Yl(e2.x, e2.y, r2.x, r2.y, n2.x, n2.y, i3.x, i3.y) && Jl(i3.prev, i3, i3.next) >= 0)
            return false;
          i3 = i3.next;
        }
        return true;
      }
      function Ol(t2, e2, r2, n2) {
        var i3 = t2.prev, s3 = t2, a2 = t2.next;
        if (Jl(i3, s3, a2) >= 0)
          return false;
        for (var o2 = i3.x > s3.x ? i3.x > a2.x ? i3.x : a2.x : s3.x > a2.x ? s3.x : a2.x, l2 = i3.y > s3.y ? i3.y > a2.y ? i3.y : a2.y : s3.y > a2.y ? s3.y : a2.y, u2 = Xl(i3.x < s3.x ? i3.x < a2.x ? i3.x : a2.x : s3.x < a2.x ? s3.x : a2.x, i3.y < s3.y ? i3.y < a2.y ? i3.y : a2.y : s3.y < a2.y ? s3.y : a2.y, e2, r2, n2), c2 = Xl(o2, l2, e2, r2, n2), h2 = t2.prevZ, p2 = t2.nextZ; h2 && h2.z >= u2 && p2 && p2.z <= c2; ) {
          if (h2 !== t2.prev && h2 !== t2.next && Yl(i3.x, i3.y, s3.x, s3.y, a2.x, a2.y, h2.x, h2.y) && Jl(h2.prev, h2, h2.next) >= 0)
            return false;
          if (h2 = h2.prevZ, p2 !== t2.prev && p2 !== t2.next && Yl(i3.x, i3.y, s3.x, s3.y, a2.x, a2.y, p2.x, p2.y) && Jl(p2.prev, p2, p2.next) >= 0)
            return false;
          p2 = p2.nextZ;
        }
        for (; h2 && h2.z >= u2; ) {
          if (h2 !== t2.prev && h2 !== t2.next && Yl(i3.x, i3.y, s3.x, s3.y, a2.x, a2.y, h2.x, h2.y) && Jl(h2.prev, h2, h2.next) >= 0)
            return false;
          h2 = h2.prevZ;
        }
        for (; p2 && p2.z <= c2; ) {
          if (p2 !== t2.prev && p2 !== t2.next && Yl(i3.x, i3.y, s3.x, s3.y, a2.x, a2.y, p2.x, p2.y) && Jl(p2.prev, p2, p2.next) >= 0)
            return false;
          p2 = p2.nextZ;
        }
        return true;
      }
      function jl(t2, e2, r2) {
        var n2 = t2;
        do {
          var i3 = n2.prev, s3 = n2.next.next;
          !Wl(i3, s3) && Ql(i3, n2, n2.next, s3) && ru(i3, s3) && ru(s3, i3) && (e2.push(i3.i / r2), e2.push(n2.i / r2), e2.push(s3.i / r2), su(n2), su(n2.next), n2 = t2 = s3), n2 = n2.next;
        } while (n2 !== t2);
        return Rl(n2);
      }
      function ql(t2, e2, r2, n2, i3, s3) {
        var a2 = t2;
        do {
          for (var o2 = a2.next.next; o2 !== a2.prev; ) {
            if (a2.i !== o2.i && Hl(a2, o2)) {
              var l2 = nu(a2, o2);
              return a2 = Rl(a2, a2.next), l2 = Rl(l2, l2.next), Ul(a2, e2, r2, n2, i3, s3), void Ul(l2, e2, r2, n2, i3, s3);
            }
            o2 = o2.next;
          }
          a2 = a2.next;
        } while (a2 !== t2);
      }
      function Nl(t2, e2) {
        return t2.x - e2.x;
      }
      function Gl(t2, e2) {
        var r2 = function(t3, e3) {
          var r3, n3 = e3, i4 = t3.x, s3 = t3.y, a2 = -1 / 0;
          do {
            if (s3 <= n3.y && s3 >= n3.next.y && n3.next.y !== n3.y) {
              var o2 = n3.x + (s3 - n3.y) * (n3.next.x - n3.x) / (n3.next.y - n3.y);
              if (o2 <= i4 && o2 > a2) {
                if (a2 = o2, o2 === i4) {
                  if (s3 === n3.y)
                    return n3;
                  if (s3 === n3.next.y)
                    return n3.next;
                }
                r3 = n3.x < n3.next.x ? n3 : n3.next;
              }
            }
            n3 = n3.next;
          } while (n3 !== e3);
          if (!r3)
            return null;
          if (i4 === a2)
            return r3;
          var l2, u2 = r3, c2 = r3.x, h2 = r3.y, p2 = 1 / 0;
          n3 = r3;
          do {
            i4 >= n3.x && n3.x >= c2 && i4 !== n3.x && Yl(s3 < h2 ? i4 : a2, s3, c2, h2, s3 < h2 ? a2 : i4, s3, n3.x, n3.y) && (l2 = Math.abs(s3 - n3.y) / (i4 - n3.x), ru(n3, t3) && (l2 < p2 || l2 === p2 && (n3.x > r3.x || n3.x === r3.x && Zl(r3, n3))) && (r3 = n3, p2 = l2)), n3 = n3.next;
          } while (n3 !== u2);
          return r3;
        }(t2, e2);
        if (!r2)
          return e2;
        var n2 = nu(r2, t2), i3 = Rl(r2, r2.next);
        return Rl(n2, n2.next), e2 === r2 ? i3 : e2;
      }
      function Zl(t2, e2) {
        return Jl(t2.prev, t2, e2.prev) < 0 && Jl(e2.next, t2, t2.next) < 0;
      }
      function Xl(t2, e2, r2, n2, i3) {
        return (t2 = 1431655765 & ((t2 = 858993459 & ((t2 = 252645135 & ((t2 = 16711935 & ((t2 = 32767 * (t2 - r2) * i3) | t2 << 8)) | t2 << 4)) | t2 << 2)) | t2 << 1)) | (e2 = 1431655765 & ((e2 = 858993459 & ((e2 = 252645135 & ((e2 = 16711935 & ((e2 = 32767 * (e2 - n2) * i3) | e2 << 8)) | e2 << 4)) | e2 << 2)) | e2 << 1)) << 1;
      }
      function Kl(t2) {
        var e2 = t2, r2 = t2;
        do {
          (e2.x < r2.x || e2.x === r2.x && e2.y < r2.y) && (r2 = e2), e2 = e2.next;
        } while (e2 !== t2);
        return r2;
      }
      function Yl(t2, e2, r2, n2, i3, s3, a2, o2) {
        return (i3 - a2) * (e2 - o2) - (t2 - a2) * (s3 - o2) >= 0 && (t2 - a2) * (n2 - o2) - (r2 - a2) * (e2 - o2) >= 0 && (r2 - a2) * (s3 - o2) - (i3 - a2) * (n2 - o2) >= 0;
      }
      function Hl(t2, e2) {
        return t2.next.i !== e2.i && t2.prev.i !== e2.i && !function(t3, e3) {
          var r2 = t3;
          do {
            if (r2.i !== t3.i && r2.next.i !== t3.i && r2.i !== e3.i && r2.next.i !== e3.i && Ql(r2, r2.next, t3, e3))
              return true;
            r2 = r2.next;
          } while (r2 !== t3);
          return false;
        }(t2, e2) && (ru(t2, e2) && ru(e2, t2) && function(t3, e3) {
          var r2 = t3, n2 = false, i3 = (t3.x + e3.x) / 2, s3 = (t3.y + e3.y) / 2;
          do {
            r2.y > s3 != r2.next.y > s3 && r2.next.y !== r2.y && i3 < (r2.next.x - r2.x) * (s3 - r2.y) / (r2.next.y - r2.y) + r2.x && (n2 = !n2), r2 = r2.next;
          } while (r2 !== t3);
          return n2;
        }(t2, e2) && (Jl(t2.prev, t2, e2.prev) || Jl(t2, e2.prev, e2)) || Wl(t2, e2) && Jl(t2.prev, t2, t2.next) > 0 && Jl(e2.prev, e2, e2.next) > 0);
      }
      function Jl(t2, e2, r2) {
        return (e2.y - t2.y) * (r2.x - e2.x) - (e2.x - t2.x) * (r2.y - e2.y);
      }
      function Wl(t2, e2) {
        return t2.x === e2.x && t2.y === e2.y;
      }
      function Ql(t2, e2, r2, n2) {
        var i3 = eu(Jl(t2, e2, r2)), s3 = eu(Jl(t2, e2, n2)), a2 = eu(Jl(r2, n2, t2)), o2 = eu(Jl(r2, n2, e2));
        return i3 !== s3 && a2 !== o2 || !(i3 !== 0 || !tu(t2, r2, e2)) || !(s3 !== 0 || !tu(t2, n2, e2)) || !(a2 !== 0 || !tu(r2, t2, n2)) || !(o2 !== 0 || !tu(r2, e2, n2));
      }
      function tu(t2, e2, r2) {
        return e2.x <= Math.max(t2.x, r2.x) && e2.x >= Math.min(t2.x, r2.x) && e2.y <= Math.max(t2.y, r2.y) && e2.y >= Math.min(t2.y, r2.y);
      }
      function eu(t2) {
        return t2 > 0 ? 1 : t2 < 0 ? -1 : 0;
      }
      function ru(t2, e2) {
        return Jl(t2.prev, t2, t2.next) < 0 ? Jl(t2, e2, t2.next) >= 0 && Jl(t2, t2.prev, e2) >= 0 : Jl(t2, e2, t2.prev) < 0 || Jl(t2, t2.next, e2) < 0;
      }
      function nu(t2, e2) {
        var r2 = new au(t2.i, t2.x, t2.y), n2 = new au(e2.i, e2.x, e2.y), i3 = t2.next, s3 = e2.prev;
        return t2.next = e2, e2.prev = t2, r2.next = i3, i3.prev = r2, n2.next = r2, r2.prev = n2, s3.next = n2, n2.prev = s3, n2;
      }
      function iu(t2, e2, r2, n2) {
        var i3 = new au(t2, e2, r2);
        return n2 ? (i3.next = n2.next, i3.prev = n2, n2.next.prev = i3, n2.next = i3) : (i3.prev = i3, i3.next = i3), i3;
      }
      function su(t2) {
        t2.next.prev = t2.prev, t2.prev.next = t2.next, t2.prevZ && (t2.prevZ.nextZ = t2.nextZ), t2.nextZ && (t2.nextZ.prevZ = t2.prevZ);
      }
      function au(t2, e2, r2) {
        this.i = t2, this.x = e2, this.y = r2, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = false;
      }
      function ou(t2, e2, r2, n2) {
        for (var i3 = 0, s3 = e2, a2 = r2 - n2; s3 < r2; s3 += n2)
          i3 += (t2[a2] - t2[s3]) * (t2[s3 + 1] + t2[a2 + 1]), a2 = s3;
        return i3;
      }
      function lu(t2, e2, r2, n2, i3) {
        uu(t2, e2, r2 || 0, n2 || t2.length - 1, i3 || hu);
      }
      function uu(t2, e2, r2, n2, i3) {
        for (; n2 > r2; ) {
          if (n2 - r2 > 600) {
            var s3 = n2 - r2 + 1, a2 = e2 - r2 + 1, o2 = Math.log(s3), l2 = 0.5 * Math.exp(2 * o2 / 3), u2 = 0.5 * Math.sqrt(o2 * l2 * (s3 - l2) / s3) * (a2 - s3 / 2 < 0 ? -1 : 1);
            uu(t2, e2, Math.max(r2, Math.floor(e2 - a2 * l2 / s3 + u2)), Math.min(n2, Math.floor(e2 + (s3 - a2) * l2 / s3 + u2)), i3);
          }
          var c2 = t2[e2], h2 = r2, p2 = n2;
          for (cu(t2, r2, e2), i3(t2[n2], c2) > 0 && cu(t2, r2, n2); h2 < p2; ) {
            for (cu(t2, h2, p2), h2++, p2--; i3(t2[h2], c2) < 0; )
              h2++;
            for (; i3(t2[p2], c2) > 0; )
              p2--;
          }
          i3(t2[r2], c2) === 0 ? cu(t2, r2, p2) : cu(t2, ++p2, n2), p2 <= e2 && (r2 = p2 + 1), e2 <= p2 && (n2 = p2 - 1);
        }
      }
      function cu(t2, e2, r2) {
        var n2 = t2[e2];
        t2[e2] = t2[r2], t2[r2] = n2;
      }
      function hu(t2, e2) {
        return t2 < e2 ? -1 : t2 > e2 ? 1 : 0;
      }
      function pu(t2, e2) {
        const r2 = t2.length;
        if (r2 <= 1)
          return [t2];
        const n2 = [];
        let i3, s3;
        for (let e3 = 0; e3 < r2; e3++) {
          const r3 = ft(t2[e3]);
          r3 !== 0 && (t2[e3].area = Math.abs(r3), s3 === void 0 && (s3 = r3 < 0), s3 === r3 < 0 ? (i3 && n2.push(i3), i3 = [t2[e3]]) : i3.push(t2[e3]));
        }
        if (i3 && n2.push(i3), e2 > 1)
          for (let t3 = 0; t3 < n2.length; t3++)
            n2[t3].length <= e2 || (lu(n2[t3], e2, 1, n2[t3].length - 1, du), n2[t3] = n2[t3].slice(0, e2));
        return n2;
      }
      function du(t2, e2) {
        return e2.area - t2.area;
      }
      function fu(t2, e2, r2) {
        const n2 = r2.patternDependencies;
        let i3 = false;
        for (const r3 of e2) {
          const e3 = r3.paint.get(`${t2}-pattern`);
          e3.isConstant() || (i3 = true);
          const s3 = e3.constantOr(null);
          s3 && (i3 = true, n2[s3.to] = true, n2[s3.from] = true);
        }
        return i3;
      }
      function yu(t2, e2, r2, n2, i3) {
        const s3 = i3.patternDependencies;
        for (const a2 of e2) {
          const e3 = a2.paint.get(`${t2}-pattern`).value;
          if (e3.kind !== "constant") {
            let t3 = e3.evaluate({ zoom: n2 - 1 }, r2, {}, i3.availableImages), o2 = e3.evaluate({ zoom: n2 }, r2, {}, i3.availableImages), l2 = e3.evaluate({ zoom: n2 + 1 }, r2, {}, i3.availableImages);
            t3 = t3 && t3.name ? t3.name : t3, o2 = o2 && o2.name ? o2.name : o2, l2 = l2 && l2.name ? l2.name : l2, s3[t3] = true, s3[o2] = true, s3[l2] = true, r2.patterns[a2.id] = { min: t3, mid: o2, max: l2 };
          }
        }
        return r2;
      }
      Fl.deviation = function(t2, e2, r2, n2) {
        var i3 = e2 && e2.length, s3 = Math.abs(ou(t2, 0, i3 ? e2[0] * r2 : t2.length, r2));
        if (i3)
          for (var a2 = 0, o2 = e2.length; a2 < o2; a2++)
            s3 -= Math.abs(ou(t2, e2[a2] * r2, a2 < o2 - 1 ? e2[a2 + 1] * r2 : t2.length, r2));
        var l2 = 0;
        for (a2 = 0; a2 < n2.length; a2 += 3) {
          var u2 = n2[a2] * r2, c2 = n2[a2 + 1] * r2, h2 = n2[a2 + 2] * r2;
          l2 += Math.abs((t2[u2] - t2[h2]) * (t2[c2 + 1] - t2[u2 + 1]) - (t2[u2] - t2[c2]) * (t2[h2 + 1] - t2[u2 + 1]));
        }
        return s3 === 0 && l2 === 0 ? 0 : Math.abs((l2 - s3) / s3);
      }, Fl.flatten = function(t2) {
        for (var e2 = t2[0][0].length, r2 = { vertices: [], holes: [], dimensions: e2 }, n2 = 0, i3 = 0; i3 < t2.length; i3++) {
          for (var s3 = 0; s3 < t2[i3].length; s3++)
            for (var a2 = 0; a2 < e2; a2++)
              r2.vertices.push(t2[i3][s3][a2]);
          i3 > 0 && r2.holes.push(n2 += t2[i3 - 1].length);
        }
        return r2;
      }, Dl.default = Vl;
      class mu {
        constructor(t2) {
          this.zoom = t2.zoom, this.overscaling = t2.overscaling, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.id), this.index = t2.index, this.hasPattern = false, this.patternFeatures = [], this.layoutVertexArray = new pa(), this.indexArray = new ka(), this.indexArray2 = new Ca(), this.programConfigurations = new xo(t2.layers, t2.zoom), this.segments = new Mo(), this.segments2 = new Mo(), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id);
        }
        populate(t2, e2, r2, n2) {
          this.hasPattern = fu("fill", this.layers, e2);
          const i3 = this.layers[0].layout.get("fill-sort-key"), s3 = [];
          for (const { feature: a2, id: o2, index: l2, sourceLayerIndex: u2 } of t2) {
            const t3 = this.layers[0]._featureFilter.needGeometry, c2 = Yo(a2, t3);
            if (!this.layers[0]._featureFilter.filter(new Gs(this.zoom), c2, r2))
              continue;
            const h2 = i3 ? i3.evaluate(c2, {}, r2, e2.availableImages) : void 0, p2 = { id: o2, properties: a2.properties, type: a2.type, sourceLayerIndex: u2, index: l2, geometry: t3 ? c2.geometry : Ko(a2, r2, n2), patterns: {}, sortKey: h2 };
            s3.push(p2);
          }
          i3 && s3.sort((t3, e3) => t3.sortKey - e3.sortKey);
          for (const n3 of s3) {
            const { geometry: i4, index: s4, sourceLayerIndex: a2 } = n3;
            if (this.hasPattern) {
              const t3 = yu("fill", this.layers, n3, this.zoom, e2);
              this.patternFeatures.push(t3);
            } else
              this.addFeature(n3, i4, s4, r2, {}, e2.availableImages);
            e2.featureIndex.insert(t2[s4].feature, i4, s4, a2, this.index);
          }
        }
        update(t2, e2, r2, n2) {
          this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t2, e2, this.stateDependentLayers, r2, n2);
        }
        addFeatures(t2, e2, r2, n2) {
          for (const t3 of this.patternFeatures)
            this.addFeature(t3, t3.geometry, t3.index, e2, r2, n2);
        }
        isEmpty() {
          return this.layoutVertexArray.length === 0;
        }
        uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload;
        }
        upload(t2) {
          this.uploaded || (this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, El), this.indexBuffer = t2.createIndexBuffer(this.indexArray), this.indexBuffer2 = t2.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t2), this.uploaded = true;
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
        }
        addFeature(t2, e2, r2, n2, i3, s3 = []) {
          for (const t3 of pu(e2, 500)) {
            let e3 = 0;
            for (const r4 of t3)
              e3 += r4.length;
            const r3 = this.segments.prepareSegment(e3, this.layoutVertexArray, this.indexArray), n3 = r3.vertexLength, i4 = [], s4 = [];
            for (const e4 of t3) {
              if (e4.length === 0)
                continue;
              e4 !== t3[0] && s4.push(i4.length / 2);
              const r4 = this.segments2.prepareSegment(e4.length, this.layoutVertexArray, this.indexArray2), n4 = r4.vertexLength;
              this.layoutVertexArray.emplaceBack(e4[0].x, e4[0].y), this.indexArray2.emplaceBack(n4 + e4.length - 1, n4), i4.push(e4[0].x), i4.push(e4[0].y);
              for (let t4 = 1; t4 < e4.length; t4++)
                this.layoutVertexArray.emplaceBack(e4[t4].x, e4[t4].y), this.indexArray2.emplaceBack(n4 + t4 - 1, n4 + t4), i4.push(e4[t4].x), i4.push(e4[t4].y);
              r4.vertexLength += e4.length, r4.primitiveLength += e4.length;
            }
            const a2 = Dl(i4, s4);
            for (let t4 = 0; t4 < a2.length; t4 += 3)
              this.indexArray.emplaceBack(n3 + a2[t4], n3 + a2[t4 + 1], n3 + a2[t4 + 2]);
            r3.vertexLength += e3, r3.primitiveLength += a2.length / 3;
          }
          this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t2, r2, i3, s3, n2);
        }
      }
      Zi("FillBucket", mu, { omit: ["layers", "patternFeatures"] });
      const gu = new sa({ "fill-sort-key": new ea(ve.layout_fill["fill-sort-key"]) });
      var xu = { paint: new sa({ "fill-antialias": new ta(ve.paint_fill["fill-antialias"]), "fill-opacity": new ea(ve.paint_fill["fill-opacity"]), "fill-color": new ea(ve.paint_fill["fill-color"]), "fill-outline-color": new ea(ve.paint_fill["fill-outline-color"]), "fill-translate": new ta(ve.paint_fill["fill-translate"]), "fill-translate-anchor": new ta(ve.paint_fill["fill-translate-anchor"]), "fill-pattern": new ra(ve.paint_fill["fill-pattern"]) }), layout: gu };
      const vu = ca([{ name: "a_pos_normal_ed", components: 4, type: "Int16" }]), bu = ca([{ name: "a_centroid_pos", components: 2, type: "Uint16" }]), { members: wu } = vu;
      var _u = Au;
      function Au(t2, e2, r2, n2, i3) {
        this.properties = {}, this.extent = r2, this.type = 0, this._pbf = t2, this._geometry = -1, this._keys = n2, this._values = i3, t2.readFields(ku, this, e2);
      }
      function ku(t2, e2, r2) {
        t2 == 1 ? e2.id = r2.readVarint() : t2 == 2 ? function(t3, e3) {
          for (var r3 = t3.readVarint() + t3.pos; t3.pos < r3; ) {
            var n2 = e3._keys[t3.readVarint()], i3 = e3._values[t3.readVarint()];
            e3.properties[n2] = i3;
          }
        }(r2, e2) : t2 == 3 ? e2.type = r2.readVarint() : t2 == 4 && (e2._geometry = r2.pos);
      }
      function Su(t2) {
        for (var e2, r2, n2 = 0, i3 = 0, s3 = t2.length, a2 = s3 - 1; i3 < s3; a2 = i3++)
          n2 += ((r2 = t2[a2]).x - (e2 = t2[i3]).x) * (e2.y + r2.y);
        return n2;
      }
      Au.types = ["Unknown", "Point", "LineString", "Polygon"], Au.prototype.loadGeometry = function() {
        var t2 = this._pbf;
        t2.pos = this._geometry;
        for (var e2, r2 = t2.readVarint() + t2.pos, n2 = 1, s3 = 0, a2 = 0, o2 = 0, l2 = []; t2.pos < r2; ) {
          if (s3 <= 0) {
            var u2 = t2.readVarint();
            n2 = 7 & u2, s3 = u2 >> 3;
          }
          if (s3--, n2 === 1 || n2 === 2)
            a2 += t2.readSVarint(), o2 += t2.readSVarint(), n2 === 1 && (e2 && l2.push(e2), e2 = []), e2.push(new i2(a2, o2));
          else {
            if (n2 !== 7)
              throw new Error("unknown command " + n2);
            e2 && e2.push(e2[0].clone());
          }
        }
        return e2 && l2.push(e2), l2;
      }, Au.prototype.bbox = function() {
        var t2 = this._pbf;
        t2.pos = this._geometry;
        for (var e2 = t2.readVarint() + t2.pos, r2 = 1, n2 = 0, i3 = 0, s3 = 0, a2 = 1 / 0, o2 = -1 / 0, l2 = 1 / 0, u2 = -1 / 0; t2.pos < e2; ) {
          if (n2 <= 0) {
            var c2 = t2.readVarint();
            r2 = 7 & c2, n2 = c2 >> 3;
          }
          if (n2--, r2 === 1 || r2 === 2)
            (i3 += t2.readSVarint()) < a2 && (a2 = i3), i3 > o2 && (o2 = i3), (s3 += t2.readSVarint()) < l2 && (l2 = s3), s3 > u2 && (u2 = s3);
          else if (r2 !== 7)
            throw new Error("unknown command " + r2);
        }
        return [a2, l2, o2, u2];
      }, Au.prototype.toGeoJSON = function(t2, e2, r2) {
        var n2, i3, s3 = this.extent * Math.pow(2, r2), a2 = this.extent * t2, o2 = this.extent * e2, l2 = this.loadGeometry(), u2 = Au.types[this.type];
        function c2(t3) {
          for (var e3 = 0; e3 < t3.length; e3++) {
            var r3 = t3[e3];
            t3[e3] = [360 * (r3.x + a2) / s3 - 180, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r3.y + o2) / s3) * Math.PI / 180)) - 90];
          }
        }
        switch (this.type) {
          case 1:
            var h2 = [];
            for (n2 = 0; n2 < l2.length; n2++)
              h2[n2] = l2[n2][0];
            c2(l2 = h2);
            break;
          case 2:
            for (n2 = 0; n2 < l2.length; n2++)
              c2(l2[n2]);
            break;
          case 3:
            for (l2 = function(t3) {
              var e3 = t3.length;
              if (e3 <= 1)
                return [t3];
              for (var r3, n3, i4 = [], s4 = 0; s4 < e3; s4++) {
                var a3 = Su(t3[s4]);
                a3 !== 0 && (n3 === void 0 && (n3 = a3 < 0), n3 === a3 < 0 ? (r3 && i4.push(r3), r3 = [t3[s4]]) : r3.push(t3[s4]));
              }
              return r3 && i4.push(r3), i4;
            }(l2), n2 = 0; n2 < l2.length; n2++)
              for (i3 = 0; i3 < l2[n2].length; i3++)
                c2(l2[n2][i3]);
        }
        l2.length === 1 ? l2 = l2[0] : u2 = "Multi" + u2;
        var p2 = { type: "Feature", geometry: { type: u2, coordinates: l2 }, properties: this.properties };
        return "id" in this && (p2.id = this.id), p2;
      };
      var Iu = zu;
      function zu(t2, e2) {
        this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t2, this._keys = [], this._values = [], this._features = [], t2.readFields(Mu, this, e2), this.length = this._features.length;
      }
      function Mu(t2, e2, r2) {
        t2 === 15 ? e2.version = r2.readVarint() : t2 === 1 ? e2.name = r2.readString() : t2 === 5 ? e2.extent = r2.readVarint() : t2 === 2 ? e2._features.push(r2.pos) : t2 === 3 ? e2._keys.push(r2.readString()) : t2 === 4 && e2._values.push(function(t3) {
          for (var e3 = null, r3 = t3.readVarint() + t3.pos; t3.pos < r3; ) {
            var n2 = t3.readVarint() >> 3;
            e3 = n2 === 1 ? t3.readString() : n2 === 2 ? t3.readFloat() : n2 === 3 ? t3.readDouble() : n2 === 4 ? t3.readVarint64() : n2 === 5 ? t3.readVarint() : n2 === 6 ? t3.readSVarint() : n2 === 7 ? t3.readBoolean() : null;
          }
          return e3;
        }(r2));
      }
      function Tu(t2, e2, r2) {
        if (t2 === 3) {
          var n2 = new Iu(r2, r2.readVarint() + r2.pos);
          n2.length && (e2[n2.name] = n2);
        }
      }
      zu.prototype.feature = function(t2) {
        if (t2 < 0 || t2 >= this._features.length)
          throw new Error("feature index out of bounds");
        this._pbf.pos = this._features[t2];
        var e2 = this._pbf.readVarint() + this._pbf.pos;
        return new _u(this._pbf, e2, this.extent, this._keys, this._values);
      };
      var Bu = { VectorTile: function(t2, e2) {
        this.layers = t2.readFields(Tu, {}, e2);
      }, VectorTileFeature: _u, VectorTileLayer: Iu };
      const Cu = Bu.VectorTileFeature.types, Pu = Math.pow(2, 13);
      function Eu(t2, e2, r2, n2, i3, s3, a2, o2) {
        t2.emplaceBack((e2 << 1) + a2, (r2 << 1) + s3, (Math.floor(n2 * Pu) << 1) + i3, Math.round(o2));
      }
      class Du {
        constructor() {
          this.acc = new i2(0, 0), this.polyCount = [];
        }
        startRing(t2) {
          this.currentPolyCount = { edges: 0, top: 0 }, this.polyCount.push(this.currentPolyCount), this.min || (this.min = new i2(t2.x, t2.y), this.max = new i2(t2.x, t2.y));
        }
        append(t2, e2) {
          this.currentPolyCount.edges++, this.acc._add(t2);
          let r2 = !!this.borders;
          const n2 = this.min, i3 = this.max;
          t2.x < n2.x ? (n2.x = t2.x, r2 = true) : t2.x > i3.x && (i3.x = t2.x, r2 = true), t2.y < n2.y ? (n2.y = t2.y, r2 = true) : t2.y > i3.y && (i3.y = t2.y, r2 = true), ((t2.x === 0 || t2.x === To) && t2.x === e2.x) != ((t2.y === 0 || t2.y === To) && t2.y === e2.y) && this.processBorderOverlap(t2, e2), r2 && this.checkBorderIntersection(t2, e2);
        }
        checkBorderIntersection(t2, e2) {
          e2.x < 0 != t2.x < 0 && this.addBorderIntersection(0, Lr(e2.y, t2.y, (0 - e2.x) / (t2.x - e2.x))), e2.x > To != t2.x > To && this.addBorderIntersection(1, Lr(e2.y, t2.y, (To - e2.x) / (t2.x - e2.x))), e2.y < 0 != t2.y < 0 && this.addBorderIntersection(2, Lr(e2.x, t2.x, (0 - e2.y) / (t2.y - e2.y))), e2.y > To != t2.y > To && this.addBorderIntersection(3, Lr(e2.x, t2.x, (To - e2.y) / (t2.y - e2.y)));
        }
        addBorderIntersection(t2, e2) {
          this.borders || (this.borders = [[Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE]]);
          const r2 = this.borders[t2];
          e2 < r2[0] && (r2[0] = e2), e2 > r2[1] && (r2[1] = e2);
        }
        processBorderOverlap(t2, e2) {
          if (t2.x === e2.x) {
            if (t2.y === e2.y)
              return;
            const r2 = t2.x === 0 ? 0 : 1;
            this.addBorderIntersection(r2, e2.y), this.addBorderIntersection(r2, t2.y);
          } else {
            const r2 = t2.y === 0 ? 2 : 3;
            this.addBorderIntersection(r2, e2.x), this.addBorderIntersection(r2, t2.x);
          }
        }
        centroid() {
          const t2 = this.polyCount.reduce((t3, e2) => t3 + e2.edges, 0);
          return t2 !== 0 ? this.acc.div(t2)._round() : new i2(0, 0);
        }
        span() {
          return new i2(this.max.x - this.min.x, this.max.y - this.min.y);
        }
        intersectsCount() {
          return this.borders.reduce((t2, e2) => t2 + +(e2[0] !== Number.MAX_VALUE), 0);
        }
      }
      class Vu {
        constructor(t2) {
          this.zoom = t2.zoom, this.overscaling = t2.overscaling, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.id), this.index = t2.index, this.hasPattern = false, this.layoutVertexArray = new da(), this.centroidVertexArray = new Za(), this.indexArray = new ka(), this.programConfigurations = new xo(t2.layers, t2.zoom), this.segments = new Mo(), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id), this.enableTerrain = t2.enableTerrain;
        }
        populate(t2, e2, r2, n2) {
          this.features = [], this.hasPattern = fu("fill-extrusion", this.layers, e2), this.featuresOnBorder = [], this.borders = [[], [], [], []], this.borderDone = [false, false, false, false], this.tileToMeter = function(t3) {
            const e3 = Math.exp(Math.PI * (1 - t3.y / (1 << t3.z) * 2));
            return 80150034 * e3 / (e3 * e3 + 1) / To / (1 << t3.z);
          }(r2);
          for (const { feature: i3, id: s3, index: a2, sourceLayerIndex: o2 } of t2) {
            const t3 = this.layers[0]._featureFilter.needGeometry, l2 = Yo(i3, t3);
            if (!this.layers[0]._featureFilter.filter(new Gs(this.zoom), l2, r2))
              continue;
            const u2 = { id: s3, sourceLayerIndex: o2, index: a2, geometry: t3 ? l2.geometry : Ko(i3, r2, n2), properties: i3.properties, type: i3.type, patterns: {} }, c2 = this.layoutVertexArray.length;
            this.hasPattern ? this.features.push(yu("fill-extrusion", this.layers, u2, this.zoom, e2)) : this.addFeature(u2, u2.geometry, a2, r2, {}, e2.availableImages), e2.featureIndex.insert(i3, u2.geometry, a2, o2, this.index, c2);
          }
          this.sortBorders();
        }
        addFeatures(t2, e2, r2, n2) {
          for (const t3 of this.features) {
            const { geometry: i3 } = t3;
            this.addFeature(t3, i3, t3.index, e2, r2, n2);
          }
          this.sortBorders();
        }
        update(t2, e2, r2, n2) {
          this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t2, e2, this.stateDependentLayers, r2, n2);
        }
        isEmpty() {
          return this.layoutVertexArray.length === 0;
        }
        uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload;
        }
        upload(t2) {
          this.uploaded || (this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, wu), this.indexBuffer = t2.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t2), this.uploaded = true;
        }
        uploadCentroid(t2) {
          this.centroidVertexArray.length !== 0 && (this.centroidVertexBuffer ? this.needsCentroidUpdate && this.centroidVertexBuffer.updateData(this.centroidVertexArray) : this.centroidVertexBuffer = t2.createVertexBuffer(this.centroidVertexArray, bu.members, true), this.needsCentroidUpdate = false);
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.centroidVertexBuffer && this.centroidVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
        }
        addFeature(t2, e2, r2, n2, i3, s3) {
          const a2 = this.enableTerrain ? new Du() : null;
          for (const r3 of pu(e2, 500)) {
            let e3 = 0, n3 = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray);
            if (r3.length === 0 || (o2 = r3[0]).every((t3) => t3.x <= 0) || o2.every((t3) => t3.x >= To) || o2.every((t3) => t3.y <= 0) || o2.every((t3) => t3.y >= To))
              continue;
            for (let t3 = 0; t3 < r3.length; t3++) {
              const i5 = r3[t3];
              if (i5.length === 0)
                continue;
              e3 += i5.length;
              let s5 = 0;
              a2 && a2.startRing(i5[0]);
              for (let t4 = 0; t4 < i5.length; t4++) {
                const e4 = i5[t4];
                if (t4 >= 1) {
                  const r4 = i5[t4 - 1];
                  if (!Fu(e4, r4)) {
                    a2 && a2.append(e4, r4), n3.vertexLength + 4 > Mo.MAX_VERTEX_ARRAY_LENGTH && (n3 = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                    const t5 = e4.sub(r4)._perp(), i6 = t5.x / (Math.abs(t5.x) + Math.abs(t5.y)), o3 = t5.y > 0 ? 1 : 0, l3 = r4.dist(e4);
                    s5 + l3 > 32768 && (s5 = 0), Eu(this.layoutVertexArray, e4.x, e4.y, i6, o3, 0, 0, s5), Eu(this.layoutVertexArray, e4.x, e4.y, i6, o3, 0, 1, s5), s5 += l3, Eu(this.layoutVertexArray, r4.x, r4.y, i6, o3, 0, 0, s5), Eu(this.layoutVertexArray, r4.x, r4.y, i6, o3, 0, 1, s5);
                    const u3 = n3.vertexLength;
                    this.indexArray.emplaceBack(u3, u3 + 2, u3 + 1), this.indexArray.emplaceBack(u3 + 1, u3 + 2, u3 + 3), n3.vertexLength += 4, n3.primitiveLength += 2;
                  }
                }
              }
            }
            if (n3.vertexLength + e3 > Mo.MAX_VERTEX_ARRAY_LENGTH && (n3 = this.segments.prepareSegment(e3, this.layoutVertexArray, this.indexArray)), Cu[t2.type] !== "Polygon")
              continue;
            const i4 = [], s4 = [], l2 = n3.vertexLength;
            for (let t3 = 0; t3 < r3.length; t3++) {
              const e4 = r3[t3];
              if (e4.length !== 0) {
                e4 !== r3[0] && s4.push(i4.length / 2);
                for (let t4 = 0; t4 < e4.length; t4++) {
                  const r4 = e4[t4];
                  Eu(this.layoutVertexArray, r4.x, r4.y, 0, 0, 1, 1, 0), i4.push(r4.x), i4.push(r4.y), a2 && a2.currentPolyCount.top++;
                }
              }
            }
            const u2 = Dl(i4, s4);
            for (let t3 = 0; t3 < u2.length; t3 += 3)
              this.indexArray.emplaceBack(l2 + u2[t3], l2 + u2[t3 + 2], l2 + u2[t3 + 1]);
            n3.primitiveLength += u2.length / 3, n3.vertexLength += e3;
          }
          var o2;
          if (a2 && a2.polyCount.length > 0) {
            if (a2.borders) {
              a2.vertexArrayOffset = this.centroidVertexArray.length;
              const t3 = a2.borders, e3 = this.featuresOnBorder.push(a2) - 1;
              for (let r3 = 0; r3 < 4; r3++)
                t3[r3][0] !== Number.MAX_VALUE && this.borders[r3].push(e3);
            }
            this.encodeCentroid(a2.borders ? void 0 : a2.centroid(), a2);
          }
          this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t2, r2, i3, s3, n2);
        }
        sortBorders() {
          for (let t2 = 0; t2 < 4; t2++)
            this.borders[t2].sort((e2, r2) => this.featuresOnBorder[e2].borders[t2][0] - this.featuresOnBorder[r2].borders[t2][0]);
        }
        encodeCentroid(t2, e2, r2 = true) {
          let n2, i3;
          if (t2)
            if (t2.y !== 0) {
              const r3 = e2.span()._mult(this.tileToMeter);
              n2 = (Math.max(t2.x, 1) << 3) + Math.min(7, Math.round(r3.x / 10)), i3 = (Math.max(t2.y, 1) << 3) + Math.min(7, Math.round(r3.y / 10));
            } else
              n2 = Math.ceil(7 * (t2.x + 450)), i3 = 0;
          else
            n2 = 0, i3 = +r2;
          let s3 = r2 ? this.centroidVertexArray.length : e2.vertexArrayOffset;
          for (const t3 of e2.polyCount) {
            r2 && this.centroidVertexArray.resize(this.centroidVertexArray.length + 4 * t3.edges + t3.top);
            for (let e3 = 0; e3 < 2 * t3.edges; e3++)
              this.centroidVertexArray.emplace(s3++, 0, i3), this.centroidVertexArray.emplace(s3++, n2, i3);
            for (let e3 = 0; e3 < t3.top; e3++)
              this.centroidVertexArray.emplace(s3++, n2, i3);
          }
        }
      }
      function Fu(t2, e2) {
        return t2.x === e2.x && (t2.x < 0 || t2.x > To) || t2.y === e2.y && (t2.y < 0 || t2.y > To);
      }
      Zi("FillExtrusionBucket", Vu, { omit: ["layers", "features"] }), Zi("PartMetadata", Du);
      var Lu = { paint: new sa({ "fill-extrusion-opacity": new ta(ve["paint_fill-extrusion"]["fill-extrusion-opacity"]), "fill-extrusion-color": new ea(ve["paint_fill-extrusion"]["fill-extrusion-color"]), "fill-extrusion-translate": new ta(ve["paint_fill-extrusion"]["fill-extrusion-translate"]), "fill-extrusion-translate-anchor": new ta(ve["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]), "fill-extrusion-pattern": new ra(ve["paint_fill-extrusion"]["fill-extrusion-pattern"]), "fill-extrusion-height": new ea(ve["paint_fill-extrusion"]["fill-extrusion-height"]), "fill-extrusion-base": new ea(ve["paint_fill-extrusion"]["fill-extrusion-base"]), "fill-extrusion-vertical-gradient": new ta(ve["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]) }) };
      function Ru(t2, e2) {
        return t2.x * e2.x + t2.y * e2.y;
      }
      function Uu(t2, e2) {
        if (t2.length === 1) {
          let r2 = 0;
          const n2 = e2[r2++];
          let i3;
          for (; !i3 || n2.equals(i3); )
            if (i3 = e2[r2++], !i3)
              return 1 / 0;
          for (; r2 < e2.length; r2++) {
            const s3 = e2[r2], a2 = t2[0], o2 = i3.sub(n2), l2 = s3.sub(n2), u2 = a2.sub(n2), c2 = Ru(o2, o2), h2 = Ru(o2, l2), p2 = Ru(l2, l2), d2 = Ru(u2, o2), f2 = Ru(u2, l2), y2 = c2 * p2 - h2 * h2, m2 = (p2 * d2 - h2 * f2) / y2, g2 = (c2 * f2 - h2 * d2) / y2, x3 = n2.z * (1 - m2 - g2) + i3.z * m2 + s3.z * g2;
            if (isFinite(x3))
              return x3;
          }
          return 1 / 0;
        }
        {
          let t3 = 1 / 0;
          for (const r2 of e2)
            t3 = Math.min(t3, r2.z);
          return t3;
        }
      }
      function $u(t2) {
        const e2 = new i2(t2[0], t2[1]);
        return e2.z = t2[2], e2;
      }
      function Ou(t2, e2, r2, n2, i3, s3, a2, o2) {
        const l2 = a2 * i3.getElevationAt(t2, e2, true, true), u2 = s3[0] !== 0, c2 = u2 ? s3[1] === 0 ? a2 * (s3[0] / 7 - 450) : a2 * function(t3, e3, r3) {
          const n3 = Math.floor(e3[0] / 8), i4 = Math.floor(e3[1] / 8), s4 = 10 * (e3[0] - 8 * n3), a3 = 10 * (e3[1] - 8 * i4), o3 = t3.getElevationAt(n3, i4, true, true), l3 = t3.getMeterToDEM(r3), u3 = Math.floor(0.5 * (s4 * l3 - 1)), c3 = Math.floor(0.5 * (a3 * l3 - 1)), h2 = t3.tileCoordToPixel(n3, i4), p2 = 2 * u3 + 1, d2 = 2 * c3 + 1, f2 = function(t4, e4, r4, n4, i5) {
            return [t4.getElevationAtPixel(e4, r4, true), t4.getElevationAtPixel(e4 + i5, r4, true), t4.getElevationAtPixel(e4, r4 + i5, true), t4.getElevationAtPixel(e4 + n4, r4 + i5, true)];
          }(t3, h2.x - u3, h2.y - c3, p2, d2), y2 = Math.abs(f2[0] - f2[1]), m2 = Math.abs(f2[2] - f2[3]), g2 = Math.abs(f2[0] - f2[2]) + Math.abs(f2[1] - f2[3]), x3 = Math.min(0.25, 0.5 * l3 * (y2 + m2) / p2), v3 = Math.min(0.25, 0.5 * l3 * g2 / d2);
          return o3 + Math.max(x3 * s4, v3 * a3);
        }(i3, s3, o2) : l2;
        return { base: l2 + (r2 === 0) ? -1 : r2, top: u2 ? Math.max(c2 + n2, l2 + r2 + 2) : l2 + n2 };
      }
      const ju = ca([{ name: "a_pos_normal", components: 2, type: "Int16" }, { name: "a_data", components: 4, type: "Uint8" }, { name: "a_linesofar", components: 1, type: "Float32" }], 4), { members: qu } = ju, Nu = ca([{ name: "a_packed", components: 3, type: "Float32" }]), { members: Gu } = Nu, Zu = Bu.VectorTileFeature.types, Xu = Math.cos(Math.PI / 180 * 37.5);
      class Ku {
        constructor(t2) {
          this.zoom = t2.zoom, this.overscaling = t2.overscaling, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.id), this.index = t2.index, this.hasPattern = false, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((t3) => {
            this.gradients[t3.id] = {};
          }), this.layoutVertexArray = new fa(), this.layoutVertexArray2 = new ya(), this.indexArray = new ka(), this.programConfigurations = new xo(t2.layers, t2.zoom), this.segments = new Mo(), this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id);
        }
        populate(t2, e2, r2, n2) {
          this.hasPattern = fu("line", this.layers, e2);
          const i3 = this.layers[0].layout.get("line-sort-key"), s3 = [];
          for (const { feature: e3, id: a3, index: o3, sourceLayerIndex: l3 } of t2) {
            const t3 = this.layers[0]._featureFilter.needGeometry, u2 = Yo(e3, t3);
            if (!this.layers[0]._featureFilter.filter(new Gs(this.zoom), u2, r2))
              continue;
            const c2 = i3 ? i3.evaluate(u2, {}, r2) : void 0, h2 = { id: a3, properties: e3.properties, type: e3.type, sourceLayerIndex: l3, index: o3, geometry: t3 ? u2.geometry : Ko(e3, r2, n2), patterns: {}, sortKey: c2 };
            s3.push(h2);
          }
          i3 && s3.sort((t3, e3) => t3.sortKey - e3.sortKey);
          const { lineAtlas: a2, featureIndex: o2 } = e2, l2 = this.addConstantDashes(a2);
          for (const n3 of s3) {
            const { geometry: i4, index: s4, sourceLayerIndex: u2 } = n3;
            if (l2 && this.addFeatureDashes(n3, a2), this.hasPattern) {
              const t3 = yu("line", this.layers, n3, this.zoom, e2);
              this.patternFeatures.push(t3);
            } else
              this.addFeature(n3, i4, s4, r2, a2.positions, e2.availableImages);
            o2.insert(t2[s4].feature, i4, s4, u2, this.index);
          }
        }
        addConstantDashes(t2) {
          let e2 = false;
          for (const r2 of this.layers) {
            const n2 = r2.paint.get("line-dasharray").value, i3 = r2.layout.get("line-cap").value;
            if (n2.kind !== "constant" || i3.kind !== "constant")
              e2 = true;
            else {
              const e3 = i3.value, r3 = n2.value;
              if (!r3)
                continue;
              t2.addDash(r3.from, e3), t2.addDash(r3.to, e3), r3.other && t2.addDash(r3.other, e3);
            }
          }
          return e2;
        }
        addFeatureDashes(t2, e2) {
          const r2 = this.zoom;
          for (const n2 of this.layers) {
            const i3 = n2.paint.get("line-dasharray").value, s3 = n2.layout.get("line-cap").value;
            if (i3.kind === "constant" && s3.kind === "constant")
              continue;
            let a2, o2, l2, u2, c2, h2;
            if (i3.kind === "constant") {
              const t3 = i3.value;
              if (!t3)
                continue;
              a2 = t3.other || t3.to, o2 = t3.to, l2 = t3.from;
            } else
              a2 = i3.evaluate({ zoom: r2 - 1 }, t2), o2 = i3.evaluate({ zoom: r2 }, t2), l2 = i3.evaluate({ zoom: r2 + 1 }, t2);
            s3.kind === "constant" ? u2 = c2 = h2 = s3.value : (u2 = s3.evaluate({ zoom: r2 - 1 }, t2), c2 = s3.evaluate({ zoom: r2 }, t2), h2 = s3.evaluate({ zoom: r2 + 1 }, t2)), e2.addDash(a2, u2), e2.addDash(o2, c2), e2.addDash(l2, h2);
            const p2 = e2.getKey(a2, u2), d2 = e2.getKey(o2, c2), f2 = e2.getKey(l2, h2);
            t2.patterns[n2.id] = { min: p2, mid: d2, max: f2 };
          }
        }
        update(t2, e2, r2, n2) {
          this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t2, e2, this.stateDependentLayers, r2, n2);
        }
        addFeatures(t2, e2, r2, n2) {
          for (const t3 of this.patternFeatures)
            this.addFeature(t3, t3.geometry, t3.index, e2, r2, n2);
        }
        isEmpty() {
          return this.layoutVertexArray.length === 0;
        }
        uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload;
        }
        upload(t2) {
          this.uploaded || (this.layoutVertexArray2.length !== 0 && (this.layoutVertexBuffer2 = t2.createVertexBuffer(this.layoutVertexArray2, Gu)), this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, qu), this.indexBuffer = t2.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t2), this.uploaded = true;
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
        }
        lineFeatureClips(t2) {
          if (t2.properties && t2.properties.hasOwnProperty("mapbox_clip_start") && t2.properties.hasOwnProperty("mapbox_clip_end"))
            return { start: +t2.properties.mapbox_clip_start, end: +t2.properties.mapbox_clip_end };
        }
        addFeature(t2, e2, r2, n2, i3, s3) {
          const a2 = this.layers[0].layout, o2 = a2.get("line-join").evaluate(t2, {}), l2 = a2.get("line-cap").evaluate(t2, {}), u2 = a2.get("line-miter-limit"), c2 = a2.get("line-round-limit");
          this.lineClips = this.lineFeatureClips(t2);
          for (const r3 of e2)
            this.addLine(r3, t2, o2, l2, u2, c2);
          this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t2, r2, i3, s3, n2);
        }
        addLine(t2, e2, r2, n2, i3, s3) {
          if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineSoFar = 0, this.lineClips) {
            this.lineClipsArray.push(this.lineClips);
            for (let e3 = 0; e3 < t2.length - 1; e3++)
              this.totalDistance += t2[e3].dist(t2[e3 + 1]);
            this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
          }
          const a2 = Zu[e2.type] === "Polygon";
          let o2 = t2.length;
          for (; o2 >= 2 && t2[o2 - 1].equals(t2[o2 - 2]); )
            o2--;
          let l2 = 0;
          for (; l2 < o2 - 1 && t2[l2].equals(t2[l2 + 1]); )
            l2++;
          if (o2 < (a2 ? 3 : 2))
            return;
          r2 === "bevel" && (i3 = 1.05);
          const u2 = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0, c2 = this.segments.prepareSegment(10 * o2, this.layoutVertexArray, this.indexArray);
          let h2, p2, d2, f2, y2;
          this.e1 = this.e2 = -1, a2 && (h2 = t2[o2 - 2], y2 = t2[l2].sub(h2)._unit()._perp());
          for (let e3 = l2; e3 < o2; e3++) {
            if (d2 = e3 === o2 - 1 ? a2 ? t2[l2 + 1] : void 0 : t2[e3 + 1], d2 && t2[e3].equals(d2))
              continue;
            y2 && (f2 = y2), h2 && (p2 = h2), h2 = t2[e3], y2 = d2 ? d2.sub(h2)._unit()._perp() : f2, f2 = f2 || y2;
            let m2 = f2.add(y2);
            m2.x === 0 && m2.y === 0 || m2._unit();
            const g2 = f2.x * y2.x + f2.y * y2.y, x3 = m2.x * y2.x + m2.y * y2.y, v3 = x3 !== 0 ? 1 / x3 : 1 / 0, b2 = 2 * Math.sqrt(2 - 2 * x3), w2 = x3 < Xu && p2 && d2, _2 = f2.x * y2.y - f2.y * y2.x > 0;
            if (w2 && e3 > l2) {
              const t3 = h2.dist(p2);
              if (t3 > 2 * u2) {
                const e4 = h2.sub(h2.sub(p2)._mult(u2 / t3)._round());
                this.updateDistance(p2, e4), this.addCurrentVertex(e4, f2, 0, 0, c2), p2 = e4;
              }
            }
            const A3 = p2 && d2;
            let k2 = A3 ? r2 : a2 ? "butt" : n2;
            if (A3 && k2 === "round" && (v3 < s3 ? k2 = "miter" : v3 <= 2 && (k2 = "fakeround")), k2 === "miter" && v3 > i3 && (k2 = "bevel"), k2 === "bevel" && (v3 > 2 && (k2 = "flipbevel"), v3 < i3 && (k2 = "miter")), p2 && this.updateDistance(p2, h2), k2 === "miter")
              m2._mult(v3), this.addCurrentVertex(h2, m2, 0, 0, c2);
            else if (k2 === "flipbevel") {
              if (v3 > 100)
                m2 = y2.mult(-1);
              else {
                const t3 = v3 * f2.add(y2).mag() / f2.sub(y2).mag();
                m2._perp()._mult(t3 * (_2 ? -1 : 1));
              }
              this.addCurrentVertex(h2, m2, 0, 0, c2), this.addCurrentVertex(h2, m2.mult(-1), 0, 0, c2);
            } else if (k2 === "bevel" || k2 === "fakeround") {
              const t3 = -Math.sqrt(v3 * v3 - 1), e4 = _2 ? t3 : 0, r3 = _2 ? 0 : t3;
              if (p2 && this.addCurrentVertex(h2, f2, e4, r3, c2), k2 === "fakeround") {
                const t4 = Math.round(180 * b2 / Math.PI / 20);
                for (let e5 = 1; e5 < t4; e5++) {
                  let r4 = e5 / t4;
                  if (r4 !== 0.5) {
                    const t5 = r4 - 0.5;
                    r4 += r4 * t5 * (r4 - 1) * ((1.0904 + g2 * (g2 * (3.55645 - 1.43519 * g2) - 3.2452)) * t5 * t5 + (0.848013 + g2 * (0.215638 * g2 - 1.06021)));
                  }
                  const n3 = y2.sub(f2)._mult(r4)._add(f2)._unit()._mult(_2 ? -1 : 1);
                  this.addHalfVertex(h2, n3.x, n3.y, false, _2, 0, c2);
                }
              }
              d2 && this.addCurrentVertex(h2, y2, -e4, -r3, c2);
            } else if (k2 === "butt")
              this.addCurrentVertex(h2, m2, 0, 0, c2);
            else if (k2 === "square") {
              const t3 = p2 ? 1 : -1;
              p2 || this.addCurrentVertex(h2, m2, t3, t3, c2), this.addCurrentVertex(h2, m2, 0, 0, c2), p2 && this.addCurrentVertex(h2, m2, t3, t3, c2);
            } else
              k2 === "round" && (p2 && (this.addCurrentVertex(h2, f2, 0, 0, c2), this.addCurrentVertex(h2, f2, 1, 1, c2, true)), d2 && (this.addCurrentVertex(h2, y2, -1, -1, c2, true), this.addCurrentVertex(h2, y2, 0, 0, c2)));
            if (w2 && e3 < o2 - 1) {
              const t3 = h2.dist(d2);
              if (t3 > 2 * u2) {
                const e4 = h2.add(d2.sub(h2)._mult(u2 / t3)._round());
                this.updateDistance(h2, e4), this.addCurrentVertex(e4, y2, 0, 0, c2), h2 = e4;
              }
            }
          }
        }
        addCurrentVertex(t2, e2, r2, n2, i3, s3 = false) {
          const a2 = e2.y * n2 - e2.x, o2 = -e2.y - e2.x * n2;
          this.addHalfVertex(t2, e2.x + e2.y * r2, e2.y - e2.x * r2, s3, false, r2, i3), this.addHalfVertex(t2, a2, o2, s3, true, -n2, i3);
        }
        addHalfVertex({ x: t2, y: e2 }, r2, n2, i3, s3, a2, o2) {
          this.layoutVertexArray.emplaceBack((t2 << 1) + (i3 ? 1 : 0), (e2 << 1) + (s3 ? 1 : 0), Math.round(63 * r2) + 128, Math.round(63 * n2) + 128, 1 + (a2 === 0 ? 0 : a2 < 0 ? -1 : 1), 0, this.lineSoFar), this.lineClips && this.layoutVertexArray2.emplaceBack(this.scaledDistance, this.lineClipsArray.length, this.lineSoFar);
          const l2 = o2.vertexLength++;
          this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, l2), o2.primitiveLength++), s3 ? this.e2 = l2 : this.e1 = l2;
        }
        updateScaledDistance() {
          if (this.lineClips) {
            const t2 = this.totalDistance / (this.lineClips.end - this.lineClips.start);
            this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = t2 * this.lineClips.start + this.distance;
          } else
            this.lineSoFar = this.distance;
        }
        updateDistance(t2, e2) {
          this.distance += t2.dist(e2), this.updateScaledDistance();
        }
      }
      Zi("LineBucket", Ku, { omit: ["layers", "patternFeatures"] });
      const Yu = new sa({ "line-cap": new ea(ve.layout_line["line-cap"]), "line-join": new ea(ve.layout_line["line-join"]), "line-miter-limit": new ta(ve.layout_line["line-miter-limit"]), "line-round-limit": new ta(ve.layout_line["line-round-limit"]), "line-sort-key": new ea(ve.layout_line["line-sort-key"]) });
      var Hu = { paint: new sa({ "line-opacity": new ea(ve.paint_line["line-opacity"]), "line-color": new ea(ve.paint_line["line-color"]), "line-translate": new ta(ve.paint_line["line-translate"]), "line-translate-anchor": new ta(ve.paint_line["line-translate-anchor"]), "line-width": new ea(ve.paint_line["line-width"]), "line-gap-width": new ea(ve.paint_line["line-gap-width"]), "line-offset": new ea(ve.paint_line["line-offset"]), "line-blur": new ea(ve.paint_line["line-blur"]), "line-dasharray": new ra(ve.paint_line["line-dasharray"]), "line-pattern": new ra(ve.paint_line["line-pattern"]), "line-gradient": new ia(ve.paint_line["line-gradient"]) }), layout: Yu };
      const Ju = new class extends ea {
        possiblyEvaluate(t2, e2) {
          return e2 = new Gs(Math.floor(e2.zoom), { now: e2.now, fadeDuration: e2.fadeDuration, zoomHistory: e2.zoomHistory, transition: e2.transition }), super.possiblyEvaluate(t2, e2);
        }
        evaluate(t2, e2, r2, n2) {
          return e2 = tt({}, e2, { zoom: Math.floor(e2.zoom) }), super.evaluate(t2, e2, r2, n2);
        }
      }(Hu.paint.properties["line-width"].specification);
      function Wu(t2, e2) {
        return e2 > 0 ? e2 + 2 * t2 : t2;
      }
      Ju.useIntegerZoom = true;
      const Qu = ca([{ name: "a_pos_offset", components: 4, type: "Int16" }, { name: "a_tex_size", components: 4, type: "Uint16" }, { name: "a_pixeloffset", components: 4, type: "Int16" }, { name: "a_z_tile_anchor", components: 4, type: "Int16" }], 4), tc = ca([{ name: "a_projected_pos", components: 3, type: "Float32" }], 4);
      ca([{ name: "a_fade_opacity", components: 1, type: "Uint32" }], 4);
      const ec = ca([{ name: "a_placed", components: 2, type: "Uint8" }, { name: "a_shift", components: 2, type: "Float32" }]), rc = ca([{ name: "a_size_scale", components: 1, type: "Float32" }, { name: "a_padding", components: 2, type: "Float32" }]);
      ca([{ type: "Int16", name: "projectedAnchorX" }, { type: "Int16", name: "projectedAnchorY" }, { type: "Int16", name: "projectedAnchorZ" }, { type: "Int16", name: "tileAnchorX" }, { type: "Int16", name: "tileAnchorY" }, { type: "Float32", name: "x1" }, { type: "Float32", name: "y1" }, { type: "Float32", name: "x2" }, { type: "Float32", name: "y2" }, { type: "Int16", name: "padding" }, { type: "Uint32", name: "featureIndex" }, { type: "Uint16", name: "sourceLayerIndex" }, { type: "Uint16", name: "bucketIndex" }]);
      const nc = ca([{ name: "a_pos", components: 3, type: "Int16" }, { name: "a_anchor_pos", components: 2, type: "Int16" }, { name: "a_extrude", components: 2, type: "Int16" }], 4), ic = ca([{ name: "a_pos_2f", components: 2, type: "Float32" }, { name: "a_radius", components: 1, type: "Float32" }, { name: "a_flags", components: 2, type: "Int16" }], 4);
      ca([{ name: "triangle", components: 3, type: "Uint16" }]), ca([{ type: "Int16", name: "projectedAnchorX" }, { type: "Int16", name: "projectedAnchorY" }, { type: "Int16", name: "projectedAnchorZ" }, { type: "Float32", name: "tileAnchorX" }, { type: "Float32", name: "tileAnchorY" }, { type: "Uint16", name: "glyphStartIndex" }, { type: "Uint16", name: "numGlyphs" }, { type: "Uint32", name: "vertexStartIndex" }, { type: "Uint32", name: "lineStartIndex" }, { type: "Uint32", name: "lineLength" }, { type: "Uint16", name: "segment" }, { type: "Uint16", name: "lowerSize" }, { type: "Uint16", name: "upperSize" }, { type: "Float32", name: "lineOffsetX" }, { type: "Float32", name: "lineOffsetY" }, { type: "Uint8", name: "writingMode" }, { type: "Uint8", name: "placedOrientation" }, { type: "Uint8", name: "hidden" }, { type: "Uint32", name: "crossTileID" }, { type: "Int16", name: "associatedIconIndex" }, { type: "Uint8", name: "flipState" }]), ca([{ type: "Int16", name: "projectedAnchorX" }, { type: "Int16", name: "projectedAnchorY" }, { type: "Int16", name: "projectedAnchorZ" }, { type: "Float32", name: "tileAnchorX" }, { type: "Float32", name: "tileAnchorY" }, { type: "Int16", name: "rightJustifiedTextSymbolIndex" }, { type: "Int16", name: "centerJustifiedTextSymbolIndex" }, { type: "Int16", name: "leftJustifiedTextSymbolIndex" }, { type: "Int16", name: "verticalPlacedTextSymbolIndex" }, { type: "Int16", name: "placedIconSymbolIndex" }, { type: "Int16", name: "verticalPlacedIconSymbolIndex" }, { type: "Uint16", name: "key" }, { type: "Uint16", name: "textBoxStartIndex" }, { type: "Uint16", name: "textBoxEndIndex" }, { type: "Uint16", name: "verticalTextBoxStartIndex" }, { type: "Uint16", name: "verticalTextBoxEndIndex" }, { type: "Uint16", name: "iconBoxStartIndex" }, { type: "Uint16", name: "iconBoxEndIndex" }, { type: "Uint16", name: "verticalIconBoxStartIndex" }, { type: "Uint16", name: "verticalIconBoxEndIndex" }, { type: "Uint16", name: "featureIndex" }, { type: "Uint16", name: "numHorizontalGlyphVertices" }, { type: "Uint16", name: "numVerticalGlyphVertices" }, { type: "Uint16", name: "numIconVertices" }, { type: "Uint16", name: "numVerticalIconVertices" }, { type: "Uint16", name: "useRuntimeCollisionCircles" }, { type: "Uint32", name: "crossTileID" }, { type: "Float32", components: 2, name: "textOffset" }, { type: "Float32", name: "collisionCircleDiameter" }]), ca([{ type: "Float32", name: "offsetX" }]), ca([{ type: "Int16", name: "x" }, { type: "Int16", name: "y" }, { type: "Int16", name: "tileUnitDistanceFromAnchor" }]);
      var sc = 24;
      const ac = 128;
      function oc(t2, e2) {
        const { expression: r2 } = e2;
        if (r2.kind === "constant")
          return { kind: "constant", layoutSize: r2.evaluate(new Gs(t2 + 1)) };
        if (r2.kind === "source")
          return { kind: "source" };
        {
          const { zoomStops: e3, interpolationType: n2 } = r2;
          let i3 = 0;
          for (; i3 < e3.length && e3[i3] <= t2; )
            i3++;
          i3 = Math.max(0, i3 - 1);
          let s3 = i3;
          for (; s3 < e3.length && e3[s3] < t2 + 1; )
            s3++;
          s3 = Math.min(e3.length - 1, s3);
          const a2 = e3[i3], o2 = e3[s3];
          return r2.kind === "composite" ? { kind: "composite", minZoom: a2, maxZoom: o2, interpolationType: n2 } : { kind: "camera", minZoom: a2, maxZoom: o2, minSize: r2.evaluate(new Gs(a2)), maxSize: r2.evaluate(new Gs(o2)), interpolationType: n2 };
        }
      }
      function lc(t2, { uSize: e2, uSizeT: r2 }, { lowerSize: n2, upperSize: i3 }) {
        return t2.kind === "source" ? n2 / ac : t2.kind === "composite" ? Lr(n2 / ac, i3 / ac, r2) : e2;
      }
      function uc(t2, e2) {
        let r2 = 0, n2 = 0;
        if (t2.kind === "constant")
          n2 = t2.layoutSize;
        else if (t2.kind !== "source") {
          const { interpolationType: i3, minZoom: s3, maxZoom: a2 } = t2, o2 = i3 ? Y2(rn.interpolationFactor(i3, e2, s3, a2), 0, 1) : 0;
          t2.kind === "camera" ? n2 = Lr(t2.minSize, t2.maxSize, o2) : r2 = o2;
        }
        return { uSizeT: r2, uSize: n2 };
      }
      var cc = Object.freeze({ __proto__: null, getSizeData: oc, evaluateSizeForFeature: lc, evaluateSizeForZoom: uc, SIZE_PACK_FACTOR: ac });
      function hc(t2, e2, r2) {
        return t2.sections.forEach((t3) => {
          t3.text = function(t4, e3, r3) {
            const n2 = e3.layout.get("text-transform").evaluate(r3, {});
            return n2 === "uppercase" ? t4 = t4.toLocaleUpperCase() : n2 === "lowercase" && (t4 = t4.toLocaleLowerCase()), Ns.applyArabicShaping && (t4 = Ns.applyArabicShaping(t4)), t4;
          }(t3.text, e2, r2);
        }), t2;
      }
      const pc = { "!": "\uFE15", "#": "\uFF03", $: "\uFF04", "%": "\uFF05", "&": "\uFF06", "(": "\uFE35", ")": "\uFE36", "*": "\uFF0A", "+": "\uFF0B", ",": "\uFE10", "-": "\uFE32", ".": "\u30FB", "/": "\uFF0F", ":": "\uFE13", ";": "\uFE14", "<": "\uFE3F", "=": "\uFF1D", ">": "\uFE40", "?": "\uFE16", "@": "\uFF20", "[": "\uFE47", "\\": "\uFF3C", "]": "\uFE48", "^": "\uFF3E", _: "\uFE33", "`": "\uFF40", "{": "\uFE37", "|": "\u2015", "}": "\uFE38", "~": "\uFF5E", "\xA2": "\uFFE0", "\xA3": "\uFFE1", "\xA5": "\uFFE5", "\xA6": "\uFFE4", "\xAC": "\uFFE2", "\xAF": "\uFFE3", "\u2013": "\uFE32", "\u2014": "\uFE31", "\u2018": "\uFE43", "\u2019": "\uFE44", "\u201C": "\uFE41", "\u201D": "\uFE42", "\u2026": "\uFE19", "\u2027": "\u30FB", "\u20A9": "\uFFE6", "\u3001": "\uFE11", "\u3002": "\uFE12", "\u3008": "\uFE3F", "\u3009": "\uFE40", "\u300A": "\uFE3D", "\u300B": "\uFE3E", "\u300C": "\uFE41", "\u300D": "\uFE42", "\u300E": "\uFE43", "\u300F": "\uFE44", "\u3010": "\uFE3B", "\u3011": "\uFE3C", "\u3014": "\uFE39", "\u3015": "\uFE3A", "\u3016": "\uFE17", "\u3017": "\uFE18", "\uFF01": "\uFE15", "\uFF08": "\uFE35", "\uFF09": "\uFE36", "\uFF0C": "\uFE10", "\uFF0D": "\uFE32", "\uFF0E": "\u30FB", "\uFF1A": "\uFE13", "\uFF1B": "\uFE14", "\uFF1C": "\uFE3F", "\uFF1E": "\uFE40", "\uFF1F": "\uFE16", "\uFF3B": "\uFE47", "\uFF3D": "\uFE48", "\uFF3F": "\uFE33", "\uFF5B": "\uFE37", "\uFF5C": "\u2015", "\uFF5D": "\uFE38", "\uFF5F": "\uFE35", "\uFF60": "\uFE36", "\uFF61": "\uFE12", "\uFF62": "\uFE41", "\uFF63": "\uFE42" };
      function dc(t2) {
        return t2 === "\uFE36" || t2 === "\uFE48" || t2 === "\uFE38" || t2 === "\uFE44" || t2 === "\uFE42" || t2 === "\uFE3E" || t2 === "\uFE3C" || t2 === "\uFE3A" || t2 === "\uFE18" || t2 === "\uFE40" || t2 === "\uFE10" || t2 === "\uFE13" || t2 === "\uFE14" || t2 === "\uFF40" || t2 === "\uFFE3" || t2 === "\uFE11" || t2 === "\uFE12";
      }
      function fc(t2) {
        return t2 === "\uFE35" || t2 === "\uFE47" || t2 === "\uFE37" || t2 === "\uFE43" || t2 === "\uFE41" || t2 === "\uFE3D" || t2 === "\uFE3B" || t2 === "\uFE39" || t2 === "\uFE17" || t2 === "\uFE3F";
      }
      var yc = function(t2, e2, r2, n2, i3) {
        var s3, a2, o2 = 8 * i3 - n2 - 1, l2 = (1 << o2) - 1, u2 = l2 >> 1, c2 = -7, h2 = r2 ? i3 - 1 : 0, p2 = r2 ? -1 : 1, d2 = t2[e2 + h2];
        for (h2 += p2, s3 = d2 & (1 << -c2) - 1, d2 >>= -c2, c2 += o2; c2 > 0; s3 = 256 * s3 + t2[e2 + h2], h2 += p2, c2 -= 8)
          ;
        for (a2 = s3 & (1 << -c2) - 1, s3 >>= -c2, c2 += n2; c2 > 0; a2 = 256 * a2 + t2[e2 + h2], h2 += p2, c2 -= 8)
          ;
        if (s3 === 0)
          s3 = 1 - u2;
        else {
          if (s3 === l2)
            return a2 ? NaN : 1 / 0 * (d2 ? -1 : 1);
          a2 += Math.pow(2, n2), s3 -= u2;
        }
        return (d2 ? -1 : 1) * a2 * Math.pow(2, s3 - n2);
      }, mc = function(t2, e2, r2, n2, i3, s3) {
        var a2, o2, l2, u2 = 8 * s3 - i3 - 1, c2 = (1 << u2) - 1, h2 = c2 >> 1, p2 = i3 === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d2 = n2 ? 0 : s3 - 1, f2 = n2 ? 1 : -1, y2 = e2 < 0 || e2 === 0 && 1 / e2 < 0 ? 1 : 0;
        for (e2 = Math.abs(e2), isNaN(e2) || e2 === 1 / 0 ? (o2 = isNaN(e2) ? 1 : 0, a2 = c2) : (a2 = Math.floor(Math.log(e2) / Math.LN2), e2 * (l2 = Math.pow(2, -a2)) < 1 && (a2--, l2 *= 2), (e2 += a2 + h2 >= 1 ? p2 / l2 : p2 * Math.pow(2, 1 - h2)) * l2 >= 2 && (a2++, l2 /= 2), a2 + h2 >= c2 ? (o2 = 0, a2 = c2) : a2 + h2 >= 1 ? (o2 = (e2 * l2 - 1) * Math.pow(2, i3), a2 += h2) : (o2 = e2 * Math.pow(2, h2 - 1) * Math.pow(2, i3), a2 = 0)); i3 >= 8; t2[r2 + d2] = 255 & o2, d2 += f2, o2 /= 256, i3 -= 8)
          ;
        for (a2 = a2 << i3 | o2, u2 += i3; u2 > 0; t2[r2 + d2] = 255 & a2, d2 += f2, a2 /= 256, u2 -= 8)
          ;
        t2[r2 + d2 - f2] |= 128 * y2;
      }, gc = xc;
      function xc(t2) {
        this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t2) ? t2 : new Uint8Array(t2 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
      }
      xc.Varint = 0, xc.Fixed64 = 1, xc.Bytes = 2, xc.Fixed32 = 5;
      var vc = 4294967296, bc = 1 / vc, wc = typeof TextDecoder == "undefined" ? null : new TextDecoder("utf8");
      function _c(t2) {
        return t2.type === xc.Bytes ? t2.readVarint() + t2.pos : t2.pos + 1;
      }
      function Ac(t2, e2, r2) {
        return r2 ? 4294967296 * e2 + (t2 >>> 0) : 4294967296 * (e2 >>> 0) + (t2 >>> 0);
      }
      function kc(t2, e2, r2) {
        var n2 = e2 <= 16383 ? 1 : e2 <= 2097151 ? 2 : e2 <= 268435455 ? 3 : Math.floor(Math.log(e2) / (7 * Math.LN2));
        r2.realloc(n2);
        for (var i3 = r2.pos - 1; i3 >= t2; i3--)
          r2.buf[i3 + n2] = r2.buf[i3];
      }
      function Sc(t2, e2) {
        for (var r2 = 0; r2 < t2.length; r2++)
          e2.writeVarint(t2[r2]);
      }
      function Ic(t2, e2) {
        for (var r2 = 0; r2 < t2.length; r2++)
          e2.writeSVarint(t2[r2]);
      }
      function zc(t2, e2) {
        for (var r2 = 0; r2 < t2.length; r2++)
          e2.writeFloat(t2[r2]);
      }
      function Mc(t2, e2) {
        for (var r2 = 0; r2 < t2.length; r2++)
          e2.writeDouble(t2[r2]);
      }
      function Tc(t2, e2) {
        for (var r2 = 0; r2 < t2.length; r2++)
          e2.writeBoolean(t2[r2]);
      }
      function Bc(t2, e2) {
        for (var r2 = 0; r2 < t2.length; r2++)
          e2.writeFixed32(t2[r2]);
      }
      function Cc(t2, e2) {
        for (var r2 = 0; r2 < t2.length; r2++)
          e2.writeSFixed32(t2[r2]);
      }
      function Pc(t2, e2) {
        for (var r2 = 0; r2 < t2.length; r2++)
          e2.writeFixed64(t2[r2]);
      }
      function Ec(t2, e2) {
        for (var r2 = 0; r2 < t2.length; r2++)
          e2.writeSFixed64(t2[r2]);
      }
      function Dc(t2, e2) {
        return (t2[e2] | t2[e2 + 1] << 8 | t2[e2 + 2] << 16) + 16777216 * t2[e2 + 3];
      }
      function Vc(t2, e2, r2) {
        t2[r2] = e2, t2[r2 + 1] = e2 >>> 8, t2[r2 + 2] = e2 >>> 16, t2[r2 + 3] = e2 >>> 24;
      }
      function Fc(t2, e2) {
        return (t2[e2] | t2[e2 + 1] << 8 | t2[e2 + 2] << 16) + (t2[e2 + 3] << 24);
      }
      function Lc(t2, e2, r2) {
        e2.glyphs = [], t2 === 1 && r2.readMessage(Rc, e2);
      }
      function Rc(t2, e2, r2) {
        if (t2 === 3) {
          const { id: t3, bitmap: n2, width: i3, height: s3, left: a2, top: o2, advance: l2 } = r2.readMessage(Uc, {});
          e2.glyphs.push({ id: t3, bitmap: new zl({ width: i3 + 6, height: s3 + 6 }, n2), metrics: { width: i3, height: s3, left: a2, top: o2, advance: l2 } });
        } else
          t2 === 4 ? e2.ascender = r2.readSVarint() : t2 === 5 && (e2.descender = r2.readSVarint());
      }
      function Uc(t2, e2, r2) {
        t2 === 1 ? e2.id = r2.readVarint() : t2 === 2 ? e2.bitmap = r2.readBytes() : t2 === 3 ? e2.width = r2.readVarint() : t2 === 4 ? e2.height = r2.readVarint() : t2 === 5 ? e2.left = r2.readSVarint() : t2 === 6 ? e2.top = r2.readSVarint() : t2 === 7 && (e2.advance = r2.readVarint());
      }
      function $c(t2) {
        let e2 = 0, r2 = 0;
        for (const n3 of t2)
          e2 += n3.w * n3.h, r2 = Math.max(r2, n3.w);
        t2.sort((t3, e3) => e3.h - t3.h);
        const n2 = [{ x: 0, y: 0, w: Math.max(Math.ceil(Math.sqrt(e2 / 0.95)), r2), h: 1 / 0 }];
        let i3 = 0, s3 = 0;
        for (const e3 of t2)
          for (let t3 = n2.length - 1; t3 >= 0; t3--) {
            const r3 = n2[t3];
            if (!(e3.w > r3.w || e3.h > r3.h)) {
              if (e3.x = r3.x, e3.y = r3.y, s3 = Math.max(s3, e3.y + e3.h), i3 = Math.max(i3, e3.x + e3.w), e3.w === r3.w && e3.h === r3.h) {
                const e4 = n2.pop();
                t3 < n2.length && (n2[t3] = e4);
              } else
                e3.h === r3.h ? (r3.x += e3.w, r3.w -= e3.w) : e3.w === r3.w ? (r3.y += e3.h, r3.h -= e3.h) : (n2.push({ x: r3.x + e3.w, y: r3.y, w: r3.w - e3.w, h: e3.h }), r3.y += e3.h, r3.h -= e3.h);
              break;
            }
          }
        return { w: i3, h: s3, fill: e2 / (i3 * s3) || 0 };
      }
      xc.prototype = { destroy: function() {
        this.buf = null;
      }, readFields: function(t2, e2, r2) {
        for (r2 = r2 || this.length; this.pos < r2; ) {
          var n2 = this.readVarint(), i3 = n2 >> 3, s3 = this.pos;
          this.type = 7 & n2, t2(i3, e2, this), this.pos === s3 && this.skip(n2);
        }
        return e2;
      }, readMessage: function(t2, e2) {
        return this.readFields(t2, e2, this.readVarint() + this.pos);
      }, readFixed32: function() {
        var t2 = Dc(this.buf, this.pos);
        return this.pos += 4, t2;
      }, readSFixed32: function() {
        var t2 = Fc(this.buf, this.pos);
        return this.pos += 4, t2;
      }, readFixed64: function() {
        var t2 = Dc(this.buf, this.pos) + Dc(this.buf, this.pos + 4) * vc;
        return this.pos += 8, t2;
      }, readSFixed64: function() {
        var t2 = Dc(this.buf, this.pos) + Fc(this.buf, this.pos + 4) * vc;
        return this.pos += 8, t2;
      }, readFloat: function() {
        var t2 = yc(this.buf, this.pos, true, 23, 4);
        return this.pos += 4, t2;
      }, readDouble: function() {
        var t2 = yc(this.buf, this.pos, true, 52, 8);
        return this.pos += 8, t2;
      }, readVarint: function(t2) {
        var e2, r2, n2 = this.buf;
        return e2 = 127 & (r2 = n2[this.pos++]), r2 < 128 ? e2 : (e2 |= (127 & (r2 = n2[this.pos++])) << 7, r2 < 128 ? e2 : (e2 |= (127 & (r2 = n2[this.pos++])) << 14, r2 < 128 ? e2 : (e2 |= (127 & (r2 = n2[this.pos++])) << 21, r2 < 128 ? e2 : function(t3, e3, r3) {
          var n3, i3, s3 = r3.buf;
          if (n3 = (112 & (i3 = s3[r3.pos++])) >> 4, i3 < 128)
            return Ac(t3, n3, e3);
          if (n3 |= (127 & (i3 = s3[r3.pos++])) << 3, i3 < 128)
            return Ac(t3, n3, e3);
          if (n3 |= (127 & (i3 = s3[r3.pos++])) << 10, i3 < 128)
            return Ac(t3, n3, e3);
          if (n3 |= (127 & (i3 = s3[r3.pos++])) << 17, i3 < 128)
            return Ac(t3, n3, e3);
          if (n3 |= (127 & (i3 = s3[r3.pos++])) << 24, i3 < 128)
            return Ac(t3, n3, e3);
          if (n3 |= (1 & (i3 = s3[r3.pos++])) << 31, i3 < 128)
            return Ac(t3, n3, e3);
          throw new Error("Expected varint not more than 10 bytes");
        }(e2 |= (15 & (r2 = n2[this.pos])) << 28, t2, this))));
      }, readVarint64: function() {
        return this.readVarint(true);
      }, readSVarint: function() {
        var t2 = this.readVarint();
        return t2 % 2 == 1 ? (t2 + 1) / -2 : t2 / 2;
      }, readBoolean: function() {
        return Boolean(this.readVarint());
      }, readString: function() {
        var t2 = this.readVarint() + this.pos, e2 = this.pos;
        return this.pos = t2, t2 - e2 >= 12 && wc ? function(t3, e3, r2) {
          return wc.decode(t3.subarray(e3, r2));
        }(this.buf, e2, t2) : function(t3, e3, r2) {
          for (var n2 = "", i3 = e3; i3 < r2; ) {
            var s3, a2, o2, l2 = t3[i3], u2 = null, c2 = l2 > 239 ? 4 : l2 > 223 ? 3 : l2 > 191 ? 2 : 1;
            if (i3 + c2 > r2)
              break;
            c2 === 1 ? l2 < 128 && (u2 = l2) : c2 === 2 ? (192 & (s3 = t3[i3 + 1])) == 128 && (u2 = (31 & l2) << 6 | 63 & s3) <= 127 && (u2 = null) : c2 === 3 ? (a2 = t3[i3 + 2], (192 & (s3 = t3[i3 + 1])) == 128 && (192 & a2) == 128 && ((u2 = (15 & l2) << 12 | (63 & s3) << 6 | 63 & a2) <= 2047 || u2 >= 55296 && u2 <= 57343) && (u2 = null)) : c2 === 4 && (a2 = t3[i3 + 2], o2 = t3[i3 + 3], (192 & (s3 = t3[i3 + 1])) == 128 && (192 & a2) == 128 && (192 & o2) == 128 && ((u2 = (15 & l2) << 18 | (63 & s3) << 12 | (63 & a2) << 6 | 63 & o2) <= 65535 || u2 >= 1114112) && (u2 = null)), u2 === null ? (u2 = 65533, c2 = 1) : u2 > 65535 && (u2 -= 65536, n2 += String.fromCharCode(u2 >>> 10 & 1023 | 55296), u2 = 56320 | 1023 & u2), n2 += String.fromCharCode(u2), i3 += c2;
          }
          return n2;
        }(this.buf, e2, t2);
      }, readBytes: function() {
        var t2 = this.readVarint() + this.pos, e2 = this.buf.subarray(this.pos, t2);
        return this.pos = t2, e2;
      }, readPackedVarint: function(t2, e2) {
        if (this.type !== xc.Bytes)
          return t2.push(this.readVarint(e2));
        var r2 = _c(this);
        for (t2 = t2 || []; this.pos < r2; )
          t2.push(this.readVarint(e2));
        return t2;
      }, readPackedSVarint: function(t2) {
        if (this.type !== xc.Bytes)
          return t2.push(this.readSVarint());
        var e2 = _c(this);
        for (t2 = t2 || []; this.pos < e2; )
          t2.push(this.readSVarint());
        return t2;
      }, readPackedBoolean: function(t2) {
        if (this.type !== xc.Bytes)
          return t2.push(this.readBoolean());
        var e2 = _c(this);
        for (t2 = t2 || []; this.pos < e2; )
          t2.push(this.readBoolean());
        return t2;
      }, readPackedFloat: function(t2) {
        if (this.type !== xc.Bytes)
          return t2.push(this.readFloat());
        var e2 = _c(this);
        for (t2 = t2 || []; this.pos < e2; )
          t2.push(this.readFloat());
        return t2;
      }, readPackedDouble: function(t2) {
        if (this.type !== xc.Bytes)
          return t2.push(this.readDouble());
        var e2 = _c(this);
        for (t2 = t2 || []; this.pos < e2; )
          t2.push(this.readDouble());
        return t2;
      }, readPackedFixed32: function(t2) {
        if (this.type !== xc.Bytes)
          return t2.push(this.readFixed32());
        var e2 = _c(this);
        for (t2 = t2 || []; this.pos < e2; )
          t2.push(this.readFixed32());
        return t2;
      }, readPackedSFixed32: function(t2) {
        if (this.type !== xc.Bytes)
          return t2.push(this.readSFixed32());
        var e2 = _c(this);
        for (t2 = t2 || []; this.pos < e2; )
          t2.push(this.readSFixed32());
        return t2;
      }, readPackedFixed64: function(t2) {
        if (this.type !== xc.Bytes)
          return t2.push(this.readFixed64());
        var e2 = _c(this);
        for (t2 = t2 || []; this.pos < e2; )
          t2.push(this.readFixed64());
        return t2;
      }, readPackedSFixed64: function(t2) {
        if (this.type !== xc.Bytes)
          return t2.push(this.readSFixed64());
        var e2 = _c(this);
        for (t2 = t2 || []; this.pos < e2; )
          t2.push(this.readSFixed64());
        return t2;
      }, skip: function(t2) {
        var e2 = 7 & t2;
        if (e2 === xc.Varint)
          for (; this.buf[this.pos++] > 127; )
            ;
        else if (e2 === xc.Bytes)
          this.pos = this.readVarint() + this.pos;
        else if (e2 === xc.Fixed32)
          this.pos += 4;
        else {
          if (e2 !== xc.Fixed64)
            throw new Error("Unimplemented type: " + e2);
          this.pos += 8;
        }
      }, writeTag: function(t2, e2) {
        this.writeVarint(t2 << 3 | e2);
      }, realloc: function(t2) {
        for (var e2 = this.length || 16; e2 < this.pos + t2; )
          e2 *= 2;
        if (e2 !== this.length) {
          var r2 = new Uint8Array(e2);
          r2.set(this.buf), this.buf = r2, this.length = e2;
        }
      }, finish: function() {
        return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
      }, writeFixed32: function(t2) {
        this.realloc(4), Vc(this.buf, t2, this.pos), this.pos += 4;
      }, writeSFixed32: function(t2) {
        this.realloc(4), Vc(this.buf, t2, this.pos), this.pos += 4;
      }, writeFixed64: function(t2) {
        this.realloc(8), Vc(this.buf, -1 & t2, this.pos), Vc(this.buf, Math.floor(t2 * bc), this.pos + 4), this.pos += 8;
      }, writeSFixed64: function(t2) {
        this.realloc(8), Vc(this.buf, -1 & t2, this.pos), Vc(this.buf, Math.floor(t2 * bc), this.pos + 4), this.pos += 8;
      }, writeVarint: function(t2) {
        (t2 = +t2 || 0) > 268435455 || t2 < 0 ? function(t3, e2) {
          var r2, n2;
          if (t3 >= 0 ? (r2 = t3 % 4294967296 | 0, n2 = t3 / 4294967296 | 0) : (n2 = ~(-t3 / 4294967296), 4294967295 ^ (r2 = ~(-t3 % 4294967296)) ? r2 = r2 + 1 | 0 : (r2 = 0, n2 = n2 + 1 | 0)), t3 >= 18446744073709552e3 || t3 < -18446744073709552e3)
            throw new Error("Given varint doesn't fit into 10 bytes");
          e2.realloc(10), function(t4, e3, r3) {
            r3.buf[r3.pos++] = 127 & t4 | 128, t4 >>>= 7, r3.buf[r3.pos++] = 127 & t4 | 128, t4 >>>= 7, r3.buf[r3.pos++] = 127 & t4 | 128, t4 >>>= 7, r3.buf[r3.pos++] = 127 & t4 | 128, r3.buf[r3.pos] = 127 & (t4 >>>= 7);
          }(r2, 0, e2), function(t4, e3) {
            var r3 = (7 & t4) << 4;
            e3.buf[e3.pos++] |= r3 | ((t4 >>>= 3) ? 128 : 0), t4 && (e3.buf[e3.pos++] = 127 & t4 | ((t4 >>>= 7) ? 128 : 0), t4 && (e3.buf[e3.pos++] = 127 & t4 | ((t4 >>>= 7) ? 128 : 0), t4 && (e3.buf[e3.pos++] = 127 & t4 | ((t4 >>>= 7) ? 128 : 0), t4 && (e3.buf[e3.pos++] = 127 & t4 | ((t4 >>>= 7) ? 128 : 0), t4 && (e3.buf[e3.pos++] = 127 & t4)))));
          }(n2, e2);
        }(t2, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t2 | (t2 > 127 ? 128 : 0), t2 <= 127 || (this.buf[this.pos++] = 127 & (t2 >>>= 7) | (t2 > 127 ? 128 : 0), t2 <= 127 || (this.buf[this.pos++] = 127 & (t2 >>>= 7) | (t2 > 127 ? 128 : 0), t2 <= 127 || (this.buf[this.pos++] = t2 >>> 7 & 127))));
      }, writeSVarint: function(t2) {
        this.writeVarint(t2 < 0 ? 2 * -t2 - 1 : 2 * t2);
      }, writeBoolean: function(t2) {
        this.writeVarint(Boolean(t2));
      }, writeString: function(t2) {
        t2 = String(t2), this.realloc(4 * t2.length), this.pos++;
        var e2 = this.pos;
        this.pos = function(t3, e3, r3) {
          for (var n2, i3, s3 = 0; s3 < e3.length; s3++) {
            if ((n2 = e3.charCodeAt(s3)) > 55295 && n2 < 57344) {
              if (!i3) {
                n2 > 56319 || s3 + 1 === e3.length ? (t3[r3++] = 239, t3[r3++] = 191, t3[r3++] = 189) : i3 = n2;
                continue;
              }
              if (n2 < 56320) {
                t3[r3++] = 239, t3[r3++] = 191, t3[r3++] = 189, i3 = n2;
                continue;
              }
              n2 = i3 - 55296 << 10 | n2 - 56320 | 65536, i3 = null;
            } else
              i3 && (t3[r3++] = 239, t3[r3++] = 191, t3[r3++] = 189, i3 = null);
            n2 < 128 ? t3[r3++] = n2 : (n2 < 2048 ? t3[r3++] = n2 >> 6 | 192 : (n2 < 65536 ? t3[r3++] = n2 >> 12 | 224 : (t3[r3++] = n2 >> 18 | 240, t3[r3++] = n2 >> 12 & 63 | 128), t3[r3++] = n2 >> 6 & 63 | 128), t3[r3++] = 63 & n2 | 128);
          }
          return r3;
        }(this.buf, t2, this.pos);
        var r2 = this.pos - e2;
        r2 >= 128 && kc(e2, r2, this), this.pos = e2 - 1, this.writeVarint(r2), this.pos += r2;
      }, writeFloat: function(t2) {
        this.realloc(4), mc(this.buf, t2, this.pos, true, 23, 4), this.pos += 4;
      }, writeDouble: function(t2) {
        this.realloc(8), mc(this.buf, t2, this.pos, true, 52, 8), this.pos += 8;
      }, writeBytes: function(t2) {
        var e2 = t2.length;
        this.writeVarint(e2), this.realloc(e2);
        for (var r2 = 0; r2 < e2; r2++)
          this.buf[this.pos++] = t2[r2];
      }, writeRawMessage: function(t2, e2) {
        this.pos++;
        var r2 = this.pos;
        t2(e2, this);
        var n2 = this.pos - r2;
        n2 >= 128 && kc(r2, n2, this), this.pos = r2 - 1, this.writeVarint(n2), this.pos += n2;
      }, writeMessage: function(t2, e2, r2) {
        this.writeTag(t2, xc.Bytes), this.writeRawMessage(e2, r2);
      }, writePackedVarint: function(t2, e2) {
        e2.length && this.writeMessage(t2, Sc, e2);
      }, writePackedSVarint: function(t2, e2) {
        e2.length && this.writeMessage(t2, Ic, e2);
      }, writePackedBoolean: function(t2, e2) {
        e2.length && this.writeMessage(t2, Tc, e2);
      }, writePackedFloat: function(t2, e2) {
        e2.length && this.writeMessage(t2, zc, e2);
      }, writePackedDouble: function(t2, e2) {
        e2.length && this.writeMessage(t2, Mc, e2);
      }, writePackedFixed32: function(t2, e2) {
        e2.length && this.writeMessage(t2, Bc, e2);
      }, writePackedSFixed32: function(t2, e2) {
        e2.length && this.writeMessage(t2, Cc, e2);
      }, writePackedFixed64: function(t2, e2) {
        e2.length && this.writeMessage(t2, Pc, e2);
      }, writePackedSFixed64: function(t2, e2) {
        e2.length && this.writeMessage(t2, Ec, e2);
      }, writeBytesField: function(t2, e2) {
        this.writeTag(t2, xc.Bytes), this.writeBytes(e2);
      }, writeFixed32Field: function(t2, e2) {
        this.writeTag(t2, xc.Fixed32), this.writeFixed32(e2);
      }, writeSFixed32Field: function(t2, e2) {
        this.writeTag(t2, xc.Fixed32), this.writeSFixed32(e2);
      }, writeFixed64Field: function(t2, e2) {
        this.writeTag(t2, xc.Fixed64), this.writeFixed64(e2);
      }, writeSFixed64Field: function(t2, e2) {
        this.writeTag(t2, xc.Fixed64), this.writeSFixed64(e2);
      }, writeVarintField: function(t2, e2) {
        this.writeTag(t2, xc.Varint), this.writeVarint(e2);
      }, writeSVarintField: function(t2, e2) {
        this.writeTag(t2, xc.Varint), this.writeSVarint(e2);
      }, writeStringField: function(t2, e2) {
        this.writeTag(t2, xc.Bytes), this.writeString(e2);
      }, writeFloatField: function(t2, e2) {
        this.writeTag(t2, xc.Fixed32), this.writeFloat(e2);
      }, writeDoubleField: function(t2, e2) {
        this.writeTag(t2, xc.Fixed64), this.writeDouble(e2);
      }, writeBooleanField: function(t2, e2) {
        this.writeVarintField(t2, Boolean(e2));
      } };
      class Oc {
        constructor(t2, { pixelRatio: e2, version: r2, stretchX: n2, stretchY: i3, content: s3 }) {
          this.paddedRect = t2, this.pixelRatio = e2, this.stretchX = n2, this.stretchY = i3, this.content = s3, this.version = r2;
        }
        get tl() {
          return [this.paddedRect.x + 1, this.paddedRect.y + 1];
        }
        get br() {
          return [this.paddedRect.x + this.paddedRect.w - 1, this.paddedRect.y + this.paddedRect.h - 1];
        }
        get displaySize() {
          return [(this.paddedRect.w - 2) / this.pixelRatio, (this.paddedRect.h - 2) / this.pixelRatio];
        }
      }
      class jc {
        constructor(t2, e2) {
          const r2 = {}, n2 = {};
          this.haveRenderCallbacks = [];
          const i3 = [];
          this.addImages(t2, r2, i3), this.addImages(e2, n2, i3);
          const { w: s3, h: a2 } = $c(i3), o2 = new Ml({ width: s3 || 1, height: a2 || 1 });
          for (const e3 in t2) {
            const n3 = t2[e3], i4 = r2[e3].paddedRect;
            Ml.copy(n3.data, o2, { x: 0, y: 0 }, { x: i4.x + 1, y: i4.y + 1 }, n3.data);
          }
          for (const t3 in e2) {
            const r3 = e2[t3], i4 = n2[t3].paddedRect, s4 = i4.x + 1, a3 = i4.y + 1, l2 = r3.data.width, u2 = r3.data.height;
            Ml.copy(r3.data, o2, { x: 0, y: 0 }, { x: s4, y: a3 }, r3.data), Ml.copy(r3.data, o2, { x: 0, y: u2 - 1 }, { x: s4, y: a3 - 1 }, { width: l2, height: 1 }), Ml.copy(r3.data, o2, { x: 0, y: 0 }, { x: s4, y: a3 + u2 }, { width: l2, height: 1 }), Ml.copy(r3.data, o2, { x: l2 - 1, y: 0 }, { x: s4 - 1, y: a3 }, { width: 1, height: u2 }), Ml.copy(r3.data, o2, { x: 0, y: 0 }, { x: s4 + l2, y: a3 }, { width: 1, height: u2 });
          }
          this.image = o2, this.iconPositions = r2, this.patternPositions = n2;
        }
        addImages(t2, e2, r2) {
          for (const n2 in t2) {
            const i3 = t2[n2], s3 = { x: 0, y: 0, w: i3.data.width + 2, h: i3.data.height + 2 };
            r2.push(s3), e2[n2] = new Oc(s3, i3), i3.hasRenderCallback && this.haveRenderCallbacks.push(n2);
          }
        }
        patchUpdatedImages(t2, e2) {
          t2.dispatchRenderCallbacks(this.haveRenderCallbacks);
          for (const r2 in t2.updatedImages)
            this.patchUpdatedImage(this.iconPositions[r2], t2.getImage(r2), e2), this.patchUpdatedImage(this.patternPositions[r2], t2.getImage(r2), e2);
        }
        patchUpdatedImage(t2, e2, r2) {
          if (!t2 || !e2)
            return;
          if (t2.version === e2.version)
            return;
          t2.version = e2.version;
          const [n2, i3] = t2.tl;
          r2.update(e2.data, void 0, { x: n2, y: i3 });
        }
      }
      Zi("ImagePosition", Oc), Zi("ImageAtlas", jc);
      const qc = { horizontal: 1, vertical: 2, horizontalOnly: 3 };
      class Nc {
        constructor() {
          this.scale = 1, this.fontStack = "", this.imageName = null;
        }
        static forText(t2, e2) {
          const r2 = new Nc();
          return r2.scale = t2 || 1, r2.fontStack = e2, r2;
        }
        static forImage(t2) {
          const e2 = new Nc();
          return e2.imageName = t2, e2;
        }
      }
      class Gc {
        constructor() {
          this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
        }
        static fromFeature(t2, e2) {
          const r2 = new Gc();
          for (let n2 = 0; n2 < t2.sections.length; n2++) {
            const i3 = t2.sections[n2];
            i3.image ? r2.addImageSection(i3) : r2.addTextSection(i3, e2);
          }
          return r2;
        }
        length() {
          return this.text.length;
        }
        getSection(t2) {
          return this.sections[this.sectionIndex[t2]];
        }
        getSections() {
          return this.sections;
        }
        getSectionIndex(t2) {
          return this.sectionIndex[t2];
        }
        getCharCode(t2) {
          return this.text.charCodeAt(t2);
        }
        verticalizePunctuation(t2) {
          this.text = function(t3, e2) {
            let r2 = "";
            for (let n2 = 0; n2 < t3.length; n2++) {
              const i3 = t3.charCodeAt(n2 + 1) || null, s3 = t3.charCodeAt(n2 - 1) || null;
              r2 += !e2 && (i3 && Ts(i3) && !pc[t3[n2 + 1]] || s3 && Ts(s3) && !pc[t3[n2 - 1]]) || !pc[t3[n2]] ? t3[n2] : pc[t3[n2]];
            }
            return r2;
          }(this.text, t2);
        }
        trim() {
          let t2 = 0;
          for (let e3 = 0; e3 < this.text.length && Xc[this.text.charCodeAt(e3)]; e3++)
            t2++;
          let e2 = this.text.length;
          for (let r2 = this.text.length - 1; r2 >= 0 && r2 >= t2 && Xc[this.text.charCodeAt(r2)]; r2--)
            e2--;
          this.text = this.text.substring(t2, e2), this.sectionIndex = this.sectionIndex.slice(t2, e2);
        }
        substring(t2, e2) {
          const r2 = new Gc();
          return r2.text = this.text.substring(t2, e2), r2.sectionIndex = this.sectionIndex.slice(t2, e2), r2.sections = this.sections, r2;
        }
        toString() {
          return this.text;
        }
        getMaxScale() {
          return this.sectionIndex.reduce((t2, e2) => Math.max(t2, this.sections[e2].scale), 0);
        }
        addTextSection(t2, e2) {
          this.text += t2.text, this.sections.push(Nc.forText(t2.scale, t2.fontStack || e2));
          const r2 = this.sections.length - 1;
          for (let e3 = 0; e3 < t2.text.length; ++e3)
            this.sectionIndex.push(r2);
        }
        addImageSection(t2) {
          const e2 = t2.image ? t2.image.name : "";
          if (e2.length === 0)
            return void pt("Can't add FormattedSection with an empty image.");
          const r2 = this.getNextImageSectionCharCode();
          r2 ? (this.text += String.fromCharCode(r2), this.sections.push(Nc.forImage(e2)), this.sectionIndex.push(this.sections.length - 1)) : pt("Reached maximum number of images 6401");
        }
        getNextImageSectionCharCode() {
          return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
        }
      }
      function Zc(t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2, h2, p2, d2, f2, y2) {
        const m2 = Gc.fromFeature(t2, i3);
        let g2;
        h2 === qc.vertical && m2.verticalizePunctuation(p2);
        const { processBidirectionalText: x3, processStyledBidirectionalText: v3 } = Ns;
        if (x3 && m2.sections.length === 1) {
          g2 = [];
          const t3 = x3(m2.toString(), th(m2, u2, s3, e2, n2, d2, f2));
          for (const e3 of t3) {
            const t4 = new Gc();
            t4.text = e3, t4.sections = m2.sections;
            for (let r3 = 0; r3 < e3.length; r3++)
              t4.sectionIndex.push(0);
            g2.push(t4);
          }
        } else if (v3) {
          g2 = [];
          const t3 = v3(m2.text, m2.sectionIndex, th(m2, u2, s3, e2, n2, d2, f2));
          for (const e3 of t3) {
            const t4 = new Gc();
            t4.text = e3[0], t4.sectionIndex = e3[1], t4.sections = m2.sections, g2.push(t4);
          }
        } else
          g2 = function(t3, e3) {
            const r3 = [], n3 = t3.text;
            let i4 = 0;
            for (const n4 of e3)
              r3.push(t3.substring(i4, n4)), i4 = n4;
            return i4 < n3.length && r3.push(t3.substring(i4, n3.length)), r3;
          }(m2, th(m2, u2, s3, e2, n2, d2, f2));
        const b2 = [], w2 = { positionedLines: b2, text: m2.toString(), top: c2[1], bottom: c2[1], left: c2[0], right: c2[0], writingMode: h2, iconsInText: false, verticalizable: false, hasBaseline: false };
        return function(t3, e3, r3, n3, i4, s4, a3, o3, l3, u3, c3, h3) {
          let p3 = 0, d3 = 0, f3 = 0;
          const y3 = o3 === "right" ? 1 : o3 === "left" ? 0 : 0.5;
          let m3 = false;
          for (const t4 of i4) {
            const r4 = t4.getSections();
            for (const t5 of r4) {
              if (t5.imageName)
                continue;
              const r5 = e3[t5.fontStack];
              if (r5 && (m3 = r5.ascender !== void 0 && r5.descender !== void 0, !m3))
                break;
            }
            if (!m3)
              break;
          }
          let g3 = 0;
          for (const a4 of i4) {
            a4.trim();
            const i5 = a4.getMaxScale(), o4 = (i5 - 1) * sc, v5 = { positionedGlyphs: [], lineOffset: 0 };
            t3.positionedLines[g3] = v5;
            const b4 = v5.positionedGlyphs;
            let w4 = 0;
            if (!a4.length()) {
              d3 += s4, ++g3;
              continue;
            }
            let _2 = 0, A3 = 0;
            for (let s5 = 0; s5 < a4.length(); s5++) {
              const o5 = a4.getSection(s5), f4 = a4.getSectionIndex(s5), y4 = a4.getCharCode(s5);
              let g4 = o5.scale, v6 = null, k3 = null, S3 = null, I3 = sc, z2 = 0;
              const M3 = !(l3 === qc.horizontal || !c3 && !Ms(y4) || c3 && (Xc[y4] || (x4 = y4, Wi(x4) || Qi(x4) || ts(x4) || vs(x4) || As(x4))));
              if (o5.imageName) {
                const e4 = n3[o5.imageName];
                if (!e4)
                  continue;
                S3 = o5.imageName, t3.iconsInText = t3.iconsInText || true, k3 = e4.paddedRect;
                const r4 = e4.displaySize;
                g4 = g4 * sc / h3, v6 = { width: r4[0], height: r4[1], left: 1, top: -3, advance: M3 ? r4[1] : r4[0], localGlyph: false }, z2 = m3 ? -v6.height * g4 : i5 * sc - 17 - r4[1] * g4, I3 = v6.advance;
                const s6 = (M3 ? r4[0] : r4[1]) * g4 - sc * i5;
                s6 > 0 && s6 > w4 && (w4 = s6);
              } else {
                const t4 = r3[o5.fontStack];
                if (!t4)
                  continue;
                t4[y4] && (k3 = t4[y4]);
                const n4 = e3[o5.fontStack];
                if (!n4)
                  continue;
                const s6 = n4.glyphs[y4];
                if (!s6)
                  continue;
                if (v6 = s6.metrics, I3 = y4 !== 8203 ? sc : 0, m3) {
                  const t5 = n4.ascender !== void 0 ? Math.abs(n4.ascender) : 0, e4 = n4.descender !== void 0 ? Math.abs(n4.descender) : 0, r4 = (t5 + e4) * g4;
                  _2 < r4 && (_2 = r4, A3 = (t5 - e4) / 2 * g4), z2 = -t5 * g4;
                } else
                  z2 = (i5 - g4) * sc - 17;
              }
              M3 ? (t3.verticalizable = true, b4.push({ glyph: y4, imageName: S3, x: p3, y: d3 + z2, vertical: M3, scale: g4, localGlyph: v6.localGlyph, fontStack: o5.fontStack, sectionIndex: f4, metrics: v6, rect: k3 }), p3 += I3 * g4 + u3) : (b4.push({ glyph: y4, imageName: S3, x: p3, y: d3 + z2, vertical: M3, scale: g4, localGlyph: v6.localGlyph, fontStack: o5.fontStack, sectionIndex: f4, metrics: v6, rect: k3 }), p3 += v6.advance * g4 + u3);
            }
            b4.length !== 0 && (f3 = Math.max(p3 - u3, f3), m3 ? rh(b4, y3, w4, A3, s4 * i5 / 2) : rh(b4, y3, w4, 0, s4 / 2)), p3 = 0;
            const k2 = s4 * i5 + w4;
            v5.lineOffset = Math.max(w4, o4), d3 += k2, ++g3;
          }
          var x4;
          const v4 = d3, { horizontalAlign: b3, verticalAlign: w3 } = eh(a3);
          (function(t4, e4, r4, n4, i5, s5) {
            const a4 = (e4 - r4) * i5, o4 = -s5 * n4;
            for (const e5 of t4)
              for (const t5 of e5.positionedGlyphs)
                t5.x += a4, t5.y += o4;
          })(t3.positionedLines, y3, b3, w3, f3, v4), t3.top += -w3 * v4, t3.bottom = t3.top + v4, t3.left += -b3 * f3, t3.right = t3.left + f3, t3.hasBaseline = m3;
        }(w2, e2, r2, n2, g2, a2, o2, l2, h2, u2, p2, y2), !function(t3) {
          for (const e3 of t3)
            if (e3.positionedGlyphs.length !== 0)
              return false;
          return true;
        }(b2) && w2;
      }
      const Xc = { 9: true, 10: true, 11: true, 12: true, 13: true, 32: true }, Kc = { 10: true, 32: true, 38: true, 40: true, 41: true, 43: true, 45: true, 47: true, 173: true, 183: true, 8203: true, 8208: true, 8211: true, 8231: true };
      function Yc(t2, e2, r2, n2, i3, s3) {
        if (e2.imageName) {
          const t3 = n2[e2.imageName];
          return t3 ? t3.displaySize[0] * e2.scale * sc / s3 + i3 : 0;
        }
        {
          const n3 = r2[e2.fontStack], s4 = n3 && n3.glyphs[t2];
          return s4 ? s4.metrics.advance * e2.scale + i3 : 0;
        }
      }
      function Hc(t2, e2, r2, n2) {
        const i3 = Math.pow(t2 - e2, 2);
        return n2 ? t2 < e2 ? i3 / 2 : 2 * i3 : i3 + Math.abs(r2) * r2;
      }
      function Jc(t2, e2, r2) {
        let n2 = 0;
        return t2 === 10 && (n2 -= 1e4), r2 && (n2 += 150), t2 !== 40 && t2 !== 65288 || (n2 += 50), e2 !== 41 && e2 !== 65289 || (n2 += 50), n2;
      }
      function Wc(t2, e2, r2, n2, i3, s3) {
        let a2 = null, o2 = Hc(e2, r2, i3, s3);
        for (const t3 of n2) {
          const n3 = Hc(e2 - t3.x, r2, i3, s3) + t3.badness;
          n3 <= o2 && (a2 = t3, o2 = n3);
        }
        return { index: t2, x: e2, priorBreak: a2, badness: o2 };
      }
      function Qc(t2) {
        return t2 ? Qc(t2.priorBreak).concat(t2.index) : [];
      }
      function th(t2, e2, r2, n2, i3, s3, a2) {
        if (s3 !== "point")
          return [];
        if (!t2)
          return [];
        const o2 = [], l2 = function(t3, e3, r3, n3, i4, s4) {
          let a3 = 0;
          for (let r4 = 0; r4 < t3.length(); r4++) {
            const o3 = t3.getSection(r4);
            a3 += Yc(t3.getCharCode(r4), o3, n3, i4, e3, s4);
          }
          return a3 / Math.max(1, Math.ceil(a3 / r3));
        }(t2, e2, r2, n2, i3, a2), u2 = t2.text.indexOf("\u200B") >= 0;
        let c2 = 0;
        for (let r3 = 0; r3 < t2.length(); r3++) {
          const s4 = t2.getSection(r3), p2 = t2.getCharCode(r3);
          if (Xc[p2] || (c2 += Yc(p2, s4, n2, i3, e2, a2)), r3 < t2.length() - 1) {
            const e3 = !((h2 = p2) < 11904 || !(ls(h2) || os2(h2) || ws(h2) || xs(h2) || ps(h2) || es(h2) || us(h2) || is2(h2) || ds(h2) || fs(h2) || hs(h2) || ks(h2) || ss(h2) || ns(h2) || rs(h2) || cs(h2) || as2(h2) || bs(h2) || ms(h2) || ys(h2)));
            (Kc[p2] || e3 || s4.imageName) && o2.push(Wc(r3 + 1, c2, l2, o2, Jc(p2, t2.getCharCode(r3 + 1), e3 && u2), false));
          }
        }
        var h2;
        return Qc(Wc(t2.length(), c2, l2, o2, 0, true));
      }
      function eh(t2) {
        let e2 = 0.5, r2 = 0.5;
        switch (t2) {
          case "right":
          case "top-right":
          case "bottom-right":
            e2 = 1;
            break;
          case "left":
          case "top-left":
          case "bottom-left":
            e2 = 0;
        }
        switch (t2) {
          case "bottom":
          case "bottom-right":
          case "bottom-left":
            r2 = 1;
            break;
          case "top":
          case "top-right":
          case "top-left":
            r2 = 0;
        }
        return { horizontalAlign: e2, verticalAlign: r2 };
      }
      function rh(t2, e2, r2, n2, i3) {
        if (!(e2 || r2 || n2 || i3))
          return;
        const s3 = t2.length - 1, a2 = t2[s3], o2 = (a2.x + a2.metrics.advance * a2.scale) * e2;
        for (let e3 = 0; e3 <= s3; e3++)
          t2[e3].x -= o2, t2[e3].y += r2 + n2 + i3;
      }
      function nh(t2, e2, r2) {
        const { horizontalAlign: n2, verticalAlign: i3 } = eh(r2), s3 = e2[0] - t2.displaySize[0] * n2, a2 = e2[1] - t2.displaySize[1] * i3;
        return { image: t2, top: a2, bottom: a2 + t2.displaySize[1], left: s3, right: s3 + t2.displaySize[0] };
      }
      function ih(t2, e2, r2, n2, i3, s3) {
        const a2 = t2.image;
        let o2;
        if (a2.content) {
          const t3 = a2.content, e3 = a2.pixelRatio || 1;
          o2 = [t3[0] / e3, t3[1] / e3, a2.displaySize[0] - t3[2] / e3, a2.displaySize[1] - t3[3] / e3];
        }
        const l2 = e2.left * s3, u2 = e2.right * s3;
        let c2, h2, p2, d2;
        r2 === "width" || r2 === "both" ? (d2 = i3[0] + l2 - n2[3], h2 = i3[0] + u2 + n2[1]) : (d2 = i3[0] + (l2 + u2 - a2.displaySize[0]) / 2, h2 = d2 + a2.displaySize[0]);
        const f2 = e2.top * s3, y2 = e2.bottom * s3;
        return r2 === "height" || r2 === "both" ? (c2 = i3[1] + f2 - n2[0], p2 = i3[1] + y2 + n2[2]) : (c2 = i3[1] + (f2 + y2 - a2.displaySize[1]) / 2, p2 = c2 + a2.displaySize[1]), { image: a2, top: c2, right: h2, bottom: p2, left: d2, collisionPadding: o2 };
      }
      class sh extends i2 {
        constructor(t2, e2, r2, n2, i3) {
          super(t2, e2), this.angle = n2, this.z = r2, i3 !== void 0 && (this.segment = i3);
        }
        clone() {
          return new sh(this.x, this.y, this.z, this.angle, this.segment);
        }
      }
      function ah(t2, e2, r2, n2, i3) {
        if (e2.segment === void 0)
          return true;
        let s3 = e2, a2 = e2.segment + 1, o2 = 0;
        for (; o2 > -r2 / 2; ) {
          if (a2--, a2 < 0)
            return false;
          o2 -= t2[a2].dist(s3), s3 = t2[a2];
        }
        o2 += t2[a2].dist(t2[a2 + 1]), a2++;
        const l2 = [];
        let u2 = 0;
        for (; o2 < r2 / 2; ) {
          const e3 = t2[a2], r3 = t2[a2 + 1];
          if (!r3)
            return false;
          let s4 = t2[a2 - 1].angleTo(e3) - e3.angleTo(r3);
          for (s4 = Math.abs((s4 + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l2.push({ distance: o2, angleDelta: s4 }), u2 += s4; o2 - l2[0].distance > n2; )
            u2 -= l2.shift().angleDelta;
          if (u2 > i3)
            return false;
          a2++, o2 += e3.dist(r3);
        }
        return true;
      }
      function oh(t2) {
        let e2 = 0;
        for (let r2 = 0; r2 < t2.length - 1; r2++)
          e2 += t2[r2].dist(t2[r2 + 1]);
        return e2;
      }
      function lh(t2, e2, r2) {
        return t2 ? 0.6 * e2 * r2 : 0;
      }
      function uh(t2, e2) {
        return Math.max(t2 ? t2.right - t2.left : 0, e2 ? e2.right - e2.left : 0);
      }
      function ch(t2, e2, r2, n2, i3, s3) {
        const a2 = lh(r2, i3, s3), o2 = uh(r2, n2) * s3;
        let l2 = 0;
        const u2 = oh(t2) / 2;
        for (let r3 = 0; r3 < t2.length - 1; r3++) {
          const n3 = t2[r3], i4 = t2[r3 + 1], s4 = n3.dist(i4);
          if (l2 + s4 > u2) {
            const c2 = (u2 - l2) / s4, h2 = Lr(n3.x, i4.x, c2), p2 = Lr(n3.y, i4.y, c2), d2 = new sh(h2, p2, 0, i4.angleTo(n3), r3);
            return !a2 || ah(t2, d2, o2, a2, e2) ? d2 : void 0;
          }
          l2 += s4;
        }
      }
      function hh(t2, e2, r2, n2, i3, s3, a2, o2, l2) {
        const u2 = lh(n2, s3, a2), c2 = uh(n2, i3), h2 = c2 * a2, p2 = t2[0].x === 0 || t2[0].x === l2 || t2[0].y === 0 || t2[0].y === l2;
        return e2 - h2 < e2 / 4 && (e2 = h2 + e2 / 4), ph(t2, p2 ? e2 / 2 * o2 % e2 : (c2 / 2 + 2 * s3) * a2 * o2 % e2, e2, u2, r2, h2, p2, false, l2);
      }
      function ph(t2, e2, r2, n2, i3, s3, a2, o2, l2) {
        const u2 = s3 / 2, c2 = oh(t2);
        let h2 = 0, p2 = e2 - r2, d2 = [];
        for (let e3 = 0; e3 < t2.length - 1; e3++) {
          const a3 = t2[e3], o3 = t2[e3 + 1], f2 = a3.dist(o3), y2 = o3.angleTo(a3);
          for (; p2 + r2 < h2 + f2; ) {
            p2 += r2;
            const m2 = (p2 - h2) / f2, g2 = Lr(a3.x, o3.x, m2), x3 = Lr(a3.y, o3.y, m2);
            if (g2 >= 0 && g2 < l2 && x3 >= 0 && x3 < l2 && p2 - u2 >= 0 && p2 + u2 <= c2) {
              const r3 = new sh(g2, x3, 0, y2, e3);
              r3._round(), n2 && !ah(t2, r3, s3, n2, i3) || d2.push(r3);
            }
          }
          h2 += f2;
        }
        return o2 || d2.length || a2 || (d2 = ph(t2, h2 / 2, r2, n2, i3, s3, a2, true, l2)), d2;
      }
      function dh(t2, e2, r2, n2, s3) {
        const a2 = [];
        for (let o2 = 0; o2 < t2.length; o2++) {
          const l2 = t2[o2];
          let u2;
          for (let t3 = 0; t3 < l2.length - 1; t3++) {
            let o3 = l2[t3], c2 = l2[t3 + 1];
            o3.x < e2 && c2.x < e2 || (o3.x < e2 ? o3 = new i2(e2, o3.y + (e2 - o3.x) / (c2.x - o3.x) * (c2.y - o3.y))._round() : c2.x < e2 && (c2 = new i2(e2, o3.y + (e2 - o3.x) / (c2.x - o3.x) * (c2.y - o3.y))._round()), o3.y < r2 && c2.y < r2 || (o3.y < r2 ? o3 = new i2(o3.x + (r2 - o3.y) / (c2.y - o3.y) * (c2.x - o3.x), r2)._round() : c2.y < r2 && (c2 = new i2(o3.x + (r2 - o3.y) / (c2.y - o3.y) * (c2.x - o3.x), r2)._round()), o3.x >= n2 && c2.x >= n2 || (o3.x >= n2 ? o3 = new i2(n2, o3.y + (n2 - o3.x) / (c2.x - o3.x) * (c2.y - o3.y))._round() : c2.x >= n2 && (c2 = new i2(n2, o3.y + (n2 - o3.x) / (c2.x - o3.x) * (c2.y - o3.y))._round()), o3.y >= s3 && c2.y >= s3 || (o3.y >= s3 ? o3 = new i2(o3.x + (s3 - o3.y) / (c2.y - o3.y) * (c2.x - o3.x), s3)._round() : c2.y >= s3 && (c2 = new i2(o3.x + (s3 - o3.y) / (c2.y - o3.y) * (c2.x - o3.x), s3)._round()), u2 && o3.equals(u2[u2.length - 1]) || (u2 = [o3], a2.push(u2)), u2.push(c2)))));
          }
        }
        return a2;
      }
      Zi("Anchor", sh);
      const fh = 1e20;
      function yh(t2, e2, r2, n2, i3, s3, a2, o2, l2) {
        for (let u2 = e2; u2 < e2 + n2; u2++)
          mh(t2, r2 * s3 + u2, s3, i3, a2, o2, l2);
        for (let u2 = r2; u2 < r2 + i3; u2++)
          mh(t2, u2 * s3 + e2, 1, n2, a2, o2, l2);
      }
      function mh(t2, e2, r2, n2, i3, s3, a2) {
        s3[0] = 0, a2[0] = -fh, a2[1] = fh, i3[0] = t2[e2];
        for (let o2 = 1, l2 = 0, u2 = 0; o2 < n2; o2++) {
          i3[o2] = t2[e2 + o2 * r2];
          const n3 = o2 * o2;
          do {
            const t3 = s3[l2];
            u2 = (i3[o2] - i3[t3] + n3 - t3 * t3) / (o2 - t3) / 2;
          } while (u2 <= a2[l2] && --l2 > -1);
          l2++, s3[l2] = o2, a2[l2] = u2, a2[l2 + 1] = fh;
        }
        for (let o2 = 0, l2 = 0; o2 < n2; o2++) {
          for (; a2[l2 + 1] < o2; )
            l2++;
          const n3 = s3[l2], u2 = o2 - n3;
          t2[e2 + o2 * r2] = i3[n3] + u2 * u2;
        }
      }
      const gh = { none: 0, ideographs: 1, all: 2 };
      class xh {
        constructor(t2, e2, r2) {
          this.requestManager = t2, this.localGlyphMode = e2, this.localFontFamily = r2, this.entries = {}, this.localGlyphs = { 200: {}, 400: {}, 500: {}, 900: {} };
        }
        setURL(t2) {
          this.url = t2;
        }
        getGlyphs(t2, e2) {
          const r2 = [];
          for (const e3 in t2)
            for (const n2 of t2[e3])
              r2.push({ stack: e3, id: n2 });
          W(r2, ({ stack: t3, id: e3 }, r3) => {
            let n2 = this.entries[t3];
            n2 || (n2 = this.entries[t3] = { glyphs: {}, requests: {}, ranges: {}, ascender: void 0, descender: void 0 });
            let i3 = n2.glyphs[e3];
            if (i3 !== void 0)
              return void r3(null, { stack: t3, id: e3, glyph: i3 });
            if (i3 = this._tinySDF(n2, t3, e3), i3)
              return n2.glyphs[e3] = i3, void r3(null, { stack: t3, id: e3, glyph: i3 });
            const s3 = Math.floor(e3 / 256);
            if (256 * s3 > 65535)
              return void r3(new Error("glyphs > 65535 not supported"));
            if (n2.ranges[s3])
              return void r3(null, { stack: t3, id: e3, glyph: i3 });
            let a2 = n2.requests[s3];
            a2 || (a2 = n2.requests[s3] = [], xh.loadGlyphRange(t3, s3, this.url, this.requestManager, (t4, e4) => {
              if (e4) {
                n2.ascender = e4.ascender, n2.descender = e4.descender;
                for (const t5 in e4.glyphs)
                  this._doesCharSupportLocalGlyph(+t5) || (n2.glyphs[+t5] = e4.glyphs[+t5]);
                n2.ranges[s3] = true;
              }
              for (const r4 of a2)
                r4(t4, e4);
              delete n2.requests[s3];
            })), a2.push((n3, i4) => {
              n3 ? r3(n3) : i4 && r3(null, { stack: t3, id: e3, glyph: i4.glyphs[e3] || null });
            });
          }, (t3, r3) => {
            if (t3)
              e2(t3);
            else if (r3) {
              const t4 = {};
              for (const { stack: e3, id: n2, glyph: i3 } of r3)
                t4[e3] === void 0 && (t4[e3] = {}), t4[e3].glyphs === void 0 && (t4[e3].glyphs = {}), t4[e3].glyphs[n2] = i3 && { id: i3.id, bitmap: i3.bitmap.clone(), metrics: i3.metrics }, t4[e3].ascender = this.entries[e3].ascender, t4[e3].descender = this.entries[e3].descender;
              e2(null, t4);
            }
          });
        }
        _doesCharSupportLocalGlyph(t2) {
          return this.localGlyphMode !== gh.none && (this.localGlyphMode === gh.all ? !!this.localFontFamily : !!this.localFontFamily && (fs(t2) || gs(t2) || ss(t2) || as2(t2)) || is2(t2));
        }
        _tinySDF(t2, e2, r2) {
          const n2 = this.localFontFamily;
          if (!n2 || !this._doesCharSupportLocalGlyph(r2))
            return;
          let i3 = t2.tinySDF;
          if (!i3) {
            let r3 = "400";
            /bold/i.test(e2) ? r3 = "900" : /medium/i.test(e2) ? r3 = "500" : /light/i.test(e2) && (r3 = "200"), i3 = t2.tinySDF = new xh.TinySDF({ fontFamily: n2, fontWeight: r3, fontSize: 48, buffer: 6, radius: 16 }), i3.fontWeight = r3;
          }
          if (this.localGlyphs[i3.fontWeight][r2])
            return this.localGlyphs[i3.fontWeight][r2];
          const s3 = String.fromCharCode(r2), { data: a2, width: o2, height: l2, glyphWidth: u2, glyphHeight: c2, glyphLeft: h2, glyphTop: p2, glyphAdvance: d2 } = i3.draw(s3);
          return this.localGlyphs[i3.fontWeight][r2] = { id: r2, bitmap: new zl({ width: o2, height: l2 }, a2), metrics: { width: u2 / 2, height: c2 / 2, left: h2 / 2, top: p2 / 2 - 27, advance: d2 / 2, localGlyph: true } };
        }
      }
      function vh(t2, e2, r2, n2) {
        const s3 = [], a2 = t2.image, o2 = a2.pixelRatio, l2 = a2.paddedRect.w - 2, u2 = a2.paddedRect.h - 2, c2 = t2.right - t2.left, h2 = t2.bottom - t2.top, p2 = a2.stretchX || [[0, l2]], d2 = a2.stretchY || [[0, u2]], f2 = (t3, e3) => t3 + e3[1] - e3[0], y2 = p2.reduce(f2, 0), m2 = d2.reduce(f2, 0), g2 = l2 - y2, x3 = u2 - m2;
        let v3 = 0, b2 = y2, w2 = 0, _2 = m2, A3 = 0, k2 = g2, S3 = 0, I3 = x3;
        if (a2.content && n2) {
          const t3 = a2.content;
          v3 = bh(p2, 0, t3[0]), w2 = bh(d2, 0, t3[1]), b2 = bh(p2, t3[0], t3[2]), _2 = bh(d2, t3[1], t3[3]), A3 = t3[0] - v3, S3 = t3[1] - w2, k2 = t3[2] - t3[0] - b2, I3 = t3[3] - t3[1] - _2;
        }
        const z2 = (n3, s4, l3, u3) => {
          const p3 = _h(n3.stretch - v3, b2, c2, t2.left), d3 = Ah(n3.fixed - A3, k2, n3.stretch, y2), f3 = _h(s4.stretch - w2, _2, h2, t2.top), g3 = Ah(s4.fixed - S3, I3, s4.stretch, m2), x4 = _h(l3.stretch - v3, b2, c2, t2.left), z3 = Ah(l3.fixed - A3, k2, l3.stretch, y2), M3 = _h(u3.stretch - w2, _2, h2, t2.top), T2 = Ah(u3.fixed - S3, I3, u3.stretch, m2), B3 = new i2(p3, f3), C2 = new i2(x4, f3), P2 = new i2(x4, M3), E2 = new i2(p3, M3), D4 = new i2(d3 / o2, g3 / o2), V2 = new i2(z3 / o2, T2 / o2), F2 = e2 * Math.PI / 180;
          if (F2) {
            const t3 = Math.sin(F2), e3 = Math.cos(F2), r3 = [e3, -t3, t3, e3];
            B3._matMult(r3), C2._matMult(r3), E2._matMult(r3), P2._matMult(r3);
          }
          const L3 = n3.stretch + n3.fixed, R6 = s4.stretch + s4.fixed;
          return { tl: B3, tr: C2, bl: E2, br: P2, tex: { x: a2.paddedRect.x + 1 + L3, y: a2.paddedRect.y + 1 + R6, w: l3.stretch + l3.fixed - L3, h: u3.stretch + u3.fixed - R6 }, writingMode: void 0, glyphOffset: [0, 0], sectionIndex: 0, pixelOffsetTL: D4, pixelOffsetBR: V2, minFontScaleX: k2 / o2 / c2, minFontScaleY: I3 / o2 / h2, isSDF: r2 };
        };
        if (n2 && (a2.stretchX || a2.stretchY)) {
          const t3 = wh(p2, g2, y2), e3 = wh(d2, x3, m2);
          for (let r3 = 0; r3 < t3.length - 1; r3++) {
            const n3 = t3[r3], i3 = t3[r3 + 1];
            for (let t4 = 0; t4 < e3.length - 1; t4++)
              s3.push(z2(n3, e3[t4], i3, e3[t4 + 1]));
          }
        } else
          s3.push(z2({ fixed: 0, stretch: -1 }, { fixed: 0, stretch: -1 }, { fixed: 0, stretch: l2 + 1 }, { fixed: 0, stretch: u2 + 1 }));
        return s3;
      }
      function bh(t2, e2, r2) {
        let n2 = 0;
        for (const i3 of t2)
          n2 += Math.max(e2, Math.min(r2, i3[1])) - Math.max(e2, Math.min(r2, i3[0]));
        return n2;
      }
      function wh(t2, e2, r2) {
        const n2 = [{ fixed: -1, stretch: 0 }];
        for (const [e3, r3] of t2) {
          const t3 = n2[n2.length - 1];
          n2.push({ fixed: e3 - t3.stretch, stretch: t3.stretch }), n2.push({ fixed: e3 - t3.stretch, stretch: t3.stretch + (r3 - e3) });
        }
        return n2.push({ fixed: e2 + 1, stretch: r2 }), n2;
      }
      function _h(t2, e2, r2, n2) {
        return t2 / e2 * r2 + n2;
      }
      function Ah(t2, e2, r2, n2) {
        return t2 - e2 * r2 / n2;
      }
      function kh(t2, e2, r2, n2) {
        const i3 = e2 + t2.positionedLines[n2].lineOffset;
        return n2 === 0 ? r2 + i3 / 2 : r2 + (i3 + (e2 + t2.positionedLines[n2 - 1].lineOffset)) / 2;
      }
      xh.loadGlyphRange = function(t2, e2, r2, n2, i3) {
        const s3 = 256 * e2, a2 = s3 + 255, o2 = n2.transformRequest(n2.normalizeGlyphsURL(r2).replace("{fontstack}", t2).replace("{range}", `${s3}-${a2}`), re.Glyphs);
        ae(o2, (t3, e3) => {
          if (t3)
            i3(t3);
          else if (e3) {
            const t4 = {}, r3 = function(t5) {
              return new gc(t5).readFields(Lc, {});
            }(e3);
            for (const e4 of r3.glyphs)
              t4[e4.id] = e4;
            i3(null, { glyphs: t4, ascender: r3.ascender, descender: r3.descender });
          }
        });
      }, xh.TinySDF = class {
        constructor({ fontSize: t2 = 24, buffer: e2 = 3, radius: r2 = 8, cutoff: n2 = 0.25, fontFamily: i3 = "sans-serif", fontWeight: s3 = "normal", fontStyle: a2 = "normal" }) {
          this.buffer = e2, this.cutoff = n2, this.radius = r2;
          const o2 = this.size = t2 + 4 * e2, l2 = this._createCanvas(o2), u2 = this.ctx = l2.getContext("2d", { willReadFrequently: true });
          u2.font = `${a2} ${s3} ${t2}px ${i3}`, u2.textBaseline = "alphabetic", u2.textAlign = "left", u2.fillStyle = "black", this.gridOuter = new Float64Array(o2 * o2), this.gridInner = new Float64Array(o2 * o2), this.f = new Float64Array(o2), this.z = new Float64Array(o2 + 1), this.v = new Uint16Array(o2);
        }
        _createCanvas(t2) {
          const e2 = document.createElement("canvas");
          return e2.width = e2.height = t2, e2;
        }
        draw(t2) {
          const { width: e2, actualBoundingBoxAscent: r2, actualBoundingBoxDescent: n2, actualBoundingBoxLeft: i3, actualBoundingBoxRight: s3 } = this.ctx.measureText(t2), a2 = Math.floor(r2), o2 = Math.min(this.size - this.buffer, Math.ceil(s3 - i3)), l2 = Math.min(this.size - this.buffer, Math.ceil(r2) + Math.ceil(n2)), u2 = o2 + 2 * this.buffer, c2 = l2 + 2 * this.buffer, h2 = u2 * c2, p2 = new Uint8ClampedArray(h2), d2 = { data: p2, width: u2, height: c2, glyphWidth: o2, glyphHeight: l2, glyphTop: a2, glyphLeft: 0, glyphAdvance: e2 };
          if (o2 === 0 || l2 === 0)
            return d2;
          const { ctx: f2, buffer: y2, gridInner: m2, gridOuter: g2 } = this;
          f2.clearRect(y2, y2, o2, l2), f2.fillText(t2, y2, y2 + a2 + 1);
          const x3 = f2.getImageData(y2, y2, o2, l2);
          g2.fill(fh, 0, h2), m2.fill(0, 0, h2);
          for (let t3 = 0; t3 < l2; t3++)
            for (let e3 = 0; e3 < o2; e3++) {
              const r3 = x3.data[4 * (t3 * o2 + e3) + 3] / 255;
              if (r3 === 0)
                continue;
              const n3 = (t3 + y2) * u2 + e3 + y2;
              if (r3 === 1)
                g2[n3] = 0, m2[n3] = fh;
              else {
                const t4 = 0.5 - r3;
                g2[n3] = t4 > 0 ? t4 * t4 : 0, m2[n3] = t4 < 0 ? t4 * t4 : 0;
              }
            }
          yh(g2, 0, 0, u2, c2, u2, this.f, this.v, this.z), yh(m2, y2, y2, o2, l2, u2, this.f, this.v, this.z);
          for (let t3 = 0; t3 < h2; t3++) {
            const e3 = Math.sqrt(g2[t3]) - Math.sqrt(m2[t3]);
            p2[t3] = Math.round(255 - 255 * (e3 / this.radius + this.cutoff));
          }
          return d2;
        }
      };
      class Sh {
        constructor(t2 = [], e2 = Ih) {
          if (this.data = t2, this.length = this.data.length, this.compare = e2, this.length > 0)
            for (let t3 = (this.length >> 1) - 1; t3 >= 0; t3--)
              this._down(t3);
        }
        push(t2) {
          this.data.push(t2), this.length++, this._up(this.length - 1);
        }
        pop() {
          if (this.length === 0)
            return;
          const t2 = this.data[0], e2 = this.data.pop();
          return this.length--, this.length > 0 && (this.data[0] = e2, this._down(0)), t2;
        }
        peek() {
          return this.data[0];
        }
        _up(t2) {
          const { data: e2, compare: r2 } = this, n2 = e2[t2];
          for (; t2 > 0; ) {
            const i3 = t2 - 1 >> 1, s3 = e2[i3];
            if (r2(n2, s3) >= 0)
              break;
            e2[t2] = s3, t2 = i3;
          }
          e2[t2] = n2;
        }
        _down(t2) {
          const { data: e2, compare: r2 } = this, n2 = this.length >> 1, i3 = e2[t2];
          for (; t2 < n2; ) {
            let n3 = 1 + (t2 << 1), s3 = e2[n3];
            const a2 = n3 + 1;
            if (a2 < this.length && r2(e2[a2], s3) < 0 && (n3 = a2, s3 = e2[a2]), r2(s3, i3) >= 0)
              break;
            e2[t2] = s3, t2 = n3;
          }
          e2[t2] = i3;
        }
      }
      function Ih(t2, e2) {
        return t2 < e2 ? -1 : t2 > e2 ? 1 : 0;
      }
      function zh(t2, e2 = 1, r2 = false) {
        let n2 = 1 / 0, s3 = 1 / 0, a2 = -1 / 0, o2 = -1 / 0;
        const l2 = t2[0];
        for (let t3 = 0; t3 < l2.length; t3++) {
          const e3 = l2[t3];
          (!t3 || e3.x < n2) && (n2 = e3.x), (!t3 || e3.y < s3) && (s3 = e3.y), (!t3 || e3.x > a2) && (a2 = e3.x), (!t3 || e3.y > o2) && (o2 = e3.y);
        }
        const u2 = Math.min(a2 - n2, o2 - s3);
        let c2 = u2 / 2;
        const h2 = new Sh([], Mh);
        if (u2 === 0)
          return new i2(n2, s3);
        for (let e3 = n2; e3 < a2; e3 += u2)
          for (let r3 = s3; r3 < o2; r3 += u2)
            h2.push(new Th(e3 + c2, r3 + c2, c2, t2));
        let p2 = function(t3) {
          let e3 = 0, r3 = 0, n3 = 0;
          const i3 = t3[0];
          for (let t4 = 0, s4 = i3.length, a3 = s4 - 1; t4 < s4; a3 = t4++) {
            const s5 = i3[t4], o3 = i3[a3], l3 = s5.x * o3.y - o3.x * s5.y;
            r3 += (s5.x + o3.x) * l3, n3 += (s5.y + o3.y) * l3, e3 += 3 * l3;
          }
          return new Th(r3 / e3, n3 / e3, 0, t3);
        }(t2), d2 = h2.length;
        for (; h2.length; ) {
          const n3 = h2.pop();
          (n3.d > p2.d || !p2.d) && (p2 = n3, r2 && console.log("found best %d after %d probes", Math.round(1e4 * n3.d) / 1e4, d2)), n3.max - p2.d <= e2 || (c2 = n3.h / 2, h2.push(new Th(n3.p.x - c2, n3.p.y - c2, c2, t2)), h2.push(new Th(n3.p.x + c2, n3.p.y - c2, c2, t2)), h2.push(new Th(n3.p.x - c2, n3.p.y + c2, c2, t2)), h2.push(new Th(n3.p.x + c2, n3.p.y + c2, c2, t2)), d2 += 4);
        }
        return r2 && (console.log(`num probes: ${d2}`), console.log(`best distance: ${p2.d}`)), p2.p;
      }
      function Mh(t2, e2) {
        return e2.max - t2.max;
      }
      function Th(t2, e2, r2, n2) {
        this.p = new i2(t2, e2), this.h = r2, this.d = function(t3, e3) {
          let r3 = false, n3 = 1 / 0;
          for (let i3 = 0; i3 < e3.length; i3++) {
            const s3 = e3[i3];
            for (let e4 = 0, i4 = s3.length, a2 = i4 - 1; e4 < i4; a2 = e4++) {
              const i5 = s3[e4], o2 = s3[a2];
              i5.y > t3.y != o2.y > t3.y && t3.x < (o2.x - i5.x) * (t3.y - i5.y) / (o2.y - i5.y) + i5.x && (r3 = !r3), n3 = Math.min(n3, sl(t3, i5, o2));
            }
          }
          return (r3 ? 1 : -1) * Math.sqrt(n3);
        }(this.p, n2), this.max = this.d + this.h * Math.SQRT2;
      }
      const Bh = Number.POSITIVE_INFINITY, Ch = Math.sqrt(2);
      function Ph(t2, e2) {
        return e2[1] !== Bh ? function(t3, e3, r2) {
          let n2 = 0, i3 = 0;
          switch (e3 = Math.abs(e3), r2 = Math.abs(r2), t3) {
            case "top-right":
            case "top-left":
            case "top":
              i3 = r2 - 7;
              break;
            case "bottom-right":
            case "bottom-left":
            case "bottom":
              i3 = 7 - r2;
          }
          switch (t3) {
            case "top-right":
            case "bottom-right":
            case "right":
              n2 = -e3;
              break;
            case "top-left":
            case "bottom-left":
            case "left":
              n2 = e3;
          }
          return [n2, i3];
        }(t2, e2[0], e2[1]) : function(t3, e3) {
          let r2 = 0, n2 = 0;
          e3 < 0 && (e3 = 0);
          const i3 = e3 / Ch;
          switch (t3) {
            case "top-right":
            case "top-left":
              n2 = i3 - 7;
              break;
            case "bottom-right":
            case "bottom-left":
              n2 = 7 - i3;
              break;
            case "bottom":
              n2 = 7 - e3;
              break;
            case "top":
              n2 = e3 - 7;
          }
          switch (t3) {
            case "top-right":
            case "bottom-right":
              r2 = -i3;
              break;
            case "top-left":
            case "bottom-left":
              r2 = i3;
              break;
            case "left":
              r2 = e3;
              break;
            case "right":
              r2 = -e3;
          }
          return [r2, n2];
        }(t2, e2[0]);
      }
      function Eh(t2, e2, r2, n2, i3, s3, a2, o2, l2, u2) {
        t2.createArrays(), t2.tilePixelRatio = To / (512 * t2.overscaling), t2.compareText = {}, t2.iconsNeedLinear = false;
        const c2 = t2.layers[0].layout, h2 = t2.layers[0]._unevaluatedLayout._values, p2 = {};
        if (t2.textSizeData.kind === "composite") {
          const { minZoom: e3, maxZoom: r3 } = t2.textSizeData;
          p2.compositeTextSizes = [h2["text-size"].possiblyEvaluate(new Gs(e3), o2), h2["text-size"].possiblyEvaluate(new Gs(r3), o2)];
        }
        if (t2.iconSizeData.kind === "composite") {
          const { minZoom: e3, maxZoom: r3 } = t2.iconSizeData;
          p2.compositeIconSizes = [h2["icon-size"].possiblyEvaluate(new Gs(e3), o2), h2["icon-size"].possiblyEvaluate(new Gs(r3), o2)];
        }
        p2.layoutTextSize = h2["text-size"].possiblyEvaluate(new Gs(l2 + 1), o2), p2.layoutIconSize = h2["icon-size"].possiblyEvaluate(new Gs(l2 + 1), o2), p2.textMaxSize = h2["text-size"].possiblyEvaluate(new Gs(18), o2);
        const d2 = c2.get("text-rotation-alignment") === "map" && c2.get("symbol-placement") !== "point", f2 = c2.get("text-size");
        for (const s4 of t2.features) {
          const l3 = c2.get("text-font").evaluate(s4, {}, o2).join(","), h3 = f2.evaluate(s4, {}, o2), y2 = p2.layoutTextSize.evaluate(s4, {}, o2), m2 = (p2.layoutIconSize.evaluate(s4, {}, o2), { horizontal: {}, vertical: void 0 }), g2 = s4.text;
          let x3, v3 = [0, 0];
          if (g2) {
            const n3 = g2.toString(), a3 = c2.get("text-letter-spacing").evaluate(s4, {}, o2) * sc, u3 = c2.get("text-line-height").evaluate(s4, {}, o2) * sc, p3 = Is(n3) ? a3 : 0, f3 = c2.get("text-anchor").evaluate(s4, {}, o2), x4 = c2.get("text-variable-anchor");
            if (!x4) {
              const t3 = c2.get("text-radial-offset").evaluate(s4, {}, o2);
              v3 = t3 ? Ph(f3, [t3 * sc, Bh]) : c2.get("text-offset").evaluate(s4, {}, o2).map((t4) => t4 * sc);
            }
            let b3 = d2 ? "center" : c2.get("text-justify").evaluate(s4, {}, o2);
            const w3 = c2.get("symbol-placement"), _2 = w3 === "point", A3 = w3 === "point" ? c2.get("text-max-width").evaluate(s4, {}, o2) * sc : 0, k2 = (s5) => {
              t2.allowVerticalPlacement && Ss(n3) && (m2.vertical = Zc(g2, e2, r2, i3, l3, A3, u3, f3, s5, p3, v3, qc.vertical, true, w3, y2, h3));
            };
            if (!d2 && x4) {
              const t3 = b3 === "auto" ? x4.map((t4) => Dh(t4)) : [b3];
              let n4 = false;
              for (let s5 = 0; s5 < t3.length; s5++) {
                const a4 = t3[s5];
                if (!m2.horizontal[a4])
                  if (n4)
                    m2.horizontal[a4] = m2.horizontal[0];
                  else {
                    const t4 = Zc(g2, e2, r2, i3, l3, A3, u3, "center", a4, p3, v3, qc.horizontal, false, w3, y2, h3);
                    t4 && (m2.horizontal[a4] = t4, n4 = t4.positionedLines.length === 1);
                  }
              }
              k2("left");
            } else {
              if (b3 === "auto" && (b3 = Dh(f3)), _2 || c2.get("text-writing-mode").indexOf("horizontal") >= 0 || !Ss(n3)) {
                const t3 = Zc(g2, e2, r2, i3, l3, A3, u3, f3, b3, p3, v3, qc.horizontal, false, w3, y2, h3);
                t3 && (m2.horizontal[b3] = t3);
              }
              k2(w3 === "point" ? "left" : b3);
            }
          }
          let b2 = false;
          if (s4.icon && s4.icon.name) {
            const e3 = n2[s4.icon.name];
            e3 && (x3 = nh(i3[s4.icon.name], c2.get("icon-offset").evaluate(s4, {}, o2), c2.get("icon-anchor").evaluate(s4, {}, o2)), b2 = e3.sdf, t2.sdfIcons === void 0 ? t2.sdfIcons = e3.sdf : t2.sdfIcons !== e3.sdf && pt("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (e3.pixelRatio !== t2.pixelRatio || c2.get("icon-rotate").constantOr(1) !== 0) && (t2.iconsNeedLinear = true));
          }
          const w2 = Rh(m2.horizontal) || m2.vertical;
          t2.iconsInText || (t2.iconsInText = !!w2 && w2.iconsInText), (w2 || x3) && Vh(t2, s4, m2, x3, n2, p2, y2, 0, v3, b2, a2, o2, u2);
        }
        s3 && t2.generateCollisionDebugBuffers(l2, t2.collisionBoxArray);
      }
      function Dh(t2) {
        switch (t2) {
          case "right":
          case "top-right":
          case "bottom-right":
            return "right";
          case "left":
          case "top-left":
          case "bottom-left":
            return "left";
        }
        return "center";
      }
      function Vh(t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2, h2, p2) {
        let d2 = s3.textMaxSize.evaluate(e2, {}, h2);
        d2 === void 0 && (d2 = a2);
        const f2 = t2.layers[0].layout, y2 = f2.get("icon-offset").evaluate(e2, {}, h2), m2 = Rh(r2.horizontal) || r2.vertical, g2 = a2 / 24, x3 = t2.tilePixelRatio * d2 / 24, v3 = t2.tilePixelRatio * f2.get("symbol-spacing"), b2 = f2.get("text-padding") * t2.tilePixelRatio, w2 = f2.get("icon-padding") * t2.tilePixelRatio, _2 = q(f2.get("text-max-angle")), A3 = f2.get("text-rotation-alignment") === "map" && f2.get("symbol-placement") !== "point", k2 = f2.get("icon-rotation-alignment") === "map" && f2.get("symbol-placement") !== "point", S3 = f2.get("symbol-placement"), I3 = v3 / 2, z2 = f2.get("icon-text-fit");
        let M3;
        n2 && z2 !== "none" && (t2.allowVerticalPlacement && r2.vertical && (M3 = ih(n2, r2.vertical, z2, f2.get("icon-text-fit-padding"), y2, g2)), m2 && (n2 = ih(n2, m2, z2, f2.get("icon-text-fit-padding"), y2, g2)));
        const T2 = (a3, o3, d3) => {
          if (o3.x < 0 || o3.x >= To || o3.y < 0 || o3.y >= To)
            return;
          const { x: f3, y: m3, z: g3 } = p2.projectTilePoint(o3.x, o3.y, d3), x4 = new sh(f3, m3, g3, 0, void 0);
          !function(t3, e3, r3, n3, i4, s4, a4, o4, l3, u3, c3, h3, p3, d4, f4, y3, m4, g4, x5, v4, b3, w3, _3, A4, k3) {
            const S4 = t3.addToLineVertexArray(e3, n3);
            let I4, z3, M4, T3, B3, C2, P2, E2 = 0, D4 = 0, V2 = 0, F2 = 0, L3 = -1, R6 = -1;
            const U2 = {};
            let $2 = Ja(""), O2 = 0, j2 = 0;
            if (l3._unevaluatedLayout.getValue("text-radial-offset") === void 0 ? [O2, j2] = l3.layout.get("text-offset").evaluate(b3, {}, k3).map((t4) => t4 * sc) : (O2 = l3.layout.get("text-radial-offset").evaluate(b3, {}, k3) * sc, j2 = Bh), t3.allowVerticalPlacement && i4.vertical) {
              const t4 = i4.vertical;
              if (f4)
                C2 = $h(t4), o4 && (P2 = $h(o4));
              else {
                const n4 = l3.layout.get("text-rotate").evaluate(b3, {}, k3) + 90;
                M4 = Uh(u3, r3, e3, c3, h3, p3, t4, d4, n4, y3), o4 && (T3 = Uh(u3, r3, e3, c3, h3, p3, o4, g4, n4));
              }
            }
            if (s4) {
              const n4 = l3.layout.get("icon-rotate").evaluate(b3, {}, k3), i5 = l3.layout.get("icon-text-fit") !== "none", a5 = vh(s4, n4, _3, i5), d5 = o4 ? vh(o4, n4, _3, i5) : void 0;
              z3 = Uh(u3, r3, e3, c3, h3, p3, s4, g4, n4), E2 = 4 * a5.length;
              const f5 = t3.iconSizeData;
              let y4 = null;
              f5.kind === "source" ? (y4 = [ac * l3.layout.get("icon-size").evaluate(b3, {}, k3)], y4[0] > Fh && pt(`${t3.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)) : f5.kind === "composite" && (y4 = [ac * w3.compositeIconSizes[0].evaluate(b3, {}, k3), ac * w3.compositeIconSizes[1].evaluate(b3, {}, k3)], (y4[0] > Fh || y4[1] > Fh) && pt(`${t3.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)), t3.addSymbols(t3.icon, a5, y4, v4, x5, b3, false, r3, e3, S4.lineStartIndex, S4.lineLength, -1, A4, k3), L3 = t3.icon.placedSymbolArray.length - 1, d5 && (D4 = 4 * d5.length, t3.addSymbols(t3.icon, d5, y4, v4, x5, b3, qc.vertical, r3, e3, S4.lineStartIndex, S4.lineLength, -1, A4, k3), R6 = t3.icon.placedSymbolArray.length - 1);
            }
            for (const n4 in i4.horizontal) {
              const s5 = i4.horizontal[n4];
              I4 || ($2 = Ja(s5.text), f4 ? B3 = $h(s5) : I4 = Uh(u3, r3, e3, c3, h3, p3, s5, d4, l3.layout.get("text-rotate").evaluate(b3, {}, k3), y3));
              const o5 = s5.positionedLines.length === 1;
              if (V2 += Lh(t3, r3, e3, s5, a4, l3, f4, b3, y3, S4, i4.vertical ? qc.horizontal : qc.horizontalOnly, o5 ? Object.keys(i4.horizontal) : [n4], U2, L3, w3, A4, k3), o5)
                break;
            }
            i4.vertical && (F2 += Lh(t3, r3, e3, i4.vertical, a4, l3, f4, b3, y3, S4, qc.vertical, ["vertical"], U2, R6, w3, A4, k3));
            let q2 = -1;
            const N2 = (t4, e4) => t4 ? Math.max(t4, e4) : e4;
            q2 = N2(B3, q2), q2 = N2(C2, q2), q2 = N2(P2, q2);
            const G2 = q2 > -1 ? 1 : 0;
            t3.glyphOffsetArray.length >= Yh.MAX_GLYPHS && pt("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), b3.sortKey !== void 0 && t3.addToSortKeyRanges(t3.symbolInstances.length, b3.sortKey), t3.symbolInstances.emplaceBack(r3.x, r3.y, r3.z, e3.x, e3.y, U2.right >= 0 ? U2.right : -1, U2.center >= 0 ? U2.center : -1, U2.left >= 0 ? U2.left : -1, U2.vertical >= 0 ? U2.vertical : -1, L3, R6, $2, I4 !== void 0 ? I4 : t3.collisionBoxArray.length, I4 !== void 0 ? I4 + 1 : t3.collisionBoxArray.length, M4 !== void 0 ? M4 : t3.collisionBoxArray.length, M4 !== void 0 ? M4 + 1 : t3.collisionBoxArray.length, z3 !== void 0 ? z3 : t3.collisionBoxArray.length, z3 !== void 0 ? z3 + 1 : t3.collisionBoxArray.length, T3 || t3.collisionBoxArray.length, T3 ? T3 + 1 : t3.collisionBoxArray.length, c3, V2, F2, E2, D4, G2, 0, O2, j2, q2);
          }(t2, o3, x4, a3, r2, n2, i3, M3, t2.layers[0], t2.collisionBoxArray, e2.index, e2.sourceLayerIndex, t2.index, b2, A3, l2, 0, w2, k2, y2, e2, s3, u2, c2, h2);
        };
        if (S3 === "line")
          for (const i4 of dh(e2.geometry, 0, 0, To, To)) {
            const e3 = hh(i4, v3, _2, r2.vertical || m2, n2, 24, x3, t2.overscaling, To);
            for (const r3 of e3) {
              const e4 = m2;
              e4 && Oh(t2, e4.text, I3, r3) || T2(i4, r3, h2);
            }
          }
        else if (S3 === "line-center") {
          for (const t3 of e2.geometry)
            if (t3.length > 1) {
              const e3 = ch(t3, _2, r2.vertical || m2, n2, 24, x3);
              e3 && T2(t3, e3, h2);
            }
        } else if (e2.type === "Polygon")
          for (const t3 of pu(e2.geometry, 0)) {
            const e3 = zh(t3, 16);
            T2(t3[0], new sh(e3.x, e3.y, 0, 0, void 0), h2);
          }
        else if (e2.type === "LineString")
          for (const t3 of e2.geometry)
            T2(t3, new sh(t3[0].x, t3[0].y, 0, 0, void 0), h2);
        else if (e2.type === "Point")
          for (const t3 of e2.geometry)
            for (const e3 of t3)
              T2([e3], new sh(e3.x, e3.y, 0, 0, void 0), h2);
      }
      const Fh = 32640;
      function Lh(t2, e2, r2, n2, s3, a2, o2, l2, u2, c2, h2, p2, d2, f2, y2, m2, g2) {
        const x3 = function(t3, e3, r3, n3, s4, a3, o3, l3) {
          const u3 = [];
          if (e3.positionedLines.length === 0)
            return u3;
          const c3 = n3.layout.get("text-rotate").evaluate(a3, {}) * Math.PI / 180, h3 = function(t4) {
            const e4 = t4[0], r4 = t4[1], n4 = e4 * r4;
            return n4 > 0 ? [e4, -r4] : n4 < 0 ? [-e4, r4] : e4 === 0 ? [r4, e4] : [r4, -e4];
          }(r3);
          let p3 = Math.abs(e3.top - e3.bottom);
          for (const t4 of e3.positionedLines)
            p3 -= t4.lineOffset;
          const d3 = e3.positionedLines.length, f3 = p3 / d3;
          let y3 = e3.top - r3[1];
          for (let t4 = 0; t4 < d3; ++t4) {
            const n4 = e3.positionedLines[t4];
            y3 = kh(e3, f3, y3, t4);
            for (const t5 of n4.positionedGlyphs) {
              if (!t5.rect)
                continue;
              const n5 = t5.rect || {};
              let a4 = 4, p4 = true, d4 = 1, f4 = 0;
              if (t5.imageName) {
                const e4 = o3[t5.imageName];
                if (!e4)
                  continue;
                if (e4.sdf) {
                  pt("SDF images are not supported in formatted text and will be ignored.");
                  continue;
                }
                p4 = false, d4 = e4.pixelRatio, a4 = 1 / d4;
              }
              const m3 = (s4 || l3) && t5.vertical, g3 = t5.metrics.advance * t5.scale / 2, x4 = t5.metrics, v4 = t5.rect;
              if (v4 === null)
                continue;
              l3 && e3.verticalizable && (f4 = t5.imageName ? g3 - t5.metrics.width * t5.scale / 2 : 0);
              const b3 = s4 ? [t5.x + g3, t5.y] : [0, 0];
              let w2 = [0, 0], _2 = [0, 0], A3 = false;
              s4 || (m3 ? (_2 = [t5.x + g3 + h3[0], t5.y + h3[1] - f4], A3 = true) : w2 = [t5.x + g3 + r3[0], t5.y + r3[1] - f4]);
              const k2 = v4.w * t5.scale / (d4 * (t5.localGlyph ? 2 : 1)), S3 = v4.h * t5.scale / (d4 * (t5.localGlyph ? 2 : 1));
              let I3, z2, M3, T2;
              if (m3) {
                const e4 = t5.y - y3, r4 = new i2(-g3, g3 - e4), n6 = -Math.PI / 2, s5 = new i2(..._2);
                I3 = new i2(-g3 + w2[0], w2[1]), I3._rotateAround(n6, r4)._add(s5), I3.x += -e4 + g3, I3.y -= (x4.left - a4) * t5.scale;
                const o4 = t5.imageName ? x4.advance * t5.scale : sc * t5.scale, l4 = String.fromCharCode(t5.glyph);
                dc(l4) ? I3.x += (1 - a4) * t5.scale : fc(l4) ? I3.x += o4 - x4.height * t5.scale + (-a4 - 1) * t5.scale : I3.x += t5.imageName || x4.width + 2 * a4 === v4.w && x4.height + 2 * a4 === v4.h ? (o4 - S3) / 2 : (o4 - (x4.height + 2 * a4) * t5.scale) / 2, z2 = new i2(I3.x, I3.y - k2), M3 = new i2(I3.x + S3, I3.y), T2 = new i2(I3.x + S3, I3.y - k2);
              } else {
                const e4 = (x4.left - a4) * t5.scale - g3 + w2[0], r4 = (-x4.top - a4) * t5.scale + w2[1], n6 = e4 + k2, s5 = r4 + S3;
                I3 = new i2(e4, r4), z2 = new i2(n6, r4), M3 = new i2(e4, s5), T2 = new i2(n6, s5);
              }
              if (c3) {
                let t6;
                t6 = s4 ? new i2(0, 0) : A3 ? new i2(h3[0], h3[1]) : new i2(r3[0], r3[1]), I3._rotateAround(c3, t6), z2._rotateAround(c3, t6), M3._rotateAround(c3, t6), T2._rotateAround(c3, t6);
              }
              const B3 = new i2(0, 0), C2 = new i2(0, 0);
              u3.push({ tl: I3, tr: z2, bl: M3, br: T2, tex: n5, writingMode: e3.writingMode, glyphOffset: b3, sectionIndex: t5.sectionIndex, isSDF: p4, pixelOffsetTL: B3, pixelOffsetBR: C2, minFontScaleX: 0, minFontScaleY: 0 });
            }
          }
          return u3;
        }(0, n2, u2, a2, o2, l2, s3, t2.allowVerticalPlacement), v3 = t2.textSizeData;
        let b2 = null;
        v3.kind === "source" ? (b2 = [ac * a2.layout.get("text-size").evaluate(l2, {}, g2)], b2[0] > Fh && pt(`${t2.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)) : v3.kind === "composite" && (b2 = [ac * y2.compositeTextSizes[0].evaluate(l2, {}, g2), ac * y2.compositeTextSizes[1].evaluate(l2, {}, g2)], (b2[0] > Fh || b2[1] > Fh) && pt(`${t2.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)), t2.addSymbols(t2.text, x3, b2, u2, o2, l2, h2, e2, r2, c2.lineStartIndex, c2.lineLength, f2, m2, g2);
        for (const e3 of p2)
          d2[e3] = t2.text.placedSymbolArray.length - 1;
        return 4 * x3.length;
      }
      function Rh(t2) {
        for (const e2 in t2)
          return t2[e2];
        return null;
      }
      function Uh(t2, e2, r2, n2, s3, a2, o2, l2, u2, c2) {
        let h2 = o2.top, p2 = o2.bottom, d2 = o2.left, f2 = o2.right;
        const y2 = o2.collisionPadding;
        if (y2 && (d2 -= y2[0], h2 -= y2[1], f2 += y2[2], p2 += y2[3]), u2) {
          const t3 = new i2(d2, h2), e3 = new i2(f2, h2), r3 = new i2(d2, p2), n3 = new i2(f2, p2), s4 = q(u2);
          let a3 = new i2(0, 0);
          c2 && (a3 = new i2(c2[0], c2[1])), t3._rotateAround(s4, a3), e3._rotateAround(s4, a3), r3._rotateAround(s4, a3), n3._rotateAround(s4, a3), d2 = Math.min(t3.x, e3.x, r3.x, n3.x), f2 = Math.max(t3.x, e3.x, r3.x, n3.x), h2 = Math.min(t3.y, e3.y, r3.y, n3.y), p2 = Math.max(t3.y, e3.y, r3.y, n3.y);
        }
        return t2.emplaceBack(e2.x, e2.y, e2.z, r2.x, r2.y, d2, h2, f2, p2, l2, n2, s3, a2), t2.length - 1;
      }
      function $h(t2) {
        t2.collisionPadding && (t2.top -= t2.collisionPadding[1], t2.bottom += t2.collisionPadding[3]);
        const e2 = t2.bottom - t2.top;
        return e2 > 0 ? Math.max(10, e2) : null;
      }
      function Oh(t2, e2, r2, n2) {
        const i3 = t2.compareText;
        if (e2 in i3) {
          const t3 = i3[e2];
          for (let e3 = t3.length - 1; e3 >= 0; e3--)
            if (n2.dist(t3[e3]) < r2)
              return true;
        } else
          i3[e2] = [];
        return i3[e2].push(n2), false;
      }
      const jh = Bu.VectorTileFeature.types, qh = [{ name: "a_fade_opacity", components: 1, type: "Uint8", offset: 0 }];
      function Nh(t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2, h2, p2, d2, f2, y2) {
        const m2 = c2 ? Math.min(Fh, Math.round(c2[0])) : 0, g2 = c2 ? Math.min(Fh, Math.round(c2[1])) : 0;
        t2.emplaceBack(e2, r2, Math.round(32 * a2), Math.round(32 * o2), l2, u2, (m2 << 1) + (h2 ? 1 : 0), g2, 16 * p2, 16 * d2, 256 * f2, 256 * y2, n2, i3, s3, 0);
      }
      function Gh(t2, e2, r2) {
        t2.emplaceBack(e2.x, e2.y, r2), t2.emplaceBack(e2.x, e2.y, r2), t2.emplaceBack(e2.x, e2.y, r2), t2.emplaceBack(e2.x, e2.y, r2);
      }
      function Zh(t2) {
        for (const e2 of t2.sections)
          if (Ps(e2.text))
            return true;
        return false;
      }
      class Xh {
        constructor(t2) {
          this.layoutVertexArray = new xa(), this.indexArray = new ka(), this.programConfigurations = t2, this.segments = new Mo(), this.dynamicLayoutVertexArray = new ya(), this.opacityVertexArray = new va(), this.placedSymbolArray = new Ra();
        }
        isEmpty() {
          return this.layoutVertexArray.length === 0 && this.indexArray.length === 0 && this.dynamicLayoutVertexArray.length === 0 && this.opacityVertexArray.length === 0;
        }
        upload(t2, e2, r2, n2) {
          this.isEmpty() || (r2 && (this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, Qu.members), this.indexBuffer = t2.createIndexBuffer(this.indexArray, e2), this.dynamicLayoutVertexBuffer = t2.createVertexBuffer(this.dynamicLayoutVertexArray, tc.members, true), this.opacityVertexBuffer = t2.createVertexBuffer(this.opacityVertexArray, qh, true), this.opacityVertexBuffer.itemSize = 1), (r2 || n2) && this.programConfigurations.upload(t2));
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
        }
      }
      Zi("SymbolBuffers", Xh);
      class Kh {
        constructor(t2, e2, r2) {
          this.layoutVertexArray = new t2(), this.layoutAttributes = e2, this.indexArray = new r2(), this.segments = new Mo(), this.collisionVertexArray = new Aa(), this.collisionVertexArrayExt = new ya();
        }
        upload(t2) {
          this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t2.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t2.createVertexBuffer(this.collisionVertexArray, ec.members, true), this.collisionVertexBufferExt = t2.createVertexBuffer(this.collisionVertexArrayExt, rc.members, true);
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy(), this.collisionVertexBufferExt.destroy());
        }
      }
      Zi("CollisionBuffers", Kh);
      class Yh {
        constructor(t2) {
          this.collisionBoxArray = t2.collisionBoxArray, this.zoom = t2.zoom, this.overscaling = t2.overscaling, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.id), this.index = t2.index, this.pixelRatio = t2.pixelRatio, this.sourceLayerIndex = t2.sourceLayerIndex, this.hasPattern = false, this.hasRTLText = false, this.fullyClipped = false, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = c([]), this.placementViewportMatrix = c([]);
          const e2 = this.layers[0]._unevaluatedLayout._values;
          this.textSizeData = oc(this.zoom, e2["text-size"]), this.iconSizeData = oc(this.zoom, e2["icon-size"]);
          const r2 = this.layers[0].layout, n2 = r2.get("symbol-sort-key"), i3 = r2.get("symbol-z-order");
          this.canOverlap = r2.get("text-allow-overlap") || r2.get("icon-allow-overlap") || r2.get("text-ignore-placement") || r2.get("icon-ignore-placement"), this.sortFeaturesByKey = i3 !== "viewport-y" && n2.constantOr(1) !== void 0, this.sortFeaturesByY = (i3 === "viewport-y" || i3 === "auto" && !this.sortFeaturesByKey) && this.canOverlap, this.writingModes = r2.get("text-writing-mode").map((t3) => qc[t3]), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id), this.sourceID = t2.sourceID;
        }
        createArrays() {
          this.text = new Xh(new xo(this.layers, this.zoom, (t2) => /^text/.test(t2))), this.icon = new Xh(new xo(this.layers, this.zoom, (t2) => /^icon/.test(t2))), this.glyphOffsetArray = new Oa(), this.lineVertexArray = new ja(), this.symbolInstances = new $a();
        }
        calculateGlyphDependencies(t2, e2, r2, n2, i3) {
          for (let r3 = 0; r3 < t2.length; r3++)
            if (e2[t2.charCodeAt(r3)] = true, n2 && i3) {
              const n3 = pc[t2.charAt(r3)];
              n3 && (e2[n3.charCodeAt(0)] = true);
            }
        }
        populate(t2, e2, r2, n2) {
          const i3 = this.layers[0], s3 = i3.layout, a2 = s3.get("text-font"), o2 = s3.get("text-field"), l2 = s3.get("icon-image"), u2 = (o2.value.kind !== "constant" || o2.value.value instanceof Ke && !o2.value.value.isEmpty() || o2.value.value.toString().length > 0) && (a2.value.kind !== "constant" || a2.value.value.length > 0), c2 = l2.value.kind !== "constant" || !!l2.value.value || Object.keys(l2.parameters).length > 0, h2 = s3.get("symbol-sort-key");
          if (this.features = [], !u2 && !c2)
            return;
          const p2 = e2.iconDependencies, d2 = e2.glyphDependencies, f2 = e2.availableImages, y2 = new Gs(this.zoom);
          for (const { feature: e3, id: o3, index: l3, sourceLayerIndex: m2 } of t2) {
            const t3 = i3._featureFilter.needGeometry, g2 = Yo(e3, t3);
            if (!i3._featureFilter.filter(y2, g2, r2))
              continue;
            let x3, v3;
            if (t3 || (g2.geometry = Ko(e3, r2, n2)), u2) {
              const t4 = i3.getValueAndResolveTokens("text-field", g2, r2, f2), e4 = Ke.factory(t4);
              Zh(e4) && (this.hasRTLText = true), (!this.hasRTLText || js() === "unavailable" || this.hasRTLText && Ns.isParsed()) && (x3 = hc(e4, i3, g2));
            }
            if (c2) {
              const t4 = i3.getValueAndResolveTokens("icon-image", g2, r2, f2);
              v3 = t4 instanceof Ye ? t4 : Ye.fromString(t4);
            }
            if (!x3 && !v3)
              continue;
            const b2 = this.sortFeaturesByKey ? h2.evaluate(g2, {}, r2) : void 0;
            if (this.features.push({ id: o3, text: x3, icon: v3, index: l3, sourceLayerIndex: m2, geometry: g2.geometry, properties: e3.properties, type: jh[e3.type], sortKey: b2 }), v3 && (p2[v3.name] = true), x3) {
              const t4 = a2.evaluate(g2, {}, r2).join(","), e4 = s3.get("text-rotation-alignment") === "map" && s3.get("symbol-placement") !== "point";
              this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(qc.vertical) >= 0;
              for (const r3 of x3.sections)
                if (r3.image)
                  p2[r3.image.name] = true;
                else {
                  const n3 = Ss(x3.toString()), i4 = r3.fontStack || t4, s4 = d2[i4] = d2[i4] || {};
                  this.calculateGlyphDependencies(r3.text, s4, e4, this.allowVerticalPlacement, n3);
                }
            }
          }
          s3.get("symbol-placement") === "line" && (this.features = function(t3) {
            const e3 = {}, r3 = {}, n3 = [];
            let i4 = 0;
            function s4(e4) {
              n3.push(t3[e4]), i4++;
            }
            function a3(t4, e4, i5) {
              const s5 = r3[t4];
              return delete r3[t4], r3[e4] = s5, n3[s5].geometry[0].pop(), n3[s5].geometry[0] = n3[s5].geometry[0].concat(i5[0]), s5;
            }
            function o3(t4, r4, i5) {
              const s5 = e3[r4];
              return delete e3[r4], e3[t4] = s5, n3[s5].geometry[0].shift(), n3[s5].geometry[0] = i5[0].concat(n3[s5].geometry[0]), s5;
            }
            function l3(t4, e4, r4) {
              const n4 = r4 ? e4[0][e4[0].length - 1] : e4[0][0];
              return `${t4}:${n4.x}:${n4.y}`;
            }
            for (let u3 = 0; u3 < t3.length; u3++) {
              const c3 = t3[u3], h3 = c3.geometry, p3 = c3.text ? c3.text.toString() : null;
              if (!p3) {
                s4(u3);
                continue;
              }
              const d3 = l3(p3, h3), f3 = l3(p3, h3, true);
              if (d3 in r3 && f3 in e3 && r3[d3] !== e3[f3]) {
                const t4 = o3(d3, f3, h3), i5 = a3(d3, f3, n3[t4].geometry);
                delete e3[d3], delete r3[f3], r3[l3(p3, n3[i5].geometry, true)] = i5, n3[t4].geometry = null;
              } else
                d3 in r3 ? a3(d3, f3, h3) : f3 in e3 ? o3(d3, f3, h3) : (s4(u3), e3[d3] = i4 - 1, r3[f3] = i4 - 1);
            }
            return n3.filter((t4) => t4.geometry);
          }(this.features)), this.sortFeaturesByKey && this.features.sort((t3, e3) => t3.sortKey - e3.sortKey);
        }
        update(t2, e2, r2, n2) {
          this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t2, e2, this.layers, r2, n2), this.icon.programConfigurations.updatePaintArrays(t2, e2, this.layers, r2, n2));
        }
        isEmpty() {
          return this.symbolInstances.length === 0 && !this.hasRTLText;
        }
        uploadPending() {
          return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
        }
        upload(t2) {
          !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t2), this.iconCollisionBox.upload(t2)), this.text.upload(t2, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t2, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = true;
        }
        destroyDebugData() {
          this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
        }
        destroy() {
          this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
        }
        addToLineVertexArray(t2, e2) {
          const r2 = this.lineVertexArray.length;
          if (t2.segment !== void 0) {
            let r3 = t2.dist(e2[t2.segment + 1]), n2 = t2.dist(e2[t2.segment]);
            const i3 = {};
            for (let n3 = t2.segment + 1; n3 < e2.length; n3++)
              i3[n3] = { x: e2[n3].x, y: e2[n3].y, tileUnitDistanceFromAnchor: r3 }, n3 < e2.length - 1 && (r3 += e2[n3 + 1].dist(e2[n3]));
            for (let r4 = t2.segment || 0; r4 >= 0; r4--)
              i3[r4] = { x: e2[r4].x, y: e2[r4].y, tileUnitDistanceFromAnchor: n2 }, r4 > 0 && (n2 += e2[r4 - 1].dist(e2[r4]));
            for (let t3 = 0; t3 < e2.length; t3++) {
              const e3 = i3[t3];
              this.lineVertexArray.emplaceBack(e3.x, e3.y, e3.tileUnitDistanceFromAnchor);
            }
          }
          return { lineStartIndex: r2, lineLength: this.lineVertexArray.length - r2 };
        }
        addSymbols(t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2, h2, p2, d2) {
          const f2 = t2.indexArray, y2 = t2.layoutVertexArray, m2 = t2.segments.prepareSegment(4 * e2.length, y2, f2, this.canOverlap ? s3.sortKey : void 0), g2 = this.glyphOffsetArray.length, x3 = m2.vertexLength, v3 = this.allowVerticalPlacement && a2 === qc.vertical ? Math.PI / 2 : 0, b2 = s3.text && s3.text.sections;
          for (let n3 = 0; n3 < e2.length; n3++) {
            const { tl: i4, tr: a3, bl: u3, br: c3, tex: h3, pixelOffsetTL: g3, pixelOffsetBR: x4, minFontScaleX: w2, minFontScaleY: _2, glyphOffset: A3, isSDF: k2, sectionIndex: S3 } = e2[n3], I3 = m2.vertexLength, z2 = A3[1];
            Nh(y2, o2.x, o2.y, o2.z, l2.x, l2.y, i4.x, z2 + i4.y, h3.x, h3.y, r2, k2, g3.x, g3.y, w2, _2), Nh(y2, o2.x, o2.y, o2.z, l2.x, l2.y, a3.x, z2 + a3.y, h3.x + h3.w, h3.y, r2, k2, x4.x, g3.y, w2, _2), Nh(y2, o2.x, o2.y, o2.z, l2.x, l2.y, u3.x, z2 + u3.y, h3.x, h3.y + h3.h, r2, k2, g3.x, x4.y, w2, _2), Nh(y2, o2.x, o2.y, o2.z, l2.x, l2.y, c3.x, z2 + c3.y, h3.x + h3.w, h3.y + h3.h, r2, k2, x4.x, x4.y, w2, _2), Gh(t2.dynamicLayoutVertexArray, o2, v3), f2.emplaceBack(I3, I3 + 1, I3 + 2), f2.emplaceBack(I3 + 1, I3 + 2, I3 + 3), m2.vertexLength += 4, m2.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(A3[0]), n3 !== e2.length - 1 && S3 === e2[n3 + 1].sectionIndex || t2.programConfigurations.populatePaintArrays(y2.length, s3, s3.index, {}, p2, d2, b2 && b2[S3]);
          }
          t2.placedSymbolArray.emplaceBack(o2.x, o2.y, o2.z, l2.x, l2.y, g2, this.glyphOffsetArray.length - g2, x3, u2, c2, l2.segment, r2 ? r2[0] : 0, r2 ? r2[1] : 0, n2[0], n2[1], a2, 0, false, 0, h2, 0);
        }
        _commitLayoutVertex(t2, e2, r2, n2, i3, s3, a2) {
          t2.emplaceBack(e2, r2, n2, i3, s3, Math.round(a2.x), Math.round(a2.y));
        }
        _addCollisionDebugVertices(t2, e2, r2, n2, s3, a2, o2) {
          const l2 = r2.segments.prepareSegment(4, r2.layoutVertexArray, r2.indexArray), u2 = l2.vertexLength, c2 = o2.tileAnchorX, h2 = o2.tileAnchorY;
          for (let t3 = 0; t3 < 4; t3++)
            r2.collisionVertexArray.emplaceBack(0, 0, 0, 0);
          r2.collisionVertexArrayExt.emplaceBack(e2, -t2.padding, -t2.padding), r2.collisionVertexArrayExt.emplaceBack(e2, t2.padding, -t2.padding), r2.collisionVertexArrayExt.emplaceBack(e2, t2.padding, t2.padding), r2.collisionVertexArrayExt.emplaceBack(e2, -t2.padding, t2.padding), this._commitLayoutVertex(r2.layoutVertexArray, n2, s3, a2, c2, h2, new i2(t2.x1, t2.y1)), this._commitLayoutVertex(r2.layoutVertexArray, n2, s3, a2, c2, h2, new i2(t2.x2, t2.y1)), this._commitLayoutVertex(r2.layoutVertexArray, n2, s3, a2, c2, h2, new i2(t2.x2, t2.y2)), this._commitLayoutVertex(r2.layoutVertexArray, n2, s3, a2, c2, h2, new i2(t2.x1, t2.y2)), l2.vertexLength += 4;
          const p2 = r2.indexArray;
          p2.emplaceBack(u2, u2 + 1), p2.emplaceBack(u2 + 1, u2 + 2), p2.emplaceBack(u2 + 2, u2 + 3), p2.emplaceBack(u2 + 3, u2), l2.primitiveLength += 4;
        }
        _addTextDebugCollisionBoxes(t2, e2, r2, n2, i3, s3) {
          for (let a2 = n2; a2 < i3; a2++) {
            const n3 = r2.get(a2), i4 = this.getSymbolInstanceTextSize(t2, s3, e2, a2);
            this._addCollisionDebugVertices(n3, i4, this.textCollisionBox, n3.projectedAnchorX, n3.projectedAnchorY, n3.projectedAnchorZ, s3);
          }
        }
        _addIconDebugCollisionBoxes(t2, e2, r2, n2, i3, s3) {
          for (let a2 = n2; a2 < i3; a2++) {
            const n3 = r2.get(a2), i4 = this.getSymbolInstanceIconSize(t2, e2, a2);
            this._addCollisionDebugVertices(n3, i4, this.iconCollisionBox, n3.projectedAnchorX, n3.projectedAnchorY, n3.projectedAnchorZ, s3);
          }
        }
        generateCollisionDebugBuffers(t2, e2) {
          this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new Kh(wa, nc.members, Ca), this.iconCollisionBox = new Kh(wa, nc.members, Ca);
          const r2 = uc(this.iconSizeData, t2), n2 = uc(this.textSizeData, t2);
          for (let i3 = 0; i3 < this.symbolInstances.length; i3++) {
            const s3 = this.symbolInstances.get(i3);
            this._addTextDebugCollisionBoxes(n2, t2, e2, s3.textBoxStartIndex, s3.textBoxEndIndex, s3), this._addTextDebugCollisionBoxes(n2, t2, e2, s3.verticalTextBoxStartIndex, s3.verticalTextBoxEndIndex, s3), this._addIconDebugCollisionBoxes(r2, t2, e2, s3.iconBoxStartIndex, s3.iconBoxEndIndex, s3), this._addIconDebugCollisionBoxes(r2, t2, e2, s3.verticalIconBoxStartIndex, s3.verticalIconBoxEndIndex, s3);
          }
        }
        getSymbolInstanceTextSize(t2, e2, r2, n2) {
          const i3 = this.text.placedSymbolArray.get(e2.rightJustifiedTextSymbolIndex >= 0 ? e2.rightJustifiedTextSymbolIndex : e2.centerJustifiedTextSymbolIndex >= 0 ? e2.centerJustifiedTextSymbolIndex : e2.leftJustifiedTextSymbolIndex >= 0 ? e2.leftJustifiedTextSymbolIndex : e2.verticalPlacedTextSymbolIndex >= 0 ? e2.verticalPlacedTextSymbolIndex : n2), s3 = lc(this.textSizeData, t2, i3) / sc;
          return this.tilePixelRatio * s3;
        }
        getSymbolInstanceIconSize(t2, e2, r2) {
          const n2 = this.icon.placedSymbolArray.get(r2), i3 = lc(this.iconSizeData, t2, n2);
          return this.tilePixelRatio * i3;
        }
        _commitDebugCollisionVertexUpdate(t2, e2, r2) {
          t2.emplaceBack(e2, -r2, -r2), t2.emplaceBack(e2, r2, -r2), t2.emplaceBack(e2, r2, r2), t2.emplaceBack(e2, -r2, r2);
        }
        _updateTextDebugCollisionBoxes(t2, e2, r2, n2, i3, s3) {
          for (let a2 = n2; a2 < i3; a2++) {
            const n3 = r2.get(a2), i4 = this.getSymbolInstanceTextSize(t2, s3, e2, a2);
            this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt, i4, n3.padding);
          }
        }
        _updateIconDebugCollisionBoxes(t2, e2, r2, n2, i3) {
          for (let s3 = n2; s3 < i3; s3++) {
            const n3 = r2.get(s3), i4 = this.getSymbolInstanceIconSize(t2, e2, s3);
            this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt, i4, n3.padding);
          }
        }
        updateCollisionDebugBuffers(t2, e2) {
          if (!this.hasDebugData())
            return;
          this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexArrayExt.clear(), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexArrayExt.clear();
          const r2 = uc(this.iconSizeData, t2), n2 = uc(this.textSizeData, t2);
          for (let i3 = 0; i3 < this.symbolInstances.length; i3++) {
            const s3 = this.symbolInstances.get(i3);
            this._updateTextDebugCollisionBoxes(n2, t2, e2, s3.textBoxStartIndex, s3.textBoxEndIndex, s3), this._updateTextDebugCollisionBoxes(n2, t2, e2, s3.verticalTextBoxStartIndex, s3.verticalTextBoxEndIndex, s3), this._updateIconDebugCollisionBoxes(r2, t2, e2, s3.iconBoxStartIndex, s3.iconBoxEndIndex), this._updateIconDebugCollisionBoxes(r2, t2, e2, s3.verticalIconBoxStartIndex, s3.verticalIconBoxEndIndex);
          }
          this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexBufferExt && this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexBufferExt && this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);
        }
        _deserializeCollisionBoxesForSymbol(t2, e2, r2, n2, i3, s3, a2, o2, l2) {
          const u2 = {};
          for (let n3 = e2; n3 < r2; n3++) {
            const e3 = t2.get(n3);
            u2.textBox = { x1: e3.x1, y1: e3.y1, x2: e3.x2, y2: e3.y2, padding: e3.padding, projectedAnchorX: e3.projectedAnchorX, projectedAnchorY: e3.projectedAnchorY, projectedAnchorZ: e3.projectedAnchorZ, tileAnchorX: e3.tileAnchorX, tileAnchorY: e3.tileAnchorY }, u2.textFeatureIndex = e3.featureIndex;
            break;
          }
          for (let e3 = n2; e3 < i3; e3++) {
            const r3 = t2.get(e3);
            u2.verticalTextBox = { x1: r3.x1, y1: r3.y1, x2: r3.x2, y2: r3.y2, padding: r3.padding, projectedAnchorX: r3.projectedAnchorX, projectedAnchorY: r3.projectedAnchorY, projectedAnchorZ: r3.projectedAnchorZ, tileAnchorX: r3.tileAnchorX, tileAnchorY: r3.tileAnchorY }, u2.verticalTextFeatureIndex = r3.featureIndex;
            break;
          }
          for (let e3 = s3; e3 < a2; e3++) {
            const r3 = t2.get(e3);
            u2.iconBox = { x1: r3.x1, y1: r3.y1, x2: r3.x2, y2: r3.y2, padding: r3.padding, projectedAnchorX: r3.projectedAnchorX, projectedAnchorY: r3.projectedAnchorY, projectedAnchorZ: r3.projectedAnchorZ, tileAnchorX: r3.tileAnchorX, tileAnchorY: r3.tileAnchorY }, u2.iconFeatureIndex = r3.featureIndex;
            break;
          }
          for (let e3 = o2; e3 < l2; e3++) {
            const r3 = t2.get(e3);
            u2.verticalIconBox = { x1: r3.x1, y1: r3.y1, x2: r3.x2, y2: r3.y2, padding: r3.padding, projectedAnchorX: r3.projectedAnchorX, projectedAnchorY: r3.projectedAnchorY, projectedAnchorZ: r3.projectedAnchorZ, tileAnchorX: r3.tileAnchorX, tileAnchorY: r3.tileAnchorY }, u2.verticalIconFeatureIndex = r3.featureIndex;
            break;
          }
          return u2;
        }
        deserializeCollisionBoxes(t2) {
          this.collisionArrays = [];
          for (let e2 = 0; e2 < this.symbolInstances.length; e2++) {
            const r2 = this.symbolInstances.get(e2);
            this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t2, r2.textBoxStartIndex, r2.textBoxEndIndex, r2.verticalTextBoxStartIndex, r2.verticalTextBoxEndIndex, r2.iconBoxStartIndex, r2.iconBoxEndIndex, r2.verticalIconBoxStartIndex, r2.verticalIconBoxEndIndex));
          }
        }
        hasTextData() {
          return this.text.segments.get().length > 0;
        }
        hasIconData() {
          return this.icon.segments.get().length > 0;
        }
        hasDebugData() {
          return this.textCollisionBox && this.iconCollisionBox;
        }
        hasTextCollisionBoxData() {
          return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
        }
        hasIconCollisionBoxData() {
          return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
        }
        addIndicesForPlacedSymbol(t2, e2) {
          const r2 = t2.placedSymbolArray.get(e2), n2 = r2.vertexStartIndex + 4 * r2.numGlyphs;
          for (let e3 = r2.vertexStartIndex; e3 < n2; e3 += 4)
            t2.indexArray.emplaceBack(e3, e3 + 1, e3 + 2), t2.indexArray.emplaceBack(e3 + 1, e3 + 2, e3 + 3);
        }
        getSortedSymbolIndexes(t2) {
          if (this.sortedAngle === t2 && this.symbolInstanceIndexes !== void 0)
            return this.symbolInstanceIndexes;
          const e2 = Math.sin(t2), r2 = Math.cos(t2), n2 = [], i3 = [], s3 = [];
          for (let t3 = 0; t3 < this.symbolInstances.length; ++t3) {
            s3.push(t3);
            const a2 = this.symbolInstances.get(t3);
            n2.push(0 | Math.round(e2 * a2.tileAnchorX + r2 * a2.tileAnchorY)), i3.push(a2.featureIndex);
          }
          return s3.sort((t3, e3) => n2[t3] - n2[e3] || i3[e3] - i3[t3]), s3;
        }
        addToSortKeyRanges(t2, e2) {
          const r2 = this.sortKeyRanges[this.sortKeyRanges.length - 1];
          r2 && r2.sortKey === e2 ? r2.symbolInstanceEnd = t2 + 1 : this.sortKeyRanges.push({ sortKey: e2, symbolInstanceStart: t2, symbolInstanceEnd: t2 + 1 });
        }
        sortFeatures(t2) {
          if (this.sortFeaturesByY && this.sortedAngle !== t2 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
            this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t2), this.sortedAngle = t2, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
            for (const t3 of this.symbolInstanceIndexes) {
              const e2 = this.symbolInstances.get(t3);
              this.featureSortOrder.push(e2.featureIndex), [e2.rightJustifiedTextSymbolIndex, e2.centerJustifiedTextSymbolIndex, e2.leftJustifiedTextSymbolIndex].forEach((t4, e3, r2) => {
                t4 >= 0 && r2.indexOf(t4) === e3 && this.addIndicesForPlacedSymbol(this.text, t4);
              }), e2.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, e2.verticalPlacedTextSymbolIndex), e2.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e2.placedIconSymbolIndex), e2.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e2.verticalPlacedIconSymbolIndex);
            }
            this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
          }
        }
      }
      Zi("SymbolBucket", Yh, { omit: ["layers", "collisionBoxArray", "features", "compareText"] }), Yh.MAX_GLYPHS = 65535, Yh.addDynamicAttributes = Gh;
      const Hh = new sa({ "symbol-placement": new ta(ve.layout_symbol["symbol-placement"]), "symbol-spacing": new ta(ve.layout_symbol["symbol-spacing"]), "symbol-avoid-edges": new ta(ve.layout_symbol["symbol-avoid-edges"]), "symbol-sort-key": new ea(ve.layout_symbol["symbol-sort-key"]), "symbol-z-order": new ta(ve.layout_symbol["symbol-z-order"]), "icon-allow-overlap": new ta(ve.layout_symbol["icon-allow-overlap"]), "icon-ignore-placement": new ta(ve.layout_symbol["icon-ignore-placement"]), "icon-optional": new ta(ve.layout_symbol["icon-optional"]), "icon-rotation-alignment": new ta(ve.layout_symbol["icon-rotation-alignment"]), "icon-size": new ea(ve.layout_symbol["icon-size"]), "icon-text-fit": new ta(ve.layout_symbol["icon-text-fit"]), "icon-text-fit-padding": new ta(ve.layout_symbol["icon-text-fit-padding"]), "icon-image": new ea(ve.layout_symbol["icon-image"]), "icon-rotate": new ea(ve.layout_symbol["icon-rotate"]), "icon-padding": new ta(ve.layout_symbol["icon-padding"]), "icon-keep-upright": new ta(ve.layout_symbol["icon-keep-upright"]), "icon-offset": new ea(ve.layout_symbol["icon-offset"]), "icon-anchor": new ea(ve.layout_symbol["icon-anchor"]), "icon-pitch-alignment": new ta(ve.layout_symbol["icon-pitch-alignment"]), "text-pitch-alignment": new ta(ve.layout_symbol["text-pitch-alignment"]), "text-rotation-alignment": new ta(ve.layout_symbol["text-rotation-alignment"]), "text-field": new ea(ve.layout_symbol["text-field"]), "text-font": new ea(ve.layout_symbol["text-font"]), "text-size": new ea(ve.layout_symbol["text-size"]), "text-max-width": new ea(ve.layout_symbol["text-max-width"]), "text-line-height": new ea(ve.layout_symbol["text-line-height"]), "text-letter-spacing": new ea(ve.layout_symbol["text-letter-spacing"]), "text-justify": new ea(ve.layout_symbol["text-justify"]), "text-radial-offset": new ea(ve.layout_symbol["text-radial-offset"]), "text-variable-anchor": new ta(ve.layout_symbol["text-variable-anchor"]), "text-anchor": new ea(ve.layout_symbol["text-anchor"]), "text-max-angle": new ta(ve.layout_symbol["text-max-angle"]), "text-writing-mode": new ta(ve.layout_symbol["text-writing-mode"]), "text-rotate": new ea(ve.layout_symbol["text-rotate"]), "text-padding": new ta(ve.layout_symbol["text-padding"]), "text-keep-upright": new ta(ve.layout_symbol["text-keep-upright"]), "text-transform": new ea(ve.layout_symbol["text-transform"]), "text-offset": new ea(ve.layout_symbol["text-offset"]), "text-allow-overlap": new ta(ve.layout_symbol["text-allow-overlap"]), "text-ignore-placement": new ta(ve.layout_symbol["text-ignore-placement"]), "text-optional": new ta(ve.layout_symbol["text-optional"]) });
      var Jh = { paint: new sa({ "icon-opacity": new ea(ve.paint_symbol["icon-opacity"]), "icon-color": new ea(ve.paint_symbol["icon-color"]), "icon-halo-color": new ea(ve.paint_symbol["icon-halo-color"]), "icon-halo-width": new ea(ve.paint_symbol["icon-halo-width"]), "icon-halo-blur": new ea(ve.paint_symbol["icon-halo-blur"]), "icon-translate": new ta(ve.paint_symbol["icon-translate"]), "icon-translate-anchor": new ta(ve.paint_symbol["icon-translate-anchor"]), "text-opacity": new ea(ve.paint_symbol["text-opacity"]), "text-color": new ea(ve.paint_symbol["text-color"], { runtimeType: Ce, getOverride: (t2) => t2.textColor, hasOverride: (t2) => !!t2.textColor }), "text-halo-color": new ea(ve.paint_symbol["text-halo-color"]), "text-halo-width": new ea(ve.paint_symbol["text-halo-width"]), "text-halo-blur": new ea(ve.paint_symbol["text-halo-blur"]), "text-translate": new ta(ve.paint_symbol["text-translate"]), "text-translate-anchor": new ta(ve.paint_symbol["text-translate-anchor"]) }), layout: Hh };
      class Wh {
        constructor(t2) {
          this.type = t2.property.overrides ? t2.property.overrides.runtimeType : ze, this.defaultValue = t2;
        }
        evaluate(t2) {
          if (t2.formattedSection) {
            const e2 = this.defaultValue.property.overrides;
            if (e2 && e2.hasOverride(t2.formattedSection))
              return e2.getOverride(t2.formattedSection);
          }
          return t2.feature && t2.featureState ? this.defaultValue.evaluate(t2.feature, t2.featureState) : this.defaultValue.property.specification.default;
        }
        eachChild(t2) {
          this.defaultValue.isConstant() || t2(this.defaultValue.value._styleExpression.expression);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          return null;
        }
      }
      Zi("FormatSectionOverride", Wh, { omit: ["defaultValue"] });
      class Qh extends So {
        constructor(t2) {
          super(t2, Jh);
        }
        recalculate(t2, e2) {
          super.recalculate(t2, e2), this.layout.get("icon-rotation-alignment") === "auto" && (this.layout._values["icon-rotation-alignment"] = this.layout.get("symbol-placement") !== "point" ? "map" : "viewport"), this.layout.get("text-rotation-alignment") === "auto" && (this.layout._values["text-rotation-alignment"] = this.layout.get("symbol-placement") !== "point" ? "map" : "viewport"), this.layout.get("text-pitch-alignment") === "auto" && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), this.layout.get("icon-pitch-alignment") === "auto" && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"));
          const r2 = this.layout.get("text-writing-mode");
          if (r2) {
            const t3 = [];
            for (const e3 of r2)
              t3.indexOf(e3) < 0 && t3.push(e3);
            this.layout._values["text-writing-mode"] = t3;
          } else
            this.layout._values["text-writing-mode"] = this.layout.get("symbol-placement") === "point" ? ["horizontal"] : ["horizontal", "vertical"];
          this._setPaintOverrides();
        }
        getValueAndResolveTokens(t2, e2, r2, n2) {
          const i3 = this.layout.get(t2).evaluate(e2, {}, r2, n2), s3 = this._unevaluatedLayout._values[t2];
          return s3.isDataDriven() || Nn(s3.value) || !i3 ? i3 : function(t3, e3) {
            return e3.replace(/{([^{}]+)}/g, (e4, r3) => r3 in t3 ? String(t3[r3]) : "");
          }(e2.properties, i3);
        }
        createBucket(t2) {
          return new Yh(t2);
        }
        queryRadius() {
          return 0;
        }
        queryIntersectsFeature() {
          return false;
        }
        _setPaintOverrides() {
          for (const t2 of Jh.paint.overridableProperties) {
            if (!Qh.hasPaintOverride(this.layout, t2))
              continue;
            const e2 = this.paint.get(t2), r2 = new Wh(e2), n2 = new qn(r2, e2.property.specification);
            let i3 = null;
            i3 = e2.value.kind === "constant" || e2.value.kind === "source" ? new Zn("source", n2) : new Xn("composite", n2, e2.value.zoomStops, e2.value._interpolationType), this.paint._values[t2] = new Ws(e2.property, i3, e2.parameters);
          }
        }
        _handleOverridablePaintPropertyUpdate(t2, e2, r2) {
          return !(!this.layout || e2.isDataDriven() || r2.isDataDriven()) && Qh.hasPaintOverride(this.layout, t2);
        }
        static hasPaintOverride(t2, e2) {
          const r2 = t2.get("text-field"), n2 = Jh.paint.properties[e2];
          let i3 = false;
          const s3 = (t3) => {
            for (const e3 of t3)
              if (n2.overrides && n2.overrides.hasOverride(e3))
                return void (i3 = true);
          };
          if (r2.value.kind === "constant" && r2.value.value instanceof Ke)
            s3(r2.value.value.sections);
          else if (r2.value.kind === "source") {
            const t3 = (e4) => {
              i3 || (e4 instanceof tr && We(e4.value) === Ve ? s3(e4.value.sections) : e4 instanceof ir ? s3(e4.sections) : e4.eachChild(t3));
            }, e3 = r2.value;
            e3._styleExpression && t3(e3._styleExpression.expression);
          }
          return i3;
        }
        getProgramConfiguration(t2) {
          return new go(this, t2);
        }
      }
      var tp = { paint: new sa({ "background-color": new ta(ve.paint_background["background-color"]), "background-pattern": new na(ve.paint_background["background-pattern"]), "background-opacity": new ta(ve.paint_background["background-opacity"]) }) }, ep = { paint: new sa({ "raster-opacity": new ta(ve.paint_raster["raster-opacity"]), "raster-hue-rotate": new ta(ve.paint_raster["raster-hue-rotate"]), "raster-brightness-min": new ta(ve.paint_raster["raster-brightness-min"]), "raster-brightness-max": new ta(ve.paint_raster["raster-brightness-max"]), "raster-saturation": new ta(ve.paint_raster["raster-saturation"]), "raster-contrast": new ta(ve.paint_raster["raster-contrast"]), "raster-resampling": new ta(ve.paint_raster["raster-resampling"]), "raster-fade-duration": new ta(ve.paint_raster["raster-fade-duration"]) }) };
      class rp extends So {
        constructor(t2) {
          super(t2, {}), this.implementation = t2;
        }
        is3D() {
          return this.implementation.renderingMode === "3d";
        }
        hasOffscreenPass() {
          return this.implementation.prerender !== void 0;
        }
        recalculate() {
        }
        updateTransitions() {
        }
        hasTransition() {
        }
        serialize() {
        }
        onAdd(t2) {
          this.implementation.onAdd && this.implementation.onAdd(t2, t2.painter.context.gl);
        }
        onRemove(t2) {
          this.implementation.onRemove && this.implementation.onRemove(t2, t2.painter.context.gl);
        }
      }
      var np = { paint: new sa({ "sky-type": new ta(ve.paint_sky["sky-type"]), "sky-atmosphere-sun": new ta(ve.paint_sky["sky-atmosphere-sun"]), "sky-atmosphere-sun-intensity": new ta(ve.paint_sky["sky-atmosphere-sun-intensity"]), "sky-gradient-center": new ta(ve.paint_sky["sky-gradient-center"]), "sky-gradient-radius": new ta(ve.paint_sky["sky-gradient-radius"]), "sky-gradient": new ia(ve.paint_sky["sky-gradient"]), "sky-atmosphere-halo-color": new ta(ve.paint_sky["sky-atmosphere-halo-color"]), "sky-atmosphere-color": new ta(ve.paint_sky["sky-atmosphere-color"]), "sky-opacity": new ta(ve.paint_sky["sky-opacity"]) }) };
      function ip(t2, e2, r2) {
        const n2 = b(0, 0, 1), i3 = R5(L2());
        return function(t3, e3, r3) {
          r3 *= 0.5;
          var n3 = e3[0], i4 = e3[1], s3 = e3[2], a2 = e3[3], o2 = Math.sin(r3), l2 = Math.cos(r3);
          t3[0] = n3 * l2 - s3 * o2, t3[1] = i4 * l2 + a2 * o2, t3[2] = s3 * l2 + n3 * o2, t3[3] = a2 * l2 - i4 * o2;
        }(i3, i3, r2 ? -q(t2) + Math.PI : q(t2)), U(i3, i3, -q(e2)), C(n2, n2, i3), z(n2, n2);
      }
      const sp = { circle: class extends So {
        constructor(t2) {
          super(t2, yl);
        }
        createBucket(t2) {
          return new Jo(t2);
        }
        queryRadius(t2) {
          const e2 = t2;
          return cl("circle-radius", this, e2) + cl("circle-stroke-width", this, e2) + hl(this.paint.get("circle-translate"));
        }
        queryIntersectsFeature(t2, e2, r2, n2, i3, s3, a2, o2) {
          const l2 = dl(this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), s3.angle, t2.pixelToTileUnitsFactor), u2 = this.paint.get("circle-radius").evaluate(e2, r2) + this.paint.get("circle-stroke-width").evaluate(e2, r2);
          return xl(t2, n2, s3, a2, o2, this.paint.get("circle-pitch-alignment") === "map", this.paint.get("circle-pitch-scale") === "map", l2, u2);
        }
        getProgramIds() {
          return ["circle"];
        }
        getProgramConfiguration(t2) {
          return new go(this, t2);
        }
      }, heatmap: class extends So {
        createBucket(t2) {
          return new Al(t2);
        }
        constructor(t2) {
          super(t2, Tl), this._updateColorRamp();
        }
        _handleSpecialPaintPropertyUpdate(t2) {
          t2 === "heatmap-color" && this._updateColorRamp();
        }
        _updateColorRamp() {
          this.colorRamp = Bl({ expression: this._transitionablePaint._values["heatmap-color"].value.expression, evaluationKey: "heatmapDensity", image: this.colorRamp }), this.colorRampTexture = null;
        }
        resize() {
          this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
        }
        queryRadius(t2) {
          return cl("heatmap-radius", this, t2);
        }
        queryIntersectsFeature(t2, e2, r2, n2, s3, a2, o2, l2) {
          const u2 = this.paint.get("heatmap-radius").evaluate(e2, r2);
          return xl(t2, n2, a2, o2, l2, true, true, new i2(0, 0), u2);
        }
        hasOffscreenPass() {
          return this.paint.get("heatmap-opacity") !== 0 && this.visibility !== "none";
        }
        getProgramIds() {
          return ["heatmap", "heatmapTexture"];
        }
        getProgramConfiguration(t2) {
          return new go(this, t2);
        }
      }, hillshade: class extends So {
        constructor(t2) {
          super(t2, Cl);
        }
        hasOffscreenPass() {
          return this.paint.get("hillshade-exaggeration") !== 0 && this.visibility !== "none";
        }
        getProgramIds() {
          return ["hillshade", "hillshadePrepare"];
        }
        getProgramConfiguration(t2) {
          return new go(this, t2);
        }
      }, fill: class extends So {
        constructor(t2) {
          super(t2, xu);
        }
        getProgramIds() {
          const t2 = this.paint.get("fill-pattern"), e2 = t2 && t2.constantOr(1), r2 = [e2 ? "fillPattern" : "fill"];
          return this.paint.get("fill-antialias") && r2.push(e2 && !this.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline"), r2;
        }
        getProgramConfiguration(t2) {
          return new go(this, t2);
        }
        recalculate(t2, e2) {
          super.recalculate(t2, e2);
          const r2 = this.paint._values["fill-outline-color"];
          r2.value.kind === "constant" && r2.value.value === void 0 && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
        }
        createBucket(t2) {
          return new mu(t2);
        }
        queryRadius() {
          return hl(this.paint.get("fill-translate"));
        }
        queryIntersectsFeature(t2, e2, r2, n2, i3, s3) {
          return !t2.queryGeometry.isAboveHorizon && tl(pl(t2.tilespaceGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), s3.angle, t2.pixelToTileUnitsFactor), n2);
        }
        isTileClipped() {
          return true;
        }
      }, "fill-extrusion": class extends So {
        constructor(t2) {
          super(t2, Lu);
        }
        createBucket(t2) {
          return new Vu(t2);
        }
        queryRadius() {
          return hl(this.paint.get("fill-extrusion-translate"));
        }
        is3D() {
          return true;
        }
        getProgramIds() {
          return [this.paint.get("fill-extrusion-pattern").constantOr(1) ? "fillExtrusionPattern" : "fillExtrusion"];
        }
        getProgramConfiguration(t2) {
          return new go(this, t2);
        }
        queryIntersectsFeature(t2, e2, r2, n2, s3, a2, o2, l2, u2) {
          const c2 = dl(this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), a2.angle, t2.pixelToTileUnitsFactor), h2 = this.paint.get("fill-extrusion-height").evaluate(e2, r2), p2 = this.paint.get("fill-extrusion-base").evaluate(e2, r2), d2 = [0, 0], f2 = l2 && a2.elevation, y2 = a2.elevation ? a2.elevation.exaggeration() : 1;
          if (f2) {
            const e3 = t2.tile.getBucket(this).centroidVertexArray, r3 = u2 + 1;
            if (r3 < e3.length) {
              const t3 = e3.get(r3);
              d2[0] = t3.a_centroid_pos0, d2[1] = t3.a_centroid_pos1;
            }
          }
          if (d2[0] === 0 && d2[1] === 1)
            return false;
          const m2 = function(t3, e3, r3, n3, s4, a3, o3, l3, u3) {
            return a3 ? function(t4, e4, r4, n4, i3, s5, a4, o4, l4) {
              const u4 = [], c3 = [], h3 = [0, 0, 0, 1];
              for (const p3 of t4) {
                const t5 = [], d3 = [];
                for (const u5 of p3) {
                  const c4 = u5.x + n4.x, p4 = u5.y + n4.y, f3 = Ou(c4, p4, e4, r4, s5, a4, o4, l4);
                  h3[0] = c4, h3[1] = p4, h3[2] = f3.base, h3[3] = 1, F(h3, h3, i3), h3[3] = Math.max(h3[3], 1e-5);
                  const y3 = $u([h3[0] / h3[3], h3[1] / h3[3], h3[2] / h3[3]]);
                  h3[0] = c4, h3[1] = p4, h3[2] = f3.top, h3[3] = 1, F(h3, h3, i3), h3[3] = Math.max(h3[3], 1e-5);
                  const m3 = $u([h3[0] / h3[3], h3[1] / h3[3], h3[2] / h3[3]]);
                  t5.push(y3), d3.push(m3);
                }
                u4.push(t5), c3.push(d3);
              }
              return [u4, c3];
            }(t3, e3, r3, n3, s4, a3, o3, l3, u3) : function(t4, e4, r4, n4, s5) {
              const a4 = [], o4 = [], l4 = s5[8] * e4, u4 = s5[9] * e4, c3 = s5[10] * e4, h3 = s5[11] * e4, p3 = s5[8] * r4, d3 = s5[9] * r4, f3 = s5[10] * r4, y3 = s5[11] * r4;
              for (const e5 of t4) {
                const t5 = [], r5 = [];
                for (const a5 of e5) {
                  const e6 = a5.x + n4.x, o5 = a5.y + n4.y, m3 = s5[0] * e6 + s5[4] * o5 + s5[12], g3 = s5[1] * e6 + s5[5] * o5 + s5[13], x3 = s5[2] * e6 + s5[6] * o5 + s5[14], v3 = s5[3] * e6 + s5[7] * o5 + s5[15], b2 = m3 + l4, w2 = g3 + u4, _2 = x3 + c3, A3 = Math.max(v3 + h3, 1e-5), k2 = m3 + p3, S3 = g3 + d3, I3 = x3 + f3, z2 = Math.max(v3 + y3, 1e-5), M3 = new i2(b2 / A3, w2 / A3);
                  M3.z = _2 / A3, t5.push(M3);
                  const T2 = new i2(k2 / z2, S3 / z2);
                  T2.z = I3 / z2, r5.push(T2);
                }
                a4.push(t5), o4.push(r5);
              }
              return [a4, o4];
            }(t3, e3, r3, n3, s4);
          }(n2, p2, h2, c2, o2, f2 ? l2 : null, d2, y2, a2.center.lat), g2 = t2.queryGeometry;
          return function(t3, e3, r3) {
            let n3 = 1 / 0;
            tl(r3, e3) && (n3 = Uu(r3, e3[0]));
            for (let i3 = 0; i3 < e3.length; i3++) {
              const s4 = e3[i3], a3 = t3[i3];
              for (let t4 = 0; t4 < s4.length - 1; t4++) {
                const e4 = s4[t4], i4 = [e4, s4[t4 + 1], a3[t4 + 1], a3[t4], e4];
                Wo(r3, i4) && (n3 = Math.min(n3, Uu(r3, i4)));
              }
            }
            return n3 !== 1 / 0 && n3;
          }(m2[0], m2[1], g2.isPointQuery() ? g2.screenBounds : g2.screenGeometry);
        }
      }, line: class extends So {
        constructor(t2) {
          super(t2, Hu), this.gradientVersion = 0;
        }
        _handleSpecialPaintPropertyUpdate(t2) {
          if (t2 === "line-gradient") {
            const t3 = this._transitionablePaint._values["line-gradient"].value.expression;
            this.stepInterpolant = t3._styleExpression && t3._styleExpression.expression instanceof Fr, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
          }
        }
        gradientExpression() {
          return this._transitionablePaint._values["line-gradient"].value.expression;
        }
        recalculate(t2, e2) {
          super.recalculate(t2, e2), this.paint._values["line-floorwidth"] = Ju.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t2);
        }
        createBucket(t2) {
          return new Ku(t2);
        }
        getProgramIds() {
          return [this.paint.get("line-pattern").constantOr(1) ? "linePattern" : "line"];
        }
        getProgramConfiguration(t2) {
          return new go(this, t2);
        }
        queryRadius(t2) {
          const e2 = t2, r2 = Wu(cl("line-width", this, e2), cl("line-gap-width", this, e2)), n2 = cl("line-offset", this, e2);
          return r2 / 2 + Math.abs(n2) + hl(this.paint.get("line-translate"));
        }
        queryIntersectsFeature(t2, e2, r2, n2, s3, a2) {
          if (t2.queryGeometry.isAboveHorizon)
            return false;
          const o2 = pl(t2.tilespaceGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), a2.angle, t2.pixelToTileUnitsFactor), l2 = t2.pixelToTileUnitsFactor / 2 * Wu(this.paint.get("line-width").evaluate(e2, r2), this.paint.get("line-gap-width").evaluate(e2, r2)), u2 = this.paint.get("line-offset").evaluate(e2, r2);
          return u2 && (n2 = function(t3, e3) {
            const r3 = [], n3 = new i2(0, 0);
            for (let i3 = 0; i3 < t3.length; i3++) {
              const s4 = t3[i3], a3 = [];
              for (let t4 = 0; t4 < s4.length; t4++) {
                const r4 = s4[t4 - 1], i4 = s4[t4], o3 = s4[t4 + 1], l3 = t4 === 0 ? n3 : i4.sub(r4)._unit()._perp(), u3 = t4 === s4.length - 1 ? n3 : o3.sub(i4)._unit()._perp(), c2 = l3._add(u3)._unit();
                c2._mult(1 / (c2.x * u3.x + c2.y * u3.y)), a3.push(c2._mult(e3)._add(i4));
              }
              r3.push(a3);
            }
            return r3;
          }(n2, u2 * t2.pixelToTileUnitsFactor)), function(t3, e3, r3) {
            for (let n3 = 0; n3 < e3.length; n3++) {
              const i3 = e3[n3];
              if (t3.length >= 3) {
                for (let e4 = 0; e4 < i3.length; e4++)
                  if (ol(t3, i3[e4]))
                    return true;
              }
              if (el(t3, i3, r3))
                return true;
            }
            return false;
          }(o2, n2, l2);
        }
        isTileClipped() {
          return true;
        }
      }, symbol: Qh, background: class extends So {
        constructor(t2) {
          super(t2, tp);
        }
        getProgramIds() {
          return [this.paint.get("background-pattern") ? "backgroundPattern" : "background"];
        }
      }, raster: class extends So {
        constructor(t2) {
          super(t2, ep);
        }
        getProgramIds() {
          return ["raster"];
        }
      }, sky: class extends So {
        constructor(t2) {
          super(t2, np), this._updateColorRamp();
        }
        _handleSpecialPaintPropertyUpdate(t2) {
          t2 === "sky-gradient" ? this._updateColorRamp() : t2 !== "sky-atmosphere-sun" && t2 !== "sky-atmosphere-halo-color" && t2 !== "sky-atmosphere-color" && t2 !== "sky-atmosphere-sun-intensity" || (this._skyboxInvalidated = true);
        }
        _updateColorRamp() {
          this.colorRamp = Bl({ expression: this._transitionablePaint._values["sky-gradient"].value.expression, evaluationKey: "skyRadialProgress" }), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
        }
        needsSkyboxCapture(t2) {
          if (this._skyboxInvalidated || !this.skyboxTexture || !this.skyboxGeometry)
            return true;
          if (!this.paint.get("sky-atmosphere-sun")) {
            const e2 = t2.style.light.properties.get("position");
            return this._lightPosition.azimuthal !== e2.azimuthal || this._lightPosition.polar !== e2.polar;
          }
        }
        getCenter(t2, e2) {
          const r2 = this.paint.get("sky-type");
          if (r2 === "atmosphere") {
            const r3 = this.paint.get("sky-atmosphere-sun"), n2 = !r3, i3 = t2.style.light, s3 = i3.properties.get("position");
            return n2 && i3.properties.get("anchor") === "viewport" && pt("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."), n2 ? ip(s3.azimuthal, 90 - s3.polar, e2) : ip(r3[0], 90 - r3[1], e2);
          }
          if (r2 === "gradient") {
            const t3 = this.paint.get("sky-gradient-center");
            return ip(t3[0], 90 - t3[1], e2);
          }
        }
        is3D() {
          return false;
        }
        isSky() {
          return true;
        }
        markSkyboxValid(t2) {
          this._skyboxInvalidated = false, this._lightPosition = t2.style.light.properties.get("position");
        }
        hasOffscreenPass() {
          return true;
        }
        getProgramIds() {
          const t2 = this.paint.get("sky-type");
          return t2 === "atmosphere" ? ["skyboxCapture", "skybox"] : t2 === "gradient" ? ["skyboxGradient"] : null;
        }
      } }, { HTMLImageElement: ap, HTMLCanvasElement: op, HTMLVideoElement: lp, ImageData: up2, ImageBitmap: cp } = a;
      class hp {
        constructor(t2, e2, r2, n2) {
          this.context = t2, this.format = r2, this.texture = t2.gl.createTexture(), this.update(e2, n2);
        }
        update(t2, e2, r2) {
          const { width: n2, height: i3 } = t2, { context: s3 } = this, { gl: a2 } = s3;
          if (a2.bindTexture(a2.TEXTURE_2D, this.texture), s3.pixelStoreUnpackFlipY.set(false), s3.pixelStoreUnpack.set(1), s3.pixelStoreUnpackPremultiplyAlpha.set(this.format === a2.RGBA && (!e2 || e2.premultiply !== false)), r2 || this.size && this.size[0] === n2 && this.size[1] === i3) {
            const { x: e3, y: s4 } = r2 || { x: 0, y: 0 };
            t2 instanceof ap || t2 instanceof op || t2 instanceof lp || t2 instanceof up2 || cp && t2 instanceof cp ? a2.texSubImage2D(a2.TEXTURE_2D, 0, e3, s4, a2.RGBA, a2.UNSIGNED_BYTE, t2) : a2.texSubImage2D(a2.TEXTURE_2D, 0, e3, s4, n2, i3, a2.RGBA, a2.UNSIGNED_BYTE, t2.data);
          } else
            this.size = [n2, i3], t2 instanceof ap || t2 instanceof op || t2 instanceof lp || t2 instanceof up2 || cp && t2 instanceof cp ? a2.texImage2D(a2.TEXTURE_2D, 0, this.format, this.format, a2.UNSIGNED_BYTE, t2) : a2.texImage2D(a2.TEXTURE_2D, 0, this.format, n2, i3, 0, this.format, a2.UNSIGNED_BYTE, t2.data);
          this.useMipmap = Boolean(e2 && e2.useMipmap && this.isSizePowerOfTwo()), this.useMipmap && a2.generateMipmap(a2.TEXTURE_2D);
        }
        bind(t2, e2) {
          const { context: r2 } = this, { gl: n2 } = r2;
          n2.bindTexture(n2.TEXTURE_2D, this.texture), t2 !== this.filter && (n2.texParameteri(n2.TEXTURE_2D, n2.TEXTURE_MAG_FILTER, t2), n2.texParameteri(n2.TEXTURE_2D, n2.TEXTURE_MIN_FILTER, this.useMipmap ? t2 === n2.NEAREST ? n2.NEAREST_MIPMAP_NEAREST : n2.LINEAR_MIPMAP_NEAREST : t2), this.filter = t2), e2 !== this.wrap && (n2.texParameteri(n2.TEXTURE_2D, n2.TEXTURE_WRAP_S, e2), n2.texParameteri(n2.TEXTURE_2D, n2.TEXTURE_WRAP_T, e2), this.wrap = e2);
        }
        isSizePowerOfTwo() {
          return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
        }
        destroy() {
          const { gl: t2 } = this.context;
          t2.deleteTexture(this.texture), this.texture = null;
        }
      }
      class pp {
        constructor(t2, e2) {
          this.width = t2, this.height = e2, this.nextRow = 0, this.image = new zl({ width: t2, height: e2 }), this.positions = {}, this.uploaded = false;
        }
        getDash(t2, e2) {
          const r2 = this.getKey(t2, e2);
          return this.positions[r2];
        }
        trim() {
          const t2 = this.width, e2 = this.height = it(this.nextRow);
          this.image.resize({ width: t2, height: e2 });
        }
        getKey(t2, e2) {
          return t2.join(",") + e2;
        }
        getDashRanges(t2, e2, r2) {
          const n2 = [];
          let i3 = t2.length % 2 == 1 ? -t2[t2.length - 1] * r2 : 0, s3 = t2[0] * r2, a2 = true;
          n2.push({ left: i3, right: s3, isDash: a2, zeroLength: t2[0] === 0 });
          let o2 = t2[0];
          for (let e3 = 1; e3 < t2.length; e3++) {
            a2 = !a2;
            const l2 = t2[e3];
            i3 = o2 * r2, o2 += l2, s3 = o2 * r2, n2.push({ left: i3, right: s3, isDash: a2, zeroLength: l2 === 0 });
          }
          return n2;
        }
        addRoundDash(t2, e2, r2) {
          const n2 = e2 / 2;
          for (let e3 = -r2; e3 <= r2; e3++) {
            const i3 = this.width * (this.nextRow + r2 + e3);
            let s3 = 0, a2 = t2[s3];
            for (let o2 = 0; o2 < this.width; o2++) {
              o2 / a2.right > 1 && (a2 = t2[++s3]);
              const l2 = Math.abs(o2 - a2.left), u2 = Math.abs(o2 - a2.right), c2 = Math.min(l2, u2);
              let h2;
              const p2 = e3 / r2 * (n2 + 1);
              if (a2.isDash) {
                const t3 = n2 - Math.abs(p2);
                h2 = Math.sqrt(c2 * c2 + t3 * t3);
              } else
                h2 = n2 - Math.sqrt(c2 * c2 + p2 * p2);
              this.image.data[i3 + o2] = Math.max(0, Math.min(255, h2 + 128));
            }
          }
        }
        addRegularDash(t2, e2) {
          for (let e3 = t2.length - 1; e3 >= 0; --e3) {
            const r3 = t2[e3], n3 = t2[e3 + 1];
            r3.zeroLength ? t2.splice(e3, 1) : n3 && n3.isDash === r3.isDash && (n3.left = r3.left, t2.splice(e3, 1));
          }
          const r2 = t2[0], n2 = t2[t2.length - 1];
          r2.isDash === n2.isDash && (r2.left = n2.left - this.width, n2.right = r2.right + this.width);
          const i3 = this.width * this.nextRow;
          let s3 = 0, a2 = t2[s3];
          for (let r3 = 0; r3 < this.width; r3++) {
            r3 / a2.right > 1 && (a2 = t2[++s3]);
            const n3 = Math.abs(r3 - a2.left), o2 = Math.abs(r3 - a2.right), l2 = Math.min(n3, o2);
            this.image.data[i3 + r3] = Math.max(0, Math.min(255, (a2.isDash ? l2 : -l2) + e2 + 128));
          }
        }
        addDash(t2, e2) {
          const r2 = this.getKey(t2, e2);
          if (this.positions[r2])
            return this.positions[r2];
          const n2 = e2 === "round", i3 = n2 ? 7 : 0, s3 = 2 * i3 + 1;
          if (this.nextRow + s3 > this.height)
            return pt("LineAtlas out of space"), null;
          t2.length === 0 && t2.push(1);
          let a2 = 0;
          for (let e3 = 0; e3 < t2.length; e3++)
            t2[e3] < 0 && (pt("Negative value is found in line dasharray, replacing values with 0"), t2[e3] = 0), a2 += t2[e3];
          if (a2 !== 0) {
            const r3 = this.width / a2, s4 = this.getDashRanges(t2, this.width, r3);
            n2 ? this.addRoundDash(s4, r3, i3) : this.addRegularDash(s4, e2 === "square" ? 0.5 * r3 : 0);
          }
          const o2 = this.nextRow + i3;
          this.nextRow += s3;
          const l2 = { tl: [o2, i3], br: [a2, 0] };
          return this.positions[r2] = l2, l2;
        }
      }
      Zi("LineAtlas", pp);
      class dp {
        constructor(t2) {
          this._callback = t2, this._triggered = false, typeof MessageChannel != "undefined" && (this._channel = new MessageChannel(), this._channel.port2.onmessage = () => {
            this._triggered = false, this._callback();
          });
        }
        trigger() {
          this._triggered || (this._triggered = true, this._channel ? this._channel.port1.postMessage(true) : setTimeout(() => {
            this._triggered = false, this._callback();
          }, 0));
        }
        remove() {
          delete this._channel, this._callback = () => {
          };
        }
      }
      const fp = a.performance;
      function yp(t2) {
        const e2 = t2 ? t2.url.toString() : void 0;
        return fp.getEntriesByName(e2);
      }
      class mp {
        constructor() {
          this.tasks = {}, this.taskQueue = [], at(["process"], this), this.invoker = new dp(this.process), this.nextId = 0;
        }
        add(t2, e2) {
          const r2 = this.nextId++, n2 = function({ type: t3, isSymbolTile: e3, zoom: r3 }) {
            return r3 = r3 || 0, t3 === "message" ? 0 : t3 !== "maybePrepare" || e3 ? t3 !== "parseTile" || e3 ? t3 === "parseTile" && e3 ? 300 - r3 : t3 === "maybePrepare" && e3 ? 400 - r3 : 500 : 200 - r3 : 100 - r3;
          }(e2);
          if (n2 === 0) {
            yt();
            try {
              t2();
            } finally {
            }
            return { cancel: () => {
            } };
          }
          return this.tasks[r2] = { fn: t2, metadata: e2, priority: n2, id: r2 }, this.taskQueue.push(r2), this.invoker.trigger(), { cancel: () => {
            delete this.tasks[r2];
          } };
        }
        process() {
          yt();
          try {
            if (this.taskQueue = this.taskQueue.filter((t3) => !!this.tasks[t3]), !this.taskQueue.length)
              return;
            const t2 = this.pick();
            if (t2 === null)
              return;
            const e2 = this.tasks[t2];
            if (delete this.tasks[t2], this.taskQueue.length && this.invoker.trigger(), !e2)
              return;
            e2.fn();
          } finally {
          }
        }
        pick() {
          let t2 = null, e2 = 1 / 0;
          for (let r3 = 0; r3 < this.taskQueue.length; r3++) {
            const n2 = this.tasks[this.taskQueue[r3]];
            n2.priority < e2 && (e2 = n2.priority, t2 = r3);
          }
          if (t2 === null)
            return null;
          const r2 = this.taskQueue[t2];
          return this.taskQueue.splice(t2, 1), r2;
        }
        remove() {
          this.invoker.remove();
        }
      }
      function gp(t2, e2, r2) {
        var n2 = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r2);
        return [t2 * n2 - 2 * Math.PI * 6378137 / 2, e2 * n2 - 2 * Math.PI * 6378137 / 2];
      }
      class xp {
        constructor(t2, e2, r2) {
          this.z = t2, this.x = e2, this.y = r2, this.key = wp(0, t2, t2, e2, r2);
        }
        equals(t2) {
          return this.z === t2.z && this.x === t2.x && this.y === t2.y;
        }
        url(t2, e2) {
          const r2 = function(t3, e3, r3) {
            var n3 = gp(256 * t3, 256 * (e3 = Math.pow(2, r3) - e3 - 1), r3), i3 = gp(256 * (t3 + 1), 256 * (e3 + 1), r3);
            return n3[0] + "," + n3[1] + "," + i3[0] + "," + i3[1];
          }(this.x, this.y, this.z), n2 = function(t3, e3, r3) {
            let n3, i3 = "";
            for (let s3 = t3; s3 > 0; s3--)
              n3 = 1 << s3 - 1, i3 += (e3 & n3 ? 1 : 0) + (r3 & n3 ? 2 : 0);
            return i3;
          }(this.z, this.x, this.y);
          return t2[(this.x + this.y) % t2.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace("{z}", String(this.z)).replace("{x}", String(this.x)).replace("{y}", String(e2 === "tms" ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", n2).replace("{bbox-epsg-3857}", r2);
        }
        toString() {
          return `${this.z}/${this.x}/${this.y}`;
        }
      }
      class vp {
        constructor(t2, e2) {
          this.wrap = t2, this.canonical = e2, this.key = wp(t2, e2.z, e2.z, e2.x, e2.y);
        }
      }
      class bp {
        constructor(t2, e2, r2, n2, i3) {
          this.overscaledZ = t2, this.wrap = e2, this.canonical = new xp(r2, +n2, +i3), this.key = e2 === 0 && t2 === r2 ? this.canonical.key : wp(e2, t2, r2, n2, i3);
        }
        equals(t2) {
          return this.overscaledZ === t2.overscaledZ && this.wrap === t2.wrap && this.canonical.equals(t2.canonical);
        }
        scaledTo(t2) {
          const e2 = this.canonical.z - t2;
          return t2 > this.canonical.z ? new bp(t2, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new bp(t2, this.wrap, t2, this.canonical.x >> e2, this.canonical.y >> e2);
        }
        calculateScaledKey(t2, e2 = true) {
          if (this.overscaledZ === t2 && e2)
            return this.key;
          if (t2 > this.canonical.z)
            return wp(this.wrap * +e2, t2, this.canonical.z, this.canonical.x, this.canonical.y);
          {
            const r2 = this.canonical.z - t2;
            return wp(this.wrap * +e2, t2, t2, this.canonical.x >> r2, this.canonical.y >> r2);
          }
        }
        isChildOf(t2) {
          if (t2.wrap !== this.wrap)
            return false;
          const e2 = this.canonical.z - t2.canonical.z;
          return t2.overscaledZ === 0 || t2.overscaledZ < this.overscaledZ && t2.canonical.x === this.canonical.x >> e2 && t2.canonical.y === this.canonical.y >> e2;
        }
        children(t2) {
          if (this.overscaledZ >= t2)
            return [new bp(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)];
          const e2 = this.canonical.z + 1, r2 = 2 * this.canonical.x, n2 = 2 * this.canonical.y;
          return [new bp(e2, this.wrap, e2, r2, n2), new bp(e2, this.wrap, e2, r2 + 1, n2), new bp(e2, this.wrap, e2, r2, n2 + 1), new bp(e2, this.wrap, e2, r2 + 1, n2 + 1)];
        }
        isLessThan(t2) {
          return this.wrap < t2.wrap || !(this.wrap > t2.wrap) && (this.overscaledZ < t2.overscaledZ || !(this.overscaledZ > t2.overscaledZ) && (this.canonical.x < t2.canonical.x || !(this.canonical.x > t2.canonical.x) && this.canonical.y < t2.canonical.y));
        }
        wrapped() {
          return new bp(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
        }
        unwrapTo(t2) {
          return new bp(this.overscaledZ, t2, this.canonical.z, this.canonical.x, this.canonical.y);
        }
        overscaleFactor() {
          return Math.pow(2, this.overscaledZ - this.canonical.z);
        }
        toUnwrapped() {
          return new vp(this.wrap, this.canonical);
        }
        toString() {
          return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
        }
      }
      function wp(t2, e2, r2, n2, i3) {
        const s3 = 1 << Math.min(r2, 22);
        let a2 = s3 * (i3 % s3) + n2 % s3;
        return t2 && r2 < 22 && (a2 += s3 * s3 * ((t2 < 0 ? -2 * t2 - 1 : 2 * t2) % (1 << 2 * (22 - r2)))), 16 * (32 * a2 + r2) + (e2 - r2);
      }
      Zi("CanonicalTileID", xp), Zi("OverscaledTileID", bp, { omit: ["projMatrix"] });
      class _p {
        constructor(t2, e2, r2) {
          this.func = t2, this.mask = e2, this.range = r2;
        }
      }
      _p.ReadOnly = false, _p.ReadWrite = true, _p.disabled = new _p(519, _p.ReadOnly, [0, 1]);
      const Ap = 7680;
      class kp {
        constructor(t2, e2, r2, n2, i3, s3) {
          this.test = t2, this.ref = e2, this.mask = r2, this.fail = n2, this.depthFail = i3, this.pass = s3;
        }
      }
      kp.disabled = new kp({ func: 519, mask: 0 }, 0, 0, Ap, Ap, Ap);
      class Sp {
        constructor(t2, e2, r2) {
          this.blendFunction = t2, this.blendColor = e2, this.mask = r2;
        }
      }
      Sp.Replace = [1, 0], Sp.disabled = new Sp(Sp.Replace, Ge.transparent, [false, false, false, false]), Sp.unblended = new Sp(Sp.Replace, Ge.transparent, [true, true, true, true]), Sp.alphaBlended = new Sp([1, 771], Ge.transparent, [true, true, true, true]);
      const Ip = 1029, zp = 2305;
      class Mp {
        constructor(t2, e2, r2) {
          this.enable = t2, this.mode = e2, this.frontFace = r2;
        }
      }
      Mp.disabled = new Mp(false, Ip, zp), Mp.backCCW = new Mp(true, Ip, zp), Mp.backCW = new Mp(true, Ip, 2304), Mp.frontCW = new Mp(true, 1028, 2304), Mp.frontCCW = new Mp(true, 1028, zp);
      class Tp {
        constructor(t2) {
          this._stringToNumber = {}, this._numberToString = [];
          for (let e2 = 0; e2 < t2.length; e2++) {
            const r2 = t2[e2];
            this._stringToNumber[r2] = e2, this._numberToString[e2] = r2;
          }
        }
        encode(t2) {
          return this._stringToNumber[t2];
        }
        decode(t2) {
          return this._numberToString[t2];
        }
      }
      class Bp {
        constructor(t2, e2, r2, n2, i3) {
          this.type = "Feature", this._vectorTileFeature = t2, t2._z = e2, t2._x = r2, t2._y = n2, this.properties = t2.properties, this.id = i3;
        }
        get geometry() {
          return this._geometry === void 0 && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
        }
        set geometry(t2) {
          this._geometry = t2;
        }
        toJSON() {
          const t2 = { geometry: this.geometry };
          for (const e2 in this)
            e2 !== "_geometry" && e2 !== "_vectorTileFeature" && (t2[e2] = this[e2]);
          return t2;
        }
      }
      class Cp {
        constructor() {
          this.state = {}, this.stateChanges = {}, this.deletedStates = {};
        }
        updateState(t2, e2, r2) {
          const n2 = String(e2);
          if (this.stateChanges[t2] = this.stateChanges[t2] || {}, this.stateChanges[t2][n2] = this.stateChanges[t2][n2] || {}, tt(this.stateChanges[t2][n2], r2), this.deletedStates[t2] === null) {
            this.deletedStates[t2] = {};
            for (const e3 in this.state[t2])
              e3 !== n2 && (this.deletedStates[t2][e3] = null);
          } else if (this.deletedStates[t2] && this.deletedStates[t2][n2] === null) {
            this.deletedStates[t2][n2] = {};
            for (const e3 in this.state[t2][n2])
              r2[e3] || (this.deletedStates[t2][n2][e3] = null);
          } else
            for (const e3 in r2)
              this.deletedStates[t2] && this.deletedStates[t2][n2] && this.deletedStates[t2][n2][e3] === null && delete this.deletedStates[t2][n2][e3];
        }
        removeFeatureState(t2, e2, r2) {
          if (this.deletedStates[t2] === null)
            return;
          const n2 = String(e2);
          if (this.deletedStates[t2] = this.deletedStates[t2] || {}, r2 && e2 !== void 0)
            this.deletedStates[t2][n2] !== null && (this.deletedStates[t2][n2] = this.deletedStates[t2][n2] || {}, this.deletedStates[t2][n2][r2] = null);
          else if (e2 !== void 0)
            if (this.stateChanges[t2] && this.stateChanges[t2][n2])
              for (r2 in this.deletedStates[t2][n2] = {}, this.stateChanges[t2][n2])
                this.deletedStates[t2][n2][r2] = null;
            else
              this.deletedStates[t2][n2] = null;
          else
            this.deletedStates[t2] = null;
        }
        getState(t2, e2) {
          const r2 = String(e2), n2 = tt({}, (this.state[t2] || {})[r2], (this.stateChanges[t2] || {})[r2]);
          if (this.deletedStates[t2] === null)
            return {};
          if (this.deletedStates[t2]) {
            const r3 = this.deletedStates[t2][e2];
            if (r3 === null)
              return {};
            for (const t3 in r3)
              delete n2[t3];
          }
          return n2;
        }
        initializeTileState(t2, e2) {
          t2.setFeatureState(this.state, e2);
        }
        coalesceChanges(t2, e2) {
          const r2 = {};
          for (const t3 in this.stateChanges) {
            this.state[t3] = this.state[t3] || {};
            const e3 = {};
            for (const r3 in this.stateChanges[t3])
              this.state[t3][r3] || (this.state[t3][r3] = {}), tt(this.state[t3][r3], this.stateChanges[t3][r3]), e3[r3] = this.state[t3][r3];
            r2[t3] = e3;
          }
          for (const t3 in this.deletedStates) {
            this.state[t3] = this.state[t3] || {};
            const e3 = {};
            if (this.deletedStates[t3] === null)
              for (const r3 in this.state[t3])
                e3[r3] = {}, this.state[t3][r3] = {};
            else
              for (const r3 in this.deletedStates[t3]) {
                if (this.deletedStates[t3][r3] === null)
                  this.state[t3][r3] = {};
                else
                  for (const e4 of Object.keys(this.deletedStates[t3][r3]))
                    delete this.state[t3][r3][e4];
                e3[r3] = this.state[t3][r3];
              }
            r2[t3] = r2[t3] || {}, tt(r2[t3], e3);
          }
          if (this.stateChanges = {}, this.deletedStates = {}, Object.keys(r2).length !== 0)
            for (const n2 in t2)
              t2[n2].setFeatureState(r2, e2);
        }
      }
      class Pp {
        constructor(t2) {
          this.size = t2, this.minimums = [], this.maximums = [], this.leaves = [];
        }
        getElevation(t2, e2) {
          const r2 = this.toIdx(t2, e2);
          return { min: this.minimums[r2], max: this.maximums[r2] };
        }
        isLeaf(t2, e2) {
          return this.leaves[this.toIdx(t2, e2)];
        }
        toIdx(t2, e2) {
          return e2 * this.size + t2;
        }
      }
      function Ep(t2, e2, r2, n2) {
        let i3 = 0, s3 = Number.MAX_VALUE;
        for (let a2 = 0; a2 < 3; a2++)
          if (Math.abs(n2[a2]) < 1e-15) {
            if (r2[a2] < t2[a2] || r2[a2] > e2[a2])
              return null;
          } else {
            const o2 = 1 / n2[a2];
            let l2 = (t2[a2] - r2[a2]) * o2, u2 = (e2[a2] - r2[a2]) * o2;
            if (l2 > u2) {
              const t3 = l2;
              l2 = u2, u2 = t3;
            }
            if (l2 > i3 && (i3 = l2), u2 < s3 && (s3 = u2), i3 > s3)
              return null;
          }
        return i3;
      }
      function Dp(t2, e2, r2, n2, i3, s3, a2, o2, l2, u2, c2) {
        const h2 = n2 - t2, p2 = i3 - e2, d2 = s3 - r2, f2 = a2 - t2, y2 = o2 - e2, m2 = l2 - r2, g2 = c2[1] * m2 - c2[2] * y2, x3 = c2[2] * f2 - c2[0] * m2, v3 = c2[0] * y2 - c2[1] * f2, b2 = h2 * g2 + p2 * x3 + d2 * v3;
        if (Math.abs(b2) < 1e-15)
          return null;
        const w2 = 1 / b2, _2 = u2[0] - t2, A3 = u2[1] - e2, k2 = u2[2] - r2, S3 = (_2 * g2 + A3 * x3 + k2 * v3) * w2;
        if (S3 < 0 || S3 > 1)
          return null;
        const I3 = A3 * d2 - k2 * p2, z2 = k2 * h2 - _2 * d2, M3 = _2 * p2 - A3 * h2, T2 = (c2[0] * I3 + c2[1] * z2 + c2[2] * M3) * w2;
        return T2 < 0 || S3 + T2 > 1 ? null : (f2 * I3 + y2 * z2 + m2 * M3) * w2;
      }
      function Vp(t2, e2, r2) {
        return (t2 - e2) / (r2 - e2);
      }
      function Fp(t2, e2, r2, n2, i3, s3, a2, o2, l2) {
        const u2 = 1 << r2, c2 = s3 - n2, h2 = a2 - i3, p2 = (t2 + 1) / u2 * c2 + n2, d2 = (e2 + 0) / u2 * h2 + i3, f2 = (e2 + 1) / u2 * h2 + i3;
        o2[0] = (t2 + 0) / u2 * c2 + n2, o2[1] = d2, l2[0] = p2, l2[1] = f2;
      }
      class Lp {
        constructor(t2) {
          if (this.maximums = [], this.minimums = [], this.leaves = [], this.childOffsets = [], this.nodeCount = 0, this.dem = t2, this._siblingOffset = [[0, 0], [1, 0], [0, 1], [1, 1]], !this.dem)
            return;
          const e2 = function(t3) {
            const e3 = Math.ceil(Math.log2(t3.dim / 8)), r3 = [];
            let n3 = Math.ceil(Math.pow(2, e3));
            const i3 = 1 / n3, s3 = (t4, e4, r4, n4, i4) => {
              const s4 = n4 ? 1 : 0, a3 = (t4 + 1) * r4 - s4, o3 = e4 * r4, l2 = (e4 + 1) * r4 - s4;
              i4[0] = t4 * r4, i4[1] = o3, i4[2] = a3, i4[3] = l2;
            };
            let a2 = new Pp(n3);
            const o2 = [];
            for (let e4 = 0; e4 < n3 * n3; e4++) {
              s3(e4 % n3, Math.floor(e4 / n3), i3, false, o2);
              const r4 = Up(o2[0], o2[1], t3), l2 = Up(o2[2], o2[1], t3), u2 = Up(o2[2], o2[3], t3), c2 = Up(o2[0], o2[3], t3);
              a2.minimums.push(Math.min(r4, l2, u2, c2)), a2.maximums.push(Math.max(r4, l2, u2, c2)), a2.leaves.push(1);
            }
            for (r3.push(a2), n3 /= 2; n3 >= 1; n3 /= 2) {
              const t4 = r3[r3.length - 1];
              a2 = new Pp(n3);
              for (let e4 = 0; e4 < n3 * n3; e4++) {
                s3(e4 % n3, Math.floor(e4 / n3), 2, true, o2);
                const r4 = t4.getElevation(o2[0], o2[1]), i4 = t4.getElevation(o2[2], o2[1]), l2 = t4.getElevation(o2[2], o2[3]), u2 = t4.getElevation(o2[0], o2[3]), c2 = t4.isLeaf(o2[0], o2[1]), h2 = t4.isLeaf(o2[2], o2[1]), p2 = t4.isLeaf(o2[2], o2[3]), d2 = t4.isLeaf(o2[0], o2[3]), f2 = Math.min(r4.min, i4.min, l2.min, u2.min), y2 = Math.max(r4.max, i4.max, l2.max, u2.max), m2 = c2 && h2 && p2 && d2;
                a2.maximums.push(y2), a2.minimums.push(f2), a2.leaves.push(y2 - f2 <= 5 && m2 ? 1 : 0);
              }
              r3.push(a2);
            }
            return r3;
          }(this.dem), r2 = e2.length - 1, n2 = e2[r2];
          this._addNode(n2.minimums[0], n2.maximums[0], n2.leaves[0]), this._construct(e2, 0, 0, r2, 0);
        }
        raycastRoot(t2, e2, r2, n2, i3, s3, a2 = 1) {
          return Ep([t2, e2, -100], [r2, n2, this.maximums[0] * a2], i3, s3);
        }
        raycast(t2, e2, r2, n2, i3, s3, a2 = 1) {
          if (!this.nodeCount)
            return null;
          const o2 = this.raycastRoot(t2, e2, r2, n2, i3, s3, a2);
          if (o2 == null)
            return null;
          const l2 = [], u2 = [], c2 = [], h2 = [], p2 = [{ idx: 0, t: o2, nodex: 0, nodey: 0, depth: 0 }];
          for (; p2.length > 0; ) {
            const { idx: o3, t: d2, nodex: f2, nodey: y2, depth: m2 } = p2.pop();
            if (this.leaves[o3]) {
              Fp(f2, y2, m2, t2, e2, r2, n2, c2, h2);
              const o4 = 1 << m2, l3 = (f2 + 0) / o4, u3 = (f2 + 1) / o4, p3 = (y2 + 0) / o4, g3 = (y2 + 1) / o4, x3 = Up(l3, p3, this.dem) * a2, v3 = Up(u3, p3, this.dem) * a2, b2 = Up(u3, g3, this.dem) * a2, w2 = Up(l3, g3, this.dem) * a2, _2 = Dp(c2[0], c2[1], x3, h2[0], c2[1], v3, h2[0], h2[1], b2, i3, s3), A3 = Dp(h2[0], h2[1], b2, c2[0], h2[1], w2, c2[0], c2[1], x3, i3, s3), k2 = Math.min(_2 !== null ? _2 : Number.MAX_VALUE, A3 !== null ? A3 : Number.MAX_VALUE);
              if (k2 !== Number.MAX_VALUE)
                return k2;
              {
                const t3 = I2([], i3, s3, d2);
                if (Rp(x3, v3, w2, b2, Vp(t3[0], c2[0], h2[0]), Vp(t3[1], c2[1], h2[1])) >= t3[2])
                  return d2;
              }
              continue;
            }
            let g2 = 0;
            for (let p3 = 0; p3 < this._siblingOffset.length; p3++) {
              Fp((f2 << 1) + this._siblingOffset[p3][0], (y2 << 1) + this._siblingOffset[p3][1], m2 + 1, t2, e2, r2, n2, c2, h2), c2[2] = -100, h2[2] = this.maximums[this.childOffsets[o3] + p3] * a2;
              const d3 = Ep(c2, h2, i3, s3);
              if (d3 != null) {
                const t3 = d3;
                l2[p3] = t3;
                let e3 = false;
                for (let r3 = 0; r3 < g2 && !e3; r3++)
                  t3 >= l2[u2[r3]] && (u2.splice(r3, 0, p3), e3 = true);
                e3 || (u2[g2] = p3), g2++;
              }
            }
            for (let t3 = 0; t3 < g2; t3++) {
              const e3 = u2[t3];
              p2.push({ idx: this.childOffsets[o3] + e3, t: l2[e3], nodex: (f2 << 1) + this._siblingOffset[e3][0], nodey: (y2 << 1) + this._siblingOffset[e3][1], depth: m2 + 1 });
            }
          }
          return null;
        }
        _addNode(t2, e2, r2) {
          return this.minimums.push(t2), this.maximums.push(e2), this.leaves.push(r2), this.childOffsets.push(0), this.nodeCount++;
        }
        _construct(t2, e2, r2, n2, i3) {
          if (t2[n2].isLeaf(e2, r2) === 1)
            return;
          this.childOffsets[i3] || (this.childOffsets[i3] = this.nodeCount);
          const s3 = n2 - 1, a2 = t2[s3];
          let o2, l2 = 0;
          for (let t3 = 0; t3 < this._siblingOffset.length; t3++) {
            const n3 = 2 * e2 + this._siblingOffset[t3][0], i4 = 2 * r2 + this._siblingOffset[t3][1], s4 = a2.getElevation(n3, i4), u2 = a2.isLeaf(n3, i4), c2 = this._addNode(s4.min, s4.max, u2);
            u2 && (l2 |= 1 << t3), o2 || (o2 = c2);
          }
          for (let n3 = 0; n3 < this._siblingOffset.length; n3++)
            l2 & 1 << n3 || this._construct(t2, 2 * e2 + this._siblingOffset[n3][0], 2 * r2 + this._siblingOffset[n3][1], s3, o2 + n3);
        }
      }
      function Rp(t2, e2, r2, n2, i3, s3) {
        return Lr(Lr(t2, r2, s3), Lr(e2, n2, s3), i3);
      }
      function Up(t2, e2, r2) {
        const n2 = r2.dim, i3 = Y2(t2 * n2 - 0.5, 0, n2 - 1), s3 = Y2(e2 * n2 - 0.5, 0, n2 - 1), a2 = Math.floor(i3), o2 = Math.floor(s3), l2 = Math.min(a2 + 1, n2 - 1), u2 = Math.min(o2 + 1, n2 - 1);
        return Rp(r2.get(a2, o2), r2.get(l2, o2), r2.get(a2, u2), r2.get(l2, u2), i3 - a2, s3 - o2);
      }
      const $p = { mapbox: [6553.6, 25.6, 0.1, 1e4], terrarium: [256, 1, 1 / 256, 32768] };
      class Op {
        get tree() {
          return this._tree || this._buildQuadTree(), this._tree;
        }
        constructor(t2, e2, r2, n2 = false, i3 = false) {
          if (this.uid = t2, e2.height !== e2.width)
            throw new RangeError("DEM tiles must be square");
          if (r2 && r2 !== "mapbox" && r2 !== "terrarium")
            return pt(`"${r2}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
          this.stride = e2.height;
          const s3 = this.dim = e2.height - 2;
          if (this.data = new Uint32Array(e2.data.buffer), this.encoding = r2 || "mapbox", this.borderReady = n2, !n2) {
            for (let t3 = 0; t3 < s3; t3++)
              this.data[this._idx(-1, t3)] = this.data[this._idx(0, t3)], this.data[this._idx(s3, t3)] = this.data[this._idx(s3 - 1, t3)], this.data[this._idx(t3, -1)] = this.data[this._idx(t3, 0)], this.data[this._idx(t3, s3)] = this.data[this._idx(t3, s3 - 1)];
            this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(s3, -1)] = this.data[this._idx(s3 - 1, 0)], this.data[this._idx(-1, s3)] = this.data[this._idx(0, s3 - 1)], this.data[this._idx(s3, s3)] = this.data[this._idx(s3 - 1, s3 - 1)], i3 && this._buildQuadTree();
          }
        }
        _buildQuadTree() {
          this._tree = new Lp(this);
        }
        get(t2, e2, r2 = false) {
          const n2 = new Uint8Array(this.data.buffer);
          r2 && (t2 = Y2(t2, -1, this.dim), e2 = Y2(e2, -1, this.dim));
          const i3 = 4 * this._idx(t2, e2);
          return (this.encoding === "terrarium" ? this._unpackTerrarium : this._unpackMapbox)(n2[i3], n2[i3 + 1], n2[i3 + 2]);
        }
        static getUnpackVector(t2) {
          return $p[t2];
        }
        get unpackVector() {
          return $p[this.encoding];
        }
        _idx(t2, e2) {
          if (t2 < -1 || t2 >= this.dim + 1 || e2 < -1 || e2 >= this.dim + 1)
            throw new RangeError("out of range source coordinates for DEM data");
          return (e2 + 1) * this.stride + (t2 + 1);
        }
        _unpackMapbox(t2, e2, r2) {
          return (256 * t2 * 256 + 256 * e2 + r2) / 10 - 1e4;
        }
        _unpackTerrarium(t2, e2, r2) {
          return 256 * t2 + e2 + r2 / 256 - 32768;
        }
        static pack(t2, e2) {
          const r2 = [0, 0, 0, 0], n2 = Op.getUnpackVector(e2);
          let i3 = Math.floor((t2 + n2[3]) / n2[2]);
          return r2[2] = i3 % 256, i3 = Math.floor(i3 / 256), r2[1] = i3 % 256, i3 = Math.floor(i3 / 256), r2[0] = i3, r2;
        }
        getPixels() {
          return new Ml({ width: this.stride, height: this.stride }, new Uint8Array(this.data.buffer));
        }
        backfillBorder(t2, e2, r2) {
          if (this.dim !== t2.dim)
            throw new Error("dem dimension mismatch");
          let n2 = e2 * this.dim, i3 = e2 * this.dim + this.dim, s3 = r2 * this.dim, a2 = r2 * this.dim + this.dim;
          switch (e2) {
            case -1:
              n2 = i3 - 1;
              break;
            case 1:
              i3 = n2 + 1;
          }
          switch (r2) {
            case -1:
              s3 = a2 - 1;
              break;
            case 1:
              a2 = s3 + 1;
          }
          const o2 = -e2 * this.dim, l2 = -r2 * this.dim;
          for (let e3 = s3; e3 < a2; e3++)
            for (let r3 = n2; r3 < i3; r3++)
              this.data[this._idx(r3, e3)] = t2.data[this._idx(r3 + o2, e3 + l2)];
        }
        onDeserialize() {
          this._tree && (this._tree.dem = this);
        }
      }
      Zi("DEMData", Op), Zi("DemMinMaxQuadTree", Lp, { omit: ["dem"] });
      class jp {
        constructor(t2, e2) {
          this.max = t2, this.onRemove = e2, this.reset();
        }
        reset() {
          for (const t2 in this.data)
            for (const e2 of this.data[t2])
              e2.timeout && clearTimeout(e2.timeout), this.onRemove(e2.value);
          return this.data = {}, this.order = [], this;
        }
        add(t2, e2, r2) {
          const n2 = t2.wrapped().key;
          this.data[n2] === void 0 && (this.data[n2] = []);
          const i3 = { value: e2, timeout: void 0 };
          if (r2 !== void 0 && (i3.timeout = setTimeout(() => {
            this.remove(t2, i3);
          }, r2)), this.data[n2].push(i3), this.order.push(n2), this.order.length > this.max) {
            const t3 = this._getAndRemoveByKey(this.order[0]);
            t3 && this.onRemove(t3);
          }
          return this;
        }
        has(t2) {
          return t2.wrapped().key in this.data;
        }
        getAndRemove(t2) {
          return this.has(t2) ? this._getAndRemoveByKey(t2.wrapped().key) : null;
        }
        _getAndRemoveByKey(t2) {
          const e2 = this.data[t2].shift();
          return e2.timeout && clearTimeout(e2.timeout), this.data[t2].length === 0 && delete this.data[t2], this.order.splice(this.order.indexOf(t2), 1), e2.value;
        }
        getByKey(t2) {
          const e2 = this.data[t2];
          return e2 ? e2[0].value : null;
        }
        get(t2) {
          return this.has(t2) ? this.data[t2.wrapped().key][0].value : null;
        }
        remove(t2, e2) {
          if (!this.has(t2))
            return this;
          const r2 = t2.wrapped().key, n2 = e2 === void 0 ? 0 : this.data[r2].indexOf(e2), i3 = this.data[r2][n2];
          return this.data[r2].splice(n2, 1), i3.timeout && clearTimeout(i3.timeout), this.data[r2].length === 0 && delete this.data[r2], this.onRemove(i3.value), this.order.splice(this.order.indexOf(r2), 1), this;
        }
        setMaxSize(t2) {
          for (this.max = t2; this.order.length > this.max; ) {
            const t3 = this._getAndRemoveByKey(this.order[0]);
            t3 && this.onRemove(t3);
          }
          return this;
        }
        filter(t2) {
          const e2 = [];
          for (const r2 in this.data)
            for (const n2 of this.data[r2])
              t2(n2.value) || e2.push(n2);
          for (const t3 of e2)
            this.remove(t3.value.tileID, t3);
        }
      }
      class qp extends xe {
        constructor(t2, e2, r2) {
          super(), this.id = t2, this._onlySymbols = r2, e2.on("data", (t3) => {
            t3.dataType === "source" && t3.sourceDataType === "metadata" && (this._sourceLoaded = true), this._sourceLoaded && !this._paused && t3.dataType === "source" && t3.sourceDataType === "content" && (this.reload(), this.transform && this.update(this.transform));
          }), e2.on("error", () => {
            this._sourceErrored = true;
          }), this._source = e2, this._tiles = {}, this._cache = new jp(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._minTileCacheSize = null, this._maxTileCacheSize = null, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new Cp();
        }
        onAdd(t2) {
          this.map = t2, this._minTileCacheSize = t2 ? t2._minTileCacheSize : null, this._maxTileCacheSize = t2 ? t2._maxTileCacheSize : null;
        }
        loaded() {
          if (this._sourceErrored)
            return true;
          if (!this._sourceLoaded)
            return false;
          if (!this._source.loaded())
            return false;
          for (const t2 in this._tiles) {
            const e2 = this._tiles[t2];
            if (e2.state !== "loaded" && e2.state !== "errored")
              return false;
          }
          return true;
        }
        getSource() {
          return this._source;
        }
        pause() {
          this._paused = true;
        }
        resume() {
          if (!this._paused)
            return;
          const t2 = this._shouldReloadOnResume;
          this._paused = false, this._shouldReloadOnResume = false, t2 && this.reload(), this.transform && this.update(this.transform);
        }
        _loadTile(t2, e2) {
          return t2.isSymbolTile = this._onlySymbols, this._source.loadTile(t2, e2);
        }
        _unloadTile(t2) {
          if (this._source.unloadTile)
            return this._source.unloadTile(t2, () => {
            });
        }
        _abortTile(t2) {
          if (this._source.abortTile)
            return this._source.abortTile(t2, () => {
            });
        }
        serialize() {
          return this._source.serialize();
        }
        prepare(t2) {
          this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
          for (const e2 in this._tiles) {
            const r2 = this._tiles[e2];
            r2.upload(t2), r2.prepare(this.map.style.imageManager);
          }
        }
        getIds() {
          return Q(this._tiles).map((t2) => t2.tileID).sort(Np).map((t2) => t2.key);
        }
        getRenderableIds(t2) {
          const e2 = [];
          for (const r2 in this._tiles)
            this._isIdRenderable(+r2, t2) && e2.push(this._tiles[r2]);
          return t2 ? e2.sort((t3, e3) => {
            const r2 = t3.tileID, n2 = e3.tileID, s3 = new i2(r2.canonical.x, r2.canonical.y)._rotate(this.transform.angle), a2 = new i2(n2.canonical.x, n2.canonical.y)._rotate(this.transform.angle);
            return r2.overscaledZ - n2.overscaledZ || a2.y - s3.y || a2.x - s3.x;
          }).map((t3) => t3.tileID.key) : e2.map((t3) => t3.tileID).sort(Np).map((t3) => t3.key);
        }
        hasRenderableParent(t2) {
          const e2 = this.findLoadedParent(t2, 0);
          return !!e2 && this._isIdRenderable(e2.tileID.key);
        }
        _isIdRenderable(t2, e2) {
          return this._tiles[t2] && this._tiles[t2].hasData() && !this._coveredTiles[t2] && (e2 || !this._tiles[t2].holdingForFade());
        }
        reload() {
          if (this._paused)
            this._shouldReloadOnResume = true;
          else {
            this._cache.reset();
            for (const t2 in this._tiles)
              this._tiles[t2].state !== "errored" && this._reloadTile(+t2, "reloading");
          }
        }
        _reloadTile(t2, e2) {
          const r2 = this._tiles[t2];
          r2 && (r2.state !== "loading" && (r2.state = e2), this._loadTile(r2, this._tileLoaded.bind(this, r2, t2, e2)));
        }
        _tileLoaded(t2, e2, r2, n2) {
          if (n2)
            if (t2.state = "errored", n2.status !== 404)
              this._source.fire(new ge(n2, { tile: t2 }));
            else if (this._source.type === "raster-dem" && this.usedForTerrain && this.map.painter.terrain) {
              const t3 = this.map.painter.terrain;
              this.update(this.transform, t3.getScaledDemTileSize(), true), t3.resetTileLookupCache(this.id);
            } else
              this.update(this.transform);
          else
            t2.timeAdded = At.now(), r2 === "expired" && (t2.refreshedUponExpiration = true), this._setTileReloadTimer(e2, t2), this._source.type === "raster-dem" && t2.dem && this._backfillDEM(t2), this._state.initializeTileState(t2, this.map ? this.map.painter : null), this._source.fire(new me("data", { dataType: "source", tile: t2, coord: t2.tileID, sourceCacheId: this.id }));
        }
        _backfillDEM(t2) {
          const e2 = this.getRenderableIds();
          for (let n2 = 0; n2 < e2.length; n2++) {
            const i3 = e2[n2];
            if (t2.neighboringTiles && t2.neighboringTiles[i3]) {
              const e3 = this.getTileByID(i3);
              r2(t2, e3), r2(e3, t2);
            }
          }
          function r2(t3, e3) {
            if (!t3.dem || t3.dem.borderReady)
              return;
            t3.needsHillshadePrepare = true, t3.needsDEMTextureUpload = true;
            let r3 = e3.tileID.canonical.x - t3.tileID.canonical.x;
            const n2 = e3.tileID.canonical.y - t3.tileID.canonical.y, i3 = Math.pow(2, t3.tileID.canonical.z), s3 = e3.tileID.key;
            r3 === 0 && n2 === 0 || Math.abs(n2) > 1 || (Math.abs(r3) > 1 && (Math.abs(r3 + i3) === 1 ? r3 += i3 : Math.abs(r3 - i3) === 1 && (r3 -= i3)), e3.dem && t3.dem && (t3.dem.backfillBorder(e3.dem, r3, n2), t3.neighboringTiles && t3.neighboringTiles[s3] && (t3.neighboringTiles[s3].backfilled = true)));
          }
        }
        getTile(t2) {
          return this.getTileByID(t2.key);
        }
        getTileByID(t2) {
          return this._tiles[t2];
        }
        _retainLoadedChildren(t2, e2, r2, n2) {
          for (const i3 in this._tiles) {
            let s3 = this._tiles[i3];
            if (n2[i3] || !s3.hasData() || s3.tileID.overscaledZ <= e2 || s3.tileID.overscaledZ > r2)
              continue;
            let a2 = s3.tileID;
            for (; s3 && s3.tileID.overscaledZ > e2 + 1; ) {
              const t3 = s3.tileID.scaledTo(s3.tileID.overscaledZ - 1);
              s3 = this._tiles[t3.key], s3 && s3.hasData() && (a2 = t3);
            }
            let o2 = a2;
            for (; o2.overscaledZ > e2; )
              if (o2 = o2.scaledTo(o2.overscaledZ - 1), t2[o2.key]) {
                n2[a2.key] = a2;
                break;
              }
          }
        }
        findLoadedParent(t2, e2) {
          if (t2.key in this._loadedParentTiles) {
            const r2 = this._loadedParentTiles[t2.key];
            return r2 && r2.tileID.overscaledZ >= e2 ? r2 : null;
          }
          for (let r2 = t2.overscaledZ - 1; r2 >= e2; r2--) {
            const e3 = t2.scaledTo(r2), n2 = this._getLoadedTile(e3);
            if (n2)
              return n2;
          }
        }
        _getLoadedTile(t2) {
          const e2 = this._tiles[t2.key];
          return e2 && e2.hasData() ? e2 : this._cache.getByKey(this._source.reparseOverscaled ? t2.wrapped().key : t2.canonical.key);
        }
        updateCacheSize(t2, e2) {
          e2 = e2 || this._source.tileSize;
          const r2 = Math.ceil(t2.width / e2) + 1, n2 = Math.ceil(t2.height / e2) + 1, i3 = Math.floor(r2 * n2 * 5), s3 = typeof this._minTileCacheSize == "number" ? Math.max(this._minTileCacheSize, i3) : i3, a2 = typeof this._maxTileCacheSize == "number" ? Math.min(this._maxTileCacheSize, s3) : s3;
          this._cache.setMaxSize(a2);
        }
        handleWrapJump(t2) {
          const e2 = Math.round((t2 - (this._prevLng === void 0 ? t2 : this._prevLng)) / 360);
          if (this._prevLng = t2, e2) {
            const t3 = {};
            for (const r2 in this._tiles) {
              const n2 = this._tiles[r2];
              n2.tileID = n2.tileID.unwrapTo(n2.tileID.wrap + e2), t3[n2.tileID.key] = n2;
            }
            this._tiles = t3;
            for (const t4 in this._timers)
              clearTimeout(this._timers[t4]), delete this._timers[t4];
            for (const t4 in this._tiles)
              this._setTileReloadTimer(+t4, this._tiles[t4]);
          }
        }
        update(t2, e2, r2) {
          if (this.transform = t2, !this._sourceLoaded || this._paused || this.transform.freezeTileCoverage)
            return;
          if (this.usedForTerrain && !r2)
            return;
          let n2;
          this.updateCacheSize(t2, e2), this.transform.projection.name !== "globe" && this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used || this.usedForTerrain ? this._source.tileID ? n2 = t2.getVisibleUnwrappedCoordinates(this._source.tileID).map((t3) => new bp(t3.canonical.z, t3.wrap, t3.canonical.z, t3.canonical.x, t3.canonical.y)) : (n2 = t2.coveringTiles({ tileSize: e2 || this._source.tileSize, minzoom: this._source.minzoom, maxzoom: this._source.maxzoom, roundZoom: this._source.roundZoom && !r2, reparseOverscaled: this._source.reparseOverscaled, isTerrainDEM: this.usedForTerrain }), this._source.hasTile && (n2 = n2.filter((t3) => this._source.hasTile(t3)))) : n2 = [];
          const i3 = this._updateRetainedTiles(n2);
          if (Gp(this._source.type) && n2.length !== 0) {
            const t3 = {}, e3 = {}, r3 = Object.keys(i3);
            for (const n3 of r3) {
              const r4 = i3[n3], s5 = this._tiles[n3];
              if (!s5 || s5.fadeEndTime && s5.fadeEndTime <= At.now())
                continue;
              const a2 = this.findLoadedParent(r4, Math.max(r4.overscaledZ - qp.maxOverzooming, this._source.minzoom));
              a2 && (this._addTile(a2.tileID), t3[a2.tileID.key] = a2.tileID), e3[n3] = r4;
            }
            const s4 = n2[n2.length - 1].overscaledZ;
            for (const t4 in this._tiles) {
              const r4 = this._tiles[t4];
              if (i3[t4] || !r4.hasData())
                continue;
              let n3 = r4.tileID;
              for (; n3.overscaledZ > s4; ) {
                n3 = n3.scaledTo(n3.overscaledZ - 1);
                const s5 = this._tiles[n3.key];
                if (s5 && s5.hasData() && e3[n3.key]) {
                  i3[t4] = r4.tileID;
                  break;
                }
              }
            }
            for (const e4 in t3)
              i3[e4] || (this._coveredTiles[e4] = true, i3[e4] = t3[e4]);
          }
          for (const t3 in i3)
            this._tiles[t3].clearFadeHold();
          const s3 = function(t3, e3) {
            const r3 = [];
            for (const n3 in t3)
              n3 in e3 || r3.push(n3);
            return r3;
          }(this._tiles, i3);
          for (const t3 of s3) {
            const e3 = this._tiles[t3];
            e3.hasSymbolBuckets && !e3.holdingForFade() ? e3.setHoldDuration(this.map._fadeDuration) : e3.hasSymbolBuckets && !e3.symbolFadeFinished() || this._removeTile(+t3);
          }
          this._updateLoadedParentTileCache(), this._onlySymbols && this._source.afterUpdate && this._source.afterUpdate();
        }
        releaseSymbolFadeTiles() {
          for (const t2 in this._tiles)
            this._tiles[t2].holdingForFade() && this._removeTile(+t2);
        }
        _updateRetainedTiles(t2) {
          const e2 = {};
          if (t2.length === 0)
            return e2;
          const r2 = {}, n2 = t2.reduce((t3, e3) => Math.min(t3, e3.overscaledZ), 1 / 0), i3 = t2[0].overscaledZ, s3 = Math.max(i3 - qp.maxOverzooming, this._source.minzoom), a2 = Math.max(i3 + qp.maxUnderzooming, this._source.minzoom), o2 = {};
          for (const r3 of t2) {
            const t3 = this._addTile(r3);
            e2[r3.key] = r3, t3.hasData() || n2 < this._source.maxzoom && (o2[r3.key] = r3);
          }
          this._retainLoadedChildren(o2, n2, a2, e2);
          for (const n3 of t2) {
            let t3 = this._tiles[n3.key];
            if (t3.hasData())
              continue;
            if (n3.canonical.z >= this._source.maxzoom) {
              const t4 = n3.children(this._source.maxzoom)[0], r3 = this.getTile(t4);
              if (r3 && r3.hasData()) {
                e2[t4.key] = t4;
                continue;
              }
            } else {
              const t4 = n3.children(this._source.maxzoom);
              if (e2[t4[0].key] && e2[t4[1].key] && e2[t4[2].key] && e2[t4[3].key])
                continue;
            }
            let i4 = t3.wasRequested();
            for (let a3 = n3.overscaledZ - 1; a3 >= s3; --a3) {
              const s4 = n3.scaledTo(a3);
              if (r2[s4.key])
                break;
              if (r2[s4.key] = true, t3 = this.getTile(s4), !t3 && i4 && (t3 = this._addTile(s4)), t3 && (e2[s4.key] = s4, i4 = t3.wasRequested(), t3.hasData()))
                break;
            }
          }
          return e2;
        }
        _updateLoadedParentTileCache() {
          this._loadedParentTiles = {};
          for (const t2 in this._tiles) {
            const e2 = [];
            let r2, n2 = this._tiles[t2].tileID;
            for (; n2.overscaledZ > 0; ) {
              if (n2.key in this._loadedParentTiles) {
                r2 = this._loadedParentTiles[n2.key];
                break;
              }
              e2.push(n2.key);
              const t3 = n2.scaledTo(n2.overscaledZ - 1);
              if (r2 = this._getLoadedTile(t3), r2)
                break;
              n2 = t3;
            }
            for (const t3 of e2)
              this._loadedParentTiles[t3] = r2;
          }
        }
        _addTile(t2) {
          let e2 = this._tiles[t2.key];
          if (e2)
            return e2;
          e2 = this._cache.getAndRemove(t2), e2 && (this._setTileReloadTimer(t2.key, e2), e2.tileID = t2, this._state.initializeTileState(e2, this.map ? this.map.painter : null), this._cacheTimers[t2.key] && (clearTimeout(this._cacheTimers[t2.key]), delete this._cacheTimers[t2.key], this._setTileReloadTimer(t2.key, e2)));
          const r2 = Boolean(e2);
          if (!r2) {
            const r3 = this.map ? this.map.painter : null, n2 = this._source.type === "raster" || this._source.type === "raster-dem";
            e2 = new ad(t2, this._source.tileSize * t2.overscaleFactor(), this.transform.tileZoom, r3, n2), this._loadTile(e2, this._tileLoaded.bind(this, e2, t2.key, e2.state));
          }
          return e2 ? (e2.uses++, this._tiles[t2.key] = e2, r2 || this._source.fire(new me("dataloading", { tile: e2, coord: e2.tileID, dataType: "source" })), e2) : null;
        }
        _setTileReloadTimer(t2, e2) {
          t2 in this._timers && (clearTimeout(this._timers[t2]), delete this._timers[t2]);
          const r2 = e2.getExpiryTimeout();
          r2 && (this._timers[t2] = setTimeout(() => {
            this._reloadTile(t2, "expired"), delete this._timers[t2];
          }, r2));
        }
        _removeTile(t2) {
          const e2 = this._tiles[t2];
          e2 && (e2.uses--, delete this._tiles[t2], this._timers[t2] && (clearTimeout(this._timers[t2]), delete this._timers[t2]), e2.uses > 0 || (e2.hasData() && e2.state !== "reloading" ? this._cache.add(e2.tileID, e2, e2.getExpiryTimeout()) : (e2.aborted = true, this._abortTile(e2), this._unloadTile(e2))));
        }
        clearTiles() {
          this._shouldReloadOnResume = false, this._paused = false;
          for (const t2 in this._tiles)
            this._removeTile(+t2);
          this._source._clear && this._source._clear(), this._cache.reset();
        }
        tilesIn(t2, e2, r2) {
          const n2 = [], i3 = this.transform;
          if (!i3)
            return n2;
          for (const s3 in this._tiles) {
            const a2 = this._tiles[s3];
            if (r2 && a2.clearQueryDebugViz(), a2.holdingForFade())
              continue;
            const o2 = t2.containsTile(a2, i3, e2);
            o2 && n2.push(o2);
          }
          return n2;
        }
        getVisibleCoordinates(t2) {
          const e2 = this.getRenderableIds(t2).map((t3) => this._tiles[t3].tileID);
          for (const t3 of e2)
            t3.projMatrix = this.transform.calculateProjMatrix(t3.toUnwrapped());
          return e2;
        }
        hasTransition() {
          if (this._source.hasTransition())
            return true;
          if (Gp(this._source.type))
            for (const t2 in this._tiles) {
              const e2 = this._tiles[t2];
              if (e2.fadeEndTime !== void 0 && e2.fadeEndTime >= At.now())
                return true;
            }
          return false;
        }
        setFeatureState(t2, e2, r2) {
          this._state.updateState(t2 = t2 || "_geojsonTileLayer", e2, r2);
        }
        removeFeatureState(t2, e2, r2) {
          this._state.removeFeatureState(t2 = t2 || "_geojsonTileLayer", e2, r2);
        }
        getFeatureState(t2, e2) {
          return this._state.getState(t2 = t2 || "_geojsonTileLayer", e2);
        }
        setDependencies(t2, e2, r2) {
          const n2 = this._tiles[t2];
          n2 && n2.setDependencies(e2, r2);
        }
        reloadTilesForDependencies(t2, e2) {
          for (const r2 in this._tiles)
            this._tiles[r2].hasDependency(t2, e2) && this._reloadTile(+r2, "reloading");
          this._cache.filter((r2) => !r2.hasDependency(t2, e2));
        }
        _preloadTiles(t2, e2) {
          const r2 = /* @__PURE__ */ new Map(), n2 = Array.isArray(t2) ? t2 : [t2], i3 = this.map.painter.terrain, s3 = this.usedForTerrain && i3 ? i3.getScaledDemTileSize() : this._source.tileSize;
          for (const t3 of n2) {
            const e3 = t3.coveringTiles({ tileSize: s3, minzoom: this._source.minzoom, maxzoom: this._source.maxzoom, roundZoom: this._source.roundZoom && !this.usedForTerrain, reparseOverscaled: this._source.reparseOverscaled, isTerrainDEM: this.usedForTerrain });
            for (const t4 of e3)
              r2.set(t4.key, t4);
            this.usedForTerrain && t3.updateElevation(false);
          }
          const a2 = Array.from(r2.values()), o2 = this._source.type === "raster" || this._source.type === "raster-dem";
          W(a2, (t3, e3) => {
            const r3 = new ad(t3, this._source.tileSize * t3.overscaleFactor(), this.transform.tileZoom, this.map.painter, o2);
            this._loadTile(r3, (t4) => {
              this._source.type === "raster-dem" && r3.dem && this._backfillDEM(r3), e3(t4, r3);
            });
          }, e2);
        }
      }
      function Np(t2, e2) {
        const r2 = Math.abs(2 * t2.wrap) - +(t2.wrap < 0), n2 = Math.abs(2 * e2.wrap) - +(e2.wrap < 0);
        return t2.overscaledZ - e2.overscaledZ || n2 - r2 || e2.canonical.y - t2.canonical.y || e2.canonical.x - t2.canonical.x;
      }
      function Gp(t2) {
        return t2 === "raster" || t2 === "image" || t2 === "video";
      }
      qp.maxOverzooming = 10, qp.maxUnderzooming = 3;
      class Zp {
        constructor(t2, e2, r2) {
          this._demTile = t2, this._dem = this._demTile.dem, this._scale = e2, this._offset = r2;
        }
        static create(t2, e2, r2) {
          const n2 = r2 || t2.findDEMTileFor(e2);
          if (!n2 || !n2.dem)
            return;
          const i3 = n2.dem, s3 = n2.tileID, a2 = 1 << e2.canonical.z - s3.canonical.z;
          return new Zp(n2, n2.tileSize / To / a2, [(e2.canonical.x / a2 - s3.canonical.x) * i3.dim, (e2.canonical.y / a2 - s3.canonical.y) * i3.dim]);
        }
        tileCoordToPixel(t2, e2) {
          const r2 = e2 * this._scale + this._offset[1], n2 = Math.floor(t2 * this._scale + this._offset[0]), s3 = Math.floor(r2);
          return new i2(n2, s3);
        }
        getElevationAt(t2, e2, r2, n2) {
          const i3 = t2 * this._scale + this._offset[0], s3 = e2 * this._scale + this._offset[1], a2 = Math.floor(i3), o2 = Math.floor(s3), l2 = this._dem;
          return n2 = !!n2, r2 ? Lr(Lr(l2.get(a2, o2, n2), l2.get(a2, o2 + 1, n2), s3 - o2), Lr(l2.get(a2 + 1, o2, n2), l2.get(a2 + 1, o2 + 1, n2), s3 - o2), i3 - a2) : l2.get(a2, o2, n2);
        }
        getElevationAtPixel(t2, e2, r2) {
          return this._dem.get(t2, e2, !!r2);
        }
        getMeterToDEM(t2) {
          return (1 << this._demTile.tileID.canonical.z) * Lo(1, t2) * this._dem.stride;
        }
      }
      class Xp {
        constructor(t2, e2) {
          this.tileID = t2, this.x = t2.canonical.x, this.y = t2.canonical.y, this.z = t2.canonical.z, this.grid = new Oi(To, 16, 0), this.featureIndexArray = new Na(), this.promoteId = e2;
        }
        insert(t2, e2, r2, n2, i3, s3 = 0) {
          const a2 = this.featureIndexArray.length;
          this.featureIndexArray.emplaceBack(r2, n2, i3, s3);
          const o2 = this.grid;
          for (let t3 = 0; t3 < e2.length; t3++) {
            const r3 = e2[t3], n3 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
            for (let t4 = 0; t4 < r3.length; t4++) {
              const e3 = r3[t4];
              n3[0] = Math.min(n3[0], e3.x), n3[1] = Math.min(n3[1], e3.y), n3[2] = Math.max(n3[2], e3.x), n3[3] = Math.max(n3[3], e3.y);
            }
            n3[0] < To && n3[1] < To && n3[2] >= 0 && n3[3] >= 0 && o2.insert(a2, n3[0], n3[1], n3[2], n3[3]);
          }
        }
        loadVTLayers() {
          if (!this.vtLayers) {
            this.vtLayers = new Bu.VectorTile(new gc(this.rawTileData)).layers, this.sourceLayerCoder = new Tp(this.vtLayers ? Object.keys(this.vtLayers).sort() : ["_geojsonTileLayer"]), this.vtFeatures = {};
            for (const t2 in this.vtLayers)
              this.vtFeatures[t2] = [];
          }
          return this.vtLayers;
        }
        query(t2, e2, r2, n2) {
          this.loadVTLayers();
          const i3 = t2.params || {}, s3 = si(i3.filter), a2 = t2.tileResult, o2 = t2.transform, l2 = a2.bufferedTilespaceBounds, u2 = this.grid.query(l2.min.x, l2.min.y, l2.max.x, l2.max.y, (t3, e3, r3, n3) => ll(a2.bufferedTilespaceGeometry, t3, e3, r3, n3));
          u2.sort(Yp);
          let c2 = null;
          o2.elevation && u2.length > 0 && (c2 = Zp.create(o2.elevation, this.tileID));
          const h2 = {};
          let p2;
          for (let o3 = 0; o3 < u2.length; o3++) {
            const l3 = u2[o3];
            if (l3 === p2)
              continue;
            p2 = l3;
            const d2 = this.featureIndexArray.get(l3);
            let f2 = null;
            this.loadMatchingFeature(h2, d2, s3, i3.layers, i3.availableImages, e2, r2, n2, (e3, r3, n3, i4 = 0) => (f2 || (f2 = Ko(e3, this.tileID.canonical, t2.tileTransform)), r3.queryIntersectsFeature(a2, e3, n3, f2, this.z, t2.transform, t2.pixelPosMatrix, c2, i4)));
          }
          return h2;
        }
        loadMatchingFeature(t2, e2, r2, n2, i3, s3, a2, o2, l2) {
          const { featureIndex: u2, bucketIndex: c2, sourceLayerIndex: h2, layoutVertexArrayOffset: p2 } = e2, d2 = this.bucketLayerIDs[c2];
          if (n2 && !function(t3, e3) {
            for (let r3 = 0; r3 < t3.length; r3++)
              if (e3.indexOf(t3[r3]) >= 0)
                return true;
            return false;
          }(n2, d2))
            return;
          const f2 = this.sourceLayerCoder.decode(h2), y2 = this.vtLayers[f2].feature(u2);
          if (r2.needGeometry) {
            const t3 = Yo(y2, true);
            if (!r2.filter(new Gs(this.tileID.overscaledZ), t3, this.tileID.canonical))
              return;
          } else if (!r2.filter(new Gs(this.tileID.overscaledZ), y2))
            return;
          const m2 = this.getId(y2, f2);
          for (let e3 = 0; e3 < d2.length; e3++) {
            const r3 = d2[e3];
            if (n2 && n2.indexOf(r3) < 0)
              continue;
            const c3 = s3[r3];
            if (!c3)
              continue;
            let h3 = {};
            m2 !== void 0 && o2 && (h3 = o2.getState(c3.sourceLayer || "_geojsonTileLayer", m2));
            const f3 = tt({}, a2[r3]);
            f3.paint = Kp(f3.paint, c3.paint, y2, h3, i3), f3.layout = Kp(f3.layout, c3.layout, y2, h3, i3);
            const g2 = !l2 || l2(y2, c3, h3, p2);
            if (!g2)
              continue;
            const x3 = new Bp(y2, this.z, this.x, this.y, m2);
            x3.layer = f3;
            let v3 = t2[r3];
            v3 === void 0 && (v3 = t2[r3] = []), v3.push({ featureIndex: u2, feature: x3, intersectionZ: g2 });
          }
        }
        lookupSymbolFeatures(t2, e2, r2, n2, i3, s3, a2, o2) {
          const l2 = {};
          this.loadVTLayers();
          const u2 = si(i3);
          for (const i4 of t2)
            this.loadMatchingFeature(l2, { bucketIndex: r2, sourceLayerIndex: n2, featureIndex: i4, layoutVertexArrayOffset: 0 }, u2, s3, a2, o2, e2);
          return l2;
        }
        loadFeature(t2) {
          const { featureIndex: e2, sourceLayerIndex: r2 } = t2;
          this.loadVTLayers();
          const n2 = this.sourceLayerCoder.decode(r2), i3 = this.vtFeatures[n2];
          if (i3[e2])
            return i3[e2];
          const s3 = this.vtLayers[n2].feature(e2);
          return i3[e2] = s3, s3;
        }
        hasLayer(t2) {
          for (const e2 of this.bucketLayerIDs)
            for (const r2 of e2)
              if (t2 === r2)
                return true;
          return false;
        }
        getId(t2, e2) {
          let r2 = t2.id;
          return this.promoteId && (r2 = t2.properties[typeof this.promoteId == "string" ? this.promoteId : this.promoteId[e2]], typeof r2 == "boolean" && (r2 = Number(r2))), r2;
        }
      }
      function Kp(t2, e2, r2, n2, i3) {
        return lt(t2, (t3, s3) => {
          const a2 = e2 instanceof Qs ? e2.get(s3) : null;
          return a2 && a2.evaluate ? a2.evaluate(r2, n2, i3) : a2;
        });
      }
      function Yp(t2, e2) {
        return e2 - t2;
      }
      Zi("FeatureIndex", Xp, { omit: ["rawTileData", "sourceLayerCoder"] });
      var Hp = ca([{ name: "a_pos", type: "Int16", components: 2 }]);
      const Jp = 32, Wp = 33, Qp = new Uint16Array(8184);
      for (let t2 = 0; t2 < 2046; t2++) {
        let e2 = t2 + 2, r2 = 0, n2 = 0, i3 = 0, s3 = 0, a2 = 0, o2 = 0;
        for (1 & e2 ? i3 = s3 = a2 = Jp : r2 = n2 = o2 = Jp; (e2 >>= 1) > 1; ) {
          const t3 = r2 + i3 >> 1, l3 = n2 + s3 >> 1;
          1 & e2 ? (i3 = r2, s3 = n2, r2 = a2, n2 = o2) : (r2 = i3, n2 = s3, i3 = a2, s3 = o2), a2 = t3, o2 = l3;
        }
        const l2 = 4 * t2;
        Qp[l2 + 0] = r2, Qp[l2 + 1] = n2, Qp[l2 + 2] = i3, Qp[l2 + 3] = s3;
      }
      const td = new Uint16Array(2178), ed = new Uint8Array(1089), rd = new Uint16Array(1089);
      function nd(t2) {
        return t2 === 0 ? -0.03125 : t2 === 32 ? 0.03125 : 0;
      }
      var id = ca([{ name: "a_pos", type: "Int16", components: 2 }, { name: "a_texture_pos", type: "Int16", components: 2 }]);
      const sd = { type: 2, extent: To, loadGeometry: () => [[new i2(0, 0), new i2(8193, 0), new i2(8193, 8193), new i2(0, 8193), new i2(0, 0)]] };
      class ad {
        constructor(t2, e2, r2, n2, i3) {
          this.tileID = t2, this.uid = rt(), this.uses = 0, this.tileSize = e2, this.tileZoom = r2, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = false, this.hasRTLText = false, this.dependencies = {}, this.isRaster = i3, this.expiredRequestCount = 0, this.state = "loading", n2 && n2.transform && (this.projection = n2.transform.projection);
        }
        registerFadeDuration(t2) {
          const e2 = t2 + this.timeAdded;
          e2 < At.now() || this.fadeEndTime && e2 < this.fadeEndTime || (this.fadeEndTime = e2);
        }
        wasRequested() {
          return this.state === "errored" || this.state === "loaded" || this.state === "reloading";
        }
        get tileTransform() {
          return this._tileTransform || (this._tileTransform = Ad(this.tileID.canonical, this.projection)), this._tileTransform;
        }
        loadVectorData(t2, e2, r2) {
          if (this.unloadVectorData(), this.state = "loaded", t2) {
            t2.featureIndex && (this.latestFeatureIndex = t2.featureIndex, t2.rawTileData ? (this.latestRawTileData = t2.rawTileData, this.latestFeatureIndex.rawTileData = t2.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t2.collisionBoxArray, this.buckets = function(t3, e3) {
              const r3 = {};
              if (!e3)
                return r3;
              for (const n2 of t3) {
                const t4 = n2.layerIds.map((t5) => e3.getLayer(t5)).filter(Boolean);
                if (t4.length !== 0) {
                  n2.layers = t4, n2.stateDependentLayerIds && (n2.stateDependentLayers = n2.stateDependentLayerIds.map((e4) => t4.filter((t5) => t5.id === e4)[0]));
                  for (const e4 of t4)
                    r3[e4.id] = n2;
                }
              }
              return r3;
            }(t2.buckets, e2.style), this.hasSymbolBuckets = false;
            for (const t3 in this.buckets) {
              const e3 = this.buckets[t3];
              if (e3 instanceof Yh) {
                if (this.hasSymbolBuckets = true, !r2)
                  break;
                e3.justReloaded = true;
              }
            }
            if (this.hasRTLText = false, this.hasSymbolBuckets)
              for (const t3 in this.buckets) {
                const e3 = this.buckets[t3];
                if (e3 instanceof Yh && e3.hasRTLText) {
                  this.hasRTLText = true, Ns.isLoading() || Ns.isLoaded() || js() !== "deferred" || qs();
                  break;
                }
              }
            this.queryPadding = 0;
            for (const t3 in this.buckets) {
              const r3 = this.buckets[t3];
              this.queryPadding = Math.max(this.queryPadding, e2.style.getLayer(t3).queryRadius(r3));
            }
            t2.imageAtlas && (this.imageAtlas = t2.imageAtlas), t2.glyphAtlasImage && (this.glyphAtlasImage = t2.glyphAtlasImage), t2.lineAtlas && (this.lineAtlas = t2.lineAtlas);
          } else
            this.collisionBoxArray = new Fa();
        }
        unloadVectorData() {
          if (this.hasData()) {
            for (const t2 in this.buckets)
              this.buckets[t2].destroy();
            this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.lineAtlasTexture && this.lineAtlasTexture.destroy(), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugIndexBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this.globeGridBuffer && (this.globeGridBuffer.destroy(), this.globeGridBuffer = null), this.globePoleBuffer && (this.globePoleBuffer.destroy(), this.globePoleBuffer = null), this.latestFeatureIndex = null, this.state = "unloaded";
          }
        }
        getBucket(t2) {
          return this.buckets[t2.id];
        }
        upload(t2) {
          for (const e3 in this.buckets) {
            const r2 = this.buckets[e3];
            r2.uploadPending() && r2.upload(t2);
          }
          const e2 = t2.gl;
          this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new hp(t2, this.imageAtlas.image, e2.RGBA), this.imageAtlas.uploaded = true), this.glyphAtlasImage && (this.glyphAtlasTexture = new hp(t2, this.glyphAtlasImage, e2.ALPHA), this.glyphAtlasImage = null), this.lineAtlas && !this.lineAtlas.uploaded && (this.lineAtlasTexture = new hp(t2, this.lineAtlas.image, e2.ALPHA), this.lineAtlas.uploaded = true);
        }
        prepare(t2) {
          this.imageAtlas && this.imageAtlas.patchUpdatedImages(t2, this.imageAtlasTexture);
        }
        queryRenderedFeatures(t2, e2, r2, n2, i3, s3, a2, o2) {
          return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({ tileResult: n2, pixelPosMatrix: a2, transform: s3, params: i3, tileTransform: this.tileTransform }, t2, e2, r2) : {};
        }
        querySourceFeatures(t2, e2) {
          const r2 = this.latestFeatureIndex;
          if (!r2 || !r2.rawTileData)
            return;
          const n2 = r2.loadVTLayers(), i3 = e2 ? e2.sourceLayer : "", s3 = n2._geojsonTileLayer || n2[i3];
          if (!s3)
            return;
          const a2 = si(e2 && e2.filter), { z: o2, x: l2, y: u2 } = this.tileID.canonical, c2 = { z: o2, x: l2, y: u2 };
          for (let e3 = 0; e3 < s3.length; e3++) {
            const n3 = s3.feature(e3);
            if (a2.needGeometry) {
              const t3 = Yo(n3, true);
              if (!a2.filter(new Gs(this.tileID.overscaledZ), t3, this.tileID.canonical))
                continue;
            } else if (!a2.filter(new Gs(this.tileID.overscaledZ), n3))
              continue;
            const h2 = r2.getId(n3, i3), p2 = new Bp(n3, o2, l2, u2, h2);
            p2.tile = c2, t2.push(p2);
          }
        }
        hasData() {
          return this.state === "loaded" || this.state === "reloading" || this.state === "expired";
        }
        patternsLoaded() {
          return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
        }
        setExpiryData(t2) {
          const e2 = this.expirationTime;
          if (t2.cacheControl) {
            const e3 = mt(t2.cacheControl);
            e3["max-age"] && (this.expirationTime = Date.now() + 1e3 * e3["max-age"]);
          } else
            t2.expires && (this.expirationTime = new Date(t2.expires).getTime());
          if (this.expirationTime) {
            const t3 = Date.now();
            let r2 = false;
            if (this.expirationTime > t3)
              r2 = false;
            else if (e2)
              if (this.expirationTime < e2)
                r2 = true;
              else {
                const n2 = this.expirationTime - e2;
                n2 ? this.expirationTime = t3 + Math.max(n2, 3e4) : r2 = true;
              }
            else
              r2 = true;
            r2 ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
          }
        }
        getExpiryTimeout() {
          if (this.expirationTime)
            return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - new Date().getTime(), Math.pow(2, 31) - 1);
        }
        setFeatureState(t2, e2) {
          if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || Object.keys(t2).length === 0 || !e2)
            return;
          const r2 = this.latestFeatureIndex.loadVTLayers(), n2 = e2.style.listImages();
          for (const i3 in this.buckets) {
            if (!e2.style.hasLayer(i3))
              continue;
            const s3 = this.buckets[i3], a2 = s3.layers[0].sourceLayer || "_geojsonTileLayer", o2 = r2[a2], l2 = t2[a2];
            if (!o2 || !l2 || Object.keys(l2).length === 0)
              continue;
            if (s3.update(l2, o2, n2, this.imageAtlas && this.imageAtlas.patternPositions || {}), s3 instanceof Ku || s3 instanceof mu) {
              const t3 = e2.style._getSourceCache(s3.layers[0].source);
              e2._terrain && e2._terrain.enabled && t3 && s3.programConfigurations.needsUpload && e2._terrain._clearRenderCacheForTile(t3.id, this.tileID);
            }
            const u2 = e2 && e2.style && e2.style.getLayer(i3);
            u2 && (this.queryPadding = Math.max(this.queryPadding, u2.queryRadius(s3)));
          }
        }
        holdingForFade() {
          return this.symbolFadeHoldUntil !== void 0;
        }
        symbolFadeFinished() {
          return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < At.now();
        }
        clearFadeHold() {
          this.symbolFadeHoldUntil = void 0;
        }
        setHoldDuration(t2) {
          this.symbolFadeHoldUntil = At.now() + t2;
        }
        setDependencies(t2, e2) {
          const r2 = {};
          for (const t3 of e2)
            r2[t3] = true;
          this.dependencies[t2] = r2;
        }
        hasDependency(t2, e2) {
          for (const r2 of t2) {
            const t3 = this.dependencies[r2];
            if (t3) {
              for (const r3 of e2)
                if (t3[r3])
                  return true;
            }
          }
          return false;
        }
        clearQueryDebugViz() {
        }
        _makeDebugTileBoundsBuffers(t2, e2) {
          if (!e2 || e2.name === "mercator" || this._tileDebugBuffer)
            return;
          const r2 = Ko(sd, this.tileID.canonical, this.tileTransform)[0], n2 = new pa(), i3 = new Pa();
          for (let t3 = 0; t3 < r2.length; t3++) {
            const { x: e3, y: s3 } = r2[t3];
            n2.emplaceBack(e3, s3), i3.emplaceBack(t3);
          }
          i3.emplaceBack(0), this._tileDebugIndexBuffer = t2.createIndexBuffer(i3), this._tileDebugBuffer = t2.createVertexBuffer(n2, id.members), this._tileDebugSegments = Mo.simpleSegment(0, 0, n2.length, i3.length);
        }
        _makeTileBoundsBuffers(t2, e2) {
          if (this._tileBoundsBuffer || !e2 || e2.name === "mercator")
            return;
          const r2 = Ko(sd, this.tileID.canonical, this.tileTransform)[0];
          let n2, i3;
          if (this.isRaster) {
            const t3 = function(t4, e3) {
              const r3 = Ad(t4, e3), n3 = Math.pow(2, t4.z);
              for (let i5 = 0; i5 < Wp; i5++)
                for (let s4 = 0; s4 < Wp; s4++) {
                  const a3 = Ro((t4.x + (s4 + nd(s4)) / Jp) / n3), o3 = Uo((t4.y + (i5 + nd(i5)) / Jp) / n3), l3 = e3.project(a3, o3), u2 = i5 * Wp + s4;
                  td[2 * u2 + 0] = Math.round((l3.x * r3.scale - r3.x) * To), td[2 * u2 + 1] = Math.round((l3.y * r3.scale - r3.y) * To);
                }
              ed.fill(0), rd.fill(0);
              for (let t5 = 2045; t5 >= 0; t5--) {
                const e4 = 4 * t5, r4 = Qp[e4 + 0], n4 = Qp[e4 + 1], i5 = Qp[e4 + 2], s4 = Qp[e4 + 3], a3 = r4 + i5 >> 1, o3 = n4 + s4 >> 1, l3 = a3 + o3 - n4, u2 = o3 + r4 - a3, c2 = n4 * Wp + r4, h2 = s4 * Wp + i5, p2 = o3 * Wp + a3, d2 = Math.hypot((td[2 * c2 + 0] + td[2 * h2 + 0]) / 2 - td[2 * p2 + 0], (td[2 * c2 + 1] + td[2 * h2 + 1]) / 2 - td[2 * p2 + 1]) >= 16;
                if (ed[p2] = ed[p2] || (d2 ? 1 : 0), t5 < 1022) {
                  const t6 = (n4 + u2 >> 1) * Wp + (r4 + l3 >> 1), e5 = (s4 + u2 >> 1) * Wp + (i5 + l3 >> 1);
                  ed[p2] = ed[p2] || ed[t6] || ed[e5];
                }
              }
              const i4 = new da(), s3 = new ka();
              let a2 = 0;
              function o2(t5, e4) {
                const r4 = e4 * Wp + t5;
                return rd[r4] === 0 && (i4.emplaceBack(td[2 * r4 + 0], td[2 * r4 + 1], t5 * To / Jp, e4 * To / Jp), rd[r4] = ++a2), rd[r4] - 1;
              }
              function l2(t5, e4, r4, n4, i5, a3) {
                const u2 = t5 + r4 >> 1, c2 = e4 + n4 >> 1;
                if (Math.abs(t5 - i5) + Math.abs(e4 - a3) > 1 && ed[c2 * Wp + u2])
                  l2(i5, a3, t5, e4, u2, c2), l2(r4, n4, i5, a3, u2, c2);
                else {
                  const l3 = o2(t5, e4), u3 = o2(r4, n4), c3 = o2(i5, a3);
                  s3.emplaceBack(l3, u3, c3);
                }
              }
              return l2(0, 0, Jp, Jp, Jp, 0), l2(Jp, Jp, 0, 0, 0, Jp), { vertices: i4, indices: s3 };
            }(this.tileID.canonical, e2);
            n2 = t3.vertices, i3 = t3.indices;
          } else {
            n2 = new da(), i3 = new ka();
            for (const { x: t4, y: e3 } of r2)
              n2.emplaceBack(t4, e3, 0, 0);
            const t3 = Dl(n2.int16, void 0, 4);
            for (let e3 = 0; e3 < t3.length; e3 += 3)
              i3.emplaceBack(t3[e3], t3[e3 + 1], t3[e3 + 2]);
          }
          this._tileBoundsBuffer = t2.createVertexBuffer(n2, id.members), this._tileBoundsIndexBuffer = t2.createIndexBuffer(i3), this._tileBoundsSegments = Mo.simpleSegment(0, 0, n2.length, i3.length);
        }
      }
      const od = ca([{ type: "Float32", name: "a_globe_pos", components: 3 }, { type: "Float32", name: "a_merc_pos", components: 2 }, { type: "Float32", name: "a_uv", components: 2 }]), ld = ca([{ type: "Float32", name: "a_pos", components: 3 }, { type: "Float32", name: "a_uv", components: 2 }]), { members: ud } = od;
      function cd(t2, e2) {
        const r2 = t2.fovAboveCenter, n2 = t2.elevation ? t2.elevation.getMinElevationBelowMSL() * e2 : 0, i3 = (t2._camera.position[2] * t2.worldSize - n2) / Math.cos(t2._pitch), s3 = Math.sin(r2) * i3 / Math.sin(Math.max(Math.PI / 2 - t2._pitch - r2, 0.01)), a2 = Math.sin(t2._pitch) * s3 + i3;
        return Math.min(1.01 * a2, i3 * (1 / t2._horizonShift));
      }
      const hd = To / Math.PI / 2, pd = -hd, dd = hd, fd = [new gl([pd, pd, pd], [dd, dd, dd]), new gl([pd, pd, pd], [0, 0, dd]), new gl([0, pd, pd], [dd, 0, dd]), new gl([pd, 0, pd], [0, dd, dd]), new gl([0, 0, pd], [dd, dd, dd])];
      function yd(t2) {
        if (t2.z <= 1)
          return fd[t2.z + 2 * t2.y + t2.x];
        const [e2, r2] = md(t2), n2 = [xd(e2[0], e2[1]), xd(e2[0], r2[1]), xd(r2[0], e2[1]), xd(r2[0], r2[1])], i3 = [dd, dd, dd], s3 = [pd, pd, pd];
        for (const t3 of n2)
          i3[0] = Math.min(i3[0], t3[0]), i3[1] = Math.min(i3[1], t3[1]), i3[2] = Math.min(i3[2], t3[2]), s3[0] = Math.max(s3[0], t3[0]), s3[1] = Math.max(s3[1], t3[1]), s3[2] = Math.max(s3[2], t3[2]);
        return new gl(i3, s3);
      }
      function md(t2) {
        const e2 = Math.pow(2, t2.z), r2 = t2.x / e2, n2 = (t2.x + 1) / e2, i3 = (t2.y + 1) / e2;
        return [[Uo(t2.y / e2), Ro(r2)], [Uo(i3), Ro(n2)]];
      }
      function gd(t2, e2, r2, n2) {
        return r2 = q(r2), n2 || (n2 = hd), [t2 * Math.sin(r2) * n2, -e2 * n2, t2 * Math.cos(r2) * n2];
      }
      function xd(t2, e2, r2) {
        return gd(Math.cos(q(t2)), Math.sin(q(t2)), e2, r2);
      }
      function vd(t2) {
        return 16383 / Math.max(...E([], t2.max, t2.min));
      }
      function bd(t2) {
        const e2 = c(new Float64Array(16)), r2 = 1 / vd(t2);
        return p(e2, e2, t2.min), d(e2, e2, [r2, r2, r2]), e2;
      }
      function wd(t2, e2, r2) {
        const n2 = e2 / (2 * Math.PI), i3 = function(t3) {
          const e3 = To / (2 * Math.PI);
          return t3 / (2 * Math.PI) / e3;
        }(e2);
        if (!r2) {
          const n3 = Y2(t2.center.lat, -85.051129, Oo);
          r2 = [Vo(t2.center.lng) * e2, Fo(n3) * e2];
        }
        const s3 = c(new Float64Array(16));
        return p(s3, s3, [r2[0], r2[1], -n2]), d(s3, s3, [i3, i3, i3]), f(s3, s3, q(-t2._center.lat)), y(s3, s3, q(-t2._center.lng)), s3;
      }
      class _d {
        constructor(t2) {
          const e2 = this._createGridIndices();
          this.gridIndexBuffer = t2.createIndexBuffer(e2, true), this.gridSegments = Mo.simpleSegment(0, 0, 4225, 8192);
          const r2 = this._createPoleTriangleIndices();
          this.poleIndexBuffer = t2.createIndexBuffer(r2, true), this.poleSegments = Mo.simpleSegment(0, 0, 66, 64);
          const n2 = new Ta();
          n2.emplaceBack(-1, 1, 1, 0, 0, 0, 0), n2.emplaceBack(1, 1, 1, 0, 0, 1, 0), n2.emplaceBack(1, -1, 1, 0, 0, 1, 1), n2.emplaceBack(-1, -1, 1, 0, 0, 0, 1);
          const i3 = new ka();
          i3.emplaceBack(0, 1, 2), i3.emplaceBack(2, 3, 0), this.atmosphereVertexBuffer = t2.createVertexBuffer(n2, ld.members), this.atmosphereIndexBuffer = t2.createIndexBuffer(i3), this.atmosphereSegments = Mo.simpleSegment(0, 0, 4, 2);
        }
        destroy() {
          this.poleIndexBuffer.destroy(), this.gridIndexBuffer.destroy(), this.poleSegments.destroy(), this.gridSegments.destroy(), this.atmosphereVertexBuffer.destroy(), this.atmosphereIndexBuffer.destroy(), this.atmosphereSegments.destroy(), this.wireframeIndexBuffer && (this.wireframeIndexBuffer.destroy(), this.wireframeSegments.destroy());
        }
        static createPoleTriangleVertices(t2, e2, r2) {
          const n2 = new Ta(), i3 = e2 / Math.PI / 2;
          n2.emplaceBack(0, -i3, 0, 0, 0, 0.5, r2 ? 0 : 1);
          const s3 = 360 / t2, a2 = Math.cos(q(85)), o2 = Math.sin(q(85));
          for (let t3 = 0; t3 <= 64; t3++) {
            const e3 = t3 / 64, u2 = gd(a2, o2, 0 * (1 - (l2 = e3)) + s3 * l2, i3);
            n2.emplaceBack(u2[0], u2[1], u2[2], 0, 0, e3, r2 ? 0 : 1);
          }
          var l2;
          return n2;
        }
        _createPoleTriangleIndices() {
          const t2 = new ka();
          for (let e2 = 0; e2 <= 64; e2++)
            t2.emplaceBack(0, e2 + 1, e2 + 2);
          return t2;
        }
        static createGridVertices(t2) {
          const e2 = Math.pow(2, t2.z), r2 = (t3, e3, r3) => t3 * (1 - r3) + e3 * r3, [n2, i3] = md(t2), s3 = new Ta(), a2 = function(t3) {
            const e3 = c(new Float64Array(16)), r3 = vd(t3);
            var n3, i4;
            return d(e3, e3, [r3, r3, r3]), p(e3, e3, ((n3 = [])[0] = -(i4 = t3.min)[0], n3[1] = -i4[1], n3[2] = -i4[2], n3)), e3;
          }(yd(t2));
          s3.reserve(4096);
          for (let o2 = 0; o2 < 65; o2++) {
            const l2 = r2(n2[0], i3[0], o2 / 64), u2 = Fo(l2), c2 = u2 * e2 - t2.y, h2 = Math.sin(q(l2)), p2 = Math.cos(q(l2));
            for (let t3 = 0; t3 < 65; t3++) {
              const e3 = t3 / 64, o3 = r2(n2[1], i3[1], e3), l3 = gd(p2, h2, o3);
              B2(l3, l3, a2);
              const d2 = Vo(o3);
              s3.emplaceBack(l3[0], l3[1], l3[2], d2, u2, e3, c2);
            }
          }
          return s3;
        }
        _createGridIndices() {
          const t2 = new ka(), e2 = (e3, r2) => {
            const n2 = 65 * r2 + e3;
            t2.emplaceBack(n2 + 1, n2, n2 + 65), t2.emplaceBack(n2 + 65, n2 + 65 + 1, n2 + 1);
          };
          for (let t3 = 0; t3 < 64; t3++)
            for (let r2 = 0; r2 < 64; r2++)
              e2(r2, t3);
          return t2;
        }
        getWirefameBuffer(t2) {
          if (!this.wireframeSegments) {
            const e2 = this._createWireframeGrid();
            this.wireframeIndexBuffer = t2.createIndexBuffer(e2), this.wireframeSegments = Mo.simpleSegment(0, 0, 4096, e2.length);
          }
          return [this.wireframeIndexBuffer, this.wireframeSegments];
        }
        _createWireframeGrid() {
          const t2 = new Ca(), e2 = (e3, r2) => {
            const n2 = 65 * r2 + e3;
            t2.emplaceBack(n2, n2 + 1), t2.emplaceBack(n2, n2 + 65), t2.emplaceBack(n2, n2 + 65 + 1);
          };
          for (let t3 = 0; t3 < 64; t3++)
            for (let r2 = 0; r2 < 64; r2++)
              e2(r2, t3);
          return t2;
        }
      }
      function Ad(t2, e2) {
        if (!e2.isReprojectedInTileSpace)
          return { scale: 1 << t2.z, x: t2.x, y: t2.y, x2: t2.x + 1, y2: t2.y + 1, projection: e2 };
        const r2 = Math.pow(2, -t2.z), n2 = t2.x * r2, i3 = (t2.x + 1) * r2, s3 = t2.y * r2, a2 = (t2.y + 1) * r2, o2 = Ro(n2), l2 = Ro(i3), u2 = Uo(s3), c2 = Uo(a2), h2 = e2.project(o2, u2), p2 = e2.project(l2, u2), d2 = e2.project(l2, c2), f2 = e2.project(o2, c2);
        let y2 = Math.min(h2.x, p2.x, d2.x, f2.x), m2 = Math.min(h2.y, p2.y, d2.y, f2.y), g2 = Math.max(h2.x, p2.x, d2.x, f2.x), x3 = Math.max(h2.y, p2.y, d2.y, f2.y);
        const v3 = r2 / 16;
        function b2(t3, r3, n3, i4, s4, a3) {
          const o3 = (n3 + s4) / 2, l3 = (i4 + a3) / 2, u3 = e2.project(Ro(o3), Uo(l3)), c3 = Math.max(0, y2 - u3.x, m2 - u3.y, u3.x - g2, u3.y - x3);
          y2 = Math.min(y2, u3.x), g2 = Math.max(g2, u3.x), m2 = Math.min(m2, u3.y), x3 = Math.max(x3, u3.y), c3 > v3 && (b2(t3, u3, n3, i4, o3, l3), b2(u3, r3, o3, l3, s4, a3));
        }
        b2(h2, p2, n2, s3, i3, s3), b2(p2, d2, i3, s3, i3, a2), b2(d2, f2, i3, a2, n2, a2), b2(f2, h2, n2, a2, n2, s3), y2 -= v3, m2 -= v3, g2 += v3, x3 += v3;
        const w2 = 1 / Math.max(g2 - y2, x3 - m2);
        return { scale: w2, x: y2 * w2, y: m2 * w2, x2: g2 * w2, y2: x3 * w2, projection: e2 };
      }
      class kd {
        constructor(t2) {
          const e2 = {}, r2 = [];
          for (const n3 in t2) {
            const i4 = t2[n3], s4 = e2[n3] = {};
            for (const t3 in i4.glyphs) {
              const e3 = i4.glyphs[+t3];
              if (!e3 || e3.bitmap.width === 0 || e3.bitmap.height === 0)
                continue;
              const n4 = e3.metrics.localGlyph ? 2 : 1, a2 = { x: 0, y: 0, w: e3.bitmap.width + 2 * n4, h: e3.bitmap.height + 2 * n4 };
              r2.push(a2), s4[t3] = a2;
            }
          }
          const { w: n2, h: i3 } = $c(r2), s3 = new zl({ width: n2 || 1, height: i3 || 1 });
          for (const r3 in t2) {
            const n3 = t2[r3];
            for (const t3 in n3.glyphs) {
              const i4 = n3.glyphs[+t3];
              if (!i4 || i4.bitmap.width === 0 || i4.bitmap.height === 0)
                continue;
              const a2 = e2[r3][t3], o2 = i4.metrics.localGlyph ? 2 : 1;
              zl.copy(i4.bitmap, s3, { x: 0, y: 0 }, { x: a2.x + o2, y: a2.y + o2 }, i4.bitmap);
            }
          }
          this.image = s3, this.positions = e2;
        }
      }
      Zi("GlyphAtlas", kd);
      class Sd {
        constructor(t2) {
          this.tileID = new bp(t2.tileID.overscaledZ, t2.tileID.wrap, t2.tileID.canonical.z, t2.tileID.canonical.x, t2.tileID.canonical.y), this.tileZoom = t2.tileZoom, this.uid = t2.uid, this.zoom = t2.zoom, this.canonical = t2.tileID.canonical, this.pixelRatio = t2.pixelRatio, this.tileSize = t2.tileSize, this.source = t2.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t2.showCollisionBoxes, this.collectResourceTiming = !!t2.collectResourceTiming, this.returnDependencies = !!t2.returnDependencies, this.promoteId = t2.promoteId, this.enableTerrain = !!t2.enableTerrain, this.isSymbolTile = t2.isSymbolTile, this.tileTransform = Ad(t2.tileID.canonical, t2.projection), this.projection = t2.projection;
        }
        parse(t2, e2, r2, n2, i3) {
          this.status = "parsing", this.data = t2, this.collisionBoxArray = new Fa();
          const s3 = new Tp(Object.keys(t2.layers).sort()), a2 = new Xp(this.tileID, this.promoteId);
          a2.bucketLayerIDs = [];
          const o2 = {}, l2 = new pp(256, 256), u2 = { featureIndex: a2, iconDependencies: {}, patternDependencies: {}, glyphDependencies: {}, lineAtlas: l2, availableImages: r2 }, c2 = e2.familiesBySource[this.source];
          for (const e3 in c2) {
            const n3 = t2.layers[e3];
            if (!n3)
              continue;
            let i4 = false, l3 = false;
            for (const t3 of c2[e3])
              t3[0].type === "symbol" ? i4 = true : l3 = true;
            if (this.isSymbolTile === true && !i4)
              continue;
            if (this.isSymbolTile === false && !l3)
              continue;
            n3.version === 1 && pt(`Vector tile source "${this.source}" layer "${e3}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
            const h3 = s3.encode(e3), p3 = [];
            for (let t3 = 0; t3 < n3.length; t3++) {
              const r3 = n3.feature(t3), i5 = a2.getId(r3, e3);
              p3.push({ feature: r3, id: i5, index: t3, sourceLayerIndex: h3 });
            }
            for (const t3 of c2[e3]) {
              const e4 = t3[0];
              this.isSymbolTile !== void 0 && e4.type === "symbol" !== this.isSymbolTile || e4.minzoom && this.zoom < Math.floor(e4.minzoom) || e4.maxzoom && this.zoom >= e4.maxzoom || e4.visibility !== "none" && (Id(t3, this.zoom, r2), (o2[e4.id] = e4.createBucket({ index: a2.bucketLayerIDs.length, layers: t3, zoom: this.zoom, canonical: this.canonical, pixelRatio: this.pixelRatio, overscaling: this.overscaling, collisionBoxArray: this.collisionBoxArray, sourceLayerIndex: h3, sourceID: this.source, enableTerrain: this.enableTerrain, availableImages: r2 })).populate(p3, u2, this.tileID.canonical, this.tileTransform), a2.bucketLayerIDs.push(t3.map((t4) => t4.id)));
            }
          }
          let h2, p2, d2, f2;
          l2.trim();
          const y2 = { type: "maybePrepare", isSymbolTile: this.isSymbolTile, zoom: this.zoom }, m2 = lt(u2.glyphDependencies, (t3) => Object.keys(t3).map(Number));
          Object.keys(m2).length ? n2.send("getGlyphs", { uid: this.uid, stacks: m2 }, (t3, e3) => {
            h2 || (h2 = t3, p2 = e3, v3.call(this));
          }, void 0, false, y2) : p2 = {};
          const g2 = Object.keys(u2.iconDependencies);
          g2.length ? n2.send("getImages", { icons: g2, source: this.source, tileID: this.tileID, type: "icons" }, (t3, e3) => {
            h2 || (h2 = t3, d2 = e3, v3.call(this));
          }, void 0, false, y2) : d2 = {};
          const x3 = Object.keys(u2.patternDependencies);
          function v3() {
            if (h2)
              return i3(h2);
            if (p2 && d2 && f2) {
              const t3 = new kd(p2), e3 = new jc(d2, f2);
              for (const n3 in o2) {
                const i4 = o2[n3];
                i4 instanceof Yh ? (Id(i4.layers, this.zoom, r2), Eh(i4, p2, t3.positions, d2, e3.iconPositions, this.showCollisionBoxes, r2, this.tileID.canonical, this.tileZoom, this.projection), i4.projection = this.projection.name) : i4.hasPattern && (i4 instanceof Ku || i4 instanceof mu || i4 instanceof Vu) && (Id(i4.layers, this.zoom, r2), i4.addFeatures(u2, this.tileID.canonical, e3.patternPositions, r2));
              }
              this.status = "done", i3(null, { buckets: Q(o2).filter((t4) => !t4.isEmpty()), featureIndex: a2, collisionBoxArray: this.collisionBoxArray, glyphAtlasImage: t3.image, lineAtlas: l2, imageAtlas: e3, glyphMap: this.returnDependencies ? p2 : null, iconMap: this.returnDependencies ? d2 : null, glyphPositions: this.returnDependencies ? t3.positions : null });
            }
          }
          x3.length ? n2.send("getImages", { icons: x3, source: this.source, tileID: this.tileID, type: "patterns" }, (t3, e3) => {
            h2 || (h2 = t3, f2 = e3, v3.call(this));
          }, void 0, false, y2) : f2 = {}, v3.call(this);
        }
      }
      function Id(t2, e2, r2) {
        const n2 = new Gs(e2);
        for (const e3 of t2)
          e3.recalculate(n2, r2);
      }
      class zd {
        constructor(t2) {
          this.entries = {}, this.scheduler = t2;
        }
        request(t2, e2, r2, n2) {
          const i3 = this.entries[t2] = this.entries[t2] || { callbacks: [] };
          if (i3.result) {
            const [t3, r3] = i3.result;
            return this.scheduler ? this.scheduler.add(() => {
              n2(t3, r3);
            }, e2) : n2(t3, r3), () => {
            };
          }
          return i3.callbacks.push(n2), i3.cancel || (i3.cancel = r2((r3, n3) => {
            i3.result = [r3, n3];
            for (const t3 of i3.callbacks)
              this.scheduler ? this.scheduler.add(() => {
                t3(r3, n3);
              }, e2) : t3(r3, n3);
            setTimeout(() => delete this.entries[t2], 3e3);
          })), () => {
            i3.result || (i3.callbacks = i3.callbacks.filter((t3) => t3 !== n2), i3.callbacks.length || (i3.cancel(), delete this.entries[t2]));
          };
        }
      }
      function Md(t2, e2, r2) {
        const n2 = JSON.stringify(t2.request);
        return t2.data && (this.deduped.entries[n2] = { result: [null, t2.data] }), this.deduped.request(n2, { type: "parseTile", isSymbolTile: t2.isSymbolTile, zoom: t2.tileZoom }, (e3) => {
          const n3 = ae(t2.request, (t3, n4, i3, s3) => {
            t3 ? e3(t3) : n4 && e3(null, { vectorTile: r2 ? void 0 : new Bu.VectorTile(new gc(n4)), rawData: n4, cacheControl: i3, expires: s3 });
          });
          return () => {
            n3.cancel(), e3();
          };
        }, e2);
      }
      const Td = c(new Float64Array(16));
      class Bd {
        constructor(t2, e2) {
          this._tr = t2, this._worldSize = e2;
        }
        createInversionMatrix() {
          return Td;
        }
        createTileMatrix(t2) {
          let e2, r2, n2;
          const i3 = t2.canonical, s3 = c(new Float64Array(16)), a2 = this._tr.projection;
          if (a2.isReprojectedInTileSpace) {
            const o2 = Ad(i3, a2);
            e2 = 1, r2 = o2.x + t2.wrap * o2.scale, n2 = o2.y, d(s3, s3, [e2 / o2.scale, e2 / o2.scale, this._tr.pixelsPerMeter / this._worldSize]);
          } else
            e2 = this._worldSize / this._tr.zoomScale(i3.z), r2 = (i3.x + Math.pow(2, i3.z) * t2.wrap) * e2, n2 = i3.y * e2;
          return p(s3, s3, [r2, n2, 0]), d(s3, s3, [e2 / To, e2 / To, 1]), s3;
        }
        pointCoordinate(t2, e2, r2) {
          const n2 = this._tr.horizonLineFromTop(false), s3 = new i2(t2, Math.max(n2, e2));
          return this._tr.rayIntersectionCoordinate(this._tr.pointRayIntersection(s3, r2));
        }
        upVector() {
          return [0, 0, 1];
        }
        upVectorScale() {
          return 1;
        }
      }
      var Cd = { name: "albers", range: [4, 7], center: [-96, 37.5], parallels: [29.5, 45.5], zAxisUnit: "meters", conic: true, isReprojectedInTileSpace: true, unsupportedLayers: ["custom"], initializeConstants() {
        if (this.constants && $(this.parallels, this.constants.parallels))
          return;
        const t2 = Math.sin(q(this.parallels[0])), e2 = (t2 + Math.sin(q(this.parallels[1]))) / 2, r2 = 1 + t2 * (2 * e2 - t2), n2 = Math.sqrt(r2) / e2;
        this.constants = { n: e2, c: r2, r0: n2, parallels: this.parallels };
      }, project(t2, e2) {
        this.initializeConstants();
        const r2 = q(t2 - this.center[0]), n2 = q(e2), { n: i3, c: s3, r0: a2 } = this.constants, o2 = Math.sqrt(s3 - 2 * i3 * Math.sin(n2)) / i3;
        return { x: o2 * Math.sin(r2 * i3), y: o2 * Math.cos(r2 * i3) - a2, z: 0 };
      }, unproject(t2, e2) {
        this.initializeConstants();
        const { n: r2, c: n2, r0: i3 } = this.constants, s3 = i3 + e2;
        let a2 = Math.atan2(t2, Math.abs(s3)) * Math.sign(s3);
        s3 * r2 < 0 && (a2 -= Math.PI * Math.sign(t2) * Math.sign(s3));
        const o2 = q(this.center[0]) * r2;
        a2 = J(a2, -Math.PI - o2, Math.PI - o2);
        const l2 = N(a2 / r2) + this.center[0], u2 = Math.asin(Y2((n2 - (t2 * t2 + s3 * s3) * r2 * r2) / (2 * r2), -1, 1)), c2 = Y2(N(u2), -85.051129, Oo);
        return new Po(l2, c2);
      }, projectTilePoint: (t2, e2) => ({ x: t2, y: e2, z: 0 }), locationPoint: (t2, e2) => t2._coordinatePoint(t2.locationCoordinate(e2), false), pixelsPerMeter: (t2, e2) => Lo(1, t2) * e2, farthestPixelDistance(t2) {
        return cd(t2, this.pixelsPerMeter(t2.center.lat, t2.worldSize));
      }, createTileTransform: (t2, e2) => new Bd(t2, e2) };
      const Pd = 1.340264, Ed = -0.081106, Dd = 893e-6, Vd = 3796e-6, Fd = Math.sqrt(3) / 2;
      var Ld = { name: "equalEarth", center: [0, 0], range: [3.5, 7], zAxisUnit: "meters", isReprojectedInTileSpace: true, unsupportedLayers: ["custom"], project(t2, e2) {
        e2 = e2 / 180 * Math.PI, t2 = t2 / 180 * Math.PI;
        const r2 = Math.asin(Fd * Math.sin(e2)), n2 = r2 * r2, i3 = n2 * n2 * n2;
        return { x: 0.5 * (t2 * Math.cos(r2) / (Fd * (Pd + 3 * Ed * n2 + i3 * (7 * Dd + 9 * Vd * n2))) / Math.PI + 0.5), y: 1 - 0.5 * (r2 * (Pd + Ed * n2 + i3 * (Dd + Vd * n2)) / Math.PI + 1), z: 0 };
      }, unproject(t2, e2) {
        t2 = (2 * t2 - 0.5) * Math.PI;
        let r2 = e2 = (2 * (1 - e2) - 1) * Math.PI, n2 = r2 * r2, i3 = n2 * n2 * n2;
        for (let t3, s4, a3, o3 = 0; o3 < 12 && (s4 = r2 * (Pd + Ed * n2 + i3 * (Dd + Vd * n2)) - e2, a3 = Pd + 3 * Ed * n2 + i3 * (7 * Dd + 9 * Vd * n2), t3 = s4 / a3, r2 = Y2(r2 - t3, -Math.PI / 3, Math.PI / 3), n2 = r2 * r2, i3 = n2 * n2 * n2, !(Math.abs(t3) < 1e-12)); ++o3)
          ;
        const s3 = Fd * t2 * (Pd + 3 * Ed * n2 + i3 * (7 * Dd + 9 * Vd * n2)) / Math.cos(r2), a2 = Math.asin(Math.sin(r2) / Fd), o2 = Y2(180 * s3 / Math.PI, -180, 180), l2 = Y2(180 * a2 / Math.PI, -85.051129, Oo);
        return new Po(o2, l2);
      }, projectTilePoint: (t2, e2) => ({ x: t2, y: e2, z: 0 }), locationPoint: (t2, e2) => t2._coordinatePoint(t2.locationCoordinate(e2), false), pixelsPerMeter: (t2, e2) => Lo(1, t2) * e2, farthestPixelDistance(t2) {
        return cd(t2, this.pixelsPerMeter(t2.center.lat, t2.worldSize));
      }, createTileTransform: (t2, e2) => new Bd(t2, e2) }, Rd = { name: "equirectangular", supportsWorldCopies: true, center: [0, 0], range: [3.5, 7], zAxisUnit: "meters", wrap: true, isReprojectedInTileSpace: true, unsupportedLayers: ["custom"], project: (t2, e2) => ({ x: 0.5 + t2 / 360, y: 0.5 - e2 / 360, z: 0 }), unproject(t2, e2) {
        const r2 = 360 * (t2 - 0.5), n2 = Y2(360 * (0.5 - e2), -85.051129, Oo);
        return new Po(r2, n2);
      }, projectTilePoint: (t2, e2) => ({ x: t2, y: e2, z: 0 }), locationPoint: (t2, e2) => t2._coordinatePoint(t2.locationCoordinate(e2), false), pixelsPerMeter: (t2, e2) => Lo(1, t2) * e2, farthestPixelDistance(t2) {
        return cd(t2, this.pixelsPerMeter(t2.center.lat, t2.worldSize));
      }, createTileTransform: (t2, e2) => new Bd(t2, e2) };
      const Ud = Math.PI / 2;
      function $d(t2) {
        return Math.tan((Ud + t2) / 2);
      }
      var Od = { name: "lambertConformalConic", range: [3.5, 7], zAxisUnit: "meters", center: [0, 30], parallels: [30, 30], conic: true, isReprojectedInTileSpace: true, unsupportedLayers: ["custom"], initializeConstants() {
        if (this.constants && $(this.parallels, this.constants.parallels))
          return;
        const t2 = q(this.parallels[0]), e2 = q(this.parallels[1]), r2 = Math.cos(t2), n2 = t2 === e2 ? Math.sin(t2) : Math.log(r2 / Math.cos(e2)) / Math.log($d(e2) / $d(t2)), i3 = r2 * Math.pow($d(t2), n2) / n2;
        this.constants = { n: n2, f: i3, parallels: this.parallels };
      }, project(t2, e2) {
        this.initializeConstants(), e2 = q(e2), t2 = q(t2 - this.center[0]);
        const r2 = 1e-6, { n: n2, f: i3 } = this.constants;
        i3 > 0 ? e2 < -Ud + r2 && (e2 = -Ud + r2) : e2 > Ud - r2 && (e2 = Ud - r2);
        const s3 = i3 / Math.pow($d(e2), n2), a2 = s3 * Math.sin(n2 * t2), o2 = i3 - s3 * Math.cos(n2 * t2);
        return { x: 0.5 * (a2 / Math.PI + 0.5), y: 1 - 0.5 * (o2 / Math.PI + 0.5), z: 0 };
      }, unproject(t2, e2) {
        this.initializeConstants(), t2 = (2 * t2 - 0.5) * Math.PI, e2 = (2 * (1 - e2) - 0.5) * Math.PI;
        const { n: r2, f: n2 } = this.constants, i3 = n2 - e2, s3 = Math.sign(i3), a2 = Math.sign(r2) * Math.sqrt(t2 * t2 + i3 * i3);
        let o2 = Math.atan2(t2, Math.abs(i3)) * s3;
        i3 * r2 < 0 && (o2 -= Math.PI * Math.sign(t2) * s3);
        const l2 = Y2(N(o2 / r2) + this.center[0], -180, 180), u2 = Y2(N(2 * Math.atan(Math.pow(n2 / a2, 1 / r2)) - Ud), -85.051129, Oo);
        return new Po(l2, u2);
      }, projectTilePoint: (t2, e2) => ({ x: t2, y: e2, z: 0 }), locationPoint: (t2, e2) => t2._coordinatePoint(t2.locationCoordinate(e2), false), pixelsPerMeter: (t2, e2) => Lo(1, t2) * e2, farthestPixelDistance(t2) {
        return cd(t2, this.pixelsPerMeter(t2.center.lat, t2.worldSize));
      }, createTileTransform: (t2, e2) => new Bd(t2, e2) }, jd = { name: "mercator", wrap: true, requiresDraping: false, supportsWorldCopies: true, supportsTerrain: true, supportsFog: true, supportsFreeCamera: true, zAxisUnit: "meters", center: [0, 0], project: (t2, e2) => ({ x: Vo(t2), y: Fo(e2), z: 0 }), unproject(t2, e2) {
        const r2 = Ro(t2), n2 = Uo(e2);
        return new Po(r2, n2);
      }, projectTilePoint: (t2, e2) => ({ x: t2, y: e2, z: 0 }), locationPoint: (t2, e2) => t2._coordinatePoint(t2.locationCoordinate(e2), false), pixelsPerMeter: (t2, e2) => Lo(1, t2) * e2, farthestPixelDistance(t2) {
        return cd(t2, this.pixelsPerMeter(t2.center.lat, t2.worldSize));
      }, createTileTransform: (t2, e2) => new Bd(t2, e2) };
      const qd = q(Oo);
      var Nd = { name: "naturalEarth", center: [0, 0], range: [3.5, 7], isReprojectedInTileSpace: true, zAxisUnit: "meters", unsupportedLayers: ["custom"], project(t2, e2) {
        const r2 = (e2 = q(e2)) * e2, n2 = r2 * r2;
        return { x: 0.5 * ((t2 = q(t2)) * (0.8707 - 0.131979 * r2 + n2 * (n2 * (3971e-6 * r2 - 1529e-6 * n2) - 0.013791)) / Math.PI + 0.5), y: 1 - 0.5 * (e2 * (1.007226 + r2 * (0.015085 + n2 * (0.028874 * r2 - 0.044475 - 5916e-6 * n2))) / Math.PI + 1), z: 0 };
      }, unproject(t2, e2) {
        t2 = (2 * t2 - 0.5) * Math.PI;
        let r2 = e2 = (2 * (1 - e2) - 1) * Math.PI, n2 = 25, i3 = 0, s3 = r2 * r2;
        do {
          s3 = r2 * r2;
          const t3 = s3 * s3;
          i3 = (r2 * (1.007226 + s3 * (0.015085 + t3 * (0.028874 * s3 - 0.044475 - 5916e-6 * t3))) - e2) / (1.007226 + s3 * (0.045255 + t3 * (0.259866 * s3 - 0.311325 - 5916e-6 * 11 * t3))), r2 = Y2(r2 - i3, -qd, qd);
        } while (Math.abs(i3) > 1e-6 && --n2 > 0);
        s3 = r2 * r2;
        const a2 = Y2(N(t2 / (0.8707 + s3 * (s3 * (s3 * s3 * s3 * (3971e-6 - 1529e-6 * s3) - 0.013791) - 0.131979))), -180, 180), o2 = N(r2);
        return new Po(a2, o2);
      }, projectTilePoint: (t2, e2) => ({ x: t2, y: e2, z: 0 }), locationPoint: (t2, e2) => t2._coordinatePoint(t2.locationCoordinate(e2), false), pixelsPerMeter: (t2, e2) => Lo(1, t2) * e2, farthestPixelDistance(t2) {
        return cd(t2, this.pixelsPerMeter(t2.center.lat, t2.worldSize));
      }, createTileTransform: (t2, e2) => new Bd(t2, e2) };
      const Gd = q(Oo), Zd = { albers: Cd, equalEarth: Ld, equirectangular: Rd, lambertConformalConic: Od, mercator: jd, naturalEarth: Nd, winkelTripel: { name: "winkelTripel", center: [0, 0], range: [3.5, 7], zAxisUnit: "meters", isReprojectedInTileSpace: true, unsupportedLayers: ["custom"], project(t2, e2) {
        e2 = q(e2), t2 = q(t2);
        const r2 = Math.cos(e2), n2 = 2 / Math.PI, i3 = Math.acos(r2 * Math.cos(t2 / 2)), s3 = Math.sin(i3) / i3, a2 = 0.5 * (t2 * n2 + 2 * r2 * Math.sin(t2 / 2) / s3) || 0, o2 = 0.5 * (e2 + Math.sin(e2) / s3) || 0;
        return { x: 0.5 * (a2 / Math.PI + 0.5), y: 1 - 0.5 * (o2 / Math.PI + 1), z: 0 };
      }, unproject(t2, e2) {
        let r2 = t2 = (2 * t2 - 0.5) * Math.PI, n2 = e2 = (2 * (1 - e2) - 1) * Math.PI, i3 = 25;
        const s3 = 1e-6;
        let a2 = 0, o2 = 0;
        do {
          const i4 = Math.cos(n2), s4 = Math.sin(n2), l2 = 2 * s4 * i4, u2 = s4 * s4, c2 = i4 * i4, h2 = Math.cos(r2 / 2), p2 = Math.sin(r2 / 2), d2 = 2 * h2 * p2, f2 = p2 * p2, y2 = 1 - c2 * h2 * h2, m2 = y2 ? 1 / y2 : 0, g2 = y2 ? Math.acos(i4 * h2) * Math.sqrt(1 / y2) : 0, x3 = 0.5 * (2 * g2 * i4 * p2 + 2 * r2 / Math.PI) - t2, v3 = 0.5 * (g2 * s4 + n2) - e2, b2 = 0.5 * m2 * (c2 * f2 + g2 * i4 * h2 * u2) + 1 / Math.PI, w2 = m2 * (d2 * l2 / 4 - g2 * s4 * p2), _2 = 0.125 * m2 * (l2 * p2 - g2 * s4 * c2 * d2), A3 = 0.5 * m2 * (u2 * h2 + g2 * f2 * i4) + 0.5, k2 = w2 * _2 - A3 * b2;
          a2 = (v3 * w2 - x3 * A3) / k2, o2 = (x3 * _2 - v3 * b2) / k2, r2 = Y2(r2 - a2, -Math.PI, Math.PI), n2 = Y2(n2 - o2, -Gd, Gd);
        } while ((Math.abs(a2) > s3 || Math.abs(o2) > s3) && --i3 > 0);
        return new Po(N(r2), N(n2));
      }, projectTilePoint: (t2, e2) => ({ x: t2, y: e2, z: 0 }), locationPoint: (t2, e2) => t2._coordinatePoint(t2.locationCoordinate(e2), false), pixelsPerMeter: (t2, e2) => Lo(1, t2) * e2, farthestPixelDistance(t2) {
        return cd(t2, this.pixelsPerMeter(t2.center.lat, t2.worldSize));
      }, createTileTransform: (t2, e2) => new Bd(t2, e2) } };
      t.ARRAY_TYPE = l, t.AUTH_ERR_MSG = Et, t.Aabb = gl, t.Actor = class {
        constructor(t2, e2, r2) {
          this.target = t2, this.parent = e2, this.mapId = r2, this.callbacks = {}, this.cancelCallbacks = {}, at(["receive"], this), this.target.addEventListener("message", this.receive, false), this.globalScope = yt() ? t2 : a, this.scheduler = new mp();
        }
        send(t2, e2, r2, n2, i3 = false, s3) {
          const a2 = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
          r2 && (r2.metadata = s3, this.callbacks[a2] = r2);
          const o2 = wt(this.globalScope) ? void 0 : [];
          return this.target.postMessage({ id: a2, type: t2, hasCallback: !!r2, targetMapId: n2, mustQueue: i3, sourceMapId: this.mapId, data: Yi(e2, o2) }, o2), { cancel: () => {
            r2 && delete this.callbacks[a2], this.target.postMessage({ id: a2, type: "<cancel>", targetMapId: n2, sourceMapId: this.mapId });
          } };
        }
        receive(t2) {
          const e2 = t2.data, r2 = e2.id;
          if (r2 && (!e2.targetMapId || this.mapId === e2.targetMapId))
            if (e2.type === "<cancel>") {
              const t3 = this.cancelCallbacks[r2];
              delete this.cancelCallbacks[r2], t3 && t3.cancel();
            } else if (e2.mustQueue || yt()) {
              const t3 = this.callbacks[r2];
              this.cancelCallbacks[r2] = this.scheduler.add(() => this.processTask(r2, e2), t3 && t3.metadata || { type: "message" });
            } else
              this.processTask(r2, e2);
        }
        processTask(t2, e2) {
          if (e2.type === "<response>") {
            const r2 = this.callbacks[t2];
            delete this.callbacks[t2], r2 && (e2.error ? r2(Hi(e2.error)) : r2(null, Hi(e2.data)));
          } else {
            const r2 = wt(this.globalScope) ? void 0 : [], n2 = e2.hasCallback ? (e3, n3) => {
              delete this.cancelCallbacks[t2], this.target.postMessage({ id: t2, type: "<response>", sourceMapId: this.mapId, error: e3 ? Yi(e3) : null, data: Yi(n3, r2) }, r2);
            } : (t3) => {
            }, i3 = Hi(e2.data);
            if (this.parent[e2.type])
              this.parent[e2.type](e2.sourceMapId, i3, n2);
            else if (this.parent.getWorkerSource) {
              const t3 = e2.type.split(".");
              this.parent.getWorkerSource(e2.sourceMapId, t3[0], i3.source)[t3[1]](i3, n2);
            } else
              n2(new Error(`Could not find function ${e2.type}`));
          }
        }
        remove() {
          this.scheduler.remove(), this.target.removeEventListener("message", this.receive, false);
        }
      }, t.CanonicalTileID = xp, t.Color = Ge, t.ColorMode = Sp, t.CullFaceMode = Mp, t.DEMData = Op, t.DataConstantProperty = ta, t.DedupedRequest = zd, t.DepthMode = _p, t.EXTENT = To, t.Elevation = class {
        getAtPointOrZero(t2, e2 = 0) {
          return this.getAtPoint(t2, e2) || 0;
        }
        getAtPoint(t2, e2, r2 = true) {
          e2 == null && (e2 = null);
          const n2 = this._source();
          if (!n2)
            return e2;
          if (t2.y < 0 || t2.y > 1)
            return e2;
          const i3 = n2.getSource().maxzoom, s3 = 1 << i3, a2 = Math.floor(t2.x), o2 = t2.x - a2, l2 = new bp(i3, a2, i3, Math.floor(o2 * s3), Math.floor(t2.y * s3)), u2 = this.findDEMTileFor(l2);
          if (!u2 || !u2.dem)
            return e2;
          const c2 = u2.dem, h2 = 1 << u2.tileID.canonical.z, p2 = (o2 * h2 - u2.tileID.canonical.x) * c2.dim, d2 = (t2.y * h2 - u2.tileID.canonical.y) * c2.dim, f2 = Math.floor(p2), y2 = Math.floor(d2);
          return (r2 ? this.exaggeration() : 1) * Lr(Lr(c2.get(f2, y2), c2.get(f2, y2 + 1), d2 - y2), Lr(c2.get(f2 + 1, y2), c2.get(f2 + 1, y2 + 1), d2 - y2), p2 - f2);
        }
        getAtTileOffset(t2, e2, r2) {
          const n2 = 1 << t2.canonical.z;
          return this.getAtPointOrZero(new jo(t2.wrap + (t2.canonical.x + e2 / To) / n2, (t2.canonical.y + r2 / To) / n2));
        }
        getAtTileOffsetFunc(t2, e2) {
          return (r2) => {
            const n2 = this.getAtTileOffset(t2, r2.x, r2.y), i3 = e2.upVector(t2.canonical, r2.x, r2.y);
            return S2(i3, i3, n2 * e2.upVectorScale(t2.canonical)), i3;
          };
        }
        getForTilePoints(t2, e2, r2, n2) {
          const i3 = Zp.create(this, t2, n2);
          return !!i3 && (e2.forEach((t3) => {
            t3[2] = this.exaggeration() * i3.getElevationAt(t3[0], t3[1], r2);
          }), true);
        }
        getMinMaxForTile(t2) {
          const e2 = this.findDEMTileFor(t2);
          if (!e2 || !e2.dem)
            return null;
          const r2 = e2.dem.tree, n2 = e2.tileID, i3 = 1 << t2.canonical.z - n2.canonical.z;
          let s3 = t2.canonical.x / i3 - n2.canonical.x, a2 = t2.canonical.y / i3 - n2.canonical.y, o2 = 0;
          for (let e3 = 0; e3 < t2.canonical.z - n2.canonical.z && !r2.leaves[o2]; e3++) {
            s3 *= 2, a2 *= 2;
            const t3 = 2 * Math.floor(a2) + Math.floor(s3);
            o2 = r2.childOffsets[o2] + t3, s3 %= 1, a2 %= 1;
          }
          return { min: this.exaggeration() * r2.minimums[o2], max: this.exaggeration() * r2.maximums[o2] };
        }
        getMinElevationBelowMSL() {
          throw new Error("Pure virtual method called.");
        }
        raycast(t2, e2, r2) {
          throw new Error("Pure virtual method called.");
        }
        pointCoordinate(t2) {
          throw new Error("Pure virtual method called.");
        }
        _source() {
          throw new Error("Pure virtual method called.");
        }
        exaggeration() {
          throw new Error("Pure virtual method called.");
        }
        findDEMTileFor(t2) {
          throw new Error("Pure virtual method called.");
        }
        get visibleDemTiles() {
          throw new Error("Getter must be implemented in subclass.");
        }
      }, t.ErrorEvent = ge, t.EvaluationParameters = Gs, t.Event = me, t.Evented = xe, t.Frustum = ml, t.GLOBE_ZOOM_THRESHOLD_MAX = 6, t.GlobeSharedBuffers = _d, t.GlyphManager = xh, t.ImagePosition = Oc, t.LineAtlas = pp, t.LngLat = Po, t.LngLatBounds = Bo, t.LocalGlyphMode = gh, t.MAX_MERCATOR_LATITUDE = Oo, t.MercatorCoordinate = jo, t.ONE_EM = sc, t.OverscaledTileID = bp, t.Properties = sa, t.RGBAImage = Ml, t.Ray = class {
        constructor(t2, e2) {
          this.pos = t2, this.dir = e2;
        }
        intersectsPlane(t2, e2, r2) {
          const n2 = M2(e2, this.dir);
          if (Math.abs(n2) < 1e-6)
            return false;
          const i3 = ((t2[0] - this.pos[0]) * e2[0] + (t2[1] - this.pos[1]) * e2[1] + (t2[2] - this.pos[2]) * e2[2]) / n2;
          return r2[0] = this.pos[0] + this.dir[0] * i3, r2[1] = this.pos[1] + this.dir[1] * i3, r2[2] = this.pos[2] + this.dir[2] * i3, true;
        }
        closestPointOnSphere(t2, e2, r2) {
          if (function(t3, e3) {
            var r3 = t3[0], n3 = t3[1], i4 = t3[2], s4 = e3[0], a3 = e3[1], l3 = e3[2];
            return Math.abs(r3 - s4) <= o * Math.max(1, Math.abs(r3), Math.abs(s4)) && Math.abs(n3 - a3) <= o * Math.max(1, Math.abs(n3), Math.abs(a3)) && Math.abs(i4 - l3) <= o * Math.max(1, Math.abs(i4), Math.abs(l3));
          }(this.pos, t2) || e2 === 0)
            return r2[0] = r2[1] = r2[2] = 0, false;
          const [n2, i3, s3] = this.dir, a2 = this.pos[0] - t2[0], l2 = this.pos[1] - t2[1], u2 = this.pos[2] - t2[2], c2 = n2 * n2 + i3 * i3 + s3 * s3, h2 = 2 * (a2 * n2 + l2 * i3 + u2 * s3), p2 = h2 * h2 - 4 * c2 * (a2 * a2 + l2 * l2 + u2 * u2 - e2 * e2);
          if (p2 < 0) {
            const t3 = Math.max(-h2 / 2, 0), o2 = a2 + n2 * t3, c3 = l2 + i3 * t3, p3 = u2 + s3 * t3, d2 = Math.hypot(o2, c3, p3);
            return r2[0] = o2 * e2 / d2, r2[1] = c3 * e2 / d2, r2[2] = p3 * e2 / d2, false;
          }
          {
            const t3 = (-h2 - Math.sqrt(p2)) / (2 * c2);
            if (t3 < 0) {
              const t4 = Math.hypot(a2, l2, u2);
              return r2[0] = a2 * e2 / t4, r2[1] = l2 * e2 / t4, r2[2] = u2 * e2 / t4, false;
            }
            return r2[0] = a2 + n2 * t3, r2[1] = l2 + i3 * t3, r2[2] = u2 + s3 * t3, true;
          }
        }
      }, t.RequestManager = class {
        constructor(t2, e2, r2) {
          this._transformRequestFn = t2, this._customAccessToken = e2, this._silenceAuthErrors = !!r2, this._createSkuToken();
        }
        _createSkuToken() {
          const t2 = function() {
            let t3 = "";
            for (let e2 = 0; e2 < 10; e2++)
              t3 += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
            return { token: ["1", Pt, t3].join(""), tokenExpiresAt: Date.now() + 432e5 };
          }();
          this._skuToken = t2.token, this._skuTokenExpiresAt = t2.tokenExpiresAt;
        }
        _isSkuTokenExpired() {
          return Date.now() > this._skuTokenExpiresAt;
        }
        transformRequest(t2, e2) {
          return this._transformRequestFn && this._transformRequestFn(t2, e2) || { url: t2 };
        }
        normalizeStyleURL(t2, e2) {
          if (!Dt(t2))
            return t2;
          const r2 = Lt(t2);
          return r2.path = `/styles/v1${r2.path}`, this._makeAPIURL(r2, this._customAccessToken || e2);
        }
        normalizeGlyphsURL(t2, e2) {
          if (!Dt(t2))
            return t2;
          const r2 = Lt(t2);
          return r2.path = `/fonts/v1${r2.path}`, this._makeAPIURL(r2, this._customAccessToken || e2);
        }
        normalizeSourceURL(t2, e2) {
          if (!Dt(t2))
            return t2;
          const r2 = Lt(t2);
          return r2.path = `/v4/${r2.authority}.json`, r2.params.push("secure"), this._makeAPIURL(r2, this._customAccessToken || e2);
        }
        normalizeSpriteURL(t2, e2, r2, n2) {
          const i3 = Lt(t2);
          return Dt(t2) ? (i3.path = `/styles/v1${i3.path}/sprite${e2}${r2}`, this._makeAPIURL(i3, this._customAccessToken || n2)) : (i3.path += `${e2}${r2}`, Rt(i3));
        }
        normalizeTileURL(t2, e2, r2) {
          if (this._isSkuTokenExpired() && this._createSkuToken(), t2 && !Dt(t2))
            return t2;
          const n2 = Lt(t2);
          n2.path = n2.path.replace(/(\.(png|jpg)\d*)(?=$)/, `${e2 || r2 && n2.authority !== "raster" && r2 === 512 ? "@2x" : ""}${It.supported ? ".webp" : "$1"}`), n2.authority === "raster" ? n2.path = `/${St.RASTER_URL_PREFIX}${n2.path}` : (n2.path = n2.path.replace(/^.+\/v4\//, "/"), n2.path = `/${St.TILE_URL_VERSION}${n2.path}`);
          const i3 = this._customAccessToken || function(t3) {
            for (const e3 of t3) {
              const t4 = e3.match(/^access_token=(.*)$/);
              if (t4)
                return t4[1];
            }
            return null;
          }(n2.params) || St.ACCESS_TOKEN;
          return St.REQUIRE_ACCESS_TOKEN && i3 && this._skuToken && n2.params.push(`sku=${this._skuToken}`), this._makeAPIURL(n2, i3);
        }
        canonicalizeTileURL(t2, e2) {
          const r2 = Lt(t2);
          if (!r2.path.match(/^(\/v4\/|\/raster\/v1\/)/) || !r2.path.match(/\.[\w]+$/))
            return t2;
          let n2 = "mapbox://";
          r2.path.match(/^\/raster\/v1\//) ? n2 += `raster/${r2.path.replace(`/${St.RASTER_URL_PREFIX}/`, "")}` : n2 += `tiles/${r2.path.replace(`/${St.TILE_URL_VERSION}/`, "")}`;
          let i3 = r2.params;
          return e2 && (i3 = i3.filter((t3) => !t3.match(/^access_token=/))), i3.length && (n2 += `?${i3.join("&")}`), n2;
        }
        canonicalizeTileset(t2, e2) {
          const r2 = !!e2 && Dt(e2), n2 = [];
          for (const e3 of t2.tiles || [])
            Vt(e3) ? n2.push(this.canonicalizeTileURL(e3, r2)) : n2.push(e3);
          return n2;
        }
        _makeAPIURL(t2, e2) {
          const r2 = "See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes", n2 = Lt(St.API_URL);
          if (t2.protocol = n2.protocol, t2.authority = n2.authority, t2.protocol === "http") {
            const e3 = t2.params.indexOf("secure");
            e3 >= 0 && t2.params.splice(e3, 1);
          }
          if (n2.path !== "/" && (t2.path = `${n2.path}${t2.path}`), !St.REQUIRE_ACCESS_TOKEN)
            return Rt(t2);
          if (e2 = e2 || St.ACCESS_TOKEN, !this._silenceAuthErrors) {
            if (!e2)
              throw new Error(`An API access token is required to use Mapbox GL. ${r2}`);
            if (e2[0] === "s")
              throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${r2}`);
          }
          return t2.params = t2.params.filter((t3) => t3.indexOf("access_token") === -1), t2.params.push(`access_token=${e2 || ""}`), Rt(t2);
        }
      }, t.ResourceType = re, t.SegmentVector = Mo, t.SourceCache = qp, t.StencilMode = kp, t.StructArrayLayout1ui2 = Pa, t.StructArrayLayout2f1f2i16 = _a, t.StructArrayLayout2i4 = pa, t.StructArrayLayout2ui4 = Ca, t.StructArrayLayout3f12 = ya, t.StructArrayLayout3ui6 = ka, t.StructArrayLayout4i8 = da, t.Texture = hp, t.Tile = ad, t.Transitionable = Ks, t.Uniform1f = io, t.Uniform1i = class extends no {
        constructor(t2, e2) {
          super(t2, e2), this.current = 0;
        }
        set(t2) {
          this.current !== t2 && (this.current = t2, this.gl.uniform1i(this.location, t2));
        }
      }, t.Uniform2f = class extends no {
        constructor(t2, e2) {
          super(t2, e2), this.current = [0, 0];
        }
        set(t2) {
          t2[0] === this.current[0] && t2[1] === this.current[1] || (this.current = t2, this.gl.uniform2f(this.location, t2[0], t2[1]));
        }
      }, t.Uniform3f = class extends no {
        constructor(t2, e2) {
          super(t2, e2), this.current = [0, 0, 0];
        }
        set(t2) {
          t2[0] === this.current[0] && t2[1] === this.current[1] && t2[2] === this.current[2] || (this.current = t2, this.gl.uniform3f(this.location, t2[0], t2[1], t2[2]));
        }
      }, t.Uniform4f = so, t.UniformColor = ao, t.UniformMatrix2f = class extends no {
        constructor(t2, e2) {
          super(t2, e2), this.current = uo;
        }
        set(t2) {
          for (let e2 = 0; e2 < 4; e2++)
            if (t2[e2] !== this.current[e2]) {
              this.current = t2, this.gl.uniformMatrix2fv(this.location, false, t2);
              break;
            }
        }
      }, t.UniformMatrix3f = class extends no {
        constructor(t2, e2) {
          super(t2, e2), this.current = lo;
        }
        set(t2) {
          for (let e2 = 0; e2 < 9; e2++)
            if (t2[e2] !== this.current[e2]) {
              this.current = t2, this.gl.uniformMatrix3fv(this.location, false, t2);
              break;
            }
        }
      }, t.UniformMatrix4f = class extends no {
        constructor(t2, e2) {
          super(t2, e2), this.current = oo;
        }
        set(t2) {
          if (t2[12] !== this.current[12] || t2[0] !== this.current[0])
            return this.current = t2, void this.gl.uniformMatrix4fv(this.location, false, t2);
          for (let e2 = 1; e2 < 16; e2++)
            if (t2[e2] !== this.current[e2]) {
              this.current = t2, this.gl.uniformMatrix4fv(this.location, false, t2);
              break;
            }
        }
      }, t.UnwrappedTileID = vp, t.ValidationError = be, t.VectorTileWorkerSource = class extends xe {
        constructor(t2, e2, r2, n2, i3) {
          super(), this.actor = t2, this.layerIndex = e2, this.availableImages = r2, this.loadVectorData = i3 || Md, this.loading = {}, this.loaded = {}, this.deduped = new zd(t2.scheduler), this.isSpriteLoaded = n2, this.scheduler = t2.scheduler;
        }
        loadTile(t2, e2) {
          const r2 = t2.uid, n2 = t2 && t2.request, i3 = n2 && n2.collectResourceTiming, s3 = this.loading[r2] = new Sd(t2);
          s3.abort = this.loadVectorData(t2, (a2, o2) => {
            const l2 = !this.loading[r2];
            if (delete this.loading[r2], l2 || a2 || !o2)
              return s3.status = "done", l2 || (this.loaded[r2] = s3), e2(a2);
            const u2 = o2.rawData, c2 = {};
            o2.expires && (c2.expires = o2.expires), o2.cacheControl && (c2.cacheControl = o2.cacheControl), s3.vectorTile = o2.vectorTile || new Bu.VectorTile(new gc(u2));
            const h2 = () => {
              s3.parse(s3.vectorTile, this.layerIndex, this.availableImages, this.actor, (t3, r3) => {
                if (t3 || !r3)
                  return e2(t3);
                const s4 = {};
                if (i3) {
                  const t4 = yp(n2);
                  t4.length > 0 && (s4.resourceTiming = JSON.parse(JSON.stringify(t4)));
                }
                e2(null, tt({ rawTileData: u2.slice(0) }, r3, c2, s4));
              });
            };
            this.isSpriteLoaded ? h2() : this.once("isSpriteLoaded", () => {
              this.scheduler ? this.scheduler.add(h2, { type: "parseTile", isSymbolTile: t2.isSymbolTile, zoom: t2.tileZoom }) : h2();
            }), this.loaded = this.loaded || {}, this.loaded[r2] = s3;
          });
        }
        reloadTile(t2, e2) {
          const r2 = this.loaded, n2 = t2.uid, i3 = this;
          if (r2 && r2[n2]) {
            const s3 = r2[n2];
            s3.showCollisionBoxes = t2.showCollisionBoxes, s3.enableTerrain = !!t2.enableTerrain, s3.projection = t2.projection;
            const a2 = (t3, r3) => {
              const n3 = s3.reloadCallback;
              n3 && (delete s3.reloadCallback, s3.parse(s3.vectorTile, i3.layerIndex, this.availableImages, i3.actor, n3)), e2(t3, r3);
            };
            s3.status === "parsing" ? s3.reloadCallback = a2 : s3.status === "done" && (s3.vectorTile ? s3.parse(s3.vectorTile, this.layerIndex, this.availableImages, this.actor, a2) : a2());
          }
        }
        abortTile(t2, e2) {
          const r2 = t2.uid, n2 = this.loading[r2];
          n2 && (n2.abort && n2.abort(), delete this.loading[r2]), e2();
        }
        removeTile(t2, e2) {
          const r2 = this.loaded, n2 = t2.uid;
          r2 && r2[n2] && delete r2[n2], e2();
        }
      }, t.WritingMode = qc, t.ZoomHistory = Ji, t.add = w, t.addDynamicAttributes = Gh, t.adjoint = function(t2, e2) {
        var r2 = e2[0], n2 = e2[1], i3 = e2[2], s3 = e2[3], a2 = e2[4], o2 = e2[5], l2 = e2[6], u2 = e2[7], c2 = e2[8];
        return t2[0] = a2 * c2 - o2 * u2, t2[1] = i3 * u2 - n2 * c2, t2[2] = n2 * o2 - i3 * a2, t2[3] = o2 * l2 - s3 * c2, t2[4] = r2 * c2 - i3 * l2, t2[5] = i3 * s3 - r2 * o2, t2[6] = s3 * u2 - a2 * l2, t2[7] = n2 * l2 - r2 * u2, t2[8] = r2 * a2 - n2 * s3, t2;
      }, t.asyncAll = W, t.bezier = X2, t.bindAll = at, t.boundsAttributes = id, t.bufferConvexPolygon = function(t2, e2) {
        const r2 = [];
        for (let n2 = 0; n2 < t2.length; n2++) {
          const i3 = J(n2 - 1, -1, t2.length - 1), s3 = J(n2 + 1, -1, t2.length - 1), a2 = t2[n2], o2 = t2[s3], l2 = t2[i3].sub(a2).unit(), u2 = o2.sub(a2).unit(), c2 = u2.angleWithSep(l2.x, l2.y), h2 = l2.add(u2).unit().mult(-1 * e2 / Math.sin(c2 / 2));
          r2.push(a2.add(h2));
        }
        return r2;
      }, t.cacheEntryPossiblyAdded = function(t2) {
        ee++, ee > Wt && (t2.getActor().send("enforceCacheSizeLimit", Jt), ee = 0);
      }, t.calculateGlobeMatrix = wd, t.calculateGlobeMercatorMatrix = function(t2) {
        const e2 = t2.worldSize, r2 = Y2(t2.center.lat, -85.051129, Oo), n2 = new i2(Vo(t2.center.lng) * e2, Fo(r2) * e2), s3 = Lo(1, t2.center.lat) * e2, a2 = t2.pixelsPerMeter, o2 = e2 / (s3 / t2.pixelsPerMeter), l2 = c(new Float64Array(16));
        return p(l2, l2, [n2.x, n2.y, 0]), d(l2, l2, [o2, o2, a2]), l2;
      }, t.clamp = Y2, t.clearTileCache = function(t2) {
        const e2 = a.caches.delete(Kt);
        t2 && e2.catch(t2).then(() => t2());
      }, t.clipLine = dh, t.clone = function(t2) {
        var e2 = new l(16);
        return e2[0] = t2[0], e2[1] = t2[1], e2[2] = t2[2], e2[3] = t2[3], e2[4] = t2[4], e2[5] = t2[5], e2[6] = t2[6], e2[7] = t2[7], e2[8] = t2[8], e2[9] = t2[9], e2[10] = t2[10], e2[11] = t2[11], e2[12] = t2[12], e2[13] = t2[13], e2[14] = t2[14], e2[15] = t2[15], e2;
      }, t.clone$1 = ct, t.collisionCircleLayout = ic, t.config = St, t.conjugate = function(t2, e2) {
        return t2[0] = -e2[0], t2[1] = -e2[1], t2[2] = -e2[2], t2[3] = e2[3], t2;
      }, t.create = function() {
        var t2 = new l(16);
        return l != Float32Array && (t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0), t2[0] = 1, t2[5] = 1, t2[10] = 1, t2[15] = 1, t2;
      }, t.create$1 = u, t.createExpression = Gn, t.createLayout = ca, t.createStyleLayer = function(t2) {
        return t2.type === "custom" ? new rp(t2) : new sp[t2.type](t2);
      }, t.cross = T, t.degToRad = q, t.div = function(t2, e2, r2) {
        return t2[0] = e2[0] / r2[0], t2[1] = e2[1] / r2[1], t2[2] = e2[2] / r2[2], t2;
      }, t.dot = M2, t.ease = K, t.easeCubicInOut = Z2, t.emitValidationErrors = $i, t.endsWith = ot, t.enforceCacheSizeLimit = function(t2) {
        Qt(), Yt && Yt.then((e2) => {
          e2.keys().then((r2) => {
            for (let n2 = 0; n2 < r2.length - t2; n2++)
              e2.delete(r2[n2]);
          });
        });
      }, t.evaluateSizeForFeature = lc, t.evaluateSizeForZoom = uc, t.evaluateVariableOffset = Ph, t.evented = Os, t.exactEquals = function(t2, e2) {
        return t2[0] === e2[0] && t2[1] === e2[1] && t2[2] === e2[2] && t2[3] === e2[3];
      }, t.exactEquals$1 = function(t2, e2) {
        return t2[0] === e2[0] && t2[1] === e2[1] && t2[2] === e2[2];
      }, t.exported = At, t.exported$1 = It, t.extend = tt, t.extend$1 = _e, t.filterObject = ut, t.fromMat4 = function(t2, e2) {
        return t2[0] = e2[0], t2[1] = e2[1], t2[2] = e2[2], t2[3] = e2[4], t2[4] = e2[5], t2[5] = e2[6], t2[6] = e2[8], t2[7] = e2[9], t2[8] = e2[10], t2;
      }, t.fromQuat = function(t2, e2) {
        var r2 = e2[0], n2 = e2[1], i3 = e2[2], s3 = e2[3], a2 = r2 + r2, o2 = n2 + n2, l2 = i3 + i3, u2 = r2 * a2, c2 = n2 * a2, h2 = n2 * o2, p2 = i3 * a2, d2 = i3 * o2, f2 = i3 * l2, y2 = s3 * a2, m2 = s3 * o2, g2 = s3 * l2;
        return t2[0] = 1 - h2 - f2, t2[1] = c2 + g2, t2[2] = p2 - m2, t2[3] = 0, t2[4] = c2 - g2, t2[5] = 1 - u2 - f2, t2[6] = d2 + y2, t2[7] = 0, t2[8] = p2 + m2, t2[9] = d2 - y2, t2[10] = 1 - u2 - h2, t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0, t2[15] = 1, t2;
      }, t.fromRotation = function(t2, e2) {
        var r2 = Math.sin(e2), n2 = Math.cos(e2);
        return t2[0] = n2, t2[1] = r2, t2[2] = 0, t2[3] = -r2, t2[4] = n2, t2[5] = 0, t2[6] = 0, t2[7] = 0, t2[8] = 1, t2;
      }, t.fromScaling = function(t2, e2) {
        return t2[0] = e2[0], t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = e2[1], t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[10] = e2[2], t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0, t2[15] = 1, t2;
      }, t.furthestTileCorner = function(t2) {
        const e2 = Math.round((t2 + 45 + 360) % 360 / 90) % 4;
        return G[e2];
      }, t.getAABBPointSquareDist = function(t2, e2, r2) {
        let n2 = 0;
        for (let i3 = 0; i3 < 2; ++i3) {
          const s3 = r2 ? r2[i3] : 0;
          t2[i3] > s3 && (n2 += (t2[i3] - s3) * (t2[i3] - s3)), e2[i3] < s3 && (n2 += (s3 - e2[i3]) * (s3 - e2[i3]));
        }
        return n2;
      }, t.getAnchorAlignment = eh, t.getAnchorJustification = Dh, t.getBounds = function(t2) {
        let e2 = 1 / 0, r2 = 1 / 0, n2 = -1 / 0, s3 = -1 / 0;
        for (const i3 of t2)
          e2 = Math.min(e2, i3.x), r2 = Math.min(r2, i3.y), n2 = Math.max(n2, i3.x), s3 = Math.max(s3, i3.y);
        return { min: new i2(e2, r2), max: new i2(n2, s3) };
      }, t.getColumn = function(t2, e2) {
        return [t2[4 * e2], t2[4 * e2 + 1], t2[4 * e2 + 2], t2[4 * e2 + 3]];
      }, t.getImage = de, t.getJSON = function(t2, e2) {
        return se(tt(t2, { type: "json" }), e2);
      }, t.getMapSessionAPI = Zt, t.getPerformanceMeasurement = yp, t.getProjection = function(t2) {
        const e2 = Zd[t2.name];
        if (!e2)
          throw new Error(`Invalid projection name: ${t2.name}`);
        return e2.conic ? function(t3, e3) {
          if (e3.parallels && Math.abs(e3.parallels[0] + e3.parallels[1]) < 0.01) {
            let r2 = function(t4) {
              const e4 = Math.max(0.01, Math.cos(q(t4))), r3 = 1 / (2 * Math.max(Math.PI * e4, 1 / e4));
              return { wrap: true, supportsWorldCopies: true, unsupportedLayers: ["custom"], project(t5, n2) {
                const i3 = q(t5) * e4, s3 = Math.sin(q(n2)) / e4;
                return { x: i3 * r3 + 0.5, y: -s3 * r3 + 0.5, z: 0 };
              }, unproject(t5, n2) {
                const i3 = -(n2 - 0.5) / r3, s3 = Y2(N((t5 - 0.5) / r3) / e4, -180, 180), a2 = Math.asin(Y2(i3 * e4, -1, 1)), o2 = Y2(N(a2), -85.051129, Oo);
                return new Po(s3, o2);
              } };
            }(e3.parallels[0]);
            if (e3.name === "lambertConformalConic") {
              const { project: t4, unproject: e4 } = Zd.mercator;
              r2 = { wrap: true, supportsWorldCopies: true, project: t4, unproject: e4 };
            }
            return tt({}, t3, e3, r2);
          }
          return tt({}, t3, e3);
        }(e2, t2) : e2;
      }, t.getRTLTextPluginStatus = js, t.getReferrer = ie2, t.getTilePoint = function(t2, { x: e2, y: r2 }, n2 = 0) {
        return new i2(((e2 - n2) * t2.scale - t2.x) * To, (r2 * t2.scale - t2.y) * To);
      }, t.getTileVec3 = function(t2, e2, r2 = 0) {
        return b(((e2.x - r2) * t2.scale - t2.x) * To, (e2.y * t2.scale - t2.y) * To, $o(e2.z, e2.y));
      }, t.getVideo = function(t2, e2) {
        const r2 = a.document.createElement("video");
        r2.muted = true, r2.onloadstart = function() {
          e2(null, r2);
        };
        for (let e3 = 0; e3 < t2.length; e3++) {
          const n2 = a.document.createElement("source");
          ue(t2[e3]) || (r2.crossOrigin = "Anonymous"), n2.src = t2[e3], r2.appendChild(n2);
        }
        return { cancel: () => {
        } };
      }, t.globeBuffersForTileMesh = function(t2, e2, r2, n2) {
        const i3 = t2.context, s3 = t2.transform;
        let a2 = e2.globeGridBuffer, o2 = e2.globePoleBuffer;
        if (!a2) {
          const t3 = _d.createGridVertices(r2.canonical);
          a2 = e2.globeGridBuffer = i3.createVertexBuffer(t3, ud, false);
        }
        if (!o2) {
          const t3 = _d.createPoleTriangleVertices(n2, s3.tileSize * n2, r2.canonical.y === 0);
          o2 = e2.globePoleBuffer = i3.createVertexBuffer(t3, ud, false);
        }
        return [a2, o2];
      }, t.globeDenormalizeECEF = bd, t.globeMatrixForTile = function(t2, e2) {
        const r2 = bd(yd(t2)), n2 = ((i3 = new Float64Array(16))[0] = (s3 = e2)[0], i3[1] = s3[1], i3[2] = s3[2], i3[3] = s3[3], i3[4] = s3[4], i3[5] = s3[5], i3[6] = s3[6], i3[7] = s3[7], i3[8] = s3[8], i3[9] = s3[9], i3[10] = s3[10], i3[11] = s3[11], i3[12] = s3[12], i3[13] = s3[13], i3[14] = s3[14], i3[15] = s3[15], i3);
        var i3, s3;
        return m(n2, n2, r2), n2;
      }, t.globePoleMatrixForTile = function(t2, e2, r2) {
        const n2 = c(new Float64Array(16)), i3 = Math.pow(2, t2.z), s3 = (t2.x - i3 / 2) / i3 * Math.PI * 2, a2 = r2.point, o2 = r2.worldSize / (r2.tileSize * i3);
        return p(n2, n2, [a2.x, a2.y, -r2.worldSize / Math.PI / 2]), d(n2, n2, [o2, o2, o2]), f(n2, n2, q(-r2._center.lat)), y(n2, n2, q(-r2._center.lng)), y(n2, n2, s3), e2 && d(n2, n2, [1, -1, 1]), n2;
      }, t.globeTileBounds = yd, t.globeToMercatorTransition = function(t2) {
        return H(5, 6, t2);
      }, t.identity = c, t.identity$1 = R5, t.invert = function(t2, e2) {
        var r2 = e2[0], n2 = e2[1], i3 = e2[2], s3 = e2[3], a2 = e2[4], o2 = e2[5], l2 = e2[6], u2 = e2[7], c2 = e2[8], h2 = e2[9], p2 = e2[10], d2 = e2[11], f2 = e2[12], y2 = e2[13], m2 = e2[14], g2 = e2[15], x3 = r2 * o2 - n2 * a2, v3 = r2 * l2 - i3 * a2, b2 = r2 * u2 - s3 * a2, w2 = n2 * l2 - i3 * o2, _2 = n2 * u2 - s3 * o2, A3 = i3 * u2 - s3 * l2, k2 = c2 * y2 - h2 * f2, S3 = c2 * m2 - p2 * f2, I3 = c2 * g2 - d2 * f2, z2 = h2 * m2 - p2 * y2, M3 = h2 * g2 - d2 * y2, T2 = p2 * g2 - d2 * m2, B3 = x3 * T2 - v3 * M3 + b2 * z2 + w2 * I3 - _2 * S3 + A3 * k2;
        return B3 ? (t2[0] = (o2 * T2 - l2 * M3 + u2 * z2) * (B3 = 1 / B3), t2[1] = (i3 * M3 - n2 * T2 - s3 * z2) * B3, t2[2] = (y2 * A3 - m2 * _2 + g2 * w2) * B3, t2[3] = (p2 * _2 - h2 * A3 - d2 * w2) * B3, t2[4] = (l2 * I3 - a2 * T2 - u2 * S3) * B3, t2[5] = (r2 * T2 - i3 * I3 + s3 * S3) * B3, t2[6] = (m2 * b2 - f2 * A3 - g2 * v3) * B3, t2[7] = (c2 * A3 - p2 * b2 + d2 * v3) * B3, t2[8] = (a2 * M3 - o2 * I3 + u2 * k2) * B3, t2[9] = (n2 * I3 - r2 * M3 - s3 * k2) * B3, t2[10] = (f2 * _2 - y2 * b2 + g2 * x3) * B3, t2[11] = (h2 * b2 - c2 * _2 - d2 * x3) * B3, t2[12] = (o2 * S3 - a2 * z2 - l2 * k2) * B3, t2[13] = (r2 * z2 - n2 * S3 + i3 * k2) * B3, t2[14] = (y2 * v3 - f2 * w2 - m2 * x3) * B3, t2[15] = (c2 * w2 - h2 * v3 + p2 * x3) * B3, t2) : null;
      }, t.isMapAuthenticated = function(t2) {
        return Xt.has(t2);
      }, t.isMapboxURL = Dt, t.latFromMercatorY = Uo, t.len = V, t.length = v2, t.length$1 = function(t2) {
        return Math.hypot(t2[0], t2[1], t2[2], t2[3]);
      }, t.loadVectorTile = Md, t.makeRequest = se, t.mercatorXfromLng = Vo, t.mercatorYfromLat = Fo, t.mercatorZfromAltitude = Lo, t.mul = m, t.mul$1 = D3, t.multiply = function(t2, e2, r2) {
        var n2 = e2[0], i3 = e2[1], s3 = e2[2], a2 = e2[3], o2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h2 = e2[8], p2 = r2[0], d2 = r2[1], f2 = r2[2], y2 = r2[3], m2 = r2[4], g2 = r2[5], x3 = r2[6], v3 = r2[7], b2 = r2[8];
        return t2[0] = p2 * n2 + d2 * a2 + f2 * u2, t2[1] = p2 * i3 + d2 * o2 + f2 * c2, t2[2] = p2 * s3 + d2 * l2 + f2 * h2, t2[3] = y2 * n2 + m2 * a2 + g2 * u2, t2[4] = y2 * i3 + m2 * o2 + g2 * c2, t2[5] = y2 * s3 + m2 * l2 + g2 * h2, t2[6] = x3 * n2 + v3 * a2 + b2 * u2, t2[7] = x3 * i3 + v3 * o2 + b2 * c2, t2[8] = x3 * s3 + v3 * l2 + b2 * h2, t2;
      }, t.multiply$1 = h, t.multiply$2 = A2, t.nextPowerOfTwo = it, t.normalize = z, t.normalize$1 = function(t2, e2) {
        var r2 = e2[0], n2 = e2[1], i3 = e2[2], s3 = e2[3], a2 = r2 * r2 + n2 * n2 + i3 * i3 + s3 * s3;
        return a2 > 0 && (a2 = 1 / Math.sqrt(a2)), t2[0] = r2 * a2, t2[1] = n2 * a2, t2[2] = i3 * a2, t2[3] = s3 * a2, t2;
      }, t.number = Lr, t.ortho = function(t2, e2, r2, n2, i3, s3, a2) {
        var o2 = 1 / (e2 - r2), l2 = 1 / (n2 - i3), u2 = 1 / (s3 - a2);
        return t2[0] = -2 * o2, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = -2 * l2, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[10] = 2 * u2, t2[11] = 0, t2[12] = (e2 + r2) * o2, t2[13] = (i3 + n2) * l2, t2[14] = (a2 + s3) * u2, t2[15] = 1, t2;
      }, t.pbf = gc, t.perspective = function(t2, e2, r2, n2, i3) {
        var s3, a2 = 1 / Math.tan(e2 / 2);
        return t2[0] = a2 / r2, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = a2, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[11] = -1, t2[12] = 0, t2[13] = 0, t2[15] = 0, i3 != null && i3 !== 1 / 0 ? (t2[10] = (i3 + n2) * (s3 = 1 / (n2 - i3)), t2[14] = 2 * i3 * n2 * s3) : (t2[10] = -1, t2[14] = -2 * n2), t2;
      }, t.pick = function(t2, e2) {
        const r2 = {};
        for (let n2 = 0; n2 < e2.length; n2++) {
          const i3 = e2[n2];
          i3 in t2 && (r2[i3] = t2[i3]);
        }
        return r2;
      }, t.plugin = Ns, t.pointGeometry = i2, t.polygonIntersectsBox = ll, t.polygonIntersectsPolygon = Wo, t.polygonizeBounds = function(t2, e2, r2 = 0, n2 = true) {
        const s3 = new i2(r2, r2), a2 = t2.sub(s3), o2 = e2.add(s3), l2 = [a2, new i2(o2.x, a2.y), o2, new i2(a2.x, o2.y)];
        return n2 && l2.push(a2), l2;
      }, t.posAttributes = Hp, t.postMapLoadEvent = Nt, t.postTurnstileEvent = jt, t.potpack = $c, t.prevPowerOfTwo = function(t2) {
        return t2 <= 1 ? 1 : Math.pow(2, Math.floor(Math.log(t2) / Math.LN2));
      }, t.radToDeg = N, t.refProperties = ["type", "source", "source-layer", "minzoom", "maxzoom", "filter", "layout"], t.registerForPluginStateChange = function(t2) {
        return t2({ pluginStatus: Ls, pluginURL: Rs }), Os.on("pluginStateChange", t2), t2;
      }, t.removeAuthState = function(t2) {
        Xt.delete(t2);
      }, t.renderColorRamp = Bl, t.rotateX = f, t.rotateX$1 = U, t.rotateY = y, t.rotateZ = function(t2, e2, r2) {
        var n2 = Math.sin(r2), i3 = Math.cos(r2), s3 = e2[0], a2 = e2[1], o2 = e2[2], l2 = e2[3], u2 = e2[4], c2 = e2[5], h2 = e2[6], p2 = e2[7];
        return e2 !== t2 && (t2[8] = e2[8], t2[9] = e2[9], t2[10] = e2[10], t2[11] = e2[11], t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15]), t2[0] = s3 * i3 + u2 * n2, t2[1] = a2 * i3 + c2 * n2, t2[2] = o2 * i3 + h2 * n2, t2[3] = l2 * i3 + p2 * n2, t2[4] = u2 * i3 - s3 * n2, t2[5] = c2 * i3 - a2 * n2, t2[6] = h2 * i3 - o2 * n2, t2[7] = p2 * i3 - l2 * n2, t2;
      }, t.rotateZ$1 = function(t2, e2, r2) {
        r2 *= 0.5;
        var n2 = e2[0], i3 = e2[1], s3 = e2[2], a2 = e2[3], o2 = Math.sin(r2), l2 = Math.cos(r2);
        return t2[0] = n2 * l2 + i3 * o2, t2[1] = i3 * l2 - n2 * o2, t2[2] = s3 * l2 + a2 * o2, t2[3] = a2 * l2 - s3 * o2, t2;
      }, t.scale = d, t.scale$1 = function(t2, e2, r2) {
        return t2[0] = e2[0] * r2, t2[1] = e2[1] * r2, t2[2] = e2[2] * r2, t2[3] = e2[3] * r2, t2;
      }, t.scale$2 = S2, t.scaleAndAdd = I2, t.setCacheLimits = function(t2, e2) {
        Jt = t2, Wt = e2;
      }, t.setColumn = function(t2, e2, r2) {
        t2[4 * e2 + 0] = r2[0], t2[4 * e2 + 1] = r2[1], t2[4 * e2 + 2] = r2[2], t2[4 * e2 + 3] = r2[3];
      }, t.setRTLTextPlugin = function(t2, e2, r2 = false) {
        if (Ls === Es || Ls === Ds || Ls === Vs)
          throw new Error("setRTLTextPlugin cannot be called multiple times.");
        Rs = At.resolveURL(t2), Ls = Es, Fs = e2, $s(), r2 || qs();
      }, t.smoothstep = H, t.spec = ve, t.storeAuthState = function(t2, e2) {
        e2 ? Xt.add(t2) : Xt.delete(t2);
      }, t.sub = E, t.subtract = _, t.symbolSize = cc, t.tileAABB = function(t2, e2, r2, n2, i3, s3, a2, o2, l2) {
        if (l2.name === "globe") {
          const a3 = yd(new vp(s3, new xp(r2, n2, i3)).canonical).getCorners(), o3 = Number.MAX_VALUE, l3 = [-o3, -o3, -o3], p3 = [o3, o3, o3], d2 = wd(t2, e2);
          for (let t3 = 0; t3 < a3.length; t3++)
            B2(a3[t3], a3[t3], d2), c2 = p3, h2 = a3[t3], (u2 = p3)[0] = Math.min(c2[0], h2[0]), u2[1] = Math.min(c2[1], h2[1]), u2[2] = Math.min(c2[2], h2[2]), k(l3, l3, a3[t3]);
          return new gl(p3, l3);
        }
        var u2, c2, h2;
        const p2 = Ad({ z: r2, x: n2, y: i3 }, l2);
        return new gl([(s3 + p2.x / p2.scale) * e2, e2 * (p2.y / p2.scale), a2], [(s3 + p2.x2 / p2.scale) * e2, e2 * (p2.y2 / p2.scale), o2]);
      }, t.tileTransform = Ad, t.transformMat3 = function(t2, e2, r2) {
        var n2 = e2[0], i3 = e2[1], s3 = e2[2];
        return t2[0] = n2 * r2[0] + i3 * r2[3] + s3 * r2[6], t2[1] = n2 * r2[1] + i3 * r2[4] + s3 * r2[7], t2[2] = n2 * r2[2] + i3 * r2[5] + s3 * r2[8], t2;
      }, t.transformMat4 = B2, t.transformMat4$1 = F, t.transformQuat = C, t.translate = p, t.transpose = function(t2, e2) {
        if (t2 === e2) {
          var r2 = e2[1], n2 = e2[2], i3 = e2[5];
          t2[1] = e2[3], t2[2] = e2[6], t2[3] = r2, t2[5] = e2[7], t2[6] = n2, t2[7] = i3;
        } else
          t2[0] = e2[0], t2[1] = e2[3], t2[2] = e2[6], t2[3] = e2[1], t2[4] = e2[4], t2[5] = e2[7], t2[6] = e2[2], t2[7] = e2[5], t2[8] = e2[8];
        return t2;
      }, t.triggerPluginCompletionEvent = Us, t.uniqueId = rt, t.validateCustomStyleLayer = function(t2) {
        const e2 = [], r2 = t2.id;
        return r2 === void 0 && e2.push({ message: `layers.${r2}: missing required property "id"` }), t2.render === void 0 && e2.push({ message: `layers.${r2}: missing required method "render"` }), t2.renderingMode && t2.renderingMode !== "2d" && t2.renderingMode !== "3d" && e2.push({ message: `layers.${r2}: property "renderingMode" must be either "2d" or "3d"` }), e2;
      }, t.validateFog = Li, t.validateLight = Fi, t.validateStyle = Vi, t.values = Q, t.vectorTile = Bu, t.version = e, t.warnOnce = pt, t.window = a, t.wrap = J;
    });
    define(["./shared"], function(e) {
      function t(e2) {
        const r2 = typeof e2;
        if (r2 === "number" || r2 === "boolean" || r2 === "string" || e2 == null)
          return JSON.stringify(e2);
        if (Array.isArray(e2)) {
          let r3 = "[";
          for (const o3 of e2)
            r3 += `${t(o3)},`;
          return `${r3}]`;
        }
        const o2 = Object.keys(e2).sort();
        let n2 = "{";
        for (let r3 = 0; r3 < o2.length; r3++)
          n2 += `${JSON.stringify(o2[r3])}:${t(e2[o2[r3]])},`;
        return `${n2}}`;
      }
      function r(r2) {
        let o2 = "";
        for (const n2 of e.refProperties)
          o2 += `/${t(r2[n2])}`;
        return o2;
      }
      class o {
        constructor(e2) {
          this.keyCache = {}, e2 && this.replace(e2);
        }
        replace(e2) {
          this._layerConfigs = {}, this._layers = {}, this.update(e2, []);
        }
        update(t2, o2) {
          for (const r2 of t2)
            this._layerConfigs[r2.id] = r2, (this._layers[r2.id] = e.createStyleLayer(r2)).compileFilter(), this.keyCache[r2.id] && delete this.keyCache[r2.id];
          for (const e2 of o2)
            delete this.keyCache[e2], delete this._layerConfigs[e2], delete this._layers[e2];
          this.familiesBySource = {};
          const n2 = function(e2, t3) {
            const o3 = {};
            for (let n4 = 0; n4 < e2.length; n4++) {
              const i3 = t3 && t3[e2[n4].id] || r(e2[n4]);
              t3 && (t3[e2[n4].id] = i3);
              let s3 = o3[i3];
              s3 || (s3 = o3[i3] = []), s3.push(e2[n4]);
            }
            const n3 = [];
            for (const e3 in o3)
              n3.push(o3[e3]);
            return n3;
          }(e.values(this._layerConfigs), this.keyCache);
          for (const e2 of n2) {
            const t3 = e2.map((e3) => this._layers[e3.id]), r2 = t3[0];
            if (r2.visibility === "none")
              continue;
            const o3 = r2.source || "";
            let n3 = this.familiesBySource[o3];
            n3 || (n3 = this.familiesBySource[o3] = {});
            const i3 = r2.sourceLayer || "_geojsonTileLayer";
            let s3 = n3[i3];
            s3 || (s3 = n3[i3] = []), s3.push(t3);
          }
        }
      }
      const { ImageBitmap: n } = e.window;
      class i2 {
        loadTile(t2, r2) {
          const { uid: o2, encoding: i3, rawImageData: s3, padding: a2, buildQuadTree: l2 } = t2, u2 = n && s3 instanceof n ? this.getImageData(s3, a2) : s3;
          r2(null, new e.DEMData(o2, u2, i3, a2 < 1, l2));
        }
        getImageData(t2, r2) {
          this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(t2.width, t2.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d")), this.offscreenCanvas.width = t2.width, this.offscreenCanvas.height = t2.height, this.offscreenCanvasContext.drawImage(t2, 0, 0, t2.width, t2.height);
          const o2 = this.offscreenCanvasContext.getImageData(-r2, -r2, t2.width + 2 * r2, t2.height + 2 * r2);
          return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), new e.RGBAImage({ width: o2.width, height: o2.height }, o2.data);
        }
      }
      var s2 = function e2(t2, r2) {
        var o2, n2 = t2 && t2.type;
        if (n2 === "FeatureCollection")
          for (o2 = 0; o2 < t2.features.length; o2++)
            e2(t2.features[o2], r2);
        else if (n2 === "GeometryCollection")
          for (o2 = 0; o2 < t2.geometries.length; o2++)
            e2(t2.geometries[o2], r2);
        else if (n2 === "Feature")
          e2(t2.geometry, r2);
        else if (n2 === "Polygon")
          a(t2.coordinates, r2);
        else if (n2 === "MultiPolygon")
          for (o2 = 0; o2 < t2.coordinates.length; o2++)
            a(t2.coordinates[o2], r2);
        return t2;
      };
      function a(e2, t2) {
        if (e2.length !== 0) {
          l(e2[0], t2);
          for (var r2 = 1; r2 < e2.length; r2++)
            l(e2[r2], !t2);
        }
      }
      function l(e2, t2) {
        for (var r2 = 0, o2 = 0, n2 = 0, i3 = e2.length, s3 = i3 - 1; n2 < i3; s3 = n2++) {
          var a2 = (e2[n2][0] - e2[s3][0]) * (e2[s3][1] + e2[n2][1]), l2 = r2 + a2;
          o2 += Math.abs(r2) >= Math.abs(a2) ? r2 - l2 + a2 : a2 - l2 + r2, r2 = l2;
        }
        r2 + o2 >= 0 != !!t2 && e2.reverse();
      }
      const u = e.vectorTile.VectorTileFeature.prototype.toGeoJSON;
      class h {
        constructor(t2) {
          this._feature = t2, this.extent = e.EXTENT, this.type = t2.type, this.properties = t2.tags, "id" in t2 && !isNaN(t2.id) && (this.id = parseInt(t2.id, 10));
        }
        loadGeometry() {
          if (this._feature.type === 1) {
            const t2 = [];
            for (const r2 of this._feature.geometry)
              t2.push([new e.pointGeometry(r2[0], r2[1])]);
            return t2;
          }
          {
            const t2 = [];
            for (const r2 of this._feature.geometry) {
              const o2 = [];
              for (const t3 of r2)
                o2.push(new e.pointGeometry(t3[0], t3[1]));
              t2.push(o2);
            }
            return t2;
          }
        }
        toGeoJSON(e2, t2, r2) {
          return u.call(this, e2, t2, r2);
        }
      }
      class c {
        constructor(t2) {
          this.layers = { _geojsonTileLayer: this }, this.name = "_geojsonTileLayer", this.extent = e.EXTENT, this.length = t2.length, this._features = t2;
        }
        feature(e2) {
          return new h(this._features[e2]);
        }
      }
      var f = e.vectorTile.VectorTileFeature, p = g;
      function g(e2, t2) {
        this.options = t2 || {}, this.features = e2, this.length = e2.length;
      }
      function d(e2, t2) {
        this.id = typeof e2.id == "number" ? e2.id : void 0, this.type = e2.type, this.rawGeometry = e2.type === 1 ? [e2.geometry] : e2.geometry, this.properties = e2.tags, this.extent = t2 || 4096;
      }
      g.prototype.feature = function(e2) {
        return new d(this.features[e2], this.options.extent);
      }, d.prototype.loadGeometry = function() {
        var t2 = this.rawGeometry;
        this.geometry = [];
        for (var r2 = 0; r2 < t2.length; r2++) {
          for (var o2 = t2[r2], n2 = [], i3 = 0; i3 < o2.length; i3++)
            n2.push(new e.pointGeometry(o2[i3][0], o2[i3][1]));
          this.geometry.push(n2);
        }
        return this.geometry;
      }, d.prototype.bbox = function() {
        this.geometry || this.loadGeometry();
        for (var e2 = this.geometry, t2 = 1 / 0, r2 = -1 / 0, o2 = 1 / 0, n2 = -1 / 0, i3 = 0; i3 < e2.length; i3++)
          for (var s3 = e2[i3], a2 = 0; a2 < s3.length; a2++) {
            var l2 = s3[a2];
            t2 = Math.min(t2, l2.x), r2 = Math.max(r2, l2.x), o2 = Math.min(o2, l2.y), n2 = Math.max(n2, l2.y);
          }
        return [t2, o2, r2, n2];
      }, d.prototype.toGeoJSON = f.prototype.toGeoJSON;
      var m = v2, y = p;
      function v2(t2) {
        var r2 = new e.pbf();
        return function(e2, t3) {
          for (var r3 in e2.layers)
            t3.writeMessage(3, x2, e2.layers[r3]);
        }(t2, r2), r2.finish();
      }
      function x2(e2, t2) {
        var r2;
        t2.writeVarintField(15, e2.version || 1), t2.writeStringField(1, e2.name || ""), t2.writeVarintField(5, e2.extent || 4096);
        var o2 = { keys: [], values: [], keycache: {}, valuecache: {} };
        for (r2 = 0; r2 < e2.length; r2++)
          o2.feature = e2.feature(r2), t2.writeMessage(2, w, o2);
        var n2 = o2.keys;
        for (r2 = 0; r2 < n2.length; r2++)
          t2.writeStringField(3, n2[r2]);
        var i3 = o2.values;
        for (r2 = 0; r2 < i3.length; r2++)
          t2.writeMessage(4, T, i3[r2]);
      }
      function w(e2, t2) {
        var r2 = e2.feature;
        r2.id !== void 0 && t2.writeVarintField(1, r2.id), t2.writeMessage(2, S2, e2), t2.writeVarintField(3, r2.type), t2.writeMessage(4, b, r2);
      }
      function S2(e2, t2) {
        var r2 = e2.feature, o2 = e2.keys, n2 = e2.values, i3 = e2.keycache, s3 = e2.valuecache;
        for (var a2 in r2.properties) {
          var l2 = r2.properties[a2], u2 = i3[a2];
          if (l2 !== null) {
            u2 === void 0 && (o2.push(a2), i3[a2] = u2 = o2.length - 1), t2.writeVarint(u2);
            var h2 = typeof l2;
            h2 !== "string" && h2 !== "boolean" && h2 !== "number" && (l2 = JSON.stringify(l2));
            var c2 = h2 + ":" + l2, f2 = s3[c2];
            f2 === void 0 && (n2.push(l2), s3[c2] = f2 = n2.length - 1), t2.writeVarint(f2);
          }
        }
      }
      function M2(e2, t2) {
        return (t2 << 3) + (7 & e2);
      }
      function P(e2) {
        return e2 << 1 ^ e2 >> 31;
      }
      function b(e2, t2) {
        for (var r2 = e2.loadGeometry(), o2 = e2.type, n2 = 0, i3 = 0, s3 = r2.length, a2 = 0; a2 < s3; a2++) {
          var l2 = r2[a2], u2 = 1;
          o2 === 1 && (u2 = l2.length), t2.writeVarint(M2(1, u2));
          for (var h2 = o2 === 3 ? l2.length - 1 : l2.length, c2 = 0; c2 < h2; c2++) {
            c2 === 1 && o2 !== 1 && t2.writeVarint(M2(2, h2 - 1));
            var f2 = l2[c2].x - n2, p2 = l2[c2].y - i3;
            t2.writeVarint(P(f2)), t2.writeVarint(P(p2)), n2 += f2, i3 += p2;
          }
          o2 === 3 && t2.writeVarint(M2(7, 1));
        }
      }
      function T(e2, t2) {
        var r2 = typeof e2;
        r2 === "string" ? t2.writeStringField(1, e2) : r2 === "boolean" ? t2.writeBooleanField(7, e2) : r2 === "number" && (e2 % 1 != 0 ? t2.writeDoubleField(3, e2) : e2 < 0 ? t2.writeSVarintField(6, e2) : t2.writeVarintField(5, e2));
      }
      function k(e2, t2, r2, o2, n2, i3) {
        if (n2 - o2 <= r2)
          return;
        const s3 = o2 + n2 >> 1;
        I2(e2, t2, s3, o2, n2, i3 % 2), k(e2, t2, r2, o2, s3 - 1, i3 + 1), k(e2, t2, r2, s3 + 1, n2, i3 + 1);
      }
      function I2(e2, t2, r2, o2, n2, i3) {
        for (; n2 > o2; ) {
          if (n2 - o2 > 600) {
            const s4 = n2 - o2 + 1, a3 = r2 - o2 + 1, l3 = Math.log(s4), u2 = 0.5 * Math.exp(2 * l3 / 3), h2 = 0.5 * Math.sqrt(l3 * u2 * (s4 - u2) / s4) * (a3 - s4 / 2 < 0 ? -1 : 1);
            I2(e2, t2, r2, Math.max(o2, Math.floor(r2 - a3 * u2 / s4 + h2)), Math.min(n2, Math.floor(r2 + (s4 - a3) * u2 / s4 + h2)), i3);
          }
          const s3 = t2[2 * r2 + i3];
          let a2 = o2, l2 = n2;
          for (_(e2, t2, o2, r2), t2[2 * n2 + i3] > s3 && _(e2, t2, o2, n2); a2 < l2; ) {
            for (_(e2, t2, a2, l2), a2++, l2--; t2[2 * a2 + i3] < s3; )
              a2++;
            for (; t2[2 * l2 + i3] > s3; )
              l2--;
          }
          t2[2 * o2 + i3] === s3 ? _(e2, t2, o2, l2) : (l2++, _(e2, t2, l2, n2)), l2 <= r2 && (o2 = l2 + 1), r2 <= l2 && (n2 = l2 - 1);
        }
      }
      function _(e2, t2, r2, o2) {
        L2(e2, r2, o2), L2(t2, 2 * r2, 2 * o2), L2(t2, 2 * r2 + 1, 2 * o2 + 1);
      }
      function L2(e2, t2, r2) {
        const o2 = e2[t2];
        e2[t2] = e2[r2], e2[r2] = o2;
      }
      function C(e2, t2, r2, o2) {
        const n2 = e2 - r2, i3 = t2 - o2;
        return n2 * n2 + i3 * i3;
      }
      m.fromVectorTileJs = v2, m.fromGeojsonVt = function(e2, t2) {
        t2 = t2 || {};
        var r2 = {};
        for (var o2 in e2)
          r2[o2] = new p(e2[o2].features, t2), r2[o2].name = o2, r2[o2].version = t2.version, r2[o2].extent = t2.extent;
        return v2({ layers: r2 });
      }, m.GeoJSONWrapper = y;
      const O = (e2) => e2[0], z = (e2) => e2[1];
      class E {
        constructor(e2, t2 = O, r2 = z, o2 = 64, n2 = Float64Array) {
          this.nodeSize = o2, this.points = e2;
          const i3 = e2.length < 65536 ? Uint16Array : Uint32Array, s3 = this.ids = new i3(e2.length), a2 = this.coords = new n2(2 * e2.length);
          for (let o3 = 0; o3 < e2.length; o3++)
            s3[o3] = o3, a2[2 * o3] = t2(e2[o3]), a2[2 * o3 + 1] = r2(e2[o3]);
          k(s3, a2, o2, 0, s3.length - 1, 0);
        }
        range(e2, t2, r2, o2) {
          return function(e3, t3, r3, o3, n2, i3, s3) {
            const a2 = [0, e3.length - 1, 0], l2 = [];
            let u2, h2;
            for (; a2.length; ) {
              const c2 = a2.pop(), f2 = a2.pop(), p2 = a2.pop();
              if (f2 - p2 <= s3) {
                for (let s4 = p2; s4 <= f2; s4++)
                  u2 = t3[2 * s4], h2 = t3[2 * s4 + 1], u2 >= r3 && u2 <= n2 && h2 >= o3 && h2 <= i3 && l2.push(e3[s4]);
                continue;
              }
              const g2 = Math.floor((p2 + f2) / 2);
              u2 = t3[2 * g2], h2 = t3[2 * g2 + 1], u2 >= r3 && u2 <= n2 && h2 >= o3 && h2 <= i3 && l2.push(e3[g2]);
              const d2 = (c2 + 1) % 2;
              (c2 === 0 ? r3 <= u2 : o3 <= h2) && (a2.push(p2), a2.push(g2 - 1), a2.push(d2)), (c2 === 0 ? n2 >= u2 : i3 >= h2) && (a2.push(g2 + 1), a2.push(f2), a2.push(d2));
            }
            return l2;
          }(this.ids, this.coords, e2, t2, r2, o2, this.nodeSize);
        }
        within(e2, t2, r2) {
          return function(e3, t3, r3, o2, n2, i3) {
            const s3 = [0, e3.length - 1, 0], a2 = [], l2 = n2 * n2;
            for (; s3.length; ) {
              const u2 = s3.pop(), h2 = s3.pop(), c2 = s3.pop();
              if (h2 - c2 <= i3) {
                for (let n3 = c2; n3 <= h2; n3++)
                  C(t3[2 * n3], t3[2 * n3 + 1], r3, o2) <= l2 && a2.push(e3[n3]);
                continue;
              }
              const f2 = Math.floor((c2 + h2) / 2), p2 = t3[2 * f2], g2 = t3[2 * f2 + 1];
              C(p2, g2, r3, o2) <= l2 && a2.push(e3[f2]);
              const d2 = (u2 + 1) % 2;
              (u2 === 0 ? r3 - n2 <= p2 : o2 - n2 <= g2) && (s3.push(c2), s3.push(f2 - 1), s3.push(d2)), (u2 === 0 ? r3 + n2 >= p2 : o2 + n2 >= g2) && (s3.push(f2 + 1), s3.push(h2), s3.push(d2));
            }
            return a2;
          }(this.ids, this.coords, e2, t2, r2, this.nodeSize);
        }
      }
      const F = { minZoom: 0, maxZoom: 16, minPoints: 2, radius: 40, extent: 512, nodeSize: 64, log: false, generateId: false, reduce: null, map: (e2) => e2 }, N = Math.fround || (j = new Float32Array(1), (e2) => (j[0] = +e2, j[0]));
      var j;
      class Z2 {
        constructor(e2) {
          this.options = D3(Object.create(F), e2), this.trees = new Array(this.options.maxZoom + 1);
        }
        load(e2) {
          const { log: t2, minZoom: r2, maxZoom: o2, nodeSize: n2 } = this.options;
          t2 && console.time("total time");
          const i3 = `prepare ${e2.length} points`;
          t2 && console.time(i3), this.points = e2;
          let s3 = [];
          for (let t3 = 0; t3 < e2.length; t3++)
            e2[t3].geometry && s3.push(J(e2[t3], t3));
          this.trees[o2 + 1] = new E(s3, $, B2, n2, Float32Array), t2 && console.timeEnd(i3);
          for (let e3 = o2; e3 >= r2; e3--) {
            const r3 = +Date.now();
            s3 = this._cluster(s3, e3), this.trees[e3] = new E(s3, $, B2, n2, Float32Array), t2 && console.log("z%d: %d clusters in %dms", e3, s3.length, +Date.now() - r3);
          }
          return t2 && console.timeEnd("total time"), this;
        }
        getClusters(e2, t2) {
          let r2 = ((e2[0] + 180) % 360 + 360) % 360 - 180;
          const o2 = Math.max(-90, Math.min(90, e2[1]));
          let n2 = e2[2] === 180 ? 180 : ((e2[2] + 180) % 360 + 360) % 360 - 180;
          const i3 = Math.max(-90, Math.min(90, e2[3]));
          if (e2[2] - e2[0] >= 360)
            r2 = -180, n2 = 180;
          else if (r2 > n2) {
            const e3 = this.getClusters([r2, o2, 180, i3], t2), s4 = this.getClusters([-180, o2, n2, i3], t2);
            return e3.concat(s4);
          }
          const s3 = this.trees[this._limitZoom(t2)], a2 = s3.range(X2(r2), V(i3), X2(n2), V(o2)), l2 = [];
          for (const e3 of a2) {
            const t3 = s3.points[e3];
            l2.push(t3.numPoints ? W(t3) : this.points[t3.index]);
          }
          return l2;
        }
        getChildren(e2) {
          const t2 = this._getOriginId(e2), r2 = this._getOriginZoom(e2), o2 = "No cluster with the specified id.", n2 = this.trees[r2];
          if (!n2)
            throw new Error(o2);
          const i3 = n2.points[t2];
          if (!i3)
            throw new Error(o2);
          const s3 = this.options.radius / (this.options.extent * Math.pow(2, r2 - 1)), a2 = n2.within(i3.x, i3.y, s3), l2 = [];
          for (const t3 of a2) {
            const r3 = n2.points[t3];
            r3.parentId === e2 && l2.push(r3.numPoints ? W(r3) : this.points[r3.index]);
          }
          if (l2.length === 0)
            throw new Error(o2);
          return l2;
        }
        getLeaves(e2, t2, r2) {
          const o2 = [];
          return this._appendLeaves(o2, e2, t2 = t2 || 10, r2 = r2 || 0, 0), o2;
        }
        getTile(e2, t2, r2) {
          const o2 = this.trees[this._limitZoom(e2)], n2 = Math.pow(2, e2), { extent: i3, radius: s3 } = this.options, a2 = s3 / i3, l2 = (r2 - a2) / n2, u2 = (r2 + 1 + a2) / n2, h2 = { features: [] };
          return this._addTileFeatures(o2.range((t2 - a2) / n2, l2, (t2 + 1 + a2) / n2, u2), o2.points, t2, r2, n2, h2), t2 === 0 && this._addTileFeatures(o2.range(1 - a2 / n2, l2, 1, u2), o2.points, n2, r2, n2, h2), t2 === n2 - 1 && this._addTileFeatures(o2.range(0, l2, a2 / n2, u2), o2.points, -1, r2, n2, h2), h2.features.length ? h2 : null;
        }
        getClusterExpansionZoom(e2) {
          let t2 = this._getOriginZoom(e2) - 1;
          for (; t2 <= this.options.maxZoom; ) {
            const r2 = this.getChildren(e2);
            if (t2++, r2.length !== 1)
              break;
            e2 = r2[0].properties.cluster_id;
          }
          return t2;
        }
        _appendLeaves(e2, t2, r2, o2, n2) {
          const i3 = this.getChildren(t2);
          for (const t3 of i3) {
            const i4 = t3.properties;
            if (i4 && i4.cluster ? n2 + i4.point_count <= o2 ? n2 += i4.point_count : n2 = this._appendLeaves(e2, i4.cluster_id, r2, o2, n2) : n2 < o2 ? n2++ : e2.push(t3), e2.length === r2)
              break;
          }
          return n2;
        }
        _addTileFeatures(e2, t2, r2, o2, n2, i3) {
          for (const s3 of e2) {
            const e3 = t2[s3], a2 = e3.numPoints;
            let l2, u2, h2;
            if (a2)
              l2 = Y2(e3), u2 = e3.x, h2 = e3.y;
            else {
              const t3 = this.points[e3.index];
              l2 = t3.properties, u2 = X2(t3.geometry.coordinates[0]), h2 = V(t3.geometry.coordinates[1]);
            }
            const c2 = { type: 1, geometry: [[Math.round(this.options.extent * (u2 * n2 - r2)), Math.round(this.options.extent * (h2 * n2 - o2))]], tags: l2 };
            let f2;
            a2 ? f2 = e3.id : this.options.generateId ? f2 = e3.index : this.points[e3.index].id && (f2 = this.points[e3.index].id), f2 !== void 0 && (c2.id = f2), i3.features.push(c2);
          }
        }
        _limitZoom(e2) {
          return Math.max(this.options.minZoom, Math.min(+e2, this.options.maxZoom + 1));
        }
        _cluster(e2, t2) {
          const r2 = [], { radius: o2, extent: n2, reduce: i3, minPoints: s3 } = this.options, a2 = o2 / (n2 * Math.pow(2, t2));
          for (let o3 = 0; o3 < e2.length; o3++) {
            const n3 = e2[o3];
            if (n3.zoom <= t2)
              continue;
            n3.zoom = t2;
            const l2 = this.trees[t2 + 1], u2 = l2.within(n3.x, n3.y, a2), h2 = n3.numPoints || 1;
            let c2 = h2;
            for (const e3 of u2) {
              const r3 = l2.points[e3];
              r3.zoom > t2 && (c2 += r3.numPoints || 1);
            }
            if (c2 > h2 && c2 >= s3) {
              let e3 = n3.x * h2, s4 = n3.y * h2, a3 = i3 && h2 > 1 ? this._map(n3, true) : null;
              const f2 = (o3 << 5) + (t2 + 1) + this.points.length;
              for (const r3 of u2) {
                const o4 = l2.points[r3];
                if (o4.zoom <= t2)
                  continue;
                o4.zoom = t2;
                const u3 = o4.numPoints || 1;
                e3 += o4.x * u3, s4 += o4.y * u3, o4.parentId = f2, i3 && (a3 || (a3 = this._map(n3, true)), i3(a3, this._map(o4)));
              }
              n3.parentId = f2, r2.push(G(e3 / c2, s4 / c2, f2, c2, a3));
            } else if (r2.push(n3), c2 > 1)
              for (const e3 of u2) {
                const o4 = l2.points[e3];
                o4.zoom <= t2 || (o4.zoom = t2, r2.push(o4));
              }
          }
          return r2;
        }
        _getOriginId(e2) {
          return e2 - this.points.length >> 5;
        }
        _getOriginZoom(e2) {
          return (e2 - this.points.length) % 32;
        }
        _map(e2, t2) {
          if (e2.numPoints)
            return t2 ? D3({}, e2.properties) : e2.properties;
          const r2 = this.points[e2.index].properties, o2 = this.options.map(r2);
          return t2 && o2 === r2 ? D3({}, o2) : o2;
        }
      }
      function G(e2, t2, r2, o2, n2) {
        return { x: N(e2), y: N(t2), zoom: 1 / 0, id: r2, parentId: -1, numPoints: o2, properties: n2 };
      }
      function J(e2, t2) {
        const [r2, o2] = e2.geometry.coordinates;
        return { x: N(X2(r2)), y: N(V(o2)), zoom: 1 / 0, index: t2, parentId: -1 };
      }
      function W(e2) {
        return { type: "Feature", id: e2.id, properties: Y2(e2), geometry: { type: "Point", coordinates: [(t2 = e2.x, 360 * (t2 - 0.5)), A2(e2.y)] } };
        var t2;
      }
      function Y2(e2) {
        const t2 = e2.numPoints, r2 = t2 >= 1e4 ? `${Math.round(t2 / 1e3)}k` : t2 >= 1e3 ? Math.round(t2 / 100) / 10 + "k" : t2;
        return D3(D3({}, e2.properties), { cluster: true, cluster_id: e2.id, point_count: t2, point_count_abbreviated: r2 });
      }
      function X2(e2) {
        return e2 / 360 + 0.5;
      }
      function V(e2) {
        const t2 = Math.sin(e2 * Math.PI / 180), r2 = 0.5 - 0.25 * Math.log((1 + t2) / (1 - t2)) / Math.PI;
        return r2 < 0 ? 0 : r2 > 1 ? 1 : r2;
      }
      function A2(e2) {
        const t2 = (180 - 360 * e2) * Math.PI / 180;
        return 360 * Math.atan(Math.exp(t2)) / Math.PI - 90;
      }
      function D3(e2, t2) {
        for (const r2 in t2)
          e2[r2] = t2[r2];
        return e2;
      }
      function $(e2) {
        return e2.x;
      }
      function B2(e2) {
        return e2.y;
      }
      function R5(e2, t2, r2, o2) {
        for (var n2, i3 = o2, s3 = r2 - t2 >> 1, a2 = r2 - t2, l2 = e2[t2], u2 = e2[t2 + 1], h2 = e2[r2], c2 = e2[r2 + 1], f2 = t2 + 3; f2 < r2; f2 += 3) {
          var p2 = q(e2[f2], e2[f2 + 1], l2, u2, h2, c2);
          if (p2 > i3)
            n2 = f2, i3 = p2;
          else if (p2 === i3) {
            var g2 = Math.abs(f2 - s3);
            g2 < a2 && (n2 = f2, a2 = g2);
          }
        }
        i3 > o2 && (n2 - t2 > 3 && R5(e2, t2, n2, o2), e2[n2 + 2] = i3, r2 - n2 > 3 && R5(e2, n2, r2, o2));
      }
      function q(e2, t2, r2, o2, n2, i3) {
        var s3 = n2 - r2, a2 = i3 - o2;
        if (s3 !== 0 || a2 !== 0) {
          var l2 = ((e2 - r2) * s3 + (t2 - o2) * a2) / (s3 * s3 + a2 * a2);
          l2 > 1 ? (r2 = n2, o2 = i3) : l2 > 0 && (r2 += s3 * l2, o2 += a2 * l2);
        }
        return (s3 = e2 - r2) * s3 + (a2 = t2 - o2) * a2;
      }
      function U(e2, t2, r2, o2) {
        var n2 = { id: e2 === void 0 ? null : e2, type: t2, geometry: r2, tags: o2, minX: 1 / 0, minY: 1 / 0, maxX: -1 / 0, maxY: -1 / 0 };
        return function(e3) {
          var t3 = e3.geometry, r3 = e3.type;
          if (r3 === "Point" || r3 === "MultiPoint" || r3 === "LineString")
            Q(e3, t3);
          else if (r3 === "Polygon" || r3 === "MultiLineString")
            for (var o3 = 0; o3 < t3.length; o3++)
              Q(e3, t3[o3]);
          else if (r3 === "MultiPolygon")
            for (o3 = 0; o3 < t3.length; o3++)
              for (var n3 = 0; n3 < t3[o3].length; n3++)
                Q(e3, t3[o3][n3]);
        }(n2), n2;
      }
      function Q(e2, t2) {
        for (var r2 = 0; r2 < t2.length; r2 += 3)
          e2.minX = Math.min(e2.minX, t2[r2]), e2.minY = Math.min(e2.minY, t2[r2 + 1]), e2.maxX = Math.max(e2.maxX, t2[r2]), e2.maxY = Math.max(e2.maxY, t2[r2 + 1]);
      }
      function H(e2, t2, r2, o2) {
        if (t2.geometry) {
          var n2 = t2.geometry.coordinates, i3 = t2.geometry.type, s3 = Math.pow(r2.tolerance / ((1 << r2.maxZoom) * r2.extent), 2), a2 = [], l2 = t2.id;
          if (r2.promoteId ? l2 = t2.properties[r2.promoteId] : r2.generateId && (l2 = o2 || 0), i3 === "Point")
            K(n2, a2);
          else if (i3 === "MultiPoint")
            for (var u2 = 0; u2 < n2.length; u2++)
              K(n2[u2], a2);
          else if (i3 === "LineString")
            ee(n2, a2, s3, false);
          else if (i3 === "MultiLineString") {
            if (r2.lineMetrics) {
              for (u2 = 0; u2 < n2.length; u2++)
                ee(n2[u2], a2 = [], s3, false), e2.push(U(l2, "LineString", a2, t2.properties));
              return;
            }
            te(n2, a2, s3, false);
          } else if (i3 === "Polygon")
            te(n2, a2, s3, true);
          else {
            if (i3 !== "MultiPolygon") {
              if (i3 === "GeometryCollection") {
                for (u2 = 0; u2 < t2.geometry.geometries.length; u2++)
                  H(e2, { id: l2, geometry: t2.geometry.geometries[u2], properties: t2.properties }, r2, o2);
                return;
              }
              throw new Error("Input data is not a valid GeoJSON object.");
            }
            for (u2 = 0; u2 < n2.length; u2++) {
              var h2 = [];
              te(n2[u2], h2, s3, true), a2.push(h2);
            }
          }
          e2.push(U(l2, i3, a2, t2.properties));
        }
      }
      function K(e2, t2) {
        t2.push(re(e2[0])), t2.push(oe(e2[1])), t2.push(0);
      }
      function ee(e2, t2, r2, o2) {
        for (var n2, i3, s3 = 0, a2 = 0; a2 < e2.length; a2++) {
          var l2 = re(e2[a2][0]), u2 = oe(e2[a2][1]);
          t2.push(l2), t2.push(u2), t2.push(0), a2 > 0 && (s3 += o2 ? (n2 * u2 - l2 * i3) / 2 : Math.sqrt(Math.pow(l2 - n2, 2) + Math.pow(u2 - i3, 2))), n2 = l2, i3 = u2;
        }
        var h2 = t2.length - 3;
        t2[2] = 1, R5(t2, 0, h2, r2), t2[h2 + 2] = 1, t2.size = Math.abs(s3), t2.start = 0, t2.end = t2.size;
      }
      function te(e2, t2, r2, o2) {
        for (var n2 = 0; n2 < e2.length; n2++) {
          var i3 = [];
          ee(e2[n2], i3, r2, o2), t2.push(i3);
        }
      }
      function re(e2) {
        return e2 / 360 + 0.5;
      }
      function oe(e2) {
        var t2 = Math.sin(e2 * Math.PI / 180), r2 = 0.5 - 0.25 * Math.log((1 + t2) / (1 - t2)) / Math.PI;
        return r2 < 0 ? 0 : r2 > 1 ? 1 : r2;
      }
      function ne(e2, t2, r2, o2, n2, i3, s3, a2) {
        if (o2 /= t2, i3 >= (r2 /= t2) && s3 < o2)
          return e2;
        if (s3 < r2 || i3 >= o2)
          return null;
        for (var l2 = [], u2 = 0; u2 < e2.length; u2++) {
          var h2 = e2[u2], c2 = h2.geometry, f2 = h2.type, p2 = n2 === 0 ? h2.minX : h2.minY, g2 = n2 === 0 ? h2.maxX : h2.maxY;
          if (p2 >= r2 && g2 < o2)
            l2.push(h2);
          else if (!(g2 < r2 || p2 >= o2)) {
            var d2 = [];
            if (f2 === "Point" || f2 === "MultiPoint")
              ie2(c2, d2, r2, o2, n2);
            else if (f2 === "LineString")
              se(c2, d2, r2, o2, n2, false, a2.lineMetrics);
            else if (f2 === "MultiLineString")
              le(c2, d2, r2, o2, n2, false);
            else if (f2 === "Polygon")
              le(c2, d2, r2, o2, n2, true);
            else if (f2 === "MultiPolygon")
              for (var m2 = 0; m2 < c2.length; m2++) {
                var y2 = [];
                le(c2[m2], y2, r2, o2, n2, true), y2.length && d2.push(y2);
              }
            if (d2.length) {
              if (a2.lineMetrics && f2 === "LineString") {
                for (m2 = 0; m2 < d2.length; m2++)
                  l2.push(U(h2.id, f2, d2[m2], h2.tags));
                continue;
              }
              f2 !== "LineString" && f2 !== "MultiLineString" || (d2.length === 1 ? (f2 = "LineString", d2 = d2[0]) : f2 = "MultiLineString"), f2 !== "Point" && f2 !== "MultiPoint" || (f2 = d2.length === 3 ? "Point" : "MultiPoint"), l2.push(U(h2.id, f2, d2, h2.tags));
            }
          }
        }
        return l2.length ? l2 : null;
      }
      function ie2(e2, t2, r2, o2, n2) {
        for (var i3 = 0; i3 < e2.length; i3 += 3) {
          var s3 = e2[i3 + n2];
          s3 >= r2 && s3 <= o2 && (t2.push(e2[i3]), t2.push(e2[i3 + 1]), t2.push(e2[i3 + 2]));
        }
      }
      function se(e2, t2, r2, o2, n2, i3, s3) {
        for (var a2, l2, u2 = ae(e2), h2 = n2 === 0 ? he : ce, c2 = e2.start, f2 = 0; f2 < e2.length - 3; f2 += 3) {
          var p2 = e2[f2], g2 = e2[f2 + 1], d2 = e2[f2 + 2], m2 = e2[f2 + 3], y2 = e2[f2 + 4], v3 = n2 === 0 ? p2 : g2, x3 = n2 === 0 ? m2 : y2, w2 = false;
          s3 && (a2 = Math.sqrt(Math.pow(p2 - m2, 2) + Math.pow(g2 - y2, 2))), v3 < r2 ? x3 > r2 && (l2 = h2(u2, p2, g2, m2, y2, r2), s3 && (u2.start = c2 + a2 * l2)) : v3 > o2 ? x3 < o2 && (l2 = h2(u2, p2, g2, m2, y2, o2), s3 && (u2.start = c2 + a2 * l2)) : ue(u2, p2, g2, d2), x3 < r2 && v3 >= r2 && (l2 = h2(u2, p2, g2, m2, y2, r2), w2 = true), x3 > o2 && v3 <= o2 && (l2 = h2(u2, p2, g2, m2, y2, o2), w2 = true), !i3 && w2 && (s3 && (u2.end = c2 + a2 * l2), t2.push(u2), u2 = ae(e2)), s3 && (c2 += a2);
        }
        var S3 = e2.length - 3;
        p2 = e2[S3], g2 = e2[S3 + 1], d2 = e2[S3 + 2], (v3 = n2 === 0 ? p2 : g2) >= r2 && v3 <= o2 && ue(u2, p2, g2, d2), S3 = u2.length - 3, i3 && S3 >= 3 && (u2[S3] !== u2[0] || u2[S3 + 1] !== u2[1]) && ue(u2, u2[0], u2[1], u2[2]), u2.length && t2.push(u2);
      }
      function ae(e2) {
        var t2 = [];
        return t2.size = e2.size, t2.start = e2.start, t2.end = e2.end, t2;
      }
      function le(e2, t2, r2, o2, n2, i3) {
        for (var s3 = 0; s3 < e2.length; s3++)
          se(e2[s3], t2, r2, o2, n2, i3, false);
      }
      function ue(e2, t2, r2, o2) {
        e2.push(t2), e2.push(r2), e2.push(o2);
      }
      function he(e2, t2, r2, o2, n2, i3) {
        var s3 = (i3 - t2) / (o2 - t2);
        return e2.push(i3), e2.push(r2 + (n2 - r2) * s3), e2.push(1), s3;
      }
      function ce(e2, t2, r2, o2, n2, i3) {
        var s3 = (i3 - r2) / (n2 - r2);
        return e2.push(t2 + (o2 - t2) * s3), e2.push(i3), e2.push(1), s3;
      }
      function fe(e2, t2) {
        for (var r2 = [], o2 = 0; o2 < e2.length; o2++) {
          var n2, i3 = e2[o2], s3 = i3.type;
          if (s3 === "Point" || s3 === "MultiPoint" || s3 === "LineString")
            n2 = pe(i3.geometry, t2);
          else if (s3 === "MultiLineString" || s3 === "Polygon") {
            n2 = [];
            for (var a2 = 0; a2 < i3.geometry.length; a2++)
              n2.push(pe(i3.geometry[a2], t2));
          } else if (s3 === "MultiPolygon")
            for (n2 = [], a2 = 0; a2 < i3.geometry.length; a2++) {
              for (var l2 = [], u2 = 0; u2 < i3.geometry[a2].length; u2++)
                l2.push(pe(i3.geometry[a2][u2], t2));
              n2.push(l2);
            }
          r2.push(U(i3.id, s3, n2, i3.tags));
        }
        return r2;
      }
      function pe(e2, t2) {
        var r2 = [];
        r2.size = e2.size, e2.start !== void 0 && (r2.start = e2.start, r2.end = e2.end);
        for (var o2 = 0; o2 < e2.length; o2 += 3)
          r2.push(e2[o2] + t2, e2[o2 + 1], e2[o2 + 2]);
        return r2;
      }
      function ge(e2, t2) {
        if (e2.transformed)
          return e2;
        var r2, o2, n2, i3 = 1 << e2.z, s3 = e2.x, a2 = e2.y;
        for (r2 = 0; r2 < e2.features.length; r2++) {
          var l2 = e2.features[r2], u2 = l2.geometry, h2 = l2.type;
          if (l2.geometry = [], h2 === 1)
            for (o2 = 0; o2 < u2.length; o2 += 2)
              l2.geometry.push(de(u2[o2], u2[o2 + 1], t2, i3, s3, a2));
          else
            for (o2 = 0; o2 < u2.length; o2++) {
              var c2 = [];
              for (n2 = 0; n2 < u2[o2].length; n2 += 2)
                c2.push(de(u2[o2][n2], u2[o2][n2 + 1], t2, i3, s3, a2));
              l2.geometry.push(c2);
            }
        }
        return e2.transformed = true, e2;
      }
      function de(e2, t2, r2, o2, n2, i3) {
        return [Math.round(r2 * (e2 * o2 - n2)), Math.round(r2 * (t2 * o2 - i3))];
      }
      function me(e2, t2, r2, o2, n2) {
        for (var i3 = t2 === n2.maxZoom ? 0 : n2.tolerance / ((1 << t2) * n2.extent), s3 = { features: [], numPoints: 0, numSimplified: 0, numFeatures: 0, source: null, x: r2, y: o2, z: t2, transformed: false, minX: 2, minY: 1, maxX: -1, maxY: 0 }, a2 = 0; a2 < e2.length; a2++) {
          s3.numFeatures++, ye(s3, e2[a2], i3, n2);
          var l2 = e2[a2].minX, u2 = e2[a2].minY, h2 = e2[a2].maxX, c2 = e2[a2].maxY;
          l2 < s3.minX && (s3.minX = l2), u2 < s3.minY && (s3.minY = u2), h2 > s3.maxX && (s3.maxX = h2), c2 > s3.maxY && (s3.maxY = c2);
        }
        return s3;
      }
      function ye(e2, t2, r2, o2) {
        var n2 = t2.geometry, i3 = t2.type, s3 = [];
        if (i3 === "Point" || i3 === "MultiPoint")
          for (var a2 = 0; a2 < n2.length; a2 += 3)
            s3.push(n2[a2]), s3.push(n2[a2 + 1]), e2.numPoints++, e2.numSimplified++;
        else if (i3 === "LineString")
          ve(s3, n2, e2, r2, false, false);
        else if (i3 === "MultiLineString" || i3 === "Polygon")
          for (a2 = 0; a2 < n2.length; a2++)
            ve(s3, n2[a2], e2, r2, i3 === "Polygon", a2 === 0);
        else if (i3 === "MultiPolygon")
          for (var l2 = 0; l2 < n2.length; l2++) {
            var u2 = n2[l2];
            for (a2 = 0; a2 < u2.length; a2++)
              ve(s3, u2[a2], e2, r2, true, a2 === 0);
          }
        if (s3.length) {
          var h2 = t2.tags || null;
          if (i3 === "LineString" && o2.lineMetrics) {
            for (var c2 in h2 = {}, t2.tags)
              h2[c2] = t2.tags[c2];
            h2.mapbox_clip_start = n2.start / n2.size, h2.mapbox_clip_end = n2.end / n2.size;
          }
          var f2 = { geometry: s3, type: i3 === "Polygon" || i3 === "MultiPolygon" ? 3 : i3 === "LineString" || i3 === "MultiLineString" ? 2 : 1, tags: h2 };
          t2.id !== null && (f2.id = t2.id), e2.features.push(f2);
        }
      }
      function ve(e2, t2, r2, o2, n2, i3) {
        var s3 = o2 * o2;
        if (o2 > 0 && t2.size < (n2 ? s3 : o2))
          r2.numPoints += t2.length / 3;
        else {
          for (var a2 = [], l2 = 0; l2 < t2.length; l2 += 3)
            (o2 === 0 || t2[l2 + 2] > s3) && (r2.numSimplified++, a2.push(t2[l2]), a2.push(t2[l2 + 1])), r2.numPoints++;
          n2 && function(e3, t3) {
            for (var r3 = 0, o3 = 0, n3 = e3.length, i4 = n3 - 2; o3 < n3; i4 = o3, o3 += 2)
              r3 += (e3[o3] - e3[i4]) * (e3[o3 + 1] + e3[i4 + 1]);
            if (r3 > 0 === t3)
              for (o3 = 0, n3 = e3.length; o3 < n3 / 2; o3 += 2) {
                var s4 = e3[o3], a3 = e3[o3 + 1];
                e3[o3] = e3[n3 - 2 - o3], e3[o3 + 1] = e3[n3 - 1 - o3], e3[n3 - 2 - o3] = s4, e3[n3 - 1 - o3] = a3;
              }
          }(a2, i3), e2.push(a2);
        }
      }
      function xe(e2, t2) {
        var r2 = (t2 = this.options = function(e3, t3) {
          for (var r3 in t3)
            e3[r3] = t3[r3];
          return e3;
        }(Object.create(this.options), t2)).debug;
        if (r2 && console.time("preprocess data"), t2.maxZoom < 0 || t2.maxZoom > 24)
          throw new Error("maxZoom should be in the 0-24 range");
        if (t2.promoteId && t2.generateId)
          throw new Error("promoteId and generateId cannot be used together.");
        var o2 = function(e3, t3) {
          var r3 = [];
          if (e3.type === "FeatureCollection")
            for (var o3 = 0; o3 < e3.features.length; o3++)
              H(r3, e3.features[o3], t3, o3);
          else
            H(r3, e3.type === "Feature" ? e3 : { geometry: e3 }, t3);
          return r3;
        }(e2, t2);
        this.tiles = {}, this.tileCoords = [], r2 && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t2.indexMaxZoom, t2.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), (o2 = function(e3, t3) {
          var r3 = t3.buffer / t3.extent, o3 = e3, n2 = ne(e3, 1, -1 - r3, r3, 0, -1, 2, t3), i3 = ne(e3, 1, 1 - r3, 2 + r3, 0, -1, 2, t3);
          return (n2 || i3) && (o3 = ne(e3, 1, -r3, 1 + r3, 0, -1, 2, t3) || [], n2 && (o3 = fe(n2, 1).concat(o3)), i3 && (o3 = o3.concat(fe(i3, -1)))), o3;
        }(o2, t2)).length && this.splitTile(o2, 0, 0, 0), r2 && (o2.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
      }
      function we(e2, t2, r2) {
        return 32 * ((1 << e2) * r2 + t2) + e2;
      }
      function Se(e2, t2) {
        const r2 = e2.tileID.canonical;
        if (!this._geoJSONIndex)
          return t2(null, null);
        const o2 = this._geoJSONIndex.getTile(r2.z, r2.x, r2.y);
        if (!o2)
          return t2(null, null);
        const n2 = new c(o2.features);
        let i3 = m(n2);
        i3.byteOffset === 0 && i3.byteLength === i3.buffer.byteLength || (i3 = new Uint8Array(i3)), t2(null, { vectorTile: n2, rawData: i3.buffer });
      }
      xe.prototype.options = { maxZoom: 14, indexMaxZoom: 5, indexMaxPoints: 1e5, tolerance: 3, extent: 4096, buffer: 64, lineMetrics: false, promoteId: null, generateId: false, debug: 0 }, xe.prototype.splitTile = function(e2, t2, r2, o2, n2, i3, s3) {
        for (var a2 = [e2, t2, r2, o2], l2 = this.options, u2 = l2.debug; a2.length; ) {
          o2 = a2.pop(), r2 = a2.pop(), t2 = a2.pop(), e2 = a2.pop();
          var h2 = 1 << t2, c2 = we(t2, r2, o2), f2 = this.tiles[c2];
          if (!f2 && (u2 > 1 && console.time("creation"), f2 = this.tiles[c2] = me(e2, t2, r2, o2, l2), this.tileCoords.push({ z: t2, x: r2, y: o2 }), u2)) {
            u2 > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t2, r2, o2, f2.numFeatures, f2.numPoints, f2.numSimplified), console.timeEnd("creation"));
            var p2 = "z" + t2;
            this.stats[p2] = (this.stats[p2] || 0) + 1, this.total++;
          }
          if (f2.source = e2, n2) {
            if (t2 === l2.maxZoom || t2 === n2)
              continue;
            var g2 = 1 << n2 - t2;
            if (r2 !== Math.floor(i3 / g2) || o2 !== Math.floor(s3 / g2))
              continue;
          } else if (t2 === l2.indexMaxZoom || f2.numPoints <= l2.indexMaxPoints)
            continue;
          if (f2.source = null, e2.length !== 0) {
            u2 > 1 && console.time("clipping");
            var d2, m2, y2, v3, x3, w2, S3 = 0.5 * l2.buffer / l2.extent, M3 = 0.5 - S3, P2 = 0.5 + S3, b2 = 1 + S3;
            d2 = m2 = y2 = v3 = null, x3 = ne(e2, h2, r2 - S3, r2 + P2, 0, f2.minX, f2.maxX, l2), w2 = ne(e2, h2, r2 + M3, r2 + b2, 0, f2.minX, f2.maxX, l2), e2 = null, x3 && (d2 = ne(x3, h2, o2 - S3, o2 + P2, 1, f2.minY, f2.maxY, l2), m2 = ne(x3, h2, o2 + M3, o2 + b2, 1, f2.minY, f2.maxY, l2), x3 = null), w2 && (y2 = ne(w2, h2, o2 - S3, o2 + P2, 1, f2.minY, f2.maxY, l2), v3 = ne(w2, h2, o2 + M3, o2 + b2, 1, f2.minY, f2.maxY, l2), w2 = null), u2 > 1 && console.timeEnd("clipping"), a2.push(d2 || [], t2 + 1, 2 * r2, 2 * o2), a2.push(m2 || [], t2 + 1, 2 * r2, 2 * o2 + 1), a2.push(y2 || [], t2 + 1, 2 * r2 + 1, 2 * o2), a2.push(v3 || [], t2 + 1, 2 * r2 + 1, 2 * o2 + 1);
          }
        }
      }, xe.prototype.getTile = function(e2, t2, r2) {
        var o2 = this.options, n2 = o2.extent, i3 = o2.debug;
        if (e2 < 0 || e2 > 24)
          return null;
        var s3 = 1 << e2, a2 = we(e2, t2 = (t2 % s3 + s3) % s3, r2);
        if (this.tiles[a2])
          return ge(this.tiles[a2], n2);
        i3 > 1 && console.log("drilling down to z%d-%d-%d", e2, t2, r2);
        for (var l2, u2 = e2, h2 = t2, c2 = r2; !l2 && u2 > 0; )
          u2--, h2 = Math.floor(h2 / 2), c2 = Math.floor(c2 / 2), l2 = this.tiles[we(u2, h2, c2)];
        return l2 && l2.source ? (i3 > 1 && console.log("found parent tile z%d-%d-%d", u2, h2, c2), i3 > 1 && console.time("drilling down"), this.splitTile(l2.source, u2, h2, c2, e2, t2, r2), i3 > 1 && console.timeEnd("drilling down"), this.tiles[a2] ? ge(this.tiles[a2], n2) : null) : null;
      };
      class Me extends e.VectorTileWorkerSource {
        constructor(e2, t2, r2, o2, n2) {
          super(e2, t2, r2, o2, Se), n2 && (this.loadGeoJSON = n2);
        }
        loadData(t2, r2) {
          const o2 = t2 && t2.request, n2 = o2 && o2.collectResourceTiming;
          this.loadGeoJSON(t2, (i3, a2) => {
            if (i3 || !a2)
              return r2(i3);
            if (typeof a2 != "object")
              return r2(new Error(`Input data given to '${t2.source}' is not a valid GeoJSON object.`));
            {
              s2(a2, true);
              try {
                if (t2.filter) {
                  const r3 = e.createExpression(t2.filter, { type: "boolean", "property-type": "data-driven", overridable: false, transition: false });
                  if (r3.result === "error")
                    throw new Error(r3.value.map((e2) => `${e2.key}: ${e2.message}`).join(", "));
                  const o3 = a2.features.filter((e2) => r3.value.evaluate({ zoom: 0 }, e2));
                  a2 = { type: "FeatureCollection", features: o3 };
                }
                this._geoJSONIndex = t2.cluster ? new Z2(function({ superclusterOptions: t3, clusterProperties: r3 }) {
                  if (!r3 || !t3)
                    return t3;
                  const o3 = {}, n3 = {}, i4 = { accumulated: null, zoom: 0 }, s3 = { properties: null }, a3 = Object.keys(r3);
                  for (const t4 of a3) {
                    const [i5, s4] = r3[t4], a4 = e.createExpression(s4), l3 = e.createExpression(typeof i5 == "string" ? [i5, ["accumulated"], ["get", t4]] : i5);
                    o3[t4] = a4.value, n3[t4] = l3.value;
                  }
                  return t3.map = (e2) => {
                    s3.properties = e2;
                    const t4 = {};
                    for (const e3 of a3)
                      t4[e3] = o3[e3].evaluate(i4, s3);
                    return t4;
                  }, t3.reduce = (e2, t4) => {
                    s3.properties = t4;
                    for (const t5 of a3)
                      i4.accumulated = e2[t5], e2[t5] = n3[t5].evaluate(i4, s3);
                  }, t3;
                }(t2)).load(a2.features) : function(e2, t3) {
                  return new xe(e2, t3);
                }(a2, t2.geojsonVtOptions);
              } catch (i4) {
                return r2(i4);
              }
              this.loaded = {};
              const l2 = {};
              if (n2) {
                const r3 = e.getPerformanceMeasurement(o2);
                r3 && (l2.resourceTiming = {}, l2.resourceTiming[t2.source] = JSON.parse(JSON.stringify(r3)));
              }
              r2(null, l2);
            }
          });
        }
        reloadTile(e2, t2) {
          const r2 = this.loaded;
          return r2 && r2[e2.uid] ? super.reloadTile(e2, t2) : this.loadTile(e2, t2);
        }
        loadGeoJSON(t2, r2) {
          if (t2.request)
            e.getJSON(t2.request, r2);
          else {
            if (typeof t2.data != "string")
              return r2(new Error(`Input data given to '${t2.source}' is not a valid GeoJSON object.`));
            try {
              return r2(null, JSON.parse(t2.data));
            } catch (e2) {
              return r2(new Error(`Input data given to '${t2.source}' is not a valid GeoJSON object.`));
            }
          }
        }
        getClusterExpansionZoom(e2, t2) {
          try {
            t2(null, this._geoJSONIndex.getClusterExpansionZoom(e2.clusterId));
          } catch (e3) {
            t2(e3);
          }
        }
        getClusterChildren(e2, t2) {
          try {
            t2(null, this._geoJSONIndex.getChildren(e2.clusterId));
          } catch (e3) {
            t2(e3);
          }
        }
        getClusterLeaves(e2, t2) {
          try {
            t2(null, this._geoJSONIndex.getLeaves(e2.clusterId, e2.limit, e2.offset));
          } catch (e3) {
            t2(e3);
          }
        }
      }
      class Pe {
        constructor(t2) {
          this.self = t2, this.actor = new e.Actor(t2, this), this.layerIndexes = {}, this.availableImages = {}, this.isSpriteLoaded = {}, this.projections = {}, this.defaultProjection = e.getProjection({ name: "mercator" }), this.workerSourceTypes = { vector: e.VectorTileWorkerSource, geojson: Me }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = (e2, t3) => {
            if (this.workerSourceTypes[e2])
              throw new Error(`Worker source with name "${e2}" already registered.`);
            this.workerSourceTypes[e2] = t3;
          }, this.self.registerRTLTextPlugin = (t3) => {
            if (e.plugin.isParsed())
              throw new Error("RTL text plugin already registered.");
            e.plugin.applyArabicShaping = t3.applyArabicShaping, e.plugin.processBidirectionalText = t3.processBidirectionalText, e.plugin.processStyledBidirectionalText = t3.processStyledBidirectionalText;
          };
        }
        clearCaches(e2, t2, r2) {
          delete this.layerIndexes[e2], delete this.availableImages[e2], delete this.workerSources[e2], delete this.demWorkerSources[e2], r2();
        }
        checkIfReady(e2, t2, r2) {
          r2();
        }
        setReferrer(e2, t2) {
          this.referrer = t2;
        }
        spriteLoaded(t2, r2) {
          this.isSpriteLoaded[t2] = r2;
          for (const o2 in this.workerSources[t2]) {
            const n2 = this.workerSources[t2][o2];
            for (const t3 in n2)
              n2[t3] instanceof e.VectorTileWorkerSource && (n2[t3].isSpriteLoaded = r2, n2[t3].fire(new e.Event("isSpriteLoaded")));
          }
        }
        setImages(e2, t2, r2) {
          this.availableImages[e2] = t2;
          for (const r3 in this.workerSources[e2]) {
            const o2 = this.workerSources[e2][r3];
            for (const e3 in o2)
              o2[e3].availableImages = t2;
          }
          r2();
        }
        enableTerrain(e2, t2, r2) {
          this.terrain = t2, r2();
        }
        setProjection(t2, r2) {
          this.projections[t2] = e.getProjection(r2);
        }
        setLayers(e2, t2, r2) {
          this.getLayerIndex(e2).replace(t2), r2();
        }
        updateLayers(e2, t2, r2) {
          this.getLayerIndex(e2).update(t2.layers, t2.removedIds), r2();
        }
        loadTile(t2, r2, o2) {
          const n2 = this.enableTerrain ? e.extend({ enableTerrain: this.terrain }, r2) : r2;
          n2.projection = this.projections[t2] || this.defaultProjection, this.getWorkerSource(t2, r2.type, r2.source).loadTile(n2, o2);
        }
        loadDEMTile(t2, r2, o2) {
          const n2 = this.enableTerrain ? e.extend({ buildQuadTree: this.terrain }, r2) : r2;
          this.getDEMWorkerSource(t2, r2.source).loadTile(n2, o2);
        }
        reloadTile(t2, r2, o2) {
          const n2 = this.enableTerrain ? e.extend({ enableTerrain: this.terrain }, r2) : r2;
          n2.projection = this.projections[t2] || this.defaultProjection, this.getWorkerSource(t2, r2.type, r2.source).reloadTile(n2, o2);
        }
        abortTile(e2, t2, r2) {
          this.getWorkerSource(e2, t2.type, t2.source).abortTile(t2, r2);
        }
        removeTile(e2, t2, r2) {
          this.getWorkerSource(e2, t2.type, t2.source).removeTile(t2, r2);
        }
        removeSource(e2, t2, r2) {
          if (!this.workerSources[e2] || !this.workerSources[e2][t2.type] || !this.workerSources[e2][t2.type][t2.source])
            return;
          const o2 = this.workerSources[e2][t2.type][t2.source];
          delete this.workerSources[e2][t2.type][t2.source], o2.removeSource !== void 0 ? o2.removeSource(t2, r2) : r2();
        }
        loadWorkerSource(e2, t2, r2) {
          try {
            this.self.importScripts(t2.url), r2();
          } catch (e3) {
            r2(e3.toString());
          }
        }
        syncRTLPluginState(t2, r2, o2) {
          try {
            e.plugin.setState(r2);
            const t3 = e.plugin.getPluginURL();
            if (e.plugin.isLoaded() && !e.plugin.isParsed() && t3 != null) {
              this.self.importScripts(t3);
              const r3 = e.plugin.isParsed();
              o2(r3 ? void 0 : new Error(`RTL Text Plugin failed to import scripts from ${t3}`), r3);
            }
          } catch (e2) {
            o2(e2.toString());
          }
        }
        getAvailableImages(e2) {
          let t2 = this.availableImages[e2];
          return t2 || (t2 = []), t2;
        }
        getLayerIndex(e2) {
          let t2 = this.layerIndexes[e2];
          return t2 || (t2 = this.layerIndexes[e2] = new o()), t2;
        }
        getWorkerSource(e2, t2, r2) {
          return this.workerSources[e2] || (this.workerSources[e2] = {}), this.workerSources[e2][t2] || (this.workerSources[e2][t2] = {}), this.workerSources[e2][t2][r2] || (this.workerSources[e2][t2][r2] = new this.workerSourceTypes[t2]({ send: (t3, r3, o2, n2, i3, s3) => {
            this.actor.send(t3, r3, o2, e2, i3, s3);
          }, scheduler: this.actor.scheduler }, this.getLayerIndex(e2), this.getAvailableImages(e2), this.isSpriteLoaded[e2])), this.workerSources[e2][t2][r2];
        }
        getDEMWorkerSource(e2, t2) {
          return this.demWorkerSources[e2] || (this.demWorkerSources[e2] = {}), this.demWorkerSources[e2][t2] || (this.demWorkerSources[e2][t2] = new i2()), this.demWorkerSources[e2][t2];
        }
        enforceCacheSizeLimit(t2, r2) {
          e.enforceCacheSizeLimit(r2);
        }
        getWorkerPerformanceMetrics(e2, t2, r2) {
          r2(void 0, void 0);
        }
      }
      return typeof WorkerGlobalScope != "undefined" && typeof self != "undefined" && self instanceof WorkerGlobalScope && (self.worker = new Pe(self)), Pe;
    });
    define(["./shared"], function(e) {
      var t = i2;
      function i2(e2) {
        return !function(e3) {
          return typeof window == "undefined" || typeof document == "undefined" ? "not a browser" : Array.prototype && Array.prototype.every && Array.prototype.filter && Array.prototype.forEach && Array.prototype.indexOf && Array.prototype.lastIndexOf && Array.prototype.map && Array.prototype.some && Array.prototype.reduce && Array.prototype.reduceRight && Array.isArray ? Function.prototype && Function.prototype.bind ? Object.keys && Object.create && Object.getPrototypeOf && Object.getOwnPropertyNames && Object.isSealed && Object.isFrozen && Object.isExtensible && Object.getOwnPropertyDescriptor && Object.defineProperty && Object.defineProperties && Object.seal && Object.freeze && Object.preventExtensions ? "JSON" in window && "parse" in JSON && "stringify" in JSON ? function() {
            if (!("Worker" in window && "Blob" in window && "URL" in window))
              return false;
            var e4, t3, i3 = new Blob([""], { type: "text/javascript" }), o2 = URL.createObjectURL(i3);
            try {
              t3 = new Worker(o2), e4 = true;
            } catch (t4) {
              e4 = false;
            }
            return t3 && t3.terminate(), URL.revokeObjectURL(o2), e4;
          }() ? "Uint8ClampedArray" in window ? ArrayBuffer.isView ? function() {
            var e4 = document.createElement("canvas");
            e4.width = e4.height = 1;
            var t3 = e4.getContext("2d");
            if (!t3)
              return false;
            var i3 = t3.getImageData(0, 0, 1, 1);
            return i3 && i3.width === e4.width;
          }() ? (o[t2 = e3 && e3.failIfMajorPerformanceCaveat] === void 0 && (o[t2] = function(e4) {
            var t3, o2 = function(e5) {
              var t4 = document.createElement("canvas"), o3 = Object.create(i2.webGLContextAttributes);
              return o3.failIfMajorPerformanceCaveat = e5, t4.getContext("webgl", o3) || t4.getContext("experimental-webgl", o3);
            }(e4);
            if (!o2)
              return false;
            try {
              t3 = o2.createShader(o2.VERTEX_SHADER);
            } catch (e5) {
              return false;
            }
            return !(!t3 || o2.isContextLost()) && (o2.shaderSource(t3, "void main() {}"), o2.compileShader(t3), o2.getShaderParameter(t3, o2.COMPILE_STATUS) === true);
          }(t2)), o[t2] ? document.documentMode ? "insufficient ECMAScript 6 support" : void 0 : "insufficient WebGL support") : "insufficient Canvas/getImageData support" : "insufficient ArrayBuffer support" : "insufficient Uint8ClampedArray support" : "insufficient worker support" : "insufficient JSON support" : "insufficient Object support" : "insufficient Function support" : "insufficent Array support";
          var t2;
        }(e2);
      }
      var o = {};
      function r(e2, t2) {
        var i3 = t2[0], o2 = t2[1], r2 = t2[2], n2 = t2[3], a2 = i3 * n2 - r2 * o2;
        return a2 ? (e2[0] = n2 * (a2 = 1 / a2), e2[1] = -o2 * a2, e2[2] = -r2 * a2, e2[3] = i3 * a2, e2) : null;
      }
      function n(e2, t2) {
        if (Array.isArray(e2)) {
          if (!Array.isArray(t2) || e2.length !== t2.length)
            return false;
          for (let i3 = 0; i3 < e2.length; i3++)
            if (!n(e2[i3], t2[i3]))
              return false;
          return true;
        }
        if (typeof e2 == "object" && e2 !== null && t2 !== null) {
          if (typeof t2 != "object")
            return false;
          if (Object.keys(e2).length !== Object.keys(t2).length)
            return false;
          for (const i3 in e2)
            if (!n(e2[i3], t2[i3]))
              return false;
          return true;
        }
        return e2 === t2;
      }
      i2.webGLContextAttributes = { antialias: false, alpha: true, stencil: true, depth: true };
      const a = { create: function(t2, i3, o2) {
        const r2 = e.window.document.createElement(t2);
        return i3 !== void 0 && (r2.className = i3), o2 && o2.appendChild(r2), r2;
      }, createSVG: function(t2, i3, o2) {
        const r2 = e.window.document.createElementNS("http://www.w3.org/2000/svg", t2);
        for (const e2 of Object.keys(i3))
          r2.setAttributeNS(null, e2, i3[e2]);
        return o2 && o2.appendChild(r2), r2;
      } }, s2 = e.window.document && e.window.document.documentElement.style, l = s2 && s2.userSelect !== void 0 ? "userSelect" : "WebkitUserSelect";
      let c;
      a.disableDrag = function() {
        s2 && l && (c = s2[l], s2[l] = "none");
      }, a.enableDrag = function() {
        s2 && l && (s2[l] = c);
      };
      const h = function(t2) {
        t2.preventDefault(), t2.stopPropagation(), e.window.removeEventListener("click", h, true);
      };
      function u(t2, i3, o2) {
        const r2 = t2.offsetWidth === i3.width ? 1 : t2.offsetWidth / i3.width;
        return new e.pointGeometry((o2.clientX - i3.left) * r2, (o2.clientY - i3.top) * r2);
      }
      function _(e2) {
        const { userImage: t2 } = e2;
        return !!(t2 && t2.render && t2.render()) && (e2.data.replace(new Uint8Array(t2.data.buffer)), true);
      }
      a.suppressClick = function() {
        e.window.addEventListener("click", h, true), e.window.setTimeout(() => {
          e.window.removeEventListener("click", h, true);
        }, 0);
      }, a.mousePos = function(e2, t2) {
        const i3 = e2.getBoundingClientRect();
        return u(e2, i3, t2);
      }, a.touchPos = function(e2, t2) {
        const i3 = e2.getBoundingClientRect(), o2 = [];
        for (let r2 = 0; r2 < t2.length; r2++)
          o2.push(u(e2, i3, t2[r2]));
        return o2;
      }, a.mouseButton = function(t2) {
        return e.window.InstallTrigger !== void 0 && t2.button === 2 && t2.ctrlKey && e.window.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? 0 : t2.button;
      };
      class d extends e.Evented {
        constructor() {
          super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = false, this.requestors = [], this.patterns = {}, this.atlasImage = new e.RGBAImage({ width: 1, height: 1 }), this.dirty = true;
        }
        isLoaded() {
          return this.loaded;
        }
        setLoaded(e2) {
          if (this.loaded !== e2 && (this.loaded = e2, e2)) {
            for (const { ids: e3, callback: t2 } of this.requestors)
              this._notify(e3, t2);
            this.requestors = [];
          }
        }
        getImage(e2) {
          return this.images[e2];
        }
        addImage(e2, t2) {
          this._validate(e2, t2) && (this.images[e2] = t2);
        }
        _validate(t2, i3) {
          let o2 = true;
          return this._validateStretch(i3.stretchX, i3.data && i3.data.width) || (this.fire(new e.ErrorEvent(new Error(`Image "${t2}" has invalid "stretchX" value`))), o2 = false), this._validateStretch(i3.stretchY, i3.data && i3.data.height) || (this.fire(new e.ErrorEvent(new Error(`Image "${t2}" has invalid "stretchY" value`))), o2 = false), this._validateContent(i3.content, i3) || (this.fire(new e.ErrorEvent(new Error(`Image "${t2}" has invalid "content" value`))), o2 = false), o2;
        }
        _validateStretch(e2, t2) {
          if (!e2)
            return true;
          let i3 = 0;
          for (const o2 of e2) {
            if (o2[0] < i3 || o2[1] < o2[0] || t2 < o2[1])
              return false;
            i3 = o2[1];
          }
          return true;
        }
        _validateContent(e2, t2) {
          return !(e2 && (e2.length !== 4 || e2[0] < 0 || t2.data.width < e2[0] || e2[1] < 0 || t2.data.height < e2[1] || e2[2] < 0 || t2.data.width < e2[2] || e2[3] < 0 || t2.data.height < e2[3] || e2[2] < e2[0] || e2[3] < e2[1]));
        }
        updateImage(e2, t2) {
          t2.version = this.images[e2].version + 1, this.images[e2] = t2, this.updatedImages[e2] = true;
        }
        removeImage(e2) {
          const t2 = this.images[e2];
          delete this.images[e2], delete this.patterns[e2], t2.userImage && t2.userImage.onRemove && t2.userImage.onRemove();
        }
        listImages() {
          return Object.keys(this.images);
        }
        getImages(e2, t2) {
          let i3 = true;
          if (!this.isLoaded())
            for (const t3 of e2)
              this.images[t3] || (i3 = false);
          this.isLoaded() || i3 ? this._notify(e2, t2) : this.requestors.push({ ids: e2, callback: t2 });
        }
        _notify(t2, i3) {
          const o2 = {};
          for (const i4 of t2) {
            this.images[i4] || this.fire(new e.Event("styleimagemissing", { id: i4 }));
            const t3 = this.images[i4];
            t3 ? o2[i4] = { data: t3.data.clone(), pixelRatio: t3.pixelRatio, sdf: t3.sdf, version: t3.version, stretchX: t3.stretchX, stretchY: t3.stretchY, content: t3.content, hasRenderCallback: Boolean(t3.userImage && t3.userImage.render) } : e.warnOnce(`Image "${i4}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
          }
          i3(null, o2);
        }
        getPixelSize() {
          const { width: e2, height: t2 } = this.atlasImage;
          return { width: e2, height: t2 };
        }
        getPattern(t2) {
          const i3 = this.patterns[t2], o2 = this.getImage(t2);
          if (!o2)
            return null;
          if (i3 && i3.position.version === o2.version)
            return i3.position;
          if (i3)
            i3.position.version = o2.version;
          else {
            const i4 = { w: o2.data.width + 2, h: o2.data.height + 2, x: 0, y: 0 }, r2 = new e.ImagePosition(i4, o2);
            this.patterns[t2] = { bin: i4, position: r2 };
          }
          return this._updatePatternAtlas(), this.patterns[t2].position;
        }
        bind(t2) {
          const i3 = t2.gl;
          this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = false) : this.atlasTexture = new e.Texture(t2, this.atlasImage, i3.RGBA), this.atlasTexture.bind(i3.LINEAR, i3.CLAMP_TO_EDGE);
        }
        _updatePatternAtlas() {
          const t2 = [];
          for (const e2 in this.patterns)
            t2.push(this.patterns[e2].bin);
          const { w: i3, h: o2 } = e.potpack(t2), r2 = this.atlasImage;
          r2.resize({ width: i3 || 1, height: o2 || 1 });
          for (const t3 in this.patterns) {
            const { bin: i4 } = this.patterns[t3], o3 = i4.x + 1, n2 = i4.y + 1, a2 = this.images[t3].data, s3 = a2.width, l2 = a2.height;
            e.RGBAImage.copy(a2, r2, { x: 0, y: 0 }, { x: o3, y: n2 }, { width: s3, height: l2 }), e.RGBAImage.copy(a2, r2, { x: 0, y: l2 - 1 }, { x: o3, y: n2 - 1 }, { width: s3, height: 1 }), e.RGBAImage.copy(a2, r2, { x: 0, y: 0 }, { x: o3, y: n2 + l2 }, { width: s3, height: 1 }), e.RGBAImage.copy(a2, r2, { x: s3 - 1, y: 0 }, { x: o3 - 1, y: n2 }, { width: 1, height: l2 }), e.RGBAImage.copy(a2, r2, { x: 0, y: 0 }, { x: o3 + s3, y: n2 }, { width: 1, height: l2 });
          }
          this.dirty = true;
        }
        beginFrame() {
          this.callbackDispatchedThisFrame = {};
        }
        dispatchRenderCallbacks(e2) {
          for (const t2 of e2) {
            if (this.callbackDispatchedThisFrame[t2])
              continue;
            this.callbackDispatchedThisFrame[t2] = true;
            const e3 = this.images[t2];
            _(e3) && this.updateImage(t2, e3);
          }
        }
      }
      const p = new e.Properties({ anchor: new e.DataConstantProperty(e.spec.light.anchor), position: new class {
        constructor() {
          this.specification = e.spec.light.position;
        }
        possiblyEvaluate(t2, i3) {
          return function([t3, i4, o2]) {
            const r2 = e.degToRad(i4 + 90), n2 = e.degToRad(o2);
            return { x: t3 * Math.cos(r2) * Math.sin(n2), y: t3 * Math.sin(r2) * Math.sin(n2), z: t3 * Math.cos(n2), azimuthal: i4, polar: o2 };
          }(t2.expression.evaluate(i3));
        }
        interpolate(t2, i3, o2) {
          return { x: e.number(t2.x, i3.x, o2), y: e.number(t2.y, i3.y, o2), z: e.number(t2.z, i3.z, o2), azimuthal: e.number(t2.azimuthal, i3.azimuthal, o2), polar: e.number(t2.polar, i3.polar, o2) };
        }
      }(), color: new e.DataConstantProperty(e.spec.light.color), intensity: new e.DataConstantProperty(e.spec.light.intensity) }), m = "-transition";
      class f extends e.Evented {
        constructor(t2) {
          super(), this._transitionable = new e.Transitionable(p), this.setLight(t2), this._transitioning = this._transitionable.untransitioned();
        }
        getLight() {
          return this._transitionable.serialize();
        }
        setLight(t2, i3 = {}) {
          if (!this._validate(e.validateLight, t2, i3))
            for (const i4 in t2) {
              const o2 = t2[i4];
              e.endsWith(i4, m) ? this._transitionable.setTransition(i4.slice(0, -m.length), o2) : this._transitionable.setValue(i4, o2);
            }
        }
        updateTransitions(e2) {
          this._transitioning = this._transitionable.transitioned(e2, this._transitioning);
        }
        hasTransition() {
          return this._transitioning.hasTransition();
        }
        recalculate(e2) {
          this.properties = this._transitioning.possiblyEvaluate(e2);
        }
        _validate(t2, i3, o2) {
          return (!o2 || o2.validate !== false) && e.emitValidationErrors(this, t2.call(e.validateStyle, e.extend({ value: i3, style: { glyphs: true, sprite: true }, styleSpec: e.spec })));
        }
      }
      const g = new e.Properties({ source: new e.DataConstantProperty(e.spec.terrain.source), exaggeration: new e.DataConstantProperty(e.spec.terrain.exaggeration) }), v2 = "-transition";
      class x2 extends e.Evented {
        constructor(t2, i3) {
          super(), this._transitionable = new e.Transitionable(g), this.set(t2), this._transitioning = this._transitionable.untransitioned(), this.drapeRenderMode = i3;
        }
        get() {
          return this._transitionable.serialize();
        }
        set(t2) {
          for (const i3 in t2) {
            const o2 = t2[i3];
            e.endsWith(i3, v2) ? this._transitionable.setTransition(i3.slice(0, -v2.length), o2) : this._transitionable.setValue(i3, o2);
          }
        }
        updateTransitions(e2) {
          this._transitioning = this._transitionable.transitioned(e2, this._transitioning);
        }
        hasTransition() {
          return this._transitioning.hasTransition();
        }
        recalculate(e2) {
          this.properties = this._transitioning.possiblyEvaluate(e2);
        }
      }
      function y(t2, i3, o2, r2) {
        const n2 = e.smoothstep(45, 65, o2), [a2, s3] = b(t2, r2), l2 = e.length(i3);
        let c2 = 1 - Math.min(1, Math.exp((l2 - a2) / (s3 - a2) * -6));
        return c2 *= c2 * c2, c2 = Math.min(1, 1.00747 * c2), c2 * n2 * t2.alpha;
      }
      function b(e2, t2) {
        const i3 = 0.5 / Math.tan(0.5 * t2);
        return [e2.range[0] + i3, e2.range[1] + i3];
      }
      const w = new e.Properties({ range: new e.DataConstantProperty(e.spec.fog.range), color: new e.DataConstantProperty(e.spec.fog.color), "horizon-blend": new e.DataConstantProperty(e.spec.fog["horizon-blend"]) }), T = "-transition";
      class E extends e.Evented {
        constructor(t2, i3) {
          super(), this._transitionable = new e.Transitionable(w), this.set(t2), this._transitioning = this._transitionable.untransitioned(), this._transform = i3;
        }
        get state() {
          return { range: this.properties.get("range"), horizonBlend: this.properties.get("horizon-blend"), alpha: this.properties.get("color").a };
        }
        get() {
          return this._transitionable.serialize();
        }
        set(t2, i3 = {}) {
          if (!this._validate(e.validateFog, t2, i3))
            for (const i4 in t2) {
              const o2 = t2[i4];
              e.endsWith(i4, T) ? this._transitionable.setTransition(i4.slice(0, -T.length), o2) : this._transitionable.setValue(i4, o2);
            }
        }
        getOpacity(t2) {
          if (!this._transform.projection.supportsFog)
            return 0;
          const i3 = this.properties && this.properties.get("color") || 1;
          return e.smoothstep(45, 65, t2) * i3.a;
        }
        getOpacityAtLatLng(t2, i3) {
          return this._transform.projection.supportsFog ? function(t3, i4, o2) {
            const r2 = e.MercatorCoordinate.fromLngLat(i4), n2 = o2.elevation ? o2.elevation.getAtPointOrZero(r2) : 0, a2 = [r2.x, r2.y, n2];
            return e.transformMat4(a2, a2, o2.mercatorFogMatrix), y(t3, a2, o2.pitch, o2._fov);
          }(this.state, t2, i3) : 0;
        }
        getFovAdjustedRange(e2) {
          return this._transform.projection.supportsFog ? b(this.state, e2) : [0, 1];
        }
        updateTransitions(e2) {
          this._transitioning = this._transitionable.transitioned(e2, this._transitioning);
        }
        hasTransition() {
          return this._transitioning.hasTransition();
        }
        recalculate(e2) {
          this.properties = this._transitioning.possiblyEvaluate(e2);
        }
        _validate(t2, i3, o2) {
          return (!o2 || o2.validate !== false) && e.emitValidationErrors(this, t2.call(e.validateStyle, e.extend({ value: i3, style: { glyphs: true, sprite: true }, styleSpec: e.spec })));
        }
      }
      class C {
        constructor(t2, i3) {
          this.workerPool = t2, this.actors = [], this.currentActor = 0, this.id = e.uniqueId();
          const o2 = this.workerPool.acquire(this.id);
          for (let e2 = 0; e2 < o2.length; e2++) {
            const t3 = new C.Actor(o2[e2], i3, this.id);
            t3.name = `Worker ${e2}`, this.actors.push(t3);
          }
          this.ready = false, this.broadcast("checkIfReady", null, () => {
            this.ready = true;
          });
        }
        broadcast(t2, i3, o2) {
          e.asyncAll(this.actors, (e2, o3) => {
            e2.send(t2, i3, o3);
          }, o2 = o2 || function() {
          });
        }
        getActor() {
          return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
        }
        remove() {
          this.actors.forEach((e2) => {
            e2.remove();
          }), this.actors = [], this.workerPool.release(this.id);
        }
      }
      function M2(t2, i3, o2) {
        return i3 * (e.EXTENT / (t2.tileSize * Math.pow(2, o2 - t2.tileID.overscaledZ)));
      }
      C.Actor = e.Actor;
      class S2 {
        constructor(e2, t2, i3) {
          this.context = e2;
          const o2 = e2.gl;
          this.buffer = o2.createBuffer(), this.dynamicDraw = Boolean(i3), this.context.unbindVAO(), e2.bindElementBuffer.set(this.buffer), o2.bufferData(o2.ELEMENT_ARRAY_BUFFER, t2.arrayBuffer, this.dynamicDraw ? o2.DYNAMIC_DRAW : o2.STATIC_DRAW), this.dynamicDraw || delete t2.arrayBuffer;
        }
        bind() {
          this.context.bindElementBuffer.set(this.buffer);
        }
        updateData(e2) {
          const t2 = this.context.gl;
          this.context.unbindVAO(), this.bind(), t2.bufferSubData(t2.ELEMENT_ARRAY_BUFFER, 0, e2.arrayBuffer);
        }
        destroy() {
          this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
        }
      }
      const I2 = { Int8: "BYTE", Uint8: "UNSIGNED_BYTE", Int16: "SHORT", Uint16: "UNSIGNED_SHORT", Int32: "INT", Uint32: "UNSIGNED_INT", Float32: "FLOAT" };
      class z {
        constructor(e2, t2, i3, o2) {
          this.length = t2.length, this.attributes = i3, this.itemSize = t2.bytesPerElement, this.dynamicDraw = o2, this.context = e2;
          const r2 = e2.gl;
          this.buffer = r2.createBuffer(), e2.bindVertexBuffer.set(this.buffer), r2.bufferData(r2.ARRAY_BUFFER, t2.arrayBuffer, this.dynamicDraw ? r2.DYNAMIC_DRAW : r2.STATIC_DRAW), this.dynamicDraw || delete t2.arrayBuffer;
        }
        bind() {
          this.context.bindVertexBuffer.set(this.buffer);
        }
        updateData(e2) {
          const t2 = this.context.gl;
          this.bind(), t2.bufferSubData(t2.ARRAY_BUFFER, 0, e2.arrayBuffer);
        }
        enableAttributes(e2, t2) {
          for (let i3 = 0; i3 < this.attributes.length; i3++) {
            const o2 = t2.attributes[this.attributes[i3].name];
            o2 !== void 0 && e2.enableVertexAttribArray(o2);
          }
        }
        setVertexAttribPointers(e2, t2, i3) {
          for (let o2 = 0; o2 < this.attributes.length; o2++) {
            const r2 = this.attributes[o2], n2 = t2.attributes[r2.name];
            n2 !== void 0 && e2.vertexAttribPointer(n2, r2.components, e2[I2[r2.type]], false, this.itemSize, r2.offset + this.itemSize * (i3 || 0));
          }
        }
        destroy() {
          this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
        }
      }
      class D3 {
        constructor(e2) {
          this.gl = e2.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = false;
        }
        get() {
          return this.current;
        }
        set(e2) {
        }
        getDefault() {
          return this.default;
        }
        setDefault() {
          this.set(this.default);
        }
      }
      class P extends D3 {
        getDefault() {
          return e.Color.transparent;
        }
        set(e2) {
          const t2 = this.current;
          (e2.r !== t2.r || e2.g !== t2.g || e2.b !== t2.b || e2.a !== t2.a || this.dirty) && (this.gl.clearColor(e2.r, e2.g, e2.b, e2.a), this.current = e2, this.dirty = false);
        }
      }
      class A2 extends D3 {
        getDefault() {
          return 1;
        }
        set(e2) {
          (e2 !== this.current || this.dirty) && (this.gl.clearDepth(e2), this.current = e2, this.dirty = false);
        }
      }
      class L2 extends D3 {
        getDefault() {
          return 0;
        }
        set(e2) {
          (e2 !== this.current || this.dirty) && (this.gl.clearStencil(e2), this.current = e2, this.dirty = false);
        }
      }
      class R5 extends D3 {
        getDefault() {
          return [true, true, true, true];
        }
        set(e2) {
          const t2 = this.current;
          (e2[0] !== t2[0] || e2[1] !== t2[1] || e2[2] !== t2[2] || e2[3] !== t2[3] || this.dirty) && (this.gl.colorMask(e2[0], e2[1], e2[2], e2[3]), this.current = e2, this.dirty = false);
        }
      }
      class k extends D3 {
        getDefault() {
          return true;
        }
        set(e2) {
          (e2 !== this.current || this.dirty) && (this.gl.depthMask(e2), this.current = e2, this.dirty = false);
        }
      }
      class O extends D3 {
        getDefault() {
          return 255;
        }
        set(e2) {
          (e2 !== this.current || this.dirty) && (this.gl.stencilMask(e2), this.current = e2, this.dirty = false);
        }
      }
      class B2 extends D3 {
        getDefault() {
          return { func: this.gl.ALWAYS, ref: 0, mask: 255 };
        }
        set(e2) {
          const t2 = this.current;
          (e2.func !== t2.func || e2.ref !== t2.ref || e2.mask !== t2.mask || this.dirty) && (this.gl.stencilFunc(e2.func, e2.ref, e2.mask), this.current = e2, this.dirty = false);
        }
      }
      class F extends D3 {
        getDefault() {
          const e2 = this.gl;
          return [e2.KEEP, e2.KEEP, e2.KEEP];
        }
        set(e2) {
          const t2 = this.current;
          (e2[0] !== t2[0] || e2[1] !== t2[1] || e2[2] !== t2[2] || this.dirty) && (this.gl.stencilOp(e2[0], e2[1], e2[2]), this.current = e2, this.dirty = false);
        }
      }
      class U extends D3 {
        getDefault() {
          return false;
        }
        set(e2) {
          if (e2 === this.current && !this.dirty)
            return;
          const t2 = this.gl;
          e2 ? t2.enable(t2.STENCIL_TEST) : t2.disable(t2.STENCIL_TEST), this.current = e2, this.dirty = false;
        }
      }
      class N extends D3 {
        getDefault() {
          return [0, 1];
        }
        set(e2) {
          const t2 = this.current;
          (e2[0] !== t2[0] || e2[1] !== t2[1] || this.dirty) && (this.gl.depthRange(e2[0], e2[1]), this.current = e2, this.dirty = false);
        }
      }
      class G extends D3 {
        getDefault() {
          return false;
        }
        set(e2) {
          if (e2 === this.current && !this.dirty)
            return;
          const t2 = this.gl;
          e2 ? t2.enable(t2.DEPTH_TEST) : t2.disable(t2.DEPTH_TEST), this.current = e2, this.dirty = false;
        }
      }
      class j extends D3 {
        getDefault() {
          return this.gl.LESS;
        }
        set(e2) {
          (e2 !== this.current || this.dirty) && (this.gl.depthFunc(e2), this.current = e2, this.dirty = false);
        }
      }
      class Z2 extends D3 {
        getDefault() {
          return false;
        }
        set(e2) {
          if (e2 === this.current && !this.dirty)
            return;
          const t2 = this.gl;
          e2 ? t2.enable(t2.BLEND) : t2.disable(t2.BLEND), this.current = e2, this.dirty = false;
        }
      }
      class V extends D3 {
        getDefault() {
          const e2 = this.gl;
          return [e2.ONE, e2.ZERO];
        }
        set(e2) {
          const t2 = this.current;
          (e2[0] !== t2[0] || e2[1] !== t2[1] || this.dirty) && (this.gl.blendFunc(e2[0], e2[1]), this.current = e2, this.dirty = false);
        }
      }
      class W extends D3 {
        getDefault() {
          return e.Color.transparent;
        }
        set(e2) {
          const t2 = this.current;
          (e2.r !== t2.r || e2.g !== t2.g || e2.b !== t2.b || e2.a !== t2.a || this.dirty) && (this.gl.blendColor(e2.r, e2.g, e2.b, e2.a), this.current = e2, this.dirty = false);
        }
      }
      class q extends D3 {
        getDefault() {
          return this.gl.FUNC_ADD;
        }
        set(e2) {
          (e2 !== this.current || this.dirty) && (this.gl.blendEquation(e2), this.current = e2, this.dirty = false);
        }
      }
      class X2 extends D3 {
        getDefault() {
          return false;
        }
        set(e2) {
          if (e2 === this.current && !this.dirty)
            return;
          const t2 = this.gl;
          e2 ? t2.enable(t2.CULL_FACE) : t2.disable(t2.CULL_FACE), this.current = e2, this.dirty = false;
        }
      }
      class $ extends D3 {
        getDefault() {
          return this.gl.BACK;
        }
        set(e2) {
          (e2 !== this.current || this.dirty) && (this.gl.cullFace(e2), this.current = e2, this.dirty = false);
        }
      }
      class H extends D3 {
        getDefault() {
          return this.gl.CCW;
        }
        set(e2) {
          (e2 !== this.current || this.dirty) && (this.gl.frontFace(e2), this.current = e2, this.dirty = false);
        }
      }
      class K extends D3 {
        getDefault() {
          return null;
        }
        set(e2) {
          (e2 !== this.current || this.dirty) && (this.gl.useProgram(e2), this.current = e2, this.dirty = false);
        }
      }
      class Y2 extends D3 {
        getDefault() {
          return this.gl.TEXTURE0;
        }
        set(e2) {
          (e2 !== this.current || this.dirty) && (this.gl.activeTexture(e2), this.current = e2, this.dirty = false);
        }
      }
      class J extends D3 {
        getDefault() {
          const e2 = this.gl;
          return [0, 0, e2.drawingBufferWidth, e2.drawingBufferHeight];
        }
        set(e2) {
          const t2 = this.current;
          (e2[0] !== t2[0] || e2[1] !== t2[1] || e2[2] !== t2[2] || e2[3] !== t2[3] || this.dirty) && (this.gl.viewport(e2[0], e2[1], e2[2], e2[3]), this.current = e2, this.dirty = false);
        }
      }
      class Q extends D3 {
        getDefault() {
          return null;
        }
        set(e2) {
          if (e2 === this.current && !this.dirty)
            return;
          const t2 = this.gl;
          t2.bindFramebuffer(t2.FRAMEBUFFER, e2), this.current = e2, this.dirty = false;
        }
      }
      class ee extends D3 {
        getDefault() {
          return null;
        }
        set(e2) {
          if (e2 === this.current && !this.dirty)
            return;
          const t2 = this.gl;
          t2.bindRenderbuffer(t2.RENDERBUFFER, e2), this.current = e2, this.dirty = false;
        }
      }
      class te extends D3 {
        getDefault() {
          return null;
        }
        set(e2) {
          if (e2 === this.current && !this.dirty)
            return;
          const t2 = this.gl;
          t2.bindTexture(t2.TEXTURE_2D, e2), this.current = e2, this.dirty = false;
        }
      }
      class ie2 extends D3 {
        getDefault() {
          return null;
        }
        set(e2) {
          if (e2 === this.current && !this.dirty)
            return;
          const t2 = this.gl;
          t2.bindBuffer(t2.ARRAY_BUFFER, e2), this.current = e2, this.dirty = false;
        }
      }
      class oe extends D3 {
        getDefault() {
          return null;
        }
        set(e2) {
          const t2 = this.gl;
          t2.bindBuffer(t2.ELEMENT_ARRAY_BUFFER, e2), this.current = e2, this.dirty = false;
        }
      }
      class re extends D3 {
        constructor(e2) {
          super(e2), this.vao = e2.extVertexArrayObject;
        }
        getDefault() {
          return null;
        }
        set(e2) {
          this.vao && (e2 !== this.current || this.dirty) && (this.vao.bindVertexArrayOES(e2), this.current = e2, this.dirty = false);
        }
      }
      class ne extends D3 {
        getDefault() {
          return 4;
        }
        set(e2) {
          if (e2 === this.current && !this.dirty)
            return;
          const t2 = this.gl;
          t2.pixelStorei(t2.UNPACK_ALIGNMENT, e2), this.current = e2, this.dirty = false;
        }
      }
      class ae extends D3 {
        getDefault() {
          return false;
        }
        set(e2) {
          if (e2 === this.current && !this.dirty)
            return;
          const t2 = this.gl;
          t2.pixelStorei(t2.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e2), this.current = e2, this.dirty = false;
        }
      }
      class se extends D3 {
        getDefault() {
          return false;
        }
        set(e2) {
          if (e2 === this.current && !this.dirty)
            return;
          const t2 = this.gl;
          t2.pixelStorei(t2.UNPACK_FLIP_Y_WEBGL, e2), this.current = e2, this.dirty = false;
        }
      }
      class le extends D3 {
        constructor(e2, t2) {
          super(e2), this.context = e2, this.parent = t2;
        }
        getDefault() {
          return null;
        }
      }
      class ce extends le {
        setDirty() {
          this.dirty = true;
        }
        set(e2) {
          if (e2 === this.current && !this.dirty)
            return;
          this.context.bindFramebuffer.set(this.parent);
          const t2 = this.gl;
          t2.framebufferTexture2D(t2.FRAMEBUFFER, t2.COLOR_ATTACHMENT0, t2.TEXTURE_2D, e2, 0), this.current = e2, this.dirty = false;
        }
      }
      class he extends le {
        attachment() {
          return this.gl.DEPTH_ATTACHMENT;
        }
        set(e2) {
          if (e2 === this.current && !this.dirty)
            return;
          this.context.bindFramebuffer.set(this.parent);
          const t2 = this.gl;
          t2.framebufferRenderbuffer(t2.FRAMEBUFFER, this.attachment(), t2.RENDERBUFFER, e2), this.current = e2, this.dirty = false;
        }
      }
      class ue extends he {
        attachment() {
          return this.gl.DEPTH_STENCIL_ATTACHMENT;
        }
      }
      class _e {
        constructor(e2, t2, i3, o2) {
          this.context = e2, this.width = t2, this.height = i3;
          const r2 = this.framebuffer = e2.gl.createFramebuffer();
          this.colorAttachment = new ce(e2, r2), o2 && (this.depthAttachment = new he(e2, r2));
        }
        destroy() {
          const e2 = this.context.gl, t2 = this.colorAttachment.get();
          if (t2 && e2.deleteTexture(t2), this.depthAttachment) {
            const t3 = this.depthAttachment.get();
            t3 && e2.deleteRenderbuffer(t3);
          }
          e2.deleteFramebuffer(this.framebuffer);
        }
      }
      class de {
        constructor(e2) {
          this.gl = e2, this.extVertexArrayObject = this.gl.getExtension("OES_vertex_array_object"), this.clearColor = new P(this), this.clearDepth = new A2(this), this.clearStencil = new L2(this), this.colorMask = new R5(this), this.depthMask = new k(this), this.stencilMask = new O(this), this.stencilFunc = new B2(this), this.stencilOp = new F(this), this.stencilTest = new U(this), this.depthRange = new N(this), this.depthTest = new G(this), this.depthFunc = new j(this), this.blend = new Z2(this), this.blendFunc = new V(this), this.blendColor = new W(this), this.blendEquation = new q(this), this.cullFace = new X2(this), this.cullFaceSide = new $(this), this.frontFace = new H(this), this.program = new K(this), this.activeTexture = new Y2(this), this.viewport = new J(this), this.bindFramebuffer = new Q(this), this.bindRenderbuffer = new ee(this), this.bindTexture = new te(this), this.bindVertexBuffer = new ie2(this), this.bindElementBuffer = new oe(this), this.bindVertexArrayOES = this.extVertexArrayObject && new re(this), this.pixelStoreUnpack = new ne(this), this.pixelStoreUnpackPremultiplyAlpha = new ae(this), this.pixelStoreUnpackFlipY = new se(this), this.extTextureFilterAnisotropic = e2.getExtension("EXT_texture_filter_anisotropic") || e2.getExtension("MOZ_EXT_texture_filter_anisotropic") || e2.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e2.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.extTextureFilterAnisotropicForceOff = false, this.extTextureHalfFloat = e2.getExtension("OES_texture_half_float"), this.extTextureHalfFloat && (e2.getExtension("OES_texture_half_float_linear"), this.extRenderToTextureHalfFloat = e2.getExtension("EXT_color_buffer_half_float")), this.extTimerQuery = e2.getExtension("EXT_disjoint_timer_query"), this.maxTextureSize = e2.getParameter(e2.MAX_TEXTURE_SIZE);
        }
        setDefault() {
          this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
        }
        setDirty() {
          this.clearColor.dirty = true, this.clearDepth.dirty = true, this.clearStencil.dirty = true, this.colorMask.dirty = true, this.depthMask.dirty = true, this.stencilMask.dirty = true, this.stencilFunc.dirty = true, this.stencilOp.dirty = true, this.stencilTest.dirty = true, this.depthRange.dirty = true, this.depthTest.dirty = true, this.depthFunc.dirty = true, this.blend.dirty = true, this.blendFunc.dirty = true, this.blendColor.dirty = true, this.blendEquation.dirty = true, this.cullFace.dirty = true, this.cullFaceSide.dirty = true, this.frontFace.dirty = true, this.program.dirty = true, this.activeTexture.dirty = true, this.viewport.dirty = true, this.bindFramebuffer.dirty = true, this.bindRenderbuffer.dirty = true, this.bindTexture.dirty = true, this.bindVertexBuffer.dirty = true, this.bindElementBuffer.dirty = true, this.extVertexArrayObject && (this.bindVertexArrayOES.dirty = true), this.pixelStoreUnpack.dirty = true, this.pixelStoreUnpackPremultiplyAlpha.dirty = true, this.pixelStoreUnpackFlipY.dirty = true;
        }
        createIndexBuffer(e2, t2) {
          return new S2(this, e2, t2);
        }
        createVertexBuffer(e2, t2, i3) {
          return new z(this, e2, t2, i3);
        }
        createRenderbuffer(e2, t2, i3) {
          const o2 = this.gl, r2 = o2.createRenderbuffer();
          return this.bindRenderbuffer.set(r2), o2.renderbufferStorage(o2.RENDERBUFFER, e2, t2, i3), this.bindRenderbuffer.set(null), r2;
        }
        createFramebuffer(e2, t2, i3) {
          return new _e(this, e2, t2, i3);
        }
        clear({ color: e2, depth: t2, stencil: i3 }) {
          const o2 = this.gl;
          let r2 = 0;
          e2 && (r2 |= o2.COLOR_BUFFER_BIT, this.clearColor.set(e2), this.colorMask.set([true, true, true, true])), t2 !== void 0 && (r2 |= o2.DEPTH_BUFFER_BIT, this.depthRange.set([0, 1]), this.clearDepth.set(t2), this.depthMask.set(true)), i3 !== void 0 && (r2 |= o2.STENCIL_BUFFER_BIT, this.clearStencil.set(i3), this.stencilMask.set(255)), o2.clear(r2);
        }
        setCullFace(e2) {
          e2.enable === false ? this.cullFace.set(false) : (this.cullFace.set(true), this.cullFaceSide.set(e2.mode), this.frontFace.set(e2.frontFace));
        }
        setDepthMode(e2) {
          e2.func !== this.gl.ALWAYS || e2.mask ? (this.depthTest.set(true), this.depthFunc.set(e2.func), this.depthMask.set(e2.mask), this.depthRange.set(e2.range)) : this.depthTest.set(false);
        }
        setStencilMode(e2) {
          e2.test.func !== this.gl.ALWAYS || e2.mask ? (this.stencilTest.set(true), this.stencilMask.set(e2.mask), this.stencilOp.set([e2.fail, e2.depthFail, e2.pass]), this.stencilFunc.set({ func: e2.test.func, ref: e2.ref, mask: e2.test.mask })) : this.stencilTest.set(false);
        }
        setColorMode(t2) {
          n(t2.blendFunction, e.ColorMode.Replace) ? this.blend.set(false) : (this.blend.set(true), this.blendFunc.set(t2.blendFunction), this.blendColor.set(t2.blendColor)), this.colorMask.set(t2.mask);
        }
        unbindVAO() {
          this.extVertexArrayObject && this.bindVertexArrayOES.set(null);
        }
      }
      class pe {
        constructor(e2, t2, i3, o2) {
          this.screenBounds = e2, this.cameraPoint = t2, this._screenRaycastCache = {}, this._cameraRaycastCache = {}, this.isAboveHorizon = i3, this.screenGeometry = this.bufferedScreenGeometry(0), this.screenGeometryMercator = this.screenGeometry.map((e3) => o2.pointCoordinate3D(e3)), this.cameraGeometry = this.bufferedCameraGeometry(0);
        }
        static createFromScreenPoints(t2, i3) {
          let o2, r2;
          if (t2 instanceof e.pointGeometry || typeof t2[0] == "number") {
            const n2 = e.pointGeometry.convert(t2);
            o2 = [e.pointGeometry.convert(t2)], r2 = i3.isPointAboveHorizon(n2);
          } else {
            const n2 = e.pointGeometry.convert(t2[0]), a2 = e.pointGeometry.convert(t2[1]);
            o2 = [n2, a2], r2 = e.polygonizeBounds(n2, a2).every((e2) => i3.isPointAboveHorizon(e2));
          }
          return new pe(o2, i3.getCameraPoint(), r2, i3);
        }
        isPointQuery() {
          return this.screenBounds.length === 1;
        }
        bufferedScreenGeometry(t2) {
          return e.polygonizeBounds(this.screenBounds[0], this.screenBounds.length === 1 ? this.screenBounds[0] : this.screenBounds[1], t2);
        }
        bufferedCameraGeometry(t2) {
          const i3 = this.screenBounds[0], o2 = this.screenBounds.length === 1 ? this.screenBounds[0].add(new e.pointGeometry(1, 1)) : this.screenBounds[1], r2 = e.polygonizeBounds(i3, o2, 0, false);
          return this.cameraPoint.y > o2.y && (this.cameraPoint.x > i3.x && this.cameraPoint.x < o2.x ? r2.splice(3, 0, this.cameraPoint) : this.cameraPoint.x >= o2.x ? r2[2] = this.cameraPoint : this.cameraPoint.x <= i3.x && (r2[3] = this.cameraPoint)), e.bufferConvexPolygon(r2, t2);
        }
        containsTile(t2, i3, o2) {
          const r2 = t2.queryPadding + 1, n2 = t2.tileID.wrap, a2 = o2 ? this._bufferedCameraMercator(r2, i3).map((i4) => e.getTilePoint(t2.tileTransform, i4, n2)) : this._bufferedScreenMercator(r2, i3).map((i4) => e.getTilePoint(t2.tileTransform, i4, n2)), s3 = this.screenGeometryMercator.map((i4) => e.getTileVec3(t2.tileTransform, i4, n2)), l2 = s3.map((t3) => new e.pointGeometry(t3[0], t3[1])), c2 = i3.getFreeCameraOptions().position || new e.MercatorCoordinate(0, 0, 0), h2 = e.getTileVec3(t2.tileTransform, c2, n2), u2 = s3.map((t3) => {
            const i4 = e.sub(t3, t3, h2);
            return e.normalize(i4, i4), new e.Ray(h2, i4);
          }), _2 = M2(t2, 1, i3.zoom);
          if (e.polygonIntersectsBox(a2, 0, 0, e.EXTENT, e.EXTENT))
            return { queryGeometry: this, tilespaceGeometry: l2, tilespaceRays: u2, bufferedTilespaceGeometry: a2, bufferedTilespaceBounds: (d2 = e.getBounds(a2), d2.min.x = e.clamp(d2.min.x, 0, e.EXTENT), d2.min.y = e.clamp(d2.min.y, 0, e.EXTENT), d2.max.x = e.clamp(d2.max.x, 0, e.EXTENT), d2.max.y = e.clamp(d2.max.y, 0, e.EXTENT), d2), tile: t2, tileID: t2.tileID, pixelToTileUnitsFactor: _2 };
          var d2;
        }
        _bufferedScreenMercator(e2, t2) {
          const i3 = me(e2);
          if (this._screenRaycastCache[i3])
            return this._screenRaycastCache[i3];
          {
            const o2 = this.bufferedScreenGeometry(e2).map((e3) => t2.pointCoordinate3D(e3));
            return this._screenRaycastCache[i3] = o2, o2;
          }
        }
        _bufferedCameraMercator(e2, t2) {
          const i3 = me(e2);
          if (this._cameraRaycastCache[i3])
            return this._cameraRaycastCache[i3];
          {
            const o2 = this.bufferedCameraGeometry(e2).map((e3) => t2.pointCoordinate3D(e3));
            return this._cameraRaycastCache[i3] = o2, o2;
          }
        }
      }
      function me(e2) {
        return 100 * e2 | 0;
      }
      function fe(t2, i3, o2) {
        const r2 = function(r3, n2) {
          if (r3)
            return o2(r3);
          if (n2) {
            const r4 = e.pick(e.extend(n2, t2), ["tiles", "minzoom", "maxzoom", "attribution", "mapbox_logo", "bounds", "scheme", "tileSize", "encoding"]);
            n2.vector_layers && (r4.vectorLayers = n2.vector_layers, r4.vectorLayerIds = r4.vectorLayers.map((e2) => e2.id)), r4.tiles = i3.canonicalizeTileset(r4, t2.url), o2(null, r4);
          }
        };
        return t2.url ? e.getJSON(i3.transformRequest(i3.normalizeSourceURL(t2.url), e.ResourceType.Source), r2) : e.exported.frame(() => r2(null, t2));
      }
      class ge {
        constructor(t2, i3, o2) {
          this.bounds = e.LngLatBounds.convert(this.validateBounds(t2)), this.minzoom = i3 || 0, this.maxzoom = o2 || 24;
        }
        validateBounds(e2) {
          return Array.isArray(e2) && e2.length === 4 ? [Math.max(-180, e2[0]), Math.max(-90, e2[1]), Math.min(180, e2[2]), Math.min(90, e2[3])] : [-180, -90, 180, 90];
        }
        contains(t2) {
          const i3 = Math.pow(2, t2.z), o2 = Math.floor(e.mercatorXfromLng(this.bounds.getWest()) * i3), r2 = Math.floor(e.mercatorYfromLat(this.bounds.getNorth()) * i3), n2 = Math.ceil(e.mercatorXfromLng(this.bounds.getEast()) * i3), a2 = Math.ceil(e.mercatorYfromLat(this.bounds.getSouth()) * i3);
          return t2.x >= o2 && t2.x < n2 && t2.y >= r2 && t2.y < a2;
        }
      }
      class ve extends e.Evented {
        constructor(t2, i3, o2, r2) {
          super(), this.id = t2, this.dispatcher = o2, this.setEventedParent(r2), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = true, this.scheme = "xyz", this.tileSize = 512, this._loaded = false, this._options = e.extend({ type: "raster" }, i3), e.extend(this, e.pick(i3, ["url", "scheme", "tileSize"]));
        }
        load() {
          this._loaded = false, this.fire(new e.Event("dataloading", { dataType: "source" })), this._tileJSONRequest = fe(this._options, this.map._requestManager, (t2, i3) => {
            this._tileJSONRequest = null, this._loaded = true, t2 ? this.fire(new e.ErrorEvent(t2)) : i3 && (e.extend(this, i3), i3.bounds && (this.tileBounds = new ge(i3.bounds, this.minzoom, this.maxzoom)), e.postTurnstileEvent(i3.tiles), this.fire(new e.Event("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new e.Event("data", { dataType: "source", sourceDataType: "content" })));
          });
        }
        loaded() {
          return this._loaded;
        }
        onAdd(e2) {
          this.map = e2, this.load();
        }
        onRemove() {
          this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
        }
        serialize() {
          return e.extend({}, this._options);
        }
        hasTile(e2) {
          return !this.tileBounds || this.tileBounds.contains(e2.canonical);
        }
        loadTile(t2, i3) {
          const o2 = e.exported.devicePixelRatio >= 2, r2 = this.map._requestManager.normalizeTileURL(t2.tileID.canonical.url(this.tiles, this.scheme), o2, this.tileSize);
          t2.request = e.getImage(this.map._requestManager.transformRequest(r2, e.ResourceType.Tile), (o3, r3, n2, a2) => {
            if (delete t2.request, t2.aborted)
              t2.state = "unloaded", i3(null);
            else if (o3)
              t2.state = "errored", i3(o3);
            else if (r3) {
              this.map._refreshExpiredTiles && t2.setExpiryData({ cacheControl: n2, expires: a2 });
              const o4 = this.map.painter.context, s3 = o4.gl;
              t2.texture = this.map.painter.getTileTexture(r3.width), t2.texture ? t2.texture.update(r3, { useMipmap: true }) : (t2.texture = new e.Texture(o4, r3, s3.RGBA, { useMipmap: true }), t2.texture.bind(s3.LINEAR, s3.CLAMP_TO_EDGE), o4.extTextureFilterAnisotropic && s3.texParameterf(s3.TEXTURE_2D, o4.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, o4.extTextureFilterAnisotropicMax)), t2.state = "loaded", e.cacheEntryPossiblyAdded(this.dispatcher), i3(null);
            }
          });
        }
        abortTile(e2, t2) {
          e2.request && (e2.request.cancel(), delete e2.request), t2();
        }
        unloadTile(e2, t2) {
          e2.texture && this.map.painter.saveTileTexture(e2.texture), t2();
        }
        hasTransition() {
          return false;
        }
      }
      let xe;
      function ye(t2, i3, o2, r2, n2, a2, s3, l2) {
        const c2 = [t2, o2, n2, i3, r2, a2, 1, 1, 1], h2 = [s3, l2, 1], u2 = e.adjoint([], c2), [_2, d2, p2] = e.transformMat3(h2, h2, e.transpose(u2, u2));
        return e.multiply(c2, [_2, 0, 0, 0, d2, 0, 0, 0, p2], c2);
      }
      class be extends e.Evented {
        constructor(e2, t2, i3, o2) {
          super(), this.id = e2, this.dispatcher = i3, this.coordinates = t2.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = false, this.setEventedParent(o2), this.options = t2;
        }
        load(t2, i3) {
          this._loaded = false, this.fire(new e.Event("dataloading", { dataType: "source" })), this.url = this.options.url, e.getImage(this.map._requestManager.transformRequest(this.url, e.ResourceType.Image), (o2, r2) => {
            this._loaded = true, o2 ? this.fire(new e.ErrorEvent(o2)) : r2 && (this.image = e.exported.getImageData(r2), this.width = this.image.width, this.height = this.image.height, t2 && (this.coordinates = t2), i3 && i3(), this._finishLoading());
          });
        }
        loaded() {
          return this._loaded;
        }
        updateImage(e2) {
          return this.image && e2.url ? (this.options.url = e2.url, this.load(e2.coordinates, () => {
            this.texture = null;
          }), this) : this;
        }
        _finishLoading() {
          this.map && (this.setCoordinates(this.coordinates), this.fire(new e.Event("data", { dataType: "source", sourceDataType: "metadata" })));
        }
        onAdd(e2) {
          this.map = e2, this.load();
        }
        setCoordinates(t2) {
          this.coordinates = t2, delete this._boundsArray;
          const i3 = t2.map(e.MercatorCoordinate.fromLngLat);
          return this.tileID = function(t3) {
            let i4 = 1 / 0, o2 = 1 / 0, r2 = -1 / 0, n2 = -1 / 0;
            for (const e2 of t3)
              i4 = Math.min(i4, e2.x), o2 = Math.min(o2, e2.y), r2 = Math.max(r2, e2.x), n2 = Math.max(n2, e2.y);
            const a2 = Math.max(r2 - i4, n2 - o2), s3 = Math.max(0, Math.floor(-Math.log(a2) / Math.LN2)), l2 = Math.pow(2, s3);
            return new e.CanonicalTileID(s3, Math.floor((i4 + r2) / 2 * l2), Math.floor((o2 + n2) / 2 * l2));
          }(i3), this.minzoom = this.maxzoom = this.tileID.z, this.fire(new e.Event("data", { dataType: "source", sourceDataType: "content" })), this;
        }
        _clear() {
          delete this._boundsArray;
        }
        _makeBoundsArray() {
          const t2 = e.tileTransform(this.tileID, this.map.transform.projection), [i3, o2, r2, n2] = this.coordinates.map((i4) => {
            const o3 = t2.projection.project(i4[0], i4[1]);
            return e.getTilePoint(t2, o3)._round();
          });
          return this.perspectiveTransform = function(t3, i4, o3, r3, n3, a2, s3, l2, c2, h2) {
            const u2 = ye(0, 0, t3, 0, 0, i4, t3, i4), _2 = ye(o3, r3, n3, a2, s3, l2, c2, h2);
            return e.multiply(_2, e.adjoint(u2, u2), _2), [_2[6] / _2[8] * t3 / e.EXTENT, _2[7] / _2[8] * i4 / e.EXTENT];
          }(this.width, this.height, i3.x, i3.y, o2.x, o2.y, n2.x, n2.y, r2.x, r2.y), this._boundsArray = new e.StructArrayLayout4i8(), this._boundsArray.emplaceBack(i3.x, i3.y, 0, 0), this._boundsArray.emplaceBack(o2.x, o2.y, e.EXTENT, 0), this._boundsArray.emplaceBack(n2.x, n2.y, 0, e.EXTENT), this._boundsArray.emplaceBack(r2.x, r2.y, e.EXTENT, e.EXTENT), this.boundsBuffer && (this.boundsBuffer.destroy(), delete this.boundsBuffer), this;
        }
        prepare() {
          if (Object.keys(this.tiles).length === 0 || !this.image)
            return;
          const t2 = this.map.painter.context, i3 = t2.gl;
          this._boundsArray || this._makeBoundsArray(), this.boundsBuffer || (this.boundsBuffer = t2.createVertexBuffer(this._boundsArray, e.boundsAttributes.members)), this.boundsSegments || (this.boundsSegments = e.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture || (this.texture = new e.Texture(t2, this.image, i3.RGBA), this.texture.bind(i3.LINEAR, i3.CLAMP_TO_EDGE));
          for (const e2 in this.tiles) {
            const t3 = this.tiles[e2];
            t3.state !== "loaded" && (t3.state = "loaded", t3.texture = this.texture);
          }
        }
        loadTile(e2, t2) {
          this.tileID && this.tileID.equals(e2.tileID.canonical) ? (this.tiles[String(e2.tileID.wrap)] = e2, e2.buckets = {}, t2(null)) : (e2.state = "errored", t2(null));
        }
        serialize() {
          return { type: "image", url: this.options.url, coordinates: this.coordinates };
        }
        hasTransition() {
          return false;
        }
      }
      const we = { vector: class extends e.Evented {
        constructor(t2, i3, o2, r2) {
          if (super(), this.id = t2, this.dispatcher = o2, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = true, this.isTileClipped = true, this._loaded = false, e.extend(this, e.pick(i3, ["url", "scheme", "tileSize", "promoteId"])), this._options = e.extend({ type: "vector" }, i3), this._collectResourceTiming = i3.collectResourceTiming, this.tileSize !== 512)
            throw new Error("vector tile sources must have a tileSize of 512");
          this.setEventedParent(r2), this._tileWorkers = {}, this._deduped = new e.DedupedRequest();
        }
        load() {
          this._loaded = false, this.fire(new e.Event("dataloading", { dataType: "source" })), this._tileJSONRequest = fe(this._options, this.map._requestManager, (t2, i3) => {
            this._tileJSONRequest = null, this._loaded = true, t2 ? this.fire(new e.ErrorEvent(t2)) : i3 && (e.extend(this, i3), i3.bounds && (this.tileBounds = new ge(i3.bounds, this.minzoom, this.maxzoom)), e.postTurnstileEvent(i3.tiles, this.map._requestManager._customAccessToken), this.fire(new e.Event("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new e.Event("data", { dataType: "source", sourceDataType: "content" })));
          });
        }
        loaded() {
          return this._loaded;
        }
        hasTile(e2) {
          return !this.tileBounds || this.tileBounds.contains(e2.canonical);
        }
        onAdd(e2) {
          this.map = e2, this.load();
        }
        setSourceProperty(e2) {
          this._tileJSONRequest && this._tileJSONRequest.cancel(), e2();
          const t2 = this.map.style._getSourceCaches(this.id);
          for (const e3 of t2)
            e3.clearTiles();
          this.load();
        }
        setTiles(e2) {
          return this.setSourceProperty(() => {
            this._options.tiles = e2;
          }), this;
        }
        setUrl(e2) {
          return this.setSourceProperty(() => {
            this.url = e2, this._options.url = e2;
          }), this;
        }
        onRemove() {
          this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
        }
        serialize() {
          return e.extend({}, this._options);
        }
        loadTile(t2, i3) {
          const o2 = this.map._requestManager.normalizeTileURL(t2.tileID.canonical.url(this.tiles, this.scheme)), r2 = { request: this.map._requestManager.transformRequest(o2, e.ResourceType.Tile), data: void 0, uid: t2.uid, tileID: t2.tileID, tileZoom: t2.tileZoom, zoom: t2.tileID.overscaledZ, tileSize: this.tileSize * t2.tileID.overscaleFactor(), type: this.type, source: this.id, pixelRatio: e.exported.devicePixelRatio, showCollisionBoxes: this.map.showCollisionBoxes, promoteId: this.promoteId, isSymbolTile: t2.isSymbolTile };
          if (r2.request.collectResourceTiming = this._collectResourceTiming, t2.actor && t2.state !== "expired")
            t2.state === "loading" ? t2.reloadCallback = i3 : t2.request = t2.actor.send("reloadTile", r2, n2.bind(this));
          else if (t2.actor = this._tileWorkers[o2] = this._tileWorkers[o2] || this.dispatcher.getActor(), this.dispatcher.ready)
            t2.request = t2.actor.send("loadTile", r2, n2.bind(this), void 0, true);
          else {
            const i4 = e.loadVectorTile.call({ deduped: this._deduped }, r2, (e2, i5) => {
              e2 || !i5 ? n2.call(this, e2) : (r2.data = { cacheControl: i5.cacheControl, expires: i5.expires, rawData: i5.rawData.slice(0) }, t2.actor && t2.actor.send("loadTile", r2, n2.bind(this), void 0, true));
            }, true);
            t2.request = { cancel: i4 };
          }
          function n2(o3, r3) {
            return delete t2.request, t2.aborted ? i3(null) : o3 && o3.status !== 404 ? i3(o3) : (r3 && r3.resourceTiming && (t2.resourceTiming = r3.resourceTiming), this.map._refreshExpiredTiles && r3 && t2.setExpiryData(r3), t2.loadVectorData(r3, this.map.painter), e.cacheEntryPossiblyAdded(this.dispatcher), i3(null), void (t2.reloadCallback && (this.loadTile(t2, t2.reloadCallback), t2.reloadCallback = null)));
          }
        }
        abortTile(e2) {
          e2.request && (e2.request.cancel(), delete e2.request), e2.actor && e2.actor.send("abortTile", { uid: e2.uid, type: this.type, source: this.id });
        }
        unloadTile(e2) {
          e2.unloadVectorData(), e2.actor && e2.actor.send("removeTile", { uid: e2.uid, type: this.type, source: this.id });
        }
        hasTransition() {
          return false;
        }
        afterUpdate() {
          this._tileWorkers = {};
        }
      }, raster: ve, "raster-dem": class extends ve {
        constructor(t2, i3, o2, r2) {
          super(t2, i3, o2, r2), this.type = "raster-dem", this.maxzoom = 22, this._options = e.extend({ type: "raster-dem" }, i3), this.encoding = i3.encoding || "mapbox";
        }
        loadTile(t2, i3) {
          const o2 = this.map._requestManager.normalizeTileURL(t2.tileID.canonical.url(this.tiles, this.scheme), false, this.tileSize);
          function r2(e2, o3) {
            e2 && (t2.state = "errored", i3(e2)), o3 && (t2.dem = o3, t2.dem.onDeserialize(), t2.needsHillshadePrepare = true, t2.needsDEMTextureUpload = true, t2.state = "loaded", i3(null));
          }
          t2.request = e.getImage(this.map._requestManager.transformRequest(o2, e.ResourceType.Tile), function(o3, n2, a2, s3) {
            if (delete t2.request, t2.aborted)
              t2.state = "unloaded", i3(null);
            else if (o3)
              t2.state = "errored", i3(o3);
            else if (n2) {
              this.map._refreshExpiredTiles && t2.setExpiryData({ cacheControl: a2, expires: s3 });
              const i4 = e.window.ImageBitmap && n2 instanceof e.window.ImageBitmap && (xe == null && (xe = e.window.OffscreenCanvas && new e.window.OffscreenCanvas(1, 1).getContext("2d") && typeof e.window.createImageBitmap == "function"), xe), o4 = 1 - (n2.width - e.prevPowerOfTwo(n2.width)) / 2;
              o4 < 1 || t2.neighboringTiles || (t2.neighboringTiles = this._getNeighboringTiles(t2.tileID));
              const l2 = i4 ? n2 : e.exported.getImageData(n2, o4), c2 = { uid: t2.uid, coord: t2.tileID, source: this.id, rawImageData: l2, encoding: this.encoding, padding: o4 };
              t2.actor && t2.state !== "expired" || (t2.actor = this.dispatcher.getActor(), t2.actor.send("loadDEMTile", c2, r2.bind(this), void 0, true));
            }
          }.bind(this));
        }
        _getNeighboringTiles(t2) {
          const i3 = t2.canonical, o2 = Math.pow(2, i3.z), r2 = (i3.x - 1 + o2) % o2, n2 = i3.x === 0 ? t2.wrap - 1 : t2.wrap, a2 = (i3.x + 1 + o2) % o2, s3 = i3.x + 1 === o2 ? t2.wrap + 1 : t2.wrap, l2 = {};
          return l2[new e.OverscaledTileID(t2.overscaledZ, n2, i3.z, r2, i3.y).key] = { backfilled: false }, l2[new e.OverscaledTileID(t2.overscaledZ, s3, i3.z, a2, i3.y).key] = { backfilled: false }, i3.y > 0 && (l2[new e.OverscaledTileID(t2.overscaledZ, n2, i3.z, r2, i3.y - 1).key] = { backfilled: false }, l2[new e.OverscaledTileID(t2.overscaledZ, t2.wrap, i3.z, i3.x, i3.y - 1).key] = { backfilled: false }, l2[new e.OverscaledTileID(t2.overscaledZ, s3, i3.z, a2, i3.y - 1).key] = { backfilled: false }), i3.y + 1 < o2 && (l2[new e.OverscaledTileID(t2.overscaledZ, n2, i3.z, r2, i3.y + 1).key] = { backfilled: false }, l2[new e.OverscaledTileID(t2.overscaledZ, t2.wrap, i3.z, i3.x, i3.y + 1).key] = { backfilled: false }, l2[new e.OverscaledTileID(t2.overscaledZ, s3, i3.z, a2, i3.y + 1).key] = { backfilled: false }), l2;
        }
        unloadTile(e2) {
          e2.demTexture && this.map.painter.saveTileTexture(e2.demTexture), e2.fbo && (e2.fbo.destroy(), delete e2.fbo), e2.dem && delete e2.dem, delete e2.neighboringTiles, e2.state = "unloaded";
        }
      }, geojson: class extends e.Evented {
        constructor(t2, i3, o2, r2) {
          super(), this.id = t2, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = true, this.reparseOverscaled = true, this._loaded = false, this.actor = o2.getActor(), this.setEventedParent(r2), this._data = i3.data, this._options = e.extend({}, i3), this._collectResourceTiming = i3.collectResourceTiming, i3.maxzoom !== void 0 && (this.maxzoom = i3.maxzoom), i3.type && (this.type = i3.type), i3.attribution && (this.attribution = i3.attribution), this.promoteId = i3.promoteId;
          const n2 = e.EXTENT / this.tileSize;
          this.workerOptions = e.extend({ source: this.id, cluster: i3.cluster || false, geojsonVtOptions: { buffer: (i3.buffer !== void 0 ? i3.buffer : 128) * n2, tolerance: (i3.tolerance !== void 0 ? i3.tolerance : 0.375) * n2, extent: e.EXTENT, maxZoom: this.maxzoom, lineMetrics: i3.lineMetrics || false, generateId: i3.generateId || false }, superclusterOptions: { maxZoom: i3.clusterMaxZoom !== void 0 ? i3.clusterMaxZoom : this.maxzoom - 1, minPoints: Math.max(2, i3.clusterMinPoints || 2), extent: e.EXTENT, radius: (i3.clusterRadius !== void 0 ? i3.clusterRadius : 50) * n2, log: false, generateId: i3.generateId || false }, clusterProperties: i3.clusterProperties, filter: i3.filter }, i3.workerOptions);
        }
        onAdd(e2) {
          this.map = e2, this.setData(this._data);
        }
        setData(e2) {
          return this._data = e2, this._updateWorkerData(), this;
        }
        getClusterExpansionZoom(e2, t2) {
          return this.actor.send("geojson.getClusterExpansionZoom", { clusterId: e2, source: this.id }, t2), this;
        }
        getClusterChildren(e2, t2) {
          return this.actor.send("geojson.getClusterChildren", { clusterId: e2, source: this.id }, t2), this;
        }
        getClusterLeaves(e2, t2, i3, o2) {
          return this.actor.send("geojson.getClusterLeaves", { source: this.id, clusterId: e2, limit: t2, offset: i3 }, o2), this;
        }
        _updateWorkerData() {
          if (this._pendingLoad)
            return void (this._coalesce = true);
          this.fire(new e.Event("dataloading", { dataType: "source" })), this._loaded = false;
          const t2 = e.extend({}, this.workerOptions), i3 = this._data;
          typeof i3 == "string" ? (t2.request = this.map._requestManager.transformRequest(e.exported.resolveURL(i3), e.ResourceType.Source), t2.request.collectResourceTiming = this._collectResourceTiming) : t2.data = JSON.stringify(i3), this._pendingLoad = this.actor.send(`${this.type}.loadData`, t2, (t3, i4) => {
            if (this._loaded = true, this._pendingLoad = null, t3)
              this.fire(new e.ErrorEvent(t3));
            else {
              const t4 = { dataType: "source", sourceDataType: this._metadataFired ? "content" : "metadata" };
              this._collectResourceTiming && i4 && i4.resourceTiming && i4.resourceTiming[this.id] && (t4.resourceTiming = i4.resourceTiming[this.id]), this.fire(new e.Event("data", t4)), this._metadataFired = true;
            }
            this._coalesce && (this._updateWorkerData(), this._coalesce = false);
          });
        }
        loaded() {
          return this._loaded;
        }
        loadTile(t2, i3) {
          const o2 = t2.actor ? "reloadTile" : "loadTile";
          t2.actor = this.actor, t2.request = this.actor.send(o2, { type: this.type, uid: t2.uid, tileID: t2.tileID, tileZoom: t2.tileZoom, zoom: t2.tileID.overscaledZ, maxZoom: this.maxzoom, tileSize: this.tileSize, source: this.id, pixelRatio: e.exported.devicePixelRatio, showCollisionBoxes: this.map.showCollisionBoxes, promoteId: this.promoteId }, (e2, r2) => (delete t2.request, t2.unloadVectorData(), t2.aborted ? i3(null) : e2 ? i3(e2) : (t2.loadVectorData(r2, this.map.painter, o2 === "reloadTile"), i3(null))), void 0, o2 === "loadTile");
        }
        abortTile(e2) {
          e2.request && (e2.request.cancel(), delete e2.request), e2.aborted = true;
        }
        unloadTile(e2) {
          e2.unloadVectorData(), this.actor.send("removeTile", { uid: e2.uid, type: this.type, source: this.id });
        }
        onRemove() {
          this._pendingLoad && this._pendingLoad.cancel();
        }
        serialize() {
          return e.extend({}, this._options, { type: this.type, data: this._data });
        }
        hasTransition() {
          return false;
        }
      }, video: class extends be {
        constructor(e2, t2, i3, o2) {
          super(e2, t2, i3, o2), this.roundZoom = true, this.type = "video", this.options = t2;
        }
        load() {
          this._loaded = false;
          const t2 = this.options;
          this.urls = [];
          for (const i3 of t2.urls)
            this.urls.push(this.map._requestManager.transformRequest(i3, e.ResourceType.Source).url);
          e.getVideo(this.urls, (t3, i3) => {
            this._loaded = true, t3 ? this.fire(new e.ErrorEvent(t3)) : i3 && (this.video = i3, this.video.loop = true, this.video.setAttribute("playsinline", ""), this.video.addEventListener("playing", () => {
              this.map.triggerRepaint();
            }), this.map && this.video.play(), this._finishLoading());
          });
        }
        pause() {
          this.video && this.video.pause();
        }
        play() {
          this.video && this.video.play();
        }
        seek(t2) {
          if (this.video) {
            const i3 = this.video.seekable;
            t2 < i3.start(0) || t2 > i3.end(0) ? this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i3.start(0)} and ${i3.end(0)}-second mark.`))) : this.video.currentTime = t2;
          }
        }
        getVideo() {
          return this.video;
        }
        onAdd(e2) {
          this.map || (this.map = e2, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
        }
        prepare() {
          if (Object.keys(this.tiles).length === 0 || this.video.readyState < 2)
            return;
          const t2 = this.map.painter.context, i3 = t2.gl;
          this.texture ? this.video.paused || (this.texture.bind(i3.LINEAR, i3.CLAMP_TO_EDGE), i3.texSubImage2D(i3.TEXTURE_2D, 0, 0, 0, i3.RGBA, i3.UNSIGNED_BYTE, this.video)) : (this.texture = new e.Texture(t2, this.video, i3.RGBA), this.texture.bind(i3.LINEAR, i3.CLAMP_TO_EDGE), this.width = this.video.videoWidth, this.height = this.video.videoHeight), this._boundsArray || this._makeBoundsArray(), this.boundsBuffer || (this.boundsBuffer = t2.createVertexBuffer(this._boundsArray, e.boundsAttributes.members)), this.boundsSegments || (this.boundsSegments = e.SegmentVector.simpleSegment(0, 0, 4, 2));
          for (const e2 in this.tiles) {
            const t3 = this.tiles[e2];
            t3.state !== "loaded" && (t3.state = "loaded", t3.texture = this.texture);
          }
        }
        serialize() {
          return { type: "video", urls: this.urls, coordinates: this.coordinates };
        }
        hasTransition() {
          return this.video && !this.video.paused;
        }
      }, image: be, canvas: class extends be {
        constructor(t2, i3, o2, r2) {
          super(t2, i3, o2, r2), i3.coordinates ? Array.isArray(i3.coordinates) && i3.coordinates.length === 4 && !i3.coordinates.some((e2) => !Array.isArray(e2) || e2.length !== 2 || e2.some((e3) => typeof e3 != "number")) || this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${t2}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${t2}`, null, 'missing required property "coordinates"'))), i3.animate && typeof i3.animate != "boolean" && this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${t2}`, null, 'optional "animate" property must be a boolean value'))), i3.canvas ? typeof i3.canvas == "string" || i3.canvas instanceof e.window.HTMLCanvasElement || this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${t2}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${t2}`, null, 'missing required property "canvas"'))), this.options = i3, this.animate = i3.animate === void 0 || i3.animate;
        }
        load() {
          this._loaded = true, this.canvas || (this.canvas = this.options.canvas instanceof e.window.HTMLCanvasElement ? this.options.canvas : e.window.document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new e.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
            this._playing = true, this.map.triggerRepaint();
          }, this.pause = function() {
            this._playing && (this.prepare(), this._playing = false);
          }, this._finishLoading());
        }
        getCanvas() {
          return this.canvas;
        }
        onAdd(e2) {
          this.map = e2, this.load(), this.canvas && this.animate && this.play();
        }
        onRemove() {
          this.pause();
        }
        prepare() {
          let t2 = false;
          if (this.canvas.width !== this.width && (this.width = this.canvas.width, t2 = true), this.canvas.height !== this.height && (this.height = this.canvas.height, t2 = true), this._hasInvalidDimensions())
            return;
          if (Object.keys(this.tiles).length === 0)
            return;
          const i3 = this.map.painter.context, o2 = i3.gl;
          this._boundsArray || this._makeBoundsArray(), this.boundsBuffer || (this.boundsBuffer = i3.createVertexBuffer(this._boundsArray, e.boundsAttributes.members)), this.boundsSegments || (this.boundsSegments = e.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? (t2 || this._playing) && this.texture.update(this.canvas, { premultiply: true }) : this.texture = new e.Texture(i3, this.canvas, o2.RGBA, { premultiply: true });
          for (const e2 in this.tiles) {
            const t3 = this.tiles[e2];
            t3.state !== "loaded" && (t3.state = "loaded", t3.texture = this.texture);
          }
        }
        serialize() {
          return { type: "canvas", coordinates: this.coordinates };
        }
        hasTransition() {
          return this._playing;
        }
        _hasInvalidDimensions() {
          for (const e2 of [this.canvas.width, this.canvas.height])
            if (isNaN(e2) || e2 <= 0)
              return true;
          return false;
        }
      } }, Te = function(t2, i3, o2, r2) {
        const n2 = new we[i3.type](t2, i3, o2, r2);
        if (n2.id !== t2)
          throw new Error(`Expected Source id to be ${t2} instead of ${n2.id}`);
        return e.bindAll(["load", "abort", "unload", "serialize", "prepare"], n2), n2;
      };
      function Ee(t2, i3) {
        const o2 = e.identity([]);
        return e.scale(o2, o2, [0.5 * t2.width, 0.5 * -t2.height, 1]), e.translate(o2, o2, [1, -1, 0]), e.multiply$1(o2, o2, t2.calculateProjMatrix(i3.toUnwrapped()));
      }
      function Ce(e2, t2, i3, o2, r2, n2, a2, s3 = false) {
        const l2 = e2.tilesIn(o2, a2, s3);
        l2.sort(Se);
        const c2 = [];
        for (const o3 of l2)
          c2.push({ wrappedTileID: o3.tile.tileID.wrapped().key, queryResults: o3.tile.queryRenderedFeatures(t2, i3, e2._state, o3, r2, n2, Ee(e2.transform, o3.tile.tileID), s3) });
        const h2 = function(e3) {
          const t3 = {}, i4 = {};
          for (const o3 of e3) {
            const e4 = o3.queryResults, r3 = o3.wrappedTileID, n3 = i4[r3] = i4[r3] || {};
            for (const i5 in e4) {
              const o4 = e4[i5], r4 = n3[i5] = n3[i5] || {}, a3 = t3[i5] = t3[i5] || [];
              for (const e5 of o4)
                r4[e5.featureIndex] || (r4[e5.featureIndex] = true, a3.push(e5));
            }
          }
          return t3;
        }(c2);
        for (const t3 in h2)
          h2[t3].forEach((t4) => {
            const i4 = t4.feature, o3 = e2.getFeatureState(i4.layer["source-layer"], i4.id);
            i4.source = i4.layer.source, i4.layer["source-layer"] && (i4.sourceLayer = i4.layer["source-layer"]), i4.state = o3;
          });
        return h2;
      }
      function Me(e2, t2) {
        const i3 = e2.getRenderableIds().map((t3) => e2.getTileByID(t3)), o2 = [], r2 = {};
        for (let e3 = 0; e3 < i3.length; e3++) {
          const n2 = i3[e3], a2 = n2.tileID.canonical.key;
          r2[a2] || (r2[a2] = true, n2.querySourceFeatures(o2, t2));
        }
        return o2;
      }
      function Se(e2, t2) {
        const i3 = e2.tileID, o2 = t2.tileID;
        return i3.overscaledZ - o2.overscaledZ || i3.canonical.y - o2.canonical.y || i3.wrap - o2.wrap || i3.canonical.x - o2.canonical.x;
      }
      function Ie() {
        return Kr.workerClass != null ? new Kr.workerClass() : new e.window.Worker(Kr.workerUrl);
      }
      const ze = "mapboxgl_preloaded_worker_pool";
      class De {
        constructor() {
          this.active = {};
        }
        acquire(e2) {
          if (!this.workers)
            for (this.workers = []; this.workers.length < De.workerCount; )
              this.workers.push(new Ie());
          return this.active[e2] = true, this.workers.slice();
        }
        release(e2) {
          delete this.active[e2], this.numActive() === 0 && (this.workers.forEach((e3) => {
            e3.terminate();
          }), this.workers = null);
        }
        isPreloaded() {
          return !!this.active[ze];
        }
        numActive() {
          return Object.keys(this.active).length;
        }
      }
      let Pe;
      function Ae() {
        return Pe || (Pe = new De()), Pe;
      }
      function Le(t2, i3) {
        const o2 = {};
        for (const e2 in t2)
          e2 !== "ref" && (o2[e2] = t2[e2]);
        return e.refProperties.forEach((e2) => {
          e2 in i3 && (o2[e2] = i3[e2]);
        }), o2;
      }
      function Re(e2) {
        e2 = e2.slice();
        const t2 = /* @__PURE__ */ Object.create(null);
        for (let i3 = 0; i3 < e2.length; i3++)
          t2[e2[i3].id] = e2[i3];
        for (let i3 = 0; i3 < e2.length; i3++)
          "ref" in e2[i3] && (e2[i3] = Le(e2[i3], t2[e2[i3].ref]));
        return e2;
      }
      De.workerCount = 2;
      const ke = { setStyle: "setStyle", addLayer: "addLayer", removeLayer: "removeLayer", setPaintProperty: "setPaintProperty", setLayoutProperty: "setLayoutProperty", setFilter: "setFilter", addSource: "addSource", removeSource: "removeSource", setGeoJSONSourceData: "setGeoJSONSourceData", setLayerZoomRange: "setLayerZoomRange", setLayerProperty: "setLayerProperty", setCenter: "setCenter", setZoom: "setZoom", setBearing: "setBearing", setPitch: "setPitch", setSprite: "setSprite", setGlyphs: "setGlyphs", setTransition: "setTransition", setLight: "setLight", setTerrain: "setTerrain", setFog: "setFog", setProjection: "setProjection" };
      function Oe(e2, t2, i3) {
        i3.push({ command: ke.addSource, args: [e2, t2[e2]] });
      }
      function Be(e2, t2, i3) {
        t2.push({ command: ke.removeSource, args: [e2] }), i3[e2] = true;
      }
      function Fe(e2, t2, i3, o2) {
        Be(e2, i3, o2), Oe(e2, t2, i3);
      }
      function Ue(e2, t2, i3) {
        let o2;
        for (o2 in e2[i3])
          if (e2[i3].hasOwnProperty(o2) && o2 !== "data" && !n(e2[i3][o2], t2[i3][o2]))
            return false;
        for (o2 in t2[i3])
          if (t2[i3].hasOwnProperty(o2) && o2 !== "data" && !n(e2[i3][o2], t2[i3][o2]))
            return false;
        return true;
      }
      function Ne(e2, t2, i3, o2, r2, a2) {
        let s3;
        for (s3 in t2 = t2 || {}, e2 = e2 || {})
          e2.hasOwnProperty(s3) && (n(e2[s3], t2[s3]) || i3.push({ command: a2, args: [o2, s3, t2[s3], r2] }));
        for (s3 in t2)
          t2.hasOwnProperty(s3) && !e2.hasOwnProperty(s3) && (n(e2[s3], t2[s3]) || i3.push({ command: a2, args: [o2, s3, t2[s3], r2] }));
      }
      function Ge(e2) {
        return e2.id;
      }
      function je(e2, t2) {
        return e2[t2.id] = t2, e2;
      }
      class Ze {
        constructor(e2, t2) {
          this.reset(e2, t2);
        }
        reset(e2, t2) {
          this.points = e2 || [], this._distances = [0];
          for (let e3 = 1; e3 < this.points.length; e3++)
            this._distances[e3] = this._distances[e3 - 1] + this.points[e3].dist(this.points[e3 - 1]);
          this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t2 || 0, 0.5 * this.length), this.paddedLength = this.length - 2 * this.padding;
        }
        lerp(t2) {
          if (this.points.length === 1)
            return this.points[0];
          t2 = e.clamp(t2, 0, 1);
          let i3 = 1, o2 = this._distances[i3];
          const r2 = t2 * this.paddedLength + this.padding;
          for (; o2 < r2 && i3 < this._distances.length; )
            o2 = this._distances[++i3];
          const n2 = i3 - 1, a2 = this._distances[n2], s3 = o2 - a2, l2 = s3 > 0 ? (r2 - a2) / s3 : 0;
          return this.points[n2].mult(1 - l2).add(this.points[i3].mult(l2));
        }
      }
      class Ve {
        constructor(e2, t2, i3) {
          const o2 = this.boxCells = [], r2 = this.circleCells = [];
          this.xCellCount = Math.ceil(e2 / i3), this.yCellCount = Math.ceil(t2 / i3);
          for (let e3 = 0; e3 < this.xCellCount * this.yCellCount; e3++)
            o2.push([]), r2.push([]);
          this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e2, this.height = t2, this.xScale = this.xCellCount / e2, this.yScale = this.yCellCount / t2, this.boxUid = 0, this.circleUid = 0;
        }
        keysLength() {
          return this.boxKeys.length + this.circleKeys.length;
        }
        insert(e2, t2, i3, o2, r2) {
          this._forEachCell(t2, i3, o2, r2, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e2), this.bboxes.push(t2), this.bboxes.push(i3), this.bboxes.push(o2), this.bboxes.push(r2);
        }
        insertCircle(e2, t2, i3, o2) {
          this._forEachCell(t2 - o2, i3 - o2, t2 + o2, i3 + o2, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e2), this.circles.push(t2), this.circles.push(i3), this.circles.push(o2);
        }
        _insertBoxCell(e2, t2, i3, o2, r2, n2) {
          this.boxCells[r2].push(n2);
        }
        _insertCircleCell(e2, t2, i3, o2, r2, n2) {
          this.circleCells[r2].push(n2);
        }
        _query(e2, t2, i3, o2, r2, n2) {
          if (i3 < 0 || e2 > this.width || o2 < 0 || t2 > this.height)
            return !r2 && [];
          const a2 = [];
          if (e2 <= 0 && t2 <= 0 && this.width <= i3 && this.height <= o2) {
            if (r2)
              return true;
            for (let e3 = 0; e3 < this.boxKeys.length; e3++)
              a2.push({ key: this.boxKeys[e3], x1: this.bboxes[4 * e3], y1: this.bboxes[4 * e3 + 1], x2: this.bboxes[4 * e3 + 2], y2: this.bboxes[4 * e3 + 3] });
            for (let e3 = 0; e3 < this.circleKeys.length; e3++) {
              const t3 = this.circles[3 * e3], i4 = this.circles[3 * e3 + 1], o3 = this.circles[3 * e3 + 2];
              a2.push({ key: this.circleKeys[e3], x1: t3 - o3, y1: i4 - o3, x2: t3 + o3, y2: i4 + o3 });
            }
            return n2 ? a2.filter(n2) : a2;
          }
          return this._forEachCell(e2, t2, i3, o2, this._queryCell, a2, { hitTest: r2, seenUids: { box: {}, circle: {} } }, n2), r2 ? a2.length > 0 : a2;
        }
        _queryCircle(e2, t2, i3, o2, r2) {
          const n2 = e2 - i3, a2 = e2 + i3, s3 = t2 - i3, l2 = t2 + i3;
          if (a2 < 0 || n2 > this.width || l2 < 0 || s3 > this.height)
            return !o2 && [];
          const c2 = [];
          return this._forEachCell(n2, s3, a2, l2, this._queryCellCircle, c2, { hitTest: o2, circle: { x: e2, y: t2, radius: i3 }, seenUids: { box: {}, circle: {} } }, r2), o2 ? c2.length > 0 : c2;
        }
        query(e2, t2, i3, o2, r2) {
          return this._query(e2, t2, i3, o2, false, r2);
        }
        hitTest(e2, t2, i3, o2, r2) {
          return this._query(e2, t2, i3, o2, true, r2);
        }
        hitTestCircle(e2, t2, i3, o2) {
          return this._queryCircle(e2, t2, i3, true, o2);
        }
        _queryCell(e2, t2, i3, o2, r2, n2, a2, s3) {
          const l2 = a2.seenUids, c2 = this.boxCells[r2];
          if (c2 !== null) {
            const r3 = this.bboxes;
            for (const h3 of c2)
              if (!l2.box[h3]) {
                l2.box[h3] = true;
                const c3 = 4 * h3;
                if (e2 <= r3[c3 + 2] && t2 <= r3[c3 + 3] && i3 >= r3[c3 + 0] && o2 >= r3[c3 + 1] && (!s3 || s3(this.boxKeys[h3]))) {
                  if (a2.hitTest)
                    return n2.push(true), true;
                  n2.push({ key: this.boxKeys[h3], x1: r3[c3], y1: r3[c3 + 1], x2: r3[c3 + 2], y2: r3[c3 + 3] });
                }
              }
          }
          const h2 = this.circleCells[r2];
          if (h2 !== null) {
            const r3 = this.circles;
            for (const c3 of h2)
              if (!l2.circle[c3]) {
                l2.circle[c3] = true;
                const h3 = 3 * c3;
                if (this._circleAndRectCollide(r3[h3], r3[h3 + 1], r3[h3 + 2], e2, t2, i3, o2) && (!s3 || s3(this.circleKeys[c3]))) {
                  if (a2.hitTest)
                    return n2.push(true), true;
                  {
                    const e3 = r3[h3], t3 = r3[h3 + 1], i4 = r3[h3 + 2];
                    n2.push({ key: this.circleKeys[c3], x1: e3 - i4, y1: t3 - i4, x2: e3 + i4, y2: t3 + i4 });
                  }
                }
              }
          }
        }
        _queryCellCircle(e2, t2, i3, o2, r2, n2, a2, s3) {
          const l2 = a2.circle, c2 = a2.seenUids, h2 = this.boxCells[r2];
          if (h2 !== null) {
            const e3 = this.bboxes;
            for (const t3 of h2)
              if (!c2.box[t3]) {
                c2.box[t3] = true;
                const i4 = 4 * t3;
                if (this._circleAndRectCollide(l2.x, l2.y, l2.radius, e3[i4 + 0], e3[i4 + 1], e3[i4 + 2], e3[i4 + 3]) && (!s3 || s3(this.boxKeys[t3])))
                  return n2.push(true), true;
              }
          }
          const u2 = this.circleCells[r2];
          if (u2 !== null) {
            const e3 = this.circles;
            for (const t3 of u2)
              if (!c2.circle[t3]) {
                c2.circle[t3] = true;
                const i4 = 3 * t3;
                if (this._circlesCollide(e3[i4], e3[i4 + 1], e3[i4 + 2], l2.x, l2.y, l2.radius) && (!s3 || s3(this.circleKeys[t3])))
                  return n2.push(true), true;
              }
          }
        }
        _forEachCell(e2, t2, i3, o2, r2, n2, a2, s3) {
          const l2 = this._convertToXCellCoord(e2), c2 = this._convertToYCellCoord(t2), h2 = this._convertToXCellCoord(i3), u2 = this._convertToYCellCoord(o2);
          for (let _2 = l2; _2 <= h2; _2++)
            for (let l3 = c2; l3 <= u2; l3++)
              if (r2.call(this, e2, t2, i3, o2, this.xCellCount * l3 + _2, n2, a2, s3))
                return;
        }
        _convertToXCellCoord(e2) {
          return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e2 * this.xScale)));
        }
        _convertToYCellCoord(e2) {
          return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e2 * this.yScale)));
        }
        _circlesCollide(e2, t2, i3, o2, r2, n2) {
          const a2 = o2 - e2, s3 = r2 - t2, l2 = i3 + n2;
          return l2 * l2 > a2 * a2 + s3 * s3;
        }
        _circleAndRectCollide(e2, t2, i3, o2, r2, n2, a2) {
          const s3 = (n2 - o2) / 2, l2 = Math.abs(e2 - (o2 + s3));
          if (l2 > s3 + i3)
            return false;
          const c2 = (a2 - r2) / 2, h2 = Math.abs(t2 - (r2 + c2));
          if (h2 > c2 + i3)
            return false;
          if (l2 <= s3 || h2 <= c2)
            return true;
          const u2 = l2 - s3, _2 = h2 - c2;
          return u2 * u2 + _2 * _2 <= i3 * i3;
        }
      }
      const We = Math.tan(85 * Math.PI / 180);
      function qe(t2, i3, o2, n2, a2, s3) {
        let l2 = e.create();
        if (o2) {
          if (a2.projection.name === "globe")
            l2 = e.calculateGlobeMatrix(a2, a2.worldSize / a2._projectionScaler, [0, 0]), e.multiply$1(l2, l2, e.globeDenormalizeECEF(e.globeTileBounds(i3)));
          else {
            const e2 = r([], s3);
            l2[0] = e2[0], l2[1] = e2[1], l2[4] = e2[2], l2[5] = e2[3];
          }
          n2 || e.rotateZ(l2, l2, a2.angle);
        } else
          e.multiply$1(l2, a2.labelPlaneMatrix, t2);
        return l2;
      }
      function Xe(t2, i3, o2, r2, n2, a2) {
        if (o2) {
          if (n2.projection.name === "globe") {
            const s3 = qe(t2, i3, o2, r2, n2, a2);
            return e.invert(s3, s3), e.multiply$1(s3, t2, s3), s3;
          }
          {
            const i4 = e.clone(t2), o3 = e.identity([]);
            return o3[0] = a2[0], o3[1] = a2[1], o3[4] = a2[2], o3[5] = a2[3], e.multiply$1(i4, i4, o3), r2 || e.rotateZ(i4, i4, -n2.angle), i4;
          }
        }
        return n2.glCoordMatrix;
      }
      function $e(t2, i3, o2 = 0) {
        const r2 = [t2.x, t2.y, o2, 1];
        o2 ? e.transformMat4$1(r2, r2, i3) : at(r2, r2, i3);
        const n2 = r2[3];
        return { point: new e.pointGeometry(r2[0] / n2, r2[1] / n2), signedDistanceFromCamera: n2 };
      }
      function He(e2, t2) {
        return Math.min(0.5 + e2 / t2 * 0.5, 1.5);
      }
      function Ke(e2, t2) {
        const i3 = e2[0] / e2[3], o2 = e2[1] / e2[3];
        return i3 >= -t2[0] && i3 <= t2[0] && o2 >= -t2[1] && o2 <= t2[1];
      }
      function Ye(t2, i3, o2, r2, n2, a2, s3, l2, c2, h2) {
        const u2 = o2.transform, _2 = r2 ? t2.textSizeData : t2.iconSizeData, d2 = e.evaluateSizeForZoom(_2, o2.transform.zoom), p2 = [256 / o2.width * 2 + 1, 256 / o2.height * 2 + 1], m2 = r2 ? t2.text.dynamicLayoutVertexArray : t2.icon.dynamicLayoutVertexArray;
        m2.clear();
        const f2 = t2.lineVertexArray, g2 = r2 ? t2.text.placedSymbolArray : t2.icon.placedSymbolArray, v3 = o2.transform.width / o2.transform.height;
        let x3 = false;
        for (let r3 = 0; r3 < g2.length; r3++) {
          const y2 = g2.get(r3);
          if (y2.writingMode !== e.WritingMode.vertical || x3 || r3 !== 0 && g2.get(r3 - 1).writingMode === e.WritingMode.horizontal || (x3 = true), y2.hidden || y2.writingMode === e.WritingMode.vertical && !x3) {
            nt(y2.numGlyphs, m2);
            continue;
          }
          x3 = false;
          const b2 = new e.pointGeometry(y2.tileAnchorX, y2.tileAnchorY), w2 = c2 ? c2(b2) : [0, 0, 0], T2 = u2.projection.projectTilePoint(b2.x, b2.y, h2.canonical), E2 = [T2.x + w2[0], T2.y + w2[1], T2.z + w2[2]], C2 = [...E2, 1];
          if (e.transformMat4$1(C2, C2, i3), !Ke(C2, p2)) {
            nt(y2.numGlyphs, m2);
            continue;
          }
          const M3 = He(o2.transform.cameraToCenterDistance, C2[3]), S3 = e.evaluateSizeForFeature(_2, d2, y2), I3 = s3 ? S3 / M3 : S3 * M3, z2 = $e(new e.pointGeometry(E2[0], E2[1]), n2, E2[2]);
          if (z2.signedDistanceFromCamera <= 0) {
            nt(y2.numGlyphs, m2);
            continue;
          }
          let D4 = {};
          const P2 = s3 ? null : c2, A3 = et(y2, I3, false, l2, i3, n2, a2, t2.glyphOffsetArray, f2, m2, z2.point, b2, D4, v3, P2, u2.projection, h2);
          x3 = A3.useVertical, P2 && A3.needsFlipping && (D4 = {}), (A3.notEnoughRoom || x3 || A3.needsFlipping && et(y2, I3, true, l2, i3, n2, a2, t2.glyphOffsetArray, f2, m2, z2.point, b2, D4, v3, P2, u2.projection, h2).notEnoughRoom) && nt(y2.numGlyphs, m2);
        }
        r2 ? t2.text.dynamicLayoutVertexBuffer.updateData(m2) : t2.icon.dynamicLayoutVertexBuffer.updateData(m2);
      }
      function Je(e2, t2, i3, o2, r2, n2, a2, s3, l2, c2, h2, u2, _2, d2, p2) {
        const m2 = s3.glyphStartIndex + s3.numGlyphs, f2 = s3.lineStartIndex, g2 = s3.lineStartIndex + s3.lineLength, v3 = t2.getoffsetX(s3.glyphStartIndex), x3 = t2.getoffsetX(m2 - 1), y2 = ot(e2 * v3, i3, o2, r2, n2, a2, s3.segment, f2, g2, l2, c2, h2, u2, _2, true, d2, p2);
        if (!y2)
          return null;
        const b2 = ot(e2 * x3, i3, o2, r2, n2, a2, s3.segment, f2, g2, l2, c2, h2, u2, _2, true, d2, p2);
        return b2 ? { first: y2, last: b2 } : null;
      }
      function Qe(t2, i3, o2, r2) {
        return t2.writingMode === e.WritingMode.horizontal && Math.abs(o2.y - i3.y) > Math.abs(o2.x - i3.x) * r2 ? { useVertical: true } : t2.writingMode === e.WritingMode.vertical ? i3.y < o2.y ? { needsFlipping: true } : null : t2.flipState !== 0 && function(e2, t3, i4) {
          const o3 = (t3.x - e2.x) * i4;
          return o3 === 0 || Math.abs((t3.y - e2.y) / o3) > We;
        }(i3, o2, r2) ? t2.flipState === 1 ? { needsFlipping: true } : null : i3.x > o2.x ? { needsFlipping: true } : null;
      }
      function et(t2, i3, o2, r2, n2, a2, s3, l2, c2, h2, u2, _2, d2, p2, m2, f2, g2) {
        const v3 = i3 / 24, x3 = t2.lineOffsetX * v3, y2 = t2.lineOffsetY * v3;
        let b2;
        if (t2.numGlyphs > 1) {
          const e2 = t2.glyphStartIndex + t2.numGlyphs, i4 = t2.lineStartIndex, n3 = t2.lineStartIndex + t2.lineLength, h3 = Je(v3, l2, x3, y2, o2, u2, _2, t2, c2, a2, d2, m2, false, f2, g2);
          if (!h3)
            return { notEnoughRoom: true };
          const w2 = $e(h3.first.point, s3).point, T2 = $e(h3.last.point, s3).point;
          if (r2 && !o2) {
            const e3 = Qe(t2, w2, T2, p2);
            if (t2.flipState = e3 && e3.needsFlipping ? 1 : 2, e3)
              return e3;
          }
          b2 = [h3.first];
          for (let r3 = t2.glyphStartIndex + 1; r3 < e2 - 1; r3++)
            b2.push(ot(v3 * l2.getoffsetX(r3), x3, y2, o2, u2, _2, t2.segment, i4, n3, c2, a2, d2, m2, false, false, f2, g2));
          b2.push(h3.last);
        } else {
          if (r2 && !o2) {
            const i5 = $e(_2, n2).point, o3 = t2.lineStartIndex + t2.segment + 1, r3 = new e.pointGeometry(c2.getx(o3), c2.gety(o3)), a3 = $e(r3, n2), s4 = Qe(t2, i5, a3.signedDistanceFromCamera > 0 ? a3.point : it(_2, r3, i5, 1, n2, void 0, f2, g2.canonical), p2);
            if (t2.flipState = s4 && s4.needsFlipping ? 1 : 2, s4)
              return s4;
          }
          const i4 = ot(v3 * l2.getoffsetX(t2.glyphStartIndex), x3, y2, o2, u2, _2, t2.segment, t2.lineStartIndex, t2.lineStartIndex + t2.lineLength, c2, a2, d2, m2, false, false, f2, g2);
          if (!i4)
            return { notEnoughRoom: true };
          b2 = [i4];
        }
        for (const t3 of b2)
          e.addDynamicAttributes(h2, t3.point, t3.angle);
        return {};
      }
      function tt(t2, i3, o2, r2, n2) {
        const a2 = r2.projectTilePoint(t2.x, t2.y, i3);
        if (!n2)
          return $e(a2, o2, a2.z);
        const s3 = n2(t2);
        return $e(new e.pointGeometry(a2.x + s3[0], a2.y + s3[1]), o2, a2.z + s3[2]);
      }
      function it(e2, t2, i3, o2, r2, n2, a2, s3) {
        const l2 = tt(e2.add(e2.sub(t2)._unit()), s3, r2, a2, n2).point, c2 = i3.sub(l2);
        return i3.add(c2._mult(o2 / c2.mag()));
      }
      function ot(t2, i3, o2, r2, n2, a2, s3, l2, c2, h2, u2, _2, d2, p2, m2, f2, g2) {
        const v3 = r2 ? t2 - i3 : t2 + i3;
        let x3 = v3 > 0 ? 1 : -1, y2 = 0;
        r2 && (x3 *= -1, y2 = Math.PI), x3 < 0 && (y2 += Math.PI);
        let b2 = x3 > 0 ? l2 + s3 : l2 + s3 + 1, w2 = n2, T2 = n2, E2 = 0, C2 = 0;
        const M3 = Math.abs(v3), S3 = [], I3 = [];
        let z2 = a2;
        const D4 = () => {
          const t3 = b2 - x3;
          return E2 === 0 ? a2 : new e.pointGeometry(h2.getx(t3), h2.gety(t3));
        }, P2 = () => it(D4(), z2, T2, M3 - E2 + 1, u2, d2, f2, g2.canonical);
        for (; E2 + C2 <= M3; ) {
          if (b2 += x3, b2 < l2 || b2 >= c2)
            return null;
          if (T2 = w2, S3.push(w2), p2 && I3.push(z2 || D4()), w2 = _2[b2], w2 === void 0) {
            z2 = new e.pointGeometry(h2.getx(b2), h2.gety(b2));
            const t3 = tt(z2, g2.canonical, u2, f2, d2);
            w2 = t3.signedDistanceFromCamera > 0 ? _2[b2] = t3.point : P2();
          } else
            z2 = null;
          E2 += C2, C2 = T2.dist(w2);
        }
        m2 && d2 && (z2 = z2 || new e.pointGeometry(h2.getx(b2), h2.gety(b2)), _2[b2] = w2 = _2[b2] === void 0 ? w2 : P2(), C2 = T2.dist(w2));
        const A3 = (M3 - E2) / C2, L3 = w2.sub(T2), R6 = L3.mult(A3)._add(T2);
        o2 && R6._add(L3._unit()._perp()._mult(o2 * x3));
        const k2 = y2 + Math.atan2(w2.y - T2.y, w2.x - T2.x);
        return S3.push(R6), p2 && (z2 = z2 || new e.pointGeometry(h2.getx(b2), h2.gety(b2)), I3.push(function(t3, i4, o3) {
          const r3 = 1 - o3;
          return new e.pointGeometry(t3.x * r3 + i4.x * o3, t3.y * r3 + i4.y * o3);
        }(I3.length > 0 ? I3[I3.length - 1] : z2, z2, A3))), { point: R6, angle: k2, path: S3, tilePath: I3 };
      }
      const rt = new Float32Array([-1 / 0, -1 / 0, 0, -1 / 0, -1 / 0, 0, -1 / 0, -1 / 0, 0, -1 / 0, -1 / 0, 0]);
      function nt(e2, t2) {
        for (let i3 = 0; i3 < e2; i3++) {
          const e3 = t2.length;
          t2.resize(e3 + 4), t2.float32.set(rt, 3 * e3);
        }
      }
      function at(e2, t2, i3) {
        const o2 = t2[0], r2 = t2[1];
        return e2[0] = i3[0] * o2 + i3[4] * r2 + i3[12], e2[1] = i3[1] * o2 + i3[5] * r2 + i3[13], e2[3] = i3[3] * o2 + i3[7] * r2 + i3[15], e2;
      }
      const st = 100;
      class lt {
        constructor(e2, t2, i3 = new Ve(e2.width + 200, e2.height + 200, 25), o2 = new Ve(e2.width + 200, e2.height + 200, 25)) {
          this.transform = e2, this.grid = i3, this.ignoredGrid = o2, this.pitchfactor = Math.cos(e2._pitch) * e2.cameraToCenterDistance, this.screenRightBoundary = e2.width + st, this.screenBottomBoundary = e2.height + st, this.gridRightBoundary = e2.width + 200, this.gridBottomBoundary = e2.height + 200, this.fogState = t2;
        }
        placeCollisionBox(e2, t2, i3, o2, r2, n2, a2) {
          let s3 = t2.projectedAnchorX, l2 = t2.projectedAnchorY, c2 = t2.projectedAnchorZ;
          const h2 = t2.elevation, u2 = t2.tileID;
          if (h2 && u2) {
            const e3 = this.transform.projection.createTileTransform(this.transform, this.transform.worldSize), i4 = e3.upVector(u2.canonical, t2.tileAnchorX, t2.tileAnchorY), o3 = e3.upVectorScale(u2.canonical);
            s3 += i4[0] * h2 * o3, l2 += i4[1] * h2 * o3, c2 += i4[2] * h2 * o3;
          }
          const _2 = this.projectAndGetPerspectiveRatio(n2, s3, l2, c2, t2.tileID), d2 = r2 * _2.perspectiveRatio, p2 = (t2.x1 * e2 + i3.x - t2.padding) * d2 + _2.point.x, m2 = (t2.y1 * e2 + i3.y - t2.padding) * d2 + _2.point.y, f2 = (t2.x2 * e2 + i3.x + t2.padding) * d2 + _2.point.x, g2 = (t2.y2 * e2 + i3.y + t2.padding) * d2 + _2.point.y, v3 = _2.perspectiveRatio <= 0.55 || _2.aboveHorizon;
          return !this.isInsideGrid(p2, m2, f2, g2) || !o2 && this.grid.hitTest(p2, m2, f2, g2, a2) || v3 ? { box: [], offscreen: false } : { box: [p2, m2, f2, g2], offscreen: this.isOffscreen(p2, m2, f2, g2) };
        }
        placeCollisionCircles(t2, i3, o2, r2, n2, a2, s3, l2, c2, h2, u2, _2, d2, p2) {
          const m2 = [], f2 = this.transform.elevation, g2 = this.transform.projection.createTileTransform(this.transform, this.transform.worldSize), v3 = f2 ? f2.getAtTileOffsetFunc(p2, g2) : (e2) => [0, 0, 0], x3 = new e.pointGeometry(i3.tileAnchorX, i3.tileAnchorY), y2 = this.transform.projection.projectTilePoint(i3.tileAnchorX, i3.tileAnchorY, p2.canonical), b2 = v3(x3), w2 = [y2.x + b2[0], y2.y + b2[1], y2.z + b2[2]], T2 = this.projectAndGetPerspectiveRatio(a2, w2[0], w2[1], w2[2], p2), { perspectiveRatio: E2 } = T2, C2 = (h2 ? n2 / E2 : n2 * E2) / e.ONE_EM, M3 = $e(new e.pointGeometry(w2[0], w2[1]), s3, w2[2]).point, S3 = T2.signedDistanceFromCamera > 0 ? Je(C2, r2, i3.lineOffsetX * C2, i3.lineOffsetY * C2, false, M3, x3, i3, o2, s3, {}, f2 && !h2 ? v3 : null, h2 && !!f2, this.transform.projection, p2) : null;
          let I3 = false, z2 = false, D4 = true;
          if (S3 && !T2.aboveHorizon) {
            const i4 = 0.5 * _2 * E2 + d2, o3 = new e.pointGeometry(-100, -100), r3 = new e.pointGeometry(this.screenRightBoundary, this.screenBottomBoundary), n3 = new Ze(), a3 = S3.first, s4 = S3.last;
            let h3 = [];
            for (let e2 = a3.path.length - 1; e2 >= 1; e2--)
              h3.push(a3.path[e2]);
            for (let e2 = 1; e2 < s4.path.length; e2++)
              h3.push(s4.path[e2]);
            const p3 = 2.5 * i4;
            if (l2) {
              const e2 = h3.map(f2 ? (e3, t3) => {
                const i5 = v3(t3 < a3.path.length - 1 ? a3.tilePath[a3.path.length - 1 - t3] : s4.tilePath[t3 - a3.path.length + 2]);
                return $e(e3, l2, i5[2]);
              } : (e3) => $e(e3, l2));
              h3 = e2.some((e3) => e3.signedDistanceFromCamera <= 0) ? [] : e2.map((e3) => e3.point);
            }
            let g3 = [];
            if (h3.length > 0) {
              const t3 = h3[0].clone(), i5 = h3[0].clone();
              for (let e2 = 1; e2 < h3.length; e2++)
                t3.x = Math.min(t3.x, h3[e2].x), t3.y = Math.min(t3.y, h3[e2].y), i5.x = Math.max(i5.x, h3[e2].x), i5.y = Math.max(i5.y, h3[e2].y);
              g3 = t3.x >= o3.x && i5.x <= r3.x && t3.y >= o3.y && i5.y <= r3.y ? [h3] : i5.x < o3.x || t3.x > r3.x || i5.y < o3.y || t3.y > r3.y ? [] : e.clipLine([h3], o3.x, o3.y, r3.x, r3.y);
            }
            for (const e2 of g3) {
              n3.reset(e2, 0.25 * i4);
              let o4 = 0;
              o4 = n3.length <= 0.5 * i4 ? 1 : Math.ceil(n3.paddedLength / p3) + 1;
              for (let e3 = 0; e3 < o4; e3++) {
                const r4 = e3 / Math.max(o4 - 1, 1), a4 = n3.lerp(r4), s5 = a4.x + st, l3 = a4.y + st;
                m2.push(s5, l3, i4, 0);
                const h4 = s5 - i4, _3 = l3 - i4, d3 = s5 + i4, p4 = l3 + i4;
                if (D4 = D4 && this.isOffscreen(h4, _3, d3, p4), z2 = z2 || this.isInsideGrid(h4, _3, d3, p4), !t2 && this.grid.hitTestCircle(s5, l3, i4, u2) && (I3 = true, !c2))
                  return { circles: [], offscreen: false, collisionDetected: I3 };
              }
            }
          }
          return { circles: !c2 && I3 || !z2 ? [] : m2, offscreen: D4, collisionDetected: I3 };
        }
        queryRenderedSymbols(t2) {
          if (t2.length === 0 || this.grid.keysLength() === 0 && this.ignoredGrid.keysLength() === 0)
            return {};
          const i3 = [];
          let o2 = 1 / 0, r2 = 1 / 0, n2 = -1 / 0, a2 = -1 / 0;
          for (const s4 of t2) {
            const t3 = new e.pointGeometry(s4.x + st, s4.y + st);
            o2 = Math.min(o2, t3.x), r2 = Math.min(r2, t3.y), n2 = Math.max(n2, t3.x), a2 = Math.max(a2, t3.y), i3.push(t3);
          }
          const s3 = this.grid.query(o2, r2, n2, a2).concat(this.ignoredGrid.query(o2, r2, n2, a2)), l2 = {}, c2 = {};
          for (const t3 of s3) {
            const o3 = t3.key;
            if (l2[o3.bucketInstanceId] === void 0 && (l2[o3.bucketInstanceId] = {}), l2[o3.bucketInstanceId][o3.featureIndex])
              continue;
            const r3 = [new e.pointGeometry(t3.x1, t3.y1), new e.pointGeometry(t3.x2, t3.y1), new e.pointGeometry(t3.x2, t3.y2), new e.pointGeometry(t3.x1, t3.y2)];
            e.polygonIntersectsPolygon(i3, r3) && (l2[o3.bucketInstanceId][o3.featureIndex] = true, c2[o3.bucketInstanceId] === void 0 && (c2[o3.bucketInstanceId] = []), c2[o3.bucketInstanceId].push(o3.featureIndex));
          }
          return c2;
        }
        insertCollisionBox(e2, t2, i3, o2, r2) {
          (t2 ? this.ignoredGrid : this.grid).insert({ bucketInstanceId: i3, featureIndex: o2, collisionGroupID: r2 }, e2[0], e2[1], e2[2], e2[3]);
        }
        insertCollisionCircles(e2, t2, i3, o2, r2) {
          const n2 = t2 ? this.ignoredGrid : this.grid, a2 = { bucketInstanceId: i3, featureIndex: o2, collisionGroupID: r2 };
          for (let t3 = 0; t3 < e2.length; t3 += 4)
            n2.insertCircle(a2, e2[t3], e2[t3 + 1], e2[t3 + 2]);
        }
        projectAndGetPerspectiveRatio(t2, i3, o2, r2, n2) {
          const a2 = [i3, o2, r2 || 0, 1];
          let s3 = false;
          if (r2 || this.transform.pitch > 0) {
            e.transformMat4$1(a2, a2, t2);
            let l2 = false;
            this.fogState && n2 && (l2 = function(t3, i4, o3, r3, n3, a3) {
              const s4 = a3.calculateFogTileMatrix(n3), l3 = [i4, o3, r3];
              return e.transformMat4(l3, l3, s4), y(t3, l3, a3.pitch, a3._fov);
            }(this.fogState, i3, o2, r2 || 0, n2.toUnwrapped(), this.transform) > 0.9), s3 = a2[2] > a2[3] || l2;
          } else
            at(a2, a2, t2);
          return { point: new e.pointGeometry((a2[0] / a2[3] + 1) / 2 * this.transform.width + st, (-a2[1] / a2[3] + 1) / 2 * this.transform.height + st), perspectiveRatio: Math.min(0.5 + this.transform.cameraToCenterDistance / a2[3] * 0.5, 1.5), signedDistanceFromCamera: a2[3], aboveHorizon: s3 };
        }
        isOffscreen(e2, t2, i3, o2) {
          return i3 < st || e2 >= this.screenRightBoundary || o2 < st || t2 > this.screenBottomBoundary;
        }
        isInsideGrid(e2, t2, i3, o2) {
          return i3 >= 0 && e2 < this.gridRightBoundary && o2 >= 0 && t2 < this.gridBottomBoundary;
        }
        getViewportMatrix() {
          const t2 = e.identity([]);
          return e.translate(t2, t2, [-100, -100, 0]), t2;
        }
      }
      class ct {
        constructor(e2, t2, i3, o2) {
          this.opacity = e2 ? Math.max(0, Math.min(1, e2.opacity + (e2.placed ? t2 : -t2))) : o2 && i3 ? 1 : 0, this.placed = i3;
        }
        isHidden() {
          return this.opacity === 0 && !this.placed;
        }
      }
      class ht {
        constructor(e2, t2, i3, o2, r2, n2 = false) {
          this.text = new ct(e2 ? e2.text : null, t2, i3, r2), this.icon = new ct(e2 ? e2.icon : null, t2, o2, r2), this.clipped = n2;
        }
        isHidden() {
          return this.text.isHidden() && this.icon.isHidden();
        }
      }
      class ut {
        constructor(e2, t2, i3, o2 = false) {
          this.text = e2, this.icon = t2, this.skipFade = i3, this.clipped = o2;
        }
      }
      class _t {
        constructor() {
          this.invProjMatrix = e.create(), this.viewportMatrix = e.create(), this.circles = [];
        }
      }
      class dt {
        constructor(e2, t2, i3, o2, r2) {
          this.bucketInstanceId = e2, this.featureIndex = t2, this.sourceLayerIndex = i3, this.bucketIndex = o2, this.tileID = r2;
        }
      }
      class pt {
        constructor(e2) {
          this.crossSourceCollisions = e2, this.maxGroupID = 0, this.collisionGroups = {};
        }
        get(e2) {
          if (this.crossSourceCollisions)
            return { ID: 0, predicate: null };
          if (!this.collisionGroups[e2]) {
            const t2 = ++this.maxGroupID;
            this.collisionGroups[e2] = { ID: t2, predicate: (e3) => e3.collisionGroupID === t2 };
          }
          return this.collisionGroups[e2];
        }
      }
      function mt(t2, i3, o2, r2, n2) {
        const { horizontalAlign: a2, verticalAlign: s3 } = e.getAnchorAlignment(t2), l2 = -(a2 - 0.5) * i3, c2 = -(s3 - 0.5) * o2, h2 = e.evaluateVariableOffset(t2, r2);
        return new e.pointGeometry(l2 + h2[0] * n2, c2 + h2[1] * n2);
      }
      function ft(t2, i3, o2, r2, n2) {
        const a2 = new e.pointGeometry(t2, i3);
        return o2 && a2._rotate(r2 ? n2 : -n2), a2;
      }
      class gt {
        constructor(e2, t2, i3, o2, r2) {
          this.transform = e2.clone(), this.collisionIndex = new lt(this.transform, r2), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = false, this.commitTime = 0, this.fadeDuration = t2, this.retainedQueryData = {}, this.collisionGroups = new pt(i3), this.collisionCircleArrays = {}, this.prevPlacement = o2, o2 && (o2.prevPlacement = void 0), this.placedOrientations = {};
        }
        getBucketParts(t2, i3, o2, r2) {
          const n2 = o2.getBucket(i3), a2 = o2.latestFeatureIndex;
          if (!n2 || !a2 || i3.id !== n2.layerIds[0])
            return;
          const s3 = n2.layers[0].layout, l2 = o2.collisionBoxArray, c2 = Math.pow(2, this.transform.zoom - o2.tileID.overscaledZ), h2 = o2.tileSize / e.EXTENT, u2 = o2.tileID.toUnwrapped(), _2 = this.transform.calculateProjMatrix(u2), d2 = s3.get("text-pitch-alignment") === "map", p2 = s3.get("text-rotation-alignment") === "map";
          i3.compileFilter();
          const m2 = i3.dynamicFilter(), f2 = i3.dynamicFilterNeedsFeature(), g2 = this.transform.calculatePixelsToTileUnitsMatrix(o2), v3 = qe(_2, o2.tileID.canonical, d2, p2, this.transform, g2);
          let x3 = null;
          if (d2) {
            const t3 = Xe(_2, o2.tileID.canonical, d2, p2, this.transform, g2);
            x3 = e.multiply$1([], this.transform.labelPlaneMatrix, t3);
          }
          let y2 = null;
          m2 && o2.latestFeatureIndex && (y2 = { unwrappedTileID: u2, dynamicFilter: m2, dynamicFilterNeedsFeature: f2, featureIndex: o2.latestFeatureIndex }), this.retainedQueryData[n2.bucketInstanceId] = new dt(n2.bucketInstanceId, a2, n2.sourceLayerIndex, n2.index, o2.tileID);
          const b2 = { bucket: n2, layout: s3, posMatrix: _2, textLabelPlaneMatrix: v3, labelToScreenMatrix: x3, clippingData: y2, scale: c2, textPixelRatio: h2, holdingForFade: o2.holdingForFade(), collisionBoxArray: l2, partiallyEvaluatedTextSize: e.evaluateSizeForZoom(n2.textSizeData, this.transform.zoom), partiallyEvaluatedIconSize: e.evaluateSizeForZoom(n2.iconSizeData, this.transform.zoom), collisionGroup: this.collisionGroups.get(n2.sourceID) };
          if (r2)
            for (const e2 of n2.sortKeyRanges) {
              const { sortKey: i4, symbolInstanceStart: o3, symbolInstanceEnd: r3 } = e2;
              t2.push({ sortKey: i4, symbolInstanceStart: o3, symbolInstanceEnd: r3, parameters: b2 });
            }
          else
            t2.push({ symbolInstanceStart: 0, symbolInstanceEnd: n2.symbolInstances.length, parameters: b2 });
        }
        attemptAnchorPlacement(e2, t2, i3, o2, r2, n2, a2, s3, l2, c2, h2, u2, _2, d2, p2, m2, f2, g2) {
          const v3 = [u2.textOffset0, u2.textOffset1], x3 = mt(e2, i3, o2, v3, r2), y2 = this.collisionIndex.placeCollisionBox(r2, t2, ft(x3.x, x3.y, n2, a2, this.transform.angle), h2, s3, l2, c2.predicate);
          if ((!m2 || this.collisionIndex.placeCollisionBox(d2.getSymbolInstanceIconSize(g2, this.transform.zoom, _2), m2, ft(x3.x, x3.y, n2, a2, this.transform.angle), h2, s3, l2, c2.predicate).box.length !== 0) && y2.box.length > 0) {
            let t3;
            return this.prevPlacement && this.prevPlacement.variableOffsets[u2.crossTileID] && this.prevPlacement.placements[u2.crossTileID] && this.prevPlacement.placements[u2.crossTileID].text && (t3 = this.prevPlacement.variableOffsets[u2.crossTileID].anchor), this.variableOffsets[u2.crossTileID] = { textOffset: v3, width: i3, height: o2, anchor: e2, textScale: r2, prevAnchor: t3 }, this.markUsedJustification(d2, e2, u2, p2), d2.allowVerticalPlacement && (this.markUsedOrientation(d2, p2, u2), this.placedOrientations[u2.crossTileID] = p2), { shift: x3, placedGlyphBoxes: y2 };
          }
        }
        placeLayerBucketPart(t2, i3, o2, r2) {
          const { bucket: n2, layout: a2, posMatrix: s3, textLabelPlaneMatrix: l2, labelToScreenMatrix: c2, clippingData: h2, textPixelRatio: u2, holdingForFade: _2, collisionBoxArray: d2, partiallyEvaluatedTextSize: p2, partiallyEvaluatedIconSize: m2, collisionGroup: f2 } = t2.parameters, g2 = a2.get("text-optional"), v3 = a2.get("icon-optional"), x3 = a2.get("text-allow-overlap"), y2 = a2.get("icon-allow-overlap"), b2 = a2.get("text-rotation-alignment") === "map", w2 = a2.get("text-pitch-alignment") === "map", T2 = a2.get("icon-text-fit") !== "none", E2 = a2.get("symbol-z-order") === "viewport-y", C2 = x3 && (y2 || !n2.hasIconData() || v3), M3 = y2 && (x3 || !n2.hasTextData() || g2);
          !n2.collisionArrays && d2 && n2.deserializeCollisionBoxes(d2), o2 && r2 && n2.updateCollisionDebugBuffers(this.transform.zoom, d2);
          const S3 = (t3, r3, d3) => {
            if (h2) {
              const o3 = { zoom: this.transform.zoom, pitch: this.transform.pitch };
              let r4 = null;
              if (h2.dynamicFilterNeedsFeature) {
                const e2 = this.retainedQueryData[n2.bucketInstanceId];
                r4 = h2.featureIndex.loadFeature({ featureIndex: t3.featureIndex, bucketIndex: e2.bucketIndex, sourceLayerIndex: e2.sourceLayerIndex, layoutVertexArrayOffset: 0 });
              }
              if (!(0, h2.dynamicFilter)(o3, r4, this.retainedQueryData[n2.bucketInstanceId].tileID.canonical, new e.pointGeometry(t3.tileAnchorX, t3.tileAnchorY), this.transform.calculateDistanceTileData(h2.unwrappedTileID)))
                return this.placements[t3.crossTileID] = new ut(false, false, false, true), void (i3[t3.crossTileID] = true);
            }
            if (i3[t3.crossTileID])
              return;
            if (_2)
              return void (this.placements[t3.crossTileID] = new ut(false, false, false));
            let E3 = false, S4 = false, I3 = true, z2 = null, D4 = { box: null, offscreen: null }, P2 = { box: null, offscreen: null }, A3 = null, L3 = null, R6 = null, k2 = 0, O2 = 0, B3 = 0;
            d3.textFeatureIndex ? k2 = d3.textFeatureIndex : t3.useRuntimeCollisionCircles && (k2 = t3.featureIndex), d3.verticalTextFeatureIndex && (O2 = d3.verticalTextFeatureIndex);
            const F2 = (e2) => {
              e2.tileID = this.retainedQueryData[n2.bucketInstanceId].tileID, (this.transform.elevation || e2.elevation) && (e2.elevation = this.transform.elevation ? this.transform.elevation.getAtTileOffset(this.retainedQueryData[n2.bucketInstanceId].tileID, e2.tileAnchorX, e2.tileAnchorY) : 0);
            }, U2 = d3.textBox;
            if (U2) {
              F2(U2);
              const i4 = (i5) => {
                let o4 = e.WritingMode.horizontal;
                if (n2.allowVerticalPlacement && !i5 && this.prevPlacement) {
                  const e2 = this.prevPlacement.placedOrientations[t3.crossTileID];
                  e2 && (this.placedOrientations[t3.crossTileID] = e2, o4 = e2, this.markUsedOrientation(n2, o4, t3));
                }
                return o4;
              }, o3 = (i5, o4) => {
                if (n2.allowVerticalPlacement && t3.numVerticalGlyphVertices > 0 && d3.verticalTextBox) {
                  for (const t4 of n2.writingModes)
                    if (t4 === e.WritingMode.vertical ? (D4 = o4(), P2 = D4) : D4 = i5(), D4 && D4.box && D4.box.length)
                      break;
                } else
                  D4 = i5();
              };
              if (a2.get("text-variable-anchor")) {
                let l3 = a2.get("text-variable-anchor");
                if (this.prevPlacement && this.prevPlacement.variableOffsets[t3.crossTileID]) {
                  const e2 = this.prevPlacement.variableOffsets[t3.crossTileID];
                  l3.indexOf(e2.anchor) > 0 && (l3 = l3.filter((t4) => t4 !== e2.anchor), l3.unshift(e2.anchor));
                }
                const c3 = (e2, i5, o4) => {
                  const a3 = n2.getSymbolInstanceTextSize(p2, t3, this.transform.zoom, r3), c4 = (e2.x2 - e2.x1) * a3 + 2 * e2.padding, h4 = (e2.y2 - e2.y1) * a3 + 2 * e2.padding, _3 = T2 && !y2 ? i5 : null;
                  _3 && F2(_3);
                  let d4 = { box: [], offscreen: false };
                  const g3 = x3 ? 2 * l3.length : l3.length;
                  for (let i6 = 0; i6 < g3; ++i6) {
                    const g4 = this.attemptAnchorPlacement(l3[i6 % l3.length], e2, c4, h4, a3, b2, w2, u2, s3, f2, i6 >= l3.length, t3, r3, n2, o4, _3, p2, m2);
                    if (g4 && (d4 = g4.placedGlyphBoxes, d4 && d4.box && d4.box.length)) {
                      E3 = true, z2 = g4.shift;
                      break;
                    }
                  }
                  return d4;
                };
                o3(() => c3(U2, d3.iconBox, e.WritingMode.horizontal), () => {
                  const i5 = d3.verticalTextBox;
                  return i5 && F2(i5), n2.allowVerticalPlacement && !(D4 && D4.box && D4.box.length) && t3.numVerticalGlyphVertices > 0 && i5 ? c3(i5, d3.verticalIconBox, e.WritingMode.vertical) : { box: null, offscreen: null };
                }), D4 && (E3 = D4.box, I3 = D4.offscreen);
                const h3 = i4(D4 && D4.box);
                if (!E3 && this.prevPlacement) {
                  const e2 = this.prevPlacement.variableOffsets[t3.crossTileID];
                  e2 && (this.variableOffsets[t3.crossTileID] = e2, this.markUsedJustification(n2, e2.anchor, t3, h3));
                }
              } else {
                const a3 = (i5, o4) => {
                  const a4 = n2.getSymbolInstanceTextSize(p2, t3, this.transform.zoom, r3), l3 = this.collisionIndex.placeCollisionBox(a4, i5, new e.pointGeometry(0, 0), x3, u2, s3, f2.predicate);
                  return l3 && l3.box && l3.box.length && (this.markUsedOrientation(n2, o4, t3), this.placedOrientations[t3.crossTileID] = o4), l3;
                };
                o3(() => a3(U2, e.WritingMode.horizontal), () => {
                  const i5 = d3.verticalTextBox;
                  return n2.allowVerticalPlacement && t3.numVerticalGlyphVertices > 0 && i5 ? (F2(i5), a3(i5, e.WritingMode.vertical)) : { box: null, offscreen: null };
                }), i4(D4 && D4.box && D4.box.length);
              }
            }
            if (A3 = D4, E3 = A3 && A3.box && A3.box.length > 0, I3 = A3 && A3.offscreen, t3.useRuntimeCollisionCircles) {
              const i4 = n2.text.placedSymbolArray.get(t3.centerJustifiedTextSymbolIndex >= 0 ? t3.centerJustifiedTextSymbolIndex : t3.verticalPlacedTextSymbolIndex), r4 = e.evaluateSizeForFeature(n2.textSizeData, p2, i4), h3 = a2.get("text-padding");
              L3 = this.collisionIndex.placeCollisionCircles(x3, i4, n2.lineVertexArray, n2.glyphOffsetArray, r4, s3, l2, c2, o2, w2, f2.predicate, t3.collisionCircleDiameter * r4 / e.ONE_EM, h3, this.retainedQueryData[n2.bucketInstanceId].tileID), E3 = x3 || L3.circles.length > 0 && !L3.collisionDetected, I3 = I3 && L3.offscreen;
            }
            if (d3.iconFeatureIndex && (B3 = d3.iconFeatureIndex), d3.iconBox) {
              const t4 = (t5) => {
                F2(t5);
                const i4 = T2 && z2 ? ft(z2.x, z2.y, b2, w2, this.transform.angle) : new e.pointGeometry(0, 0), o3 = n2.getSymbolInstanceIconSize(m2, this.transform.zoom, r3);
                return this.collisionIndex.placeCollisionBox(o3, t5, i4, y2, u2, s3, f2.predicate);
              };
              P2 && P2.box && P2.box.length && d3.verticalIconBox ? (R6 = t4(d3.verticalIconBox), S4 = R6.box.length > 0) : (R6 = t4(d3.iconBox), S4 = R6.box.length > 0), I3 = I3 && R6.offscreen;
            }
            const N2 = g2 || t3.numHorizontalGlyphVertices === 0 && t3.numVerticalGlyphVertices === 0, G2 = v3 || t3.numIconVertices === 0;
            if (N2 || G2 ? G2 ? N2 || (S4 = S4 && E3) : E3 = S4 && E3 : S4 = E3 = S4 && E3, E3 && A3 && A3.box && this.collisionIndex.insertCollisionBox(A3.box, a2.get("text-ignore-placement"), n2.bucketInstanceId, P2 && P2.box && O2 ? O2 : k2, f2.ID), S4 && R6 && this.collisionIndex.insertCollisionBox(R6.box, a2.get("icon-ignore-placement"), n2.bucketInstanceId, B3, f2.ID), L3 && (E3 && this.collisionIndex.insertCollisionCircles(L3.circles, a2.get("text-ignore-placement"), n2.bucketInstanceId, k2, f2.ID), o2)) {
              const e2 = n2.bucketInstanceId;
              let t4 = this.collisionCircleArrays[e2];
              t4 === void 0 && (t4 = this.collisionCircleArrays[e2] = new _t());
              for (let e3 = 0; e3 < L3.circles.length; e3 += 4)
                t4.circles.push(L3.circles[e3 + 0]), t4.circles.push(L3.circles[e3 + 1]), t4.circles.push(L3.circles[e3 + 2]), t4.circles.push(L3.collisionDetected ? 1 : 0);
            }
            this.placements[t3.crossTileID] = new ut(E3 || C2, S4 || M3, I3 || n2.justReloaded), i3[t3.crossTileID] = true;
          };
          if (E2) {
            const e2 = n2.getSortedSymbolIndexes(this.transform.angle);
            for (let t3 = e2.length - 1; t3 >= 0; --t3) {
              const i4 = e2[t3];
              S3(n2.symbolInstances.get(i4), i4, n2.collisionArrays[i4]);
            }
          } else
            for (let e2 = t2.symbolInstanceStart; e2 < t2.symbolInstanceEnd; e2++)
              S3(n2.symbolInstances.get(e2), e2, n2.collisionArrays[e2]);
          if (o2 && n2.bucketInstanceId in this.collisionCircleArrays) {
            const t3 = this.collisionCircleArrays[n2.bucketInstanceId];
            e.invert(t3.invProjMatrix, s3), t3.viewportMatrix = this.collisionIndex.getViewportMatrix();
          }
          n2.justReloaded = false;
        }
        markUsedJustification(t2, i3, o2, r2) {
          let n2;
          n2 = r2 === e.WritingMode.vertical ? o2.verticalPlacedTextSymbolIndex : { left: o2.leftJustifiedTextSymbolIndex, center: o2.centerJustifiedTextSymbolIndex, right: o2.rightJustifiedTextSymbolIndex }[e.getAnchorJustification(i3)];
          const a2 = [o2.leftJustifiedTextSymbolIndex, o2.centerJustifiedTextSymbolIndex, o2.rightJustifiedTextSymbolIndex, o2.verticalPlacedTextSymbolIndex];
          for (const e2 of a2)
            e2 >= 0 && (t2.text.placedSymbolArray.get(e2).crossTileID = n2 >= 0 && e2 !== n2 ? 0 : o2.crossTileID);
        }
        markUsedOrientation(t2, i3, o2) {
          const r2 = i3 === e.WritingMode.horizontal || i3 === e.WritingMode.horizontalOnly ? i3 : 0, n2 = i3 === e.WritingMode.vertical ? i3 : 0, a2 = [o2.leftJustifiedTextSymbolIndex, o2.centerJustifiedTextSymbolIndex, o2.rightJustifiedTextSymbolIndex];
          for (const e2 of a2)
            t2.text.placedSymbolArray.get(e2).placedOrientation = r2;
          o2.verticalPlacedTextSymbolIndex && (t2.text.placedSymbolArray.get(o2.verticalPlacedTextSymbolIndex).placedOrientation = n2);
        }
        commit(e2) {
          this.commitTime = e2, this.zoomAtLastRecencyCheck = this.transform.zoom;
          const t2 = this.prevPlacement;
          let i3 = false;
          this.prevZoomAdjustment = t2 ? t2.zoomAdjustment(this.transform.zoom) : 0;
          const o2 = t2 ? t2.symbolFadeChange(e2) : 1, r2 = t2 ? t2.opacities : {}, n2 = t2 ? t2.variableOffsets : {}, a2 = t2 ? t2.placedOrientations : {};
          for (const e3 in this.placements) {
            const t3 = this.placements[e3], n3 = r2[e3];
            n3 ? (this.opacities[e3] = new ht(n3, o2, t3.text, t3.icon, null, t3.clipped), i3 = i3 || t3.text !== n3.text.placed || t3.icon !== n3.icon.placed) : (this.opacities[e3] = new ht(null, o2, t3.text, t3.icon, t3.skipFade, t3.clipped), i3 = i3 || t3.text || t3.icon);
          }
          for (const e3 in r2) {
            const t3 = r2[e3];
            if (!this.opacities[e3]) {
              const r3 = new ht(t3, o2, false, false);
              r3.isHidden() || (this.opacities[e3] = r3, i3 = i3 || t3.text.placed || t3.icon.placed);
            }
          }
          for (const e3 in n2)
            this.variableOffsets[e3] || !this.opacities[e3] || this.opacities[e3].isHidden() || (this.variableOffsets[e3] = n2[e3]);
          for (const e3 in a2)
            this.placedOrientations[e3] || !this.opacities[e3] || this.opacities[e3].isHidden() || (this.placedOrientations[e3] = a2[e3]);
          i3 ? this.lastPlacementChangeTime = e2 : typeof this.lastPlacementChangeTime != "number" && (this.lastPlacementChangeTime = t2 ? t2.lastPlacementChangeTime : e2);
        }
        updateLayerOpacities(e2, t2) {
          const i3 = {};
          for (const o2 of t2) {
            const t3 = o2.getBucket(e2);
            t3 && o2.latestFeatureIndex && e2.id === t3.layerIds[0] && this.updateBucketOpacities(t3, i3, o2.collisionBoxArray);
          }
        }
        updateBucketOpacities(t2, i3, o2) {
          t2.hasTextData() && t2.text.opacityVertexArray.clear(), t2.hasIconData() && t2.icon.opacityVertexArray.clear(), t2.hasIconCollisionBoxData() && t2.iconCollisionBox.collisionVertexArray.clear(), t2.hasTextCollisionBoxData() && t2.textCollisionBox.collisionVertexArray.clear();
          const r2 = t2.layers[0].layout, n2 = !!t2.layers[0].dynamicFilter(), a2 = new ht(null, 0, false, false, true), s3 = r2.get("text-allow-overlap"), l2 = r2.get("icon-allow-overlap"), c2 = r2.get("text-variable-anchor"), h2 = r2.get("text-rotation-alignment") === "map", u2 = r2.get("text-pitch-alignment") === "map", _2 = r2.get("icon-text-fit") !== "none", d2 = new ht(null, 0, s3 && (l2 || !t2.hasIconData() || r2.get("icon-optional")), l2 && (s3 || !t2.hasTextData() || r2.get("text-optional")), true);
          !t2.collisionArrays && o2 && (t2.hasIconCollisionBoxData() || t2.hasTextCollisionBoxData()) && t2.deserializeCollisionBoxes(o2);
          const p2 = (e2, t3, i4) => {
            for (let o3 = 0; o3 < t3 / 4; o3++)
              e2.opacityVertexArray.emplaceBack(i4);
          };
          let m2 = 0;
          for (let o3 = 0; o3 < t2.symbolInstances.length; o3++) {
            const r3 = t2.symbolInstances.get(o3), { numHorizontalGlyphVertices: s4, numVerticalGlyphVertices: l3, crossTileID: f2 } = r3;
            let g2 = this.opacities[f2];
            i3[f2] ? g2 = a2 : g2 || (g2 = d2, this.opacities[f2] = g2), i3[f2] = true;
            const v3 = s4 > 0 || l3 > 0, x3 = r3.numIconVertices > 0, y2 = this.placedOrientations[r3.crossTileID], b2 = y2 === e.WritingMode.vertical, w2 = y2 === e.WritingMode.horizontal || y2 === e.WritingMode.horizontalOnly;
            if (!v3 && !x3 || g2.isHidden() || m2++, v3) {
              const e2 = Mt(g2.text);
              p2(t2.text, s4, b2 ? St : e2), p2(t2.text, l3, w2 ? St : e2);
              const i4 = g2.text.isHidden();
              [r3.rightJustifiedTextSymbolIndex, r3.centerJustifiedTextSymbolIndex, r3.leftJustifiedTextSymbolIndex].forEach((e3) => {
                e3 >= 0 && (t2.text.placedSymbolArray.get(e3).hidden = i4 || b2 ? 1 : 0);
              }), r3.verticalPlacedTextSymbolIndex >= 0 && (t2.text.placedSymbolArray.get(r3.verticalPlacedTextSymbolIndex).hidden = i4 || w2 ? 1 : 0);
              const o4 = this.variableOffsets[r3.crossTileID];
              o4 && this.markUsedJustification(t2, o4.anchor, r3, y2);
              const n3 = this.placedOrientations[r3.crossTileID];
              n3 && (this.markUsedJustification(t2, "left", r3, n3), this.markUsedOrientation(t2, n3, r3));
            }
            if (x3) {
              const e2 = Mt(g2.icon);
              r3.placedIconSymbolIndex >= 0 && (p2(t2.icon, r3.numIconVertices, b2 ? St : e2), t2.icon.placedSymbolArray.get(r3.placedIconSymbolIndex).hidden = g2.icon.isHidden()), r3.verticalPlacedIconSymbolIndex >= 0 && (p2(t2.icon, r3.numVerticalIconVertices, w2 ? St : e2), t2.icon.placedSymbolArray.get(r3.verticalPlacedIconSymbolIndex).hidden = g2.icon.isHidden());
            }
            if (t2.hasIconCollisionBoxData() || t2.hasTextCollisionBoxData()) {
              const i4 = t2.collisionArrays[o3];
              if (i4) {
                let o4 = new e.pointGeometry(0, 0), r4 = true;
                if (i4.textBox || i4.verticalTextBox) {
                  if (c2) {
                    const e2 = this.variableOffsets[f2];
                    e2 ? (o4 = mt(e2.anchor, e2.width, e2.height, e2.textOffset, e2.textScale), h2 && o4._rotate(u2 ? this.transform.angle : -this.transform.angle)) : r4 = false;
                  }
                  n2 && (r4 = !g2.clipped), i4.textBox && vt(t2.textCollisionBox.collisionVertexArray, g2.text.placed, !r4 || b2, o4.x, o4.y), i4.verticalTextBox && vt(t2.textCollisionBox.collisionVertexArray, g2.text.placed, !r4 || w2, o4.x, o4.y);
                }
                const a3 = r4 && Boolean(!w2 && i4.verticalIconBox);
                i4.iconBox && vt(t2.iconCollisionBox.collisionVertexArray, g2.icon.placed, a3, _2 ? o4.x : 0, _2 ? o4.y : 0), i4.verticalIconBox && vt(t2.iconCollisionBox.collisionVertexArray, g2.icon.placed, !a3, _2 ? o4.x : 0, _2 ? o4.y : 0);
              }
            }
          }
          if (t2.fullyClipped = m2 === 0, t2.sortFeatures(this.transform.angle), this.retainedQueryData[t2.bucketInstanceId] && (this.retainedQueryData[t2.bucketInstanceId].featureSortOrder = t2.featureSortOrder), t2.hasTextData() && t2.text.opacityVertexBuffer && t2.text.opacityVertexBuffer.updateData(t2.text.opacityVertexArray), t2.hasIconData() && t2.icon.opacityVertexBuffer && t2.icon.opacityVertexBuffer.updateData(t2.icon.opacityVertexArray), t2.hasIconCollisionBoxData() && t2.iconCollisionBox.collisionVertexBuffer && t2.iconCollisionBox.collisionVertexBuffer.updateData(t2.iconCollisionBox.collisionVertexArray), t2.hasTextCollisionBoxData() && t2.textCollisionBox.collisionVertexBuffer && t2.textCollisionBox.collisionVertexBuffer.updateData(t2.textCollisionBox.collisionVertexArray), t2.bucketInstanceId in this.collisionCircleArrays) {
            const e2 = this.collisionCircleArrays[t2.bucketInstanceId];
            t2.placementInvProjMatrix = e2.invProjMatrix, t2.placementViewportMatrix = e2.viewportMatrix, t2.collisionCircleArray = e2.circles, delete this.collisionCircleArrays[t2.bucketInstanceId];
          }
        }
        symbolFadeChange(e2) {
          return this.fadeDuration === 0 ? 1 : (e2 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
        }
        zoomAdjustment(e2) {
          return Math.max(0, (this.transform.zoom - e2) / 1.5);
        }
        hasTransitions(e2) {
          return this.stale || e2 - this.lastPlacementChangeTime < this.fadeDuration;
        }
        stillRecent(e2, t2) {
          const i3 = this.zoomAtLastRecencyCheck === t2 ? 1 - this.zoomAdjustment(t2) : 1;
          return this.zoomAtLastRecencyCheck = t2, this.commitTime + this.fadeDuration * i3 > e2;
        }
        setStale() {
          this.stale = true;
        }
      }
      function vt(e2, t2, i3, o2, r2) {
        e2.emplaceBack(t2 ? 1 : 0, i3 ? 1 : 0, o2 || 0, r2 || 0), e2.emplaceBack(t2 ? 1 : 0, i3 ? 1 : 0, o2 || 0, r2 || 0), e2.emplaceBack(t2 ? 1 : 0, i3 ? 1 : 0, o2 || 0, r2 || 0), e2.emplaceBack(t2 ? 1 : 0, i3 ? 1 : 0, o2 || 0, r2 || 0);
      }
      const xt = Math.pow(2, 25), yt = Math.pow(2, 24), bt = Math.pow(2, 17), wt = Math.pow(2, 16), Tt = Math.pow(2, 9), Et = Math.pow(2, 8), Ct = Math.pow(2, 1);
      function Mt(e2) {
        if (e2.opacity === 0 && !e2.placed)
          return 0;
        if (e2.opacity === 1 && e2.placed)
          return 4294967295;
        const t2 = e2.placed ? 1 : 0, i3 = Math.floor(127 * e2.opacity);
        return i3 * xt + t2 * yt + i3 * bt + t2 * wt + i3 * Tt + t2 * Et + i3 * Ct + t2;
      }
      const St = 0;
      class It {
        constructor(e2) {
          this._sortAcrossTiles = e2.layout.get("symbol-z-order") !== "viewport-y" && e2.layout.get("symbol-sort-key").constantOr(1) !== void 0, this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
        }
        continuePlacement(e2, t2, i3, o2, r2) {
          const n2 = this._bucketParts;
          for (; this._currentTileIndex < e2.length; )
            if (t2.getBucketParts(n2, o2, e2[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, r2())
              return true;
          for (this._sortAcrossTiles && (this._sortAcrossTiles = false, n2.sort((e3, t3) => e3.sortKey - t3.sortKey)); this._currentPartIndex < n2.length; ) {
            const e3 = n2[this._currentPartIndex];
            if (t2.placeLayerBucketPart(e3, this._seenCrossTileIDs, i3, e3.symbolInstanceStart === 0), this._currentPartIndex++, r2())
              return true;
          }
          return false;
        }
      }
      class zt {
        constructor(e2, t2, i3, o2, r2, n2, a2, s3) {
          this.placement = new gt(e2, r2, n2, a2, s3), this._currentPlacementIndex = t2.length - 1, this._forceFullPlacement = i3, this._showCollisionBoxes = o2, this._done = false;
        }
        isDone() {
          return this._done;
        }
        continuePlacement(t2, i3, o2) {
          const r2 = e.exported.now(), n2 = () => {
            const t3 = e.exported.now() - r2;
            return !this._forceFullPlacement && t3 > 2;
          };
          for (; this._currentPlacementIndex >= 0; ) {
            const e2 = i3[t2[this._currentPlacementIndex]], r3 = this.placement.collisionIndex.transform.zoom;
            if (e2.type === "symbol" && (!e2.minzoom || e2.minzoom <= r3) && (!e2.maxzoom || e2.maxzoom > r3)) {
              if (this._inProgressLayer || (this._inProgressLayer = new It(e2)), this._inProgressLayer.continuePlacement(o2[e2.source], this.placement, this._showCollisionBoxes, e2, n2))
                return;
              delete this._inProgressLayer;
            }
            this._currentPlacementIndex--;
          }
          this._done = true;
        }
        commit(e2) {
          return this.placement.commit(e2), this.placement;
        }
      }
      const Dt = 512 / e.EXTENT / 2;
      class Pt {
        constructor(e2, t2, i3) {
          this.tileID = e2, this.indexedSymbolInstances = {}, this.bucketInstanceId = i3;
          for (let i4 = 0; i4 < t2.length; i4++) {
            const o2 = t2.get(i4), r2 = o2.key;
            this.indexedSymbolInstances[r2] || (this.indexedSymbolInstances[r2] = []), this.indexedSymbolInstances[r2].push({ crossTileID: o2.crossTileID, coord: this.getScaledCoordinates(o2, e2) });
          }
        }
        getScaledCoordinates(t2, i3) {
          const o2 = Dt / Math.pow(2, i3.canonical.z - this.tileID.canonical.z);
          return { x: Math.floor((i3.canonical.x * e.EXTENT + t2.tileAnchorX) * o2), y: Math.floor((i3.canonical.y * e.EXTENT + t2.tileAnchorY) * o2) };
        }
        findMatches(e2, t2, i3) {
          const o2 = this.tileID.canonical.z < t2.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - t2.canonical.z);
          for (let r2 = 0; r2 < e2.length; r2++) {
            const n2 = e2.get(r2);
            if (n2.crossTileID)
              continue;
            const a2 = this.indexedSymbolInstances[n2.key];
            if (!a2)
              continue;
            const s3 = this.getScaledCoordinates(n2, t2);
            for (const e3 of a2)
              if (Math.abs(e3.coord.x - s3.x) <= o2 && Math.abs(e3.coord.y - s3.y) <= o2 && !i3[e3.crossTileID]) {
                i3[e3.crossTileID] = true, n2.crossTileID = e3.crossTileID;
                break;
              }
          }
        }
      }
      class At {
        constructor() {
          this.maxCrossTileID = 0;
        }
        generate() {
          return ++this.maxCrossTileID;
        }
      }
      class Lt {
        constructor() {
          this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
        }
        handleWrapJump(e2) {
          const t2 = Math.round((e2 - this.lng) / 360);
          if (t2 !== 0)
            for (const e3 in this.indexes) {
              const i3 = this.indexes[e3], o2 = {};
              for (const e4 in i3) {
                const r2 = i3[e4];
                r2.tileID = r2.tileID.unwrapTo(r2.tileID.wrap + t2), o2[r2.tileID.key] = r2;
              }
              this.indexes[e3] = o2;
            }
          this.lng = e2;
        }
        addBucket(e2, t2, i3) {
          if (this.indexes[e2.overscaledZ] && this.indexes[e2.overscaledZ][e2.key]) {
            if (this.indexes[e2.overscaledZ][e2.key].bucketInstanceId === t2.bucketInstanceId)
              return false;
            this.removeBucketCrossTileIDs(e2.overscaledZ, this.indexes[e2.overscaledZ][e2.key]);
          }
          for (let e3 = 0; e3 < t2.symbolInstances.length; e3++)
            t2.symbolInstances.get(e3).crossTileID = 0;
          this.usedCrossTileIDs[e2.overscaledZ] || (this.usedCrossTileIDs[e2.overscaledZ] = {});
          const o2 = this.usedCrossTileIDs[e2.overscaledZ];
          for (const i4 in this.indexes) {
            const r2 = this.indexes[i4];
            if (Number(i4) > e2.overscaledZ)
              for (const i5 in r2) {
                const n2 = r2[i5];
                n2.tileID.isChildOf(e2) && n2.findMatches(t2.symbolInstances, e2, o2);
              }
            else {
              const n2 = r2[e2.scaledTo(Number(i4)).key];
              n2 && n2.findMatches(t2.symbolInstances, e2, o2);
            }
          }
          for (let e3 = 0; e3 < t2.symbolInstances.length; e3++) {
            const r2 = t2.symbolInstances.get(e3);
            r2.crossTileID || (r2.crossTileID = i3.generate(), o2[r2.crossTileID] = true);
          }
          return this.indexes[e2.overscaledZ] === void 0 && (this.indexes[e2.overscaledZ] = {}), this.indexes[e2.overscaledZ][e2.key] = new Pt(e2, t2.symbolInstances, t2.bucketInstanceId), true;
        }
        removeBucketCrossTileIDs(e2, t2) {
          for (const i3 in t2.indexedSymbolInstances)
            for (const o2 of t2.indexedSymbolInstances[i3])
              delete this.usedCrossTileIDs[e2][o2.crossTileID];
        }
        removeStaleBuckets(e2) {
          let t2 = false;
          for (const i3 in this.indexes) {
            const o2 = this.indexes[i3];
            for (const r2 in o2)
              e2[o2[r2].bucketInstanceId] || (this.removeBucketCrossTileIDs(i3, o2[r2]), delete o2[r2], t2 = true);
          }
          return t2;
        }
      }
      class Rt {
        constructor() {
          this.layerIndexes = {}, this.crossTileIDs = new At(), this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
        }
        addLayer(e2, t2, i3, o2) {
          let r2 = this.layerIndexes[e2.id];
          r2 === void 0 && (r2 = this.layerIndexes[e2.id] = new Lt());
          let n2 = false;
          const a2 = {};
          o2.name !== "globe" && r2.handleWrapJump(i3);
          for (const i4 of t2) {
            const t3 = i4.getBucket(e2);
            t3 && e2.id === t3.layerIds[0] && (t3.bucketInstanceId || (t3.bucketInstanceId = ++this.maxBucketInstanceId), r2.addBucket(i4.tileID, t3, this.crossTileIDs) && (n2 = true), a2[t3.bucketInstanceId] = true);
          }
          return r2.removeStaleBuckets(a2) && (n2 = true), n2;
        }
        pruneUnusedLayers(e2) {
          const t2 = {};
          e2.forEach((e3) => {
            t2[e3] = true;
          });
          for (const e3 in this.layerIndexes)
            t2[e3] || delete this.layerIndexes[e3];
        }
      }
      const kt = (t2, i3) => e.emitValidationErrors(t2, i3 && i3.filter((e2) => e2.identifier !== "source.canvas")), Ot = e.pick(ke, ["addLayer", "removeLayer", "setPaintProperty", "setLayoutProperty", "setFilter", "addSource", "removeSource", "setLayerZoomRange", "setLight", "setTransition", "setGeoJSONSourceData", "setTerrain", "setFog", "setProjection"]), Bt = e.pick(ke, ["setCenter", "setZoom", "setBearing", "setPitch"]), Ft = function() {
        const t2 = {}, i3 = e.spec.$version;
        for (const o2 in e.spec.$root) {
          const r2 = e.spec.$root[o2];
          if (r2.required) {
            let e2 = null;
            e2 = o2 === "version" ? i3 : r2.type === "array" ? [] : {}, e2 != null && (t2[o2] = e2);
          }
        }
        return t2;
      }(), Ut = { fill: true, line: true, background: true, hillshade: true, raster: true };
      class Nt extends e.Evented {
        constructor(t2, i3 = {}) {
          super(), this.map = t2, this.dispatcher = new C(Ae(), this), this.imageManager = new d(), this.imageManager.setEventedParent(this), this.glyphManager = new e.GlyphManager(t2._requestManager, i3.localFontFamily ? e.LocalGlyphMode.all : i3.localIdeographFontFamily ? e.LocalGlyphMode.ideographs : e.LocalGlyphMode.none, i3.localFontFamily || i3.localIdeographFontFamily), this.lineAtlas = new e.LineAtlas(256, 512), this.crossTileSymbolIndex = new Rt(), this._layers = {}, this._num3DLayers = 0, this._numSymbolLayers = 0, this._numCircleLayers = 0, this._serializedLayers = {}, this._sourceCaches = {}, this._otherSourceCaches = {}, this._symbolSourceCaches = {}, this.zoomHistory = new e.ZoomHistory(), this._loaded = false, this._availableImages = [], this._order = [], this._drapedFirstOrder = [], this._markersNeedUpdate = false, this._resetUpdates(), this.dispatcher.broadcast("setReferrer", e.getReferrer());
          const o2 = this;
          this._rtlTextPluginCallback = Nt.registerForPluginStateChange((t3) => {
            o2.dispatcher.broadcast("syncRTLPluginState", { pluginStatus: t3.pluginStatus, pluginURL: t3.pluginURL }, (t4, i4) => {
              if (e.triggerPluginCompletionEvent(t4), i4 && i4.every((e2) => e2))
                for (const e2 in o2._sourceCaches) {
                  const t5 = o2._sourceCaches[e2], i5 = t5.getSource().type;
                  i5 !== "vector" && i5 !== "geojson" || t5.reload();
                }
            });
          }), this.on("data", (e2) => {
            if (e2.dataType !== "source" || e2.sourceDataType !== "metadata")
              return;
            const t3 = this.getSource(e2.sourceId);
            if (t3 && t3.vectorLayerIds)
              for (const e3 in this._layers) {
                const i4 = this._layers[e3];
                i4.source === t3.id && this._validateLayer(i4);
              }
          });
        }
        loadURL(t2, i3 = {}) {
          this.fire(new e.Event("dataloading", { dataType: "style" }));
          const o2 = typeof i3.validate == "boolean" ? i3.validate : !e.isMapboxURL(t2);
          t2 = this.map._requestManager.normalizeStyleURL(t2, i3.accessToken);
          const r2 = this.map._requestManager.transformRequest(t2, e.ResourceType.Style);
          this._request = e.getJSON(r2, (t3, i4) => {
            this._request = null, t3 ? this.fire(new e.ErrorEvent(t3)) : i4 && this._load(i4, o2);
          });
        }
        loadJSON(t2, i3 = {}) {
          this.fire(new e.Event("dataloading", { dataType: "style" })), this._request = e.exported.frame(() => {
            this._request = null, this._load(t2, i3.validate !== false);
          });
        }
        loadEmpty() {
          this.fire(new e.Event("dataloading", { dataType: "style" })), this._load(Ft, false);
        }
        _updateLayerCount(e2, t2) {
          const i3 = t2 ? 1 : -1;
          e2.is3D() && (this._num3DLayers += i3), e2.type === "circle" && (this._numCircleLayers += i3), e2.type === "symbol" && (this._numSymbolLayers += i3);
        }
        _load(t2, i3) {
          if (i3 && kt(this, e.validateStyle(t2)))
            return;
          this._loaded = true, this.stylesheet = t2, this.updateProjection();
          for (const e2 in t2.sources)
            this.addSource(e2, t2.sources[e2], { validate: false });
          this._changed = false, t2.sprite ? this._loadSprite(t2.sprite) : (this.imageManager.setLoaded(true), this.dispatcher.broadcast("spriteLoaded", true)), this.glyphManager.setURL(t2.glyphs);
          const o2 = Re(this.stylesheet.layers);
          this._order = o2.map((e2) => e2.id), this._layers = {}, this._serializedLayers = {};
          for (let t3 of o2)
            t3 = e.createStyleLayer(t3), t3.setEventedParent(this, { layer: { id: t3.id } }), this._layers[t3.id] = t3, this._serializedLayers[t3.id] = t3.serialize(), this._updateLayerCount(t3, true);
          this.dispatcher.broadcast("setLayers", this._serializeLayers(this._order)), this.light = new f(this.stylesheet.light), this.stylesheet.terrain && !this.terrainSetForDrapingOnly() && this._createTerrain(this.stylesheet.terrain, 1), this.stylesheet.fog && this._createFog(this.stylesheet.fog), this._updateDrapeFirstLayers(), this.fire(new e.Event("data", { dataType: "style" })), this.fire(new e.Event("style.load"));
        }
        terrainSetForDrapingOnly() {
          return this.terrain && this.terrain.drapeRenderMode === 0;
        }
        setProjection(e2) {
          e2 ? this.stylesheet.projection = e2 : delete this.stylesheet.projection, this.updateProjection();
        }
        updateProjection() {
          const e2 = this.map.transform.projection, t2 = this.map.transform.setProjection(this.map._runtimeProjection || (this.stylesheet ? this.stylesheet.projection : void 0)), i3 = this.map.transform.projection;
          if (this._loaded && (i3.requiresDraping ? this.getTerrain() || this.stylesheet.terrain || this.setTerrainForDraping() : this.terrainSetForDrapingOnly() && this.setTerrain(null)), this.dispatcher.broadcast("setProjection", this.map.transform.projectionOptions), t2) {
            if (i3.isReprojectedInTileSpace || e2.isReprojectedInTileSpace) {
              this.map.painter.clearBackgroundTiles();
              for (const e3 in this._sourceCaches)
                this._sourceCaches[e3].clearTiles();
            } else
              this._forceSymbolLayerUpdate();
            this.map._update(true);
          }
        }
        _loadSprite(t2) {
          this._spriteRequest = function(t3, i3, o2) {
            let r2, n2, a2;
            const s3 = e.exported.devicePixelRatio > 1 ? "@2x" : "";
            let l2 = e.getJSON(i3.transformRequest(i3.normalizeSpriteURL(t3, s3, ".json"), e.ResourceType.SpriteJSON), (e2, t4) => {
              l2 = null, a2 || (a2 = e2, r2 = t4, h2());
            }), c2 = e.getImage(i3.transformRequest(i3.normalizeSpriteURL(t3, s3, ".png"), e.ResourceType.SpriteImage), (e2, t4) => {
              c2 = null, a2 || (a2 = e2, n2 = t4, h2());
            });
            function h2() {
              if (a2)
                o2(a2);
              else if (r2 && n2) {
                const t4 = e.exported.getImageData(n2), i4 = {};
                for (const o3 in r2) {
                  const { width: n3, height: a3, x: s4, y: l3, sdf: c3, pixelRatio: h3, stretchX: u2, stretchY: _2, content: d2 } = r2[o3], p2 = new e.RGBAImage({ width: n3, height: a3 });
                  e.RGBAImage.copy(t4, p2, { x: s4, y: l3 }, { x: 0, y: 0 }, { width: n3, height: a3 }), i4[o3] = { data: p2, pixelRatio: h3, sdf: c3, stretchX: u2, stretchY: _2, content: d2 };
                }
                o2(null, i4);
              }
            }
            return { cancel() {
              l2 && (l2.cancel(), l2 = null), c2 && (c2.cancel(), c2 = null);
            } };
          }(t2, this.map._requestManager, (t3, i3) => {
            if (this._spriteRequest = null, t3)
              this.fire(new e.ErrorEvent(t3));
            else if (i3)
              for (const e2 in i3)
                this.imageManager.addImage(e2, i3[e2]);
            this.imageManager.setLoaded(true), this._availableImages = this.imageManager.listImages(), this.dispatcher.broadcast("setImages", this._availableImages), this.dispatcher.broadcast("spriteLoaded", true), this.fire(new e.Event("data", { dataType: "style" }));
          });
        }
        _validateLayer(t2) {
          const i3 = this.getSource(t2.source);
          if (!i3)
            return;
          const o2 = t2.sourceLayer;
          o2 && (i3.type === "geojson" || i3.vectorLayerIds && i3.vectorLayerIds.indexOf(o2) === -1) && this.fire(new e.ErrorEvent(new Error(`Source layer "${o2}" does not exist on source "${i3.id}" as specified by style layer "${t2.id}"`)));
        }
        loaded() {
          if (!this._loaded)
            return false;
          if (Object.keys(this._updatedSources).length)
            return false;
          for (const e2 in this._sourceCaches)
            if (!this._sourceCaches[e2].loaded())
              return false;
          return !!this.imageManager.isLoaded();
        }
        _serializeLayers(e2) {
          const t2 = [];
          for (const i3 of e2) {
            const e3 = this._layers[i3];
            e3.type !== "custom" && t2.push(e3.serialize());
          }
          return t2;
        }
        hasTransitions() {
          if (this.light && this.light.hasTransition())
            return true;
          if (this.fog && this.fog.hasTransition())
            return true;
          for (const e2 in this._sourceCaches)
            if (this._sourceCaches[e2].hasTransition())
              return true;
          for (const e2 in this._layers)
            if (this._layers[e2].hasTransition())
              return true;
          return false;
        }
        get order() {
          return this.map._optimizeForTerrain && this.terrain ? this._drapedFirstOrder : this._order;
        }
        isLayerDraped(e2) {
          return !!this.terrain && Ut[e2.type];
        }
        _checkLoaded() {
          if (!this._loaded)
            throw new Error("Style is not done loading");
        }
        update(t2) {
          if (!this._loaded)
            return;
          const i3 = this._changed;
          if (this._changed) {
            const e2 = Object.keys(this._updatedLayers), i4 = Object.keys(this._removedLayers);
            (e2.length || i4.length) && this._updateWorkerLayers(e2, i4);
            for (const e3 in this._updatedSources) {
              const t3 = this._updatedSources[e3];
              t3 === "reload" ? this._reloadSource(e3) : t3 === "clear" && this._clearSource(e3);
            }
            this._updateTilesForChangedImages();
            for (const e3 in this._updatedPaintProps)
              this._layers[e3].updateTransitions(t2);
            this.light.updateTransitions(t2), this.fog && this.fog.updateTransitions(t2), this._resetUpdates();
          }
          const o2 = {};
          for (const e2 in this._sourceCaches) {
            const t3 = this._sourceCaches[e2];
            o2[e2] = t3.used, t3.used = false;
          }
          for (const e2 of this._order) {
            const i4 = this._layers[e2];
            if (i4.recalculate(t2, this._availableImages), !i4.isHidden(t2.zoom)) {
              const e3 = this._getLayerSourceCache(i4);
              e3 && (e3.used = true);
            }
            const o3 = this.map.painter;
            if (o3) {
              const e3 = i4.getProgramIds();
              if (!e3)
                continue;
              const r2 = i4.getProgramConfiguration(t2.zoom);
              for (const t3 of e3)
                o3.useProgram(t3, r2);
            }
          }
          for (const t3 in o2) {
            const i4 = this._sourceCaches[t3];
            o2[t3] !== i4.used && i4.getSource().fire(new e.Event("data", { sourceDataType: "visibility", dataType: "source", sourceId: i4.getSource().id }));
          }
          this.light.recalculate(t2), this.terrain && this.terrain.recalculate(t2), this.fog && this.fog.recalculate(t2), this.z = t2.zoom, this._markersNeedUpdate && (this._updateMarkersOpacity(), this._markersNeedUpdate = false), i3 && this.fire(new e.Event("data", { dataType: "style" }));
        }
        _updateTilesForChangedImages() {
          const e2 = Object.keys(this._changedImages);
          if (e2.length) {
            for (const t2 in this._sourceCaches)
              this._sourceCaches[t2].reloadTilesForDependencies(["icons", "patterns"], e2);
            this._changedImages = {};
          }
        }
        _updateWorkerLayers(e2, t2) {
          this.dispatcher.broadcast("updateLayers", { layers: this._serializeLayers(e2), removedIds: t2 });
        }
        _resetUpdates() {
          this._changed = false, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {};
        }
        setState(t2) {
          if (this._checkLoaded(), kt(this, e.validateStyle(t2)))
            return false;
          (t2 = e.clone$1(t2)).layers = Re(t2.layers);
          const i3 = function(e2, t3) {
            if (!e2)
              return [{ command: ke.setStyle, args: [t3] }];
            let i4 = [];
            try {
              if (!n(e2.version, t3.version))
                return [{ command: ke.setStyle, args: [t3] }];
              n(e2.center, t3.center) || i4.push({ command: ke.setCenter, args: [t3.center] }), n(e2.zoom, t3.zoom) || i4.push({ command: ke.setZoom, args: [t3.zoom] }), n(e2.bearing, t3.bearing) || i4.push({ command: ke.setBearing, args: [t3.bearing] }), n(e2.pitch, t3.pitch) || i4.push({ command: ke.setPitch, args: [t3.pitch] }), n(e2.sprite, t3.sprite) || i4.push({ command: ke.setSprite, args: [t3.sprite] }), n(e2.glyphs, t3.glyphs) || i4.push({ command: ke.setGlyphs, args: [t3.glyphs] }), n(e2.transition, t3.transition) || i4.push({ command: ke.setTransition, args: [t3.transition] }), n(e2.light, t3.light) || i4.push({ command: ke.setLight, args: [t3.light] }), n(e2.fog, t3.fog) || i4.push({ command: ke.setFog, args: [t3.fog] }), n(e2.projection, t3.projection) || i4.push({ command: ke.setProjection, args: [t3.projection] });
              const o3 = {}, r2 = [];
              !function(e3, t4, i5, o4) {
                let r3;
                for (r3 in t4 = t4 || {}, e3 = e3 || {})
                  e3.hasOwnProperty(r3) && (t4.hasOwnProperty(r3) || Be(r3, i5, o4));
                for (r3 in t4)
                  t4.hasOwnProperty(r3) && (e3.hasOwnProperty(r3) ? n(e3[r3], t4[r3]) || (e3[r3].type === "geojson" && t4[r3].type === "geojson" && Ue(e3, t4, r3) ? i5.push({ command: ke.setGeoJSONSourceData, args: [r3, t4[r3].data] }) : Fe(r3, t4, i5, o4)) : Oe(r3, t4, i5));
              }(e2.sources, t3.sources, r2, o3);
              const a2 = [];
              e2.layers && e2.layers.forEach((e3) => {
                o3[e3.source] ? i4.push({ command: ke.removeLayer, args: [e3.id] }) : a2.push(e3);
              });
              let s3 = e2.terrain;
              s3 && o3[s3.source] && (i4.push({ command: ke.setTerrain, args: [void 0] }), s3 = void 0), i4 = i4.concat(r2), n(s3, t3.terrain) || i4.push({ command: ke.setTerrain, args: [t3.terrain] }), function(e3, t4, i5) {
                t4 = t4 || [];
                const o4 = (e3 = e3 || []).map(Ge), r3 = t4.map(Ge), a3 = e3.reduce(je, {}), s4 = t4.reduce(je, {}), l2 = o4.slice(), c2 = /* @__PURE__ */ Object.create(null);
                let h2, u2, _2, d2, p2, m2, f2;
                for (h2 = 0, u2 = 0; h2 < o4.length; h2++)
                  _2 = o4[h2], s4.hasOwnProperty(_2) ? u2++ : (i5.push({ command: ke.removeLayer, args: [_2] }), l2.splice(l2.indexOf(_2, u2), 1));
                for (h2 = 0, u2 = 0; h2 < r3.length; h2++)
                  _2 = r3[r3.length - 1 - h2], l2[l2.length - 1 - h2] !== _2 && (a3.hasOwnProperty(_2) ? (i5.push({ command: ke.removeLayer, args: [_2] }), l2.splice(l2.lastIndexOf(_2, l2.length - u2), 1)) : u2++, m2 = l2[l2.length - h2], i5.push({ command: ke.addLayer, args: [s4[_2], m2] }), l2.splice(l2.length - h2, 0, _2), c2[_2] = true);
                for (h2 = 0; h2 < r3.length; h2++)
                  if (_2 = r3[h2], d2 = a3[_2], p2 = s4[_2], !c2[_2] && !n(d2, p2))
                    if (n(d2.source, p2.source) && n(d2["source-layer"], p2["source-layer"]) && n(d2.type, p2.type)) {
                      for (f2 in Ne(d2.layout, p2.layout, i5, _2, null, ke.setLayoutProperty), Ne(d2.paint, p2.paint, i5, _2, null, ke.setPaintProperty), n(d2.filter, p2.filter) || i5.push({ command: ke.setFilter, args: [_2, p2.filter] }), n(d2.minzoom, p2.minzoom) && n(d2.maxzoom, p2.maxzoom) || i5.push({ command: ke.setLayerZoomRange, args: [_2, p2.minzoom, p2.maxzoom] }), d2)
                        d2.hasOwnProperty(f2) && f2 !== "layout" && f2 !== "paint" && f2 !== "filter" && f2 !== "metadata" && f2 !== "minzoom" && f2 !== "maxzoom" && (f2.indexOf("paint.") === 0 ? Ne(d2[f2], p2[f2], i5, _2, f2.slice(6), ke.setPaintProperty) : n(d2[f2], p2[f2]) || i5.push({ command: ke.setLayerProperty, args: [_2, f2, p2[f2]] }));
                      for (f2 in p2)
                        p2.hasOwnProperty(f2) && !d2.hasOwnProperty(f2) && f2 !== "layout" && f2 !== "paint" && f2 !== "filter" && f2 !== "metadata" && f2 !== "minzoom" && f2 !== "maxzoom" && (f2.indexOf("paint.") === 0 ? Ne(d2[f2], p2[f2], i5, _2, f2.slice(6), ke.setPaintProperty) : n(d2[f2], p2[f2]) || i5.push({ command: ke.setLayerProperty, args: [_2, f2, p2[f2]] }));
                    } else
                      i5.push({ command: ke.removeLayer, args: [_2] }), m2 = l2[l2.lastIndexOf(_2) + 1], i5.push({ command: ke.addLayer, args: [p2, m2] });
              }(a2, t3.layers, i4);
            } catch (e3) {
              console.warn("Unable to compute style diff:", e3), i4 = [{ command: ke.setStyle, args: [t3] }];
            }
            return i4;
          }(this.serialize(), t2).filter((e2) => !(e2.command in Bt));
          if (i3.length === 0)
            return false;
          const o2 = i3.filter((e2) => !(e2.command in Ot));
          if (o2.length > 0)
            throw new Error(`Unimplemented: ${o2.map((e2) => e2.command).join(", ")}.`);
          return i3.forEach((e2) => {
            e2.command !== "setTransition" && this[e2.command].apply(this, e2.args);
          }), this.stylesheet = t2, this.updateProjection(), true;
        }
        addImage(t2, i3) {
          if (this.getImage(t2))
            return this.fire(new e.ErrorEvent(new Error("An image with this name already exists.")));
          this.imageManager.addImage(t2, i3), this._afterImageUpdated(t2);
        }
        updateImage(e2, t2) {
          this.imageManager.updateImage(e2, t2);
        }
        getImage(e2) {
          return this.imageManager.getImage(e2);
        }
        removeImage(t2) {
          if (!this.getImage(t2))
            return this.fire(new e.ErrorEvent(new Error("No image with this name exists.")));
          this.imageManager.removeImage(t2), this._afterImageUpdated(t2);
        }
        _afterImageUpdated(t2) {
          this._availableImages = this.imageManager.listImages(), this._changedImages[t2] = true, this._changed = true, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new e.Event("data", { dataType: "style" }));
        }
        listImages() {
          return this._checkLoaded(), this._availableImages.slice();
        }
        addSource(t2, i3, o2 = {}) {
          if (this._checkLoaded(), this.getSource(t2) !== void 0)
            throw new Error("There is already a source with this ID");
          if (!i3.type)
            throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i3).join(", ")}.`);
          if (["vector", "raster", "geojson", "video", "image"].indexOf(i3.type) >= 0 && this._validate(e.validateStyle.source, `sources.${t2}`, i3, null, o2))
            return;
          this.map && this.map._collectResourceTiming && (i3.collectResourceTiming = true);
          const r2 = Te(t2, i3, this.dispatcher, this);
          r2.setEventedParent(this, () => ({ isSourceLoaded: this.loaded(), source: r2.serialize(), sourceId: t2 }));
          const n2 = (i4) => {
            const o3 = (i4 ? "symbol:" : "other:") + t2, n3 = this._sourceCaches[o3] = new e.SourceCache(o3, r2, i4);
            (i4 ? this._symbolSourceCaches : this._otherSourceCaches)[t2] = n3, n3.style = this, n3.onAdd(this.map);
          };
          n2(false), i3.type !== "vector" && i3.type !== "geojson" || n2(true), r2.onAdd && r2.onAdd(this.map), this._changed = true;
        }
        removeSource(t2) {
          this._checkLoaded();
          const i3 = this.getSource(t2);
          if (i3 === void 0)
            throw new Error("There is no source with this ID");
          for (const i4 in this._layers)
            if (this._layers[i4].source === t2)
              return this.fire(new e.ErrorEvent(new Error(`Source "${t2}" cannot be removed while layer "${i4}" is using it.`)));
          if (this.terrain && this.terrain.get().source === t2)
            return this.fire(new e.ErrorEvent(new Error(`Source "${t2}" cannot be removed while terrain is using it.`)));
          const o2 = this._getSourceCaches(t2);
          for (const t3 of o2)
            delete this._sourceCaches[t3.id], delete this._updatedSources[t3.id], t3.fire(new e.Event("data", { sourceDataType: "metadata", dataType: "source", sourceId: t3.getSource().id })), t3.setEventedParent(null), t3.clearTiles();
          delete this._otherSourceCaches[t2], delete this._symbolSourceCaches[t2], i3.setEventedParent(null), i3.onRemove && i3.onRemove(this.map), this._changed = true;
        }
        setGeoJSONSourceData(e2, t2) {
          this._checkLoaded(), this.getSource(e2).setData(t2), this._changed = true;
        }
        getSource(e2) {
          const t2 = this._getSourceCache(e2);
          return t2 && t2.getSource();
        }
        addLayer(t2, i3, o2 = {}) {
          this._checkLoaded();
          const r2 = t2.id;
          if (this.getLayer(r2))
            return void this.fire(new e.ErrorEvent(new Error(`Layer with id "${r2}" already exists on this map`)));
          let n2;
          if (t2.type === "custom") {
            if (kt(this, e.validateCustomStyleLayer(t2)))
              return;
            n2 = e.createStyleLayer(t2);
          } else {
            if (typeof t2.source == "object" && (this.addSource(r2, t2.source), t2 = e.clone$1(t2), t2 = e.extend(t2, { source: r2 })), this._validate(e.validateStyle.layer, `layers.${r2}`, t2, { arrayIndex: -1 }, o2))
              return;
            n2 = e.createStyleLayer(t2), this._validateLayer(n2), n2.setEventedParent(this, { layer: { id: r2 } }), this._serializedLayers[n2.id] = n2.serialize(), this._updateLayerCount(n2, true);
          }
          const a2 = i3 ? this._order.indexOf(i3) : this._order.length;
          if (i3 && a2 === -1)
            return void this.fire(new e.ErrorEvent(new Error(`Layer with id "${i3}" does not exist on this map.`)));
          this._order.splice(a2, 0, r2), this._layerOrderChanged = true, this._layers[r2] = n2;
          const s3 = this._getLayerSourceCache(n2);
          if (this._removedLayers[r2] && n2.source && s3 && n2.type !== "custom") {
            const e2 = this._removedLayers[r2];
            delete this._removedLayers[r2], e2.type !== n2.type ? this._updatedSources[n2.source] = "clear" : (this._updatedSources[n2.source] = "reload", s3.pause());
          }
          this._updateLayer(n2), n2.onAdd && n2.onAdd(this.map), this._updateDrapeFirstLayers();
        }
        moveLayer(t2, i3) {
          if (this._checkLoaded(), this._changed = true, !this._layers[t2])
            return void this.fire(new e.ErrorEvent(new Error(`The layer '${t2}' does not exist in the map's style and cannot be moved.`)));
          if (t2 === i3)
            return;
          const o2 = this._order.indexOf(t2);
          this._order.splice(o2, 1);
          const r2 = i3 ? this._order.indexOf(i3) : this._order.length;
          i3 && r2 === -1 ? this.fire(new e.ErrorEvent(new Error(`Layer with id "${i3}" does not exist on this map.`))) : (this._order.splice(r2, 0, t2), this._layerOrderChanged = true, this._updateDrapeFirstLayers());
        }
        removeLayer(t2) {
          this._checkLoaded();
          const i3 = this._layers[t2];
          if (!i3)
            return void this.fire(new e.ErrorEvent(new Error(`The layer '${t2}' does not exist in the map's style and cannot be removed.`)));
          i3.setEventedParent(null), this._updateLayerCount(i3, false);
          const o2 = this._order.indexOf(t2);
          this._order.splice(o2, 1), this._layerOrderChanged = true, this._changed = true, this._removedLayers[t2] = i3, delete this._layers[t2], delete this._serializedLayers[t2], delete this._updatedLayers[t2], delete this._updatedPaintProps[t2], i3.onRemove && i3.onRemove(this.map), this._updateDrapeFirstLayers();
        }
        getLayer(e2) {
          return this._layers[e2];
        }
        hasLayer(e2) {
          return e2 in this._layers;
        }
        hasLayerType(e2) {
          for (const t2 in this._layers)
            if (this._layers[t2].type === e2)
              return true;
          return false;
        }
        setLayerZoomRange(t2, i3, o2) {
          this._checkLoaded();
          const r2 = this.getLayer(t2);
          r2 ? r2.minzoom === i3 && r2.maxzoom === o2 || (i3 != null && (r2.minzoom = i3), o2 != null && (r2.maxzoom = o2), this._updateLayer(r2)) : this.fire(new e.ErrorEvent(new Error(`The layer '${t2}' does not exist in the map's style and cannot have zoom extent.`)));
        }
        setFilter(t2, i3, o2 = {}) {
          this._checkLoaded();
          const r2 = this.getLayer(t2);
          if (r2) {
            if (!n(r2.filter, i3))
              return i3 == null ? (r2.filter = void 0, void this._updateLayer(r2)) : void (this._validate(e.validateStyle.filter, `layers.${r2.id}.filter`, i3, { layerType: r2.type }, o2) || (r2.filter = e.clone$1(i3), this._updateLayer(r2)));
          } else
            this.fire(new e.ErrorEvent(new Error(`The layer '${t2}' does not exist in the map's style and cannot be filtered.`)));
        }
        getFilter(t2) {
          return e.clone$1(this.getLayer(t2).filter);
        }
        setLayoutProperty(t2, i3, o2, r2 = {}) {
          this._checkLoaded();
          const a2 = this.getLayer(t2);
          a2 ? n(a2.getLayoutProperty(i3), o2) || (a2.setLayoutProperty(i3, o2, r2), this._updateLayer(a2)) : this.fire(new e.ErrorEvent(new Error(`The layer '${t2}' does not exist in the map's style and cannot be styled.`)));
        }
        getLayoutProperty(t2, i3) {
          const o2 = this.getLayer(t2);
          if (o2)
            return o2.getLayoutProperty(i3);
          this.fire(new e.ErrorEvent(new Error(`The layer '${t2}' does not exist in the map's style.`)));
        }
        setPaintProperty(t2, i3, o2, r2 = {}) {
          this._checkLoaded();
          const a2 = this.getLayer(t2);
          a2 ? n(a2.getPaintProperty(i3), o2) || (a2.setPaintProperty(i3, o2, r2) && this._updateLayer(a2), this._changed = true, this._updatedPaintProps[t2] = true) : this.fire(new e.ErrorEvent(new Error(`The layer '${t2}' does not exist in the map's style and cannot be styled.`)));
        }
        getPaintProperty(e2, t2) {
          return this.getLayer(e2).getPaintProperty(t2);
        }
        setFeatureState(t2, i3) {
          this._checkLoaded();
          const o2 = t2.source, r2 = t2.sourceLayer, n2 = this.getSource(o2);
          if (n2 === void 0)
            return void this.fire(new e.ErrorEvent(new Error(`The source '${o2}' does not exist in the map's style.`)));
          const a2 = n2.type;
          if (a2 === "geojson" && r2)
            return void this.fire(new e.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
          if (a2 === "vector" && !r2)
            return void this.fire(new e.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
          t2.id === void 0 && this.fire(new e.ErrorEvent(new Error("The feature id parameter must be provided.")));
          const s3 = this._getSourceCaches(o2);
          for (const e2 of s3)
            e2.setFeatureState(r2, t2.id, i3);
        }
        removeFeatureState(t2, i3) {
          this._checkLoaded();
          const o2 = t2.source, r2 = this.getSource(o2);
          if (r2 === void 0)
            return void this.fire(new e.ErrorEvent(new Error(`The source '${o2}' does not exist in the map's style.`)));
          const n2 = r2.type, a2 = n2 === "vector" ? t2.sourceLayer : void 0;
          if (n2 === "vector" && !a2)
            return void this.fire(new e.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
          if (i3 && typeof t2.id != "string" && typeof t2.id != "number")
            return void this.fire(new e.ErrorEvent(new Error("A feature id is required to remove its specific state property.")));
          const s3 = this._getSourceCaches(o2);
          for (const e2 of s3)
            e2.removeFeatureState(a2, t2.id, i3);
        }
        getFeatureState(t2) {
          this._checkLoaded();
          const i3 = t2.source, o2 = t2.sourceLayer, r2 = this.getSource(i3);
          if (r2 !== void 0) {
            if (r2.type !== "vector" || o2)
              return t2.id === void 0 && this.fire(new e.ErrorEvent(new Error("The feature id parameter must be provided."))), this._getSourceCaches(i3)[0].getFeatureState(o2, t2.id);
            this.fire(new e.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
          } else
            this.fire(new e.ErrorEvent(new Error(`The source '${i3}' does not exist in the map's style.`)));
        }
        getTransition() {
          return e.extend({ duration: 300, delay: 0 }, this.stylesheet && this.stylesheet.transition);
        }
        serialize() {
          const t2 = {};
          for (const e2 in this._sourceCaches) {
            const i3 = this._sourceCaches[e2].getSource();
            t2[i3.id] || (t2[i3.id] = i3.serialize());
          }
          return e.filterObject({ version: this.stylesheet.version, name: this.stylesheet.name, metadata: this.stylesheet.metadata, light: this.stylesheet.light, terrain: this.stylesheet.terrain, fog: this.stylesheet.fog, center: this.stylesheet.center, zoom: this.stylesheet.zoom, bearing: this.stylesheet.bearing, pitch: this.stylesheet.pitch, sprite: this.stylesheet.sprite, glyphs: this.stylesheet.glyphs, transition: this.stylesheet.transition, projection: this.stylesheet.projection, sources: t2, layers: this._serializeLayers(this._order) }, (e2) => e2 !== void 0);
        }
        _updateLayer(e2) {
          this._updatedLayers[e2.id] = true;
          const t2 = this._getLayerSourceCache(e2);
          e2.source && !this._updatedSources[e2.source] && t2 && t2.getSource().type !== "raster" && (this._updatedSources[e2.source] = "reload", t2.pause()), this._changed = true, e2.invalidateCompiledFilter();
        }
        _flattenAndSortRenderedFeatures(e2) {
          const t2 = (e3) => this._layers[e3].type === "fill-extrusion", i3 = {}, o2 = [];
          for (let r3 = this._order.length - 1; r3 >= 0; r3--) {
            const n2 = this._order[r3];
            if (t2(n2)) {
              i3[n2] = r3;
              for (const t3 of e2) {
                const e3 = t3[n2];
                if (e3)
                  for (const t4 of e3)
                    o2.push(t4);
              }
            }
          }
          o2.sort((e3, t3) => t3.intersectionZ - e3.intersectionZ);
          const r2 = [];
          for (let n2 = this._order.length - 1; n2 >= 0; n2--) {
            const a2 = this._order[n2];
            if (t2(a2))
              for (let e3 = o2.length - 1; e3 >= 0; e3--) {
                const t3 = o2[e3].feature;
                if (i3[t3.layer.id] < n2)
                  break;
                r2.push(t3), o2.pop();
              }
            else
              for (const t3 of e2) {
                const e3 = t3[a2];
                if (e3)
                  for (const t4 of e3)
                    r2.push(t4.feature);
              }
          }
          return r2;
        }
        queryRenderedFeatures(t2, i3, o2) {
          i3 && i3.filter && this._validate(e.validateStyle.filter, "queryRenderedFeatures.filter", i3.filter, null, i3);
          const r2 = {};
          if (i3 && i3.layers) {
            if (!Array.isArray(i3.layers))
              return this.fire(new e.ErrorEvent(new Error("parameters.layers must be an Array."))), [];
            for (const t3 of i3.layers) {
              const i4 = this._layers[t3];
              if (!i4)
                return this.fire(new e.ErrorEvent(new Error(`The layer '${t3}' does not exist in the map's style and cannot be queried for features.`))), [];
              r2[i4.source] = true;
            }
          }
          const n2 = [];
          i3.availableImages = this._availableImages;
          const a2 = i3 && i3.layers ? i3.layers.some((e2) => {
            const t3 = this.getLayer(e2);
            return t3 && t3.is3D();
          }) : this.has3DLayers(), s3 = pe.createFromScreenPoints(t2, o2);
          for (const e2 in this._sourceCaches) {
            const t3 = this._sourceCaches[e2].getSource().id;
            i3.layers && !r2[t3] || n2.push(Ce(this._sourceCaches[e2], this._layers, this._serializedLayers, s3, i3, o2, a2, !!this.map._showQueryGeometry));
          }
          return this.placement && n2.push(function(e2, t3, i4, o3, r3, n3, a3) {
            const s4 = {}, l2 = n3.queryRenderedSymbols(o3), c2 = [];
            for (const e3 of Object.keys(l2).map(Number))
              c2.push(a3[e3]);
            c2.sort(Se);
            for (const i5 of c2) {
              const o4 = i5.featureIndex.lookupSymbolFeatures(l2[i5.bucketInstanceId], t3, i5.bucketIndex, i5.sourceLayerIndex, r3.filter, r3.layers, r3.availableImages, e2);
              for (const e3 in o4) {
                const t4 = s4[e3] = s4[e3] || [], r4 = o4[e3];
                r4.sort((e4, t5) => {
                  const o5 = i5.featureSortOrder;
                  if (o5) {
                    const i6 = o5.indexOf(e4.featureIndex);
                    return o5.indexOf(t5.featureIndex) - i6;
                  }
                  return t5.featureIndex - e4.featureIndex;
                });
                for (const e4 of r4)
                  t4.push(e4);
              }
            }
            for (const t4 in s4)
              s4[t4].forEach((o4) => {
                const r4 = o4.feature, n4 = i4(e2[t4]).getFeatureState(r4.layer["source-layer"], r4.id);
                r4.source = r4.layer.source, r4.layer["source-layer"] && (r4.sourceLayer = r4.layer["source-layer"]), r4.state = n4;
              });
            return s4;
          }(this._layers, this._serializedLayers, this._getLayerSourceCache.bind(this), s3.screenGeometry, i3, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(n2);
        }
        querySourceFeatures(t2, i3) {
          i3 && i3.filter && this._validate(e.validateStyle.filter, "querySourceFeatures.filter", i3.filter, null, i3);
          const o2 = this._getSourceCaches(t2);
          let r2 = [];
          for (const e2 of o2)
            r2 = r2.concat(Me(e2, i3));
          return r2;
        }
        addSourceType(e2, t2, i3) {
          return Nt.getSourceType(e2) ? i3(new Error(`A source type called "${e2}" already exists.`)) : (Nt.setSourceType(e2, t2), t2.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", { name: e2, url: t2.workerSourceURL }, i3) : i3(null, null));
        }
        getLight() {
          return this.light.getLight();
        }
        setLight(t2, i3 = {}) {
          this._checkLoaded();
          const o2 = this.light.getLight();
          let r2 = false;
          for (const e2 in t2)
            if (!n(t2[e2], o2[e2])) {
              r2 = true;
              break;
            }
          if (!r2)
            return;
          const a2 = { now: e.exported.now(), transition: e.extend({ duration: 300, delay: 0 }, this.stylesheet.transition) };
          this.light.setLight(t2, i3), this.light.updateTransitions(a2);
        }
        getTerrain() {
          return this.terrain && this.terrain.drapeRenderMode === 1 ? this.terrain.get() : null;
        }
        setTerrainForDraping() {
          this.setTerrain({ source: "", exaggeration: 0 }, 0);
        }
        setTerrain(t2, i3 = 1) {
          if (this._checkLoaded(), !t2)
            return delete this.terrain, delete this.stylesheet.terrain, this.dispatcher.broadcast("enableTerrain", false), this._force3DLayerUpdate(), void (this._markersNeedUpdate = true);
          if (i3 === 1) {
            if (typeof t2.source == "object") {
              const i4 = "terrain-dem-src";
              this.addSource(i4, t2.source), t2 = e.clone$1(t2), t2 = e.extend(t2, { source: i4 });
            }
            if (this._validate(e.validateStyle.terrain, "terrain", t2))
              return;
          }
          if (!this.terrain || this.terrain && i3 !== this.terrain.drapeRenderMode)
            this._createTerrain(t2, i3);
          else {
            const i4 = this.terrain, o2 = i4.get();
            for (const r2 in t2)
              if (!n(t2[r2], o2[r2])) {
                i4.set(t2), this.stylesheet.terrain = t2;
                const o3 = { now: e.exported.now(), transition: e.extend({ duration: 0 }, this.stylesheet.transition) };
                i4.updateTransitions(o3);
                break;
              }
          }
          this._updateDrapeFirstLayers(), this._markersNeedUpdate = true;
        }
        _createFog(t2) {
          const i3 = this.fog = new E(t2, this.map.transform);
          this.stylesheet.fog = t2;
          const o2 = { now: e.exported.now(), transition: e.extend({ duration: 0 }, this.stylesheet.transition) };
          i3.updateTransitions(o2);
        }
        _updateMarkersOpacity() {
          this.map._markers.length !== 0 && this.map._requestDomTask(() => {
            for (const e2 of this.map._markers)
              e2._evaluateOpacity();
          });
        }
        getFog() {
          return this.fog ? this.fog.get() : null;
        }
        setFog(t2) {
          if (this._checkLoaded(), !t2)
            return delete this.fog, delete this.stylesheet.fog, void (this._markersNeedUpdate = true);
          if (this.fog) {
            const i3 = this.fog, o2 = i3.get();
            for (const r2 in t2)
              if (!n(t2[r2], o2[r2])) {
                i3.set(t2), this.stylesheet.fog = t2;
                const o3 = { now: e.exported.now(), transition: e.extend({ duration: 0 }, this.stylesheet.transition) };
                i3.updateTransitions(o3);
                break;
              }
          } else
            this._createFog(t2);
          this._markersNeedUpdate = true;
        }
        _updateDrapeFirstLayers() {
          if (!this.map._optimizeForTerrain || !this.terrain)
            return;
          const e2 = this._order.filter((e3) => this.isLayerDraped(this._layers[e3])), t2 = this._order.filter((e3) => !this.isLayerDraped(this._layers[e3]));
          this._drapedFirstOrder = [], this._drapedFirstOrder.push(...e2), this._drapedFirstOrder.push(...t2);
        }
        _createTerrain(t2, i3) {
          const o2 = this.terrain = new x2(t2, i3);
          this.stylesheet.terrain = t2, this.dispatcher.broadcast("enableTerrain", true), this._force3DLayerUpdate();
          const r2 = { now: e.exported.now(), transition: e.extend({ duration: 0 }, this.stylesheet.transition) };
          o2.updateTransitions(r2);
        }
        _force3DLayerUpdate() {
          for (const e2 in this._layers) {
            const t2 = this._layers[e2];
            t2.type === "fill-extrusion" && this._updateLayer(t2);
          }
        }
        _forceSymbolLayerUpdate() {
          for (const e2 in this._layers) {
            const t2 = this._layers[e2];
            t2.type === "symbol" && this._updateLayer(t2);
          }
        }
        _validate(t2, i3, o2, r2, n2 = {}) {
          return (!n2 || n2.validate !== false) && kt(this, t2.call(e.validateStyle, e.extend({ key: i3, style: this.serialize(), value: o2, styleSpec: e.spec }, r2)));
        }
        _remove() {
          this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), e.evented.off("pluginStateChange", this._rtlTextPluginCallback);
          for (const e2 in this._layers)
            this._layers[e2].setEventedParent(null);
          for (const e2 in this._sourceCaches)
            this._sourceCaches[e2].clearTiles(), this._sourceCaches[e2].setEventedParent(null);
          this.imageManager.setEventedParent(null), this.setEventedParent(null), this.dispatcher.remove();
        }
        _clearSource(e2) {
          const t2 = this._getSourceCaches(e2);
          for (const e3 of t2)
            e3.clearTiles();
        }
        _reloadSource(e2) {
          const t2 = this._getSourceCaches(e2);
          for (const e3 of t2)
            e3.resume(), e3.reload();
        }
        _updateSources(e2) {
          for (const t2 in this._sourceCaches)
            this._sourceCaches[t2].update(e2);
        }
        _generateCollisionBoxes() {
          for (const e2 in this._sourceCaches) {
            const t2 = this._sourceCaches[e2];
            t2.resume(), t2.reload();
          }
        }
        _updatePlacement(t2, i3, o2, r2, n2 = false) {
          let a2 = false, s3 = false;
          const l2 = {};
          for (const e2 of this._order) {
            const i4 = this._layers[e2];
            if (i4.type !== "symbol")
              continue;
            if (!l2[i4.source]) {
              const e3 = this._getLayerSourceCache(i4);
              if (!e3)
                continue;
              l2[i4.source] = e3.getRenderableIds(true).map((t3) => e3.getTileByID(t3)).sort((e4, t3) => t3.tileID.overscaledZ - e4.tileID.overscaledZ || (e4.tileID.isLessThan(t3.tileID) ? -1 : 1));
            }
            const o3 = this.crossTileSymbolIndex.addLayer(i4, l2[i4.source], t2.center.lng, t2.projection);
            a2 = a2 || o3;
          }
          if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), n2 = n2 || this._layerOrderChanged || o2 === 0, this._layerOrderChanged && this.fire(new e.Event("neworder")), (n2 || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(e.exported.now(), t2.zoom)) && (this.pauseablePlacement = new zt(t2, this._order, n2, i3, o2, r2, this.placement, this.fog && t2.projection.supportsFog ? this.fog.state : null), this._layerOrderChanged = false), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, l2), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(e.exported.now()), s3 = true), a2 && this.pauseablePlacement.placement.setStale()), s3 || a2)
            for (const e2 of this._order) {
              const t3 = this._layers[e2];
              t3.type === "symbol" && this.placement.updateLayerOpacities(t3, l2[t3.source]);
            }
          return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(e.exported.now());
        }
        _releaseSymbolFadeTiles() {
          for (const e2 in this._sourceCaches)
            this._sourceCaches[e2].releaseSymbolFadeTiles();
        }
        getImages(e2, t2, i3) {
          this.imageManager.getImages(t2.icons, i3), this._updateTilesForChangedImages();
          const o2 = (e3) => {
            e3 && e3.setDependencies(t2.tileID.key, t2.type, t2.icons);
          };
          o2(this._otherSourceCaches[t2.source]), o2(this._symbolSourceCaches[t2.source]);
        }
        getGlyphs(e2, t2, i3) {
          this.glyphManager.getGlyphs(t2.stacks, i3);
        }
        getResource(t2, i3, o2) {
          return e.makeRequest(i3, o2);
        }
        _getSourceCache(e2) {
          return this._otherSourceCaches[e2];
        }
        _getLayerSourceCache(e2) {
          return e2.type === "symbol" ? this._symbolSourceCaches[e2.source] : this._otherSourceCaches[e2.source];
        }
        _getSourceCaches(e2) {
          const t2 = [];
          return this._otherSourceCaches[e2] && t2.push(this._otherSourceCaches[e2]), this._symbolSourceCaches[e2] && t2.push(this._symbolSourceCaches[e2]), t2;
        }
        has3DLayers() {
          return this._num3DLayers > 0;
        }
        hasSymbolLayers() {
          return this._numSymbolLayers > 0;
        }
        hasCircleLayers() {
          return this._numCircleLayers > 0;
        }
        _clearWorkerCaches() {
          this.dispatcher.broadcast("clearCaches");
        }
        destroy() {
          this._clearWorkerCaches(), this.terrainSetForDrapingOnly() && (delete this.terrain, delete this.stylesheet.terrain);
        }
      }
      Nt.getSourceType = function(e2) {
        return we[e2];
      }, Nt.setSourceType = function(e2, t2) {
        we[e2] = t2;
      }, Nt.registerForPluginStateChange = e.registerForPluginStateChange;
      var Gt = "\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#define EXTENT 8192.0\n#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;varying vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}\n#endif", jt = "attribute highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;varying highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}";
      let Zt = {}, Vt = {};
      Zt = $t("", "\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;vec3 elevationVector(vec2 pos) {vec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;}\n#else\nvec3 elevationVector(vec2 pos) { return vec3(0,0,1); }\n#endif\n#ifdef TERRAIN\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nuniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;\n#else\nuniform sampler2D u_dem;uniform sampler2D u_dem_prev;\n#endif\nuniform vec4 u_dem_unpack;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;uniform sampler2D u_depth;uniform vec2 u_depth_size_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float decodeElevation(vec4 v) {return dot(vec4(v.xyz*255.0,-1.0),u_dem_unpack);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture2D(u_dem,pos).a;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=decodeElevation(texture2D(u_dem,pos));\n#ifdef TERRAIN_DEM_NEAREST_FILTER\nreturn u_exaggeration*tl;\n#endif\nfloat tr=decodeElevation(texture2D(u_dem,pos+vec2(dd,0.0)));float bl=decodeElevation(texture2D(u_dem,pos+vec2(0.0,dd)));float br=decodeElevation(texture2D(u_dem,pos+vec2(dd,dd)));return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}float prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture2D(u_dem_prev,pos).a;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=decodeElevation(texture2D(u_dem_prev,pos));float tr=decodeElevation(texture2D(u_dem_prev,pos+vec2(dd,0.0)));float bl=decodeElevation(texture2D(u_dem_prev,pos+vec2(0.0,dd)));float br=decodeElevation(texture2D(u_dem_prev,pos+vec2(dd,dd)));return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat elevation(vec2 apos) {float nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);}\n#else\nfloat elevation(vec2 apos) {return currentElevation(apos);}\n#endif\nfloat unpack_depth(vec4 rgba_depth)\n{const vec4 bit_shift=vec4(1.0/(256.0*256.0*256.0),1.0/(256.0*256.0),1.0/256.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}bool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;float depth=unpack_depth(texture2D(u_depth,(coord.xy+1.0)*0.5));return coord.z > depth+0.0005;}float occlusionFade(vec4 frag) {vec3 coord=frag.xyz/frag.w;vec3 df=vec3(5.0*u_depth_size_inv,0.0);vec2 uv=0.5*coord.xy+0.5;vec4 depth=vec4(\nunpack_depth(texture2D(u_depth,uv-df.xz)),unpack_depth(texture2D(u_depth,uv+df.xz)),unpack_depth(texture2D(u_depth,uv-df.zy)),unpack_depth(texture2D(u_depth,uv+df.zy))\n);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z-0.001)-depth),0.0,1.0));}vec4 fourSample(vec2 pos,vec2 off) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nfloat tl=texture2D(u_dem,pos).a;float tr=texture2D(u_dem,pos+vec2(off.x,0.0)).a;float bl=texture2D(u_dem,pos+vec2(0.0,off.y)).a;float br=texture2D(u_dem,pos+off).a;\n#else\nvec4 demtl=vec4(texture2D(u_dem,pos).xyz*255.0,-1.0);float tl=dot(demtl,u_dem_unpack);vec4 demtr=vec4(texture2D(u_dem,pos+vec2(off.x,0.0)).xyz*255.0,-1.0);float tr=dot(demtr,u_dem_unpack);vec4 dembl=vec4(texture2D(u_dem,pos+vec2(0.0,off.y)).xyz*255.0,-1.0);float bl=dot(dembl,u_dem_unpack);vec4 dembr=vec4(texture2D(u_dem,pos+off).xyz*255.0,-1.0);float br=dot(dembr,u_dem_unpack);\n#endif\nreturn vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;vec4 bounds=vec4(d,vec2(1.0)-d);h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#else\nfloat elevation(vec2 pos) { return 0.0; }bool isOccluded(vec4 frag) { return false; }float occlusionFade(vec4 frag) { return 1.0; }\n#endif", true), Vt = $t("#ifdef FOG\nuniform float u_fog_temporal_offset;float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);return mix(color,u_fog_color.rgb,opacity);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec3 fog_dither(vec3 color) {vec2 dither_seed=gl_FragCoord.xy+u_fog_temporal_offset;return dither(color,dither_seed);}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif", "#ifdef FOG\nuniform mat4 u_fog_matrix;vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif", true);
      const Wt = $t("\nhighp vec3 hash(highp vec2 p) {highp vec3 p3=fract(p.xyx*vec3(443.8975,397.2973,491.1871));p3+=dot(p3,p3.yxz+19.19);return fract((p3.xxy+p3.yzz)*p3.zyx);}vec3 dither(vec3 color,highp vec2 seed) {vec3 rnd=hash(seed)+hash(seed+0.59374)-0.5;return color+rnd/255.0;}\n#ifdef TERRAIN\nhighp vec4 pack_depth(highp float ndc_z) {highp float depth=ndc_z*0.5+0.5;const highp vec4 bit_shift=vec4(256.0*256.0*256.0,256.0*256.0,256.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/256.0,1.0/256.0,1.0/256.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}\n#endif", "\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}vec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#if defined(PROJECTION_GLOBE_VIEW) && !defined(PROJECTED_POS_ON_VIEWPORT)\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {\n#if defined(PROJECTION_GLOBE_VIEW) && !defined(PROJECTED_POS_ON_VIEWPORT)\nreturn mix(globe,mercator,t);\n#else\nreturn globe;\n#endif\n}\n#ifdef PROJECTION_GLOBE_VIEW\nmat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}const vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);//Normalized device coordinate that is not rendered."), qt = Gt;
      var Xt = { background: $t("uniform vec4 u_color;uniform float u_opacity;void main() {vec4 out_color=u_color;\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"), backgroundPattern: $t("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 out_color=mix(color1,color2,u_mix);\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"), circle: $t("varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\ngl_FragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;attribute float a_scale;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nvarying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1,-1),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1,-1),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1,1),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1,1),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}float get_sample_step() {\n#ifdef PITCH_WITH_MAP\nreturn 2.0*PI/float(NUM_SAMPLES_PER_RING);\n#else\nreturn PI/float(NUM_SAMPLES_PER_RING);\n#endif\n}void main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);\n#ifdef PROJECTION_GLOBE_VIEW\nvec2 scaled_extrude=extrude*a_scale;vec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=scaled_extrude.x*surface_vectors[0]+scaled_extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*circle_elevation(circle_center);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*circle_elevation(circle_center);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);vec4 world_center=vec4(pos,1);\n#else \nmat3 surface_vectors=mat3(1.0);float height=circle_elevation(circle_center);vec4 world_center=vec4(circle_center,height,1);\n#endif\nvec4 projected_center=u_matrix*world_center;float view_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nview_scale=1.0;\n#else\nview_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nview_scale=u_camera_to_center_distance;\n#else\nview_scale=projected_center.w;\n#endif\n#endif\n#if defined(SCALE_WITH_MAP) && defined(PROJECTION_GLOBE_VIEW)\nview_scale*=a_scale;\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;\n#ifdef TERRAIN\nfloat step=get_sample_step();\n#ifdef PITCH_WITH_MAP\nfloat cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);vec4 occlusion_world_center=vec4(circle_center,cantilevered_height,1);vec4 occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\nvec4 occlusion_world_center=world_center;vec4 occlusion_projected_center=projected_center;\n#endif\nfor(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);\n#else\nvisibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nvisibility=1.0;\n#endif\nv_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}"), clippingMask: $t("void main() {gl_FragColor=vec4(1.0);}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"), heatmap: $t("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\ngl_FragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;attribute float a_scale;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nvarying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(a_pos*0.5);\n#ifdef PROJECTION_GLOBE_VIEW\nextrude*=a_scale;vec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\nvec3 pos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"), heatmapTexture: $t("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}", "attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=a_pos*0.5+0.5;}"), collisionBox: $t("varying float v_placed;varying float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);gl_FragColor =mix(red,blue,step(0.5,v_placed))*0.5;gl_FragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}", "attribute vec3 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;attribute float a_size_scale;attribute vec2 a_padding;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_pos+elevationVector(a_anchor_pos)*elevation(a_anchor_pos),1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(a_extrude*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"), collisionCircle: $t("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}", "attribute vec2 a_pos_2f;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"), debug: $t("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}", "attribute vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;\n#endif\nvarying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {float h=elevation(a_pos);v_uv=a_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(a_pos_3+elevationVector(a_pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(a_pos*u_overlay_scale,h,1);\n#endif\n}"), fill: $t("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec4 out_color=color;\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"), fillOutline: $t("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"), fillOutlinePattern: $t("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=mix(color1,color2,u_fade);\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"), fillPattern: $t("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 out_color=mix(color1,color2,u_fade);\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"), fillExtrusion: $t("varying vec4 v_color;void main() {vec4 color=v_color;\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ngl_FragColor=color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec4 a_pos_normal_ed;attribute vec2 a_centroid_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nvarying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 pos_nx=floor(a_pos_normal_ed.xyz*0.5);mediump vec3 top_up_ny=a_pos_normal_ed.xyz-2.0*pos_nx;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));base=max(0.0,base);height=max(0.0,height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;float ele=elevation(pos_nx.xy);float c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;float h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);vec3 pos=vec3(pos_nx.xy,h);\n#else\nvec3 pos=vec3(pos_nx.xy,t > 0.0 ? height : base);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*(pos.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.rgb+=clamp(color.rgb*directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_color*=u_opacity;\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"), fillExtrusionPattern: $t("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 out_color=mix(color1,color2,u_fade);out_color=out_color*v_lighting;\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec4 a_pos_normal_ed;attribute vec2 a_centroid_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nvarying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 pos_nx=floor(a_pos_normal_ed.xyz*0.5);mediump vec3 top_up_ny=a_pos_normal_ed.xyz-2.0*pos_nx;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=a_pos_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;float ele=elevation(pos_nx.xy);float c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;float h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);vec3 p=vec3(pos_nx.xy,h);\n#else\nvec3 p=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}"), hillshadePrepare: $t("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nreturn texture2D(u_image,coord).a/4.0;\n#else\nvec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;\n#endif\n}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos);float f=getElevation(v_pos+vec2(epsilon.x,0));float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float h=getElevation(v_pos+vec2(0,epsilon.y));float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"), hillshade: $t("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;void main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef FOG\ngl_FragColor=fog_dither(fog_apply_premultiplied(gl_FragColor,v_fog_pos));\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"), line: $t("uniform lowp float u_device_pixel_ratio;uniform float u_alpha_discard_threshold;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#ifdef RENDER_LINE_DASH\nuniform sampler2D u_dash_image;uniform float u_mix;uniform vec3 u_scale;varying vec2 v_tex_a;varying vec2 v_tex_b;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;varying highp vec2 v_uv;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash_from\n#pragma mapbox: define lowp vec4 dash_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash_from\n#pragma mapbox: initialize lowp vec4 dash_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);\n#ifdef RENDER_LINE_DASH\nfloat sdfdist_a=texture2D(u_dash_image,v_tex_a).a;float sdfdist_b=texture2D(u_dash_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfwidth=min(dash_from.z*u_scale.y,dash_to.z*u_scale.z);float sdfgamma=1.0/(2.0*u_device_pixel_ratio)/sdfwidth;alpha*=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);\n#endif\n#ifdef RENDER_LINE_GRADIENT\nvec4 out_color=texture2D(u_gradient_image,v_uv);\n#else\nvec4 out_color=color;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef RENDER_LINE_ALPHA_DISCARD\nif (alpha < u_alpha_discard_threshold) {discard;}\n#endif\ngl_FragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define EXTRUDE_SCALE 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;\n#ifdef RENDER_LINE_GRADIENT\nattribute vec3 a_packed;\n#else\nattribute float a_linesofar;\n#endif\nuniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;\n#ifdef RENDER_LINE_DASH\nuniform vec2 u_texsize;uniform mediump vec3 u_scale;varying vec2 v_tex_a;varying vec2 v_tex_b;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform float u_image_height;varying highp vec2 v_uv;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash_from\n#pragma mapbox: define lowp vec4 dash_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash_from\n#pragma mapbox: initialize lowp vec4 dash_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nfloat a_uv_x=a_packed[0];float a_split_index=a_packed[1];float a_linesofar=a_packed[2];highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);\n#endif\n#ifdef RENDER_LINE_DASH\nfloat tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;float scaleA=dash_from.z==0.0 ? 0.0 : tileZoomRatio/(dash_from.z*fromScale);float scaleB=dash_to.z==0.0 ? 0.0 : tileZoomRatio/(dash_to.z*toScale);float heightA=dash_from.y;float heightB=dash_to.y;v_tex_a=vec2(a_linesofar*scaleA/floorwidth,(-normal.y*heightA+dash_from.x+0.5)/u_texsize.y);v_tex_b=vec2(a_linesofar*scaleB/floorwidth,(-normal.y*heightB+dash_to.x+0.5)/u_texsize.y);\n#endif\nv_width2=vec2(outset,inset);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"), linePattern: $t("uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ngl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_linesofar;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"), raster: $t("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef FOG\nout_color=fog_dither(fog_apply(out_color,v_fog_pos));\n#endif\ngl_FragColor=vec4(out_color*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {float w=1.0+dot(a_texture_pos,u_perspective_transform);gl_Position=u_matrix*vec4(a_pos*w,0,w);v_pos0=a_texture_pos/8192.0;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"), symbolIcon: $t("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec4 a_pos_offset;attribute vec4 a_tex_size;attribute vec4 a_pixeloffset;attribute vec4 a_z_tile_anchor;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}float anchorZ=a_z_tile_anchor.x;vec2 tileAnchor=a_z_tile_anchor.yz;vec3 h=elevationVector(tileAnchor)*elevation(tileAnchor);vec3 mercator_pos=mercator_tile_position(u_inv_rot_matrix,tileAnchor,u_tile_id,u_merc_center);vec3 world_pos=mix_globe_mercator(vec3(a_pos,anchorZ)+h,mercator_pos,u_zoom_transition);vec4 projectedPoint=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),anchorZ,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec3 proj_pos=mix_globe_mercator(vec3(a_projected_pos.xy,anchorZ),mercator_pos,u_zoom_transition);\n#ifdef PROJECTED_POS_ON_VIEWPORT\nvec4 projected_pos=u_label_plane_matrix*vec4(proj_pos.xy,0.0,1.0);\n#else\nvec4 projected_pos=u_label_plane_matrix*vec4(proj_pos.xyz+h,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0);\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\nfloat occlusion_fade=occlusionFade(projectedPoint);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,float(projectedPoint.w <=0.0 || occlusion_fade==0.0));float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nv_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change))*projection_transition_fade;}"), symbolSDF: $t("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec4 a_pos_offset;attribute vec4 a_tex_size;attribute vec4 a_pixeloffset;attribute vec4 a_z_tile_anchor;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_tile_id;uniform float u_zoom_transition;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}float anchorZ=a_z_tile_anchor.x;vec2 tileAnchor=a_z_tile_anchor.yz;vec3 h=elevationVector(tileAnchor)*elevation(tileAnchor);vec3 mercator_pos=mercator_tile_position(u_inv_rot_matrix,tileAnchor,u_tile_id,u_merc_center);vec3 world_pos=mix_globe_mercator(vec3(a_pos,anchorZ)+h,mercator_pos,u_zoom_transition);vec4 projectedPoint=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),anchorZ,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec3 proj_pos=mix_globe_mercator(vec3(a_projected_pos.xy,anchorZ),mercator_pos,u_zoom_transition);\n#ifdef PROJECTED_POS_ON_VIEWPORT\nvec4 projected_pos=u_label_plane_matrix*vec4(proj_pos.xy,0.0,1.0);\n#else\nvec4 projected_pos=u_label_plane_matrix*vec4(proj_pos.xyz+h,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset);\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\nfloat occlusion_fade=occlusionFade(projectedPoint);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,float(projectedPoint.w <=0.0 || occlusion_fade==0.0));float gamma_scale=gl_Position.w;float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nvec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity*projection_transition_fade);}"), symbolTextAndIcon: $t("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec4 a_pos_offset;attribute vec4 a_tex_size;attribute vec4 a_z_tile_anchor;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}float anchorZ=a_z_tile_anchor.x;vec2 tileAnchor=a_z_tile_anchor.yz;vec3 h=elevationVector(tileAnchor)*elevation(tileAnchor);vec3 mercator_pos=mercator_tile_position(u_inv_rot_matrix,tileAnchor,u_tile_id,u_merc_center);vec3 world_pos=mix_globe_mercator(vec3(a_pos,anchorZ)+h,mercator_pos,u_zoom_transition);vec4 projectedPoint=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),anchorZ,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec3 proj_pos=mix_globe_mercator(vec3(a_projected_pos.xy,anchorZ),mercator_pos,u_zoom_transition);\n#ifdef PROJECTED_POS_ON_VIEWPORT\nvec4 projected_pos=u_label_plane_matrix*vec4(proj_pos.xy,0.0,1.0);\n#else\nvec4 projected_pos=u_label_plane_matrix*vec4(proj_pos.xyz+h,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*fontScale);\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\nfloat occlusion_fade=occlusionFade(projectedPoint);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,float(projectedPoint.w <=0.0 || occlusion_fade==0.0));float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nv_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity*projection_transition_fade,is_sdf);}"), terrainRaster: $t("uniform sampler2D u_image0;varying vec2 v_pos0;\n#ifdef FOG\nvarying float v_fog_opacity;\n#endif\nvoid main() {vec4 color=texture2D(u_image0,v_pos0);\n#ifdef FOG\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\ngl_FragColor=color;\n#ifdef TERRAIN_WIREFRAME\ngl_FragColor=vec4(1.0,0.0,0.0,0.8);\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform float u_skirt_height;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;\n#ifdef FOG\nvarying float v_fog_opacity;\n#endif\nconst float skirtOffset=24575.0;const float wireframeOffset=0.00015;void main() {v_pos0=a_texture_pos/8192.0;float skirt=float(a_pos.x >=skirtOffset);float elevation=elevation(a_texture_pos)-skirt*u_skirt_height;\n#ifdef TERRAIN_WIREFRAME\nelevation+=u_skirt_height*u_skirt_height*wireframeOffset;\n#endif\nvec2 decodedPos=a_pos-vec2(skirt*skirtOffset,0.0);gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n}"), terrainDepth: $t("#ifdef GL_ES\nprecision highp float;\n#endif\nvarying float v_depth;void main() {gl_FragColor=pack_depth(v_depth);}", "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying float v_depth;void main() {float elevation=elevation(a_texture_pos);gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}"), skybox: $t("\nvarying lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=textureCube(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color.rgb=dither(sky_color.rgb,gl_FragCoord.xy+u_temporal_offset);sky_color+=0.1*sun_disk(v_uv,u_sun_direction);gl_FragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", jt), skyboxGradient: $t("varying highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture2D(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;color.rgb=dither(color.rgb,gl_FragCoord.xy+u_temporal_offset);gl_FragColor=color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", jt), skyboxCapture: $t("\nvarying highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;\n#ifdef GL_ES\nprecision highp float;\n#endif\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;gl_FragColor=vec4(color,1.0);}", "attribute highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;varying highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;v_position.y*=-1.0;v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"), globeRaster: $t("uniform sampler2D u_image0;varying vec2 v_pos0;void main() {gl_FragColor=texture2D(u_image0,v_pos0);\n#ifdef TERRAIN_WIREFRAME\ngl_FragColor=vec4(1.0,0.0,0.0,0.8);\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_proj_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform float u_zoom_transition;uniform vec2 u_merc_center;attribute vec3 a_globe_pos;attribute vec2 a_merc_pos;attribute vec2 a_uv;varying vec2 v_pos0;const float wireframeOffset=1e3;void main() {v_pos0=a_uv;vec2 uv=a_uv*EXTENT;vec4 up_vector=vec4(elevationVector(uv),1.0);float height=elevation(uv);\n#ifdef TERRAIN_WIREFRAME\nheight+=wireframeOffset;\n#endif\nvec4 globe=u_globe_matrix*vec4(a_globe_pos+up_vector.xyz*height,1.0);vec4 mercator=vec4(0.0);if (u_zoom_transition > 0.0) {mercator=vec4(a_merc_pos,height,1.0);mercator.xy-=u_merc_center;mercator.x=wrap(mercator.x,-0.5,0.5);mercator=u_merc_matrix*mercator;}vec3 position=mix(globe.xyz,mercator.xyz,u_zoom_transition);gl_Position=u_proj_matrix*vec4(position,1.0);}"), globeAtmosphere: $t("uniform vec2 u_center;uniform float u_radius;uniform vec2 u_screen_size;uniform float u_opacity;uniform highp float u_fadeout_range;uniform vec3 u_start_color;uniform vec3 u_end_color;uniform float u_pixel_ratio;void main() {highp vec2 fragCoord=gl_FragCoord.xy/u_pixel_ratio;fragCoord.y=u_screen_size.y-fragCoord.y;float distFromCenter=length(fragCoord-u_center);float normDistFromCenter=length(fragCoord-u_center)/u_radius;if (normDistFromCenter < 1.0)\ndiscard;float t=clamp(1.0-sqrt(normDistFromCenter-1.0)/u_fadeout_range,0.0,1.0);vec3 color=mix(u_start_color,u_end_color,1.0-t);gl_FragColor=vec4(color*t*u_opacity,u_opacity);}", "attribute vec3 a_pos;void main() {gl_Position=vec4(a_pos,1.0);}") };
      function $t(e2, t2, i3) {
        const o2 = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, r2 = /uniform (highp |mediump |lowp )?([\w]+) ([\w]+)([\s]*)([\w]*)/g, n2 = t2.match(/attribute (highp |mediump |lowp )?([\w]+) ([\w]+)/g), a2 = e2.match(r2), s3 = t2.match(r2), l2 = Gt.match(r2);
        let c2 = s3 ? s3.concat(a2) : a2;
        i3 || (Zt.staticUniforms && (c2 = Zt.staticUniforms.concat(c2)), Vt.staticUniforms && (c2 = Vt.staticUniforms.concat(c2))), c2 && (c2 = c2.concat(l2));
        const h2 = {};
        return { fragmentSource: e2 = e2.replace(o2, (e3, t3, i4, o3, r3) => (h2[r3] = true, t3 === "define" ? `
#ifndef HAS_UNIFORM_u_${r3}
varying ${i4} ${o3} ${r3};
#else
uniform ${i4} ${o3} u_${r3};
#endif
` : `
#ifdef HAS_UNIFORM_u_${r3}
    ${i4} ${o3} ${r3} = u_${r3};
#endif
`)), vertexSource: t2 = t2.replace(o2, (e3, t3, i4, o3, r3) => {
          const n3 = o3 === "float" ? "vec2" : "vec4", a3 = r3.match(/color/) ? "color" : n3;
          return h2[r3] ? t3 === "define" ? `
#ifndef HAS_UNIFORM_u_${r3}
uniform lowp float u_${r3}_t;
attribute ${i4} ${n3} a_${r3};
varying ${i4} ${o3} ${r3};
#else
uniform ${i4} ${o3} u_${r3};
#endif
` : a3 === "vec4" ? `
#ifndef HAS_UNIFORM_u_${r3}
    ${r3} = a_${r3};
#else
    ${i4} ${o3} ${r3} = u_${r3};
#endif
` : `
#ifndef HAS_UNIFORM_u_${r3}
    ${r3} = unpack_mix_${a3}(a_${r3}, u_${r3}_t);
#else
    ${i4} ${o3} ${r3} = u_${r3};
#endif
` : t3 === "define" ? `
#ifndef HAS_UNIFORM_u_${r3}
uniform lowp float u_${r3}_t;
attribute ${i4} ${n3} a_${r3};
#else
uniform ${i4} ${o3} u_${r3};
#endif
` : a3 === "vec4" ? `
#ifndef HAS_UNIFORM_u_${r3}
    ${i4} ${o3} ${r3} = a_${r3};
#else
    ${i4} ${o3} ${r3} = u_${r3};
#endif
` : `
#ifndef HAS_UNIFORM_u_${r3}
    ${i4} ${o3} ${r3} = unpack_mix_${a3}(a_${r3}, u_${r3}_t);
#else
    ${i4} ${o3} ${r3} = u_${r3};
#endif
`;
        }), staticAttributes: n2, staticUniforms: c2 };
      }
      class Ht {
        constructor() {
          this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
        }
        bind(e2, t2, i3, o2, r2, n2, a2, s3) {
          this.context = e2;
          let l2 = this.boundPaintVertexBuffers.length !== o2.length;
          for (let e3 = 0; !l2 && e3 < o2.length; e3++)
            this.boundPaintVertexBuffers[e3] !== o2[e3] && (l2 = true);
          e2.extVertexArrayObject && this.vao && this.boundProgram === t2 && this.boundLayoutVertexBuffer === i3 && !l2 && this.boundIndexBuffer === r2 && this.boundVertexOffset === n2 && this.boundDynamicVertexBuffer === a2 && this.boundDynamicVertexBuffer2 === s3 ? (e2.bindVertexArrayOES.set(this.vao), a2 && a2.bind(), r2 && r2.dynamicDraw && r2.bind(), s3 && s3.bind()) : this.freshBind(t2, i3, o2, r2, n2, a2, s3);
        }
        freshBind(e2, t2, i3, o2, r2, n2, a2) {
          let s3;
          const l2 = e2.numAttributes, c2 = this.context, h2 = c2.gl;
          if (c2.extVertexArrayObject)
            this.vao && this.destroy(), this.vao = c2.extVertexArrayObject.createVertexArrayOES(), c2.bindVertexArrayOES.set(this.vao), s3 = 0, this.boundProgram = e2, this.boundLayoutVertexBuffer = t2, this.boundPaintVertexBuffers = i3, this.boundIndexBuffer = o2, this.boundVertexOffset = r2, this.boundDynamicVertexBuffer = n2, this.boundDynamicVertexBuffer2 = a2;
          else {
            s3 = c2.currentNumAttributes || 0;
            for (let e3 = l2; e3 < s3; e3++)
              h2.disableVertexAttribArray(e3);
          }
          t2.enableAttributes(h2, e2);
          for (const t3 of i3)
            t3.enableAttributes(h2, e2);
          n2 && n2.enableAttributes(h2, e2), a2 && a2.enableAttributes(h2, e2), t2.bind(), t2.setVertexAttribPointers(h2, e2, r2);
          for (const t3 of i3)
            t3.bind(), t3.setVertexAttribPointers(h2, e2, r2);
          n2 && (n2.bind(), n2.setVertexAttribPointers(h2, e2, r2)), o2 && o2.bind(), a2 && (a2.bind(), a2.setVertexAttribPointers(h2, e2, r2)), c2.currentNumAttributes = l2;
        }
        destroy() {
          this.vao && (this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao), this.vao = null);
        }
      }
      function Kt(t2, i3) {
        const o2 = Math.pow(2, i3.canonical.z), r2 = i3.canonical.y;
        return [new e.MercatorCoordinate(0, r2 / o2).toLngLat().lat, new e.MercatorCoordinate(0, (r2 + 1) / o2).toLngLat().lat];
      }
      function Yt(t2, i3, o2, r2, n2, a2, s3) {
        const l2 = t2.context, c2 = l2.gl, h2 = o2.fbo;
        if (!h2)
          return;
        t2.prepareDrawTile(i3);
        const u2 = t2.useProgram("hillshade");
        l2.activeTexture.set(c2.TEXTURE0), c2.bindTexture(c2.TEXTURE_2D, h2.colorAttachment.get());
        const _2 = ((e2, t3, i4, o3) => {
          const r3 = i4.paint.get("hillshade-shadow-color"), n3 = i4.paint.get("hillshade-highlight-color"), a3 = i4.paint.get("hillshade-accent-color");
          let s4 = i4.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
          i4.paint.get("hillshade-illumination-anchor") === "viewport" && (s4 -= e2.transform.angle);
          const l3 = !e2.options.moving;
          return { u_matrix: o3 || e2.transform.calculateProjMatrix(t3.tileID.toUnwrapped(), l3), u_image: 0, u_latrange: Kt(0, t3.tileID), u_light: [i4.paint.get("hillshade-exaggeration"), s4], u_shadow: r3, u_highlight: n3, u_accent: a3 };
        })(t2, o2, r2, t2.terrain ? i3.projMatrix : null);
        t2.prepareDrawProgram(l2, u2, i3.toUnwrapped());
        const { tileBoundsBuffer: d2, tileBoundsIndexBuffer: p2, tileBoundsSegments: m2 } = t2.getTileBoundsBuffers(o2);
        u2.draw(l2, c2.TRIANGLES, n2, a2, s3, e.CullFaceMode.disabled, _2, r2.id, d2, p2, m2);
      }
      function Jt(t2, i3, o2) {
        if (!i3.needsDEMTextureUpload)
          return;
        const r2 = t2.context, n2 = r2.gl;
        r2.pixelStoreUnpackPremultiplyAlpha.set(false), i3.demTexture = i3.demTexture || t2.getTileTexture(o2.stride);
        const a2 = o2.getPixels();
        i3.demTexture ? i3.demTexture.update(a2, { premultiply: false }) : i3.demTexture = new e.Texture(r2, a2, n2.RGBA, { premultiply: false }), i3.needsDEMTextureUpload = false;
      }
      function Qt(t2, i3, o2, r2, n2, a2) {
        const s3 = t2.context, l2 = s3.gl;
        if (!i3.dem)
          return;
        const c2 = i3.dem;
        if (s3.activeTexture.set(l2.TEXTURE1), Jt(t2, i3, c2), !i3.demTexture)
          return;
        i3.demTexture.bind(l2.NEAREST, l2.CLAMP_TO_EDGE);
        const h2 = c2.dim;
        s3.activeTexture.set(l2.TEXTURE0);
        let u2 = i3.fbo;
        if (!u2) {
          const t3 = new e.Texture(s3, { width: h2, height: h2, data: null }, l2.RGBA);
          t3.bind(l2.LINEAR, l2.CLAMP_TO_EDGE), u2 = i3.fbo = s3.createFramebuffer(h2, h2, true), u2.colorAttachment.set(t3.texture);
        }
        s3.bindFramebuffer.set(u2.framebuffer), s3.viewport.set([0, 0, h2, h2]);
        const { tileBoundsBuffer: _2, tileBoundsIndexBuffer: d2, tileBoundsSegments: p2 } = t2.getMercatorTileBoundsBuffers();
        t2.useProgram("hillshadePrepare").draw(s3, l2.TRIANGLES, r2, n2, a2, e.CullFaceMode.disabled, ((t3, i4) => {
          const o3 = i4.stride, r3 = e.create();
          return e.ortho(r3, 0, e.EXTENT, -e.EXTENT, 0, 0, 1), e.translate(r3, r3, [0, -e.EXTENT, 0]), { u_matrix: r3, u_image: 1, u_dimension: [o3, o3], u_zoom: t3.overscaledZ, u_unpack: i4.unpackVector };
        })(i3.tileID, c2), o2.id, _2, d2, p2), i3.needsHillshadePrepare = false;
      }
      const ei = (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_image0: new e.Uniform1i(t2, i3.u_image0), u_skirt_height: new e.Uniform1f(t2, i3.u_skirt_height) }), ti = (e2, t2) => ({ u_matrix: e2, u_image0: 0, u_skirt_height: t2 }), ii = (e2, t2, i3, o2, r2) => ({ u_proj_matrix: Float32Array.from(e2), u_globe_matrix: t2, u_merc_matrix: i3, u_zoom_transition: o2, u_merc_center: r2, u_image0: 0 });
      function oi(e2, t2) {
        return e2 != null && t2 != null && !(!e2.hasData() || !t2.hasData()) && e2.demTexture != null && t2.demTexture != null && e2.tileID.key !== t2.tileID.key;
      }
      const ri = new class {
        constructor() {
          this.operations = {};
        }
        newMorphing(e2, t2, i3, o2, r2) {
          if (e2 in this.operations) {
            const t3 = this.operations[e2];
            t3.to.tileID.key !== i3.tileID.key && (t3.queued = i3);
          } else
            this.operations[e2] = { startTime: o2, phase: 0, duration: r2, from: t2, to: i3, queued: null };
        }
        getMorphValuesForProxy(e2) {
          if (!(e2 in this.operations))
            return null;
          const t2 = this.operations[e2];
          return { from: t2.from, to: t2.to, phase: t2.phase };
        }
        update(e2) {
          for (const t2 in this.operations) {
            const i3 = this.operations[t2];
            for (i3.phase = (e2 - i3.startTime) / i3.duration; i3.phase >= 1 || !this._validOp(i3); )
              if (!this._nextOp(i3, e2)) {
                delete this.operations[t2];
                break;
              }
          }
        }
        _nextOp(e2, t2) {
          return !!e2.queued && (e2.from = e2.to, e2.to = e2.queued, e2.queued = null, e2.phase = 0, e2.startTime = t2, true);
        }
        _validOp(e2) {
          return e2.from.hasData() && e2.to.hasData();
        }
      }(), ni = { 0: null, 1: "TERRAIN_VERTEX_MORPHING", 2: "TERRAIN_WIREFRAME" };
      function ai(e2, t2) {
        const i3 = 1 << e2.z;
        return !t2 && (e2.x === 0 || e2.x === i3 - 1) || e2.y === 0 || e2.y === i3 - 1;
      }
      const si = (e2) => ({ u_matrix: e2 });
      function li(t2, i3, o2, r2, n2) {
        if (n2 > 0) {
          const a2 = e.exported.now(), s3 = (a2 - t2.timeAdded) / n2, l2 = i3 ? (a2 - i3.timeAdded) / n2 : -1, c2 = o2.getSource(), h2 = r2.coveringZoomLevel({ tileSize: c2.tileSize, roundZoom: c2.roundZoom }), u2 = !i3 || Math.abs(i3.tileID.overscaledZ - h2) > Math.abs(t2.tileID.overscaledZ - h2), _2 = u2 && t2.refreshedUponExpiration ? 1 : e.clamp(u2 ? s3 : 1 - l2, 0, 1);
          return t2.refreshedUponExpiration && s3 >= 1 && (t2.refreshedUponExpiration = false), i3 ? { opacity: 1, mix: 1 - _2 } : { opacity: _2, mix: 0 };
        }
        return { opacity: 1, mix: 0 };
      }
      class ci extends e.SourceCache {
        constructor(e2) {
          const t2 = { type: "raster-dem", maxzoom: e2.transform.maxZoom }, i3 = new C(Ae(), null), o2 = Te("mock-dem", t2, i3, e2.style);
          super("mock-dem", o2, false), o2.setEventedParent(this), this._sourceLoaded = true;
        }
        _loadTile(e2, t2) {
          e2.state = "loaded", t2(null);
        }
      }
      class hi extends e.SourceCache {
        constructor(e2) {
          const t2 = Te("proxy", { type: "geojson", maxzoom: e2.transform.maxZoom }, new C(Ae(), null), e2.style);
          super("proxy", t2, false), t2.setEventedParent(this), this.map = this.getSource().map = e2, this.used = this._sourceLoaded = true, this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
        }
        update(t2, i3, o2) {
          if (t2.freezeTileCoverage)
            return;
          this.transform = t2;
          const r2 = t2.coveringTiles({ tileSize: this._source.tileSize, minzoom: this._source.minzoom, maxzoom: this._source.maxzoom, roundZoom: this._source.roundZoom, reparseOverscaled: this._source.reparseOverscaled }).reduce((i4, o3) => {
            if (i4[o3.key] = "", !this._tiles[o3.key]) {
              const i5 = new e.Tile(o3, this._source.tileSize * o3.overscaleFactor(), t2.tileZoom);
              i5.state = "loaded", this._tiles[o3.key] = i5;
            }
            return i4;
          }, {});
          for (const e2 in this._tiles)
            e2 in r2 || (this.freeFBO(e2), this._tiles[e2].unloadVectorData(), delete this._tiles[e2]);
        }
        freeFBO(e2) {
          const t2 = this.proxyCachedFBO[e2];
          if (t2 !== void 0) {
            const i3 = Object.values(t2);
            this.renderCachePool.push(...i3), delete this.proxyCachedFBO[e2];
          }
        }
        deallocRenderCache() {
          this.renderCache.forEach((e2) => e2.fb.destroy()), this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
        }
      }
      class ui extends e.OverscaledTileID {
        constructor(e2, t2, i3) {
          super(e2.overscaledZ, e2.wrap, e2.canonical.z, e2.canonical.x, e2.canonical.y), this.proxyTileKey = t2, this.projMatrix = i3;
        }
      }
      class _i extends e.Elevation {
        constructor(t2, i3) {
          super(), this.painter = t2, this.terrainTileForTile = {}, this.prevTerrainTileForTile = {};
          const [o2, r2, n2] = function(t3) {
            const i4 = new e.StructArrayLayout4i8(), o3 = new e.StructArrayLayout3ui6(), r3 = 131;
            i4.reserve(17161), o3.reserve(33800);
            const n3 = e.EXTENT / 128, a3 = e.EXTENT + n3 / 2, s4 = a3 + n3;
            for (let t4 = -n3; t4 < s4; t4 += n3)
              for (let o4 = -n3; o4 < s4; o4 += n3) {
                const r4 = o4 < 0 || o4 > a3 || t4 < 0 || t4 > a3 ? 24575 : 0, n4 = e.clamp(Math.round(o4), 0, e.EXTENT), s5 = e.clamp(Math.round(t4), 0, e.EXTENT);
                i4.emplaceBack(n4 + r4, s5, n4, s5);
              }
            const l2 = (e2, t4) => {
              const i5 = t4 * r3 + e2;
              o3.emplaceBack(i5 + 1, i5, i5 + r3), o3.emplaceBack(i5 + r3, i5 + r3 + 1, i5 + 1);
            };
            for (let e2 = 1; e2 < 129; e2++)
              for (let t4 = 1; t4 < 129; t4++)
                l2(t4, e2);
            return [0, 129].forEach((e2) => {
              for (let t4 = 0; t4 < 130; t4++)
                l2(t4, e2), l2(e2, t4);
            }), [i4, o3, 32768];
          }(), a2 = t2.context;
          this.gridBuffer = a2.createVertexBuffer(o2, e.boundsAttributes.members), this.gridIndexBuffer = a2.createIndexBuffer(r2), this.gridSegments = e.SegmentVector.simpleSegment(0, 0, o2.length, r2.length), this.gridNoSkirtSegments = e.SegmentVector.simpleSegment(0, 0, o2.length, n2), this.proxyCoords = [], this.proxiedCoords = {}, this._visibleDemTiles = [], this._drapedRenderBatches = [], this._sourceTilesOverlap = {}, this.proxySourceCache = new hi(i3.map), this.orthoMatrix = e.create(), e.ortho(this.orthoMatrix, 0, e.EXTENT, 0, e.EXTENT, 0, 1);
          const s3 = a2.gl;
          this._overlapStencilMode = new e.StencilMode({ func: s3.GEQUAL, mask: 255 }, 0, 255, s3.KEEP, s3.KEEP, s3.REPLACE), this._previousZoom = t2.transform.zoom, this.pool = [], this._findCoveringTileCache = {}, this._tilesDirty = {}, this.style = i3, this._useVertexMorphing = true, this._exaggeration = 1, this._mockSourceCache = new ci(i3.map);
        }
        set style(e2) {
          e2.on("data", this._onStyleDataEvent.bind(this)), e2.on("neworder", this._checkRenderCacheEfficiency.bind(this)), this._style = e2, this._checkRenderCacheEfficiency();
        }
        update(t2, i3, o2) {
          if (t2 && t2.terrain) {
            this._style !== t2 && (this.style = t2), this.enabled = true;
            const r2 = t2.terrain.properties;
            this.sourceCache = t2.terrain.drapeRenderMode === 0 ? this._mockSourceCache : t2._getSourceCache(r2.get("source")), this._exaggeration = r2.get("exaggeration");
            const n2 = () => {
              this.sourceCache.used && e.warnOnce(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.
This leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);
              const t3 = this.getScaledDemTileSize();
              this.sourceCache.update(i3, t3, true), this.resetTileLookupCache(this.sourceCache.id);
            };
            this.sourceCache.usedForTerrain || (this.resetTileLookupCache(this.sourceCache.id), this.sourceCache.usedForTerrain = true, n2(), this._initializing = true), n2(), i3.updateElevation(!o2), this.resetTileLookupCache(this.proxySourceCache.id), this.proxySourceCache.update(i3), this._emptyDEMTextureDirty = true;
          } else
            this._disable();
        }
        resetTileLookupCache(e2) {
          this._findCoveringTileCache[e2] = {};
        }
        getScaledDemTileSize() {
          return this.sourceCache.getSource().tileSize / 128 * this.proxySourceCache.getSource().tileSize;
        }
        _checkRenderCacheEfficiency() {
          const t2 = this.renderCacheEfficiency(this._style);
          this._style.map._optimizeForTerrain || t2.efficiency !== 100 && e.warnOnce(`Terrain render cache efficiency is not optimal (${t2.efficiency}%) and performance
                may be affected negatively, consider placing all background, fill and line layers before layer
                with id '${t2.firstUndrapedLayer}' or create a map using optimizeForTerrain: true option.`);
        }
        _onStyleDataEvent(e2) {
          e2.coord && e2.dataType === "source" ? this._clearRenderCacheForTile(e2.sourceCacheId, e2.coord) : e2.dataType === "style" && (this._invalidateRenderCache = true);
        }
        _disable() {
          if (this.enabled && (this.enabled = false, this._sharedDepthStencil = void 0, this.proxySourceCache.deallocRenderCache(), this._style))
            for (const e2 in this._style._sourceCaches)
              this._style._sourceCaches[e2].usedForTerrain = false;
        }
        destroy() {
          this._disable(), this._emptyDEMTexture && this._emptyDEMTexture.destroy(), this._emptyDepthBufferTexture && this._emptyDepthBufferTexture.destroy(), this.pool.forEach((e2) => e2.fb.destroy()), this.pool = [], this._depthFBO && (this._depthFBO.destroy(), delete this._depthFBO, delete this._depthTexture);
        }
        _source() {
          return this.enabled ? this.sourceCache : null;
        }
        exaggeration() {
          return this._exaggeration;
        }
        get visibleDemTiles() {
          return this._visibleDemTiles;
        }
        get drapeBufferSize() {
          const e2 = 2 * this.proxySourceCache.getSource().tileSize;
          return [e2, e2];
        }
        set useVertexMorphing(e2) {
          this._useVertexMorphing = e2;
        }
        updateTileBinding(t2) {
          if (!this.enabled)
            return;
          this.prevTerrainTileForTile = this.terrainTileForTile;
          const i3 = this.proxySourceCache, o2 = this.painter.transform;
          this._initializing && (this._initializing = o2._centerAltitude === 0 && this.getAtPointOrZero(e.MercatorCoordinate.fromLngLat(o2.center), -1) === -1, this._emptyDEMTextureDirty = !this._initializing);
          const r2 = this.proxyCoords = i3.getIds().map((e2) => {
            const t3 = i3.getTileByID(e2).tileID;
            return t3.projMatrix = o2.calculateProjMatrix(t3.toUnwrapped()), t3;
          });
          !function(t3, i4) {
            const o3 = i4.transform.pointCoordinate(i4.transform.getCameraPoint()), r3 = new e.pointGeometry(o3.x, o3.y);
            t3.sort((t4, i5) => {
              if (i5.overscaledZ - t4.overscaledZ)
                return i5.overscaledZ - t4.overscaledZ;
              const o4 = new e.pointGeometry(t4.canonical.x + (1 << t4.canonical.z) * t4.wrap, t4.canonical.y), n3 = new e.pointGeometry(i5.canonical.x + (1 << i5.canonical.z) * i5.wrap, i5.canonical.y), a3 = r3.mult(1 << t4.canonical.z);
              return a3.x -= 0.5, a3.y -= 0.5, a3.distSqr(o4) - a3.distSqr(n3);
            });
          }(r2, this.painter), this._previousZoom = o2.zoom;
          const n2 = this.proxyToSource || {};
          this.proxyToSource = {}, r2.forEach((e2) => {
            this.proxyToSource[e2.key] = {};
          }), this.terrainTileForTile = {};
          const a2 = this._style._sourceCaches;
          for (const e2 in a2) {
            const i4 = a2[e2];
            if (!i4.used)
              continue;
            if (i4 !== this.sourceCache && this.resetTileLookupCache(i4.id), this._setupProxiedCoordsForOrtho(i4, t2[e2], n2), i4.usedForTerrain)
              continue;
            const o3 = t2[e2];
            i4.getSource().reparseOverscaled && this._assignTerrainTiles(o3);
          }
          this.proxiedCoords[i3.id] = r2.map((e2) => new ui(e2, e2.key, this.orthoMatrix)), this._assignTerrainTiles(r2), this._prepareDEMTextures(), this._setupDrapedRenderBatches(), this._initFBOPool(), this._setupRenderCache(n2), this.renderingToTexture = false, this._updateTimestamp = e.exported.now();
          const s3 = {};
          this._visibleDemTiles = [];
          for (const e2 of this.proxyCoords) {
            const t3 = this.terrainTileForTile[e2.key];
            if (!t3)
              continue;
            const i4 = t3.tileID.key;
            i4 in s3 || (this._visibleDemTiles.push(t3), s3[i4] = i4);
          }
        }
        _assignTerrainTiles(e2) {
          this._initializing || e2.forEach((e3) => {
            if (this.terrainTileForTile[e3.key])
              return;
            const t2 = this._findTileCoveringTileID(e3, this.sourceCache);
            t2 && (this.terrainTileForTile[e3.key] = t2);
          });
        }
        _prepareDEMTextures() {
          const e2 = this.painter.context, t2 = e2.gl;
          for (const i3 in this.terrainTileForTile) {
            const o2 = this.terrainTileForTile[i3], r2 = o2.dem;
            !r2 || o2.demTexture && !o2.needsDEMTextureUpload || (e2.activeTexture.set(t2.TEXTURE1), Jt(this.painter, o2, r2));
          }
        }
        _prepareDemTileUniforms(e2, t2, i3, o2) {
          if (!t2 || t2.demTexture == null)
            return false;
          const r2 = e2.tileID.canonical, n2 = Math.pow(2, t2.tileID.canonical.z - r2.z), a2 = o2 || "";
          return i3[`u_dem_tl${a2}`] = [r2.x * n2 % 1, r2.y * n2 % 1], i3[`u_dem_scale${a2}`] = n2, true;
        }
        get emptyDEMTexture() {
          return !this._emptyDEMTextureDirty && this._emptyDEMTexture ? this._emptyDEMTexture : this._updateEmptyDEMTexture();
        }
        get emptyDepthBufferTexture() {
          const t2 = this.painter.context, i3 = t2.gl;
          if (!this._emptyDepthBufferTexture) {
            const o2 = { width: 1, height: 1, data: new Uint8Array([255, 255, 255, 255]) };
            this._emptyDepthBufferTexture = new e.Texture(t2, o2, i3.RGBA, { premultiply: false });
          }
          return this._emptyDepthBufferTexture;
        }
        _getLoadedAreaMinimum() {
          let e2 = 0;
          const t2 = this._visibleDemTiles.reduce((t3, i3) => {
            if (!i3.dem)
              return t3;
            const o2 = i3.dem.tree.minimums[0];
            return o2 > 0 && e2++, t3 + o2;
          }, 0);
          return e2 ? t2 / e2 : 0;
        }
        _updateEmptyDEMTexture() {
          const t2 = this.painter.context, i3 = t2.gl;
          t2.activeTexture.set(i3.TEXTURE2);
          const o2 = this._getLoadedAreaMinimum(), r2 = { width: 1, height: 1, data: new Uint8Array(e.DEMData.pack(o2, this.sourceCache.getSource().encoding)) };
          this._emptyDEMTextureDirty = false;
          let n2 = this._emptyDEMTexture;
          return n2 ? n2.update(r2, { premultiply: false }) : n2 = this._emptyDEMTexture = new e.Texture(t2, r2, i3.RGBA, { premultiply: false }), n2;
        }
        setupElevationDraw(t2, i3, o2) {
          const r2 = this.painter.context, n2 = r2.gl, a2 = (s3 = this.sourceCache.getSource().encoding, { u_dem: 2, u_dem_prev: 4, u_dem_unpack: e.DEMData.getUnpackVector(s3), u_dem_tl: [0, 0], u_dem_tl_prev: [0, 0], u_dem_scale: 0, u_dem_scale_prev: 0, u_dem_size: 0, u_dem_lerp: 1, u_depth: 3, u_depth_size_inv: [0, 0], u_exaggeration: 0, u_tile_tl_up: [0, 0, 1], u_tile_tr_up: [0, 0, 1], u_tile_br_up: [0, 0, 1], u_tile_bl_up: [0, 0, 1], u_tile_up_scale: 1 });
          var s3;
          a2.u_dem_size = this.sourceCache.getSource().tileSize, a2.u_exaggeration = this.exaggeration();
          const l2 = this.painter.transform, c2 = l2.projection.createTileTransform(l2, l2.worldSize), h2 = t2.tileID.canonical;
          a2.u_tile_tl_up = c2.upVector(h2, 0, 0), a2.u_tile_tr_up = c2.upVector(h2, e.EXTENT, 0), a2.u_tile_br_up = c2.upVector(h2, e.EXTENT, e.EXTENT), a2.u_tile_bl_up = c2.upVector(h2, 0, e.EXTENT), a2.u_tile_up_scale = c2.upVectorScale(h2);
          let u2 = null, _2 = null, d2 = 1;
          if (o2 && o2.morphing && this._useVertexMorphing) {
            const e2 = o2.morphing.srcDemTile, i4 = o2.morphing.dstDemTile;
            d2 = o2.morphing.phase, e2 && i4 && (this._prepareDemTileUniforms(t2, e2, a2, "_prev") && (_2 = e2), this._prepareDemTileUniforms(t2, i4, a2) && (u2 = i4));
          }
          if (_2 && u2 ? (r2.activeTexture.set(n2.TEXTURE2), u2.demTexture.bind(n2.NEAREST, n2.CLAMP_TO_EDGE, n2.NEAREST), r2.activeTexture.set(n2.TEXTURE4), _2.demTexture.bind(n2.NEAREST, n2.CLAMP_TO_EDGE, n2.NEAREST), a2.u_dem_lerp = d2) : (u2 = this.terrainTileForTile[t2.tileID.key], r2.activeTexture.set(n2.TEXTURE2), (this._prepareDemTileUniforms(t2, u2, a2) ? u2.demTexture : this.emptyDEMTexture).bind(n2.NEAREST, n2.CLAMP_TO_EDGE)), r2.activeTexture.set(n2.TEXTURE3), o2 && o2.useDepthForOcclusion ? (this._depthTexture.bind(n2.NEAREST, n2.CLAMP_TO_EDGE), a2.u_depth_size_inv = [1 / this._depthFBO.width, 1 / this._depthFBO.height]) : (this.emptyDepthBufferTexture.bind(n2.NEAREST, n2.CLAMP_TO_EDGE), a2.u_depth_size_inv = [1, 1]), o2 && o2.useMeterToDem && u2) {
            const t3 = (1 << u2.tileID.canonical.z) * e.mercatorZfromAltitude(1, this.painter.transform.center.lat) * this.sourceCache.getSource().tileSize;
            a2.u_meter_to_dem = t3;
          }
          o2 && o2.labelPlaneMatrixInv && (a2.u_label_plane_matrix_inv = o2.labelPlaneMatrixInv), i3.setTerrainUniformValues(r2, a2);
        }
        renderToBackBuffer(t2) {
          const i3 = this.painter, o2 = this.painter.context;
          t2.length !== 0 && (o2.bindFramebuffer.set(null), o2.viewport.set([0, 0, i3.width, i3.height]), this.renderingToTexture = false, function(t3, i4, o3, r2, n2) {
            if (t3.transform.projection.name === "globe")
              !function(t4, i5, o4, r3, n3) {
                const a2 = t4.context, s3 = a2.gl;
                let l2, c2;
                const h2 = t4.options.showTerrainWireframe ? 2 : 0, u2 = (e2, i6) => {
                  if (c2 === e2)
                    return;
                  const o5 = [];
                  i6 && o5.push(ni[h2]), o5.push(ni[e2]), o5.push("PROJECTION_GLOBE_VIEW"), l2 = t4.useProgram("globeRaster", null, o5), c2 = e2;
                }, _2 = t4.colorModeForRenderPass(), d2 = new e.DepthMode(s3.LEQUAL, e.DepthMode.ReadWrite, t4.depthRangeFor3D);
                ri.update(n3);
                const p2 = t4.transform, m2 = e.calculateGlobeMatrix(p2, p2.worldSize), f2 = e.calculateGlobeMercatorMatrix(p2), g2 = [e.mercatorXfromLng(p2.center.lng), e.mercatorYfromLat(p2.center.lat)], v3 = t4.globeSharedBuffers;
                (h2 ? [false, true] : [false]).forEach((h3) => {
                  c2 = -1;
                  const x3 = h3 ? s3.LINES : s3.TRIANGLES;
                  for (const c3 of r3) {
                    const r4 = o4.getTile(c3), y2 = Math.pow(2, c3.canonical.z), [b2, w2] = e.globeBuffersForTileMesh(t4, r4, c3, y2), T2 = e.StencilMode.disabled, E2 = i5.prevTerrainTileForTile[c3.key], C2 = i5.terrainTileForTile[c3.key];
                    oi(E2, C2) && ri.newMorphing(c3.key, E2, C2, n3, 250), a2.activeTexture.set(s3.TEXTURE0), r4.texture.bind(s3.LINEAR, s3.CLAMP_TO_EDGE);
                    const M3 = ri.getMorphValuesForProxy(c3.key), S3 = M3 ? 1 : 0, I3 = {};
                    M3 && e.extend$1(I3, { morphing: { srcDemTile: M3.from, dstDemTile: M3.to, phase: e.easeCubicInOut(M3.phase) } });
                    const z2 = e.globeMatrixForTile(c3.canonical, m2), D4 = ii(p2.projMatrix, z2, f2, e.globeToMercatorTransition(p2.zoom), g2);
                    if (u2(S3, h3), i5.setupElevationDraw(r4, l2, I3), t4.prepareDrawProgram(a2, l2, c3.toUnwrapped()), v3) {
                      const [i6, o5] = h3 ? v3.getWirefameBuffer(t4.context) : [v3.gridIndexBuffer, v3.gridSegments];
                      l2.draw(a2, x3, d2, T2, _2, e.CullFaceMode.backCCW, D4, "globe_raster", b2, i6, o5);
                    }
                    if (!h3) {
                      const t5 = [c3.canonical.y === 0 ? e.globePoleMatrixForTile(c3.canonical, false, p2) : null, c3.canonical.y === y2 - 1 ? e.globePoleMatrixForTile(c3.canonical, true, p2) : null];
                      for (const i6 of t5) {
                        if (!i6)
                          continue;
                        const t6 = ii(p2.projMatrix, i6, i6, 0, g2);
                        v3 && l2.draw(a2, x3, d2, T2, _2, e.CullFaceMode.disabled, t6, "globe_pole_raster", w2, v3.poleIndexBuffer, v3.poleSegments);
                      }
                    }
                  }
                });
              }(t3, i4, o3, r2, n2);
            else {
              const a2 = t3.context, s3 = a2.gl;
              let l2, c2;
              const h2 = t3.options.showTerrainWireframe ? 2 : 0, u2 = (e2, i5) => {
                if (c2 === e2)
                  return;
                const o4 = [ni[e2]];
                i5 && o4.push(ni[h2]), l2 = t3.useProgram("terrainRaster", null, o4), c2 = e2;
              }, _2 = t3.colorModeForRenderPass(), d2 = new e.DepthMode(s3.LEQUAL, e.DepthMode.ReadWrite, t3.depthRangeFor3D);
              ri.update(n2);
              const p2 = t3.transform, m2 = 6 * Math.pow(1.5, 22 - p2.zoom) * i4.exaggeration();
              (h2 ? [false, true] : [false]).forEach((h3) => {
                c2 = -1;
                const f2 = h3 ? s3.LINES : s3.TRIANGLES, [g2, v3] = h3 ? i4.getWirefameBuffer() : [i4.gridIndexBuffer, i4.gridSegments];
                for (const c3 of r2) {
                  const r3 = o3.getTile(c3), x3 = e.StencilMode.disabled, y2 = i4.prevTerrainTileForTile[c3.key], b2 = i4.terrainTileForTile[c3.key];
                  oi(y2, b2) && ri.newMorphing(c3.key, y2, b2, n2, 250), a2.activeTexture.set(s3.TEXTURE0), r3.texture.bind(s3.LINEAR, s3.CLAMP_TO_EDGE, s3.LINEAR_MIPMAP_NEAREST);
                  const w2 = ri.getMorphValuesForProxy(c3.key), T2 = w2 ? 1 : 0;
                  let E2;
                  w2 && (E2 = { morphing: { srcDemTile: w2.from, dstDemTile: w2.to, phase: e.easeCubicInOut(w2.phase) } });
                  const C2 = ti(c3.projMatrix, ai(c3.canonical, p2.renderWorldCopies) ? m2 / 10 : m2);
                  u2(T2, h3), i4.setupElevationDraw(r3, l2, E2), t3.prepareDrawProgram(a2, l2, c3.toUnwrapped()), l2.draw(a2, f2, d2, x3, _2, e.CullFaceMode.backCCW, C2, "terrain_raster", i4.gridBuffer, g2, v3);
                }
              });
            }
          }(i3, this, this.proxySourceCache, t2, this._updateTimestamp), this.renderingToTexture = true, t2.splice(0, t2.length));
        }
        renderBatch(t2) {
          if (this._drapedRenderBatches.length === 0)
            return t2 + 1;
          this.renderingToTexture = true;
          const i3 = this.painter, o2 = this.painter.context, r2 = this.proxySourceCache, n2 = this.proxiedCoords[r2.id], a2 = this._drapedRenderBatches.shift(), s3 = [], l2 = i3.style.order;
          let c2 = 0;
          for (const h2 of n2) {
            const n3 = r2.getTileByID(h2.proxyTileKey), u2 = r2.proxyCachedFBO[h2.key] ? r2.proxyCachedFBO[h2.key][t2] : void 0, _2 = u2 !== void 0 ? r2.renderCache[u2] : this.pool[c2++], d2 = u2 !== void 0;
            if (n3.texture = _2.tex, d2 && !_2.dirty) {
              s3.push(n3.tileID);
              continue;
            }
            let p2;
            o2.bindFramebuffer.set(_2.fb.framebuffer), this.renderedToTile = false, _2.dirty && (o2.clear({ color: e.Color.transparent, stencil: 0 }), _2.dirty = false);
            for (let e2 = a2.start; e2 <= a2.end; ++e2) {
              const t3 = i3.style._layers[l2[e2]];
              if (t3.isHidden(i3.transform.zoom))
                continue;
              const r3 = i3.style._getLayerSourceCache(t3), n4 = r3 ? this.proxyToSource[h2.key][r3.id] : [h2];
              if (!n4)
                continue;
              const a3 = n4;
              o2.viewport.set([0, 0, _2.fb.width, _2.fb.height]), p2 !== (r3 ? r3.id : null) && (this._setupStencil(_2, n4, t3, r3), p2 = r3 ? r3.id : null), i3.renderLayer(i3, r3, t3, a3);
            }
            this.renderedToTile ? (_2.dirty = true, s3.push(n3.tileID)) : d2 || --c2, c2 === 5 && (c2 = 0, this.renderToBackBuffer(s3));
          }
          return this.renderToBackBuffer(s3), this.renderingToTexture = false, o2.bindFramebuffer.set(null), o2.viewport.set([0, 0, i3.width, i3.height]), a2.end + 1;
        }
        postRender() {
        }
        renderCacheEfficiency(e2) {
          const t2 = e2.order.length;
          if (t2 === 0)
            return { efficiency: 100 };
          let i3, o2 = 0, r2 = 0, n2 = false;
          for (let a2 = 0; a2 < t2; ++a2) {
            const t3 = e2._layers[e2.order[a2]];
            this._style.isLayerDraped(t3) ? (n2 && ++o2, ++r2) : n2 || (n2 = true, i3 = t3.id);
          }
          return r2 === 0 ? { efficiency: 100 } : { efficiency: 100 * (1 - o2 / r2), firstUndrapedLayer: i3 };
        }
        getMinElevationBelowMSL() {
          let e2 = 0;
          return this._visibleDemTiles.filter((e3) => e3.dem).forEach((t2) => {
            e2 = Math.min(e2, t2.dem.tree.minimums[0]);
          }), e2 === 0 ? e2 : (e2 - 30) * this._exaggeration;
        }
        raycast(e2, t2, i3) {
          if (!this._visibleDemTiles)
            return null;
          const o2 = this._visibleDemTiles.filter((e3) => e3.dem).map((o3) => {
            const r2 = o3.tileID, n2 = Math.pow(2, r2.overscaledZ), { x: a2, y: s3 } = r2.canonical, l2 = a2 / n2, c2 = (a2 + 1) / n2, h2 = s3 / n2, u2 = (s3 + 1) / n2;
            return { minx: l2, miny: h2, maxx: c2, maxy: u2, t: o3.dem.tree.raycastRoot(l2, h2, c2, u2, e2, t2, i3), tile: o3 };
          });
          o2.sort((e3, t3) => (e3.t !== null ? e3.t : Number.MAX_VALUE) - (t3.t !== null ? t3.t : Number.MAX_VALUE));
          for (const r2 of o2) {
            if (r2.t == null)
              return null;
            const o3 = r2.tile.dem.tree.raycast(r2.minx, r2.miny, r2.maxx, r2.maxy, e2, t2, i3);
            if (o3 != null)
              return o3;
          }
          return null;
        }
        _createFBO() {
          const t2 = this.painter.context, i3 = t2.gl, o2 = this.drapeBufferSize;
          t2.activeTexture.set(i3.TEXTURE0);
          const r2 = new e.Texture(t2, { width: o2[0], height: o2[1], data: null }, i3.RGBA);
          r2.bind(i3.LINEAR, i3.CLAMP_TO_EDGE);
          const n2 = t2.createFramebuffer(o2[0], o2[1], false);
          return n2.colorAttachment.set(r2.texture), n2.depthAttachment = new ue(t2, n2.framebuffer), this._sharedDepthStencil === void 0 ? (this._sharedDepthStencil = t2.createRenderbuffer(t2.gl.DEPTH_STENCIL, o2[0], o2[1]), this._stencilRef = 0, n2.depthAttachment.set(this._sharedDepthStencil), t2.clear({ stencil: 0 })) : n2.depthAttachment.set(this._sharedDepthStencil), t2.extTextureFilterAnisotropic && !t2.extTextureFilterAnisotropicForceOff && i3.texParameterf(i3.TEXTURE_2D, t2.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, t2.extTextureFilterAnisotropicMax), { fb: n2, tex: r2, dirty: false };
        }
        _initFBOPool() {
          for (; this.pool.length < Math.min(5, this.proxyCoords.length); )
            this.pool.push(this._createFBO());
        }
        _shouldDisableRenderCache() {
          if (this._style.light && this._style.light.hasTransition())
            return true;
          for (const e2 in this._style._sourceCaches)
            if (this._style._sourceCaches[e2].hasTransition())
              return true;
          return this._style.order.some((e2) => {
            const t2 = this._style._layers[e2], i3 = t2.isHidden(this.painter.transform.zoom), o2 = t2.getCrossfadeParameters(), r2 = !!o2 && o2.t !== 1, n2 = t2.hasTransition();
            return t2.type !== "custom" && !i3 && (r2 || n2);
          });
        }
        _clearRasterFadeFromRenderCache() {
          let e2 = false;
          for (const t2 in this._style._sourceCaches)
            if (this._style._sourceCaches[t2]._source instanceof ve) {
              e2 = true;
              break;
            }
          if (e2)
            for (let e3 = 0; e3 < this._style.order.length; ++e3) {
              const t2 = this._style._layers[this._style.order[e3]], i3 = t2.isHidden(this.painter.transform.zoom), o2 = this._style._getLayerSourceCache(t2);
              if (t2.type !== "raster" || i3 || !o2)
                continue;
              const r2 = t2.paint.get("raster-fade-duration");
              for (const e4 of this.proxyCoords) {
                const t3 = this.proxyToSource[e4.key][o2.id];
                if (t3)
                  for (const e5 of t3) {
                    const t4 = li(o2.getTile(e5), o2.findLoadedParent(e5, 0), o2, this.painter.transform, r2);
                    (t4.opacity !== 1 || t4.mix !== 0) && this._clearRenderCacheForTile(o2.id, e5);
                  }
              }
            }
        }
        _setupDrapedRenderBatches() {
          const e2 = this._style.order, t2 = e2.length;
          if (t2 === 0)
            return;
          const i3 = [];
          let o2, r2 = 0, n2 = this._style._layers[e2[r2]];
          for (; !this._style.isLayerDraped(n2) && n2.isHidden(this.painter.transform.zoom) && ++r2 < t2; )
            n2 = this._style._layers[e2[r2]];
          for (; r2 < t2; ++r2) {
            const t3 = this._style._layers[e2[r2]];
            t3.isHidden(this.painter.transform.zoom) || (this._style.isLayerDraped(t3) ? o2 === void 0 && (o2 = r2) : o2 !== void 0 && (i3.push({ start: o2, end: r2 - 1 }), o2 = void 0));
          }
          o2 !== void 0 && i3.push({ start: o2, end: r2 - 1 }), this._drapedRenderBatches = i3;
        }
        _setupRenderCache(e2) {
          const t2 = this.proxySourceCache;
          if (this._shouldDisableRenderCache() || this._invalidateRenderCache) {
            if (this._invalidateRenderCache = false, t2.renderCache.length > t2.renderCachePool.length) {
              const e3 = Object.values(t2.proxyCachedFBO);
              t2.proxyCachedFBO = {};
              for (let i4 = 0; i4 < e3.length; ++i4) {
                const o3 = Object.values(e3[i4]);
                t2.renderCachePool.push(...o3);
              }
            }
            return;
          }
          this._clearRasterFadeFromRenderCache();
          const i3 = this.proxyCoords, o2 = this._tilesDirty;
          for (let r3 = i3.length - 1; r3 >= 0; r3--) {
            const n2 = i3[r3];
            if (t2.getTileByID(n2.key), t2.proxyCachedFBO[n2.key] !== void 0) {
              const i4 = e2[n2.key], r4 = this.proxyToSource[n2.key];
              let a2 = 0;
              for (const e3 in r4) {
                const t3 = r4[e3], n3 = i4[e3];
                if (!n3 || n3.length !== t3.length || t3.some((t4, i5) => t4 !== n3[i5] || o2[e3] && o2[e3].hasOwnProperty(t4.key))) {
                  a2 = -1;
                  break;
                }
                ++a2;
              }
              for (const e3 in t2.proxyCachedFBO[n2.key])
                t2.renderCache[t2.proxyCachedFBO[n2.key][e3]].dirty = a2 < 0 || a2 !== Object.values(i4).length;
            }
          }
          const r2 = [...this._drapedRenderBatches];
          r2.sort((e3, t3) => t3.end - t3.start - (e3.end - e3.start));
          for (const e3 of r2)
            for (const o3 of i3) {
              if (t2.proxyCachedFBO[o3.key])
                continue;
              let i4 = t2.renderCachePool.pop();
              i4 === void 0 && t2.renderCache.length < 50 && (i4 = t2.renderCache.length, t2.renderCache.push(this._createFBO())), i4 !== void 0 && (t2.proxyCachedFBO[o3.key] = {}, t2.proxyCachedFBO[o3.key][e3.start] = i4, t2.renderCache[i4].dirty = true);
            }
          this._tilesDirty = {};
        }
        _setupStencil(e2, t2, i3, o2) {
          if (!o2 || !this._sourceTilesOverlap[o2.id])
            return void (this._overlapStencilType && (this._overlapStencilType = false));
          const r2 = this.painter.context, n2 = r2.gl;
          if (t2.length <= 1)
            return void (this._overlapStencilType = false);
          let a2;
          if (i3.isTileClipped())
            a2 = t2.length, this._overlapStencilMode.test = { func: n2.EQUAL, mask: 255 }, this._overlapStencilType = "Clip";
          else {
            if (!(t2[0].overscaledZ > t2[t2.length - 1].overscaledZ))
              return void (this._overlapStencilType = false);
            a2 = 1, this._overlapStencilMode.test = { func: n2.GREATER, mask: 255 }, this._overlapStencilType = "Mask";
          }
          this._stencilRef + a2 > 255 && (r2.clear({ stencil: 0 }), this._stencilRef = 0), this._stencilRef += a2, this._overlapStencilMode.ref = this._stencilRef, i3.isTileClipped() && this._renderTileClippingMasks(t2, this._overlapStencilMode.ref);
        }
        clipOrMaskOverlapStencilType() {
          return this._overlapStencilType === "Clip" || this._overlapStencilType === "Mask";
        }
        stencilModeForRTTOverlap(t2) {
          return this.renderingToTexture && this._overlapStencilType ? (this._overlapStencilType === "Clip" && (this._overlapStencilMode.ref = this.painter._tileClippingMaskIDs[t2.key]), this._overlapStencilMode) : e.StencilMode.disabled;
        }
        _renderTileClippingMasks(t2, i3) {
          const o2 = this.painter, r2 = this.painter.context, n2 = r2.gl;
          o2._tileClippingMaskIDs = {}, r2.setColorMode(e.ColorMode.disabled), r2.setDepthMode(e.DepthMode.disabled);
          const a2 = o2.useProgram("clippingMask");
          for (const s3 of t2) {
            const t3 = o2._tileClippingMaskIDs[s3.key] = --i3;
            a2.draw(r2, n2.TRIANGLES, e.DepthMode.disabled, new e.StencilMode({ func: n2.ALWAYS, mask: 0 }, t3, 255, n2.KEEP, n2.KEEP, n2.REPLACE), e.ColorMode.disabled, e.CullFaceMode.disabled, si(s3.projMatrix), "$clipping", o2.tileExtentBuffer, o2.quadTriangleIndexBuffer, o2.tileExtentSegments);
          }
        }
        pointCoordinate(t2) {
          const i3 = this.painter.transform;
          if (t2.x < 0 || t2.x > i3.width || t2.y < 0 || t2.y > i3.height)
            return null;
          const o2 = [t2.x, t2.y, 1, 1];
          e.transformMat4$1(o2, o2, i3.pixelMatrixInverse), e.scale$1(o2, o2, 1 / o2[3]), o2[0] /= i3.worldSize, o2[1] /= i3.worldSize;
          const r2 = i3._camera.position, n2 = e.mercatorZfromAltitude(1, i3.center.lat), a2 = [r2[0], r2[1], r2[2] / n2, 0], s3 = e.subtract([], o2.slice(0, 3), a2);
          e.normalize(s3, s3);
          const l2 = this.raycast(a2, s3, this._exaggeration);
          return l2 !== null && l2 ? (e.scaleAndAdd(a2, a2, s3, l2), a2[3] = a2[2], a2[2] *= n2, a2) : null;
        }
        drawDepth() {
          const t2 = this.painter, i3 = t2.context, o2 = this.proxySourceCache, r2 = Math.ceil(t2.width), n2 = Math.ceil(t2.height);
          if (!this._depthFBO || this._depthFBO.width === r2 && this._depthFBO.height === n2 || (this._depthFBO.destroy(), delete this._depthFBO, delete this._depthTexture), !this._depthFBO) {
            const t3 = i3.gl, o3 = i3.createFramebuffer(r2, n2, true);
            i3.activeTexture.set(t3.TEXTURE0);
            const a2 = new e.Texture(i3, { width: r2, height: n2, data: null }, t3.RGBA);
            a2.bind(t3.NEAREST, t3.CLAMP_TO_EDGE), o3.colorAttachment.set(a2.texture);
            const s3 = i3.createRenderbuffer(i3.gl.DEPTH_COMPONENT16, r2, n2);
            o3.depthAttachment.set(s3), this._depthFBO = o3, this._depthTexture = a2;
          }
          i3.bindFramebuffer.set(this._depthFBO.framebuffer), i3.viewport.set([0, 0, r2, n2]), function(t3, i4, o3, r3) {
            if (t3.transform.projection.name === "globe")
              return;
            const n3 = t3.context, a2 = n3.gl;
            n3.clear({ depth: 1 });
            const s3 = t3.useProgram("terrainDepth"), l2 = new e.DepthMode(a2.LESS, e.DepthMode.ReadWrite, t3.depthRangeFor3D);
            for (const t4 of r3) {
              const r4 = o3.getTile(t4), c2 = ti(t4.projMatrix, 0);
              i4.setupElevationDraw(r4, s3), s3.draw(n3, a2.TRIANGLES, l2, e.StencilMode.disabled, e.ColorMode.unblended, e.CullFaceMode.backCCW, c2, "terrain_depth", i4.gridBuffer, i4.gridIndexBuffer, i4.gridNoSkirtSegments);
            }
          }(t2, this, o2, this.proxyCoords);
        }
        _setupProxiedCoordsForOrtho(e2, t2, i3) {
          if (e2.getSource() instanceof be)
            return this._setupProxiedCoordsForImageSource(e2, t2, i3);
          this._findCoveringTileCache[e2.id] = this._findCoveringTileCache[e2.id] || {};
          const o2 = this.proxiedCoords[e2.id] = [], r2 = this.proxyCoords;
          for (let t3 = 0; t3 < r2.length; t3++) {
            const n3 = r2[t3], a2 = this._findTileCoveringTileID(n3, e2);
            if (a2) {
              const t4 = this._createProxiedId(n3, a2, i3[n3.key] && i3[n3.key][e2.id]);
              o2.push(t4), this.proxyToSource[n3.key][e2.id] = [t4];
            }
          }
          let n2 = false;
          for (let r3 = 0; r3 < t2.length; r3++) {
            const a2 = e2.getTile(t2[r3]);
            if (!a2 || !a2.hasData())
              continue;
            const s3 = this._findTileCoveringTileID(a2.tileID, this.proxySourceCache);
            if (s3 && s3.tileID.canonical.z !== a2.tileID.canonical.z) {
              const t3 = this.proxyToSource[s3.tileID.key][e2.id], r4 = this._createProxiedId(s3.tileID, a2, i3[s3.tileID.key] && i3[s3.tileID.key][e2.id]);
              t3 ? t3.splice(t3.length - 1, 0, r4) : this.proxyToSource[s3.tileID.key][e2.id] = [r4], o2.push(r4), n2 = true;
            }
          }
          this._sourceTilesOverlap[e2.id] = n2;
        }
        _setupProxiedCoordsForImageSource(t2, i3, o2) {
          if (!t2.getSource().loaded())
            return;
          const r2 = this.proxiedCoords[t2.id] = [], n2 = this.proxyCoords, a2 = t2.getSource(), s3 = new e.pointGeometry(a2.tileID.x, a2.tileID.y)._div(1 << a2.tileID.z), l2 = a2.coordinates.map(e.MercatorCoordinate.fromLngLat).reduce((e2, t3) => (e2.min.x = Math.min(e2.min.x, t3.x - s3.x), e2.min.y = Math.min(e2.min.y, t3.y - s3.y), e2.max.x = Math.max(e2.max.x, t3.x - s3.x), e2.max.y = Math.max(e2.max.y, t3.y - s3.y), e2), { min: new e.pointGeometry(Number.MAX_VALUE, Number.MAX_VALUE), max: new e.pointGeometry(-Number.MAX_VALUE, -Number.MAX_VALUE) }), c2 = (t3, i4) => {
            const o3 = t3.wrap + t3.canonical.x / (1 << t3.canonical.z), r3 = t3.canonical.y / (1 << t3.canonical.z), n3 = e.EXTENT / (1 << t3.canonical.z), a3 = i4.wrap + i4.canonical.x / (1 << i4.canonical.z), s4 = i4.canonical.y / (1 << i4.canonical.z);
            return o3 + n3 < a3 + l2.min.x || o3 > a3 + l2.max.x || r3 + n3 < s4 + l2.min.y || r3 > s4 + l2.max.y;
          };
          for (let e2 = 0; e2 < n2.length; e2++) {
            const a3 = n2[e2];
            for (let e3 = 0; e3 < i3.length; e3++) {
              const n3 = t2.getTile(i3[e3]);
              if (!n3 || !n3.hasData())
                continue;
              if (c2(a3, n3.tileID))
                continue;
              const s4 = this._createProxiedId(a3, n3, o2[a3.key] && o2[a3.key][t2.id]), l3 = this.proxyToSource[a3.key][t2.id];
              l3 ? l3.push(s4) : this.proxyToSource[a3.key][t2.id] = [s4], r2.push(s4);
            }
          }
        }
        _createProxiedId(t2, i3, o2) {
          let r2 = this.orthoMatrix;
          if (o2) {
            const e2 = o2.find((e3) => e3.key === i3.tileID.key);
            if (e2)
              return e2;
          }
          if (i3.tileID.key !== t2.key) {
            const o3 = t2.canonical.z - i3.tileID.canonical.z;
            let n2, a2, s3;
            r2 = e.create();
            const l2 = i3.tileID.wrap - t2.wrap << t2.overscaledZ;
            o3 > 0 ? (n2 = e.EXTENT >> o3, a2 = n2 * ((i3.tileID.canonical.x << o3) - t2.canonical.x + l2), s3 = n2 * ((i3.tileID.canonical.y << o3) - t2.canonical.y)) : (n2 = e.EXTENT << -o3, a2 = e.EXTENT * (i3.tileID.canonical.x - (t2.canonical.x + l2 << -o3)), s3 = e.EXTENT * (i3.tileID.canonical.y - (t2.canonical.y << -o3))), e.ortho(r2, 0, n2, 0, n2, 0, 1), e.translate(r2, r2, [a2, s3, 0]);
          }
          return new ui(i3.tileID, t2.key, r2);
        }
        _findTileCoveringTileID(t2, i3) {
          let o2 = i3.getTile(t2);
          if (o2 && o2.hasData())
            return o2;
          const r2 = this._findCoveringTileCache[i3.id], n2 = r2[t2.key];
          if (o2 = n2 ? i3.getTileByID(n2) : null, o2 && o2.hasData() || n2 === null)
            return o2;
          let a2 = o2 ? o2.tileID : t2, s3 = a2.overscaledZ;
          const l2 = i3.getSource().minzoom, c2 = [];
          if (!n2) {
            const r3 = i3.getSource().maxzoom;
            if (t2.canonical.z >= r3) {
              const o3 = t2.canonical.z - r3;
              i3.getSource().reparseOverscaled ? (s3 = Math.max(t2.canonical.z + 2, i3.transform.tileZoom), a2 = new e.OverscaledTileID(s3, t2.wrap, r3, t2.canonical.x >> o3, t2.canonical.y >> o3)) : o3 !== 0 && (s3 = r3, a2 = new e.OverscaledTileID(s3, t2.wrap, r3, t2.canonical.x >> o3, t2.canonical.y >> o3));
            }
            a2.key !== t2.key && (c2.push(a2.key), o2 = i3.getTile(a2));
          }
          const h2 = (e2) => {
            c2.forEach((t3) => {
              r2[t3] = e2;
            }), c2.length = 0;
          };
          for (s3 -= 1; s3 >= l2 && (!o2 || !o2.hasData()); s3--) {
            o2 && h2(o2.tileID.key);
            const e2 = a2.calculateScaledKey(s3);
            if (o2 = i3.getTileByID(e2), o2 && o2.hasData())
              break;
            const t3 = r2[e2];
            if (t3 === null)
              break;
            t3 === void 0 ? c2.push(e2) : o2 = i3.getTileByID(t3);
          }
          return h2(o2 ? o2.tileID.key : null), o2 && o2.hasData() ? o2 : null;
        }
        findDEMTileFor(e2) {
          return this.enabled ? this._findTileCoveringTileID(e2, this.sourceCache) : null;
        }
        prepareDrawTile(e2) {
          this.renderedToTile = true;
        }
        _clearRenderCacheForTile(e2, t2) {
          let i3 = this._tilesDirty[e2];
          i3 || (i3 = this._tilesDirty[e2] = {}), i3[t2.key] = true;
        }
        getWirefameBuffer() {
          if (!this.wireframeSegments) {
            const t2 = function(t3) {
              let i3, o2, r2;
              const n2 = new e.StructArrayLayout2ui4(), a2 = 131;
              for (o2 = 1; o2 < 129; o2++) {
                for (i3 = 1; i3 < 129; i3++)
                  r2 = o2 * a2 + i3, n2.emplaceBack(r2, r2 + 1), n2.emplaceBack(r2, r2 + a2), n2.emplaceBack(r2 + 1, r2 + a2), o2 === 128 && n2.emplaceBack(r2 + a2, r2 + a2 + 1);
                n2.emplaceBack(r2 + 1, r2 + 1 + a2);
              }
              return n2;
            }();
            this.wireframeIndexBuffer = this.painter.context.createIndexBuffer(t2), this.wireframeSegments = e.SegmentVector.simpleSegment(0, 0, this.gridBuffer.length, t2.length);
          }
          return [this.wireframeIndexBuffer, this.wireframeSegments];
        }
      }
      function di(e2) {
        const t2 = [];
        for (let i3 = 0; i3 < e2.length; i3++) {
          if (e2[i3] === null)
            continue;
          const o2 = e2[i3].split(" ");
          t2.push(o2.pop());
        }
        return t2;
      }
      class pi {
        static cacheKey(e2, t2, i3) {
          let o2 = `${e2}${i3 ? i3.cacheKey : ""}`;
          for (const e3 of t2)
            o2 += `/${e3}`;
          return o2;
        }
        constructor(t2, i3, o2, r2, n2, a2) {
          const s3 = t2.gl;
          this.program = s3.createProgram();
          const l2 = di(o2.staticAttributes), c2 = r2 ? r2.getBinderAttributes() : [], h2 = l2.concat(c2), u2 = o2.staticUniforms ? di(o2.staticUniforms) : [], _2 = r2 ? r2.getBinderUniforms() : [], d2 = u2.concat(_2), p2 = [];
          for (const e2 of d2)
            p2.indexOf(e2) < 0 && p2.push(e2);
          let m2 = r2 ? r2.defines() : [];
          m2 = m2.concat(a2.map((e2) => `#define ${e2}`));
          const f2 = m2.concat("\n#ifdef GL_ES\nprecision mediump float;\n#else\n\n#if !defined(lowp)\n#define lowp\n#endif\n\n#if !defined(mediump)\n#define mediump\n#endif\n\n#if !defined(highp)\n#define highp\n#endif\n\n#endif", qt, Wt.fragmentSource, Vt.fragmentSource, o2.fragmentSource).join("\n"), g2 = m2.concat("\n#ifdef GL_ES\nprecision highp float;\n#else\n\n#if !defined(lowp)\n#define lowp\n#endif\n\n#if !defined(mediump)\n#define mediump\n#endif\n\n#if !defined(highp)\n#define highp\n#endif\n\n#endif", qt, Wt.vertexSource, Vt.vertexSource, Zt.vertexSource, o2.vertexSource).join("\n"), v3 = s3.createShader(s3.FRAGMENT_SHADER);
          if (s3.isContextLost())
            return void (this.failedToCreate = true);
          s3.shaderSource(v3, f2), s3.compileShader(v3), s3.attachShader(this.program, v3);
          const x3 = s3.createShader(s3.VERTEX_SHADER);
          if (s3.isContextLost())
            return void (this.failedToCreate = true);
          s3.shaderSource(x3, g2), s3.compileShader(x3), s3.attachShader(this.program, x3), this.attributes = {};
          const y2 = {};
          this.numAttributes = h2.length;
          for (let e2 = 0; e2 < this.numAttributes; e2++)
            h2[e2] && (s3.bindAttribLocation(this.program, e2, h2[e2]), this.attributes[h2[e2]] = e2);
          s3.linkProgram(this.program), s3.deleteShader(x3), s3.deleteShader(v3);
          for (let e2 = 0; e2 < p2.length; e2++) {
            const t3 = p2[e2];
            if (t3 && !y2[t3]) {
              const e3 = s3.getUniformLocation(this.program, t3);
              e3 && (y2[t3] = e3);
            }
          }
          this.fixedUniforms = n2(t2, y2), this.binderUniforms = r2 ? r2.getUniforms(t2, y2) : [], a2.indexOf("TERRAIN") !== -1 && (this.terrainUniforms = ((t3, i4) => ({ u_dem: new e.Uniform1i(t3, i4.u_dem), u_dem_prev: new e.Uniform1i(t3, i4.u_dem_prev), u_dem_unpack: new e.Uniform4f(t3, i4.u_dem_unpack), u_dem_tl: new e.Uniform2f(t3, i4.u_dem_tl), u_dem_scale: new e.Uniform1f(t3, i4.u_dem_scale), u_dem_tl_prev: new e.Uniform2f(t3, i4.u_dem_tl_prev), u_dem_scale_prev: new e.Uniform1f(t3, i4.u_dem_scale_prev), u_dem_size: new e.Uniform1f(t3, i4.u_dem_size), u_dem_lerp: new e.Uniform1f(t3, i4.u_dem_lerp), u_exaggeration: new e.Uniform1f(t3, i4.u_exaggeration), u_depth: new e.Uniform1i(t3, i4.u_depth), u_depth_size_inv: new e.Uniform2f(t3, i4.u_depth_size_inv), u_meter_to_dem: new e.Uniform1f(t3, i4.u_meter_to_dem), u_label_plane_matrix_inv: new e.UniformMatrix4f(t3, i4.u_label_plane_matrix_inv), u_tile_tl_up: new e.Uniform3f(t3, i4.u_tile_tl_up), u_tile_tr_up: new e.Uniform3f(t3, i4.u_tile_tr_up), u_tile_br_up: new e.Uniform3f(t3, i4.u_tile_br_up), u_tile_bl_up: new e.Uniform3f(t3, i4.u_tile_bl_up), u_tile_up_scale: new e.Uniform1f(t3, i4.u_tile_up_scale) }))(t2, y2)), a2.indexOf("FOG") !== -1 && (this.fogUniforms = ((t3, i4) => ({ u_fog_matrix: new e.UniformMatrix4f(t3, i4.u_fog_matrix), u_fog_range: new e.Uniform2f(t3, i4.u_fog_range), u_fog_color: new e.Uniform4f(t3, i4.u_fog_color), u_fog_horizon_blend: new e.Uniform1f(t3, i4.u_fog_horizon_blend), u_fog_temporal_offset: new e.Uniform1f(t3, i4.u_fog_temporal_offset) }))(t2, y2));
        }
        setTerrainUniformValues(e2, t2) {
          if (!this.terrainUniforms)
            return;
          const i3 = this.terrainUniforms;
          if (!this.failedToCreate) {
            e2.program.set(this.program);
            for (const e3 in t2)
              i3[e3].set(t2[e3]);
          }
        }
        setFogUniformValues(e2, t2) {
          if (!this.fogUniforms)
            return;
          const i3 = this.fogUniforms;
          if (!this.failedToCreate) {
            e2.program.set(this.program);
            for (const e3 in t2)
              i3[e3].location && i3[e3].set(t2[e3]);
          }
        }
        draw(e2, t2, i3, o2, r2, n2, a2, s3, l2, c2, h2, u2, _2, d2, p2, m2) {
          const f2 = e2.gl;
          if (this.failedToCreate)
            return;
          e2.program.set(this.program), e2.setDepthMode(i3), e2.setStencilMode(o2), e2.setColorMode(r2), e2.setCullFace(n2);
          for (const e3 of Object.keys(this.fixedUniforms))
            this.fixedUniforms[e3].set(a2[e3]);
          d2 && d2.setUniforms(e2, this.binderUniforms, u2, { zoom: _2 });
          const g2 = { [f2.LINES]: 2, [f2.TRIANGLES]: 3, [f2.LINE_STRIP]: 1 }[t2];
          for (const i4 of h2.get()) {
            const o3 = i4.vaos || (i4.vaos = {});
            (o3[s3] || (o3[s3] = new Ht())).bind(e2, this, l2, d2 ? d2.getPaintVertexBuffers() : [], c2, i4.vertexOffset, p2, m2), f2.drawElements(t2, i4.primitiveLength * g2, f2.UNSIGNED_SHORT, i4.primitiveOffset * g2 * 2);
          }
        }
      }
      function mi(e2, t2, i3) {
        const o2 = 1 / M2(i3, 1, t2.transform.tileZoom), r2 = Math.pow(2, i3.tileID.overscaledZ), n2 = i3.tileSize * Math.pow(2, t2.transform.tileZoom) / r2, a2 = n2 * (i3.tileID.canonical.x + i3.tileID.wrap * r2), s3 = n2 * i3.tileID.canonical.y;
        return { u_image: 0, u_texsize: i3.imageAtlasTexture.size, u_scale: [o2, e2.fromScale, e2.toScale], u_fade: e2.t, u_pixel_coord_upper: [a2 >> 16, s3 >> 16], u_pixel_coord_lower: [65535 & a2, 65535 & s3] };
      }
      const fi = (t2, i3, o2, r2) => {
        const n2 = i3.style.light, a2 = n2.properties.get("position"), s3 = [a2.x, a2.y, a2.z], l2 = e.create$1();
        n2.properties.get("anchor") === "viewport" && (e.fromRotation(l2, -i3.transform.angle), e.transformMat3(s3, s3, l2));
        const c2 = n2.properties.get("color");
        return { u_matrix: t2, u_lightpos: s3, u_lightintensity: n2.properties.get("intensity"), u_lightcolor: [c2.r, c2.g, c2.b], u_vertical_gradient: +o2, u_opacity: r2 };
      }, gi = (t2, i3, o2, r2, n2, a2, s3) => e.extend(fi(t2, i3, o2, r2), mi(a2, i3, s3), { u_height_factor: -Math.pow(2, n2.overscaledZ) / s3.tileSize / 8 }), vi = (e2) => ({ u_matrix: e2 }), xi = (t2, i3, o2, r2) => e.extend(vi(t2), mi(o2, i3, r2)), yi = (e2, t2) => ({ u_matrix: e2, u_world: t2 }), bi = (t2, i3, o2, r2, n2) => e.extend(xi(t2, i3, o2, r2), { u_world: n2 }), wi = (t2, i3, o2, r2) => {
        const n2 = t2.transform;
        let a2;
        return a2 = r2.paint.get("circle-pitch-alignment") === "map" ? n2.calculatePixelsToTileUnitsMatrix(o2) : new Float32Array([n2.pixelsToGLUnits[0], 0, 0, n2.pixelsToGLUnits[1]]), { u_camera_to_center_distance: n2.cameraToCenterDistance, u_matrix: t2.translatePosMatrix(i3.projMatrix, o2, r2.paint.get("circle-translate"), r2.paint.get("circle-translate-anchor")), u_device_pixel_ratio: e.exported.devicePixelRatio, u_extrude_scale: a2 };
      }, Ti = (e2) => {
        const t2 = [];
        return e2.paint.get("circle-pitch-alignment") === "map" && t2.push("PITCH_WITH_MAP"), e2.paint.get("circle-pitch-scale") === "map" && t2.push("SCALE_WITH_MAP"), t2;
      }, Ei = (t2, i3, o2) => {
        const r2 = e.EXTENT / o2.tileSize;
        return { u_matrix: t2, u_camera_to_center_distance: i3.cameraToCenterDistance, u_extrude_scale: [i3.pixelsToGLUnits[0] / r2, i3.pixelsToGLUnits[1] / r2] };
      }, Ci = (e2, t2, i3 = 1) => ({ u_matrix: e2, u_color: t2, u_overlay: 0, u_overlay_scale: i3 }), Mi = (e2, t2, i3, o2) => ({ u_matrix: e2, u_extrude_scale: M2(t2, 1, i3), u_intensity: o2 }), Si = (t2, i3, o2, r2, n2, a2) => {
        const s3 = t2.transform, l2 = s3.calculatePixelsToTileUnitsMatrix(i3), c2 = { u_matrix: Di(t2, i3, o2, n2), u_pixels_to_tile_units: l2, u_device_pixel_ratio: e.exported.devicePixelRatio, u_units_to_pixels: [1 / s3.pixelsToGLUnits[0], 1 / s3.pixelsToGLUnits[1]], u_dash_image: 0, u_gradient_image: 1, u_image_height: a2, u_texsize: [0, 0], u_scale: [0, 0, 0], u_mix: 0, u_alpha_discard_threshold: 0 };
        if (Pi(o2)) {
          const e2 = zi(i3, t2.transform);
          c2.u_texsize = i3.lineAtlasTexture.size, c2.u_scale = [e2, r2.fromScale, r2.toScale], c2.u_mix = r2.t;
        }
        return c2;
      }, Ii = (t2, i3, o2, r2, n2) => {
        const a2 = t2.transform, s3 = zi(i3, a2);
        return { u_matrix: Di(t2, i3, o2, n2), u_texsize: i3.imageAtlasTexture.size, u_pixels_to_tile_units: a2.calculatePixelsToTileUnitsMatrix(i3), u_device_pixel_ratio: e.exported.devicePixelRatio, u_image: 0, u_scale: [s3, r2.fromScale, r2.toScale], u_fade: r2.t, u_units_to_pixels: [1 / a2.pixelsToGLUnits[0], 1 / a2.pixelsToGLUnits[1]], u_alpha_discard_threshold: 0 };
      };
      function zi(e2, t2) {
        return 1 / M2(e2, 1, t2.tileZoom);
      }
      function Di(e2, t2, i3, o2) {
        return e2.translatePosMatrix(o2 || t2.tileID.projMatrix, t2, i3.paint.get("line-translate"), i3.paint.get("line-translate-anchor"));
      }
      function Pi(e2) {
        const t2 = e2.paint.get("line-dasharray").value;
        return t2.value || t2.kind !== "constant";
      }
      const Ai = (e2, t2, i3, o2, r2, n2) => {
        return { u_matrix: e2, u_tl_parent: t2, u_scale_parent: i3, u_fade_t: o2.mix, u_opacity: o2.opacity * r2.paint.get("raster-opacity"), u_image0: 0, u_image1: 1, u_brightness_low: r2.paint.get("raster-brightness-min"), u_brightness_high: r2.paint.get("raster-brightness-max"), u_saturation_factor: (s3 = r2.paint.get("raster-saturation"), s3 > 0 ? 1 - 1 / (1.001 - s3) : -s3), u_contrast_factor: (a2 = r2.paint.get("raster-contrast"), a2 > 0 ? 1 / (1 - a2) : 1 + a2), u_spin_weights: Li(r2.paint.get("raster-hue-rotate")), u_perspective_transform: n2 };
        var a2, s3;
      };
      function Li(e2) {
        e2 *= Math.PI / 180;
        const t2 = Math.sin(e2), i3 = Math.cos(e2);
        return [(2 * i3 + 1) / 3, (-Math.sqrt(3) * t2 - i3 + 1) / 3, (Math.sqrt(3) * t2 - i3 + 1) / 3];
      }
      const Ri = (e2, t2, i3, o2, r2, n2, a2, s3, l2, c2, h2, u2, _2, d2) => {
        const p2 = r2.transform;
        return { u_is_size_zoom_constant: +(e2 === "constant" || e2 === "source"), u_is_size_feature_constant: +(e2 === "constant" || e2 === "camera"), u_size_t: t2 ? t2.uSizeT : 0, u_size: t2 ? t2.uSize : 0, u_camera_to_center_distance: p2.cameraToCenterDistance, u_pitch: p2.pitch / 360 * 2 * Math.PI, u_rotate_symbol: +i3, u_aspect_ratio: p2.width / p2.height, u_fade_change: r2.options.fadeDuration ? r2.symbolFadeChange : 1, u_matrix: n2, u_label_plane_matrix: a2, u_coord_matrix: s3, u_is_text: +l2, u_pitch_with_map: +o2, u_texsize: c2, u_tile_id: h2, u_zoom_transition: u2, u_inv_rot_matrix: _2, u_merc_center: d2, u_texture: 0 };
      }, ki = (t2, i3, o2, r2, n2, a2, s3, l2, c2, h2, u2, _2, d2, p2, m2) => {
        const { cameraToCenterDistance: f2, _pitch: g2 } = n2.transform;
        return e.extend(Ri(t2, i3, o2, r2, n2, a2, s3, l2, c2, h2, _2, d2, p2, m2), { u_gamma_scale: r2 ? f2 * Math.cos(n2.terrain ? 0 : g2) : 1, u_device_pixel_ratio: e.exported.devicePixelRatio, u_is_halo: +u2 });
      }, Oi = (t2, i3, o2, r2, n2, a2, s3, l2, c2, h2, u2, _2, d2, p2) => e.extend(ki(t2, i3, o2, r2, n2, a2, s3, l2, true, c2, true, u2, _2, d2, p2), { u_texsize_icon: h2, u_texture_icon: 1 }), Bi = (e2, t2, i3) => ({ u_matrix: e2, u_opacity: t2, u_color: i3 }), Fi = (t2, i3, o2, r2, n2, a2) => e.extend(function(e2, t3, i4, o3) {
        const r3 = i4.imageManager.getPattern(e2.from.toString()), n3 = i4.imageManager.getPattern(e2.to.toString()), { width: a3, height: s3 } = i4.imageManager.getPixelSize(), l2 = Math.pow(2, o3.tileID.overscaledZ), c2 = o3.tileSize * Math.pow(2, i4.transform.tileZoom) / l2, h2 = c2 * (o3.tileID.canonical.x + o3.tileID.wrap * l2), u2 = c2 * o3.tileID.canonical.y;
        return { u_image: 0, u_pattern_tl_a: r3.tl, u_pattern_br_a: r3.br, u_pattern_tl_b: n3.tl, u_pattern_br_b: n3.br, u_texsize: [a3, s3], u_mix: t3.t, u_pattern_size_a: r3.displaySize, u_pattern_size_b: n3.displaySize, u_scale_a: t3.fromScale, u_scale_b: t3.toScale, u_tile_units_to_pixels: 1 / M2(o3, 1, i4.transform.tileZoom), u_pixel_coord_upper: [h2 >> 16, u2 >> 16], u_pixel_coord_lower: [65535 & h2, 65535 & u2] };
      }(r2, a2, o2, n2), { u_matrix: t2, u_opacity: i3 }), Ui = { fillExtrusion: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_lightpos: new e.Uniform3f(t2, i3.u_lightpos), u_lightintensity: new e.Uniform1f(t2, i3.u_lightintensity), u_lightcolor: new e.Uniform3f(t2, i3.u_lightcolor), u_vertical_gradient: new e.Uniform1f(t2, i3.u_vertical_gradient), u_opacity: new e.Uniform1f(t2, i3.u_opacity) }), fillExtrusionPattern: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_lightpos: new e.Uniform3f(t2, i3.u_lightpos), u_lightintensity: new e.Uniform1f(t2, i3.u_lightintensity), u_lightcolor: new e.Uniform3f(t2, i3.u_lightcolor), u_vertical_gradient: new e.Uniform1f(t2, i3.u_vertical_gradient), u_height_factor: new e.Uniform1f(t2, i3.u_height_factor), u_image: new e.Uniform1i(t2, i3.u_image), u_texsize: new e.Uniform2f(t2, i3.u_texsize), u_pixel_coord_upper: new e.Uniform2f(t2, i3.u_pixel_coord_upper), u_pixel_coord_lower: new e.Uniform2f(t2, i3.u_pixel_coord_lower), u_scale: new e.Uniform3f(t2, i3.u_scale), u_fade: new e.Uniform1f(t2, i3.u_fade), u_opacity: new e.Uniform1f(t2, i3.u_opacity) }), fill: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix) }), fillPattern: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_image: new e.Uniform1i(t2, i3.u_image), u_texsize: new e.Uniform2f(t2, i3.u_texsize), u_pixel_coord_upper: new e.Uniform2f(t2, i3.u_pixel_coord_upper), u_pixel_coord_lower: new e.Uniform2f(t2, i3.u_pixel_coord_lower), u_scale: new e.Uniform3f(t2, i3.u_scale), u_fade: new e.Uniform1f(t2, i3.u_fade) }), fillOutline: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_world: new e.Uniform2f(t2, i3.u_world) }), fillOutlinePattern: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_world: new e.Uniform2f(t2, i3.u_world), u_image: new e.Uniform1i(t2, i3.u_image), u_texsize: new e.Uniform2f(t2, i3.u_texsize), u_pixel_coord_upper: new e.Uniform2f(t2, i3.u_pixel_coord_upper), u_pixel_coord_lower: new e.Uniform2f(t2, i3.u_pixel_coord_lower), u_scale: new e.Uniform3f(t2, i3.u_scale), u_fade: new e.Uniform1f(t2, i3.u_fade) }), circle: (t2, i3) => ({ u_camera_to_center_distance: new e.Uniform1f(t2, i3.u_camera_to_center_distance), u_extrude_scale: new e.UniformMatrix2f(t2, i3.u_extrude_scale), u_device_pixel_ratio: new e.Uniform1f(t2, i3.u_device_pixel_ratio), u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix) }), collisionBox: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_camera_to_center_distance: new e.Uniform1f(t2, i3.u_camera_to_center_distance), u_extrude_scale: new e.Uniform2f(t2, i3.u_extrude_scale) }), collisionCircle: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_inv_matrix: new e.UniformMatrix4f(t2, i3.u_inv_matrix), u_camera_to_center_distance: new e.Uniform1f(t2, i3.u_camera_to_center_distance), u_viewport_size: new e.Uniform2f(t2, i3.u_viewport_size) }), debug: (t2, i3) => ({ u_color: new e.UniformColor(t2, i3.u_color), u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_overlay: new e.Uniform1i(t2, i3.u_overlay), u_overlay_scale: new e.Uniform1f(t2, i3.u_overlay_scale) }), clippingMask: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix) }), heatmap: (t2, i3) => ({ u_extrude_scale: new e.Uniform1f(t2, i3.u_extrude_scale), u_intensity: new e.Uniform1f(t2, i3.u_intensity), u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix) }), heatmapTexture: (t2, i3) => ({ u_image: new e.Uniform1i(t2, i3.u_image), u_color_ramp: new e.Uniform1i(t2, i3.u_color_ramp), u_opacity: new e.Uniform1f(t2, i3.u_opacity) }), hillshade: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_image: new e.Uniform1i(t2, i3.u_image), u_latrange: new e.Uniform2f(t2, i3.u_latrange), u_light: new e.Uniform2f(t2, i3.u_light), u_shadow: new e.UniformColor(t2, i3.u_shadow), u_highlight: new e.UniformColor(t2, i3.u_highlight), u_accent: new e.UniformColor(t2, i3.u_accent) }), hillshadePrepare: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_image: new e.Uniform1i(t2, i3.u_image), u_dimension: new e.Uniform2f(t2, i3.u_dimension), u_zoom: new e.Uniform1f(t2, i3.u_zoom), u_unpack: new e.Uniform4f(t2, i3.u_unpack) }), line: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_pixels_to_tile_units: new e.UniformMatrix2f(t2, i3.u_pixels_to_tile_units), u_device_pixel_ratio: new e.Uniform1f(t2, i3.u_device_pixel_ratio), u_units_to_pixels: new e.Uniform2f(t2, i3.u_units_to_pixels), u_dash_image: new e.Uniform1i(t2, i3.u_dash_image), u_gradient_image: new e.Uniform1i(t2, i3.u_gradient_image), u_image_height: new e.Uniform1f(t2, i3.u_image_height), u_texsize: new e.Uniform2f(t2, i3.u_texsize), u_scale: new e.Uniform3f(t2, i3.u_scale), u_mix: new e.Uniform1f(t2, i3.u_mix), u_alpha_discard_threshold: new e.Uniform1f(t2, i3.u_alpha_discard_threshold) }), linePattern: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_texsize: new e.Uniform2f(t2, i3.u_texsize), u_pixels_to_tile_units: new e.UniformMatrix2f(t2, i3.u_pixels_to_tile_units), u_device_pixel_ratio: new e.Uniform1f(t2, i3.u_device_pixel_ratio), u_image: new e.Uniform1i(t2, i3.u_image), u_units_to_pixels: new e.Uniform2f(t2, i3.u_units_to_pixels), u_scale: new e.Uniform3f(t2, i3.u_scale), u_fade: new e.Uniform1f(t2, i3.u_fade), u_alpha_discard_threshold: new e.Uniform1f(t2, i3.u_alpha_discard_threshold) }), raster: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_tl_parent: new e.Uniform2f(t2, i3.u_tl_parent), u_scale_parent: new e.Uniform1f(t2, i3.u_scale_parent), u_fade_t: new e.Uniform1f(t2, i3.u_fade_t), u_opacity: new e.Uniform1f(t2, i3.u_opacity), u_image0: new e.Uniform1i(t2, i3.u_image0), u_image1: new e.Uniform1i(t2, i3.u_image1), u_brightness_low: new e.Uniform1f(t2, i3.u_brightness_low), u_brightness_high: new e.Uniform1f(t2, i3.u_brightness_high), u_saturation_factor: new e.Uniform1f(t2, i3.u_saturation_factor), u_contrast_factor: new e.Uniform1f(t2, i3.u_contrast_factor), u_spin_weights: new e.Uniform3f(t2, i3.u_spin_weights), u_perspective_transform: new e.Uniform2f(t2, i3.u_perspective_transform) }), symbolIcon: (t2, i3) => ({ u_is_size_zoom_constant: new e.Uniform1i(t2, i3.u_is_size_zoom_constant), u_is_size_feature_constant: new e.Uniform1i(t2, i3.u_is_size_feature_constant), u_size_t: new e.Uniform1f(t2, i3.u_size_t), u_size: new e.Uniform1f(t2, i3.u_size), u_camera_to_center_distance: new e.Uniform1f(t2, i3.u_camera_to_center_distance), u_pitch: new e.Uniform1f(t2, i3.u_pitch), u_rotate_symbol: new e.Uniform1i(t2, i3.u_rotate_symbol), u_aspect_ratio: new e.Uniform1f(t2, i3.u_aspect_ratio), u_fade_change: new e.Uniform1f(t2, i3.u_fade_change), u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_label_plane_matrix: new e.UniformMatrix4f(t2, i3.u_label_plane_matrix), u_coord_matrix: new e.UniformMatrix4f(t2, i3.u_coord_matrix), u_is_text: new e.Uniform1i(t2, i3.u_is_text), u_pitch_with_map: new e.Uniform1i(t2, i3.u_pitch_with_map), u_texsize: new e.Uniform2f(t2, i3.u_texsize), u_tile_id: new e.Uniform3f(t2, i3.u_tile_id), u_zoom_transition: new e.Uniform1f(t2, i3.u_zoom_transition), u_inv_rot_matrix: new e.UniformMatrix4f(t2, i3.u_inv_rot_matrix), u_merc_center: new e.Uniform2f(t2, i3.u_merc_center), u_texture: new e.Uniform1i(t2, i3.u_texture) }), symbolSDF: (t2, i3) => ({ u_is_size_zoom_constant: new e.Uniform1i(t2, i3.u_is_size_zoom_constant), u_is_size_feature_constant: new e.Uniform1i(t2, i3.u_is_size_feature_constant), u_size_t: new e.Uniform1f(t2, i3.u_size_t), u_size: new e.Uniform1f(t2, i3.u_size), u_camera_to_center_distance: new e.Uniform1f(t2, i3.u_camera_to_center_distance), u_pitch: new e.Uniform1f(t2, i3.u_pitch), u_rotate_symbol: new e.Uniform1i(t2, i3.u_rotate_symbol), u_aspect_ratio: new e.Uniform1f(t2, i3.u_aspect_ratio), u_fade_change: new e.Uniform1f(t2, i3.u_fade_change), u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_label_plane_matrix: new e.UniformMatrix4f(t2, i3.u_label_plane_matrix), u_coord_matrix: new e.UniformMatrix4f(t2, i3.u_coord_matrix), u_is_text: new e.Uniform1i(t2, i3.u_is_text), u_pitch_with_map: new e.Uniform1i(t2, i3.u_pitch_with_map), u_texsize: new e.Uniform2f(t2, i3.u_texsize), u_texture: new e.Uniform1i(t2, i3.u_texture), u_gamma_scale: new e.Uniform1f(t2, i3.u_gamma_scale), u_device_pixel_ratio: new e.Uniform1f(t2, i3.u_device_pixel_ratio), u_tile_id: new e.Uniform3f(t2, i3.u_tile_id), u_zoom_transition: new e.Uniform1f(t2, i3.u_zoom_transition), u_inv_rot_matrix: new e.UniformMatrix4f(t2, i3.u_inv_rot_matrix), u_merc_center: new e.Uniform2f(t2, i3.u_merc_center), u_is_halo: new e.Uniform1i(t2, i3.u_is_halo) }), symbolTextAndIcon: (t2, i3) => ({ u_is_size_zoom_constant: new e.Uniform1i(t2, i3.u_is_size_zoom_constant), u_is_size_feature_constant: new e.Uniform1i(t2, i3.u_is_size_feature_constant), u_size_t: new e.Uniform1f(t2, i3.u_size_t), u_size: new e.Uniform1f(t2, i3.u_size), u_camera_to_center_distance: new e.Uniform1f(t2, i3.u_camera_to_center_distance), u_pitch: new e.Uniform1f(t2, i3.u_pitch), u_rotate_symbol: new e.Uniform1i(t2, i3.u_rotate_symbol), u_aspect_ratio: new e.Uniform1f(t2, i3.u_aspect_ratio), u_fade_change: new e.Uniform1f(t2, i3.u_fade_change), u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_label_plane_matrix: new e.UniformMatrix4f(t2, i3.u_label_plane_matrix), u_coord_matrix: new e.UniformMatrix4f(t2, i3.u_coord_matrix), u_is_text: new e.Uniform1i(t2, i3.u_is_text), u_pitch_with_map: new e.Uniform1i(t2, i3.u_pitch_with_map), u_texsize: new e.Uniform2f(t2, i3.u_texsize), u_texsize_icon: new e.Uniform2f(t2, i3.u_texsize_icon), u_texture: new e.Uniform1i(t2, i3.u_texture), u_texture_icon: new e.Uniform1i(t2, i3.u_texture_icon), u_gamma_scale: new e.Uniform1f(t2, i3.u_gamma_scale), u_device_pixel_ratio: new e.Uniform1f(t2, i3.u_device_pixel_ratio), u_is_halo: new e.Uniform1i(t2, i3.u_is_halo) }), background: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_opacity: new e.Uniform1f(t2, i3.u_opacity), u_color: new e.UniformColor(t2, i3.u_color) }), backgroundPattern: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_opacity: new e.Uniform1f(t2, i3.u_opacity), u_image: new e.Uniform1i(t2, i3.u_image), u_pattern_tl_a: new e.Uniform2f(t2, i3.u_pattern_tl_a), u_pattern_br_a: new e.Uniform2f(t2, i3.u_pattern_br_a), u_pattern_tl_b: new e.Uniform2f(t2, i3.u_pattern_tl_b), u_pattern_br_b: new e.Uniform2f(t2, i3.u_pattern_br_b), u_texsize: new e.Uniform2f(t2, i3.u_texsize), u_mix: new e.Uniform1f(t2, i3.u_mix), u_pattern_size_a: new e.Uniform2f(t2, i3.u_pattern_size_a), u_pattern_size_b: new e.Uniform2f(t2, i3.u_pattern_size_b), u_scale_a: new e.Uniform1f(t2, i3.u_scale_a), u_scale_b: new e.Uniform1f(t2, i3.u_scale_b), u_pixel_coord_upper: new e.Uniform2f(t2, i3.u_pixel_coord_upper), u_pixel_coord_lower: new e.Uniform2f(t2, i3.u_pixel_coord_lower), u_tile_units_to_pixels: new e.Uniform1f(t2, i3.u_tile_units_to_pixels) }), terrainRaster: ei, terrainDepth: ei, skybox: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_sun_direction: new e.Uniform3f(t2, i3.u_sun_direction), u_cubemap: new e.Uniform1i(t2, i3.u_cubemap), u_opacity: new e.Uniform1f(t2, i3.u_opacity), u_temporal_offset: new e.Uniform1f(t2, i3.u_temporal_offset) }), skyboxGradient: (t2, i3) => ({ u_matrix: new e.UniformMatrix4f(t2, i3.u_matrix), u_color_ramp: new e.Uniform1i(t2, i3.u_color_ramp), u_center_direction: new e.Uniform3f(t2, i3.u_center_direction), u_radius: new e.Uniform1f(t2, i3.u_radius), u_opacity: new e.Uniform1f(t2, i3.u_opacity), u_temporal_offset: new e.Uniform1f(t2, i3.u_temporal_offset) }), skyboxCapture: (t2, i3) => ({ u_matrix_3f: new e.UniformMatrix3f(t2, i3.u_matrix_3f), u_sun_direction: new e.Uniform3f(t2, i3.u_sun_direction), u_sun_intensity: new e.Uniform1f(t2, i3.u_sun_intensity), u_color_tint_r: new e.Uniform4f(t2, i3.u_color_tint_r), u_color_tint_m: new e.Uniform4f(t2, i3.u_color_tint_m), u_luminance: new e.Uniform1f(t2, i3.u_luminance) }), globeRaster: (t2, i3) => ({ u_proj_matrix: new e.UniformMatrix4f(t2, i3.u_proj_matrix), u_globe_matrix: new e.UniformMatrix4f(t2, i3.u_globe_matrix), u_merc_matrix: new e.UniformMatrix4f(t2, i3.u_merc_matrix), u_zoom_transition: new e.Uniform1f(t2, i3.u_zoom_transition), u_merc_center: new e.Uniform2f(t2, i3.u_merc_center), u_image0: new e.Uniform1i(t2, i3.u_image0) }), globeAtmosphere: (t2, i3) => ({ u_center: new e.Uniform2f(t2, i3.u_center), u_radius: new e.Uniform1f(t2, i3.u_radius), u_screen_size: new e.Uniform2f(t2, i3.u_screen_size), u_pixel_ratio: new e.Uniform1f(t2, i3.u_pixel_ratio), u_opacity: new e.Uniform1f(t2, i3.u_opacity), u_fadeout_range: new e.Uniform1f(t2, i3.u_fadeout_range), u_start_color: new e.Uniform3f(t2, i3.u_start_color), u_end_color: new e.Uniform3f(t2, i3.u_end_color) }) };
      let Ni;
      function Gi(t2, i3, o2, r2, n2, a2, s3) {
        const l2 = t2.context, c2 = l2.gl, h2 = t2.useProgram("collisionBox"), u2 = [];
        let _2 = 0, d2 = 0;
        for (let p3 = 0; p3 < r2.length; p3++) {
          const m3 = r2[p3], f3 = i3.getTile(m3), g3 = f3.getBucket(o2);
          if (!g3)
            continue;
          let v4 = m3.projMatrix;
          n2[0] === 0 && n2[1] === 0 || (v4 = t2.translatePosMatrix(m3.projMatrix, f3, n2, a2));
          const x4 = s3 ? g3.textCollisionBox : g3.iconCollisionBox, y2 = g3.collisionCircleArray;
          if (y2.length > 0) {
            const i4 = e.create(), o3 = v4;
            e.mul(i4, g3.placementInvProjMatrix, t2.transform.glCoordMatrix), e.mul(i4, i4, g3.placementViewportMatrix), u2.push({ circleArray: y2, circleOffset: d2, transform: o3, invTransform: i4 }), _2 += y2.length / 4, d2 = _2;
          }
          x4 && (t2.terrain && t2.terrain.setupElevationDraw(f3, h2), h2.draw(l2, c2.LINES, e.DepthMode.disabled, e.StencilMode.disabled, t2.colorModeForRenderPass(), e.CullFaceMode.disabled, Ei(v4, t2.transform, f3), o2.id, x4.layoutVertexBuffer, x4.indexBuffer, x4.segments, null, t2.transform.zoom, null, x4.collisionVertexBuffer, x4.collisionVertexBufferExt));
        }
        if (!s3 || !u2.length)
          return;
        const p2 = t2.useProgram("collisionCircle"), m2 = new e.StructArrayLayout2f1f2i16();
        m2.resize(4 * _2), m2._trim();
        let f2 = 0;
        for (const e2 of u2)
          for (let t3 = 0; t3 < e2.circleArray.length / 4; t3++) {
            const i4 = 4 * t3, o3 = e2.circleArray[i4 + 0], r3 = e2.circleArray[i4 + 1], n3 = e2.circleArray[i4 + 2], a3 = e2.circleArray[i4 + 3];
            m2.emplace(f2++, o3, r3, n3, a3, 0), m2.emplace(f2++, o3, r3, n3, a3, 1), m2.emplace(f2++, o3, r3, n3, a3, 2), m2.emplace(f2++, o3, r3, n3, a3, 3);
          }
        (!Ni || Ni.length < 2 * _2) && (Ni = function(t3) {
          const i4 = 2 * t3, o3 = new e.StructArrayLayout3ui6();
          o3.resize(i4), o3._trim();
          for (let e2 = 0; e2 < i4; e2++) {
            const t4 = 6 * e2;
            o3.uint16[t4 + 0] = 4 * e2 + 0, o3.uint16[t4 + 1] = 4 * e2 + 1, o3.uint16[t4 + 2] = 4 * e2 + 2, o3.uint16[t4 + 3] = 4 * e2 + 2, o3.uint16[t4 + 4] = 4 * e2 + 3, o3.uint16[t4 + 5] = 4 * e2 + 0;
          }
          return o3;
        }(_2));
        const g2 = l2.createIndexBuffer(Ni, true), v3 = l2.createVertexBuffer(m2, e.collisionCircleLayout.members, true);
        for (const i4 of u2) {
          const r3 = { u_matrix: i4.transform, u_inv_matrix: i4.invTransform, u_camera_to_center_distance: (x3 = t2.transform).cameraToCenterDistance, u_viewport_size: [x3.width, x3.height] };
          p2.draw(l2, c2.TRIANGLES, e.DepthMode.disabled, e.StencilMode.disabled, t2.colorModeForRenderPass(), e.CullFaceMode.disabled, r3, o2.id, v3, g2, e.SegmentVector.simpleSegment(0, 2 * i4.circleOffset, i4.circleArray.length, i4.circleArray.length / 2), null, t2.transform.zoom, null, null, null);
        }
        var x3;
        v3.destroy(), g2.destroy();
      }
      const ji = e.identity(new Float32Array(16));
      function Zi(t2, i3, o2, r2, n2, a2) {
        const { horizontalAlign: s3, verticalAlign: l2 } = e.getAnchorAlignment(t2), c2 = -(s3 - 0.5) * i3, h2 = -(l2 - 0.5) * o2, u2 = e.evaluateVariableOffset(t2, r2);
        return new e.pointGeometry((c2 / n2 + u2[0]) * a2, (h2 / n2 + u2[1]) * a2);
      }
      function Vi(t2, i3, o2, r2, n2, a2, s3, l2, c2, h2, u2, _2) {
        const d2 = t2.text.placedSymbolArray, p2 = t2.text.dynamicLayoutVertexArray, m2 = t2.icon.dynamicLayoutVertexArray, f2 = {}, g2 = l2.projMatrix, v3 = a2.elevation, x3 = v3 ? v3.getAtTileOffsetFunc(l2, _2) : (e2) => [0, 0, 0];
        p2.clear();
        for (let l3 = 0; l3 < d2.length; l3++) {
          const _3 = d2.get(l3), m3 = t2.allowVerticalPlacement && !_3.placedOrientation, v4 = _3.hidden || !_3.crossTileID || m3 ? null : r2[_3.crossTileID];
          if (v4) {
            const r3 = new e.pointGeometry(_3.tileAnchorX, _3.tileAnchorY), l4 = x3(r3), d3 = $e(r3, o2 ? g2 : s3, l4[2]), m4 = He(a2.cameraToCenterDistance, d3.signedDistanceFromCamera);
            let y2 = n2.evaluateSizeForFeature(t2.textSizeData, h2, _3) * m4 / e.ONE_EM;
            o2 && (y2 *= t2.tilePixelRatio / c2);
            const { width: b2, height: w2, anchor: T2, textOffset: E2, textScale: C2 } = v4, M3 = Zi(T2, b2, w2, E2, C2, y2), S3 = o2 ? $e(r3.add(M3), s3, l4[2]).point : d3.point.add(i3 ? M3.rotate(-a2.angle) : M3), I3 = t2.allowVerticalPlacement && _3.placedOrientation === e.WritingMode.vertical ? Math.PI / 2 : 0;
            for (let t3 = 0; t3 < _3.numGlyphs; t3++)
              e.addDynamicAttributes(p2, S3, I3);
            u2 && _3.associatedIconIndex >= 0 && (f2[_3.associatedIconIndex] = { shiftedAnchor: S3, angle: I3 });
          } else
            nt(_3.numGlyphs, p2);
        }
        if (u2) {
          m2.clear();
          const i4 = t2.icon.placedSymbolArray;
          for (let t3 = 0; t3 < i4.length; t3++) {
            const o3 = i4.get(t3);
            if (o3.hidden)
              nt(o3.numGlyphs, m2);
            else {
              const i5 = f2[t3];
              if (i5)
                for (let t4 = 0; t4 < o3.numGlyphs; t4++)
                  e.addDynamicAttributes(m2, i5.shiftedAnchor, i5.angle);
              else
                nt(o3.numGlyphs, m2);
            }
          }
          t2.icon.dynamicLayoutVertexBuffer.updateData(m2);
        }
        t2.text.dynamicLayoutVertexBuffer.updateData(p2);
      }
      function Wi(e2, t2, i3) {
        return i3.iconsInText && t2 ? "symbolTextAndIcon" : e2 ? "symbolSDF" : "symbolIcon";
      }
      function qi(t2, i3, o2, r2, n2, a2, s3, l2, c2, h2, u2, _2) {
        const d2 = t2.context, p2 = d2.gl, m2 = t2.transform, f2 = m2.projection.createTileTransform(m2, m2.worldSize), g2 = l2 === "map", v3 = c2 === "map", x3 = g2 && o2.layout.get("symbol-placement") !== "point", y2 = g2 && !v3 && !x3, b2 = o2.layout.get("symbol-sort-key").constantOr(1) !== void 0;
        let w2 = false;
        const T2 = t2.depthModeForSublayer(0, e.DepthMode.ReadOnly), E2 = [e.mercatorXfromLng(m2.center.lng), e.mercatorYfromLat(m2.center.lat)], C2 = o2.layout.get("text-variable-anchor"), M3 = m2.projection.name === "globe", S3 = M3 ? e.globeToMercatorTransition(m2.zoom) : 0, I3 = [], z2 = [];
        t2.terrain && v3 && z2.push("PITCH_WITH_MAP_TERRAIN"), M3 && z2.push("PROJECTION_GLOBE_VIEW"), x3 && z2.push("PROJECTED_POS_ON_VIEWPORT");
        for (const l3 of r2) {
          const r3 = i3.getTile(l3), c3 = r3.getBucket(o2);
          if (!c3 || c3.projection !== m2.projection.name)
            continue;
          const u3 = n2 ? c3.text : c3.icon;
          if (!u3 || c3.fullyClipped || !u3.segments.get().length)
            continue;
          const _3 = u3.programConfigurations.get(o2.id), d3 = n2 || c3.sdfIcons, T3 = n2 ? c3.textSizeData : c3.iconSizeData, M4 = v3 || m2.pitch !== 0, D4 = t2.useProgram(Wi(d3, n2, c3), _3, z2), P2 = e.evaluateSizeForZoom(T3, m2.zoom), A3 = [l3.canonical.x, l3.canonical.y, 1 << l3.canonical.z];
          let L3, R6, k2, O2, B3 = [0, 0], F2 = null;
          if (n2) {
            if (R6 = r3.glyphAtlasTexture, k2 = p2.LINEAR, L3 = r3.glyphAtlasTexture.size, c3.iconsInText) {
              B3 = r3.imageAtlasTexture.size, F2 = r3.imageAtlasTexture;
              const e2 = T3.kind === "composite" || T3.kind === "camera";
              O2 = M4 || t2.options.rotating || t2.options.zooming || e2 ? p2.LINEAR : p2.NEAREST;
            }
          } else {
            const e2 = o2.layout.get("icon-size").constantOr(0) !== 1 || c3.iconsNeedLinear;
            R6 = r3.imageAtlasTexture, k2 = d3 || t2.options.rotating || t2.options.zooming || e2 || M4 ? p2.LINEAR : p2.NEAREST, L3 = r3.imageAtlasTexture.size;
          }
          const U2 = t2.transform.calculatePixelsToTileUnitsMatrix(r3), N2 = qe(l3.projMatrix, r3.tileID.canonical, v3, g2, t2.transform, U2), G2 = t2.terrain && v3 && x3 ? e.invert(new Float32Array(16), N2) : ji, j2 = Xe(l3.projMatrix, r3.tileID.canonical, v3, g2, t2.transform, U2), Z3 = C2 && c3.hasTextData(), V2 = o2.layout.get("icon-text-fit") !== "none" && Z3 && c3.hasIconData();
          if (x3) {
            const e2 = m2.elevation, i4 = e2 ? e2.getAtTileOffsetFunc(l3, f2) : (e3) => [0, 0, 0];
            Ye(c3, l3.projMatrix, t2, n2, N2, j2, v3, h2, i4, l3);
          }
          const W2 = t2.translatePosMatrix(l3.projMatrix, r3, a2, s3), q2 = x3 || n2 && C2 || V2 ? ji : N2, X3 = t2.translatePosMatrix(j2, r3, a2, s3, true), $2 = d3 && o2.paint.get(n2 ? "text-halo-width" : "icon-halo-width").constantOr(1) !== 0;
          let H10;
          const K2 = f2.createInversionMatrix(l3.toUnwrapped());
          H10 = d3 ? c3.iconsInText ? Oi(T3.kind, P2, y2, v3, t2, W2, q2, X3, L3, B3, A3, S3, K2, E2) : ki(T3.kind, P2, y2, v3, t2, W2, q2, X3, n2, L3, true, A3, S3, K2, E2) : Ri(T3.kind, P2, y2, v3, t2, W2, q2, X3, n2, L3, A3, S3, K2, E2);
          const Y3 = { program: D4, buffers: u3, uniformValues: H10, atlasTexture: R6, atlasTextureIcon: F2, atlasInterpolation: k2, atlasInterpolationIcon: O2, isSDF: d3, hasHalo: $2, tile: r3, labelPlaneMatrixInv: G2 };
          if (b2 && c3.canOverlap) {
            w2 = true;
            const t3 = u3.segments.get();
            for (const i4 of t3)
              I3.push({ segments: new e.SegmentVector([i4]), sortKey: i4.sortKey, state: Y3 });
          } else
            I3.push({ segments: u3.segments, sortKey: 0, state: Y3 });
        }
        w2 && I3.sort((e2, t3) => e2.sortKey - t3.sortKey);
        for (const e2 of I3) {
          const i4 = e2.state;
          if (t2.terrain && t2.terrain.setupElevationDraw(i4.tile, i4.program, { useDepthForOcclusion: !M3, labelPlaneMatrixInv: i4.labelPlaneMatrixInv }), d2.activeTexture.set(p2.TEXTURE0), i4.atlasTexture.bind(i4.atlasInterpolation, p2.CLAMP_TO_EDGE), i4.atlasTextureIcon && (d2.activeTexture.set(p2.TEXTURE1), i4.atlasTextureIcon && i4.atlasTextureIcon.bind(i4.atlasInterpolationIcon, p2.CLAMP_TO_EDGE)), i4.isSDF) {
            const r3 = i4.uniformValues;
            i4.hasHalo && (r3.u_is_halo = 1, Xi(i4.buffers, e2.segments, o2, t2, i4.program, T2, u2, _2, r3)), r3.u_is_halo = 0;
          }
          Xi(i4.buffers, e2.segments, o2, t2, i4.program, T2, u2, _2, i4.uniformValues);
        }
      }
      function Xi(t2, i3, o2, r2, n2, a2, s3, l2, c2) {
        const h2 = r2.context;
        n2.draw(h2, h2.gl.TRIANGLES, a2, s3, l2, e.CullFaceMode.disabled, c2, o2.id, t2.layoutVertexBuffer, t2.indexBuffer, i3, o2.paint, r2.transform.zoom, t2.programConfigurations.get(o2.id), t2.dynamicLayoutVertexBuffer, t2.opacityVertexBuffer);
      }
      function $i(t2, i3, o2, r2, n2, a2, s3) {
        const l2 = t2.context.gl, c2 = o2.paint.get("fill-pattern"), h2 = c2 && c2.constantOr(1), u2 = o2.getCrossfadeParameters();
        let _2, d2, p2, m2, f2;
        s3 ? (d2 = h2 && !o2.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", _2 = l2.LINES) : (d2 = h2 ? "fillPattern" : "fill", _2 = l2.TRIANGLES);
        for (const g2 of r2) {
          const r3 = i3.getTile(g2);
          if (h2 && !r3.patternsLoaded())
            continue;
          const v3 = r3.getBucket(o2);
          if (!v3)
            continue;
          t2.prepareDrawTile(g2);
          const x3 = v3.programConfigurations.get(o2.id), y2 = t2.useProgram(d2, x3);
          h2 && (t2.context.activeTexture.set(l2.TEXTURE0), r3.imageAtlasTexture.bind(l2.LINEAR, l2.CLAMP_TO_EDGE), x3.updatePaintBuffers(u2));
          const b2 = c2.constantOr(null);
          if (b2 && r3.imageAtlas) {
            const e2 = r3.imageAtlas, t3 = e2.patternPositions[b2.to.toString()], i4 = e2.patternPositions[b2.from.toString()];
            t3 && i4 && x3.setConstantPatternPositions(t3, i4);
          }
          const w2 = t2.translatePosMatrix(g2.projMatrix, r3, o2.paint.get("fill-translate"), o2.paint.get("fill-translate-anchor"));
          if (s3) {
            m2 = v3.indexBuffer2, f2 = v3.segments2;
            const e2 = t2.terrain && t2.terrain.renderingToTexture ? t2.terrain.drapeBufferSize : [l2.drawingBufferWidth, l2.drawingBufferHeight];
            p2 = d2 === "fillOutlinePattern" && h2 ? bi(w2, t2, u2, r3, e2) : yi(w2, e2);
          } else
            m2 = v3.indexBuffer, f2 = v3.segments, p2 = h2 ? xi(w2, t2, u2, r3) : vi(w2);
          t2.prepareDrawProgram(t2.context, y2, g2.toUnwrapped()), y2.draw(t2.context, _2, n2, t2.stencilModeForClipping(g2), a2, e.CullFaceMode.disabled, p2, o2.id, v3.layoutVertexBuffer, m2, f2, o2.paint, t2.transform.zoom, x3);
        }
      }
      function Hi(t2, i3, o2, r2, n2, a2, s3) {
        const l2 = t2.context, c2 = l2.gl, h2 = o2.paint.get("fill-extrusion-pattern"), u2 = h2.constantOr(1), _2 = o2.getCrossfadeParameters(), d2 = o2.paint.get("fill-extrusion-opacity");
        for (const p2 of r2) {
          const r3 = i3.getTile(p2), m2 = r3.getBucket(o2);
          if (!m2)
            continue;
          const f2 = m2.programConfigurations.get(o2.id), g2 = t2.useProgram(u2 ? "fillExtrusionPattern" : "fillExtrusion", f2);
          if (t2.terrain) {
            const e2 = t2.terrain;
            if (!m2.enableTerrain)
              continue;
            if (e2.setupElevationDraw(r3, g2, { useMeterToDem: true }), Ki(l2, i3, p2, m2, o2, e2), !m2.centroidVertexBuffer) {
              const e3 = g2.attributes.a_centroid_pos;
              e3 !== void 0 && c2.vertexAttrib2f(e3, 0, 0);
            }
          }
          u2 && (t2.context.activeTexture.set(c2.TEXTURE0), r3.imageAtlasTexture.bind(c2.LINEAR, c2.CLAMP_TO_EDGE), f2.updatePaintBuffers(_2));
          const v3 = h2.constantOr(null);
          if (v3 && r3.imageAtlas) {
            const e2 = r3.imageAtlas, t3 = e2.patternPositions[v3.to.toString()], i4 = e2.patternPositions[v3.from.toString()];
            t3 && i4 && f2.setConstantPatternPositions(t3, i4);
          }
          const x3 = t2.translatePosMatrix(p2.projMatrix, r3, o2.paint.get("fill-extrusion-translate"), o2.paint.get("fill-extrusion-translate-anchor")), y2 = o2.paint.get("fill-extrusion-vertical-gradient"), b2 = u2 ? gi(x3, t2, y2, d2, p2, _2, r3) : fi(x3, t2, y2, d2);
          t2.prepareDrawProgram(l2, g2, p2.toUnwrapped()), g2.draw(l2, l2.gl.TRIANGLES, n2, a2, s3, e.CullFaceMode.backCCW, b2, o2.id, m2.layoutVertexBuffer, m2.indexBuffer, m2.segments, o2.paint, t2.transform.zoom, f2, t2.terrain ? m2.centroidVertexBuffer : null);
        }
      }
      function Ki(t2, i3, o2, r2, n2, a2) {
        const s3 = [(t3) => {
          let i4 = t3.canonical.x - 1, o3 = t3.wrap;
          return i4 < 0 && (i4 = (1 << t3.canonical.z) - 1, o3--), new e.OverscaledTileID(t3.overscaledZ, o3, t3.canonical.z, i4, t3.canonical.y);
        }, (t3) => {
          let i4 = t3.canonical.x + 1, o3 = t3.wrap;
          return i4 === 1 << t3.canonical.z && (i4 = 0, o3++), new e.OverscaledTileID(t3.overscaledZ, o3, t3.canonical.z, i4, t3.canonical.y);
        }, (t3) => new e.OverscaledTileID(t3.overscaledZ, t3.wrap, t3.canonical.z, t3.canonical.x, (t3.canonical.y === 0 ? 1 << t3.canonical.z : t3.canonical.y) - 1), (t3) => new e.OverscaledTileID(t3.overscaledZ, t3.wrap, t3.canonical.z, t3.canonical.x, t3.canonical.y === (1 << t3.canonical.z) - 1 ? 0 : t3.canonical.y + 1)], l2 = (e2) => {
          const t3 = i3.getSource().maxzoom, o3 = (e3) => {
            const t4 = i3.getTileByID(e3);
            if (t4 && t4.hasData())
              return t4.getBucket(n2);
          };
          let r3, a3, s4;
          return (e2.overscaledZ === e2.canonical.z || e2.overscaledZ >= t3) && (r3 = o3(e2.key)), e2.overscaledZ >= t3 && (a3 = o3(e2.calculateScaledKey(e2.overscaledZ + 1))), e2.overscaledZ > t3 && (s4 = o3(e2.calculateScaledKey(e2.overscaledZ - 1))), r3 || a3 || s4;
        }, c2 = [0, 0, 0], h2 = (t3, i4) => (c2[0] = Math.min(t3.min.y, i4.min.y), c2[1] = Math.max(t3.max.y, i4.max.y), c2[2] = e.EXTENT - i4.min.x > t3.max.x ? i4.min.x - e.EXTENT : t3.max.x, c2), u2 = (t3, i4) => (c2[0] = Math.min(t3.min.x, i4.min.x), c2[1] = Math.max(t3.max.x, i4.max.x), c2[2] = e.EXTENT - i4.min.y > t3.max.y ? i4.min.y - e.EXTENT : t3.max.y, c2), _2 = [(e2, t3) => h2(e2, t3), (e2, t3) => h2(t3, e2), (e2, t3) => u2(e2, t3), (e2, t3) => u2(t3, e2)], d2 = new e.pointGeometry(0, 0);
        let p2, m2, f2;
        const g2 = (t3, i4, r3, n3, s4) => {
          const l3 = [[n3 ? r3 : t3, n3 ? t3 : r3, 0], [n3 ? r3 : i4, n3 ? i4 : r3, 0]], c3 = s4 < 0 ? e.EXTENT + s4 : s4, h3 = [n3 ? c3 : (t3 + i4) / 2, n3 ? (t3 + i4) / 2 : c3, 0];
          return r3 === 0 && s4 < 0 || r3 !== 0 && s4 > 0 ? a2.getForTilePoints(f2, [h3], true, m2) : l3.push(h3), a2.getForTilePoints(o2, l3, true, p2), Math.max(l3[0][2], l3[1][2], h3[2]) / a2.exaggeration();
        };
        for (let t3 = 0; t3 < 4; t3++) {
          const i4 = r2.borders[t3];
          if (i4.length === 0 && (r2.borderDone[t3] = true), r2.borderDone[t3])
            continue;
          const n3 = f2 = s3[t3](o2), c3 = l2(n3);
          if (!c3 || !c3.enableTerrain)
            continue;
          if (m2 = a2.findDEMTileFor(n3), !m2 || !m2.dem)
            continue;
          if (!p2) {
            const e2 = a2.findDEMTileFor(o2);
            if (!e2 || !e2.dem)
              return;
            p2 = e2;
          }
          const h3 = (t3 < 2 ? 1 : 5) - t3, u3 = c3.borders[h3];
          let v3 = 0;
          for (let o3 = 0; o3 < i4.length; o3++) {
            const n4 = r2.featuresOnBorder[i4[o3]], a3 = n4.borders[t3];
            let s4;
            for (; v3 < u3.length && (s4 = c3.featuresOnBorder[u3[v3]], !(s4.borders[h3][1] > a3[0] + 3)); )
              c3.borderDone[h3] || c3.encodeCentroid(void 0, s4, false), v3++;
            if (s4 && v3 < u3.length) {
              const i5 = v3;
              let o4 = 0;
              for (; !(s4.borders[h3][0] > a3[1] - 3) && (o4++, ++v3 !== u3.length); )
                s4 = c3.featuresOnBorder[u3[v3]];
              if (s4 = c3.featuresOnBorder[u3[i5]], n4.intersectsCount() > 1 || s4.intersectsCount() > 1 || o4 !== 1) {
                o4 !== 1 && (v3 = i5), r2.encodeCentroid(void 0, n4, false), c3.borderDone[h3] || c3.encodeCentroid(void 0, s4, false);
                continue;
              }
              const l3 = _2[t3](n4, s4), p3 = t3 % 2 ? e.EXTENT - 1 : 0;
              d2.x = g2(l3[0], Math.min(e.EXTENT - 1, l3[1]), p3, t3 < 2, l3[2]), d2.y = 0, r2.encodeCentroid(d2, n4, false), c3.borderDone[h3] || c3.encodeCentroid(d2, s4, false);
            } else
              r2.encodeCentroid(void 0, n4, false);
          }
          r2.borderDone[t3] = r2.needsCentroidUpdate = true, c3.borderDone[h3] || (c3.borderDone[h3] = c3.needsCentroidUpdate = true);
        }
        (r2.needsCentroidUpdate || !r2.centroidVertexBuffer && r2.centroidVertexArray.length !== 0) && r2.uploadCentroid(t2);
      }
      const Yi = new e.Color(1, 0, 0, 1), Ji = new e.Color(0, 1, 0, 1), Qi = new e.Color(0, 0, 1, 1), eo = new e.Color(1, 0, 1, 1), to2 = new e.Color(0, 1, 1, 1);
      function io(e2, t2, i3, o2) {
        ro(e2, 0, t2 + i3 / 2, e2.transform.width, i3, o2);
      }
      function oo(e2, t2, i3, o2) {
        ro(e2, t2 - i3 / 2, 0, i3, e2.transform.height, o2);
      }
      function ro(t2, i3, o2, r2, n2, a2) {
        const s3 = t2.context, l2 = s3.gl;
        l2.enable(l2.SCISSOR_TEST), l2.scissor(i3 * e.exported.devicePixelRatio, o2 * e.exported.devicePixelRatio, r2 * e.exported.devicePixelRatio, n2 * e.exported.devicePixelRatio), s3.clear({ color: a2 }), l2.disable(l2.SCISSOR_TEST);
      }
      function no(t2, i3, o2) {
        const r2 = t2.context, n2 = r2.gl, a2 = o2.projMatrix, s3 = t2.useProgram("debug"), l2 = i3.getTileByID(o2.key);
        t2.terrain && t2.terrain.setupElevationDraw(l2, s3);
        const c2 = e.DepthMode.disabled, h2 = e.StencilMode.disabled, u2 = t2.colorModeForRenderPass(), _2 = "$debug";
        r2.activeTexture.set(n2.TEXTURE0), t2.emptyTexture.bind(n2.LINEAR, n2.CLAMP_TO_EDGE), l2._makeDebugTileBoundsBuffers(t2.context, t2.transform.projection);
        const d2 = l2._tileDebugBuffer || t2.debugBuffer, p2 = l2._tileDebugIndexBuffer || t2.debugIndexBuffer, m2 = l2._tileDebugSegments || t2.debugSegments;
        s3.draw(r2, n2.LINE_STRIP, c2, h2, u2, e.CullFaceMode.disabled, Ci(a2, e.Color.red), _2, d2, p2, m2);
        const f2 = l2.latestRawTileData, g2 = Math.floor((f2 && f2.byteLength || 0) / 1024), v3 = i3.getTile(o2).tileSize, x3 = 512 / Math.min(v3, 512) * (o2.overscaledZ / t2.transform.zoom) * 0.5;
        let y2 = o2.canonical.toString();
        o2.overscaledZ !== o2.canonical.z && (y2 += ` => ${o2.overscaledZ}`), function(e2, t3) {
          e2.initDebugOverlayCanvas();
          const i4 = e2.debugOverlayCanvas, o3 = e2.context.gl, r3 = e2.debugOverlayCanvas.getContext("2d");
          r3.clearRect(0, 0, i4.width, i4.height), r3.shadowColor = "white", r3.shadowBlur = 2, r3.lineWidth = 1.5, r3.strokeStyle = "white", r3.textBaseline = "top", r3.font = "bold 36px Open Sans, sans-serif", r3.fillText(t3, 5, 5), r3.strokeText(t3, 5, 5), e2.debugOverlayTexture.update(i4), e2.debugOverlayTexture.bind(o3.LINEAR, o3.CLAMP_TO_EDGE);
        }(t2, `${y2} ${g2}kb`), s3.draw(r2, n2.TRIANGLES, c2, h2, e.ColorMode.alphaBlended, e.CullFaceMode.disabled, Ci(a2, e.Color.transparent, x3), _2, t2.debugBuffer, t2.quadTriangleIndexBuffer, t2.debugSegments);
      }
      const ao = e.createLayout([{ name: "a_pos_3f", components: 3, type: "Float32" }]), { members: so } = ao;
      function lo(e2, t2, i3, o2) {
        e2.emplaceBack(t2, i3, o2);
      }
      class co {
        constructor(t2) {
          this.vertexArray = new e.StructArrayLayout3f12(), this.indices = new e.StructArrayLayout3ui6(), lo(this.vertexArray, -1, -1, 1), lo(this.vertexArray, 1, -1, 1), lo(this.vertexArray, -1, 1, 1), lo(this.vertexArray, 1, 1, 1), lo(this.vertexArray, -1, -1, -1), lo(this.vertexArray, 1, -1, -1), lo(this.vertexArray, -1, 1, -1), lo(this.vertexArray, 1, 1, -1), this.indices.emplaceBack(5, 1, 3), this.indices.emplaceBack(3, 7, 5), this.indices.emplaceBack(6, 2, 0), this.indices.emplaceBack(0, 4, 6), this.indices.emplaceBack(2, 6, 7), this.indices.emplaceBack(7, 3, 2), this.indices.emplaceBack(5, 4, 0), this.indices.emplaceBack(0, 1, 5), this.indices.emplaceBack(0, 2, 3), this.indices.emplaceBack(3, 1, 0), this.indices.emplaceBack(7, 6, 4), this.indices.emplaceBack(4, 5, 7), this.vertexBuffer = t2.createVertexBuffer(this.vertexArray, so), this.indexBuffer = t2.createIndexBuffer(this.indices), this.segment = e.SegmentVector.simpleSegment(0, 0, 36, 12);
        }
      }
      function ho(t2, i3, o2, r2, n2, a2) {
        const s3 = t2.gl, l2 = i3.paint.get("sky-atmosphere-color"), c2 = i3.paint.get("sky-atmosphere-halo-color"), h2 = i3.paint.get("sky-atmosphere-sun-intensity"), u2 = ((e2, t3, i4, o3, r3) => ({ u_matrix_3f: e2, u_sun_direction: t3, u_sun_intensity: i4, u_color_tint_r: [o3.r, o3.g, o3.b, o3.a], u_color_tint_m: [r3.r, r3.g, r3.b, r3.a], u_luminance: 5e-5 }))(e.fromMat4([], r2), n2, h2, l2, c2);
        s3.framebufferTexture2D(s3.FRAMEBUFFER, s3.COLOR_ATTACHMENT0, s3.TEXTURE_CUBE_MAP_POSITIVE_X + a2, i3.skyboxTexture, 0), o2.draw(t2, s3.TRIANGLES, e.DepthMode.disabled, e.StencilMode.disabled, e.ColorMode.unblended, e.CullFaceMode.frontCW, u2, "skyboxCapture", i3.skyboxGeometry.vertexBuffer, i3.skyboxGeometry.indexBuffer, i3.skyboxGeometry.segment);
      }
      const uo = { symbol: function(t2, i3, o2, r2, n2) {
        if (t2.renderPass !== "translucent")
          return;
        const a2 = e.StencilMode.disabled, s3 = t2.colorModeForRenderPass();
        o2.layout.get("text-variable-anchor") && function(t3, i4, o3, r3, n3, a3, s4) {
          const l2 = i4.transform, c2 = n3 === "map", h2 = a3 === "map", u2 = l2.projection.createTileTransform(l2, l2.worldSize);
          for (const n4 of t3) {
            const t4 = r3.getTile(n4), a4 = t4.getBucket(o3);
            if (!a4 || a4.projection !== l2.projection.name || !a4.text || !a4.text.segments.get().length)
              continue;
            const _2 = e.evaluateSizeForZoom(a4.textSizeData, l2.zoom), d2 = i4.transform.calculatePixelsToTileUnitsMatrix(t4), p2 = qe(n4.projMatrix, t4.tileID.canonical, h2, c2, i4.transform, d2), m2 = o3.layout.get("icon-text-fit") !== "none" && a4.hasIconData();
            if (_2) {
              const i5 = Math.pow(2, l2.zoom - t4.tileID.overscaledZ);
              Vi(a4, c2, h2, s4, e.symbolSize, l2, p2, n4, i5, _2, m2, u2);
            }
          }
        }(r2, t2, o2, i3, o2.layout.get("text-rotation-alignment"), o2.layout.get("text-pitch-alignment"), n2), o2.paint.get("icon-opacity").constantOr(1) !== 0 && qi(t2, i3, o2, r2, false, o2.paint.get("icon-translate"), o2.paint.get("icon-translate-anchor"), o2.layout.get("icon-rotation-alignment"), o2.layout.get("icon-pitch-alignment"), o2.layout.get("icon-keep-upright"), a2, s3), o2.paint.get("text-opacity").constantOr(1) !== 0 && qi(t2, i3, o2, r2, true, o2.paint.get("text-translate"), o2.paint.get("text-translate-anchor"), o2.layout.get("text-rotation-alignment"), o2.layout.get("text-pitch-alignment"), o2.layout.get("text-keep-upright"), a2, s3), i3.map.showCollisionBoxes && (Gi(t2, i3, o2, r2, o2.paint.get("text-translate"), o2.paint.get("text-translate-anchor"), true), Gi(t2, i3, o2, r2, o2.paint.get("icon-translate"), o2.paint.get("icon-translate-anchor"), false));
      }, circle: function(t2, i3, o2, r2) {
        if (t2.renderPass !== "translucent")
          return;
        const n2 = o2.paint.get("circle-opacity"), a2 = o2.paint.get("circle-stroke-width"), s3 = o2.paint.get("circle-stroke-opacity"), l2 = o2.layout.get("circle-sort-key").constantOr(1) !== void 0;
        if (n2.constantOr(1) === 0 && (a2.constantOr(1) === 0 || s3.constantOr(1) === 0))
          return;
        const c2 = t2.context, h2 = c2.gl, u2 = t2.depthModeForSublayer(0, e.DepthMode.ReadOnly), _2 = e.StencilMode.disabled, d2 = t2.colorModeForRenderPass(), p2 = [];
        for (let n3 = 0; n3 < r2.length; n3++) {
          const a3 = r2[n3], s4 = i3.getTile(a3), c3 = s4.getBucket(o2);
          if (!c3)
            continue;
          const h3 = c3.programConfigurations.get(o2.id), u3 = Ti(o2), _3 = { programConfiguration: h3, program: t2.useProgram("circle", h3, u3), layoutVertexBuffer: c3.layoutVertexBuffer, indexBuffer: c3.indexBuffer, uniformValues: wi(t2, a3, s4, o2), tile: s4 };
          if (l2) {
            const t3 = c3.segments.get();
            for (const i4 of t3)
              p2.push({ segments: new e.SegmentVector([i4]), sortKey: i4.sortKey, state: _3 });
          } else
            p2.push({ segments: c3.segments, sortKey: 0, state: _3 });
        }
        l2 && p2.sort((e2, t3) => e2.sortKey - t3.sortKey);
        const m2 = { useDepthForOcclusion: !(t2.transform.projection.name === "globe") };
        for (const i4 of p2) {
          const { programConfiguration: r3, program: n3, layoutVertexBuffer: a3, indexBuffer: s4, uniformValues: l3, tile: p3 } = i4.state, f2 = i4.segments;
          t2.terrain && t2.terrain.setupElevationDraw(p3, n3, m2), t2.prepareDrawProgram(c2, n3, p3.tileID.toUnwrapped()), n3.draw(c2, h2.TRIANGLES, u2, _2, d2, e.CullFaceMode.disabled, l3, o2.id, a3, s4, f2, o2.paint, t2.transform.zoom, r3);
        }
      }, heatmap: function(t2, i3, o2, r2) {
        if (o2.paint.get("heatmap-opacity") !== 0)
          if (t2.renderPass === "offscreen") {
            const n2 = t2.context, a2 = n2.gl, s3 = e.StencilMode.disabled, l2 = new e.ColorMode([a2.ONE, a2.ONE], e.Color.transparent, [true, true, true, true]);
            !function(e2, t3, i4) {
              const o3 = e2.gl;
              e2.activeTexture.set(o3.TEXTURE1), e2.viewport.set([0, 0, t3.width / 4, t3.height / 4]);
              let r3 = i4.heatmapFbo;
              if (r3)
                o3.bindTexture(o3.TEXTURE_2D, r3.colorAttachment.get()), e2.bindFramebuffer.set(r3.framebuffer);
              else {
                const n3 = o3.createTexture();
                o3.bindTexture(o3.TEXTURE_2D, n3), o3.texParameteri(o3.TEXTURE_2D, o3.TEXTURE_WRAP_S, o3.CLAMP_TO_EDGE), o3.texParameteri(o3.TEXTURE_2D, o3.TEXTURE_WRAP_T, o3.CLAMP_TO_EDGE), o3.texParameteri(o3.TEXTURE_2D, o3.TEXTURE_MIN_FILTER, o3.LINEAR), o3.texParameteri(o3.TEXTURE_2D, o3.TEXTURE_MAG_FILTER, o3.LINEAR), r3 = i4.heatmapFbo = e2.createFramebuffer(t3.width / 4, t3.height / 4, false), function(e3, t4, i5, o4) {
                  const r4 = e3.gl;
                  r4.texImage2D(r4.TEXTURE_2D, 0, r4.RGBA, t4.width / 4, t4.height / 4, 0, r4.RGBA, e3.extRenderToTextureHalfFloat ? e3.extTextureHalfFloat.HALF_FLOAT_OES : r4.UNSIGNED_BYTE, null), o4.colorAttachment.set(i5);
                }(e2, t3, n3, r3);
              }
            }(n2, t2, o2), n2.clear({ color: e.Color.transparent });
            for (let c2 = 0; c2 < r2.length; c2++) {
              const h2 = r2[c2];
              if (i3.hasRenderableParent(h2))
                continue;
              const u2 = i3.getTile(h2), _2 = u2.getBucket(o2);
              if (!_2)
                continue;
              const d2 = _2.programConfigurations.get(o2.id), p2 = t2.useProgram("heatmap", d2), { zoom: m2 } = t2.transform;
              t2.terrain && t2.terrain.setupElevationDraw(u2, p2), t2.prepareDrawProgram(n2, p2, h2.toUnwrapped()), p2.draw(n2, a2.TRIANGLES, e.DepthMode.disabled, s3, l2, e.CullFaceMode.disabled, Mi(h2.projMatrix, u2, m2, o2.paint.get("heatmap-intensity")), o2.id, _2.layoutVertexBuffer, _2.indexBuffer, _2.segments, o2.paint, t2.transform.zoom, d2);
            }
            n2.viewport.set([0, 0, t2.width, t2.height]);
          } else
            t2.renderPass === "translucent" && (t2.context.setColorMode(t2.colorModeForRenderPass()), function(t3, i4) {
              const o3 = t3.context, r3 = o3.gl, n2 = i4.heatmapFbo;
              if (!n2)
                return;
              o3.activeTexture.set(r3.TEXTURE0), r3.bindTexture(r3.TEXTURE_2D, n2.colorAttachment.get()), o3.activeTexture.set(r3.TEXTURE1);
              let a2 = i4.colorRampTexture;
              a2 || (a2 = i4.colorRampTexture = new e.Texture(o3, i4.colorRamp, r3.RGBA)), a2.bind(r3.LINEAR, r3.CLAMP_TO_EDGE), t3.useProgram("heatmapTexture").draw(o3, r3.TRIANGLES, e.DepthMode.disabled, e.StencilMode.disabled, t3.colorModeForRenderPass(), e.CullFaceMode.disabled, ((e2, t4, i5, o4) => ({ u_image: 0, u_color_ramp: 1, u_opacity: t4.paint.get("heatmap-opacity") }))(0, i4), i4.id, t3.viewportBuffer, t3.quadTriangleIndexBuffer, t3.viewportSegments, i4.paint, t3.transform.zoom);
            }(t2, o2));
      }, line: function(t2, i3, o2, r2) {
        if (t2.renderPass !== "translucent")
          return;
        const n2 = o2.paint.get("line-opacity"), a2 = o2.paint.get("line-width");
        if (n2.constantOr(1) === 0 || a2.constantOr(1) === 0)
          return;
        const s3 = t2.depthModeForSublayer(0, e.DepthMode.ReadOnly), l2 = t2.colorModeForRenderPass(), c2 = o2.paint.get("line-dasharray"), h2 = c2.constantOr(1), u2 = o2.layout.get("line-cap"), _2 = o2.paint.get("line-pattern"), d2 = _2.constantOr(1), p2 = o2.paint.get("line-gradient"), m2 = o2.getCrossfadeParameters(), f2 = d2 ? "linePattern" : "line", g2 = t2.context, v3 = g2.gl, x3 = ((e2) => {
          const t3 = [];
          Pi(e2) && t3.push("RENDER_LINE_DASH"), e2.paint.get("line-gradient") && t3.push("RENDER_LINE_GRADIENT");
          const i4 = e2.paint.get("line-pattern").constantOr(1), o3 = e2.paint.get("line-opacity").constantOr(1) !== 1;
          return !i4 && o3 && t3.push("RENDER_LINE_ALPHA_DISCARD"), t3;
        })(o2);
        let y2 = x3.includes("RENDER_LINE_ALPHA_DISCARD");
        t2.terrain && t2.terrain.clipOrMaskOverlapStencilType() && (y2 = false);
        for (const n3 of r2) {
          const r3 = i3.getTile(n3);
          if (d2 && !r3.patternsLoaded())
            continue;
          const a3 = r3.getBucket(o2);
          if (!a3)
            continue;
          t2.prepareDrawTile(n3);
          const b2 = a3.programConfigurations.get(o2.id), w2 = t2.useProgram(f2, b2, x3), T2 = _2.constantOr(null);
          if (T2 && r3.imageAtlas) {
            const e2 = r3.imageAtlas, t3 = e2.patternPositions[T2.to.toString()], i4 = e2.patternPositions[T2.from.toString()];
            t3 && i4 && b2.setConstantPatternPositions(t3, i4);
          }
          const E2 = c2.constantOr(null), C2 = u2.constantOr(null);
          if (!d2 && E2 && C2 && r3.lineAtlas) {
            const e2 = r3.lineAtlas, t3 = e2.getDash(E2.to, C2), i4 = e2.getDash(E2.from, C2);
            t3 && i4 && b2.setConstantPatternPositions(t3, i4);
          }
          const M3 = t2.terrain ? n3.projMatrix : null, S3 = d2 ? Ii(t2, r3, o2, m2, M3) : Si(t2, r3, o2, m2, M3, a3.lineClipsArray.length);
          if (p2) {
            const r4 = a3.gradients[o2.id];
            let s4 = r4.texture;
            if (o2.gradientVersion !== r4.version) {
              let l3 = 256;
              if (o2.stepInterpolant) {
                const o3 = i3.getSource().maxzoom, r5 = n3.canonical.z === o3 ? Math.ceil(1 << t2.transform.maxZoom - n3.canonical.z) : 1;
                l3 = e.clamp(e.nextPowerOfTwo(a3.maxLineLength / e.EXTENT * 1024 * r5), 256, g2.maxTextureSize);
              }
              r4.gradient = e.renderColorRamp({ expression: o2.gradientExpression(), evaluationKey: "lineProgress", resolution: l3, image: r4.gradient || void 0, clips: a3.lineClipsArray }), r4.texture ? r4.texture.update(r4.gradient) : r4.texture = new e.Texture(g2, r4.gradient, v3.RGBA), r4.version = o2.gradientVersion, s4 = r4.texture;
            }
            g2.activeTexture.set(v3.TEXTURE1), s4.bind(o2.stepInterpolant ? v3.NEAREST : v3.LINEAR, v3.CLAMP_TO_EDGE);
          }
          h2 && (g2.activeTexture.set(v3.TEXTURE0), r3.lineAtlasTexture.bind(v3.LINEAR, v3.REPEAT), b2.updatePaintBuffers(m2)), d2 && (g2.activeTexture.set(v3.TEXTURE0), r3.imageAtlasTexture.bind(v3.LINEAR, v3.CLAMP_TO_EDGE), b2.updatePaintBuffers(m2)), t2.prepareDrawProgram(g2, w2, n3.toUnwrapped());
          const I3 = (i4) => {
            w2.draw(g2, v3.TRIANGLES, s3, i4, l2, e.CullFaceMode.disabled, S3, o2.id, a3.layoutVertexBuffer, a3.indexBuffer, a3.segments, o2.paint, t2.transform.zoom, b2, a3.layoutVertexBuffer2);
          };
          if (y2) {
            const i4 = t2.stencilModeForClipping(n3).ref;
            i4 === 0 && t2.terrain && g2.clear({ stencil: 0 });
            const o3 = { func: v3.EQUAL, mask: 255 };
            S3.u_alpha_discard_threshold = 0.8, I3(new e.StencilMode(o3, i4, 255, v3.KEEP, v3.KEEP, v3.INVERT)), S3.u_alpha_discard_threshold = 0, I3(new e.StencilMode(o3, i4, 255, v3.KEEP, v3.KEEP, v3.KEEP));
          } else
            I3(t2.stencilModeForClipping(n3));
        }
        y2 && (t2.resetStencilClippingMasks(), t2.terrain && g2.clear({ stencil: 0 }));
      }, fill: function(t2, i3, o2, r2) {
        const n2 = o2.paint.get("fill-color"), a2 = o2.paint.get("fill-opacity");
        if (a2.constantOr(1) === 0)
          return;
        const s3 = t2.colorModeForRenderPass(), l2 = o2.paint.get("fill-pattern"), c2 = t2.opaquePassEnabledForLayer() && !l2.constantOr(1) && n2.constantOr(e.Color.transparent).a === 1 && a2.constantOr(0) === 1 ? "opaque" : "translucent";
        if (t2.renderPass === c2) {
          const n3 = t2.depthModeForSublayer(1, t2.renderPass === "opaque" ? e.DepthMode.ReadWrite : e.DepthMode.ReadOnly);
          $i(t2, i3, o2, r2, n3, s3, false);
        }
        if (t2.renderPass === "translucent" && o2.paint.get("fill-antialias")) {
          const n3 = t2.depthModeForSublayer(o2.getPaintProperty("fill-outline-color") ? 2 : 0, e.DepthMode.ReadOnly);
          $i(t2, i3, o2, r2, n3, s3, true);
        }
      }, "fill-extrusion": function(t2, i3, o2, r2) {
        const n2 = o2.paint.get("fill-extrusion-opacity");
        if (n2 !== 0 && t2.renderPass === "translucent") {
          const a2 = new e.DepthMode(t2.context.gl.LEQUAL, e.DepthMode.ReadWrite, t2.depthRangeFor3D);
          if (n2 !== 1 || o2.paint.get("fill-extrusion-pattern").constantOr(1))
            Hi(t2, i3, o2, r2, a2, e.StencilMode.disabled, e.ColorMode.disabled), Hi(t2, i3, o2, r2, a2, t2.stencilModeFor3D(), t2.colorModeForRenderPass()), t2.resetStencilClippingMasks();
          else {
            const n3 = t2.colorModeForRenderPass();
            Hi(t2, i3, o2, r2, a2, e.StencilMode.disabled, n3);
          }
        }
      }, hillshade: function(t2, i3, o2, r2) {
        if (t2.renderPass !== "offscreen" && t2.renderPass !== "translucent")
          return;
        const n2 = t2.context, a2 = t2.depthModeForSublayer(0, e.DepthMode.ReadOnly), s3 = t2.colorModeForRenderPass(), l2 = t2.terrain && t2.terrain.renderingToTexture, [c2, h2] = t2.renderPass !== "translucent" || l2 ? [{}, r2] : t2.stencilConfigForOverlap(r2);
        for (const r3 of h2) {
          const n3 = i3.getTile(r3);
          if (n3.needsHillshadePrepare && t2.renderPass === "offscreen")
            Qt(t2, n3, o2, a2, e.StencilMode.disabled, s3);
          else if (t2.renderPass === "translucent") {
            const e2 = l2 && t2.terrain ? t2.terrain.stencilModeForRTTOverlap(r3) : c2[r3.overscaledZ];
            Yt(t2, r3, n3, o2, a2, e2, s3);
          }
        }
        n2.viewport.set([0, 0, t2.width, t2.height]), t2.resetStencilClippingMasks();
      }, raster: function(t2, i3, o2, r2, n2, a2) {
        if (t2.renderPass !== "translucent")
          return;
        if (o2.paint.get("raster-opacity") === 0)
          return;
        if (!r2.length)
          return;
        const s3 = t2.context, l2 = s3.gl, c2 = i3.getSource(), h2 = t2.useProgram("raster"), u2 = t2.colorModeForRenderPass(), _2 = t2.terrain && t2.terrain.renderingToTexture, [d2, p2] = c2 instanceof be || _2 ? [{}, r2] : t2.stencilConfigForOverlap(r2), m2 = p2[p2.length - 1].overscaledZ, f2 = !t2.options.moving;
        for (const r3 of p2) {
          const n3 = _2 ? e.DepthMode.disabled : t2.depthModeForSublayer(r3.overscaledZ - m2, o2.paint.get("raster-opacity") === 1 ? e.DepthMode.ReadWrite : e.DepthMode.ReadOnly, l2.LESS), p3 = r3.toUnwrapped(), g2 = i3.getTile(r3);
          if (_2 && (!g2 || !g2.hasData()))
            continue;
          const v3 = _2 ? r3.projMatrix : t2.transform.calculateProjMatrix(p3, f2), x3 = t2.terrain && _2 ? t2.terrain.stencilModeForRTTOverlap(r3) : d2[r3.overscaledZ], y2 = a2 ? 0 : o2.paint.get("raster-fade-duration");
          g2.registerFadeDuration(y2);
          const b2 = i3.findLoadedParent(r3, 0), w2 = li(g2, b2, i3, t2.transform, y2);
          let T2, E2;
          t2.terrain && t2.terrain.prepareDrawTile(r3);
          const C2 = o2.paint.get("raster-resampling") === "nearest" ? l2.NEAREST : l2.LINEAR;
          s3.activeTexture.set(l2.TEXTURE0), g2.texture.bind(C2, l2.CLAMP_TO_EDGE), s3.activeTexture.set(l2.TEXTURE1), b2 ? (b2.texture.bind(C2, l2.CLAMP_TO_EDGE), T2 = Math.pow(2, b2.tileID.overscaledZ - g2.tileID.overscaledZ), E2 = [g2.tileID.canonical.x * T2 % 1, g2.tileID.canonical.y * T2 % 1]) : g2.texture.bind(C2, l2.CLAMP_TO_EDGE);
          const M3 = Ai(v3, E2 || [0, 0], T2 || 1, w2, o2, c2 instanceof be ? c2.perspectiveTransform : [0, 0]);
          if (t2.prepareDrawProgram(s3, h2, p3), c2 instanceof be)
            h2.draw(s3, l2.TRIANGLES, n3, e.StencilMode.disabled, u2, e.CullFaceMode.disabled, M3, o2.id, c2.boundsBuffer, t2.quadTriangleIndexBuffer, c2.boundsSegments);
          else {
            const { tileBoundsBuffer: i4, tileBoundsIndexBuffer: r4, tileBoundsSegments: a3 } = t2.getTileBoundsBuffers(g2);
            h2.draw(s3, l2.TRIANGLES, n3, x3, u2, e.CullFaceMode.disabled, M3, o2.id, i4, r4, a3);
          }
        }
        t2.resetStencilClippingMasks();
      }, background: function(t2, i3, o2, r2) {
        const n2 = o2.paint.get("background-color"), a2 = o2.paint.get("background-opacity");
        if (a2 === 0)
          return;
        const s3 = t2.context, l2 = s3.gl, c2 = t2.transform, h2 = c2.tileSize, u2 = o2.paint.get("background-pattern");
        if (t2.isPatternMissing(u2))
          return;
        const _2 = !u2 && n2.a === 1 && a2 === 1 && t2.opaquePassEnabledForLayer() ? "opaque" : "translucent";
        if (t2.renderPass !== _2)
          return;
        const d2 = e.StencilMode.disabled, p2 = t2.depthModeForSublayer(0, _2 === "opaque" ? e.DepthMode.ReadWrite : e.DepthMode.ReadOnly), m2 = t2.colorModeForRenderPass(), f2 = t2.useProgram(u2 ? "backgroundPattern" : "background");
        let g2, v3 = r2;
        v3 || (g2 = t2.getBackgroundTiles(), v3 = Object.values(g2).map((e2) => e2.tileID)), u2 && (s3.activeTexture.set(l2.TEXTURE0), t2.imageManager.bind(t2.context));
        const x3 = o2.getCrossfadeParameters();
        for (const _3 of v3) {
          const v4 = _3.toUnwrapped(), y2 = r2 ? _3.projMatrix : t2.transform.calculateProjMatrix(v4);
          t2.prepareDrawTile(_3);
          const b2 = i3 ? i3.getTile(_3) : g2 ? g2[_3.key] : new e.Tile(_3, h2, c2.zoom, t2), w2 = u2 ? Fi(y2, a2, t2, u2, { tileID: _3, tileSize: h2 }, x3) : Bi(y2, a2, n2);
          t2.prepareDrawProgram(s3, f2, v4);
          const { tileBoundsBuffer: T2, tileBoundsIndexBuffer: E2, tileBoundsSegments: C2 } = t2.getTileBoundsBuffers(b2);
          f2.draw(s3, l2.TRIANGLES, p2, d2, m2, e.CullFaceMode.disabled, w2, o2.id, T2, E2, C2);
        }
      }, sky: function(t2, i3, o2) {
        const r2 = t2.transform, n2 = r2.projection.name === "mercator" || r2.projection.name === "globe" ? 1 : e.smoothstep(7, 8, r2.zoom), a2 = o2.paint.get("sky-opacity") * n2;
        if (a2 === 0)
          return;
        const s3 = t2.context, l2 = o2.paint.get("sky-type"), c2 = new e.DepthMode(s3.gl.LEQUAL, e.DepthMode.ReadOnly, [0, 1]), h2 = t2.frameCounter / 1e3 % 1;
        l2 === "atmosphere" ? t2.renderPass === "offscreen" ? o2.needsSkyboxCapture(t2) && (function(t3, i4, o3, r3) {
          const n3 = t3.context, a3 = n3.gl;
          let s4 = i4.skyboxFbo;
          if (!s4) {
            s4 = i4.skyboxFbo = n3.createFramebuffer(32, 32, false), i4.skyboxGeometry = new co(n3), i4.skyboxTexture = n3.gl.createTexture(), a3.bindTexture(a3.TEXTURE_CUBE_MAP, i4.skyboxTexture), a3.texParameteri(a3.TEXTURE_CUBE_MAP, a3.TEXTURE_WRAP_S, a3.CLAMP_TO_EDGE), a3.texParameteri(a3.TEXTURE_CUBE_MAP, a3.TEXTURE_WRAP_T, a3.CLAMP_TO_EDGE), a3.texParameteri(a3.TEXTURE_CUBE_MAP, a3.TEXTURE_MIN_FILTER, a3.LINEAR), a3.texParameteri(a3.TEXTURE_CUBE_MAP, a3.TEXTURE_MAG_FILTER, a3.LINEAR);
            for (let e2 = 0; e2 < 6; ++e2)
              a3.texImage2D(a3.TEXTURE_CUBE_MAP_POSITIVE_X + e2, 0, a3.RGBA, 32, 32, 0, a3.RGBA, a3.UNSIGNED_BYTE, null);
          }
          n3.bindFramebuffer.set(s4.framebuffer), n3.viewport.set([0, 0, 32, 32]);
          const l3 = i4.getCenter(t3, true), c3 = t3.useProgram("skyboxCapture"), h3 = new Float64Array(16);
          e.identity(h3), e.rotateY(h3, h3, 0.5 * -Math.PI), ho(n3, i4, c3, h3, l3, 0), e.identity(h3), e.rotateY(h3, h3, 0.5 * Math.PI), ho(n3, i4, c3, h3, l3, 1), e.identity(h3), e.rotateX(h3, h3, 0.5 * -Math.PI), ho(n3, i4, c3, h3, l3, 2), e.identity(h3), e.rotateX(h3, h3, 0.5 * Math.PI), ho(n3, i4, c3, h3, l3, 3), e.identity(h3), ho(n3, i4, c3, h3, l3, 4), e.identity(h3), e.rotateY(h3, h3, Math.PI), ho(n3, i4, c3, h3, l3, 5), n3.viewport.set([0, 0, t3.width, t3.height]);
        }(t2, o2), o2.markSkyboxValid(t2)) : t2.renderPass === "sky" && function(t3, i4, o3, r3, n3) {
          const a3 = t3.context, s4 = a3.gl, l3 = t3.transform, c3 = t3.useProgram("skybox");
          a3.activeTexture.set(s4.TEXTURE0), s4.bindTexture(s4.TEXTURE_CUBE_MAP, i4.skyboxTexture);
          const h3 = ((e2, t4, i5, o4, r4) => ({ u_matrix: e2, u_sun_direction: t4, u_cubemap: 0, u_opacity: o4, u_temporal_offset: r4 }))(l3.skyboxMatrix, i4.getCenter(t3, false), 0, r3, n3);
          t3.prepareDrawProgram(a3, c3), c3.draw(a3, s4.TRIANGLES, o3, e.StencilMode.disabled, t3.colorModeForRenderPass(), e.CullFaceMode.backCW, h3, "skybox", i4.skyboxGeometry.vertexBuffer, i4.skyboxGeometry.indexBuffer, i4.skyboxGeometry.segment);
        }(t2, o2, c2, a2, h2) : l2 === "gradient" && t2.renderPass === "sky" && function(t3, i4, o3, r3, n3) {
          const a3 = t3.context, s4 = a3.gl, l3 = t3.transform, c3 = t3.useProgram("skyboxGradient");
          i4.skyboxGeometry || (i4.skyboxGeometry = new co(a3)), a3.activeTexture.set(s4.TEXTURE0);
          let h3 = i4.colorRampTexture;
          h3 || (h3 = i4.colorRampTexture = new e.Texture(a3, i4.colorRamp, s4.RGBA)), h3.bind(s4.LINEAR, s4.CLAMP_TO_EDGE);
          const u2 = ((t4, i5, o4, r4, n4) => ({ u_matrix: t4, u_color_ramp: 0, u_center_direction: i5, u_radius: e.degToRad(o4), u_opacity: r4, u_temporal_offset: n4 }))(l3.skyboxMatrix, i4.getCenter(t3, false), i4.paint.get("sky-gradient-radius"), r3, n3);
          t3.prepareDrawProgram(a3, c3), c3.draw(a3, s4.TRIANGLES, o3, e.StencilMode.disabled, t3.colorModeForRenderPass(), e.CullFaceMode.backCW, u2, "skyboxGradient", i4.skyboxGeometry.vertexBuffer, i4.skyboxGeometry.indexBuffer, i4.skyboxGeometry.segment);
        }(t2, o2, c2, a2, h2);
      }, debug: function(e2, t2, i3) {
        for (let o2 = 0; o2 < i3.length; o2++)
          no(e2, t2, i3[o2]);
      }, custom: function(t2, i3, o2) {
        const r2 = t2.context, n2 = o2.implementation;
        if (t2.transform.projection.unsupportedLayers && t2.transform.projection.unsupportedLayers.includes("custom"))
          e.warnOnce("Custom layers are not yet supported with non-mercator projections. Use mercator to enable custom layers.");
        else if (t2.renderPass === "offscreen") {
          const e2 = n2.prerender;
          e2 && (t2.setCustomLayerDefaults(), r2.setColorMode(t2.colorModeForRenderPass()), e2.call(n2, r2.gl, t2.transform.customLayerMatrix()), r2.setDirty(), t2.setBaseState());
        } else if (t2.renderPass === "translucent") {
          t2.setCustomLayerDefaults(), r2.setColorMode(t2.colorModeForRenderPass()), r2.setStencilMode(e.StencilMode.disabled);
          const i4 = n2.renderingMode === "3d" ? new e.DepthMode(t2.context.gl.LEQUAL, e.DepthMode.ReadWrite, t2.depthRangeFor3D) : t2.depthModeForSublayer(0, e.DepthMode.ReadOnly);
          r2.setDepthMode(i4), n2.render(r2.gl, t2.transform.customLayerMatrix()), r2.setDirty(), t2.setBaseState(), r2.bindFramebuffer.set(null);
        }
      } };
      class _o {
        constructor(t2, i3) {
          this.context = new de(t2), this.transform = i3, this._tileTextures = {}, this.frameCopies = [], this.loadTimeStamps = [], this.setup(), this.numSublayers = e.SourceCache.maxUnderzooming + e.SourceCache.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new Rt(), this.gpuTimers = {}, this.frameCounter = 0, this._backgroundTiles = {};
        }
        updateTerrain(e2, t2) {
          const i3 = !!e2 && !!e2.terrain && this.transform.projection.supportsTerrain;
          if (!(i3 || this._terrain && this._terrain.enabled))
            return;
          this._terrain || (this._terrain = new _i(this, e2));
          const o2 = this._terrain;
          this.transform.elevation = i3 ? o2 : null, o2.update(e2, this.transform, t2);
        }
        _updateFog(e2) {
          const t2 = e2.fog;
          if (!t2 || t2.getOpacity(this.transform.pitch) < 1 || t2.properties.get("horizon-blend") < 0.03)
            return void (this.transform.fogCullDistSq = null);
          const [i3, o2] = t2.getFovAdjustedRange(this.transform._fov);
          if (i3 > o2)
            return void (this.transform.fogCullDistSq = null);
          const r2 = i3 + 0.78 * (o2 - i3);
          this.transform.fogCullDistSq = r2 * r2;
        }
        get terrain() {
          return this.transform._terrainEnabled() && this._terrain && this._terrain.enabled ? this._terrain : null;
        }
        resize(t2, i3) {
          if (this.width = t2 * e.exported.devicePixelRatio, this.height = i3 * e.exported.devicePixelRatio, this.context.viewport.set([0, 0, this.width, this.height]), this.style)
            for (const e2 of this.style.order)
              this.style._layers[e2].resize();
        }
        setup() {
          const t2 = this.context, i3 = new e.StructArrayLayout2i4();
          i3.emplaceBack(0, 0), i3.emplaceBack(e.EXTENT, 0), i3.emplaceBack(0, e.EXTENT), i3.emplaceBack(e.EXTENT, e.EXTENT), this.tileExtentBuffer = t2.createVertexBuffer(i3, e.posAttributes.members), this.tileExtentSegments = e.SegmentVector.simpleSegment(0, 0, 4, 2);
          const o2 = new e.StructArrayLayout2i4();
          o2.emplaceBack(0, 0), o2.emplaceBack(e.EXTENT, 0), o2.emplaceBack(0, e.EXTENT), o2.emplaceBack(e.EXTENT, e.EXTENT), this.debugBuffer = t2.createVertexBuffer(o2, e.posAttributes.members), this.debugSegments = e.SegmentVector.simpleSegment(0, 0, 4, 5);
          const r2 = new e.StructArrayLayout2i4();
          r2.emplaceBack(-1, -1), r2.emplaceBack(1, -1), r2.emplaceBack(-1, 1), r2.emplaceBack(1, 1), this.viewportBuffer = t2.createVertexBuffer(r2, e.posAttributes.members), this.viewportSegments = e.SegmentVector.simpleSegment(0, 0, 4, 2);
          const n2 = new e.StructArrayLayout4i8();
          n2.emplaceBack(0, 0, 0, 0), n2.emplaceBack(e.EXTENT, 0, e.EXTENT, 0), n2.emplaceBack(0, e.EXTENT, 0, e.EXTENT), n2.emplaceBack(e.EXTENT, e.EXTENT, e.EXTENT, e.EXTENT), this.mercatorBoundsBuffer = t2.createVertexBuffer(n2, e.boundsAttributes.members), this.mercatorBoundsSegments = e.SegmentVector.simpleSegment(0, 0, 4, 2);
          const a2 = new e.StructArrayLayout3ui6();
          a2.emplaceBack(0, 1, 2), a2.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = t2.createIndexBuffer(a2);
          const s3 = new e.StructArrayLayout1ui2();
          for (const e2 of [0, 1, 3, 2, 0])
            s3.emplaceBack(e2);
          this.debugIndexBuffer = t2.createIndexBuffer(s3), this.emptyTexture = new e.Texture(t2, { width: 1, height: 1, data: new Uint8Array([0, 0, 0, 0]) }, t2.gl.RGBA), this.identityMat = e.create();
          const l2 = this.context.gl;
          this.stencilClearMode = new e.StencilMode({ func: l2.ALWAYS, mask: 0 }, 0, 255, l2.ZERO, l2.ZERO, l2.ZERO), this.loadTimeStamps.push(e.window.performance.now());
        }
        getMercatorTileBoundsBuffers() {
          return { tileBoundsBuffer: this.mercatorBoundsBuffer, tileBoundsIndexBuffer: this.quadTriangleIndexBuffer, tileBoundsSegments: this.mercatorBoundsSegments };
        }
        getTileBoundsBuffers(e2) {
          return e2._makeTileBoundsBuffers(this.context, this.transform.projection), e2._tileBoundsBuffer ? { tileBoundsBuffer: e2._tileBoundsBuffer, tileBoundsIndexBuffer: e2._tileBoundsIndexBuffer, tileBoundsSegments: e2._tileBoundsSegments } : this.getMercatorTileBoundsBuffers();
        }
        clearStencil() {
          const t2 = this.context, i3 = t2.gl;
          this.nextStencilID = 1, this.currentStencilSource = void 0, this._tileClippingMaskIDs = {}, this.useProgram("clippingMask").draw(t2, i3.TRIANGLES, e.DepthMode.disabled, this.stencilClearMode, e.ColorMode.disabled, e.CullFaceMode.disabled, si(this.identityMat), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
        }
        resetStencilClippingMasks() {
          this.terrain || (this.currentStencilSource = void 0, this._tileClippingMaskIDs = {});
        }
        _renderTileClippingMasks(t2, i3, o2) {
          if (!i3 || this.currentStencilSource === i3.id || !t2.isTileClipped() || !o2 || o2.length === 0)
            return;
          if (this._tileClippingMaskIDs && !this.terrain) {
            let e2 = false;
            for (const t3 of o2)
              if (this._tileClippingMaskIDs[t3.key] === void 0) {
                e2 = true;
                break;
              }
            if (!e2)
              return;
          }
          this.currentStencilSource = i3.id;
          const r2 = this.context, n2 = r2.gl;
          this.nextStencilID + o2.length > 256 && this.clearStencil(), r2.setColorMode(e.ColorMode.disabled), r2.setDepthMode(e.DepthMode.disabled);
          const a2 = this.useProgram("clippingMask");
          this._tileClippingMaskIDs = {};
          for (const t3 of o2) {
            const o3 = i3.getTile(t3), s3 = this._tileClippingMaskIDs[t3.key] = this.nextStencilID++, { tileBoundsBuffer: l2, tileBoundsIndexBuffer: c2, tileBoundsSegments: h2 } = this.getTileBoundsBuffers(o3);
            a2.draw(r2, n2.TRIANGLES, e.DepthMode.disabled, new e.StencilMode({ func: n2.ALWAYS, mask: 0 }, s3, 255, n2.KEEP, n2.KEEP, n2.REPLACE), e.ColorMode.disabled, e.CullFaceMode.disabled, si(t3.projMatrix), "$clipping", l2, c2, h2);
          }
        }
        stencilModeFor3D() {
          this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
          const t2 = this.nextStencilID++, i3 = this.context.gl;
          return new e.StencilMode({ func: i3.NOTEQUAL, mask: 255 }, t2, 255, i3.KEEP, i3.KEEP, i3.REPLACE);
        }
        stencilModeForClipping(t2) {
          if (this.terrain)
            return this.terrain.stencilModeForRTTOverlap(t2);
          const i3 = this.context.gl;
          return new e.StencilMode({ func: i3.EQUAL, mask: 255 }, this._tileClippingMaskIDs[t2.key], 0, i3.KEEP, i3.KEEP, i3.REPLACE);
        }
        stencilConfigForOverlap(t2) {
          const i3 = this.context.gl, o2 = t2.sort((e2, t3) => t3.overscaledZ - e2.overscaledZ), r2 = o2[o2.length - 1].overscaledZ, n2 = o2[0].overscaledZ - r2 + 1;
          if (n2 > 1) {
            this.currentStencilSource = void 0, this.nextStencilID + n2 > 256 && this.clearStencil();
            const t3 = {};
            for (let o3 = 0; o3 < n2; o3++)
              t3[o3 + r2] = new e.StencilMode({ func: i3.GEQUAL, mask: 255 }, o3 + this.nextStencilID, 255, i3.KEEP, i3.KEEP, i3.REPLACE);
            return this.nextStencilID += n2, [t3, o2];
          }
          return [{ [r2]: e.StencilMode.disabled }, o2];
        }
        colorModeForRenderPass() {
          const t2 = this.context.gl;
          if (this._showOverdrawInspector) {
            const i3 = 1 / 8;
            return new e.ColorMode([t2.CONSTANT_COLOR, t2.ONE], new e.Color(i3, i3, i3, 0), [true, true, true, true]);
          }
          return this.renderPass === "opaque" ? e.ColorMode.unblended : e.ColorMode.alphaBlended;
        }
        depthModeForSublayer(t2, i3, o2) {
          if (!this.opaquePassEnabledForLayer())
            return e.DepthMode.disabled;
          const r2 = 1 - ((1 + this.currentLayer) * this.numSublayers + t2) * this.depthEpsilon;
          return new e.DepthMode(o2 || this.context.gl.LEQUAL, i3, [r2, r2]);
        }
        opaquePassEnabledForLayer() {
          return this.currentLayer < this.opaquePassCutoff;
        }
        render(t2, i3) {
          this.style = t2, this.options = i3, this.lineAtlas = t2.lineAtlas, this.imageManager = t2.imageManager, this.glyphManager = t2.glyphManager, this.symbolFadeChange = t2.placement.symbolFadeChange(e.exported.now()), this.imageManager.beginFrame();
          const o2 = this.style.order, r2 = this.style._sourceCaches;
          for (const e2 in r2) {
            const t3 = r2[e2];
            t3.used && t3.prepare(this.context);
          }
          const n2 = {}, a2 = {}, s3 = {};
          for (const e2 in r2) {
            const t3 = r2[e2];
            n2[e2] = t3.getVisibleCoordinates(), a2[e2] = n2[e2].slice().reverse(), s3[e2] = t3.getVisibleCoordinates(true).reverse();
          }
          this.opaquePassCutoff = 1 / 0;
          for (let e2 = 0; e2 < o2.length; e2++)
            if (this.style._layers[o2[e2]].is3D()) {
              this.opaquePassCutoff = e2;
              break;
            }
          if (this.terrain && (this.terrain.updateTileBinding(s3), this.opaquePassCutoff = 0), this.transform.projection.name !== "globe" || this.globeSharedBuffers || (this.globeSharedBuffers = new e.GlobeSharedBuffers(this.context)), !e.isMapAuthenticated(this.context.gl))
            return;
          this.renderPass = "offscreen";
          for (const e2 of o2) {
            const i4 = this.style._layers[e2], o3 = t2._getLayerSourceCache(i4);
            if (!i4.hasOffscreenPass() || i4.isHidden(this.transform.zoom))
              continue;
            const r3 = o3 ? a2[o3.id] : void 0;
            (i4.type === "custom" || i4.isSky() || r3 && r3.length) && this.renderLayer(this, o3, i4, r3);
          }
          this.depthRangeFor3D = [0, 1 - (t2.order.length + 2) * this.numSublayers * this.depthEpsilon], this.terrain && (this.style.hasSymbolLayers() || this.style.hasCircleLayers()) && this.terrain.drawDepth(), this.context.bindFramebuffer.set(null), this.context.viewport.set([0, 0, this.width, this.height]);
          let l2 = e.Color.transparent;
          if (this.style.fog && this.style.fog.getOpacity(this.transform.pitch) && (l2 = this.style.fog.properties.get("color")), this.context.clear({ color: i3.showOverdrawInspector ? e.Color.black : l2, depth: 1 }), this.clearStencil(), this._showOverdrawInspector = i3.showOverdrawInspector, this.renderPass = "opaque", !this.terrain)
            for (this.currentLayer = o2.length - 1; this.currentLayer >= 0; this.currentLayer--) {
              const e2 = this.style._layers[o2[this.currentLayer]], i4 = t2._getLayerSourceCache(e2);
              if (e2.isSky())
                continue;
              const r3 = i4 ? a2[i4.id] : void 0;
              this._renderTileClippingMasks(e2, i4, r3), this.renderLayer(this, i4, e2, r3);
            }
          if (this.renderPass = "sky", (e.globeToMercatorTransition(this.transform.zoom) > 0 || this.transform.projection.name !== "globe") && this.transform.isHorizonVisible())
            for (this.currentLayer = 0; this.currentLayer < o2.length; this.currentLayer++) {
              const e2 = this.style._layers[o2[this.currentLayer]], i4 = t2._getLayerSourceCache(e2);
              e2.isSky() && this.renderLayer(this, i4, e2, i4 ? a2[i4.id] : void 0);
            }
          for (this.transform.projection.name === "globe" && function(t3) {
            const i4 = t3.context, o3 = i4.gl, r3 = t3.transform, n3 = new e.DepthMode(o3.LEQUAL, e.DepthMode.ReadOnly, [0, 1]), a3 = t3.useProgram("globeAtmosphere"), s4 = r3._camera.getWorldToCamera(r3.worldSize, 1), l3 = r3._camera.getCameraToClipPerspective(r3._fov, r3.width / r3.height, r3._nearZ, r3._farZ), c2 = e.mul([], s4, e.calculateGlobeMatrix(r3, r3.worldSize)), h2 = e.mul([], r3.labelPlaneMatrix, l3), u2 = e.transformMat4([], [0, 0, 0], c2), _2 = e.add([], u2, [r3.worldSize / Math.PI / 2, 0, 0]), d2 = e.transformMat4([], u2, h2), p2 = e.transformMat4([], _2, h2), m2 = e.length(e.sub([], p2, d2)), f2 = 1 - e.globeToMercatorTransition(r3.zoom), g2 = { u_center: d2, u_radius: m2, u_screen_size: [r3.width, r3.height], u_pixel_ratio: e.exported.devicePixelRatio, u_opacity: f2, u_fadeout_range: 2, u_start_color: [1, 1, 1], u_end_color: [0.0118, 0.7451, 0.9882] };
            t3.prepareDrawProgram(i4, a3);
            const v3 = t3.globeSharedBuffers;
            v3 && a3.draw(i4, o3.TRIANGLES, n3, e.StencilMode.disabled, e.ColorMode.alphaBlended, e.CullFaceMode.backCW, g2, "skybox", v3.atmosphereVertexBuffer, v3.atmosphereIndexBuffer, v3.atmosphereSegments);
          }(this), this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < o2.length; ) {
            const e2 = this.style._layers[o2[this.currentLayer]], i4 = t2._getLayerSourceCache(e2);
            if (e2.isSky()) {
              ++this.currentLayer;
              continue;
            }
            if (this.terrain && this.style.isLayerDraped(e2)) {
              if (e2.isHidden(this.transform.zoom)) {
                ++this.currentLayer;
                continue;
              }
              this.currentLayer = this.terrain.renderBatch(this.currentLayer);
              continue;
            }
            const r3 = i4 ? (e2.type === "symbol" ? s3 : a2)[i4.id] : void 0;
            this._renderTileClippingMasks(e2, i4, i4 ? n2[i4.id] : void 0), this.renderLayer(this, i4, e2, r3), ++this.currentLayer;
          }
          if (this.terrain && this.terrain.postRender(), this.options.showTileBoundaries || this.options.showQueryGeometry) {
            let i4 = null;
            e.values(this.style._layers).forEach((e2) => {
              const o3 = t2._getLayerSourceCache(e2);
              o3 && !e2.isHidden(this.transform.zoom) && (!i4 || i4.getSource().maxzoom < o3.getSource().maxzoom) && (i4 = o3);
            }), i4 && this.options.showTileBoundaries && uo.debug(this, i4, i4.getVisibleCoordinates());
          }
          this.options.showPadding && function(e2) {
            const t3 = e2.transform.padding;
            io(e2, e2.transform.height - (t3.top || 0), 3, Yi), io(e2, t3.bottom || 0, 3, Ji), oo(e2, t3.left || 0, 3, Qi), oo(e2, e2.transform.width - (t3.right || 0), 3, eo);
            const i4 = e2.transform.centerPoint;
            !function(e3, t4, i5, o3) {
              ro(e3, t4 - 1, i5 - 10, 2, 20, o3), ro(e3, t4 - 10, i5 - 1, 20, 2, o3);
            }(e2, i4.x, e2.transform.height - i4.y, to2);
          }(this), this.context.setDefault(), this.frameCounter = (this.frameCounter + 1) % Number.MAX_SAFE_INTEGER, this.tileLoaded && this.options.speedIndexTiming && (this.loadTimeStamps.push(e.window.performance.now()), this.saveCanvasCopy());
        }
        renderLayer(e2, t2, i3, o2) {
          i3.isHidden(this.transform.zoom) || (i3.type === "background" || i3.type === "sky" || i3.type === "custom" || o2 && o2.length) && (this.id = i3.id, this.gpuTimingStart(i3), e2.transform.projection.unsupportedLayers && e2.transform.projection.unsupportedLayers.includes(i3.type) || uo[i3.type](e2, t2, i3, o2, this.style.placement.variableOffsets, this.options.isInitialLoad), this.gpuTimingEnd());
        }
        gpuTimingStart(e2) {
          if (!this.options.gpuTiming)
            return;
          const t2 = this.context.extTimerQuery;
          let i3 = this.gpuTimers[e2.id];
          i3 || (i3 = this.gpuTimers[e2.id] = { calls: 0, cpuTime: 0, query: t2.createQueryEXT() }), i3.calls++, t2.beginQueryEXT(t2.TIME_ELAPSED_EXT, i3.query);
        }
        gpuTimingEnd() {
          if (!this.options.gpuTiming)
            return;
          const e2 = this.context.extTimerQuery;
          e2.endQueryEXT(e2.TIME_ELAPSED_EXT);
        }
        collectGpuTimers() {
          const e2 = this.gpuTimers;
          return this.gpuTimers = {}, e2;
        }
        queryGpuTimers(e2) {
          const t2 = {};
          for (const i3 in e2) {
            const o2 = e2[i3], r2 = this.context.extTimerQuery, n2 = r2.getQueryObjectEXT(o2.query, r2.QUERY_RESULT_EXT) / 1e6;
            r2.deleteQueryEXT(o2.query), t2[i3] = n2;
          }
          return t2;
        }
        translatePosMatrix(t2, i3, o2, r2, n2) {
          if (!o2[0] && !o2[1])
            return t2;
          const a2 = n2 ? r2 === "map" ? this.transform.angle : 0 : r2 === "viewport" ? -this.transform.angle : 0;
          if (a2) {
            const e2 = Math.sin(a2), t3 = Math.cos(a2);
            o2 = [o2[0] * t3 - o2[1] * e2, o2[0] * e2 + o2[1] * t3];
          }
          const s3 = [n2 ? o2[0] : M2(i3, o2[0], this.transform.zoom), n2 ? o2[1] : M2(i3, o2[1], this.transform.zoom), 0], l2 = new Float32Array(16);
          return e.translate(l2, t2, s3), l2;
        }
        saveTileTexture(e2) {
          const t2 = this._tileTextures[e2.size[0]];
          t2 ? t2.push(e2) : this._tileTextures[e2.size[0]] = [e2];
        }
        getTileTexture(e2) {
          const t2 = this._tileTextures[e2];
          return t2 && t2.length > 0 ? t2.pop() : null;
        }
        isPatternMissing(e2) {
          if (!e2)
            return false;
          if (!e2.from || !e2.to)
            return true;
          const t2 = this.imageManager.getPattern(e2.from.toString()), i3 = this.imageManager.getPattern(e2.to.toString());
          return !t2 || !i3;
        }
        currentGlobalDefines() {
          const e2 = this.terrain && this.terrain.renderingToTexture, t2 = this.style && this.style.fog, i3 = [];
          return this.terrain && !this.terrain.renderingToTexture && i3.push("TERRAIN"), t2 && !e2 && t2.getOpacity(this.transform.pitch) !== 0 && i3.push("FOG"), e2 && i3.push("RENDER_TO_TEXTURE"), this._showOverdrawInspector && i3.push("OVERDRAW_INSPECTOR"), i3;
        }
        useProgram(e2, t2, i3) {
          this.cache = this.cache || {};
          const o2 = i3 || [], r2 = this.currentGlobalDefines().concat(o2), n2 = pi.cacheKey(e2, r2, t2);
          return this.cache[n2] || (this.cache[n2] = new pi(this.context, e2, Xt[e2], t2, Ui[e2], r2)), this.cache[n2];
        }
        setCustomLayerDefaults() {
          this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.frontFace.setDefault(), this.context.cullFaceSide.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
        }
        setBaseState() {
          const e2 = this.context.gl;
          this.context.cullFace.set(false), this.context.viewport.set([0, 0, this.width, this.height]), this.context.blendEquation.set(e2.FUNC_ADD);
        }
        initDebugOverlayCanvas() {
          this.debugOverlayCanvas == null && (this.debugOverlayCanvas = e.window.document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new e.Texture(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
        }
        destroy() {
          this._terrain && this._terrain.destroy(), this.globeSharedBuffers && this.globeSharedBuffers.destroy(), this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy();
        }
        prepareDrawTile(e2) {
          this.terrain && this.terrain.prepareDrawTile(e2);
        }
        prepareDrawProgram(e2, t2, i3) {
          if (this.terrain && this.terrain.renderingToTexture)
            return;
          const o2 = this.style.fog;
          if (o2) {
            const r2 = o2.getOpacity(this.transform.pitch);
            r2 !== 0 && t2.setFogUniformValues(e2, ((e3, t3, i4, o3) => {
              const r3 = t3.properties.get("color"), n2 = e3.frameCounter / 1e3 % 1, a2 = [r3.r / r3.a, r3.g / r3.a, r3.b / r3.a, o3];
              return { u_fog_matrix: i4 ? e3.transform.calculateFogTileMatrix(i4) : e3.identityMat, u_fog_range: t3.getFovAdjustedRange(e3.transform._fov), u_fog_color: a2, u_fog_horizon_blend: t3.properties.get("horizon-blend"), u_fog_temporal_offset: n2 };
            })(this, o2, i3, r2));
          }
        }
        setTileLoadedFlag(e2) {
          this.tileLoaded = e2;
        }
        saveCanvasCopy() {
          this.frameCopies.push(this.canvasCopy()), this.tileLoaded = false;
        }
        canvasCopy() {
          const e2 = this.context.gl, t2 = e2.createTexture();
          return e2.bindTexture(e2.TEXTURE_2D, t2), e2.copyTexImage2D(e2.TEXTURE_2D, 0, e2.RGBA, 0, 0, e2.drawingBufferWidth, e2.drawingBufferHeight, 0), t2;
        }
        getCanvasCopiesAndTimestamps() {
          return { canvasCopies: this.frameCopies, timeStamps: this.loadTimeStamps };
        }
        averageElevationNeedsEasing() {
          if (!this.transform._elevation)
            return false;
          const e2 = this.style && this.style.fog;
          return !!e2 && e2.getOpacity(this.transform.pitch) !== 0;
        }
        getBackgroundTiles() {
          const t2 = this._backgroundTiles, i3 = this._backgroundTiles = {}, o2 = this.transform.coveringTiles({ tileSize: 512 });
          for (const r2 of o2)
            i3[r2.key] = t2[r2.key] || new e.Tile(r2, 512, this.transform.tileZoom, this);
          return i3;
        }
        clearBackgroundTiles() {
          this._backgroundTiles = {};
        }
      }
      class po {
        constructor(e2 = 0, t2 = 0, i3 = 0, o2 = 0) {
          if (isNaN(e2) || e2 < 0 || isNaN(t2) || t2 < 0 || isNaN(i3) || i3 < 0 || isNaN(o2) || o2 < 0)
            throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
          this.top = e2, this.bottom = t2, this.left = i3, this.right = o2;
        }
        interpolate(t2, i3, o2) {
          return i3.top != null && t2.top != null && (this.top = e.number(t2.top, i3.top, o2)), i3.bottom != null && t2.bottom != null && (this.bottom = e.number(t2.bottom, i3.bottom, o2)), i3.left != null && t2.left != null && (this.left = e.number(t2.left, i3.left, o2)), i3.right != null && t2.right != null && (this.right = e.number(t2.right, i3.right, o2)), this;
        }
        getCenter(t2, i3) {
          const o2 = e.clamp((this.left + t2 - this.right) / 2, 0, t2), r2 = e.clamp((this.top + i3 - this.bottom) / 2, 0, i3);
          return new e.pointGeometry(o2, r2);
        }
        equals(e2) {
          return this.top === e2.top && this.bottom === e2.bottom && this.left === e2.left && this.right === e2.right;
        }
        clone() {
          return new po(this.top, this.bottom, this.left, this.right);
        }
        toJSON() {
          return { top: this.top, bottom: this.bottom, left: this.left, right: this.right };
        }
      }
      function mo(t2, i3) {
        const o2 = e.getColumn(t2, 3);
        e.fromQuat(t2, i3), e.setColumn(t2, 3, o2);
      }
      function fo(t2, i3) {
        e.setColumn(t2, 3, [i3[0], i3[1], i3[2], 1]);
      }
      function go(t2, i3) {
        const o2 = e.identity$1([]);
        return e.rotateZ$1(o2, o2, -i3), e.rotateX$1(o2, o2, -t2), o2;
      }
      function vo(t2, i3) {
        const o2 = [t2[0], t2[1], 0], r2 = [i3[0], i3[1], 0];
        if (e.length(o2) >= 1e-15) {
          const t3 = e.normalize([], o2);
          e.scale$2(r2, t3, e.dot(r2, t3)), i3[0] = r2[0], i3[1] = r2[1];
        }
        const n2 = e.cross([], i3, t2);
        if (e.len(n2) < 1e-15)
          return null;
        const a2 = Math.atan2(-n2[1], n2[0]);
        return go(Math.atan2(Math.sqrt(t2[0] * t2[0] + t2[1] * t2[1]), -t2[2]), a2);
      }
      class xo {
        constructor(e2, t2) {
          this.position = e2, this.orientation = t2;
        }
        get position() {
          return this._position;
        }
        set position(t2) {
          this._position = this._renderWorldCopies ? function(t3) {
            if (!t3)
              return;
            const i3 = Array.isArray(t3) ? new e.MercatorCoordinate(t3[0], t3[1], t3[2]) : t3;
            return i3.x = e.wrap(i3.x, 0, 1), i3;
          }(t2) : t2;
        }
        lookAtPoint(t2, i3) {
          if (this.orientation = null, !this.position)
            return;
          const o2 = this._elevation ? this._elevation.getAtPointOrZero(e.MercatorCoordinate.fromLngLat(t2)) : 0, r2 = this.position, n2 = e.MercatorCoordinate.fromLngLat(t2, o2), a2 = [n2.x - r2.x, n2.y - r2.y, n2.z - r2.z];
          i3 || (i3 = [0, 0, 1]), i3[2] = Math.abs(i3[2]), this.orientation = vo(a2, i3);
        }
        setPitchBearing(t2, i3) {
          this.orientation = go(e.degToRad(t2), e.degToRad(-i3));
        }
      }
      class yo {
        constructor(t2, i3) {
          this._transform = e.identity([]), this._orientation = e.identity$1([]), i3 && (this._orientation = i3, mo(this._transform, this._orientation)), t2 && fo(this._transform, t2);
        }
        get mercatorPosition() {
          const t2 = this.position;
          return new e.MercatorCoordinate(t2[0], t2[1], t2[2]);
        }
        get position() {
          const t2 = e.getColumn(this._transform, 3);
          return [t2[0], t2[1], t2[2]];
        }
        set position(e2) {
          fo(this._transform, e2);
        }
        get orientation() {
          return this._orientation;
        }
        set orientation(e2) {
          this._orientation = e2, mo(this._transform, this._orientation);
        }
        getPitchBearing() {
          const e2 = this.forward(), t2 = this.right();
          return { bearing: Math.atan2(-t2[1], t2[0]), pitch: Math.atan2(Math.sqrt(e2[0] * e2[0] + e2[1] * e2[1]), -e2[2]) };
        }
        setPitchBearing(e2, t2) {
          this._orientation = go(e2, t2), mo(this._transform, this._orientation);
        }
        forward() {
          const t2 = e.getColumn(this._transform, 2);
          return [-t2[0], -t2[1], -t2[2]];
        }
        up() {
          const t2 = e.getColumn(this._transform, 1);
          return [-t2[0], -t2[1], -t2[2]];
        }
        right() {
          const t2 = e.getColumn(this._transform, 0);
          return [t2[0], t2[1], t2[2]];
        }
        getCameraToWorld(t2, i3) {
          const o2 = new Float64Array(16);
          return e.invert(o2, this.getWorldToCamera(t2, i3)), o2;
        }
        getWorldToCameraPosition(t2, i3, o2) {
          const r2 = this.position;
          e.scale$2(r2, r2, -t2);
          const n2 = new Float64Array(16);
          return e.fromScaling(n2, [o2, o2, o2]), e.translate(n2, n2, r2), n2[10] *= i3, n2;
        }
        getWorldToCamera(t2, i3) {
          const o2 = new Float64Array(16), r2 = new Float64Array(4), n2 = this.position;
          return e.conjugate(r2, this._orientation), e.scale$2(n2, n2, -t2), e.fromQuat(o2, r2), e.translate(o2, o2, n2), o2[1] *= -1, o2[5] *= -1, o2[9] *= -1, o2[13] *= -1, o2[8] *= i3, o2[9] *= i3, o2[10] *= i3, o2[11] *= i3, o2;
        }
        getCameraToClipPerspective(t2, i3, o2, r2) {
          const n2 = new Float64Array(16);
          return e.perspective(n2, t2, i3, o2, r2), n2;
        }
        getDistanceToElevation(t2) {
          const i3 = t2 === 0 ? 0 : e.mercatorZfromAltitude(t2, this.position[1]), o2 = this.forward();
          return (i3 - this.position[2]) / o2[2];
        }
        clone() {
          return new yo([...this.position], [...this.orientation]);
        }
      }
      function bo(t2, i3) {
        const o2 = To(t2), r2 = function(t3, i4, o3, r3, n3) {
          const a2 = new e.LngLat(o3.lng - 180 * Eo, o3.lat), s3 = new e.LngLat(o3.lng + 180 * Eo, o3.lat), l2 = t3.project(a2.lng, a2.lat), c2 = t3.project(s3.lng, s3.lat), h2 = -Math.atan2(c2.y - l2.y, c2.x - l2.x), u2 = e.MercatorCoordinate.fromLngLat(o3);
          u2.y = e.clamp(u2.y, -0.999975, 0.999975);
          const _2 = u2.toLngLat(), d2 = t3.project(_2.lng, _2.lat), p2 = e.MercatorCoordinate.fromLngLat(_2);
          p2.x += Eo;
          const m2 = p2.toLngLat(), f2 = t3.project(m2.lng, m2.lat), g2 = Mo(f2.x - d2.x, f2.y - d2.y, h2), v3 = e.MercatorCoordinate.fromLngLat(_2);
          v3.y += Eo;
          const x3 = v3.toLngLat(), y2 = t3.project(x3.lng, x3.lat), b2 = Mo(y2.x - d2.x, y2.y - d2.y, h2), w2 = Math.abs(g2.x) / Math.abs(b2.y), T2 = e.identity([]);
          e.rotateZ(T2, T2, -h2 * (1 - (n3 ? 0 : r3)));
          const E2 = e.identity([]);
          return e.scale(E2, E2, [1, 1 - (1 - w2) * r3, 1]), E2[4] = -b2.x / b2.y * r3, e.rotateZ(E2, E2, h2), e.multiply$1(E2, T2, E2), E2;
        }(t2.projection, 0, t2.center, o2, i3), n2 = wo(t2);
        return e.scale(r2, r2, [n2, n2, 1]), r2;
      }
      function wo(t2) {
        const i3 = t2.projection, o2 = To(t2), r2 = Co(i3, t2.center), n2 = Co(i3, e.LngLat.convert(i3.center));
        return Math.pow(2, r2 * o2 + (1 - o2) * n2);
      }
      function To(t2) {
        const i3 = t2.projection.range;
        if (!i3)
          return 0;
        const o2 = Math.max(t2.width, t2.height), r2 = Math.log(o2 / 1024) / Math.LN2;
        return e.smoothstep(i3[0] + r2, i3[1] + r2, t2.zoom);
      }
      const Eo = 1 / 4e4;
      function Co(t2, i3) {
        const o2 = e.clamp(i3.lat, -e.MAX_MERCATOR_LATITUDE, e.MAX_MERCATOR_LATITUDE), r2 = new e.LngLat(i3.lng - 180 * Eo, o2), n2 = new e.LngLat(i3.lng + 180 * Eo, o2), a2 = t2.project(r2.lng, o2), s3 = t2.project(n2.lng, o2), l2 = e.MercatorCoordinate.fromLngLat(r2), c2 = e.MercatorCoordinate.fromLngLat(n2), h2 = s3.x - a2.x, u2 = s3.y - a2.y, _2 = c2.x - l2.x, d2 = c2.y - l2.y, p2 = Math.sqrt((_2 * _2 + d2 * d2) / (h2 * h2 + u2 * u2));
        return Math.log(p2) / Math.LN2;
      }
      function Mo(e2, t2, i3) {
        const o2 = Math.cos(i3), r2 = Math.sin(i3);
        return { x: e2 * o2 - t2 * r2, y: e2 * r2 + t2 * o2 };
      }
      class So {
        constructor(t2, i3, o2, r2, n2) {
          this.tileSize = 512, this._renderWorldCopies = n2 === void 0 || n2, this._minZoom = t2 || 0, this._maxZoom = i3 || 22, this._minPitch = o2 == null ? 0 : o2, this._maxPitch = r2 == null ? 60 : r2, this.setProjection(), this.setMaxBounds(), this.width = 0, this.height = 0, this._center = new e.LngLat(0, 0), this.zoom = 0, this.angle = 0, this._fov = 0.6435011087932844, this._pitch = 0, this._nearZ = 0, this._farZ = 0, this._unmodified = true, this._edgeInsets = new po(), this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._fogTileMatrixCache = {}, this._distanceTileDataCache = {}, this._camera = new yo(), this._centerAltitude = 0, this._averageElevation = 0, this.cameraElevationReference = "ground", this._projectionScaler = 1, this._horizonShift = 0.1;
        }
        clone() {
          const e2 = new So(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
          return e2.setProjection(this.getProjection()), e2._elevation = this._elevation, e2._centerAltitude = this._centerAltitude, e2.tileSize = this.tileSize, e2.setMaxBounds(this.getMaxBounds()), e2.width = this.width, e2.height = this.height, e2.cameraElevationReference = this.cameraElevationReference, e2._center = this._center, e2._setZoom(this.zoom), e2._cameraZoom = this._cameraZoom, e2.angle = this.angle, e2._fov = this._fov, e2._pitch = this._pitch, e2._nearZ = this._nearZ, e2._farZ = this._farZ, e2._averageElevation = this._averageElevation, e2._unmodified = this._unmodified, e2._edgeInsets = this._edgeInsets.clone(), e2._camera = this._camera.clone(), e2._calcMatrices(), e2.freezeTileCoverage = this.freezeTileCoverage, e2;
        }
        get elevation() {
          return this._elevation;
        }
        set elevation(e2) {
          this._elevation !== e2 && (this._elevation = e2, e2 ? this._updateCenterElevation() && this._updateCameraOnTerrain() : (this._cameraZoom = null, this._centerAltitude = 0), this._calcMatrices());
        }
        updateElevation(e2) {
          this._terrainEnabled() && this._cameraZoom == null && this._updateCenterElevation() && this._updateCameraOnTerrain(), e2 && this._constrainCameraAltitude(), this._calcMatrices();
        }
        getProjection() {
          return e.pick(this.projection, ["name", "center", "parallels"]);
        }
        setProjection(t2) {
          t2 == null && (t2 = { name: "mercator" }), this.projectionOptions = t2;
          const i3 = this.projection ? this.getProjection() : void 0;
          return this.projection = e.getProjection(t2), !n(i3, this.getProjection()) && (this._calcMatrices(), true);
        }
        get minZoom() {
          return this._minZoom;
        }
        set minZoom(e2) {
          this._minZoom !== e2 && (this._minZoom = e2, this.zoom = Math.max(this.zoom, e2));
        }
        get maxZoom() {
          return this._maxZoom;
        }
        set maxZoom(e2) {
          this._maxZoom !== e2 && (this._maxZoom = e2, this.zoom = Math.min(this.zoom, e2));
        }
        get minPitch() {
          return this._minPitch;
        }
        set minPitch(e2) {
          this._minPitch !== e2 && (this._minPitch = e2, this.pitch = Math.max(this.pitch, e2));
        }
        get maxPitch() {
          return this._maxPitch;
        }
        set maxPitch(e2) {
          this._maxPitch !== e2 && (this._maxPitch = e2, this.pitch = Math.min(this.pitch, e2));
        }
        get renderWorldCopies() {
          return this._renderWorldCopies && this.projection.supportsWorldCopies === true;
        }
        set renderWorldCopies(e2) {
          e2 === void 0 ? e2 = true : e2 === null && (e2 = false), this._renderWorldCopies = e2;
        }
        get worldSize() {
          return this.tileSize * this.scale;
        }
        get cameraWorldSize() {
          const e2 = Math.max(this._camera.getDistanceToElevation(this._averageElevation), Number.EPSILON);
          return this._worldSizeFromZoom(this._zoomFromMercatorZ(e2));
        }
        get pixelsPerMeter() {
          return this.projection.pixelsPerMeter(this.center.lat, this.worldSize);
        }
        get cameraPixelsPerMeter() {
          return this.projection.pixelsPerMeter(this.center.lat, this.cameraWorldSize);
        }
        get centerOffset() {
          return this.centerPoint._sub(this.size._div(2));
        }
        get size() {
          return new e.pointGeometry(this.width, this.height);
        }
        get bearing() {
          return e.wrap(this.rotation, -180, 180);
        }
        set bearing(e2) {
          this.rotation = e2;
        }
        get rotation() {
          return -this.angle / Math.PI * 180;
        }
        set rotation(t2) {
          const i3 = -t2 * Math.PI / 180;
          var o2;
          this.angle !== i3 && (this._unmodified = false, this.angle = i3, this._calcMatrices(), this.rotationMatrix = (o2 = new e.ARRAY_TYPE(4), e.ARRAY_TYPE != Float32Array && (o2[1] = 0, o2[2] = 0), o2[0] = 1, o2[3] = 1, o2), function(e2, t3, i4) {
            var o3 = t3[0], r2 = t3[1], n2 = t3[2], a2 = t3[3], s3 = Math.sin(i4), l2 = Math.cos(i4);
            e2[0] = o3 * l2 + n2 * s3, e2[1] = r2 * l2 + a2 * s3, e2[2] = o3 * -s3 + n2 * l2, e2[3] = r2 * -s3 + a2 * l2;
          }(this.rotationMatrix, this.rotationMatrix, this.angle));
        }
        get pitch() {
          return this._pitch / Math.PI * 180;
        }
        set pitch(t2) {
          const i3 = e.clamp(t2, this.minPitch, this.maxPitch) / 180 * Math.PI;
          this._pitch !== i3 && (this._unmodified = false, this._pitch = i3, this._calcMatrices());
        }
        get fov() {
          return this._fov / Math.PI * 180;
        }
        set fov(e2) {
          e2 = Math.max(0.01, Math.min(60, e2)), this._fov !== e2 && (this._unmodified = false, this._fov = e2 / 180 * Math.PI, this._calcMatrices());
        }
        get averageElevation() {
          return this._averageElevation;
        }
        set averageElevation(e2) {
          this._averageElevation = e2, this._calcFogMatrices();
        }
        get zoom() {
          return this._zoom;
        }
        set zoom(e2) {
          const t2 = Math.min(Math.max(e2, this.minZoom), this.maxZoom);
          this._zoom !== t2 && (this._unmodified = false, this._setZoom(t2), this._terrainEnabled() && this._updateCameraOnTerrain(), this._constrain(), this._calcMatrices());
        }
        _setZoom(e2) {
          this._zoom = e2, this.scale = this.zoomScale(e2), this.tileZoom = Math.floor(e2), this.zoomFraction = e2 - this.tileZoom;
        }
        _updateCenterElevation() {
          if (!this._elevation)
            return false;
          const e2 = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center), -1);
          return e2 === -1 ? (this._cameraZoom = null, false) : (this._centerAltitude = e2, true);
        }
        _updateCameraOnTerrain() {
          this._cameraZoom = this._zoomFromMercatorZ((this.pixelsPerMeter * this._centerAltitude + this.cameraToCenterDistance) / this.worldSize);
        }
        sampleAverageElevation() {
          if (!this._elevation)
            return 0;
          const t2 = this._elevation, i3 = [[0.5, 0.2], [0.3, 0.5], [0.5, 0.5], [0.7, 0.5], [0.5, 0.8]], o2 = this.horizonLineFromTop();
          let r2 = 0, n2 = 0;
          for (let a2 = 0; a2 < i3.length; a2++) {
            const s3 = new e.pointGeometry(i3[a2][0] * this.width, o2 + i3[a2][1] * (this.height - o2)), l2 = t2.pointCoordinate(s3);
            if (!l2)
              continue;
            const c2 = 1 / Math.hypot(l2[0] - this._camera.position[0], l2[1] - this._camera.position[1]);
            r2 += l2[3] * c2, n2 += c2;
          }
          return n2 === 0 ? NaN : r2 / n2;
        }
        get center() {
          return this._center;
        }
        set center(e2) {
          e2.lat === this._center.lat && e2.lng === this._center.lng || (this._unmodified = false, this._center = e2, this._terrainEnabled() && (this.cameraElevationReference === "ground" ? this._updateCenterElevation() ? this._updateCameraOnTerrain() : this._cameraZoom = null : this._updateZoomFromElevation()), this._constrain(), this._calcMatrices());
        }
        _updateZoomFromElevation() {
          if (this._cameraZoom == null || !this._elevation)
            return;
          const e2 = this._cameraZoom, t2 = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)), i3 = this.pixelsPerMeter / this.worldSize * t2, o2 = this._mercatorZfromZoom(e2), r2 = this._mercatorZfromZoom(this._maxZoom), n2 = Math.max(o2 - i3, r2);
          this._setZoom(this._zoomFromMercatorZ(n2));
        }
        get padding() {
          return this._edgeInsets.toJSON();
        }
        set padding(e2) {
          this._edgeInsets.equals(e2) || (this._unmodified = false, this._edgeInsets.interpolate(this._edgeInsets, e2, 1), this._calcMatrices());
        }
        computeZoomRelativeTo(t2) {
          const i3 = this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint, t2.toAltitude()));
          let o2;
          o2 = t2.z < this._camera.position[2] ? [i3.x, i3.y, i3.z] : [t2.x, t2.y, t2.z];
          const r2 = e.length(e.sub([], this._camera.position, o2));
          return e.clamp(this._zoomFromMercatorZ(r2), this._minZoom, this._maxZoom);
        }
        setFreeCameraOptions(t2) {
          if (!this.height)
            return;
          if (!t2.position && !t2.orientation)
            return;
          this._updateCameraState();
          let i3 = false;
          if (t2.orientation && !e.exactEquals(t2.orientation, this._camera.orientation) && (i3 = this._setCameraOrientation(t2.orientation)), t2.position) {
            const o2 = [t2.position.x, t2.position.y, t2.position.z];
            e.exactEquals$1(o2, this._camera.position) || (this._setCameraPosition(o2), i3 = true);
          }
          i3 && (this._updateStateFromCamera(), this.recenterOnTerrain());
        }
        getFreeCameraOptions() {
          this._updateCameraState();
          const t2 = this._camera.position, i3 = new xo();
          return i3.position = new e.MercatorCoordinate(t2[0], t2[1], t2[2]), i3.orientation = this._camera.orientation, i3._elevation = this.elevation, i3._renderWorldCopies = this.renderWorldCopies, i3;
        }
        _setCameraOrientation(t2) {
          if (!e.length$1(t2))
            return false;
          e.normalize$1(t2, t2);
          const i3 = e.transformQuat([], [0, 0, -1], t2), o2 = e.transformQuat([], [0, -1, 0], t2);
          if (o2[2] < 0)
            return false;
          const r2 = vo(i3, o2);
          return !!r2 && (this._camera.orientation = r2, true);
        }
        _setCameraPosition(t2) {
          const i3 = this.zoomScale(this.minZoom) * this.tileSize, o2 = this.zoomScale(this.maxZoom) * this.tileSize, r2 = this.cameraToCenterDistance;
          t2[2] = e.clamp(t2[2], r2 / o2, r2 / i3), this._camera.position = t2;
        }
        get centerPoint() {
          return this._edgeInsets.getCenter(this.width, this.height);
        }
        get fovAboveCenter() {
          return this._fov * (0.5 + this.centerOffset.y / this.height);
        }
        isPaddingEqual(e2) {
          return this._edgeInsets.equals(e2);
        }
        interpolatePadding(e2, t2, i3) {
          this._unmodified = false, this._edgeInsets.interpolate(e2, t2, i3), this._constrain(), this._calcMatrices();
        }
        coveringZoomLevel(e2) {
          const t2 = (e2.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / e2.tileSize));
          return Math.max(0, t2);
        }
        getVisibleUnwrappedCoordinates(t2) {
          const i3 = [new e.UnwrappedTileID(0, t2)];
          if (this.renderWorldCopies) {
            const o2 = this.pointCoordinate(new e.pointGeometry(0, 0)), r2 = this.pointCoordinate(new e.pointGeometry(this.width, 0)), n2 = this.pointCoordinate(new e.pointGeometry(this.width, this.height)), a2 = this.pointCoordinate(new e.pointGeometry(0, this.height)), s3 = Math.floor(Math.min(o2.x, r2.x, n2.x, a2.x)), l2 = Math.floor(Math.max(o2.x, r2.x, n2.x, a2.x)), c2 = 1;
            for (let o3 = s3 - c2; o3 <= l2 + c2; o3++)
              o3 !== 0 && i3.push(new e.UnwrappedTileID(o3, t2));
          }
          return i3;
        }
        coveringTiles(t2) {
          let i3 = this.coveringZoomLevel(t2);
          const o2 = i3, r2 = this.elevation && !t2.isTerrainDEM, n2 = this.projection.name === "mercator";
          if (t2.minzoom !== void 0 && i3 < t2.minzoom)
            return [];
          t2.maxzoom !== void 0 && i3 > t2.maxzoom && (i3 = t2.maxzoom);
          const a2 = this.locationCoordinate(this.center), s3 = 1 << i3, l2 = [s3 * a2.x, s3 * a2.y, 0], c2 = e.Frustum.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, i3, this.projection.name !== "globe"), h2 = this.pointCoordinate(this.getCameraPoint()), u2 = s3 * e.mercatorZfromAltitude(1, this.center.lat), _2 = this._camera.position[2] / e.mercatorZfromAltitude(1, this.center.lat), d2 = [s3 * h2.x, s3 * h2.y, _2], p2 = this.cameraToCenterDistance / t2.tileSize * (t2.roundZoom ? 1 : 0.502), m2 = this.pitch <= 60 && this._edgeInsets.top <= this._edgeInsets.bottom && !this._elevation && !this.projection.isReprojectedInTileSpace ? i3 : 0, f2 = t2.isTerrainDEM && this._elevation ? 1e4 * this._elevation.exaggeration() : this._centerAltitude, g2 = t2.isTerrainDEM ? -f2 : this._elevation ? this._elevation.getMinElevationBelowMSL() : 0, v3 = this.projection.isReprojectedInTileSpace ? wo(this) : 1, x3 = (t3) => {
            const i4 = 1 / 4e4, o3 = new e.MercatorCoordinate(t3.x + i4, t3.y, t3.z), r3 = new e.MercatorCoordinate(t3.x, t3.y + i4, t3.z), n3 = t3.toLngLat(), a3 = o3.toLngLat(), s4 = r3.toLngLat(), l3 = this.locationCoordinate(n3), c3 = this.locationCoordinate(a3), h3 = this.locationCoordinate(s4), u3 = Math.hypot(c3.x - l3.x, c3.y - l3.y), _3 = Math.hypot(h3.x - l3.x, h3.y - l3.y);
            return Math.sqrt(u3 * _3) * v3 / i4;
          }, y2 = (t3) => {
            const i4 = f2, o3 = g2;
            return { aabb: e.tileAABB(this, s3, 0, 0, 0, t3, o3, i4, this.projection), zoom: 0, x: 0, y: 0, minZ: o3, maxZ: i4, wrap: t3, fullyVisible: false };
          }, b2 = [];
          let w2 = [];
          const T2 = i3, E2 = t2.reparseOverscaled ? o2 : i3, C2 = (e2) => e2 * e2, M3 = C2((_2 - this._centerAltitude) * u2), S3 = (e2) => {
            if (!this._elevation || !e2.tileID || !n2)
              return;
            const t3 = this._elevation.getMinMaxForTile(e2.tileID), i4 = e2.aabb;
            t3 ? (i4.min[2] = t3.min, i4.max[2] = t3.max, i4.center[2] = (i4.min[2] + i4.max[2]) / 2) : (e2.shouldSplit = I3(e2), e2.shouldSplit || (i4.min[2] = i4.max[2] = i4.center[2] = this._centerAltitude));
          }, I3 = (t3) => {
            if (t3.zoom < m2)
              return true;
            if (t3.zoom === T2)
              return false;
            if (t3.shouldSplit != null)
              return t3.shouldSplit;
            const i4 = t3.aabb.distanceX(d2), n3 = t3.aabb.distanceY(d2);
            let a3 = M3;
            r2 && (a3 = C2(t3.aabb.distanceZ(d2) * u2));
            let s4 = 1;
            if (this.projection.isReprojectedInTileSpace && o2 <= 5) {
              const i5 = Math.pow(2, t3.zoom), o3 = x3(new e.MercatorCoordinate((t3.x + 0.5) / i5, (t3.y + 0.5) / i5));
              s4 = o3 > 0.85 ? 1 : o3;
            }
            const l3 = i4 * i4 + n3 * n3 + a3;
            return l3 < C2((1 << T2 - t3.zoom) * p2 * s4 * ((e2, t4) => {
              if (t4 * C2(0.707) < e2)
                return 1;
              const i5 = Math.sqrt(t4 / e2);
              return i5 / (1.4144271570014144 + (Math.pow(1.1, i5 - 1.4144271570014144 + 1) - 1) / (1.1 - 1) - 1);
            })(Math.max(a3, M3), l3));
          };
          if (this.renderWorldCopies)
            for (let e2 = 1; e2 <= 3; e2++)
              b2.push(y2(-e2)), b2.push(y2(e2));
          for (b2.push(y2(0)); b2.length > 0; ) {
            const o3 = b2.pop(), a3 = o3.x, h3 = o3.y;
            let u3 = o3.fullyVisible;
            if (!u3) {
              const e2 = o3.aabb.intersects(c2);
              if (e2 === 0)
                continue;
              u3 = e2 === 2;
            }
            if (o3.zoom !== T2 && I3(o3))
              for (let t3 = 0; t3 < 4; t3++) {
                const i4 = (a3 << 1) + t3 % 2, l3 = (h3 << 1) + (t3 >> 1), c3 = { aabb: n2 ? o3.aabb.quadrant(t3) : e.tileAABB(this, s3, o3.zoom + 1, i4, l3, o3.wrap, o3.minZ, o3.maxZ, this.projection), zoom: o3.zoom + 1, x: i4, y: l3, wrap: o3.wrap, fullyVisible: u3, tileID: void 0, shouldSplit: void 0, minZ: o3.minZ, maxZ: o3.maxZ };
                r2 && (c3.tileID = new e.OverscaledTileID(o3.zoom + 1 === T2 ? E2 : o3.zoom + 1, o3.wrap, o3.zoom + 1, i4, l3), S3(c3)), b2.push(c3);
              }
            else {
              const r3 = o3.zoom === T2 ? E2 : o3.zoom;
              if (t2.minzoom && t2.minzoom > r3)
                continue;
              const n3 = l2[0] - (0.5 + a3 + (o3.wrap << o3.zoom)) * (1 << i3 - o3.zoom), s4 = l2[1] - 0.5 - h3, c3 = o3.tileID ? o3.tileID : new e.OverscaledTileID(r3, o3.wrap, o3.zoom, a3, h3);
              w2.push({ tileID: c3, distanceSq: n3 * n3 + s4 * s4 });
            }
          }
          if (this.fogCullDistSq) {
            const i4 = this.fogCullDistSq, o3 = this.horizonLineFromTop();
            w2 = w2.filter((r3) => {
              const n3 = [0, 0, 0, 1], a3 = [e.EXTENT, e.EXTENT, 0, 1], s4 = this.calculateFogTileMatrix(r3.tileID.toUnwrapped());
              e.transformMat4$1(n3, n3, s4), e.transformMat4$1(a3, a3, s4);
              const l3 = e.getAABBPointSquareDist(n3, a3);
              if (l3 === 0)
                return true;
              let c3 = false;
              const h3 = this._elevation;
              if (h3 && l3 > i4 && o3 !== 0) {
                const i5 = this.calculateProjMatrix(r3.tileID.toUnwrapped());
                let n4;
                t2.isTerrainDEM || (n4 = h3.getMinMaxForTile(r3.tileID)), n4 || (n4 = { min: g2, max: f2 });
                const a4 = e.furthestTileCorner(this.rotation), s5 = [a4[0] * e.EXTENT, a4[1] * e.EXTENT, n4.max];
                e.transformMat4(s5, s5, i5), c3 = (1 - s5[1]) * this.height * 0.5 < o3;
              }
              return l3 < i4 || c3;
            });
          }
          return w2.sort((e2, t3) => e2.distanceSq - t3.distanceSq).map((e2) => e2.tileID);
        }
        resize(e2, t2) {
          this.width = e2, this.height = t2, this.pixelsToGLUnits = [2 / e2, -2 / t2], this._constrain(), this._calcMatrices();
        }
        get unmodified() {
          return this._unmodified;
        }
        zoomScale(e2) {
          return Math.pow(2, e2);
        }
        scaleZoom(e2) {
          return Math.log(e2) / Math.LN2;
        }
        project(t2) {
          const i3 = e.clamp(t2.lat, -e.MAX_MERCATOR_LATITUDE, e.MAX_MERCATOR_LATITUDE), o2 = this.projection.project(t2.lng, i3);
          return new e.pointGeometry(o2.x * this.worldSize, o2.y * this.worldSize);
        }
        unproject(e2) {
          return this.projection.unproject(e2.x / this.worldSize, e2.y / this.worldSize);
        }
        get point() {
          return this.project(this.center);
        }
        setLocationAtPoint(t2, i3) {
          const o2 = this.pointCoordinate(i3), r2 = this.pointCoordinate(this.centerPoint), n2 = this.locationCoordinate(t2);
          this.setLocation(new e.MercatorCoordinate(n2.x - (o2.x - r2.x), n2.y - (o2.y - r2.y)));
        }
        setLocation(e2) {
          this.center = this.coordinateLocation(e2), this.projection.wrap && (this.center = this.center.wrap());
        }
        locationPoint(e2) {
          return this.projection.locationPoint(this, e2);
        }
        locationPoint3D(e2) {
          return this._coordinatePoint(this.locationCoordinate(e2), true);
        }
        pointLocation(e2) {
          return this.coordinateLocation(this.pointCoordinate(e2));
        }
        pointLocation3D(e2) {
          return this.coordinateLocation(this.pointCoordinate3D(e2));
        }
        locationCoordinate(t2, i3) {
          const o2 = i3 ? e.mercatorZfromAltitude(i3, t2.lat) : void 0, r2 = this.projection.project(t2.lng, t2.lat);
          return new e.MercatorCoordinate(r2.x, r2.y, o2);
        }
        coordinateLocation(e2) {
          return this.projection.unproject(e2.x, e2.y);
        }
        pointRayIntersection(t2, i3) {
          const o2 = i3 != null ? i3 : this._centerAltitude, r2 = [t2.x, t2.y, 0, 1], n2 = [t2.x, t2.y, 1, 1];
          e.transformMat4$1(r2, r2, this.pixelMatrixInverse), e.transformMat4$1(n2, n2, this.pixelMatrixInverse);
          const a2 = n2[3];
          e.scale$1(r2, r2, 1 / r2[3]), e.scale$1(n2, n2, 1 / a2);
          const s3 = r2[2], l2 = n2[2];
          return { p0: r2, p1: n2, t: s3 === l2 ? 0 : (o2 - s3) / (l2 - s3) };
        }
        screenPointToMercatorRay(t2) {
          const i3 = [t2.x, t2.y, 0, 1], o2 = [t2.x, t2.y, 1, 1];
          return e.transformMat4$1(i3, i3, this.pixelMatrixInverse), e.transformMat4$1(o2, o2, this.pixelMatrixInverse), e.scale$1(i3, i3, 1 / i3[3]), e.scale$1(o2, o2, 1 / o2[3]), i3[2] = e.mercatorZfromAltitude(i3[2], this._center.lat) * this.worldSize, o2[2] = e.mercatorZfromAltitude(o2[2], this._center.lat) * this.worldSize, e.scale$1(i3, i3, 1 / this.worldSize), e.scale$1(o2, o2, 1 / this.worldSize), new e.Ray([i3[0], i3[1], i3[2]], e.normalize([], e.sub([], o2, i3)));
        }
        rayIntersectionCoordinate(t2) {
          const { p0: i3, p1: o2, t: r2 } = t2, n2 = e.mercatorZfromAltitude(i3[2], this._center.lat), a2 = e.mercatorZfromAltitude(o2[2], this._center.lat);
          return new e.MercatorCoordinate(e.number(i3[0], o2[0], r2) / this.worldSize, e.number(i3[1], o2[1], r2) / this.worldSize, e.number(n2, a2, r2));
        }
        pointCoordinate(e2, t2 = this._centerAltitude) {
          return this.projection.createTileTransform(this, this.worldSize).pointCoordinate(e2.x, e2.y, t2);
        }
        pointCoordinate3D(t2) {
          if (!this.elevation)
            return this.pointCoordinate(t2);
          const i3 = this.elevation;
          let o2 = this.elevation.pointCoordinate(t2);
          if (o2)
            return new e.MercatorCoordinate(o2[0], o2[1], o2[2]);
          let r2 = 0, n2 = this.horizonLineFromTop();
          if (t2.y > n2)
            return this.pointCoordinate(t2);
          const a2 = 0.02 * n2, s3 = t2.clone();
          for (let t3 = 0; t3 < 10 && n2 - r2 > a2; t3++) {
            s3.y = e.number(r2, n2, 0.66);
            const t4 = i3.pointCoordinate(s3);
            t4 ? (n2 = s3.y, o2 = t4) : r2 = s3.y;
          }
          return o2 ? new e.MercatorCoordinate(o2[0], o2[1], o2[2]) : this.pointCoordinate(t2);
        }
        isPointAboveHorizon(e2) {
          if (this.elevation)
            return !this.elevation.pointCoordinate(e2);
          {
            const t2 = this.horizonLineFromTop();
            return e2.y < t2;
          }
        }
        _coordinatePoint(t2, i3) {
          const o2 = i3 && this.elevation ? this.elevation.getAtPointOrZero(t2, this._centerAltitude) : this._centerAltitude, r2 = [t2.x * this.worldSize, t2.y * this.worldSize, o2 + t2.toAltitude(), 1];
          return e.transformMat4$1(r2, r2, this.pixelMatrix), r2[3] > 0 ? new e.pointGeometry(r2[0] / r2[3], r2[1] / r2[3]) : new e.pointGeometry(Number.MAX_VALUE, Number.MAX_VALUE);
        }
        _getBounds(t2, i3) {
          const o2 = new e.pointGeometry(this._edgeInsets.left, this._edgeInsets.top), r2 = new e.pointGeometry(this.width - this._edgeInsets.right, this._edgeInsets.top), n2 = new e.pointGeometry(this.width - this._edgeInsets.right, this.height - this._edgeInsets.bottom), a2 = new e.pointGeometry(this._edgeInsets.left, this.height - this._edgeInsets.bottom);
          let s3 = this.pointCoordinate(o2, t2), l2 = this.pointCoordinate(r2, t2);
          const c2 = this.pointCoordinate(n2, i3), h2 = this.pointCoordinate(a2, i3), u2 = (e2, t3) => (t3.y - e2.y) / (t3.x - e2.x);
          return s3.y > 1 && l2.y >= 0 ? s3 = new e.MercatorCoordinate((1 - h2.y) / u2(h2, s3) + h2.x, 1) : s3.y < 0 && l2.y <= 1 && (s3 = new e.MercatorCoordinate(-h2.y / u2(h2, s3) + h2.x, 0)), l2.y > 1 && s3.y >= 0 ? l2 = new e.MercatorCoordinate((1 - c2.y) / u2(c2, l2) + c2.x, 1) : l2.y < 0 && s3.y <= 1 && (l2 = new e.MercatorCoordinate(-c2.y / u2(c2, l2) + c2.x, 0)), new e.LngLatBounds().extend(this.coordinateLocation(s3)).extend(this.coordinateLocation(l2)).extend(this.coordinateLocation(h2)).extend(this.coordinateLocation(c2));
        }
        _getBounds3D() {
          const e2 = this.elevation;
          if (!e2.visibleDemTiles.length)
            return this._getBounds(0, 0);
          const t2 = e2.visibleDemTiles.reduce((e3, t3) => {
            if (t3.dem) {
              const i3 = t3.dem.tree;
              e3.min = Math.min(e3.min, i3.minimums[0]), e3.max = Math.max(e3.max, i3.maximums[0]);
            }
            return e3;
          }, { min: Number.MAX_VALUE, max: 0 });
          return this._getBounds(t2.min * e2.exaggeration(), t2.max * e2.exaggeration());
        }
        getBounds() {
          return this._terrainEnabled() ? this._getBounds3D() : this._getBounds(0, 0);
        }
        horizonLineFromTop(e2 = true) {
          const t2 = this.height / 2 / Math.tan(this._fov / 2) / Math.tan(Math.max(this._pitch, 0.1)) + this.centerOffset.y, i3 = this.height / 2 - t2 * (1 - this._horizonShift);
          return e2 ? Math.max(0, i3) : i3;
        }
        getMaxBounds() {
          return this.maxBounds;
        }
        setMaxBounds(t2) {
          this.maxBounds = t2, this.minLat = -e.MAX_MERCATOR_LATITUDE, this.maxLat = e.MAX_MERCATOR_LATITUDE, this.minLng = -180, this.maxLng = 180, t2 && (this.minLat = t2.getSouth(), this.maxLat = t2.getNorth(), this.minLng = t2.getWest(), this.maxLng = t2.getEast(), this.maxLng < this.minLng && (this.maxLng += 360)), this.worldMinX = e.mercatorXfromLng(this.minLng) * this.tileSize, this.worldMaxX = e.mercatorXfromLng(this.maxLng) * this.tileSize, this.worldMinY = e.mercatorYfromLat(this.maxLat) * this.tileSize, this.worldMaxY = e.mercatorYfromLat(this.minLat) * this.tileSize, this._constrain();
        }
        calculatePosMatrix(e2, t2) {
          return this.projection.createTileTransform(this, t2).createTileMatrix(e2);
        }
        calculateDistanceTileData(t2) {
          const i3 = t2.key, o2 = this._distanceTileDataCache;
          if (o2[i3])
            return o2[i3];
          const r2 = t2.canonical, n2 = 1 / this.height, a2 = this.cameraWorldSize / this.zoomScale(r2.z), s3 = (r2.x + Math.pow(2, r2.z) * t2.wrap) * a2, l2 = r2.y * a2, c2 = this.point, h2 = this.angle, u2 = Math.sin(-h2), _2 = -Math.cos(-h2);
          return o2[i3] = { bearing: [u2, _2], center: [(c2.x - s3) * n2, (c2.y - l2) * n2], scale: a2 / e.EXTENT * n2 }, o2[i3];
        }
        calculateFogTileMatrix(t2) {
          const i3 = t2.key, o2 = this._fogTileMatrixCache;
          if (o2[i3])
            return o2[i3];
          const r2 = this.calculatePosMatrix(t2, this.cameraWorldSize);
          return e.multiply$1(r2, this.worldToFogMatrix, r2), o2[i3] = new Float32Array(r2), o2[i3];
        }
        calculateProjMatrix(t2, i3 = false) {
          const o2 = t2.key, r2 = i3 ? this._alignedProjMatrixCache : this._projMatrixCache;
          if (r2[o2])
            return r2[o2];
          const n2 = this.calculatePosMatrix(t2, this.worldSize);
          return e.multiply$1(n2, this.projection.isReprojectedInTileSpace ? this.mercatorMatrix : i3 ? this.alignedProjMatrix : this.projMatrix, n2), r2[o2] = new Float32Array(n2), r2[o2];
        }
        calculatePixelsToTileUnitsMatrix(t2) {
          const i3 = t2.tileID.key, o2 = this._pixelsToTileUnitsCache;
          if (o2[i3])
            return o2[i3];
          const r2 = function(t3, i4) {
            const { scale: o3 } = t3.tileTransform, r3 = o3 * e.EXTENT / (t3.tileSize * Math.pow(2, i4.zoom - t3.tileID.overscaledZ + t3.tileID.canonical.z));
            return n2 = new Float32Array(4), l2 = (a2 = i4.inverseAdjustmentMatrix)[1], c2 = a2[2], h2 = a2[3], _2 = (s3 = [r3, r3])[1], n2[0] = a2[0] * (u2 = s3[0]), n2[1] = l2 * u2, n2[2] = c2 * _2, n2[3] = h2 * _2, n2;
            var n2, a2, s3, l2, c2, h2, u2, _2;
          }(t2, this);
          return o2[i3] = r2, o2[i3];
        }
        customLayerMatrix() {
          return this.mercatorMatrix.slice();
        }
        recenterOnTerrain() {
          if (!this._elevation)
            return;
          const t2 = this._elevation;
          this._updateCameraState();
          const i3 = e.mercatorZfromAltitude(1, this._center.lat) * this.worldSize, o2 = this._computeCameraPosition(i3), r2 = this._camera.forward(), n2 = e.mercatorZfromAltitude(1, this._center.lat);
          o2[2] /= n2, r2[2] /= n2, e.normalize(r2, r2);
          const a2 = t2.raycast(o2, r2, t2.exaggeration());
          if (a2) {
            const t3 = e.scaleAndAdd([], o2, r2, a2), i4 = new e.MercatorCoordinate(t3[0], t3[1], e.mercatorZfromAltitude(t3[2], e.latFromMercatorY(t3[1]))), s3 = (i4.z + e.length([i4.x - o2[0], i4.y - o2[1], i4.z - o2[2] * n2])) * this._projectionScaler;
            this._cameraZoom = this._zoomFromMercatorZ(s3), this._centerAltitude = i4.toAltitude(), this._center = this.coordinateLocation(i4), this._updateZoomFromElevation(), this._constrain(), this._calcMatrices();
          }
        }
        _constrainCameraAltitude() {
          if (!this._elevation)
            return;
          const t2 = this._elevation;
          this._updateCameraState();
          const i3 = e.mercatorZfromAltitude(1, this._center.lat) * this.worldSize, o2 = this._computeCameraPosition(i3), r2 = t2.getAtPointOrZero(new e.MercatorCoordinate(...o2)), n2 = this._minimumHeightOverTerrain() * Math.cos(e.degToRad(this._maxPitch)), a2 = this._camera.position[2] - this.pixelsPerMeter / this.worldSize * r2;
          if (a2 < n2) {
            const t3 = this.locationCoordinate(this._center, this._centerAltitude), i4 = [t3.x - o2[0], t3.y - o2[1], t3.z - o2[2]], r3 = e.length(i4);
            i4[2] -= (n2 - a2) / this._projectionScaler;
            const s3 = e.length(i4);
            if (s3 === 0)
              return;
            e.scale$2(i4, i4, r3 / s3 * this._projectionScaler), this._camera.position = [t3.x - i4[0], t3.y - i4[1], t3.z * this._projectionScaler - i4[2]], this._camera.orientation = vo(i4, this._camera.up()), this._updateStateFromCamera();
          }
        }
        _constrain() {
          if (!this.center || !this.width || !this.height || this._constraining)
            return;
          if (this._constraining = true, this.projection.isReprojectedInTileSpace) {
            const t3 = this.center;
            return t3.lat = e.clamp(t3.lat, this.minLat, this.maxLat), !this.maxBounds && this.renderWorldCopies || (t3.lng = e.clamp(t3.lng, this.minLng, this.maxLng)), this.center = t3, void (this._constraining = false);
          }
          const t2 = this._unmodified, { x: i3, y: o2 } = this.point;
          let r2 = 0, n2 = i3, a2 = o2;
          const s3 = this.width / 2, l2 = this.height / 2, c2 = this.worldMinY * this.scale, h2 = this.worldMaxY * this.scale;
          if (o2 - l2 < c2 && (a2 = c2 + l2), o2 + l2 > h2 && (a2 = h2 - l2), h2 - c2 < this.height && (r2 = Math.max(r2, this.height / (h2 - c2)), a2 = (h2 + c2) / 2), this.maxBounds || !this._renderWorldCopies || !this.projection.wrap) {
            const e2 = this.worldMinX * this.scale, t3 = this.worldMaxX * this.scale, o3 = this.worldSize / 2 - (e2 + t3) / 2;
            n2 = (i3 + o3 + this.worldSize) % this.worldSize - o3, n2 - s3 < e2 && (n2 = e2 + s3), n2 + s3 > t3 && (n2 = t3 - s3), t3 - e2 < this.width && (r2 = Math.max(r2, this.width / (t3 - e2)), n2 = (t3 + e2) / 2);
          }
          n2 === i3 && a2 === o2 || (this.center = this.unproject(new e.pointGeometry(n2, a2))), r2 && (this.zoom += this.scaleZoom(r2)), this._constrainCameraAltitude(), this._unmodified = t2, this._constraining = false;
        }
        _minZoomForBounds() {
          let e2 = Math.max(0, this.scaleZoom(this.height / (this.worldMaxY - this.worldMinY)));
          return this.maxBounds && (e2 = Math.max(e2, this.scaleZoom(this.width / (this.worldMaxX - this.worldMinX)))), e2;
        }
        _maxCameraBoundsDistance() {
          return this._mercatorZfromZoom(this._minZoomForBounds());
        }
        _calcMatrices() {
          if (!this.height)
            return;
          const t2 = this._fov / 2, i3 = this.centerOffset, o2 = this.pixelsPerMeter;
          this._projectionScaler = o2 / (e.mercatorZfromAltitude(1, this.center.lat) * this.worldSize), this.cameraToCenterDistance = 0.5 / Math.tan(t2) * this.height * this._projectionScaler, this._updateCameraState(), this._farZ = this.projection.farthestPixelDistance(this), this._nearZ = this.height / 50;
          const n2 = this._camera.getWorldToCamera(this.worldSize, this.projection.zAxisUnit === "meters" ? o2 : 1), a2 = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, this._farZ);
          a2[8] = 2 * -i3.x / this.width, a2[9] = 2 * i3.y / this.height;
          let s3 = e.mul([], a2, n2);
          if (this.projection.isReprojectedInTileSpace) {
            const t3 = this.locationCoordinate(this.center), i4 = e.identity([]);
            e.translate(i4, i4, [t3.x * this.worldSize, t3.y * this.worldSize, 0]), e.multiply$1(i4, i4, bo(this)), e.translate(i4, i4, [-t3.x * this.worldSize, -t3.y * this.worldSize, 0]), e.multiply$1(s3, s3, i4), this.inverseAdjustmentMatrix = function(e2) {
              const t4 = bo(e2, true);
              return r([], [t4[0], t4[1], t4[4], t4[5]]);
            }(this);
          } else
            this.inverseAdjustmentMatrix = [1, 0, 0, 1];
          this.mercatorMatrix = e.scale([], s3, [this.worldSize, this.worldSize, this.worldSize / o2, 1]), this.projMatrix = s3, this.invProjMatrix = e.invert(new Float64Array(16), this.projMatrix);
          const l2 = new Float32Array(16);
          e.identity(l2), e.scale(l2, l2, [1, -1, 1]), e.rotateX(l2, l2, this._pitch), e.rotateZ(l2, l2, this.angle);
          const c2 = e.perspective(new Float32Array(16), this._fov, this.width / this.height, this._nearZ, this._farZ), h2 = (Math.PI / 2 - this._pitch) * (this.height / this._fov) * this._horizonShift;
          c2[8] = 2 * -i3.x / this.width, c2[9] = 2 * (i3.y + h2) / this.height, this.skyboxMatrix = e.multiply$1(l2, c2, l2);
          const u2 = this.point, _2 = u2.x, d2 = u2.y, p2 = this.width % 2 / 2, m2 = this.height % 2 / 2, f2 = Math.cos(this.angle), g2 = Math.sin(this.angle), v3 = _2 - Math.round(_2) + f2 * p2 + g2 * m2, x3 = d2 - Math.round(d2) + f2 * m2 + g2 * p2, y2 = new Float64Array(s3);
          if (e.translate(y2, y2, [v3 > 0.5 ? v3 - 1 : v3, x3 > 0.5 ? x3 - 1 : x3, 0]), this.alignedProjMatrix = y2, s3 = e.create(), e.scale(s3, s3, [this.width / 2, -this.height / 2, 1]), e.translate(s3, s3, [1, -1, 0]), this.labelPlaneMatrix = s3, s3 = e.create(), e.scale(s3, s3, [1, -1, 1]), e.translate(s3, s3, [-1, -1, 0]), e.scale(s3, s3, [2 / this.width, 2 / this.height, 1]), this.glCoordMatrix = s3, this.pixelMatrix = e.multiply$1(new Float64Array(16), this.labelPlaneMatrix, this.projMatrix), this._calcFogMatrices(), this._distanceTileDataCache = {}, s3 = e.invert(new Float64Array(16), this.pixelMatrix), !s3)
            throw new Error("failed to invert matrix");
          this.pixelMatrixInverse = s3, this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._pixelsToTileUnitsCache = {};
        }
        _calcFogMatrices() {
          this._fogTileMatrixCache = {};
          const t2 = this.cameraWorldSize, i3 = this.cameraPixelsPerMeter, o2 = this._camera.position, r2 = 1 / this.height, n2 = [t2, t2, i3];
          e.scale$2(n2, n2, r2), e.scale$2(o2, o2, -1), e.multiply$2(o2, o2, n2);
          const a2 = e.create();
          e.translate(a2, a2, o2), e.scale(a2, a2, n2), this.mercatorFogMatrix = a2, this.worldToFogMatrix = this._camera.getWorldToCameraPosition(t2, i3, r2);
        }
        _computeCameraPosition(e2) {
          const t2 = (e2 = e2 || this.pixelsPerMeter) / this.pixelsPerMeter, i3 = this._camera.forward(), o2 = this.point, r2 = this._mercatorZfromZoom(this._cameraZoom ? this._cameraZoom : this._zoom) * t2 - e2 / this.worldSize * this._centerAltitude;
          return [o2.x / this.worldSize - i3[0] * r2, o2.y / this.worldSize - i3[1] * r2, e2 / this.worldSize * this._centerAltitude - i3[2] * r2];
        }
        _updateCameraState() {
          this.height && (this._camera.setPitchBearing(this._pitch, this.angle), this._camera.position = this._computeCameraPosition());
        }
        _translateCameraConstrained(t2) {
          const i3 = this._maxCameraBoundsDistance() * Math.cos(this._pitch), o2 = t2[2];
          let r2 = 1;
          o2 > 0 && (r2 = Math.min((i3 - this._camera.position[2]) / o2, 1)), this._camera.position = e.scaleAndAdd([], this._camera.position, t2, r2), this._updateStateFromCamera();
        }
        _updateStateFromCamera() {
          const t2 = this._camera.position, i3 = this._camera.forward(), { pitch: o2, bearing: r2 } = this._camera.getPitchBearing(), n2 = e.mercatorZfromAltitude(this._centerAltitude, this.center.lat) * this._projectionScaler, a2 = this._mercatorZfromZoom(this._maxZoom) * Math.cos(e.degToRad(this._maxPitch)), s3 = Math.max((t2[2] - n2) / Math.cos(o2), a2), l2 = this._zoomFromMercatorZ(s3);
          e.scaleAndAdd(t2, t2, i3, s3), this._pitch = e.clamp(o2, e.degToRad(this.minPitch), e.degToRad(this.maxPitch)), this.angle = e.wrap(r2, -Math.PI, Math.PI), this._setZoom(e.clamp(l2, this._minZoom, this._maxZoom)), this._terrainEnabled() && this._updateCameraOnTerrain(), this._center = this.coordinateLocation(new e.MercatorCoordinate(t2[0], t2[1], t2[2])), this._unmodified = false, this._constrain(), this._calcMatrices();
        }
        _worldSizeFromZoom(e2) {
          return Math.pow(2, e2) * this.tileSize;
        }
        _mercatorZfromZoom(e2) {
          return this.cameraToCenterDistance / this._worldSizeFromZoom(e2);
        }
        _minimumHeightOverTerrain() {
          const e2 = Math.min((this._cameraZoom != null ? this._cameraZoom : this._zoom) + 2, this._maxZoom);
          return this._mercatorZfromZoom(e2);
        }
        _zoomFromMercatorZ(e2) {
          return this.scaleZoom(this.cameraToCenterDistance / (e2 * this.tileSize));
        }
        _terrainEnabled() {
          return !(!this._elevation || !this.projection.supportsTerrain && (e.warnOnce("Terrain is not yet supported with alternate projections. Use mercator to enable terrain."), 1));
        }
        anyCornerOffEdge(t2, i3) {
          const o2 = Math.min(t2.x, i3.x), r2 = Math.max(t2.x, i3.x), n2 = Math.min(t2.y, i3.y), a2 = Math.max(t2.y, i3.y);
          if (n2 < this.horizonLineFromTop(false))
            return true;
          if (this.projection.name !== "mercator")
            return false;
          const s3 = [new e.pointGeometry(o2, n2), new e.pointGeometry(r2, a2), new e.pointGeometry(o2, a2), new e.pointGeometry(r2, n2)], l2 = this.renderWorldCopies ? -3 : 0, c2 = this.renderWorldCopies ? 4 : 1;
          for (const e2 of s3) {
            const t3 = this.pointRayIntersection(e2);
            if (t3.t < 0)
              return true;
            const i4 = this.rayIntersectionCoordinate(t3);
            if (i4.x < l2 || i4.y < 0 || i4.x > c2 || i4.y > 1)
              return true;
          }
          return false;
        }
        isHorizonVisible() {
          return this.pitch + e.radToDeg(this.fovAboveCenter) > 88 || this.anyCornerOffEdge(new e.pointGeometry(0, 0), new e.pointGeometry(this.width, this.height));
        }
        zoomDeltaToMovement(t2, i3) {
          const o2 = e.length(e.sub([], this._camera.position, t2)), r2 = this._zoomFromMercatorZ(o2) + i3;
          return o2 - this._mercatorZfromZoom(r2);
        }
        getCameraPoint() {
          const t2 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
          return this.centerPoint.add(new e.pointGeometry(0, t2));
        }
      }
      function Io(e2, t2) {
        let i3 = false, o2 = null;
        const r2 = () => {
          o2 = null, i3 && (e2(), o2 = setTimeout(r2, t2), i3 = false);
        };
        return () => (i3 = true, o2 || r2(), o2);
      }
      class zo {
        constructor(t2) {
          this._hashName = t2 && encodeURIComponent(t2), e.bindAll(["_getCurrentHash", "_onHashChange", "_updateHash"], this), this._updateHash = Io(this._updateHashUnthrottled.bind(this), 300);
        }
        addTo(t2) {
          return this._map = t2, e.window.addEventListener("hashchange", this._onHashChange, false), this._map.on("moveend", this._updateHash), this;
        }
        remove() {
          return e.window.removeEventListener("hashchange", this._onHashChange, false), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), delete this._map, this;
        }
        getHashString(t2) {
          const i3 = this._map.getCenter(), o2 = Math.round(100 * this._map.getZoom()) / 100, r2 = Math.ceil((o2 * Math.LN2 + Math.log(512 / 360 / 0.5)) / Math.LN10), n2 = Math.pow(10, r2), a2 = Math.round(i3.lng * n2) / n2, s3 = Math.round(i3.lat * n2) / n2, l2 = this._map.getBearing(), c2 = this._map.getPitch();
          let h2 = "";
          if (h2 += t2 ? `/${a2}/${s3}/${o2}` : `${o2}/${s3}/${a2}`, (l2 || c2) && (h2 += "/" + Math.round(10 * l2) / 10), c2 && (h2 += `/${Math.round(c2)}`), this._hashName) {
            const t3 = this._hashName;
            let i4 = false;
            const o3 = e.window.location.hash.slice(1).split("&").map((e2) => {
              const o4 = e2.split("=")[0];
              return o4 === t3 ? (i4 = true, `${o4}=${h2}`) : e2;
            }).filter((e2) => e2);
            return i4 || o3.push(`${t3}=${h2}`), `#${o3.join("&")}`;
          }
          return `#${h2}`;
        }
        _getCurrentHash() {
          const t2 = e.window.location.hash.replace("#", "");
          if (this._hashName) {
            let e2;
            return t2.split("&").map((e3) => e3.split("=")).forEach((t3) => {
              t3[0] === this._hashName && (e2 = t3);
            }), (e2 && e2[1] || "").split("/");
          }
          return t2.split("/");
        }
        _onHashChange() {
          const e2 = this._getCurrentHash();
          if (e2.length >= 3 && !e2.some((e3) => isNaN(e3))) {
            const t2 = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(e2[3] || 0) : this._map.getBearing();
            return this._map.jumpTo({ center: [+e2[2], +e2[1]], zoom: +e2[0], bearing: t2, pitch: +(e2[4] || 0) }), true;
          }
          return false;
        }
        _updateHashUnthrottled() {
          const t2 = e.window.location.href.replace(/(#.+)?$/, this.getHashString());
          e.window.history.replaceState(e.window.history.state, null, t2);
        }
      }
      const Do = { linearity: 0.3, easing: e.bezier(0, 0, 0.3, 1) }, Po = e.extend({ deceleration: 2500, maxSpeed: 1400 }, Do), Ao = e.extend({ deceleration: 20, maxSpeed: 1400 }, Do), Lo = e.extend({ deceleration: 1e3, maxSpeed: 360 }, Do), Ro = e.extend({ deceleration: 1e3, maxSpeed: 90 }, Do);
      class ko {
        constructor(e2) {
          this._map = e2, this.clear();
        }
        clear() {
          this._inertiaBuffer = [];
        }
        record(t2) {
          this._drainInertiaBuffer(), this._inertiaBuffer.push({ time: e.exported.now(), settings: t2 });
        }
        _drainInertiaBuffer() {
          const t2 = this._inertiaBuffer, i3 = e.exported.now();
          for (; t2.length > 0 && i3 - t2[0].time > 160; )
            t2.shift();
        }
        _onMoveEnd(t2) {
          if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2)
            return;
          const i3 = { zoom: 0, bearing: 0, pitch: 0, pan: new e.pointGeometry(0, 0), pinchAround: void 0, around: void 0 };
          for (const { settings: e2 } of this._inertiaBuffer)
            i3.zoom += e2.zoomDelta || 0, i3.bearing += e2.bearingDelta || 0, i3.pitch += e2.pitchDelta || 0, e2.panDelta && i3.pan._add(e2.panDelta), e2.around && (i3.around = e2.around), e2.pinchAround && (i3.pinchAround = e2.pinchAround);
          const o2 = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, r2 = {};
          if (i3.pan.mag()) {
            const n2 = Bo(i3.pan.mag(), o2, e.extend({}, Po, t2 || {}));
            r2.offset = i3.pan.mult(n2.amount / i3.pan.mag()), r2.center = this._map.transform.center, Oo(r2, n2);
          }
          if (i3.zoom) {
            const e2 = Bo(i3.zoom, o2, Ao);
            r2.zoom = this._map.transform.zoom + e2.amount, Oo(r2, e2);
          }
          if (i3.bearing) {
            const t3 = Bo(i3.bearing, o2, Lo);
            r2.bearing = this._map.transform.bearing + e.clamp(t3.amount, -179, 179), Oo(r2, t3);
          }
          if (i3.pitch) {
            const e2 = Bo(i3.pitch, o2, Ro);
            r2.pitch = this._map.transform.pitch + e2.amount, Oo(r2, e2);
          }
          if (r2.zoom || r2.bearing) {
            const e2 = i3.pinchAround === void 0 ? i3.around : i3.pinchAround;
            r2.around = e2 ? this._map.unproject(e2) : this._map.getCenter();
          }
          return this.clear(), e.extend(r2, { noMoveStart: true });
        }
      }
      function Oo(e2, t2) {
        (!e2.duration || e2.duration < t2.duration) && (e2.duration = t2.duration, e2.easing = t2.easing);
      }
      function Bo(t2, i3, o2) {
        const { maxSpeed: r2, linearity: n2, deceleration: a2 } = o2, s3 = e.clamp(t2 * n2 / (i3 / 1e3), -r2, r2), l2 = Math.abs(s3) / (a2 * n2);
        return { easing: o2.easing, duration: 1e3 * l2, amount: s3 * (l2 / 2) };
      }
      class Fo extends e.Event {
        preventDefault() {
          this._defaultPrevented = true;
        }
        get defaultPrevented() {
          return this._defaultPrevented;
        }
        constructor(t2, i3, o2, r2 = {}) {
          const n2 = a.mousePos(i3.getCanvasContainer(), o2), s3 = i3.unproject(n2);
          super(t2, e.extend({ point: n2, lngLat: s3, originalEvent: o2 }, r2)), this._defaultPrevented = false, this.target = i3;
        }
      }
      class Uo extends e.Event {
        preventDefault() {
          this._defaultPrevented = true;
        }
        get defaultPrevented() {
          return this._defaultPrevented;
        }
        constructor(t2, i3, o2) {
          const r2 = t2 === "touchend" ? o2.changedTouches : o2.touches, n2 = a.touchPos(i3.getCanvasContainer(), r2), s3 = n2.map((e2) => i3.unproject(e2)), l2 = n2.reduce((e2, t3, i4, o3) => e2.add(t3.div(o3.length)), new e.pointGeometry(0, 0));
          super(t2, { points: n2, point: l2, lngLats: s3, lngLat: i3.unproject(l2), originalEvent: o2 }), this._defaultPrevented = false;
        }
      }
      class No extends e.Event {
        preventDefault() {
          this._defaultPrevented = true;
        }
        get defaultPrevented() {
          return this._defaultPrevented;
        }
        constructor(e2, t2, i3) {
          super(e2, { originalEvent: i3 }), this._defaultPrevented = false;
        }
      }
      class Go {
        constructor(e2, t2) {
          this._map = e2, this._clickTolerance = t2.clickTolerance;
        }
        reset() {
          delete this._mousedownPos;
        }
        wheel(e2) {
          return this._firePreventable(new No(e2.type, this._map, e2));
        }
        mousedown(e2, t2) {
          return this._mousedownPos = t2, this._firePreventable(new Fo(e2.type, this._map, e2));
        }
        mouseup(e2) {
          this._map.fire(new Fo(e2.type, this._map, e2));
        }
        preclick(t2) {
          const i3 = e.extend({}, t2);
          i3.type = "preclick", this._map.fire(new Fo(i3.type, this._map, i3));
        }
        click(e2, t2) {
          this._mousedownPos && this._mousedownPos.dist(t2) >= this._clickTolerance || (this.preclick(e2), this._map.fire(new Fo(e2.type, this._map, e2)));
        }
        dblclick(e2) {
          return this._firePreventable(new Fo(e2.type, this._map, e2));
        }
        mouseover(e2) {
          this._map.fire(new Fo(e2.type, this._map, e2));
        }
        mouseout(e2) {
          this._map.fire(new Fo(e2.type, this._map, e2));
        }
        touchstart(e2) {
          return this._firePreventable(new Uo(e2.type, this._map, e2));
        }
        touchmove(e2) {
          this._map.fire(new Uo(e2.type, this._map, e2));
        }
        touchend(e2) {
          this._map.fire(new Uo(e2.type, this._map, e2));
        }
        touchcancel(e2) {
          this._map.fire(new Uo(e2.type, this._map, e2));
        }
        _firePreventable(e2) {
          if (this._map.fire(e2), e2.defaultPrevented)
            return {};
        }
        isEnabled() {
          return true;
        }
        isActive() {
          return false;
        }
        enable() {
        }
        disable() {
        }
      }
      class jo {
        constructor(e2) {
          this._map = e2;
        }
        reset() {
          this._delayContextMenu = false, delete this._contextMenuEvent;
        }
        mousemove(e2) {
          this._map.fire(new Fo(e2.type, this._map, e2));
        }
        mousedown() {
          this._delayContextMenu = true;
        }
        mouseup() {
          this._delayContextMenu = false, this._contextMenuEvent && (this._map.fire(new Fo("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
        }
        contextmenu(e2) {
          this._delayContextMenu ? this._contextMenuEvent = e2 : this._map.fire(new Fo(e2.type, this._map, e2)), this._map.listens("contextmenu") && e2.preventDefault();
        }
        isEnabled() {
          return true;
        }
        isActive() {
          return false;
        }
        enable() {
        }
        disable() {
        }
      }
      class Zo {
        constructor(e2, t2) {
          this._map = e2, this._el = e2.getCanvasContainer(), this._container = e2.getContainer(), this._clickTolerance = t2.clickTolerance || 1;
        }
        isEnabled() {
          return !!this._enabled;
        }
        isActive() {
          return !!this._active;
        }
        enable() {
          this.isEnabled() || (this._enabled = true);
        }
        disable() {
          this.isEnabled() && (this._enabled = false);
        }
        mousedown(e2, t2) {
          this.isEnabled() && e2.shiftKey && e2.button === 0 && (a.disableDrag(), this._startPos = this._lastPos = t2, this._active = true);
        }
        mousemoveWindow(e2, t2) {
          if (!this._active)
            return;
          const i3 = t2;
          if (this._lastPos.equals(i3) || !this._box && i3.dist(this._startPos) < this._clickTolerance)
            return;
          const o2 = this._startPos;
          this._lastPos = i3, this._box || (this._box = a.create("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", e2));
          const r2 = Math.min(o2.x, i3.x), n2 = Math.max(o2.x, i3.x), s3 = Math.min(o2.y, i3.y), l2 = Math.max(o2.y, i3.y);
          this._map._requestDomTask(() => {
            this._box && (this._box.style.transform = `translate(${r2}px,${s3}px)`, this._box.style.width = n2 - r2 + "px", this._box.style.height = l2 - s3 + "px");
          });
        }
        mouseupWindow(t2, i3) {
          if (!this._active)
            return;
          if (t2.button !== 0)
            return;
          const o2 = this._startPos, r2 = i3;
          if (this.reset(), a.suppressClick(), o2.x !== r2.x || o2.y !== r2.y)
            return this._map.fire(new e.Event("boxzoomend", { originalEvent: t2 })), { cameraAnimation: (e2) => e2.fitScreenCoordinates(o2, r2, this._map.getBearing(), { linear: false }) };
          this._fireEvent("boxzoomcancel", t2);
        }
        keydown(e2) {
          this._active && e2.keyCode === 27 && (this.reset(), this._fireEvent("boxzoomcancel", e2));
        }
        blur() {
          this.reset();
        }
        reset() {
          this._active = false, this._container.classList.remove("mapboxgl-crosshair"), this._box && (this._box.remove(), this._box = null), a.enableDrag(), delete this._startPos, delete this._lastPos;
        }
        _fireEvent(t2, i3) {
          return this._map.fire(new e.Event(t2, { originalEvent: i3 }));
        }
      }
      function Vo(e2, t2) {
        const i3 = {};
        for (let o2 = 0; o2 < e2.length; o2++)
          i3[e2[o2].identifier] = t2[o2];
        return i3;
      }
      class Wo {
        constructor(e2) {
          this.reset(), this.numTouches = e2.numTouches;
        }
        reset() {
          delete this.centroid, delete this.startTime, delete this.touches, this.aborted = false;
        }
        touchstart(t2, i3, o2) {
          (this.centroid || o2.length > this.numTouches) && (this.aborted = true), this.aborted || (this.startTime === void 0 && (this.startTime = t2.timeStamp), o2.length === this.numTouches && (this.centroid = function(t3) {
            const i4 = new e.pointGeometry(0, 0);
            for (const e2 of t3)
              i4._add(e2);
            return i4.div(t3.length);
          }(i3), this.touches = Vo(o2, i3)));
        }
        touchmove(e2, t2, i3) {
          if (this.aborted || !this.centroid)
            return;
          const o2 = Vo(i3, t2);
          for (const e3 in this.touches) {
            const t3 = this.touches[e3], i4 = o2[e3];
            (!i4 || i4.dist(t3) > 30) && (this.aborted = true);
          }
        }
        touchend(e2, t2, i3) {
          if ((!this.centroid || e2.timeStamp - this.startTime > 500) && (this.aborted = true), i3.length === 0) {
            const e3 = !this.aborted && this.centroid;
            if (this.reset(), e3)
              return e3;
          }
        }
      }
      class qo {
        constructor(e2) {
          this.singleTap = new Wo(e2), this.numTaps = e2.numTaps, this.reset();
        }
        reset() {
          this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
        }
        touchstart(e2, t2, i3) {
          this.singleTap.touchstart(e2, t2, i3);
        }
        touchmove(e2, t2, i3) {
          this.singleTap.touchmove(e2, t2, i3);
        }
        touchend(e2, t2, i3) {
          const o2 = this.singleTap.touchend(e2, t2, i3);
          if (o2) {
            const t3 = e2.timeStamp - this.lastTime < 500, i4 = !this.lastTap || this.lastTap.dist(o2) < 30;
            if (t3 && i4 || this.reset(), this.count++, this.lastTime = e2.timeStamp, this.lastTap = o2, this.count === this.numTaps)
              return this.reset(), o2;
          }
        }
      }
      class Xo {
        constructor() {
          this._zoomIn = new qo({ numTouches: 1, numTaps: 2 }), this._zoomOut = new qo({ numTouches: 2, numTaps: 1 }), this.reset();
        }
        reset() {
          this._active = false, this._zoomIn.reset(), this._zoomOut.reset();
        }
        touchstart(e2, t2, i3) {
          this._zoomIn.touchstart(e2, t2, i3), this._zoomOut.touchstart(e2, t2, i3);
        }
        touchmove(e2, t2, i3) {
          this._zoomIn.touchmove(e2, t2, i3), this._zoomOut.touchmove(e2, t2, i3);
        }
        touchend(e2, t2, i3) {
          const o2 = this._zoomIn.touchend(e2, t2, i3), r2 = this._zoomOut.touchend(e2, t2, i3);
          return o2 ? (this._active = true, e2.preventDefault(), setTimeout(() => this.reset(), 0), { cameraAnimation: (t3) => t3.easeTo({ duration: 300, zoom: t3.getZoom() + 1, around: t3.unproject(o2) }, { originalEvent: e2 }) }) : r2 ? (this._active = true, e2.preventDefault(), setTimeout(() => this.reset(), 0), { cameraAnimation: (t3) => t3.easeTo({ duration: 300, zoom: t3.getZoom() - 1, around: t3.unproject(r2) }, { originalEvent: e2 }) }) : void 0;
        }
        touchcancel() {
          this.reset();
        }
        enable() {
          this._enabled = true;
        }
        disable() {
          this._enabled = false, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      const $o = { 0: 1, 2: 2 };
      class Ho {
        constructor(e2) {
          this.reset(), this._clickTolerance = e2.clickTolerance || 1;
        }
        blur() {
          this.reset();
        }
        reset() {
          this._active = false, this._moved = false, delete this._lastPoint, delete this._eventButton;
        }
        _correctButton(e2, t2) {
          return false;
        }
        _move(e2, t2) {
          return {};
        }
        mousedown(e2, t2) {
          if (this._lastPoint)
            return;
          const i3 = a.mouseButton(e2);
          this._correctButton(e2, i3) && (this._lastPoint = t2, this._eventButton = i3);
        }
        mousemoveWindow(e2, t2) {
          const i3 = this._lastPoint;
          if (i3) {
            if (e2.preventDefault(), function(e3, t3) {
              const i4 = $o[t3];
              return e3.buttons === void 0 || (e3.buttons & i4) !== i4;
            }(e2, this._eventButton))
              this.reset();
            else if (this._moved || !(t2.dist(i3) < this._clickTolerance))
              return this._moved = true, this._lastPoint = t2, this._move(i3, t2);
          }
        }
        mouseupWindow(e2) {
          this._lastPoint && a.mouseButton(e2) === this._eventButton && (this._moved && a.suppressClick(), this.reset());
        }
        enable() {
          this._enabled = true;
        }
        disable() {
          this._enabled = false, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      class Ko extends Ho {
        mousedown(e2, t2) {
          super.mousedown(e2, t2), this._lastPoint && (this._active = true);
        }
        _correctButton(e2, t2) {
          return t2 === 0 && !e2.ctrlKey;
        }
        _move(e2, t2) {
          return { around: t2, panDelta: t2.sub(e2) };
        }
      }
      class Yo extends Ho {
        _correctButton(e2, t2) {
          return t2 === 0 && e2.ctrlKey || t2 === 2;
        }
        _move(e2, t2) {
          const i3 = 0.8 * (t2.x - e2.x);
          if (i3)
            return this._active = true, { bearingDelta: i3 };
        }
        contextmenu(e2) {
          e2.preventDefault();
        }
      }
      class Jo extends Ho {
        _correctButton(e2, t2) {
          return t2 === 0 && e2.ctrlKey || t2 === 2;
        }
        _move(e2, t2) {
          const i3 = -0.5 * (t2.y - e2.y);
          if (i3)
            return this._active = true, { pitchDelta: i3 };
        }
        contextmenu(e2) {
          e2.preventDefault();
        }
      }
      class Qo {
        constructor(t2, i3) {
          this._map = t2, this._el = t2.getCanvasContainer(), this._minTouches = 1, this._clickTolerance = i3.clickTolerance || 1, this.reset(), e.bindAll(["_addTouchPanBlocker", "_showTouchPanBlockerAlert"], this);
        }
        reset() {
          this._active = false, this._touches = {}, this._sum = new e.pointGeometry(0, 0);
        }
        touchstart(e2, t2, i3) {
          return this._calculateTransform(e2, t2, i3);
        }
        touchmove(e2, t2, i3) {
          if (this._active && !(i3.length < this._minTouches)) {
            if (this._map._cooperativeGestures && !this._map.isMoving()) {
              if (i3.length === 1)
                return void this._showTouchPanBlockerAlert();
              this._alertContainer.style.visibility !== "hidden" && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
            }
            return e2.preventDefault(), this._calculateTransform(e2, t2, i3);
          }
        }
        touchend(e2, t2, i3) {
          this._calculateTransform(e2, t2, i3), this._active && i3.length < this._minTouches && this.reset();
        }
        touchcancel() {
          this.reset();
        }
        _calculateTransform(t2, i3, o2) {
          o2.length > 0 && (this._active = true);
          const r2 = Vo(o2, i3), n2 = new e.pointGeometry(0, 0), a2 = new e.pointGeometry(0, 0);
          let s3 = 0;
          for (const e2 in r2) {
            const t3 = r2[e2], i4 = this._touches[e2];
            i4 && (n2._add(t3), a2._add(t3.sub(i4)), s3++, r2[e2] = t3);
          }
          if (this._touches = r2, s3 < this._minTouches || !a2.mag())
            return;
          const l2 = a2.div(s3);
          return this._sum._add(l2), this._sum.mag() < this._clickTolerance ? void 0 : { around: n2.div(s3), panDelta: l2 };
        }
        enable() {
          this._enabled = true, this._map._cooperativeGestures && (this._addTouchPanBlocker(), this._el.classList.add("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page"));
        }
        disable() {
          this._enabled = false, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove(), this._el.classList.remove("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page")), this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
        _addTouchPanBlocker() {
          this._map && !this._alertContainer && (this._alertContainer = a.create("div", "mapboxgl-touch-pan-blocker", this._map._container), this._alertContainer.textContent = this._map._getUIString("TouchPanBlocker.Message"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(0.05 * this._el.clientWidth)))}px`);
        }
        _showTouchPanBlockerAlert() {
          this._alertContainer.style.visibility === "hidden" && (this._alertContainer.style.visibility = "visible"), this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"), clearTimeout(this._alertTimer), this._alertTimer = setTimeout(() => {
            this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show");
          }, 500);
        }
      }
      class er {
        constructor() {
          this.reset();
        }
        reset() {
          this._active = false, delete this._firstTwoTouches;
        }
        _start(e2) {
        }
        _move(e2, t2, i3) {
          return {};
        }
        touchstart(e2, t2, i3) {
          this._firstTwoTouches || i3.length < 2 || (this._firstTwoTouches = [i3[0].identifier, i3[1].identifier], this._start([t2[0], t2[1]]));
        }
        touchmove(e2, t2, i3) {
          if (!this._firstTwoTouches)
            return;
          e2.preventDefault();
          const [o2, r2] = this._firstTwoTouches, n2 = tr(i3, t2, o2), a2 = tr(i3, t2, r2);
          if (!n2 || !a2)
            return;
          const s3 = this._aroundCenter ? null : n2.add(a2).div(2);
          return this._move([n2, a2], s3, e2);
        }
        touchend(e2, t2, i3) {
          if (!this._firstTwoTouches)
            return;
          const [o2, r2] = this._firstTwoTouches, n2 = tr(i3, t2, o2), s3 = tr(i3, t2, r2);
          n2 && s3 || (this._active && a.suppressClick(), this.reset());
        }
        touchcancel() {
          this.reset();
        }
        enable(e2) {
          this._enabled = true, this._aroundCenter = !!e2 && e2.around === "center";
        }
        disable() {
          this._enabled = false, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      function tr(e2, t2, i3) {
        for (let o2 = 0; o2 < e2.length; o2++)
          if (e2[o2].identifier === i3)
            return t2[o2];
      }
      function ir(e2, t2) {
        return Math.log(e2 / t2) / Math.LN2;
      }
      class or extends er {
        reset() {
          super.reset(), delete this._distance, delete this._startDistance;
        }
        _start(e2) {
          this._startDistance = this._distance = e2[0].dist(e2[1]);
        }
        _move(e2, t2) {
          const i3 = this._distance;
          if (this._distance = e2[0].dist(e2[1]), this._active || !(Math.abs(ir(this._distance, this._startDistance)) < 0.1))
            return this._active = true, { zoomDelta: ir(this._distance, i3), pinchAround: t2 };
        }
      }
      function rr2(e2, t2) {
        return 180 * e2.angleWith(t2) / Math.PI;
      }
      class nr extends er {
        reset() {
          super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
        }
        _start(e2) {
          this._startVector = this._vector = e2[0].sub(e2[1]), this._minDiameter = e2[0].dist(e2[1]);
        }
        _move(e2, t2) {
          const i3 = this._vector;
          if (this._vector = e2[0].sub(e2[1]), this._active || !this._isBelowThreshold(this._vector))
            return this._active = true, { bearingDelta: rr2(this._vector, i3), pinchAround: t2 };
        }
        _isBelowThreshold(e2) {
          this._minDiameter = Math.min(this._minDiameter, e2.mag());
          const t2 = 25 / (Math.PI * this._minDiameter) * 360, i3 = rr2(e2, this._startVector);
          return Math.abs(i3) < t2;
        }
      }
      function ar(e2) {
        return Math.abs(e2.y) > Math.abs(e2.x);
      }
      class sr extends er {
        constructor(e2) {
          super(), this._map = e2;
        }
        reset() {
          super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
        }
        _start(e2) {
          this._lastPoints = e2, ar(e2[0].sub(e2[1])) && (this._valid = false);
        }
        _move(e2, t2, i3) {
          const o2 = e2[0].sub(this._lastPoints[0]), r2 = e2[1].sub(this._lastPoints[1]);
          if (!(this._map._cooperativeGestures && i3.touches.length < 3) && (this._valid = this.gestureBeginsVertically(o2, r2, i3.timeStamp), this._valid))
            return this._lastPoints = e2, this._active = true, { pitchDelta: (o2.y + r2.y) / 2 * -0.5 };
        }
        gestureBeginsVertically(e2, t2, i3) {
          if (this._valid !== void 0)
            return this._valid;
          const o2 = e2.mag() >= 2, r2 = t2.mag() >= 2;
          if (!o2 && !r2)
            return;
          if (!o2 || !r2)
            return this._firstMove === void 0 && (this._firstMove = i3), i3 - this._firstMove < 100 && void 0;
          const n2 = e2.y > 0 == t2.y > 0;
          return ar(e2) && ar(t2) && n2;
        }
      }
      const lr = { panStep: 100, bearingStep: 15, pitchStep: 10 };
      class cr {
        constructor() {
          const e2 = lr;
          this._panStep = e2.panStep, this._bearingStep = e2.bearingStep, this._pitchStep = e2.pitchStep, this._rotationDisabled = false;
        }
        blur() {
          this.reset();
        }
        reset() {
          this._active = false;
        }
        keydown(e2) {
          if (e2.altKey || e2.ctrlKey || e2.metaKey)
            return;
          let t2 = 0, i3 = 0, o2 = 0, r2 = 0, n2 = 0;
          switch (e2.keyCode) {
            case 61:
            case 107:
            case 171:
            case 187:
              t2 = 1;
              break;
            case 189:
            case 109:
            case 173:
              t2 = -1;
              break;
            case 37:
              e2.shiftKey ? i3 = -1 : (e2.preventDefault(), r2 = -1);
              break;
            case 39:
              e2.shiftKey ? i3 = 1 : (e2.preventDefault(), r2 = 1);
              break;
            case 38:
              e2.shiftKey ? o2 = 1 : (e2.preventDefault(), n2 = -1);
              break;
            case 40:
              e2.shiftKey ? o2 = -1 : (e2.preventDefault(), n2 = 1);
              break;
            default:
              return;
          }
          return this._rotationDisabled && (i3 = 0, o2 = 0), { cameraAnimation: (a2) => {
            const s3 = a2.getZoom();
            a2.easeTo({ duration: 300, easeId: "keyboardHandler", easing: hr, zoom: t2 ? Math.round(s3) + t2 * (e2.shiftKey ? 2 : 1) : s3, bearing: a2.getBearing() + i3 * this._bearingStep, pitch: a2.getPitch() + o2 * this._pitchStep, offset: [-r2 * this._panStep, -n2 * this._panStep], center: a2.getCenter() }, { originalEvent: e2 });
          } };
        }
        enable() {
          this._enabled = true;
        }
        disable() {
          this._enabled = false, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
        disableRotation() {
          this._rotationDisabled = true;
        }
        enableRotation() {
          this._rotationDisabled = false;
        }
      }
      function hr(e2) {
        return e2 * (2 - e2);
      }
      const ur = 4.000244140625;
      class _r2 {
        constructor(t2, i3) {
          this._map = t2, this._el = t2.getCanvasContainer(), this._handler = i3, this._delta = 0, this._defaultZoomRate = 0.01, this._wheelZoomRate = 0.0022222222222222222, e.bindAll(["_onTimeout", "_addScrollZoomBlocker", "_showBlockerAlert", "_isFullscreen"], this);
        }
        setZoomRate(e2) {
          this._defaultZoomRate = e2;
        }
        setWheelZoomRate(e2) {
          this._wheelZoomRate = e2;
        }
        isEnabled() {
          return !!this._enabled;
        }
        isActive() {
          return !!this._active || this._finishTimeout !== void 0;
        }
        isZooming() {
          return !!this._zooming;
        }
        enable(e2) {
          this.isEnabled() || (this._enabled = true, this._aroundCenter = !!e2 && e2.around === "center", this._map._cooperativeGestures && this._addScrollZoomBlocker());
        }
        disable() {
          this.isEnabled() && (this._enabled = false, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove()));
        }
        wheel(t2) {
          if (!this.isEnabled())
            return;
          if (this._map._cooperativeGestures) {
            if (!(t2.ctrlKey || t2.metaKey || this.isZooming() || this._isFullscreen()))
              return void this._showBlockerAlert();
            this._alertContainer.style.visibility !== "hidden" && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
          }
          let i3 = t2.deltaMode === e.window.WheelEvent.DOM_DELTA_LINE ? 40 * t2.deltaY : t2.deltaY;
          const o2 = e.exported.now(), r2 = o2 - (this._lastWheelEventTime || 0);
          this._lastWheelEventTime = o2, i3 !== 0 && i3 % ur == 0 ? this._type = "wheel" : i3 !== 0 && Math.abs(i3) < 4 ? this._type = "trackpad" : r2 > 400 ? (this._type = null, this._lastValue = i3, this._timeout = setTimeout(this._onTimeout, 40, t2)) : this._type || (this._type = Math.abs(r2 * i3) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i3 += this._lastValue)), t2.shiftKey && i3 && (i3 /= 4), this._type && (this._lastWheelEvent = t2, this._delta -= i3, this._active || this._start(t2)), t2.preventDefault();
        }
        _onTimeout(e2) {
          this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e2);
        }
        _start(e2) {
          if (!this._delta)
            return;
          this._frameId && (this._frameId = null), this._active = true, this.isZooming() || (this._zooming = true), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
          const t2 = a.mousePos(this._el, e2);
          this._aroundPoint = this._aroundCenter ? this._map.transform.centerPoint : t2, this._aroundCoord = this._map.transform.pointCoordinate3D(this._aroundPoint), this._targetZoom = void 0, this._frameId || (this._frameId = true, this._handler._triggerRenderFrame());
        }
        renderFrame() {
          if (!this._frameId)
            return;
          if (this._frameId = null, !this.isActive())
            return;
          const t2 = this._map.transform, i3 = () => t2._terrainEnabled() && this._aroundCoord ? t2.computeZoomRelativeTo(this._aroundCoord) : t2.zoom;
          if (this._delta !== 0) {
            const e2 = this._type === "wheel" && Math.abs(this._delta) > ur ? this._wheelZoomRate : this._defaultZoomRate;
            let o3 = 2 / (1 + Math.exp(-Math.abs(this._delta * e2)));
            this._delta < 0 && o3 !== 0 && (o3 = 1 / o3);
            const r3 = i3(), n3 = Math.pow(2, r3), a3 = typeof this._targetZoom == "number" ? t2.zoomScale(this._targetZoom) : n3;
            this._targetZoom = Math.min(t2.maxZoom, Math.max(t2.minZoom, t2.scaleZoom(a3 * o3))), this._type === "wheel" && (this._startZoom = i3(), this._easing = this._smoothOutEasing(200)), this._delta = 0;
          }
          const o2 = typeof this._targetZoom == "number" ? this._targetZoom : i3(), r2 = this._startZoom, n2 = this._easing;
          let a2, s3 = false;
          if (this._type === "wheel" && r2 && n2) {
            const t3 = Math.min((e.exported.now() - this._lastWheelEventTime) / 200, 1), i4 = n2(t3);
            a2 = e.number(r2, o2, i4), t3 < 1 ? this._frameId || (this._frameId = true) : s3 = true;
          } else
            a2 = o2, s3 = true;
          return this._active = true, s3 && (this._active = false, this._finishTimeout = setTimeout(() => {
            this._zooming = false, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
          }, 200)), { noInertia: true, needsRenderFrame: !s3, zoomDelta: a2 - i3(), around: this._aroundPoint, aroundCoord: this._aroundCoord, originalEvent: this._lastWheelEvent };
        }
        _smoothOutEasing(t2) {
          let i3 = e.ease;
          if (this._prevEase) {
            const t3 = this._prevEase, o2 = (e.exported.now() - t3.start) / t3.duration, r2 = t3.easing(o2 + 0.01) - t3.easing(o2), n2 = 0.27 / Math.sqrt(r2 * r2 + 1e-4) * 0.01, a2 = Math.sqrt(0.0729 - n2 * n2);
            i3 = e.bezier(n2, a2, 0.25, 1);
          }
          return this._prevEase = { start: e.exported.now(), duration: t2, easing: i3 }, i3;
        }
        blur() {
          this.reset();
        }
        reset() {
          this._active = false;
        }
        _addScrollZoomBlocker() {
          this._map && !this._alertContainer && (this._alertContainer = a.create("div", "mapboxgl-scroll-zoom-blocker", this._map._container), this._alertContainer.textContent = /(Mac|iPad)/i.test(e.window.navigator.userAgent) ? this._map._getUIString("ScrollZoomBlocker.CmdMessage") : this._map._getUIString("ScrollZoomBlocker.CtrlMessage"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(0.05 * this._el.clientWidth)))}px`);
        }
        _isFullscreen() {
          return !!e.window.document.fullscreenElement;
        }
        _showBlockerAlert() {
          this._alertContainer.style.visibility === "hidden" && (this._alertContainer.style.visibility = "visible"), this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"), clearTimeout(this._alertTimer), this._alertTimer = setTimeout(() => {
            this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show");
          }, 200);
        }
      }
      class dr {
        constructor(e2, t2) {
          this._clickZoom = e2, this._tapZoom = t2;
        }
        enable() {
          this._clickZoom.enable(), this._tapZoom.enable();
        }
        disable() {
          this._clickZoom.disable(), this._tapZoom.disable();
        }
        isEnabled() {
          return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
        }
        isActive() {
          return this._clickZoom.isActive() || this._tapZoom.isActive();
        }
      }
      class pr {
        constructor() {
          this.reset();
        }
        reset() {
          this._active = false;
        }
        blur() {
          this.reset();
        }
        dblclick(e2, t2) {
          return e2.preventDefault(), { cameraAnimation: (i3) => {
            i3.easeTo({ duration: 300, zoom: i3.getZoom() + (e2.shiftKey ? -1 : 1), around: i3.unproject(t2) }, { originalEvent: e2 });
          } };
        }
        enable() {
          this._enabled = true;
        }
        disable() {
          this._enabled = false, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      class mr {
        constructor() {
          this._tap = new qo({ numTouches: 1, numTaps: 1 }), this.reset();
        }
        reset() {
          this._active = false, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, this._tap.reset();
        }
        touchstart(e2, t2, i3) {
          this._swipePoint || (this._tapTime && e2.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i3.length > 0 && (this._swipePoint = t2[0], this._swipeTouch = i3[0].identifier) : this._tap.touchstart(e2, t2, i3));
        }
        touchmove(e2, t2, i3) {
          if (this._tapTime) {
            if (this._swipePoint) {
              if (i3[0].identifier !== this._swipeTouch)
                return;
              const o2 = t2[0], r2 = o2.y - this._swipePoint.y;
              return this._swipePoint = o2, e2.preventDefault(), this._active = true, { zoomDelta: r2 / 128 };
            }
          } else
            this._tap.touchmove(e2, t2, i3);
        }
        touchend(e2, t2, i3) {
          this._tapTime ? this._swipePoint && i3.length === 0 && this.reset() : this._tap.touchend(e2, t2, i3) && (this._tapTime = e2.timeStamp);
        }
        touchcancel() {
          this.reset();
        }
        enable() {
          this._enabled = true;
        }
        disable() {
          this._enabled = false, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      class fr {
        constructor(e2, t2, i3) {
          this._el = e2, this._mousePan = t2, this._touchPan = i3;
        }
        enable(e2) {
          this._inertiaOptions = e2 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
        }
        disable() {
          this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
        }
        isEnabled() {
          return this._mousePan.isEnabled() && this._touchPan.isEnabled();
        }
        isActive() {
          return this._mousePan.isActive() || this._touchPan.isActive();
        }
      }
      class gr {
        constructor(e2, t2, i3) {
          this._pitchWithRotate = e2.pitchWithRotate, this._mouseRotate = t2, this._mousePitch = i3;
        }
        enable() {
          this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
        }
        disable() {
          this._mouseRotate.disable(), this._mousePitch.disable();
        }
        isEnabled() {
          return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
        }
        isActive() {
          return this._mouseRotate.isActive() || this._mousePitch.isActive();
        }
      }
      class vr {
        constructor(e2, t2, i3, o2) {
          this._el = e2, this._touchZoom = t2, this._touchRotate = i3, this._tapDragZoom = o2, this._rotationDisabled = false, this._enabled = true;
        }
        enable(e2) {
          this._touchZoom.enable(e2), this._rotationDisabled || this._touchRotate.enable(e2), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
        }
        disable() {
          this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
        }
        isEnabled() {
          return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
        }
        isActive() {
          return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
        }
        disableRotation() {
          this._rotationDisabled = true, this._touchRotate.disable();
        }
        enableRotation() {
          this._rotationDisabled = false, this._touchZoom.isEnabled() && this._touchRotate.enable();
        }
      }
      const xr = (e2) => e2.zoom || e2.drag || e2.pitch || e2.rotate;
      class yr extends e.Event {
      }
      class br {
        constructor() {
          this.constants = [1, 1, 0.01], this.radius = 0;
        }
        setup(t2, i3) {
          const o2 = e.sub([], i3, t2);
          this.radius = e.length(o2[2] < 0 ? e.div([], o2, this.constants) : [o2[0], o2[1], 0]);
        }
        projectRay(t2) {
          e.div(t2, t2, this.constants), e.normalize(t2, t2), e.mul$1(t2, t2, this.constants);
          const i3 = e.scale$2([], t2, this.radius);
          if (i3[2] > 0) {
            const t3 = e.scale$2([], [0, 0, 1], e.dot(i3, [0, 0, 1])), o2 = e.scale$2([], e.normalize([], [i3[0], i3[1], 0]), this.radius), r2 = e.add([], i3, e.scale$2([], e.sub([], e.add([], o2, t3), i3), 2));
            i3[0] = r2[0], i3[1] = r2[1];
          }
          return i3;
        }
      }
      function wr(e2) {
        return e2.panDelta && e2.panDelta.mag() || e2.zoomDelta || e2.bearingDelta || e2.pitchDelta;
      }
      class Tr {
        constructor(t2, i3) {
          this._map = t2, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new ko(t2), this._bearingSnap = i3.bearingSnap, this._previousActiveHandlers = {}, this._trackingEllipsoid = new br(), this._dragOrigin = null, this._eventsInProgress = {}, this._addDefaultHandlers(i3), e.bindAll(["handleEvent", "handleWindowEvent"], this);
          const o2 = this._el;
          this._listeners = [[o2, "touchstart", { passive: true }], [o2, "touchmove", { passive: false }], [o2, "touchend", void 0], [o2, "touchcancel", void 0], [o2, "mousedown", void 0], [o2, "mousemove", void 0], [o2, "mouseup", void 0], [e.window.document, "mousemove", { capture: true }], [e.window.document, "mouseup", void 0], [o2, "mouseover", void 0], [o2, "mouseout", void 0], [o2, "dblclick", void 0], [o2, "click", void 0], [o2, "keydown", { capture: false }], [o2, "keyup", void 0], [o2, "wheel", { passive: false }], [o2, "contextmenu", void 0], [e.window, "blur", void 0]];
          for (const [t3, i4, o3] of this._listeners)
            t3.addEventListener(i4, t3 === e.window.document ? this.handleWindowEvent : this.handleEvent, o3);
        }
        destroy() {
          for (const [t2, i3, o2] of this._listeners)
            t2.removeEventListener(i3, t2 === e.window.document ? this.handleWindowEvent : this.handleEvent, o2);
        }
        _addDefaultHandlers(e2) {
          const t2 = this._map, i3 = t2.getCanvasContainer();
          this._add("mapEvent", new Go(t2, e2));
          const o2 = t2.boxZoom = new Zo(t2, e2);
          this._add("boxZoom", o2);
          const r2 = new Xo(), n2 = new pr();
          t2.doubleClickZoom = new dr(n2, r2), this._add("tapZoom", r2), this._add("clickZoom", n2);
          const a2 = new mr();
          this._add("tapDragZoom", a2);
          const s3 = t2.touchPitch = new sr(t2);
          this._add("touchPitch", s3);
          const l2 = new Yo(e2), c2 = new Jo(e2);
          t2.dragRotate = new gr(e2, l2, c2), this._add("mouseRotate", l2, ["mousePitch"]), this._add("mousePitch", c2, ["mouseRotate"]);
          const h2 = new Ko(e2), u2 = new Qo(t2, e2);
          t2.dragPan = new fr(i3, h2, u2), this._add("mousePan", h2), this._add("touchPan", u2, ["touchZoom", "touchRotate"]);
          const _2 = new nr(), d2 = new or();
          t2.touchZoomRotate = new vr(i3, d2, _2, a2), this._add("touchRotate", _2, ["touchPan", "touchZoom"]), this._add("touchZoom", d2, ["touchPan", "touchRotate"]), this._add("blockableMapEvent", new jo(t2));
          const p2 = t2.scrollZoom = new _r2(t2, this);
          this._add("scrollZoom", p2, ["mousePan"]);
          const m2 = t2.keyboard = new cr();
          this._add("keyboard", m2);
          for (const i4 of ["boxZoom", "doubleClickZoom", "tapDragZoom", "touchPitch", "dragRotate", "dragPan", "touchZoomRotate", "scrollZoom", "keyboard"])
            e2.interactive && e2[i4] && t2[i4].enable(e2[i4]);
        }
        _add(e2, t2, i3) {
          this._handlers.push({ handlerName: e2, handler: t2, allowed: i3 }), this._handlersById[e2] = t2;
        }
        stop(e2) {
          if (!this._updatingCamera) {
            for (const { handler: e3 } of this._handlers)
              e3.reset();
            this._inertia.clear(), this._fireEvents({}, {}, e2), this._changes = [];
          }
        }
        isActive() {
          for (const { handler: e2 } of this._handlers)
            if (e2.isActive())
              return true;
          return false;
        }
        isZooming() {
          return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
        }
        isRotating() {
          return !!this._eventsInProgress.rotate;
        }
        isMoving() {
          return Boolean(xr(this._eventsInProgress)) || this.isZooming();
        }
        _blockedByActive(e2, t2, i3) {
          for (const o2 in e2)
            if (o2 !== i3 && (!t2 || t2.indexOf(o2) < 0))
              return true;
          return false;
        }
        handleWindowEvent(e2) {
          this.handleEvent(e2, `${e2.type}Window`);
        }
        _getMapTouches(e2) {
          const t2 = [];
          for (const i3 of e2)
            this._el.contains(i3.target) && t2.push(i3);
          return t2;
        }
        handleEvent(e2, t2) {
          this._updatingCamera = true;
          const i3 = e2.type === "renderFrame", o2 = i3 ? void 0 : e2, r2 = { needsRenderFrame: false }, n2 = {}, s3 = {}, l2 = e2.touches ? this._getMapTouches(e2.touches) : void 0, c2 = l2 ? a.touchPos(this._el, l2) : i3 ? void 0 : a.mousePos(this._el, e2);
          for (const { handlerName: i4, handler: a2, allowed: h3 } of this._handlers) {
            if (!a2.isEnabled())
              continue;
            let u3;
            this._blockedByActive(s3, h3, i4) ? a2.reset() : a2[t2 || e2.type] && (u3 = a2[t2 || e2.type](e2, c2, l2), this.mergeHandlerResult(r2, n2, u3, i4, o2), u3 && u3.needsRenderFrame && this._triggerRenderFrame()), (u3 || a2.isActive()) && (s3[i4] = a2);
          }
          const h2 = {};
          for (const e3 in this._previousActiveHandlers)
            s3[e3] || (h2[e3] = o2);
          this._previousActiveHandlers = s3, (Object.keys(h2).length || wr(r2)) && (this._changes.push([r2, n2, h2]), this._triggerRenderFrame()), (Object.keys(s3).length || wr(r2)) && this._map._stop(true), this._updatingCamera = false;
          const { cameraAnimation: u2 } = r2;
          u2 && (this._inertia.clear(), this._fireEvents({}, {}, true), this._changes = [], u2(this._map));
        }
        mergeHandlerResult(t2, i3, o2, r2, n2) {
          if (!o2)
            return;
          e.extend(t2, o2);
          const a2 = { handlerName: r2, originalEvent: o2.originalEvent || n2 };
          o2.zoomDelta !== void 0 && (i3.zoom = a2), o2.panDelta !== void 0 && (i3.drag = a2), o2.pitchDelta !== void 0 && (i3.pitch = a2), o2.bearingDelta !== void 0 && (i3.rotate = a2);
        }
        _applyChanges() {
          const t2 = {}, i3 = {}, o2 = {};
          for (const [r2, n2, a2] of this._changes)
            r2.panDelta && (t2.panDelta = (t2.panDelta || new e.pointGeometry(0, 0))._add(r2.panDelta)), r2.zoomDelta && (t2.zoomDelta = (t2.zoomDelta || 0) + r2.zoomDelta), r2.bearingDelta && (t2.bearingDelta = (t2.bearingDelta || 0) + r2.bearingDelta), r2.pitchDelta && (t2.pitchDelta = (t2.pitchDelta || 0) + r2.pitchDelta), r2.around !== void 0 && (t2.around = r2.around), r2.aroundCoord !== void 0 && (t2.aroundCoord = r2.aroundCoord), r2.pinchAround !== void 0 && (t2.pinchAround = r2.pinchAround), r2.noInertia && (t2.noInertia = r2.noInertia), e.extend(i3, n2), e.extend(o2, a2);
          this._updateMapTransform(t2, i3, o2), this._changes = [];
        }
        _updateMapTransform(t2, i3, o2) {
          const r2 = this._map, n2 = r2.transform, a2 = (e2) => [e2.x, e2.y, e2.z];
          if (((e2) => {
            const t3 = this._eventsInProgress.drag;
            return t3 && !this._handlersById[t3.handlerName].isActive();
          })() && !wr(t2)) {
            const e2 = n2.zoom;
            n2.cameraElevationReference = "sea", n2.recenterOnTerrain(), n2.cameraElevationReference = "ground", e2 !== n2.zoom && this._map._update(true);
          }
          if (!wr(t2))
            return this._fireEvents(i3, o2, true);
          let { panDelta: s3, zoomDelta: l2, bearingDelta: c2, pitchDelta: h2, around: u2, aroundCoord: _2, pinchAround: d2 } = t2;
          d2 !== void 0 && (u2 = d2), ((e2) => i3.drag && !this._eventsInProgress.drag)() && u2 && (this._dragOrigin = a2(n2.pointCoordinate3D(u2)), this._trackingEllipsoid.setup(n2._camera.position, this._dragOrigin)), n2.cameraElevationReference = "sea", r2._stop(true), u2 = u2 || r2.transform.centerPoint, c2 && (n2.bearing += c2), h2 && (n2.pitch += h2), n2._updateCameraState();
          const p2 = [0, 0, 0];
          if (s3) {
            const e2 = n2.pointCoordinate(u2), t3 = n2.pointCoordinate(u2.sub(s3));
            e2 && t3 && (p2[0] = t3.x - e2.x, p2[1] = t3.y - e2.y);
          }
          const m2 = n2.zoom, f2 = [0, 0, 0];
          if (l2) {
            const t3 = a2(_2 || n2.pointCoordinate3D(u2)), i4 = { dir: e.normalize([], e.sub([], t3, n2._camera.position)) };
            if (i4.dir[2] < 0) {
              const o3 = n2.zoomDeltaToMovement(t3, l2);
              e.scale$2(f2, i4.dir, o3);
            }
          }
          const g2 = e.add(p2, p2, f2);
          n2._translateCameraConstrained(g2), l2 && Math.abs(n2.zoom - m2) > 1e-4 && n2.recenterOnTerrain(), n2.cameraElevationReference = "ground", this._map._update(), t2.noInertia || this._inertia.record(t2), this._fireEvents(i3, o2, true);
        }
        _fireEvents(t2, i3, o2) {
          const r2 = xr(this._eventsInProgress), n2 = xr(t2), a2 = {};
          for (const e2 in t2) {
            const { originalEvent: i4 } = t2[e2];
            this._eventsInProgress[e2] || (a2[`${e2}start`] = i4), this._eventsInProgress[e2] = t2[e2];
          }
          !r2 && n2 && this._fireEvent("movestart", n2.originalEvent);
          for (const e2 in a2)
            this._fireEvent(e2, a2[e2]);
          n2 && this._fireEvent("move", n2.originalEvent);
          for (const e2 in t2) {
            const { originalEvent: i4 } = t2[e2];
            this._fireEvent(e2, i4);
          }
          const s3 = {};
          let l2;
          for (const e2 in this._eventsInProgress) {
            const { handlerName: t3, originalEvent: o3 } = this._eventsInProgress[e2];
            this._handlersById[t3].isActive() || (delete this._eventsInProgress[e2], l2 = i3[t3] || o3, s3[`${e2}end`] = l2);
          }
          for (const e2 in s3)
            this._fireEvent(e2, s3[e2]);
          const c2 = xr(this._eventsInProgress);
          if (o2 && (r2 || n2) && !c2) {
            this._updatingCamera = true;
            const t3 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i4 = (e2) => e2 !== 0 && -this._bearingSnap < e2 && e2 < this._bearingSnap;
            t3 ? (i4(t3.bearing || this._map.getBearing()) && (t3.bearing = 0), this._map.easeTo(t3, { originalEvent: l2 })) : (this._map.fire(new e.Event("moveend", { originalEvent: l2 })), i4(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = false;
          }
        }
        _fireEvent(t2, i3) {
          this._map.fire(new e.Event(t2, i3 ? { originalEvent: i3 } : {}));
        }
        _requestFrame() {
          return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e2) => {
            delete this._frameId, this.handleEvent(new yr("renderFrame", { timeStamp: e2 })), this._applyChanges();
          });
        }
        _triggerRenderFrame() {
          this._frameId === void 0 && (this._frameId = this._requestFrame());
        }
      }
      const Er = "map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";
      class Cr extends e.Evented {
        constructor(t2, i3) {
          super(), this._moving = false, this._zooming = false, this.transform = t2, this._bearingSnap = i3.bearingSnap, e.bindAll(["_renderFrameCallback"], this);
        }
        getCenter() {
          return new e.LngLat(this.transform.center.lng, this.transform.center.lat);
        }
        setCenter(e2, t2) {
          return this.jumpTo({ center: e2 }, t2);
        }
        panBy(t2, i3, o2) {
          return t2 = e.pointGeometry.convert(t2).mult(-1), this.panTo(this.transform.center, e.extend({ offset: t2 }, i3), o2);
        }
        panTo(t2, i3, o2) {
          return this.easeTo(e.extend({ center: t2 }, i3), o2);
        }
        getZoom() {
          return this.transform.zoom;
        }
        setZoom(e2, t2) {
          return this.jumpTo({ zoom: e2 }, t2), this;
        }
        zoomTo(t2, i3, o2) {
          return this.easeTo(e.extend({ zoom: t2 }, i3), o2);
        }
        zoomIn(e2, t2) {
          return this.zoomTo(this.getZoom() + 1, e2, t2), this;
        }
        zoomOut(e2, t2) {
          return this.zoomTo(this.getZoom() - 1, e2, t2), this;
        }
        getBearing() {
          return this.transform.bearing;
        }
        setBearing(e2, t2) {
          return this.jumpTo({ bearing: e2 }, t2), this;
        }
        getPadding() {
          return this.transform.padding;
        }
        setPadding(e2, t2) {
          return this.jumpTo({ padding: e2 }, t2), this;
        }
        rotateTo(t2, i3, o2) {
          return this.easeTo(e.extend({ bearing: t2 }, i3), o2);
        }
        resetNorth(t2, i3) {
          return this.rotateTo(0, e.extend({ duration: 1e3 }, t2), i3), this;
        }
        resetNorthPitch(t2, i3) {
          return this.easeTo(e.extend({ bearing: 0, pitch: 0, duration: 1e3 }, t2), i3), this;
        }
        snapToNorth(e2, t2) {
          return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e2, t2) : this;
        }
        getPitch() {
          return this.transform.pitch;
        }
        setPitch(e2, t2) {
          return this.jumpTo({ pitch: e2 }, t2), this;
        }
        cameraForBounds(t2, i3) {
          t2 = e.LngLatBounds.convert(t2);
          const o2 = i3 && i3.bearing || 0;
          return this._cameraForBoxAndBearing(t2.getNorthWest(), t2.getSouthEast(), o2, i3);
        }
        _extendCameraOptions(t2) {
          const i3 = { top: 0, bottom: 0, right: 0, left: 0 };
          if (typeof (t2 = e.extend({ padding: i3, offset: [0, 0], maxZoom: this.transform.maxZoom }, t2)).padding == "number") {
            const e2 = t2.padding;
            t2.padding = { top: e2, bottom: e2, right: e2, left: e2 };
          }
          return t2.padding = e.extend(i3, t2.padding), t2;
        }
        _cameraForBoxAndBearing(t2, i3, o2, r2) {
          const n2 = this._extendCameraOptions(r2), a2 = this.transform, s3 = a2.padding, l2 = a2.project(e.LngLat.convert(t2)), c2 = a2.project(e.LngLat.convert(i3)), h2 = l2.rotate(-e.degToRad(o2)), u2 = c2.rotate(-e.degToRad(o2)), _2 = new e.pointGeometry(Math.max(h2.x, u2.x), Math.max(h2.y, u2.y)), d2 = new e.pointGeometry(Math.min(h2.x, u2.x), Math.min(h2.y, u2.y)), p2 = _2.sub(d2), m2 = (a2.width - (s3.left + s3.right + n2.padding.left + n2.padding.right)) / p2.x, f2 = (a2.height - (s3.top + s3.bottom + n2.padding.top + n2.padding.bottom)) / p2.y;
          if (f2 < 0 || m2 < 0)
            return void e.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
          const g2 = Math.min(a2.scaleZoom(a2.scale * Math.min(m2, f2)), n2.maxZoom), v3 = typeof n2.offset.x == "number" ? new e.pointGeometry(n2.offset.x, n2.offset.y) : e.pointGeometry.convert(n2.offset), x3 = new e.pointGeometry((n2.padding.left - n2.padding.right) / 2, (n2.padding.top - n2.padding.bottom) / 2).rotate(o2 * Math.PI / 180), y2 = v3.add(x3).mult(a2.scale / a2.zoomScale(g2));
          return { center: a2.unproject(l2.add(c2).div(2).sub(y2)), zoom: g2, bearing: o2 };
        }
        _cameraForBox(t2, i3, o2, r2, n2) {
          const a2 = this._extendCameraOptions(n2);
          o2 = o2 || 0, r2 = r2 || 0, t2 = e.LngLat.convert(t2), i3 = e.LngLat.convert(i3);
          const s3 = this.transform.clone();
          s3.padding = a2.padding;
          const l2 = this.getFreeCameraOptions(), c2 = new e.LngLat(0.5 * (t2.lng + i3.lng), 0.5 * (t2.lat + i3.lat)), h2 = 0.5 * (o2 + r2);
          if (s3._camera.position[2] < e.mercatorZfromAltitude(h2, c2.lat))
            return void e.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
          l2.lookAtPoint(c2), s3.setFreeCameraOptions(l2);
          const u2 = e.MercatorCoordinate.fromLngLat(t2), _2 = e.MercatorCoordinate.fromLngLat(i3), d2 = s3.pointRayIntersection(s3.centerPoint, h2), p2 = [(m2 = s3.rayIntersectionCoordinate(d2)).x, m2.y, m2.z];
          var m2;
          const f2 = s3.screenPointToMercatorRay(s3.centerPoint), g2 = s3.projection.name !== "globe";
          let v3, x3 = 0;
          do {
            const t3 = Math.floor(s3.zoom), i4 = 1 << t3, n3 = Math.min(i4 * u2.x, i4 * _2.x), a3 = Math.min(i4 * u2.y, i4 * _2.y), l3 = Math.max(i4 * u2.x, i4 * _2.x), c3 = Math.max(i4 * u2.y, i4 * _2.y), h3 = new e.Aabb([n3, a3, o2], [l3, c3, r2]), d3 = e.Frustum.fromInvProjectionMatrix(s3.invProjMatrix, s3.worldSize, t3, g2);
            if (h3.intersects(d3) !== 2) {
              v3 && (s3._camera.position = e.scaleAndAdd([], s3._camera.position, f2.dir, -v3), s3._updateStateFromCamera());
              break;
            }
            const m3 = e.sub([], s3._camera.position, p2);
            v3 = 0.5 * e.length(m3), s3._camera.position = e.scaleAndAdd([], s3._camera.position, f2.dir, v3);
            try {
              s3._updateStateFromCamera();
            } catch (t4) {
              return void e.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
            }
          } while (++x3 < 10);
          return { center: s3.center, zoom: s3.zoom, bearing: s3.bearing, pitch: s3.pitch };
        }
        fitBounds(e2, t2, i3) {
          return this._fitInternal(this.cameraForBounds(e2, t2), t2, i3);
        }
        _raycastElevationBox(t2, i3) {
          const o2 = this.transform.elevation;
          if (!o2)
            return;
          const r2 = new e.pointGeometry(t2.x, i3.y), n2 = new e.pointGeometry(i3.x, t2.y), a2 = o2.pointCoordinate(t2);
          if (!a2)
            return;
          const s3 = o2.pointCoordinate(i3);
          if (!s3)
            return;
          const l2 = o2.pointCoordinate(r2);
          if (!l2)
            return;
          const c2 = o2.pointCoordinate(n2);
          if (!c2)
            return;
          const h2 = new e.MercatorCoordinate(a2[0], a2[1]).toLngLat(), u2 = new e.MercatorCoordinate(s3[0], s3[1]).toLngLat(), _2 = new e.MercatorCoordinate(l2[0], l2[1]).toLngLat(), d2 = new e.MercatorCoordinate(c2[0], c2[1]).toLngLat(), p2 = Math.min(h2.lng, Math.min(u2.lng, Math.min(_2.lng, d2.lng))), m2 = Math.min(h2.lat, Math.min(u2.lat, Math.min(_2.lat, d2.lat))), f2 = Math.max(h2.lng, Math.max(u2.lng, Math.max(_2.lng, d2.lng))), g2 = Math.max(h2.lat, Math.max(u2.lat, Math.max(_2.lat, d2.lat))), v3 = Math.min(a2[3], Math.min(s3[3], Math.min(l2[3], c2[3]))), x3 = Math.max(a2[3], Math.max(s3[3], Math.max(l2[3], c2[3])));
          return { minLngLat: new e.LngLat(p2, m2), maxLngLat: new e.LngLat(f2, g2), minAltitude: v3, maxAltitude: x3 };
        }
        fitScreenCoordinates(t2, i3, o2, r2, n2) {
          let a2, s3, l2, c2;
          const h2 = e.pointGeometry.convert(t2), u2 = e.pointGeometry.convert(i3), _2 = this._raycastElevationBox(h2, u2);
          if (_2)
            a2 = _2.minLngLat, s3 = _2.maxLngLat, l2 = _2.minAltitude, c2 = _2.maxAltitude;
          else {
            if (this.transform.anyCornerOffEdge(h2, u2))
              return this;
            a2 = this.transform.pointLocation(h2), s3 = this.transform.pointLocation(u2);
          }
          return this._fitInternal(this.transform.pitch === 0 ? this._cameraForBoxAndBearing(this.transform.pointLocation(e.pointGeometry.convert(t2)), this.transform.pointLocation(e.pointGeometry.convert(i3)), o2, r2) : this._cameraForBox(a2, s3, l2, c2, r2), r2, n2);
        }
        _fitInternal(t2, i3, o2) {
          return t2 ? (delete (i3 = e.extend(t2, i3)).padding, i3.linear ? this.easeTo(i3, o2) : this.flyTo(i3, o2)) : this;
        }
        jumpTo(t2, i3) {
          this.stop();
          const o2 = t2.preloadOnly ? this.transform.clone() : this.transform;
          let r2 = false, n2 = false, a2 = false;
          return "zoom" in t2 && o2.zoom !== +t2.zoom && (r2 = true, o2.zoom = +t2.zoom), t2.center !== void 0 && (o2.center = e.LngLat.convert(t2.center)), "bearing" in t2 && o2.bearing !== +t2.bearing && (n2 = true, o2.bearing = +t2.bearing), "pitch" in t2 && o2.pitch !== +t2.pitch && (a2 = true, o2.pitch = +t2.pitch), t2.padding == null || o2.isPaddingEqual(t2.padding) || (o2.padding = t2.padding), t2.preloadOnly ? (this._preloadTiles(o2), this) : (this.fire(new e.Event("movestart", i3)).fire(new e.Event("move", i3)), r2 && this.fire(new e.Event("zoomstart", i3)).fire(new e.Event("zoom", i3)).fire(new e.Event("zoomend", i3)), n2 && this.fire(new e.Event("rotatestart", i3)).fire(new e.Event("rotate", i3)).fire(new e.Event("rotateend", i3)), a2 && this.fire(new e.Event("pitchstart", i3)).fire(new e.Event("pitch", i3)).fire(new e.Event("pitchend", i3)), this.fire(new e.Event("moveend", i3)));
        }
        getFreeCameraOptions() {
          return this.transform.projection.supportsFreeCamera || e.warnOnce(Er), this.transform.getFreeCameraOptions();
        }
        setFreeCameraOptions(t2, i3) {
          const o2 = this.transform;
          if (!o2.projection.supportsFreeCamera)
            return void e.warnOnce(Er);
          this.stop();
          const r2 = o2.zoom, n2 = o2.pitch, a2 = o2.bearing;
          o2.setFreeCameraOptions(t2);
          const s3 = r2 !== o2.zoom, l2 = n2 !== o2.pitch, c2 = a2 !== o2.bearing;
          return this.fire(new e.Event("movestart", i3)).fire(new e.Event("move", i3)), s3 && this.fire(new e.Event("zoomstart", i3)).fire(new e.Event("zoom", i3)).fire(new e.Event("zoomend", i3)), c2 && this.fire(new e.Event("rotatestart", i3)).fire(new e.Event("rotate", i3)).fire(new e.Event("rotateend", i3)), l2 && this.fire(new e.Event("pitchstart", i3)).fire(new e.Event("pitch", i3)).fire(new e.Event("pitchend", i3)), this.fire(new e.Event("moveend", i3)), this;
        }
        easeTo(t2, i3) {
          this._stop(false, t2.easeId), ((t2 = e.extend({ offset: [0, 0], duration: 500, easing: e.ease }, t2)).animate === false || !t2.essential && e.exported.prefersReducedMotion) && (t2.duration = 0);
          const o2 = this.transform, r2 = this.getZoom(), n2 = this.getBearing(), a2 = this.getPitch(), s3 = this.getPadding(), l2 = "zoom" in t2 ? +t2.zoom : r2, c2 = "bearing" in t2 ? this._normalizeBearing(t2.bearing, n2) : n2, h2 = "pitch" in t2 ? +t2.pitch : a2, u2 = "padding" in t2 ? t2.padding : o2.padding, _2 = e.pointGeometry.convert(t2.offset);
          let d2 = o2.centerPoint.add(_2);
          const p2 = o2.projection.name === "globe" ? o2.pointCoordinate(d2).toLngLat() : o2.pointLocation(d2), m2 = e.LngLat.convert(t2.center || p2);
          this._normalizeCenter(m2);
          const f2 = o2.project(p2), g2 = o2.project(m2).sub(f2), v3 = o2.zoomScale(l2 - r2);
          let x3, y2;
          t2.around && (x3 = e.LngLat.convert(t2.around), y2 = o2.locationPoint(x3));
          const b2 = this._zooming || l2 !== r2, w2 = this._rotating || n2 !== c2, T2 = this._pitching || h2 !== a2, E2 = !o2.isPaddingEqual(u2), C2 = (o3) => (p3) => {
            if (b2 && (o3.zoom = e.number(r2, l2, p3)), w2 && (o3.bearing = e.number(n2, c2, p3)), T2 && (o3.pitch = e.number(a2, h2, p3)), E2 && (o3.interpolatePadding(s3, u2, p3), d2 = o3.centerPoint.add(_2)), x3)
              o3.setLocationAtPoint(x3, y2);
            else {
              const e2 = o3.zoomScale(o3.zoom - r2), t3 = l2 > r2 ? Math.min(2, v3) : Math.max(0.5, v3), i4 = Math.pow(t3, 1 - p3), n3 = o3.unproject(f2.add(g2.mult(p3 * i4)).mult(e2));
              o3.setLocationAtPoint(o3.renderWorldCopies ? n3.wrap() : n3, d2);
            }
            return t2.preloadOnly || this._fireMoveEvents(i3), o3;
          };
          if (t2.preloadOnly) {
            const e2 = this._emulate(C2, t2.duration, o2);
            return this._preloadTiles(e2), this;
          }
          const M3 = { moving: this._moving, zooming: this._zooming, rotating: this._rotating, pitching: this._pitching };
          return this._zooming = b2, this._rotating = w2, this._pitching = T2, this._padding = E2, this._easeId = t2.easeId, this._prepareEase(i3, t2.noMoveStart, M3), this._ease(C2(o2), (e2) => {
            o2.recenterOnTerrain(), this._afterEase(i3, e2);
          }, t2), this;
        }
        _prepareEase(t2, i3, o2 = {}) {
          this._moving = true, this.transform.cameraElevationReference = "sea", i3 || o2.moving || this.fire(new e.Event("movestart", t2)), this._zooming && !o2.zooming && this.fire(new e.Event("zoomstart", t2)), this._rotating && !o2.rotating && this.fire(new e.Event("rotatestart", t2)), this._pitching && !o2.pitching && this.fire(new e.Event("pitchstart", t2));
        }
        _fireMoveEvents(t2) {
          this.fire(new e.Event("move", t2)), this._zooming && this.fire(new e.Event("zoom", t2)), this._rotating && this.fire(new e.Event("rotate", t2)), this._pitching && this.fire(new e.Event("pitch", t2));
        }
        _afterEase(t2, i3) {
          if (this._easeId && i3 && this._easeId === i3)
            return;
          delete this._easeId, this.transform.cameraElevationReference = "ground";
          const o2 = this._zooming, r2 = this._rotating, n2 = this._pitching;
          this._moving = false, this._zooming = false, this._rotating = false, this._pitching = false, this._padding = false, o2 && this.fire(new e.Event("zoomend", t2)), r2 && this.fire(new e.Event("rotateend", t2)), n2 && this.fire(new e.Event("pitchend", t2)), this.fire(new e.Event("moveend", t2));
        }
        flyTo(t2, i3) {
          if (!t2.essential && e.exported.prefersReducedMotion) {
            const o3 = e.pick(t2, ["center", "zoom", "bearing", "pitch", "around"]);
            return this.jumpTo(o3, i3);
          }
          this.stop(), t2 = e.extend({ offset: [0, 0], speed: 1.2, curve: 1.42, easing: e.ease }, t2);
          const o2 = this.transform, r2 = this.getZoom(), n2 = this.getBearing(), a2 = this.getPitch(), s3 = this.getPadding(), l2 = "zoom" in t2 ? e.clamp(+t2.zoom, o2.minZoom, o2.maxZoom) : r2, c2 = "bearing" in t2 ? this._normalizeBearing(t2.bearing, n2) : n2, h2 = "pitch" in t2 ? +t2.pitch : a2, u2 = "padding" in t2 ? t2.padding : o2.padding, _2 = o2.zoomScale(l2 - r2), d2 = e.pointGeometry.convert(t2.offset);
          let p2 = o2.centerPoint.add(d2);
          const m2 = o2.pointLocation(p2), f2 = e.LngLat.convert(t2.center || m2);
          this._normalizeCenter(f2);
          const g2 = o2.project(m2), v3 = o2.project(f2).sub(g2);
          let x3 = t2.curve;
          const y2 = Math.max(o2.width, o2.height), b2 = y2 / _2, w2 = v3.mag();
          if ("minZoom" in t2) {
            const i4 = e.clamp(Math.min(t2.minZoom, r2, l2), o2.minZoom, o2.maxZoom), n3 = y2 / o2.zoomScale(i4 - r2);
            x3 = Math.sqrt(n3 / w2 * 2);
          }
          const T2 = x3 * x3;
          function E2(e2) {
            const t3 = (b2 * b2 - y2 * y2 + (e2 ? -1 : 1) * T2 * T2 * w2 * w2) / (2 * (e2 ? b2 : y2) * T2 * w2);
            return Math.log(Math.sqrt(t3 * t3 + 1) - t3);
          }
          function C2(e2) {
            return (Math.exp(e2) - Math.exp(-e2)) / 2;
          }
          function M3(e2) {
            return (Math.exp(e2) + Math.exp(-e2)) / 2;
          }
          const S3 = E2(0);
          let I3 = function(e2) {
            return M3(S3) / M3(S3 + x3 * e2);
          }, z2 = function(e2) {
            return y2 * ((M3(S3) * (C2(t3 = S3 + x3 * e2) / M3(t3)) - C2(S3)) / T2) / w2;
            var t3;
          }, D4 = (E2(1) - S3) / x3;
          if (Math.abs(w2) < 1e-6 || !isFinite(D4)) {
            if (Math.abs(y2 - b2) < 1e-6)
              return this.easeTo(t2, i3);
            const e2 = b2 < y2 ? -1 : 1;
            D4 = Math.abs(Math.log(b2 / y2)) / x3, z2 = function() {
              return 0;
            }, I3 = function(t3) {
              return Math.exp(e2 * x3 * t3);
            };
          }
          t2.duration = "duration" in t2 ? +t2.duration : 1e3 * D4 / ("screenSpeed" in t2 ? +t2.screenSpeed / x3 : +t2.speed), t2.maxDuration && t2.duration > t2.maxDuration && (t2.duration = 0);
          const P2 = n2 !== c2, A3 = h2 !== a2, L3 = !o2.isPaddingEqual(u2), R6 = (o3) => (_3) => {
            const m3 = _3 * D4, x4 = 1 / I3(m3);
            o3.zoom = _3 === 1 ? l2 : r2 + o3.scaleZoom(x4), P2 && (o3.bearing = e.number(n2, c2, _3)), A3 && (o3.pitch = e.number(a2, h2, _3)), L3 && (o3.interpolatePadding(s3, u2, _3), p2 = o3.centerPoint.add(d2));
            const y3 = _3 === 1 ? f2 : o3.unproject(g2.add(v3.mult(z2(m3))).mult(x4));
            return o3.setLocationAtPoint(o3.renderWorldCopies ? y3.wrap() : y3, p2), o3._updateCenterElevation(), t2.preloadOnly || this._fireMoveEvents(i3), o3;
          };
          if (t2.preloadOnly) {
            const e2 = this._emulate(R6, t2.duration, o2);
            return this._preloadTiles(e2), this;
          }
          return this._zooming = true, this._rotating = P2, this._pitching = A3, this._padding = L3, this._prepareEase(i3, false), this._ease(R6(o2), () => this._afterEase(i3), t2), this;
        }
        isEasing() {
          return !!this._easeFrameId;
        }
        stop() {
          return this._stop();
        }
        _stop(e2, t2) {
          if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
            const e3 = this._onEaseEnd;
            delete this._onEaseEnd, e3.call(this, t2);
          }
          if (!e2) {
            const e3 = this.handlers;
            e3 && e3.stop(false);
          }
          return this;
        }
        _ease(t2, i3, o2) {
          o2.animate === false || o2.duration === 0 ? (t2(1), i3()) : (this._easeStart = e.exported.now(), this._easeOptions = o2, this._onEaseFrame = t2, this._onEaseEnd = i3, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
        }
        _renderFrameCallback() {
          const t2 = Math.min((e.exported.now() - this._easeStart) / this._easeOptions.duration, 1);
          this._onEaseFrame(this._easeOptions.easing(t2)), t2 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
        }
        _normalizeBearing(t2, i3) {
          t2 = e.wrap(t2, -180, 180);
          const o2 = Math.abs(t2 - i3);
          return Math.abs(t2 - 360 - i3) < o2 && (t2 -= 360), Math.abs(t2 + 360 - i3) < o2 && (t2 += 360), t2;
        }
        _normalizeCenter(e2) {
          const t2 = this.transform;
          if (!t2.renderWorldCopies || t2.maxBounds)
            return;
          const i3 = e2.lng - t2.center.lng;
          e2.lng += i3 > 180 ? -360 : i3 < -180 ? 360 : 0;
        }
        _emulate(e2, t2, i3) {
          const o2 = Math.ceil(15 * t2 / 1e3), r2 = [], n2 = e2(i3.clone());
          for (let e3 = 0; e3 <= o2; e3++) {
            const t3 = n2(e3 / o2);
            r2.push(t3.clone());
          }
          return r2;
        }
      }
      class Mr {
        constructor(t2 = {}) {
          this.options = t2, e.bindAll(["_toggleAttribution", "_updateEditLink", "_updateData", "_updateCompact"], this);
        }
        getDefaultPosition() {
          return "bottom-right";
        }
        onAdd(e2) {
          const t2 = this.options && this.options.compact;
          return this._map = e2, this._container = a.create("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = a.create("button", "mapboxgl-ctrl-attrib-button", this._container), a.create("span", "mapboxgl-ctrl-icon", this._compactButton).setAttribute("aria-hidden", true), this._compactButton.type = "button", this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = a.create("div", "mapboxgl-ctrl-attrib-inner", this._container), this._innerContainer.setAttribute("role", "list"), t2 && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), t2 === void 0 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
        }
        onRemove() {
          this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
        }
        _setElementTitle(e2, t2) {
          const i3 = this._map._getUIString(`AttributionControl.${t2}`);
          e2.setAttribute("aria-label", i3), e2.removeAttribute("title"), e2.firstElementChild && e2.firstElementChild.setAttribute("title", i3);
        }
        _toggleAttribution() {
          this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "true"));
        }
        _updateEditLink() {
          let t2 = this._editLink;
          t2 || (t2 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
          const i3 = [{ key: "owner", value: this.styleOwner }, { key: "id", value: this.styleId }, { key: "access_token", value: this._map._requestManager._customAccessToken || e.config.ACCESS_TOKEN }];
          if (t2) {
            const o2 = i3.reduce((e2, t3, o3) => (t3.value && (e2 += `${t3.key}=${t3.value}${o3 < i3.length - 1 ? "&" : ""}`), e2), "?");
            t2.href = `${e.config.FEEDBACK_URL}/${o2}${this._map._hash ? this._map._hash.getHashString(true) : ""}`, t2.rel = "noopener nofollow", this._setElementTitle(t2, "MapFeedback");
          }
        }
        _updateData(e2) {
          !e2 || e2.sourceDataType !== "metadata" && e2.sourceDataType !== "visibility" && e2.dataType !== "style" || (this._updateAttributions(), this._updateEditLink());
        }
        _updateAttributions() {
          if (!this._map.style)
            return;
          let e2 = [];
          if (this._map.style.stylesheet) {
            const e3 = this._map.style.stylesheet;
            this.styleOwner = e3.owner, this.styleId = e3.id;
          }
          const t2 = this._map.style._sourceCaches;
          for (const i4 in t2) {
            const o2 = t2[i4];
            if (o2.used) {
              const t3 = o2.getSource();
              t3.attribution && e2.indexOf(t3.attribution) < 0 && e2.push(t3.attribution);
            }
          }
          e2.sort((e3, t3) => e3.length - t3.length), e2 = e2.filter((t3, i4) => {
            for (let o2 = i4 + 1; o2 < e2.length; o2++)
              if (e2[o2].indexOf(t3) >= 0)
                return false;
            return true;
          }), this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e2 = [...this.options.customAttribution, ...e2] : e2.unshift(this.options.customAttribution));
          const i3 = e2.join(" | ");
          i3 !== this._attribHTML && (this._attribHTML = i3, e2.length ? (this._innerContainer.innerHTML = i3, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
        }
        _updateCompact() {
          this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
        }
      }
      class Sr {
        constructor() {
          e.bindAll(["_updateLogo"], this), e.bindAll(["_updateCompact"], this);
        }
        onAdd(e2) {
          this._map = e2, this._container = a.create("div", "mapboxgl-ctrl");
          const t2 = a.create("a", "mapboxgl-ctrl-logo");
          return t2.target = "_blank", t2.rel = "noopener nofollow", t2.href = "https://www.mapbox.com/", t2.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t2.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t2), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
        }
        onRemove() {
          this._container.remove(), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
        }
        getDefaultPosition() {
          return "bottom-left";
        }
        _updateLogo(e2) {
          e2 && e2.sourceDataType !== "metadata" || (this._container.style.display = this._logoRequired() ? "block" : "none");
        }
        _logoRequired() {
          if (!this._map.style)
            return true;
          const e2 = this._map.style._sourceCaches;
          if (Object.entries(e2).length === 0)
            return true;
          for (const t2 in e2) {
            const i3 = e2[t2].getSource();
            if (i3.hasOwnProperty("mapbox_logo") && !i3.mapbox_logo)
              return false;
          }
          return true;
        }
        _updateCompact() {
          const e2 = this._container.children;
          if (e2.length) {
            const t2 = e2[0];
            this._map.getCanvasContainer().offsetWidth < 250 ? t2.classList.add("mapboxgl-compact") : t2.classList.remove("mapboxgl-compact");
          }
        }
      }
      class Ir {
        constructor() {
          this._queue = [], this._id = 0, this._cleared = false, this._currentlyRunning = false;
        }
        add(e2) {
          const t2 = ++this._id;
          return this._queue.push({ callback: e2, id: t2, cancelled: false }), t2;
        }
        remove(e2) {
          const t2 = this._currentlyRunning, i3 = t2 ? this._queue.concat(t2) : this._queue;
          for (const t3 of i3)
            if (t3.id === e2)
              return void (t3.cancelled = true);
        }
        run(e2 = 0) {
          const t2 = this._currentlyRunning = this._queue;
          this._queue = [];
          for (const i3 of t2)
            if (!i3.cancelled && (i3.callback(e2), this._cleared))
              break;
          this._cleared = false, this._currentlyRunning = false;
        }
        clear() {
          this._currentlyRunning && (this._cleared = true), this._queue = [];
        }
      }
      function zr(t2, i3, o2) {
        if (t2 = new e.LngLat(t2.lng, t2.lat), i3) {
          const r2 = new e.LngLat(t2.lng - 360, t2.lat), n2 = new e.LngLat(t2.lng + 360, t2.lat), a2 = 360 * Math.ceil(Math.abs(t2.lng - o2.center.lng) / 360), s3 = o2.locationPoint(t2).distSqr(i3), l2 = i3.x < 0 || i3.y < 0 || i3.x > o2.width || i3.y > o2.height;
          o2.locationPoint(r2).distSqr(i3) < s3 && (l2 || Math.abs(r2.lng - o2.center.lng) < a2) ? t2 = r2 : o2.locationPoint(n2).distSqr(i3) < s3 && (l2 || Math.abs(n2.lng - o2.center.lng) < a2) && (t2 = n2);
        }
        for (; Math.abs(t2.lng - o2.center.lng) > 180; ) {
          const e2 = o2.locationPoint(t2);
          if (e2.x >= 0 && e2.y >= 0 && e2.x <= o2.width && e2.y <= o2.height)
            break;
          t2.lng > o2.center.lng ? t2.lng -= 360 : t2.lng += 360;
        }
        return t2;
      }
      const Dr = { center: "translate(-50%,-50%)", top: "translate(-50%,0)", "top-left": "translate(0,0)", "top-right": "translate(-100%,0)", bottom: "translate(-50%,-100%)", "bottom-left": "translate(0,-100%)", "bottom-right": "translate(-100%,-100%)", left: "translate(0,-50%)", right: "translate(-100%,-50%)" };
      class Pr extends e.Evented {
        constructor(t2, i3) {
          if (super(), (t2 instanceof e.window.HTMLElement || i3) && (t2 = e.extend({ element: t2 }, i3)), e.bindAll(["_update", "_onMove", "_onUp", "_addDragHandler", "_onMapClick", "_onKeyPress", "_clearFadeTimer"], this), this._anchor = t2 && t2.anchor || "center", this._color = t2 && t2.color || "#3FB1CE", this._scale = t2 && t2.scale || 1, this._draggable = t2 && t2.draggable || false, this._clickTolerance = t2 && t2.clickTolerance || 0, this._isDragging = false, this._state = "inactive", this._rotation = t2 && t2.rotation || 0, this._rotationAlignment = t2 && t2.rotationAlignment || "auto", this._pitchAlignment = t2 && t2.pitchAlignment && t2.pitchAlignment !== "auto" ? t2.pitchAlignment : this._rotationAlignment, this._updateMoving = () => this._update(true), t2 && t2.element)
            this._element = t2.element, this._offset = e.pointGeometry.convert(t2 && t2.offset || [0, 0]);
          else {
            this._defaultMarker = true, this._element = a.create("div");
            const i4 = 41, o3 = 27, r2 = a.createSVG("svg", { display: "block", height: i4 * this._scale + "px", width: o3 * this._scale + "px", viewBox: `0 0 ${o3} ${i4}` }, this._element), n2 = a.createSVG("radialGradient", { id: "shadowGradient" }, a.createSVG("defs", {}, r2));
            a.createSVG("stop", { offset: "10%", "stop-opacity": 0.4 }, n2), a.createSVG("stop", { offset: "100%", "stop-opacity": 0.05 }, n2), a.createSVG("ellipse", { cx: 13.5, cy: 34.8, rx: 10.5, ry: 5.25, fill: "url(#shadowGradient)" }, r2), a.createSVG("path", { fill: this._color, d: "M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z" }, r2), a.createSVG("path", { opacity: 0.25, d: "M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z" }, r2), a.createSVG("circle", { fill: "white", cx: 13.5, cy: 13.5, r: 5.5 }, r2), this._offset = e.pointGeometry.convert(t2 && t2.offset || [0, -14]);
          }
          this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", "Map marker"), this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", (e2) => {
            e2.preventDefault();
          }), this._element.addEventListener("mousedown", (e2) => {
            e2.preventDefault();
          });
          const o2 = this._element.classList;
          for (const e2 in Dr)
            o2.remove(`mapboxgl-marker-anchor-${e2}`);
          o2.add(`mapboxgl-marker-anchor-${this._anchor}`), this._popup = null;
        }
        addTo(e2) {
          return e2 === this._map || (this.remove(), this._map = e2, e2.getCanvasContainer().appendChild(this._element), e2.on("move", this._updateMoving), e2.on("moveend", this._update), e2.on("remove", this._clearFadeTimer), e2._addMarker(this), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick)), this;
        }
        remove() {
          return this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._updateMoving), this._map.off("moveend", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), this._map.off("remove", this._clearFadeTimer), this._map._removeMarker(this), delete this._map), this._clearFadeTimer(), this._element.remove(), this._popup && this._popup.remove(), this;
        }
        getLngLat() {
          return this._lngLat;
        }
        setLngLat(t2) {
          return this._lngLat = e.LngLat.convert(t2), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(true), this;
        }
        getElement() {
          return this._element;
        }
        setPopup(e2) {
          if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeAttribute("role"), this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e2) {
            if (!("offset" in e2.options)) {
              const t2 = 38.1, i3 = 13.5, o2 = Math.sqrt(Math.pow(i3, 2) / 2);
              e2.options.offset = this._defaultMarker ? { top: [0, 0], "top-left": [0, 0], "top-right": [0, 0], bottom: [0, -t2], "bottom-left": [o2, -1 * (t2 - i3 + o2)], "bottom-right": [-o2, -1 * (t2 - i3 + o2)], left: [i3, -1 * (t2 - i3)], right: [-i3, -1 * (t2 - i3)] } : this._offset;
            }
            this._popup = e2, this._lngLat && this._popup.setLngLat(this._lngLat), this._element.setAttribute("role", "button"), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress), this._element.setAttribute("aria-expanded", "false");
          }
          return this;
        }
        _onKeyPress(e2) {
          const t2 = e2.code, i3 = e2.charCode || e2.keyCode;
          t2 !== "Space" && t2 !== "Enter" && i3 !== 32 && i3 !== 13 || this.togglePopup();
        }
        _onMapClick(e2) {
          const t2 = e2.originalEvent.target, i3 = this._element;
          this._popup && (t2 === i3 || i3.contains(t2)) && this.togglePopup();
        }
        getPopup() {
          return this._popup;
        }
        togglePopup() {
          const e2 = this._popup;
          return e2 ? (e2.isOpen() ? (e2.remove(), this._element.setAttribute("aria-expanded", "false")) : (e2.addTo(this._map), this._element.setAttribute("aria-expanded", "true")), this) : this;
        }
        _evaluateOpacity() {
          const e2 = this._pos ? this._pos.sub(this._transformedOffset()) : null;
          if (!this._withinScreenBounds(e2))
            return void this._clearFadeTimer();
          const t2 = this._map.unproject(e2);
          let i3 = false;
          if (this._map.transform._terrainEnabled() && this._map.getTerrain()) {
            const e3 = this._map.getFreeCameraOptions();
            if (e3.position) {
              const o3 = e3.position.toLngLat();
              i3 = o3.distanceTo(t2) < 0.9 * o3.distanceTo(this._lngLat);
            }
          }
          const o2 = (1 - this._map._queryFogOpacity(t2)) * (i3 ? 0.2 : 1);
          this._element.style.opacity = `${o2}`, this._popup && this._popup._setOpacity(`${o2}`), this._fadeTimer = null;
        }
        _clearFadeTimer() {
          this._fadeTimer && (clearTimeout(this._fadeTimer), this._fadeTimer = null);
        }
        _withinScreenBounds(e2) {
          const t2 = this._map.transform;
          return !!e2 && e2.x >= 0 && e2.x < t2.width && e2.y >= 0 && e2.y < t2.height;
        }
        _updateDOM() {
          const t2 = this._pos || new e.pointGeometry(0, 0), i3 = this._calculatePitch(), o2 = this._calculateRotation();
          this._element.style.transform = `${Dr[this._anchor]} translate(${t2.x}px, ${t2.y}px) rotateX(${i3}deg) rotateZ(${o2}deg)`;
        }
        _calculatePitch() {
          return this._pitchAlignment === "viewport" || this._pitchAlignment === "auto" ? 0 : this._pitchAlignment === "map" ? this._map.getPitch() : 0;
        }
        _calculateRotation() {
          return this._rotationAlignment === "viewport" || this._rotationAlignment === "auto" ? this._rotation : this._rotationAlignment === "map" ? this._rotation - this._map.getBearing() : 0;
        }
        _update(t2) {
          e.window.cancelAnimationFrame(this._updateFrameId), this._map && (this._map.transform.renderWorldCopies && (this._lngLat = zr(this._lngLat, this._pos, this._map.transform)), this._pos = this._map.project(this._lngLat)._add(this._transformedOffset()), t2 === true ? this._updateFrameId = e.window.requestAnimationFrame(() => {
            this._element && this._pos && this._anchor && (this._pos = this._pos.round(), this._updateDOM());
          }) : this._pos = this._pos.round(), this._map._requestDomTask(() => {
            this._map && (this._element && this._pos && this._anchor && this._updateDOM(), !this._map.getTerrain() && !this._map.getFog() || this._fadeTimer || (this._fadeTimer = setTimeout(this._evaluateOpacity.bind(this), 60)));
          }));
        }
        _transformedOffset() {
          if (!this._defaultMarker)
            return this._offset;
          const e2 = this._map.transform, t2 = this._offset.mult(this._scale);
          return this._rotationAlignment === "map" && t2._rotate(e2.angle), this._pitchAlignment === "map" && (t2.y *= Math.cos(e2._pitch)), t2;
        }
        getOffset() {
          return this._offset;
        }
        setOffset(t2) {
          return this._offset = e.pointGeometry.convert(t2), this._update(), this;
        }
        _onMove(t2) {
          if (!this._isDragging) {
            const e2 = this._clickTolerance || this._map._clickTolerance;
            this._isDragging = t2.point.dist(this._pointerdownPos) >= e2;
          }
          this._isDragging && (this._pos = t2.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", this._state === "pending" && (this._state = "active", this.fire(new e.Event("dragstart"))), this.fire(new e.Event("drag")));
        }
        _onUp() {
          this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = false, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), this._state === "active" && this.fire(new e.Event("dragend")), this._state = "inactive";
        }
        _addDragHandler(e2) {
          this._element.contains(e2.originalEvent.target) && (e2.preventDefault(), this._positionDelta = e2.point.sub(this._pos).add(this._transformedOffset()), this._pointerdownPos = e2.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
        }
        setDraggable(e2) {
          return this._draggable = !!e2, this._map && (e2 ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
        }
        isDraggable() {
          return this._draggable;
        }
        setRotation(e2) {
          return this._rotation = e2 || 0, this._update(), this;
        }
        getRotation() {
          return this._rotation;
        }
        setRotationAlignment(e2) {
          return this._rotationAlignment = e2 || "auto", this._update(), this;
        }
        getRotationAlignment() {
          return this._rotationAlignment;
        }
        setPitchAlignment(e2) {
          return this._pitchAlignment = e2 && e2 !== "auto" ? e2 : this._rotationAlignment, this._update(), this;
        }
        getPitchAlignment() {
          return this._pitchAlignment;
        }
      }
      class Ar {
        constructor(e2) {
          this.jumpTo(e2);
        }
        getValue(t2) {
          if (t2 <= this._startTime)
            return this._start;
          if (t2 >= this._endTime)
            return this._end;
          const i3 = e.easeCubicInOut((t2 - this._startTime) / (this._endTime - this._startTime));
          return this._start * (1 - i3) + this._end * i3;
        }
        isEasing(e2) {
          return e2 >= this._startTime && e2 <= this._endTime;
        }
        jumpTo(e2) {
          this._startTime = -1 / 0, this._endTime = -1 / 0, this._start = e2, this._end = e2;
        }
        easeTo(e2, t2, i3) {
          this._start = this.getValue(t2), this._end = e2, this._startTime = t2, this._endTime = t2 + i3;
        }
      }
      const Lr = { "AttributionControl.ToggleAttribution": "Toggle attribution", "AttributionControl.MapFeedback": "Map feedback", "FullscreenControl.Enter": "Enter fullscreen", "FullscreenControl.Exit": "Exit fullscreen", "GeolocateControl.FindMyLocation": "Find my location", "GeolocateControl.LocationNotAvailable": "Location not available", "LogoControl.Title": "Mapbox logo", "NavigationControl.ResetBearing": "Reset bearing to north", "NavigationControl.ZoomIn": "Zoom in", "NavigationControl.ZoomOut": "Zoom out", "ScaleControl.Feet": "ft", "ScaleControl.Meters": "m", "ScaleControl.Kilometers": "km", "ScaleControl.Miles": "mi", "ScaleControl.NauticalMiles": "nm", "ScrollZoomBlocker.CtrlMessage": "Use ctrl + scroll to zoom the map", "ScrollZoomBlocker.CmdMessage": "Use \u2318 + scroll to zoom the map", "TouchPanBlocker.Message": "Use two fingers to move the map" }, { HTMLImageElement: Rr, HTMLElement: kr, ImageBitmap: Or } = e.window, Br = { center: [0, 0], zoom: 0, bearing: 0, pitch: 0, minZoom: -2, maxZoom: 22, minPitch: 0, maxPitch: 85, interactive: true, scrollZoom: true, boxZoom: true, dragRotate: true, dragPan: true, keyboard: true, doubleClickZoom: true, touchZoomRotate: true, touchPitch: true, cooperativeGestures: false, bearingSnap: 7, clickTolerance: 3, pitchWithRotate: true, hash: false, attributionControl: true, failIfMajorPerformanceCaveat: false, preserveDrawingBuffer: false, trackResize: true, optimizeForTerrain: true, renderWorldCopies: true, refreshExpiredTiles: true, maxTileCacheSize: null, localIdeographFontFamily: "sans-serif", localFontFamily: null, transformRequest: null, accessToken: null, fadeDuration: 300, crossSourceCollisions: true };
      function Fr(e2) {
        e2.parentNode && e2.parentNode.removeChild(e2);
      }
      const Ur = { showCompass: true, showZoom: true, visualizePitch: false };
      class Nr {
        constructor(t2, i3, o2 = false) {
          this._clickTolerance = 10, this.element = i3, this.mouseRotate = new Yo({ clickTolerance: t2.dragRotate._mouseRotate._clickTolerance }), this.map = t2, o2 && (this.mousePitch = new Jo({ clickTolerance: t2.dragRotate._mousePitch._clickTolerance })), e.bindAll(["mousedown", "mousemove", "mouseup", "touchstart", "touchmove", "touchend", "reset"], this), i3.addEventListener("mousedown", this.mousedown), i3.addEventListener("touchstart", this.touchstart, { passive: false }), i3.addEventListener("touchmove", this.touchmove), i3.addEventListener("touchend", this.touchend), i3.addEventListener("touchcancel", this.reset);
        }
        down(e2, t2) {
          this.mouseRotate.mousedown(e2, t2), this.mousePitch && this.mousePitch.mousedown(e2, t2), a.disableDrag();
        }
        move(e2, t2) {
          const i3 = this.map, o2 = this.mouseRotate.mousemoveWindow(e2, t2);
          if (o2 && o2.bearingDelta && i3.setBearing(i3.getBearing() + o2.bearingDelta), this.mousePitch) {
            const o3 = this.mousePitch.mousemoveWindow(e2, t2);
            o3 && o3.pitchDelta && i3.setPitch(i3.getPitch() + o3.pitchDelta);
          }
        }
        off() {
          const e2 = this.element;
          e2.removeEventListener("mousedown", this.mousedown), e2.removeEventListener("touchstart", this.touchstart, { passive: false }), e2.removeEventListener("touchmove", this.touchmove), e2.removeEventListener("touchend", this.touchend), e2.removeEventListener("touchcancel", this.reset), this.offTemp();
        }
        offTemp() {
          a.enableDrag(), e.window.removeEventListener("mousemove", this.mousemove), e.window.removeEventListener("mouseup", this.mouseup);
        }
        mousedown(t2) {
          this.down(e.extend({}, t2, { ctrlKey: true, preventDefault: () => t2.preventDefault() }), a.mousePos(this.element, t2)), e.window.addEventListener("mousemove", this.mousemove), e.window.addEventListener("mouseup", this.mouseup);
        }
        mousemove(e2) {
          this.move(e2, a.mousePos(this.element, e2));
        }
        mouseup(e2) {
          this.mouseRotate.mouseupWindow(e2), this.mousePitch && this.mousePitch.mouseupWindow(e2), this.offTemp();
        }
        touchstart(e2) {
          e2.targetTouches.length !== 1 ? this.reset() : (this._startPos = this._lastPos = a.touchPos(this.element, e2.targetTouches)[0], this.down({ type: "mousedown", button: 0, ctrlKey: true, preventDefault: () => e2.preventDefault() }, this._startPos));
        }
        touchmove(e2) {
          e2.targetTouches.length !== 1 ? this.reset() : (this._lastPos = a.touchPos(this.element, e2.targetTouches)[0], this.move({ preventDefault: () => e2.preventDefault() }, this._lastPos));
        }
        touchend(e2) {
          e2.targetTouches.length === 0 && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
        }
        reset() {
          this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
        }
      }
      const Gr = { positionOptions: { enableHighAccuracy: false, maximumAge: 0, timeout: 6e3 }, fitBoundsOptions: { maxZoom: 15 }, trackUserLocation: false, showAccuracyCircle: true, showUserLocation: true, showUserHeading: false };
      let jr, Zr = 0, Vr = false;
      const Wr = { maxWidth: 100, unit: "metric" };
      function qr(e2, t2, i3) {
        const o2 = i3 && i3.maxWidth || 100, r2 = e2._containerHeight / 2, n2 = e2.unproject([0, r2]), a2 = e2.unproject([o2, r2]), s3 = n2.distanceTo(a2);
        if (i3 && i3.unit === "imperial") {
          const i4 = 3.2808 * s3;
          i4 > 5280 ? Xr(t2, o2, i4 / 5280, e2._getUIString("ScaleControl.Miles"), e2) : Xr(t2, o2, i4, e2._getUIString("ScaleControl.Feet"), e2);
        } else
          i3 && i3.unit === "nautical" ? Xr(t2, o2, s3 / 1852, e2._getUIString("ScaleControl.NauticalMiles"), e2) : s3 >= 1e3 ? Xr(t2, o2, s3 / 1e3, e2._getUIString("ScaleControl.Kilometers"), e2) : Xr(t2, o2, s3, e2._getUIString("ScaleControl.Meters"), e2);
      }
      function Xr(e2, t2, i3, o2, r2) {
        const n2 = function(e3) {
          const t3 = Math.pow(10, `${Math.floor(e3)}`.length - 1);
          let i4 = e3 / t3;
          return i4 = i4 >= 10 ? 10 : i4 >= 5 ? 5 : i4 >= 3 ? 3 : i4 >= 2 ? 2 : i4 >= 1 ? 1 : function(e4) {
            const t4 = Math.pow(10, Math.ceil(-Math.log(e4) / Math.LN10));
            return Math.round(e4 * t4) / t4;
          }(i4), t3 * i4;
        }(i3), a2 = n2 / i3;
        r2._requestDomTask(() => {
          e2.style.width = t2 * a2 + "px", e2.innerHTML = `${n2}&nbsp;${o2}`;
        });
      }
      const $r = { closeButton: true, closeOnClick: true, focusAfterOpen: true, className: "", maxWidth: "240px" }, Hr = ["a[href]", "[tabindex]:not([tabindex='-1'])", "[contenteditable]:not([contenteditable='false'])", "button:not([disabled])", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].join(", "), Kr = { version: e.version, supported: t, setRTLTextPlugin: e.setRTLTextPlugin, getRTLTextPluginStatus: e.getRTLTextPluginStatus, Map: class extends Cr {
        constructor(t2) {
          if ((t2 = e.extend({}, Br, t2)).minZoom != null && t2.maxZoom != null && t2.minZoom > t2.maxZoom)
            throw new Error("maxZoom must be greater than or equal to minZoom");
          if (t2.minPitch != null && t2.maxPitch != null && t2.minPitch > t2.maxPitch)
            throw new Error("maxPitch must be greater than or equal to minPitch");
          if (t2.minPitch != null && t2.minPitch < 0)
            throw new Error("minPitch must be greater than or equal to 0");
          if (t2.maxPitch != null && t2.maxPitch > 85)
            throw new Error("maxPitch must be less than or equal to 85");
          if (super(new So(t2.minZoom, t2.maxZoom, t2.minPitch, t2.maxPitch, t2.renderWorldCopies), t2), this._interactive = t2.interactive, this._minTileCacheSize = t2.minTileCacheSize, this._maxTileCacheSize = t2.maxTileCacheSize, this._failIfMajorPerformanceCaveat = t2.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = t2.preserveDrawingBuffer, this._antialias = t2.antialias, this._trackResize = t2.trackResize, this._bearingSnap = t2.bearingSnap, this._refreshExpiredTiles = t2.refreshExpiredTiles, this._fadeDuration = t2.fadeDuration, this._isInitialLoad = true, this._crossSourceCollisions = t2.crossSourceCollisions, this._crossFadingFactor = 1, this._collectResourceTiming = t2.collectResourceTiming, this._optimizeForTerrain = t2.optimizeForTerrain, this._renderTaskQueue = new Ir(), this._domRenderTaskQueue = new Ir(), this._controls = [], this._markers = [], this._mapId = e.uniqueId(), this._locale = e.extend({}, Lr, t2.locale), this._clickTolerance = t2.clickTolerance, this._cooperativeGestures = t2.cooperativeGestures, this._containerWidth = 0, this._containerHeight = 0, this._averageElevationLastSampledAt = -1 / 0, this._averageElevation = new Ar(0), this._requestManager = new e.RequestManager(t2.transformRequest, t2.accessToken, t2.testMode), this._silenceAuthErrors = !!t2.testMode, typeof t2.container == "string") {
            if (this._container = e.window.document.getElementById(t2.container), !this._container)
              throw new Error(`Container '${t2.container}' not found.`);
          } else {
            if (!(t2.container instanceof kr))
              throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
            this._container = t2.container;
          }
          if (this._container.childNodes.length > 0 && e.warnOnce("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."), t2.maxBounds && this.setMaxBounds(t2.maxBounds), e.bindAll(["_onWindowOnline", "_onWindowResize", "_onMapScroll", "_contextLost", "_contextRestored"], this), this._setupContainer(), this._setupPainter(), this.painter === void 0)
            throw new Error("Failed to initialize WebGL.");
          this.on("move", () => this._update(false)), this.on("moveend", () => this._update(false)), this.on("zoom", () => this._update(true)), e.window !== void 0 && (e.window.addEventListener("online", this._onWindowOnline, false), e.window.addEventListener("resize", this._onWindowResize, false), e.window.addEventListener("orientationchange", this._onWindowResize, false), e.window.addEventListener("webkitfullscreenchange", this._onWindowResize, false)), this.handlers = new Tr(this, t2), this._localFontFamily = t2.localFontFamily, this._localIdeographFontFamily = t2.localIdeographFontFamily, t2.style && this.setStyle(t2.style, { localFontFamily: this._localFontFamily, localIdeographFontFamily: this._localIdeographFontFamily }), t2.projection && this.setProjection(t2.projection), this._hash = t2.hash && new zo(typeof t2.hash == "string" && t2.hash || void 0).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({ center: t2.center, zoom: t2.zoom, bearing: t2.bearing, pitch: t2.pitch }), t2.bounds && (this.resize(), this.fitBounds(t2.bounds, e.extend({}, t2.fitBoundsOptions, { duration: 0 })))), this.resize(), t2.attributionControl && this.addControl(new Mr({ customAttribution: t2.customAttribution })), this._logoControl = new Sr(), this.addControl(this._logoControl, t2.logoPosition), this.on("style.load", () => {
            this.transform.unmodified && this.jumpTo(this.style.stylesheet);
          }), this.on("data", (t3) => {
            this._update(t3.dataType === "style"), this.fire(new e.Event(`${t3.dataType}data`, t3));
          }), this.on("dataloading", (t3) => {
            this.fire(new e.Event(`${t3.dataType}dataloading`, t3));
          });
        }
        _getMapId() {
          return this._mapId;
        }
        addControl(t2, i3) {
          if (i3 === void 0 && (i3 = t2.getDefaultPosition ? t2.getDefaultPosition() : "top-right"), !t2 || !t2.onAdd)
            return this.fire(new e.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
          const o2 = t2.onAdd(this);
          this._controls.push(t2);
          const r2 = this._controlPositions[i3];
          return i3.indexOf("bottom") !== -1 ? r2.insertBefore(o2, r2.firstChild) : r2.appendChild(o2), this;
        }
        removeControl(t2) {
          if (!t2 || !t2.onRemove)
            return this.fire(new e.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
          const i3 = this._controls.indexOf(t2);
          return i3 > -1 && this._controls.splice(i3, 1), t2.onRemove(this), this;
        }
        hasControl(e2) {
          return this._controls.indexOf(e2) > -1;
        }
        getContainer() {
          return this._container;
        }
        getCanvasContainer() {
          return this._canvasContainer;
        }
        getCanvas() {
          return this._canvas;
        }
        resize(t2) {
          if (this._updateContainerDimensions(), this._containerWidth === this.transform.width && this._containerHeight === this.transform.height)
            return this;
          this._resizeCanvas(this._containerWidth, this._containerHeight), this.transform.resize(this._containerWidth, this._containerHeight), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight));
          const i3 = !this._moving;
          return i3 && this.fire(new e.Event("movestart", t2)).fire(new e.Event("move", t2)), this.fire(new e.Event("resize", t2)), i3 && this.fire(new e.Event("moveend", t2)), this;
        }
        getBounds() {
          return this.transform.getBounds();
        }
        getMaxBounds() {
          return this.transform.getMaxBounds() || null;
        }
        setMaxBounds(t2) {
          return this.transform.setMaxBounds(e.LngLatBounds.convert(t2)), this._update();
        }
        setMinZoom(t2) {
          if ((t2 = t2 == null ? -2 : t2) >= -2 && t2 <= this.transform.maxZoom)
            return this.transform.minZoom = t2, this._update(), this.getZoom() < t2 ? this.setZoom(t2) : this.fire(new e.Event("zoomstart")).fire(new e.Event("zoom")).fire(new e.Event("zoomend")), this;
          throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
        }
        getMinZoom() {
          return this.transform.minZoom;
        }
        setMaxZoom(t2) {
          if ((t2 = t2 == null ? 22 : t2) >= this.transform.minZoom)
            return this.transform.maxZoom = t2, this._update(), this.getZoom() > t2 ? this.setZoom(t2) : this.fire(new e.Event("zoomstart")).fire(new e.Event("zoom")).fire(new e.Event("zoomend")), this;
          throw new Error("maxZoom must be greater than the current minZoom");
        }
        getMaxZoom() {
          return this.transform.maxZoom;
        }
        setMinPitch(t2) {
          if ((t2 = t2 == null ? 0 : t2) < 0)
            throw new Error("minPitch must be greater than or equal to 0");
          if (t2 >= 0 && t2 <= this.transform.maxPitch)
            return this.transform.minPitch = t2, this._update(), this.getPitch() < t2 ? this.setPitch(t2) : this.fire(new e.Event("pitchstart")).fire(new e.Event("pitch")).fire(new e.Event("pitchend")), this;
          throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
        }
        getMinPitch() {
          return this.transform.minPitch;
        }
        setMaxPitch(t2) {
          if ((t2 = t2 == null ? 85 : t2) > 85)
            throw new Error("maxPitch must be less than or equal to 85");
          if (t2 >= this.transform.minPitch)
            return this.transform.maxPitch = t2, this._update(), this.getPitch() > t2 ? this.setPitch(t2) : this.fire(new e.Event("pitchstart")).fire(new e.Event("pitch")).fire(new e.Event("pitchend")), this;
          throw new Error("maxPitch must be greater than the current minPitch");
        }
        getMaxPitch() {
          return this.transform.maxPitch;
        }
        getRenderWorldCopies() {
          return this.transform.renderWorldCopies;
        }
        setRenderWorldCopies(e2) {
          return this.transform.renderWorldCopies = e2, this._update();
        }
        getProjection() {
          return this.transform.getProjection();
        }
        setProjection(e2) {
          return this._lazyInitEmptyStyle(), typeof e2 == "string" && (e2 = { name: e2 }), this._runtimeProjection = e2, this.style.updateProjection(), this._transitionFromGlobe = false, this;
        }
        project(t2) {
          return this.transform.locationPoint3D(e.LngLat.convert(t2));
        }
        unproject(t2) {
          return this.transform.pointLocation3D(e.pointGeometry.convert(t2));
        }
        isMoving() {
          return this._moving || this.handlers && this.handlers.isMoving();
        }
        isZooming() {
          return this._zooming || this.handlers && this.handlers.isZooming();
        }
        isRotating() {
          return this._rotating || this.handlers && this.handlers.isRotating();
        }
        _createDelegatedListener(e2, t2, i3) {
          if (e2 === "mouseenter" || e2 === "mouseover") {
            let o2 = false;
            const r2 = (r3) => {
              const n3 = t2.filter((e3) => this.getLayer(e3)), a2 = n3.length ? this.queryRenderedFeatures(r3.point, { layers: n3 }) : [];
              a2.length ? o2 || (o2 = true, i3.call(this, new Fo(e2, this, r3.originalEvent, { features: a2 }))) : o2 = false;
            }, n2 = () => {
              o2 = false;
            };
            return { layers: new Set(t2), listener: i3, delegates: { mousemove: r2, mouseout: n2 } };
          }
          if (e2 === "mouseleave" || e2 === "mouseout") {
            let o2 = false;
            const r2 = (r3) => {
              const n3 = t2.filter((e3) => this.getLayer(e3));
              (n3.length ? this.queryRenderedFeatures(r3.point, { layers: n3 }) : []).length ? o2 = true : o2 && (o2 = false, i3.call(this, new Fo(e2, this, r3.originalEvent)));
            }, n2 = (t3) => {
              o2 && (o2 = false, i3.call(this, new Fo(e2, this, t3.originalEvent)));
            };
            return { layers: new Set(t2), listener: i3, delegates: { mousemove: r2, mouseout: n2 } };
          }
          {
            const o2 = (e3) => {
              const o3 = t2.filter((e4) => this.getLayer(e4)), r2 = o3.length ? this.queryRenderedFeatures(e3.point, { layers: o3 }) : [];
              r2.length && (e3.features = r2, i3.call(this, e3), delete e3.features);
            };
            return { layers: new Set(t2), listener: i3, delegates: { [e2]: o2 } };
          }
        }
        on(e2, t2, i3) {
          if (i3 === void 0)
            return super.on(e2, t2);
          Array.isArray(t2) || (t2 = [t2]);
          const o2 = this._createDelegatedListener(e2, t2, i3);
          this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e2] = this._delegatedListeners[e2] || [], this._delegatedListeners[e2].push(o2);
          for (const e3 in o2.delegates)
            this.on(e3, o2.delegates[e3]);
          return this;
        }
        once(e2, t2, i3) {
          if (i3 === void 0)
            return super.once(e2, t2);
          Array.isArray(t2) || (t2 = [t2]);
          const o2 = this._createDelegatedListener(e2, t2, i3);
          for (const e3 in o2.delegates)
            this.once(e3, o2.delegates[e3]);
          return this;
        }
        off(e2, t2, i3) {
          if (i3 === void 0)
            return super.off(e2, t2);
          t2 = new Set(Array.isArray(t2) ? t2 : [t2]);
          const o2 = (e3, t3) => {
            if (e3.size !== t3.size)
              return false;
            for (const i4 of e3)
              if (!t3.has(i4))
                return false;
            return true;
          }, r2 = this._delegatedListeners ? this._delegatedListeners[e2] : void 0;
          return r2 && ((e3) => {
            for (let r3 = 0; r3 < e3.length; r3++) {
              const n2 = e3[r3];
              if (n2.listener === i3 && o2(n2.layers, t2)) {
                for (const e4 in n2.delegates)
                  this.off(e4, n2.delegates[e4]);
                return e3.splice(r3, 1), this;
              }
            }
          })(r2), this;
        }
        queryRenderedFeatures(t2, i3) {
          return this.style ? (i3 !== void 0 || t2 === void 0 || t2 instanceof e.pointGeometry || Array.isArray(t2) || (i3 = t2, t2 = void 0), this.style.queryRenderedFeatures(t2 = t2 || [[0, 0], [this.transform.width, this.transform.height]], i3 = i3 || {}, this.transform)) : [];
        }
        querySourceFeatures(e2, t2) {
          return this.style.querySourceFeatures(e2, t2);
        }
        queryTerrainElevation(t2, i3) {
          const o2 = this.transform.elevation;
          return o2 ? (i3 = e.extend({}, { exaggerated: true }, i3), o2.getAtPoint(e.MercatorCoordinate.fromLngLat(t2), null, i3.exaggerated)) : null;
        }
        setStyle(t2, i3) {
          return (i3 = e.extend({}, { localIdeographFontFamily: this._localIdeographFontFamily, localFontFamily: this._localFontFamily }, i3)).diff !== false && i3.localIdeographFontFamily === this._localIdeographFontFamily && i3.localFontFamily === this._localFontFamily && this.style && t2 ? (this._diffStyle(t2, i3), this) : (this._localIdeographFontFamily = i3.localIdeographFontFamily, this._localFontFamily = i3.localFontFamily, this._updateStyle(t2, i3));
        }
        _getUIString(e2) {
          const t2 = this._locale[e2];
          if (t2 == null)
            throw new Error(`Missing UI string '${e2}'`);
          return t2;
        }
        _updateStyle(e2, t2) {
          return this.style && (this.style.setEventedParent(null), this.style._remove(), delete this.style), e2 && (this.style = new Nt(this, t2 || {}), this.style.setEventedParent(this, { style: this.style }), typeof e2 == "string" ? this.style.loadURL(e2) : this.style.loadJSON(e2)), this._updateTerrain(), this;
        }
        _lazyInitEmptyStyle() {
          this.style || (this.style = new Nt(this, {}), this.style.setEventedParent(this, { style: this.style }), this.style.loadEmpty());
        }
        _diffStyle(t2, i3) {
          if (typeof t2 == "string") {
            const o2 = this._requestManager.normalizeStyleURL(t2), r2 = this._requestManager.transformRequest(o2, e.ResourceType.Style);
            e.getJSON(r2, (t3, o3) => {
              t3 ? this.fire(new e.ErrorEvent(t3)) : o3 && this._updateDiff(o3, i3);
            });
          } else
            typeof t2 == "object" && this._updateDiff(t2, i3);
        }
        _updateDiff(t2, i3) {
          try {
            this.style.setState(t2) && this._update(true);
          } catch (o2) {
            e.warnOnce(`Unable to perform style diff: ${o2.message || o2.error || o2}.  Rebuilding the style from scratch.`), this._updateStyle(t2, i3);
          }
        }
        getStyle() {
          if (this.style)
            return this.style.serialize();
        }
        isStyleLoaded() {
          return this.style ? this.style.loaded() : e.warnOnce("There is no style added to the map.");
        }
        addSource(e2, t2) {
          return this._lazyInitEmptyStyle(), this.style.addSource(e2, t2), this._update(true);
        }
        isSourceLoaded(t2) {
          const i3 = this.style && this.style._getSourceCaches(t2);
          if (i3.length !== 0)
            return i3.every((e2) => e2.loaded());
          this.fire(new e.ErrorEvent(new Error(`There is no source with ID '${t2}'`)));
        }
        areTilesLoaded() {
          const e2 = this.style && this.style._sourceCaches;
          for (const t2 in e2) {
            const i3 = e2[t2]._tiles;
            for (const e3 in i3) {
              const t3 = i3[e3];
              if (t3.state !== "loaded" && t3.state !== "errored")
                return false;
            }
          }
          return true;
        }
        addSourceType(e2, t2, i3) {
          return this._lazyInitEmptyStyle(), this.style.addSourceType(e2, t2, i3);
        }
        removeSource(e2) {
          return this.style.removeSource(e2), this._updateTerrain(), this._update(true);
        }
        getSource(e2) {
          return this.style.getSource(e2);
        }
        addImage(t2, i3, { pixelRatio: o2 = 1, sdf: r2 = false, stretchX: n2, stretchY: a2, content: s3 } = {}) {
          if (this._lazyInitEmptyStyle(), i3 instanceof Rr || Or && i3 instanceof Or) {
            const { width: l2, height: c2, data: h2 } = e.exported.getImageData(i3);
            this.style.addImage(t2, { data: new e.RGBAImage({ width: l2, height: c2 }, h2), pixelRatio: o2, stretchX: n2, stretchY: a2, content: s3, sdf: r2, version: 0 });
          } else {
            if (i3.width === void 0 || i3.height === void 0)
              return this.fire(new e.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
            {
              const { width: l2, height: c2, data: h2 } = i3, u2 = i3;
              this.style.addImage(t2, { data: new e.RGBAImage({ width: l2, height: c2 }, new Uint8Array(h2)), pixelRatio: o2, stretchX: n2, stretchY: a2, content: s3, sdf: r2, version: 0, userImage: u2 }), u2.onAdd && u2.onAdd(this, t2);
            }
          }
        }
        updateImage(t2, i3) {
          const o2 = this.style.getImage(t2);
          if (!o2)
            return this.fire(new e.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
          const r2 = i3 instanceof Rr || Or && i3 instanceof Or ? e.exported.getImageData(i3) : i3, { width: n2, height: a2, data: s3 } = r2;
          return n2 === void 0 || a2 === void 0 ? this.fire(new e.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`"))) : n2 !== o2.data.width || a2 !== o2.data.height ? this.fire(new e.ErrorEvent(new Error("The width and height of the updated image must be that same as the previous version of the image"))) : (o2.data.replace(s3, !(i3 instanceof Rr || Or && i3 instanceof Or)), void this.style.updateImage(t2, o2));
        }
        hasImage(t2) {
          return t2 ? !!this.style.getImage(t2) : (this.fire(new e.ErrorEvent(new Error("Missing required image id"))), false);
        }
        removeImage(e2) {
          this.style.removeImage(e2);
        }
        loadImage(t2, i3) {
          e.getImage(this._requestManager.transformRequest(t2, e.ResourceType.Image), (t3, o2) => {
            i3(t3, o2 instanceof Rr ? e.exported.getImageData(o2) : o2);
          });
        }
        listImages() {
          return this.style.listImages();
        }
        addLayer(e2, t2) {
          return this._lazyInitEmptyStyle(), this.style.addLayer(e2, t2), this._update(true);
        }
        moveLayer(e2, t2) {
          return this.style.moveLayer(e2, t2), this._update(true);
        }
        removeLayer(e2) {
          return this.style.removeLayer(e2), this._update(true);
        }
        getLayer(e2) {
          return this.style.getLayer(e2);
        }
        setLayerZoomRange(e2, t2, i3) {
          return this.style.setLayerZoomRange(e2, t2, i3), this._update(true);
        }
        setFilter(e2, t2, i3 = {}) {
          return this.style.setFilter(e2, t2, i3), this._update(true);
        }
        getFilter(e2) {
          return this.style.getFilter(e2);
        }
        setPaintProperty(e2, t2, i3, o2 = {}) {
          return this.style.setPaintProperty(e2, t2, i3, o2), this._update(true);
        }
        getPaintProperty(e2, t2) {
          return this.style.getPaintProperty(e2, t2);
        }
        setLayoutProperty(e2, t2, i3, o2 = {}) {
          return this.style.setLayoutProperty(e2, t2, i3, o2), this._update(true);
        }
        getLayoutProperty(e2, t2) {
          return this.style.getLayoutProperty(e2, t2);
        }
        setLight(e2, t2 = {}) {
          return this._lazyInitEmptyStyle(), this.style.setLight(e2, t2), this._update(true);
        }
        getLight() {
          return this.style.getLight();
        }
        setTerrain(e2) {
          return this._lazyInitEmptyStyle(), !e2 && this.transform.projection.requiresDraping ? this.style.setTerrainForDraping() : this.style.setTerrain(e2), this._averageElevationLastSampledAt = -1 / 0, this._update(true);
        }
        _updateProjection() {
          this.transform.projection.name === "globe" && this.transform.zoom >= e.GLOBE_ZOOM_THRESHOLD_MAX && !this._transitionFromGlobe && (this.setProjection({ name: "mercator" }), this._transitionFromGlobe = true);
        }
        getTerrain() {
          return this.style ? this.style.getTerrain() : null;
        }
        setFog(e2) {
          return this._lazyInitEmptyStyle(), this.style.setFog(e2), this._update(true);
        }
        getFog() {
          return this.style ? this.style.getFog() : null;
        }
        _queryFogOpacity(t2) {
          return this.style && this.style.fog ? this.style.fog.getOpacityAtLatLng(e.LngLat.convert(t2), this.transform) : 0;
        }
        setFeatureState(e2, t2) {
          return this.style.setFeatureState(e2, t2), this._update();
        }
        removeFeatureState(e2, t2) {
          return this.style.removeFeatureState(e2, t2), this._update();
        }
        getFeatureState(e2) {
          return this.style.getFeatureState(e2);
        }
        _updateContainerDimensions() {
          if (!this._container)
            return;
          const t2 = this._container.getBoundingClientRect().width || 400, i3 = this._container.getBoundingClientRect().height || 300;
          let o2, r2 = this._container;
          for (; r2 && !o2; ) {
            const t3 = e.window.getComputedStyle(r2).transform;
            t3 && t3 !== "none" && (o2 = t3.match(/matrix.*\((.+)\)/)[1].split(", ")), r2 = r2.parentElement;
          }
          o2 ? (this._containerWidth = o2[0] && o2[0] !== "0" ? Math.abs(t2 / o2[0]) : t2, this._containerHeight = o2[3] && o2[3] !== "0" ? Math.abs(i3 / o2[3]) : i3) : (this._containerWidth = t2, this._containerHeight = i3);
        }
        _detectMissingCSS() {
          e.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") !== "rgb(250, 128, 114)" && e.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
        }
        _setupContainer() {
          const e2 = this._container;
          e2.classList.add("mapboxgl-map"), (this._missingCSSCanary = a.create("div", "mapboxgl-canary", e2)).style.visibility = "hidden", this._detectMissingCSS();
          const t2 = this._canvasContainer = a.create("div", "mapboxgl-canvas-container", e2);
          this._interactive && t2.classList.add("mapboxgl-interactive"), this._canvas = a.create("canvas", "mapboxgl-canvas", t2), this._canvas.addEventListener("webglcontextlost", this._contextLost, false), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, false), this._canvas.setAttribute("tabindex", "0"), this._canvas.setAttribute("aria-label", "Map"), this._canvas.setAttribute("role", "region"), this._updateContainerDimensions(), this._resizeCanvas(this._containerWidth, this._containerHeight);
          const i3 = this._controlContainer = a.create("div", "mapboxgl-control-container", e2), o2 = this._controlPositions = {};
          ["top-left", "top-right", "bottom-left", "bottom-right"].forEach((e3) => {
            o2[e3] = a.create("div", `mapboxgl-ctrl-${e3}`, i3);
          }), this._container.addEventListener("scroll", this._onMapScroll, false);
        }
        _resizeCanvas(t2, i3) {
          const o2 = e.exported.devicePixelRatio || 1;
          this._canvas.width = o2 * Math.ceil(t2), this._canvas.height = o2 * Math.ceil(i3), this._canvas.style.width = `${t2}px`, this._canvas.style.height = `${i3}px`;
        }
        _addMarker(e2) {
          this._markers.push(e2);
        }
        _removeMarker(e2) {
          const t2 = this._markers.indexOf(e2);
          t2 !== -1 && this._markers.splice(t2, 1);
        }
        _setupPainter() {
          const i3 = e.extend({}, t.webGLContextAttributes, { failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat, preserveDrawingBuffer: this._preserveDrawingBuffer, antialias: this._antialias || false }), o2 = this._canvas.getContext("webgl", i3) || this._canvas.getContext("experimental-webgl", i3);
          o2 ? (e.storeAuthState(o2, true), this.painter = new _o(o2, this.transform), this.on("data", (e2) => {
            e2.dataType === "source" && this.painter.setTileLoadedFlag(true);
          }), e.exported$1.testSupport(o2)) : this.fire(new e.ErrorEvent(new Error("Failed to initialize WebGL")));
        }
        _contextLost(t2) {
          t2.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new e.Event("webglcontextlost", { originalEvent: t2 }));
        }
        _contextRestored(t2) {
          this._setupPainter(), this.resize(), this._update(), this.fire(new e.Event("webglcontextrestored", { originalEvent: t2 }));
        }
        _onMapScroll(e2) {
          if (e2.target === this._container)
            return this._container.scrollTop = 0, this._container.scrollLeft = 0, false;
        }
        loaded() {
          return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
        }
        _update(e2) {
          return this.style ? (this._styleDirty = this._styleDirty || e2, this._sourcesDirty = true, this.triggerRepaint(), this) : this;
        }
        _requestRenderFrame(e2) {
          return this._update(), this._renderTaskQueue.add(e2);
        }
        _cancelRenderFrame(e2) {
          this._renderTaskQueue.remove(e2);
        }
        _requestDomTask(e2) {
          !this.loaded() || this.loaded() && !this.isMoving() ? e2() : this._domRenderTaskQueue.add(e2);
        }
        _render(t2) {
          let i3;
          const o2 = this.painter.context.extTimerQuery, r2 = e.exported.now();
          this.listens("gpu-timing-frame") && (i3 = o2.createQueryEXT(), o2.beginQueryEXT(o2.TIME_ELAPSED_EXT, i3));
          let n2 = this._updateAverageElevation(r2);
          if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(t2), this._domRenderTaskQueue.run(t2), this._removed)
            return;
          this._updateProjection();
          let a2 = false;
          const s3 = this._isInitialLoad ? 0 : this._fadeDuration;
          if (this.style && this._styleDirty) {
            this._styleDirty = false;
            const t3 = this.transform.zoom, i4 = this.transform.pitch, o3 = e.exported.now();
            this.style.zoomHistory.update(t3, o3);
            const r3 = new e.EvaluationParameters(t3, { now: o3, fadeDuration: s3, pitch: i4, zoomHistory: this.style.zoomHistory, transition: this.style.getTransition() }), n3 = r3.crossFadingFactor();
            n3 === 1 && n3 === this._crossFadingFactor || (a2 = true, this._crossFadingFactor = n3), this.style.update(r3);
          }
          if (this.style && this.style.fog && this.style.fog.hasTransition() && (this.style._markersNeedUpdate = true, this._sourcesDirty = true), this.style && this._sourcesDirty && (this._sourcesDirty = false, this.painter._updateFog(this.style), this._updateTerrain(), this.style._updateSources(this.transform), this._forceMarkerUpdate()), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, s3, this._crossSourceCollisions), this.style && this.painter.render(this.style, { showTileBoundaries: this.showTileBoundaries, showTerrainWireframe: this.showTerrainWireframe, showOverdrawInspector: this._showOverdrawInspector, showQueryGeometry: !!this._showQueryGeometry, rotating: this.isRotating(), zooming: this.isZooming(), moving: this.isMoving(), fadeDuration: s3, isInitialLoad: this._isInitialLoad, showPadding: this.showPadding, gpuTiming: !!this.listens("gpu-timing-layer"), speedIndexTiming: this.speedIndexTiming }), this.fire(new e.Event("render")), this.loaded() && !this._loaded && (this._loaded = true, this.fire(new e.Event("load"))), this.style && (this.style.hasTransitions() || a2) && (this._styleDirty = true), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), this.listens("gpu-timing-frame")) {
            const t3 = e.exported.now() - r2;
            o2.endQueryEXT(o2.TIME_ELAPSED_EXT, i3), setTimeout(() => {
              const r3 = o2.getQueryObjectEXT(i3, o2.QUERY_RESULT_EXT) / 1e6;
              o2.deleteQueryEXT(i3), this.fire(new e.Event("gpu-timing-frame", { cpuTime: t3, gpuTime: r3 }));
            }, 50);
          }
          if (this.listens("gpu-timing-layer")) {
            const t3 = this.painter.collectGpuTimers();
            setTimeout(() => {
              const i4 = this.painter.queryGpuTimers(t3);
              this.fire(new e.Event("gpu-timing-layer", { layerTimes: i4 }));
            }, 50);
          }
          const l2 = this._sourcesDirty || this._styleDirty || this._placementDirty || n2;
          if (l2 || this._repaint)
            this.triggerRepaint();
          else {
            const t3 = !this.isMoving() && this.loaded();
            if (t3 && (n2 = this._updateAverageElevation(r2, true)), n2)
              this.triggerRepaint();
            else if (this._triggerFrame(false), t3 && (this.fire(new e.Event("idle")), this._isInitialLoad = false, this.speedIndexTiming)) {
              const t4 = this._calculateSpeedIndex();
              this.fire(new e.Event("speedindexcompleted", { speedIndex: t4 })), this.speedIndexTiming = false;
            }
          }
          return !this._loaded || this._fullyLoaded || l2 || (this._fullyLoaded = true, this._authenticate()), this;
        }
        _forceMarkerUpdate() {
          for (const e2 of this._markers)
            e2._update();
        }
        _updateAverageElevation(e2, t2 = false) {
          const i3 = (e3) => (this.transform.averageElevation = e3, this._update(false), true);
          if (!this.painter.averageElevationNeedsEasing())
            return this.transform.averageElevation !== 0 && i3(0);
          if ((t2 || e2 - this._averageElevationLastSampledAt > 500) && !this._averageElevation.isEasing(e2)) {
            const t3 = this.transform.averageElevation;
            let o2 = this.transform.sampleAverageElevation();
            isNaN(o2) ? o2 = 0 : this._averageElevationLastSampledAt = e2;
            const r2 = Math.abs(t3 - o2);
            if (r2 > 1) {
              if (this._isInitialLoad)
                return this._averageElevation.jumpTo(o2), i3(o2);
              this._averageElevation.easeTo(o2, e2, 300);
            } else if (r2 > 1e-4)
              return this._averageElevation.jumpTo(o2), i3(o2);
          }
          return !!this._averageElevation.isEasing(e2) && i3(this._averageElevation.getValue(e2));
        }
        _authenticate() {
          e.getMapSessionAPI(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, (t2) => {
            if (t2 && (t2.message === e.AUTH_ERR_MSG || t2.status === 401)) {
              const t3 = this.painter.context.gl;
              e.storeAuthState(t3, false), this._logoControl instanceof Sr && this._logoControl._updateLogo(), t3 && t3.clear(t3.DEPTH_BUFFER_BIT | t3.COLOR_BUFFER_BIT | t3.STENCIL_BUFFER_BIT), this._silenceAuthErrors || this.fire(new e.ErrorEvent(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));
            }
          }), e.postMapLoadEvent(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, () => {
          });
        }
        _updateTerrain() {
          this.painter.updateTerrain(this.style, this.isMoving() || this.isRotating() || this.isZooming());
        }
        _calculateSpeedIndex() {
          const e2 = this.painter.canvasCopy(), t2 = this.painter.getCanvasCopiesAndTimestamps();
          t2.timeStamps.push(performance.now());
          const i3 = this.painter.context.gl, o2 = i3.createFramebuffer();
          function r2(e3) {
            i3.framebufferTexture2D(i3.FRAMEBUFFER, i3.COLOR_ATTACHMENT0, i3.TEXTURE_2D, e3, 0);
            const t3 = new Uint8Array(i3.drawingBufferWidth * i3.drawingBufferHeight * 4);
            return i3.readPixels(0, 0, i3.drawingBufferWidth, i3.drawingBufferHeight, i3.RGBA, i3.UNSIGNED_BYTE, t3), t3;
          }
          return i3.bindFramebuffer(i3.FRAMEBUFFER, o2), this._canvasPixelComparison(r2(e2), t2.canvasCopies.map(r2), t2.timeStamps);
        }
        _canvasPixelComparison(e2, t2, i3) {
          let o2 = i3[1] - i3[0];
          const r2 = e2.length / 4;
          for (let n2 = 0; n2 < t2.length; n2++) {
            const a2 = t2[n2];
            let s3 = 0;
            for (let t3 = 0; t3 < a2.length; t3 += 4)
              a2[t3] === e2[t3] && a2[t3 + 1] === e2[t3 + 1] && a2[t3 + 2] === e2[t3 + 2] && a2[t3 + 3] === e2[t3 + 3] && (s3 += 1);
            o2 += (i3[n2 + 2] - i3[n2 + 1]) * (1 - s3 / r2);
          }
          return o2;
        }
        remove() {
          this._hash && this._hash.remove();
          for (const e2 of this._controls)
            e2.onRemove(this);
          this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this._domRenderTaskQueue.clear(), this.style && this.style.destroy(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), e.window !== void 0 && (e.window.removeEventListener("resize", this._onWindowResize, false), e.window.removeEventListener("orientationchange", this._onWindowResize, false), e.window.removeEventListener("webkitfullscreenchange", this._onWindowResize, false), e.window.removeEventListener("online", this._onWindowOnline, false));
          const t2 = this.painter.context.gl.getExtension("WEBGL_lose_context");
          t2 && t2.loseContext(), Fr(this._canvasContainer), Fr(this._controlContainer), Fr(this._missingCSSCanary), this._container.classList.remove("mapboxgl-map"), e.removeAuthState(this.painter.context.gl), this._removed = true, this.fire(new e.Event("remove"));
        }
        triggerRepaint() {
          this._triggerFrame(true);
        }
        _triggerFrame(t2) {
          this._renderNextFrame = this._renderNextFrame || t2, this.style && !this._frame && (this._frame = e.exported.frame((e2) => {
            const t3 = !!this._renderNextFrame;
            this._frame = null, this._renderNextFrame = null, t3 && this._render(e2);
          }));
        }
        _preloadTiles(t2) {
          const i3 = this.style && Object.values(this.style._sourceCaches) || [];
          return e.asyncAll(i3, (e2, i4) => e2._preloadTiles(t2, i4), () => {
            this.triggerRepaint();
          }), this;
        }
        _onWindowOnline() {
          this._update();
        }
        _onWindowResize(e2) {
          this._trackResize && this.resize({ originalEvent: e2 })._update();
        }
        get showTileBoundaries() {
          return !!this._showTileBoundaries;
        }
        set showTileBoundaries(e2) {
          this._showTileBoundaries !== e2 && (this._showTileBoundaries = e2, this._update());
        }
        get showTerrainWireframe() {
          return !!this._showTerrainWireframe;
        }
        set showTerrainWireframe(e2) {
          this._showTerrainWireframe !== e2 && (this._showTerrainWireframe = e2, this._update());
        }
        get speedIndexTiming() {
          return !!this._speedIndexTiming;
        }
        set speedIndexTiming(e2) {
          this._speedIndexTiming !== e2 && (this._speedIndexTiming = e2, this._update());
        }
        get showPadding() {
          return !!this._showPadding;
        }
        set showPadding(e2) {
          this._showPadding !== e2 && (this._showPadding = e2, this._update());
        }
        get showCollisionBoxes() {
          return !!this._showCollisionBoxes;
        }
        set showCollisionBoxes(e2) {
          this._showCollisionBoxes !== e2 && (this._showCollisionBoxes = e2, e2 ? this.style._generateCollisionBoxes() : this._update());
        }
        get showOverdrawInspector() {
          return !!this._showOverdrawInspector;
        }
        set showOverdrawInspector(e2) {
          this._showOverdrawInspector !== e2 && (this._showOverdrawInspector = e2, this._update());
        }
        get repaint() {
          return !!this._repaint;
        }
        set repaint(e2) {
          this._repaint !== e2 && (this._repaint = e2, this.triggerRepaint());
        }
        get vertices() {
          return !!this._vertices;
        }
        set vertices(e2) {
          this._vertices = e2, this._update();
        }
        _setCacheLimits(t2, i3) {
          e.setCacheLimits(t2, i3);
        }
        get version() {
          return e.version;
        }
      }, NavigationControl: class {
        constructor(t2) {
          this.options = e.extend({}, Ur, t2), this._container = a.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", (e2) => e2.preventDefault()), this.options.showZoom && (e.bindAll(["_setButtonTitle", "_updateZoomButtons"], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", (e2) => this._map.zoomIn({}, { originalEvent: e2 })), a.create("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", true), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", (e2) => this._map.zoomOut({}, { originalEvent: e2 })), a.create("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", true)), this.options.showCompass && (e.bindAll(["_rotateCompassArrow"], this), this._compass = this._createButton("mapboxgl-ctrl-compass", (e2) => {
            this.options.visualizePitch ? this._map.resetNorthPitch({}, { originalEvent: e2 }) : this._map.resetNorth({}, { originalEvent: e2 });
          }), this._compassIcon = a.create("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", true));
        }
        _updateZoomButtons() {
          const e2 = this._map.getZoom(), t2 = e2 === this._map.getMaxZoom(), i3 = e2 === this._map.getMinZoom();
          this._zoomInButton.disabled = t2, this._zoomOutButton.disabled = i3, this._zoomInButton.setAttribute("aria-disabled", t2.toString()), this._zoomOutButton.setAttribute("aria-disabled", i3.toString());
        }
        _rotateCompassArrow() {
          const e2 = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), 0.5)}) rotateX(${this._map.transform.pitch}deg) rotateZ(${this._map.transform.angle * (180 / Math.PI)}deg)` : `rotate(${this._map.transform.angle * (180 / Math.PI)}deg)`;
          this._map._requestDomTask(() => {
            this._compassIcon && (this._compassIcon.style.transform = e2);
          });
        }
        onAdd(e2) {
          return this._map = e2, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new Nr(this._map, this._compass, this.options.visualizePitch)), this._container;
        }
        onRemove() {
          this._container.remove(), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
        }
        _createButton(e2, t2) {
          const i3 = a.create("button", e2, this._container);
          return i3.type = "button", i3.addEventListener("click", t2), i3;
        }
        _setButtonTitle(e2, t2) {
          const i3 = this._map._getUIString(`NavigationControl.${t2}`);
          e2.setAttribute("aria-label", i3), e2.firstElementChild && e2.firstElementChild.setAttribute("title", i3);
        }
      }, GeolocateControl: class extends e.Evented {
        constructor(t2) {
          super(), this.options = e.extend({}, Gr, t2), e.bindAll(["_onSuccess", "_onError", "_onZoom", "_finish", "_setupUI", "_updateCamera", "_updateMarker", "_updateMarkerRotation"], this), this._onDeviceOrientationListener = this._onDeviceOrientation.bind(this), this._updateMarkerRotationThrottled = Io(this._updateMarkerRotation, 20);
        }
        onAdd(t2) {
          var i3;
          return this._map = t2, this._container = a.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), i3 = this._setupUI, jr !== void 0 ? i3(jr) : e.window.navigator.permissions !== void 0 ? e.window.navigator.permissions.query({ name: "geolocation" }).then((e2) => {
            jr = e2.state !== "denied", i3(jr);
          }) : (jr = !!e.window.navigator.geolocation, i3(jr)), this._container;
        }
        onRemove() {
          this._geolocationWatchID !== void 0 && (e.window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("zoom", this._onZoom), this._map = void 0, Zr = 0, Vr = false;
        }
        _isOutOfMapMaxBounds(e2) {
          const t2 = this._map.getMaxBounds(), i3 = e2.coords;
          return t2 && (i3.longitude < t2.getWest() || i3.longitude > t2.getEast() || i3.latitude < t2.getSouth() || i3.latitude > t2.getNorth());
        }
        _setErrorState() {
          switch (this._watchState) {
            case "WAITING_ACTIVE":
              this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
              break;
            case "ACTIVE_LOCK":
              this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
              break;
            case "BACKGROUND":
              this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
          }
        }
        _onSuccess(t2) {
          if (this._map) {
            if (this._isOutOfMapMaxBounds(t2))
              return this._setErrorState(), this.fire(new e.Event("outofmaxbounds", t2)), this._updateMarker(), void this._finish();
            if (this.options.trackUserLocation)
              switch (this._lastKnownPosition = t2, this._watchState) {
                case "WAITING_ACTIVE":
                case "ACTIVE_LOCK":
                case "ACTIVE_ERROR":
                  this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                  break;
                case "BACKGROUND":
                case "BACKGROUND_ERROR":
                  this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
              }
            this.options.showUserLocation && this._watchState !== "OFF" && this._updateMarker(t2), this.options.trackUserLocation && this._watchState !== "ACTIVE_LOCK" || this._updateCamera(t2), this.options.showUserLocation && this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"), this.fire(new e.Event("geolocate", t2)), this._finish();
          }
        }
        _updateCamera(t2) {
          const i3 = new e.LngLat(t2.coords.longitude, t2.coords.latitude), o2 = t2.coords.accuracy, r2 = this._map.getBearing(), n2 = e.extend({ bearing: r2 }, this.options.fitBoundsOptions);
          this._map.fitBounds(i3.toBounds(o2), n2, { geolocateSource: true });
        }
        _updateMarker(t2) {
          if (t2) {
            const i3 = new e.LngLat(t2.coords.longitude, t2.coords.latitude);
            this._accuracyCircleMarker.setLngLat(i3).addTo(this._map), this._userLocationDotMarker.setLngLat(i3).addTo(this._map), this._accuracy = t2.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
          } else
            this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
        }
        _updateCircleRadius() {
          const e2 = this._map._containerHeight / 2, t2 = this._map.unproject([0, e2]), i3 = this._map.unproject([100, e2]), o2 = t2.distanceTo(i3) / 100, r2 = Math.ceil(2 * this._accuracy / o2);
          this._circleElement.style.width = `${r2}px`, this._circleElement.style.height = `${r2}px`;
        }
        _onZoom() {
          this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
        }
        _updateMarkerRotation() {
          this._userLocationDotMarker && typeof this._heading == "number" ? (this._userLocationDotMarker.setRotation(this._heading), this._dotElement.classList.add("mapboxgl-user-location-show-heading")) : (this._dotElement.classList.remove("mapboxgl-user-location-show-heading"), this._userLocationDotMarker.setRotation(0));
        }
        _onError(t2) {
          if (this._map) {
            if (this.options.trackUserLocation)
              if (t2.code === 1) {
                this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = true;
                const e2 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                this._geolocateButton.setAttribute("aria-label", e2), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e2), this._geolocationWatchID !== void 0 && this._clearWatch();
              } else {
                if (t2.code === 3 && Vr)
                  return;
                this._setErrorState();
              }
            this._watchState !== "OFF" && this.options.showUserLocation && this._dotElement.classList.add("mapboxgl-user-location-dot-stale"), this.fire(new e.Event("error", t2)), this._finish();
          }
        }
        _finish() {
          this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
        }
        _setupUI(t2) {
          if (this._container.addEventListener("contextmenu", (e2) => e2.preventDefault()), this._geolocateButton = a.create("button", "mapboxgl-ctrl-geolocate", this._container), a.create("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", true), this._geolocateButton.type = "button", t2 === false) {
            e.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled.");
            const t3 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
            this._geolocateButton.disabled = true, this._geolocateButton.setAttribute("aria-label", t3), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", t3);
          } else {
            const e2 = this._map._getUIString("GeolocateControl.FindMyLocation");
            this._geolocateButton.setAttribute("aria-label", e2), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e2);
          }
          this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = a.create("div", "mapboxgl-user-location"), this._dotElement.appendChild(a.create("div", "mapboxgl-user-location-dot")), this._dotElement.appendChild(a.create("div", "mapboxgl-user-location-heading")), this._userLocationDotMarker = new Pr({ element: this._dotElement, rotationAlignment: "map", pitchAlignment: "map" }), this._circleElement = a.create("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Pr({ element: this._circleElement, pitchAlignment: "map" }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = true, this.options.trackUserLocation && this._map.on("movestart", (t3) => {
            t3.geolocateSource || this._watchState !== "ACTIVE_LOCK" || t3.originalEvent && t3.originalEvent.type === "resize" || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this.fire(new e.Event("trackuserlocationend")));
          });
        }
        _onDeviceOrientation(e2) {
          this._userLocationDotMarker && (e2.webkitCompassHeading ? this._heading = e2.webkitCompassHeading : e2.absolute === true && (this._heading = -1 * e2.alpha), this._updateMarkerRotationThrottled());
        }
        trigger() {
          if (!this._setup)
            return e.warnOnce("Geolocate control triggered before added to a map"), false;
          if (this.options.trackUserLocation) {
            switch (this._watchState) {
              case "OFF":
                this._watchState = "WAITING_ACTIVE", this.fire(new e.Event("trackuserlocationstart"));
                break;
              case "WAITING_ACTIVE":
              case "ACTIVE_LOCK":
              case "ACTIVE_ERROR":
              case "BACKGROUND_ERROR":
                Zr--, Vr = false, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new e.Event("trackuserlocationend"));
                break;
              case "BACKGROUND":
                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e.Event("trackuserlocationstart"));
            }
            switch (this._watchState) {
              case "WAITING_ACTIVE":
                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                break;
              case "ACTIVE_LOCK":
                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                break;
              case "ACTIVE_ERROR":
                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                break;
              case "BACKGROUND":
                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                break;
              case "BACKGROUND_ERROR":
                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
            }
            if (this._watchState === "OFF" && this._geolocationWatchID !== void 0)
              this._clearWatch();
            else if (this._geolocationWatchID === void 0) {
              let t2;
              this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), Zr++, Zr > 1 ? (t2 = { maximumAge: 6e5, timeout: 0 }, Vr = true) : (t2 = this.options.positionOptions, Vr = false), this._geolocationWatchID = e.window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, t2), this.options.showUserHeading && this._addDeviceOrientationListener();
            }
          } else
            e.window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
          return true;
        }
        _addDeviceOrientationListener() {
          const t2 = () => {
            e.window.addEventListener("ondeviceorientationabsolute" in e.window ? "deviceorientationabsolute" : "deviceorientation", this._onDeviceOrientationListener);
          };
          e.window.DeviceMotionEvent !== void 0 && typeof e.window.DeviceMotionEvent.requestPermission == "function" ? DeviceOrientationEvent.requestPermission().then((e2) => {
            e2 === "granted" && t2();
          }).catch(console.error) : t2();
        }
        _clearWatch() {
          e.window.navigator.geolocation.clearWatch(this._geolocationWatchID), e.window.removeEventListener("deviceorientation", this._onDeviceOrientationListener), e.window.removeEventListener("deviceorientationabsolute", this._onDeviceOrientationListener), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
        }
      }, AttributionControl: Mr, ScaleControl: class {
        constructor(t2) {
          this.options = e.extend({}, Wr, t2), e.bindAll(["_onMove", "setUnit"], this);
        }
        getDefaultPosition() {
          return "bottom-left";
        }
        _onMove() {
          qr(this._map, this._container, this.options);
        }
        onAdd(e2) {
          return this._map = e2, this._container = a.create("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", e2.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
        }
        onRemove() {
          this._container.remove(), this._map.off("move", this._onMove), this._map = void 0;
        }
        setUnit(e2) {
          this.options.unit = e2, qr(this._map, this._container, this.options);
        }
      }, FullscreenControl: class {
        constructor(t2) {
          this._fullscreen = false, t2 && t2.container && (t2.container instanceof e.window.HTMLElement ? this._container = t2.container : e.warnOnce("Full screen control 'container' must be a DOM element.")), e.bindAll(["_onClickFullscreen", "_changeIcon"], this), "onfullscreenchange" in e.window.document ? this._fullscreenchange = "fullscreenchange" : "onwebkitfullscreenchange" in e.window.document && (this._fullscreenchange = "webkitfullscreenchange");
        }
        onAdd(t2) {
          return this._map = t2, this._container || (this._container = this._map.getContainer()), this._controlContainer = a.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", e.warnOnce("This device does not support fullscreen mode.")), this._controlContainer;
        }
        onRemove() {
          this._controlContainer.remove(), this._map = null, e.window.document.removeEventListener(this._fullscreenchange, this._changeIcon);
        }
        _checkFullscreenSupport() {
          return !(!e.window.document.fullscreenEnabled && !e.window.document.webkitFullscreenEnabled);
        }
        _setupUI() {
          const t2 = this._fullscreenButton = a.create("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
          a.create("span", "mapboxgl-ctrl-icon", t2).setAttribute("aria-hidden", true), t2.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), e.window.document.addEventListener(this._fullscreenchange, this._changeIcon);
        }
        _updateTitle() {
          const e2 = this._getTitle();
          this._fullscreenButton.setAttribute("aria-label", e2), this._fullscreenButton.firstElementChild && this._fullscreenButton.firstElementChild.setAttribute("title", e2);
        }
        _getTitle() {
          return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
        }
        _isFullscreen() {
          return this._fullscreen;
        }
        _changeIcon() {
          (e.window.document.fullscreenElement || e.window.document.webkitFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
        }
        _onClickFullscreen() {
          this._isFullscreen() ? e.window.document.exitFullscreen ? e.window.document.exitFullscreen() : e.window.document.webkitCancelFullScreen && e.window.document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
        }
      }, Popup: class extends e.Evented {
        constructor(t2) {
          super(), this.options = e.extend(Object.create($r), t2), e.bindAll(["_update", "_onClose", "remove", "_onMouseMove", "_onMouseUp", "_onDrag"], this), this._classList = new Set(t2 && t2.className ? t2.className.trim().split(/\s+/) : []);
        }
        addTo(t2) {
          return this._map && this.remove(), this._map = t2, this.options.closeOnClick && this._map.on("preclick", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._map._canvasContainer.classList.add("mapboxgl-track-pointer")) : this._map.on("move", this._update), this.fire(new e.Event("open")), this;
        }
        isOpen() {
          return !!this._map;
        }
        remove() {
          return this._content && this._content.remove(), this._container && (this._container.remove(), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), delete this._map), this.fire(new e.Event("close")), this;
        }
        getLngLat() {
          return this._lngLat;
        }
        setLngLat(t2) {
          return this._lngLat = e.LngLat.convert(t2), this._pos = null, this._trackPointer = false, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._map._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
        }
        trackPointer() {
          return this._trackPointer = true, this._pos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._map._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
        }
        getElement() {
          return this._container;
        }
        setText(t2) {
          return this.setDOMContent(e.window.document.createTextNode(t2));
        }
        setHTML(t2) {
          const i3 = e.window.document.createDocumentFragment(), o2 = e.window.document.createElement("body");
          let r2;
          for (o2.innerHTML = t2; r2 = o2.firstChild, r2; )
            i3.appendChild(r2);
          return this.setDOMContent(i3);
        }
        getMaxWidth() {
          return this._container && this._container.style.maxWidth;
        }
        setMaxWidth(e2) {
          return this.options.maxWidth = e2, this._update(), this;
        }
        setDOMContent(e2) {
          if (this._content)
            for (; this._content.hasChildNodes(); )
              this._content.firstChild && this._content.removeChild(this._content.firstChild);
          else
            this._content = a.create("div", "mapboxgl-popup-content", this._container);
          return this._content.appendChild(e2), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
        }
        addClassName(e2) {
          return this._classList.add(e2), this._container && this._updateClassList(), this;
        }
        removeClassName(e2) {
          return this._classList.delete(e2), this._container && this._updateClassList(), this;
        }
        setOffset(e2) {
          return this.options.offset = e2, this._update(), this;
        }
        toggleClassName(e2) {
          let t2;
          return this._classList.delete(e2) ? t2 = false : (this._classList.add(e2), t2 = true), this._container && this._updateClassList(), t2;
        }
        _createCloseButton() {
          this.options.closeButton && (this._closeButton = a.create("button", "mapboxgl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.setAttribute("aria-label", "Close popup"), this._closeButton.setAttribute("aria-hidden", "true"), this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
        }
        _onMouseUp(e2) {
          this._update(e2.point);
        }
        _onMouseMove(e2) {
          this._update(e2.point);
        }
        _onDrag(e2) {
          this._update(e2.point);
        }
        _getAnchor(e2) {
          if (this.options.anchor)
            return this.options.anchor;
          const t2 = this._pos, i3 = this._container.offsetWidth, o2 = this._container.offsetHeight;
          let r2;
          return r2 = t2.y + e2.bottom.y < o2 ? ["top"] : t2.y > this._map.transform.height - o2 ? ["bottom"] : [], t2.x < i3 / 2 ? r2.push("left") : t2.x > this._map.transform.width - i3 / 2 && r2.push("right"), r2.length === 0 ? "bottom" : r2.join("-");
        }
        _updateClassList() {
          const e2 = [...this._classList];
          e2.push("mapboxgl-popup"), this._anchor && e2.push(`mapboxgl-popup-anchor-${this._anchor}`), this._trackPointer && e2.push("mapboxgl-popup-track-pointer"), this._container.className = e2.join(" ");
        }
        _update(t2) {
          if (this._map && (this._lngLat || this._trackPointer) && this._content) {
            if (this._container || (this._container = a.create("div", "mapboxgl-popup", this._map.getContainer()), this._tip = a.create("div", "mapboxgl-popup-tip", this._container), this._container.appendChild(this._content)), this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._map.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = zr(this._lngLat, this._pos, this._map.transform)), !this._trackPointer || t2) {
              const i3 = this._pos = this._trackPointer && t2 ? t2 : this._map.project(this._lngLat), o2 = function(t3) {
                if (t3 || (t3 = new e.pointGeometry(0, 0)), typeof t3 == "number") {
                  const i4 = Math.round(Math.sqrt(0.5 * Math.pow(t3, 2)));
                  return { center: new e.pointGeometry(0, 0), top: new e.pointGeometry(0, t3), "top-left": new e.pointGeometry(i4, i4), "top-right": new e.pointGeometry(-i4, i4), bottom: new e.pointGeometry(0, -t3), "bottom-left": new e.pointGeometry(i4, -i4), "bottom-right": new e.pointGeometry(-i4, -i4), left: new e.pointGeometry(t3, 0), right: new e.pointGeometry(-t3, 0) };
                }
                if (t3 instanceof e.pointGeometry || Array.isArray(t3)) {
                  const i4 = e.pointGeometry.convert(t3);
                  return { center: i4, top: i4, "top-left": i4, "top-right": i4, bottom: i4, "bottom-left": i4, "bottom-right": i4, left: i4, right: i4 };
                }
                return { center: e.pointGeometry.convert(t3.center || [0, 0]), top: e.pointGeometry.convert(t3.top || [0, 0]), "top-left": e.pointGeometry.convert(t3["top-left"] || [0, 0]), "top-right": e.pointGeometry.convert(t3["top-right"] || [0, 0]), bottom: e.pointGeometry.convert(t3.bottom || [0, 0]), "bottom-left": e.pointGeometry.convert(t3["bottom-left"] || [0, 0]), "bottom-right": e.pointGeometry.convert(t3["bottom-right"] || [0, 0]), left: e.pointGeometry.convert(t3.left || [0, 0]), right: e.pointGeometry.convert(t3.right || [0, 0]) };
              }(this.options.offset), r2 = this._anchor = this._getAnchor(o2), n2 = i3.add(o2[r2]).round();
              this._map._requestDomTask(() => {
                this._container && r2 && (this._container.style.transform = `${Dr[r2]} translate(${n2.x}px,${n2.y}px)`);
              });
            }
            this._updateClassList();
          }
        }
        _focusFirstElement() {
          if (!this.options.focusAfterOpen || !this._container)
            return;
          const e2 = this._container.querySelector(Hr);
          e2 && e2.focus();
        }
        _onClose() {
          this.remove();
        }
        _setOpacity(e2) {
          this._content && (this._content.style.opacity = e2), this._tip && (this._tip.style.opacity = e2);
        }
      }, Marker: Pr, Style: Nt, LngLat: e.LngLat, LngLatBounds: e.LngLatBounds, Point: e.pointGeometry, MercatorCoordinate: e.MercatorCoordinate, FreeCameraOptions: xo, Evented: e.Evented, config: e.config, prewarm: function() {
        Ae().acquire(ze);
      }, clearPrewarmedResources: function() {
        const e2 = Pe;
        e2 && (e2.isPreloaded() && e2.numActive() === 1 ? (e2.release(ze), Pe = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
      }, get accessToken() {
        return e.config.ACCESS_TOKEN;
      }, set accessToken(t2) {
        e.config.ACCESS_TOKEN = t2;
      }, get baseApiUrl() {
        return e.config.API_URL;
      }, set baseApiUrl(t2) {
        e.config.API_URL = t2;
      }, get workerCount() {
        return De.workerCount;
      }, set workerCount(e2) {
        De.workerCount = e2;
      }, get maxParallelImageRequests() {
        return e.config.MAX_PARALLEL_IMAGE_REQUESTS;
      }, set maxParallelImageRequests(t2) {
        e.config.MAX_PARALLEL_IMAGE_REQUESTS = t2;
      }, clearStorage(t2) {
        e.clearTileCache(t2);
      }, workerUrl: "", workerClass: null, setNow: e.exported.setNow, restoreNow: e.exported.restoreNow };
      return Kr;
    });
    var mapboxgl$1 = mapboxgl2;
    return mapboxgl$1;
  });
})(mapboxGl);
var mapboxgl = mapboxGl.exports;
var immutable = extend$2;
var hasOwnProperty = Object.prototype.hasOwnProperty;
function extend$2() {
  var target = {};
  for (var i2 = 0; i2 < arguments.length; i2++) {
    var source2 = arguments[i2];
    for (var key in source2) {
      if (hasOwnProperty.call(source2, key)) {
        target[key] = source2[key];
      }
    }
  }
  return target;
}
var fuzzy$1 = { exports: {} };
(function(module2, exports) {
  (function() {
    var fuzzy2 = {};
    {
      module2.exports = fuzzy2;
    }
    fuzzy2.simpleFilter = function(pattern, array) {
      return array.filter(function(str) {
        return fuzzy2.test(pattern, str);
      });
    };
    fuzzy2.test = function(pattern, str) {
      return fuzzy2.match(pattern, str) !== null;
    };
    fuzzy2.match = function(pattern, str, opts) {
      opts = opts || {};
      var patternIdx = 0, result2 = [], len = str.length, totalScore = 0, currScore = 0, pre = opts.pre || "", post = opts.post || "", compareString = opts.caseSensitive && str || str.toLowerCase(), ch;
      pattern = opts.caseSensitive && pattern || pattern.toLowerCase();
      for (var idx = 0; idx < len; idx++) {
        ch = str[idx];
        if (compareString[idx] === pattern[patternIdx]) {
          ch = pre + ch + post;
          patternIdx += 1;
          currScore += 1 + currScore;
        } else {
          currScore = 0;
        }
        totalScore += currScore;
        result2[result2.length] = ch;
      }
      if (patternIdx === pattern.length) {
        totalScore = compareString === pattern ? Infinity : totalScore;
        return { rendered: result2.join(""), score: totalScore };
      }
      return null;
    };
    fuzzy2.filter = function(pattern, arr, opts) {
      if (!arr || arr.length === 0) {
        return [];
      }
      if (typeof pattern !== "string") {
        return arr;
      }
      opts = opts || {};
      return arr.reduce(function(prev, element, idx, arr2) {
        var str = element;
        if (opts.extract) {
          str = opts.extract(element);
        }
        var rendered = fuzzy2.match(pattern, str, opts);
        if (rendered != null) {
          prev[prev.length] = {
            string: rendered.rendered,
            score: rendered.score,
            index: idx,
            original: element
          };
        }
        return prev;
      }, []).sort(function(a, b) {
        var compare = b.score - a.score;
        if (compare)
          return compare;
        return a.index - b.index;
      });
    };
  })();
})(fuzzy$1);
var List$1 = function(component) {
  this.component = component;
  this.items = [];
  this.active = 0;
  this.wrapper = document.createElement("div");
  this.wrapper.className = "suggestions-wrapper";
  this.element = document.createElement("ul");
  this.element.className = "suggestions";
  this.wrapper.appendChild(this.element);
  this.selectingListItem = false;
  component.el.parentNode.insertBefore(this.wrapper, component.el.nextSibling);
  return this;
};
List$1.prototype.show = function() {
  this.element.style.display = "block";
};
List$1.prototype.hide = function() {
  this.element.style.display = "none";
};
List$1.prototype.add = function(item) {
  this.items.push(item);
};
List$1.prototype.clear = function() {
  this.items = [];
  this.active = 0;
};
List$1.prototype.isEmpty = function() {
  return !this.items.length;
};
List$1.prototype.isVisible = function() {
  return this.element.style.display === "block";
};
List$1.prototype.draw = function() {
  this.element.innerHTML = "";
  if (this.items.length === 0) {
    this.hide();
    return;
  }
  for (var i2 = 0; i2 < this.items.length; i2++) {
    this.drawItem(this.items[i2], this.active === i2);
  }
  this.show();
};
List$1.prototype.drawItem = function(item, active) {
  var li = document.createElement("li"), a = document.createElement("a");
  if (active)
    li.className += " active";
  a.innerHTML = item.string;
  li.appendChild(a);
  this.element.appendChild(li);
  li.addEventListener("mousedown", function() {
    this.selectingListItem = true;
  }.bind(this));
  li.addEventListener("mouseup", function() {
    this.handleMouseUp.call(this, item);
  }.bind(this));
};
List$1.prototype.handleMouseUp = function(item) {
  this.selectingListItem = false;
  this.component.value(item.original);
  this.clear();
  this.draw();
};
List$1.prototype.move = function(index3) {
  this.active = index3;
  this.draw();
};
List$1.prototype.previous = function() {
  this.move(this.active === 0 ? this.items.length - 1 : this.active - 1);
};
List$1.prototype.next = function() {
  this.move(this.active === this.items.length - 1 ? 0 : this.active + 1);
};
List$1.prototype.drawError = function(msg) {
  var li = document.createElement("li");
  li.innerHTML = msg;
  this.element.appendChild(li);
  this.show();
};
var list = List$1;
var extend$1 = immutable;
var fuzzy = fuzzy$1.exports;
var List = list;
var Suggestions$1 = function(el, data, options) {
  options = options || {};
  this.options = extend$1({
    minLength: 2,
    limit: 5,
    filter: true,
    hideOnBlur: true
  }, options);
  this.el = el;
  this.data = data || [];
  this.list = new List(this);
  this.query = "";
  this.selected = null;
  this.list.draw();
  this.el.addEventListener("keyup", function(e) {
    this.handleKeyUp(e.keyCode);
  }.bind(this), false);
  this.el.addEventListener("keydown", function(e) {
    this.handleKeyDown(e);
  }.bind(this));
  this.el.addEventListener("focus", function() {
    this.handleFocus();
  }.bind(this));
  this.el.addEventListener("blur", function() {
    this.handleBlur();
  }.bind(this));
  this.el.addEventListener("paste", function(e) {
    this.handlePaste(e);
  }.bind(this));
  this.render = this.options.render ? this.options.render.bind(this) : this.render.bind(this);
  this.getItemValue = this.options.getItemValue ? this.options.getItemValue.bind(this) : this.getItemValue.bind(this);
  return this;
};
Suggestions$1.prototype.handleKeyUp = function(keyCode) {
  if (keyCode === 40 || keyCode === 38 || keyCode === 27 || keyCode === 13 || keyCode === 9)
    return;
  this.handleInputChange(this.el.value);
};
Suggestions$1.prototype.handleKeyDown = function(e) {
  switch (e.keyCode) {
    case 13:
    case 9:
      if (!this.list.isEmpty()) {
        if (this.list.isVisible()) {
          e.preventDefault();
        }
        this.value(this.list.items[this.list.active].original);
        this.list.hide();
      }
      break;
    case 27:
      if (!this.list.isEmpty())
        this.list.hide();
      break;
    case 38:
      this.list.previous();
      break;
    case 40:
      this.list.next();
      break;
  }
};
Suggestions$1.prototype.handleBlur = function() {
  if (!this.list.selectingListItem && this.options.hideOnBlur) {
    this.list.hide();
  }
};
Suggestions$1.prototype.handlePaste = function(e) {
  if (e.clipboardData) {
    this.handleInputChange(e.clipboardData.getData("Text"));
  } else {
    var self2 = this;
    setTimeout(function() {
      self2.handleInputChange(e.target.value);
    }, 100);
  }
};
Suggestions$1.prototype.handleInputChange = function(query) {
  this.query = this.normalize(query);
  this.list.clear();
  if (this.query.length < this.options.minLength) {
    this.list.draw();
    return;
  }
  this.getCandidates(function(data) {
    for (var i2 = 0; i2 < data.length; i2++) {
      this.list.add(data[i2]);
      if (i2 === this.options.limit - 1)
        break;
    }
    this.list.draw();
  }.bind(this));
};
Suggestions$1.prototype.handleFocus = function() {
  if (!this.list.isEmpty())
    this.list.show();
  this.list.selectingListItem = false;
};
Suggestions$1.prototype.update = function(revisedData) {
  this.data = revisedData;
  this.handleKeyUp();
};
Suggestions$1.prototype.clear = function() {
  this.data = [];
  this.list.clear();
};
Suggestions$1.prototype.normalize = function(value) {
  value = value.toLowerCase();
  return value;
};
Suggestions$1.prototype.match = function(candidate, query) {
  return candidate.indexOf(query) > -1;
};
Suggestions$1.prototype.value = function(value) {
  this.selected = value;
  this.el.value = this.getItemValue(value);
  if (document.createEvent) {
    var e = document.createEvent("HTMLEvents");
    e.initEvent("change", true, false);
    this.el.dispatchEvent(e);
  } else {
    this.el.fireEvent("onchange");
  }
};
Suggestions$1.prototype.getCandidates = function(callback) {
  var options = {
    pre: "<strong>",
    post: "</strong>",
    extract: function(d) {
      return this.getItemValue(d);
    }.bind(this)
  };
  var results;
  if (this.options.filter) {
    results = fuzzy.filter(this.query, this.data, options);
    results = results.map(function(item) {
      return {
        original: item.original,
        string: this.render(item.original, item.string)
      };
    }.bind(this));
  } else {
    results = this.data.map(function(d) {
      var renderedString = this.render(d);
      return {
        original: d,
        string: renderedString
      };
    }.bind(this));
  }
  callback(results);
};
Suggestions$1.prototype.getItemValue = function(item) {
  return item;
};
Suggestions$1.prototype.render = function(item, sourceFormatting) {
  if (sourceFormatting) {
    return sourceFormatting;
  }
  var boldString = item.original ? this.getItemValue(item.original) : this.getItemValue(item);
  var indexString = this.normalize(boldString);
  var indexOfQuery = indexString.lastIndexOf(this.query);
  while (indexOfQuery > -1) {
    var endIndexOfQuery = indexOfQuery + this.query.length;
    boldString = boldString.slice(0, indexOfQuery) + "<strong>" + boldString.slice(indexOfQuery, endIndexOfQuery) + "</strong>" + boldString.slice(endIndexOfQuery);
    indexOfQuery = indexString.slice(0, indexOfQuery).lastIndexOf(this.query);
  }
  return boldString;
};
Suggestions$1.prototype.renderError = function(msg) {
  this.list.drawError(msg);
};
var suggestions$1 = Suggestions$1;
var Suggestions = suggestions$1;
var suggestions = Suggestions;
if (typeof window !== "undefined") {
  window.Suggestions = Suggestions;
}
var FUNC_ERROR_TEXT = "Expected a function";
var NAN = 0 / 0;
var symbolTag = "[object Symbol]";
var reTrim = /^\s+|\s+$/g;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
var objectProto = Object.prototype;
var objectToString = objectProto.toString;
var nativeMax = Math.max, nativeMin = Math.min;
var now = function() {
  return root.Date.now();
};
function debounce$1(func2, wait, options) {
  var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func2 != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result2 = func2.apply(thisArg, args);
    return result2;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result2;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result3 = wait - timeSinceLastCall;
    return maxing ? nativeMin(result3, maxWait - timeSinceLastInvoke) : result3;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result2;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush2() {
    return timerId === void 0 ? result2 : trailingEdge(now());
  }
  function debounced() {
    var time = now(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result2;
  }
  debounced.cancel = cancel;
  debounced.flush = flush2;
  return debounced;
}
function isObject(value) {
  var type = typeof value;
  return !!value && (type == "object" || type == "function");
}
function isObjectLike(value) {
  return !!value && typeof value == "object";
}
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, "");
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var lodash_debounce = debounce$1;
var events$1 = { exports: {} };
var R = typeof Reflect === "object" ? Reflect : null;
var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply2(target, receiver, args) {
  return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === "function") {
  ReflectOwnKeys = R.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys2(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys2(target) {
    return Object.getOwnPropertyNames(target);
  };
}
function ProcessEmitWarning(warning) {
  if (console && console.warn)
    console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN2(value) {
  return value !== value;
};
function EventEmitter$2() {
  EventEmitter$2.init.call(this);
}
events$1.exports = EventEmitter$2;
events$1.exports.once = once2;
EventEmitter$2.EventEmitter = EventEmitter$2;
EventEmitter$2.prototype._events = void 0;
EventEmitter$2.prototype._eventsCount = 0;
EventEmitter$2.prototype._maxListeners = void 0;
var defaultMaxListeners = 10;
function checkListener(listener) {
  if (typeof listener !== "function") {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}
Object.defineProperty(EventEmitter$2, "defaultMaxListeners", {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
    }
    defaultMaxListeners = arg;
  }
});
EventEmitter$2.init = function() {
  if (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) {
    this._events = /* @__PURE__ */ Object.create(null);
    this._eventsCount = 0;
  }
  this._maxListeners = this._maxListeners || void 0;
};
EventEmitter$2.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
  }
  this._maxListeners = n;
  return this;
};
function _getMaxListeners(that) {
  if (that._maxListeners === void 0)
    return EventEmitter$2.defaultMaxListeners;
  return that._maxListeners;
}
EventEmitter$2.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};
EventEmitter$2.prototype.emit = function emit(type) {
  var args = [];
  for (var i2 = 1; i2 < arguments.length; i2++)
    args.push(arguments[i2]);
  var doError = type === "error";
  var events2 = this._events;
  if (events2 !== void 0)
    doError = doError && events2.error === void 0;
  else if (!doError)
    return false;
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      throw er;
    }
    var err2 = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
    err2.context = er;
    throw err2;
  }
  var handler = events2[type];
  if (handler === void 0)
    return false;
  if (typeof handler === "function") {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners2 = arrayClone(handler, len);
    for (var i2 = 0; i2 < len; ++i2)
      ReflectApply(listeners2[i2], this, args);
  }
  return true;
};
function _addListener(target, type, listener, prepend2) {
  var m;
  var events2;
  var existing;
  checkListener(listener);
  events2 = target._events;
  if (events2 === void 0) {
    events2 = target._events = /* @__PURE__ */ Object.create(null);
    target._eventsCount = 0;
  } else {
    if (events2.newListener !== void 0) {
      target.emit("newListener", type, listener.listener ? listener.listener : listener);
      events2 = target._events;
    }
    existing = events2[type];
  }
  if (existing === void 0) {
    existing = events2[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === "function") {
      existing = events2[type] = prepend2 ? [listener, existing] : [existing, listener];
    } else if (prepend2) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      w.name = "MaxListenersExceededWarning";
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }
  return target;
}
EventEmitter$2.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};
EventEmitter$2.prototype.on = EventEmitter$2.prototype.addListener;
EventEmitter$2.prototype.prependListener = function prependListener(type, listener) {
  return _addListener(this, type, listener, true);
};
function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}
function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: void 0, target, type, listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}
EventEmitter$2.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};
EventEmitter$2.prototype.prependOnceListener = function prependOnceListener(type, listener) {
  checkListener(listener);
  this.prependListener(type, _onceWrap(this, type, listener));
  return this;
};
EventEmitter$2.prototype.removeListener = function removeListener(type, listener) {
  var list2, events2, position, i2, originalListener;
  checkListener(listener);
  events2 = this._events;
  if (events2 === void 0)
    return this;
  list2 = events2[type];
  if (list2 === void 0)
    return this;
  if (list2 === listener || list2.listener === listener) {
    if (--this._eventsCount === 0)
      this._events = /* @__PURE__ */ Object.create(null);
    else {
      delete events2[type];
      if (events2.removeListener)
        this.emit("removeListener", type, list2.listener || listener);
    }
  } else if (typeof list2 !== "function") {
    position = -1;
    for (i2 = list2.length - 1; i2 >= 0; i2--) {
      if (list2[i2] === listener || list2[i2].listener === listener) {
        originalListener = list2[i2].listener;
        position = i2;
        break;
      }
    }
    if (position < 0)
      return this;
    if (position === 0)
      list2.shift();
    else {
      spliceOne(list2, position);
    }
    if (list2.length === 1)
      events2[type] = list2[0];
    if (events2.removeListener !== void 0)
      this.emit("removeListener", type, originalListener || listener);
  }
  return this;
};
EventEmitter$2.prototype.off = EventEmitter$2.prototype.removeListener;
EventEmitter$2.prototype.removeAllListeners = function removeAllListeners(type) {
  var listeners2, events2, i2;
  events2 = this._events;
  if (events2 === void 0)
    return this;
  if (events2.removeListener === void 0) {
    if (arguments.length === 0) {
      this._events = /* @__PURE__ */ Object.create(null);
      this._eventsCount = 0;
    } else if (events2[type] !== void 0) {
      if (--this._eventsCount === 0)
        this._events = /* @__PURE__ */ Object.create(null);
      else
        delete events2[type];
    }
    return this;
  }
  if (arguments.length === 0) {
    var keys2 = Object.keys(events2);
    var key;
    for (i2 = 0; i2 < keys2.length; ++i2) {
      key = keys2[i2];
      if (key === "removeListener")
        continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners("removeListener");
    this._events = /* @__PURE__ */ Object.create(null);
    this._eventsCount = 0;
    return this;
  }
  listeners2 = events2[type];
  if (typeof listeners2 === "function") {
    this.removeListener(type, listeners2);
  } else if (listeners2 !== void 0) {
    for (i2 = listeners2.length - 1; i2 >= 0; i2--) {
      this.removeListener(type, listeners2[i2]);
    }
  }
  return this;
};
function _listeners(target, type, unwrap) {
  var events2 = target._events;
  if (events2 === void 0)
    return [];
  var evlistener = events2[type];
  if (evlistener === void 0)
    return [];
  if (typeof evlistener === "function")
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];
  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter$2.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};
EventEmitter$2.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};
EventEmitter$2.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === "function") {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};
EventEmitter$2.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events2 = this._events;
  if (events2 !== void 0) {
    var evlistener = events2[type];
    if (typeof evlistener === "function") {
      return 1;
    } else if (evlistener !== void 0) {
      return evlistener.length;
    }
  }
  return 0;
}
EventEmitter$2.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
  var copy5 = new Array(n);
  for (var i2 = 0; i2 < n; ++i2)
    copy5[i2] = arr[i2];
  return copy5;
}
function spliceOne(list2, index3) {
  for (; index3 + 1 < list2.length; index3++)
    list2[index3] = list2[index3 + 1];
  list2.pop();
}
function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i2 = 0; i2 < ret.length; ++i2) {
    ret[i2] = arr[i2].listener || arr[i2];
  }
  return ret;
}
function once2(emitter, name) {
  return new Promise(function(resolve7, reject) {
    function errorListener(err2) {
      emitter.removeListener(name, resolver);
      reject(err2);
    }
    function resolver() {
      if (typeof emitter.removeListener === "function") {
        emitter.removeListener("error", errorListener);
      }
      resolve7([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== "error") {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === "function") {
    eventTargetAgnosticAddListener(emitter, "error", handler, flags);
  }
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === "function") {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === "function") {
    emitter.addEventListener(name, function wrapListener(arg) {
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}
var exceptions$1 = {
  "fr": {
    "name": "France",
    "bbox": [[-4.59235, 41.380007], [9.560016, 51.148506]]
  },
  "us": {
    "name": "United States",
    "bbox": [[-171.791111, 18.91619], [-66.96466, 71.357764]]
  },
  "ru": {
    "name": "Russia",
    "bbox": [[19.66064, 41.151416], [190.10042, 81.2504]]
  },
  "ca": {
    "name": "Canada",
    "bbox": [[-140.99778, 41.675105], [-52.648099, 83.23324]]
  }
};
function parseParam(param) {
  var parts = param.match(/\s*(.+)\s*=\s*"?([^"]+)"?/);
  if (!parts)
    return null;
  return {
    key: parts[1],
    value: parts[2]
  };
}
function parseLink(link2) {
  var parts = link2.match(/<?([^>]*)>(.*)/);
  if (!parts)
    return null;
  var linkUrl = parts[1];
  var linkParams = parts[2].split(";");
  var rel = null;
  var parsedLinkParams = linkParams.reduce(function(result2, param) {
    var parsed = parseParam(param);
    if (!parsed)
      return result2;
    if (parsed.key === "rel") {
      if (!rel) {
        rel = parsed.value;
      }
      return result2;
    }
    result2[parsed.key] = parsed.value;
    return result2;
  }, {});
  if (!rel)
    return null;
  return {
    url: linkUrl,
    rel,
    params: parsedLinkParams
  };
}
function parseLinkHeader$1(linkHeader) {
  if (!linkHeader)
    return {};
  return linkHeader.split(/,\s*</).reduce(function(result2, link2) {
    var parsed = parseLink(link2);
    if (!parsed)
      return result2;
    var splitRel = parsed.rel.split(/\s+/);
    splitRel.forEach(function(rel) {
      if (!result2[rel]) {
        result2[rel] = {
          url: parsed.url,
          params: parsed.params
        };
      }
    });
    return result2;
  }, {});
}
var parseLinkHeader_1 = parseLinkHeader$1;
var parseLinkHeader = parseLinkHeader_1;
function MapiResponse$1(request, responseData) {
  this.request = request;
  this.headers = responseData.headers;
  this.rawBody = responseData.body;
  this.statusCode = responseData.statusCode;
  try {
    this.body = JSON.parse(responseData.body || "{}");
  } catch (parseError) {
    this.body = responseData.body;
  }
  this.links = parseLinkHeader(this.headers.link);
}
MapiResponse$1.prototype.hasNextPage = function hasNextPage() {
  return !!this.links.next;
};
MapiResponse$1.prototype.nextPage = function nextPage() {
  if (!this.hasNextPage())
    return null;
  return this.request._extend({
    path: this.links.next.url
  });
};
var mapiResponse = MapiResponse$1;
var constants$4 = {
  API_ORIGIN: "https://api.mapbox.com",
  EVENT_PROGRESS_DOWNLOAD: "downloadProgress",
  EVENT_PROGRESS_UPLOAD: "uploadProgress",
  EVENT_ERROR: "error",
  EVENT_RESPONSE: "response",
  ERROR_HTTP: "HttpError",
  ERROR_REQUEST_ABORTED: "RequestAbortedError"
};
var constants$3 = constants$4;
function MapiError$1(options) {
  var errorType = options.type || constants$3.ERROR_HTTP;
  var body;
  if (options.body) {
    try {
      body = JSON.parse(options.body);
    } catch (e) {
      body = options.body;
    }
  } else {
    body = null;
  }
  var message = options.message || null;
  if (!message) {
    if (typeof body === "string") {
      message = body;
    } else if (body && typeof body.message === "string") {
      message = body.message;
    } else if (errorType === constants$3.ERROR_REQUEST_ABORTED) {
      message = "Request aborted";
    }
  }
  this.message = message;
  this.type = errorType;
  this.statusCode = options.statusCode || null;
  this.request = options.request;
  this.body = body;
}
var mapiError = MapiError$1;
function parseSingleHeader(raw) {
  var boundary = raw.indexOf(":");
  var name = raw.substring(0, boundary).trim().toLowerCase();
  var value = raw.substring(boundary + 1).trim();
  return {
    name,
    value
  };
}
function parseHeaders$1(raw) {
  var headers = {};
  if (!raw) {
    return headers;
  }
  raw.trim().split(/[\r|\n]+/).forEach(function(rawHeader) {
    var parsed = parseSingleHeader(rawHeader);
    headers[parsed.name] = parsed.value;
  });
  return headers;
}
var parseHeaders_1 = parseHeaders$1;
var MapiResponse = mapiResponse;
var MapiError = mapiError;
var constants$2 = constants$4;
var parseHeaders = parseHeaders_1;
var requestsUnderway = {};
function browserAbort(request) {
  var xhr = requestsUnderway[request.id];
  if (!xhr)
    return;
  xhr.abort();
  delete requestsUnderway[request.id];
}
function createResponse(request, xhr) {
  return new MapiResponse(request, {
    body: xhr.response,
    headers: parseHeaders(xhr.getAllResponseHeaders()),
    statusCode: xhr.status
  });
}
function normalizeBrowserProgressEvent(event) {
  var total = event.total;
  var transferred = event.loaded;
  var percent = 100 * transferred / total;
  return {
    total,
    transferred,
    percent
  };
}
function sendRequestXhr(request, xhr) {
  return new Promise(function(resolve7, reject) {
    xhr.onprogress = function(event) {
      request.emitter.emit(constants$2.EVENT_PROGRESS_DOWNLOAD, normalizeBrowserProgressEvent(event));
    };
    var file2 = request.file;
    if (file2) {
      xhr.upload.onprogress = function(event) {
        request.emitter.emit(constants$2.EVENT_PROGRESS_UPLOAD, normalizeBrowserProgressEvent(event));
      };
    }
    xhr.onerror = function(error) {
      reject(error);
    };
    xhr.onabort = function() {
      var mapiError2 = new MapiError({
        request,
        type: constants$2.ERROR_REQUEST_ABORTED
      });
      reject(mapiError2);
    };
    xhr.onload = function() {
      delete requestsUnderway[request.id];
      if (xhr.status < 200 || xhr.status >= 400) {
        var mapiError2 = new MapiError({
          request,
          body: xhr.response,
          statusCode: xhr.status
        });
        reject(mapiError2);
        return;
      }
      resolve7(xhr);
    };
    var body = request.body;
    if (typeof body === "string") {
      xhr.send(body);
    } else if (body) {
      xhr.send(JSON.stringify(body));
    } else if (file2) {
      xhr.send(file2);
    } else {
      xhr.send();
    }
    requestsUnderway[request.id] = xhr;
  }).then(function(xhr2) {
    return createResponse(request, xhr2);
  });
}
function createRequestXhr(request, accessToken) {
  var url3 = request.url(accessToken);
  var xhr = new window.XMLHttpRequest();
  xhr.open(request.method, url3);
  Object.keys(request.headers).forEach(function(key) {
    xhr.setRequestHeader(key, request.headers[key]);
  });
  return xhr;
}
function browserSend(request) {
  return Promise.resolve().then(function() {
    var xhr = createRequestXhr(request, request.client.accessToken);
    return sendRequestXhr(request, xhr);
  });
}
var browserLayer = {
  browserAbort,
  sendRequestXhr,
  browserSend,
  createRequestXhr
};
var base64$1 = { exports: {} };
/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */
(function(module2, exports) {
  (function(root2) {
    var freeExports = exports;
    var freeModule = module2 && module2.exports == freeExports && module2;
    var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal;
    if (freeGlobal2.global === freeGlobal2 || freeGlobal2.window === freeGlobal2) {
      root2 = freeGlobal2;
    }
    var InvalidCharacterError = function(message) {
      this.message = message;
    };
    InvalidCharacterError.prototype = new Error();
    InvalidCharacterError.prototype.name = "InvalidCharacterError";
    var error = function(message) {
      throw new InvalidCharacterError(message);
    };
    var TABLE = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;
    var decode = function(input) {
      input = String(input).replace(REGEX_SPACE_CHARACTERS, "");
      var length = input.length;
      if (length % 4 == 0) {
        input = input.replace(/==?$/, "");
        length = input.length;
      }
      if (length % 4 == 1 || /[^+a-zA-Z0-9/]/.test(input)) {
        error("Invalid character: the string to be decoded is not correctly encoded.");
      }
      var bitCounter = 0;
      var bitStorage;
      var buffer;
      var output = "";
      var position = -1;
      while (++position < length) {
        buffer = TABLE.indexOf(input.charAt(position));
        bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
        if (bitCounter++ % 4) {
          output += String.fromCharCode(255 & bitStorage >> (-2 * bitCounter & 6));
        }
      }
      return output;
    };
    var encode = function(input) {
      input = String(input);
      if (/[^\0-\xFF]/.test(input)) {
        error("The string to be encoded contains characters outside of the Latin1 range.");
      }
      var padding = input.length % 3;
      var output = "";
      var position = -1;
      var a;
      var b;
      var c;
      var buffer;
      var length = input.length - padding;
      while (++position < length) {
        a = input.charCodeAt(position) << 16;
        b = input.charCodeAt(++position) << 8;
        c = input.charCodeAt(++position);
        buffer = a + b + c;
        output += TABLE.charAt(buffer >> 18 & 63) + TABLE.charAt(buffer >> 12 & 63) + TABLE.charAt(buffer >> 6 & 63) + TABLE.charAt(buffer & 63);
      }
      if (padding == 2) {
        a = input.charCodeAt(position) << 8;
        b = input.charCodeAt(++position);
        buffer = a + b;
        output += TABLE.charAt(buffer >> 10) + TABLE.charAt(buffer >> 4 & 63) + TABLE.charAt(buffer << 2 & 63) + "=";
      } else if (padding == 1) {
        buffer = input.charCodeAt(position);
        output += TABLE.charAt(buffer >> 2) + TABLE.charAt(buffer << 4 & 63) + "==";
      }
      return output;
    };
    var base642 = {
      "encode": encode,
      "decode": decode,
      "version": "0.1.0"
    };
    if (freeExports && !freeExports.nodeType) {
      if (freeModule) {
        freeModule.exports = base642;
      } else {
        for (var key in base642) {
          base642.hasOwnProperty(key) && (freeExports[key] = base642[key]);
        }
      }
    } else {
      root2.base64 = base642;
    }
  })(commonjsGlobal);
})(base64$1, base64$1.exports);
var base64 = base64$1.exports;
var tokenCache = {};
function parseToken$2(token2) {
  if (tokenCache[token2]) {
    return tokenCache[token2];
  }
  var parts = token2.split(".");
  var usage = parts[0];
  var rawPayload = parts[1];
  if (!rawPayload) {
    throw new Error("Invalid token");
  }
  var parsedPayload = parsePaylod(rawPayload);
  var result2 = {
    usage,
    user: parsedPayload.u
  };
  if (has(parsedPayload, "a"))
    result2.authorization = parsedPayload.a;
  if (has(parsedPayload, "exp"))
    result2.expires = parsedPayload.exp * 1e3;
  if (has(parsedPayload, "iat"))
    result2.created = parsedPayload.iat * 1e3;
  if (has(parsedPayload, "scopes"))
    result2.scopes = parsedPayload.scopes;
  if (has(parsedPayload, "client"))
    result2.client = parsedPayload.client;
  if (has(parsedPayload, "ll"))
    result2.lastLogin = parsedPayload.ll;
  if (has(parsedPayload, "iu"))
    result2.impersonator = parsedPayload.iu;
  tokenCache[token2] = result2;
  return result2;
}
function parsePaylod(rawPayload) {
  try {
    return JSON.parse(base64.decode(rawPayload));
  } catch (parseError) {
    throw new Error("Invalid token");
  }
}
function has(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}
var parseMapboxToken = parseToken$2;
var eventemitter3 = { exports: {} };
(function(module2) {
  var has2 = Object.prototype.hasOwnProperty, prefix2 = "~";
  function Events() {
  }
  if (Object.create) {
    Events.prototype = /* @__PURE__ */ Object.create(null);
    if (!new Events().__proto__)
      prefix2 = false;
  }
  function EE(fn, context, once3) {
    this.fn = fn;
    this.context = context;
    this.once = once3 || false;
  }
  function addListener2(emitter, event, fn, context, once3) {
    if (typeof fn !== "function") {
      throw new TypeError("The listener must be a function");
    }
    var listener = new EE(fn, context || emitter, once3), evt = prefix2 ? prefix2 + event : event;
    if (!emitter._events[evt])
      emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn)
      emitter._events[evt].push(listener);
    else
      emitter._events[evt] = [emitter._events[evt], listener];
    return emitter;
  }
  function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0)
      emitter._events = new Events();
    else
      delete emitter._events[evt];
  }
  function EventEmitter2() {
    this._events = new Events();
    this._eventsCount = 0;
  }
  EventEmitter2.prototype.eventNames = function eventNames2() {
    var names = [], events2, name;
    if (this._eventsCount === 0)
      return names;
    for (name in events2 = this._events) {
      if (has2.call(events2, name))
        names.push(prefix2 ? name.slice(1) : name);
    }
    if (Object.getOwnPropertySymbols) {
      return names.concat(Object.getOwnPropertySymbols(events2));
    }
    return names;
  };
  EventEmitter2.prototype.listeners = function listeners2(event) {
    var evt = prefix2 ? prefix2 + event : event, handlers2 = this._events[evt];
    if (!handlers2)
      return [];
    if (handlers2.fn)
      return [handlers2.fn];
    for (var i2 = 0, l = handlers2.length, ee = new Array(l); i2 < l; i2++) {
      ee[i2] = handlers2[i2].fn;
    }
    return ee;
  };
  EventEmitter2.prototype.listenerCount = function listenerCount2(event) {
    var evt = prefix2 ? prefix2 + event : event, listeners2 = this._events[evt];
    if (!listeners2)
      return 0;
    if (listeners2.fn)
      return 1;
    return listeners2.length;
  };
  EventEmitter2.prototype.emit = function emit2(event, a1, a2, a3, a4, a5) {
    var evt = prefix2 ? prefix2 + event : event;
    if (!this._events[evt])
      return false;
    var listeners2 = this._events[evt], len = arguments.length, args, i2;
    if (listeners2.fn) {
      if (listeners2.once)
        this.removeListener(event, listeners2.fn, void 0, true);
      switch (len) {
        case 1:
          return listeners2.fn.call(listeners2.context), true;
        case 2:
          return listeners2.fn.call(listeners2.context, a1), true;
        case 3:
          return listeners2.fn.call(listeners2.context, a1, a2), true;
        case 4:
          return listeners2.fn.call(listeners2.context, a1, a2, a3), true;
        case 5:
          return listeners2.fn.call(listeners2.context, a1, a2, a3, a4), true;
        case 6:
          return listeners2.fn.call(listeners2.context, a1, a2, a3, a4, a5), true;
      }
      for (i2 = 1, args = new Array(len - 1); i2 < len; i2++) {
        args[i2 - 1] = arguments[i2];
      }
      listeners2.fn.apply(listeners2.context, args);
    } else {
      var length = listeners2.length, j;
      for (i2 = 0; i2 < length; i2++) {
        if (listeners2[i2].once)
          this.removeListener(event, listeners2[i2].fn, void 0, true);
        switch (len) {
          case 1:
            listeners2[i2].fn.call(listeners2[i2].context);
            break;
          case 2:
            listeners2[i2].fn.call(listeners2[i2].context, a1);
            break;
          case 3:
            listeners2[i2].fn.call(listeners2[i2].context, a1, a2);
            break;
          case 4:
            listeners2[i2].fn.call(listeners2[i2].context, a1, a2, a3);
            break;
          default:
            if (!args)
              for (j = 1, args = new Array(len - 1); j < len; j++) {
                args[j - 1] = arguments[j];
              }
            listeners2[i2].fn.apply(listeners2[i2].context, args);
        }
      }
    }
    return true;
  };
  EventEmitter2.prototype.on = function on(event, fn, context) {
    return addListener2(this, event, fn, context, false);
  };
  EventEmitter2.prototype.once = function once3(event, fn, context) {
    return addListener2(this, event, fn, context, true);
  };
  EventEmitter2.prototype.removeListener = function removeListener2(event, fn, context, once3) {
    var evt = prefix2 ? prefix2 + event : event;
    if (!this._events[evt])
      return this;
    if (!fn) {
      clearEvent(this, evt);
      return this;
    }
    var listeners2 = this._events[evt];
    if (listeners2.fn) {
      if (listeners2.fn === fn && (!once3 || listeners2.once) && (!context || listeners2.context === context)) {
        clearEvent(this, evt);
      }
    } else {
      for (var i2 = 0, events2 = [], length = listeners2.length; i2 < length; i2++) {
        if (listeners2[i2].fn !== fn || once3 && !listeners2[i2].once || context && listeners2[i2].context !== context) {
          events2.push(listeners2[i2]);
        }
      }
      if (events2.length)
        this._events[evt] = events2.length === 1 ? events2[0] : events2;
      else
        clearEvent(this, evt);
    }
    return this;
  };
  EventEmitter2.prototype.removeAllListeners = function removeAllListeners2(event) {
    var evt;
    if (event) {
      evt = prefix2 ? prefix2 + event : event;
      if (this._events[evt])
        clearEvent(this, evt);
    } else {
      this._events = new Events();
      this._eventsCount = 0;
    }
    return this;
  };
  EventEmitter2.prototype.off = EventEmitter2.prototype.removeListener;
  EventEmitter2.prototype.addListener = EventEmitter2.prototype.on;
  EventEmitter2.prefixed = prefix2;
  EventEmitter2.EventEmitter = EventEmitter2;
  {
    module2.exports = EventEmitter2;
  }
})(eventemitter3);
function encodeArray(arrayValue) {
  return arrayValue.map(encodeURIComponent).join(",");
}
function encodeValue(value) {
  if (Array.isArray(value)) {
    return encodeArray(value);
  }
  return encodeURIComponent(String(value));
}
function appendQueryParam(url3, key, value) {
  if (value === false || value === null) {
    return url3;
  }
  var punctuation = /\?/.test(url3) ? "&" : "?";
  var query = encodeURIComponent(key);
  if (value !== void 0 && value !== "" && value !== true) {
    query += "=" + encodeValue(value);
  }
  return "" + url3 + punctuation + query;
}
function appendQueryObject(url3, queryObject) {
  if (!queryObject) {
    return url3;
  }
  var result2 = url3;
  Object.keys(queryObject).forEach(function(key) {
    var value = queryObject[key];
    if (value === void 0) {
      return;
    }
    if (Array.isArray(value)) {
      value = value.filter(function(v2) {
        return v2 !== null && v2 !== void 0;
      }).join(",");
    }
    result2 = appendQueryParam(result2, key, value);
  });
  return result2;
}
function prependOrigin(url3, origin) {
  if (!origin) {
    return url3;
  }
  if (url3.slice(0, 4) === "http") {
    return url3;
  }
  var delimiter = url3[0] === "/" ? "" : "/";
  return "" + origin.replace(/\/$/, "") + delimiter + url3;
}
function interpolateRouteParams(route2, params) {
  if (!params) {
    return route2;
  }
  return route2.replace(/\/:([a-zA-Z0-9]+)/g, function(_, paramId) {
    var value = params[paramId];
    if (value === void 0) {
      throw new Error("Unspecified route parameter " + paramId);
    }
    var preppedValue = encodeValue(value);
    return "/" + preppedValue;
  });
}
var urlUtils$1 = {
  appendQueryObject,
  appendQueryParam,
  prependOrigin,
  interpolateRouteParams
};
var parseToken$1 = parseMapboxToken;
var xtend$3 = immutable;
var EventEmitter$1 = eventemitter3.exports;
var urlUtils = urlUtils$1;
var constants$1 = constants$4;
var requestId = 1;
function MapiRequest$1(client2, options) {
  if (!client2) {
    throw new Error("MapiRequest requires a client");
  }
  if (!options || !options.path || !options.method) {
    throw new Error("MapiRequest requires an options object with path and method properties");
  }
  var defaultHeaders = {};
  if (options.body) {
    defaultHeaders["content-type"] = "application/json";
  }
  var headersWithDefaults = xtend$3(defaultHeaders, options.headers);
  var headers = Object.keys(headersWithDefaults).reduce(function(memo, name) {
    memo[name.toLowerCase()] = headersWithDefaults[name];
    return memo;
  }, {});
  this.id = requestId++;
  this._options = options;
  this.emitter = new EventEmitter$1();
  this.client = client2;
  this.response = null;
  this.error = null;
  this.sent = false;
  this.aborted = false;
  this.path = options.path;
  this.method = options.method;
  this.origin = options.origin || client2.origin;
  this.query = options.query || {};
  this.params = options.params || {};
  this.body = options.body || null;
  this.file = options.file || null;
  this.encoding = options.encoding || "utf8";
  this.sendFileAs = options.sendFileAs || null;
  this.headers = headers;
}
MapiRequest$1.prototype.url = function url(accessToken) {
  var url3 = urlUtils.prependOrigin(this.path, this.origin);
  url3 = urlUtils.appendQueryObject(url3, this.query);
  var routeParams = this.params;
  var actualAccessToken = accessToken == null ? this.client.accessToken : accessToken;
  if (actualAccessToken) {
    url3 = urlUtils.appendQueryParam(url3, "access_token", actualAccessToken);
    var accessTokenOwnerId = parseToken$1(actualAccessToken).user;
    routeParams = xtend$3({ ownerId: accessTokenOwnerId }, routeParams);
  }
  url3 = urlUtils.interpolateRouteParams(url3, routeParams);
  return url3;
};
MapiRequest$1.prototype.send = function send() {
  var self2 = this;
  if (self2.sent) {
    throw new Error("This request has already been sent. Check the response and error properties. Create a new request with clone().");
  }
  self2.sent = true;
  return self2.client.sendRequest(self2).then(function(response) {
    self2.response = response;
    self2.emitter.emit(constants$1.EVENT_RESPONSE, response);
    return response;
  }, function(error) {
    self2.error = error;
    self2.emitter.emit(constants$1.EVENT_ERROR, error);
    throw error;
  });
};
MapiRequest$1.prototype.abort = function abort() {
  if (this._nextPageRequest) {
    this._nextPageRequest.abort();
    delete this._nextPageRequest;
  }
  if (this.response || this.error || this.aborted)
    return;
  this.aborted = true;
  this.client.abortRequest(this);
};
MapiRequest$1.prototype.eachPage = function eachPage(callback) {
  var self2 = this;
  function handleResponse(response) {
    function getNextPage() {
      delete self2._nextPageRequest;
      var nextPageRequest = response.nextPage();
      if (nextPageRequest) {
        self2._nextPageRequest = nextPageRequest;
        getPage(nextPageRequest);
      }
    }
    callback(null, response, getNextPage);
  }
  function handleError(error) {
    callback(error, null, function() {
    });
  }
  function getPage(request) {
    request.send().then(handleResponse, handleError);
  }
  getPage(this);
};
MapiRequest$1.prototype.clone = function clone2() {
  return this._extend();
};
MapiRequest$1.prototype._extend = function _extend(options) {
  var extendedOptions = xtend$3(this._options, options);
  return new MapiRequest$1(this.client, extendedOptions);
};
var mapiRequest = MapiRequest$1;
var parseToken = parseMapboxToken;
var MapiRequest = mapiRequest;
var constants = constants$4;
function MapiClient$2(options) {
  if (!options || !options.accessToken) {
    throw new Error("Cannot create a client without an access token");
  }
  parseToken(options.accessToken);
  this.accessToken = options.accessToken;
  this.origin = options.origin || constants.API_ORIGIN;
}
MapiClient$2.prototype.createRequest = function createRequest(requestOptions) {
  return new MapiRequest(this, requestOptions);
};
var mapiClient = MapiClient$2;
var browser$1 = browserLayer;
var MapiClient$1 = mapiClient;
function BrowserClient(options) {
  MapiClient$1.call(this, options);
}
BrowserClient.prototype = Object.create(MapiClient$1.prototype);
BrowserClient.prototype.constructor = BrowserClient;
BrowserClient.prototype.sendRequest = browser$1.browserSend;
BrowserClient.prototype.abortRequest = browser$1.browserAbort;
function createBrowserClient(options) {
  return new BrowserClient(options);
}
var browserClient = createBrowserClient;
var client = browserClient;
var mapboxSdk = client;
var toString7 = Object.prototype.toString;
var isPlainObj = function(x2) {
  var prototype;
  return toString7.call(x2) === "[object Object]" && (prototype = Object.getPrototypeOf(x2), prototype === null || prototype === Object.getPrototypeOf({}));
};
var isPlainObject = isPlainObj;
var xtend$2 = immutable;
var DEFAULT_ERROR_PATH = "value";
var NEWLINE_INDENT = "\n  ";
var v$2 = {};
v$2.assert = function(rootValidator, options) {
  options = options || {};
  return function(value) {
    var message = validate(rootValidator, value);
    if (!message) {
      return;
    }
    var errorMessage = processMessage(message, options);
    if (options.apiName) {
      errorMessage = options.apiName + ": " + errorMessage;
    }
    throw new Error(errorMessage);
  };
};
v$2.shape = function shape(validatorObj) {
  var validators2 = objectEntries(validatorObj);
  return function shapeValidator(value) {
    var validationResult = validate(v$2.plainObject, value);
    if (validationResult) {
      return validationResult;
    }
    var key, validator2;
    var errorMessages2 = [];
    for (var i2 = 0; i2 < validators2.length; i2++) {
      key = validators2[i2].key;
      validator2 = validators2[i2].value;
      validationResult = validate(validator2, value[key]);
      if (validationResult) {
        errorMessages2.push([key].concat(validationResult));
      }
    }
    if (errorMessages2.length < 2) {
      return errorMessages2[0];
    }
    return function(options) {
      errorMessages2 = errorMessages2.map(function(message) {
        var key2 = message[0];
        var renderedMessage = processMessage(message, options).split("\n").join(NEWLINE_INDENT);
        return "- " + key2 + ": " + renderedMessage;
      });
      var objectId = options.path.join(".");
      var ofPhrase = objectId === DEFAULT_ERROR_PATH ? "" : " of " + objectId;
      return "The following properties" + ofPhrase + " have invalid values:" + NEWLINE_INDENT + errorMessages2.join(NEWLINE_INDENT);
    };
  };
};
v$2.strictShape = function strictShape(validatorObj) {
  var shapeValidator = v$2.shape(validatorObj);
  return function strictShapeValidator(value) {
    var shapeResult = shapeValidator(value);
    if (shapeResult) {
      return shapeResult;
    }
    var invalidKeys = Object.keys(value).reduce(function(memo, valueKey) {
      if (validatorObj[valueKey] === void 0) {
        memo.push(valueKey);
      }
      return memo;
    }, []);
    if (invalidKeys.length !== 0) {
      return function() {
        return "The following keys are invalid: " + invalidKeys.join(", ");
      };
    }
  };
};
v$2.arrayOf = function arrayOf(validator2) {
  return createArrayValidator(validator2);
};
v$2.tuple = function tuple() {
  var validators2 = Array.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.call(arguments);
  return createArrayValidator(validators2);
};
function createArrayValidator(validators2) {
  var validatingTuple = Array.isArray(validators2);
  var getValidator = function(index3) {
    if (validatingTuple) {
      return validators2[index3];
    }
    return validators2;
  };
  return function arrayValidator(value) {
    var validationResult = validate(v$2.plainArray, value);
    if (validationResult) {
      return validationResult;
    }
    if (validatingTuple && value.length !== validators2.length) {
      return "an array with " + validators2.length + " items";
    }
    for (var i2 = 0; i2 < value.length; i2++) {
      validationResult = validate(getValidator(i2), value[i2]);
      if (validationResult) {
        return [i2].concat(validationResult);
      }
    }
  };
}
v$2.required = function required(validator2) {
  function requiredValidator(value) {
    if (value == null) {
      return function(options) {
        return formatErrorMessage(options, isArrayCulprit(options.path) ? "cannot be undefined/null." : "is required.");
      };
    }
    return validator2.apply(this, arguments);
  }
  requiredValidator.__required = true;
  return requiredValidator;
};
v$2.oneOfType = function oneOfType() {
  var validators2 = Array.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.call(arguments);
  return function oneOfTypeValidator(value) {
    var messages = validators2.map(function(validator2) {
      return validate(validator2, value);
    }).filter(Boolean);
    if (messages.length !== validators2.length) {
      return;
    }
    if (messages.every(function(message) {
      return message.length === 1 && typeof message[0] === "string";
    })) {
      return orList(messages.map(function(m) {
        return m[0];
      }));
    }
    return messages.reduce(function(max3, arr) {
      return arr.length > max3.length ? arr : max3;
    });
  };
};
v$2.equal = function equal(compareWith) {
  return function equalValidator(value) {
    if (value !== compareWith) {
      return JSON.stringify(compareWith);
    }
  };
};
v$2.oneOf = function oneOf() {
  var options = Array.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.call(arguments);
  var validators2 = options.map(function(value) {
    return v$2.equal(value);
  });
  return v$2.oneOfType.apply(this, validators2);
};
v$2.range = function range(compareWith) {
  var min3 = compareWith[0];
  var max3 = compareWith[1];
  return function rangeValidator(value) {
    var validationResult = validate(v$2.number, value);
    if (validationResult || value < min3 || value > max3) {
      return "number between " + min3 + " & " + max3 + " (inclusive)";
    }
  };
};
v$2.any = function any() {
  return;
};
v$2.boolean = function boolean(value) {
  if (typeof value !== "boolean") {
    return "boolean";
  }
};
v$2.number = function number(value) {
  if (typeof value !== "number") {
    return "number";
  }
};
v$2.plainArray = function plainArray(value) {
  if (!Array.isArray(value)) {
    return "array";
  }
};
v$2.plainObject = function plainObject(value) {
  if (!isPlainObject(value)) {
    return "object";
  }
};
v$2.string = function string(value) {
  if (typeof value !== "string") {
    return "string";
  }
};
v$2.func = function func(value) {
  if (typeof value !== "function") {
    return "function";
  }
};
function validate(validator2, value) {
  if (value == null && !validator2.hasOwnProperty("__required")) {
    return;
  }
  var result2 = validator2(value);
  if (result2) {
    return Array.isArray(result2) ? result2 : [result2];
  }
}
function processMessage(message, options) {
  var len = message.length;
  var result2 = message[len - 1];
  var path = message.slice(0, len - 1);
  if (path.length === 0) {
    path = [DEFAULT_ERROR_PATH];
  }
  options = xtend$2(options, { path });
  return typeof result2 === "function" ? result2(options) : formatErrorMessage(options, prettifyResult(result2));
}
function orList(list2) {
  if (list2.length < 2) {
    return list2[0];
  }
  if (list2.length === 2) {
    return list2.join(" or ");
  }
  return list2.slice(0, -1).join(", ") + ", or " + list2.slice(-1);
}
function prettifyResult(result2) {
  return "must be " + addArticle(result2) + ".";
}
function addArticle(nounPhrase) {
  if (/^an? /.test(nounPhrase)) {
    return nounPhrase;
  }
  if (/^[aeiou]/i.test(nounPhrase)) {
    return "an " + nounPhrase;
  }
  if (/^[a-z]/i.test(nounPhrase)) {
    return "a " + nounPhrase;
  }
  return nounPhrase;
}
function formatErrorMessage(options, prettyResult) {
  var arrayCulprit = isArrayCulprit(options.path);
  var output = options.path.join(".") + " " + prettyResult;
  var prepend2 = arrayCulprit ? "Item at position " : "";
  return prepend2 + output;
}
function isArrayCulprit(path) {
  return typeof path[path.length - 1] == "number" || typeof path[0] == "number";
}
function objectEntries(obj) {
  return Object.keys(obj || {}).map(function(key) {
    return { key, value: obj[key] };
  });
}
v$2.validate = validate;
v$2.processMessage = processMessage;
var lib$1 = v$2;
var xtend$1 = immutable;
var v$1 = lib$1;
function file(value) {
  if (typeof window !== "undefined") {
    if (value instanceof commonjsGlobal.Blob || value instanceof commonjsGlobal.ArrayBuffer) {
      return;
    }
    return "Blob or ArrayBuffer";
  }
  if (typeof value === "string" || value.pipe !== void 0) {
    return;
  }
  return "Filename or Readable stream";
}
function assertShape(validatorObj, apiName) {
  return v$1.assert(v$1.strictShape(validatorObj), apiName);
}
function date(value) {
  var msg = "date";
  if (typeof value === "boolean") {
    return msg;
  }
  try {
    var date2 = new Date(value);
    if (date2.getTime && isNaN(date2.getTime())) {
      return msg;
    }
  } catch (e) {
    return msg;
  }
}
function coordinates(value) {
  return v$1.tuple(v$1.number, v$1.number)(value);
}
var validator = xtend$1(v$1, {
  file,
  date,
  coordinates,
  assertShape
});
function pick$1(source2, keys2) {
  var filter2 = function(key, val) {
    return keys2.indexOf(key) !== -1 && val !== void 0;
  };
  if (typeof keys2 === "function") {
    filter2 = keys2;
  }
  return Object.keys(source2).filter(function(key) {
    return filter2(key, source2[key]);
  }).reduce(function(result2, key) {
    result2[key] = source2[key];
    return result2;
  }, {});
}
var pick_1 = pick$1;
function objectMap$1(obj, cb) {
  return Object.keys(obj).reduce(function(result2, key) {
    result2[key] = cb(key, obj[key]);
    return result2;
  }, {});
}
var objectMap_1 = objectMap$1;
var objectMap = objectMap_1;
function stringifyBoolean(obj) {
  return objectMap(obj, function(_, value) {
    return typeof value === "boolean" ? JSON.stringify(value) : value;
  });
}
var stringifyBooleans$1 = stringifyBoolean;
var MapiClient = mapiClient;
var createClient = browserClient;
function createServiceFactory$1(ServicePrototype) {
  return function(clientOrConfig) {
    var client2;
    if (MapiClient.prototype.isPrototypeOf(clientOrConfig)) {
      client2 = clientOrConfig;
    } else {
      client2 = createClient(clientOrConfig);
    }
    var service = Object.create(ServicePrototype);
    service.client = client2;
    return service;
  };
}
var createServiceFactory_1 = createServiceFactory$1;
var xtend = immutable;
var v = validator;
var pick = pick_1;
var stringifyBooleans = stringifyBooleans$1;
var createServiceFactory = createServiceFactory_1;
var Geocoding = {};
var featureTypes = [
  "country",
  "region",
  "postcode",
  "district",
  "place",
  "locality",
  "neighborhood",
  "address",
  "poi",
  "poi.landmark"
];
Geocoding.forwardGeocode = function(config2) {
  v.assertShape({
    query: v.required(v.string),
    mode: v.oneOf("mapbox.places", "mapbox.places-permanent"),
    countries: v.arrayOf(v.string),
    proximity: v.oneOf(v.coordinates, "ip"),
    types: v.arrayOf(v.oneOf(featureTypes)),
    autocomplete: v.boolean,
    bbox: v.arrayOf(v.number),
    limit: v.number,
    language: v.arrayOf(v.string),
    routing: v.boolean,
    fuzzyMatch: v.boolean,
    worldview: v.string
  })(config2);
  config2.mode = config2.mode || "mapbox.places";
  var query = stringifyBooleans(xtend({ country: config2.countries }, pick(config2, [
    "proximity",
    "types",
    "autocomplete",
    "bbox",
    "limit",
    "language",
    "routing",
    "fuzzyMatch",
    "worldview"
  ])));
  return this.client.createRequest({
    method: "GET",
    path: "/geocoding/v5/:mode/:query.json",
    params: pick(config2, ["mode", "query"]),
    query
  });
};
Geocoding.reverseGeocode = function(config2) {
  v.assertShape({
    query: v.required(v.coordinates),
    mode: v.oneOf("mapbox.places", "mapbox.places-permanent"),
    countries: v.arrayOf(v.string),
    types: v.arrayOf(v.oneOf(featureTypes)),
    bbox: v.arrayOf(v.number),
    limit: v.number,
    language: v.arrayOf(v.string),
    reverseMode: v.oneOf("distance", "score"),
    routing: v.boolean,
    worldview: v.string
  })(config2);
  config2.mode = config2.mode || "mapbox.places";
  var query = stringifyBooleans(xtend({ country: config2.countries }, pick(config2, [
    "country",
    "types",
    "bbox",
    "limit",
    "language",
    "reverseMode",
    "routing",
    "worldview"
  ])));
  return this.client.createRequest({
    method: "GET",
    path: "/geocoding/v5/:mode/:query.json",
    params: pick(config2, ["mode", "query"]),
    query
  });
};
var geocoding = createServiceFactory(Geocoding);
var crypto = self.crypto || self.msCrypto;
var url2 = "-_";
var i = 36;
while (i--) {
  url2 += i.toString(36);
}
i = 36;
while (i-- - 10) {
  url2 += i.toString(36).toUpperCase();
}
var index_browser = function(size) {
  var id = "";
  var bytes = crypto.getRandomValues(new Uint8Array(size || 21));
  i = size || 21;
  while (i--) {
    id += url2[bytes[i] & 63];
  }
  return id;
};
var nanoid = index_browser;
function MapboxEventManager$1(options) {
  this.origin = options.origin || "https://api.mapbox.com";
  this.endpoint = "events/v2";
  this.access_token = options.accessToken;
  this.version = "0.2.0";
  this.sessionID = this.generateSessionID();
  this.userAgent = this.getUserAgent();
  this.options = options;
  this.send = this.send.bind(this);
  this.countries = options.countries ? options.countries.split(",") : null;
  this.types = options.types ? options.types.split(",") : null;
  this.bbox = options.bbox ? options.bbox : null;
  this.language = options.language ? options.language.split(",") : null;
  this.limit = options.limit ? +options.limit : null;
  this.locale = navigator.language || null;
  this.enableEventLogging = this.shouldEnableLogging(options);
  this.eventQueue = new Array();
  this.flushInterval = options.flushInterval || 1e3;
  this.maxQueueSize = options.maxQueueSize || 100;
  this.timer = this.flushInterval ? setTimeout(this.flush.bind(this), this.flushInterval) : null;
  this.lastSentInput = "";
  this.lastSentIndex = 0;
}
MapboxEventManager$1.prototype = {
  select: function(selected, geocoder) {
    var resultIndex = this.getSelectedIndex(selected, geocoder);
    var payload = this.getEventPayload("search.select", geocoder);
    payload.resultIndex = resultIndex;
    payload.resultPlaceName = selected.place_name;
    payload.resultId = selected.id;
    if (resultIndex === this.lastSentIndex && payload.queryString === this.lastSentInput || resultIndex == -1) {
      return;
    }
    this.lastSentIndex = resultIndex;
    this.lastSentInput = payload.queryString;
    if (!payload.queryString)
      return;
    return this.push(payload);
  },
  start: function(geocoder) {
    var payload = this.getEventPayload("search.start", geocoder);
    if (!payload.queryString)
      return;
    return this.push(payload);
  },
  keyevent: function(keyEvent2, geocoder) {
    if (!keyEvent2.key)
      return;
    if (keyEvent2.metaKey || [9, 27, 37, 39, 13, 38, 40].indexOf(keyEvent2.keyCode) !== -1)
      return;
    var payload = this.getEventPayload("search.keystroke", geocoder);
    payload.lastAction = keyEvent2.key;
    if (!payload.queryString)
      return;
    return this.push(payload);
  },
  send: function(payload, callback) {
    if (!this.enableEventLogging) {
      if (callback)
        return callback();
      return;
    }
    var options = this.getRequestOptions(payload);
    this.request(options, function(err2) {
      if (err2)
        return this.handleError(err2, callback);
      if (callback) {
        return callback();
      }
    }.bind(this));
  },
  getRequestOptions: function(payload) {
    if (!Array.isArray(payload))
      payload = [payload];
    var options = {
      method: "POST",
      host: this.origin,
      path: this.endpoint + "?access_token=" + this.access_token,
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    };
    return options;
  },
  getEventPayload: function(event, geocoder) {
    var proximity;
    if (!geocoder.options.proximity)
      proximity = null;
    else
      proximity = [geocoder.options.proximity.longitude, geocoder.options.proximity.latitude];
    var zoom = geocoder._map ? geocoder._map.getZoom() : void 0;
    var payload = {
      event,
      created: +new Date(),
      sessionIdentifier: this.sessionID,
      country: this.countries,
      userAgent: this.userAgent,
      language: this.language,
      bbox: this.bbox,
      types: this.types,
      endpoint: "mapbox.places",
      autocomplete: geocoder.options.autocomplete,
      fuzzyMatch: geocoder.options.fuzzyMatch,
      proximity,
      limit: geocoder.options.limit,
      routing: geocoder.options.routing,
      worldview: geocoder.options.worldview,
      mapZoom: zoom,
      keyboardLocale: this.locale
    };
    if (event === "search.select") {
      payload.queryString = geocoder.inputString;
    } else if (event != "search.select" && geocoder._inputEl) {
      payload.queryString = geocoder._inputEl.value;
    } else {
      payload.queryString = geocoder.inputString;
    }
    return payload;
  },
  request: function(opts, callback) {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4) {
        if (this.status == 204) {
          return callback(null);
        } else {
          return callback(this.statusText);
        }
      }
    };
    xhttp.open(opts.method, opts.host + "/" + opts.path, true);
    for (var header in opts.headers) {
      var headerValue = opts.headers[header];
      xhttp.setRequestHeader(header, headerValue);
    }
    xhttp.send(opts.body);
  },
  handleError: function(err2, callback) {
    if (callback)
      return callback(err2);
  },
  generateSessionID: function() {
    return nanoid();
  },
  getUserAgent: function() {
    return "mapbox-gl-geocoder." + this.version + "." + navigator.userAgent;
  },
  getSelectedIndex: function(selected, geocoder) {
    if (!geocoder._typeahead)
      return;
    var results = geocoder._typeahead.data;
    var selectedID = selected.id;
    var resultIDs = results.map(function(feature2) {
      return feature2.id;
    });
    var selectedIdx = resultIDs.indexOf(selectedID);
    return selectedIdx;
  },
  shouldEnableLogging: function(options) {
    if (options.enableEventLogging === false)
      return false;
    if (options.origin && options.origin.indexOf("api.mapbox.com") == -1)
      return false;
    if (options.localGeocoder)
      return false;
    if (options.filter)
      return false;
    return true;
  },
  flush: function() {
    if (this.eventQueue.length > 0) {
      this.send(this.eventQueue);
      this.eventQueue = new Array();
    }
    if (this.timer)
      clearTimeout(this.timer);
    if (this.flushInterval)
      this.timer = setTimeout(this.flush.bind(this), this.flushInterval);
  },
  push: function(evt, forceFlush2) {
    this.eventQueue.push(evt);
    if (this.eventQueue.length >= this.maxQueueSize || forceFlush2) {
      this.flush();
    }
  },
  remove: function() {
    this.flush();
  }
};
var events = MapboxEventManager$1;
var placeholder = {
  "de": "Suche",
  "it": "Ricerca",
  "en": "Search",
  "nl": "Zoeken",
  "fr": "Chercher",
  "ca": "Cerca",
  "he": "\u05DC\u05D7\u05E4\u05E9",
  "ja": "\u30B5\u30FC\u30C1",
  "lv": "Mekl\u0113t",
  "pt": "Procurar",
  "sr": "\u041F\u0440\u0435\u0442\u0440\u0430\u0433\u0430",
  "zh": "\u641C\u7D22",
  "cs": "Vyhled\xE1v\xE1n\xED",
  "hu": "Keres\xE9s",
  "ka": "\u10EB\u10D8\u10D4\u10D1\u10D0",
  "nb": "S\xF8ke",
  "sk": "Vyh\u013Ead\xE1vanie",
  "th": "\u0E04\u0E49\u0E19\u0E2B\u0E32",
  "fi": "Hae",
  "is": "Leita",
  "ko": "\uC218\uC0C9",
  "pl": "Szukaj",
  "sl": "Iskanje",
  "fa": "\u062C\u0633\u062A\u062C\u0648",
  "ru": "\u041F\u043E\u0438\u0441\u043A"
};
var localization$1 = { placeholder };
var subtag$1 = { exports: {} };
(function(module2) {
  !function(root2, name, make) {
    if (module2.exports)
      module2.exports = make();
    else
      root2[name] = make();
  }(commonjsGlobal, "subtag", function() {
    var empty2 = "";
    var pattern = /^([a-zA-Z]{2,3})(?:[_-]+([a-zA-Z]{3})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{4})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{2}|[0-9]{3})(?=$|[_-]+))?/;
    function match(tag2) {
      return tag2.match(pattern) || [];
    }
    function split(tag2) {
      return match(tag2).filter(function(v2, i2) {
        return v2 && i2;
      });
    }
    function api2(tag2) {
      tag2 = match(tag2);
      return {
        language: tag2[1] || empty2,
        extlang: tag2[2] || empty2,
        script: tag2[3] || empty2,
        region: tag2[4] || empty2
      };
    }
    function expose(target, key, value) {
      Object.defineProperty(target, key, {
        value,
        enumerable: true
      });
    }
    function part(position, pattern2, type) {
      function method(tag2) {
        return match(tag2)[position] || empty2;
      }
      expose(method, "pattern", pattern2);
      expose(api2, type, method);
    }
    part(1, /^[a-zA-Z]{2,3}$/, "language");
    part(2, /^[a-zA-Z]{3}$/, "extlang");
    part(3, /^[a-zA-Z]{4}$/, "script");
    part(4, /^[a-zA-Z]{2}$|^[0-9]{3}$/, "region");
    expose(api2, "split", split);
    return api2;
  });
})(subtag$1);
var Typeahead = suggestions;
var debounce = lodash_debounce;
var extend = immutable;
var EventEmitter = events$1.exports.EventEmitter;
var exceptions = exceptions$1;
var MapboxClient = mapboxSdk;
var mbxGeocoder = geocoding;
var MapboxEventManager = events;
var localization = localization$1;
var subtag = subtag$1.exports;
const GEOCODE_REQUEST_TYPE = {
  FORWARD: 0,
  LOCAL: 1,
  REVERSE: 2
};
function MapboxGeocoder(options) {
  this._eventEmitter = new EventEmitter();
  this.options = extend({}, this.options, options);
  this.inputString = "";
  this.fresh = true;
  this.lastSelected = null;
}
MapboxGeocoder.prototype = {
  options: {
    zoom: 16,
    flyTo: true,
    trackProximity: true,
    minLength: 2,
    reverseGeocode: false,
    limit: 5,
    origin: "https://api.mapbox.com",
    enableEventLogging: true,
    marker: true,
    mapboxgl: null,
    collapsed: false,
    clearAndBlurOnEsc: false,
    clearOnBlur: false,
    getItemValue: function(item) {
      return item.place_name;
    },
    render: function(item) {
      var placeName = item.place_name.split(",");
      return '<div class="mapboxgl-ctrl-geocoder--suggestion"><div class="mapboxgl-ctrl-geocoder--suggestion-title">' + placeName[0] + '</div><div class="mapboxgl-ctrl-geocoder--suggestion-address">' + placeName.splice(1, placeName.length).join(",") + "</div></div>";
    }
  },
  addTo: function(container) {
    function addToExistingContainer(geocoder, container2) {
      if (!document.body.contains(container2)) {
        throw new Error("Element provided to #addTo() exists, but is not in the DOM");
      }
      const el = geocoder.onAdd();
      container2.appendChild(el);
    }
    if (container._controlContainer) {
      container.addControl(this);
    } else if (container instanceof HTMLElement) {
      addToExistingContainer(this, container);
    } else if (typeof container == "string") {
      const parent = document.querySelectorAll(container);
      if (parent.length === 0) {
        throw new Error("Element ", container, "not found.");
      }
      if (parent.length > 1) {
        throw new Error("Geocoder can only be added to a single html element");
      }
      addToExistingContainer(this, parent[0]);
    } else {
      throw new Error("Error: addTo must be a mapbox-gl-js map, an html element, or a CSS selector query for a single html element");
    }
  },
  onAdd: function(map16) {
    if (map16 && typeof map16 != "string") {
      this._map = map16;
    }
    this.setLanguage();
    if (!this.options.localGeocoderOnly) {
      this.geocoderService = mbxGeocoder(MapboxClient({
        accessToken: this.options.accessToken,
        origin: this.options.origin
      }));
    }
    if (this.options.localGeocoderOnly && !this.options.localGeocoder) {
      throw new Error("A localGeocoder function must be specified to use localGeocoderOnly mode");
    }
    this.eventManager = new MapboxEventManager(this.options);
    this._onChange = this._onChange.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);
    this._onPaste = this._onPaste.bind(this);
    this._onBlur = this._onBlur.bind(this);
    this._showButton = this._showButton.bind(this);
    this._hideButton = this._hideButton.bind(this);
    this._onQueryResult = this._onQueryResult.bind(this);
    this.clear = this.clear.bind(this);
    this._updateProximity = this._updateProximity.bind(this);
    this._collapse = this._collapse.bind(this);
    this._unCollapse = this._unCollapse.bind(this);
    this._clear = this._clear.bind(this);
    this._clearOnBlur = this._clearOnBlur.bind(this);
    var el = this.container = document.createElement("div");
    el.className = "mapboxgl-ctrl-geocoder mapboxgl-ctrl";
    var searchIcon = this.createIcon("search", '<path d="M7.4 2.5c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9c1 0 1.8-.2 2.5-.8l3.7 3.7c.2.2.4.3.8.3.7 0 1.1-.4 1.1-1.1 0-.3-.1-.5-.3-.8L11.4 10c.4-.8.8-1.6.8-2.5.1-2.8-2.1-5-4.8-5zm0 1.6c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2-3.3-1.3-3.3-3.1 1.4-3.3 3.3-3.3z"/>');
    this._inputEl = document.createElement("input");
    this._inputEl.type = "text";
    this._inputEl.className = "mapboxgl-ctrl-geocoder--input";
    this.setPlaceholder();
    if (this.options.collapsed) {
      this._collapse();
      this.container.addEventListener("mouseenter", this._unCollapse);
      this.container.addEventListener("mouseleave", this._collapse);
      this._inputEl.addEventListener("focus", this._unCollapse);
    }
    if (this.options.collapsed || this.options.clearOnBlur) {
      this._inputEl.addEventListener("blur", this._onBlur);
    }
    this._inputEl.addEventListener("keydown", debounce(this._onKeyDown, 200));
    this._inputEl.addEventListener("paste", this._onPaste);
    this._inputEl.addEventListener("change", this._onChange);
    this.container.addEventListener("mouseenter", this._showButton);
    this.container.addEventListener("mouseleave", this._hideButton);
    this._inputEl.addEventListener("keyup", function(e) {
      this.eventManager.keyevent(e, this);
    }.bind(this));
    var actions = document.createElement("div");
    actions.classList.add("mapboxgl-ctrl-geocoder--pin-right");
    this._clearEl = document.createElement("button");
    this._clearEl.setAttribute("aria-label", "Clear");
    this._clearEl.addEventListener("click", this.clear);
    this._clearEl.className = "mapboxgl-ctrl-geocoder--button";
    var buttonIcon = this.createIcon("close", '<path d="M3.8 2.5c-.6 0-1.3.7-1.3 1.3 0 .3.2.7.5.8L7.2 9 3 13.2c-.3.3-.5.7-.5 1 0 .6.7 1.3 1.3 1.3.3 0 .7-.2 1-.5L9 10.8l4.2 4.2c.2.3.7.3 1 .3.6 0 1.3-.7 1.3-1.3 0-.3-.2-.7-.3-1l-4.4-4L15 4.6c.3-.2.5-.5.5-.8 0-.7-.7-1.3-1.3-1.3-.3 0-.7.2-1 .3L9 7.1 4.8 2.8c-.3-.1-.7-.3-1-.3z"/>');
    this._clearEl.appendChild(buttonIcon);
    this._loadingEl = this.createIcon("loading", '<path fill="#333" d="M4.4 4.4l.8.8c2.1-2.1 5.5-2.1 7.6 0l.8-.8c-2.5-2.5-6.7-2.5-9.2 0z"/><path opacity=".1" d="M12.8 12.9c-2.1 2.1-5.5 2.1-7.6 0-2.1-2.1-2.1-5.5 0-7.7l-.8-.8c-2.5 2.5-2.5 6.7 0 9.2s6.6 2.5 9.2 0 2.5-6.6 0-9.2l-.8.8c2.2 2.1 2.2 5.6 0 7.7z"/>');
    actions.appendChild(this._clearEl);
    actions.appendChild(this._loadingEl);
    el.appendChild(searchIcon);
    el.appendChild(this._inputEl);
    el.appendChild(actions);
    this._typeahead = new Typeahead(this._inputEl, [], {
      filter: false,
      minLength: this.options.minLength,
      limit: this.options.limit
    });
    this.setRenderFunction(this.options.render);
    this._typeahead.getItemValue = this.options.getItemValue;
    this.mapMarker = null;
    this._handleMarker = this._handleMarker.bind(this);
    if (this._map) {
      if (this.options.trackProximity) {
        this._updateProximity();
        this._map.on("moveend", this._updateProximity);
      }
      this._mapboxgl = this.options.mapboxgl;
      if (!this._mapboxgl && this.options.marker) {
        console.error("No mapboxgl detected in options. Map markers are disabled. Please set options.mapboxgl.");
        this.options.marker = false;
      }
    }
    return el;
  },
  createIcon: function(name, path) {
    var icon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    icon.setAttribute("class", "mapboxgl-ctrl-geocoder--icon mapboxgl-ctrl-geocoder--icon-" + name);
    icon.setAttribute("viewBox", "0 0 18 18");
    icon.setAttribute("xml:space", "preserve");
    icon.setAttribute("width", 18);
    icon.setAttribute("height", 18);
    if (!("innerHTML" in icon)) {
      var SVGNodeContainer = document.createElement("div");
      SVGNodeContainer.innerHTML = "<svg>" + path.valueOf().toString() + "</svg>";
      var SVGNode = SVGNodeContainer.firstChild, SVGPath = SVGNode.firstChild;
      icon.appendChild(SVGPath);
    } else {
      icon.innerHTML = path;
    }
    return icon;
  },
  onRemove: function() {
    this.container.parentNode.removeChild(this.container);
    if (this.options.trackProximity && this._map) {
      this._map.off("moveend", this._updateProximity);
    }
    this._removeMarker();
    this._map = null;
    return this;
  },
  _onPaste: function(e) {
    var value = (e.clipboardData || window.clipboardData).getData("text");
    if (value.length >= this.options.minLength) {
      this._geocode(value);
    }
  },
  _onKeyDown: function(e) {
    var ESC_KEY_CODE = 27, TAB_KEY_CODE = 9;
    if (e.keyCode === ESC_KEY_CODE && this.options.clearAndBlurOnEsc) {
      this._clear(e);
      return this._inputEl.blur();
    }
    var target = e.target && e.target.shadowRoot ? e.target.shadowRoot.activeElement : e.target;
    var value = target ? target.value : "";
    if (!value) {
      this.fresh = true;
      if (e.keyCode !== TAB_KEY_CODE)
        this.clear(e);
      return this._clearEl.style.display = "none";
    }
    if (e.metaKey || [TAB_KEY_CODE, ESC_KEY_CODE, 37, 39, 13, 38, 40].indexOf(e.keyCode) !== -1)
      return;
    if (target.value.length >= this.options.minLength) {
      this._geocode(target.value);
    }
  },
  _showButton: function() {
    if (this._typeahead.selected)
      this._clearEl.style.display = "block";
  },
  _hideButton: function() {
    if (this._typeahead.selected)
      this._clearEl.style.display = "none";
  },
  _onBlur: function(e) {
    if (this.options.clearOnBlur) {
      this._clearOnBlur(e);
    }
    if (this.options.collapsed) {
      this._collapse();
    }
  },
  _onChange: function() {
    var selected = this._typeahead.selected;
    if (selected && JSON.stringify(selected) !== this.lastSelected) {
      this._clearEl.style.display = "none";
      if (this.options.flyTo) {
        var flyOptions;
        if (selected.properties && exceptions[selected.properties.short_code]) {
          flyOptions = extend({}, this.options.flyTo);
          if (this._map) {
            this._map.fitBounds(exceptions[selected.properties.short_code].bbox, flyOptions);
          }
        } else if (selected.bbox) {
          var bbox = selected.bbox;
          flyOptions = extend({}, this.options.flyTo);
          if (this._map) {
            this._map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]], flyOptions);
          }
        } else {
          var defaultFlyOptions = {
            zoom: this.options.zoom
          };
          flyOptions = extend({}, defaultFlyOptions, this.options.flyTo);
          if (selected.center) {
            flyOptions.center = selected.center;
          } else if (selected.geometry && selected.geometry.type && selected.geometry.type === "Point" && selected.geometry.coordinates) {
            flyOptions.center = selected.geometry.coordinates;
          }
          if (this._map) {
            this._map.flyTo(flyOptions);
          }
        }
      }
      if (this.options.marker && this._mapboxgl) {
        this._handleMarker(selected);
      }
      this._inputEl.focus();
      this._inputEl.scrollLeft = 0;
      this._inputEl.setSelectionRange(0, 0);
      this.lastSelected = JSON.stringify(selected);
      this._eventEmitter.emit("result", { result: selected });
      this.eventManager.select(selected, this);
    }
  },
  _requestType: function(options, search2) {
    var type;
    const reverseGeocodeCoordRgx = /^[ ]*(-?\d+\.?\d*)[, ]+(-?\d+\.?\d*)[ ]*$/;
    if (options.localGeocoderOnly) {
      type = GEOCODE_REQUEST_TYPE.LOCAL;
    } else if (options.reverseGeocode && reverseGeocodeCoordRgx.test(search2)) {
      type = GEOCODE_REQUEST_TYPE.REVERSE;
    } else {
      type = GEOCODE_REQUEST_TYPE.FORWARD;
    }
    return type;
  },
  _setupConfig: function(requestType, search2) {
    const keys2 = [
      "bbox",
      "limit",
      "proximity",
      "countries",
      "types",
      "language",
      "reverseMode",
      "mode",
      "autocomplete",
      "fuzzyMatch",
      "routing",
      "worldview"
    ];
    const spacesOrCommaRgx = /[\s,]+/;
    var self2 = this;
    var config2 = keys2.reduce(function(config3, key) {
      if (self2.options[key] === void 0 || self2.options[key] === null) {
        return config3;
      }
      ["countries", "types", "language"].indexOf(key) > -1 ? config3[key] = self2.options[key].split(spacesOrCommaRgx) : config3[key] = self2.options[key];
      const isCoordKey = typeof self2.options[key].longitude === "number" && typeof self2.options[key].latitude === "number";
      if (key === "proximity" && isCoordKey) {
        const lng = self2.options[key].longitude;
        const lat = self2.options[key].latitude;
        config3[key] = [lng, lat];
      }
      return config3;
    }, {});
    switch (requestType) {
      case GEOCODE_REQUEST_TYPE.REVERSE:
        {
          var coords = search2.split(spacesOrCommaRgx).map(function(c) {
            return parseFloat(c, 10);
          }).reverse();
          config2.types ? [config2.types[0]] : ["poi"];
          config2 = extend(config2, { query: coords, limit: 1 });
          ["proximity", "autocomplete", "fuzzyMatch", "bbox"].forEach(function(key) {
            if (key in config2) {
              delete config2[key];
            }
          });
        }
        break;
      case GEOCODE_REQUEST_TYPE.FORWARD:
        {
          const reverseGeocodeCoordRgx = /^[ ]*(-?\d+\.?\d*)[, ]+(-?\d+\.?\d*)*[ ]*$/;
          if (reverseGeocodeCoordRgx.test(search2)) {
            search2 = search2.replace(/,/g, " ");
          }
          config2 = extend(config2, { query: search2 });
        }
        break;
    }
    return config2;
  },
  _geocode: function(searchInput) {
    this.inputString = searchInput;
    this._loadingEl.style.display = "block";
    this._eventEmitter.emit("loading", { query: searchInput });
    const requestType = this._requestType(this.options, searchInput);
    const config2 = this._setupConfig(requestType, searchInput);
    var request;
    switch (requestType) {
      case GEOCODE_REQUEST_TYPE.LOCAL:
        request = Promise.resolve();
        break;
      case GEOCODE_REQUEST_TYPE.FORWARD:
        request = this.geocoderService.forwardGeocode(config2).send();
        break;
      case GEOCODE_REQUEST_TYPE.REVERSE:
        request = this.geocoderService.reverseGeocode(config2).send();
        break;
    }
    var localGeocoderRes = this.options.localGeocoder ? this.options.localGeocoder(searchInput) || [] : [];
    var externalGeocoderRes = [];
    var geocoderError = null;
    request.catch(function(error) {
      geocoderError = error;
    }.bind(this)).then(function(response) {
      this._loadingEl.style.display = "none";
      var res = {};
      if (!response) {
        res = {
          type: "FeatureCollection",
          features: []
        };
      } else if (response.statusCode == "200") {
        res = response.body;
        res.request = response.request;
        res.headers = response.headers;
      }
      res.config = config2;
      if (this.fresh) {
        this.eventManager.start(this);
        this.fresh = false;
      }
      res.features = res.features ? localGeocoderRes.concat(res.features) : localGeocoderRes;
      if (this.options.externalGeocoder) {
        externalGeocoderRes = this.options.externalGeocoder(searchInput, res.features) || [];
        return externalGeocoderRes.then(function(features) {
          res.features = res.features ? features.concat(res.features) : features;
          return res;
        }, function() {
          return res;
        });
      }
      return res;
    }.bind(this)).then(function(res) {
      if (geocoderError) {
        throw geocoderError;
      }
      if (this.options.filter && res.features.length) {
        res.features = res.features.filter(this.options.filter);
      }
      if (res.features.length) {
        this._clearEl.style.display = "block";
        this._eventEmitter.emit("results", res);
        this._typeahead.update(res.features);
      } else {
        this._clearEl.style.display = "none";
        this._typeahead.selected = null;
        this._renderNoResults();
        this._eventEmitter.emit("results", res);
      }
    }.bind(this)).catch(function(err2) {
      this._loadingEl.style.display = "none";
      if (localGeocoderRes.length && this.options.localGeocoder || externalGeocoderRes.length && this.options.externalGeocoder) {
        this._clearEl.style.display = "block";
        this._typeahead.update(localGeocoderRes);
      } else {
        this._clearEl.style.display = "none";
        this._typeahead.selected = null;
        this._renderError();
      }
      this._eventEmitter.emit("results", { features: localGeocoderRes });
      this._eventEmitter.emit("error", { error: err2 });
    }.bind(this));
    return request;
  },
  _clear: function(ev) {
    if (ev)
      ev.preventDefault();
    this._inputEl.value = "";
    this._typeahead.selected = null;
    this._typeahead.clear();
    this._onChange();
    this._clearEl.style.display = "none";
    this._removeMarker();
    this.lastSelected = null;
    this._eventEmitter.emit("clear");
    this.fresh = true;
  },
  clear: function(ev) {
    this._clear(ev);
    this._inputEl.focus();
  },
  _clearOnBlur: function(ev) {
    var ctx = this;
    if (ev.relatedTarget) {
      ctx._clear(ev);
    }
  },
  _onQueryResult: function(response) {
    var results = response.body;
    if (!results.features.length)
      return;
    var result2 = results.features[0];
    this._typeahead.selected = result2;
    this._inputEl.value = result2.place_name;
    this._onChange();
  },
  _updateProximity: function() {
    if (!this._map) {
      return;
    }
    if (this._map.getZoom() > 9) {
      var center = this._map.getCenter().wrap();
      this.setProximity({ longitude: center.lng, latitude: center.lat });
    } else {
      this.setProximity(null);
    }
  },
  _collapse: function() {
    if (!this._inputEl.value && this._inputEl !== document.activeElement)
      this.container.classList.add("mapboxgl-ctrl-geocoder--collapsed");
  },
  _unCollapse: function() {
    this.container.classList.remove("mapboxgl-ctrl-geocoder--collapsed");
  },
  query: function(searchInput) {
    this._geocode(searchInput).then(this._onQueryResult);
    return this;
  },
  _renderError: function() {
    var errorMessage = "<div class='mapbox-gl-geocoder--error'>There was an error reaching the server</div>";
    this._renderMessage(errorMessage);
  },
  _renderNoResults: function() {
    var errorMessage = "<div class='mapbox-gl-geocoder--error mapbox-gl-geocoder--no-results'>No results found</div>";
    this._renderMessage(errorMessage);
  },
  _renderMessage: function(msg) {
    this._typeahead.update([]);
    this._typeahead.selected = null;
    this._typeahead.clear();
    this._typeahead.renderError(msg);
  },
  _getPlaceholderText: function() {
    if (this.options.placeholder)
      return this.options.placeholder;
    if (this.options.language) {
      var firstLanguage = this.options.language.split(",")[0];
      var language = subtag.language(firstLanguage);
      var localizedValue = localization.placeholder[language];
      if (localizedValue)
        return localizedValue;
    }
    return "Search";
  },
  setInput: function(searchInput) {
    this._inputEl.value = searchInput;
    this._typeahead.selected = null;
    this._typeahead.clear();
    if (searchInput.length >= this.options.minLength) {
      this._geocode(searchInput);
    }
    return this;
  },
  setProximity: function(proximity) {
    this.options.proximity = proximity;
    return this;
  },
  getProximity: function() {
    return this.options.proximity;
  },
  setRenderFunction: function(fn) {
    if (fn && typeof fn == "function") {
      this._typeahead.render = fn;
    }
    return this;
  },
  getRenderFunction: function() {
    return this._typeahead.render;
  },
  setLanguage: function(language) {
    var browserLocale = navigator.language || navigator.userLanguage || navigator.browserLanguage;
    this.options.language = language || this.options.language || browserLocale;
    return this;
  },
  getLanguage: function() {
    return this.options.language;
  },
  getZoom: function() {
    return this.options.zoom;
  },
  setZoom: function(zoom) {
    this.options.zoom = zoom;
    return this;
  },
  getFlyTo: function() {
    return this.options.flyTo;
  },
  setFlyTo: function(flyTo) {
    this.options.flyTo = flyTo;
    return this;
  },
  getPlaceholder: function() {
    return this.options.placeholder;
  },
  setPlaceholder: function(placeholder2) {
    this.placeholder = placeholder2 ? placeholder2 : this._getPlaceholderText();
    this._inputEl.placeholder = this.placeholder;
    this._inputEl.setAttribute("aria-label", this.placeholder);
    return this;
  },
  getBbox: function() {
    return this.options.bbox;
  },
  setBbox: function(bbox) {
    this.options.bbox = bbox;
    return this;
  },
  getCountries: function() {
    return this.options.countries;
  },
  setCountries: function(countries) {
    this.options.countries = countries;
    return this;
  },
  getTypes: function() {
    return this.options.types;
  },
  setTypes: function(types) {
    this.options.types = types;
    return this;
  },
  getMinLength: function() {
    return this.options.minLength;
  },
  setMinLength: function(minLength) {
    this.options.minLength = minLength;
    if (this._typeahead)
      this._typeahead.options.minLength = minLength;
    return this;
  },
  getLimit: function() {
    return this.options.limit;
  },
  setLimit: function(limit) {
    this.options.limit = limit;
    if (this._typeahead)
      this._typeahead.options.limit = limit;
    return this;
  },
  getFilter: function() {
    return this.options.filter;
  },
  setFilter: function(filter2) {
    this.options.filter = filter2;
    return this;
  },
  setOrigin: function(origin) {
    this.options.origin = origin;
    this.geocoderService = mbxGeocoder(MapboxClient({
      accessToken: this.options.accessToken,
      origin: this.options.origin
    }));
    return this;
  },
  getOrigin: function() {
    return this.options.origin;
  },
  setAutocomplete: function(value) {
    this.options.autocomplete = value;
    return this;
  },
  getAutocomplete: function() {
    return this.options.autocomplete;
  },
  setFuzzyMatch: function(value) {
    this.options.fuzzyMatch = value;
    return this;
  },
  getFuzzyMatch: function() {
    return this.options.fuzzyMatch;
  },
  setRouting: function(value) {
    this.options.routing = value;
    return this;
  },
  getRouting: function() {
    return this.options.routing;
  },
  setWorldview: function(code) {
    this.options.worldview = code;
    return this;
  },
  getWorldview: function() {
    return this.options.worldview;
  },
  _handleMarker: function(selected) {
    if (!this._map) {
      return;
    }
    this._removeMarker();
    var defaultMarkerOptions = {
      color: "#4668F2"
    };
    var markerOptions = extend({}, defaultMarkerOptions, this.options.marker);
    this.mapMarker = new this._mapboxgl.Marker(markerOptions);
    if (selected.center) {
      this.mapMarker.setLngLat(selected.center).addTo(this._map);
    } else if (selected.geometry && selected.geometry.type && selected.geometry.type === "Point" && selected.geometry.coordinates) {
      this.mapMarker.setLngLat(selected.geometry.coordinates).addTo(this._map);
    }
    return this;
  },
  _removeMarker: function() {
    if (this.mapMarker) {
      this.mapMarker.remove();
      this.mapMarker = null;
    }
  },
  on: function(type, fn) {
    this._eventEmitter.on(type, fn);
    return this;
  },
  off: function(type, fn) {
    this._eventEmitter.removeListener(type, fn);
    this.eventManager.remove();
    return this;
  }
};
var lib = MapboxGeocoder;
function feature(geom, properties, options) {
  if (options === void 0) {
    options = {};
  }
  var feat = { type: "Feature" };
  if (options.id === 0 || options.id) {
    feat.id = options.id;
  }
  if (options.bbox) {
    feat.bbox = options.bbox;
  }
  feat.properties = properties || {};
  feat.geometry = geom;
  return feat;
}
function lineString(coordinates2, properties, options) {
  if (options === void 0) {
    options = {};
  }
  if (coordinates2.length < 2) {
    throw new Error("coordinates must be an array of two or more positions");
  }
  var geom = {
    type: "LineString",
    coordinates: coordinates2
  };
  return feature(geom, properties, options);
}
function getGeom(geojson) {
  if (geojson.type === "Feature") {
    return geojson.geometry;
  }
  return geojson;
}
var Spline = function() {
  function Spline2(options) {
    this.points = options.points || [];
    this.duration = options.duration || 1e4;
    this.sharpness = options.sharpness || 0.85;
    this.centers = [];
    this.controls = [];
    this.stepLength = options.stepLength || 60;
    this.length = this.points.length;
    this.delay = 0;
    for (var i2 = 0; i2 < this.length; i2++) {
      this.points[i2].z = this.points[i2].z || 0;
    }
    for (var i2 = 0; i2 < this.length - 1; i2++) {
      var p1 = this.points[i2];
      var p2 = this.points[i2 + 1];
      this.centers.push({
        x: (p1.x + p2.x) / 2,
        y: (p1.y + p2.y) / 2,
        z: (p1.z + p2.z) / 2
      });
    }
    this.controls.push([this.points[0], this.points[0]]);
    for (var i2 = 0; i2 < this.centers.length - 1; i2++) {
      var dx = this.points[i2 + 1].x - (this.centers[i2].x + this.centers[i2 + 1].x) / 2;
      var dy = this.points[i2 + 1].y - (this.centers[i2].y + this.centers[i2 + 1].y) / 2;
      var dz = this.points[i2 + 1].z - (this.centers[i2].y + this.centers[i2 + 1].z) / 2;
      this.controls.push([
        {
          x: (1 - this.sharpness) * this.points[i2 + 1].x + this.sharpness * (this.centers[i2].x + dx),
          y: (1 - this.sharpness) * this.points[i2 + 1].y + this.sharpness * (this.centers[i2].y + dy),
          z: (1 - this.sharpness) * this.points[i2 + 1].z + this.sharpness * (this.centers[i2].z + dz)
        },
        {
          x: (1 - this.sharpness) * this.points[i2 + 1].x + this.sharpness * (this.centers[i2 + 1].x + dx),
          y: (1 - this.sharpness) * this.points[i2 + 1].y + this.sharpness * (this.centers[i2 + 1].y + dy),
          z: (1 - this.sharpness) * this.points[i2 + 1].z + this.sharpness * (this.centers[i2 + 1].z + dz)
        }
      ]);
    }
    this.controls.push([
      this.points[this.length - 1],
      this.points[this.length - 1]
    ]);
    this.steps = this.cacheSteps(this.stepLength);
    return this;
  }
  Spline2.prototype.cacheSteps = function(mindist) {
    var steps = [];
    var laststep = this.pos(0);
    steps.push(0);
    for (var t = 0; t < this.duration; t += 10) {
      var step2 = this.pos(t);
      var dist = Math.sqrt((step2.x - laststep.x) * (step2.x - laststep.x) + (step2.y - laststep.y) * (step2.y - laststep.y) + (step2.z - laststep.z) * (step2.z - laststep.z));
      if (dist > mindist) {
        steps.push(t);
        laststep = step2;
      }
    }
    return steps;
  };
  Spline2.prototype.vector = function(t) {
    var p1 = this.pos(t + 10);
    var p2 = this.pos(t - 10);
    return {
      angle: 180 * Math.atan2(p1.y - p2.y, p1.x - p2.x) / 3.14,
      speed: Math.sqrt((p2.x - p1.x) * (p2.x - p1.x) + (p2.y - p1.y) * (p2.y - p1.y) + (p2.z - p1.z) * (p2.z - p1.z))
    };
  };
  Spline2.prototype.pos = function(time) {
    var t = time - this.delay;
    if (t < 0) {
      t = 0;
    }
    if (t > this.duration) {
      t = this.duration - 1;
    }
    var t2 = t / this.duration;
    if (t2 >= 1) {
      return this.points[this.length - 1];
    }
    var n = Math.floor((this.points.length - 1) * t2);
    var t1 = (this.length - 1) * t2 - n;
    return bezier$1(t1, this.points[n], this.controls[n][1], this.controls[n + 1][0], this.points[n + 1]);
  };
  return Spline2;
}();
var Spline$1 = Spline;
function bezier$1(t, p1, c1, c2, p2) {
  var b = B(t);
  var pos = {
    x: p2.x * b[0] + c2.x * b[1] + c1.x * b[2] + p1.x * b[3],
    y: p2.y * b[0] + c2.y * b[1] + c1.y * b[2] + p1.y * b[3],
    z: p2.z * b[0] + c2.z * b[1] + c1.z * b[2] + p1.z * b[3]
  };
  return pos;
}
function B(t) {
  var t2 = t * t;
  var t3 = t2 * t;
  return [
    t3,
    3 * t2 * (1 - t),
    3 * t * (1 - t) * (1 - t),
    (1 - t) * (1 - t) * (1 - t)
  ];
}
function bezier(line, options) {
  if (options === void 0) {
    options = {};
  }
  var resolution = options.resolution || 1e4;
  var sharpness = options.sharpness || 0.85;
  var coords = [];
  var points = getGeom(line).coordinates.map(function(pt) {
    return { x: pt[0], y: pt[1] };
  });
  var spline = new Spline$1({
    duration: resolution,
    points,
    sharpness
  });
  var pushCoord = function(time) {
    var pos = spline.pos(time);
    if (Math.floor(time / 100) % 2 === 0) {
      coords.push([pos.x, pos.y]);
    }
  };
  for (var i2 = 0; i2 < spline.duration; i2 += 10) {
    pushCoord(i2);
  }
  pushCoord(spline.duration);
  return lineString(coords, options.properties);
}
var SCoordinates_vue_vue_type_style_index_0_lang = "";
class ClearButtonControl {
  constructor({
    className,
    title,
    eventHandler
  }) {
    __publicField(this, "_className");
    __publicField(this, "_title");
    __publicField(this, "_eventHandler");
    __publicField(this, "_btn");
    __publicField(this, "_container");
    this._className = className;
    this._title = title;
    this._eventHandler = eventHandler;
  }
  onAdd(map16) {
    this._btn = document.createElement("button");
    this._btn.className = "mapboxgl-ctrl-icon " + this._className;
    this._btn.type = "button";
    this._btn.title = this._title;
    this._btn.onclick = this._eventHandler;
    this._container = document.createElement("div");
    this._container.className = "mapboxgl-ctrl-group mapboxgl-ctrl";
    this._container.appendChild(this._btn);
    return this._container;
  }
  onRemove() {
    if (this._container && this._container.parentNode) {
      this._container.parentNode.removeChild(this._container);
    }
  }
}
function simplify$1(lngLat) {
  if (lngLat.hasOwnProperty("lat") && lngLat.hasOwnProperty("lng")) {
    return { lat: lngLat.lat, lng: lngLat.lng };
  } else {
    return { lat: lngLat[1], lng: lngLat[0] };
  }
}
const _sfc_main$1 = defineComponent({
  name: "SCoordinates",
  props: {
    modelValue: null,
    center: null,
    zoom: null,
    search: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    line: null,
    smoothLine: { type: Boolean, default: false },
    autoFollow: { type: Boolean, default: false }
  },
  emits: ["click", "update:modelValue"],
  setup(props, { emit: emit2 }) {
    function createGeoJson(line) {
      const features = [];
      if (line.length == 1) {
        features.push({
          "type": "Feature",
          "properties": {
            "Position": "Start"
          },
          "geometry": {
            "type": "Point",
            "coordinates": line[0]
          }
        });
      } else {
        const lineFeature = props.smoothLine ? bezier(lineString(line), { resolution: 1e3, sharpness: 0.8 }) : {
          "type": "Feature",
          "properties": {},
          "geometry": {
            "type": "LineString",
            "coordinates": line
          }
        };
        features.push({
          "type": "Feature",
          "properties": {
            "Position": "Start"
          },
          "geometry": {
            "type": "Point",
            "coordinates": line[0]
          }
        });
        features.push({
          "type": "Feature",
          "properties": {
            "Position": "End"
          },
          "geometry": {
            "type": "Point",
            "coordinates": line[line.length - 1]
          }
        });
        features.push({
          "type": "Feature",
          "properties": {
            "Position": "End"
          },
          "geometry": {
            "type": "Point",
            "coordinates": line[line.length - 1]
          }
        });
        features.push(lineFeature);
      }
      return {
        "type": "FeatureCollection",
        "features": features
      };
    }
    const setCoordinates = (lngLat) => {
      const coordinates2 = simplify$1(lngLat);
      emit2("update:modelValue", coordinates2);
      emit2("click", coordinates2);
    };
    let resultMarker = null;
    const supervueui = inject("supervueui");
    mapboxgl.accessToken = supervueui.tokens.mapbox;
    const el = ref(null);
    let map16 = null;
    let clearButton = null;
    let marker = null;
    let geocoder = null;
    const navControl = new mapboxGl.exports.NavigationControl();
    const updateMarker = (c, centerView) => {
      if (c && map16) {
        if (!marker) {
          marker = new mapboxgl.Marker({
            color: supervueui.colors.brand.DEFAULT,
            draggable: !props.disabled
          });
          marker.getElement().addEventListener("click", (e) => {
            e.stopPropagation();
            return false;
          });
        }
        toggleClearButton(map16, true);
        marker.setLngLat(c);
        marker.addTo(map16);
        if (centerView) {
          map16.flyTo({ speed: 5, curve: 2 });
        }
      } else {
        if (marker) {
          marker.remove();
          marker = null;
        }
        toggleClearButton(map16, false);
      }
    };
    watch(() => props.disabled, (disabled) => {
      if (marker) {
        marker.setDraggable(!disabled);
      }
      toggleClearButton(map16, !disabled);
    });
    watch(() => props.modelValue, (newCoordintate) => {
      updateMarker(newCoordintate, true);
    });
    watch(() => props.search, (hasSearch) => {
      toggleGeocoder(map16, props.search);
    });
    const updateLine = (newValue) => {
      if (map16) {
        let s2 = map16.getSource("geoJson");
        if (newValue && newValue.length) {
          if (!s2) {
            map16.addSource("geoJson", {
              type: "geojson",
              data: createGeoJson(newValue)
            });
            map16.addLayer({
              "id": "geoJson-line",
              "type": "line",
              "source": "geoJson",
              "layout": {
                "line-join": "round",
                "line-cap": "round"
              },
              "paint": {
                "line-color": supervueui.colors.brand.DEFAULT,
                "line-width": 6
              }
            }, "poi-label");
            map16.addLayer({
              "id": "geoJson-start",
              "type": "circle",
              "source": "geoJson",
              "filter": ["==", "Position", "Start"],
              "paint": {
                "circle-radius": 10,
                "circle-color": supervueui.colors.brand.DEFAULT,
                "circle-stroke-color": supervueui.colors.brand.contrast,
                "circle-stroke-width": 2
              }
            }, "geoJson-line");
            map16.addLayer({
              "id": "geoJson-end",
              "type": "circle",
              "source": "geoJson",
              "filter": ["==", "Position", "End"],
              "paint": {
                "circle-radius": 10,
                "circle-color": supervueui.colors.brand.DEFAULT,
                "circle-stroke-color": supervueui.colors.brand.contrast,
                "circle-stroke-width": 2
              }
            }, "geoJson-start");
          } else {
            s2.setData(createGeoJson(newValue));
          }
          const bounds = new mapboxgl.LngLatBounds(newValue[0], newValue[0]);
          for (const coord of newValue) {
            bounds.extend(coord);
          }
          map16.fitBounds(bounds, {
            padding: { top: 100, right: 60, bottom: 40, left: 60 },
            speed: 5,
            curve: 2
          });
        } else {
          if (s2) {
            map16.removeLayer("geoJson-start");
            map16.removeLayer("geoJson-end");
            map16.removeLayer("geoJson-line");
            map16.removeSource("geoJson");
          }
        }
      }
    };
    watch(() => props.line, (newValue) => {
      updateLine(newValue);
    });
    const toggleClearButton = (map22, on) => {
      if (on) {
        if (!clearButton) {
          if (!props.disabled) {
            clearButton = new ClearButtonControl({
              className: "mapbox-gl-clear_marker",
              title: "Clear",
              eventHandler: (e) => {
                e.stopPropagation();
                emit2("update:modelValue", null);
                return false;
              }
            });
            map22.addControl(clearButton, "top-left");
          }
        }
      } else {
        if (clearButton && map22 && map22.hasControl(clearButton)) {
          map22.removeControl(clearButton);
          clearButton = null;
        }
      }
    };
    const toggleGeocoder = (map22, on) => {
      if (map22) {
        if (on) {
          if (!geocoder) {
            geocoder = new lib({
              accessToken: mapboxgl.accessToken,
              mapboxgl: map22,
              marker: false,
              flyTo: { speed: 5, curve: 2 }
            });
            geocoder.on("result", (e) => {
              let lngLat = null;
              if (e.result.center) {
                lngLat = e.result.center;
              } else if (e.result.geometry && e.result.geometry.type && e.result.geometry.type === "Point" && e.result.geometry.coordinates) {
                lngLat = e.result.geometry.coordinates;
              }
              if (lngLat) {
                resultMarker = new mapboxgl.Marker({
                  color: supervueui.colors.info.DEFAULT
                });
                resultMarker.getElement().addEventListener("click", (e2) => {
                  e2.stopPropagation();
                  if (!props.disabled) {
                    setCoordinates(lngLat);
                    resultMarker.remove();
                    resultMarker = null;
                  }
                  return false;
                });
                resultMarker.setLngLat(e.result.geometry.coordinates).addTo(map22);
              }
            });
            if (map22.hasControl(navControl)) {
              map22.removeControl(navControl);
            }
            map22.addControl(geocoder, "top-left");
            map22.addControl(navControl, "top-left");
          }
        } else {
          if (geocoder) {
            map22.removeControl(geocoder);
            geocoder = null;
          }
          map22.addControl(navControl, "top-left");
        }
      }
    };
    onMounted(() => {
      nextTick(() => {
        const options = {
          container: el.value,
          style: "mapbox://styles/mapbox/streets-v11",
          zoom: 0,
          center: void 0
        };
        if (props.center) {
          options.center = props.center;
        }
        if (props.zoom) {
          options.zoom = props.zoom;
        }
        map16 = new mapboxgl.Map(options);
        toggleGeocoder(map16, props.search);
        map16.addControl(new mapboxGl.exports.FullscreenControl(), "top-right");
        map16.on("click", (e) => {
          if (!props.disabled) {
            setCoordinates(e.lngLat);
          }
        });
        updateMarker(props.modelValue, true);
        map16.on("load", () => {
          setTimeout(() => {
            map16 && map16.resize();
          }, 200);
          updateLine(props.line);
        });
      });
    });
    return {
      el
    };
  }
});
const _hoisted_1$1 = { class: "rounded border" };
const _hoisted_2$1 = {
  class: "w-full h-full z-0",
  ref: "el"
};
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$1, [
    createElementVNode("div", _hoisted_2$1, null, 512)
  ]);
}
var SCoordinates = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1]]);
var leafletSrc = { exports: {} };
/* @preserve
 * Leaflet 1.7.1, a JS library for interactive maps. http://leafletjs.com
 * (c) 2010-2019 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */
(function(module2, exports) {
  (function(global2, factory) {
    factory(exports);
  })(commonjsGlobal, function(exports2) {
    var version = "1.7.1";
    function extend2(dest) {
      var i2, j, len, src;
      for (j = 1, len = arguments.length; j < len; j++) {
        src = arguments[j];
        for (i2 in src) {
          dest[i2] = src[i2];
        }
      }
      return dest;
    }
    var create6 = Object.create || function() {
      function F() {
      }
      return function(proto2) {
        F.prototype = proto2;
        return new F();
      };
    }();
    function bind2(fn, obj) {
      var slice4 = Array.prototype.slice;
      if (fn.bind) {
        return fn.bind.apply(fn, slice4.call(arguments, 1));
      }
      var args = slice4.call(arguments, 2);
      return function() {
        return fn.apply(obj, args.length ? args.concat(slice4.call(arguments)) : arguments);
      };
    }
    var lastId = 0;
    function stamp(obj) {
      obj._leaflet_id = obj._leaflet_id || ++lastId;
      return obj._leaflet_id;
    }
    function throttle(fn, time, context) {
      var lock, args, wrapperFn, later;
      later = function() {
        lock = false;
        if (args) {
          wrapperFn.apply(context, args);
          args = false;
        }
      };
      wrapperFn = function() {
        if (lock) {
          args = arguments;
        } else {
          fn.apply(context, arguments);
          setTimeout(later, time);
          lock = true;
        }
      };
      return wrapperFn;
    }
    function wrapNum(x2, range2, includeMax) {
      var max3 = range2[1], min3 = range2[0], d = max3 - min3;
      return x2 === max3 && includeMax ? x2 : ((x2 - min3) % d + d) % d + min3;
    }
    function falseFn() {
      return false;
    }
    function formatNum(num, digits) {
      var pow = Math.pow(10, digits === void 0 ? 6 : digits);
      return Math.round(num * pow) / pow;
    }
    function trim(str) {
      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    function splitWords(str) {
      return trim(str).split(/\s+/);
    }
    function setOptions(obj, options) {
      if (!Object.prototype.hasOwnProperty.call(obj, "options")) {
        obj.options = obj.options ? create6(obj.options) : {};
      }
      for (var i2 in options) {
        obj.options[i2] = options[i2];
      }
      return obj.options;
    }
    function getParamString(obj, existingUrl, uppercase) {
      var params = [];
      for (var i2 in obj) {
        params.push(encodeURIComponent(uppercase ? i2.toUpperCase() : i2) + "=" + encodeURIComponent(obj[i2]));
      }
      return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
    }
    var templateRe = /\{ *([\w_-]+) *\}/g;
    function template2(str, data) {
      return str.replace(templateRe, function(str2, key) {
        var value = data[key];
        if (value === void 0) {
          throw new Error("No value provided for variable " + str2);
        } else if (typeof value === "function") {
          value = value(data);
        }
        return value;
      });
    }
    var isArray2 = Array.isArray || function(obj) {
      return Object.prototype.toString.call(obj) === "[object Array]";
    };
    function indexOf2(array, el) {
      for (var i2 = 0; i2 < array.length; i2++) {
        if (array[i2] === el) {
          return i2;
        }
      }
      return -1;
    }
    var emptyImageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    function getPrefixed(name) {
      return window["webkit" + name] || window["moz" + name] || window["ms" + name];
    }
    var lastTime = 0;
    function timeoutDefer(fn) {
      var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
      lastTime = time + timeToCall;
      return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed("RequestAnimationFrame") || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed("CancelAnimationFrame") || getPrefixed("CancelRequestAnimationFrame") || function(id) {
      window.clearTimeout(id);
    };
    function requestAnimFrame(fn, context, immediate) {
      if (immediate && requestFn === timeoutDefer) {
        fn.call(context);
      } else {
        return requestFn.call(window, bind2(fn, context));
      }
    }
    function cancelAnimFrame(id) {
      if (id) {
        cancelFn.call(window, id);
      }
    }
    var Util = {
      extend: extend2,
      create: create6,
      bind: bind2,
      lastId,
      stamp,
      throttle,
      wrapNum,
      falseFn,
      formatNum,
      trim,
      splitWords,
      setOptions,
      getParamString,
      template: template2,
      isArray: isArray2,
      indexOf: indexOf2,
      emptyImageUrl,
      requestFn,
      cancelFn,
      requestAnimFrame,
      cancelAnimFrame
    };
    function Class() {
    }
    Class.extend = function(props) {
      var NewClass = function() {
        if (this.initialize) {
          this.initialize.apply(this, arguments);
        }
        this.callInitHooks();
      };
      var parentProto = NewClass.__super__ = this.prototype;
      var proto2 = create6(parentProto);
      proto2.constructor = NewClass;
      NewClass.prototype = proto2;
      for (var i2 in this) {
        if (Object.prototype.hasOwnProperty.call(this, i2) && i2 !== "prototype" && i2 !== "__super__") {
          NewClass[i2] = this[i2];
        }
      }
      if (props.statics) {
        extend2(NewClass, props.statics);
        delete props.statics;
      }
      if (props.includes) {
        checkDeprecatedMixinEvents(props.includes);
        extend2.apply(null, [proto2].concat(props.includes));
        delete props.includes;
      }
      if (proto2.options) {
        props.options = extend2(create6(proto2.options), props.options);
      }
      extend2(proto2, props);
      proto2._initHooks = [];
      proto2.callInitHooks = function() {
        if (this._initHooksCalled) {
          return;
        }
        if (parentProto.callInitHooks) {
          parentProto.callInitHooks.call(this);
        }
        this._initHooksCalled = true;
        for (var i3 = 0, len = proto2._initHooks.length; i3 < len; i3++) {
          proto2._initHooks[i3].call(this);
        }
      };
      return NewClass;
    };
    Class.include = function(props) {
      extend2(this.prototype, props);
      return this;
    };
    Class.mergeOptions = function(options) {
      extend2(this.prototype.options, options);
      return this;
    };
    Class.addInitHook = function(fn) {
      var args = Array.prototype.slice.call(arguments, 1);
      var init6 = typeof fn === "function" ? fn : function() {
        this[fn].apply(this, args);
      };
      this.prototype._initHooks = this.prototype._initHooks || [];
      this.prototype._initHooks.push(init6);
      return this;
    };
    function checkDeprecatedMixinEvents(includes) {
      if (typeof L === "undefined" || !L || !L.Mixin) {
        return;
      }
      includes = isArray2(includes) ? includes : [includes];
      for (var i2 = 0; i2 < includes.length; i2++) {
        if (includes[i2] === L.Mixin.Events) {
          console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
        }
      }
    }
    var Events = {
      on: function(types, fn, context) {
        if (typeof types === "object") {
          for (var type in types) {
            this._on(type, types[type], fn);
          }
        } else {
          types = splitWords(types);
          for (var i2 = 0, len = types.length; i2 < len; i2++) {
            this._on(types[i2], fn, context);
          }
        }
        return this;
      },
      off: function(types, fn, context) {
        if (!types) {
          delete this._events;
        } else if (typeof types === "object") {
          for (var type in types) {
            this._off(type, types[type], fn);
          }
        } else {
          types = splitWords(types);
          for (var i2 = 0, len = types.length; i2 < len; i2++) {
            this._off(types[i2], fn, context);
          }
        }
        return this;
      },
      _on: function(type, fn, context) {
        this._events = this._events || {};
        var typeListeners = this._events[type];
        if (!typeListeners) {
          typeListeners = [];
          this._events[type] = typeListeners;
        }
        if (context === this) {
          context = void 0;
        }
        var newListener = { fn, ctx: context }, listeners2 = typeListeners;
        for (var i2 = 0, len = listeners2.length; i2 < len; i2++) {
          if (listeners2[i2].fn === fn && listeners2[i2].ctx === context) {
            return;
          }
        }
        listeners2.push(newListener);
      },
      _off: function(type, fn, context) {
        var listeners2, i2, len;
        if (!this._events) {
          return;
        }
        listeners2 = this._events[type];
        if (!listeners2) {
          return;
        }
        if (!fn) {
          for (i2 = 0, len = listeners2.length; i2 < len; i2++) {
            listeners2[i2].fn = falseFn;
          }
          delete this._events[type];
          return;
        }
        if (context === this) {
          context = void 0;
        }
        if (listeners2) {
          for (i2 = 0, len = listeners2.length; i2 < len; i2++) {
            var l = listeners2[i2];
            if (l.ctx !== context) {
              continue;
            }
            if (l.fn === fn) {
              l.fn = falseFn;
              if (this._firingCount) {
                this._events[type] = listeners2 = listeners2.slice();
              }
              listeners2.splice(i2, 1);
              return;
            }
          }
        }
      },
      fire: function(type, data, propagate) {
        if (!this.listens(type, propagate)) {
          return this;
        }
        var event = extend2({}, data, {
          type,
          target: this,
          sourceTarget: data && data.sourceTarget || this
        });
        if (this._events) {
          var listeners2 = this._events[type];
          if (listeners2) {
            this._firingCount = this._firingCount + 1 || 1;
            for (var i2 = 0, len = listeners2.length; i2 < len; i2++) {
              var l = listeners2[i2];
              l.fn.call(l.ctx || this, event);
            }
            this._firingCount--;
          }
        }
        if (propagate) {
          this._propagateEvent(event);
        }
        return this;
      },
      listens: function(type, propagate) {
        var listeners2 = this._events && this._events[type];
        if (listeners2 && listeners2.length) {
          return true;
        }
        if (propagate) {
          for (var id in this._eventParents) {
            if (this._eventParents[id].listens(type, propagate)) {
              return true;
            }
          }
        }
        return false;
      },
      once: function(types, fn, context) {
        if (typeof types === "object") {
          for (var type in types) {
            this.once(type, types[type], fn);
          }
          return this;
        }
        var handler = bind2(function() {
          this.off(types, fn, context).off(types, handler, context);
        }, this);
        return this.on(types, fn, context).on(types, handler, context);
      },
      addEventParent: function(obj) {
        this._eventParents = this._eventParents || {};
        this._eventParents[stamp(obj)] = obj;
        return this;
      },
      removeEventParent: function(obj) {
        if (this._eventParents) {
          delete this._eventParents[stamp(obj)];
        }
        return this;
      },
      _propagateEvent: function(e) {
        for (var id in this._eventParents) {
          this._eventParents[id].fire(e.type, extend2({
            layer: e.target,
            propagatedFrom: e.target
          }, e), true);
        }
      }
    };
    Events.addEventListener = Events.on;
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    Events.addOneTimeEventListener = Events.once;
    Events.fireEvent = Events.fire;
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    function Point(x2, y, round2) {
      this.x = round2 ? Math.round(x2) : x2;
      this.y = round2 ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v2) {
      return v2 > 0 ? Math.floor(v2) : Math.ceil(v2);
    };
    Point.prototype = {
      clone: function() {
        return new Point(this.x, this.y);
      },
      add: function(point) {
        return this.clone()._add(toPoint(point));
      },
      _add: function(point) {
        this.x += point.x;
        this.y += point.y;
        return this;
      },
      subtract: function(point) {
        return this.clone()._subtract(toPoint(point));
      },
      _subtract: function(point) {
        this.x -= point.x;
        this.y -= point.y;
        return this;
      },
      divideBy: function(num) {
        return this.clone()._divideBy(num);
      },
      _divideBy: function(num) {
        this.x /= num;
        this.y /= num;
        return this;
      },
      multiplyBy: function(num) {
        return this.clone()._multiplyBy(num);
      },
      _multiplyBy: function(num) {
        this.x *= num;
        this.y *= num;
        return this;
      },
      scaleBy: function(point) {
        return new Point(this.x * point.x, this.y * point.y);
      },
      unscaleBy: function(point) {
        return new Point(this.x / point.x, this.y / point.y);
      },
      round: function() {
        return this.clone()._round();
      },
      _round: function() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
      },
      floor: function() {
        return this.clone()._floor();
      },
      _floor: function() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
      },
      ceil: function() {
        return this.clone()._ceil();
      },
      _ceil: function() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
      },
      trunc: function() {
        return this.clone()._trunc();
      },
      _trunc: function() {
        this.x = trunc(this.x);
        this.y = trunc(this.y);
        return this;
      },
      distanceTo: function(point) {
        point = toPoint(point);
        var x2 = point.x - this.x, y = point.y - this.y;
        return Math.sqrt(x2 * x2 + y * y);
      },
      equals: function(point) {
        point = toPoint(point);
        return point.x === this.x && point.y === this.y;
      },
      contains: function(point) {
        point = toPoint(point);
        return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
      },
      toString: function() {
        return "Point(" + formatNum(this.x) + ", " + formatNum(this.y) + ")";
      }
    };
    function toPoint(x2, y, round2) {
      if (x2 instanceof Point) {
        return x2;
      }
      if (isArray2(x2)) {
        return new Point(x2[0], x2[1]);
      }
      if (x2 === void 0 || x2 === null) {
        return x2;
      }
      if (typeof x2 === "object" && "x" in x2 && "y" in x2) {
        return new Point(x2.x, x2.y);
      }
      return new Point(x2, y, round2);
    }
    function Bounds(a, b) {
      if (!a) {
        return;
      }
      var points = b ? [a, b] : a;
      for (var i2 = 0, len = points.length; i2 < len; i2++) {
        this.extend(points[i2]);
      }
    }
    Bounds.prototype = {
      extend: function(point) {
        point = toPoint(point);
        if (!this.min && !this.max) {
          this.min = point.clone();
          this.max = point.clone();
        } else {
          this.min.x = Math.min(point.x, this.min.x);
          this.max.x = Math.max(point.x, this.max.x);
          this.min.y = Math.min(point.y, this.min.y);
          this.max.y = Math.max(point.y, this.max.y);
        }
        return this;
      },
      getCenter: function(round2) {
        return new Point((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round2);
      },
      getBottomLeft: function() {
        return new Point(this.min.x, this.max.y);
      },
      getTopRight: function() {
        return new Point(this.max.x, this.min.y);
      },
      getTopLeft: function() {
        return this.min;
      },
      getBottomRight: function() {
        return this.max;
      },
      getSize: function() {
        return this.max.subtract(this.min);
      },
      contains: function(obj) {
        var min3, max3;
        if (typeof obj[0] === "number" || obj instanceof Point) {
          obj = toPoint(obj);
        } else {
          obj = toBounds(obj);
        }
        if (obj instanceof Bounds) {
          min3 = obj.min;
          max3 = obj.max;
        } else {
          min3 = max3 = obj;
        }
        return min3.x >= this.min.x && max3.x <= this.max.x && min3.y >= this.min.y && max3.y <= this.max.y;
      },
      intersects: function(bounds) {
        bounds = toBounds(bounds);
        var min3 = this.min, max3 = this.max, min22 = bounds.min, max22 = bounds.max, xIntersects = max22.x >= min3.x && min22.x <= max3.x, yIntersects = max22.y >= min3.y && min22.y <= max3.y;
        return xIntersects && yIntersects;
      },
      overlaps: function(bounds) {
        bounds = toBounds(bounds);
        var min3 = this.min, max3 = this.max, min22 = bounds.min, max22 = bounds.max, xOverlaps = max22.x > min3.x && min22.x < max3.x, yOverlaps = max22.y > min3.y && min22.y < max3.y;
        return xOverlaps && yOverlaps;
      },
      isValid: function() {
        return !!(this.min && this.max);
      }
    };
    function toBounds(a, b) {
      if (!a || a instanceof Bounds) {
        return a;
      }
      return new Bounds(a, b);
    }
    function LatLngBounds(corner1, corner2) {
      if (!corner1) {
        return;
      }
      var latlngs = corner2 ? [corner1, corner2] : corner1;
      for (var i2 = 0, len = latlngs.length; i2 < len; i2++) {
        this.extend(latlngs[i2]);
      }
    }
    LatLngBounds.prototype = {
      extend: function(obj) {
        var sw = this._southWest, ne = this._northEast, sw2, ne2;
        if (obj instanceof LatLng) {
          sw2 = obj;
          ne2 = obj;
        } else if (obj instanceof LatLngBounds) {
          sw2 = obj._southWest;
          ne2 = obj._northEast;
          if (!sw2 || !ne2) {
            return this;
          }
        } else {
          return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
        }
        if (!sw && !ne) {
          this._southWest = new LatLng(sw2.lat, sw2.lng);
          this._northEast = new LatLng(ne2.lat, ne2.lng);
        } else {
          sw.lat = Math.min(sw2.lat, sw.lat);
          sw.lng = Math.min(sw2.lng, sw.lng);
          ne.lat = Math.max(ne2.lat, ne.lat);
          ne.lng = Math.max(ne2.lng, ne.lng);
        }
        return this;
      },
      pad: function(bufferRatio) {
        var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
        return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
      },
      getCenter: function() {
        return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
      },
      getSouthWest: function() {
        return this._southWest;
      },
      getNorthEast: function() {
        return this._northEast;
      },
      getNorthWest: function() {
        return new LatLng(this.getNorth(), this.getWest());
      },
      getSouthEast: function() {
        return new LatLng(this.getSouth(), this.getEast());
      },
      getWest: function() {
        return this._southWest.lng;
      },
      getSouth: function() {
        return this._southWest.lat;
      },
      getEast: function() {
        return this._northEast.lng;
      },
      getNorth: function() {
        return this._northEast.lat;
      },
      contains: function(obj) {
        if (typeof obj[0] === "number" || obj instanceof LatLng || "lat" in obj) {
          obj = toLatLng(obj);
        } else {
          obj = toLatLngBounds(obj);
        }
        var sw = this._southWest, ne = this._northEast, sw2, ne2;
        if (obj instanceof LatLngBounds) {
          sw2 = obj.getSouthWest();
          ne2 = obj.getNorthEast();
        } else {
          sw2 = ne2 = obj;
        }
        return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
      },
      intersects: function(bounds) {
        bounds = toLatLngBounds(bounds);
        var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
        return latIntersects && lngIntersects;
      },
      overlaps: function(bounds) {
        bounds = toLatLngBounds(bounds);
        var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
        return latOverlaps && lngOverlaps;
      },
      toBBoxString: function() {
        return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(",");
      },
      equals: function(bounds, maxMargin) {
        if (!bounds) {
          return false;
        }
        bounds = toLatLngBounds(bounds);
        return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
      },
      isValid: function() {
        return !!(this._southWest && this._northEast);
      }
    };
    function toLatLngBounds(a, b) {
      if (a instanceof LatLngBounds) {
        return a;
      }
      return new LatLngBounds(a, b);
    }
    function LatLng(lat, lng, alt) {
      if (isNaN(lat) || isNaN(lng)) {
        throw new Error("Invalid LatLng object: (" + lat + ", " + lng + ")");
      }
      this.lat = +lat;
      this.lng = +lng;
      if (alt !== void 0) {
        this.alt = +alt;
      }
    }
    LatLng.prototype = {
      equals: function(obj, maxMargin) {
        if (!obj) {
          return false;
        }
        obj = toLatLng(obj);
        var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
        return margin <= (maxMargin === void 0 ? 1e-9 : maxMargin);
      },
      toString: function(precision) {
        return "LatLng(" + formatNum(this.lat, precision) + ", " + formatNum(this.lng, precision) + ")";
      },
      distanceTo: function(other) {
        return Earth.distance(this, toLatLng(other));
      },
      wrap: function() {
        return Earth.wrapLatLng(this);
      },
      toBounds: function(sizeInMeters) {
        var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
        return toLatLngBounds([this.lat - latAccuracy, this.lng - lngAccuracy], [this.lat + latAccuracy, this.lng + lngAccuracy]);
      },
      clone: function() {
        return new LatLng(this.lat, this.lng, this.alt);
      }
    };
    function toLatLng(a, b, c) {
      if (a instanceof LatLng) {
        return a;
      }
      if (isArray2(a) && typeof a[0] !== "object") {
        if (a.length === 3) {
          return new LatLng(a[0], a[1], a[2]);
        }
        if (a.length === 2) {
          return new LatLng(a[0], a[1]);
        }
        return null;
      }
      if (a === void 0 || a === null) {
        return a;
      }
      if (typeof a === "object" && "lat" in a) {
        return new LatLng(a.lat, "lng" in a ? a.lng : a.lon, a.alt);
      }
      if (b === void 0) {
        return null;
      }
      return new LatLng(a, b, c);
    }
    var CRS = {
      latLngToPoint: function(latlng, zoom2) {
        var projectedPoint = this.projection.project(latlng), scale3 = this.scale(zoom2);
        return this.transformation._transform(projectedPoint, scale3);
      },
      pointToLatLng: function(point, zoom2) {
        var scale3 = this.scale(zoom2), untransformedPoint = this.transformation.untransform(point, scale3);
        return this.projection.unproject(untransformedPoint);
      },
      project: function(latlng) {
        return this.projection.project(latlng);
      },
      unproject: function(point) {
        return this.projection.unproject(point);
      },
      scale: function(zoom2) {
        return 256 * Math.pow(2, zoom2);
      },
      zoom: function(scale3) {
        return Math.log(scale3 / 256) / Math.LN2;
      },
      getProjectedBounds: function(zoom2) {
        if (this.infinite) {
          return null;
        }
        var b = this.projection.bounds, s2 = this.scale(zoom2), min3 = this.transformation.transform(b.min, s2), max3 = this.transformation.transform(b.max, s2);
        return new Bounds(min3, max3);
      },
      infinite: false,
      wrapLatLng: function(latlng) {
        var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
        return new LatLng(lat, lng, alt);
      },
      wrapLatLngBounds: function(bounds) {
        var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
        if (latShift === 0 && lngShift === 0) {
          return bounds;
        }
        var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
        return new LatLngBounds(newSw, newNe);
      }
    };
    var Earth = extend2({}, CRS, {
      wrapLng: [-180, 180],
      R: 6371e3,
      distance: function(latlng1, latlng2) {
        var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return this.R * c;
      }
    });
    var earthRadius = 6378137;
    var SphericalMercator = {
      R: earthRadius,
      MAX_LATITUDE: 85.0511287798,
      project: function(latlng) {
        var d = Math.PI / 180, max3 = this.MAX_LATITUDE, lat = Math.max(Math.min(max3, latlng.lat), -max3), sin = Math.sin(lat * d);
        return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
      },
      unproject: function(point) {
        var d = 180 / Math.PI;
        return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
      },
      bounds: function() {
        var d = earthRadius * Math.PI;
        return new Bounds([-d, -d], [d, d]);
      }()
    };
    function Transformation(a, b, c, d) {
      if (isArray2(a)) {
        this._a = a[0];
        this._b = a[1];
        this._c = a[2];
        this._d = a[3];
        return;
      }
      this._a = a;
      this._b = b;
      this._c = c;
      this._d = d;
    }
    Transformation.prototype = {
      transform: function(point, scale3) {
        return this._transform(point.clone(), scale3);
      },
      _transform: function(point, scale3) {
        scale3 = scale3 || 1;
        point.x = scale3 * (this._a * point.x + this._b);
        point.y = scale3 * (this._c * point.y + this._d);
        return point;
      },
      untransform: function(point, scale3) {
        scale3 = scale3 || 1;
        return new Point((point.x / scale3 - this._b) / this._a, (point.y / scale3 - this._d) / this._c);
      }
    };
    function toTransformation(a, b, c, d) {
      return new Transformation(a, b, c, d);
    }
    var EPSG3857 = extend2({}, Earth, {
      code: "EPSG:3857",
      projection: SphericalMercator,
      transformation: function() {
        var scale3 = 0.5 / (Math.PI * SphericalMercator.R);
        return toTransformation(scale3, 0.5, -scale3, 0.5);
      }()
    });
    var EPSG900913 = extend2({}, EPSG3857, {
      code: "EPSG:900913"
    });
    function svgCreate(name) {
      return document.createElementNS("http://www.w3.org/2000/svg", name);
    }
    function pointsToPath(rings, closed) {
      var str = "", i2, j, len, len2, points, p;
      for (i2 = 0, len = rings.length; i2 < len; i2++) {
        points = rings[i2];
        for (j = 0, len2 = points.length; j < len2; j++) {
          p = points[j];
          str += (j ? "L" : "M") + p.x + " " + p.y;
        }
        str += closed ? svg ? "z" : "x" : "";
      }
      return str || "M0 0";
    }
    var style$1 = document.documentElement.style;
    var ie2 = "ActiveXObject" in window;
    var ielt9 = ie2 && !document.addEventListener;
    var edge2 = "msLaunchUri" in navigator && !("documentMode" in document);
    var webkit = userAgentContains("webkit");
    var android = userAgentContains("android");
    var android23 = userAgentContains("android 2") || userAgentContains("android 3");
    var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10);
    var androidStock = android && userAgentContains("Google") && webkitVer < 537 && !("AudioNode" in window);
    var opera = !!window.opera;
    var chrome2 = !edge2 && userAgentContains("chrome");
    var gecko2 = userAgentContains("gecko") && !webkit && !opera && !ie2;
    var safari2 = !chrome2 && userAgentContains("safari");
    var phantom = userAgentContains("phantom");
    var opera12 = "OTransition" in style$1;
    var win = navigator.platform.indexOf("Win") === 0;
    var ie3d = ie2 && "transition" in style$1;
    var webkit3d = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !android23;
    var gecko3d = "MozPerspective" in style$1;
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    var mobile = typeof orientation !== "undefined" || userAgentContains("mobile");
    var mobileWebkit = mobile && webkit;
    var mobileWebkit3d = mobile && webkit3d;
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    var pointer = !!(window.PointerEvent || msPointer);
    var touch = !window.L_NO_TOUCH && (pointer || "ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch);
    var mobileOpera = mobile && opera;
    var mobileGecko = mobile && gecko2;
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    var passiveEvents = function() {
      var supportsPassiveOption = false;
      try {
        var opts = Object.defineProperty({}, "passive", {
          get: function() {
            supportsPassiveOption = true;
          }
        });
        window.addEventListener("testPassiveEventSupport", falseFn, opts);
        window.removeEventListener("testPassiveEventSupport", falseFn, opts);
      } catch (e) {
      }
      return supportsPassiveOption;
    }();
    var canvas = function() {
      return !!document.createElement("canvas").getContext;
    }();
    var svg = !!(document.createElementNS && svgCreate("svg").createSVGRect);
    var vml = !svg && function() {
      try {
        var div = document.createElement("div");
        div.innerHTML = '<v:shape adj="1"/>';
        var shape2 = div.firstChild;
        shape2.style.behavior = "url(#default#VML)";
        return shape2 && typeof shape2.adj === "object";
      } catch (e) {
        return false;
      }
    }();
    function userAgentContains(str) {
      return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
      ie: ie2,
      ielt9,
      edge: edge2,
      webkit,
      android,
      android23,
      androidStock,
      opera,
      chrome: chrome2,
      gecko: gecko2,
      safari: safari2,
      phantom,
      opera12,
      win,
      ie3d,
      webkit3d,
      gecko3d,
      any3d,
      mobile,
      mobileWebkit,
      mobileWebkit3d,
      msPointer,
      pointer,
      touch,
      mobileOpera,
      mobileGecko,
      retina,
      passiveEvents,
      canvas,
      svg,
      vml
    };
    var POINTER_DOWN = msPointer ? "MSPointerDown" : "pointerdown";
    var POINTER_MOVE = msPointer ? "MSPointerMove" : "pointermove";
    var POINTER_UP = msPointer ? "MSPointerUp" : "pointerup";
    var POINTER_CANCEL = msPointer ? "MSPointerCancel" : "pointercancel";
    var _pointers = {};
    var _pointerDocListener = false;
    function addPointerListener(obj, type, handler, id) {
      if (type === "touchstart") {
        _addPointerStart(obj, handler, id);
      } else if (type === "touchmove") {
        _addPointerMove(obj, handler, id);
      } else if (type === "touchend") {
        _addPointerEnd(obj, handler, id);
      }
      return this;
    }
    function removePointerListener(obj, type, id) {
      var handler = obj["_leaflet_" + type + id];
      if (type === "touchstart") {
        obj.removeEventListener(POINTER_DOWN, handler, false);
      } else if (type === "touchmove") {
        obj.removeEventListener(POINTER_MOVE, handler, false);
      } else if (type === "touchend") {
        obj.removeEventListener(POINTER_UP, handler, false);
        obj.removeEventListener(POINTER_CANCEL, handler, false);
      }
      return this;
    }
    function _addPointerStart(obj, handler, id) {
      var onDown = bind2(function(e) {
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) {
          preventDefault(e);
        }
        _handlePointer(e, handler);
      });
      obj["_leaflet_touchstart" + id] = onDown;
      obj.addEventListener(POINTER_DOWN, onDown, false);
      if (!_pointerDocListener) {
        document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
        document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
        document.addEventListener(POINTER_UP, _globalPointerUp, true);
        document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
        _pointerDocListener = true;
      }
    }
    function _globalPointerDown(e) {
      _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
      if (_pointers[e.pointerId]) {
        _pointers[e.pointerId] = e;
      }
    }
    function _globalPointerUp(e) {
      delete _pointers[e.pointerId];
    }
    function _handlePointer(e, handler) {
      e.touches = [];
      for (var i2 in _pointers) {
        e.touches.push(_pointers[i2]);
      }
      e.changedTouches = [e];
      handler(e);
    }
    function _addPointerMove(obj, handler, id) {
      var onMove = function(e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || "mouse") && e.buttons === 0) {
          return;
        }
        _handlePointer(e, handler);
      };
      obj["_leaflet_touchmove" + id] = onMove;
      obj.addEventListener(POINTER_MOVE, onMove, false);
    }
    function _addPointerEnd(obj, handler, id) {
      var onUp = function(e) {
        _handlePointer(e, handler);
      };
      obj["_leaflet_touchend" + id] = onUp;
      obj.addEventListener(POINTER_UP, onUp, false);
      obj.addEventListener(POINTER_CANCEL, onUp, false);
    }
    var _touchstart = msPointer ? "MSPointerDown" : pointer ? "pointerdown" : "touchstart";
    var _touchend = msPointer ? "MSPointerUp" : pointer ? "pointerup" : "touchend";
    var _pre = "_leaflet_";
    function addDoubleTapListener(obj, handler, id) {
      var last, touch$$1, doubleTap = false, delay = 250;
      function onTouchStart(e) {
        if (pointer) {
          if (!e.isPrimary) {
            return;
          }
          if (e.pointerType === "mouse") {
            return;
          }
        } else if (e.touches.length > 1) {
          return;
        }
        var now2 = Date.now(), delta = now2 - (last || now2);
        touch$$1 = e.touches ? e.touches[0] : e;
        doubleTap = delta > 0 && delta <= delay;
        last = now2;
      }
      function onTouchEnd(e) {
        if (doubleTap && !touch$$1.cancelBubble) {
          if (pointer) {
            if (e.pointerType === "mouse") {
              return;
            }
            var newTouch = {}, prop, i2;
            for (i2 in touch$$1) {
              prop = touch$$1[i2];
              newTouch[i2] = prop && prop.bind ? prop.bind(touch$$1) : prop;
            }
            touch$$1 = newTouch;
          }
          touch$$1.type = "dblclick";
          touch$$1.button = 0;
          handler(touch$$1);
          last = null;
        }
      }
      obj[_pre + _touchstart + id] = onTouchStart;
      obj[_pre + _touchend + id] = onTouchEnd;
      obj[_pre + "dblclick" + id] = handler;
      obj.addEventListener(_touchstart, onTouchStart, passiveEvents ? { passive: false } : false);
      obj.addEventListener(_touchend, onTouchEnd, passiveEvents ? { passive: false } : false);
      obj.addEventListener("dblclick", handler, false);
      return this;
    }
    function removeDoubleTapListener(obj, id) {
      var touchstart = obj[_pre + _touchstart + id], touchend = obj[_pre + _touchend + id], dblclick = obj[_pre + "dblclick" + id];
      obj.removeEventListener(_touchstart, touchstart, passiveEvents ? { passive: false } : false);
      obj.removeEventListener(_touchend, touchend, passiveEvents ? { passive: false } : false);
      obj.removeEventListener("dblclick", dblclick, false);
      return this;
    }
    var TRANSFORM = testProp(["transform", "webkitTransform", "OTransform", "MozTransform", "msTransform"]);
    var TRANSITION = testProp(["webkitTransition", "transition", "OTransition", "MozTransition", "msTransition"]);
    var TRANSITION_END = TRANSITION === "webkitTransition" || TRANSITION === "OTransition" ? TRANSITION + "End" : "transitionend";
    function get4(id) {
      return typeof id === "string" ? document.getElementById(id) : id;
    }
    function getStyle(el, style) {
      var value = el.style[style] || el.currentStyle && el.currentStyle[style];
      if ((!value || value === "auto") && document.defaultView) {
        var css = document.defaultView.getComputedStyle(el, null);
        value = css ? css[style] : null;
      }
      return value === "auto" ? null : value;
    }
    function create$1(tagName, className, container) {
      var el = document.createElement(tagName);
      el.className = className || "";
      if (container) {
        container.appendChild(el);
      }
      return el;
    }
    function remove2(el) {
      var parent = el.parentNode;
      if (parent) {
        parent.removeChild(el);
      }
    }
    function empty2(el) {
      while (el.firstChild) {
        el.removeChild(el.firstChild);
      }
    }
    function toFront(el) {
      var parent = el.parentNode;
      if (parent && parent.lastChild !== el) {
        parent.appendChild(el);
      }
    }
    function toBack(el) {
      var parent = el.parentNode;
      if (parent && parent.firstChild !== el) {
        parent.insertBefore(el, parent.firstChild);
      }
    }
    function hasClass(el, name) {
      if (el.classList !== void 0) {
        return el.classList.contains(name);
      }
      var className = getClass(el);
      return className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(className);
    }
    function addClass(el, name) {
      if (el.classList !== void 0) {
        var classes = splitWords(name);
        for (var i2 = 0, len = classes.length; i2 < len; i2++) {
          el.classList.add(classes[i2]);
        }
      } else if (!hasClass(el, name)) {
        var className = getClass(el);
        setClass2(el, (className ? className + " " : "") + name);
      }
    }
    function removeClass(el, name) {
      if (el.classList !== void 0) {
        el.classList.remove(name);
      } else {
        setClass2(el, trim((" " + getClass(el) + " ").replace(" " + name + " ", " ")));
      }
    }
    function setClass2(el, name) {
      if (el.className.baseVal === void 0) {
        el.className = name;
      } else {
        el.className.baseVal = name;
      }
    }
    function getClass(el) {
      if (el.correspondingElement) {
        el = el.correspondingElement;
      }
      return el.className.baseVal === void 0 ? el.className : el.className.baseVal;
    }
    function setOpacity(el, value) {
      if ("opacity" in el.style) {
        el.style.opacity = value;
      } else if ("filter" in el.style) {
        _setOpacityIE(el, value);
      }
    }
    function _setOpacityIE(el, value) {
      var filter2 = false, filterName = "DXImageTransform.Microsoft.Alpha";
      try {
        filter2 = el.filters.item(filterName);
      } catch (e) {
        if (value === 1) {
          return;
        }
      }
      value = Math.round(value * 100);
      if (filter2) {
        filter2.Enabled = value !== 100;
        filter2.Opacity = value;
      } else {
        el.style.filter += " progid:" + filterName + "(opacity=" + value + ")";
      }
    }
    function testProp(props) {
      var style = document.documentElement.style;
      for (var i2 = 0; i2 < props.length; i2++) {
        if (props[i2] in style) {
          return props[i2];
        }
      }
      return false;
    }
    function setTransform(el, offset3, scale3) {
      var pos = offset3 || new Point(0, 0);
      el.style[TRANSFORM] = (ie3d ? "translate(" + pos.x + "px," + pos.y + "px)" : "translate3d(" + pos.x + "px," + pos.y + "px,0)") + (scale3 ? " scale(" + scale3 + ")" : "");
    }
    function setPosition(el, point) {
      el._leaflet_pos = point;
      if (any3d) {
        setTransform(el, point);
      } else {
        el.style.left = point.x + "px";
        el.style.top = point.y + "px";
      }
    }
    function getPosition(el) {
      return el._leaflet_pos || new Point(0, 0);
    }
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ("onselectstart" in document) {
      disableTextSelection = function() {
        on(window, "selectstart", preventDefault);
      };
      enableTextSelection = function() {
        off(window, "selectstart", preventDefault);
      };
    } else {
      var userSelectProperty = testProp(["userSelect", "WebkitUserSelect", "OUserSelect", "MozUserSelect", "msUserSelect"]);
      disableTextSelection = function() {
        if (userSelectProperty) {
          var style = document.documentElement.style;
          _userSelect = style[userSelectProperty];
          style[userSelectProperty] = "none";
        }
      };
      enableTextSelection = function() {
        if (userSelectProperty) {
          document.documentElement.style[userSelectProperty] = _userSelect;
          _userSelect = void 0;
        }
      };
    }
    function disableImageDrag() {
      on(window, "dragstart", preventDefault);
    }
    function enableImageDrag() {
      off(window, "dragstart", preventDefault);
    }
    var _outlineElement, _outlineStyle;
    function preventOutline(element) {
      while (element.tabIndex === -1) {
        element = element.parentNode;
      }
      if (!element.style) {
        return;
      }
      restoreOutline();
      _outlineElement = element;
      _outlineStyle = element.style.outline;
      element.style.outline = "none";
      on(window, "keydown", restoreOutline);
    }
    function restoreOutline() {
      if (!_outlineElement) {
        return;
      }
      _outlineElement.style.outline = _outlineStyle;
      _outlineElement = void 0;
      _outlineStyle = void 0;
      off(window, "keydown", restoreOutline);
    }
    function getSizedParentNode(element) {
      do {
        element = element.parentNode;
      } while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
      return element;
    }
    function getScale(element) {
      var rect = element.getBoundingClientRect();
      return {
        x: rect.width / element.offsetWidth || 1,
        y: rect.height / element.offsetHeight || 1,
        boundingClientRect: rect
      };
    }
    var DomUtil = {
      TRANSFORM,
      TRANSITION,
      TRANSITION_END,
      get: get4,
      getStyle,
      create: create$1,
      remove: remove2,
      empty: empty2,
      toFront,
      toBack,
      hasClass,
      addClass,
      removeClass,
      setClass: setClass2,
      getClass,
      setOpacity,
      testProp,
      setTransform,
      setPosition,
      getPosition,
      disableTextSelection,
      enableTextSelection,
      disableImageDrag,
      enableImageDrag,
      preventOutline,
      restoreOutline,
      getSizedParentNode,
      getScale
    };
    function on(obj, types, fn, context) {
      if (typeof types === "object") {
        for (var type in types) {
          addOne(obj, type, types[type], fn);
        }
      } else {
        types = splitWords(types);
        for (var i2 = 0, len = types.length; i2 < len; i2++) {
          addOne(obj, types[i2], fn, context);
        }
      }
      return this;
    }
    var eventsKey = "_leaflet_events";
    function off(obj, types, fn, context) {
      if (typeof types === "object") {
        for (var type in types) {
          removeOne(obj, type, types[type], fn);
        }
      } else if (types) {
        types = splitWords(types);
        for (var i2 = 0, len = types.length; i2 < len; i2++) {
          removeOne(obj, types[i2], fn, context);
        }
      } else {
        for (var j in obj[eventsKey]) {
          removeOne(obj, j, obj[eventsKey][j]);
        }
        delete obj[eventsKey];
      }
      return this;
    }
    function browserFiresNativeDblClick() {
      if (pointer) {
        return !(edge2 || safari2);
      }
    }
    var mouseSubst = {
      mouseenter: "mouseover",
      mouseleave: "mouseout",
      wheel: !("onwheel" in window) && "mousewheel"
    };
    function addOne(obj, type, fn, context) {
      var id = type + stamp(fn) + (context ? "_" + stamp(context) : "");
      if (obj[eventsKey] && obj[eventsKey][id]) {
        return this;
      }
      var handler = function(e) {
        return fn.call(context || obj, e || window.event);
      };
      var originalHandler = handler;
      if (pointer && type.indexOf("touch") === 0) {
        addPointerListener(obj, type, handler, id);
      } else if (touch && type === "dblclick" && !browserFiresNativeDblClick()) {
        addDoubleTapListener(obj, handler, id);
      } else if ("addEventListener" in obj) {
        if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") {
          obj.addEventListener(mouseSubst[type] || type, handler, passiveEvents ? { passive: false } : false);
        } else if (type === "mouseenter" || type === "mouseleave") {
          handler = function(e) {
            e = e || window.event;
            if (isExternalTarget(obj, e)) {
              originalHandler(e);
            }
          };
          obj.addEventListener(mouseSubst[type], handler, false);
        } else {
          obj.addEventListener(type, originalHandler, false);
        }
      } else if ("attachEvent" in obj) {
        obj.attachEvent("on" + type, handler);
      }
      obj[eventsKey] = obj[eventsKey] || {};
      obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context) {
      var id = type + stamp(fn) + (context ? "_" + stamp(context) : ""), handler = obj[eventsKey] && obj[eventsKey][id];
      if (!handler) {
        return this;
      }
      if (pointer && type.indexOf("touch") === 0) {
        removePointerListener(obj, type, id);
      } else if (touch && type === "dblclick" && !browserFiresNativeDblClick()) {
        removeDoubleTapListener(obj, id);
      } else if ("removeEventListener" in obj) {
        obj.removeEventListener(mouseSubst[type] || type, handler, false);
      } else if ("detachEvent" in obj) {
        obj.detachEvent("on" + type, handler);
      }
      obj[eventsKey][id] = null;
    }
    function stopPropagation(e) {
      if (e.stopPropagation) {
        e.stopPropagation();
      } else if (e.originalEvent) {
        e.originalEvent._stopped = true;
      } else {
        e.cancelBubble = true;
      }
      skipped(e);
      return this;
    }
    function disableScrollPropagation(el) {
      addOne(el, "wheel", stopPropagation);
      return this;
    }
    function disableClickPropagation(el) {
      on(el, "mousedown touchstart dblclick", stopPropagation);
      addOne(el, "click", fakeStop);
      return this;
    }
    function preventDefault(e) {
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }
      return this;
    }
    function stop3(e) {
      preventDefault(e);
      stopPropagation(e);
      return this;
    }
    function getMousePosition(e, container) {
      if (!container) {
        return new Point(e.clientX, e.clientY);
      }
      var scale3 = getScale(container), offset3 = scale3.boundingClientRect;
      return new Point((e.clientX - offset3.left) / scale3.x - container.clientLeft, (e.clientY - offset3.top) / scale3.y - container.clientTop);
    }
    var wheelPxFactor = win && chrome2 ? 2 * window.devicePixelRatio : gecko2 ? window.devicePixelRatio : 1;
    function getWheelDelta(e) {
      return edge2 ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    var skipEvents = {};
    function fakeStop(e) {
      skipEvents[e.type] = true;
    }
    function skipped(e) {
      var events2 = skipEvents[e.type];
      skipEvents[e.type] = false;
      return events2;
    }
    function isExternalTarget(el, e) {
      var related = e.relatedTarget;
      if (!related) {
        return true;
      }
      try {
        while (related && related !== el) {
          related = related.parentNode;
        }
      } catch (err2) {
        return false;
      }
      return related !== el;
    }
    var DomEvent = {
      on,
      off,
      stopPropagation,
      disableScrollPropagation,
      disableClickPropagation,
      preventDefault,
      stop: stop3,
      getMousePosition,
      getWheelDelta,
      fakeStop,
      skipped,
      isExternalTarget,
      addListener: on,
      removeListener: off
    };
    var PosAnimation = Evented.extend({
      run: function(el, newPos, duration, easeLinearity) {
        this.stop();
        this._el = el;
        this._inProgress = true;
        this._duration = duration || 0.25;
        this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
        this._startPos = getPosition(el);
        this._offset = newPos.subtract(this._startPos);
        this._startTime = +new Date();
        this.fire("start");
        this._animate();
      },
      stop: function() {
        if (!this._inProgress) {
          return;
        }
        this._step(true);
        this._complete();
      },
      _animate: function() {
        this._animId = requestAnimFrame(this._animate, this);
        this._step();
      },
      _step: function(round2) {
        var elapsed = +new Date() - this._startTime, duration = this._duration * 1e3;
        if (elapsed < duration) {
          this._runFrame(this._easeOut(elapsed / duration), round2);
        } else {
          this._runFrame(1);
          this._complete();
        }
      },
      _runFrame: function(progress, round2) {
        var pos = this._startPos.add(this._offset.multiplyBy(progress));
        if (round2) {
          pos._round();
        }
        setPosition(this._el, pos);
        this.fire("step");
      },
      _complete: function() {
        cancelAnimFrame(this._animId);
        this._inProgress = false;
        this.fire("end");
      },
      _easeOut: function(t) {
        return 1 - Math.pow(1 - t, this._easeOutPower);
      }
    });
    var Map2 = Evented.extend({
      options: {
        crs: EPSG3857,
        center: void 0,
        zoom: void 0,
        minZoom: void 0,
        maxZoom: void 0,
        layers: [],
        maxBounds: void 0,
        renderer: void 0,
        zoomAnimation: true,
        zoomAnimationThreshold: 4,
        fadeAnimation: true,
        markerZoomAnimation: true,
        transform3DLimit: 8388608,
        zoomSnap: 1,
        zoomDelta: 1,
        trackResize: true
      },
      initialize: function(id, options) {
        options = setOptions(this, options);
        this._handlers = [];
        this._layers = {};
        this._zoomBoundLayers = {};
        this._sizeChanged = true;
        this._initContainer(id);
        this._initLayout();
        this._onResize = bind2(this._onResize, this);
        this._initEvents();
        if (options.maxBounds) {
          this.setMaxBounds(options.maxBounds);
        }
        if (options.zoom !== void 0) {
          this._zoom = this._limitZoom(options.zoom);
        }
        if (options.center && options.zoom !== void 0) {
          this.setView(toLatLng(options.center), options.zoom, { reset: true });
        }
        this.callInitHooks();
        this._zoomAnimated = TRANSITION && any3d && !mobileOpera && this.options.zoomAnimation;
        if (this._zoomAnimated) {
          this._createAnimProxy();
          on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
        }
        this._addLayers(this.options.layers);
      },
      setView: function(center, zoom2, options) {
        zoom2 = zoom2 === void 0 ? this._zoom : this._limitZoom(zoom2);
        center = this._limitCenter(toLatLng(center), zoom2, this.options.maxBounds);
        options = options || {};
        this._stop();
        if (this._loaded && !options.reset && options !== true) {
          if (options.animate !== void 0) {
            options.zoom = extend2({ animate: options.animate }, options.zoom);
            options.pan = extend2({ animate: options.animate, duration: options.duration }, options.pan);
          }
          var moved = this._zoom !== zoom2 ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom2, options.zoom) : this._tryAnimatedPan(center, options.pan);
          if (moved) {
            clearTimeout(this._sizeTimer);
            return this;
          }
        }
        this._resetView(center, zoom2);
        return this;
      },
      setZoom: function(zoom2, options) {
        if (!this._loaded) {
          this._zoom = zoom2;
          return this;
        }
        return this.setView(this.getCenter(), zoom2, { zoom: options });
      },
      zoomIn: function(delta, options) {
        delta = delta || (any3d ? this.options.zoomDelta : 1);
        return this.setZoom(this._zoom + delta, options);
      },
      zoomOut: function(delta, options) {
        delta = delta || (any3d ? this.options.zoomDelta : 1);
        return this.setZoom(this._zoom - delta, options);
      },
      setZoomAround: function(latlng, zoom2, options) {
        var scale3 = this.getZoomScale(zoom2), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale3), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
        return this.setView(newCenter, zoom2, { zoom: options });
      },
      _getBoundsCenterZoom: function(bounds, options) {
        options = options || {};
        bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
        var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]), zoom2 = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
        zoom2 = typeof options.maxZoom === "number" ? Math.min(options.maxZoom, zoom2) : zoom2;
        if (zoom2 === Infinity) {
          return {
            center: bounds.getCenter(),
            zoom: zoom2
          };
        }
        var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom2), nePoint = this.project(bounds.getNorthEast(), zoom2), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom2);
        return {
          center,
          zoom: zoom2
        };
      },
      fitBounds: function(bounds, options) {
        bounds = toLatLngBounds(bounds);
        if (!bounds.isValid()) {
          throw new Error("Bounds are not valid.");
        }
        var target = this._getBoundsCenterZoom(bounds, options);
        return this.setView(target.center, target.zoom, options);
      },
      fitWorld: function(options) {
        return this.fitBounds([[-90, -180], [90, 180]], options);
      },
      panTo: function(center, options) {
        return this.setView(center, this._zoom, { pan: options });
      },
      panBy: function(offset3, options) {
        offset3 = toPoint(offset3).round();
        options = options || {};
        if (!offset3.x && !offset3.y) {
          return this.fire("moveend");
        }
        if (options.animate !== true && !this.getSize().contains(offset3)) {
          this._resetView(this.unproject(this.project(this.getCenter()).add(offset3)), this.getZoom());
          return this;
        }
        if (!this._panAnim) {
          this._panAnim = new PosAnimation();
          this._panAnim.on({
            "step": this._onPanTransitionStep,
            "end": this._onPanTransitionEnd
          }, this);
        }
        if (!options.noMoveStart) {
          this.fire("movestart");
        }
        if (options.animate !== false) {
          addClass(this._mapPane, "leaflet-pan-anim");
          var newPos = this._getMapPanePos().subtract(offset3).round();
          this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
        } else {
          this._rawPanBy(offset3);
          this.fire("move").fire("moveend");
        }
        return this;
      },
      flyTo: function(targetCenter, targetZoom, options) {
        options = options || {};
        if (options.animate === false || !any3d) {
          return this.setView(targetCenter, targetZoom, options);
        }
        this._stop();
        var from5 = this.project(this.getCenter()), to2 = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
        targetCenter = toLatLng(targetCenter);
        targetZoom = targetZoom === void 0 ? startZoom : targetZoom;
        var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to2.distanceTo(from5) || 1, rho = 1.42, rho2 = rho * rho;
        function r(i2) {
          var s1 = i2 ? -1 : 1, s2 = i2 ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
          var log2 = sq < 1e-9 ? -18 : Math.log(sq);
          return log2;
        }
        function sinh(n) {
          return (Math.exp(n) - Math.exp(-n)) / 2;
        }
        function cosh(n) {
          return (Math.exp(n) + Math.exp(-n)) / 2;
        }
        function tanh(n) {
          return sinh(n) / cosh(n);
        }
        var r0 = r(0);
        function w(s2) {
          return w0 * (cosh(r0) / cosh(r0 + rho * s2));
        }
        function u(s2) {
          return w0 * (cosh(r0) * tanh(r0 + rho * s2) - sinh(r0)) / rho2;
        }
        function easeOut(t) {
          return 1 - Math.pow(1 - t, 1.5);
        }
        var start3 = Date.now(), S2 = (r(1) - r0) / rho, duration = options.duration ? 1e3 * options.duration : 1e3 * S2 * 0.8;
        function frame() {
          var t = (Date.now() - start3) / duration, s2 = easeOut(t) * S2;
          if (t <= 1) {
            this._flyToFrame = requestAnimFrame(frame, this);
            this._move(this.unproject(from5.add(to2.subtract(from5).multiplyBy(u(s2) / u1)), startZoom), this.getScaleZoom(w0 / w(s2), startZoom), { flyTo: true });
          } else {
            this._move(targetCenter, targetZoom)._moveEnd(true);
          }
        }
        this._moveStart(true, options.noMoveStart);
        frame.call(this);
        return this;
      },
      flyToBounds: function(bounds, options) {
        var target = this._getBoundsCenterZoom(bounds, options);
        return this.flyTo(target.center, target.zoom, options);
      },
      setMaxBounds: function(bounds) {
        bounds = toLatLngBounds(bounds);
        if (!bounds.isValid()) {
          this.options.maxBounds = null;
          return this.off("moveend", this._panInsideMaxBounds);
        } else if (this.options.maxBounds) {
          this.off("moveend", this._panInsideMaxBounds);
        }
        this.options.maxBounds = bounds;
        if (this._loaded) {
          this._panInsideMaxBounds();
        }
        return this.on("moveend", this._panInsideMaxBounds);
      },
      setMinZoom: function(zoom2) {
        var oldZoom = this.options.minZoom;
        this.options.minZoom = zoom2;
        if (this._loaded && oldZoom !== zoom2) {
          this.fire("zoomlevelschange");
          if (this.getZoom() < this.options.minZoom) {
            return this.setZoom(zoom2);
          }
        }
        return this;
      },
      setMaxZoom: function(zoom2) {
        var oldZoom = this.options.maxZoom;
        this.options.maxZoom = zoom2;
        if (this._loaded && oldZoom !== zoom2) {
          this.fire("zoomlevelschange");
          if (this.getZoom() > this.options.maxZoom) {
            return this.setZoom(zoom2);
          }
        }
        return this;
      },
      panInsideBounds: function(bounds, options) {
        this._enforcingBounds = true;
        var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
        if (!center.equals(newCenter)) {
          this.panTo(newCenter, options);
        }
        this._enforcingBounds = false;
        return this;
      },
      panInside: function(latlng, options) {
        options = options || {};
        var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]), center = this.getCenter(), pixelCenter = this.project(center), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), halfPixelBounds = pixelBounds.getSize().divideBy(2), paddedBounds = toBounds([pixelBounds.min.add(paddingTL), pixelBounds.max.subtract(paddingBR)]);
        if (!paddedBounds.contains(pixelPoint)) {
          this._enforcingBounds = true;
          var diff2 = pixelCenter.subtract(pixelPoint), newCenter = toPoint(pixelPoint.x + diff2.x, pixelPoint.y + diff2.y);
          if (pixelPoint.x < paddedBounds.min.x || pixelPoint.x > paddedBounds.max.x) {
            newCenter.x = pixelCenter.x - diff2.x;
            if (diff2.x > 0) {
              newCenter.x += halfPixelBounds.x - paddingTL.x;
            } else {
              newCenter.x -= halfPixelBounds.x - paddingBR.x;
            }
          }
          if (pixelPoint.y < paddedBounds.min.y || pixelPoint.y > paddedBounds.max.y) {
            newCenter.y = pixelCenter.y - diff2.y;
            if (diff2.y > 0) {
              newCenter.y += halfPixelBounds.y - paddingTL.y;
            } else {
              newCenter.y -= halfPixelBounds.y - paddingBR.y;
            }
          }
          this.panTo(this.unproject(newCenter), options);
          this._enforcingBounds = false;
        }
        return this;
      },
      invalidateSize: function(options) {
        if (!this._loaded) {
          return this;
        }
        options = extend2({
          animate: false,
          pan: true
        }, options === true ? { animate: true } : options);
        var oldSize = this.getSize();
        this._sizeChanged = true;
        this._lastCenter = null;
        var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset3 = oldCenter.subtract(newCenter);
        if (!offset3.x && !offset3.y) {
          return this;
        }
        if (options.animate && options.pan) {
          this.panBy(offset3);
        } else {
          if (options.pan) {
            this._rawPanBy(offset3);
          }
          this.fire("move");
          if (options.debounceMoveend) {
            clearTimeout(this._sizeTimer);
            this._sizeTimer = setTimeout(bind2(this.fire, this, "moveend"), 200);
          } else {
            this.fire("moveend");
          }
        }
        return this.fire("resize", {
          oldSize,
          newSize
        });
      },
      stop: function() {
        this.setZoom(this._limitZoom(this._zoom));
        if (!this.options.zoomSnap) {
          this.fire("viewreset");
        }
        return this._stop();
      },
      locate: function(options) {
        options = this._locateOptions = extend2({
          timeout: 1e4,
          watch: false
        }, options);
        if (!("geolocation" in navigator)) {
          this._handleGeolocationError({
            code: 0,
            message: "Geolocation not supported."
          });
          return this;
        }
        var onResponse = bind2(this._handleGeolocationResponse, this), onError = bind2(this._handleGeolocationError, this);
        if (options.watch) {
          this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
        } else {
          navigator.geolocation.getCurrentPosition(onResponse, onError, options);
        }
        return this;
      },
      stopLocate: function() {
        if (navigator.geolocation && navigator.geolocation.clearWatch) {
          navigator.geolocation.clearWatch(this._locationWatchId);
        }
        if (this._locateOptions) {
          this._locateOptions.setView = false;
        }
        return this;
      },
      _handleGeolocationError: function(error) {
        var c = error.code, message = error.message || (c === 1 ? "permission denied" : c === 2 ? "position unavailable" : "timeout");
        if (this._locateOptions.setView && !this._loaded) {
          this.fitWorld();
        }
        this.fire("locationerror", {
          code: c,
          message: "Geolocation error: " + message + "."
        });
      },
      _handleGeolocationResponse: function(pos) {
        var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
        if (options.setView) {
          var zoom2 = this.getBoundsZoom(bounds);
          this.setView(latlng, options.maxZoom ? Math.min(zoom2, options.maxZoom) : zoom2);
        }
        var data = {
          latlng,
          bounds,
          timestamp: pos.timestamp
        };
        for (var i2 in pos.coords) {
          if (typeof pos.coords[i2] === "number") {
            data[i2] = pos.coords[i2];
          }
        }
        this.fire("locationfound", data);
      },
      addHandler: function(name, HandlerClass) {
        if (!HandlerClass) {
          return this;
        }
        var handler = this[name] = new HandlerClass(this);
        this._handlers.push(handler);
        if (this.options[name]) {
          handler.enable();
        }
        return this;
      },
      remove: function() {
        this._initEvents(true);
        this.off("moveend", this._panInsideMaxBounds);
        if (this._containerId !== this._container._leaflet_id) {
          throw new Error("Map container is being reused by another instance");
        }
        try {
          delete this._container._leaflet_id;
          delete this._containerId;
        } catch (e) {
          this._container._leaflet_id = void 0;
          this._containerId = void 0;
        }
        if (this._locationWatchId !== void 0) {
          this.stopLocate();
        }
        this._stop();
        remove2(this._mapPane);
        if (this._clearControlPos) {
          this._clearControlPos();
        }
        if (this._resizeRequest) {
          cancelAnimFrame(this._resizeRequest);
          this._resizeRequest = null;
        }
        this._clearHandlers();
        if (this._loaded) {
          this.fire("unload");
        }
        var i2;
        for (i2 in this._layers) {
          this._layers[i2].remove();
        }
        for (i2 in this._panes) {
          remove2(this._panes[i2]);
        }
        this._layers = [];
        this._panes = [];
        delete this._mapPane;
        delete this._renderer;
        return this;
      },
      createPane: function(name, container) {
        var className = "leaflet-pane" + (name ? " leaflet-" + name.replace("Pane", "") + "-pane" : ""), pane = create$1("div", className, container || this._mapPane);
        if (name) {
          this._panes[name] = pane;
        }
        return pane;
      },
      getCenter: function() {
        this._checkIfLoaded();
        if (this._lastCenter && !this._moved()) {
          return this._lastCenter;
        }
        return this.layerPointToLatLng(this._getCenterLayerPoint());
      },
      getZoom: function() {
        return this._zoom;
      },
      getBounds: function() {
        var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
        return new LatLngBounds(sw, ne);
      },
      getMinZoom: function() {
        return this.options.minZoom === void 0 ? this._layersMinZoom || 0 : this.options.minZoom;
      },
      getMaxZoom: function() {
        return this.options.maxZoom === void 0 ? this._layersMaxZoom === void 0 ? Infinity : this._layersMaxZoom : this.options.maxZoom;
      },
      getBoundsZoom: function(bounds, inside, padding) {
        bounds = toLatLngBounds(bounds);
        padding = toPoint(padding || [0, 0]);
        var zoom2 = this.getZoom() || 0, min3 = this.getMinZoom(), max3 = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom2), this.project(nw, zoom2)).getSize(), snap = any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale3 = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
        zoom2 = this.getScaleZoom(scale3, zoom2);
        if (snap) {
          zoom2 = Math.round(zoom2 / (snap / 100)) * (snap / 100);
          zoom2 = inside ? Math.ceil(zoom2 / snap) * snap : Math.floor(zoom2 / snap) * snap;
        }
        return Math.max(min3, Math.min(max3, zoom2));
      },
      getSize: function() {
        if (!this._size || this._sizeChanged) {
          this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
          this._sizeChanged = false;
        }
        return this._size.clone();
      },
      getPixelBounds: function(center, zoom2) {
        var topLeftPoint = this._getTopLeftPoint(center, zoom2);
        return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
      },
      getPixelOrigin: function() {
        this._checkIfLoaded();
        return this._pixelOrigin;
      },
      getPixelWorldBounds: function(zoom2) {
        return this.options.crs.getProjectedBounds(zoom2 === void 0 ? this.getZoom() : zoom2);
      },
      getPane: function(pane) {
        return typeof pane === "string" ? this._panes[pane] : pane;
      },
      getPanes: function() {
        return this._panes;
      },
      getContainer: function() {
        return this._container;
      },
      getZoomScale: function(toZoom, fromZoom) {
        var crs = this.options.crs;
        fromZoom = fromZoom === void 0 ? this._zoom : fromZoom;
        return crs.scale(toZoom) / crs.scale(fromZoom);
      },
      getScaleZoom: function(scale3, fromZoom) {
        var crs = this.options.crs;
        fromZoom = fromZoom === void 0 ? this._zoom : fromZoom;
        var zoom2 = crs.zoom(scale3 * crs.scale(fromZoom));
        return isNaN(zoom2) ? Infinity : zoom2;
      },
      project: function(latlng, zoom2) {
        zoom2 = zoom2 === void 0 ? this._zoom : zoom2;
        return this.options.crs.latLngToPoint(toLatLng(latlng), zoom2);
      },
      unproject: function(point, zoom2) {
        zoom2 = zoom2 === void 0 ? this._zoom : zoom2;
        return this.options.crs.pointToLatLng(toPoint(point), zoom2);
      },
      layerPointToLatLng: function(point) {
        var projectedPoint = toPoint(point).add(this.getPixelOrigin());
        return this.unproject(projectedPoint);
      },
      latLngToLayerPoint: function(latlng) {
        var projectedPoint = this.project(toLatLng(latlng))._round();
        return projectedPoint._subtract(this.getPixelOrigin());
      },
      wrapLatLng: function(latlng) {
        return this.options.crs.wrapLatLng(toLatLng(latlng));
      },
      wrapLatLngBounds: function(latlng) {
        return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
      },
      distance: function(latlng1, latlng2) {
        return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
      },
      containerPointToLayerPoint: function(point) {
        return toPoint(point).subtract(this._getMapPanePos());
      },
      layerPointToContainerPoint: function(point) {
        return toPoint(point).add(this._getMapPanePos());
      },
      containerPointToLatLng: function(point) {
        var layerPoint = this.containerPointToLayerPoint(toPoint(point));
        return this.layerPointToLatLng(layerPoint);
      },
      latLngToContainerPoint: function(latlng) {
        return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
      },
      mouseEventToContainerPoint: function(e) {
        return getMousePosition(e, this._container);
      },
      mouseEventToLayerPoint: function(e) {
        return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
      },
      mouseEventToLatLng: function(e) {
        return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
      },
      _initContainer: function(id) {
        var container = this._container = get4(id);
        if (!container) {
          throw new Error("Map container not found.");
        } else if (container._leaflet_id) {
          throw new Error("Map container is already initialized.");
        }
        on(container, "scroll", this._onScroll, this);
        this._containerId = stamp(container);
      },
      _initLayout: function() {
        var container = this._container;
        this._fadeAnimated = this.options.fadeAnimation && any3d;
        addClass(container, "leaflet-container" + (touch ? " leaflet-touch" : "") + (retina ? " leaflet-retina" : "") + (ielt9 ? " leaflet-oldie" : "") + (safari2 ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
        var position = getStyle(container, "position");
        if (position !== "absolute" && position !== "relative" && position !== "fixed") {
          container.style.position = "relative";
        }
        this._initPanes();
        if (this._initControlPos) {
          this._initControlPos();
        }
      },
      _initPanes: function() {
        var panes = this._panes = {};
        this._paneRenderers = {};
        this._mapPane = this.createPane("mapPane", this._container);
        setPosition(this._mapPane, new Point(0, 0));
        this.createPane("tilePane");
        this.createPane("shadowPane");
        this.createPane("overlayPane");
        this.createPane("markerPane");
        this.createPane("tooltipPane");
        this.createPane("popupPane");
        if (!this.options.markerZoomAnimation) {
          addClass(panes.markerPane, "leaflet-zoom-hide");
          addClass(panes.shadowPane, "leaflet-zoom-hide");
        }
      },
      _resetView: function(center, zoom2) {
        setPosition(this._mapPane, new Point(0, 0));
        var loading = !this._loaded;
        this._loaded = true;
        zoom2 = this._limitZoom(zoom2);
        this.fire("viewprereset");
        var zoomChanged = this._zoom !== zoom2;
        this._moveStart(zoomChanged, false)._move(center, zoom2)._moveEnd(zoomChanged);
        this.fire("viewreset");
        if (loading) {
          this.fire("load");
        }
      },
      _moveStart: function(zoomChanged, noMoveStart) {
        if (zoomChanged) {
          this.fire("zoomstart");
        }
        if (!noMoveStart) {
          this.fire("movestart");
        }
        return this;
      },
      _move: function(center, zoom2, data) {
        if (zoom2 === void 0) {
          zoom2 = this._zoom;
        }
        var zoomChanged = this._zoom !== zoom2;
        this._zoom = zoom2;
        this._lastCenter = center;
        this._pixelOrigin = this._getNewPixelOrigin(center);
        if (zoomChanged || data && data.pinch) {
          this.fire("zoom", data);
        }
        return this.fire("move", data);
      },
      _moveEnd: function(zoomChanged) {
        if (zoomChanged) {
          this.fire("zoomend");
        }
        return this.fire("moveend");
      },
      _stop: function() {
        cancelAnimFrame(this._flyToFrame);
        if (this._panAnim) {
          this._panAnim.stop();
        }
        return this;
      },
      _rawPanBy: function(offset3) {
        setPosition(this._mapPane, this._getMapPanePos().subtract(offset3));
      },
      _getZoomSpan: function() {
        return this.getMaxZoom() - this.getMinZoom();
      },
      _panInsideMaxBounds: function() {
        if (!this._enforcingBounds) {
          this.panInsideBounds(this.options.maxBounds);
        }
      },
      _checkIfLoaded: function() {
        if (!this._loaded) {
          throw new Error("Set map center and zoom first.");
        }
      },
      _initEvents: function(remove$$1) {
        this._targets = {};
        this._targets[stamp(this._container)] = this;
        var onOff = remove$$1 ? off : on;
        onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
        if (this.options.trackResize) {
          onOff(window, "resize", this._onResize, this);
        }
        if (any3d && this.options.transform3DLimit) {
          (remove$$1 ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        }
      },
      _onResize: function() {
        cancelAnimFrame(this._resizeRequest);
        this._resizeRequest = requestAnimFrame(function() {
          this.invalidateSize({ debounceMoveend: true });
        }, this);
      },
      _onScroll: function() {
        this._container.scrollTop = 0;
        this._container.scrollLeft = 0;
      },
      _onMoveEnd: function() {
        var pos = this._getMapPanePos();
        if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
          this._resetView(this.getCenter(), this.getZoom());
        }
      },
      _findEventTargets: function(e, type) {
        var targets = [], target, isHover = type === "mouseout" || type === "mouseover", src = e.target || e.srcElement, dragging = false;
        while (src) {
          target = this._targets[stamp(src)];
          if (target && (type === "click" || type === "preclick") && !e._simulated && this._draggableMoved(target)) {
            dragging = true;
            break;
          }
          if (target && target.listens(type, true)) {
            if (isHover && !isExternalTarget(src, e)) {
              break;
            }
            targets.push(target);
            if (isHover) {
              break;
            }
          }
          if (src === this._container) {
            break;
          }
          src = src.parentNode;
        }
        if (!targets.length && !dragging && !isHover && isExternalTarget(src, e)) {
          targets = [this];
        }
        return targets;
      },
      _handleDOMEvent: function(e) {
        if (!this._loaded || skipped(e)) {
          return;
        }
        var type = e.type;
        if (type === "mousedown" || type === "keypress" || type === "keyup" || type === "keydown") {
          preventOutline(e.target || e.srcElement);
        }
        this._fireDOMEvent(e, type);
      },
      _mouseEvents: ["click", "dblclick", "mouseover", "mouseout", "contextmenu"],
      _fireDOMEvent: function(e, type, targets) {
        if (e.type === "click") {
          var synth = extend2({}, e);
          synth.type = "preclick";
          this._fireDOMEvent(synth, synth.type, targets);
        }
        if (e._stopped) {
          return;
        }
        targets = (targets || []).concat(this._findEventTargets(e, type));
        if (!targets.length) {
          return;
        }
        var target = targets[0];
        if (type === "contextmenu" && target.listens(type, true)) {
          preventDefault(e);
        }
        var data = {
          originalEvent: e
        };
        if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
          var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
          data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
          data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
          data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
        }
        for (var i2 = 0; i2 < targets.length; i2++) {
          targets[i2].fire(type, data, true);
          if (data.originalEvent._stopped || targets[i2].options.bubblingMouseEvents === false && indexOf2(this._mouseEvents, type) !== -1) {
            return;
          }
        }
      },
      _draggableMoved: function(obj) {
        obj = obj.dragging && obj.dragging.enabled() ? obj : this;
        return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
      },
      _clearHandlers: function() {
        for (var i2 = 0, len = this._handlers.length; i2 < len; i2++) {
          this._handlers[i2].disable();
        }
      },
      whenReady: function(callback, context) {
        if (this._loaded) {
          callback.call(context || this, { target: this });
        } else {
          this.on("load", callback, context);
        }
        return this;
      },
      _getMapPanePos: function() {
        return getPosition(this._mapPane) || new Point(0, 0);
      },
      _moved: function() {
        var pos = this._getMapPanePos();
        return pos && !pos.equals([0, 0]);
      },
      _getTopLeftPoint: function(center, zoom2) {
        var pixelOrigin = center && zoom2 !== void 0 ? this._getNewPixelOrigin(center, zoom2) : this.getPixelOrigin();
        return pixelOrigin.subtract(this._getMapPanePos());
      },
      _getNewPixelOrigin: function(center, zoom2) {
        var viewHalf = this.getSize()._divideBy(2);
        return this.project(center, zoom2)._subtract(viewHalf)._add(this._getMapPanePos())._round();
      },
      _latLngToNewLayerPoint: function(latlng, zoom2, center) {
        var topLeft = this._getNewPixelOrigin(center, zoom2);
        return this.project(latlng, zoom2)._subtract(topLeft);
      },
      _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom2, center) {
        var topLeft = this._getNewPixelOrigin(center, zoom2);
        return toBounds([
          this.project(latLngBounds.getSouthWest(), zoom2)._subtract(topLeft),
          this.project(latLngBounds.getNorthWest(), zoom2)._subtract(topLeft),
          this.project(latLngBounds.getSouthEast(), zoom2)._subtract(topLeft),
          this.project(latLngBounds.getNorthEast(), zoom2)._subtract(topLeft)
        ]);
      },
      _getCenterLayerPoint: function() {
        return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
      },
      _getCenterOffset: function(latlng) {
        return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
      },
      _limitCenter: function(center, zoom2, bounds) {
        if (!bounds) {
          return center;
        }
        var centerPoint = this.project(center, zoom2), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset3 = this._getBoundsOffset(viewBounds, bounds, zoom2);
        if (offset3.round().equals([0, 0])) {
          return center;
        }
        return this.unproject(centerPoint.add(offset3), zoom2);
      },
      _limitOffset: function(offset3, bounds) {
        if (!bounds) {
          return offset3;
        }
        var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset3), viewBounds.max.add(offset3));
        return offset3.add(this._getBoundsOffset(newBounds, bounds));
      },
      _getBoundsOffset: function(pxBounds, maxBounds, zoom2) {
        var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom2), this.project(maxBounds.getSouthWest(), zoom2)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
        return new Point(dx, dy);
      },
      _rebound: function(left, right) {
        return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
      },
      _limitZoom: function(zoom2) {
        var min3 = this.getMinZoom(), max3 = this.getMaxZoom(), snap = any3d ? this.options.zoomSnap : 1;
        if (snap) {
          zoom2 = Math.round(zoom2 / snap) * snap;
        }
        return Math.max(min3, Math.min(max3, zoom2));
      },
      _onPanTransitionStep: function() {
        this.fire("move");
      },
      _onPanTransitionEnd: function() {
        removeClass(this._mapPane, "leaflet-pan-anim");
        this.fire("moveend");
      },
      _tryAnimatedPan: function(center, options) {
        var offset3 = this._getCenterOffset(center)._trunc();
        if ((options && options.animate) !== true && !this.getSize().contains(offset3)) {
          return false;
        }
        this.panBy(offset3, options);
        return true;
      },
      _createAnimProxy: function() {
        var proxy = this._proxy = create$1("div", "leaflet-proxy leaflet-zoom-animated");
        this._panes.mapPane.appendChild(proxy);
        this.on("zoomanim", function(e) {
          var prop = TRANSFORM, transform = this._proxy.style[prop];
          setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
          if (transform === this._proxy.style[prop] && this._animatingZoom) {
            this._onZoomTransitionEnd();
          }
        }, this);
        this.on("load moveend", this._animMoveEnd, this);
        this._on("unload", this._destroyAnimProxy, this);
      },
      _destroyAnimProxy: function() {
        remove2(this._proxy);
        this.off("load moveend", this._animMoveEnd, this);
        delete this._proxy;
      },
      _animMoveEnd: function() {
        var c = this.getCenter(), z = this.getZoom();
        setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
      },
      _catchTransitionEnd: function(e) {
        if (this._animatingZoom && e.propertyName.indexOf("transform") >= 0) {
          this._onZoomTransitionEnd();
        }
      },
      _nothingToAnimate: function() {
        return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
      },
      _tryAnimatedZoom: function(center, zoom2, options) {
        if (this._animatingZoom) {
          return true;
        }
        options = options || {};
        if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom2 - this._zoom) > this.options.zoomAnimationThreshold) {
          return false;
        }
        var scale3 = this.getZoomScale(zoom2), offset3 = this._getCenterOffset(center)._divideBy(1 - 1 / scale3);
        if (options.animate !== true && !this.getSize().contains(offset3)) {
          return false;
        }
        requestAnimFrame(function() {
          this._moveStart(true, false)._animateZoom(center, zoom2, true);
        }, this);
        return true;
      },
      _animateZoom: function(center, zoom2, startAnim, noUpdate) {
        if (!this._mapPane) {
          return;
        }
        if (startAnim) {
          this._animatingZoom = true;
          this._animateToCenter = center;
          this._animateToZoom = zoom2;
          addClass(this._mapPane, "leaflet-zoom-anim");
        }
        this.fire("zoomanim", {
          center,
          zoom: zoom2,
          noUpdate
        });
        setTimeout(bind2(this._onZoomTransitionEnd, this), 250);
      },
      _onZoomTransitionEnd: function() {
        if (!this._animatingZoom) {
          return;
        }
        if (this._mapPane) {
          removeClass(this._mapPane, "leaflet-zoom-anim");
        }
        this._animatingZoom = false;
        this._move(this._animateToCenter, this._animateToZoom);
        requestAnimFrame(function() {
          this._moveEnd(true);
        }, this);
      }
    });
    function createMap(id, options) {
      return new Map2(id, options);
    }
    var Control = Class.extend({
      options: {
        position: "topright"
      },
      initialize: function(options) {
        setOptions(this, options);
      },
      getPosition: function() {
        return this.options.position;
      },
      setPosition: function(position) {
        var map16 = this._map;
        if (map16) {
          map16.removeControl(this);
        }
        this.options.position = position;
        if (map16) {
          map16.addControl(this);
        }
        return this;
      },
      getContainer: function() {
        return this._container;
      },
      addTo: function(map16) {
        this.remove();
        this._map = map16;
        var container = this._container = this.onAdd(map16), pos = this.getPosition(), corner = map16._controlCorners[pos];
        addClass(container, "leaflet-control");
        if (pos.indexOf("bottom") !== -1) {
          corner.insertBefore(container, corner.firstChild);
        } else {
          corner.appendChild(container);
        }
        this._map.on("unload", this.remove, this);
        return this;
      },
      remove: function() {
        if (!this._map) {
          return this;
        }
        remove2(this._container);
        if (this.onRemove) {
          this.onRemove(this._map);
        }
        this._map.off("unload", this.remove, this);
        this._map = null;
        return this;
      },
      _refocusOnMap: function(e) {
        if (this._map && e && e.screenX > 0 && e.screenY > 0) {
          this._map.getContainer().focus();
        }
      }
    });
    var control = function(options) {
      return new Control(options);
    };
    Map2.include({
      addControl: function(control2) {
        control2.addTo(this);
        return this;
      },
      removeControl: function(control2) {
        control2.remove();
        return this;
      },
      _initControlPos: function() {
        var corners = this._controlCorners = {}, l = "leaflet-", container = this._controlContainer = create$1("div", l + "control-container", this._container);
        function createCorner(vSide, hSide) {
          var className = l + vSide + " " + l + hSide;
          corners[vSide + hSide] = create$1("div", className, container);
        }
        createCorner("top", "left");
        createCorner("top", "right");
        createCorner("bottom", "left");
        createCorner("bottom", "right");
      },
      _clearControlPos: function() {
        for (var i2 in this._controlCorners) {
          remove2(this._controlCorners[i2]);
        }
        remove2(this._controlContainer);
        delete this._controlCorners;
        delete this._controlContainer;
      }
    });
    var Layers = Control.extend({
      options: {
        collapsed: true,
        position: "topright",
        autoZIndex: true,
        hideSingleBase: false,
        sortLayers: false,
        sortFunction: function(layerA, layerB, nameA, nameB) {
          return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
        }
      },
      initialize: function(baseLayers, overlays, options) {
        setOptions(this, options);
        this._layerControlInputs = [];
        this._layers = [];
        this._lastZIndex = 0;
        this._handlingClick = false;
        for (var i2 in baseLayers) {
          this._addLayer(baseLayers[i2], i2);
        }
        for (i2 in overlays) {
          this._addLayer(overlays[i2], i2, true);
        }
      },
      onAdd: function(map16) {
        this._initLayout();
        this._update();
        this._map = map16;
        map16.on("zoomend", this._checkDisabledLayers, this);
        for (var i2 = 0; i2 < this._layers.length; i2++) {
          this._layers[i2].layer.on("add remove", this._onLayerChange, this);
        }
        return this._container;
      },
      addTo: function(map16) {
        Control.prototype.addTo.call(this, map16);
        return this._expandIfNotCollapsed();
      },
      onRemove: function() {
        this._map.off("zoomend", this._checkDisabledLayers, this);
        for (var i2 = 0; i2 < this._layers.length; i2++) {
          this._layers[i2].layer.off("add remove", this._onLayerChange, this);
        }
      },
      addBaseLayer: function(layer, name) {
        this._addLayer(layer, name);
        return this._map ? this._update() : this;
      },
      addOverlay: function(layer, name) {
        this._addLayer(layer, name, true);
        return this._map ? this._update() : this;
      },
      removeLayer: function(layer) {
        layer.off("add remove", this._onLayerChange, this);
        var obj = this._getLayer(stamp(layer));
        if (obj) {
          this._layers.splice(this._layers.indexOf(obj), 1);
        }
        return this._map ? this._update() : this;
      },
      expand: function() {
        addClass(this._container, "leaflet-control-layers-expanded");
        this._section.style.height = null;
        var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
        if (acceptableHeight < this._section.clientHeight) {
          addClass(this._section, "leaflet-control-layers-scrollbar");
          this._section.style.height = acceptableHeight + "px";
        } else {
          removeClass(this._section, "leaflet-control-layers-scrollbar");
        }
        this._checkDisabledLayers();
        return this;
      },
      collapse: function() {
        removeClass(this._container, "leaflet-control-layers-expanded");
        return this;
      },
      _initLayout: function() {
        var className = "leaflet-control-layers", container = this._container = create$1("div", className), collapsed = this.options.collapsed;
        container.setAttribute("aria-haspopup", true);
        disableClickPropagation(container);
        disableScrollPropagation(container);
        var section = this._section = create$1("section", className + "-list");
        if (collapsed) {
          this._map.on("click", this.collapse, this);
          if (!android) {
            on(container, {
              mouseenter: this.expand,
              mouseleave: this.collapse
            }, this);
          }
        }
        var link2 = this._layersLink = create$1("a", className + "-toggle", container);
        link2.href = "#";
        link2.title = "Layers";
        if (touch) {
          on(link2, "click", stop3);
          on(link2, "click", this.expand, this);
        } else {
          on(link2, "focus", this.expand, this);
        }
        if (!collapsed) {
          this.expand();
        }
        this._baseLayersList = create$1("div", className + "-base", section);
        this._separator = create$1("div", className + "-separator", section);
        this._overlaysList = create$1("div", className + "-overlays", section);
        container.appendChild(section);
      },
      _getLayer: function(id) {
        for (var i2 = 0; i2 < this._layers.length; i2++) {
          if (this._layers[i2] && stamp(this._layers[i2].layer) === id) {
            return this._layers[i2];
          }
        }
      },
      _addLayer: function(layer, name, overlay) {
        if (this._map) {
          layer.on("add remove", this._onLayerChange, this);
        }
        this._layers.push({
          layer,
          name,
          overlay
        });
        if (this.options.sortLayers) {
          this._layers.sort(bind2(function(a, b) {
            return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
          }, this));
        }
        if (this.options.autoZIndex && layer.setZIndex) {
          this._lastZIndex++;
          layer.setZIndex(this._lastZIndex);
        }
        this._expandIfNotCollapsed();
      },
      _update: function() {
        if (!this._container) {
          return this;
        }
        empty2(this._baseLayersList);
        empty2(this._overlaysList);
        this._layerControlInputs = [];
        var baseLayersPresent, overlaysPresent, i2, obj, baseLayersCount = 0;
        for (i2 = 0; i2 < this._layers.length; i2++) {
          obj = this._layers[i2];
          this._addItem(obj);
          overlaysPresent = overlaysPresent || obj.overlay;
          baseLayersPresent = baseLayersPresent || !obj.overlay;
          baseLayersCount += !obj.overlay ? 1 : 0;
        }
        if (this.options.hideSingleBase) {
          baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
          this._baseLayersList.style.display = baseLayersPresent ? "" : "none";
        }
        this._separator.style.display = overlaysPresent && baseLayersPresent ? "" : "none";
        return this;
      },
      _onLayerChange: function(e) {
        if (!this._handlingClick) {
          this._update();
        }
        var obj = this._getLayer(stamp(e.target));
        var type = obj.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
        if (type) {
          this._map.fire(type, obj);
        }
      },
      _createRadioElement: function(name, checked) {
        var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : "") + "/>";
        var radioFragment = document.createElement("div");
        radioFragment.innerHTML = radioHtml;
        return radioFragment.firstChild;
      },
      _addItem: function(obj) {
        var label = document.createElement("label"), checked = this._map.hasLayer(obj.layer), input;
        if (obj.overlay) {
          input = document.createElement("input");
          input.type = "checkbox";
          input.className = "leaflet-control-layers-selector";
          input.defaultChecked = checked;
        } else {
          input = this._createRadioElement("leaflet-base-layers_" + stamp(this), checked);
        }
        this._layerControlInputs.push(input);
        input.layerId = stamp(obj.layer);
        on(input, "click", this._onInputClick, this);
        var name = document.createElement("span");
        name.innerHTML = " " + obj.name;
        var holder = document.createElement("div");
        label.appendChild(holder);
        holder.appendChild(input);
        holder.appendChild(name);
        var container = obj.overlay ? this._overlaysList : this._baseLayersList;
        container.appendChild(label);
        this._checkDisabledLayers();
        return label;
      },
      _onInputClick: function() {
        var inputs = this._layerControlInputs, input, layer;
        var addedLayers = [], removedLayers = [];
        this._handlingClick = true;
        for (var i2 = inputs.length - 1; i2 >= 0; i2--) {
          input = inputs[i2];
          layer = this._getLayer(input.layerId).layer;
          if (input.checked) {
            addedLayers.push(layer);
          } else if (!input.checked) {
            removedLayers.push(layer);
          }
        }
        for (i2 = 0; i2 < removedLayers.length; i2++) {
          if (this._map.hasLayer(removedLayers[i2])) {
            this._map.removeLayer(removedLayers[i2]);
          }
        }
        for (i2 = 0; i2 < addedLayers.length; i2++) {
          if (!this._map.hasLayer(addedLayers[i2])) {
            this._map.addLayer(addedLayers[i2]);
          }
        }
        this._handlingClick = false;
        this._refocusOnMap();
      },
      _checkDisabledLayers: function() {
        var inputs = this._layerControlInputs, input, layer, zoom2 = this._map.getZoom();
        for (var i2 = inputs.length - 1; i2 >= 0; i2--) {
          input = inputs[i2];
          layer = this._getLayer(input.layerId).layer;
          input.disabled = layer.options.minZoom !== void 0 && zoom2 < layer.options.minZoom || layer.options.maxZoom !== void 0 && zoom2 > layer.options.maxZoom;
        }
      },
      _expandIfNotCollapsed: function() {
        if (this._map && !this.options.collapsed) {
          this.expand();
        }
        return this;
      },
      _expand: function() {
        return this.expand();
      },
      _collapse: function() {
        return this.collapse();
      }
    });
    var layers = function(baseLayers, overlays, options) {
      return new Layers(baseLayers, overlays, options);
    };
    var Zoom = Control.extend({
      options: {
        position: "topleft",
        zoomInText: "+",
        zoomInTitle: "Zoom in",
        zoomOutText: "&#x2212;",
        zoomOutTitle: "Zoom out"
      },
      onAdd: function(map16) {
        var zoomName = "leaflet-control-zoom", container = create$1("div", zoomName + " leaflet-bar"), options = this.options;
        this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + "-in", container, this._zoomIn);
        this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + "-out", container, this._zoomOut);
        this._updateDisabled();
        map16.on("zoomend zoomlevelschange", this._updateDisabled, this);
        return container;
      },
      onRemove: function(map16) {
        map16.off("zoomend zoomlevelschange", this._updateDisabled, this);
      },
      disable: function() {
        this._disabled = true;
        this._updateDisabled();
        return this;
      },
      enable: function() {
        this._disabled = false;
        this._updateDisabled();
        return this;
      },
      _zoomIn: function(e) {
        if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
          this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        }
      },
      _zoomOut: function(e) {
        if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
          this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        }
      },
      _createButton: function(html, title, className, container, fn) {
        var link2 = create$1("a", className, container);
        link2.innerHTML = html;
        link2.href = "#";
        link2.title = title;
        link2.setAttribute("role", "button");
        link2.setAttribute("aria-label", title);
        disableClickPropagation(link2);
        on(link2, "click", stop3);
        on(link2, "click", fn, this);
        on(link2, "click", this._refocusOnMap, this);
        return link2;
      },
      _updateDisabled: function() {
        var map16 = this._map, className = "leaflet-disabled";
        removeClass(this._zoomInButton, className);
        removeClass(this._zoomOutButton, className);
        if (this._disabled || map16._zoom === map16.getMinZoom()) {
          addClass(this._zoomOutButton, className);
        }
        if (this._disabled || map16._zoom === map16.getMaxZoom()) {
          addClass(this._zoomInButton, className);
        }
      }
    });
    Map2.mergeOptions({
      zoomControl: true
    });
    Map2.addInitHook(function() {
      if (this.options.zoomControl) {
        this.zoomControl = new Zoom();
        this.addControl(this.zoomControl);
      }
    });
    var zoom = function(options) {
      return new Zoom(options);
    };
    var Scale = Control.extend({
      options: {
        position: "bottomleft",
        maxWidth: 100,
        metric: true,
        imperial: true
      },
      onAdd: function(map16) {
        var className = "leaflet-control-scale", container = create$1("div", className), options = this.options;
        this._addScales(options, className + "-line", container);
        map16.on(options.updateWhenIdle ? "moveend" : "move", this._update, this);
        map16.whenReady(this._update, this);
        return container;
      },
      onRemove: function(map16) {
        map16.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
      },
      _addScales: function(options, className, container) {
        if (options.metric) {
          this._mScale = create$1("div", className, container);
        }
        if (options.imperial) {
          this._iScale = create$1("div", className, container);
        }
      },
      _update: function() {
        var map16 = this._map, y = map16.getSize().y / 2;
        var maxMeters = map16.distance(map16.containerPointToLatLng([0, y]), map16.containerPointToLatLng([this.options.maxWidth, y]));
        this._updateScales(maxMeters);
      },
      _updateScales: function(maxMeters) {
        if (this.options.metric && maxMeters) {
          this._updateMetric(maxMeters);
        }
        if (this.options.imperial && maxMeters) {
          this._updateImperial(maxMeters);
        }
      },
      _updateMetric: function(maxMeters) {
        var meters = this._getRoundNum(maxMeters), label = meters < 1e3 ? meters + " m" : meters / 1e3 + " km";
        this._updateScale(this._mScale, label, meters / maxMeters);
      },
      _updateImperial: function(maxMeters) {
        var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
        if (maxFeet > 5280) {
          maxMiles = maxFeet / 5280;
          miles = this._getRoundNum(maxMiles);
          this._updateScale(this._iScale, miles + " mi", miles / maxMiles);
        } else {
          feet = this._getRoundNum(maxFeet);
          this._updateScale(this._iScale, feet + " ft", feet / maxFeet);
        }
      },
      _updateScale: function(scale3, text2, ratio) {
        scale3.style.width = Math.round(this.options.maxWidth * ratio) + "px";
        scale3.innerHTML = text2;
      },
      _getRoundNum: function(num) {
        var pow10 = Math.pow(10, (Math.floor(num) + "").length - 1), d = num / pow10;
        d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
        return pow10 * d;
      }
    });
    var scale2 = function(options) {
      return new Scale(options);
    };
    var Attribution = Control.extend({
      options: {
        position: "bottomright",
        prefix: '<a href="https://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
      },
      initialize: function(options) {
        setOptions(this, options);
        this._attributions = {};
      },
      onAdd: function(map16) {
        map16.attributionControl = this;
        this._container = create$1("div", "leaflet-control-attribution");
        disableClickPropagation(this._container);
        for (var i2 in map16._layers) {
          if (map16._layers[i2].getAttribution) {
            this.addAttribution(map16._layers[i2].getAttribution());
          }
        }
        this._update();
        return this._container;
      },
      setPrefix: function(prefix2) {
        this.options.prefix = prefix2;
        this._update();
        return this;
      },
      addAttribution: function(text2) {
        if (!text2) {
          return this;
        }
        if (!this._attributions[text2]) {
          this._attributions[text2] = 0;
        }
        this._attributions[text2]++;
        this._update();
        return this;
      },
      removeAttribution: function(text2) {
        if (!text2) {
          return this;
        }
        if (this._attributions[text2]) {
          this._attributions[text2]--;
          this._update();
        }
        return this;
      },
      _update: function() {
        if (!this._map) {
          return;
        }
        var attribs = [];
        for (var i2 in this._attributions) {
          if (this._attributions[i2]) {
            attribs.push(i2);
          }
        }
        var prefixAndAttribs = [];
        if (this.options.prefix) {
          prefixAndAttribs.push(this.options.prefix);
        }
        if (attribs.length) {
          prefixAndAttribs.push(attribs.join(", "));
        }
        this._container.innerHTML = prefixAndAttribs.join(" | ");
      }
    });
    Map2.mergeOptions({
      attributionControl: true
    });
    Map2.addInitHook(function() {
      if (this.options.attributionControl) {
        new Attribution().addTo(this);
      }
    });
    var attribution = function(options) {
      return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale2;
    control.attribution = attribution;
    var Handler = Class.extend({
      initialize: function(map16) {
        this._map = map16;
      },
      enable: function() {
        if (this._enabled) {
          return this;
        }
        this._enabled = true;
        this.addHooks();
        return this;
      },
      disable: function() {
        if (!this._enabled) {
          return this;
        }
        this._enabled = false;
        this.removeHooks();
        return this;
      },
      enabled: function() {
        return !!this._enabled;
      }
    });
    Handler.addTo = function(map16, name) {
      map16.addHandler(name, this);
      return this;
    };
    var Mixin = { Events };
    var START = touch ? "touchstart mousedown" : "mousedown";
    var END = {
      mousedown: "mouseup",
      touchstart: "touchend",
      pointerdown: "touchend",
      MSPointerDown: "touchend"
    };
    var MOVE = {
      mousedown: "mousemove",
      touchstart: "touchmove",
      pointerdown: "touchmove",
      MSPointerDown: "touchmove"
    };
    var Draggable = Evented.extend({
      options: {
        clickTolerance: 3
      },
      initialize: function(element, dragStartTarget, preventOutline$$1, options) {
        setOptions(this, options);
        this._element = element;
        this._dragStartTarget = dragStartTarget || element;
        this._preventOutline = preventOutline$$1;
      },
      enable: function() {
        if (this._enabled) {
          return;
        }
        on(this._dragStartTarget, START, this._onDown, this);
        this._enabled = true;
      },
      disable: function() {
        if (!this._enabled) {
          return;
        }
        if (Draggable._dragging === this) {
          this.finishDrag();
        }
        off(this._dragStartTarget, START, this._onDown, this);
        this._enabled = false;
        this._moved = false;
      },
      _onDown: function(e) {
        if (e._simulated || !this._enabled) {
          return;
        }
        this._moved = false;
        if (hasClass(this._element, "leaflet-zoom-anim")) {
          return;
        }
        if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) {
          return;
        }
        Draggable._dragging = this;
        if (this._preventOutline) {
          preventOutline(this._element);
        }
        disableImageDrag();
        disableTextSelection();
        if (this._moving) {
          return;
        }
        this.fire("down");
        var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
        this._startPoint = new Point(first.clientX, first.clientY);
        this._parentScale = getScale(sizedParent);
        on(document, MOVE[e.type], this._onMove, this);
        on(document, END[e.type], this._onUp, this);
      },
      _onMove: function(e) {
        if (e._simulated || !this._enabled) {
          return;
        }
        if (e.touches && e.touches.length > 1) {
          this._moved = true;
          return;
        }
        var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset3 = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
        if (!offset3.x && !offset3.y) {
          return;
        }
        if (Math.abs(offset3.x) + Math.abs(offset3.y) < this.options.clickTolerance) {
          return;
        }
        offset3.x /= this._parentScale.x;
        offset3.y /= this._parentScale.y;
        preventDefault(e);
        if (!this._moved) {
          this.fire("dragstart");
          this._moved = true;
          this._startPos = getPosition(this._element).subtract(offset3);
          addClass(document.body, "leaflet-dragging");
          this._lastTarget = e.target || e.srcElement;
          if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) {
            this._lastTarget = this._lastTarget.correspondingUseElement;
          }
          addClass(this._lastTarget, "leaflet-drag-target");
        }
        this._newPos = this._startPos.add(offset3);
        this._moving = true;
        cancelAnimFrame(this._animRequest);
        this._lastEvent = e;
        this._animRequest = requestAnimFrame(this._updatePosition, this, true);
      },
      _updatePosition: function() {
        var e = { originalEvent: this._lastEvent };
        this.fire("predrag", e);
        setPosition(this._element, this._newPos);
        this.fire("drag", e);
      },
      _onUp: function(e) {
        if (e._simulated || !this._enabled) {
          return;
        }
        this.finishDrag();
      },
      finishDrag: function() {
        removeClass(document.body, "leaflet-dragging");
        if (this._lastTarget) {
          removeClass(this._lastTarget, "leaflet-drag-target");
          this._lastTarget = null;
        }
        for (var i2 in MOVE) {
          off(document, MOVE[i2], this._onMove, this);
          off(document, END[i2], this._onUp, this);
        }
        enableImageDrag();
        enableTextSelection();
        if (this._moved && this._moving) {
          cancelAnimFrame(this._animRequest);
          this.fire("dragend", {
            distance: this._newPos.distanceTo(this._startPos)
          });
        }
        this._moving = false;
        Draggable._dragging = false;
      }
    });
    function simplify2(points, tolerance) {
      if (!tolerance || !points.length) {
        return points.slice();
      }
      var sqTolerance = tolerance * tolerance;
      points = _reducePoints(points, sqTolerance);
      points = _simplifyDP(points, sqTolerance);
      return points;
    }
    function pointToSegmentDistance(p, p1, p2) {
      return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    function closestPointOnSegment(p, p1, p2) {
      return _sqClosestPointOnSegment(p, p1, p2);
    }
    function _simplifyDP(points, sqTolerance) {
      var len = points.length, ArrayConstructor = typeof Uint8Array !== void 0 + "" ? Uint8Array : Array, markers = new ArrayConstructor(len);
      markers[0] = markers[len - 1] = 1;
      _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
      var i2, newPoints = [];
      for (i2 = 0; i2 < len; i2++) {
        if (markers[i2]) {
          newPoints.push(points[i2]);
        }
      }
      return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
      var maxSqDist = 0, index4, i2, sqDist;
      for (i2 = first + 1; i2 <= last - 1; i2++) {
        sqDist = _sqClosestPointOnSegment(points[i2], points[first], points[last], true);
        if (sqDist > maxSqDist) {
          index4 = i2;
          maxSqDist = sqDist;
        }
      }
      if (maxSqDist > sqTolerance) {
        markers[index4] = 1;
        _simplifyDPStep(points, markers, sqTolerance, first, index4);
        _simplifyDPStep(points, markers, sqTolerance, index4, last);
      }
    }
    function _reducePoints(points, sqTolerance) {
      var reducedPoints = [points[0]];
      for (var i2 = 1, prev = 0, len = points.length; i2 < len; i2++) {
        if (_sqDist(points[i2], points[prev]) > sqTolerance) {
          reducedPoints.push(points[i2]);
          prev = i2;
        }
      }
      if (prev < len - 1) {
        reducedPoints.push(points[len - 1]);
      }
      return reducedPoints;
    }
    var _lastCode;
    function clipSegment(a, b, bounds, useLastCode, round2) {
      var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
      _lastCode = codeB;
      while (true) {
        if (!(codeA | codeB)) {
          return [a, b];
        }
        if (codeA & codeB) {
          return false;
        }
        codeOut = codeA || codeB;
        p = _getEdgeIntersection(a, b, codeOut, bounds, round2);
        newCode = _getBitCode(p, bounds);
        if (codeOut === codeA) {
          a = p;
          codeA = newCode;
        } else {
          b = p;
          codeB = newCode;
        }
      }
    }
    function _getEdgeIntersection(a, b, code, bounds, round2) {
      var dx = b.x - a.x, dy = b.y - a.y, min3 = bounds.min, max3 = bounds.max, x2, y;
      if (code & 8) {
        x2 = a.x + dx * (max3.y - a.y) / dy;
        y = max3.y;
      } else if (code & 4) {
        x2 = a.x + dx * (min3.y - a.y) / dy;
        y = min3.y;
      } else if (code & 2) {
        x2 = max3.x;
        y = a.y + dy * (max3.x - a.x) / dx;
      } else if (code & 1) {
        x2 = min3.x;
        y = a.y + dy * (min3.x - a.x) / dx;
      }
      return new Point(x2, y, round2);
    }
    function _getBitCode(p, bounds) {
      var code = 0;
      if (p.x < bounds.min.x) {
        code |= 1;
      } else if (p.x > bounds.max.x) {
        code |= 2;
      }
      if (p.y < bounds.min.y) {
        code |= 4;
      } else if (p.y > bounds.max.y) {
        code |= 8;
      }
      return code;
    }
    function _sqDist(p1, p2) {
      var dx = p2.x - p1.x, dy = p2.y - p1.y;
      return dx * dx + dy * dy;
    }
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
      var x2 = p1.x, y = p1.y, dx = p2.x - x2, dy = p2.y - y, dot = dx * dx + dy * dy, t;
      if (dot > 0) {
        t = ((p.x - x2) * dx + (p.y - y) * dy) / dot;
        if (t > 1) {
          x2 = p2.x;
          y = p2.y;
        } else if (t > 0) {
          x2 += dx * t;
          y += dy * t;
        }
      }
      dx = p.x - x2;
      dy = p.y - y;
      return sqDist ? dx * dx + dy * dy : new Point(x2, y);
    }
    function isFlat(latlngs) {
      return !isArray2(latlngs[0]) || typeof latlngs[0][0] !== "object" && typeof latlngs[0][0] !== "undefined";
    }
    function _flat(latlngs) {
      console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead.");
      return isFlat(latlngs);
    }
    var LineUtil = {
      simplify: simplify2,
      pointToSegmentDistance,
      closestPointOnSegment,
      clipSegment,
      _getEdgeIntersection,
      _getBitCode,
      _sqClosestPointOnSegment,
      isFlat,
      _flat
    };
    function clipPolygon(points, bounds, round2) {
      var clippedPoints, edges = [1, 4, 2, 8], i2, j, k, a, b, len, edge3, p;
      for (i2 = 0, len = points.length; i2 < len; i2++) {
        points[i2]._code = _getBitCode(points[i2], bounds);
      }
      for (k = 0; k < 4; k++) {
        edge3 = edges[k];
        clippedPoints = [];
        for (i2 = 0, len = points.length, j = len - 1; i2 < len; j = i2++) {
          a = points[i2];
          b = points[j];
          if (!(a._code & edge3)) {
            if (b._code & edge3) {
              p = _getEdgeIntersection(b, a, edge3, bounds, round2);
              p._code = _getBitCode(p, bounds);
              clippedPoints.push(p);
            }
            clippedPoints.push(a);
          } else if (!(b._code & edge3)) {
            p = _getEdgeIntersection(b, a, edge3, bounds, round2);
            p._code = _getBitCode(p, bounds);
            clippedPoints.push(p);
          }
        }
        points = clippedPoints;
      }
      return points;
    }
    var PolyUtil = {
      clipPolygon
    };
    var LonLat = {
      project: function(latlng) {
        return new Point(latlng.lng, latlng.lat);
      },
      unproject: function(point) {
        return new LatLng(point.y, point.x);
      },
      bounds: new Bounds([-180, -90], [180, 90])
    };
    var Mercator = {
      R: 6378137,
      R_MINOR: 6356752314245179e-9,
      bounds: new Bounds([-2003750834279e-5, -1549657073972e-5], [2003750834279e-5, 1876465623138e-5]),
      project: function(latlng) {
        var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
        var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
        y = -r * Math.log(Math.max(ts, 1e-10));
        return new Point(latlng.lng * d * r, y);
      },
      unproject: function(point) {
        var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
        for (var i2 = 0, dphi = 0.1, con; i2 < 15 && Math.abs(dphi) > 1e-7; i2++) {
          con = e * Math.sin(phi);
          con = Math.pow((1 - con) / (1 + con), e / 2);
          dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
          phi += dphi;
        }
        return new LatLng(phi * d, point.x * d / r);
      }
    };
    var index3 = {
      LonLat,
      Mercator,
      SphericalMercator
    };
    var EPSG3395 = extend2({}, Earth, {
      code: "EPSG:3395",
      projection: Mercator,
      transformation: function() {
        var scale3 = 0.5 / (Math.PI * Mercator.R);
        return toTransformation(scale3, 0.5, -scale3, 0.5);
      }()
    });
    var EPSG4326 = extend2({}, Earth, {
      code: "EPSG:4326",
      projection: LonLat,
      transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    var Simple = extend2({}, CRS, {
      projection: LonLat,
      transformation: toTransformation(1, 0, -1, 0),
      scale: function(zoom2) {
        return Math.pow(2, zoom2);
      },
      zoom: function(scale3) {
        return Math.log(scale3) / Math.LN2;
      },
      distance: function(latlng1, latlng2) {
        var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
        return Math.sqrt(dx * dx + dy * dy);
      },
      infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    var Layer = Evented.extend({
      options: {
        pane: "overlayPane",
        attribution: null,
        bubblingMouseEvents: true
      },
      addTo: function(map16) {
        map16.addLayer(this);
        return this;
      },
      remove: function() {
        return this.removeFrom(this._map || this._mapToAdd);
      },
      removeFrom: function(obj) {
        if (obj) {
          obj.removeLayer(this);
        }
        return this;
      },
      getPane: function(name) {
        return this._map.getPane(name ? this.options[name] || name : this.options.pane);
      },
      addInteractiveTarget: function(targetEl) {
        this._map._targets[stamp(targetEl)] = this;
        return this;
      },
      removeInteractiveTarget: function(targetEl) {
        delete this._map._targets[stamp(targetEl)];
        return this;
      },
      getAttribution: function() {
        return this.options.attribution;
      },
      _layerAdd: function(e) {
        var map16 = e.target;
        if (!map16.hasLayer(this)) {
          return;
        }
        this._map = map16;
        this._zoomAnimated = map16._zoomAnimated;
        if (this.getEvents) {
          var events2 = this.getEvents();
          map16.on(events2, this);
          this.once("remove", function() {
            map16.off(events2, this);
          }, this);
        }
        this.onAdd(map16);
        if (this.getAttribution && map16.attributionControl) {
          map16.attributionControl.addAttribution(this.getAttribution());
        }
        this.fire("add");
        map16.fire("layeradd", { layer: this });
      }
    });
    Map2.include({
      addLayer: function(layer) {
        if (!layer._layerAdd) {
          throw new Error("The provided object is not a Layer.");
        }
        var id = stamp(layer);
        if (this._layers[id]) {
          return this;
        }
        this._layers[id] = layer;
        layer._mapToAdd = this;
        if (layer.beforeAdd) {
          layer.beforeAdd(this);
        }
        this.whenReady(layer._layerAdd, layer);
        return this;
      },
      removeLayer: function(layer) {
        var id = stamp(layer);
        if (!this._layers[id]) {
          return this;
        }
        if (this._loaded) {
          layer.onRemove(this);
        }
        if (layer.getAttribution && this.attributionControl) {
          this.attributionControl.removeAttribution(layer.getAttribution());
        }
        delete this._layers[id];
        if (this._loaded) {
          this.fire("layerremove", { layer });
          layer.fire("remove");
        }
        layer._map = layer._mapToAdd = null;
        return this;
      },
      hasLayer: function(layer) {
        return !!layer && stamp(layer) in this._layers;
      },
      eachLayer: function(method, context) {
        for (var i2 in this._layers) {
          method.call(context, this._layers[i2]);
        }
        return this;
      },
      _addLayers: function(layers2) {
        layers2 = layers2 ? isArray2(layers2) ? layers2 : [layers2] : [];
        for (var i2 = 0, len = layers2.length; i2 < len; i2++) {
          this.addLayer(layers2[i2]);
        }
      },
      _addZoomLimit: function(layer) {
        if (isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
          this._zoomBoundLayers[stamp(layer)] = layer;
          this._updateZoomLevels();
        }
      },
      _removeZoomLimit: function(layer) {
        var id = stamp(layer);
        if (this._zoomBoundLayers[id]) {
          delete this._zoomBoundLayers[id];
          this._updateZoomLevels();
        }
      },
      _updateZoomLevels: function() {
        var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
        for (var i2 in this._zoomBoundLayers) {
          var options = this._zoomBoundLayers[i2].options;
          minZoom = options.minZoom === void 0 ? minZoom : Math.min(minZoom, options.minZoom);
          maxZoom = options.maxZoom === void 0 ? maxZoom : Math.max(maxZoom, options.maxZoom);
        }
        this._layersMaxZoom = maxZoom === -Infinity ? void 0 : maxZoom;
        this._layersMinZoom = minZoom === Infinity ? void 0 : minZoom;
        if (oldZoomSpan !== this._getZoomSpan()) {
          this.fire("zoomlevelschange");
        }
        if (this.options.maxZoom === void 0 && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
          this.setZoom(this._layersMaxZoom);
        }
        if (this.options.minZoom === void 0 && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
          this.setZoom(this._layersMinZoom);
        }
      }
    });
    var LayerGroup = Layer.extend({
      initialize: function(layers2, options) {
        setOptions(this, options);
        this._layers = {};
        var i2, len;
        if (layers2) {
          for (i2 = 0, len = layers2.length; i2 < len; i2++) {
            this.addLayer(layers2[i2]);
          }
        }
      },
      addLayer: function(layer) {
        var id = this.getLayerId(layer);
        this._layers[id] = layer;
        if (this._map) {
          this._map.addLayer(layer);
        }
        return this;
      },
      removeLayer: function(layer) {
        var id = layer in this._layers ? layer : this.getLayerId(layer);
        if (this._map && this._layers[id]) {
          this._map.removeLayer(this._layers[id]);
        }
        delete this._layers[id];
        return this;
      },
      hasLayer: function(layer) {
        if (!layer) {
          return false;
        }
        var layerId = typeof layer === "number" ? layer : this.getLayerId(layer);
        return layerId in this._layers;
      },
      clearLayers: function() {
        return this.eachLayer(this.removeLayer, this);
      },
      invoke: function(methodName) {
        var args = Array.prototype.slice.call(arguments, 1), i2, layer;
        for (i2 in this._layers) {
          layer = this._layers[i2];
          if (layer[methodName]) {
            layer[methodName].apply(layer, args);
          }
        }
        return this;
      },
      onAdd: function(map16) {
        this.eachLayer(map16.addLayer, map16);
      },
      onRemove: function(map16) {
        this.eachLayer(map16.removeLayer, map16);
      },
      eachLayer: function(method, context) {
        for (var i2 in this._layers) {
          method.call(context, this._layers[i2]);
        }
        return this;
      },
      getLayer: function(id) {
        return this._layers[id];
      },
      getLayers: function() {
        var layers2 = [];
        this.eachLayer(layers2.push, layers2);
        return layers2;
      },
      setZIndex: function(zIndex) {
        return this.invoke("setZIndex", zIndex);
      },
      getLayerId: function(layer) {
        return stamp(layer);
      }
    });
    var layerGroup = function(layers2, options) {
      return new LayerGroup(layers2, options);
    };
    var FeatureGroup = LayerGroup.extend({
      addLayer: function(layer) {
        if (this.hasLayer(layer)) {
          return this;
        }
        layer.addEventParent(this);
        LayerGroup.prototype.addLayer.call(this, layer);
        return this.fire("layeradd", { layer });
      },
      removeLayer: function(layer) {
        if (!this.hasLayer(layer)) {
          return this;
        }
        if (layer in this._layers) {
          layer = this._layers[layer];
        }
        layer.removeEventParent(this);
        LayerGroup.prototype.removeLayer.call(this, layer);
        return this.fire("layerremove", { layer });
      },
      setStyle: function(style) {
        return this.invoke("setStyle", style);
      },
      bringToFront: function() {
        return this.invoke("bringToFront");
      },
      bringToBack: function() {
        return this.invoke("bringToBack");
      },
      getBounds: function() {
        var bounds = new LatLngBounds();
        for (var id in this._layers) {
          var layer = this._layers[id];
          bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
        }
        return bounds;
      }
    });
    var featureGroup = function(layers2, options) {
      return new FeatureGroup(layers2, options);
    };
    var Icon = Class.extend({
      options: {
        popupAnchor: [0, 0],
        tooltipAnchor: [0, 0]
      },
      initialize: function(options) {
        setOptions(this, options);
      },
      createIcon: function(oldIcon) {
        return this._createIcon("icon", oldIcon);
      },
      createShadow: function(oldIcon) {
        return this._createIcon("shadow", oldIcon);
      },
      _createIcon: function(name, oldIcon) {
        var src = this._getIconUrl(name);
        if (!src) {
          if (name === "icon") {
            throw new Error("iconUrl not set in Icon options (see the docs).");
          }
          return null;
        }
        var img = this._createImg(src, oldIcon && oldIcon.tagName === "IMG" ? oldIcon : null);
        this._setIconStyles(img, name);
        return img;
      },
      _setIconStyles: function(img, name) {
        var options = this.options;
        var sizeOption = options[name + "Size"];
        if (typeof sizeOption === "number") {
          sizeOption = [sizeOption, sizeOption];
        }
        var size = toPoint(sizeOption), anchor = toPoint(name === "shadow" && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
        img.className = "leaflet-marker-" + name + " " + (options.className || "");
        if (anchor) {
          img.style.marginLeft = -anchor.x + "px";
          img.style.marginTop = -anchor.y + "px";
        }
        if (size) {
          img.style.width = size.x + "px";
          img.style.height = size.y + "px";
        }
      },
      _createImg: function(src, el) {
        el = el || document.createElement("img");
        el.src = src;
        return el;
      },
      _getIconUrl: function(name) {
        return retina && this.options[name + "RetinaUrl"] || this.options[name + "Url"];
      }
    });
    function icon(options) {
      return new Icon(options);
    }
    var IconDefault = Icon.extend({
      options: {
        iconUrl: "marker-icon.png",
        iconRetinaUrl: "marker-icon-2x.png",
        shadowUrl: "marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41]
      },
      _getIconUrl: function(name) {
        if (!IconDefault.imagePath) {
          IconDefault.imagePath = this._detectIconPath();
        }
        return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
      },
      _detectIconPath: function() {
        var el = create$1("div", "leaflet-default-icon-path", document.body);
        var path = getStyle(el, "background-image") || getStyle(el, "backgroundImage");
        document.body.removeChild(el);
        if (path === null || path.indexOf("url") !== 0) {
          path = "";
        } else {
          path = path.replace(/^url\(["']?/, "").replace(/marker-icon\.png["']?\)$/, "");
        }
        return path;
      }
    });
    var MarkerDrag = Handler.extend({
      initialize: function(marker2) {
        this._marker = marker2;
      },
      addHooks: function() {
        var icon2 = this._marker._icon;
        if (!this._draggable) {
          this._draggable = new Draggable(icon2, icon2, true);
        }
        this._draggable.on({
          dragstart: this._onDragStart,
          predrag: this._onPreDrag,
          drag: this._onDrag,
          dragend: this._onDragEnd
        }, this).enable();
        addClass(icon2, "leaflet-marker-draggable");
      },
      removeHooks: function() {
        this._draggable.off({
          dragstart: this._onDragStart,
          predrag: this._onPreDrag,
          drag: this._onDrag,
          dragend: this._onDragEnd
        }, this).disable();
        if (this._marker._icon) {
          removeClass(this._marker._icon, "leaflet-marker-draggable");
        }
      },
      moved: function() {
        return this._draggable && this._draggable._moved;
      },
      _adjustPan: function(e) {
        var marker2 = this._marker, map16 = marker2._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker2._icon), bounds = map16.getPixelBounds(), origin = map16.getPixelOrigin();
        var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
        if (!panBounds.contains(iconPos)) {
          var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
          map16.panBy(movement, { animate: false });
          this._draggable._newPos._add(movement);
          this._draggable._startPos._add(movement);
          setPosition(marker2._icon, this._draggable._newPos);
          this._onDrag(e);
          this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
        }
      },
      _onDragStart: function() {
        this._oldLatLng = this._marker.getLatLng();
        this._marker.closePopup && this._marker.closePopup();
        this._marker.fire("movestart").fire("dragstart");
      },
      _onPreDrag: function(e) {
        if (this._marker.options.autoPan) {
          cancelAnimFrame(this._panRequest);
          this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
        }
      },
      _onDrag: function(e) {
        var marker2 = this._marker, shadow = marker2._shadow, iconPos = getPosition(marker2._icon), latlng = marker2._map.layerPointToLatLng(iconPos);
        if (shadow) {
          setPosition(shadow, iconPos);
        }
        marker2._latlng = latlng;
        e.latlng = latlng;
        e.oldLatLng = this._oldLatLng;
        marker2.fire("move", e).fire("drag", e);
      },
      _onDragEnd: function(e) {
        cancelAnimFrame(this._panRequest);
        delete this._oldLatLng;
        this._marker.fire("moveend").fire("dragend", e);
      }
    });
    var Marker = Layer.extend({
      options: {
        icon: new IconDefault(),
        interactive: true,
        keyboard: true,
        title: "",
        alt: "",
        zIndexOffset: 0,
        opacity: 1,
        riseOnHover: false,
        riseOffset: 250,
        pane: "markerPane",
        shadowPane: "shadowPane",
        bubblingMouseEvents: false,
        draggable: false,
        autoPan: false,
        autoPanPadding: [50, 50],
        autoPanSpeed: 10
      },
      initialize: function(latlng, options) {
        setOptions(this, options);
        this._latlng = toLatLng(latlng);
      },
      onAdd: function(map16) {
        this._zoomAnimated = this._zoomAnimated && map16.options.markerZoomAnimation;
        if (this._zoomAnimated) {
          map16.on("zoomanim", this._animateZoom, this);
        }
        this._initIcon();
        this.update();
      },
      onRemove: function(map16) {
        if (this.dragging && this.dragging.enabled()) {
          this.options.draggable = true;
          this.dragging.removeHooks();
        }
        delete this.dragging;
        if (this._zoomAnimated) {
          map16.off("zoomanim", this._animateZoom, this);
        }
        this._removeIcon();
        this._removeShadow();
      },
      getEvents: function() {
        return {
          zoom: this.update,
          viewreset: this.update
        };
      },
      getLatLng: function() {
        return this._latlng;
      },
      setLatLng: function(latlng) {
        var oldLatLng = this._latlng;
        this._latlng = toLatLng(latlng);
        this.update();
        return this.fire("move", { oldLatLng, latlng: this._latlng });
      },
      setZIndexOffset: function(offset3) {
        this.options.zIndexOffset = offset3;
        return this.update();
      },
      getIcon: function() {
        return this.options.icon;
      },
      setIcon: function(icon2) {
        this.options.icon = icon2;
        if (this._map) {
          this._initIcon();
          this.update();
        }
        if (this._popup) {
          this.bindPopup(this._popup, this._popup.options);
        }
        return this;
      },
      getElement: function() {
        return this._icon;
      },
      update: function() {
        if (this._icon && this._map) {
          var pos = this._map.latLngToLayerPoint(this._latlng).round();
          this._setPos(pos);
        }
        return this;
      },
      _initIcon: function() {
        var options = this.options, classToAdd = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
        var icon2 = options.icon.createIcon(this._icon), addIcon = false;
        if (icon2 !== this._icon) {
          if (this._icon) {
            this._removeIcon();
          }
          addIcon = true;
          if (options.title) {
            icon2.title = options.title;
          }
          if (icon2.tagName === "IMG") {
            icon2.alt = options.alt || "";
          }
        }
        addClass(icon2, classToAdd);
        if (options.keyboard) {
          icon2.tabIndex = "0";
        }
        this._icon = icon2;
        if (options.riseOnHover) {
          this.on({
            mouseover: this._bringToFront,
            mouseout: this._resetZIndex
          });
        }
        var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
        if (newShadow !== this._shadow) {
          this._removeShadow();
          addShadow = true;
        }
        if (newShadow) {
          addClass(newShadow, classToAdd);
          newShadow.alt = "";
        }
        this._shadow = newShadow;
        if (options.opacity < 1) {
          this._updateOpacity();
        }
        if (addIcon) {
          this.getPane().appendChild(this._icon);
        }
        this._initInteraction();
        if (newShadow && addShadow) {
          this.getPane(options.shadowPane).appendChild(this._shadow);
        }
      },
      _removeIcon: function() {
        if (this.options.riseOnHover) {
          this.off({
            mouseover: this._bringToFront,
            mouseout: this._resetZIndex
          });
        }
        remove2(this._icon);
        this.removeInteractiveTarget(this._icon);
        this._icon = null;
      },
      _removeShadow: function() {
        if (this._shadow) {
          remove2(this._shadow);
        }
        this._shadow = null;
      },
      _setPos: function(pos) {
        if (this._icon) {
          setPosition(this._icon, pos);
        }
        if (this._shadow) {
          setPosition(this._shadow, pos);
        }
        this._zIndex = pos.y + this.options.zIndexOffset;
        this._resetZIndex();
      },
      _updateZIndex: function(offset3) {
        if (this._icon) {
          this._icon.style.zIndex = this._zIndex + offset3;
        }
      },
      _animateZoom: function(opt) {
        var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
        this._setPos(pos);
      },
      _initInteraction: function() {
        if (!this.options.interactive) {
          return;
        }
        addClass(this._icon, "leaflet-interactive");
        this.addInteractiveTarget(this._icon);
        if (MarkerDrag) {
          var draggable2 = this.options.draggable;
          if (this.dragging) {
            draggable2 = this.dragging.enabled();
            this.dragging.disable();
          }
          this.dragging = new MarkerDrag(this);
          if (draggable2) {
            this.dragging.enable();
          }
        }
      },
      setOpacity: function(opacity) {
        this.options.opacity = opacity;
        if (this._map) {
          this._updateOpacity();
        }
        return this;
      },
      _updateOpacity: function() {
        var opacity = this.options.opacity;
        if (this._icon) {
          setOpacity(this._icon, opacity);
        }
        if (this._shadow) {
          setOpacity(this._shadow, opacity);
        }
      },
      _bringToFront: function() {
        this._updateZIndex(this.options.riseOffset);
      },
      _resetZIndex: function() {
        this._updateZIndex(0);
      },
      _getPopupAnchor: function() {
        return this.options.icon.options.popupAnchor;
      },
      _getTooltipAnchor: function() {
        return this.options.icon.options.tooltipAnchor;
      }
    });
    function marker(latlng, options) {
      return new Marker(latlng, options);
    }
    var Path = Layer.extend({
      options: {
        stroke: true,
        color: "#3388ff",
        weight: 3,
        opacity: 1,
        lineCap: "round",
        lineJoin: "round",
        dashArray: null,
        dashOffset: null,
        fill: false,
        fillColor: null,
        fillOpacity: 0.2,
        fillRule: "evenodd",
        interactive: true,
        bubblingMouseEvents: true
      },
      beforeAdd: function(map16) {
        this._renderer = map16.getRenderer(this);
      },
      onAdd: function() {
        this._renderer._initPath(this);
        this._reset();
        this._renderer._addPath(this);
      },
      onRemove: function() {
        this._renderer._removePath(this);
      },
      redraw: function() {
        if (this._map) {
          this._renderer._updatePath(this);
        }
        return this;
      },
      setStyle: function(style) {
        setOptions(this, style);
        if (this._renderer) {
          this._renderer._updateStyle(this);
          if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, "weight")) {
            this._updateBounds();
          }
        }
        return this;
      },
      bringToFront: function() {
        if (this._renderer) {
          this._renderer._bringToFront(this);
        }
        return this;
      },
      bringToBack: function() {
        if (this._renderer) {
          this._renderer._bringToBack(this);
        }
        return this;
      },
      getElement: function() {
        return this._path;
      },
      _reset: function() {
        this._project();
        this._update();
      },
      _clickTolerance: function() {
        return (this.options.stroke ? this.options.weight / 2 : 0) + this._renderer.options.tolerance;
      }
    });
    var CircleMarker = Path.extend({
      options: {
        fill: true,
        radius: 10
      },
      initialize: function(latlng, options) {
        setOptions(this, options);
        this._latlng = toLatLng(latlng);
        this._radius = this.options.radius;
      },
      setLatLng: function(latlng) {
        var oldLatLng = this._latlng;
        this._latlng = toLatLng(latlng);
        this.redraw();
        return this.fire("move", { oldLatLng, latlng: this._latlng });
      },
      getLatLng: function() {
        return this._latlng;
      },
      setRadius: function(radius) {
        this.options.radius = this._radius = radius;
        return this.redraw();
      },
      getRadius: function() {
        return this._radius;
      },
      setStyle: function(options) {
        var radius = options && options.radius || this._radius;
        Path.prototype.setStyle.call(this, options);
        this.setRadius(radius);
        return this;
      },
      _project: function() {
        this._point = this._map.latLngToLayerPoint(this._latlng);
        this._updateBounds();
      },
      _updateBounds: function() {
        var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [r + w, r2 + w];
        this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
      },
      _update: function() {
        if (this._map) {
          this._updatePath();
        }
      },
      _updatePath: function() {
        this._renderer._updateCircle(this);
      },
      _empty: function() {
        return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
      },
      _containsPoint: function(p) {
        return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
      }
    });
    function circleMarker(latlng, options) {
      return new CircleMarker(latlng, options);
    }
    var Circle = CircleMarker.extend({
      initialize: function(latlng, options, legacyOptions) {
        if (typeof options === "number") {
          options = extend2({}, legacyOptions, { radius: options });
        }
        setOptions(this, options);
        this._latlng = toLatLng(latlng);
        if (isNaN(this.options.radius)) {
          throw new Error("Circle radius cannot be NaN");
        }
        this._mRadius = this.options.radius;
      },
      setRadius: function(radius) {
        this._mRadius = radius;
        return this.redraw();
      },
      getRadius: function() {
        return this._mRadius;
      },
      getBounds: function() {
        var half = [this._radius, this._radiusY || this._radius];
        return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
      },
      setStyle: Path.prototype.setStyle,
      _project: function() {
        var lng = this._latlng.lng, lat = this._latlng.lat, map16 = this._map, crs = map16.options.crs;
        if (crs.distance === Earth.distance) {
          var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map16.project([lat + latR, lng]), bottom = map16.project([lat - latR, lng]), p = top.add(bottom).divideBy(2), lat2 = map16.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
          if (isNaN(lngR) || lngR === 0) {
            lngR = latR / Math.cos(Math.PI / 180 * lat);
          }
          this._point = p.subtract(map16.getPixelOrigin());
          this._radius = isNaN(lngR) ? 0 : p.x - map16.project([lat2, lng - lngR]).x;
          this._radiusY = p.y - top.y;
        } else {
          var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));
          this._point = map16.latLngToLayerPoint(this._latlng);
          this._radius = this._point.x - map16.latLngToLayerPoint(latlng2).x;
        }
        this._updateBounds();
      }
    });
    function circle(latlng, options, legacyOptions) {
      return new Circle(latlng, options, legacyOptions);
    }
    var Polyline = Path.extend({
      options: {
        smoothFactor: 1,
        noClip: false
      },
      initialize: function(latlngs, options) {
        setOptions(this, options);
        this._setLatLngs(latlngs);
      },
      getLatLngs: function() {
        return this._latlngs;
      },
      setLatLngs: function(latlngs) {
        this._setLatLngs(latlngs);
        return this.redraw();
      },
      isEmpty: function() {
        return !this._latlngs.length;
      },
      closestLayerPoint: function(p) {
        var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
        for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
          var points = this._parts[j];
          for (var i2 = 1, len = points.length; i2 < len; i2++) {
            p1 = points[i2 - 1];
            p2 = points[i2];
            var sqDist = closest(p, p1, p2, true);
            if (sqDist < minDistance) {
              minDistance = sqDist;
              minPoint = closest(p, p1, p2);
            }
          }
        }
        if (minPoint) {
          minPoint.distance = Math.sqrt(minDistance);
        }
        return minPoint;
      },
      getCenter: function() {
        if (!this._map) {
          throw new Error("Must add layer to map before using getCenter()");
        }
        var i2, halfDist, segDist, dist, p1, p2, ratio, points = this._rings[0], len = points.length;
        if (!len) {
          return null;
        }
        for (i2 = 0, halfDist = 0; i2 < len - 1; i2++) {
          halfDist += points[i2].distanceTo(points[i2 + 1]) / 2;
        }
        if (halfDist === 0) {
          return this._map.layerPointToLatLng(points[0]);
        }
        for (i2 = 0, dist = 0; i2 < len - 1; i2++) {
          p1 = points[i2];
          p2 = points[i2 + 1];
          segDist = p1.distanceTo(p2);
          dist += segDist;
          if (dist > halfDist) {
            ratio = (dist - halfDist) / segDist;
            return this._map.layerPointToLatLng([
              p2.x - ratio * (p2.x - p1.x),
              p2.y - ratio * (p2.y - p1.y)
            ]);
          }
        }
      },
      getBounds: function() {
        return this._bounds;
      },
      addLatLng: function(latlng, latlngs) {
        latlngs = latlngs || this._defaultShape();
        latlng = toLatLng(latlng);
        latlngs.push(latlng);
        this._bounds.extend(latlng);
        return this.redraw();
      },
      _setLatLngs: function(latlngs) {
        this._bounds = new LatLngBounds();
        this._latlngs = this._convertLatLngs(latlngs);
      },
      _defaultShape: function() {
        return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
      },
      _convertLatLngs: function(latlngs) {
        var result2 = [], flat = isFlat(latlngs);
        for (var i2 = 0, len = latlngs.length; i2 < len; i2++) {
          if (flat) {
            result2[i2] = toLatLng(latlngs[i2]);
            this._bounds.extend(result2[i2]);
          } else {
            result2[i2] = this._convertLatLngs(latlngs[i2]);
          }
        }
        return result2;
      },
      _project: function() {
        var pxBounds = new Bounds();
        this._rings = [];
        this._projectLatlngs(this._latlngs, this._rings, pxBounds);
        if (this._bounds.isValid() && pxBounds.isValid()) {
          this._rawPxBounds = pxBounds;
          this._updateBounds();
        }
      },
      _updateBounds: function() {
        var w = this._clickTolerance(), p = new Point(w, w);
        this._pxBounds = new Bounds([
          this._rawPxBounds.min.subtract(p),
          this._rawPxBounds.max.add(p)
        ]);
      },
      _projectLatlngs: function(latlngs, result2, projectedBounds) {
        var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i2, ring;
        if (flat) {
          ring = [];
          for (i2 = 0; i2 < len; i2++) {
            ring[i2] = this._map.latLngToLayerPoint(latlngs[i2]);
            projectedBounds.extend(ring[i2]);
          }
          result2.push(ring);
        } else {
          for (i2 = 0; i2 < len; i2++) {
            this._projectLatlngs(latlngs[i2], result2, projectedBounds);
          }
        }
      },
      _clipPoints: function() {
        var bounds = this._renderer._bounds;
        this._parts = [];
        if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
          return;
        }
        if (this.options.noClip) {
          this._parts = this._rings;
          return;
        }
        var parts = this._parts, i2, j, k, len, len2, segment, points;
        for (i2 = 0, k = 0, len = this._rings.length; i2 < len; i2++) {
          points = this._rings[i2];
          for (j = 0, len2 = points.length; j < len2 - 1; j++) {
            segment = clipSegment(points[j], points[j + 1], bounds, j, true);
            if (!segment) {
              continue;
            }
            parts[k] = parts[k] || [];
            parts[k].push(segment[0]);
            if (segment[1] !== points[j + 1] || j === len2 - 2) {
              parts[k].push(segment[1]);
              k++;
            }
          }
        }
      },
      _simplifyPoints: function() {
        var parts = this._parts, tolerance = this.options.smoothFactor;
        for (var i2 = 0, len = parts.length; i2 < len; i2++) {
          parts[i2] = simplify2(parts[i2], tolerance);
        }
      },
      _update: function() {
        if (!this._map) {
          return;
        }
        this._clipPoints();
        this._simplifyPoints();
        this._updatePath();
      },
      _updatePath: function() {
        this._renderer._updatePoly(this);
      },
      _containsPoint: function(p, closed) {
        var i2, j, k, len, len2, part, w = this._clickTolerance();
        if (!this._pxBounds || !this._pxBounds.contains(p)) {
          return false;
        }
        for (i2 = 0, len = this._parts.length; i2 < len; i2++) {
          part = this._parts[i2];
          for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
            if (!closed && j === 0) {
              continue;
            }
            if (pointToSegmentDistance(p, part[k], part[j]) <= w) {
              return true;
            }
          }
        }
        return false;
      }
    });
    function polyline(latlngs, options) {
      return new Polyline(latlngs, options);
    }
    Polyline._flat = _flat;
    var Polygon = Polyline.extend({
      options: {
        fill: true
      },
      isEmpty: function() {
        return !this._latlngs.length || !this._latlngs[0].length;
      },
      getCenter: function() {
        if (!this._map) {
          throw new Error("Must add layer to map before using getCenter()");
        }
        var i2, j, p1, p2, f, area, x2, y, center, points = this._rings[0], len = points.length;
        if (!len) {
          return null;
        }
        area = x2 = y = 0;
        for (i2 = 0, j = len - 1; i2 < len; j = i2++) {
          p1 = points[i2];
          p2 = points[j];
          f = p1.y * p2.x - p2.y * p1.x;
          x2 += (p1.x + p2.x) * f;
          y += (p1.y + p2.y) * f;
          area += f * 3;
        }
        if (area === 0) {
          center = points[0];
        } else {
          center = [x2 / area, y / area];
        }
        return this._map.layerPointToLatLng(center);
      },
      _convertLatLngs: function(latlngs) {
        var result2 = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result2.length;
        if (len >= 2 && result2[0] instanceof LatLng && result2[0].equals(result2[len - 1])) {
          result2.pop();
        }
        return result2;
      },
      _setLatLngs: function(latlngs) {
        Polyline.prototype._setLatLngs.call(this, latlngs);
        if (isFlat(this._latlngs)) {
          this._latlngs = [this._latlngs];
        }
      },
      _defaultShape: function() {
        return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
      },
      _clipPoints: function() {
        var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
        bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
        this._parts = [];
        if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
          return;
        }
        if (this.options.noClip) {
          this._parts = this._rings;
          return;
        }
        for (var i2 = 0, len = this._rings.length, clipped; i2 < len; i2++) {
          clipped = clipPolygon(this._rings[i2], bounds, true);
          if (clipped.length) {
            this._parts.push(clipped);
          }
        }
      },
      _updatePath: function() {
        this._renderer._updatePoly(this, true);
      },
      _containsPoint: function(p) {
        var inside = false, part, p1, p2, i2, j, k, len, len2;
        if (!this._pxBounds || !this._pxBounds.contains(p)) {
          return false;
        }
        for (i2 = 0, len = this._parts.length; i2 < len; i2++) {
          part = this._parts[i2];
          for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
            p1 = part[j];
            p2 = part[k];
            if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) {
              inside = !inside;
            }
          }
        }
        return inside || Polyline.prototype._containsPoint.call(this, p, true);
      }
    });
    function polygon(latlngs, options) {
      return new Polygon(latlngs, options);
    }
    var GeoJSON = FeatureGroup.extend({
      initialize: function(geojson, options) {
        setOptions(this, options);
        this._layers = {};
        if (geojson) {
          this.addData(geojson);
        }
      },
      addData: function(geojson) {
        var features = isArray2(geojson) ? geojson : geojson.features, i2, len, feature2;
        if (features) {
          for (i2 = 0, len = features.length; i2 < len; i2++) {
            feature2 = features[i2];
            if (feature2.geometries || feature2.geometry || feature2.features || feature2.coordinates) {
              this.addData(feature2);
            }
          }
          return this;
        }
        var options = this.options;
        if (options.filter && !options.filter(geojson)) {
          return this;
        }
        var layer = geometryToLayer(geojson, options);
        if (!layer) {
          return this;
        }
        layer.feature = asFeature(geojson);
        layer.defaultOptions = layer.options;
        this.resetStyle(layer);
        if (options.onEachFeature) {
          options.onEachFeature(geojson, layer);
        }
        return this.addLayer(layer);
      },
      resetStyle: function(layer) {
        if (layer === void 0) {
          return this.eachLayer(this.resetStyle, this);
        }
        layer.options = extend2({}, layer.defaultOptions);
        this._setLayerStyle(layer, this.options.style);
        return this;
      },
      setStyle: function(style) {
        return this.eachLayer(function(layer) {
          this._setLayerStyle(layer, style);
        }, this);
      },
      _setLayerStyle: function(layer, style) {
        if (layer.setStyle) {
          if (typeof style === "function") {
            style = style(layer.feature);
          }
          layer.setStyle(style);
        }
      }
    });
    function geometryToLayer(geojson, options) {
      var geometry = geojson.type === "Feature" ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers2 = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i2, len;
      if (!coords && !geometry) {
        return null;
      }
      switch (geometry.type) {
        case "Point":
          latlng = _coordsToLatLng(coords);
          return _pointToLayer(pointToLayer, geojson, latlng, options);
        case "MultiPoint":
          for (i2 = 0, len = coords.length; i2 < len; i2++) {
            latlng = _coordsToLatLng(coords[i2]);
            layers2.push(_pointToLayer(pointToLayer, geojson, latlng, options));
          }
          return new FeatureGroup(layers2);
        case "LineString":
        case "MultiLineString":
          latlngs = coordsToLatLngs(coords, geometry.type === "LineString" ? 0 : 1, _coordsToLatLng);
          return new Polyline(latlngs, options);
        case "Polygon":
        case "MultiPolygon":
          latlngs = coordsToLatLngs(coords, geometry.type === "Polygon" ? 1 : 2, _coordsToLatLng);
          return new Polygon(latlngs, options);
        case "GeometryCollection":
          for (i2 = 0, len = geometry.geometries.length; i2 < len; i2++) {
            var layer = geometryToLayer({
              geometry: geometry.geometries[i2],
              type: "Feature",
              properties: geojson.properties
            }, options);
            if (layer) {
              layers2.push(layer);
            }
          }
          return new FeatureGroup(layers2);
        default:
          throw new Error("Invalid GeoJSON object.");
      }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
      return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    function coordsToLatLng(coords) {
      return new LatLng(coords[1], coords[0], coords[2]);
    }
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
      var latlngs = [];
      for (var i2 = 0, len = coords.length, latlng; i2 < len; i2++) {
        latlng = levelsDeep ? coordsToLatLngs(coords[i2], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i2]);
        latlngs.push(latlng);
      }
      return latlngs;
    }
    function latLngToCoords(latlng, precision) {
      precision = typeof precision === "number" ? precision : 6;
      return latlng.alt !== void 0 ? [formatNum(latlng.lng, precision), formatNum(latlng.lat, precision), formatNum(latlng.alt, precision)] : [formatNum(latlng.lng, precision), formatNum(latlng.lat, precision)];
    }
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
      var coords = [];
      for (var i2 = 0, len = latlngs.length; i2 < len; i2++) {
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i2], levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i2], precision));
      }
      if (!levelsDeep && closed) {
        coords.push(coords[0]);
      }
      return coords;
    }
    function getFeature(layer, newGeometry) {
      return layer.feature ? extend2({}, layer.feature, { geometry: newGeometry }) : asFeature(newGeometry);
    }
    function asFeature(geojson) {
      if (geojson.type === "Feature" || geojson.type === "FeatureCollection") {
        return geojson;
      }
      return {
        type: "Feature",
        properties: {},
        geometry: geojson
      };
    }
    var PointToGeoJSON = {
      toGeoJSON: function(precision) {
        return getFeature(this, {
          type: "Point",
          coordinates: latLngToCoords(this.getLatLng(), precision)
        });
      }
    };
    Marker.include(PointToGeoJSON);
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    Polyline.include({
      toGeoJSON: function(precision) {
        var multi = !isFlat(this._latlngs);
        var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
        return getFeature(this, {
          type: (multi ? "Multi" : "") + "LineString",
          coordinates: coords
        });
      }
    });
    Polygon.include({
      toGeoJSON: function(precision) {
        var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
        var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
        if (!holes) {
          coords = [coords];
        }
        return getFeature(this, {
          type: (multi ? "Multi" : "") + "Polygon",
          coordinates: coords
        });
      }
    });
    LayerGroup.include({
      toMultiPoint: function(precision) {
        var coords = [];
        this.eachLayer(function(layer) {
          coords.push(layer.toGeoJSON(precision).geometry.coordinates);
        });
        return getFeature(this, {
          type: "MultiPoint",
          coordinates: coords
        });
      },
      toGeoJSON: function(precision) {
        var type = this.feature && this.feature.geometry && this.feature.geometry.type;
        if (type === "MultiPoint") {
          return this.toMultiPoint(precision);
        }
        var isGeometryCollection = type === "GeometryCollection", jsons = [];
        this.eachLayer(function(layer) {
          if (layer.toGeoJSON) {
            var json = layer.toGeoJSON(precision);
            if (isGeometryCollection) {
              jsons.push(json.geometry);
            } else {
              var feature2 = asFeature(json);
              if (feature2.type === "FeatureCollection") {
                jsons.push.apply(jsons, feature2.features);
              } else {
                jsons.push(feature2);
              }
            }
          }
        });
        if (isGeometryCollection) {
          return getFeature(this, {
            geometries: jsons,
            type: "GeometryCollection"
          });
        }
        return {
          type: "FeatureCollection",
          features: jsons
        };
      }
    });
    function geoJSON(geojson, options) {
      return new GeoJSON(geojson, options);
    }
    var geoJson = geoJSON;
    var ImageOverlay = Layer.extend({
      options: {
        opacity: 1,
        alt: "",
        interactive: false,
        crossOrigin: false,
        errorOverlayUrl: "",
        zIndex: 1,
        className: ""
      },
      initialize: function(url3, bounds, options) {
        this._url = url3;
        this._bounds = toLatLngBounds(bounds);
        setOptions(this, options);
      },
      onAdd: function() {
        if (!this._image) {
          this._initImage();
          if (this.options.opacity < 1) {
            this._updateOpacity();
          }
        }
        if (this.options.interactive) {
          addClass(this._image, "leaflet-interactive");
          this.addInteractiveTarget(this._image);
        }
        this.getPane().appendChild(this._image);
        this._reset();
      },
      onRemove: function() {
        remove2(this._image);
        if (this.options.interactive) {
          this.removeInteractiveTarget(this._image);
        }
      },
      setOpacity: function(opacity) {
        this.options.opacity = opacity;
        if (this._image) {
          this._updateOpacity();
        }
        return this;
      },
      setStyle: function(styleOpts) {
        if (styleOpts.opacity) {
          this.setOpacity(styleOpts.opacity);
        }
        return this;
      },
      bringToFront: function() {
        if (this._map) {
          toFront(this._image);
        }
        return this;
      },
      bringToBack: function() {
        if (this._map) {
          toBack(this._image);
        }
        return this;
      },
      setUrl: function(url3) {
        this._url = url3;
        if (this._image) {
          this._image.src = url3;
        }
        return this;
      },
      setBounds: function(bounds) {
        this._bounds = toLatLngBounds(bounds);
        if (this._map) {
          this._reset();
        }
        return this;
      },
      getEvents: function() {
        var events2 = {
          zoom: this._reset,
          viewreset: this._reset
        };
        if (this._zoomAnimated) {
          events2.zoomanim = this._animateZoom;
        }
        return events2;
      },
      setZIndex: function(value) {
        this.options.zIndex = value;
        this._updateZIndex();
        return this;
      },
      getBounds: function() {
        return this._bounds;
      },
      getElement: function() {
        return this._image;
      },
      _initImage: function() {
        var wasElementSupplied = this._url.tagName === "IMG";
        var img = this._image = wasElementSupplied ? this._url : create$1("img");
        addClass(img, "leaflet-image-layer");
        if (this._zoomAnimated) {
          addClass(img, "leaflet-zoom-animated");
        }
        if (this.options.className) {
          addClass(img, this.options.className);
        }
        img.onselectstart = falseFn;
        img.onmousemove = falseFn;
        img.onload = bind2(this.fire, this, "load");
        img.onerror = bind2(this._overlayOnError, this, "error");
        if (this.options.crossOrigin || this.options.crossOrigin === "") {
          img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
        }
        if (this.options.zIndex) {
          this._updateZIndex();
        }
        if (wasElementSupplied) {
          this._url = img.src;
          return;
        }
        img.src = this._url;
        img.alt = this.options.alt;
      },
      _animateZoom: function(e) {
        var scale3 = this._map.getZoomScale(e.zoom), offset3 = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
        setTransform(this._image, offset3, scale3);
      },
      _reset: function() {
        var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
        setPosition(image, bounds.min);
        image.style.width = size.x + "px";
        image.style.height = size.y + "px";
      },
      _updateOpacity: function() {
        setOpacity(this._image, this.options.opacity);
      },
      _updateZIndex: function() {
        if (this._image && this.options.zIndex !== void 0 && this.options.zIndex !== null) {
          this._image.style.zIndex = this.options.zIndex;
        }
      },
      _overlayOnError: function() {
        this.fire("error");
        var errorUrl = this.options.errorOverlayUrl;
        if (errorUrl && this._url !== errorUrl) {
          this._url = errorUrl;
          this._image.src = errorUrl;
        }
      }
    });
    var imageOverlay = function(url3, bounds, options) {
      return new ImageOverlay(url3, bounds, options);
    };
    var VideoOverlay = ImageOverlay.extend({
      options: {
        autoplay: true,
        loop: true,
        keepAspectRatio: true,
        muted: false
      },
      _initImage: function() {
        var wasElementSupplied = this._url.tagName === "VIDEO";
        var vid = this._image = wasElementSupplied ? this._url : create$1("video");
        addClass(vid, "leaflet-image-layer");
        if (this._zoomAnimated) {
          addClass(vid, "leaflet-zoom-animated");
        }
        if (this.options.className) {
          addClass(vid, this.options.className);
        }
        vid.onselectstart = falseFn;
        vid.onmousemove = falseFn;
        vid.onloadeddata = bind2(this.fire, this, "load");
        if (wasElementSupplied) {
          var sourceElements = vid.getElementsByTagName("source");
          var sources = [];
          for (var j = 0; j < sourceElements.length; j++) {
            sources.push(sourceElements[j].src);
          }
          this._url = sourceElements.length > 0 ? sources : [vid.src];
          return;
        }
        if (!isArray2(this._url)) {
          this._url = [this._url];
        }
        if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, "objectFit")) {
          vid.style["objectFit"] = "fill";
        }
        vid.autoplay = !!this.options.autoplay;
        vid.loop = !!this.options.loop;
        vid.muted = !!this.options.muted;
        for (var i2 = 0; i2 < this._url.length; i2++) {
          var source2 = create$1("source");
          source2.src = this._url[i2];
          vid.appendChild(source2);
        }
      }
    });
    function videoOverlay(video, bounds, options) {
      return new VideoOverlay(video, bounds, options);
    }
    var SVGOverlay = ImageOverlay.extend({
      _initImage: function() {
        var el = this._image = this._url;
        addClass(el, "leaflet-image-layer");
        if (this._zoomAnimated) {
          addClass(el, "leaflet-zoom-animated");
        }
        if (this.options.className) {
          addClass(el, this.options.className);
        }
        el.onselectstart = falseFn;
        el.onmousemove = falseFn;
      }
    });
    function svgOverlay(el, bounds, options) {
      return new SVGOverlay(el, bounds, options);
    }
    var DivOverlay = Layer.extend({
      options: {
        offset: [0, 7],
        className: "",
        pane: "popupPane"
      },
      initialize: function(options, source2) {
        setOptions(this, options);
        this._source = source2;
      },
      onAdd: function(map16) {
        this._zoomAnimated = map16._zoomAnimated;
        if (!this._container) {
          this._initLayout();
        }
        if (map16._fadeAnimated) {
          setOpacity(this._container, 0);
        }
        clearTimeout(this._removeTimeout);
        this.getPane().appendChild(this._container);
        this.update();
        if (map16._fadeAnimated) {
          setOpacity(this._container, 1);
        }
        this.bringToFront();
      },
      onRemove: function(map16) {
        if (map16._fadeAnimated) {
          setOpacity(this._container, 0);
          this._removeTimeout = setTimeout(bind2(remove2, void 0, this._container), 200);
        } else {
          remove2(this._container);
        }
      },
      getLatLng: function() {
        return this._latlng;
      },
      setLatLng: function(latlng) {
        this._latlng = toLatLng(latlng);
        if (this._map) {
          this._updatePosition();
          this._adjustPan();
        }
        return this;
      },
      getContent: function() {
        return this._content;
      },
      setContent: function(content2) {
        this._content = content2;
        this.update();
        return this;
      },
      getElement: function() {
        return this._container;
      },
      update: function() {
        if (!this._map) {
          return;
        }
        this._container.style.visibility = "hidden";
        this._updateContent();
        this._updateLayout();
        this._updatePosition();
        this._container.style.visibility = "";
        this._adjustPan();
      },
      getEvents: function() {
        var events2 = {
          zoom: this._updatePosition,
          viewreset: this._updatePosition
        };
        if (this._zoomAnimated) {
          events2.zoomanim = this._animateZoom;
        }
        return events2;
      },
      isOpen: function() {
        return !!this._map && this._map.hasLayer(this);
      },
      bringToFront: function() {
        if (this._map) {
          toFront(this._container);
        }
        return this;
      },
      bringToBack: function() {
        if (this._map) {
          toBack(this._container);
        }
        return this;
      },
      _prepareOpen: function(parent, layer, latlng) {
        if (!(layer instanceof Layer)) {
          latlng = layer;
          layer = parent;
        }
        if (layer instanceof FeatureGroup) {
          for (var id in parent._layers) {
            layer = parent._layers[id];
            break;
          }
        }
        if (!latlng) {
          if (layer.getCenter) {
            latlng = layer.getCenter();
          } else if (layer.getLatLng) {
            latlng = layer.getLatLng();
          } else {
            throw new Error("Unable to get source layer LatLng.");
          }
        }
        this._source = layer;
        this.update();
        return latlng;
      },
      _updateContent: function() {
        if (!this._content) {
          return;
        }
        var node4 = this._contentNode;
        var content2 = typeof this._content === "function" ? this._content(this._source || this) : this._content;
        if (typeof content2 === "string") {
          node4.innerHTML = content2;
        } else {
          while (node4.hasChildNodes()) {
            node4.removeChild(node4.firstChild);
          }
          node4.appendChild(content2);
        }
        this.fire("contentupdate");
      },
      _updatePosition: function() {
        if (!this._map) {
          return;
        }
        var pos = this._map.latLngToLayerPoint(this._latlng), offset3 = toPoint(this.options.offset), anchor = this._getAnchor();
        if (this._zoomAnimated) {
          setPosition(this._container, pos.add(anchor));
        } else {
          offset3 = offset3.add(pos).add(anchor);
        }
        var bottom = this._containerBottom = -offset3.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset3.x;
        this._container.style.bottom = bottom + "px";
        this._container.style.left = left + "px";
      },
      _getAnchor: function() {
        return [0, 0];
      }
    });
    var Popup = DivOverlay.extend({
      options: {
        maxWidth: 300,
        minWidth: 50,
        maxHeight: null,
        autoPan: true,
        autoPanPaddingTopLeft: null,
        autoPanPaddingBottomRight: null,
        autoPanPadding: [5, 5],
        keepInView: false,
        closeButton: true,
        autoClose: true,
        closeOnEscapeKey: true,
        className: ""
      },
      openOn: function(map16) {
        map16.openPopup(this);
        return this;
      },
      onAdd: function(map16) {
        DivOverlay.prototype.onAdd.call(this, map16);
        map16.fire("popupopen", { popup: this });
        if (this._source) {
          this._source.fire("popupopen", { popup: this }, true);
          if (!(this._source instanceof Path)) {
            this._source.on("preclick", stopPropagation);
          }
        }
      },
      onRemove: function(map16) {
        DivOverlay.prototype.onRemove.call(this, map16);
        map16.fire("popupclose", { popup: this });
        if (this._source) {
          this._source.fire("popupclose", { popup: this }, true);
          if (!(this._source instanceof Path)) {
            this._source.off("preclick", stopPropagation);
          }
        }
      },
      getEvents: function() {
        var events2 = DivOverlay.prototype.getEvents.call(this);
        if (this.options.closeOnClick !== void 0 ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
          events2.preclick = this._close;
        }
        if (this.options.keepInView) {
          events2.moveend = this._adjustPan;
        }
        return events2;
      },
      _close: function() {
        if (this._map) {
          this._map.closePopup(this);
        }
      },
      _initLayout: function() {
        var prefix2 = "leaflet-popup", container = this._container = create$1("div", prefix2 + " " + (this.options.className || "") + " leaflet-zoom-animated");
        var wrapper = this._wrapper = create$1("div", prefix2 + "-content-wrapper", container);
        this._contentNode = create$1("div", prefix2 + "-content", wrapper);
        disableClickPropagation(container);
        disableScrollPropagation(this._contentNode);
        on(container, "contextmenu", stopPropagation);
        this._tipContainer = create$1("div", prefix2 + "-tip-container", container);
        this._tip = create$1("div", prefix2 + "-tip", this._tipContainer);
        if (this.options.closeButton) {
          var closeButton = this._closeButton = create$1("a", prefix2 + "-close-button", container);
          closeButton.href = "#close";
          closeButton.innerHTML = "&#215;";
          on(closeButton, "click", this._onCloseButtonClick, this);
        }
      },
      _updateLayout: function() {
        var container = this._contentNode, style = container.style;
        style.width = "";
        style.whiteSpace = "nowrap";
        var width = container.offsetWidth;
        width = Math.min(width, this.options.maxWidth);
        width = Math.max(width, this.options.minWidth);
        style.width = width + 1 + "px";
        style.whiteSpace = "";
        style.height = "";
        var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = "leaflet-popup-scrolled";
        if (maxHeight && height > maxHeight) {
          style.height = maxHeight + "px";
          addClass(container, scrolledClass);
        } else {
          removeClass(container, scrolledClass);
        }
        this._containerWidth = this._container.offsetWidth;
      },
      _animateZoom: function(e) {
        var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
        setPosition(this._container, pos.add(anchor));
      },
      _adjustPan: function() {
        if (!this.options.autoPan) {
          return;
        }
        if (this._map._panAnim) {
          this._map._panAnim.stop();
        }
        var map16 = this._map, marginBottom = parseInt(getStyle(this._container, "marginBottom"), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
        layerPos._add(getPosition(this._container));
        var containerPos = map16.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map16.getSize(), dx = 0, dy = 0;
        if (containerPos.x + containerWidth + paddingBR.x > size.x) {
          dx = containerPos.x + containerWidth - size.x + paddingBR.x;
        }
        if (containerPos.x - dx - paddingTL.x < 0) {
          dx = containerPos.x - paddingTL.x;
        }
        if (containerPos.y + containerHeight + paddingBR.y > size.y) {
          dy = containerPos.y + containerHeight - size.y + paddingBR.y;
        }
        if (containerPos.y - dy - paddingTL.y < 0) {
          dy = containerPos.y - paddingTL.y;
        }
        if (dx || dy) {
          map16.fire("autopanstart").panBy([dx, dy]);
        }
      },
      _onCloseButtonClick: function(e) {
        this._close();
        stop3(e);
      },
      _getAnchor: function() {
        return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
      }
    });
    var popup = function(options, source2) {
      return new Popup(options, source2);
    };
    Map2.mergeOptions({
      closePopupOnClick: true
    });
    Map2.include({
      openPopup: function(popup2, latlng, options) {
        if (!(popup2 instanceof Popup)) {
          popup2 = new Popup(options).setContent(popup2);
        }
        if (latlng) {
          popup2.setLatLng(latlng);
        }
        if (this.hasLayer(popup2)) {
          return this;
        }
        if (this._popup && this._popup.options.autoClose) {
          this.closePopup();
        }
        this._popup = popup2;
        return this.addLayer(popup2);
      },
      closePopup: function(popup2) {
        if (!popup2 || popup2 === this._popup) {
          popup2 = this._popup;
          this._popup = null;
        }
        if (popup2) {
          this.removeLayer(popup2);
        }
        return this;
      }
    });
    Layer.include({
      bindPopup: function(content2, options) {
        if (content2 instanceof Popup) {
          setOptions(content2, options);
          this._popup = content2;
          content2._source = this;
        } else {
          if (!this._popup || options) {
            this._popup = new Popup(options, this);
          }
          this._popup.setContent(content2);
        }
        if (!this._popupHandlersAdded) {
          this.on({
            click: this._openPopup,
            keypress: this._onKeyPress,
            remove: this.closePopup,
            move: this._movePopup
          });
          this._popupHandlersAdded = true;
        }
        return this;
      },
      unbindPopup: function() {
        if (this._popup) {
          this.off({
            click: this._openPopup,
            keypress: this._onKeyPress,
            remove: this.closePopup,
            move: this._movePopup
          });
          this._popupHandlersAdded = false;
          this._popup = null;
        }
        return this;
      },
      openPopup: function(layer, latlng) {
        if (this._popup && this._map) {
          latlng = this._popup._prepareOpen(this, layer, latlng);
          this._map.openPopup(this._popup, latlng);
        }
        return this;
      },
      closePopup: function() {
        if (this._popup) {
          this._popup._close();
        }
        return this;
      },
      togglePopup: function(target) {
        if (this._popup) {
          if (this._popup._map) {
            this.closePopup();
          } else {
            this.openPopup(target);
          }
        }
        return this;
      },
      isPopupOpen: function() {
        return this._popup ? this._popup.isOpen() : false;
      },
      setPopupContent: function(content2) {
        if (this._popup) {
          this._popup.setContent(content2);
        }
        return this;
      },
      getPopup: function() {
        return this._popup;
      },
      _openPopup: function(e) {
        var layer = e.layer || e.target;
        if (!this._popup) {
          return;
        }
        if (!this._map) {
          return;
        }
        stop3(e);
        if (layer instanceof Path) {
          this.openPopup(e.layer || e.target, e.latlng);
          return;
        }
        if (this._map.hasLayer(this._popup) && this._popup._source === layer) {
          this.closePopup();
        } else {
          this.openPopup(layer, e.latlng);
        }
      },
      _movePopup: function(e) {
        this._popup.setLatLng(e.latlng);
      },
      _onKeyPress: function(e) {
        if (e.originalEvent.keyCode === 13) {
          this._openPopup(e);
        }
      }
    });
    var Tooltip = DivOverlay.extend({
      options: {
        pane: "tooltipPane",
        offset: [0, 0],
        direction: "auto",
        permanent: false,
        sticky: false,
        interactive: false,
        opacity: 0.9
      },
      onAdd: function(map16) {
        DivOverlay.prototype.onAdd.call(this, map16);
        this.setOpacity(this.options.opacity);
        map16.fire("tooltipopen", { tooltip: this });
        if (this._source) {
          this._source.fire("tooltipopen", { tooltip: this }, true);
        }
      },
      onRemove: function(map16) {
        DivOverlay.prototype.onRemove.call(this, map16);
        map16.fire("tooltipclose", { tooltip: this });
        if (this._source) {
          this._source.fire("tooltipclose", { tooltip: this }, true);
        }
      },
      getEvents: function() {
        var events2 = DivOverlay.prototype.getEvents.call(this);
        if (touch && !this.options.permanent) {
          events2.preclick = this._close;
        }
        return events2;
      },
      _close: function() {
        if (this._map) {
          this._map.closeTooltip(this);
        }
      },
      _initLayout: function() {
        var prefix2 = "leaflet-tooltip", className = prefix2 + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
        this._contentNode = this._container = create$1("div", className);
      },
      _updateLayout: function() {
      },
      _adjustPan: function() {
      },
      _setPosition: function(pos) {
        var subX, subY, map16 = this._map, container = this._container, centerPoint = map16.latLngToContainerPoint(map16.getCenter()), tooltipPoint = map16.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset3 = toPoint(this.options.offset), anchor = this._getAnchor();
        if (direction === "top") {
          subX = tooltipWidth / 2;
          subY = tooltipHeight;
        } else if (direction === "bottom") {
          subX = tooltipWidth / 2;
          subY = 0;
        } else if (direction === "center") {
          subX = tooltipWidth / 2;
          subY = tooltipHeight / 2;
        } else if (direction === "right") {
          subX = 0;
          subY = tooltipHeight / 2;
        } else if (direction === "left") {
          subX = tooltipWidth;
          subY = tooltipHeight / 2;
        } else if (tooltipPoint.x < centerPoint.x) {
          direction = "right";
          subX = 0;
          subY = tooltipHeight / 2;
        } else {
          direction = "left";
          subX = tooltipWidth + (offset3.x + anchor.x) * 2;
          subY = tooltipHeight / 2;
        }
        pos = pos.subtract(toPoint(subX, subY, true)).add(offset3).add(anchor);
        removeClass(container, "leaflet-tooltip-right");
        removeClass(container, "leaflet-tooltip-left");
        removeClass(container, "leaflet-tooltip-top");
        removeClass(container, "leaflet-tooltip-bottom");
        addClass(container, "leaflet-tooltip-" + direction);
        setPosition(container, pos);
      },
      _updatePosition: function() {
        var pos = this._map.latLngToLayerPoint(this._latlng);
        this._setPosition(pos);
      },
      setOpacity: function(opacity) {
        this.options.opacity = opacity;
        if (this._container) {
          setOpacity(this._container, opacity);
        }
      },
      _animateZoom: function(e) {
        var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
        this._setPosition(pos);
      },
      _getAnchor: function() {
        return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
      }
    });
    var tooltip = function(options, source2) {
      return new Tooltip(options, source2);
    };
    Map2.include({
      openTooltip: function(tooltip2, latlng, options) {
        if (!(tooltip2 instanceof Tooltip)) {
          tooltip2 = new Tooltip(options).setContent(tooltip2);
        }
        if (latlng) {
          tooltip2.setLatLng(latlng);
        }
        if (this.hasLayer(tooltip2)) {
          return this;
        }
        return this.addLayer(tooltip2);
      },
      closeTooltip: function(tooltip2) {
        if (tooltip2) {
          this.removeLayer(tooltip2);
        }
        return this;
      }
    });
    Layer.include({
      bindTooltip: function(content2, options) {
        if (content2 instanceof Tooltip) {
          setOptions(content2, options);
          this._tooltip = content2;
          content2._source = this;
        } else {
          if (!this._tooltip || options) {
            this._tooltip = new Tooltip(options, this);
          }
          this._tooltip.setContent(content2);
        }
        this._initTooltipInteractions();
        if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
          this.openTooltip();
        }
        return this;
      },
      unbindTooltip: function() {
        if (this._tooltip) {
          this._initTooltipInteractions(true);
          this.closeTooltip();
          this._tooltip = null;
        }
        return this;
      },
      _initTooltipInteractions: function(remove$$1) {
        if (!remove$$1 && this._tooltipHandlersAdded) {
          return;
        }
        var onOff = remove$$1 ? "off" : "on", events2 = {
          remove: this.closeTooltip,
          move: this._moveTooltip
        };
        if (!this._tooltip.options.permanent) {
          events2.mouseover = this._openTooltip;
          events2.mouseout = this.closeTooltip;
          if (this._tooltip.options.sticky) {
            events2.mousemove = this._moveTooltip;
          }
          if (touch) {
            events2.click = this._openTooltip;
          }
        } else {
          events2.add = this._openTooltip;
        }
        this[onOff](events2);
        this._tooltipHandlersAdded = !remove$$1;
      },
      openTooltip: function(layer, latlng) {
        if (this._tooltip && this._map) {
          latlng = this._tooltip._prepareOpen(this, layer, latlng);
          this._map.openTooltip(this._tooltip, latlng);
          if (this._tooltip.options.interactive && this._tooltip._container) {
            addClass(this._tooltip._container, "leaflet-clickable");
            this.addInteractiveTarget(this._tooltip._container);
          }
        }
        return this;
      },
      closeTooltip: function() {
        if (this._tooltip) {
          this._tooltip._close();
          if (this._tooltip.options.interactive && this._tooltip._container) {
            removeClass(this._tooltip._container, "leaflet-clickable");
            this.removeInteractiveTarget(this._tooltip._container);
          }
        }
        return this;
      },
      toggleTooltip: function(target) {
        if (this._tooltip) {
          if (this._tooltip._map) {
            this.closeTooltip();
          } else {
            this.openTooltip(target);
          }
        }
        return this;
      },
      isTooltipOpen: function() {
        return this._tooltip.isOpen();
      },
      setTooltipContent: function(content2) {
        if (this._tooltip) {
          this._tooltip.setContent(content2);
        }
        return this;
      },
      getTooltip: function() {
        return this._tooltip;
      },
      _openTooltip: function(e) {
        var layer = e.layer || e.target;
        if (!this._tooltip || !this._map) {
          return;
        }
        this.openTooltip(layer, this._tooltip.options.sticky ? e.latlng : void 0);
      },
      _moveTooltip: function(e) {
        var latlng = e.latlng, containerPoint, layerPoint;
        if (this._tooltip.options.sticky && e.originalEvent) {
          containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
          layerPoint = this._map.containerPointToLayerPoint(containerPoint);
          latlng = this._map.layerPointToLatLng(layerPoint);
        }
        this._tooltip.setLatLng(latlng);
      }
    });
    var DivIcon = Icon.extend({
      options: {
        iconSize: [12, 12],
        html: false,
        bgPos: null,
        className: "leaflet-div-icon"
      },
      createIcon: function(oldIcon) {
        var div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div"), options = this.options;
        if (options.html instanceof Element) {
          empty2(div);
          div.appendChild(options.html);
        } else {
          div.innerHTML = options.html !== false ? options.html : "";
        }
        if (options.bgPos) {
          var bgPos = toPoint(options.bgPos);
          div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
        }
        this._setIconStyles(div, "icon");
        return div;
      },
      createShadow: function() {
        return null;
      }
    });
    function divIcon(options) {
      return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    var GridLayer = Layer.extend({
      options: {
        tileSize: 256,
        opacity: 1,
        updateWhenIdle: mobile,
        updateWhenZooming: true,
        updateInterval: 200,
        zIndex: 1,
        bounds: null,
        minZoom: 0,
        maxZoom: void 0,
        maxNativeZoom: void 0,
        minNativeZoom: void 0,
        noWrap: false,
        pane: "tilePane",
        className: "",
        keepBuffer: 2
      },
      initialize: function(options) {
        setOptions(this, options);
      },
      onAdd: function() {
        this._initContainer();
        this._levels = {};
        this._tiles = {};
        this._resetView();
        this._update();
      },
      beforeAdd: function(map16) {
        map16._addZoomLimit(this);
      },
      onRemove: function(map16) {
        this._removeAllTiles();
        remove2(this._container);
        map16._removeZoomLimit(this);
        this._container = null;
        this._tileZoom = void 0;
      },
      bringToFront: function() {
        if (this._map) {
          toFront(this._container);
          this._setAutoZIndex(Math.max);
        }
        return this;
      },
      bringToBack: function() {
        if (this._map) {
          toBack(this._container);
          this._setAutoZIndex(Math.min);
        }
        return this;
      },
      getContainer: function() {
        return this._container;
      },
      setOpacity: function(opacity) {
        this.options.opacity = opacity;
        this._updateOpacity();
        return this;
      },
      setZIndex: function(zIndex) {
        this.options.zIndex = zIndex;
        this._updateZIndex();
        return this;
      },
      isLoading: function() {
        return this._loading;
      },
      redraw: function() {
        if (this._map) {
          this._removeAllTiles();
          this._update();
        }
        return this;
      },
      getEvents: function() {
        var events2 = {
          viewprereset: this._invalidateAll,
          viewreset: this._resetView,
          zoom: this._resetView,
          moveend: this._onMoveEnd
        };
        if (!this.options.updateWhenIdle) {
          if (!this._onMove) {
            this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
          }
          events2.move = this._onMove;
        }
        if (this._zoomAnimated) {
          events2.zoomanim = this._animateZoom;
        }
        return events2;
      },
      createTile: function() {
        return document.createElement("div");
      },
      getTileSize: function() {
        var s2 = this.options.tileSize;
        return s2 instanceof Point ? s2 : new Point(s2, s2);
      },
      _updateZIndex: function() {
        if (this._container && this.options.zIndex !== void 0 && this.options.zIndex !== null) {
          this._container.style.zIndex = this.options.zIndex;
        }
      },
      _setAutoZIndex: function(compare) {
        var layers2 = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity);
        for (var i2 = 0, len = layers2.length, zIndex; i2 < len; i2++) {
          zIndex = layers2[i2].style.zIndex;
          if (layers2[i2] !== this._container && zIndex) {
            edgeZIndex = compare(edgeZIndex, +zIndex);
          }
        }
        if (isFinite(edgeZIndex)) {
          this.options.zIndex = edgeZIndex + compare(-1, 1);
          this._updateZIndex();
        }
      },
      _updateOpacity: function() {
        if (!this._map) {
          return;
        }
        if (ielt9) {
          return;
        }
        setOpacity(this._container, this.options.opacity);
        var now2 = +new Date(), nextFrame = false, willPrune = false;
        for (var key in this._tiles) {
          var tile = this._tiles[key];
          if (!tile.current || !tile.loaded) {
            continue;
          }
          var fade = Math.min(1, (now2 - tile.loaded) / 200);
          setOpacity(tile.el, fade);
          if (fade < 1) {
            nextFrame = true;
          } else {
            if (tile.active) {
              willPrune = true;
            } else {
              this._onOpaqueTile(tile);
            }
            tile.active = true;
          }
        }
        if (willPrune && !this._noPrune) {
          this._pruneTiles();
        }
        if (nextFrame) {
          cancelAnimFrame(this._fadeFrame);
          this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
        }
      },
      _onOpaqueTile: falseFn,
      _initContainer: function() {
        if (this._container) {
          return;
        }
        this._container = create$1("div", "leaflet-layer " + (this.options.className || ""));
        this._updateZIndex();
        if (this.options.opacity < 1) {
          this._updateOpacity();
        }
        this.getPane().appendChild(this._container);
      },
      _updateLevels: function() {
        var zoom2 = this._tileZoom, maxZoom = this.options.maxZoom;
        if (zoom2 === void 0) {
          return void 0;
        }
        for (var z in this._levels) {
          z = Number(z);
          if (this._levels[z].el.children.length || z === zoom2) {
            this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom2 - z);
            this._onUpdateLevel(z);
          } else {
            remove2(this._levels[z].el);
            this._removeTilesAtZoom(z);
            this._onRemoveLevel(z);
            delete this._levels[z];
          }
        }
        var level = this._levels[zoom2], map16 = this._map;
        if (!level) {
          level = this._levels[zoom2] = {};
          level.el = create$1("div", "leaflet-tile-container leaflet-zoom-animated", this._container);
          level.el.style.zIndex = maxZoom;
          level.origin = map16.project(map16.unproject(map16.getPixelOrigin()), zoom2).round();
          level.zoom = zoom2;
          this._setZoomTransform(level, map16.getCenter(), map16.getZoom());
          falseFn(level.el.offsetWidth);
          this._onCreateLevel(level);
        }
        this._level = level;
        return level;
      },
      _onUpdateLevel: falseFn,
      _onRemoveLevel: falseFn,
      _onCreateLevel: falseFn,
      _pruneTiles: function() {
        if (!this._map) {
          return;
        }
        var key, tile;
        var zoom2 = this._map.getZoom();
        if (zoom2 > this.options.maxZoom || zoom2 < this.options.minZoom) {
          this._removeAllTiles();
          return;
        }
        for (key in this._tiles) {
          tile = this._tiles[key];
          tile.retain = tile.current;
        }
        for (key in this._tiles) {
          tile = this._tiles[key];
          if (tile.current && !tile.active) {
            var coords = tile.coords;
            if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
              this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
            }
          }
        }
        for (key in this._tiles) {
          if (!this._tiles[key].retain) {
            this._removeTile(key);
          }
        }
      },
      _removeTilesAtZoom: function(zoom2) {
        for (var key in this._tiles) {
          if (this._tiles[key].coords.z !== zoom2) {
            continue;
          }
          this._removeTile(key);
        }
      },
      _removeAllTiles: function() {
        for (var key in this._tiles) {
          this._removeTile(key);
        }
      },
      _invalidateAll: function() {
        for (var z in this._levels) {
          remove2(this._levels[z].el);
          this._onRemoveLevel(Number(z));
          delete this._levels[z];
        }
        this._removeAllTiles();
        this._tileZoom = void 0;
      },
      _retainParent: function(x2, y, z, minZoom) {
        var x22 = Math.floor(x2 / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x22, +y2);
        coords2.z = +z2;
        var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
        if (tile && tile.active) {
          tile.retain = true;
          return true;
        } else if (tile && tile.loaded) {
          tile.retain = true;
        }
        if (z2 > minZoom) {
          return this._retainParent(x22, y2, z2, minZoom);
        }
        return false;
      },
      _retainChildren: function(x2, y, z, maxZoom) {
        for (var i2 = 2 * x2; i2 < 2 * x2 + 2; i2++) {
          for (var j = 2 * y; j < 2 * y + 2; j++) {
            var coords = new Point(i2, j);
            coords.z = z + 1;
            var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
            if (tile && tile.active) {
              tile.retain = true;
              continue;
            } else if (tile && tile.loaded) {
              tile.retain = true;
            }
            if (z + 1 < maxZoom) {
              this._retainChildren(i2, j, z + 1, maxZoom);
            }
          }
        }
      },
      _resetView: function(e) {
        var animating = e && (e.pinch || e.flyTo);
        this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
      },
      _animateZoom: function(e) {
        this._setView(e.center, e.zoom, true, e.noUpdate);
      },
      _clampZoom: function(zoom2) {
        var options = this.options;
        if (options.minNativeZoom !== void 0 && zoom2 < options.minNativeZoom) {
          return options.minNativeZoom;
        }
        if (options.maxNativeZoom !== void 0 && options.maxNativeZoom < zoom2) {
          return options.maxNativeZoom;
        }
        return zoom2;
      },
      _setView: function(center, zoom2, noPrune, noUpdate) {
        var tileZoom = Math.round(zoom2);
        if (this.options.maxZoom !== void 0 && tileZoom > this.options.maxZoom || this.options.minZoom !== void 0 && tileZoom < this.options.minZoom) {
          tileZoom = void 0;
        } else {
          tileZoom = this._clampZoom(tileZoom);
        }
        var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
        if (!noUpdate || tileZoomChanged) {
          this._tileZoom = tileZoom;
          if (this._abortLoading) {
            this._abortLoading();
          }
          this._updateLevels();
          this._resetGrid();
          if (tileZoom !== void 0) {
            this._update(center);
          }
          if (!noPrune) {
            this._pruneTiles();
          }
          this._noPrune = !!noPrune;
        }
        this._setZoomTransforms(center, zoom2);
      },
      _setZoomTransforms: function(center, zoom2) {
        for (var i2 in this._levels) {
          this._setZoomTransform(this._levels[i2], center, zoom2);
        }
      },
      _setZoomTransform: function(level, center, zoom2) {
        var scale3 = this._map.getZoomScale(zoom2, level.zoom), translate2 = level.origin.multiplyBy(scale3).subtract(this._map._getNewPixelOrigin(center, zoom2)).round();
        if (any3d) {
          setTransform(level.el, translate2, scale3);
        } else {
          setPosition(level.el, translate2);
        }
      },
      _resetGrid: function() {
        var map16 = this._map, crs = map16.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
        var bounds = this._map.getPixelWorldBounds(this._tileZoom);
        if (bounds) {
          this._globalTileRange = this._pxBoundsToTileRange(bounds);
        }
        this._wrapX = crs.wrapLng && !this.options.noWrap && [
          Math.floor(map16.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
          Math.ceil(map16.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
        ];
        this._wrapY = crs.wrapLat && !this.options.noWrap && [
          Math.floor(map16.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
          Math.ceil(map16.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
        ];
      },
      _onMoveEnd: function() {
        if (!this._map || this._map._animatingZoom) {
          return;
        }
        this._update();
      },
      _getTiledPixelBounds: function(center) {
        var map16 = this._map, mapZoom = map16._animatingZoom ? Math.max(map16._animateToZoom, map16.getZoom()) : map16.getZoom(), scale3 = map16.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map16.project(center, this._tileZoom).floor(), halfSize = map16.getSize().divideBy(scale3 * 2);
        return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
      },
      _update: function(center) {
        var map16 = this._map;
        if (!map16) {
          return;
        }
        var zoom2 = this._clampZoom(map16.getZoom());
        if (center === void 0) {
          center = map16.getCenter();
        }
        if (this._tileZoom === void 0) {
          return;
        }
        var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([margin, -margin]), tileRange.getTopRight().add([margin, -margin]));
        if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) {
          throw new Error("Attempted to load an infinite number of tiles");
        }
        for (var key in this._tiles) {
          var c = this._tiles[key].coords;
          if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) {
            this._tiles[key].current = false;
          }
        }
        if (Math.abs(zoom2 - this._tileZoom) > 1) {
          this._setView(center, zoom2);
          return;
        }
        for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
          for (var i2 = tileRange.min.x; i2 <= tileRange.max.x; i2++) {
            var coords = new Point(i2, j);
            coords.z = this._tileZoom;
            if (!this._isValidTile(coords)) {
              continue;
            }
            var tile = this._tiles[this._tileCoordsToKey(coords)];
            if (tile) {
              tile.current = true;
            } else {
              queue.push(coords);
            }
          }
        }
        queue.sort(function(a, b) {
          return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
        });
        if (queue.length !== 0) {
          if (!this._loading) {
            this._loading = true;
            this.fire("loading");
          }
          var fragment = document.createDocumentFragment();
          for (i2 = 0; i2 < queue.length; i2++) {
            this._addTile(queue[i2], fragment);
          }
          this._level.el.appendChild(fragment);
        }
      },
      _isValidTile: function(coords) {
        var crs = this._map.options.crs;
        if (!crs.infinite) {
          var bounds = this._globalTileRange;
          if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) {
            return false;
          }
        }
        if (!this.options.bounds) {
          return true;
        }
        var tileBounds = this._tileCoordsToBounds(coords);
        return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
      },
      _keyToBounds: function(key) {
        return this._tileCoordsToBounds(this._keyToTileCoords(key));
      },
      _tileCoordsToNwSe: function(coords) {
        var map16 = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map16.unproject(nwPoint, coords.z), se = map16.unproject(sePoint, coords.z);
        return [nw, se];
      },
      _tileCoordsToBounds: function(coords) {
        var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
        if (!this.options.noWrap) {
          bounds = this._map.wrapLatLngBounds(bounds);
        }
        return bounds;
      },
      _tileCoordsToKey: function(coords) {
        return coords.x + ":" + coords.y + ":" + coords.z;
      },
      _keyToTileCoords: function(key) {
        var k = key.split(":"), coords = new Point(+k[0], +k[1]);
        coords.z = +k[2];
        return coords;
      },
      _removeTile: function(key) {
        var tile = this._tiles[key];
        if (!tile) {
          return;
        }
        remove2(tile.el);
        delete this._tiles[key];
        this.fire("tileunload", {
          tile: tile.el,
          coords: this._keyToTileCoords(key)
        });
      },
      _initTile: function(tile) {
        addClass(tile, "leaflet-tile");
        var tileSize = this.getTileSize();
        tile.style.width = tileSize.x + "px";
        tile.style.height = tileSize.y + "px";
        tile.onselectstart = falseFn;
        tile.onmousemove = falseFn;
        if (ielt9 && this.options.opacity < 1) {
          setOpacity(tile, this.options.opacity);
        }
        if (android && !android23) {
          tile.style.WebkitBackfaceVisibility = "hidden";
        }
      },
      _addTile: function(coords, container) {
        var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
        var tile = this.createTile(this._wrapCoords(coords), bind2(this._tileReady, this, coords));
        this._initTile(tile);
        if (this.createTile.length < 2) {
          requestAnimFrame(bind2(this._tileReady, this, coords, null, tile));
        }
        setPosition(tile, tilePos);
        this._tiles[key] = {
          el: tile,
          coords,
          current: true
        };
        container.appendChild(tile);
        this.fire("tileloadstart", {
          tile,
          coords
        });
      },
      _tileReady: function(coords, err2, tile) {
        if (err2) {
          this.fire("tileerror", {
            error: err2,
            tile,
            coords
          });
        }
        var key = this._tileCoordsToKey(coords);
        tile = this._tiles[key];
        if (!tile) {
          return;
        }
        tile.loaded = +new Date();
        if (this._map._fadeAnimated) {
          setOpacity(tile.el, 0);
          cancelAnimFrame(this._fadeFrame);
          this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
        } else {
          tile.active = true;
          this._pruneTiles();
        }
        if (!err2) {
          addClass(tile.el, "leaflet-tile-loaded");
          this.fire("tileload", {
            tile: tile.el,
            coords
          });
        }
        if (this._noTilesToLoad()) {
          this._loading = false;
          this.fire("load");
          if (ielt9 || !this._map._fadeAnimated) {
            requestAnimFrame(this._pruneTiles, this);
          } else {
            setTimeout(bind2(this._pruneTiles, this), 250);
          }
        }
      },
      _getTilePos: function(coords) {
        return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
      },
      _wrapCoords: function(coords) {
        var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
        newCoords.z = coords.z;
        return newCoords;
      },
      _pxBoundsToTileRange: function(bounds) {
        var tileSize = this.getTileSize();
        return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1]));
      },
      _noTilesToLoad: function() {
        for (var key in this._tiles) {
          if (!this._tiles[key].loaded) {
            return false;
          }
        }
        return true;
      }
    });
    function gridLayer(options) {
      return new GridLayer(options);
    }
    var TileLayer = GridLayer.extend({
      options: {
        minZoom: 0,
        maxZoom: 18,
        subdomains: "abc",
        errorTileUrl: "",
        zoomOffset: 0,
        tms: false,
        zoomReverse: false,
        detectRetina: false,
        crossOrigin: false
      },
      initialize: function(url3, options) {
        this._url = url3;
        options = setOptions(this, options);
        if (options.detectRetina && retina && options.maxZoom > 0) {
          options.tileSize = Math.floor(options.tileSize / 2);
          if (!options.zoomReverse) {
            options.zoomOffset++;
            options.maxZoom--;
          } else {
            options.zoomOffset--;
            options.minZoom++;
          }
          options.minZoom = Math.max(0, options.minZoom);
        }
        if (typeof options.subdomains === "string") {
          options.subdomains = options.subdomains.split("");
        }
        if (!android) {
          this.on("tileunload", this._onTileRemove);
        }
      },
      setUrl: function(url3, noRedraw) {
        if (this._url === url3 && noRedraw === void 0) {
          noRedraw = true;
        }
        this._url = url3;
        if (!noRedraw) {
          this.redraw();
        }
        return this;
      },
      createTile: function(coords, done2) {
        var tile = document.createElement("img");
        on(tile, "load", bind2(this._tileOnLoad, this, done2, tile));
        on(tile, "error", bind2(this._tileOnError, this, done2, tile));
        if (this.options.crossOrigin || this.options.crossOrigin === "") {
          tile.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
        }
        tile.alt = "";
        tile.setAttribute("role", "presentation");
        tile.src = this.getTileUrl(coords);
        return tile;
      },
      getTileUrl: function(coords) {
        var data = {
          r: retina ? "@2x" : "",
          s: this._getSubdomain(coords),
          x: coords.x,
          y: coords.y,
          z: this._getZoomForUrl()
        };
        if (this._map && !this._map.options.crs.infinite) {
          var invertedY = this._globalTileRange.max.y - coords.y;
          if (this.options.tms) {
            data["y"] = invertedY;
          }
          data["-y"] = invertedY;
        }
        return template2(this._url, extend2(data, this.options));
      },
      _tileOnLoad: function(done2, tile) {
        if (ielt9) {
          setTimeout(bind2(done2, this, null, tile), 0);
        } else {
          done2(null, tile);
        }
      },
      _tileOnError: function(done2, tile, e) {
        var errorUrl = this.options.errorTileUrl;
        if (errorUrl && tile.getAttribute("src") !== errorUrl) {
          tile.src = errorUrl;
        }
        done2(e, tile);
      },
      _onTileRemove: function(e) {
        e.tile.onload = null;
      },
      _getZoomForUrl: function() {
        var zoom2 = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
        if (zoomReverse) {
          zoom2 = maxZoom - zoom2;
        }
        return zoom2 + zoomOffset;
      },
      _getSubdomain: function(tilePoint) {
        var index4 = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
        return this.options.subdomains[index4];
      },
      _abortLoading: function() {
        var i2, tile;
        for (i2 in this._tiles) {
          if (this._tiles[i2].coords.z !== this._tileZoom) {
            tile = this._tiles[i2].el;
            tile.onload = falseFn;
            tile.onerror = falseFn;
            if (!tile.complete) {
              tile.src = emptyImageUrl;
              remove2(tile);
              delete this._tiles[i2];
            }
          }
        }
      },
      _removeTile: function(key) {
        var tile = this._tiles[key];
        if (!tile) {
          return;
        }
        if (!androidStock) {
          tile.el.setAttribute("src", emptyImageUrl);
        }
        return GridLayer.prototype._removeTile.call(this, key);
      },
      _tileReady: function(coords, err2, tile) {
        if (!this._map || tile && tile.getAttribute("src") === emptyImageUrl) {
          return;
        }
        return GridLayer.prototype._tileReady.call(this, coords, err2, tile);
      }
    });
    function tileLayer(url3, options) {
      return new TileLayer(url3, options);
    }
    var TileLayerWMS = TileLayer.extend({
      defaultWmsParams: {
        service: "WMS",
        request: "GetMap",
        layers: "",
        styles: "",
        format: "image/jpeg",
        transparent: false,
        version: "1.1.1"
      },
      options: {
        crs: null,
        uppercase: false
      },
      initialize: function(url3, options) {
        this._url = url3;
        var wmsParams = extend2({}, this.defaultWmsParams);
        for (var i2 in options) {
          if (!(i2 in this.options)) {
            wmsParams[i2] = options[i2];
          }
        }
        options = setOptions(this, options);
        var realRetina = options.detectRetina && retina ? 2 : 1;
        var tileSize = this.getTileSize();
        wmsParams.width = tileSize.x * realRetina;
        wmsParams.height = tileSize.y * realRetina;
        this.wmsParams = wmsParams;
      },
      onAdd: function(map16) {
        this._crs = this.options.crs || map16.options.crs;
        this._wmsVersion = parseFloat(this.wmsParams.version);
        var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
        this.wmsParams[projectionKey] = this._crs.code;
        TileLayer.prototype.onAdd.call(this, map16);
      },
      getTileUrl: function(coords) {
        var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min3 = bounds.min, max3 = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [min3.y, min3.x, max3.y, max3.x] : [min3.x, min3.y, max3.x, max3.y]).join(","), url3 = TileLayer.prototype.getTileUrl.call(this, coords);
        return url3 + getParamString(this.wmsParams, url3, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + bbox;
      },
      setParams: function(params, noRedraw) {
        extend2(this.wmsParams, params);
        if (!noRedraw) {
          this.redraw();
        }
        return this;
      }
    });
    function tileLayerWMS(url3, options) {
      return new TileLayerWMS(url3, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    var Renderer = Layer.extend({
      options: {
        padding: 0.1,
        tolerance: 0
      },
      initialize: function(options) {
        setOptions(this, options);
        stamp(this);
        this._layers = this._layers || {};
      },
      onAdd: function() {
        if (!this._container) {
          this._initContainer();
          if (this._zoomAnimated) {
            addClass(this._container, "leaflet-zoom-animated");
          }
        }
        this.getPane().appendChild(this._container);
        this._update();
        this.on("update", this._updatePaths, this);
      },
      onRemove: function() {
        this.off("update", this._updatePaths, this);
        this._destroyContainer();
      },
      getEvents: function() {
        var events2 = {
          viewreset: this._reset,
          zoom: this._onZoom,
          moveend: this._update,
          zoomend: this._onZoomEnd
        };
        if (this._zoomAnimated) {
          events2.zoomanim = this._onAnimZoom;
        }
        return events2;
      },
      _onAnimZoom: function(ev) {
        this._updateTransform(ev.center, ev.zoom);
      },
      _onZoom: function() {
        this._updateTransform(this._map.getCenter(), this._map.getZoom());
      },
      _updateTransform: function(center, zoom2) {
        var scale3 = this._map.getZoomScale(zoom2, this._zoom), position = getPosition(this._container), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom2), destCenterPoint = this._map.project(center, zoom2), centerOffset = destCenterPoint.subtract(currentCenterPoint), topLeftOffset = viewHalf.multiplyBy(-scale3).add(position).add(viewHalf).subtract(centerOffset);
        if (any3d) {
          setTransform(this._container, topLeftOffset, scale3);
        } else {
          setPosition(this._container, topLeftOffset);
        }
      },
      _reset: function() {
        this._update();
        this._updateTransform(this._center, this._zoom);
        for (var id in this._layers) {
          this._layers[id]._reset();
        }
      },
      _onZoomEnd: function() {
        for (var id in this._layers) {
          this._layers[id]._project();
        }
      },
      _updatePaths: function() {
        for (var id in this._layers) {
          this._layers[id]._update();
        }
      },
      _update: function() {
        var p = this.options.padding, size = this._map.getSize(), min3 = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
        this._bounds = new Bounds(min3, min3.add(size.multiplyBy(1 + p * 2)).round());
        this._center = this._map.getCenter();
        this._zoom = this._map.getZoom();
      }
    });
    var Canvas = Renderer.extend({
      getEvents: function() {
        var events2 = Renderer.prototype.getEvents.call(this);
        events2.viewprereset = this._onViewPreReset;
        return events2;
      },
      _onViewPreReset: function() {
        this._postponeUpdatePaths = true;
      },
      onAdd: function() {
        Renderer.prototype.onAdd.call(this);
        this._draw();
      },
      _initContainer: function() {
        var container = this._container = document.createElement("canvas");
        on(container, "mousemove", this._onMouseMove, this);
        on(container, "click dblclick mousedown mouseup contextmenu", this._onClick, this);
        on(container, "mouseout", this._handleMouseOut, this);
        this._ctx = container.getContext("2d");
      },
      _destroyContainer: function() {
        cancelAnimFrame(this._redrawRequest);
        delete this._ctx;
        remove2(this._container);
        off(this._container);
        delete this._container;
      },
      _updatePaths: function() {
        if (this._postponeUpdatePaths) {
          return;
        }
        var layer;
        this._redrawBounds = null;
        for (var id in this._layers) {
          layer = this._layers[id];
          layer._update();
        }
        this._redraw();
      },
      _update: function() {
        if (this._map._animatingZoom && this._bounds) {
          return;
        }
        Renderer.prototype._update.call(this);
        var b = this._bounds, container = this._container, size = b.getSize(), m = retina ? 2 : 1;
        setPosition(container, b.min);
        container.width = m * size.x;
        container.height = m * size.y;
        container.style.width = size.x + "px";
        container.style.height = size.y + "px";
        if (retina) {
          this._ctx.scale(2, 2);
        }
        this._ctx.translate(-b.min.x, -b.min.y);
        this.fire("update");
      },
      _reset: function() {
        Renderer.prototype._reset.call(this);
        if (this._postponeUpdatePaths) {
          this._postponeUpdatePaths = false;
          this._updatePaths();
        }
      },
      _initPath: function(layer) {
        this._updateDashArray(layer);
        this._layers[stamp(layer)] = layer;
        var order = layer._order = {
          layer,
          prev: this._drawLast,
          next: null
        };
        if (this._drawLast) {
          this._drawLast.next = order;
        }
        this._drawLast = order;
        this._drawFirst = this._drawFirst || this._drawLast;
      },
      _addPath: function(layer) {
        this._requestRedraw(layer);
      },
      _removePath: function(layer) {
        var order = layer._order;
        var next = order.next;
        var prev = order.prev;
        if (next) {
          next.prev = prev;
        } else {
          this._drawLast = prev;
        }
        if (prev) {
          prev.next = next;
        } else {
          this._drawFirst = next;
        }
        delete layer._order;
        delete this._layers[stamp(layer)];
        this._requestRedraw(layer);
      },
      _updatePath: function(layer) {
        this._extendRedrawBounds(layer);
        layer._project();
        layer._update();
        this._requestRedraw(layer);
      },
      _updateStyle: function(layer) {
        this._updateDashArray(layer);
        this._requestRedraw(layer);
      },
      _updateDashArray: function(layer) {
        if (typeof layer.options.dashArray === "string") {
          var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i2;
          for (i2 = 0; i2 < parts.length; i2++) {
            dashValue = Number(parts[i2]);
            if (isNaN(dashValue)) {
              return;
            }
            dashArray.push(dashValue);
          }
          layer.options._dashArray = dashArray;
        } else {
          layer.options._dashArray = layer.options.dashArray;
        }
      },
      _requestRedraw: function(layer) {
        if (!this._map) {
          return;
        }
        this._extendRedrawBounds(layer);
        this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
      },
      _extendRedrawBounds: function(layer) {
        if (layer._pxBounds) {
          var padding = (layer.options.weight || 0) + 1;
          this._redrawBounds = this._redrawBounds || new Bounds();
          this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
          this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
        }
      },
      _redraw: function() {
        this._redrawRequest = null;
        if (this._redrawBounds) {
          this._redrawBounds.min._floor();
          this._redrawBounds.max._ceil();
        }
        this._clear();
        this._draw();
        this._redrawBounds = null;
      },
      _clear: function() {
        var bounds = this._redrawBounds;
        if (bounds) {
          var size = bounds.getSize();
          this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
        } else {
          this._ctx.save();
          this._ctx.setTransform(1, 0, 0, 1, 0, 0);
          this._ctx.clearRect(0, 0, this._container.width, this._container.height);
          this._ctx.restore();
        }
      },
      _draw: function() {
        var layer, bounds = this._redrawBounds;
        this._ctx.save();
        if (bounds) {
          var size = bounds.getSize();
          this._ctx.beginPath();
          this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
          this._ctx.clip();
        }
        this._drawing = true;
        for (var order = this._drawFirst; order; order = order.next) {
          layer = order.layer;
          if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) {
            layer._updatePath();
          }
        }
        this._drawing = false;
        this._ctx.restore();
      },
      _updatePoly: function(layer, closed) {
        if (!this._drawing) {
          return;
        }
        var i2, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
        if (!len) {
          return;
        }
        ctx.beginPath();
        for (i2 = 0; i2 < len; i2++) {
          for (j = 0, len2 = parts[i2].length; j < len2; j++) {
            p = parts[i2][j];
            ctx[j ? "lineTo" : "moveTo"](p.x, p.y);
          }
          if (closed) {
            ctx.closePath();
          }
        }
        this._fillStroke(ctx, layer);
      },
      _updateCircle: function(layer) {
        if (!this._drawing || layer._empty()) {
          return;
        }
        var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s2 = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
        if (s2 !== 1) {
          ctx.save();
          ctx.scale(1, s2);
        }
        ctx.beginPath();
        ctx.arc(p.x, p.y / s2, r, 0, Math.PI * 2, false);
        if (s2 !== 1) {
          ctx.restore();
        }
        this._fillStroke(ctx, layer);
      },
      _fillStroke: function(ctx, layer) {
        var options = layer.options;
        if (options.fill) {
          ctx.globalAlpha = options.fillOpacity;
          ctx.fillStyle = options.fillColor || options.color;
          ctx.fill(options.fillRule || "evenodd");
        }
        if (options.stroke && options.weight !== 0) {
          if (ctx.setLineDash) {
            ctx.setLineDash(layer.options && layer.options._dashArray || []);
          }
          ctx.globalAlpha = options.opacity;
          ctx.lineWidth = options.weight;
          ctx.strokeStyle = options.color;
          ctx.lineCap = options.lineCap;
          ctx.lineJoin = options.lineJoin;
          ctx.stroke();
        }
      },
      _onClick: function(e) {
        var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
        for (var order = this._drawFirst; order; order = order.next) {
          layer = order.layer;
          if (layer.options.interactive && layer._containsPoint(point)) {
            if (!(e.type === "click" || e.type !== "preclick") || !this._map._draggableMoved(layer)) {
              clickedLayer = layer;
            }
          }
        }
        if (clickedLayer) {
          fakeStop(e);
          this._fireEvent([clickedLayer], e);
        }
      },
      _onMouseMove: function(e) {
        if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) {
          return;
        }
        var point = this._map.mouseEventToLayerPoint(e);
        this._handleMouseHover(e, point);
      },
      _handleMouseOut: function(e) {
        var layer = this._hoveredLayer;
        if (layer) {
          removeClass(this._container, "leaflet-interactive");
          this._fireEvent([layer], e, "mouseout");
          this._hoveredLayer = null;
          this._mouseHoverThrottled = false;
        }
      },
      _handleMouseHover: function(e, point) {
        if (this._mouseHoverThrottled) {
          return;
        }
        var layer, candidateHoveredLayer;
        for (var order = this._drawFirst; order; order = order.next) {
          layer = order.layer;
          if (layer.options.interactive && layer._containsPoint(point)) {
            candidateHoveredLayer = layer;
          }
        }
        if (candidateHoveredLayer !== this._hoveredLayer) {
          this._handleMouseOut(e);
          if (candidateHoveredLayer) {
            addClass(this._container, "leaflet-interactive");
            this._fireEvent([candidateHoveredLayer], e, "mouseover");
            this._hoveredLayer = candidateHoveredLayer;
          }
        }
        if (this._hoveredLayer) {
          this._fireEvent([this._hoveredLayer], e);
        }
        this._mouseHoverThrottled = true;
        setTimeout(bind2(function() {
          this._mouseHoverThrottled = false;
        }, this), 32);
      },
      _fireEvent: function(layers2, e, type) {
        this._map._fireDOMEvent(e, type || e.type, layers2);
      },
      _bringToFront: function(layer) {
        var order = layer._order;
        if (!order) {
          return;
        }
        var next = order.next;
        var prev = order.prev;
        if (next) {
          next.prev = prev;
        } else {
          return;
        }
        if (prev) {
          prev.next = next;
        } else if (next) {
          this._drawFirst = next;
        }
        order.prev = this._drawLast;
        this._drawLast.next = order;
        order.next = null;
        this._drawLast = order;
        this._requestRedraw(layer);
      },
      _bringToBack: function(layer) {
        var order = layer._order;
        if (!order) {
          return;
        }
        var next = order.next;
        var prev = order.prev;
        if (prev) {
          prev.next = next;
        } else {
          return;
        }
        if (next) {
          next.prev = prev;
        } else if (prev) {
          this._drawLast = prev;
        }
        order.prev = null;
        order.next = this._drawFirst;
        this._drawFirst.prev = order;
        this._drawFirst = order;
        this._requestRedraw(layer);
      }
    });
    function canvas$1(options) {
      return canvas ? new Canvas(options) : null;
    }
    var vmlCreate = function() {
      try {
        document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml");
        return function(name) {
          return document.createElement("<lvml:" + name + ' class="lvml">');
        };
      } catch (e) {
        return function(name) {
          return document.createElement("<" + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
      }
    }();
    var vmlMixin = {
      _initContainer: function() {
        this._container = create$1("div", "leaflet-vml-container");
      },
      _update: function() {
        if (this._map._animatingZoom) {
          return;
        }
        Renderer.prototype._update.call(this);
        this.fire("update");
      },
      _initPath: function(layer) {
        var container = layer._container = vmlCreate("shape");
        addClass(container, "leaflet-vml-shape " + (this.options.className || ""));
        container.coordsize = "1 1";
        layer._path = vmlCreate("path");
        container.appendChild(layer._path);
        this._updateStyle(layer);
        this._layers[stamp(layer)] = layer;
      },
      _addPath: function(layer) {
        var container = layer._container;
        this._container.appendChild(container);
        if (layer.options.interactive) {
          layer.addInteractiveTarget(container);
        }
      },
      _removePath: function(layer) {
        var container = layer._container;
        remove2(container);
        layer.removeInteractiveTarget(container);
        delete this._layers[stamp(layer)];
      },
      _updateStyle: function(layer) {
        var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
        container.stroked = !!options.stroke;
        container.filled = !!options.fill;
        if (options.stroke) {
          if (!stroke) {
            stroke = layer._stroke = vmlCreate("stroke");
          }
          container.appendChild(stroke);
          stroke.weight = options.weight + "px";
          stroke.color = options.color;
          stroke.opacity = options.opacity;
          if (options.dashArray) {
            stroke.dashStyle = isArray2(options.dashArray) ? options.dashArray.join(" ") : options.dashArray.replace(/( *, *)/g, " ");
          } else {
            stroke.dashStyle = "";
          }
          stroke.endcap = options.lineCap.replace("butt", "flat");
          stroke.joinstyle = options.lineJoin;
        } else if (stroke) {
          container.removeChild(stroke);
          layer._stroke = null;
        }
        if (options.fill) {
          if (!fill) {
            fill = layer._fill = vmlCreate("fill");
          }
          container.appendChild(fill);
          fill.color = options.fillColor || options.color;
          fill.opacity = options.fillOpacity;
        } else if (fill) {
          container.removeChild(fill);
          layer._fill = null;
        }
      },
      _updateCircle: function(layer) {
        var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
        this._setPath(layer, layer._empty() ? "M0 0" : "AL " + p.x + "," + p.y + " " + r + "," + r2 + " 0," + 65535 * 360);
      },
      _setPath: function(layer, path) {
        layer._path.v = path;
      },
      _bringToFront: function(layer) {
        toFront(layer._container);
      },
      _bringToBack: function(layer) {
        toBack(layer._container);
      }
    };
    var create$2 = vml ? vmlCreate : svgCreate;
    var SVG2 = Renderer.extend({
      getEvents: function() {
        var events2 = Renderer.prototype.getEvents.call(this);
        events2.zoomstart = this._onZoomStart;
        return events2;
      },
      _initContainer: function() {
        this._container = create$2("svg");
        this._container.setAttribute("pointer-events", "none");
        this._rootGroup = create$2("g");
        this._container.appendChild(this._rootGroup);
      },
      _destroyContainer: function() {
        remove2(this._container);
        off(this._container);
        delete this._container;
        delete this._rootGroup;
        delete this._svgSize;
      },
      _onZoomStart: function() {
        this._update();
      },
      _update: function() {
        if (this._map._animatingZoom && this._bounds) {
          return;
        }
        Renderer.prototype._update.call(this);
        var b = this._bounds, size = b.getSize(), container = this._container;
        if (!this._svgSize || !this._svgSize.equals(size)) {
          this._svgSize = size;
          container.setAttribute("width", size.x);
          container.setAttribute("height", size.y);
        }
        setPosition(container, b.min);
        container.setAttribute("viewBox", [b.min.x, b.min.y, size.x, size.y].join(" "));
        this.fire("update");
      },
      _initPath: function(layer) {
        var path = layer._path = create$2("path");
        if (layer.options.className) {
          addClass(path, layer.options.className);
        }
        if (layer.options.interactive) {
          addClass(path, "leaflet-interactive");
        }
        this._updateStyle(layer);
        this._layers[stamp(layer)] = layer;
      },
      _addPath: function(layer) {
        if (!this._rootGroup) {
          this._initContainer();
        }
        this._rootGroup.appendChild(layer._path);
        layer.addInteractiveTarget(layer._path);
      },
      _removePath: function(layer) {
        remove2(layer._path);
        layer.removeInteractiveTarget(layer._path);
        delete this._layers[stamp(layer)];
      },
      _updatePath: function(layer) {
        layer._project();
        layer._update();
      },
      _updateStyle: function(layer) {
        var path = layer._path, options = layer.options;
        if (!path) {
          return;
        }
        if (options.stroke) {
          path.setAttribute("stroke", options.color);
          path.setAttribute("stroke-opacity", options.opacity);
          path.setAttribute("stroke-width", options.weight);
          path.setAttribute("stroke-linecap", options.lineCap);
          path.setAttribute("stroke-linejoin", options.lineJoin);
          if (options.dashArray) {
            path.setAttribute("stroke-dasharray", options.dashArray);
          } else {
            path.removeAttribute("stroke-dasharray");
          }
          if (options.dashOffset) {
            path.setAttribute("stroke-dashoffset", options.dashOffset);
          } else {
            path.removeAttribute("stroke-dashoffset");
          }
        } else {
          path.setAttribute("stroke", "none");
        }
        if (options.fill) {
          path.setAttribute("fill", options.fillColor || options.color);
          path.setAttribute("fill-opacity", options.fillOpacity);
          path.setAttribute("fill-rule", options.fillRule || "evenodd");
        } else {
          path.setAttribute("fill", "none");
        }
      },
      _updatePoly: function(layer, closed) {
        this._setPath(layer, pointsToPath(layer._parts, closed));
      },
      _updateCircle: function(layer) {
        var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = "a" + r + "," + r2 + " 0 1,0 ";
        var d = layer._empty() ? "M0 0" : "M" + (p.x - r) + "," + p.y + arc + r * 2 + ",0 " + arc + -r * 2 + ",0 ";
        this._setPath(layer, d);
      },
      _setPath: function(layer, path) {
        layer._path.setAttribute("d", path);
      },
      _bringToFront: function(layer) {
        toFront(layer._path);
      },
      _bringToBack: function(layer) {
        toBack(layer._path);
      }
    });
    if (vml) {
      SVG2.include(vmlMixin);
    }
    function svg$1(options) {
      return svg || vml ? new SVG2(options) : null;
    }
    Map2.include({
      getRenderer: function(layer) {
        var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
        if (!renderer) {
          renderer = this._renderer = this._createRenderer();
        }
        if (!this.hasLayer(renderer)) {
          this.addLayer(renderer);
        }
        return renderer;
      },
      _getPaneRenderer: function(name) {
        if (name === "overlayPane" || name === void 0) {
          return false;
        }
        var renderer = this._paneRenderers[name];
        if (renderer === void 0) {
          renderer = this._createRenderer({ pane: name });
          this._paneRenderers[name] = renderer;
        }
        return renderer;
      },
      _createRenderer: function(options) {
        return this.options.preferCanvas && canvas$1(options) || svg$1(options);
      }
    });
    var Rectangle = Polygon.extend({
      initialize: function(latLngBounds, options) {
        Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
      },
      setBounds: function(latLngBounds) {
        return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
      },
      _boundsToLatLngs: function(latLngBounds) {
        latLngBounds = toLatLngBounds(latLngBounds);
        return [
          latLngBounds.getSouthWest(),
          latLngBounds.getNorthWest(),
          latLngBounds.getNorthEast(),
          latLngBounds.getSouthEast()
        ];
      }
    });
    function rectangle(latLngBounds, options) {
      return new Rectangle(latLngBounds, options);
    }
    SVG2.create = create$2;
    SVG2.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    Map2.mergeOptions({
      boxZoom: true
    });
    var BoxZoom = Handler.extend({
      initialize: function(map16) {
        this._map = map16;
        this._container = map16._container;
        this._pane = map16._panes.overlayPane;
        this._resetStateTimeout = 0;
        map16.on("unload", this._destroy, this);
      },
      addHooks: function() {
        on(this._container, "mousedown", this._onMouseDown, this);
      },
      removeHooks: function() {
        off(this._container, "mousedown", this._onMouseDown, this);
      },
      moved: function() {
        return this._moved;
      },
      _destroy: function() {
        remove2(this._pane);
        delete this._pane;
      },
      _resetState: function() {
        this._resetStateTimeout = 0;
        this._moved = false;
      },
      _clearDeferredResetState: function() {
        if (this._resetStateTimeout !== 0) {
          clearTimeout(this._resetStateTimeout);
          this._resetStateTimeout = 0;
        }
      },
      _onMouseDown: function(e) {
        if (!e.shiftKey || e.which !== 1 && e.button !== 1) {
          return false;
        }
        this._clearDeferredResetState();
        this._resetState();
        disableTextSelection();
        disableImageDrag();
        this._startPoint = this._map.mouseEventToContainerPoint(e);
        on(document, {
          contextmenu: stop3,
          mousemove: this._onMouseMove,
          mouseup: this._onMouseUp,
          keydown: this._onKeyDown
        }, this);
      },
      _onMouseMove: function(e) {
        if (!this._moved) {
          this._moved = true;
          this._box = create$1("div", "leaflet-zoom-box", this._container);
          addClass(this._container, "leaflet-crosshair");
          this._map.fire("boxzoomstart");
        }
        this._point = this._map.mouseEventToContainerPoint(e);
        var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
        setPosition(this._box, bounds.min);
        this._box.style.width = size.x + "px";
        this._box.style.height = size.y + "px";
      },
      _finish: function() {
        if (this._moved) {
          remove2(this._box);
          removeClass(this._container, "leaflet-crosshair");
        }
        enableTextSelection();
        enableImageDrag();
        off(document, {
          contextmenu: stop3,
          mousemove: this._onMouseMove,
          mouseup: this._onMouseUp,
          keydown: this._onKeyDown
        }, this);
      },
      _onMouseUp: function(e) {
        if (e.which !== 1 && e.button !== 1) {
          return;
        }
        this._finish();
        if (!this._moved) {
          return;
        }
        this._clearDeferredResetState();
        this._resetStateTimeout = setTimeout(bind2(this._resetState, this), 0);
        var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
        this._map.fitBounds(bounds).fire("boxzoomend", { boxZoomBounds: bounds });
      },
      _onKeyDown: function(e) {
        if (e.keyCode === 27) {
          this._finish();
        }
      }
    });
    Map2.addInitHook("addHandler", "boxZoom", BoxZoom);
    Map2.mergeOptions({
      doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
      addHooks: function() {
        this._map.on("dblclick", this._onDoubleClick, this);
      },
      removeHooks: function() {
        this._map.off("dblclick", this._onDoubleClick, this);
      },
      _onDoubleClick: function(e) {
        var map16 = this._map, oldZoom = map16.getZoom(), delta = map16.options.zoomDelta, zoom2 = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
        if (map16.options.doubleClickZoom === "center") {
          map16.setZoom(zoom2);
        } else {
          map16.setZoomAround(e.containerPoint, zoom2);
        }
      }
    });
    Map2.addInitHook("addHandler", "doubleClickZoom", DoubleClickZoom);
    Map2.mergeOptions({
      dragging: true,
      inertia: !android23,
      inertiaDeceleration: 3400,
      inertiaMaxSpeed: Infinity,
      easeLinearity: 0.2,
      worldCopyJump: false,
      maxBoundsViscosity: 0
    });
    var Drag = Handler.extend({
      addHooks: function() {
        if (!this._draggable) {
          var map16 = this._map;
          this._draggable = new Draggable(map16._mapPane, map16._container);
          this._draggable.on({
            dragstart: this._onDragStart,
            drag: this._onDrag,
            dragend: this._onDragEnd
          }, this);
          this._draggable.on("predrag", this._onPreDragLimit, this);
          if (map16.options.worldCopyJump) {
            this._draggable.on("predrag", this._onPreDragWrap, this);
            map16.on("zoomend", this._onZoomEnd, this);
            map16.whenReady(this._onZoomEnd, this);
          }
        }
        addClass(this._map._container, "leaflet-grab leaflet-touch-drag");
        this._draggable.enable();
        this._positions = [];
        this._times = [];
      },
      removeHooks: function() {
        removeClass(this._map._container, "leaflet-grab");
        removeClass(this._map._container, "leaflet-touch-drag");
        this._draggable.disable();
      },
      moved: function() {
        return this._draggable && this._draggable._moved;
      },
      moving: function() {
        return this._draggable && this._draggable._moving;
      },
      _onDragStart: function() {
        var map16 = this._map;
        map16._stop();
        if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
          var bounds = toLatLngBounds(this._map.options.maxBounds);
          this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
          this._viscosity = Math.min(1, Math.max(0, this._map.options.maxBoundsViscosity));
        } else {
          this._offsetLimit = null;
        }
        map16.fire("movestart").fire("dragstart");
        if (map16.options.inertia) {
          this._positions = [];
          this._times = [];
        }
      },
      _onDrag: function(e) {
        if (this._map.options.inertia) {
          var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
          this._positions.push(pos);
          this._times.push(time);
          this._prunePositions(time);
        }
        this._map.fire("move", e).fire("drag", e);
      },
      _prunePositions: function(time) {
        while (this._positions.length > 1 && time - this._times[0] > 50) {
          this._positions.shift();
          this._times.shift();
        }
      },
      _onZoomEnd: function() {
        var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);
        this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
        this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
      },
      _viscousLimit: function(value, threshold) {
        return value - (value - threshold) * this._viscosity;
      },
      _onPreDragLimit: function() {
        if (!this._viscosity || !this._offsetLimit) {
          return;
        }
        var offset3 = this._draggable._newPos.subtract(this._draggable._startPos);
        var limit = this._offsetLimit;
        if (offset3.x < limit.min.x) {
          offset3.x = this._viscousLimit(offset3.x, limit.min.x);
        }
        if (offset3.y < limit.min.y) {
          offset3.y = this._viscousLimit(offset3.y, limit.min.y);
        }
        if (offset3.x > limit.max.x) {
          offset3.x = this._viscousLimit(offset3.x, limit.max.x);
        }
        if (offset3.y > limit.max.y) {
          offset3.y = this._viscousLimit(offset3.y, limit.max.y);
        }
        this._draggable._newPos = this._draggable._startPos.add(offset3);
      },
      _onPreDragWrap: function() {
        var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x2 = this._draggable._newPos.x, newX1 = (x2 - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x2 + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
        this._draggable._absPos = this._draggable._newPos.clone();
        this._draggable._newPos.x = newX;
      },
      _onDragEnd: function(e) {
        var map16 = this._map, options = map16.options, noInertia = !options.inertia || this._times.length < 2;
        map16.fire("dragend", e);
        if (noInertia) {
          map16.fire("moveend");
        } else {
          this._prunePositions(+new Date());
          var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1e3, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([0, 0]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset3 = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
          if (!offset3.x && !offset3.y) {
            map16.fire("moveend");
          } else {
            offset3 = map16._limitOffset(offset3, map16.options.maxBounds);
            requestAnimFrame(function() {
              map16.panBy(offset3, {
                duration: decelerationDuration,
                easeLinearity: ease,
                noMoveStart: true,
                animate: true
              });
            });
          }
        }
      }
    });
    Map2.addInitHook("addHandler", "dragging", Drag);
    Map2.mergeOptions({
      keyboard: true,
      keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
      keyCodes: {
        left: [37],
        right: [39],
        down: [40],
        up: [38],
        zoomIn: [187, 107, 61, 171],
        zoomOut: [189, 109, 54, 173]
      },
      initialize: function(map16) {
        this._map = map16;
        this._setPanDelta(map16.options.keyboardPanDelta);
        this._setZoomDelta(map16.options.zoomDelta);
      },
      addHooks: function() {
        var container = this._map._container;
        if (container.tabIndex <= 0) {
          container.tabIndex = "0";
        }
        on(container, {
          focus: this._onFocus,
          blur: this._onBlur,
          mousedown: this._onMouseDown
        }, this);
        this._map.on({
          focus: this._addHooks,
          blur: this._removeHooks
        }, this);
      },
      removeHooks: function() {
        this._removeHooks();
        off(this._map._container, {
          focus: this._onFocus,
          blur: this._onBlur,
          mousedown: this._onMouseDown
        }, this);
        this._map.off({
          focus: this._addHooks,
          blur: this._removeHooks
        }, this);
      },
      _onMouseDown: function() {
        if (this._focused) {
          return;
        }
        var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
        this._map._container.focus();
        window.scrollTo(left, top);
      },
      _onFocus: function() {
        this._focused = true;
        this._map.fire("focus");
      },
      _onBlur: function() {
        this._focused = false;
        this._map.fire("blur");
      },
      _setPanDelta: function(panDelta) {
        var keys2 = this._panKeys = {}, codes = this.keyCodes, i2, len;
        for (i2 = 0, len = codes.left.length; i2 < len; i2++) {
          keys2[codes.left[i2]] = [-1 * panDelta, 0];
        }
        for (i2 = 0, len = codes.right.length; i2 < len; i2++) {
          keys2[codes.right[i2]] = [panDelta, 0];
        }
        for (i2 = 0, len = codes.down.length; i2 < len; i2++) {
          keys2[codes.down[i2]] = [0, panDelta];
        }
        for (i2 = 0, len = codes.up.length; i2 < len; i2++) {
          keys2[codes.up[i2]] = [0, -1 * panDelta];
        }
      },
      _setZoomDelta: function(zoomDelta) {
        var keys2 = this._zoomKeys = {}, codes = this.keyCodes, i2, len;
        for (i2 = 0, len = codes.zoomIn.length; i2 < len; i2++) {
          keys2[codes.zoomIn[i2]] = zoomDelta;
        }
        for (i2 = 0, len = codes.zoomOut.length; i2 < len; i2++) {
          keys2[codes.zoomOut[i2]] = -zoomDelta;
        }
      },
      _addHooks: function() {
        on(document, "keydown", this._onKeyDown, this);
      },
      _removeHooks: function() {
        off(document, "keydown", this._onKeyDown, this);
      },
      _onKeyDown: function(e) {
        if (e.altKey || e.ctrlKey || e.metaKey) {
          return;
        }
        var key = e.keyCode, map16 = this._map, offset3;
        if (key in this._panKeys) {
          if (!map16._panAnim || !map16._panAnim._inProgress) {
            offset3 = this._panKeys[key];
            if (e.shiftKey) {
              offset3 = toPoint(offset3).multiplyBy(3);
            }
            map16.panBy(offset3);
            if (map16.options.maxBounds) {
              map16.panInsideBounds(map16.options.maxBounds);
            }
          }
        } else if (key in this._zoomKeys) {
          map16.setZoom(map16.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
        } else if (key === 27 && map16._popup && map16._popup.options.closeOnEscapeKey) {
          map16.closePopup();
        } else {
          return;
        }
        stop3(e);
      }
    });
    Map2.addInitHook("addHandler", "keyboard", Keyboard);
    Map2.mergeOptions({
      scrollWheelZoom: true,
      wheelDebounceTime: 40,
      wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
      addHooks: function() {
        on(this._map._container, "wheel", this._onWheelScroll, this);
        this._delta = 0;
      },
      removeHooks: function() {
        off(this._map._container, "wheel", this._onWheelScroll, this);
      },
      _onWheelScroll: function(e) {
        var delta = getWheelDelta(e);
        var debounce2 = this._map.options.wheelDebounceTime;
        this._delta += delta;
        this._lastMousePos = this._map.mouseEventToContainerPoint(e);
        if (!this._startTime) {
          this._startTime = +new Date();
        }
        var left = Math.max(debounce2 - (+new Date() - this._startTime), 0);
        clearTimeout(this._timer);
        this._timer = setTimeout(bind2(this._performZoom, this), left);
        stop3(e);
      },
      _performZoom: function() {
        var map16 = this._map, zoom2 = map16.getZoom(), snap = this._map.options.zoomSnap || 0;
        map16._stop();
        var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map16._limitZoom(zoom2 + (this._delta > 0 ? d4 : -d4)) - zoom2;
        this._delta = 0;
        this._startTime = null;
        if (!delta) {
          return;
        }
        if (map16.options.scrollWheelZoom === "center") {
          map16.setZoom(zoom2 + delta);
        } else {
          map16.setZoomAround(this._lastMousePos, zoom2 + delta);
        }
      }
    });
    Map2.addInitHook("addHandler", "scrollWheelZoom", ScrollWheelZoom);
    Map2.mergeOptions({
      tap: true,
      tapTolerance: 15
    });
    var Tap = Handler.extend({
      addHooks: function() {
        on(this._map._container, "touchstart", this._onDown, this);
      },
      removeHooks: function() {
        off(this._map._container, "touchstart", this._onDown, this);
      },
      _onDown: function(e) {
        if (!e.touches) {
          return;
        }
        preventDefault(e);
        this._fireClick = true;
        if (e.touches.length > 1) {
          this._fireClick = false;
          clearTimeout(this._holdTimeout);
          return;
        }
        var first = e.touches[0], el = first.target;
        this._startPos = this._newPos = new Point(first.clientX, first.clientY);
        if (el.tagName && el.tagName.toLowerCase() === "a") {
          addClass(el, "leaflet-active");
        }
        this._holdTimeout = setTimeout(bind2(function() {
          if (this._isTapValid()) {
            this._fireClick = false;
            this._onUp();
            this._simulateEvent("contextmenu", first);
          }
        }, this), 1e3);
        this._simulateEvent("mousedown", first);
        on(document, {
          touchmove: this._onMove,
          touchend: this._onUp
        }, this);
      },
      _onUp: function(e) {
        clearTimeout(this._holdTimeout);
        off(document, {
          touchmove: this._onMove,
          touchend: this._onUp
        }, this);
        if (this._fireClick && e && e.changedTouches) {
          var first = e.changedTouches[0], el = first.target;
          if (el && el.tagName && el.tagName.toLowerCase() === "a") {
            removeClass(el, "leaflet-active");
          }
          this._simulateEvent("mouseup", first);
          if (this._isTapValid()) {
            this._simulateEvent("click", first);
          }
        }
      },
      _isTapValid: function() {
        return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
      },
      _onMove: function(e) {
        var first = e.touches[0];
        this._newPos = new Point(first.clientX, first.clientY);
        this._simulateEvent("mousemove", first);
      },
      _simulateEvent: function(type, e) {
        var simulatedEvent = document.createEvent("MouseEvents");
        simulatedEvent._simulated = true;
        e.target._simulatedClick = true;
        simulatedEvent.initMouseEvent(type, true, true, window, 1, e.screenX, e.screenY, e.clientX, e.clientY, false, false, false, false, 0, null);
        e.target.dispatchEvent(simulatedEvent);
      }
    });
    if (touch && (!pointer || safari2)) {
      Map2.addInitHook("addHandler", "tap", Tap);
    }
    Map2.mergeOptions({
      touchZoom: touch && !android23,
      bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
      addHooks: function() {
        addClass(this._map._container, "leaflet-touch-zoom");
        on(this._map._container, "touchstart", this._onTouchStart, this);
      },
      removeHooks: function() {
        removeClass(this._map._container, "leaflet-touch-zoom");
        off(this._map._container, "touchstart", this._onTouchStart, this);
      },
      _onTouchStart: function(e) {
        var map16 = this._map;
        if (!e.touches || e.touches.length !== 2 || map16._animatingZoom || this._zooming) {
          return;
        }
        var p1 = map16.mouseEventToContainerPoint(e.touches[0]), p2 = map16.mouseEventToContainerPoint(e.touches[1]);
        this._centerPoint = map16.getSize()._divideBy(2);
        this._startLatLng = map16.containerPointToLatLng(this._centerPoint);
        if (map16.options.touchZoom !== "center") {
          this._pinchStartLatLng = map16.containerPointToLatLng(p1.add(p2)._divideBy(2));
        }
        this._startDist = p1.distanceTo(p2);
        this._startZoom = map16.getZoom();
        this._moved = false;
        this._zooming = true;
        map16._stop();
        on(document, "touchmove", this._onTouchMove, this);
        on(document, "touchend", this._onTouchEnd, this);
        preventDefault(e);
      },
      _onTouchMove: function(e) {
        if (!e.touches || e.touches.length !== 2 || !this._zooming) {
          return;
        }
        var map16 = this._map, p1 = map16.mouseEventToContainerPoint(e.touches[0]), p2 = map16.mouseEventToContainerPoint(e.touches[1]), scale3 = p1.distanceTo(p2) / this._startDist;
        this._zoom = map16.getScaleZoom(scale3, this._startZoom);
        if (!map16.options.bounceAtZoomLimits && (this._zoom < map16.getMinZoom() && scale3 < 1 || this._zoom > map16.getMaxZoom() && scale3 > 1)) {
          this._zoom = map16._limitZoom(this._zoom);
        }
        if (map16.options.touchZoom === "center") {
          this._center = this._startLatLng;
          if (scale3 === 1) {
            return;
          }
        } else {
          var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
          if (scale3 === 1 && delta.x === 0 && delta.y === 0) {
            return;
          }
          this._center = map16.unproject(map16.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
        }
        if (!this._moved) {
          map16._moveStart(true, false);
          this._moved = true;
        }
        cancelAnimFrame(this._animRequest);
        var moveFn = bind2(map16._move, map16, this._center, this._zoom, { pinch: true, round: false });
        this._animRequest = requestAnimFrame(moveFn, this, true);
        preventDefault(e);
      },
      _onTouchEnd: function() {
        if (!this._moved || !this._zooming) {
          this._zooming = false;
          return;
        }
        this._zooming = false;
        cancelAnimFrame(this._animRequest);
        off(document, "touchmove", this._onTouchMove, this);
        off(document, "touchend", this._onTouchEnd, this);
        if (this._map.options.zoomAnimation) {
          this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
        } else {
          this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
      }
    });
    Map2.addInitHook("addHandler", "touchZoom", TouchZoom);
    Map2.BoxZoom = BoxZoom;
    Map2.DoubleClickZoom = DoubleClickZoom;
    Map2.Drag = Drag;
    Map2.Keyboard = Keyboard;
    Map2.ScrollWheelZoom = ScrollWheelZoom;
    Map2.Tap = Tap;
    Map2.TouchZoom = TouchZoom;
    exports2.version = version;
    exports2.Control = Control;
    exports2.control = control;
    exports2.Browser = Browser;
    exports2.Evented = Evented;
    exports2.Mixin = Mixin;
    exports2.Util = Util;
    exports2.Class = Class;
    exports2.Handler = Handler;
    exports2.extend = extend2;
    exports2.bind = bind2;
    exports2.stamp = stamp;
    exports2.setOptions = setOptions;
    exports2.DomEvent = DomEvent;
    exports2.DomUtil = DomUtil;
    exports2.PosAnimation = PosAnimation;
    exports2.Draggable = Draggable;
    exports2.LineUtil = LineUtil;
    exports2.PolyUtil = PolyUtil;
    exports2.Point = Point;
    exports2.point = toPoint;
    exports2.Bounds = Bounds;
    exports2.bounds = toBounds;
    exports2.Transformation = Transformation;
    exports2.transformation = toTransformation;
    exports2.Projection = index3;
    exports2.LatLng = LatLng;
    exports2.latLng = toLatLng;
    exports2.LatLngBounds = LatLngBounds;
    exports2.latLngBounds = toLatLngBounds;
    exports2.CRS = CRS;
    exports2.GeoJSON = GeoJSON;
    exports2.geoJSON = geoJSON;
    exports2.geoJson = geoJson;
    exports2.Layer = Layer;
    exports2.LayerGroup = LayerGroup;
    exports2.layerGroup = layerGroup;
    exports2.FeatureGroup = FeatureGroup;
    exports2.featureGroup = featureGroup;
    exports2.ImageOverlay = ImageOverlay;
    exports2.imageOverlay = imageOverlay;
    exports2.VideoOverlay = VideoOverlay;
    exports2.videoOverlay = videoOverlay;
    exports2.SVGOverlay = SVGOverlay;
    exports2.svgOverlay = svgOverlay;
    exports2.DivOverlay = DivOverlay;
    exports2.Popup = Popup;
    exports2.popup = popup;
    exports2.Tooltip = Tooltip;
    exports2.tooltip = tooltip;
    exports2.Icon = Icon;
    exports2.icon = icon;
    exports2.DivIcon = DivIcon;
    exports2.divIcon = divIcon;
    exports2.Marker = Marker;
    exports2.marker = marker;
    exports2.TileLayer = TileLayer;
    exports2.tileLayer = tileLayer;
    exports2.GridLayer = GridLayer;
    exports2.gridLayer = gridLayer;
    exports2.SVG = SVG2;
    exports2.svg = svg$1;
    exports2.Renderer = Renderer;
    exports2.Canvas = Canvas;
    exports2.canvas = canvas$1;
    exports2.Path = Path;
    exports2.CircleMarker = CircleMarker;
    exports2.circleMarker = circleMarker;
    exports2.Circle = Circle;
    exports2.circle = circle;
    exports2.Polyline = Polyline;
    exports2.polyline = polyline;
    exports2.Polygon = Polygon;
    exports2.polygon = polygon;
    exports2.Rectangle = Rectangle;
    exports2.rectangle = rectangle;
    exports2.Map = Map2;
    exports2.map = createMap;
    var oldL = window.L;
    exports2.noConflict = function() {
      window.L = oldL;
      return this;
    };
    window.L = exports2;
  });
})(leafletSrc, leafletSrc.exports);
var L$1 = leafletSrc.exports;
function simplify(latLng) {
  return {
    lat: latLng.lat.toString(),
    lng: latLng.lng.toString()
  };
}
const _sfc_main = defineComponent({
  name: "SLeaflet",
  props: {
    modelValue: null
  },
  emits: ["click", "update:modelValue"],
  setup(props, { emit: emit2 }) {
    var clearControl = L$1.Control.extend({
      options: {
        position: "topleft"
      },
      onAdd: function(map22) {
        var container = L$1.DomUtil.create("div", "leaflet-bar leaflet-control leaflet-control-custom bg-white");
        if (!L$1.Browser.touch) {
          L$1.DomEvent.disableClickPropagation(container).disableScrollPropagation(container);
        } else {
          L$1.DomEvent.on(container, "click", L$1.DomEvent.stopPropagation);
        }
        container.innerHTML = '<a href="#" title="Clear coordinates" role="button" aria-label="Clear coordinates"><div class="w-full h-full flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></div></a>';
        container.onclick = function(e) {
          e.preventDefault();
          emit2("update:modelValue", null);
          return false;
        };
        return container;
      }
    });
    const clearButton = new clearControl();
    const supervueui = inject("supervueui");
    const el = ref(null);
    let map16 = null;
    let marker = null;
    const updateMarker = (c, centerView) => {
      if (c) {
        marker == null ? void 0 : marker.setLatLng(c);
        marker == null ? void 0 : marker.addTo(map16);
        if (centerView) {
          map16 == null ? void 0 : map16.setView(c, map16.getZoom(), { animate: true });
        }
        map16.addControl(clearButton);
      } else {
        marker == null ? void 0 : marker.remove();
        map16 == null ? void 0 : map16.setZoom(map16.getZoom());
        map16 == null ? void 0 : map16.removeControl(clearButton);
      }
    };
    updateMarker(props.coordinates, true);
    watch(() => props.modelValue, (newCoordintate) => {
      updateMarker(newCoordintate, true);
    });
    onMounted(() => {
      map16 = L$1.map(el.value, {
        center: [0, 0],
        zoom: 4
      });
      if (document.fullscreenEnabled) {
        var fullscreenControl = L$1.Control.extend({
          options: { position: "topright" },
          onAdd: function(map22) {
            var container = L$1.DomUtil.create("div", "leaflet-bar leaflet-control leaflet-control-custom bg-white");
            container.innerHTML = '<a href="#" title="Toggle fullscreen" role="button" aria-label="Toggle fullscreen"><div class="w-full h-full flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" /></svg></div></a>';
            if (!L$1.Browser.touch) {
              L$1.DomEvent.disableClickPropagation(container).disableScrollPropagation(container);
            } else {
              L$1.DomEvent.on(container, "click", L$1.DomEvent.stopPropagation);
            }
            container.onclick = function(e) {
              e.preventDefault();
              if (!document.fullscreenElement) {
                el.value.requestFullscreen().catch((err2) => {
                  alert(`Error attempting to enable full-screen mode: ${err2.message} (${err2.name})`);
                });
              } else {
                document.exitFullscreen();
              }
              return false;
            };
            return container;
          }
        });
        map16.addControl(new fullscreenControl());
      }
      const layers = {
        mapboxLight: {
          url: "https://api.mapbox.com/styles/v1/mapbox/light-v9/tiles/{z}/{x}/{y}?access_token=" + supervueui.tokens.mapbox,
          options: { attribution: '<a href="https://www.mapbox.com/about/maps/">Mapbox</a>', tileSize: 512, zoomOffset: -1 }
        },
        mapboxStreets: {
          url: "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=" + supervueui.tokens.mapbox,
          options: { attribution: '<a href="https://www.mapbox.com/about/maps/">Mapbox</a>', tileSize: 512, zoomOffset: -1 }
        }
      };
      var l = layers.mapboxStreets;
      var tile_layer = L$1.tileLayer(l.url, l.options);
      map16.addLayer(tile_layer);
      map16.on("click", (e) => {
        const coordinates2 = simplify(e.latlng);
        emit2("update:modelValue", coordinates2);
        emit2("click", coordinates2);
      });
      marker = L$1.circleMarker([0, 0], { color: supervueui.colors.brand, fillColor: supervueui.colors.brand });
      updateMarker(props.coordinates, true);
      function maybeLayout() {
        var _a;
        if (((_a = el.value) == null ? void 0 : _a.getBoundingClientRect().width) == 0) {
          setTimeout(() => {
            maybeLayout();
          }, 200);
        } else {
          map16.invalidateSize();
        }
      }
      maybeLayout();
    });
    return {
      el
    };
  }
});
const _hoisted_1 = { class: "rounded border" };
const _hoisted_2 = {
  ref: "el",
  class: "w-full h-full z-0"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createElementVNode("div", _hoisted_2, null, 512)
  ]);
}
var SLeaflet = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
var absorb = {
  mounted(el, binding) {
    el.addEventListener(binding.arg, (e) => {
      e.cancelBubble = false;
      e.preventDefault();
      if (typeof binding.value === typeof Function) {
        return binding.value(e);
      } else {
        return typeof binding.value != "undefined" ? binding.value : true;
      }
    });
  }
};
var focus2 = {
  mounted(el, binding) {
    if (el) {
      const input = el.querySelector("input");
      if (input) {
        input.focus();
      }
    }
  }
};
const isVisible = (elem) => !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
var clickOutside = {
  mounted(element, binding) {
    let lastMouseDownX = 0;
    let lastMouseDownY = 0;
    let lastMouseDownWasOutside = false;
    const mouseDownListener = (event) => {
      lastMouseDownX = event.offsetX;
      lastMouseDownY = event.offsetY;
      lastMouseDownWasOutside = !element.contains(event.target);
    };
    const outsideClickListener = (event) => {
      const deltaX = event.offsetX - lastMouseDownX;
      const deltaY = event.offsetY - lastMouseDownY;
      const distSq = deltaX * deltaX + deltaY * deltaY;
      const isDrag = distSq > 3;
      const isDragException = isDrag && !lastMouseDownWasOutside;
      if (!element.contains(event.target) && isVisible(element) && !isDragException) {
        if (typeof binding.value === typeof Function) {
          binding.value(event);
        }
      }
    };
    document.addEventListener("mousedown", mouseDownListener);
    document.addEventListener("click", outsideClickListener);
  }
};
var colors$1 = {};
var log$1 = {};
var ansiStyles$1 = { exports: {} };
var colorName = {
  "aliceblue": [240, 248, 255],
  "antiquewhite": [250, 235, 215],
  "aqua": [0, 255, 255],
  "aquamarine": [127, 255, 212],
  "azure": [240, 255, 255],
  "beige": [245, 245, 220],
  "bisque": [255, 228, 196],
  "black": [0, 0, 0],
  "blanchedalmond": [255, 235, 205],
  "blue": [0, 0, 255],
  "blueviolet": [138, 43, 226],
  "brown": [165, 42, 42],
  "burlywood": [222, 184, 135],
  "cadetblue": [95, 158, 160],
  "chartreuse": [127, 255, 0],
  "chocolate": [210, 105, 30],
  "coral": [255, 127, 80],
  "cornflowerblue": [100, 149, 237],
  "cornsilk": [255, 248, 220],
  "crimson": [220, 20, 60],
  "cyan": [0, 255, 255],
  "darkblue": [0, 0, 139],
  "darkcyan": [0, 139, 139],
  "darkgoldenrod": [184, 134, 11],
  "darkgray": [169, 169, 169],
  "darkgreen": [0, 100, 0],
  "darkgrey": [169, 169, 169],
  "darkkhaki": [189, 183, 107],
  "darkmagenta": [139, 0, 139],
  "darkolivegreen": [85, 107, 47],
  "darkorange": [255, 140, 0],
  "darkorchid": [153, 50, 204],
  "darkred": [139, 0, 0],
  "darksalmon": [233, 150, 122],
  "darkseagreen": [143, 188, 143],
  "darkslateblue": [72, 61, 139],
  "darkslategray": [47, 79, 79],
  "darkslategrey": [47, 79, 79],
  "darkturquoise": [0, 206, 209],
  "darkviolet": [148, 0, 211],
  "deeppink": [255, 20, 147],
  "deepskyblue": [0, 191, 255],
  "dimgray": [105, 105, 105],
  "dimgrey": [105, 105, 105],
  "dodgerblue": [30, 144, 255],
  "firebrick": [178, 34, 34],
  "floralwhite": [255, 250, 240],
  "forestgreen": [34, 139, 34],
  "fuchsia": [255, 0, 255],
  "gainsboro": [220, 220, 220],
  "ghostwhite": [248, 248, 255],
  "gold": [255, 215, 0],
  "goldenrod": [218, 165, 32],
  "gray": [128, 128, 128],
  "green": [0, 128, 0],
  "greenyellow": [173, 255, 47],
  "grey": [128, 128, 128],
  "honeydew": [240, 255, 240],
  "hotpink": [255, 105, 180],
  "indianred": [205, 92, 92],
  "indigo": [75, 0, 130],
  "ivory": [255, 255, 240],
  "khaki": [240, 230, 140],
  "lavender": [230, 230, 250],
  "lavenderblush": [255, 240, 245],
  "lawngreen": [124, 252, 0],
  "lemonchiffon": [255, 250, 205],
  "lightblue": [173, 216, 230],
  "lightcoral": [240, 128, 128],
  "lightcyan": [224, 255, 255],
  "lightgoldenrodyellow": [250, 250, 210],
  "lightgray": [211, 211, 211],
  "lightgreen": [144, 238, 144],
  "lightgrey": [211, 211, 211],
  "lightpink": [255, 182, 193],
  "lightsalmon": [255, 160, 122],
  "lightseagreen": [32, 178, 170],
  "lightskyblue": [135, 206, 250],
  "lightslategray": [119, 136, 153],
  "lightslategrey": [119, 136, 153],
  "lightsteelblue": [176, 196, 222],
  "lightyellow": [255, 255, 224],
  "lime": [0, 255, 0],
  "limegreen": [50, 205, 50],
  "linen": [250, 240, 230],
  "magenta": [255, 0, 255],
  "maroon": [128, 0, 0],
  "mediumaquamarine": [102, 205, 170],
  "mediumblue": [0, 0, 205],
  "mediumorchid": [186, 85, 211],
  "mediumpurple": [147, 112, 219],
  "mediumseagreen": [60, 179, 113],
  "mediumslateblue": [123, 104, 238],
  "mediumspringgreen": [0, 250, 154],
  "mediumturquoise": [72, 209, 204],
  "mediumvioletred": [199, 21, 133],
  "midnightblue": [25, 25, 112],
  "mintcream": [245, 255, 250],
  "mistyrose": [255, 228, 225],
  "moccasin": [255, 228, 181],
  "navajowhite": [255, 222, 173],
  "navy": [0, 0, 128],
  "oldlace": [253, 245, 230],
  "olive": [128, 128, 0],
  "olivedrab": [107, 142, 35],
  "orange": [255, 165, 0],
  "orangered": [255, 69, 0],
  "orchid": [218, 112, 214],
  "palegoldenrod": [238, 232, 170],
  "palegreen": [152, 251, 152],
  "paleturquoise": [175, 238, 238],
  "palevioletred": [219, 112, 147],
  "papayawhip": [255, 239, 213],
  "peachpuff": [255, 218, 185],
  "peru": [205, 133, 63],
  "pink": [255, 192, 203],
  "plum": [221, 160, 221],
  "powderblue": [176, 224, 230],
  "purple": [128, 0, 128],
  "rebeccapurple": [102, 51, 153],
  "red": [255, 0, 0],
  "rosybrown": [188, 143, 143],
  "royalblue": [65, 105, 225],
  "saddlebrown": [139, 69, 19],
  "salmon": [250, 128, 114],
  "sandybrown": [244, 164, 96],
  "seagreen": [46, 139, 87],
  "seashell": [255, 245, 238],
  "sienna": [160, 82, 45],
  "silver": [192, 192, 192],
  "skyblue": [135, 206, 235],
  "slateblue": [106, 90, 205],
  "slategray": [112, 128, 144],
  "slategrey": [112, 128, 144],
  "snow": [255, 250, 250],
  "springgreen": [0, 255, 127],
  "steelblue": [70, 130, 180],
  "tan": [210, 180, 140],
  "teal": [0, 128, 128],
  "thistle": [216, 191, 216],
  "tomato": [255, 99, 71],
  "turquoise": [64, 224, 208],
  "violet": [238, 130, 238],
  "wheat": [245, 222, 179],
  "white": [255, 255, 255],
  "whitesmoke": [245, 245, 245],
  "yellow": [255, 255, 0],
  "yellowgreen": [154, 205, 50]
};
const cssKeywords = colorName;
const reverseKeywords = {};
for (const key of Object.keys(cssKeywords)) {
  reverseKeywords[cssKeywords[key]] = key;
}
const convert$1 = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  lch: { channels: 3, labels: "lch" },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
};
var conversions$2 = convert$1;
for (const model of Object.keys(convert$1)) {
  if (!("channels" in convert$1[model])) {
    throw new Error("missing channels property: " + model);
  }
  if (!("labels" in convert$1[model])) {
    throw new Error("missing channel labels property: " + model);
  }
  if (convert$1[model].labels.length !== convert$1[model].channels) {
    throw new Error("channel and label counts mismatch: " + model);
  }
  const { channels, labels } = convert$1[model];
  delete convert$1[model].channels;
  delete convert$1[model].labels;
  Object.defineProperty(convert$1[model], "channels", { value: channels });
  Object.defineProperty(convert$1[model], "labels", { value: labels });
}
convert$1.rgb.hsl = function(rgb) {
  const r = rgb[0] / 255;
  const g = rgb[1] / 255;
  const b = rgb[2] / 255;
  const min3 = Math.min(r, g, b);
  const max3 = Math.max(r, g, b);
  const delta = max3 - min3;
  let h;
  let s2;
  if (max3 === min3) {
    h = 0;
  } else if (r === max3) {
    h = (g - b) / delta;
  } else if (g === max3) {
    h = 2 + (b - r) / delta;
  } else if (b === max3) {
    h = 4 + (r - g) / delta;
  }
  h = Math.min(h * 60, 360);
  if (h < 0) {
    h += 360;
  }
  const l = (min3 + max3) / 2;
  if (max3 === min3) {
    s2 = 0;
  } else if (l <= 0.5) {
    s2 = delta / (max3 + min3);
  } else {
    s2 = delta / (2 - max3 - min3);
  }
  return [h, s2 * 100, l * 100];
};
convert$1.rgb.hsv = function(rgb) {
  let rdif;
  let gdif;
  let bdif;
  let h;
  let s2;
  const r = rgb[0] / 255;
  const g = rgb[1] / 255;
  const b = rgb[2] / 255;
  const v2 = Math.max(r, g, b);
  const diff2 = v2 - Math.min(r, g, b);
  const diffc = function(c) {
    return (v2 - c) / 6 / diff2 + 1 / 2;
  };
  if (diff2 === 0) {
    h = 0;
    s2 = 0;
  } else {
    s2 = diff2 / v2;
    rdif = diffc(r);
    gdif = diffc(g);
    bdif = diffc(b);
    if (r === v2) {
      h = bdif - gdif;
    } else if (g === v2) {
      h = 1 / 3 + rdif - bdif;
    } else if (b === v2) {
      h = 2 / 3 + gdif - rdif;
    }
    if (h < 0) {
      h += 1;
    } else if (h > 1) {
      h -= 1;
    }
  }
  return [
    h * 360,
    s2 * 100,
    v2 * 100
  ];
};
convert$1.rgb.hwb = function(rgb) {
  const r = rgb[0];
  const g = rgb[1];
  let b = rgb[2];
  const h = convert$1.rgb.hsl(rgb)[0];
  const w = 1 / 255 * Math.min(r, Math.min(g, b));
  b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
  return [h, w * 100, b * 100];
};
convert$1.rgb.cmyk = function(rgb) {
  const r = rgb[0] / 255;
  const g = rgb[1] / 255;
  const b = rgb[2] / 255;
  const k = Math.min(1 - r, 1 - g, 1 - b);
  const c = (1 - r - k) / (1 - k) || 0;
  const m = (1 - g - k) / (1 - k) || 0;
  const y = (1 - b - k) / (1 - k) || 0;
  return [c * 100, m * 100, y * 100, k * 100];
};
function comparativeDistance(x2, y) {
  return (x2[0] - y[0]) ** 2 + (x2[1] - y[1]) ** 2 + (x2[2] - y[2]) ** 2;
}
convert$1.rgb.keyword = function(rgb) {
  const reversed = reverseKeywords[rgb];
  if (reversed) {
    return reversed;
  }
  let currentClosestDistance = Infinity;
  let currentClosestKeyword;
  for (const keyword of Object.keys(cssKeywords)) {
    const value = cssKeywords[keyword];
    const distance = comparativeDistance(rgb, value);
    if (distance < currentClosestDistance) {
      currentClosestDistance = distance;
      currentClosestKeyword = keyword;
    }
  }
  return currentClosestKeyword;
};
convert$1.keyword.rgb = function(keyword) {
  return cssKeywords[keyword];
};
convert$1.rgb.xyz = function(rgb) {
  let r = rgb[0] / 255;
  let g = rgb[1] / 255;
  let b = rgb[2] / 255;
  r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92;
  g = g > 0.04045 ? ((g + 0.055) / 1.055) ** 2.4 : g / 12.92;
  b = b > 0.04045 ? ((b + 0.055) / 1.055) ** 2.4 : b / 12.92;
  const x2 = r * 0.4124 + g * 0.3576 + b * 0.1805;
  const y = r * 0.2126 + g * 0.7152 + b * 0.0722;
  const z = r * 0.0193 + g * 0.1192 + b * 0.9505;
  return [x2 * 100, y * 100, z * 100];
};
convert$1.rgb.lab = function(rgb) {
  const xyz = convert$1.rgb.xyz(rgb);
  let x2 = xyz[0];
  let y = xyz[1];
  let z = xyz[2];
  x2 /= 95.047;
  y /= 100;
  z /= 108.883;
  x2 = x2 > 8856e-6 ? x2 ** (1 / 3) : 7.787 * x2 + 16 / 116;
  y = y > 8856e-6 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
  z = z > 8856e-6 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
  const l = 116 * y - 16;
  const a = 500 * (x2 - y);
  const b = 200 * (y - z);
  return [l, a, b];
};
convert$1.hsl.rgb = function(hsl) {
  const h = hsl[0] / 360;
  const s2 = hsl[1] / 100;
  const l = hsl[2] / 100;
  let t2;
  let t3;
  let val;
  if (s2 === 0) {
    val = l * 255;
    return [val, val, val];
  }
  if (l < 0.5) {
    t2 = l * (1 + s2);
  } else {
    t2 = l + s2 - l * s2;
  }
  const t1 = 2 * l - t2;
  const rgb = [0, 0, 0];
  for (let i2 = 0; i2 < 3; i2++) {
    t3 = h + 1 / 3 * -(i2 - 1);
    if (t3 < 0) {
      t3++;
    }
    if (t3 > 1) {
      t3--;
    }
    if (6 * t3 < 1) {
      val = t1 + (t2 - t1) * 6 * t3;
    } else if (2 * t3 < 1) {
      val = t2;
    } else if (3 * t3 < 2) {
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    } else {
      val = t1;
    }
    rgb[i2] = val * 255;
  }
  return rgb;
};
convert$1.hsl.hsv = function(hsl) {
  const h = hsl[0];
  let s2 = hsl[1] / 100;
  let l = hsl[2] / 100;
  let smin = s2;
  const lmin = Math.max(l, 0.01);
  l *= 2;
  s2 *= l <= 1 ? l : 2 - l;
  smin *= lmin <= 1 ? lmin : 2 - lmin;
  const v2 = (l + s2) / 2;
  const sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s2 / (l + s2);
  return [h, sv * 100, v2 * 100];
};
convert$1.hsv.rgb = function(hsv) {
  const h = hsv[0] / 60;
  const s2 = hsv[1] / 100;
  let v2 = hsv[2] / 100;
  const hi = Math.floor(h) % 6;
  const f = h - Math.floor(h);
  const p = 255 * v2 * (1 - s2);
  const q = 255 * v2 * (1 - s2 * f);
  const t = 255 * v2 * (1 - s2 * (1 - f));
  v2 *= 255;
  switch (hi) {
    case 0:
      return [v2, t, p];
    case 1:
      return [q, v2, p];
    case 2:
      return [p, v2, t];
    case 3:
      return [p, q, v2];
    case 4:
      return [t, p, v2];
    case 5:
      return [v2, p, q];
  }
};
convert$1.hsv.hsl = function(hsv) {
  const h = hsv[0];
  const s2 = hsv[1] / 100;
  const v2 = hsv[2] / 100;
  const vmin = Math.max(v2, 0.01);
  let sl;
  let l;
  l = (2 - s2) * v2;
  const lmin = (2 - s2) * vmin;
  sl = s2 * vmin;
  sl /= lmin <= 1 ? lmin : 2 - lmin;
  sl = sl || 0;
  l /= 2;
  return [h, sl * 100, l * 100];
};
convert$1.hwb.rgb = function(hwb) {
  const h = hwb[0] / 360;
  let wh = hwb[1] / 100;
  let bl = hwb[2] / 100;
  const ratio = wh + bl;
  let f;
  if (ratio > 1) {
    wh /= ratio;
    bl /= ratio;
  }
  const i2 = Math.floor(6 * h);
  const v2 = 1 - bl;
  f = 6 * h - i2;
  if ((i2 & 1) !== 0) {
    f = 1 - f;
  }
  const n = wh + f * (v2 - wh);
  let r;
  let g;
  let b;
  switch (i2) {
    default:
    case 6:
    case 0:
      r = v2;
      g = n;
      b = wh;
      break;
    case 1:
      r = n;
      g = v2;
      b = wh;
      break;
    case 2:
      r = wh;
      g = v2;
      b = n;
      break;
    case 3:
      r = wh;
      g = n;
      b = v2;
      break;
    case 4:
      r = n;
      g = wh;
      b = v2;
      break;
    case 5:
      r = v2;
      g = wh;
      b = n;
      break;
  }
  return [r * 255, g * 255, b * 255];
};
convert$1.cmyk.rgb = function(cmyk) {
  const c = cmyk[0] / 100;
  const m = cmyk[1] / 100;
  const y = cmyk[2] / 100;
  const k = cmyk[3] / 100;
  const r = 1 - Math.min(1, c * (1 - k) + k);
  const g = 1 - Math.min(1, m * (1 - k) + k);
  const b = 1 - Math.min(1, y * (1 - k) + k);
  return [r * 255, g * 255, b * 255];
};
convert$1.xyz.rgb = function(xyz) {
  const x2 = xyz[0] / 100;
  const y = xyz[1] / 100;
  const z = xyz[2] / 100;
  let r;
  let g;
  let b;
  r = x2 * 3.2406 + y * -1.5372 + z * -0.4986;
  g = x2 * -0.9689 + y * 1.8758 + z * 0.0415;
  b = x2 * 0.0557 + y * -0.204 + z * 1.057;
  r = r > 31308e-7 ? 1.055 * r ** (1 / 2.4) - 0.055 : r * 12.92;
  g = g > 31308e-7 ? 1.055 * g ** (1 / 2.4) - 0.055 : g * 12.92;
  b = b > 31308e-7 ? 1.055 * b ** (1 / 2.4) - 0.055 : b * 12.92;
  r = Math.min(Math.max(0, r), 1);
  g = Math.min(Math.max(0, g), 1);
  b = Math.min(Math.max(0, b), 1);
  return [r * 255, g * 255, b * 255];
};
convert$1.xyz.lab = function(xyz) {
  let x2 = xyz[0];
  let y = xyz[1];
  let z = xyz[2];
  x2 /= 95.047;
  y /= 100;
  z /= 108.883;
  x2 = x2 > 8856e-6 ? x2 ** (1 / 3) : 7.787 * x2 + 16 / 116;
  y = y > 8856e-6 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
  z = z > 8856e-6 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
  const l = 116 * y - 16;
  const a = 500 * (x2 - y);
  const b = 200 * (y - z);
  return [l, a, b];
};
convert$1.lab.xyz = function(lab) {
  const l = lab[0];
  const a = lab[1];
  const b = lab[2];
  let x2;
  let y;
  let z;
  y = (l + 16) / 116;
  x2 = a / 500 + y;
  z = y - b / 200;
  const y2 = y ** 3;
  const x22 = x2 ** 3;
  const z2 = z ** 3;
  y = y2 > 8856e-6 ? y2 : (y - 16 / 116) / 7.787;
  x2 = x22 > 8856e-6 ? x22 : (x2 - 16 / 116) / 7.787;
  z = z2 > 8856e-6 ? z2 : (z - 16 / 116) / 7.787;
  x2 *= 95.047;
  y *= 100;
  z *= 108.883;
  return [x2, y, z];
};
convert$1.lab.lch = function(lab) {
  const l = lab[0];
  const a = lab[1];
  const b = lab[2];
  let h;
  const hr = Math.atan2(b, a);
  h = hr * 360 / 2 / Math.PI;
  if (h < 0) {
    h += 360;
  }
  const c = Math.sqrt(a * a + b * b);
  return [l, c, h];
};
convert$1.lch.lab = function(lch) {
  const l = lch[0];
  const c = lch[1];
  const h = lch[2];
  const hr = h / 360 * 2 * Math.PI;
  const a = c * Math.cos(hr);
  const b = c * Math.sin(hr);
  return [l, a, b];
};
convert$1.rgb.ansi16 = function(args, saturation = null) {
  const [r, g, b] = args;
  let value = saturation === null ? convert$1.rgb.hsv(args)[2] : saturation;
  value = Math.round(value / 50);
  if (value === 0) {
    return 30;
  }
  let ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
  if (value === 2) {
    ansi += 60;
  }
  return ansi;
};
convert$1.hsv.ansi16 = function(args) {
  return convert$1.rgb.ansi16(convert$1.hsv.rgb(args), args[2]);
};
convert$1.rgb.ansi256 = function(args) {
  const r = args[0];
  const g = args[1];
  const b = args[2];
  if (r === g && g === b) {
    if (r < 8) {
      return 16;
    }
    if (r > 248) {
      return 231;
    }
    return Math.round((r - 8) / 247 * 24) + 232;
  }
  const ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
  return ansi;
};
convert$1.ansi16.rgb = function(args) {
  let color = args % 10;
  if (color === 0 || color === 7) {
    if (args > 50) {
      color += 3.5;
    }
    color = color / 10.5 * 255;
    return [color, color, color];
  }
  const mult = (~~(args > 50) + 1) * 0.5;
  const r = (color & 1) * mult * 255;
  const g = (color >> 1 & 1) * mult * 255;
  const b = (color >> 2 & 1) * mult * 255;
  return [r, g, b];
};
convert$1.ansi256.rgb = function(args) {
  if (args >= 232) {
    const c = (args - 232) * 10 + 8;
    return [c, c, c];
  }
  args -= 16;
  let rem;
  const r = Math.floor(args / 36) / 5 * 255;
  const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
  const b = rem % 6 / 5 * 255;
  return [r, g, b];
};
convert$1.rgb.hex = function(args) {
  const integer = ((Math.round(args[0]) & 255) << 16) + ((Math.round(args[1]) & 255) << 8) + (Math.round(args[2]) & 255);
  const string2 = integer.toString(16).toUpperCase();
  return "000000".substring(string2.length) + string2;
};
convert$1.hex.rgb = function(args) {
  const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
  if (!match) {
    return [0, 0, 0];
  }
  let colorString = match[0];
  if (match[0].length === 3) {
    colorString = colorString.split("").map((char) => {
      return char + char;
    }).join("");
  }
  const integer = parseInt(colorString, 16);
  const r = integer >> 16 & 255;
  const g = integer >> 8 & 255;
  const b = integer & 255;
  return [r, g, b];
};
convert$1.rgb.hcg = function(rgb) {
  const r = rgb[0] / 255;
  const g = rgb[1] / 255;
  const b = rgb[2] / 255;
  const max3 = Math.max(Math.max(r, g), b);
  const min3 = Math.min(Math.min(r, g), b);
  const chroma = max3 - min3;
  let grayscale;
  let hue;
  if (chroma < 1) {
    grayscale = min3 / (1 - chroma);
  } else {
    grayscale = 0;
  }
  if (chroma <= 0) {
    hue = 0;
  } else if (max3 === r) {
    hue = (g - b) / chroma % 6;
  } else if (max3 === g) {
    hue = 2 + (b - r) / chroma;
  } else {
    hue = 4 + (r - g) / chroma;
  }
  hue /= 6;
  hue %= 1;
  return [hue * 360, chroma * 100, grayscale * 100];
};
convert$1.hsl.hcg = function(hsl) {
  const s2 = hsl[1] / 100;
  const l = hsl[2] / 100;
  const c = l < 0.5 ? 2 * s2 * l : 2 * s2 * (1 - l);
  let f = 0;
  if (c < 1) {
    f = (l - 0.5 * c) / (1 - c);
  }
  return [hsl[0], c * 100, f * 100];
};
convert$1.hsv.hcg = function(hsv) {
  const s2 = hsv[1] / 100;
  const v2 = hsv[2] / 100;
  const c = s2 * v2;
  let f = 0;
  if (c < 1) {
    f = (v2 - c) / (1 - c);
  }
  return [hsv[0], c * 100, f * 100];
};
convert$1.hcg.rgb = function(hcg) {
  const h = hcg[0] / 360;
  const c = hcg[1] / 100;
  const g = hcg[2] / 100;
  if (c === 0) {
    return [g * 255, g * 255, g * 255];
  }
  const pure = [0, 0, 0];
  const hi = h % 1 * 6;
  const v2 = hi % 1;
  const w = 1 - v2;
  let mg = 0;
  switch (Math.floor(hi)) {
    case 0:
      pure[0] = 1;
      pure[1] = v2;
      pure[2] = 0;
      break;
    case 1:
      pure[0] = w;
      pure[1] = 1;
      pure[2] = 0;
      break;
    case 2:
      pure[0] = 0;
      pure[1] = 1;
      pure[2] = v2;
      break;
    case 3:
      pure[0] = 0;
      pure[1] = w;
      pure[2] = 1;
      break;
    case 4:
      pure[0] = v2;
      pure[1] = 0;
      pure[2] = 1;
      break;
    default:
      pure[0] = 1;
      pure[1] = 0;
      pure[2] = w;
  }
  mg = (1 - c) * g;
  return [
    (c * pure[0] + mg) * 255,
    (c * pure[1] + mg) * 255,
    (c * pure[2] + mg) * 255
  ];
};
convert$1.hcg.hsv = function(hcg) {
  const c = hcg[1] / 100;
  const g = hcg[2] / 100;
  const v2 = c + g * (1 - c);
  let f = 0;
  if (v2 > 0) {
    f = c / v2;
  }
  return [hcg[0], f * 100, v2 * 100];
};
convert$1.hcg.hsl = function(hcg) {
  const c = hcg[1] / 100;
  const g = hcg[2] / 100;
  const l = g * (1 - c) + 0.5 * c;
  let s2 = 0;
  if (l > 0 && l < 0.5) {
    s2 = c / (2 * l);
  } else if (l >= 0.5 && l < 1) {
    s2 = c / (2 * (1 - l));
  }
  return [hcg[0], s2 * 100, l * 100];
};
convert$1.hcg.hwb = function(hcg) {
  const c = hcg[1] / 100;
  const g = hcg[2] / 100;
  const v2 = c + g * (1 - c);
  return [hcg[0], (v2 - c) * 100, (1 - v2) * 100];
};
convert$1.hwb.hcg = function(hwb) {
  const w = hwb[1] / 100;
  const b = hwb[2] / 100;
  const v2 = 1 - b;
  const c = v2 - w;
  let g = 0;
  if (c < 1) {
    g = (v2 - c) / (1 - c);
  }
  return [hwb[0], c * 100, g * 100];
};
convert$1.apple.rgb = function(apple) {
  return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
};
convert$1.rgb.apple = function(rgb) {
  return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
};
convert$1.gray.rgb = function(args) {
  return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};
convert$1.gray.hsl = function(args) {
  return [0, 0, args[0]];
};
convert$1.gray.hsv = convert$1.gray.hsl;
convert$1.gray.hwb = function(gray) {
  return [0, 100, gray[0]];
};
convert$1.gray.cmyk = function(gray) {
  return [0, 0, 0, gray[0]];
};
convert$1.gray.lab = function(gray) {
  return [gray[0], 0, 0];
};
convert$1.gray.hex = function(gray) {
  const val = Math.round(gray[0] / 100 * 255) & 255;
  const integer = (val << 16) + (val << 8) + val;
  const string2 = integer.toString(16).toUpperCase();
  return "000000".substring(string2.length) + string2;
};
convert$1.rgb.gray = function(rgb) {
  const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
  return [val / 255 * 100];
};
const conversions$1 = conversions$2;
function buildGraph() {
  const graph = {};
  const models2 = Object.keys(conversions$1);
  for (let len = models2.length, i2 = 0; i2 < len; i2++) {
    graph[models2[i2]] = {
      distance: -1,
      parent: null
    };
  }
  return graph;
}
function deriveBFS(fromModel) {
  const graph = buildGraph();
  const queue = [fromModel];
  graph[fromModel].distance = 0;
  while (queue.length) {
    const current = queue.pop();
    const adjacents = Object.keys(conversions$1[current]);
    for (let len = adjacents.length, i2 = 0; i2 < len; i2++) {
      const adjacent = adjacents[i2];
      const node4 = graph[adjacent];
      if (node4.distance === -1) {
        node4.distance = graph[current].distance + 1;
        node4.parent = current;
        queue.unshift(adjacent);
      }
    }
  }
  return graph;
}
function link(from5, to2) {
  return function(args) {
    return to2(from5(args));
  };
}
function wrapConversion(toModel, graph) {
  const path = [graph[toModel].parent, toModel];
  let fn = conversions$1[graph[toModel].parent][toModel];
  let cur = graph[toModel].parent;
  while (graph[cur].parent) {
    path.unshift(graph[cur].parent);
    fn = link(conversions$1[graph[cur].parent][cur], fn);
    cur = graph[cur].parent;
  }
  fn.conversion = path;
  return fn;
}
var route$1 = function(fromModel) {
  const graph = deriveBFS(fromModel);
  const conversion = {};
  const models2 = Object.keys(graph);
  for (let len = models2.length, i2 = 0; i2 < len; i2++) {
    const toModel = models2[i2];
    const node4 = graph[toModel];
    if (node4.parent === null) {
      continue;
    }
    conversion[toModel] = wrapConversion(toModel, graph);
  }
  return conversion;
};
const conversions = conversions$2;
const route = route$1;
const convert = {};
const models = Object.keys(conversions);
function wrapRaw(fn) {
  const wrappedFn = function(...args) {
    const arg0 = args[0];
    if (arg0 === void 0 || arg0 === null) {
      return arg0;
    }
    if (arg0.length > 1) {
      args = arg0;
    }
    return fn(args);
  };
  if ("conversion" in fn) {
    wrappedFn.conversion = fn.conversion;
  }
  return wrappedFn;
}
function wrapRounded(fn) {
  const wrappedFn = function(...args) {
    const arg0 = args[0];
    if (arg0 === void 0 || arg0 === null) {
      return arg0;
    }
    if (arg0.length > 1) {
      args = arg0;
    }
    const result2 = fn(args);
    if (typeof result2 === "object") {
      for (let len = result2.length, i2 = 0; i2 < len; i2++) {
        result2[i2] = Math.round(result2[i2]);
      }
    }
    return result2;
  };
  if ("conversion" in fn) {
    wrappedFn.conversion = fn.conversion;
  }
  return wrappedFn;
}
models.forEach((fromModel) => {
  convert[fromModel] = {};
  Object.defineProperty(convert[fromModel], "channels", { value: conversions[fromModel].channels });
  Object.defineProperty(convert[fromModel], "labels", { value: conversions[fromModel].labels });
  const routes = route(fromModel);
  const routeModels = Object.keys(routes);
  routeModels.forEach((toModel) => {
    const fn = routes[toModel];
    convert[fromModel][toModel] = wrapRounded(fn);
    convert[fromModel][toModel].raw = wrapRaw(fn);
  });
});
var colorConvert = convert;
(function(module2) {
  const wrapAnsi16 = (fn, offset3) => (...args) => {
    const code = fn(...args);
    return `\x1B[${code + offset3}m`;
  };
  const wrapAnsi256 = (fn, offset3) => (...args) => {
    const code = fn(...args);
    return `\x1B[${38 + offset3};5;${code}m`;
  };
  const wrapAnsi16m = (fn, offset3) => (...args) => {
    const rgb = fn(...args);
    return `\x1B[${38 + offset3};2;${rgb[0]};${rgb[1]};${rgb[2]}m`;
  };
  const ansi2ansi = (n) => n;
  const rgb2rgb = (r, g, b) => [r, g, b];
  const setLazyProperty = (object, property, get4) => {
    Object.defineProperty(object, property, {
      get: () => {
        const value = get4();
        Object.defineProperty(object, property, {
          value,
          enumerable: true,
          configurable: true
        });
        return value;
      },
      enumerable: true,
      configurable: true
    });
  };
  let colorConvert$1;
  const makeDynamicStyles = (wrap, targetSpace, identity, isBackground) => {
    if (colorConvert$1 === void 0) {
      colorConvert$1 = colorConvert;
    }
    const offset3 = isBackground ? 10 : 0;
    const styles2 = {};
    for (const [sourceSpace, suite] of Object.entries(colorConvert$1)) {
      const name = sourceSpace === "ansi16" ? "ansi" : sourceSpace;
      if (sourceSpace === targetSpace) {
        styles2[name] = wrap(identity, offset3);
      } else if (typeof suite === "object") {
        styles2[name] = wrap(suite[targetSpace], offset3);
      }
    }
    return styles2;
  };
  function assembleStyles() {
    const codes = /* @__PURE__ */ new Map();
    const styles2 = {
      modifier: {
        reset: [0, 0],
        bold: [1, 22],
        dim: [2, 22],
        italic: [3, 23],
        underline: [4, 24],
        inverse: [7, 27],
        hidden: [8, 28],
        strikethrough: [9, 29]
      },
      color: {
        black: [30, 39],
        red: [31, 39],
        green: [32, 39],
        yellow: [33, 39],
        blue: [34, 39],
        magenta: [35, 39],
        cyan: [36, 39],
        white: [37, 39],
        blackBright: [90, 39],
        redBright: [91, 39],
        greenBright: [92, 39],
        yellowBright: [93, 39],
        blueBright: [94, 39],
        magentaBright: [95, 39],
        cyanBright: [96, 39],
        whiteBright: [97, 39]
      },
      bgColor: {
        bgBlack: [40, 49],
        bgRed: [41, 49],
        bgGreen: [42, 49],
        bgYellow: [43, 49],
        bgBlue: [44, 49],
        bgMagenta: [45, 49],
        bgCyan: [46, 49],
        bgWhite: [47, 49],
        bgBlackBright: [100, 49],
        bgRedBright: [101, 49],
        bgGreenBright: [102, 49],
        bgYellowBright: [103, 49],
        bgBlueBright: [104, 49],
        bgMagentaBright: [105, 49],
        bgCyanBright: [106, 49],
        bgWhiteBright: [107, 49]
      }
    };
    styles2.color.gray = styles2.color.blackBright;
    styles2.bgColor.bgGray = styles2.bgColor.bgBlackBright;
    styles2.color.grey = styles2.color.blackBright;
    styles2.bgColor.bgGrey = styles2.bgColor.bgBlackBright;
    for (const [groupName, group] of Object.entries(styles2)) {
      for (const [styleName, style] of Object.entries(group)) {
        styles2[styleName] = {
          open: `\x1B[${style[0]}m`,
          close: `\x1B[${style[1]}m`
        };
        group[styleName] = styles2[styleName];
        codes.set(style[0], style[1]);
      }
      Object.defineProperty(styles2, groupName, {
        value: group,
        enumerable: false
      });
    }
    Object.defineProperty(styles2, "codes", {
      value: codes,
      enumerable: false
    });
    styles2.color.close = "\x1B[39m";
    styles2.bgColor.close = "\x1B[49m";
    setLazyProperty(styles2.color, "ansi", () => makeDynamicStyles(wrapAnsi16, "ansi16", ansi2ansi, false));
    setLazyProperty(styles2.color, "ansi256", () => makeDynamicStyles(wrapAnsi256, "ansi256", ansi2ansi, false));
    setLazyProperty(styles2.color, "ansi16m", () => makeDynamicStyles(wrapAnsi16m, "rgb", rgb2rgb, false));
    setLazyProperty(styles2.bgColor, "ansi", () => makeDynamicStyles(wrapAnsi16, "ansi16", ansi2ansi, true));
    setLazyProperty(styles2.bgColor, "ansi256", () => makeDynamicStyles(wrapAnsi256, "ansi256", ansi2ansi, true));
    setLazyProperty(styles2.bgColor, "ansi16m", () => makeDynamicStyles(wrapAnsi16m, "rgb", rgb2rgb, true));
    return styles2;
  }
  Object.defineProperty(module2, "exports", {
    enumerable: true,
    get: assembleStyles
  });
})(ansiStyles$1);
var browser = {
  stdout: false,
  stderr: false
};
const stringReplaceAll$1 = (string2, substring, replacer) => {
  let index3 = string2.indexOf(substring);
  if (index3 === -1) {
    return string2;
  }
  const substringLength = substring.length;
  let endIndex = 0;
  let returnValue = "";
  do {
    returnValue += string2.substr(endIndex, index3 - endIndex) + substring + replacer;
    endIndex = index3 + substringLength;
    index3 = string2.indexOf(substring, endIndex);
  } while (index3 !== -1);
  returnValue += string2.substr(endIndex);
  return returnValue;
};
const stringEncaseCRLFWithFirstIndex$1 = (string2, prefix2, postfix, index3) => {
  let endIndex = 0;
  let returnValue = "";
  do {
    const gotCR = string2[index3 - 1] === "\r";
    returnValue += string2.substr(endIndex, (gotCR ? index3 - 1 : index3) - endIndex) + prefix2 + (gotCR ? "\r\n" : "\n") + postfix;
    endIndex = index3 + 1;
    index3 = string2.indexOf("\n", endIndex);
  } while (index3 !== -1);
  returnValue += string2.substr(endIndex);
  return returnValue;
};
var util = {
  stringReplaceAll: stringReplaceAll$1,
  stringEncaseCRLFWithFirstIndex: stringEncaseCRLFWithFirstIndex$1
};
const TEMPLATE_REGEX = /(?:\\(u(?:[a-f\d]{4}|\{[a-f\d]{1,6}\})|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi;
const STYLE_REGEX = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g;
const STRING_REGEX = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/;
const ESCAPE_REGEX = /\\(u(?:[a-f\d]{4}|{[a-f\d]{1,6}})|x[a-f\d]{2}|.)|([^\\])/gi;
const ESCAPES = /* @__PURE__ */ new Map([
  ["n", "\n"],
  ["r", "\r"],
  ["t", "	"],
  ["b", "\b"],
  ["f", "\f"],
  ["v", "\v"],
  ["0", "\0"],
  ["\\", "\\"],
  ["e", "\x1B"],
  ["a", "\x07"]
]);
function unescape$1(c) {
  const u = c[0] === "u";
  const bracket = c[1] === "{";
  if (u && !bracket && c.length === 5 || c[0] === "x" && c.length === 3) {
    return String.fromCharCode(parseInt(c.slice(1), 16));
  }
  if (u && bracket) {
    return String.fromCodePoint(parseInt(c.slice(2, -1), 16));
  }
  return ESCAPES.get(c) || c;
}
function parseArguments(name, arguments_) {
  const results = [];
  const chunks = arguments_.trim().split(/\s*,\s*/g);
  let matches2;
  for (const chunk of chunks) {
    const number2 = Number(chunk);
    if (!Number.isNaN(number2)) {
      results.push(number2);
    } else if (matches2 = chunk.match(STRING_REGEX)) {
      results.push(matches2[2].replace(ESCAPE_REGEX, (m, escape2, character) => escape2 ? unescape$1(escape2) : character));
    } else {
      throw new Error(`Invalid Chalk template style argument: ${chunk} (in style '${name}')`);
    }
  }
  return results;
}
function parseStyle(style) {
  STYLE_REGEX.lastIndex = 0;
  const results = [];
  let matches2;
  while ((matches2 = STYLE_REGEX.exec(style)) !== null) {
    const name = matches2[1];
    if (matches2[2]) {
      const args = parseArguments(name, matches2[2]);
      results.push([name].concat(args));
    } else {
      results.push([name]);
    }
  }
  return results;
}
function buildStyle(chalk2, styles2) {
  const enabled = {};
  for (const layer of styles2) {
    for (const style of layer.styles) {
      enabled[style[0]] = layer.inverse ? null : style.slice(1);
    }
  }
  let current = chalk2;
  for (const [styleName, styles3] of Object.entries(enabled)) {
    if (!Array.isArray(styles3)) {
      continue;
    }
    if (!(styleName in current)) {
      throw new Error(`Unknown Chalk style: ${styleName}`);
    }
    current = styles3.length > 0 ? current[styleName](...styles3) : current[styleName];
  }
  return current;
}
var templates = (chalk2, temporary) => {
  const styles2 = [];
  const chunks = [];
  let chunk = [];
  temporary.replace(TEMPLATE_REGEX, (m, escapeCharacter, inverse, style, close3, character) => {
    if (escapeCharacter) {
      chunk.push(unescape$1(escapeCharacter));
    } else if (style) {
      const string2 = chunk.join("");
      chunk = [];
      chunks.push(styles2.length === 0 ? string2 : buildStyle(chalk2, styles2)(string2));
      styles2.push({ inverse, styles: parseStyle(style) });
    } else if (close3) {
      if (styles2.length === 0) {
        throw new Error("Found extraneous } in Chalk template literal");
      }
      chunks.push(buildStyle(chalk2, styles2)(chunk.join("")));
      chunk = [];
      styles2.pop();
    } else {
      chunk.push(character);
    }
  });
  chunks.push(chunk.join(""));
  if (styles2.length > 0) {
    const errMessage = `Chalk template literal is missing ${styles2.length} closing bracket${styles2.length === 1 ? "" : "s"} (\`}\`)`;
    throw new Error(errMessage);
  }
  return chunks.join("");
};
const ansiStyles = ansiStyles$1.exports;
const { stdout: stdoutColor, stderr: stderrColor } = browser;
const {
  stringReplaceAll,
  stringEncaseCRLFWithFirstIndex
} = util;
const { isArray } = Array;
const levelMapping = [
  "ansi",
  "ansi",
  "ansi256",
  "ansi16m"
];
const styles = /* @__PURE__ */ Object.create(null);
const applyOptions = (object, options = {}) => {
  if (options.level && !(Number.isInteger(options.level) && options.level >= 0 && options.level <= 3)) {
    throw new Error("The `level` option should be an integer from 0 to 3");
  }
  const colorLevel = stdoutColor ? stdoutColor.level : 0;
  object.level = options.level === void 0 ? colorLevel : options.level;
};
class ChalkClass {
  constructor(options) {
    return chalkFactory(options);
  }
}
const chalkFactory = (options) => {
  const chalk2 = {};
  applyOptions(chalk2, options);
  chalk2.template = (...arguments_) => chalkTag(chalk2.template, ...arguments_);
  Object.setPrototypeOf(chalk2, Chalk.prototype);
  Object.setPrototypeOf(chalk2.template, chalk2);
  chalk2.template.constructor = () => {
    throw new Error("`chalk.constructor()` is deprecated. Use `new chalk.Instance()` instead.");
  };
  chalk2.template.Instance = ChalkClass;
  return chalk2.template;
};
function Chalk(options) {
  return chalkFactory(options);
}
for (const [styleName, style] of Object.entries(ansiStyles)) {
  styles[styleName] = {
    get() {
      const builder = createBuilder(this, createStyler(style.open, style.close, this._styler), this._isEmpty);
      Object.defineProperty(this, styleName, { value: builder });
      return builder;
    }
  };
}
styles.visible = {
  get() {
    const builder = createBuilder(this, this._styler, true);
    Object.defineProperty(this, "visible", { value: builder });
    return builder;
  }
};
const usedModels = ["rgb", "hex", "keyword", "hsl", "hsv", "hwb", "ansi", "ansi256"];
for (const model of usedModels) {
  styles[model] = {
    get() {
      const { level } = this;
      return function(...arguments_) {
        const styler = createStyler(ansiStyles.color[levelMapping[level]][model](...arguments_), ansiStyles.color.close, this._styler);
        return createBuilder(this, styler, this._isEmpty);
      };
    }
  };
}
for (const model of usedModels) {
  const bgModel = "bg" + model[0].toUpperCase() + model.slice(1);
  styles[bgModel] = {
    get() {
      const { level } = this;
      return function(...arguments_) {
        const styler = createStyler(ansiStyles.bgColor[levelMapping[level]][model](...arguments_), ansiStyles.bgColor.close, this._styler);
        return createBuilder(this, styler, this._isEmpty);
      };
    }
  };
}
const proto = Object.defineProperties(() => {
}, __spreadProps(__spreadValues({}, styles), {
  level: {
    enumerable: true,
    get() {
      return this._generator.level;
    },
    set(level) {
      this._generator.level = level;
    }
  }
}));
const createStyler = (open, close3, parent) => {
  let openAll;
  let closeAll;
  if (parent === void 0) {
    openAll = open;
    closeAll = close3;
  } else {
    openAll = parent.openAll + open;
    closeAll = close3 + parent.closeAll;
  }
  return {
    open,
    close: close3,
    openAll,
    closeAll,
    parent
  };
};
const createBuilder = (self2, _styler, _isEmpty) => {
  const builder = (...arguments_) => {
    if (isArray(arguments_[0]) && isArray(arguments_[0].raw)) {
      return applyStyle(builder, chalkTag(builder, ...arguments_));
    }
    return applyStyle(builder, arguments_.length === 1 ? "" + arguments_[0] : arguments_.join(" "));
  };
  Object.setPrototypeOf(builder, proto);
  builder._generator = self2;
  builder._styler = _styler;
  builder._isEmpty = _isEmpty;
  return builder;
};
const applyStyle = (self2, string2) => {
  if (self2.level <= 0 || !string2) {
    return self2._isEmpty ? "" : string2;
  }
  let styler = self2._styler;
  if (styler === void 0) {
    return string2;
  }
  const { openAll, closeAll } = styler;
  if (string2.indexOf("\x1B") !== -1) {
    while (styler !== void 0) {
      string2 = stringReplaceAll(string2, styler.close, styler.open);
      styler = styler.parent;
    }
  }
  const lfIndex = string2.indexOf("\n");
  if (lfIndex !== -1) {
    string2 = stringEncaseCRLFWithFirstIndex(string2, closeAll, openAll, lfIndex);
  }
  return openAll + string2 + closeAll;
};
let template;
const chalkTag = (chalk2, ...strings) => {
  const [firstString] = strings;
  if (!isArray(firstString) || !isArray(firstString.raw)) {
    return strings.join(" ");
  }
  const arguments_ = strings.slice(1);
  const parts = [firstString.raw[0]];
  for (let i2 = 1; i2 < firstString.length; i2++) {
    parts.push(String(arguments_[i2 - 1]).replace(/[{}\\]/g, "\\$&"), String(firstString.raw[i2]));
  }
  if (template === void 0) {
    template = templates;
  }
  return template(chalk2, parts.join(""));
};
Object.defineProperties(Chalk.prototype, styles);
const chalk = Chalk();
chalk.supportsColor = stdoutColor;
chalk.stderr = Chalk({ level: stderrColor ? stderrColor.level : 0 });
chalk.stderr.supportsColor = stderrColor;
var source = chalk;
Object.defineProperty(log$1, "__esModule", {
  value: true
});
log$1.dim = dim;
log$1.default = void 0;
var _chalk = _interopRequireDefault$1(source);
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
let alreadyShown = /* @__PURE__ */ new Set();
function log(chalk2, messages, key) {
  if (key && alreadyShown.has(key))
    return;
  if (key)
    alreadyShown.add(key);
  console.warn("");
  messages.forEach((message) => console.warn(chalk2, "-", message));
}
function dim(input) {
  return _chalk.default.dim(input);
}
var _default$1 = {
  info(key, messages) {
    log(_chalk.default.bold.cyan("info"), ...Array.isArray(key) ? [
      key
    ] : [
      messages,
      key
    ]);
  },
  warn(key, messages) {
    log(_chalk.default.bold.yellow("warn"), ...Array.isArray(key) ? [
      key
    ] : [
      messages,
      key
    ]);
  },
  risk(key, messages) {
    log(_chalk.default.bold.magenta("risk"), ...Array.isArray(key) ? [
      key
    ] : [
      messages,
      key
    ]);
  }
};
log$1.default = _default$1;
Object.defineProperty(colors$1, "__esModule", {
  value: true
});
colors$1.default = void 0;
var _log = _interopRequireDefault(log$1);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function warn({ version, from: from5, to: to2 }) {
  _log.default.warn(`${from5}-color-renamed`, [
    `As of Tailwind CSS ${version}, \`${from5}\` has been renamed to \`${to2}\`.`,
    "Update your configuration file to silence this warning."
  ]);
}
var _default = {
  inherit: "inherit",
  current: "currentColor",
  transparent: "transparent",
  black: "#000",
  white: "#fff",
  slate: {
    50: "#f8fafc",
    100: "#f1f5f9",
    200: "#e2e8f0",
    300: "#cbd5e1",
    400: "#94a3b8",
    500: "#64748b",
    600: "#475569",
    700: "#334155",
    800: "#1e293b",
    900: "#0f172a"
  },
  gray: {
    50: "#f9fafb",
    100: "#f3f4f6",
    200: "#e5e7eb",
    300: "#d1d5db",
    400: "#9ca3af",
    500: "#6b7280",
    600: "#4b5563",
    700: "#374151",
    800: "#1f2937",
    900: "#111827"
  },
  zinc: {
    50: "#fafafa",
    100: "#f4f4f5",
    200: "#e4e4e7",
    300: "#d4d4d8",
    400: "#a1a1aa",
    500: "#71717a",
    600: "#52525b",
    700: "#3f3f46",
    800: "#27272a",
    900: "#18181b"
  },
  neutral: {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#e5e5e5",
    300: "#d4d4d4",
    400: "#a3a3a3",
    500: "#737373",
    600: "#525252",
    700: "#404040",
    800: "#262626",
    900: "#171717"
  },
  stone: {
    50: "#fafaf9",
    100: "#f5f5f4",
    200: "#e7e5e4",
    300: "#d6d3d1",
    400: "#a8a29e",
    500: "#78716c",
    600: "#57534e",
    700: "#44403c",
    800: "#292524",
    900: "#1c1917"
  },
  red: {
    50: "#fef2f2",
    100: "#fee2e2",
    200: "#fecaca",
    300: "#fca5a5",
    400: "#f87171",
    500: "#ef4444",
    600: "#dc2626",
    700: "#b91c1c",
    800: "#991b1b",
    900: "#7f1d1d"
  },
  orange: {
    50: "#fff7ed",
    100: "#ffedd5",
    200: "#fed7aa",
    300: "#fdba74",
    400: "#fb923c",
    500: "#f97316",
    600: "#ea580c",
    700: "#c2410c",
    800: "#9a3412",
    900: "#7c2d12"
  },
  amber: {
    50: "#fffbeb",
    100: "#fef3c7",
    200: "#fde68a",
    300: "#fcd34d",
    400: "#fbbf24",
    500: "#f59e0b",
    600: "#d97706",
    700: "#b45309",
    800: "#92400e",
    900: "#78350f"
  },
  yellow: {
    50: "#fefce8",
    100: "#fef9c3",
    200: "#fef08a",
    300: "#fde047",
    400: "#facc15",
    500: "#eab308",
    600: "#ca8a04",
    700: "#a16207",
    800: "#854d0e",
    900: "#713f12"
  },
  lime: {
    50: "#f7fee7",
    100: "#ecfccb",
    200: "#d9f99d",
    300: "#bef264",
    400: "#a3e635",
    500: "#84cc16",
    600: "#65a30d",
    700: "#4d7c0f",
    800: "#3f6212",
    900: "#365314"
  },
  green: {
    50: "#f0fdf4",
    100: "#dcfce7",
    200: "#bbf7d0",
    300: "#86efac",
    400: "#4ade80",
    500: "#22c55e",
    600: "#16a34a",
    700: "#15803d",
    800: "#166534",
    900: "#14532d"
  },
  emerald: {
    50: "#ecfdf5",
    100: "#d1fae5",
    200: "#a7f3d0",
    300: "#6ee7b7",
    400: "#34d399",
    500: "#10b981",
    600: "#059669",
    700: "#047857",
    800: "#065f46",
    900: "#064e3b"
  },
  teal: {
    50: "#f0fdfa",
    100: "#ccfbf1",
    200: "#99f6e4",
    300: "#5eead4",
    400: "#2dd4bf",
    500: "#14b8a6",
    600: "#0d9488",
    700: "#0f766e",
    800: "#115e59",
    900: "#134e4a"
  },
  cyan: {
    50: "#ecfeff",
    100: "#cffafe",
    200: "#a5f3fc",
    300: "#67e8f9",
    400: "#22d3ee",
    500: "#06b6d4",
    600: "#0891b2",
    700: "#0e7490",
    800: "#155e75",
    900: "#164e63"
  },
  sky: {
    50: "#f0f9ff",
    100: "#e0f2fe",
    200: "#bae6fd",
    300: "#7dd3fc",
    400: "#38bdf8",
    500: "#0ea5e9",
    600: "#0284c7",
    700: "#0369a1",
    800: "#075985",
    900: "#0c4a6e"
  },
  blue: {
    50: "#eff6ff",
    100: "#dbeafe",
    200: "#bfdbfe",
    300: "#93c5fd",
    400: "#60a5fa",
    500: "#3b82f6",
    600: "#2563eb",
    700: "#1d4ed8",
    800: "#1e40af",
    900: "#1e3a8a"
  },
  indigo: {
    50: "#eef2ff",
    100: "#e0e7ff",
    200: "#c7d2fe",
    300: "#a5b4fc",
    400: "#818cf8",
    500: "#6366f1",
    600: "#4f46e5",
    700: "#4338ca",
    800: "#3730a3",
    900: "#312e81"
  },
  violet: {
    50: "#f5f3ff",
    100: "#ede9fe",
    200: "#ddd6fe",
    300: "#c4b5fd",
    400: "#a78bfa",
    500: "#8b5cf6",
    600: "#7c3aed",
    700: "#6d28d9",
    800: "#5b21b6",
    900: "#4c1d95"
  },
  purple: {
    50: "#faf5ff",
    100: "#f3e8ff",
    200: "#e9d5ff",
    300: "#d8b4fe",
    400: "#c084fc",
    500: "#a855f7",
    600: "#9333ea",
    700: "#7e22ce",
    800: "#6b21a8",
    900: "#581c87"
  },
  fuchsia: {
    50: "#fdf4ff",
    100: "#fae8ff",
    200: "#f5d0fe",
    300: "#f0abfc",
    400: "#e879f9",
    500: "#d946ef",
    600: "#c026d3",
    700: "#a21caf",
    800: "#86198f",
    900: "#701a75"
  },
  pink: {
    50: "#fdf2f8",
    100: "#fce7f3",
    200: "#fbcfe8",
    300: "#f9a8d4",
    400: "#f472b6",
    500: "#ec4899",
    600: "#db2777",
    700: "#be185d",
    800: "#9d174d",
    900: "#831843"
  },
  rose: {
    50: "#fff1f2",
    100: "#ffe4e6",
    200: "#fecdd3",
    300: "#fda4af",
    400: "#fb7185",
    500: "#f43f5e",
    600: "#e11d48",
    700: "#be123c",
    800: "#9f1239",
    900: "#881337"
  },
  get lightBlue() {
    warn({
      version: "v2.2",
      from: "lightBlue",
      to: "sky"
    });
    return this.sky;
  },
  get warmGray() {
    warn({
      version: "v3.0",
      from: "warmGray",
      to: "stone"
    });
    return this.stone;
  },
  get trueGray() {
    warn({
      version: "v3.0",
      from: "trueGray",
      to: "neutral"
    });
    return this.neutral;
  },
  get coolGray() {
    warn({
      version: "v3.0",
      from: "coolGray",
      to: "gray"
    });
    return this.gray;
  },
  get blueGray() {
    warn({
      version: "v3.0",
      from: "blueGray",
      to: "slate"
    });
    return this.slate;
  }
};
colors$1.default = _default;
let colors = colors$1;
var colors_1 = (colors.__esModule ? colors : { default: colors }).default;
var defaultColors = {
  inherit: "inherit",
  sub: colors_1.slate[500],
  muted: colors_1.slate[300],
  btn: {
    DEFAULT: colors_1.black,
    hover: colors_1.gray[300],
    active: colors_1.gray[200],
    light: colors_1.gray[100],
    contrast: colors_1.white
  },
  brand: {
    DEFAULT: colors_1.pink[500],
    hover: colors_1.pink[400],
    active: colors_1.pink[300],
    light: colors_1.pink[100],
    contrast: colors_1.white
  },
  primary: {
    DEFAULT: colors_1.indigo[500],
    hover: colors_1.indigo[400],
    active: colors_1.indigo[300],
    light: colors_1.indigo[100],
    contrast: colors_1.white
  },
  secondary: {
    DEFAULT: colors_1.purple[500],
    hover: colors_1.purple[400],
    active: colors_1.purple[300],
    light: colors_1.purple[100],
    contrast: colors_1.white
  },
  success: {
    DEFAULT: colors_1.green[400],
    hover: colors_1.green[300],
    active: colors_1.green[200],
    light: colors_1.green[100],
    contrast: colors_1.white
  },
  info: {
    DEFAULT: colors_1.blue[400],
    hover: colors_1.blue[300],
    active: colors_1.blue[200],
    light: colors_1.blue[100],
    contrast: colors_1.white
  },
  warning: {
    DEFAULT: colors_1.amber[500],
    hover: colors_1.amber[400],
    active: colors_1.amber[300],
    light: colors_1.amber[100],
    contrast: colors_1.white
  },
  danger: {
    DEFAULT: colors_1.red[500],
    hover: colors_1.red[400],
    active: colors_1.red[300],
    light: colors_1.red[100],
    contrast: colors_1.white
  },
  gray: {
    DEFAULT: colors_1.slate[400],
    hover: colors_1.slate[400],
    active: colors_1.slate[200],
    light: colors_1.slate[100],
    contrast: colors_1.white
  },
  row: {
    DEFAULT: colors_1.slate[100],
    odd: colors_1.white,
    selected: colors_1.pink[100],
    hover: colors_1.pink[200]
  }
};
function mergeOptions(options) {
  const colors2 = options.colors ? Object.assign(defaultColors, options.colors) : defaultColors;
  delete options["colors"];
  const mergedOptions = Object.assign({}, options, { colors: colors2 });
  return mergedOptions;
}
function load(key, defaultValue) {
  let value = localStorage.getItem(`q4-${key}`);
  if (value) {
    return JSON.parse(value);
  } else {
    return defaultValue;
  }
}
function save(key, value) {
  localStorage.setItem(`q4-${key}`, JSON.stringify(value));
}
const useSettings = () => {
  return {
    load,
    save
  };
};
function createPaginator(params, dataLoader, router, routes) {
  const loading = ref(true);
  const hasAll = ref(false);
  const currentKey = ref("");
  const items = ref([]);
  const pages = ref(/* @__PURE__ */ new Set());
  if (!params.hasOwnProperty("columns")) {
    params.columns = [];
  }
  const listParams = reactive(Object.assign({ page: 1, perPage: 20, sortInfo: {} }, params));
  const totalPages = computed(() => {
    return Math.ceil(items.value.length / listParams.perPage);
  });
  const totalCount = computed(() => {
    return items.value.length;
  });
  const setParams = (params2) => {
    for (const key in params2) {
      if (Object.prototype.hasOwnProperty.call(listParams, key)) {
        listParams[key] = params2[key];
      }
    }
  };
  const visibleItems = computed(() => {
    const result2 = [];
    let isLoading = loading.value;
    let i2 = (listParams.page - 1) * listParams.perPage;
    items.value.length;
    if (!isLoading && pages.value.has(listParams.page)) {
      let endIndex = Math.min(i2 + listParams.perPage, items.value.length);
      for (; i2 < endIndex; i2++) {
        result2.push(items.value[i2]);
      }
    }
    return result2;
  });
  const toggleSort = (e, column) => {
    if (e.shiftKey)
      ;
    else {
      for (const col in listParams.sortInfo) {
        if (col == column) {
          listParams.sortInfo[col].dir = listParams.sortInfo[col].dir == "asc" ? "desc" : listParams.sortInfo[col].dir == "desc" ? null : "asc";
        } else {
          listParams.sortInfo[col].dir = null;
        }
      }
    }
  };
  for (let i2 = 0; i2 < params.columns.length; i2++) {
    listParams.sortInfo[params.columns[i2].name] = {
      dir: null,
      index: -1,
      column: params.columns[i2].name,
      type: params.columns[i2].hasOwnProperty("type") ? params.columns[i2]["type"] : "string"
    };
  }
  listParams.sort = computed(() => {
    return Object.values(listParams.sortInfo).filter((s2) => {
      return !!s2.dir;
    });
  });
  const resetCache = (count = 0) => {
    items.value = new Array(count);
    pages.value.clear();
    currentKey.value = "";
    hasAll.value = false;
  };
  const prev = () => {
    loadCurrentPageIfNeeded(Math.max(1, listParams.page - 1));
  };
  const next = () => {
    loadCurrentPageIfNeeded(Math.min(totalPages.value, listParams.page + 1));
  };
  const loadCurrentPageIfNeeded = (newPage) => {
    loading.value = true;
    if (newPage) {
      listParams.page = newPage;
    }
    if (pages.value.has(listParams.page)) {
      loading.value = false;
    } else {
      debouncedLoadData();
    }
  };
  const getViewKey = () => {
    let p = {};
    for (const key in listParams) {
      if (key != "page" && key != "perPage" && key != "sortInfo" && key != "sort" && Object.prototype.hasOwnProperty.call(listParams, key))
        p[key] = listParams[key];
    }
    return JSON.stringify(p);
  };
  const loadData = async (clear) => {
    if (clear) {
      resetCache();
    }
    if (hasAll.value && getViewKey() == currentKey.value) {
      const sorted = sortList(items.value, listParams.sort);
      items.value.splice(0, items.value.length, ...sorted);
    } else {
      const data = await dataLoader(listParams);
      if (listParams.perPage == data.per_page) {
        if (items.value.length != data.total) {
          resetCache(data.total);
        }
        pages.value.add(listParams.page);
        const startIndex = (data.current_page - 1) * data.per_page;
        items.value.splice(startIndex, data.data.length, ...data.data);
        if (listParams.page == data.current_page) {
          loading.value = false;
        }
        currentKey.value = getViewKey();
        hasAll.value = pages.value.size == data.last_page;
      }
    }
  };
  const sortList = (list2, sort) => {
    if (sort.length) {
      const f = sort[0].dir == "asc" ? 1 : -1;
      if (sort[0].type == "string") {
        return list2.sort((a, b) => {
          return f * (a[sort[0].column] || "").toString().localeCompare((b[sort[0].column] || "").toString());
        });
      } else if (sort[0].type == "number") {
        return list2.sort((a, b) => {
          a = Number((a[sort[0].column] || "").toString().replace(/[^0-9.-]/g, ""));
          b = Number((b[sort[0].column] || "").toString().replace(/[^0-9.-]/g, ""));
          return f * (a > b ? 1 : a < b ? -1 : 0);
        });
      }
    }
    return list2;
  };
  watch(() => listParams, (o) => {
    debouncedLoadData();
  }, { deep: true });
  const debouncedLoadData = debounce$2(null, loadData);
  loadData();
  return {
    resetCache,
    toggleSort,
    sortInfo: listParams.sortInfo,
    setParams,
    params: listParams,
    loading,
    loadData,
    prev,
    next,
    visibleItems,
    totalCount,
    totalPages,
    page: computed(() => listParams.page),
    perPage: computed(() => listParams.perPage),
    canCreate: routes && routes.hasOwnProperty("createNewItem"),
    canImport: routes && routes.hasOwnProperty("importFromFile"),
    goto(routeName) {
      router.push(routes[routeName]);
    },
    routes
  };
}
const SuperVueUI = {
  install: (app, options) => {
    app.provide("supervueui", mergeOptions(options));
    app.directive("absorb", absorb);
    app.directive("focus", focus2);
    app.directive("click-outside", clickOutside);
    app.component("SCalendar", SCalendar);
    app.component("SIcon", SIcon);
    app.component("SSelectorInput", SSelectorInput);
    app.component("STextareaInput", STextareaInput);
    app.component("SValidationErrors", SValidationErrors);
    app.component("SSearchSelect", SSearchSelect);
    app.component("SNotification", SNotification);
    app.component("SDialogs", SDialogs);
    app.component("SToasties", SToasties);
    app.component("SIconButton", SIconButton);
    app.component("STextInput", STextInput);
    app.component("SDatetimeInput", SDatetimeInput);
    app.component("STimeInput", STimeInput);
    app.component("SDateInput", SDateInput);
    app.component("SRadio", SRadio);
    app.component("SRadioButtons", SRadioButtons);
    app.component("SCheckbox", SCheckbox);
    app.component("SButton", SButton);
    app.component("SField", SField);
    app.component("SSortable", SSortable);
    app.component("SPaginatedList", SPaginatedList);
    app.component("SUploader", SUploader);
    app.component("STabs", STabs);
    app.component("SDatePicker", SDatePicker);
    app.component("SSortIndicator", SSortIndicator);
    app.component("SListHeader", SListHeader);
  }
};
export { SCodeInput, SCoordinates, SHTMLInput, SLeaflet, SuperVueUI, createPaginator, debounce$2 as debounce, getSessionSetting, md5, setSessionSetting, useDialogs, useSettings, useToasties, uuid };
